webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Label Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __webpack_require__(57);
__webpack_require__(974);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var LinkButton_1 = __webpack_require__(51);
var EllipsisLabel_1 = __webpack_require__(1255);
function Paragraph(props) {
    var WrappedComponent = props.WrappedComponent,
        labelProps = __rest(props, ["WrappedComponent"]);
    return React.createElement(Label, Object.assign({}, labelProps, { WrappedComponent: "p" }));
}
exports.Paragraph = Paragraph;
function Span(props) {
    var block = props.block,
        style = props.style,
        WrappedComponent = props.WrappedComponent,
        labelProps = __rest(props, ["block", "style", "WrappedComponent"]);

    var spanStyle = style;
    if (block) {
        var display = {
            display: 'block'
        };
        spanStyle = style ? lodash_1.extend(style, display) : display;
    }
    return React.createElement(Label, Object.assign({}, labelProps, { style: spanStyle, WrappedComponent: "span" }));
}
exports.Span = Span;

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label(props) {
        _classCallCheck(this, Label);

        var _this = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props));

        _this.bem = new BEM(_this.props.variant);
        return _this;
    }

    _createClass(Label, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.variant !== this.props.variant) {
                this.bem = new BEM(nextProps.variant);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                backgroundColor = _props.backgroundColor,
                children = _props.children,
                className = _props.className,
                htmlFor = _props.htmlFor,
                hyperLinkProps = _props.hyperLinkProps,
                maxTextLength = _props.maxTextLength,
                style = _props.style,
                size = _props.size,
                text = _props.text,
                textColor = _props.textColor;
            // Props with default values

            var variant = this.props.variant;
            var WrappedComponent = this.props.WrappedComponent;
            // If variant is a not 'label', make sure the WrappedComponent is not <label>
            if (variant !== 'label' && WrappedComponent === 'label') {
                WrappedComponent = 'span';
            }
            // Implement text/background color classes
            var extraClasses = [colors_1.getTextColorClassName(textColor), colors_1.getBackgroundColorClassName(backgroundColor), className];
            // Group props for render
            var props = Object.assign({}, this.bem('', size, extraClasses));
            // If prop htmlFor is set, push it to the component
            if (htmlFor && WrappedComponent === 'label') {
                props.htmlFor = htmlFor;
            }
            var label = !!text ? React.createElement(EllipsisLabel_1.default, { text: text, length: maxTextLength || -1, tail: "\u2026" }) : children;
            return React.createElement(WrappedComponent, Object.assign({}, props, { style: style }), hyperLinkProps ? React.createElement(LinkButton_1.default, { to: hyperLinkProps.href, external: hyperLinkProps.external, variant: "text" }, label) : label);
        }
    }]);

    return Label;
}(React.Component);

Label.defaultProps = {
    variant: 'label',
    WrappedComponent: 'label'
};
exports.default = Label;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Heading Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __webpack_require__(57);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(987);
var LinkButton_1 = __webpack_require__(51);
var Label_1 = __webpack_require__(8);

var Heading = function (_React$Component) {
    _inherits(Heading, _React$Component);

    function Heading() {
        _classCallCheck(this, Heading);

        return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
    }

    _createClass(Heading, [{
        key: "render",
        value: function render() {
            var _modifiers;

            var _props = this.props,
                backgroundColor = _props.backgroundColor,
                children = _props.children,
                className = _props.className,
                hyperLinkProps = _props.hyperLinkProps,
                icon = _props.icon,
                is = _props.is,
                maxTextLength = _props.maxTextLength,
                noMargin = _props.noMargin,
                style = _props.style,
                text = _props.text,
                textColor = _props.textColor;

            var WrappedComponent = this.props.WrappedComponent || is;
            var headingClass = classNames(colors_1.getTextColorClassName(textColor), colors_1.getBackgroundColorClassName(backgroundColor), _defineProperty({}, is, this.props.WrappedComponent), className);
            var baseClass = !!!this.props.WrappedComponent || this.props.WrappedComponent.match(/^h\d$/) ? 'heading' : '';
            var modifiers = (_modifiers = {}, _defineProperty(_modifiers, is, !!!this.props.WrappedComponent), _defineProperty(_modifiers, 'no-margin', !!noMargin), _modifiers);
            var classes = new BEM(baseClass);
            var label = !!text ? React.createElement(Label_1.Span, { text: text, maxTextLength: maxTextLength }) : children;
            return React.createElement(WrappedComponent, Object.assign({}, classes('', modifiers, headingClass), { style: style }), icon, hyperLinkProps ? React.createElement(LinkButton_1.default, { to: hyperLinkProps.href, external: hyperLinkProps.external, variant: "text" }, label) : label);
        }
    }]);

    return Heading;
}(React.Component);

exports.default = Heading;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Button Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(972);
var color_schemes_1 = __webpack_require__(143);
var colors_1 = __webpack_require__(57);
var Label_1 = __webpack_require__(8);
var classes = new BEM('button');

var Button = function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button() {
        _classCallCheck(this, Button);

        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
    }

    _createClass(Button, [{
        key: "render",
        value: function render() {
            var _classesModifiers;

            var _a = this.props,
                backgroundColor = _a.backgroundColor,
                children = _a.children,
                className = _a.className,
                colorScheme = _a.colorScheme,
                dangerous = _a.dangerous,
                disabled = _a.disabled,
                hyperLinkProps = _a.hyperLinkProps,
                icon = _a.icon,
                iconPosition = _a.iconPosition,
                isSubmit = _a.isSubmit,
                label = _a.label,
                positive = _a.positive,
                routerLinkProps = _a.routerLinkProps,
                size = _a.size,
                style = _a.style,
                submitting = _a.submitting,
                textColor = _a.textColor,
                title = _a.title,
                variant = _a.variant,
                withShadow = _a.withShadow,
                wrapperComponent = _a.wrapperComponent,
                restProps = __rest(_a, ["backgroundColor", "children", "className", "colorScheme", "dangerous", "disabled", "hyperLinkProps", "icon", "iconPosition", "isSubmit", "label", "positive", "routerLinkProps", "size", "style", "submitting", "textColor", "title", "variant", "withShadow", "wrapperComponent"]);
            var WrapperComponent = wrapperComponent;
            var wrapperProps = Object.assign({ disabled: disabled,
                style: style }, restProps);
            var Icon = icon ? React.cloneElement(icon, {
                className: classNames(icon.props.className || '', 'button__icon')
            }) : null;
            if (WrapperComponent === 'button') {
                wrapperProps.type = isSubmit ? 'submit' : 'button';
            }
            var classesModifiers = (_classesModifiers = {}, _defineProperty(_classesModifiers, size, true), _defineProperty(_classesModifiers, variant, variant !== 'normal'), _defineProperty(_classesModifiers, "submitting", !!submitting), _classesModifiers);
            // Implement text/background color classes
            var extraClasses = classNames(colors_1.getTextColorClassName(textColor), colors_1.getBackgroundColorClassName(backgroundColor), dangerous && color_schemes_1.getColorSchemeClassName('dangerous'), disabled && color_schemes_1.getColorSchemeClassName('disabled') || positive && color_schemes_1.getColorSchemeClassName('positive') || colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme), withShadow && !disabled && 'with--shadow', variant !== 'icon' && variant !== 'icon-no-padding' && !!icon && "with--icon", !!icon && !!label && "icon-position--" + iconPosition, className);
            return React.createElement(WrapperComponent, Object.assign({ title: title }, classes('', classesModifiers, extraClasses), wrapperProps, routerLinkProps, hyperLinkProps), React.createElement("span", Object.assign({}, classes('flex')), React.createElement("div", Object.assign({}, classes('active-background'))), React.createElement("div", Object.assign({}, classes('wrapper')), iconPosition === 'left' && Icon, label ? typeof label === 'string' ? React.createElement(Label_1.Span, Object.assign({}, classes('label')), label) : React.cloneElement(label, Object.assign({}, classes('label', '', 'label'))) : undefined, children, iconPosition === 'right' && Icon)));
        }
    }]);

    return Button;
}(React.Component);

Button.defaultProps = {
    iconPosition: 'left',
    size: 'medium',
    variant: 'normal',
    wrapperComponent: 'button'
};
exports.default = Button;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Icons Component
 */
/* tslint:disable:max-line-length */
// tslint:disable:jsx-self-close

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(967);
var license_icons_1 = __webpack_require__(969);
exports.IconLicenseAllMedia = license_icons_1.IconLicenseAllMedia;
exports.IconLicenseCaseStudy = license_icons_1.IconLicenseCaseStudy;
exports.IconLicenseIndustrial = license_icons_1.IconLicenseIndustrial;
exports.IconLicensePodcast = license_icons_1.IconLicensePodcast;
exports.IconLicenseRadio = license_icons_1.IconLicenseRadio;
exports.IconLicenseShowReel = license_icons_1.IconLicenseShowReel;
exports.IconLicenseSocialMedia = license_icons_1.IconLicenseSocialMedia;
exports.IconLicenseTheatrical = license_icons_1.IconLicenseTheatrical;
exports.IconLicenseTV = license_icons_1.IconLicenseTV;
exports.IconLicenseTVEditorial = license_icons_1.IconLicenseTVEditorial;
exports.IconLicenseTVWeb = license_icons_1.IconLicenseTVWeb;
exports.IconLicenseWeb = license_icons_1.IconLicenseWeb;
var player_icons_1 = __webpack_require__(970);
exports.IconPlayerNext = player_icons_1.IconPlayerNext;
exports.IconPlayerPause = player_icons_1.IconPlayerPause;
exports.IconPlayerPlay = player_icons_1.IconPlayerPlay;
exports.IconPlayerPrevious = player_icons_1.IconPlayerPrevious;
var social_icons_1 = __webpack_require__(971);
exports.IconApple = social_icons_1.IconApple;
exports.IconBandCamp = social_icons_1.IconBandCamp;
exports.IconFacebook = social_icons_1.IconFacebook;
exports.IconGoogle = social_icons_1.IconGoogle;
exports.IconInstagram = social_icons_1.IconInstagram;
exports.IconSoundCloud = social_icons_1.IconSoundCloud;
exports.IconSpotify = social_icons_1.IconSpotify;
exports.IconTwitter = social_icons_1.IconTwitter;
function IconWrapper(_a) {
    var children = _a.children,
        className = _a.className,
        id = _a.id,
        rest = __rest(_a, ["children", "className", "id"]);

    var classes = new BEM('icon');
    return React.createElement("div", Object.assign({}, classes('', id, className), rest), children);
}
function LogoAMS(_a) {
    var _a$className = _a.className,
        className = _a$className === undefined ? '' : _a$className,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "logo-ams", className: className }, props), React.createElement("svg", { width: "22", height: "20", viewBox: "0 0 22 20", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M17.674 17.768c-1.936.694-4.032-.23-4.853-2.16-1.825-4.3-1.825-4.3-3.716.08-.828 1.92-2.994 2.847-4.955 2.029-1.963-.818-2.953-3.089-2.065-5.024.888-1.936 3.003-2.572 4.933-2.023 3.978 1.132 3.978 1.132 1.654-1.902-1.204-1.574-2.363-3.253-.495-5.556 1.457-1.8 4.155-1.536 5.522-.052 1.56 1.697 1.122 3.751-.33 5.608-2.373 3.034-2.373 3.034 1.29 1.953 2.109-.62 4.247-.016 5.13 1.943.923 2.041-.12 4.388-2.115 5.104m2.456-7.176l-4.748-7.048c-2.236-3.433-6.586-3.35-8.827 0 0 0-3.304 5.01-4.702 7.048-2.912 4.244.145 8.41 3.67 8.408h10.892c3.573.002 6.684-4.216 3.715-8.408", fill: "currentColor", fillRule: "evenodd" })));
}
exports.LogoAMS = LogoAMS;
function LogoBopper(_a) {
    var _a$className2 = _a.className,
        className = _a$className2 === undefined ? '' : _a$className2,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "logo-bopper", className: className }, props), React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M9.5 8H5V15H9.5C11.433 15 13 13.433 13 11.5C13 9.567 11.433 8 9.5 8Z", fill: "currentColor" }), React.createElement("path", { d: "M18.5 8C16.567 8 15 9.567 15 11.5C15 13.433 16.567 15 18.5 15H23.5C25.433 15 27 13.433 27 11.5C27 9.567 25.433 8 23.5 8H18.5Z", fill: "currentColor" }), React.createElement("path", { d: "M20 20.5C20 18.567 21.567 17 23.5 17C25.433 17 27 18.567 27 20.5C27 22.433 25.433 24 23.5 24C21.567 24 20 22.433 20 20.5Z", fill: "currentColor" }), React.createElement("path", { d: "M14.5 17H5V24H14.5C16.433 24 18 22.433 18 20.5C18 18.567 16.433 17 14.5 17Z", fill: "currentColor" })));
}
exports.LogoBopper = LogoBopper;
function LogoBopperWithName(_a) {
    var _a$className3 = _a.className,
        className = _a$className3 === undefined ? '' : _a$className3,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "logo-bopper-name", className: className }, props), React.createElement("svg", { preserveAspectRatio: "xMinYMid slice", height: "32", width: "100", viewBox: "32 0 519 161", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M176.95 59.8031C180.386 57.4127 184.764 55.994 189.788 55.994C206.854 55.994 214.138 67.9514 214.138 83.9309C214.138 99.9104 206.854 111.977 189.788 111.977C184.779 111.977 180.411 110.566 176.98 108.139C175.872 107.356 174.134 108.087 174.134 109.445V110.977C174.134 111.529 173.687 111.977 173.134 111.977H161.003C160.451 111.977 160.003 111.529 160.003 110.977V43.0002C160.003 42.448 160.451 42.0002 161.003 42.0002H173.134C173.687 42.0002 174.134 42.448 174.134 43.0002V58.4932C174.134 59.8401 175.844 60.5723 176.95 59.8031ZM174.134 83.9309C174.134 95.1274 178.048 97.845 187.07 97.845C196.093 97.845 200.006 95.1274 200.006 83.9309C200.006 72.8431 196.093 70.1255 187.07 70.1255C178.048 70.1255 174.134 72.8431 174.134 83.9309Z", fill: "#101015" }), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M272.04 83.9311C272.04 99.9106 262.583 111.977 244.973 111.977C227.363 111.977 217.905 99.9106 217.905 83.9311C217.905 67.9516 227.363 55.9942 244.973 55.9942C262.583 55.9942 272.04 67.9516 272.04 83.9311ZM232.037 83.9311C232.037 94.8015 235.407 97.8452 244.973 97.8452C254.539 97.8452 257.908 94.8015 257.908 83.9311C257.908 73.0607 254.539 70.1257 244.973 70.1257C235.407 70.1257 232.037 73.0607 232.037 83.9311Z", fill: "#101015" }), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M305.788 55.9942C300.764 55.9942 296.385 57.4129 292.95 59.8033C291.844 60.5725 290.134 59.8403 290.134 58.4934V56.9942C290.134 56.4419 289.687 55.9942 289.134 55.9942H277.003C276.45 55.9942 276.003 56.4419 276.003 56.9942V124.999C276.003 125.551 276.45 125.999 277.003 125.999H289.134C289.687 125.999 290.134 125.551 290.134 124.999V109.445C290.134 108.088 291.872 107.356 292.98 108.139C296.411 110.566 300.779 111.977 305.788 111.977C322.854 111.977 330.137 99.9106 330.137 83.9311C330.137 67.9516 322.854 55.9942 305.788 55.9942ZM303.07 97.8452C294.048 97.8452 290.134 95.1276 290.134 83.9311C290.134 72.8433 294.048 70.1257 303.07 70.1257C312.092 70.1257 316.006 72.8433 316.006 83.9311C316.006 95.1276 312.092 97.8452 303.07 97.8452Z", fill: "#101015" }), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M350.946 59.8033C354.382 57.4129 358.76 55.9942 363.784 55.9942C380.851 55.9942 388.134 67.9516 388.134 83.9311C388.134 99.9106 380.851 111.977 363.784 111.977C358.776 111.977 354.409 110.567 350.979 108.141C349.87 107.357 348.132 108.09 348.133 109.447L348.14 124.999C348.14 125.552 347.693 126 347.14 126H335.009C334.457 126 334.009 125.552 334.009 125L333.999 56.9943C333.999 56.442 334.447 55.9942 334.999 55.9942H347.131C347.683 55.9942 348.131 56.4419 348.131 56.9942V58.4934C348.131 59.8403 349.84 60.5725 350.946 59.8033ZM348.131 83.9311C348.131 95.1276 352.044 97.8452 361.066 97.8452C370.089 97.8452 374.002 95.1276 374.002 83.9311C374.002 72.8433 370.089 70.1257 361.066 70.1257C352.044 70.1257 348.131 72.8433 348.131 83.9311Z", fill: "#101015" }), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M441.289 82.8441C441.289 67.6255 434.549 55.9942 416.939 55.9942C398.894 55.9942 392.154 68.4951 392.154 84.0398C392.154 94.258 395.742 111.977 420.852 111.977C424.855 111.977 428.858 111.977 436.817 110.196C437.271 110.095 437.593 109.69 437.593 109.225V97.3644C437.593 96.7208 436.992 96.2455 436.363 96.3808C429.552 97.8452 425.019 97.8452 421.939 97.8452C412.905 97.8452 409.054 95.4659 407.457 91.1581C407.124 90.2596 407.846 89.3663 408.804 89.3663H437.789C439.722 89.3663 441.289 87.7993 441.289 85.8663V82.8441ZM416.722 70.1257C422.846 70.1257 426.008 71.9209 426.861 76.8978C427.008 77.7551 426.309 78.4959 425.44 78.4959H408.071C407.177 78.4959 406.471 77.7141 406.665 76.8415C407.708 72.1527 410.849 70.1257 416.722 70.1257Z", fill: "#101015" }), React.createElement("path", { d: "M480.002 55.9942C480.554 55.9942 481.002 56.4419 481.002 56.9942V69.1257C481.002 69.678 480.554 70.1257 480.002 70.1257H463.631C461.698 70.1257 460.131 71.6927 460.131 73.6257V110.977C460.131 111.529 459.683 111.977 459.131 111.977H446.999C446.447 111.977 445.999 111.529 445.999 110.977V69.9942C445.999 62.2622 452.267 55.9942 459.999 55.9942H480.002Z", fill: "#101015" }), React.createElement("path", { d: "M61 49H42V77H61C68.732 77 75 70.732 75 63C75 55.268 68.732 49 61 49Z", fill: "#101015" }), React.createElement("path", { d: "M96 49C88.268 49 82 55.268 82 63C82 70.732 88.268 77 96 77H115C122.732 77 129 70.732 129 63C129 55.268 122.732 49 115 49H96Z", fill: "#101015" }), React.createElement("path", { d: "M100 98C100 90.268 106.268 84 114 84H115C122.732 84 129 90.268 129 98C129 105.732 122.732 112 115 112H114C106.268 112 100 105.732 100 98Z", fill: "#101015" }), React.createElement("path", { d: "M79 84H42V112H79C86.732 112 93 105.732 93 98C93 90.268 86.732 84 79 84Z", fill: "#101015" })));
}
exports.LogoBopperWithName = LogoBopperWithName;
function IconProject(_a) {
    var _a$className4 = _a.className,
        className = _a$className4 === undefined ? '' : _a$className4,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "project", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M20.766 9.238C19.944 8.413 18.952 8 17.79 8c-1.163 0-2.156.413-2.978 1.238l-.811.814-.812-.814C12.366 8.413 11.374 8 10.211 8c-1.163 0-2.155.413-2.978 1.238C6.411 10.063 6 11.058 6 12.225c0 1.166.411 2.162 1.233 2.987l.812.814L14 22l5.955-5.974.811-.814c.823-.825 1.234-1.82 1.234-2.987s-.411-2.163-1.234-2.987z", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconProject = IconProject;
function IconProjectSelected(_a) {
    var _a$className5 = _a.className,
        className = _a$className5 === undefined ? '' : _a$className5,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "project-selected", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M20.766 9.238C19.944 8.413 18.952 8 17.79 8c-1.163 0-2.156.413-2.978 1.238l-.811.814-.812-.814C12.366 8.413 11.374 8 10.211 8c-1.163 0-2.155.413-2.978 1.238C6.411 10.063 6 11.058 6 12.225c0 1.166.411 2.162 1.233 2.987l.812.814L14 22l5.955-5.974.811-.814c.823-.825 1.234-1.82 1.234-2.987s-.411-2.163-1.234-2.987z", stroke: "currentColor", fill: "currentColor", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconProjectSelected = IconProjectSelected;
function IconAddToCart(_a) {
    var _a$className6 = _a.className,
        className = _a$className6 === undefined ? '' : _a$className6,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "add-to-cart", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M5 7h3l2 9h9l3-7h-2" }), React.createElement("path", { d: "M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1", fill: "currentColor" }), React.createElement("path", { d: "M18 9h-6M15 12V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
exports.IconAddToCart = IconAddToCart;
function IconX(_a) {
    var _a$className7 = _a.className,
        className = _a$className7 === undefined ? '' : _a$className7,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "x", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, React.createElement("rect", { transform: "rotate(45 14 14)", x: "13.5", y: "7", width: "1", height: "14", rx: ".5" }), React.createElement("rect", { transform: "rotate(-45 14 14)", x: "13.5", y: "7", width: "1", height: "14", rx: ".5" }))));
}
exports.IconX = IconX;
function IconPlus(_a) {
    var _a$className8 = _a.className,
        className = _a$className8 === undefined ? '' : _a$className8,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "plus", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, React.createElement("rect", { x: "13", y: "6.5", width: "1", height: "14", rx: ".5" }), React.createElement("rect", { transform: "rotate(90 13.5 13.5)", x: "13", y: "6.5", width: "1", height: "14", rx: ".5" }))));
}
exports.IconPlus = IconPlus;
function IconDownload(_a) {
    var _a$className9 = _a.className,
        className = _a$className9 === undefined ? '' : _a$className9,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "download", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M6 16v3c0 1.333.593 2 1.778 2h12.444C21.407 21 22 20.333 22 19v-3M10 12l4 4 4-4M14 6v10" }))));
}
exports.IconDownload = IconDownload;
function IconUserMultiple(_a) {
    var _a$className10 = _a.className,
        className = _a$className10 === undefined ? '' : _a$className10,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "user-multiple", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M16 20v-1.333C16 16.889 15.084 16 13.25 16h-5.5c-.759 0-1.407.26-1.945.78C5.27 17.303 5 17.93 5 18.668V20M13 10.5c0 1.667-.833 2.5-2.5 2.5S8 12.167 8 10.5 8.833 8 10.5 8s2.5.833 2.5 2.5zM23 20v-1.333C23 16.888 22.171 16 20.513 16H18M21 10.5c0 1.666-.834 2.5-2.5 2.5s-2.5-.834-2.5-2.5.834-2.5 2.5-2.5 2.5.834 2.5 2.5z" }))));
}
exports.IconUserMultiple = IconUserMultiple;
function IconUserAdd(_a) {
    var _a$className11 = _a.className,
        className = _a$className11 === undefined ? '' : _a$className11,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "user-add", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M17.5 21v-1.667c0-2.222-1.111-3.333-3.333-3.333H8.333c-.92 0-1.706.325-2.357.976-.65.651-.976 1.437-.976 2.357V21M14.583 9.333c0 2.223-1.11 3.334-3.333 3.334-2.222 0-3.333-1.111-3.333-3.334C7.917 7.111 9.027 6 11.25 6c2.222 0 3.333 1.111 3.333 3.333zM20 10v5M22.5 12.5h-5" }))));
}
exports.IconUserAdd = IconUserAdd;
function IconUser(_a) {
    var _a$className12 = _a.className,
        className = _a$className12 === undefined ? '' : _a$className12,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "user", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M19.5 21v-1.667c0-2.222-1.111-3.333-3.333-3.333h-5.834c-.92 0-1.706.325-2.357.976-.65.651-.976 1.437-.976 2.357V21M16.583 9.333c0 2.223-1.11 3.334-3.333 3.334-2.222 0-3.333-1.111-3.333-3.334C9.917 7.111 11.027 6 13.25 6c2.222 0 3.333 1.111 3.333 3.333z" }))));
}
exports.IconUser = IconUser;
function IconExclude(_a) {
    var _a$className13 = _a.className,
        className = _a$className13 === undefined ? '' : _a$className13,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "exclude", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M20 14c0 1.657-.586 3.071-1.757 4.243C17.07 19.414 15.657 20 14 20c-1.657 0-3.071-.586-4.243-1.757C8.586 17.07 8 15.657 8 14c0-1.657.586-3.071 1.757-4.243C10.93 8.586 12.343 8 14 8c1.657 0 3.071.586 4.243 1.757C19.414 10.93 20 12.343 20 14zM9.758 9.758l8.484 8.484" }))));
}
exports.IconExclude = IconExclude;
function IconSearch(_a) {
    var _a$className14 = _a.className,
        className = _a$className14 === undefined ? '' : _a$className14,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "search", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M17.803 17.803L23 23l-5.197-5.197C16.34 19.268 14.571 20 12.5 20c-2.071 0-3.839-.732-5.303-2.197C5.732 16.34 5 14.571 5 12.5c0-2.071.732-3.839 2.197-5.303C8.66 5.732 10.429 5 12.5 5c2.071 0 3.839.732 5.303 2.197C19.268 8.66 20 10.429 20 12.5c0 2.071-.732 3.839-2.197 5.303z", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconSearch = IconSearch;
function IconEdit(_a) {
    var _a$className15 = _a.className,
        className = _a$className15 === undefined ? '' : _a$className15,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "edit", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M20.5 15.5V20c0 1.028-.47 1.5-1.5 1.5H8c-.9 0-1.5-.6-1.5-1.5V9c0-.943.491-1.5 1.5-1.5h5" }), React.createElement("path", { d: "M19 7l2.5 3-6.5 6-3.5.5.5-3.5z" }))));
}
exports.IconEdit = IconEdit;
function IconTrash(_a) {
    var _a$className16 = _a.className,
        className = _a$className16 === undefined ? '' : _a$className16,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "trash", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M6.5 9h14M19 9v10.5c0 1-.524 1.5-1.571 1.5H9.57C8.524 21 8 20.5 8 19.5V9m2.5 0V8c0-.968.505-2 1-2h4c.655 0 1 1 1 2v1" }))));
}
exports.IconTrash = IconTrash;
function IconCart(_a) {
    var _a$className17 = _a.className,
        className = _a$className17 === undefined ? '' : _a$className17,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "cart", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M5 7h3l2 9h9l3-7H12" }), React.createElement("path", { d: "M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1", fill: "currentColor" }))));
}
exports.IconCart = IconCart;
function IconDuplicate(_a) {
    var _a$className18 = _a.className,
        className = _a$className18 === undefined ? '' : _a$className18,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "duplicate", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(6 6)", fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M6.538 0h6.924C14.487 0 15 .513 15 1.538v6.924C15 9.487 14.487 10 13.462 10H6.538C5.513 10 5 9.487 5 8.462V1.538C5 .513 5.513 0 6.538 0z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), React.createElement("rect", { fill: "currentColor", x: "9.5", y: "2.5", width: "1", height: "5", rx: ".5" }), React.createElement("rect", { fill: "currentColor", transform: "rotate(90 10 5)", x: "9.5", y: "2.5", width: "1", height: "5", rx: ".5" }), React.createElement("path", { d: "M3 6H1.385c-.383 0-.71.135-.98.406-.27.27-.405.596-.405.979v6.23C0 14.538.462 15 1.385 15h6.23C8.538 15 9 14.538 9 13.615V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
exports.IconDuplicate = IconDuplicate;
function IconShare(_a) {
    var _a$className19 = _a.className,
        className = _a$className19 === undefined ? '' : _a$className19,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "share", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M7 13v6.4c0 1.067.542 1.6 1.625 1.6h9.75C19.458 21 20 20.467 20 19.4V13M17 9.5L13.5 6 10 9.5M13.5 6v9" }))));
}
exports.IconShare = IconShare;
function IconRename(_a) {
    var _a$className20 = _a.className,
        className = _a$className20 === undefined ? '' : _a$className20,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "rename", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M16.389 7L20 10.611 10.611 20H7v-3.611z", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconRename = IconRename;
function IconFilter(_a) {
    var _a$className21 = _a.className,
        className = _a$className21 === undefined ? '' : _a$className21,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "filter", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { stroke: "currentColor", d: "M21 9H6l6 6.832v3.724L15 21v-5.168z", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconFilter = IconFilter;
function IconArrowDown(_a) {
    var _a$className22 = _a.className,
        className = _a$className22 === undefined ? '' : _a$className22,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "arrow-down", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M13.5 10.485v8M16.5 16l-3 3-3-3" }))));
}
exports.IconArrowDown = IconArrowDown;
function IconAddCircle(_a) {
    var _a$className23 = _a.className,
        className = _a$className23 === undefined ? '' : _a$className23,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "add-circle", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M21 13.5c0 2.071-.732 3.839-2.197 5.303C17.34 20.268 15.571 21 13.5 21c-2.071 0-3.839-.732-5.303-2.197C6.732 17.34 6 15.571 6 13.5c0-2.071.732-3.839 2.197-5.303C9.66 6.732 11.429 6 13.5 6c2.071 0 3.839.732 5.303 2.197C20.268 9.66 21 11.429 21 13.5zM17 13.5h-7M13.5 10v7" }))));
}
exports.IconAddCircle = IconAddCircle;
function IconArrowRight(_a) {
    var _a$className24 = _a.className,
        className = _a$className24 === undefined ? '' : _a$className24,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "arroRight", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M11 19.5l6-6-6-6", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconArrowRight = IconArrowRight;
function IconArrowLeft(_a) {
    var _a$className25 = _a.className,
        className = _a$className25 === undefined ? '' : _a$className25,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "arrow-left", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M16 19.5l-6-6 6-6", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconArrowLeft = IconArrowLeft;
function IconMore(_a) {
    var _a$className26 = _a.className,
        className = _a$className26 === undefined ? '' : _a$className26,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "more", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(6 12)", fill: "currentColor", fillRule: "evenodd" }, React.createElement("circle", { cx: "1.5", cy: "1.5", r: "1.5" }), React.createElement("circle", { cx: "7.5", cy: "1.5", r: "1.5" }), React.createElement("circle", { cx: "13.5", cy: "1.5", r: "1.5" }))));
}
exports.IconMore = IconMore;
function IconMusicNote(_a) {
    var _a$className27 = _a.className,
        className = _a$className27 === undefined ? '' : _a$className27,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "music-note", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M11 17H8.5c-.872 0-1.5.598-1.5 1.5 0 .889.611 1.5 1.5 1.5h1c.889 0 1.5-.611 1.5-1.5V17zm8-1h-2.5c-.955 0-1.5.602-1.5 1.5 0 .889.611 1.5 1.5 1.5h1c.889 0 1.5-.611 1.5-1.5V16z" }), React.createElement("path", { d: "M11 17V9.5L19 8v8" }))));
}
exports.IconMusicNote = IconMusicNote;
function IconTerms(_a) {
    var _a$className28 = _a.className,
        className = _a$className28 === undefined ? '' : _a$className28,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "terms", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M15 6H9.5c-.414 0-.768.146-1.06.44-.294.292-.44.646-.44 1.06v12c0 1 .5 1.5 1.5 1.5h9c1 0 1.5-.5 1.5-1.5V11l-5-5z" }), React.createElement("path", { d: "M15 6v5h5" })), React.createElement("rect", { fill: "currentColor", x: "11", y: "15", width: "6", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "11", y: "17", width: "6", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "11", y: "13", width: "3", height: "1", rx: ".5" }))));
}
exports.IconTerms = IconTerms;
function IconTermsLarge(_a) {
    var _a$className29 = _a.className,
        className = _a$className29 === undefined ? '' : _a$className29,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "terms-large", className: className }, props), React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(8 6)", fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M2 0h9.495L20 8.5V23c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z", stroke: "currentColor" }), React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M11 0v9h9" }), React.createElement("rect", { fill: "currentColor", x: "4", y: "17", width: "12", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "4", y: "20", width: "9", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "4", y: "14", width: "12", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "4", y: "11", width: "5", height: "1", rx: ".5" }))));
}
exports.IconTermsLarge = IconTermsLarge;
function IconSettings(_a) {
    var _a$className30 = _a.className,
        className = _a$className30 === undefined ? '' : _a$className30,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "settings", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M16 14c0 1.333-.667 2-2 2s-2-.667-2-2 .667-2 2-2 2 .667 2 2z" }), React.createElement("path", { d: "M18.71 15.91c-.192.433-.122.819.21 1.157l.037.038c.25.249.374.55.374.9 0 .353-.125.653-.374.901-.248.25-.548.374-.9.374s-.652-.125-.9-.374l-.039-.038c-.339-.331-.725-.401-1.158-.21-.422.181-.635.502-.636.961v.108c0 .849-.425 1.273-1.273 1.273-.849 0-1.273-.424-1.273-1.273v-.057c-.011-.476-.24-.796-.687-.96-.434-.192-.82-.122-1.158.21l-.038.037c-.249.25-.55.374-.9.374-.353 0-.653-.125-.901-.374-.25-.248-.374-.548-.374-.9s.125-.652.374-.9l.038-.039c.331-.339.401-.725.21-1.158-.181-.422-.502-.635-.961-.636h-.108C7.424 15.324 7 14.899 7 14.05c0-.352.124-.652.373-.9.248-.249.548-.373.9-.373h.057c.476-.011.796-.24.96-.687.192-.434.122-.82-.21-1.158l-.037-.038c-.25-.249-.374-.55-.374-.9 0-.353.125-.653.374-.901.248-.25.548-.374.9-.374s.652.125.9.374l.039.038c.339.331.725.401 1.158.21h.05c.423-.181.635-.502.637-.961v-.108c0-.352.125-.652.373-.9.249-.249.549-.373.9-.373.848 0 1.273.424 1.273 1.273v.057c.002.46.214.78.636.96.434.192.82.122 1.158-.21l.038-.037c.249-.25.55-.374.9-.374.353 0 .653.125.901.374.25.248.374.548.374.9s-.125.652-.374.9l-.038.039c-.331.339-.401.725-.21 1.158v.05c.181.423.502.635.961.637h.108c.849 0 1.273.425 1.273 1.273 0 .848-.424 1.273-1.273 1.273h-.057c-.46.002-.78.214-.96.636z" }))));
}
exports.IconSettings = IconSettings;
function IconProjectBox(_a) {
    var _a$className31 = _a.className,
        className = _a$className31 === undefined ? '' : _a$className31,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "project-box", className: className }, props), React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M.321 35.712h35.391V.322H.322z" }), React.createElement("path", { d: "M19.33 2.46l11.796 5.898c1.09.542 1.637 1.422 1.637 2.64V25.05c0 1.218-.546 2.098-1.637 2.64L19.33 33.59c-.88.44-1.76.44-2.64 0L4.894 27.69c-1.09-.549-1.63-1.434-1.622-2.654V10.998c0-1.218.546-2.098 1.637-2.64L16.704 2.46c.876-.435 1.75-.435 2.625 0z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M3.743 9.405l14.274 7.137 14.274-7.137M18 33.5v-17" }), React.createElement("path", { d: "M27.63 17.288c-.653.325-1.212.826-1.674 1.507l-.456.672-.456-.22c-.463-.222-1.022-.17-1.676.153-.653.324-1.212.825-1.675 1.506-.463.68-.693 1.34-.693 1.978 0 .637.23 1.066.693 1.289l.456.22L25.5 26l3.35-4.926.456-.672c.463-.679.694-1.338.694-1.977 0-.638-.231-1.067-.694-1.29-.462-.222-1.02-.17-1.675.153z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
exports.IconProjectBox = IconProjectBox;
function IconCheck(_a) {
    var _a$className32 = _a.className,
        className = _a$className32 === undefined ? '' : _a$className32,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "check", className: className }, props), React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M13 6l-5.5 6L5 9.273", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconCheck = IconCheck;
function IconCheckMultiple(_a) {
    var _a$className33 = _a.className,
        className = _a$className33 === undefined ? '' : _a$className33,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "check-multiple", className: className }, props), React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M12.333 5.167l-6.389 7.666-2.555-5.11M14.889 6.444l-5.111 6.39" }))));
}
exports.IconCheckMultiple = IconCheckMultiple;
function IconClear(_a) {
    var _a$className34 = _a.className,
        className = _a$className34 === undefined ? '' : _a$className34,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "clear", className: className }, props), React.createElement("svg", { width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M6.5 8.3v3.9h3.9" }), React.createElement("path", { d: "M8.131 15.45c.975 2.766 2.926 4.065 5.854 3.896 2.928-.168 4.717-1.682 5.368-4.542.651-2.86-.307-4.999-2.874-6.418-2.566-1.419-4.887-1.092-6.963.98L6.5 12.2" }))));
}
exports.IconClear = IconClear;
function IconWarning(_a) {
    var _a$className35 = _a.className,
        className = _a$className35 === undefined ? '' : _a$className35,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "warning", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M12.612 7.298L5.734 19.014c-.31.55-.312 1.099-.004 1.65.307.55.771.829 1.393.836h13.754c.622-.007 1.086-.286 1.393-.836.308-.551.307-1.1-.004-1.65L15.388 7.298C15.072 6.766 14.61 6.5 14 6.5c-.61 0-1.072.266-1.388.798zM14 11.5v4M14 17.5v1" }))));
}
exports.IconWarning = IconWarning;
function IconWarningLarge(_a) {
    var _a$className36 = _a.className,
        className = _a$className36 === undefined ? '' : _a$className36,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "warning-large", className: className }, props), React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentcolor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M16.203 10.01l-8.9 14.841c-.402.696-.404 1.392-.006 2.09.398.697.999 1.05 1.803 1.059h17.8c.804-.009 1.405-.362 1.803-1.06.398-.697.396-1.393-.006-2.089l-8.9-14.84C19.387 9.336 18.789 9 18 9c-.789 0-1.388.337-1.797 1.01zM18 15v5M18 23v1" }))));
}
exports.IconWarningLarge = IconWarningLarge;
function IconLock(_a) {
    var _a$className37 = _a.className,
        className = _a$className37 === undefined ? '' : _a$className37,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "lock", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M8.929 13.643h10c.952 0 1.428.476 1.428 1.428v5c0 .953-.476 1.429-1.428 1.429h-10c-.953 0-1.429-.476-1.429-1.429v-5c0-.952.476-1.428 1.429-1.428zM10.357 13.643v-2.857c0-1.375.595-2.406 1.786-3.093 1.19-.688 2.38-.688 3.571 0 1.19.687 1.786 1.718 1.786 3.093v2.857" }))));
}
exports.IconLock = IconLock;
function IconMail(_a) {
    var _a$className38 = _a.className,
        className = _a$className38 === undefined ? '' : _a$className38,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "mail", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M8 8h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5H8c-.825 0-1.5-.675-1.5-1.5v-9C6.5 8.675 7.175 8 8 8z" }), React.createElement("path", { d: "M21.5 9.5L14 14.75 6.5 9.5" }))));
}
exports.IconMail = IconMail;
function IconExternalLink(_a) {
    var _a$className39 = _a.className,
        className = _a$className39 === undefined ? '' : _a$className39,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "external-link", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M19.5 14.333v5c0 1.111-.556 1.667-1.667 1.667H8.667C7.556 21 7 20.444 7 19.333v-9.166c0-.46.163-.853.488-1.179.326-.325.718-.488 1.179-.488h5M17 6h5v5M12.833 15.167L22 6" }))));
}
exports.IconExternalLink = IconExternalLink;
function IconSignOut(_a) {
    var _a$className40 = _a.className,
        className = _a$className40 === undefined ? '' : _a$className40,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "sign-out", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M13 20h-3c-.65 0-1-.331-1-1V9c0-.667.22-1 1-1h3M18 16.5l2.5-2.5-2.5-2.5M20 14h-7" }))));
}
exports.IconSignOut = IconSignOut;
function IconInCart(_a) {
    var _a$className41 = _a.className,
        className = _a$className41 === undefined ? '' : _a$className41,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "in-cart", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M5 7h3l2 9h9l3-7h-3" }), React.createElement("path", { d: "M11 9H9", stroke: "currentColor", strokeLinecap: "round" }), React.createElement("path", { d: "M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1", fill: "currentColor" }), React.createElement("path", { d: "M15 5v8M17 11l-2 2-2-2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
exports.IconInCart = IconInCart;
function IconDate(_a) {
    var _a$className42 = _a.className,
        className = _a$className42 === undefined ? '' : _a$className42,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "date", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M7.778 7.5h12.444C21.407 7.5 22 8.056 22 9.167v11.666c0 1.111-.593 1.667-1.778 1.667H7.778C6.593 22.5 6 21.944 6 20.833V9.167C6 8.056 6.593 7.5 7.778 7.5zM17.5 5.5v4M10.5 5.5v4M6.5 12h15" }))));
}
exports.IconDate = IconDate;
function IconList(_a) {
    var _a$className43 = _a.className,
        className = _a$className43 === undefined ? '' : _a$className43,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "list", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(6 10)", fill: "currentColor", fillRule: "evenodd" }, React.createElement("rect", { x: "4", y: "8", width: "12", height: "1", rx: ".5" }), React.createElement("rect", { x: "4", y: "4", width: "12", height: "1", rx: ".5" }), React.createElement("rect", { x: "4", width: "12", height: "1", rx: ".5" }), React.createElement("rect", { y: "8", width: "2", height: "1", rx: ".5" }), React.createElement("rect", { y: "4", width: "2", height: "1", rx: ".5" }), React.createElement("rect", { width: "2", height: "1", rx: ".5" }))));
}
exports.IconList = IconList;
function IconPrint(_a) {
    var _a$className44 = _a.className,
        className = _a$className44 === undefined ? '' : _a$className44,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "print", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(6 6)", fill: "none", fillRule: "evenodd" }, React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M3 5V0h10v5M3 12H1.6C.533 12 0 11.481 0 10.444V6.556c0-.43.156-.797.469-1.1C.78 5.152 1.159 5 1.6 5h12.8c1.067 0 1.6.519 1.6 1.556v3.888C16 11.481 15.467 12 14.4 12H13" }), React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M3 9h10v7H3z" }), React.createElement("rect", { fill: "currentColor", x: "5", y: "11", width: "6", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "5", y: "13", width: "5", height: "1", rx: ".5" }), React.createElement("rect", { fill: "currentColor", x: "2", y: "6", width: "2", height: "1", rx: ".5" }))));
}
exports.IconPrint = IconPrint;
function IconInvoice(_a) {
    var _a$className45 = _a.className,
        className = _a$className45 === undefined ? '' : _a$className45,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "invoice", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("path", { d: "M8 12h12M8 17h12M13 7l-2 14M17 7l-2 14" }))));
}
exports.IconInvoice = IconInvoice;
function LogoAMSBeta(_a) {
    var _a$className46 = _a.className,
        className = _a$className46 === undefined ? '' : _a$className46,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "logo-ams-beta", className: className }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "42.5", height: "18", viewBox: "0 0 42.5 18" }, React.createElement("path", { fill: "#101015", d: "M18.4 15.8c-.4.4-.9.8-1.4 1-1.9.7-4-.2-4.9-2.2-1.8-4.3-1.8-4.3-3.7.1-.8 1.9-3 2.8-5 2-2-.8-3-3.1-2.1-5 .9-1.9 3-2.6 4.9-2 4 1.1 4 1.1 1.7-1.9-1.1-1.6-2.3-3.3-.4-5.6C9 .4 11.7.7 13 2.1c1.6 1.7 1.1 3.8-.3 5.6-2.4 3-2.4 3 1.3 2 .9-.3 1.7-.3 2.5-.1V5.2l-1.8-2.7c-2.2-3.4-6.6-3.4-8.8 0 0 0-3.3 5-4.7 7-2.9 4.3.1 8.5 3.6 8.5h10.9c1.5 0 3-.8 3.9-2h-.1c-.4 0-.7-.1-1.1-.2z" }), React.createElement("path", { fill: "#4487ff", d: "M40.5 3h-21c-1.1 0-2 .9-2 2v8c0 .9.6 1.7 1.5 1.9.2 0 .3.1.5.1h21c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }), React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF", d: "M36.9 9.6h1.5l-.7-3h-.2l-.6 3zm1.8 1.1h-2l-.3 1.3h-1.2l1.4-6h2.1l1.4 5.9H39l-.3-1.2zM30.3 6h4.3v1.1H33V12h-1.1V7.1h-1.6V6zm-4.9 0h3.8v1.1h-2.6v1.4H29v1.1h-2.5V11h2.7v1h-3.9V6zm-3.9 2.5h.8c.2 0 .4 0 .6-.1.1-.1.2-.3.2-.5v-.1c0-.2-.1-.4-.2-.5-.1-.1-.3-.1-.6-.1h-.8v1.3zm0 2.4h.8c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5v-.1c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.6-.2h-.8v1.5zm-1.6 0h.6V7.1h-.6V6h2.6c.3 0 .5 0 .8.1l.6.3c0 .2.1.4.2.6.1.2.1.4.1.6v.1c0 .3-.1.6-.3.8-.2.2-.4.3-.7.4v.2c.3.1.5.2.7.4.2.2.3.5.3.8v.1c0 .2 0 .4-.1.6-.1.2-.2.4-.3.5-.2.1-.3.2-.6.3-.2.1-.5.2-.7.2h-2.6v-1.1z" })));
}
exports.LogoAMSBeta = LogoAMSBeta;
function IconAchievement(_a) {
    var _a$className47 = _a.className,
        className = _a$className47 === undefined ? '' : _a$className47,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "achievement", className: className }, props), React.createElement("svg", { width: "51", height: "42", viewBox: "0 0 51 42", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { stroke: "#FFDE4B", strokeWidth: "2", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, React.createElement("path", { fill: "#FFDE4B", strokeLinejoin: "round", d: "M25.5 35.25l-9.11 4.79 1.74-10.145-7.371-7.185 10.186-1.48L25.5 12l4.555 9.23 10.186 1.48-7.37 7.185 1.74 10.145z" }), React.createElement("path", { d: "M25.5 4V1M47 18l2.121-2.121M4 18l-2.121-2.121" }))));
}
exports.IconAchievement = IconAchievement;
function IconInfo(_a) {
    var _a$className48 = _a.className,
        className = _a$className48 === undefined ? '' : _a$className48,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "info", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M23 14c0 2.485-.879 4.607-2.636 6.364C18.607 22.121 16.485 23 14 23s-4.607-.879-6.364-2.636C5.879 18.607 5 16.485 5 14s.879-4.607 2.636-6.364C9.393 5.879 11.515 5 14 5s4.607.879 6.364 2.636C22.121 9.393 23 11.515 23 14zM14 13v5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), React.createElement("circle", { fill: "currentColor", cx: "14", cy: "10", r: "1" }))));
}
exports.IconInfo = IconInfo;
function IconInfoFilled(_a) {
    var _a$className49 = _a.className,
        className = _a$className49 === undefined ? '' : _a$className49,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "info-filled", className: className }, props), React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M14 7c0 1.933-.683 3.583-2.05 4.95C10.583 13.317 8.933 14 7 14c-1.933 0-3.583-.683-4.95-2.05C.683 10.583 0 8.933 0 7c0-1.933.683-3.583 2.05-4.95C3.417.683 5.067 0 7 0c1.933 0 3.583.683 4.95 2.05C13.317 3.417 14 5.067 14 7zM6 6v4c0 .552.448 1 1 1s1-.448 1-1V6H6zm0-3v1c0 .552.448 1 1 1s1-.448 1-1V3H6z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconInfoFilled = IconInfoFilled;
function IconHelpFilled(_a) {
    var _a$className50 = _a.className,
        className = _a$className50 === undefined ? '' : _a$className50,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "help-filled", className: className }, props), React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M14 7c0 1.933-.683 3.583-2.05 4.95C10.583 13.317 8.933 14 7 14c-1.933 0-3.583-.683-4.95-2.05C.683 10.583 0 8.933 0 7c0-1.933.683-3.583 2.05-4.95C3.417.683 5.067 0 7 0c1.933 0 3.583.683 4.95 2.05C13.317 3.417 14 5.067 14 7zM6.898 3c-.85 0-1.55.207-2.098.622-.548.415-.815 1.08-.8 1.995h1.886c0-.333.071-.605.213-.814.142-.209.408-.314.799-.314.307 0 .52.071.638.213.119.142.178.302.178.479 0 .142-.048.264-.143.367-.096.103-.248.225-.455.367-.23.163-.42.315-.569.457-.15.142-.277.328-.385.559-.107.23-.16.419-.16.609 0 .254.205.46.46.46h.899c.285 0 .537-.187.62-.46.07-.229.183-.48.768-.923.276-.199.487-.397.633-.596.145-.198.218-.478.218-.84 0-.688-.25-1.224-.747-1.607C8.354 3.191 7.703 3 6.898 3zM8 9H6v1c0 .552.448 1 1 1s1-.448 1-1V9z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconHelpFilled = IconHelpFilled;
function IconPhone(_a) {
    var _a$className51 = _a.className,
        className = _a$className51 === undefined ? '' : _a$className51,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "phone", className: className }, props), React.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M21 17.502v2.112c.001.397-.164.775-.457 1.043-.292.268-.683.4-1.078.365-2.166-.235-4.247-.975-6.075-2.161-1.7-1.08-3.143-2.523-4.223-4.223-1.19-1.837-1.93-3.928-2.161-6.103-.036-.394.096-.784.362-1.076C7.634 7.167 8.011 7 8.407 7h2.111c.707-.007 1.31.511 1.408 1.21.09.677.255 1.34.493 1.979.193.514.07 1.094-.317 1.485l-.894.894c1.002 1.762 2.461 3.221 4.224 4.224l.894-.894c.39-.387.97-.51 1.485-.317.638.238 1.302.403 1.978.493.708.1 1.228.714 1.21 1.428z", stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.IconPhone = IconPhone;
function IconArrowRight2(_a) {
    var _a$className52 = _a.className,
        className = _a$className52 === undefined ? '' : _a$className52,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "arrow-right2", className: className }, props), React.createElement("svg", { width: "22", viewBox: "0 0 24 7", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("title", null, "Group"), React.createElement("desc", null, "Created with Sketch."), React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }, React.createElement("g", { transform: "translate(-309.000000, -1334.000000)", stroke: "#101015" }, React.createElement("g", { transform: "translate(309.000000, 1334.000000)" }, React.createElement("g", { id: "Group", transform: "translate(5.000000, 3.500000) rotate(-90.000000) translate(-5.000000, -3.500000) translate(2.000000, -1.000000)" }, React.createElement("line", { x1: "3", y1: "1.42108547e-14", x2: "3", y2: "8", id: "Stroke-2", stroke: "currentColor" }), React.createElement("polyline", { points: "6 5.51469318 3 8.51469318 0 5.51469318", stroke: "currentColor" })))))));
}
exports.IconArrowRight2 = IconArrowRight2;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Router Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var qs = __webpack_require__(162);
var React = __webpack_require__(0);
var LoadingSpinner_1 = __webpack_require__(163);
var PageHeader_1 = __webpack_require__(144);
var Page_1 = __webpack_require__(38);
var helpers_1 = __webpack_require__(151);
var license_1 = __webpack_require__(393);
var types_1 = __webpack_require__(105);
var defaultList = [];
var QueryStringPersistenceBlackList = ['goto', 'view'];
exports.getStateFromMatchContext = function (match) {
    return match.context ? match.context.store.getState() : undefined;
};
function getRouteLocation(pathname, query) {
    var location = { pathname: pathname };
    if (!lodash_1.isEmpty(query)) {
        var cleanQuery = lodash_1.pickBy(query, lodash_1.identity);
        location.search = "?" + qs.stringify(helpers_1.getEncodedQuery(cleanQuery), { encode: false });
    } else {
        location.query = {};
    }
    return location;
}
exports.getRouteLocation = getRouteLocation;
function refreshRoute(location, router) {
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : location.query;

    router.replace(getRouteLocation(location.pathname, query));
}
exports.refreshRoute = refreshRoute;
function goto(pathname, query, router) {
    var location = getRouteLocation(pathname, query);
    router.push(location);
}
exports.goto = goto;
function getOriginLocation() {
    return window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '');
}
exports.getOriginLocation = getOriginLocation;
function createHref(location, withOrigin) {
    return "" + (withOrigin ? getOriginLocation() : '') + location.pathname + (location.search || '') + (location.hash || '');
}
exports.createHref = createHref;
function linkWithQueryString(pathname, query) {
    return createHref(getRouteLocation(pathname, query));
}
exports.linkWithQueryString = linkWithQueryString;
function linkWithCurrentQueryString(pathname) {
    var query = qs.parse(window.location.search);
    var sanitizedQuery = lodash_1.omit(query, QueryStringPersistenceBlackList);
    return linkWithQueryString(pathname, sanitizedQuery);
}
exports.linkWithCurrentQueryString = linkWithCurrentQueryString;
function LoadingPage(_ref) {
    var routeProps = _ref.routeProps;

    return React.createElement(Page_1.default, { id: "loading", layout: "loose" }, routeProps && routeProps.pageHeaderProps && React.createElement(PageHeader_1.default, Object.assign({}, routeProps.pageHeaderProps)), React.createElement(LoadingSpinner_1.default, { center: true, fixed: true }));
}
exports.LoadingPage = LoadingPage;
function renderLoadableRoute(routeProps) {
    return function (_ref2) {
        var Component = _ref2.Component,
            props = _ref2.props;

        if (!Component || !props) {
            return React.createElement(LoadingPage, { routeProps: routeProps });
        }
        return React.createElement(Component, Object.assign({}, props, routeProps && routeProps.extraProps));
    };
}
exports.renderLoadableRoute = renderLoadableRoute;
function getLicenseParamsForRouteQuery(match) {
    var query = match.location.query;
    return query && types_1.QueryStringParam.License in query ? license_1.LicenseFilter.unserialize(query) : defaultList;
}
exports.getLicenseParamsForRouteQuery = getLicenseParamsForRouteQuery;
function getSimilaritySeedIdForRouteQuery(match) {
    var query = match.location.query;
    return query && types_1.QueryStringParam.Similarity in query ? query[types_1.QueryStringParam.Similarity] : undefined;
}
exports.getSimilaritySeedIdForRouteQuery = getSimilaritySeedIdForRouteQuery;
function prepareVariablesForDiscoverPage(_, match) {
    return {
        license_params: getLicenseParamsForRouteQuery(match)
    };
}
exports.prepareVariablesForDiscoverPage = prepareVariablesForDiscoverPage;
function prepareVariablesForCollectionPage(params, match) {
    return {
        query: '',
        filters: {
            collection_slug: params.slug
        },
        license_params: getLicenseParamsForRouteQuery(match)
    };
}
exports.prepareVariablesForCollectionPage = prepareVariablesForCollectionPage;
function prepareVariablesForProjectsPage(_ref3) {
    var id = _ref3.id;

    return {
        id: id || '',
        isDefaultRoute: !!!id
    };
}
exports.prepareVariablesForProjectsPage = prepareVariablesForProjectsPage;
function prepareVariablesForOrdersPage(_ref4) {
    var invoice_number = _ref4.invoice_number;

    var variables = {
        isDefaultRoute: !!!invoice_number
    };
    if (invoice_number) {
        variables.invoice_number = invoice_number;
    }
    return variables;
}
exports.prepareVariablesForOrdersPage = prepareVariablesForOrdersPage;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('UI');
exports.pageIsScrolling = actionCreator('PAGE_IS_SCROLLING');
exports.toggleLicenseBarVisibility = actionCreator('TOGGLE_LICENSE_BAR_VISIBILITY');
exports.setLicenseBarHeight = actionCreator('SET_LICENSE_BAR_HEIGHT');
exports.toggleLogInFormVisibility = actionCreator('TOGGLE_LOG_IN_FORM_VISIBILITY');
exports.toggleHeaderVisibility = actionCreator('TOGGLE_TOP_BAR_VISIBILITY');
exports.toggleTrackDetailsVisibility = actionCreator('TOGGLE_TRACK_DETAILS_VISIBILITY');
exports.toggleAddToProjectVisibility = actionCreator('TOGGLE_ADD_TO_PROJECT_VISIBILITY');
exports.toggleSignUpFormVisibility = actionCreator('TOGGLE_SIGN_UP_FORM_VISIBILITY');
exports.togglePlayerTermListVisibility = actionCreator('TOGGLE_PLAYER_TERM_LIST_VISIBILITY');
exports.setHeaderType = actionCreator('SET_HEADER_TYPE');
exports.setHeaderActions = actionCreator('SET_HEADER_ACTIONS');
exports.showAddTrackToProjectForm = actionCreator('SHOW_ADD_TO_PROJECT_FORM');
exports.showTrackDetails = actionCreator('SHOW_TRACK_DETAILS');
exports.showSignUpForm = actionCreator('SHOW_SIGN_UP_FORM');
exports.showDownloadAgreementModal = actionCreator('SHOW_DOWNLOAD_AGREEMENT_MODAL');
exports.clearUIState = actionCreator('CLEAR_UI_STATE');

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * QueryString Context
 */

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var qs = __webpack_require__(162);
var React = __webpack_require__(0);
var taxonomy_1 = __webpack_require__(106);
var budgetFilter_1 = __webpack_require__(211);
var helpers_1 = __webpack_require__(151);
var license_1 = __webpack_require__(393);
var searchFilters_1 = __webpack_require__(599);
var sortOrder_1 = __webpack_require__(394);
var tempoFilter_1 = __webpack_require__(600);
var types_1 = __webpack_require__(105);
exports.QueryStringParam = types_1.QueryStringParam;
exports.removeQsParamFromContext = function (keyToRemove, ctx, _ref) {
    var match = _ref.match,
        router = _ref.router;

    var currentQuery = qs.parse(match.location.search);
    helpers_1.replaceQueryString(lodash_1.omit(currentQuery, keyToRemove), match.location, router);
    switch (keyToRemove) {
        case types_1.QueryStringParam.Search:
            return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { not_term_filters: [], term_filters: [] }), query: '' });
        case types_1.QueryStringParam.Budget:
            return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { budget: undefined }) });
        case types_1.QueryStringParam.Similarity:
            var _a = ctx.filters,
                similarity = _a.similarity,
                rest = __rest(_a, ["similarity"]);
            return Object.assign({}, ctx, { filters: rest });
        case types_1.QueryStringParam.Tempo:
            return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { tempo: undefined }) });
        case types_1.QueryStringParam.License:
            return Object.assign({}, ctx, { license_params: [] });
        default:
            return ctx;
    }
};
exports.addBudgetFilterToContext = function (budget, ctx, _ref2) {
    var location = _ref2.match.location,
        router = _ref2.router;

    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.Budget, budgetFilter_1.BudgetFilter.serialize(budget)), location, router);
    return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { budget: budget }) });
};
exports.addSimilarityFilterToContext = function (trackId, ctx, _ref3) {
    var location = _ref3.match.location,
        router = _ref3.router;

    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.Similarity, trackId), location, router);
    return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { similarity: {
                track_id: trackId,
                feature: "Default" /* Default */
            } }) });
};
exports.addTempoFilterToContext = function (tempo, ctx, _ref4) {
    var location = _ref4.match.location,
        router = _ref4.router;

    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.Tempo, tempoFilter_1.TempoFilter.serialize(tempo)), location, router);
    return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { tempo: tempo }) });
};
exports.setSearchSortOrderInContext = function (sortOrder, ctx, _ref5) {
    var location = _ref5.match.location,
        router = _ref5.router;

    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.SortOrder, sortOrder_1.SortOrderSerializer.serialize(sortOrder)), location, router);
    return Object.assign({}, ctx, { sort: sortOrder });
};
exports.updateSearchFiltersInContext = function (search, ctx, _ref6) {
    var match = _ref6.match,
        router = _ref6.router;

    var queryString = _defineProperty({}, types_1.QueryStringParam.Search, "" + search);
    if (search.length > 0) {
        helpers_1.updateQueryString(queryString, match.location, router);
    } else {
        exports.removeQsParamFromContext(types_1.QueryStringParam.Search, ctx, { match: match, router: router });
    }

    var _searchFilters_1$Sear = searchFilters_1.SearchFilter.unserialize(queryString),
        _searchFilters_1$Sear2 = _searchFilters_1$Sear.filters,
        not_term_filters = _searchFilters_1$Sear2.not_term_filters,
        term_filters = _searchFilters_1$Sear2.term_filters;

    return Object.assign({}, ctx, { filters: Object.assign({}, ctx.filters, { not_term_filters: not_term_filters,
            term_filters: term_filters }) });
};
exports.addSearchFilterToContext = function (_ref7, ctx, withRouter) {
    var _ref8 = _slicedToArray(_ref7, 2),
        term = _ref8[0],
        exclude = _ref8[1];

    var query = withRouter.match.location.query;
    var taxonomyId = term.taxonomy ? term.taxonomy.id : undefined;
    var termQuery = taxonomyId === taxonomy_1.TaxonomyId[taxonomy_1.TaxonomyType.Lyrics] ? searchFilters_1.SearchFilter.serializeTaxonomyQuery(term) : searchFilters_1.SearchFilter.serializeTerm(term, exclude);
    var termRegExp = new RegExp("(!?" + term.name + ")", 'g');
    var search = [];
    if (types_1.QueryStringParam.Search in query) {
        search = searchFilters_1.getSearchAsArray(query);
        var oppositeTermMatch = query[types_1.QueryStringParam.Search].match(termRegExp);
        if (oppositeTermMatch) {
            var _oppositeTermMatch = _slicedToArray(oppositeTermMatch, 1),
                termMatch = _oppositeTermMatch[0];

            var termIndex = search.indexOf(termMatch);
            search.splice(termIndex, 1, termQuery);
        } else {
            search = [].concat(_toConsumableArray(search), [termQuery]);
        }
    } else {
        search = [termQuery];
    }
    return exports.updateSearchFiltersInContext(search, ctx, withRouter);
};
exports.removeSearchFilterFromContext = function (_ref9, ctx, withRouter) {
    var _ref10 = _slicedToArray(_ref9, 2),
        term = _ref10[0],
        exclude = _ref10[1];

    var query = withRouter.match.location.query;
    var taxonomyId = term.taxonomy ? term.taxonomy.id : undefined;
    var termQuery = taxonomyId === taxonomy_1.TaxonomyId[taxonomy_1.TaxonomyType.Lyrics] ? searchFilters_1.SearchFilter.serializeTaxonomyQuery(term) : searchFilters_1.SearchFilter.serializeTerm(term, exclude);
    var search = [];
    if (types_1.QueryStringParam.Search in query) {
        search = searchFilters_1.getSearchAsArray(query);
        var termIndex = search.indexOf(termQuery);
        search.splice(termIndex, 1);
    }
    return exports.updateSearchFiltersInContext(search, ctx, withRouter);
};
exports.addTaxonomyQueryToContext = function (term, ctx, withRouter) {
    var query = withRouter.match.location.query;
    var termQuery = searchFilters_1.SearchFilter.serializeTaxonomyQuery(term);
    var search = [];
    if (types_1.QueryStringParam.Search in query) {
        search = searchFilters_1.getSearchAsArray(query);
        var existingQueryMatch = searchFilters_1.parseTaxonomyQuery(query[types_1.QueryStringParam.Search]);
        if (existingQueryMatch) {
            var termIndex = search.findIndex(function (value) {
                return value.startsWith(existingQueryMatch.key);
            });
            search.splice(termIndex, 1, termQuery);
        } else {
            search = [].concat(_toConsumableArray(search), [termQuery]);
        }
    } else {
        search = [termQuery];
    }
    return Object.assign({}, exports.updateSearchFiltersInContext(search, ctx, withRouter), { taxonomy_query: {
            query: term.name,
            taxonomy_id: term.taxonomy.id
        } });
};
exports.removeTaxonomyQueryFromContext = function (term, ctx, withRouter) {
    return Object.assign({}, exports.removeSearchFilterFromContext([term, false], ctx, withRouter), { taxonomy_query: undefined });
};
exports.clearSearchQueryFromContext = function (ctx, _ref11) {
    var match = _ref11.match,
        router = _ref11.router;

    var query = match.location.query;
    var search = [];
    if (types_1.QueryStringParam.Search in query) {
        search = searchFilters_1.getSearchAsArray(query);
        var searchQueryMatch = query[types_1.QueryStringParam.Search].match(searchFilters_1.searchQueryRegEx);
        if (searchQueryMatch) {
            var _searchQueryMatch = _slicedToArray(searchQueryMatch, 1),
                firstMatch = _searchQueryMatch[0];

            var queryIndex = search.indexOf(firstMatch);
            search.splice(queryIndex, 1);
        }
    }
    if (search.length > 0) {
        helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.Search, "" + search), match.location, router);
    } else {
        exports.removeQsParamFromContext(types_1.QueryStringParam.Search, ctx, { match: match, router: router });
    }
    return Object.assign({}, ctx, { query: '' });
};
exports.saveLicenseToContext = function (licenseParams, ctx, _ref12) {
    var match = _ref12.match,
        router = _ref12.router;

    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.License, license_1.LicenseFilter.serialize(licenseParams)), match.location, router);
    return Object.assign({}, ctx, { license_params: licenseParams });
};
exports.setSearchQueryInContext = function (searchQuery, ctx, _ref13) {
    var match = _ref13.match,
        router = _ref13.router;

    var query = match.location.query;
    var searchQueryString = searchFilters_1.searchQueryTemplate({ searchQuery: searchQuery });
    var search = [];
    if (types_1.QueryStringParam.Search in query) {
        search = searchFilters_1.getSearchAsArray(query);
        var searchQueryMatch = query[types_1.QueryStringParam.Search].match(searchFilters_1.searchQueryRegEx);
        if (searchQueryMatch) {
            var _searchQueryMatch2 = _slicedToArray(searchQueryMatch, 1),
                firstMatch = _searchQueryMatch2[0];

            var queryIndex = search.indexOf(firstMatch);
            search.splice(queryIndex, 1, searchQueryString);
        } else {
            search = [searchQueryString].concat(_toConsumableArray(searchFilters_1.getSearchAsArray(query)));
        }
    } else {
        search = [searchQueryString];
    }
    helpers_1.updateQueryString(_defineProperty({}, types_1.QueryStringParam.Search, "" + search), match.location, router);
    return Object.assign({}, ctx, { query: searchQuery });
};
exports.clearFiltersFromContext = function (ctx, _ref14) {
    var match = _ref14.match,
        router = _ref14.router;

    helpers_1.replaceQueryString(lodash_1.omit(match.location.query, types_1.QueryStringParam.Budget, types_1.QueryStringParam.Search, types_1.QueryStringParam.Tempo, types_1.QueryStringParam.SortOrder), match.location, router);
    return Object.assign({}, ctx, { query: '', filters: {
            budget: undefined,
            not_term_filters: [],
            tempo: undefined,
            term_filters: []
        } });
};
exports.QueryStringContext = React.createContext({
    addBudgetFilter: function addBudgetFilter() {
        return null;
    },
    addSearchFilter: function addSearchFilter() {
        return null;
    },
    addTempoFilter: function addTempoFilter() {
        return null;
    },
    addTaxonomyQuery: function addTaxonomyQuery() {
        return null;
    },
    addSimilarityFilter: function addSimilarityFilter() {
        return null;
    },
    clearFilters: function clearFilters() {
        return null;
    },
    clearSearchQuery: function clearSearchQuery() {
        return null;
    },
    removeFilter: function removeFilter() {
        return null;
    },
    removeTaxonomyQuery: function removeTaxonomyQuery() {
        return null;
    },
    removeBudgetFilter: function removeBudgetFilter() {
        return null;
    },
    removeLicense: function removeLicense() {
        return null;
    },
    removeSearchFilter: function removeSearchFilter() {
        return null;
    },
    removeSimilarityFilter: function removeSimilarityFilter() {
        return null;
    },
    removeTempoFilter: function removeTempoFilter() {
        return null;
    },
    saveLicense: function saveLicense() {
        return null;
    },
    setSearchQuery: function setSearchQuery() {
        return null;
    },
    setSearchSortOrder: function setSearchSortOrder() {
        return null;
    }
});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
var config_1 = __webpack_require__(142);
var date_1 = __webpack_require__(119);
exports.getTermsState = function (_ref) {
    var license = _ref.license;
    return license;
};
exports.getUsages = function (state) {
    return state.usages;
};
exports.getUsageByIndex = function (index) {
    return reselect_1.createSelector(exports.getUsages, function (usages) {
        return index < usages.length ? usages[index] : undefined;
    });
};
exports.getUsageById = function (id) {
    return reselect_1.createSelector(exports.getUsages, function (usages) {
        return lodash_1.find(usages, { id: id });
    });
};
exports.getUsageIndexById = function (id) {
    return reselect_1.createSelector(exports.getUsages, function (usages) {
        return lodash_1.findIndex(usages, { id: id });
    });
};
exports.setComponentForUsage = function (index, component, value) {
    return reselect_1.createSelector(exports.getUsageByIndex(index), function (usage) {
        var newUsage = Object.assign({}, usage);
        newUsage[component] = value;
        newUsage.id = generateUsageId(newUsage, index);
        return newUsage;
    });
};
function isLicenseUsageValid(_ref2) {
    var term = _ref2.term,
        spot_count = _ref2.spot_count,
        contextual_param = _ref2.contextual_param,
        contextual_param_type = _ref2.contextual_param_type;

    if (!!term && !!spot_count && !!contextual_param && !!contextual_param_type) {
        if ((typeof contextual_param === "undefined" ? "undefined" : _typeof(contextual_param)) === 'object' && contextual_param.length > 0) {
            return true;
        }
    }
    if (!term && !spot_count && !!contextual_param && !!contextual_param_type) {
        if ((typeof contextual_param === "undefined" ? "undefined" : _typeof(contextual_param)) === 'object' && contextual_param.length > 0) {
            return true;
        }
    }
    return false;
}
exports.isLicenseUsageValid = isLicenseUsageValid;
function isLicenseValid(usages) {
    return !!usages.length && usages.filter(isLicenseUsageValid).length === usages.length;
}
exports.isLicenseValid = isLicenseValid;
function isValidSessionLicense(licenseState) {
    return licenseState.isValid && !!licenseState.scope && licenseState.scope.type === 'Session';
}
exports.isValidSessionLicense = isValidSessionLicense;
function getContextualParamAsString(_ref3) {
    var contextual_param = _ref3.contextual_param,
        contextual_param_type = _ref3.contextual_param_type;

    var contextualParamStr = '';
    if (contextual_param && contextual_param.length) {
        switch (contextual_param_type) {
            case 'BroadcastTerritory':
                contextualParamStr = contextual_param.map(function (_ref4) {
                    var name = _ref4.name;
                    return name;
                }).join(', ');
                break;
            case 'AudienceSize':
                contextualParamStr = "Audience of " + contextual_param[0].name;
                break;
            case 'ProducerLocation':
                contextualParamStr = "based in " + contextual_param[0].name;
                break;
            case 'ProductionBudget':
                contextualParamStr = "Production Budget in USD of " + contextual_param[0].name;
                break;
            case 'EpisodeBudget':
                contextualParamStr = "Episode Budget in USD of " + contextual_param[0].name;
                break;
        }
    }
    return contextualParamStr;
}
exports.getContextualParamAsString = getContextualParamAsString;
function getContextualParamTitle(_ref5) {
    var contextual_param_type = _ref5.contextual_param_type;

    switch (contextual_param_type) {
        case 'BroadcastTerritory':
            return 'Broadcast Territory';
        case 'AudienceSize':
            return 'Audience Size';
        case 'ProducerLocation':
            return 'Producer Location';
        case 'ProductionBudget':
            return 'Film Production Budget';
        case 'EpisodeBudget':
            return 'Episode Budget';
        default:
            return '';
    }
}
exports.getContextualParamTitle = getContextualParamTitle;
function generateUsageId(usage, index) {
    var id = "" + usage.medium.id + index;
    if (usage.term) {
        id += usage.term.id;
    }
    if (usage.spot_count) {
        id += usage.spot_count.id;
    }
    if (usage.contextual_param) {
        var contextParamIds = usage.contextual_param.reduce(function (acc, _ref6) {
            var paramId = _ref6.id;
            return "" + acc + paramId;
        }, '');
        id += contextParamIds;
    }
    return id;
}
exports.generateUsageId = generateUsageId;
function usageToString(usage, excludeMedium) {
    var contextual_param = usage.contextual_param,
        medium = usage.medium,
        spot_count = usage.spot_count,
        term = usage.term,
        airDate = usage.airDate;

    var result = excludeMedium ? 'No parameters yet...' : medium.name;
    if (term) {
        if (excludeMedium) {
            result = term.name;
        } else {
            result += ", " + term.name;
        }
        if (spot_count) {
            var spotType = medium.id === 2006 ? 'spot' : 'film';
            var plural = parseInt(spot_count.name, 10) > 1 ? 's' : '';
            result += ", " + spot_count.name + " " + spotType + plural;
            if (contextual_param && contextual_param.length) {
                result += ", " + getContextualParamAsString(usage);
            }
        }
    }
    if (config_1.programmingMedia.indexOf(medium.id) > -1 && contextual_param && contextual_param.length) {
        var paramStr = getContextualParamAsString(usage);
        result = excludeMedium ? paramStr : medium.name + ", " + paramStr;
    }
    if (airDate) {
        result += " (" + date_1.getFormattedDateFromGraphQL(airDate) + ")";
    }
    return result;
}
exports.usageToString = usageToString;
function getLicenseString(usages) {
    return usages.map(function (usage) {
        return usageToString(usage);
    }).join(' + ');
}
exports.getLicenseString = getLicenseString;
function licenseUsagesToSearchParams(usages) {
    return usages.map(function (usage) {
        var medium = usage.medium,
            term = usage.term,
            spot_count = usage.spot_count,
            contextual_param = usage.contextual_param,
            contextual_param_type = usage.contextual_param_type;

        return {
            medium: medium.id,
            term: term && term.id,
            spot_count: spot_count && spot_count.id,
            contextual_param: contextual_param.map(function (component) {
                return component.id;
            }),
            contextual_param_type: contextual_param_type
        };
    });
}
exports.licenseUsagesToSearchParams = licenseUsagesToSearchParams;
function findLicenseComponentById(component, id) {
    if (component.edges) {
        return lodash_1.chain(component.edges).flatMap(function (_ref7) {
            var node = _ref7.node;
            return node;
        }).filter({ internal_id: id }).thru(function (results) {
            return !!results.length && lodash_1.first(results);
        }).value();
    }
    return false;
}
function getLicenseComponentObjectFromId(connection, needle) {
    var component = findLicenseComponentById(connection, needle);
    return component && needle ? {
        id: needle,
        name: component.name
    } : undefined;
}
function getLicenseUsagesFromQueryString(_ref8) {
    var components = _ref8.components,
        params = _ref8.params;
    var audience_sizes = components.audience_sizes,
        broadcast_territories = components.broadcast_territories,
        media = components.media,
        producer_locations = components.producer_locations,
        spot_counts = components.spot_counts,
        terms = components.terms,
        production_budgets = components.production_budgets,
        episode_budgets = components.episode_budgets;

    return lodash_1.chain(params).map(function (param) {
        var medium = getLicenseComponentObjectFromId(media, param.medium);
        var term = getLicenseComponentObjectFromId(terms, param.term);
        var spotCount = getLicenseComponentObjectFromId(spot_counts, param.spot_count);
        var cxParamType = param.contextual_param_type;
        var cxParams = lodash_1.chain(param.contextual_param).map(function (id) {
            return [getLicenseComponentObjectFromId(audience_sizes, id), getLicenseComponentObjectFromId(broadcast_territories, id), getLicenseComponentObjectFromId(producer_locations, id), getLicenseComponentObjectFromId(production_budgets, id), getLicenseComponentObjectFromId(episode_budgets, id)];
        }).thru(function (contextualParams) {
            var result = [];
            contextualParams.forEach(function (possibilities) {
                possibilities.forEach(function (possibility) {
                    if (possibility) {
                        result.push(possibility);
                    }
                });
            });
            return result;
        }).value();
        if (medium && cxParamType && cxParams.every(function (value) {
            return !!value;
        })) {
            var usage = {
                contextual_param_type: cxParamType,
                contextual_param: cxParams,
                medium: medium,
                spot_count: spotCount,
                term: term
            };
            return usage;
        }
        return undefined;
    }).thru(function (u) {
        var validUsages = [];
        u.forEach(function (usage, index) {
            if (!!usage) {
                usage.id = generateUsageId(usage, index);
                validUsages.push(usage);
            }
        });
        return validUsages;
    }).value();
}
exports.getLicenseUsagesFromQueryString = getLicenseUsagesFromQueryString;
// FIXME: this function is pretty much a copy paste of the function above :/
// tslint:disable-next-line:max-line-length
function setLicenseFromParams(components, params) {
    var audience_sizes = components.audience_sizes,
        broadcast_territories = components.broadcast_territories,
        media = components.media,
        producer_locations = components.producer_locations,
        spot_counts = components.spot_counts,
        terms = components.terms,
        episode_budgets = components.episode_budgets,
        production_budgets = components.production_budgets;

    var usages = lodash_1.chain(params).map(function (param) {
        var medium = getLicenseComponentObjectFromId(media, param.medium);
        var term = getLicenseComponentObjectFromId(terms, param.term);
        var spotCount = getLicenseComponentObjectFromId(spot_counts, param.spot_count);
        var cxParamType = param.contextual_param_type;
        var cxParams = lodash_1.chain(param.contextual_param).map(function (id) {
            return [getLicenseComponentObjectFromId(audience_sizes, id), getLicenseComponentObjectFromId(broadcast_territories, id), getLicenseComponentObjectFromId(producer_locations, id), getLicenseComponentObjectFromId(production_budgets, id), getLicenseComponentObjectFromId(episode_budgets, id)];
        }).thru(function (contextualParams) {
            var result = [];
            contextualParams.forEach(function (possibilities) {
                possibilities.forEach(function (possibility) {
                    if (possibility) {
                        result.push(possibility);
                    }
                });
            });
            return result;
        }).value();
        if (medium && cxParamType && cxParams.every(function (value) {
            return !!value;
        })) {
            var usage = {
                contextual_param_type: cxParamType,
                contextual_param: cxParams,
                medium: medium,
                spot_count: spotCount,
                term: term
            };
            return usage;
        }
        return undefined;
    }).thru(function (convertedUsages) {
        var validUsages = [];
        convertedUsages.forEach(function (u) {
            if (!!u) {
                // tslint:disable-next-line:max-line-length
                u.id = "" + u.medium.id + (u.spot_count && u.spot_count.id) + (u.term && u.term.id) + u.contextual_param.map(function (_ref9) {
                    var id = _ref9.id;
                    return id;
                });
                validUsages.push(u);
            }
        });
        return validUsages;
    }).value();
    return usages;
}
exports.setLicenseFromParams = setLicenseFromParams;
function generateLicenseUsageFromComponents(components, id, airDate) {
    /* tslint:disable:no-object-literal-type-assertion */
    var usageId = id || components.map(function (comp) {
        return comp.component_id;
    }).join('');
    return components.reduce(function (acc, component) {
        var type = component.type;
        var licenseComponent = {
            id: component.component_id,
            name: component.name
        };
        switch (type) {
            case 'SpotCount':
                acc.spot_count = licenseComponent;
                break;
            case 'Medium':
                var _lodash_1$find = lodash_1.find(config_1.mediaTypeDefinitions, { id: licenseComponent.id }),
                    label = _lodash_1$find.label;

                if (label) {
                    licenseComponent.name = label;
                }
                acc.medium = licenseComponent;
                acc.id = usageId;
                acc.airDate = airDate;
                break;
            case 'Term':
                acc.term = licenseComponent;
                break;
            case 'AudienceSize':
            case 'BroadcastTerritory':
            case 'ProducerLocation':
            case 'EpisodeBudget':
            case 'ProductionBudget':
                if (acc.contextual_param) {
                    acc.contextual_param.push(licenseComponent);
                } else {
                    acc.contextual_param = [licenseComponent];
                    acc.contextual_param_type = type;
                }
                break;
        }
        return acc;
    }, {});
}
exports.generateLicenseUsageFromComponents = generateLicenseUsageFromComponents;
exports.getLicenseParams = reselect_1.createSelector(exports.getTermsState, function (license) {
    return isValidSessionLicense(license) ? licenseUsagesToSearchParams(license.usages) : undefined;
});

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Page Container
 */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var Page_1 = __webpack_require__(391);
var PageContainer = function PageContainer(_a) {
    var children = _a.children,
        noIndex = _a.noIndex,
        templateProps = __rest(_a, ["children", "noIndex"]);

    return React.createElement(Page_1.default, Object.assign({}, templateProps), React.createElement(react_helmet_1.Helmet, null, noIndex && React.createElement("meta", { name: "robots", content: "noindex" })), children);
};
exports.default = found_1.withRouter(PageContainer);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Player');
exports.addTrackToQueue = actionCreator('ADD_TRACK_TO_QUEUE');
exports.addTracksToQueue = actionCreator('ADD_TRACKS_TO_QUEUE');
exports.clearQueue = actionCreator('CLEAR_QUEUE');
exports.replaceQueue = actionCreator('REPLACE_QUEUE');
exports.pause = actionCreator('PAUSE');
exports.play = actionCreator('PLAY');
exports.playNext = actionCreator('NEXT');
exports.playPrevious = actionCreator('PREVIOUS');
exports.playTrackFromQueue = actionCreator('PLAY_TRACK');
exports.togglePlay = actionCreator('TOGGLE_PLAY');
exports.changeTrack = actionCreator('CHANGE_TRACK');
exports.toggleShouldOnlyPlayOriginalTracks = actionCreator('TOGGLE_SHOULD_ONLY_PLAY_ORIGINAL_TRACKS');
exports.updateCurrentTrackElapsedTime = actionCreator('UPDATE_CURRENT_TRACK_ELAPSED_TIME');

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Track Object Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var AddToCartButton_1 = __webpack_require__(289);
var Button_1 = __webpack_require__(10);
var TrackLicenseBuilderButton_1 = __webpack_require__(661);
var Icon_1 = __webpack_require__(12);
var PriceTag_1 = __webpack_require__(126);
var Tooltip_1 = __webpack_require__(172);
// import { MakeAnOfferTooltip } from '../components/molecules/messaging/MakeAnOfferTooltip';
var Artist_1 = __webpack_require__(186);
var Track_1 = __webpack_require__(231);
var defaultList = [];
exports.getTrackAssetsForFormat = function (needle) {
    return function (assets) {
        return assets.filter(function (_ref) {
            var file_format = _ref.file_format;
            return lodash_1.lowerCase(file_format) === lodash_1.lowerCase(needle);
        });
    };
};
exports.getTrackAssetsForType = function (needle) {
    return function (assets) {
        return assets.filter(function (_ref2) {
            var type = _ref2.type;
            return lodash_1.lowerCase(type) === lodash_1.lowerCase(needle);
        });
    };
};
exports.getTrackAssetsForVersion = function (needle) {
    return function (assets) {
        return assets.filter(function (_ref3) {
            var version = _ref3.version;
            return lodash_1.lowerCase(version) === lodash_1.lowerCase(needle);
        });
    };
};
exports.AssetVersionRank = {
    original: 0,
    instrumental: 1,
    underscore: 2
};
function sortAssetsByVersion(assets) {
    return lodash_1.sortBy(assets, function (a) {
        return lodash_1.get(exports.AssetVersionRank, lodash_1.lowerCase(a.version), 100);
    });
}
exports.sortAssetsByVersion = sortAssetsByVersion;
exports.getTrackAssets = function (_ref4) {
    var assets = _ref4.assets,
        format = _ref4.format,
        type = _ref4.type,
        version = _ref4.version;
    return lodash_1.chain(sortAssetsByVersion(assets) || defaultList).thru(format ? exports.getTrackAssetsForFormat(format) : function (a) {
        return a;
    }).thru(type ? exports.getTrackAssetsForType(type) : function (a) {
        return a;
    }).thru(version ? exports.getTrackAssetsForVersion(version) : function (a) {
        return a;
    }).value();
};
exports.getTrackAsset = function (payload) {
    return lodash_1.first(exports.getTrackAssets(payload));
};
function getTrackInstrumentalAsset(assets) {
    var format = 'mp3';
    return exports.getTrackAsset({ assets: assets, format: format, version: 'instrumental', type: 'track-preview' }) || exports.getTrackAsset({ assets: assets, format: format, version: 'instrumental', type: 'track' });
}
exports.getTrackInstrumentalAsset = getTrackInstrumentalAsset;
function getDefaultTrackInstrumentalAsset(assets) {
    return getTrackInstrumentalAsset(assets) || getDefaultTrackAsset(assets);
}
exports.getDefaultTrackInstrumentalAsset = getDefaultTrackInstrumentalAsset;
function getDefaultTrackAsset(assets) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'original';

    var format = 'mp3';
    return exports.getTrackAsset({ assets: assets, format: format, version: version, type: 'track-preview' }) || exports.getTrackAsset({ assets: assets, format: format, version: version, type: 'track' }) || getTrackInstrumentalAsset(assets) || exports.getTrackAsset({ assets: assets, format: format, type: 'track-preview' }) || exports.getTrackAsset({ assets: assets, format: format, type: 'track' }) || {}; // To mitigate undefined dereference exceptions
}
exports.getDefaultTrackAsset = getDefaultTrackAsset;
exports.getResponsiveTrackThumbnail = function (track) {
    return image_1.getResponsiveThumbnailAssets(track.assets || defaultList, track.artist && track.artist.assets || defaultList);
};
exports.getTrackResultsFromLineItems = function (lineItems) {
    return lineItems.map(function (_ref5) {
        var track = _ref5.track;
        return track;
    });
};
function getTrackDuration(_ref6) {
    var track = _ref6.track,
        _ref6$version = _ref6.version,
        version = _ref6$version === undefined ? getDefaultTrackAsset(track.assets) : _ref6$version;

    var fallback = track.duration || 0;
    return !!version.metadata ? version.metadata.duration || fallback : fallback;
}
exports.getTrackDuration = getTrackDuration;
function getTrackPagePath(track) {
    return Track_1.TrackPagePath(track.slug);
}
exports.getTrackPagePath = getTrackPagePath;
function getArtistPagePath(track) {
    return Artist_1.ArtistPagePath(track.artist.slug);
}
exports.getArtistPagePath = getArtistPagePath;
function getTrackPriceElement(track, _ref7) {
    var buttonProps = _ref7.buttonProps,
        addToCartButtonProps = _ref7.addToCartButtonProps,
        licenseBuilderButtonProps = _ref7.licenseBuilderButtonProps;

    if (track.hasOwnProperty('price') === false) {
        return undefined;
    }
    if (trackHasExclusions(track)) {
        return React.createElement(Tooltip_1.Tooltip, { content: "This track cannot be licensed in the selected region.", size: "xsmall", theme: "black", placement: "bottom-end" }, React.createElement(Button_1.default, { variant: "icon", textColor: "bw7", icon: React.createElement(Icon_1.IconWarning, null) }));
    }
    if (canLicenseTrack(track)) {
        return React.createElement(React.Fragment, null, React.createElement(AddToCartButton_1.default, Object.assign({ item: track, label: React.createElement(PriceTag_1.default, { amount: track.price }), stopPropagationOnClick: true }, buttonProps, addToCartButtonProps)));
    }
    // Price at 0 means no license is set. We display a button that opens the license builder
    return React.createElement(TrackLicenseBuilderButton_1.default, Object.assign({ variant: "pill",
        // icon={<IconAddToCart />}
        label: "Show\xA0Price", colorScheme: "accent", size: "xsmall", track: track.slug, stopPropagation: true, withShadow: true }, licenseBuilderButtonProps));
}
exports.getTrackPriceElement = getTrackPriceElement;
function canLicenseTrack(track) {
    return !trackHasExclusions(track) && !!track.price;
}
exports.canLicenseTrack = canLicenseTrack;
function trackHasExclusions(track) {
    return !!track.matched_exclusions && track.matched_exclusions.length !== 0;
}
exports.trackHasExclusions = trackHasExclusions;
function compareResponsiveImage(a, b) {
    if (a && !b || b && !a) {
        return false;
    }
    var valid = true;
    if (a && b) {
        valid = !lodash_1.some(a, function (aImages, size) {
            var bImages = b[size];
            if (aImages && !bImages || bImages && !aImages) {
                return true;
            }
            if (aImages && bImages) {
                return aImages.some(function (imageData, index) {
                    return imageData.path !== bImages[index].path;
                });
            }
            return false;
        });
    }
    return valid;
}
exports.compareResponsiveImage = compareResponsiveImage;
exports.getTrackFromProps = function (_, props) {
    return props.trackResult;
};
exports.getTrackIdFromProps = function (_, _ref8) {
    var trackId = _ref8.trackId;
    return trackId;
};

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * String Utils
 */
/* tslint:disable:max-line-length */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var removeAccents = __webpack_require__(1256);
function validateEmail(value) {
    return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
    );
}
exports.validateEmail = validateEmail;
function validatePassword(value) {
    return value.length >= 8 && /[A-Z]+/.test(value) && /[0-9]+/.test(value);
}
exports.validatePassword = validatePassword;
function validateString(value) {
    return value && lodash_1.trim(value).length > 2;
}
exports.validateString = validateString;
function validatePostalCode(value, regex) {
    var reg = new RegExp("^" + regex + "$");
    return reg.test(value);
}
exports.validatePostalCode = validatePostalCode;
function toInnerHTML(text) {
    return { __html: text };
}
exports.toInnerHTML = toInnerHTML;
function stripHTMLTagsFromString(text) {
    var stripTagsRegex = /(<([^>]+)>)/ig;
    return text.replace(stripTagsRegex, '');
}
exports.stripHTMLTagsFromString = stripHTMLTagsFromString;
function sanitizeString(text) {
    return removeAccents(text.trim().toLowerCase());
}
exports.sanitizeString = sanitizeString;
function capitalizeString(text) {
    return text.replace(/(^|\s)[a-z]/g, function (f) {
        return f.toUpperCase();
    });
}
exports.capitalizeString = capitalizeString;
function fuzzyFilter(input, search) {
    var inputIndex = 0;
    lodash_1.each(search, function (letter, index) {
        if (letter === input[inputIndex]) {
            inputIndex += 1;
        }
    });
    return inputIndex === input.length;
}
exports.fuzzyFilter = fuzzyFilter;
function twitterHandleFromURL(url) {
    var res = url.match(/((https?:\/\/)?(www\.)?twitter\.com\/)?(@|#!\/)?([A-Za-z0-9_]{1,15})(\/([-a-z]{1,20}))?/);
    return res && res.length >= 6 ? res[5] : undefined;
}
exports.twitterHandleFromURL = twitterHandleFromURL;

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('User');
exports.setUserProfile = actionCreator('SET_USER_PROFILE');
exports.setViewerId = actionCreator('SET_VIEWER_ID');
exports.setUserLoginStatus = actionCreator('SET_USER_LOGIN_STATUS');
exports.setUserDetail = actionCreator('SET_USER_DETAIL');
exports.setCognitoUser = actionCreator('SET_COGNITO_USER');
exports.setUserStripeToken = actionCreator('SET_USER_STRIPE_TOKEN');
// Request Async Actions
exports.requestUpdateUserProfile = actionCreator('REQUEST_UPDATE_USER_PROFILE');
exports.requestTrackUserRegistration = actionCreator('REQUEST_TRACK_USER_REGISTRATION');
exports.requestUserLogIn = actionCreator('REQUEST_USER_LOG_IN');
exports.requestUserLogOut = actionCreator('REQUEST_USER_LOG_OUT');
exports.requestUserSignUp = actionCreator('REQUEST_USER_SIGN_UP');
exports.requestResetPassword = actionCreator('REQUEST_RESET_PASSWORD');
exports.requestUserAuthenticationWithToken = actionCreator('REQUEST_USER_AUTHENTICATION_WITH_TOKEN');
exports.requestSendConfirmationEmail = actionCreator('REQUEST_SEND_CONFIRMATION_EMAIL');
exports.requestVerifyUserEmail = actionCreator('REQUEST_VERIFY_USER_EMAIL');
// Async Actions
exports.logInUser = actionCreator.async('LOG_IN_USER');
exports.logOutUser = actionCreator.async('LOG_OUT_USER');
exports.signUpUser = actionCreator.async('SIGN_UP_USER');
exports.authenticateUserWithToken = actionCreator.async('AUTHENTICATE_USER_WITH_TOKEN');
exports.resetPassword = actionCreator.async('RESET_PASSWORD');
exports.updateUserProfile = actionCreator.async('UPDATE_USER_PROFILE');
exports.trackNewUserRegistration = actionCreator.async('TRACK_USER_REGISTRATION');
exports.sendConfirmationEmail = actionCreator.async('SEND_CONFIRMATION_EMAIL');
exports.verifyUserEmail = actionCreator.async('VERIFY_USER_EMAIL');

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LinkButton Component
 */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(10);
function LinkButton(_a) {
    var activeClassName = _a.activeClassName,
        _a$includeQsParams = _a.includeQsParams,
        includeQsParams = _a$includeQsParams === undefined ? true : _a$includeQsParams,
        external = _a.external,
        to = _a.to,
        wrapperComponent = _a.wrapperComponent,
        restProps = __rest(_a, ["activeClassName", "includeQsParams", "external", "to", "wrapperComponent"]);

    var linkProps = Object.assign({}, external ? {
        hyperLinkProps: {
            href: to,
            target: '_blank'
        },
        wrapperComponent: 'a'
    } : {
        routerLinkProps: {
            // if `to` is not a string we take for granted that we want to override
            // the current behavior of persisting query string parameters.
            to: typeof to === 'string' && includeQsParams ? router_1.linkWithCurrentQueryString(to) : to,
            activeClassName: activeClassName
        },
        wrapperComponent: wrapperComponent || found_1.Link
    });
    return React.createElement(Button_1.default, Object.assign({}, linkProps, restProps));
}
exports.default = LinkButton;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var get_user_locale_1 = __webpack_require__(1362);
var en = __webpack_require__(1364);
var getTranslations = function getTranslations(lang) {
    switch (lang) {
        case 'en':
            return en;
        // French translations are not ready yet
        // case 'fr': return fr;
        default:
            return en;
    }
};
function getUserLanguage() {
    var language = 'en';
    var locale = get_user_locale_1.getUserLocale();
    if (locale) {
        try {
            language = locale.split('-')[0];
            // tslint:disable-next-line:no-empty
        } catch (e) {}
    }
    return language;
}
exports.getUserLanguage = getUserLanguage;
exports.currentLang = getUserLanguage();
exports.default = getTranslations(exports.currentLang);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Notification');
exports.pushNotification = actionCreator('PUSH');
exports.consumeNotification = actionCreator('CONSUME');

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Colors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var woodsmoke = '#101015';
var manatee = '#8A8F99';
var cadetBlue = '#B2B8C2';
var geyser = '#D2D9E1';
var athensgray = '#E4E8ED';
var aquahaze = '#F0F4F7';
var popesmoke = '#F9FAFB';
var dodgerblue = '#4487FF';
var aliceblue = '#F5FAFF';
var carnation = '#F75B5B';
var chablis = '#FFF5F5';
var bermuda = '#75DBBE';
exports.blackHex = woodsmoke;
exports.darkHex = woodsmoke;
exports.bw8Hex = woodsmoke;
exports.bw7Hex = manatee;
exports.bw6Hex = cadetBlue;
exports.bw5Hex = geyser;
exports.bw4Hex = athensgray;
exports.bw3Hex = aquahaze;
exports.bw2Hex = popesmoke;
exports.bw1Hex = 'white';
exports.whiteHex = 'white';
exports.accentHex = dodgerblue;
exports.accentSubtleHex = aliceblue;
exports.dangerousHex = carnation;
exports.dangerousSubtleHex = chablis;
exports.positiveHex = bermuda;
exports.defaultHex = woodsmoke;
exports.black = 'bw8';
exports.bw8 = 'bw8';
exports.bw7 = 'bw7';
exports.bw6 = 'bw6';
exports.bw5 = 'bw5';
exports.bw4 = 'bw4';
exports.bw3 = 'bw3';
exports.bw2 = 'bw2';
exports.bw1 = 'bw1';
exports.white = 'bw1';
exports.accent = 'accent';
exports.accent2 = 'accent2';
exports.accentSubtle = 'accent-subtle';
exports.dangerous = 'dangerous';
exports.dangerousSubtle = 'dangerous-subtle';
exports.positive = 'positive';
exports.defaultColor = 'default';
exports.transparent = 'transparent';
function getTextColorClassName(textColor) {
    return textColor ? "color--" + textColor : '';
}
exports.getTextColorClassName = getTextColorClassName;
function getBackgroundColorClassName(bgColor) {
    return bgColor ? "bgcolor--" + bgColor : '';
}
exports.getBackgroundColorClassName = getBackgroundColorClassName;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Grid Settings
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.baseline = 8;

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * BrowsePage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1251);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var withLicenseBar_1 = __webpack_require__(392);
var Section_1 = __webpack_require__(598);
// Page Path
exports.BrowsePagePath = '/browse';

var BrowsePage = function (_React$Component) {
    _inherits(BrowsePage, _React$Component);

    function BrowsePage() {
        _classCallCheck(this, BrowsePage);

        return _possibleConstructorReturn(this, (BrowsePage.__proto__ || Object.getPrototypeOf(BrowsePage)).apply(this, arguments));
    }

    _createClass(BrowsePage, [{
        key: "render",
        value: function render() {
            return React.createElement(Section_1.default, { id: "browse" }, React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, "Find & License Music")), this.props.children);
        }
    }]);

    return BrowsePage;
}(React.Component);

exports.default = withLicenseBar_1.default(BrowsePage);

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(256);
var image_1 = __webpack_require__(64);
var string_1 = __webpack_require__(47);
var track_1 = __webpack_require__(44);
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
var player_1 = __webpack_require__(154);
exports.getLongestDuration = function (tracks) {
    return lodash_1.reduce(tracks, function (d, _ref) {
        var duration = _ref.trackInfo.duration;
        return !!duration ? duration > d ? duration : d : d;
    }, 0);
};
exports.getTrackInQueueByVersionId = function (versionId) {
    return reselect_1.createSelector(player_1.getQueue, function (queue) {
        return lodash_1.find(queue, { versionId: versionId });
    });
};
exports.getTrackInQueueById = reselect_1.createSelector(player_1.getQueue, function (queue) {
    return lodash_1.memoize(function (id) {
        var foundTracks = lodash_1.filter(queue, function (track) {
            return track.trackId === id || track.versionId === id;
        });
        if (foundTracks.length > 1) {
            var longuestDuration = exports.getLongestDuration(foundTracks);
            return foundTracks.find(function (_ref2) {
                var _ref2$trackInfo = _ref2.trackInfo,
                    assets = _ref2$trackInfo.assets,
                    duration = _ref2$trackInfo.duration;
                return !!lodash_1.find(assets, { id: id, version: 'original' }) || duration === longuestDuration;
            });
        }
        return lodash_1.first(foundTracks);
    });
});
exports.getTrackInQueueByIndex = reselect_1.createSelector(player_1.getQueue, function (queue) {
    return lodash_1.memoize(function (trackIndex) {
        return lodash_1.nth(queue, trackIndex);
    });
});
exports.getTrackVersion = function (trackVersionId) {
    return reselect_1.createSelector(exports.getTrackInQueueByVersionId(trackVersionId), function (track) {
        return track && lodash_1.find(track.trackInfo.assets, { id: trackVersionId });
    });
};
exports.getTrackVersionType = function (trackVersionId) {
    return reselect_1.createSelector(exports.getTrackInQueueByVersionId(trackVersionId), exports.getTrackVersion(trackVersionId), function (track, version) {
        return version ? version.version : '';
    });
};
exports.getTrackAudioFile = function (trackVersionId) {
    return reselect_1.createSelector(exports.getTrackInQueueByVersionId(trackVersionId), exports.getTrackVersion(trackVersionId), function (track, version) {
        return version ? version.path : '';
    });
};
exports.getTrackTitle = function (trackVersionId) {
    return reselect_1.createSelector(exports.getTrackInQueueByVersionId(trackVersionId), exports.getTrackVersion(trackVersionId), function (track, version) {
        if (track) {
            return version && lodash_1.lowerCase(version.version) !== 'original' ? track.trackInfo.title + " (" + string_1.capitalizeString(version.version) + " Version)" : track.trackInfo.title;
        }
        return '';
    });
};
exports.getTrackArtist = function (trackVersionId) {
    return reselect_1.createSelector(exports.getTrackInQueueByVersionId(trackVersionId), function (track) {
        if (track) {
            return track.trackInfo.artist.name || '';
        }
        return '';
    });
};
function changeTrack(state, track) {
    var newState = Object.assign({}, state, { isTrackPlaying: true });
    var nextTrack = typeof track === 'string' ? exports.getTrackInQueueByVersionId(track)(state) : exports.getTrackInQueueByIndex(state)(track - 1);
    if (nextTrack) {
        newState.currentTrack = Object.assign({}, nextTrack, { artist: exports.getTrackArtist(nextTrack.versionId)(state), audioFile: exports.getTrackAudioFile(nextTrack.versionId)(state), title: exports.getTrackTitle(nextTrack.versionId)(state), version: exports.getTrackVersionType(nextTrack.versionId)(state) });
        var trackIndexInQueue = lodash_1.findIndex(state.queue, { versionId: nextTrack.versionId });
        var trackIndexInHistory = lodash_1.findIndex(state.history, { versionId: nextTrack.versionId });
        // If changing track sequentially, we make sure to play only original versions
        // by skipping the other versions
        if (state.shouldOnlyPlayOriginalTracks) {
            if (typeof track === 'number' && lodash_1.lowerCase(newState.currentTrack.version) !== 'original') {
                return changeTrack(state, track > 0 ? track + 1 : track - 1);
            }
        }
        // If the currently playing track is not an original version, we ensure that the next
        // track in queue is not the same track with a different version.
        // Else we skip to the next track in queue (+2)
        // if (state.currentTrack && newState.currentTrack.trackId === state.currentTrack.trackId) {
        //   console.log('skip to next track');
        //   return changeTrack(state, trackIndexInQueue + 2);
        // }
        if (trackIndexInHistory === -1) {
            newState.history = [].concat(_toConsumableArray(state.history), [nextTrack]);
        }
        newState.queue = array_1.rotateArray([].concat(_toConsumableArray(state.queue)), trackIndexInQueue + 1);
    }
    return newState;
}
exports.changeTrack = changeTrack;
function getPlayerTracksFromResults(tracks) {
    var onlyMP3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var playerTracks = [];
    return lodash_1.reduce(tracks, function (acc, track) {
        var versions = track_1.getTrackAssets({
            assets: track.assets,
            format: onlyMP3 ? 'mp3' : undefined,
            type: 'track-preview'
        });
        if (!versions.length) {
            versions = track_1.getTrackAssets({
                assets: track.assets,
                format: onlyMP3 ? 'mp3' : undefined,
                type: 'track'
            });
        }
        var imageAssets = track_1.getResponsiveTrackThumbnail(track);
        // HOTFIX: this is a temporary hack as this object is immutable and we need to ensure
        // the redicts for assets aren't cached in the latest version of Chrome on macos
        try {
            track = JSON.parse(JSON.stringify(track));
            track.assets.forEach(function (a) {
                a.path = a.path + "?ts=" + new Date().getTime();
            });
        } catch (e) {
            console.error(e);
        }
        versions.forEach(function (version) {
            acc.push({
                duration: track_1.getTrackDuration({ track: track, version: version }),
                elapsedTime: 0,
                imageBlurred: imageAssets.blur ? imageAssets.blur[0].path : null,
                image: imageAssets.small ? imageAssets.small[0].path : image_1.getResponsivePlaceholderThumbnail().small[0].path,
                versionId: version.id,
                trackId: track.id,
                trackInfo: track
            });
        });
        return acc;
    }, playerTracks);
}
exports.getPlayerTracksFromResults = getPlayerTracksFromResults;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Image Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var placeholders = ['https://orpheus-assets.s3.amazonaws.com/images/ams-image-placeholder.png', 'https://orpheus-assets.s3.amazonaws.com/images/ams-image-placeholder-2.png'];
function getPlaceholderThumbnail() {
    return placeholders[lodash_1.random(0, placeholders.length - 1)];
}
exports.getPlaceholderThumbnail = getPlaceholderThumbnail;
function getResponsivePlaceholderThumbnail() {
    var path = placeholders[lodash_1.random(0, placeholders.length - 1)];
    return {
        blur: [{ format: 'png', metadata: { width: 512, height: 512 }, path: path }],
        small: [{ format: 'png', metadata: { width: 512, height: 512 }, path: path }],
        medium: [{ format: 'png', metadata: { width: 512, height: 512 }, path: path }],
        large: [{ format: 'png', metadata: { width: 512, height: 512 }, path: path }],
        xlarge: [{ format: 'png', metadata: { width: 512, height: 512 }, path: path }]
    };
}
exports.getResponsivePlaceholderThumbnail = getResponsivePlaceholderThumbnail;
function getResponsiveAssets(type, assets) {
    var imageAssets = assets.filter(function (asset) {
        return asset.type === type;
    });
    if (!imageAssets.length) {
        for (var _len = arguments.length, fallbackAssets = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            fallbackAssets[_key - 2] = arguments[_key];
        }

        return !!fallbackAssets.length ? getResponsiveThumbnailAssets.apply(undefined, [fallbackAssets.shift()].concat(fallbackAssets)) : getResponsivePlaceholderThumbnail();
    }
    var responsiveImage = {};
    imageAssets.reduce(function (acc, image) {
        if (['small', 'medium', 'large', 'xlarge', 'blur'].indexOf(image.version) > -1) {
            var imageData = {
                format: image.file_format,
                metadata: type === 'cover' ? image.metadata : undefined,
                path: "/" + image.path
            };
            if (lodash_1.isArray(acc[image.version])) {
                acc[image.version].push(imageData);
            } else {
                acc[image.version] = [imageData];
            }
        }
        return acc;
    }, responsiveImage);
    if (lodash_1.isEmpty(responsiveImage)) {
        return getResponsivePlaceholderThumbnail();
    }
    return responsiveImage;
}
exports.getResponsiveAssets = getResponsiveAssets;
function getResponsiveThumbnailAssets(assets) {
    for (var _len2 = arguments.length, fallbackAssets = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        fallbackAssets[_key2 - 1] = arguments[_key2];
    }

    return getResponsiveAssets.apply(undefined, ['thumb', assets].concat(fallbackAssets));
}
exports.getResponsiveThumbnailAssets = getResponsiveThumbnailAssets;
function getImagePathForSize(assets, size) {
    var imgSrc = void 0;
    var placeholder = getResponsivePlaceholderThumbnail();
    switch (size) {
        case 'xxlarge':
        case 'xlarge':
            var xlargeImg = lodash_1.find(assets.xlarge, function (_ref) {
                var format = _ref.format;
                return format !== 'webp';
            });
            imgSrc = xlargeImg ? xlargeImg.path : placeholder.xlarge[0].path;
            break;
        case 'large':
            var largeImg = lodash_1.find(assets.large, function (_ref2) {
                var format = _ref2.format;
                return format !== 'webp';
            });
            imgSrc = largeImg ? largeImg.path : placeholder.large[0].path;
            break;
        case 'medium':
        case 'small':
            var mediumImg = lodash_1.find(assets.medium, function (_ref3) {
                var format = _ref3.format;
                return format !== 'webp';
            });
            imgSrc = mediumImg ? mediumImg.path : placeholder.medium[0].path;
            break;
        default:
            var smallImg = lodash_1.find(assets.small, function (_ref4) {
                var format = _ref4.format;
                return format !== 'webp';
            });
            imgSrc = smallImg ? smallImg.path : placeholder.small[0].path;
            break;
    }
    return imgSrc;
}
exports.getImagePathForSize = getImagePathForSize;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * QueryString Context Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var staticData_1 = __webpack_require__(103);
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
var budgetFilter_1 = __webpack_require__(211);
var defaultList = [];
exports.getAllSearchFilters = function (_ref) {
    var filters = _ref.filters;
    return filters;
};
exports.getSearchQuery = function (_ref2) {
    var query = _ref2.query;
    return query || '';
};
exports.getTaxonomyQuery = function (_ref3) {
    var taxonomy_query = _ref3.taxonomy_query;
    return taxonomy_query;
};
exports.getSearchLicenseParams = function (_ref4) {
    var license_params = _ref4.license_params;
    return license_params;
};
exports.hasLicenseParams = reselect_1.createSelector(exports.getSearchLicenseParams, function (licenseParams) {
    return !!licenseParams && licenseParams.length > 0;
});
exports.getSearchFilters = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return filters && filters.term_filters ? filters.term_filters.map(function (name) {
        return { name: name };
    }) : defaultList;
});
exports.getBudgetFilter = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return !!filters ? filters.budget : undefined;
});
exports.getDefaultBudgetFilter = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return {
        maximum: filters && filters.budget ? filters.budget.maximum !== budgetFilter_1.budgetFilterMaximum ? filters.budget.maximum : null : null,
        minimum: filters && filters.budget ? filters.budget.minimum : 0
    };
});
exports.getTempoFilter = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return !!filters ? filters.tempo : undefined;
});
exports.getSimilarityFilter = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return !!filters ? filters.similarity : undefined;
});
exports.getExcludedSearchFilters = reselect_1.createSelector(exports.getAllSearchFilters, function (filters) {
    return filters && filters.not_term_filters ? filters.not_term_filters.map(function (name) {
        return { name: name };
    }) : defaultList;
});
exports.hasSearchFilters = reselect_1.createSelector([exports.getAllSearchFilters, exports.getSearchQuery, exports.getTaxonomyQuery, exports.getSimilarityFilter],
// tslint:disable-next-line:max-line-length
function (filters, query, taxonomyQuery, sim) {
    return !!lodash_1.filter(filters, function (f) {
        return !lodash_1.isEmpty(f);
    }).length || !!query || !!taxonomyQuery || !!sim;
});
exports.hasInstrumentalFilter = reselect_1.createSelector(exports.getSearchFilters, function (filters) {
    return filters.some(function (f) {
        return f.name === 'Instrumental';
    });
});
var getLicenseParams = function getLicenseParams(_, _ref5) {
    var license_params = _ref5.license_params;
    return license_params || defaultList;
};
exports.licenseUsagesFromQueryStringSelector = reselect_1.createSelector([staticData_1.getLicenseComponents, getLicenseParams], function (components, params) {
    return license_1.getLicenseUsagesFromQueryString({ components: components, params: params });
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Thumbnail Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
var track_1 = __webpack_require__(44);
__webpack_require__(1457);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ImageLoaded_1 = __webpack_require__(185);
var classes = new BEM('thumbnail');

var ThumbnailBase = function (_React$Component) {
    _inherits(ThumbnailBase, _React$Component);

    function ThumbnailBase() {
        _classCallCheck(this, ThumbnailBase);

        return _possibleConstructorReturn(this, (ThumbnailBase.__proto__ || Object.getPrototypeOf(ThumbnailBase)).apply(this, arguments));
    }

    _createClass(ThumbnailBase, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.className !== this.props.className || nextProps.imageLoaded !== this.props.imageLoaded || nextProps.ratio !== this.props.ratio || nextProps.responsive !== this.props.responsive || nextProps.shape !== this.props.shape || nextProps.size !== this.props.size || nextProps.src !== this.props.src || nextProps.withShadow !== this.props.withShadow || "" + nextProps.onClick !== "" + this.props.onClick || !lodash_1.isEqual(nextProps.hyperLinkProps, this.props.hyperLinkProps) || !lodash_1.isEqualWith(nextProps.responsiveAssets, this.props.responsiveAssets, track_1.compareResponsiveImage);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!lodash_1.isEqualWith(prevProps.responsiveAssets, this.props.responsiveAssets, track_1.compareResponsiveImage)) {
                this.props.reloadImage();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                responsiveAssets = _props.responsiveAssets,
                children = _props.children,
                className = _props.className,
                hyperLinkProps = _props.hyperLinkProps,
                imageLoaded = _props.imageLoaded,
                onClick = _props.onClick,
                src = _props.src,
                ratio = _props.ratio,
                responsive = _props.responsive,
                shape = _props.shape,
                size = _props.size,
                withShadow = _props.withShadow;

            var classModifiers = classNames(responsive && 'is-responsive', imageLoaded ? 'is-loaded' : 'loading', typeof size === 'string' && size);
            var extraClasses = classNames(className, "ratio--" + ratio, "shape--" + shape, withShadow && imageLoaded && 'with-shadow', !!onClick && 'clickable');
            var InnerWrapperComponent = hyperLinkProps ? 'a' : 'div';
            var innerProps = {};
            if (onClick) {
                innerProps.onClick = onClick;
            } else if (hyperLinkProps) {
                innerProps.href = hyperLinkProps.href;
                if (hyperLinkProps.external) {
                    innerProps.target = '_blank';
                }
            }
            if (src) {
                innerProps.style = {
                    backgroundImage: "url(" + src + ")"
                };
            } else if (responsiveAssets) {
                innerProps.style = {
                    backgroundImage: "url(" + image_1.getImagePathForSize(responsiveAssets, typeof size === 'string' ? size : 'large') + ")"
                };
            }
            return React.createElement("div", Object.assign({ style: typeof size === 'number' ? { width: size } : undefined }, classes('', classModifiers, extraClasses)), React.createElement(InnerWrapperComponent, Object.assign({}, innerProps, classes('inner'))), children);
        }
    }]);

    return ThumbnailBase;
}(React.Component);

ThumbnailBase.defaultProps = {
    ratio: 'square',
    shape: 'square'
};
var Thumbnail = function Thumbnail(props) {
    return React.createElement(ImageLoaded_1.default, { background: ".thumbnail__inner" }, function (imageLoadedProps) {
        return React.createElement(ThumbnailBase, Object.assign({}, imageLoadedProps, props));
    });
};
exports.default = Thumbnail;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$CheckoutStep;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBillingAddressIsSameAsLicensee = true;
exports.CheckoutStepId = {
    project: 'project-details',
    license: 'license-information',
    billing: 'billing-information',
    review: 'review',
    orderPlaced: 'order-placed'
};
exports.CheckoutStepFormName = {
    project: 'checkout-project-details',
    license: 'checkout-license-information',
    billing: 'checkout-billing-information',
    review: 'checkout-review'
};
exports.CheckoutStepsOrder = (_exports$CheckoutStep = {}, _defineProperty(_exports$CheckoutStep, exports.CheckoutStepId.project, 1), _defineProperty(_exports$CheckoutStep, exports.CheckoutStepId.license, 2), _defineProperty(_exports$CheckoutStep, exports.CheckoutStepId.billing, 3), _defineProperty(_exports$CheckoutStep, exports.CheckoutStepId.review, 4), _exports$CheckoutStep);
exports.CompanyTypes = [{ value: 1001, label: 'Ad Agency' }, { value: 1002, label: 'Production' }, { value: 1003, label: 'Editorial House' }, { value: 1004, label: 'Music House' }, { value: 1005, label: 'Broadcaster' }, { value: 1006, label: 'Other' }];
exports.RepresentativeRoles = [{ value: 1001, label: 'Producer' }, { value: 1002, label: 'Copywriter' }, { value: 1003, label: 'Creative Director' }, { value: 1004, label: 'Editor' }, { value: 1005, label: 'Art Director' }, { value: 1006, label: 'Music Supervisor' }, { value: 1007, label: 'Other' }];
exports.kCheckoutNoInputLabel = '<not specified>';

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Post-Authentication Request

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('PostAuthenticationRequests');
exports.recoverPostAuthenticationRequests = actionCreator('RECOVER');
exports.pushPostAuthenticationRequestPage = actionCreator('PUSH_PAGE_REQUEST');
exports.pushPostAuthenticationRequestDownload = actionCreator('PUSH_DOWNLOAD_REQUEST');
exports.pushPostAuthenticationRequestCreateProject = actionCreator('PUSH_CREATE_PROJECT_REQUEST');
exports.pushPostAuthenticationRequestJoinProject = actionCreator('PUSH_JOIN_PROJECT_REQUEST');
exports.consumePostAuthenticationRequests = actionCreator('CONSUME');
exports.clearPostAuthenticationRequests = actionCreator('CLEAR');

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TextField Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1424);
var color_schemes_1 = __webpack_require__(143);
var Label_1 = __webpack_require__(8);
var classes = new BEM('textfield');

var TextField = function (_React$Component) {
    _inherits(TextField, _React$Component);

    function TextField(props) {
        _classCallCheck(this, TextField);

        var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

        _this.rawStr = '';
        _this.caretPosition = 0;
        _this.onKeyPress = function (e) {
            if (e.key === 'Enter' && _this.props.isAutocomplete) {
                e.preventDefault();
            }
        };
        _this.onKeyDown = function (e) {
            var _this$props = _this.props,
                inlineButton = _this$props.inlineButton,
                inputProps = _this$props.inputProps,
                submitOnEnter = _this$props.submitOnEnter;

            var _ref = inputProps || {},
                _ref$onKeyDown = _ref.onKeyDown,
                onKeyDown = _ref$onKeyDown === undefined ? null : _ref$onKeyDown;

            if (onKeyDown != null) {
                onKeyDown(lodash_1.clone(e));
            }
            if (e.key === 'Escape') {
                _this.input.blur();
            } else if (submitOnEnter && e.key === 'Enter') {
                if (lodash_1.isFunction(submitOnEnter)) {
                    submitOnEnter(_this.input.value);
                } else if (inlineButton) {
                    _this.onSubmit();
                }
            }
        };
        _this.onSubmit = function () {
            var inlineButton = _this.props.inlineButton;

            if (inlineButton && inlineButton.props.onClick) {
                inlineButton.props.onClick(_this.input.value);
            }
            _this.setState({
                value: ''
            });
            _this.input.blur();
        };
        _this.onChange = function (e) {
            var event = lodash_1.clone(e);
            var newValue = e.target.value;
            _this.rawStr = String(newValue);
            _this.caretPosition = e.target.selectionEnd || 0;
            if (_this.props.allowDigitsOnly && isNaN(Number(newValue))) {
                return;
            }
            _this.setState({ value: newValue }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(event, newValue);
                }
            });
        };
        _this.onToggleFocus = function (e) {
            var event = lodash_1.clone(e);
            var eventType = e.type;
            var value = _this.state.value;

            if (eventType === 'focus') {
                e.target.select();
            } else if (eventType === 'blur') {
                if (value[0] === '0' && _this.props.allowDigitsOnly) {
                    _this.setState({ value: parseInt(String(value), 10) });
                }
                if (_this.props.appendPercentage) {
                    _this.setState({ value: lodash_1.trim(String(value), '%') + "%" });
                }
            }
            _this.setState({
                isFocus: eventType === 'focus' ? true : false
            }, function () {
                /* tslint:disable:no-unused-expression */
                eventType === 'focus' && _this.props.onFocus && _this.props.onFocus(event, value);
                eventType === 'blur' && _this.props.onBlur && _this.props.onBlur(event, value);
            });
        };
        _this.state = {
            isFocus: false,
            value: _this.props.value || ''
        };
        return _this;
    }

    _createClass(TextField, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.isControlled || lodash_1.isNil(nextProps.value)) {
                return;
            }
            if (this.state.value !== nextProps.value) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(lodash_1.isEqual(nextProps, this.props) && lodash_1.isEqual(nextState, this.state));
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(_ref2) {
            var input = _ref2.input,
                isParsed = _ref2.isParsed;

            if (this.props.input && input && !isParsed) {
                var currentValue = this.props.input.value;
                if (currentValue !== input.value) {
                    var str = this.rawStr.substr(0, this.caretPosition);
                    var index = String(currentValue).indexOf(str) + this.caretPosition;
                    if (index !== -1) {
                        this.input.selectionStart = this.input.selectionEnd = index;
                    }
                }
            }
        }
    }, {
        key: "focus",
        value: function focus() {
            var _this2 = this;

            setTimeout(function () {
                _this2.input.focus();
                _this2.onToggleFocus({ target: _this2.input, type: 'focus' });
            }, 100);
        }
    }, {
        key: "render",
        value: function render() {
            var _modifiers,
                _this3 = this;

            /* tslint:disable:no-unused-variable */
            var _props = this.props,
                autoComplete = _props.autoComplete,
                autoFocus = _props.autoFocus,
                children = _props.children,
                className = _props.className,
                colorScheme = _props.colorScheme,
                disabled = _props.disabled,
                icon = _props.icon,
                inlineButton = _props.inlineButton,
                input = _props.input,
                inputProps = _props.inputProps,
                meta = _props.meta,
                _props$name = _props.name,
                name = _props$name === undefined ? this.props.input ? this.props.input.name : '' : _props$name,
                optional = _props.optional,
                onlyValidateIfTouched = _props.onlyValidateIfTouched,
                placeholder = _props.placeholder,
                readOnly = _props.readOnly,
                size = _props.size,
                style = _props.style,
                type = _props.type,
                withoutBorder = _props.withoutBorder;
            var _a = inputProps || {},
                _a$onKeyDown = _a.onKeyDown,
                onKeyDown = _a$onKeyDown === undefined ? null : _a$onKeyDown,
                restInputProps = __rest(_a, ["onKeyDown"]);
            var modifiers = (_modifiers = {
                'is-focus': this.state.isFocus,
                'is-disabled': disabled,
                'is-readonly': readOnly
            }, _defineProperty(_modifiers, size, size), _defineProperty(_modifiers, 'error', meta && meta.touched && meta.error), _defineProperty(_modifiers, 'warning', meta && meta.touched && meta.warning), _defineProperty(_modifiers, 'no-border', !!withoutBorder), _modifiers);
            var extraClasses = classNames(colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme, 'textfield'), icon && 'with--icon', className);
            var inputControlProps = input ? {
                onFocus: function onFocus(e) {
                    _this3.onToggleFocus(e);input.onFocus(e, e.target.value, null);
                },
                onBlur: function onBlur(e) {
                    _this3.onToggleFocus(e);input.onBlur(e, e.target.value, null);
                },
                onChange: function onChange(e) {
                    _this3.onChange(e);input.onChange(e, e.target.value, null);
                },
                value: input.value
            } : {
                onFocus: this.onToggleFocus,
                onBlur: this.onToggleFocus,
                onChange: this.onChange,
                value: this.state.value
            };
            var inlineButtonProps = {
                onClick: this.onSubmit,
                className: 'textfield__inline-button',
                size: size === 'large' ? 'medium-large' : size === 'small' ? 'small' : 'small-medium',
                disabled: disabled
            };
            var iconProps = {
                onClick: function onClick() {
                    return _this3.input.focus();
                },
                className: 'textfield__icon'
            };
            var InlineButton = inlineButton && React.cloneElement(inlineButton, inlineButtonProps);
            var Icon = icon && React.cloneElement(icon, iconProps);
            var labelClasses = new BEM('label');
            return React.createElement("div", Object.assign({}, classes('', modifiers, extraClasses), { style: style }), React.createElement("div", Object.assign({}, classes('background'))), children, meta && ((onlyValidateIfTouched && meta.touched || !onlyValidateIfTouched) && meta.error && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'error'), { size: "medium", textColor: "dangerous" }), meta.error) || meta.warning && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'warning'), { size: "medium" }), meta.warning)), React.createElement("input", Object.assign({ type: type, ref: function ref(node) {
                    return _this3.input = node;
                }, name: name, onKeyPress: this.onKeyPress, onKeyDown: this.onKeyDown, placeholder: placeholder, autoComplete: autoComplete ? 'on' : 'off', autoFocus: autoFocus, disabled: disabled, required: !optional, readOnly: readOnly }, inputControlProps, restInputProps, classes('input'))), Icon, InlineButton);
        }
    }]);

    return TextField;
}(React.Component);

TextField.defaultProps = {
    optional: false,
    size: 'medium',
    type: 'text'
};
exports.default = TextField;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checkout-related Redux Actions
 */
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Checkout');
exports.registerStep = actionCreator('REGISTER_STEP');
exports.setActiveStep = actionCreator('SET_ACTIVE_STEP');
exports.completeStep = actionCreator('COMPLETE_STEP');
exports.removeCompletedStep = actionCreator('REMOVE_COMPLETED_STEP');
exports.saveCheckoutStepToLocalStorage = actionCreator('SAVE_STEP_TO_LOCAL_STORAGE');
exports.consumeLocallyStoredStep = actionCreator('CONSUME_LOCALLY_STORED_STEP');
// Request Async Actions
exports.requestSetCheckoutFromLocalStorage = actionCreator('REQUEST_SET_CHECKOUT_FROM_LOCAL_STORAGE');
exports.requestPlaceOrder = actionCreator('REQUEST_PLACE_ORDER');
exports.requestAddPromoCode = actionCreator('REQUEST_ADD_PROMO_CODE');
exports.requestDeletePromoCode = actionCreator('REQUEST_DELETE_PROMO_CODE');
exports.setCheckoutFromLocalStorage = actionCreator.async('SET_CHECKOUT_FROM_LOCAL_STORAGE');
exports.placeOrder = actionCreator.async('PLACE_ORDER');
exports.addPromoCode = actionCreator.async('ADD_PROMO_CODE');
exports.deletePromoCode = actionCreator.async('DELETE_PROMO_CODE');

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay Configuration
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_runtime_1 = __webpack_require__(43);
// Define a function that fetches the results of an operation (query/mutation/etc)
// and returns its results as a Promise:
function fetchQuery(operation, variables, cacheConfig, uploadables) {
    return fetch('/graphql', {
        credentials: 'include',
        method: 'POST',
        headers: new Headers({
            // Add authentication and other headers here
            'content-type': 'application/json'
        }),
        body: JSON.stringify({
            query: operation.text,
            variables: variables
        })
    }).then(function (response) {
        if (response.status === 503) {
            return response.text().then(function (text) {
                document.body.innerHTML = text;
            });
        }
        return response.json();
    });
}
// Create a network layer from the fetch function
var network = relay_runtime_1.Network.create(fetchQuery);
exports.environment = new relay_runtime_1.Environment({
    network: network,
    store: new relay_runtime_1.Store(new relay_runtime_1.RecordSource())
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var EventCategory;
(function (EventCategory) {
    EventCategory["Account"] = "account";
    EventCategory["Checkout"] = "checkout";
    EventCategory["Cart"] = "cart";
    EventCategory["Download"] = "download";
    EventCategory["Impression"] = "impression";
    EventCategory["Licensing"] = "licensing";
    EventCategory["Search"] = "search";
    EventCategory["SetFilter"] = "set-filter";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var FilterEvent;
(function (FilterEvent) {
    FilterEvent["Budget"] = "budget";
})(FilterEvent = exports.FilterEvent || (exports.FilterEvent = {}));
var AccountEvent;
(function (AccountEvent) {
    AccountEvent["NewAccount"] = "new-account-registration";
})(AccountEvent = exports.AccountEvent || (exports.AccountEvent = {}));
var CartEvent;
(function (CartEvent) {
    CartEvent["AddToCart"] = "add-to-cart";
    CartEvent["RemoveFromCart"] = "remove-from-cart";
})(CartEvent = exports.CartEvent || (exports.CartEvent = {}));
var CheckoutEvent;
(function (CheckoutEvent) {
    CheckoutEvent["Checkout"] = "checkout";
    CheckoutEvent["PlaceOrder"] = "place-order";
})(CheckoutEvent = exports.CheckoutEvent || (exports.CheckoutEvent = {}));
var LicensingEvent;
(function (LicensingEvent) {
    LicensingEvent["SetLicense"] = "set-license";
})(LicensingEvent = exports.LicensingEvent || (exports.LicensingEvent = {}));
var ProductEvent;
(function (ProductEvent) {
    ProductEvent["Details"] = "track-details";
    ProductEvent["Download"] = "download-track";
    ProductEvent["Impression"] = "track-impression";
})(ProductEvent = exports.ProductEvent || (exports.ProductEvent = {}));
var SearchEvent;
(function (SearchEvent) {
    SearchEvent["Search"] = "search";
    SearchEvent["SimilaritySearch"] = "similarity-search";
})(SearchEvent = exports.SearchEvent || (exports.SearchEvent = {}));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Static Data Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
exports.getBusinessInformation = function (_ref) {
    var businessInformation = _ref.staticData.businessInformation;
    return businessInformation;
};
exports.getTempos = function (_ref2) {
    var tempos = _ref2.staticData.tempos;
    return tempos;
};
exports.getTempoFilter = function (_, _ref3) {
    var tempoFilter = _ref3.tempoFilter;
    return tempoFilter;
};
exports.getExchangeRates = function (_ref4) {
    var exchangeRates = _ref4.staticData.exchangeRates;
    return exchangeRates;
};
exports.getLicenseComponents = function (_ref5) {
    var licenseComponents = _ref5.staticData.licenseComponents;
    return licenseComponents;
};
exports.getDefaultTempoValues = reselect_1.createSelector(exports.getTempos, function (tempos) {
    return {
        // We apply a minus 1 to default values to convert to base zero
        // (Base zero is required by the Range Component)
        minimum: lodash_1.minBy(tempos, 'value').value - 1,
        maximum: lodash_1.maxBy(tempos, 'value').value - 1
    };
});
// tslint:disable-next-line:max-line-length
exports.getDefaultTempoFilter = reselect_1.createSelector([exports.getDefaultTempoValues, exports.getTempoFilter], function (defaultValues, filter) {
    return !!filter ? {
        minimum: filter.minimum ? filter.minimum - 1 : 0,
        maximum: filter.maximum ? filter.maximum - 1 : 0
    } : defaultValues;
});
exports.getCurrencyOptions = reselect_1.createSelector(exports.getExchangeRates, function (rates) {
    return [{
        value: 'CAD',
        label: 'CAD'
    }].concat(rates.map(function (_ref6) {
        var to_currency = _ref6.to_currency;
        return {
            value: to_currency,
            label: to_currency
        };
    }));
});
exports.getBusinessOpeningHours = reselect_1.createSelector(exports.getBusinessInformation, function (info) {
    return info.opening_hours;
});
exports.getBusinessMainPhoneNumber = reselect_1.createSelector(exports.getBusinessInformation, function (info) {
    return info.phone_numbers.find(function (phone) {
        return phone.type === 'main';
    });
});
exports.getBusinessEuropeanPhoneNumber = reselect_1.createSelector(exports.getBusinessInformation, function (info) {
    return info.phone_numbers.find(function (phone) {
        return phone.type === 'europe';
    });
});
exports.getBusinessMainEmailAddress = reselect_1.createSelector(exports.getBusinessInformation, function (info) {
    return info.emails.find(function (email) {
        return email.type === 'main';
    });
});

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * QueryString Context Types
 */

Object.defineProperty(exports, "__esModule", { value: true });
var QueryStringParam;
(function (QueryStringParam) {
    QueryStringParam["Budget"] = "budget";
    QueryStringParam["License"] = "license";
    QueryStringParam["Search"] = "search";
    QueryStringParam["Tempo"] = "tempo";
    QueryStringParam["SortOrder"] = "sort";
    QueryStringParam["Similarity"] = "similarity";
})(QueryStringParam = exports.QueryStringParam || (exports.QueryStringParam = {}));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Taxonomy Selectors
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var TaxonomyType;
(function (TaxonomyType) {
    TaxonomyType["Tags"] = "Product_tag";
    TaxonomyType["Moods"] = "Mood";
    TaxonomyType["Genres"] = "Genre";
    TaxonomyType["Vocals"] = "Vocals";
    TaxonomyType["Languages"] = "Language";
    TaxonomyType["Catalogs"] = "Catalog";
    TaxonomyType["Budget"] = "Budget";
    TaxonomyType["Lyrics"] = "Lyric";
    TaxonomyType["Instruments"] = "Instrument";
    TaxonomyType["Industries"] = "Industry";
    TaxonomyType["References"] = "Reference";
    TaxonomyType["ProductType"] = "Product_type";
    TaxonomyType["FeMood"] = "Fe_mood";
    TaxonomyType["Tempos"] = "Tempo";
    TaxonomyType["RecordingCountry"] = "Recording Country";
})(TaxonomyType = exports.TaxonomyType || (exports.TaxonomyType = {}));
exports.TaxonomyId = _defineProperty({}, TaxonomyType.Lyrics, 9);
exports.TaxonomyIdToTaxonomyType = lodash_1.invert(exports.TaxonomyId);
var taxonomyTitles = [{ original: TaxonomyType.Tags, override: 'Tags' }, { original: TaxonomyType.Genres, override: 'Genres' }, { original: TaxonomyType.Moods, override: 'Moods' }, { original: TaxonomyType.Languages, override: 'Languages' }, { original: TaxonomyType.Catalogs, override: 'Catalogs' }, { original: TaxonomyType.Industries, override: 'Industries' }, { original: TaxonomyType.Lyrics, override: 'Lyrics' }, { original: TaxonomyType.Instruments, override: 'Instruments' }, { original: TaxonomyType.References, override: 'References' }];
function getTaxonomyTitle(original) {
    var found = lodash_1.find(taxonomyTitles, { original: original });
    return found ? found.override : original;
}
exports.getTaxonomyTitle = getTaxonomyTitle;
function getTermsByTaxonomy(taxonomyType, terms) {
    return terms.filter(function (_ref) {
        var taxonomy = _ref.taxonomy;
        return taxonomy && taxonomy.name === taxonomyType;
    });
}
exports.getTermsByTaxonomy = getTermsByTaxonomy;

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Currency Context
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.CurrencyContext = React.createContext({
  currency: 'CAD',
  setCurrency: function setCurrency() {
    return null;
  }
});

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Date Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = __webpack_require__(280);
function getFormattedTime(seconds) {
    return luxon_1.Duration.fromObject({ seconds: seconds }).toFormat('mm:ss');
}
exports.getFormattedTime = getFormattedTime;
function getTimestamp() {
    return luxon_1.DateTime.local().toString();
}
exports.getTimestamp = getTimestamp;
function getFormattedDateToday() {
    return luxon_1.DateTime.local().setLocale('en-us').toFormat('y-LL-dd');
}
exports.getFormattedDateToday = getFormattedDateToday;
function getFormattedDateFromGraphQL(date) {
    return luxon_1.DateTime.fromISO(date, { zone: 'utc' }).setLocale('en-us').toLocaleString(luxon_1.DateTime.DATE_FULL);
}
exports.getFormattedDateFromGraphQL = getFormattedDateFromGraphQL;
function isPastDue(date) {
    var now = luxon_1.DateTime.local();
    var dateToValidate = luxon_1.DateTime.fromISO(date);
    return dateToValidate < now;
}
exports.isPastDue = isPastDue;

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var money_1 = __webpack_require__(285);
var string_1 = __webpack_require__(47);
var accounting_1 = __webpack_require__(416);
var lodash_1 = __webpack_require__(6);
var luxon_1 = __webpack_require__(280);
var React = __webpack_require__(0);
var redux_form_1 = __webpack_require__(37);
var fieldIsValid = undefined;
// Number Field
exports.FieldNumber = function (props) {
    return React.createElement(redux_form_1.Field, Object.assign({ parse: function parse(value) {
            if (isNaN(value)) {
                return;
            }
            return value;
        } }, props));
};
// Percentage Field
function percentageValidate(value) {
    return value > 100 && 'Cannot exceed 100%!';
}
exports.FieldPercentage = function (_a) {
    var name = _a.name,
        _a$validate = _a.validate,
        validate = _a$validate === undefined ? false : _a$validate,
        passDownProps = __rest(_a, ["name", "validate"]);

    return React.createElement(redux_form_1.Field, Object.assign({ name: name, format: function format(value) {
            return value ? value + "%" : '';
        }, parse: function parse(value) {
            var parsedValue = value.replace(/%/g, '');
            if (isNaN(parsedValue)) {
                return;
            }
            return parseInt(parsedValue, 10);
        }, validate: validate ? percentageValidate : function () {
            return undefined;
        }, onChange: function onChange(e) {
            setTimeout(function () {
                var caretPosition = e.target.value.length - 1;
                e.target.setSelectionRange(caretPosition, caretPosition);
            }, 0);
        }, isParsed: true }, passDownProps));
};
// Money Field
var moneyFormat = function moneyFormat(currency, precision) {
    return function (value) {
        return value != null ? money_1.getFormattedMoney(value, currency, precision) : '';
    };
};
function moneyParse(value) {
    return value != null ? accounting_1.unformat(value) : '';
}
exports.FieldMoney = function (_a) {
    var name = _a.name,
        _a$currency = _a.currency,
        currency = _a$currency === undefined ? "USD" : _a$currency,
        _a$precision = _a.precision,
        precision = _a$precision === undefined ? 0 : _a$precision,
        passDownProps = __rest(_a, ["name", "currency", "precision"]);

    return React.createElement(redux_form_1.Field, Object.assign({ name: name, format: moneyFormat(currency, precision), parse: moneyParse, isParsed: true }, passDownProps));
};
// Date Field
function dateParse(value) {
    if (value) {
        var lastIndex = value.length - 1;
        var lastChar = value[lastIndex];
        var lastCharNumber = parseInt(lastChar, 10);
        // Date is complete (YYYY/MM/DD)
        if (value.match(/^(\d{4})\/(\d{2})\/(\d{2}).$/)) {
            return value.slice(0, value.length - 1);
        }
        // Disallow all non-digit characters
        if (lastChar !== '/' && isNaN(lastCharNumber)) {
            return value.slice(0, value.length - 1);
        }
        // If user has deleted characters and adds a number, we make sure that the date remains well-formatted
        if (value.match(/^(\d{5})$/) || value.match(/\/\d{3}$/)) {
            value = value.slice(0, value.length - 1) + "/" + value.slice(value.length - 1);
        }
        // If the first number of month is higher than 1 or first number of day is higher than 3, we put a zero before
        if (value.match(/^\d{4}\/\d$/) && lastCharNumber > 1 || value.match(/^\d{4}\/\d{2}\/\d$/) && lastCharNumber > 3) {
            value = value.slice(0, value.length - 1) + "0" + value.slice(value.length - 1);
        }
        // Automatically add a slash
        if (value.match(/^(\d{4})$/) || value.match(/^(\d{4})\/(\d{2})$/)) {
            return value + "/";
        }
        // Remove last slash if user is deleting characters
        if (lastChar === '/') {
            return value.slice(0, value.length - 1);
        }
    }
    return value;
}
function dateFieldValidate() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var date = luxon_1.DateTime.fromISO(value);
    var year = luxon_1.DateTime.fromISO(value);
    var dateIsAfter = year > luxon_1.DateTime.local().plus({ years: 1 });
    var dateIsBefore = year < luxon_1.DateTime.local().minus({ years: 1 });
    if (!date.isValid) {
        return locales_1.default.validations.date;
    } else if (dateIsAfter) {
        return 'You can only register licenses for the next year.';
    } else if (dateIsBefore) {
        return 'You can only register licenses from the last year.';
    }
    return fieldIsValid;
}
function dateFormat(value) {
    return value ? value.replace(/-/g, '/') : '';
}
function dateNormalize(value, previousValue) {
    if (value && previousValue) {
        var normalizedValue = value.replace(/\//g, '-');
        if (normalizedValue === previousValue) {
            return lodash_1.trimEnd(normalizedValue, '-');
        }
    }
    return value ? value.replace(/\//g, '-') : '';
}
exports.FieldDate = function (_a) {
    var name = _a.name,
        passDownProps = __rest(_a, ["name"]);
    return React.createElement(redux_form_1.Field, Object.assign({ name: name, format: dateFormat, parse: dateParse, normalize: dateNormalize, validate: dateFieldValidate, isParsed: true }, passDownProps));
};
// Email Field
function emailFieldValidate(value) {
    return !value || string_1.validateEmail(value) ? fieldIsValid : locales_1.default.validations.email;
}
exports.FieldEmail = function (_a) {
    var name = _a.name,
        passDownProps = __rest(_a, ["name"]);
    return React.createElement(redux_form_1.Field, Object.assign({ name: name, validate: emailFieldValidate }, passDownProps));
};
// Password Field
function passwordFieldValidate(value) {
    return !value || string_1.validatePassword(value) ? fieldIsValid : locales_1.default.validations.password;
}
exports.FieldPassword = function (_a) {
    var name = _a.name,
        _a$warn = _a.warn,
        warn = _a$warn === undefined ? false : _a$warn,
        passDownProps = __rest(_a, ["name", "warn"]);

    return React.createElement(redux_form_1.Field, Object.assign({ name: name, warn: passwordFieldValidate }, passDownProps, { type: "password" }));
};
// Postal Code Field
function parsePostalCode(value) {
    value = parseUppercase(value);
    return value ? value.replace(/[^\w\s-]$/, '') : value;
}
exports.FieldPostalCode = function (_a) {
    var name = _a.name,
        passDownProps = __rest(_a, ["name"]);
    return React.createElement(redux_form_1.Field, Object.assign({ name: name, parse: parsePostalCode, isParsed: true }, passDownProps));
};
// Uppercase Field
function parseUppercase(value) {
    if (value) {
        // const lastIndex = value.length - 1;
        // const lastChar = value[lastIndex];
        // if (lastChar.match(/[a-z]/)) {
        //   return value.replace(/[a-z]$/, lastChar.toUpperCase());
        // }
        return value.toUpperCase();
    }
    return value;
}
exports.FieldUppercase = function (_a) {
    var name = _a.name,
        passDownProps = __rest(_a, ["name"]);
    return React.createElement(redux_form_1.Field, Object.assign({ name: name, parse: parseUppercase, isParsed: true }, passDownProps));
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PriceTag Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(641);
var accounting_1 = __webpack_require__(416);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var currency_1 = __webpack_require__(115);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var currencySymbol = {
    CAD: {
        simple: '$',
        explicit: '$CA'
    },
    USD: {
        simple: '$',
        explicit: '$US'
    },
    EUR: {
        simple: '€',
        explicit: 'EUR'
    },
    GBP: {
        simple: '£',
        explicit: 'GBP'
    },
    AUD: {
        simple: '$',
        explicit: '$AU'
    },
    NZD: {
        simple: '$',
        explicit: '$NZ'
    }
};
var currencyFormat = {
    fr: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: ' '
    },
    // TODO: add the rest of the European currency formats
    de: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: '.'
    },
    es: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: '.'
    },
    it: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: '.'
    },
    nl: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: '.'
    },
    pt: {
        decimal: ',',
        format: {
            pos: '%v %s',
            neg: '-%v %s'
        },
        thousand: ' '
    },
    en: {
        decimal: '.',
        format: {
            pos: '%s%v',
            neg: '-%s%v'
        },
        thousand: ','
    }
};
function getCurrencyFormat(language) {
    var format = currencyFormat[language];
    return format ? format : currencyFormat.en;
}
var classes = new BEM('price-tag');

var PriceTag = function (_React$Component) {
    _inherits(PriceTag, _React$Component);

    function PriceTag() {
        _classCallCheck(this, PriceTag);

        return _possibleConstructorReturn(this, (PriceTag.__proto__ || Object.getPrototypeOf(PriceTag)).apply(this, arguments));
    }

    _createClass(PriceTag, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                amount = _props.amount,
                className = _props.className,
                currency = _props.currency,
                explicitCurrency = _props.explicitCurrency,
                isDiscount = _props.isDiscount,
                label = _props.label,
                language = _props.language,
                precision = _props.precision,
                rate = _props.rate,
                size = _props.size,
                strikeThrough = _props.strikeThrough,
                textColor = _props.textColor;

            if (!!!this.props.amount) {
                return React.createElement(Button_1.default, { variant: "icon", textColor: "bw7", icon: React.createElement(Icon_1.IconWarning, null), title: "Amount could not be properly calculated." });
            }
            var symbol = explicitCurrency ? language === 'en' ? currencySymbol[currency].explicit + " " : currencySymbol[currency].explicit : currencySymbol[currency].simple;
            var convertedAmount = rate ? rate * amount : amount;
            var formattedAmount = accounting_1.formatMoney(convertedAmount, lodash_1.extend({
                precision: precision,
                symbol: symbol
            }, getCurrencyFormat(language)));
            var price = "" + (label ? label + " " : '') + formattedAmount;
            var classModifiers = {
                'line-through': !!strikeThrough,
                'discount': !!isDiscount
            };
            var extraClasses = classNames(className);
            var commonProps = Object.assign({ textColor: textColor }, classes('', classModifiers, extraClasses));
            switch (size) {
                case 'small':
                    return React.createElement(Label_1.Span, Object.assign({ size: "medium" }, commonProps), price);
                case 'medium':
                    return React.createElement(Heading_1.default, Object.assign({ is: "h5", WrappedComponent: "div" }, commonProps), price);
                case 'large':
                    return React.createElement(Heading_1.default, Object.assign({ is: "h4", WrappedComponent: "div" }, commonProps), price);
                default:
                    return React.createElement(Label_1.Span, Object.assign({}, commonProps), price);
            }
        }
    }]);

    return PriceTag;
}(React.Component);

PriceTag.defaultProps = {
    precision: 0
};
var ConnectedPriceTag = react_redux_1.connect(function (_ref) {
    var preferences = _ref.preferences;
    return {
        language: preferences.language
    };
})(PriceTag);
var PriceTagWithContext = function PriceTagWithContext(_a) {
    var currency = _a.currency,
        props = __rest(_a, ["currency"]);
    return React.createElement(currency_1.CurrencyContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedPriceTag, Object.assign({ currency: currency || ctx.currency }, props));
    });
};
exports.default = PriceTagWithContext;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Tag Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var background_size_1 = __webpack_require__(1502);
var color_schemes_1 = __webpack_require__(143);
var colors_1 = __webpack_require__(57);
__webpack_require__(1503);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var Badge_1 = __webpack_require__(427);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var classes = new BEM('tag');

var Tag = function (_React$Component) {
    _inherits(Tag, _React$Component);

    function Tag() {
        _classCallCheck(this, Tag);

        var _this = _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));

        _this.onClick = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                onClick = _this$props.onClick,
                onRemove = _this$props.onRemove,
                removeOnClick = _this$props.removeOnClick;

            if (removeOnClick && onRemove) {
                onRemove(id);
            }
            if (onClick) {
                onClick(id);
            }
        };
        return _this;
    }

    _createClass(Tag, [{
        key: "render",
        value: function render() {
            var _classesModifiers;

            var _props = this.props,
                alwaysDisplayExclude = _props.alwaysDisplayExclude,
                backgroundColor = _props.backgroundColor,
                backgroundSize = _props.backgroundSize,
                cardinality = _props.cardinality,
                className = _props.className,
                colorScheme = _props.colorScheme,
                disabled = _props.disabled,
                exclude = _props.exclude,
                hasSubtags = _props.hasSubtags,
                id = _props.id,
                label = _props.label,
                linkProps = _props.linkProps,
                onClick = _props.onClick,
                onClickExclude = _props.onClickExclude,
                onClickSubTags = _props.onClickSubTags,
                onRemove = _props.onRemove,
                prefix = _props.prefix,
                size = _props.size,
                textColor = _props.textColor,
                variant = _props.variant;

            var WrappedComponent = this.props.wrappedComponent;
            var Wrapper = variant === 'filter' ? 'div' : linkProps ? LinkButton_1.default : 'div';
            var wrapperProps = {};
            if (Wrapper === 'button') {
                wrapperProps = {
                    type: 'button',
                    onClick: this.onClick,
                    disabled: disabled
                };
            } else if (Wrapper === LinkButton_1.default) {
                wrapperProps = linkProps;
            } else if (!!onClick && !disabled) {
                wrapperProps = {
                    onClick: this.onClick
                };
            }
            var classesModifiers = (_classesModifiers = {}, _defineProperty(_classesModifiers, variant, variant !== 'simple'), _defineProperty(_classesModifiers, 'disabled', !!disabled), _defineProperty(_classesModifiers, 'exclude', !!exclude), _defineProperty(_classesModifiers, 'no-link', variant === 'simple' && !onClick && Wrapper !== LinkButton_1.default), _defineProperty(_classesModifiers, size, true), _classesModifiers);
            var extraClasses = classNames(colors_1.getTextColorClassName(textColor), colors_1.getBackgroundColorClassName(backgroundColor), background_size_1.getBackgroundSizeClassName(backgroundSize), color_schemes_1.getColorSchemeClassName(colorScheme), className);
            var labelProps = Object.assign({}, classes('label'), { WrappedComponent: 'span' });
            return React.createElement(WrappedComponent, Object.assign({}, classes('', classesModifiers, extraClasses)), variant === 'button' && React.createElement(Button_1.default, Object.assign({}, classes('button', 'exclude', classNames(alwaysDisplayExclude && 'visible')), { size: "xsmall", variant: "icon-no-padding", icon: React.createElement(Icon_1.IconExclude, null), onClick: function onClick() {
                    if (onClickExclude) {
                        onClickExclude(id);
                    }
                } })), React.createElement(Wrapper, Object.assign({}, classes('wrapper'), wrapperProps), prefix && React.createElement(Label_1.default, Object.assign({}, labelProps), React.createElement("strong", null, prefix, ":"), "\xA0"), exclude && React.createElement(Label_1.default, Object.assign({}, labelProps), "Not\xA0"), React.createElement(Label_1.default, Object.assign({}, labelProps, { text: label })), cardinality && React.createElement(Badge_1.default, Object.assign({ label: String(cardinality) }, classes('badge')))), variant === 'filter' && React.createElement(Button_1.default, Object.assign({}, classes('button', 'remove'), { onClick: function onClick() {
                    return onRemove && onRemove(id);
                }, variant: "icon-no-padding", icon: React.createElement(Icon_1.IconX, null) })), hasSubtags && React.createElement(Button_1.default, Object.assign({}, classes('button', 'subtags'), { onClick: function onClick() {
                    return onClickSubTags && onClickSubTags(id);
                }, variant: "icon", icon: React.createElement(Icon_1.IconArrowRight, null) })));
        }
    }]);

    return Tag;
}(React.Component);

Tag.defaultProps = {
    colorScheme: 'light',
    size: 'medium',
    variant: 'simple',
    wrappedComponent: 'div'
};
exports.default = Tag;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-invalid-template-strings */

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
var apiEndpoint = 'https://s3.amazonaws.com/orpheus-assets/country-list';
var apiPostalCodeFile = 'postal-codes.json';
var apiCountriesFile = 'countries.json';
var apiStatesFile = lodash_1.template('countries/${countryFileId}.json');
exports.getCountryList = function (_ref) {
    var countries = _ref.countryList.countries;
    return countries;
};
exports.getStateList = function (_ref2) {
    var states = _ref2.countryList.states;
    return states;
};
exports.getPostalCodes = function (_ref3) {
    var postalCodes = _ref3.countryList.postalCodes;
    return postalCodes;
};
function apiFetch(url) {
    return fetch(apiEndpoint + "/" + url, {
        headers: { 'Content-Type': 'application/json' },
        method: 'get'
    }).then(function (response) {
        return response.json();
    });
}
exports.areCountriesAlreadyFetched = function () {
    return reselect_1.createSelector(exports.getCountryList, function (countries) {
        return !!countries.length;
    });
};
exports.areCountryStatesAlreadyFetched = function (countryId) {
    return reselect_1.createSelector(exports.getStateList, function (states) {
        return states.hasOwnProperty(countryId);
    });
};
exports.fetchPostalCodes = function () {
    return apiFetch(apiPostalCodeFile);
};
exports.fetchCountries = function () {
    return apiFetch(apiCountriesFile);
};
function fetchStatesForCountry(_ref4) {
    var _this = this;

    var code = _ref4.code,
        filename = _ref4.filename;

    return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var states;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return apiFetch(apiStatesFile({ countryFileId: filename }));

                        case 3:
                            states = _context.sent;

                            resolve({ states: states, countryId: code });
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](0);

                            reject(_context.t0);

                        case 10:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));
    });
}
exports.fetchStatesForCountry = fetchStatesForCountry;
function fetchCountriesAndPostalCodes() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var countries, postalCodes;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return exports.fetchCountries();

                        case 3:
                            countries = _context2.sent;
                            _context2.next = 6;
                            return exports.fetchPostalCodes();

                        case 6:
                            postalCodes = _context2.sent;

                            resolve({ countries: countries, postalCodes: postalCodes });
                            _context2.next = 13;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](0);

                            reject(_context2.t0);

                        case 13:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 10]]);
        }));
    });
}
exports.fetchCountriesAndPostalCodes = fetchCountriesAndPostalCodes;
exports.getCountryFromCode = function (countryCode) {
    return reselect_1.createSelector(exports.getCountryList, function (countries) {
        return countries.length ? lodash_1.find(countries, { code: countryCode }) : undefined;
    });
};
exports.getCountryLabelFromCode = function (countryCode) {
    return reselect_1.createSelector(exports.getCountryFromCode(countryCode), function (country) {
        return country ? country.name : undefined;
    });
};
exports.getStateLabelFromCode = function (stateCode) {
    return reselect_1.createSelector(exports.getStateList, function (states) {
        var countryCode = stateCode.split('-')[0];
        return states.hasOwnProperty(countryCode) ? lodash_1.find(states[countryCode], { code: stateCode }).name : undefined;
    });
};

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Projects-related Redux Actions
 */
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Projects');
exports.setProjects = actionCreator('SET_PROJECTS');
// export const addTrackToProject = actionCreator<IAddTrackToProjectActionPayload>('ADD_TRACK_TO_PROJECT');
// Request Async Actions
exports.requestCreateProject = actionCreator('REQUEST_CREATE_PROJECT');
exports.requestUpdateProject = actionCreator('REQUEST_UPDATE_PROJECT');
exports.requestJoinProject = actionCreator('REQUEST_JOIN_PROJECT');
exports.requestDeleteProject = actionCreator('REQUEST_DELETE_PROJECT');
exports.requestAddTrackToProject = actionCreator('REQUEST_ADD_TRACK_TO_PROJECT');
// Async Actions
exports.createProject = actionCreator.async('CREATE_PROJECT');
exports.updateProject = actionCreator.async('UPDATE_PROJECT');
exports.joinProject = actionCreator.async('JOIN_PROJECT');
exports.deleteProject = actionCreator.async('DELETE_PROJECT');
exports.addTrackToProject = actionCreator.async('ADD_TRACK_TO_PROJECT');

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(256);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var Icon_1 = __webpack_require__(12);
var Button_1 = __webpack_require__(10);
var SelectContextualParam_1 = __webpack_require__(1257);
var SelectLocation_1 = __webpack_require__(1260);
var SelectMedia_1 = __webpack_require__(1335);
var SelectSpotCount_1 = __webpack_require__(1346);
var SelectTerm_1 = __webpack_require__(1349);
var SelectTerritory_1 = __webpack_require__(1352);
function getStepNumber(predicate) {
    return 1 + lodash_1.findIndex(exports.licenseBuildingSteps, typeof predicate === 'string' ? { id: predicate } : predicate);
}
exports.contextualParamMapping = [{
    medium: [2001, 2002, 2003, 2006, 2007],
    param: 'broadcast_territories',
    type: 'BroadcastTerritory'
}, {
    medium: [2005],
    param: 'audience_sizes',
    type: 'AudienceSize'
}, {
    medium: [2014, 2015],
    param: 'production_budgets',
    type: 'ProductionBudget'
}, {
    medium: [2013],
    param: 'episode_budgets',
    type: 'EpisodeBudget'
}, {
    medium: [2004, 2008, 2009, 2010, 2011, 2012, 2016],
    param: 'producer_locations',
    type: 'ProducerLocation'
}];
exports.programmingMedia = [2013, 2014, 2015];
exports.licenseBuildingSteps = [{
    id: 'media',
    component: SelectMedia_1.default
}, {
    id: 'terms',
    component: SelectTerm_1.default
}, {
    id: 'spot_counts',
    component: SelectSpotCount_1.default
}, [{
    id: 'audience_sizes',
    component: SelectContextualParam_1.default
}, {
    id: 'production_budgets',
    component: SelectContextualParam_1.default
}, {
    id: 'episode_budgets',
    component: SelectContextualParam_1.default
}, {
    id: 'broadcast_territories',
    component: SelectTerritory_1.default
}, {
    id: 'producer_locations',
    component: SelectLocation_1.default
}]];
exports.mediumStep = getStepNumber('media');
exports.termStep = getStepNumber('terms');
exports.spotCountStep = getStepNumber('spot_counts');
exports.contextualParamStep = getStepNumber(function (stepInfo) {
    return array_1.objectIsArray(stepInfo);
});
exports.excludedMediaType = [2001, 2003, 2008, 2009, 2010];
// tslint:disable:max-line-length
exports.mediaTypeDefinitions = [{
    id: 2001,
    label: 'TV + Web Streaming',
    icon: React.createElement(Icon_1.IconLicenseTVWeb, null),
    hint: 'For use on broadcast television, network, cable and satellite programming as well as the use on streaming websites and all forms of social media.'
}, {
    id: 2002,
    icon: React.createElement(Icon_1.IconLicenseTV, null),
    hint: 'For use on broadcast television, network, cable and satellite programming.'
}, {
    id: 2003,
    icon: React.createElement(Icon_1.IconLicenseTVEditorial, null)
}, {
    id: 2004,
    icon: React.createElement(Icon_1.IconLicenseWeb, null),
    hint: 'For use on streaming websites (Youtube, Vimeo etc.), all forms of social media, and OTT.',
    contextualSubtitle: 'Web Streaming licenses are valid for the world.'
}, {
    id: 2012,
    icon: React.createElement(Icon_1.IconLicenseSocialMedia, null),
    hint: 'For use on all forms of paid or organic social media (including Tik Tok), not including streaming websites.',
    contextualSubtitle: 'Social media licenses are valid for the world.'
}, {
    id: 2005,
    icon: React.createElement(Icon_1.IconLicenseIndustrial, null),
    hint: 'For use in non-broadcast, internal and external forms of advertising. Incudes in-store advertising, events, internal company use and out-of-home.',
    contextualSubtitle: 'Industrial & Closed Circuit licenses are valid for the world.'
}, {
    id: 2006,
    icon: React.createElement(Icon_1.IconLicenseRadio, null),
    hint: 'For use on broadcast AM/FM radio, as well as satellite radio.'
}, {
    id: 2007,
    icon: React.createElement(Icon_1.IconLicenseTheatrical, null),
    hint: 'For use in theatres as pre-film on-screen advertising.'
}, {
    id: 2008,
    icon: React.createElement(Icon_1.IconLicenseShowReel, null),
    hint: 'For use as background music on a single company\'s show-reel.',
    contextualSubtitle: 'Show Reel licenses are valid for the world.'
}, {
    id: 2016,
    icon: React.createElement(Icon_1.IconLicenseShowReel, null),
    hint: 'For use on case studies and as background music on a single company\'s show-reel.',
    contextualSubtitle: 'Case study and BTS licenses are valid for the world.'
}, {
    id: 2009,
    icon: React.createElement(Icon_1.IconLicenseCaseStudy, null),
    hint: 'For use on a case study film.',
    contextualSubtitle: 'Case Study licenses are valid for the world.'
}, {
    id: 2010,
    icon: React.createElement(Icon_1.IconLicenseAllMedia, null),
    hint: 'Includes all forms of advertising media.',
    contextualSubtitle: 'All Media licenses are valid for the world.'
}, {
    id: 2013,
    icon: React.createElement(Icon_1.IconLicenseCaseStudy, null),
    hint: 'For use on TV shows.',
    contextualSubtitle: 'All TV programming licenses are for perpetuity, budget ranges are in USD.'
}, {
    id: 2014,
    icon: React.createElement(Icon_1.IconLicenseTheatrical, null),
    hint: 'For use on film productions.',
    contextualSubtitle: 'All film production licenses are for perpetuity, budget ranges are in USD.'
}, {
    id: 2015,
    icon: React.createElement(Icon_1.IconLicenseTheatrical, null),
    hint: 'For use on film trailers.',
    contextualSubtitle: 'All film production licenses are for perpetuity, budget ranges are in USD.'
}, {
    id: 2011,
    icon: React.createElement(Icon_1.IconLicensePodcast, null),
    hint: 'For use in podcast advertising or as in-program music.',
    contextualSubtitle: 'Podcast licenses are valid for the world.'
}];
exports.mediaTypeDefinitionsMap = exports.mediaTypeDefinitions.reduce(function (result, cur) {
    result[cur.id] = cur;
    return result;
}, {});
exports.componentHints = [{
    // Baltic State
    id: 4004,
    hint: 'Includes Estonia, Latvia and Lithuania'
}, {
    // Eastern Europe
    id: 4005,
    hint: 'Includes Estonia, Latvia and Lithuania, Czech Republic, Hungary, Poland, Slovakia, Slovenia, Republic of Macedonia, Serbia and Montenegro, Bosnia and Herzegovina, Bulgaria, Albania, Croatia, Russia, Belarus, Ukraine, Romania, Moldova'
}, {
    // China
    id: 4007,
    hint: 'Includes Hong Kong, Macau, Taiwan and Singapore'
}, {
    // Gulf Cooperation Council
    id: 4008,
    hint: 'Bahrain, Kuwait, Oman, Qatar, Saudi Arabia, United Arab Emirates'
}, {
    // MENA
    id: 4010,
    hint: 'Includes Algeria, Bahrain, Egypt, Iran, Iraq, Israel, Jordan, Kuwait, Lebanon, Libya, Morocco, Oman, Palestine, Qatar Sahrawi Arab Democratic Republic, Saudi Arabia, Syria, Tunisia, United Arab Emirates, Yemen, Afganistan, Armenia, Azerbaijan, Chad, Comoros, Cyprus, Djibouti, Eritrea, Georgia, Mali, Mauritania, Niger, Pakistan, Somalia and Sudan (doesn\'t include Turkey)'
}, {
    // MENAT
    id: 4011,
    hint: 'Includes all countries listed under MENA with the addition of Turkey'
}, {
    // Portugal, Brazil and CPLP
    id: 4013,
    hint: 'Includes Portugal, Brazil, Angola, Cape Verde, Guinea-Bissau, Mozambique, São Tomé and Príncipe, Timor-Leste, and Equatorial Guinea.'
}, {
    // Southeast Asia
    id: 4014,
    hint: 'Includes Brunei, Cambodia, East Timor, Indonesia, Laos, Malaysia, Myanmar, Philippines, Singapore, Thailand, Vietnam, Christmas Island, Coco (Keeling) Islands and Andaman and Nicobar Islands'
}, {
    // Western Europe
    id: 4015,
    hint: 'Includes Belgium, France, Ireland, Luxembourg, Monaco, Netherlands, UK, Andorra, Portugal and Spain'
}, {
    // UK
    id: 4018,
    hint: 'Includes Northern Ireland, Scotland, Wales and all British overseas territories'
}, {
    // France
    id: 4019,
    hint: 'Includes all French overseas regions, departments, territories and collectivities'
}, {
    // GAS - DACH
    id: 4020,
    hint: 'Includes Germany, Austria and Switzerland'
}, {
    // Netherlands
    id: 4031,
    hint: 'Includes SSS and ABC Islands'
}, {
    // USA - Regional
    id: 4039,
    hint: React.createElement(React.Fragment, null, "Defined as as the broadcast of content in less than four US Television Market Areas (TMA). A Full list of TMAs can be found here:", React.createElement(Button_1.default, { size: "medium", label: "https://en.wikipedia.org/wiki/List_of_United_States_television_markets", variant: "hyperlink", wrapperComponent: "a", hyperLinkProps: {
            href: 'https://en.wikipedia.org/wiki/List_of_United_States_television_markets',
            target: '_blank'
        }, style: {} }))
}];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Color Schemes
 */

Object.defineProperty(exports, "__esModule", { value: true });
function getColorSchemeClassName(scheme, prefix) {
  return scheme ? (prefix ? prefix + "-" : '') + "color-scheme--" + scheme : '';
}
exports.getColorSchemeClassName = getColorSchemeClassName;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PageHeader Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var grid_1 = __webpack_require__(58);
__webpack_require__(980);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_helmet_1 = __webpack_require__(78);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var CurrencySelect_1 = __webpack_require__(350);
var classes = new BEM('page__header');

var PageHeader = function (_React$Component) {
    _inherits(PageHeader, _React$Component);

    function PageHeader() {
        _classCallCheck(this, PageHeader);

        return _possibleConstructorReturn(this, (PageHeader.__proto__ || Object.getPrototypeOf(PageHeader)).apply(this, arguments));
    }

    _createClass(PageHeader, [{
        key: "render",
        value: function render() {
            return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, classes('fixed-guard'))), React.createElement("header", Object.assign({}, classes('', '', this.props.className)), React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, this.props.title)), this.props.children || React.createElement("div", Object.assign({}, classes('content')), this.props.title && React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, classes('title__dash'))), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), this.props.title)), React.createElement("div", Object.assign({}, classes('actions')), this.props.actions, this.props.withCurrencySelect && React.createElement(React.Fragment, null, React.createElement(Label_1.Span, { size: "small", style: {
                    marginLeft: 'auto',
                    marginRight: grid_1.baseline
                } }, "Currency:"), React.createElement(CurrencySelect_1.default, null))))));
        }
    }]);

    return PageHeader;
}(React.Component);

exports.default = PageHeader;

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
var qs = __webpack_require__(162);
var Browse_1 = __webpack_require__(61);
var array_1 = __webpack_require__(256);
var budgetFilter_1 = __webpack_require__(211);
var license_1 = __webpack_require__(393);
var searchFilters_1 = __webpack_require__(599);
var sortOrder_1 = __webpack_require__(394);
var tempoFilter_1 = __webpack_require__(600);
var types_1 = __webpack_require__(105);
/**
 * getEncodedQuery
 * Make sure to encode only the search filters
 */
function getEncodedQuery(query) {
    var encodedQuery = Object.assign({}, query);
    if (types_1.QueryStringParam.Search in query) {
        encodedQuery[types_1.QueryStringParam.Search] = searchFilters_1.SearchFilter.serialize(searchFilters_1.getSearchAsArray(query));
    }
    return encodedQuery;
}
exports.getEncodedQuery = getEncodedQuery;
function replaceQueryString(query, location, router) {
    var difference = array_1.diff(qs.parse(location.search), query);
    if (!(types_1.QueryStringParam.License in difference) && location.pathname !== Browse_1.BrowsePagePath) {
        // Redirect to browse page if a search is initiated from elsewhere in the app
        router_1.goto(Browse_1.BrowsePagePath, query, router);
    } else {
        router_1.refreshRoute(location, router, query);
    }
}
exports.replaceQueryString = replaceQueryString;
function updateQueryString(query, location, router) {
    var newQuery = Object.assign({}, qs.parse(location.search), query);
    if (!(types_1.QueryStringParam.License in query) && location.pathname !== Browse_1.BrowsePagePath) {
        router_1.goto(Browse_1.BrowsePagePath, newQuery, router);
    } else {
        router_1.refreshRoute(location, router, newQuery);
    }
}
exports.updateQueryString = updateQueryString;
function getQueryStringStateForRoute(match) {
    var locationQuery = match.location.query;

    var _searchFilters_1$Sear = searchFilters_1.SearchFilter.unserialize(locationQuery),
        filters = _searchFilters_1$Sear.filters,
        query = _searchFilters_1$Sear.query,
        taxonomy_query = _searchFilters_1$Sear.taxonomy_query;

    return {
        taxonomy_query: taxonomy_query,
        filters: Object.assign({}, filters, { budget: budgetFilter_1.BudgetFilter.unserialize(locationQuery), tempo: tempoFilter_1.TempoFilter.unserialize(locationQuery) }),
        license_params: router_1.getLicenseParamsForRouteQuery(match),
        sort: sortOrder_1.SortOrderSerializer.unserialize(locationQuery),
        query: query
    };
}
exports.getQueryStringStateForRoute = getQueryStringStateForRoute;
function generateQueryStringFromState(state) {
    if (state) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, types_1.QueryStringParam.License, license_1.LicenseFilter.serialize(state.license_params || [])), _defineProperty(_ref, types_1.QueryStringParam.Search, searchFilters_1.SearchFilter.serialize(searchFilters_1.SearchFilter.searchParamsToArray(state))), _defineProperty(_ref, types_1.QueryStringParam.Budget, budgetFilter_1.BudgetFilter.serialize(state.filters.budget)), _defineProperty(_ref, types_1.QueryStringParam.Tempo, tempoFilter_1.TempoFilter.serialize(state.filters.tempo)), _defineProperty(_ref, types_1.QueryStringParam.SortOrder, sortOrder_1.SortOrderSerializer.serialize(state.sort)), _defineProperty(_ref, types_1.QueryStringParam.Similarity, state.filters.similarity ? state.filters.similarity.track_id : ''), _ref;
    }
    return {};
}
exports.generateQueryStringFromState = generateQueryStringFromState;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Login Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var authentication_1 = __webpack_require__(403);
var notificationActions = __webpack_require__(53);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var user_1 = __webpack_require__(50);
var login_1 = __webpack_require__(404);
var url_1 = __webpack_require__(183);
__webpack_require__(1415);
var classNames = __webpack_require__(15);
// import * as imageloaded from 'imagesloaded';
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var query_string_1 = __webpack_require__(162);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var WindowSizeListener = __webpack_require__(124);
var Velocity = __webpack_require__(91);
var Page_1 = __webpack_require__(38);
var helpers_1 = __webpack_require__(151);
var router_1 = __webpack_require__(27);
var Heading_1 = __webpack_require__(9);
var AuthenticationDrawer_1 = __webpack_require__(632);
var Browse_1 = __webpack_require__(61);
var Registration_1 = __webpack_require__(287);
var VerifyEmail_1 = __webpack_require__(678);
// Page Path
exports.LoginPagePath = '/login';
exports.SignupPagePath = '/signup';
var classes = new BEM('login-page');

var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        _this.onResize = function () {
            // imageloaded(this.illustration, () => {
            //   if (this.illustration) {
            //     nextTick(() => {
            //       this.animateIllustration();
            //     });
            //   }
            // });
        };
        _this.receiveTokensFromUrlFragment = function () {
            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.location;
            return new Promise(function (resolve) {
                var _query_string_1$parse = query_string_1.parse(location.hash),
                    error = _query_string_1$parse.error,
                    error_description = _query_string_1$parse.error_description,
                    id_token = _query_string_1$parse.id_token,
                    state = _query_string_1$parse.state;

                _this.setState({
                    callbackError: error,
                    callbackErrorDescription: error_description,
                    callbackIdToken: id_token,
                    callbackState: state,
                    isCallback: !!id_token || !!error
                }, resolve);
            });
        };
        _this.state = {};
        return _this;
    }

    _createClass(Login, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.props.initHeader();
                                _context.next = 3;
                                return this.receiveTokensFromUrlFragment();

                            case 3:
                                this.triggerActionBasedOnState();
                                if (this.props.viewer.profile) {
                                    this.onLoginSuccess();
                                } else if (this.props.viewer.authentication_info) {
                                    this.props.setAuthenticationConfig(this.props.viewer.authentication_info);
                                }

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this2 = this;

                var _props, location, viewer;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _props = this.props, location = _props.location, viewer = _props.viewer;

                                if (lodash_1.isEqual(prevProps.location, location)) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 4;
                                return this.receiveTokensFromUrlFragment(location);

                            case 4:
                                this.triggerActionBasedOnState();
                                _context2.next = 8;
                                break;

                            case 7:
                                if (!prevProps.viewer.profile && viewer.profile) {
                                    this.props.setUserProfile(viewer.profile, viewer.id);
                                    nextTick(function () {
                                        return _this2.onLoginSuccess();
                                    });
                                }

                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.resetHeader();
        }
    }, {
        key: "onLoginSuccess",
        value: function onLoginSuccess() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this3 = this;

                var _props2, pushNotification, router, viewer, profile, isNewUser, userHadLoggedInWithEmail, loginSuccessMessage, message, redirectUrl, callbackState;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _props2 = this.props, pushNotification = _props2.pushNotification, router = _props2.router, viewer = _props2.viewer;
                                profile = viewer.profile;
                                isNewUser = profile.is_new_user;
                                userHadLoggedInWithEmail = !!!profile.external_provider;
                                loginSuccessMessage = lodash_1.template(locales_1.default.login.successMessage)({ first_name: profile.first_name });
                                message = isNewUser ? locales_1.default.signup.successMessage : loginSuccessMessage;

                                if (!(isNewUser && userHadLoggedInWithEmail)) {
                                    _context3.next = 16;
                                    break;
                                }

                                _context3.prev = 7;
                                _context3.next = 10;
                                return this.props.requestSendConfirmationEmail();

                            case 10:
                                pushNotification({
                                    message: 'A confirmation email was sent to you. Please click the link so we can verify your email.'
                                });
                                _context3.next = 16;
                                break;

                            case 13:
                                _context3.prev = 13;
                                _context3.t0 = _context3["catch"](7);

                                pushNotification({
                                    message: 'We could not deliver the confirmation email. Please contact an administrator.',
                                    state: 'error'
                                });

                            case 16:
                                pushNotification({ message: message, state: 'success' });
                                redirectUrl = Browse_1.BrowsePagePath;

                                if (!this.state.callbackState) {
                                    _context3.next = 31;
                                    break;
                                }

                                callbackState = url_1.decodeFromUrl(this.state.callbackState);
                                _context3.t1 = callbackState.stateType;
                                _context3.next = _context3.t1 === 'EmailVerification' ? 23 : _context3.t1 === 'PostAuthenticationRequests' ? 25 : 29;
                                break;

                            case 23:
                                redirectUrl = VerifyEmail_1.VerifyEmailPagePath(callbackState.email, callbackState.code);
                                return _context3.abrupt("break", 29);

                            case 25:
                                this.props.recoverPostAuthenticationRequests(callbackState.postAuthenticationRequests);
                                callbackState.postAuthenticationRequests.forEach(function (req) {
                                    if (req.requestType === 'createProject') {
                                        var searchState = req.payload.searchState;

                                        redirectUrl = router_1.getRouteLocation(Browse_1.BrowsePagePath, helpers_1.generateQueryStringFromState(searchState));
                                    }
                                });
                                nextTick(function () {
                                    return _this3.props.consumePostAuthenticationRequests();
                                });
                                return _context3.abrupt("return");

                            case 29:
                                _context3.next = 32;
                                break;

                            case 31:
                                if (isNewUser) {
                                    redirectUrl = Registration_1.RegistrationPagePath;
                                }

                            case 32:
                                setTimeout(function () {
                                    return router.push(redirectUrl);
                                }, 250);

                            case 33:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[7, 13]]);
            }));
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var isCallback = this.state.isCallback;

            var extraClasses = classNames({ 'is-callback': isCallback });
            return React.createElement(Page_1.default, { id: "login", className: extraClasses, noIndex: true }, isCallback ? React.createElement(Heading_1.default, { is: "h2", textColor: "bw6" }, "Redirecting you back to Bopper...") : React.createElement(React.Fragment, null, React.createElement("div", Object.assign({ ref: function ref(node) {
                    return _this4.illustrationContainer = node;
                } }, classes('illustration'))), React.createElement(AuthenticationDrawer_1.default, Object.assign({ action: this.props.action, drawerProps: {
                    floatingHeader: true,
                    showCloseButton: false
                }, useAbsoluteLink: true }, classes('form'))), React.createElement(WindowSizeListener, { onResize: this.onResize })));
        }
        // @ts-ignore

    }, {
        key: "animateIllustration",
        value: function animateIllustration() {
            var imageScrollAllowed = this.illustration.getBoundingClientRect().height - this.illustrationContainer.getBoundingClientRect().height;
            if (imageScrollAllowed < 0) {
                this.illustration.style.width = 'auto';
                this.illustration.style.height = '100%';
            } else {
                this.illustration.style.width = '100%';
                this.illustration.style.height = 'auto';
                Velocity(this.illustration, 'stop');
                Velocity(this.illustration, {
                    translateY: ["-" + imageScrollAllowed, 0]
                }, {
                    duration: imageScrollAllowed * 60,
                    easing: 'linear',
                    loop: true
                });
            }
        }
    }, {
        key: "triggerActionBasedOnState",
        value: function triggerActionBasedOnState() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _props3, pushNotification, requestTokenAuthentication, router, _state, callbackError, callbackErrorDescription, callbackIdToken, fallBackRedirect, error;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _props3 = this.props, pushNotification = _props3.pushNotification, requestTokenAuthentication = _props3.requestTokenAuthentication, router = _props3.router;
                                _state = this.state, callbackError = _state.callbackError, callbackErrorDescription = _state.callbackErrorDescription, callbackIdToken = _state.callbackIdToken;

                                fallBackRedirect = function fallBackRedirect() {
                                    return setTimeout(function () {
                                        return router.go(-1);
                                    }, 250);
                                };

                                if (!callbackIdToken) {
                                    _context4.next = 18;
                                    break;
                                }

                                _context4.prev = 4;
                                _context4.next = 7;
                                return requestTokenAuthentication(callbackIdToken);

                            case 7:
                                error = _context4.sent;

                                if (error) {
                                    console.error('Completed with errors:', error);
                                    pushNotification({
                                        autoDismiss: false,
                                        message: locales_1.default.errors.genericMessage,
                                        state: 'error'
                                    });
                                    fallBackRedirect();
                                }
                                _context4.next = 16;
                                break;

                            case 11:
                                _context4.prev = 11;
                                _context4.t0 = _context4["catch"](4);

                                console.error(_context4.t0);
                                pushNotification({
                                    autoDismiss: false,
                                    message: locales_1.default.errors.login.mutationError,
                                    state: 'error'
                                });
                                fallBackRedirect();

                            case 16:
                                _context4.next = 19;
                                break;

                            case 18:
                                if (callbackError) {
                                    console.error(callbackError, callbackErrorDescription);
                                    pushNotification({
                                        autoDismiss: false,
                                        message: locales_1.default.errors.genericMessage,
                                        state: 'error'
                                    });
                                    fallBackRedirect();
                                }

                            case 19:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[4, 11]]);
            }));
        }
    }]);

    return Login;
}(React.Component);

var ConnectedLogin = react_redux_1.connect(function (_ref) {
    var postAuthenticationRequests = _ref.postAuthenticationRequests;
    return { postAuthenticationRequests: postAuthenticationRequests };
}, function (dispatch) {
    return {
        consumePostAuthenticationRequests: function consumePostAuthenticationRequests() {
            dispatch(postAuthenticationRequests_1.consumePostAuthenticationRequests());
        },
        initHeader: function initHeader() {
            dispatch(ui_1.setHeaderType({ type: 'simple' }));
        },
        resetHeader: function resetHeader() {
            dispatch(ui_1.setHeaderType({ type: 'extended' }));
        },
        requestSendConfirmationEmail: function requestSendConfirmationEmail() {
            return new Promise(function (resolve, reject) {
                dispatch(user_1.requestSendConfirmationEmail({ promise: { resolve: resolve, reject: reject } }));
            });
        },
        requestTokenAuthentication: function requestTokenAuthentication(payload) {
            dispatch(user_1.requestUserAuthenticationWithToken(payload));
        },
        pushNotification: function pushNotification(notification) {
            dispatch(notificationActions.pushNotification(notification));
        },

        recoverPostAuthenticationRequests: function recoverPostAuthenticationRequests(requests) {
            dispatch(postAuthenticationRequests_1.recoverPostAuthenticationRequests(requests));
        },
        setAuthenticationConfig: function setAuthenticationConfig(config) {
            dispatch(authentication_1.setAuthenticationConfig(config));
        },
        setUserProfile: function setUserProfile(profile, viewerId) {
            dispatch(user_1.setViewerId({ viewerId: viewerId }));
            dispatch(user_1.setUserProfile({ profile: profile }));
        }
    };
}, function (stateProps, _a, ownProps) {
    var _requestTokenAuthentication = _a.requestTokenAuthentication,
        dispatchProps = __rest(_a, ["requestTokenAuthentication"]);
    return Object.assign({}, stateProps, dispatchProps, ownProps, { requestTokenAuthentication: function requestTokenAuthentication(idToken) {
            return new Promise(function (resolve, reject) {
                _requestTokenAuthentication({
                    idToken: idToken,
                    viewerId: ownProps.viewer.id,
                    promise: { resolve: resolve, reject: reject }
                });
            });
        } });
})(Login);
var RelayLogin = react_relay_1.createFragmentContainer(ConnectedLogin, login_1.LoginFormFragment);
exports.default = RelayLogin;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Player State Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(226);
var track_1 = __webpack_require__(44);
var ui_1 = __webpack_require__(294);
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
var defaultList = [];
exports.getPlayerState = function (_ref) {
    var player = _ref.player;
    return player;
};
exports.getQueue = function (_ref2) {
    var queue = _ref2.queue;
    return queue;
};
exports.getCurrentTrack = reselect_1.createSelector(exports.getPlayerState, function (_ref3) {
    var currentTrack = _ref3.currentTrack;
    return currentTrack;
});
exports.getIsTrackPlaying = reselect_1.createSelector(exports.getPlayerState, function (_ref4) {
    var isTrackPlaying = _ref4.isTrackPlaying;
    return isTrackPlaying;
});
exports.makeIsTrackPlaying = function () {
    return reselect_1.createSelector([exports.getPlayerState, track_1.getTrackIdFromProps], function (_ref5, trackId) {
        var currentTrack = _ref5.currentTrack,
            isTrackPlaying = _ref5.isTrackPlaying;

        return isTrackPlaying && !!currentTrack && (currentTrack.trackId === trackId || currentTrack.versionId === trackId);
    });
};
exports.makeIsTrackListened = function () {
    return reselect_1.createSelector([exports.getPlayerState, track_1.getTrackIdFromProps], function (_ref6, trackId) {
        var history = _ref6.history;

        return lodash_1.some(history, { versionId: trackId });
    });
};
exports.getTermsForCurrentlyPlayingTrack = reselect_1.createSelector(exports.getPlayerState, function (_ref7) {
    var currentTrack = _ref7.currentTrack;

    return currentTrack && currentTrack.trackInfo.terms ? relay_1.extractNodeFromConnection(currentTrack.trackInfo.terms) : defaultList;
});
exports.isTermListOpen = reselect_1.createSelector(ui_1.getUIState, function (_ref8) {
    var player = _ref8.player;
    return !!player && !!player.termListIsVisible;
});
exports.isTrackDetailsOpen = reselect_1.createSelector([ui_1.trackDetailsPanelIsVisible, ui_1.getTrackDetailsTrackInfo, exports.getPlayerState], function (isVisible, trackInfo, _ref9) {
    var currentTrack = _ref9.currentTrack;

    return isVisible && !!trackInfo && !!currentTrack && trackInfo.id === currentTrack.trackId;
});
exports.getPlayerTrack = reselect_1.createSelector(exports.getPlayerState, function (_ref10) {
    var currentTrack = _ref10.currentTrack;
    return !!currentTrack ? {
        trackId: currentTrack.trackId,
        versionId: currentTrack.versionId
    } : null;
});
exports.getPlayerQueue = reselect_1.createSelector(exports.getPlayerState, function (_ref11) {
    var queue = _ref11.queue;
    return queue;
});
exports.getTrackInfoFromQueue = reselect_1.createSelector(exports.getPlayerQueue, function (queue) {
    return lodash_1.memoize(function (id) {
        var track = queue.find(function (_ref12) {
            var trackId = _ref12.trackId,
                versionId = _ref12.versionId;
            return trackId === id || versionId === id;
        });
        if (track) {
            return track.trackInfo;
        }
        return null;
    });
});

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Analytics-related Redux Actions
 */

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Analytics');
exports.setLicense = actionCreator('SET_LICENSE');
exports.setSearch = actionCreator('SET_SEARCH');
exports.similaritySearch = actionCreator('SIMILARITY_SEARCH');
// Set budget action
exports.trackSetBudget = actionCreator('TRACK_SET_BUDGET');

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LoadingSpinner Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(978);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var classes = new BEM('loading-spinner');

var LoadingSpinner = function (_React$Component) {
    _inherits(LoadingSpinner, _React$Component);

    function LoadingSpinner() {
        _classCallCheck(this, LoadingSpinner);

        return _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
    }

    _createClass(LoadingSpinner, [{
        key: "render",
        value: function render() {
            var _classModifiers;

            var classModifiers = (_classModifiers = {}, _defineProperty(_classModifiers, this.props.color, true), _defineProperty(_classModifiers, this.props.size, true), _classModifiers);
            var component = React.createElement("div", Object.assign({}, classes('', classModifiers, this.props.className)), React.createElement("div", Object.assign({}, classes('icon'))));
            return !!this.props.center ? React.createElement("div", Object.assign({}, classes('centered-wrapper', { fixed: !!this.props.fixed })), component) : component;
        }
    }]);

    return LoadingSpinner;
}(React.Component);

LoadingSpinner.defaultProps = {
    color: 'accent',
    size: 'medium'
};
exports.default = LoadingSpinner;

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Tooltip
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-submodule-imports
__webpack_require__(1267);
__webpack_require__(1269);
var react_1 = __webpack_require__(1271);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Label_1 = __webpack_require__(8);
var tooltipContentClasses = new BEM('tooltip-content');
var TooltipContent = function TooltipContent(_ref) {
    var content = _ref.content,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size;

    return typeof content === 'string' ? React.createElement(Label_1.Span, Object.assign({ variant: size === 'large' ? 'description' : undefined, size: size, block: true }, tooltipContentClasses('', _defineProperty({}, size, !!size))), content) : React.cloneElement(content, Object.assign({}, tooltipContentClasses('', _defineProperty({}, size, !!size), content.props.className)));
};
exports.Tooltip = function (_a) {
    var children = _a.children,
        className = _a.className,
        content = _a.content,
        size = _a.size,
        theme = _a.theme,
        rest = __rest(_a, ["children", "className", "content", "size", "theme"]);

    return React.createElement(react_1.default, Object.assign({ content: React.createElement(TooltipContent, { content: content, size: size }), theme: "ams-" + (theme || 'light'), animation: "shift-toward", arrowType: "round", arrow: true, duration: [500, 250], inertia: true, performance: true }, rest), children);
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Animation Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var velocity_react_1 = __webpack_require__(19);
/* tslint:disable-next-line */
__webpack_require__(214);
var fx = velocity_react_1.velocityHelpers.registerEffect;
exports.ListItemAnimations = function (height) {
    var translateX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -50;
    return {
        In: fx({
            defaultDuration: 500,
            calls: [[{ height: [height, 0] }, 2 / 5], [{
                opacity: [1, 0],
                translateX: [0, translateX]
            }, 3 / 5, { easing: 'easeOutSine' }]]
        }),
        Out: fx({
            defaultDuration: 500,
            calls: [[{
                opacity: 0,
                translateX: translateX
            }, 3 / 5, { easing: 'easeInSine' }], [{
                height: 0
            }, 2 / 5]],
            reset: { height: height }
        })
    };
};

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * URL Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
function encodeForUrl(payload) {
    return btoa(JSON.stringify(payload));
}
exports.encodeForUrl = encodeForUrl;
function decodeFromUrl(payload) {
    return payload != null ? JSON.parse(atob(payload)) : null;
}
exports.decodeFromUrl = decodeFromUrl;

/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ImageLoaded Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var imageloaded = __webpack_require__(640);
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(28);

var ImageLoaded = function (_React$Component) {
    _inherits(ImageLoaded, _React$Component);

    function ImageLoaded(props) {
        _classCallCheck(this, ImageLoaded);

        var _this = _possibleConstructorReturn(this, (ImageLoaded.__proto__ || Object.getPrototypeOf(ImageLoaded)).call(this, props));

        _this.didMount = false;
        _this.onImageLoaded = function () {
            if (_this.didMount) {
                _this.setState({ imageLoaded: true });
            }
        };
        _this.loadImage = function () {
            if (_this.didMount) {
                _this.imgLoad.on('always', _this.onImageLoaded);
            }
        };
        _this.state = {
            imageLoaded: false
        };
        return _this;
    }

    _createClass(ImageLoaded, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.didMount = true;
            this.imgLoad = imageloaded(react_dom_1.findDOMNode(this), { background: this.props.background });
            this.loadImage();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.didMount = false;
            this.imgLoad = null;
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.children({
                imageLoaded: this.state.imageLoaded,
                reloadImage: this.loadImage
            });
        }
    }]);

    return ImageLoaded;
}(React.Component);

exports.default = ImageLoaded;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ArtistPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var artist_1 = __webpack_require__(644);
var taxonomy_1 = __webpack_require__(106);
var image_1 = __webpack_require__(64);
__webpack_require__(1498);
var lodash_1 = __webpack_require__(6);
var raf_throttle_1 = __webpack_require__(299);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var withLicenseBar_1 = __webpack_require__(392);
var queryString_1 = __webpack_require__(30);
var string_1 = __webpack_require__(47);
var LinkButton_1 = __webpack_require__(51);
var Icon_1 = __webpack_require__(12);
var Picture_1 = __webpack_require__(426);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Tag_1 = __webpack_require__(127);
var Collections_1 = __webpack_require__(227);
var TrackList_1 = __webpack_require__(229);
var helmet_1 = __webpack_require__(1553);
// Page Path
exports.ArtistPagePath = function (slug) {
    return "/artist/" + slug;
};
var classes = new BEM('artist');
var defaultList = [];

var ArtistPage = function (_React$Component) {
    _inherits(ArtistPage, _React$Component);

    function ArtistPage(props) {
        _classCallCheck(this, ArtistPage);

        var _this = _possibleConstructorReturn(this, (ArtistPage.__proto__ || Object.getPrototypeOf(ArtistPage)).call(this, props));

        _this.onLoadArtistImage = function (img) {
            var _img$getBoundingClien = img.getBoundingClientRect(),
                width = _img$getBoundingClien.width,
                height = _img$getBoundingClien.height;

            var ratio = width / height;
            var headerLayout = ratio <= 1.05 ? 'vertical' : 'horizontal';
            if (headerLayout !== _this.headerLayout) {
                _this.headerLayout = headerLayout;
                _this.forceUpdate();
            }
        };
        _this.onScroll = function () {
            if (_this.headerLayout === 'vertical') {
                _this.header.style.transform = "translate3d(0, -" + window.scrollY * .5 + "px, 0)";
            }
            _this.artistHeroImage.style.transform = "translate3d(0, -" + window.scrollY * .3 + "px, 0)";
        };
        _this.onTrackListResult = function (results) {
            var termsRanking = lodash_1.chain(results)
            // Gather all terms from track results
            .flatMap(function (_ref) {
                var terms = _ref.terms;
                return terms ? terms.edges.map(function (_ref2) {
                    var node = _ref2.node;
                    return node;
                }) : defaultList;
            })
            // Filter terms from Genre or Mood taxonomy
            .filter(function (term) {
                var acceptedTaxonomies = [taxonomy_1.TaxonomyType.Genres, taxonomy_1.TaxonomyType.Moods];
                var termTaxonomy = term.taxonomy.name;
                return acceptedTaxonomies.indexOf(termTaxonomy) > -1;
            })
            // Extract term names only
            .map(function (_ref3) {
                var name = _ref3.name;
                return name;
            })
            // Count all terms (returning a dictionary of the term name and the number of times it matched)
            .countBy()
            // Organize into an object for easier manipulation
            .map(function (count, name) {
                return { name: name, count: count };
            })
            // Order the results by count descending
            .orderBy('count', 'desc')
            // Keep the top most used terms
            .slice(0, 15).value();
            var featuredCollections = lodash_1.chain(results).flatMap(function (_ref4) {
                var collections = _ref4.collections;
                return collections ? collections.edges.map(function (_ref5) {
                    var node = _ref5.node;
                    return node;
                }) : defaultList;
            }).uniqBy('id').value();
            _this.setState({
                featuredCollections: featuredCollections,
                terms: termsRanking,
                tracksForSEO: results.map(function (_ref6) {
                    var title = _ref6.title;
                    return { title: title };
                })
            });
        };
        var artist = props.artist;

        _this.artistImage = image_1.getResponsiveAssets('cover', artist.assets || defaultList);
        _this.coverImage = image_1.getResponsiveAssets('thumb', artist.assets || defaultList);
        _this.artistHasSocialPresence = !!artist.facebook || !!artist.twitter || !!artist.spotify || !!artist.itunes || !!artist.instagram || !!artist.soundcloud || !!artist.bandcamp;
        var imageRatio = _this.artistImage.xlarge[0].metadata.width / _this.artistImage.xlarge[0].metadata.height;
        _this.headerLayout = imageRatio <= 1.05 ? 'vertical' : 'horizontal';
        _this.onScrollThrottled = raf_throttle_1.default(_this.onScroll);
        _this.state = {
            featuredCollections: defaultList,
            terms: defaultList,
            tracksForSEO: []
        };
        return _this;
    }

    _createClass(ArtistPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var el = react_dom_1.findDOMNode(this);
            this.artistHeroImage = el.getElementsByClassName('artist__artist-picture')[0];
            this.header = el.getElementsByClassName('artist__header')[0];
            this.scrollArea = el.getElementsByClassName('page__main')[0];
            // tslint:disable-next-line:no-string-literal
            // if (!window['safari']) {
            window.addEventListener('scroll', this.onScrollThrottled);
            // }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.onScrollThrottled);
            this.onScrollThrottled = undefined;
        }
    }, {
        key: "renderHeader",
        value: function renderHeader() {
            var artist = this.props.artist;

            var titleSize = this.headerLayout === 'horizontal' ? 'h4' : 'h2';
            return React.createElement("div", Object.assign({}, classes('header')), React.createElement("div", Object.assign({}, classes('header__content-wrapper')), React.createElement("div", Object.assign({}, classes('details')), this.headerLayout === 'horizontal' && React.createElement(Thumbnail_1.default, Object.assign({ responsiveAssets: this.coverImage }, classes('cover-image'), { size: "xsmall" })), React.createElement("div", Object.assign({}, classes('info')), React.createElement(Heading_1.default, Object.assign({ is: titleSize }, classes('info__title')), artist.name), this.headerLayout === 'horizontal' ? React.createElement(Label_1.Span, Object.assign({ text: artist.homebase || '', size: "xsmall" }, classes('info__subtitle'))) : React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('info__subtitle')), artist.homebase || ''))), React.createElement("div", Object.assign({}, classes('header__actions')))));
        }
    }, {
        key: "renderPicture",
        value: function renderPicture() {
            return React.createElement("div", Object.assign({}, classes('artist-picture')), React.createElement(Picture_1.default, Object.assign({ onLoad: this.onLoadArtistImage, assets: this.artistImage }, classes('artist-picture__inner'))));
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var artist = this.props.artist;

            return React.createElement(Page_1.default, { id: "artist", layout: "loose" }, React.createElement(helmet_1.default, { artist: artist, tracks: this.state.tracksForSEO }), React.createElement("div", Object.assign({}, classes('layout-wrapper'), { "data-header-layout": this.headerLayout }), React.createElement("section", { className: "page__main" }, React.createElement("div", Object.assign({}, classes('header__margin'))), this.renderPicture(), this.renderHeader(), React.createElement("div", Object.assign({}, classes('content')), React.createElement("div", Object.assign({}, classes('content__wrapper')), React.createElement("div", Object.assign({}, classes('content__column', 'bio')), React.createElement(Heading_1.default, { is: "h3" }, "About"), !!artist.bio && React.createElement("p", Object.assign({}, classes('about'), { dangerouslySetInnerHTML: string_1.toInnerHTML(artist.bio) })), !!this.state.terms.length && React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, classes('tags-group')), this.state.terms.map(function (_ref7) {
                var count = _ref7.count,
                    name = _ref7.name;
                return React.createElement(Tag_1.default, { key: name, id: name, label: name, cardinality: count, onClick: function onClick() {
                        return _this2.props.addSearchFilter({ name: name });
                    } });
            })))), React.createElement("div", Object.assign({}, classes('content__column', 'tracks')), React.createElement(TrackList_1.TrackListQuery, Object.assign({ actionSource: "artist_page", cardProps: {
                    backgroundColor: 'bw2',
                    size: 'small'
                }, onResult: this.onTrackListResult, searchQuery: {
                    count: 1000,
                    filters: {
                        artist_slug: artist.slug
                    }
                }, title: "Tracks" }, classes('track-listing')))), this.artistHasSocialPresence && React.createElement("div", Object.assign({}, classes('content__column', 'social')), React.createElement("div", Object.assign({}, classes('social-links')), React.createElement(Heading_1.default, { is: "h3" }, "Connect"), !!artist.facebook && React.createElement(LinkButton_1.default, { external: true, to: artist.facebook, label: "Facebook", icon: React.createElement(Icon_1.IconFacebook, null) }), !!artist.twitter && React.createElement(LinkButton_1.default, { external: true, to: artist.twitter, label: "Twitter", icon: React.createElement(Icon_1.IconTwitter, null) }), !!artist.spotify && React.createElement(LinkButton_1.default, { external: true, to: artist.spotify, label: "Spotify", icon: React.createElement(Icon_1.IconSpotify, null) }), !!artist.itunes && React.createElement(LinkButton_1.default, { external: true, to: artist.itunes, label: "Apple Music", icon: React.createElement(Icon_1.IconApple, null) }), !!artist.instagram && React.createElement(LinkButton_1.default, { external: true, to: artist.instagram, label: "Instagram", icon: React.createElement(Icon_1.IconInstagram, null) }), !!artist.soundcloud && React.createElement(LinkButton_1.default, { external: true, to: artist.soundcloud, label: "SoundCloud", icon: React.createElement(Icon_1.IconSoundCloud, null) }), !!artist.bandcamp && React.createElement(LinkButton_1.default, { external: true, to: artist.bandcamp, label: "Bandcamp", icon: React.createElement(Icon_1.IconBandCamp, null) })))), !!this.state.featuredCollections.length && React.createElement("div", Object.assign({}, classes('content__wrapper')), React.createElement("div", Object.assign({}, classes('content__column', 'collections')), React.createElement(Heading_1.default, { is: "h3" }, "Featured in Collections"), React.createElement(Collections_1.default, { data: this.state.featuredCollections, gridView: true, hideTitle: true })))))));
        }
    }]);

    return ArtistPage;
}(React.Component);

var ArtistPageWithLicenseBar = withLicenseBar_1.default(ArtistPage);
// tslint:disable-next-line:max-line-length
var ConnectedArtistPage = react_redux_1.connect(function (state) {
    var _state$player = state.player,
        currentTrack = _state$player.currentTrack,
        isTrackPlaying = _state$player.isTrackPlaying;

    var currentTrackPlaying = '';
    if (isTrackPlaying && currentTrack) {
        currentTrackPlaying = currentTrack.trackId;
    }
    return {
        currentTrackPlaying: currentTrackPlaying
    };
}, function (dispatch) {
    return {
        pausePlayer: function pausePlayer() {
            dispatch(playerActions.pause());
        },
        playTrackVersion: function playTrackVersion(trackId) {
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        },
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.addTracksToQueue({ tracks: tracks }));
        }
    };
})(ArtistPageWithLicenseBar);
var RelayArtistPage = react_relay_1.createFragmentContainer(ConnectedArtistPage, artist_1.ArtistFragment);
var ArtistPageWithQueryStringContext = function ArtistPageWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref8) {
        var addSearchFilter = _ref8.addSearchFilter;
        return React.createElement(RelayArtistPage, Object.assign({ addSearchFilter: addSearchFilter }, props));
    });
};
exports.default = ArtistPageWithQueryStringContext;

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Cart-related Redux Actions
 */
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Cart');
exports.requestSetCartFromLocalStorage = actionCreator('REQUEST_SET_CART_FROM_LOCAL_STORAGE');
exports.requestAddItemToCart = actionCreator('REQUEST_ADD_ITEM_TO_CART');
exports.requestRemoveItemFromCart = actionCreator('REQUEST_REMOVE_ITEM_FROM_CART');
exports.requestUpdateCartItemTerms = actionCreator('REQUEST_UPDATE_CART_ITEM_TERMS');
// Async Actions
exports.setCartFromLocalStorage = actionCreator.async('SET_CART_FROM_LOCAL_STORAGE');
exports.addItemToCart = actionCreator.async('ADD_ITEM_TO_CART');
exports.removeItemFromCart = actionCreator.async('REMOVE_ITEM_FROM_CART');
exports.updateCartItemTerms = actionCreator.async('UPDATE_CART_ITEM_TERMS');

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Select Component
 */
/* tslint:disable:no-submodule-imports */
var color_schemes_1 = __webpack_require__(143);
var colors_1 = __webpack_require__(57);
__webpack_require__(1138);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_select_1 = __webpack_require__(1140);
var redux_form_1 = __webpack_require__(37);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var SelectInput_1 = __webpack_require__(1142);
var classes = new BEM('select');

var SelectReduxForm = function (_React$Component) {
    _inherits(SelectReduxForm, _React$Component);

    function SelectReduxForm(props) {
        _classCallCheck(this, SelectReduxForm);

        var _this = _possibleConstructorReturn(this, (SelectReduxForm.__proto__ || Object.getPrototypeOf(SelectReduxForm)).call(this, props));

        _this.onSetInitialValue = function (value) {
            _this.initialValue = value;
        };
        _this.onChange = function (item) {
            var shouldUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props = _this.props,
                changeFieldValue = _this$props.changeFieldValue,
                onUpdate = _this$props.onUpdate;

            var input = _this.input.getRenderedComponent();
            var name = input.props.input.name;
            _this.setState({ selectValue: item || undefined });
            changeFieldValue(name, item ? item.value : '');
            if (onUpdate && shouldUpdate) {
                onUpdate(item);
            }
        };
        _this.onError = function (error) {
            _this.setState({ error: error });
        };
        _this.renderSelectArrow = function (props) {
            var iconProps = props.isOpen ? {
                style: {
                    top: 2,
                    transform: 'scaleY(-1)'
                },
                className: colors_1.getTextColorClassName(colors_1.bw6)
            } : _this.props.disabled ? {
                style: { display: 'none' }
            } : {};
            return React.createElement(Icon_1.IconArrowDown, Object.assign({}, iconProps));
        };
        _this.state = {};
        return _this;
    }

    _createClass(SelectReduxForm, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.initialValue && this.props.options.length) {
                var item = lodash_1.find(this.props.options, { value: this.initialValue }) || null;
                this.onChange(item, this.props.updateOnMount);
                this.initialValue = null;
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.options.length && !lodash_1.isEqual(nextProps.options, this.props.options)) {
                this.onChange(null);
            } else if (nextProps.options.length && !this.props.options.length) {
                if (this.initialValue) {
                    var item = lodash_1.find(nextProps.options, { value: this.initialValue }) || null;
                    this.onChange(item);
                    this.initialValue = null;
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                colorScheme = _props.colorScheme,
                disabled = _props.disabled,
                label = _props.label,
                name = _props.name,
                note = _props.note,
                optional = _props.optional,
                options = _props.options,
                selectName = _props.selectName,
                selectProps = _props.selectProps,
                size = _props.size;
            var _state = this.state,
                error = _state.error,
                selectValue = _state.selectValue;

            var modifiers = _defineProperty({
                'is-disabled': !!disabled,
                'error': !!error
            }, size, true);
            var extraClasses = classNames(colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme, 'select'), className);
            var renderers = {
                arrowRenderer: this.renderSelectArrow,
                clearRenderer: function clearRenderer() {
                    return React.createElement(Icon_1.IconX, null);
                }
            };
            var noteLabel = null;
            if (note || optional != null) {
                var noteProps = Object.assign({ size: 'small', variant: 'note' }, classes('note'));
                noteLabel = React.createElement(Label_1.default, Object.assign({}, noteProps), note || 'Optional');
            }
            var labelClasses = new BEM('label');
            return React.createElement("div", Object.assign({}, classes('', modifiers, extraClasses)), label && React.createElement(Label_1.default, Object.assign({ text: label, size: "small", htmlFor: selectName }, classes('label'))), noteLabel, React.createElement(redux_form_1.Field, { ref: function ref(node) {
                    return _this2.input = node;
                }, component: SelectInput_1.default, name: name, props: {
                    setInitialValue: this.onSetInitialValue,
                    onError: this.onError
                }, withRef: true }), React.createElement(react_select_1.default, Object.assign({ disabled: disabled, name: selectName, options: options, onChange: this.onChange, value: selectValue }, renderers, selectProps)), error && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'error'), { size: "medium", textColor: "dangerous" }), error));
        }
    }]);

    return SelectReduxForm;
}(React.Component);

SelectReduxForm.defaultProps = {
    colorScheme: 'light',
    size: 'medium'
};
var ConnectedSelectReduxForm = react_redux_1.connect(null, function (dispatch, _ref) {
    var form = _ref.form;
    return {
        changeFieldValue: function changeFieldValue(field, value) {
            return dispatch(redux_form_1.autofill(form, field, value));
        }
    };
})(SelectReduxForm);
exports.default = ConnectedSelectReduxForm;

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(105);
exports.budgetFilterMaximum = 1000000;
exports.BudgetFilter = {
    serialize: function serialize(budget) {
        if (budget) {
            if (budget.minimum) {
                if (budget.maximum) {
                    return budget.minimum + "-" + budget.maximum;
                } else {
                    return ">" + budget.minimum;
                }
            } else if (budget.maximum) {
                return "<" + budget.maximum;
            }
        }
        return '';
    },
    unserialize: function unserialize(query) {
        if (types_1.QueryStringParam.Budget in query) {
            var budget = query[types_1.QueryStringParam.Budget];
            var parts = budget.match(/^([<,>]?)(\d*)-?(\d*)$/);
            if (parts != null) {
                var _parts = _slicedToArray(parts, 4),
                    symbol = _parts[1],
                    first = _parts[2],
                    second = _parts[3];

                var firstNumber = parseInt(first, 10);
                var secondNumber = parseInt(second, 10);
                switch (symbol) {
                    case '<':
                        return {
                            minimum: 0,
                            maximum: firstNumber
                        };
                    case '>':
                        return {
                            minimum: firstNumber,
                            maximum: exports.budgetFilterMaximum
                        };
                    default:
                        return {
                            minimum: firstNumber,
                            maximum: secondNumber || firstNumber
                        };
                }
            }
        }
        return;
    }
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ConnectedLicenseBuilderComponent Container
 */

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(276);
var react_redux_1 = __webpack_require__(5);
function mapStateToProps() {
    return function (_ref) {
        var _ref$license = _ref.license,
            editingUsageIndex = _ref$license.editingUsageIndex,
            usages = _ref$license.usages;
        return {
            editingUsageIndex: editingUsageIndex,
            medium: editingUsageIndex != null ? usages[editingUsageIndex].medium.id : null,
            usages: usages
        };
    };
}
function mapDispatchToPropsFactory(componentId) {
    return function (dispatch) {
        return {
            setComponentForUsage: function setComponentForUsage(index, param) {
                dispatch(actions.setComponentForUsage({
                    component: componentId,
                    index: index,
                    value: param
                }));
            }
        };
    };
}
function mergePropsFactory(componentId, nextStep) {
    return function (_ref2, dispatchProps, ownProps) {
        var editingUsageIndex = _ref2.editingUsageIndex,
            medium = _ref2.medium,
            usages = _ref2.usages;

        var selectedParam = editingUsageIndex !== null ? usages[editingUsageIndex][componentId] : null;
        return Object.assign({}, ownProps, { editingUsageIndex: editingUsageIndex,
            medium: medium,
            selectedParam: selectedParam, setParam: function setParam(param) {
                dispatchProps.setComponentForUsage(editingUsageIndex, param);
            } });
    };
}
function ConnectedLicenseBuilderComponent(Component, componentId, nextStep) {
    return react_redux_1.connect(mapStateToProps, mapDispatchToPropsFactory(componentId), mergePropsFactory(componentId, nextStep))(Component);
}
exports.default = ConnectedLicenseBuilderComponent;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckboxWithLabel Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1263);
var Checkbox_1 = __webpack_require__(601);
var Label_1 = __webpack_require__(8);
var classes = new BEM('checkbox');

var CheckboxWithLabel = function (_React$Component) {
    _inherits(CheckboxWithLabel, _React$Component);

    function CheckboxWithLabel() {
        _classCallCheck(this, CheckboxWithLabel);

        return _possibleConstructorReturn(this, (CheckboxWithLabel.__proto__ || Object.getPrototypeOf(CheckboxWithLabel)).apply(this, arguments));
    }

    _createClass(CheckboxWithLabel, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                children = _a.children,
                label = _a.label,
                checkboxProps = __rest(_a, ["children", "label"]);
            var name = this.props.input ? this.props.input.name : this.props.name;
            return React.createElement(Checkbox_1.default, Object.assign({}, checkboxProps), React.createElement(Label_1.default, Object.assign({ text: label, htmlFor: name, size: "small" }, classes('label'))), children);
        }
    }]);

    return CheckboxWithLabel;
}(React.Component);

exports.default = CheckboxWithLabel;

/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Drawer Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1342);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_hot_keys_1 = __webpack_require__(401);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var classes = new BEM('drawer');

var Drawer = function (_React$Component) {
    _inherits(Drawer, _React$Component);

    function Drawer(props) {
        _classCallCheck(this, Drawer);

        var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

        _this.onClickDrawer = function (e) {
            e.stopPropagation();
        };
        _this.onClickClose = function () {
            _this.onRequestClose(true);
        };
        _this.onRequestClose = function (fromInside) {
            _this.setState({ willClose: true }, function () {
                if (_this.props.onRequestClose) {
                    _this.props.onRequestClose(fromInside);
                }
                setTimeout(function () {
                    if (_this.props.onClose) {
                        _this.props.onClose(fromInside);
                    }
                }, 300);
            });
        };
        _this.state = {
            willClose: false
        };
        return _this;
    }

    _createClass(Drawer, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.open && !this.props.open) {
                this.onRequestClose(false);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                actionButton = _props.actionButton,
                children = _props.children,
                className = _props.className,
                closeButtonLabel = _props.closeButtonLabel,
                floatingHeader = _props.floatingHeader,
                forwardedRef = _props.forwardedRef,
                headerIcon = _props.headerIcon,
                position = _props.position,
                showCloseButton = _props.showCloseButton;
            var willClose = this.state.willClose;

            var wrapperClassesModifiers = _defineProperty({}, position, true);
            var wrapperExtraClasses = classNames({ 'is-closing': willClose }, className);
            return React.createElement(react_hot_keys_1.default, { keyName: "esc", onKeyDown: this.onClickClose, className: "hotkeys" }, React.createElement("div", Object.assign({ ref: forwardedRef, onClick: this.onClickDrawer }, classes('', wrapperClassesModifiers, wrapperExtraClasses)), React.createElement("div", Object.assign({}, classes('background'))), React.createElement("div", Object.assign({}, classes('header', { floating: !!floatingHeader })), headerIcon, actionButton, showCloseButton && React.createElement(Button_1.default, Object.assign({}, classes('close-button'), { onClick: this.onClickClose, label: closeButtonLabel, icon: this.props.closeButtonIcon, variant: this.props.closeButtonIcon ? 'icon-no-padding' : 'text' }))), React.createElement("div", Object.assign({}, classes('content')), children)));
        }
    }]);

    return Drawer;
}(React.Component);

Drawer.defaultProps = {
    closeButtonLabel: 'Close',
    headerIcon: React.createElement(Icon_1.LogoBopper, null),
    position: 'left',
    showCloseButton: true
};
exports.default = React.forwardRef(function (props, ref) {
    return React.createElement(Drawer, Object.assign({}, props, { forwardedRef: ref }));
});

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DiscoverPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(42);
var player_2 = __webpack_require__(63);
var emptyState_1 = __webpack_require__(305);
__webpack_require__(1631);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var BlogPosts_1 = __webpack_require__(662);
var Charts_1 = __webpack_require__(663);
var Collections_1 = __webpack_require__(227);
var FeaturedArtists_1 = __webpack_require__(433);
var HeaderPosts_1 = __webpack_require__(664);
var NewsletterPromo_1 = __webpack_require__(665);
var SearchArea_1 = __webpack_require__(1646);
var StaffPicks_1 = __webpack_require__(435);
exports.DiscoverPagePath = '/browse';
var defaultList = [];

var DiscoverPage = function (_React$Component) {
    _inherits(DiscoverPage, _React$Component);

    function DiscoverPage() {
        _classCallCheck(this, DiscoverPage);

        return _possibleConstructorReturn(this, (DiscoverPage.__proto__ || Object.getPrototypeOf(DiscoverPage)).apply(this, arguments));
    }

    _createClass(DiscoverPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var data = this.props.viewer.home_page;
            var allTracks = lodash_1.concat.apply(lodash_1, [data.featured_artist_tracks || defaultList, data.featured_tracks || defaultList].concat(_toConsumableArray((data.track_charts || defaultList).map(function (_ref) {
                var items = _ref.items;
                return items || defaultList;
            }))));
            this.props.setPlayerQueue(player_2.getPlayerTracksFromResults(allTracks));
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.viewer.home_page;
            var headerPosts = data.header_posts || defaultList;
            var featuredTerms = data.featured_terms || defaultList;
            var staffPicks = data.featured_tracks || defaultList;
            var featuredArtists = data.featured_artist_tracks || defaultList;
            var featuredCollections = data.featured_collections || defaultList;
            var charts = data.track_charts || defaultList;
            var blogPosts = data.blog_posts || defaultList;
            return React.createElement(Page_1.default, { id: "discover", layout: "loose" }, React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, "Discover")), React.createElement("div", { className: "page__main" }, this.props.withCarousel && React.createElement(HeaderPosts_1.default, { data: headerPosts }), React.createElement(SearchArea_1.default, { data: featuredTerms }), React.createElement(StaffPicks_1.default, { tracks: staffPicks, withBackground: true }), React.createElement(FeaturedArtists_1.default, { data: featuredArtists }), React.createElement(BlogPosts_1.default, { data: blogPosts }), React.createElement(Collections_1.default, { data: featuredCollections }), React.createElement(NewsletterPromo_1.default, { isUserLoggedIn: this.props.isUserLoggedIn }), React.createElement(Charts_1.default, { data: charts })));
        }
    }]);

    return DiscoverPage;
}(React.Component);

var ConnectedDiscoverPage = react_redux_1.connect(function (_ref2) {
    var user = _ref2.user;
    return {
        isUserLoggedIn: user.isLoggedIn
    };
}, function (dispatch) {
    return {
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(player_1.replaceQueue({ tracks: tracks }));
        }
    };
})(DiscoverPage);
var RelayDiscoverPage = react_relay_1.createFragmentContainer(ConnectedDiscoverPage, emptyState_1.EmptyStateFragment);
exports.default = RelayDiscoverPage;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Countries-related Redux Actions
 */
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Countries');
// Request Async Actions
exports.requestFetchCountries = actionCreator('REQUEST_FETCH_COUNTRIES');
exports.requestFetchStatesForCountry = actionCreator('REQUEST_FETCH_STATES_FOR_COUNTRY');
// Async Actions
exports.fetchCountries = actionCreator.async('FETCH_COUNTRIES');
exports.fetchStatesForCountry = actionCreator.async('FETCH_STATES_FOR_COUNTRY');

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Redux form Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var redux_form_1 = __webpack_require__(37);
var config_1 = __webpack_require__(80);
exports.getForm = function (formName) {
    return function (state) {
        return redux_form_1.getFormValues(formName)(state);
    };
};
exports.getBillingAddress = function (state) {
    var licenseInformation = exports.getForm(config_1.CheckoutStepFormName.license)(state);
    var billingInformation = exports.getForm(config_1.CheckoutStepFormName.billing)(state);
    var address = lodash_1.get(licenseInformation, 'address');
    // tslint:disable-next-line:max-line-length
    var sameAddressAsLicensee = lodash_1.get(billingInformation, 'sameAddressAsLicensee', config_1.DefaultBillingAddressIsSameAsLicensee);
    return sameAddressAsLicensee ? address : lodash_1.get(billingInformation, 'address', address);
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CartPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(196);
var playerActions = __webpack_require__(42);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var license_1 = __webpack_require__(34);
var player_1 = __webpack_require__(63);
var cart_1 = __webpack_require__(422);
var cart_2 = __webpack_require__(637);
var lineItem_1 = __webpack_require__(636);
var animation_1 = __webpack_require__(173);
var track_1 = __webpack_require__(44);
var colors_1 = __webpack_require__(57);
__webpack_require__(1466);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
/* tslint:disable-next-line */
__webpack_require__(214);
var Page_1 = __webpack_require__(38);
var currency_1 = __webpack_require__(115);
var Button_1 = __webpack_require__(10);
var LicenseBuilderButton_1 = __webpack_require__(225);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PriceTag_1 = __webpack_require__(126);
var PageHeader_1 = __webpack_require__(144);
var Card_1 = __webpack_require__(293);
var Alert_1 = __webpack_require__(1564);
var Checkout_1 = __webpack_require__(290);
// Page Path
exports.CartPagePath = '/my/cart';
var CartItemAnimations = animation_1.ListItemAnimations(144, -200);
var classes = new BEM('cart');

var CartPage = function (_React$Component) {
    _inherits(CartPage, _React$Component);

    function CartPage(props) {
        _classCallCheck(this, CartPage);

        var _this = _possibleConstructorReturn(this, (CartPage.__proto__ || Object.getPrototypeOf(CartPage)).call(this, props));

        _this.onSaveItemLicense = function (lineItemId) {
            return function (usages) {
                _this.props.updateCartItemTerms(lineItemId, usages);
            };
        };
        _this.onRemoveItem = function (item) {
            return function () {
                _this.props.removeItemFromCart(item);
            };
        };
        _this.onRequestCheckout = function () {
            if (!_this.props.userIsLoggedIn) {
                _this.props.signUpAndCheckout();
            } else {
                _this.props.router.push(Checkout_1.CheckoutPagePath);
            }
        };
        _this.state = {
            hasCart: cart_2.hasValidCart(props.viewer)
        };
        return _this;
    }

    _createClass(CartPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.state.hasCart) {
                this.props.setPlayerQueue();
            }
        }
    }, {
        key: "renderLineItem",
        value: function renderLineItem(viewer, lineItem) {
            var track = lineItem.track;
            var trackOriginalVersionId = track.assets && track.assets.length ? track_1.getDefaultTrackAsset(track.assets).id : undefined;
            var thumbnail = track_1.getResponsiveTrackThumbnail(track);
            var usages = lineItem.license.usages.map(function (_ref) {
                var components = _ref.components;
                return license_1.generateLicenseUsageFromComponents(components);
            });
            var licenseString = license_1.getLicenseString(usages);
            var options = ['PriceElement', {
                option: 'EditLicense',
                element: React.createElement(LicenseBuilderButton_1.default, { scope: {
                        type: 'Track',
                        id: lineItem.id
                    }, usages: usages, onSaveLicense: this.onSaveItemLicense(lineItem.id), icon: React.createElement(Icon_1.IconEdit, null), stopPropagation: true })
            }, {
                option: 'Download'
            }, {
                option: 'RemoveFromCart',
                listener: this.onRemoveItem(lineItem)
            }];
            return React.createElement("li", Object.assign({ key: lineItem.id }, classes('line-item')), lineItem.amount === 0 && React.createElement("div", Object.assign({}, classes('line-item__red-dot'))), React.createElement(Card_1.default, Object.assign({ actionSource: "cart_page", backgroundColor: colors_1.white, trackId: trackOriginalVersionId, title: track.title, subtitle: track.artist.name, image: thumbnail, description: licenseString, options: options, PriceElement: React.createElement(PriceTag_1.default, { rate: viewer.selected_currency_rate, amount: lineItem.amount, size: "large" }), size: "medium", trackResult: track, alwaysDisplayOptions: true }, classes('card'))));
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var viewer = this.props.viewer;

            var areLineItemLicensesValid = lineItem_1.cartLicenseLineItemsAreValid(viewer);
            var lineItems = lineItem_1.getCartLineItems(viewer);
            var cartTotal = cart_2.getCartTotal(viewer);
            var classModifiers = {
                empty: !this.state.hasCart
            };
            return React.createElement(Page_1.default, Object.assign({ id: "cart", layout: "loose" }, classes('', classModifiers)), React.createElement(PageHeader_1.default, { title: "Your Cart", withCurrencySelect: true }), !!this.state.hasCart ? React.createElement(React.Fragment, null, React.createElement("div", Object.assign({ key: "cart-with-items" }, classes('content-wrapper')), React.createElement(Alert_1.default, { visible: !areLineItemLicensesValid, message: "You cannot proceed to checkout because some tracks don't have a valid license." }), React.createElement("div", Object.assign({}, classes('content')), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "ul", enter: { animation: CartItemAnimations.In, stagger: 150 }, leave: { animation: CartItemAnimations.Out } }, lineItems.map(function (item) {
                return _this2.renderLineItem(viewer, item);
            })))), React.createElement(velocity_react_1.VelocityComponent, { animation: { translateY: areLineItemLicensesValid ? 0 : '100%' } }, React.createElement("div", Object.assign({}, classes('footer')), React.createElement("div", Object.assign({}, classes('footer__content')), React.createElement("div", null, React.createElement(PriceTag_1.default, Object.assign({ label: "Total:", rate: viewer.selected_currency_rate, amount: cartTotal, size: "large" }, classes('footer__title-total'))), React.createElement(Label_1.Span, Object.assign({ size: "small" }, classes('footer__fine-prints')), "Promo code and taxes will be calculated at checkout."), React.createElement(Label_1.Span, Object.assign({ size: "small" }, classes('footer__fine-prints')), "We accept credit cards and 30 days check payments.")), React.createElement("div", Object.assign({}, classes('footer__content__right')), React.createElement(Button_1.default, Object.assign({ onClick: this.onRequestCheckout, icon: React.createElement(Icon_1.IconArrowRight, null), iconPosition: "right", label: "Proceed to checkout", size: "xlarge", colorScheme: "accent", variant: "pill", disabled: !areLineItemLicensesValid, withShadow: true }, classes('button-checkout')))))))) : React.createElement(velocity_react_1.VelocityComponent, { animation: "transition.slideUpIn", runOnMount: true }, React.createElement("div", Object.assign({ key: "empty-cart" }, classes('content-wrapper')), React.createElement("div", Object.assign({}, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h1", textColor: colors_1.bw6 }, classes('title-empty')), "Your cart is empty.")))));
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            var nextHasCart = cart_2.hasValidCart(nextProps.viewer);
            return prevState.hasCart !== nextHasCart ? { hasCart: nextHasCart } : null;
        }
    }]);

    return CartPage;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedCartPage = react_redux_1.connect(function (_ref2) {
    var license = _ref2.license,
        user = _ref2.user;
    return {
        license: license,
        userIsLoggedIn: user.isLoggedIn
    };
}, function (dispatch, ownProps) {
    return {
        removeItemFromCart: function removeItemFromCart(lineItem) {
            return new Promise(function (resolve, reject) {
                dispatch(actions.requestRemoveItemFromCart({
                    lineItem: lineItem,
                    currencyCode: ownProps.currency,
                    promise: { resolve: resolve, reject: reject }
                }));
            });
        },
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.replaceQueue({ tracks: tracks }));
        },
        signUpAndCheckout: function signUpAndCheckout() {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: Checkout_1.CheckoutPagePath }));
            dispatch(ui_1.showSignUpForm({ reason: 'checkout' }));
        },
        updateCartItemTerms: function updateCartItemTerms(lineItemId, terms) {
            return new Promise(function (resolve, reject) {
                dispatch(actions.requestUpdateCartItemTerms({
                    lineItemId: lineItemId,
                    promise: { resolve: resolve, reject: reject },
                    terms: terms
                }));
            });
        }
    };
}, function (stateProps, dispatchProps, _a) {
    var currency = _a.currency,
        ownProps = __rest(_a, ["currency"]);
    return Object.assign({}, ownProps, stateProps, dispatchProps, { setPlayerQueue: function setPlayerQueue() {
            dispatchProps.setPlayerQueue(player_1.getPlayerTracksFromResults(track_1.getTrackResultsFromLineItems(ownProps.viewer.cart.license_line_items)));
        } });
})(CartPage);
var CartPageWithContext = function CartPageWithContext(props) {
    return React.createElement(currency_1.CurrencyContext.Consumer, null, function (_ref3) {
        var currency = _ref3.currency;
        return React.createElement(ConnectedCartPage, Object.assign({ currency: currency }, props));
    });
};
var RelayCartPage = react_relay_1.createFragmentContainer(CartPageWithContext, cart_1.cartFragment);
exports.default = RelayCartPage;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseBuilderButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1468);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var portal_1 = __webpack_require__(1470);
var LicensePresetsMenu_1 = __webpack_require__(1471);
var Button_1 = __webpack_require__(10);
var classes = new BEM('license-builder-button');

var LicenseBuilderButton = function (_React$Component) {
    _inherits(LicenseBuilderButton, _React$Component);

    function LicenseBuilderButton() {
        _classCallCheck(this, LicenseBuilderButton);

        var _this = _possibleConstructorReturn(this, (LicenseBuilderButton.__proto__ || Object.getPrototypeOf(LicenseBuilderButton)).apply(this, arguments));

        _this.isComponentMounted = false;
        _this.state = {
            licenseBuilderIsActive: false,
            showLicenseBuilder: false
        };
        _this.onClick = function (e) {
            if (_this.props.stopPropagation) {
                e.stopPropagation();
            }
            if (!!_this.props.onClick) {
                e.persist();
                _this.props.onClick(e);
            }
            _this.setState({ licenseBuilderIsActive: true });
            if (_this.props.onOpenLicenseBuilder) {
                _this.props.onOpenLicenseBuilder();
            }
        };
        _this.onCloseLicenseBuilder = function () {
            if (_this.isComponentMounted) {
                _this.setState({ licenseBuilderIsActive: false, showLicenseBuilder: false });
                if (_this.props.onCloseLicenseBuilder) {
                    _this.props.onCloseLicenseBuilder();
                }
            }
        };
        _this.onSelectPreset = function (usage) {
            _this.props.onSaveLicense([usage]);
        };
        _this.openLicenseBuilder = function () {
            _this.setState({
                showLicenseBuilder: true
            });
        };
        return _this;
    }

    _createClass(LicenseBuilderButton, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.isComponentMounted = true;
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.isComponentMounted = false;
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                className = _a.className,
                unusedOnClick = _a.onClick,
                onSaveLicense = _a.onSaveLicense,
                scope = _a.scope,
                selectedUsage = _a.selectedUsage,
                stopPropagation = _a.stopPropagation,
                usages = _a.usages,
                onOpenLicenseBuilder = _a.onOpenLicenseBuilder,
                onCloseLicenseBuilder = _a.onCloseLicenseBuilder,
                buttonProps = __rest(_a, ["className", "onClick", "onSaveLicense", "scope", "selectedUsage", "stopPropagation", "usages", "onOpenLicenseBuilder", "onCloseLicenseBuilder"]);
            var hasLicense = !!usages && usages.length > 0;
            return React.createElement(React.Fragment, null, React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, title: "Build your license to display prices." }, classes('', '', className), buttonProps)), this.state.licenseBuilderIsActive && !hasLicense && !this.state.showLicenseBuilder && React.createElement(LicensePresetsMenu_1.LicensePresetsMenuPortal, { onClose: this.onCloseLicenseBuilder, onSelectPreset: this.onSelectPreset, onOpenLicenseBuilder: this.openLicenseBuilder }), this.state.licenseBuilderIsActive && (hasLicense || this.state.showLicenseBuilder) && React.createElement(portal_1.LicenseBuilderPortal, { scope: scope, selectedUsage: selectedUsage, usages: usages, onSaveLicense: onSaveLicense, onClose: this.onCloseLicenseBuilder }));
        }
    }]);

    return LicenseBuilderButton;
}(React.Component);

exports.default = LicenseBuilderButton;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(93);
var lodash_1 = __webpack_require__(6);
var react_relay_1 = __webpack_require__(13);
var defaultList = [];
function extractNodeFromConnection(connection) {
    return connection.edges ? connection.edges.map(function (_ref) {
        var node = _ref.node;
        return node;
    }) : defaultList;
}
exports.extractNodeFromConnection = extractNodeFromConnection;
function processAddMutation(mutation, input, config) {
    var baseConfig = {
        type: 'RANGE_ADD'
    };
    return processMutation(mutation, input, [lodash_1.extend(baseConfig, config)]);
}
exports.processAddMutation = processAddMutation;
function processDeleteMutation(mutation, input, config) {
    var baseConfig = {
        type: 'RANGE_DELETE',
        deletedIDFieldName: 'deleted_id'
    };
    return processMutation(mutation, input, [lodash_1.extend(baseConfig, config)]);
}
exports.processDeleteMutation = processDeleteMutation;
function processMutation(mutation, input, configs, updater) {
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: mutation,
            variables: { input: input },
            configs: configs,
            updater: updater,
            onCompleted: function onCompleted(response, errors) {
                return resolve({ response: response, errors: errors });
            },
            onError: reject
        });
    });
}
exports.processMutation = processMutation;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CollectionsSection
 */

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
__webpack_require__(1507);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var CollectionCard_1 = __webpack_require__(645);
var ScrollableSection_1 = __webpack_require__(429);
var SectionTitle_1 = __webpack_require__(230);
var CollectionsSection = ScrollableSection_1.default;
var classes = new BEM('collection-list');
function Collections(props) {
    return !!props.data.length ? props.gridView ? React.createElement("div", Object.assign({}, classes('', 'grid-view')), React.createElement("div", Object.assign({}, classes('content-wrapper', '', 'container')), !props.hideTitle && React.createElement(SectionTitle_1.default, Object.assign({ title: "Collections", subtitle: "Popular" }, classes('title'))), React.createElement("ul", Object.assign({}, classes('list')), props.data.map(function (item) {
        return item ? React.createElement("li", Object.assign({}, classes('list__item'), { key: "collection-" + item.slug }), React.createElement(CollectionCard_1.default, { image: image_1.getResponsiveAssets('cover', item.assets), subtitle: item.category ? item.category.name : 'Collection', title: item.name, slug: item.slug, size: "vertical" })) : null;
    })))) : React.createElement(CollectionsSection, Object.assign({ className: "collection-list", id: "collections", title: "Collections", subtitle: "Popular" }, props), function (item, index) {
        return item ? React.createElement(CollectionCard_1.default, { image: image_1.getResponsiveAssets('cover', item.assets), subtitle: item.category ? item.category.name : 'Collection', title: item.name, slug: item.slug, size: "vertical" }) : null;
    }) : null;
}
exports.default = Collections;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NProgress Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1518);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var nprogress = __webpack_require__(1520);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var classes = new BEM('nprogress-wrapper');

var NProgress = function (_React$Component) {
    _inherits(NProgress, _React$Component);

    function NProgress(props) {
        _classCallCheck(this, NProgress);

        var _this = _possibleConstructorReturn(this, (NProgress.__proto__ || Object.getPrototypeOf(NProgress)).call(this, props));

        _this.didMount = false;
        return _this;
    }

    _createClass(NProgress, [{
        key: "configure",
        value: function configure() {
            nprogress.configure({
                minimum: lodash_1.random(.3, .6),
                parent: '.nprogress-wrapper',
                showSpinner: false,
                trickleSpeed: 100
            });
        }
    }, {
        key: "start",
        value: function start() {
            this.configure();
            nprogress.start();
        }
    }, {
        key: "done",
        value: function done() {
            nprogress.done();
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.didMount = true;
            if (this.props.active) {
                this.start();
            }
        }
        // componentWillReceiveProps(nextProps: IOwnProps) {
        //   if (nextProps.active && !this.props.active) {
        //     nextTick(() => {
        //       if (this.didMount) {
        //         this.configure();
        //         nprogress.start();
        //       }
        //     });
        //   } else if (!nextProps.active && this.props.active) {
        //     nextTick(() => {
        //       if (this.didMount) {
        //         nprogress.done();
        //       }
        //     });
        //   }
        // }

    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (!prevProps.active && this.props.active) {
                nextTick(function () {
                    if (_this2.didMount) {
                        _this2.start();
                    }
                });
            } else if (prevProps.active && !this.props.active) {
                nextTick(function () {
                    if (_this2.didMount) {
                        _this2.done();
                    }
                });
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.didMount = false;
            nprogress.remove();
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes('', '', this.props.className), { style: this.props.style }));
        }
    }]);

    return NProgress;
}(React.Component);

exports.default = NProgress;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(42);
var player_2 = __webpack_require__(63);
var relay_1 = __webpack_require__(93);
var trackSearch_1 = __webpack_require__(301);
__webpack_require__(1539);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var lodash_1 = __webpack_require__(6);
var queryString_1 = __webpack_require__(30);
var LoadingSpinner_1 = __webpack_require__(163);
var Heading_1 = __webpack_require__(9);
var SignUpCtaCard_1 = __webpack_require__(1541);
var TrackListItem_1 = __webpack_require__(428);
var classes = new BEM('track-list');
function getTrackResultsFromEdges(viewer) {
    if (viewer.trackSearch && viewer.trackSearch.edges) {
        return viewer.trackSearch.edges.map(function (_ref) {
            var node = _ref.node;
            return node;
        });
    }
    return [];
}
var TrackListHeader = function TrackListHeader(_ref2) {
    var isLoading = _ref2.isLoading,
        title = _ref2.title;

    return typeof title === 'string' ? React.createElement(Heading_1.default, Object.assign({ is: "h3", textColor: isLoading ? 'bw6' : undefined }, classes('title')), title) : title;
};

var TrackListInternal = function (_React$Component) {
    _inherits(TrackListInternal, _React$Component);

    function TrackListInternal() {
        _classCallCheck(this, TrackListInternal);

        return _possibleConstructorReturn(this, (TrackListInternal.__proto__ || Object.getPrototypeOf(TrackListInternal)).apply(this, arguments));
    }

    _createClass(TrackListInternal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _props = this.props,
                addTracksToPlayer = _props.addTracksToPlayer,
                onResult = _props.onResult,
                shouldAddTracksToQueue = _props.shouldAddTracksToQueue;

            if (shouldAddTracksToQueue || shouldAddTracksToQueue === undefined) {
                addTracksToPlayer();
            }
            if (onResult) {
                onResult(this.getResultset());
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                actionSource = _props2.actionSource,
                cardProps = _props2.cardProps,
                className = _props2.className,
                displayPriceElement = _props2.displayPriceElement,
                showAllButton = _props2.showAllButton,
                showSignUpCta = _props2.showSignUpCta,
                title = _props2.title,
                viewer = _props2.viewer;

            var results = this.getResultset();
            return results && results.length ? React.createElement("div", Object.assign({}, classes('', '', className)), title && React.createElement(TrackListHeader, { title: title }), React.createElement("ul", null, results.reduce(function (list, track, i) {
                list.push(React.createElement(TrackListItem_1.default, { actionSource: actionSource, key: track.id, track: track, cardProps: cardProps, displayPriceElement: displayPriceElement }));
                if (showSignUpCta && !_this2.props.isUserLoggedIn && (i === 1 || results.length <= 1)) {
                    list.push(React.createElement("li", Object.assign({}, classes('item', '', 'sign-up-card'), { key: "sign-up-card" }), React.createElement(SignUpCtaCard_1.SignUpCtaCard, { viewer: viewer })));
                }
                return list;
            }, [])), viewer && results.length < viewer.trackSearch.total && showAllButton) : null;
        }
    }, {
        key: "getResultset",
        value: function getResultset() {
            var _props3 = this.props,
                excludeSearchResults = _props3.excludeSearchResults,
                tracks = _props3.tracks,
                viewer = _props3.viewer;

            var results = !!viewer && !!viewer.trackSearch ? viewer.trackSearch.edges.map(function (_ref3) {
                var node = _ref3.node;
                return node;
            }) : tracks || [];
            if (excludeSearchResults && excludeSearchResults.length) {
                lodash_1.pullAllWith(results, excludeSearchResults, function (a, id) {
                    return a.id === id;
                });
            }
            return results;
        }
    }]);

    return TrackListInternal;
}(React.Component);

TrackListInternal.defaultProps = {
    showListenedStatus: true
};
var ConnectedTrackList = react_redux_1.connect(function (_ref4, props) {
    var user = _ref4.user;
    return Object.assign({}, props, { isUserLoggedIn: user.isLoggedIn });
}, function (dispatch, _ref5) {
    var tracks = _ref5.tracks,
        viewer = _ref5.viewer;
    return {
        addTracksToPlayer: function addTracksToPlayer() {
            var dataset = viewer ? getTrackResultsFromEdges(viewer) : tracks || [];
            var playerTracks = player_2.getPlayerTracksFromResults(dataset);
            dispatch(player_1.addTracksToQueue({ tracks: playerTracks }));
        }
    };
})(TrackListInternal);
exports.default = ConnectedTrackList;
var TrackListRelay = react_relay_1.createFragmentContainer(ConnectedTrackList, trackSearch_1.trackSearchFragment);

var TrackListQuery = function (_React$Component2) {
    _inherits(TrackListQuery, _React$Component2);

    function TrackListQuery() {
        _classCallCheck(this, TrackListQuery);

        var _this3 = _possibleConstructorReturn(this, (TrackListQuery.__proto__ || Object.getPrototypeOf(TrackListQuery)).apply(this, arguments));

        _this3.isComponentMounted = false;
        return _this3;
    }

    _createClass(TrackListQuery, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.isComponentMounted = true;
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
            return this.isComponentMounted;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.isComponentMounted = true;
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.isComponentMounted = false;
        }
    }, {
        key: "getQueryRenderer",
        value: function getQueryRenderer(licenseParams) {
            var _a = this.props,
                searchQuery = _a.searchQuery,
                componentProps = __rest(_a, ["searchQuery"]);
            return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: trackSearch_1.trackSearchQuery, variables: Object.assign({ license_params: licenseParams }, searchQuery), render: function render(_ref6) {
                    var error = _ref6.error,
                        props = _ref6.props;

                    if (error) {
                        return React.createElement("div", null, error.message);
                    } else if (props) {
                        return React.createElement(TrackListRelay, Object.assign({}, props, componentProps));
                    }
                    return React.createElement("div", Object.assign({}, classes('', 'loading', componentProps.className)), componentProps.title && React.createElement(TrackListHeader, { isLoading: true, title: componentProps.title }), React.createElement(LoadingSpinner_1.default, Object.assign({ size: "small" }, classes('loading-spinner'))));
                } });
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            return this.props.searchQuery.license_params ? this.getQueryRenderer() : React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref7) {
                var license_params = _ref7.license_params;
                return _this4.getQueryRenderer(license_params);
            });
        }
    }]);

    return TrackListQuery;
}(React.Component);

exports.TrackListQuery = TrackListQuery;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SectionTitle Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1551);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Heading_1 = __webpack_require__(9);
var classes = new BEM('section-title');
var SectionTitle = function SectionTitle(_ref) {
    var className = _ref.className,
        subtitle = _ref.subtitle,
        textColor = _ref.textColor,
        title = _ref.title;

    return React.createElement("div", Object.assign({}, classes('', '', className)), subtitle && React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('subtitle'), { textColor: textColor || 'bw6', noMargin: true }), subtitle), React.createElement(Heading_1.default, Object.assign({ is: "h2", WrappedComponent: "h2" }, classes('title'), { textColor: textColor || 'bw6', noMargin: true }), title));
};
exports.default = SectionTitle;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var license_1 = __webpack_require__(34);
var player_1 = __webpack_require__(63);
var taxonomy_1 = __webpack_require__(106);
var track_1 = __webpack_require__(650);
var date_1 = __webpack_require__(119);
var image_1 = __webpack_require__(64);
var string_1 = __webpack_require__(47);
var track_2 = __webpack_require__(44);
var colors_1 = __webpack_require__(57);
__webpack_require__(1557);
var lodash_1 = __webpack_require__(6);
var raf_throttle_1 = __webpack_require__(299);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var withLicenseBar_1 = __webpack_require__(392);
var queryString_1 = __webpack_require__(30);
var AddToCartButton_1 = __webpack_require__(289);
var AddToProjectButton_1 = __webpack_require__(423);
var Button_1 = __webpack_require__(10);
var CardPlayButton_1 = __webpack_require__(425);
var DownloadButton_1 = __webpack_require__(296);
var SessionLicenseBuilderButton_1 = __webpack_require__(300);
var LinkButtonWithLicense_1 = __webpack_require__(651);
var Icon_1 = __webpack_require__(12);
var Picture_1 = __webpack_require__(426);
var Thumbnail_1 = __webpack_require__(66);
var WaveformPlaceholder_1 = __webpack_require__(1561);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PriceTag_1 = __webpack_require__(126);
var DropdownMenu_1 = __webpack_require__(297);
var ThumbnailWithPlayButton_1 = __webpack_require__(298);
var Tag_1 = __webpack_require__(127);
var Collections_1 = __webpack_require__(227);
var TrackList_1 = __webpack_require__(229);
var Artist_1 = __webpack_require__(186);
var helmet_1 = __webpack_require__(1562);
// Page Path
exports.TrackPagePath = function (slug) {
    return "/track/" + slug;
};
var classes = new BEM('track');
var defaultList = [];

var TrackPage = function (_React$Component) {
    _inherits(TrackPage, _React$Component);

    function TrackPage(props) {
        _classCallCheck(this, TrackPage);

        var _this = _possibleConstructorReturn(this, (TrackPage.__proto__ || Object.getPrototypeOf(TrackPage)).call(this, props));

        _this.onClickVersion = function (id) {
            return function () {
                _this.setState({ selectedVersion: id });
            };
        };
        _this.onSetTempoFilter = function (value) {
            _this.props.addTempoFilter({
                minimum: value,
                maximum: value
            });
        };
        _this.onToggleDropdownMenu = function (downloadMenuOpen) {
            _this.setState({ downloadMenuOpen: downloadMenuOpen });
        };
        _this.onScroll = function () {
            _this.heroBackground.style.transform = "translate3d(0, -" + window.scrollY * .1 + "px, 0)";
            _this.hero.style.transform = "translate3d(0, -" + window.scrollY * .2 + "px, 0)";
        };
        var track = props.track;

        _this.artistImage = image_1.getResponsiveAssets('cover', track.artist.assets || defaultList);
        _this.coverImage = track_2.getResponsiveTrackThumbnail(track);
        _this.terms = track.terms.edges.map(function (_ref) {
            var node = _ref.node;
            return node;
        });
        if (track.assets) {
            var defaultTrack = track_2.getDefaultTrackAsset(track.assets);
            _this.originalVersionId = defaultTrack ? defaultTrack.id : '';
            _this.versions = track_2.getTrackAssets({ assets: track.assets, format: 'mp3', type: 'track-preview' });
        }
        _this.onScrollThrottled = raf_throttle_1.default(_this.onScroll);
        _this.state = {
            downloadMenuOpen: false,
            selectedVersion: _this.originalVersionId
        };
        return _this;
    }

    _createClass(TrackPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.track) {
                this.props.setPlayerQueue(player_1.getPlayerTracksFromResults([this.props.track]));
            }
            var el = react_dom_1.findDOMNode(this);
            this.hero = el.getElementsByClassName('track__hero')[0];
            this.heroBackground = el.getElementsByClassName('track__artist-picture')[0];
            window.addEventListener('scroll', this.onScrollThrottled);
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (lodash_1.isEqual(nextProps, this.props) && lodash_1.isEqual(nextState, this.state)) {
                return false;
            }
            return true;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            // Whenever user toggles between versions, playback starts
            if (prevState.selectedVersion !== this.state.selectedVersion) {
                this.props.pausePlayer();
                this.props.playTrackVersion(this.state.selectedVersion);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.onScrollThrottled);
            this.onScrollThrottled = undefined;
        }
    }, {
        key: "renderHero",
        value: function renderHero() {
            var _this2 = this;

            var _props = this.props,
                currentVersionPlaying = _props.currentVersionPlaying,
                track = _props.track;

            return React.createElement("div", Object.assign({}, classes('hero')), React.createElement(Picture_1.default, Object.assign({ assets: this.artistImage }, classes('artist-picture'))), React.createElement("div", Object.assign({}, classes('hero__content')), React.createElement(ThumbnailWithPlayButton_1.default, Object.assign({ trackId: currentVersionPlaying || this.originalVersionId, responsiveAssets: this.coverImage, size: "large" }, classes('cover-image'))), React.createElement(Heading_1.default, Object.assign({ is: "h2", text: string_1.stripHTMLTagsFromString(track.title) }, classes('title'))), React.createElement(Heading_1.default, Object.assign({ is: "h6", hyperLinkProps: {
                    href: track_2.getArtistPagePath(track)
                }, text: string_1.stripHTMLTagsFromString(track.artist.name) }, classes('artist'))), this.versions.length > 1 && React.createElement("div", Object.assign({}, classes('versions')), React.createElement("div", { className: "buttons-group" }, this.versions.map(function (_ref2) {
                var id = _ref2.id,
                    version = _ref2.version;

                var isActive = _this2.state.selectedVersion === id;
                var extraClasses = {
                    'is-active': isActive
                };
                var buttonProps = Object.assign({ label: string_1.capitalizeString(version) }, classes('version-button', '', extraClasses));
                if (!isActive) {
                    buttonProps.onClick = _this2.onClickVersion(id);
                }
                return React.createElement(Button_1.default, Object.assign({ key: id }, buttonProps));
            })))));
        }
    }, {
        key: "renderHeader",
        value: function renderHeader(sticky) {
            var track = this.props.track;

            var downloadableAsset = track_2.getDefaultTrackAsset(track.assets);
            var versions = track_2.getTrackAssets({ assets: track.assets || defaultList, format: 'mp3', type: 'track-preview' });
            return React.createElement("div", Object.assign({}, classes('header')), React.createElement("div", Object.assign({}, classes('details')), React.createElement(Thumbnail_1.default, Object.assign({}, classes('cover-image'), { size: "xsmall", responsiveAssets: this.coverImage })), React.createElement("div", Object.assign({}, classes('info')), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('info__title')), track.title), React.createElement(Label_1.Span, Object.assign({ text: track.artist.name, size: "small", textColor: "bw7" }, classes('info__subtitle'))))), React.createElement("div", Object.assign({}, classes('header__actions')), React.createElement(AddToProjectButton_1.default, Object.assign({ trackId: track.id }, classes('action'))), versions.length > 1 ? React.createElement(DropdownMenu_1.default, { Button: React.createElement(Button_1.default, Object.assign({ icon: React.createElement(Icon_1.IconDownload, null), label: "Download Preview MP3" }, classes('action'))), options: versions.map(function (asset) {
                    return React.createElement(DownloadButton_1.default, { key: "download-" + asset.version, icon: React.createElement(Icon_1.IconMusicNote, null), label: string_1.capitalizeString(asset.version), assetPath: asset.path, track: track });
                }), requestClose: this.state.downloadMenuOpen === false, disableOnClickOutside: this.state.downloadMenuOpen === false, onToggle: this.onToggleDropdownMenu }) : React.createElement(DownloadButton_1.default, Object.assign({ assetPath: downloadableAsset.path, track: track }, classes('action'))), track_2.canLicenseTrack(track) ? React.createElement(AddToCartButton_1.default, Object.assign({ label: React.createElement(PriceTag_1.default, { amount: track.price, label: "License for" }), item: track, size: "small-medium", variant: "pill" }, classes('button-license'))) : React.createElement(SessionLicenseBuilderButton_1.default, Object.assign({ colorScheme: "accent", label: "License this track", icon: React.createElement(Icon_1.IconAddToCart, null), size: "small-medium", variant: "pill" }, classes('button-license')))));
        }
    }, {
        key: "renderVersionsLicense",
        value: function renderVersionsLicense() {
            var _this3 = this;

            var _props2 = this.props,
                currentVersionPlaying = _props2.currentVersionPlaying,
                pausePlayer = _props2.pausePlayer,
                playTrackVersion = _props2.playTrackVersion,
                track = _props2.track;
            var selectedVersion = this.state.selectedVersion;

            return React.createElement("div", Object.assign({}, classes('versions-and-license')), React.createElement("div", Object.assign({}, classes('versions')), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('versions__title')), "Versions"), React.createElement("div", { className: "buttons-group" }, this.versions.map(function (_ref3) {
                var id = _ref3.id,
                    version = _ref3.version;

                var isActive = selectedVersion === id;
                var extraClasses = {
                    'is-active': isActive
                };
                var buttonProps = Object.assign({ label: string_1.capitalizeString(version) }, classes('version-button', '', extraClasses));
                if (!isActive) {
                    buttonProps.onClick = function () {
                        return _this3.onClickVersion(id);
                    };
                }
                return React.createElement(Button_1.default, Object.assign({ key: id }, buttonProps));
            })), React.createElement("div", Object.assign({}, classes('versions__player')), React.createElement(CardPlayButton_1.default, Object.assign({ isPlaying: !!currentVersionPlaying, onClick: function onClick() {
                    currentVersionPlaying === selectedVersion ? pausePlayer() : playTrackVersion(selectedVersion);
                } }, classes('versions__player__play-button'))), React.createElement(WaveformPlaceholder_1.default, Object.assign({}, classes('versions__player__waveform'))))), !!track.price && track.price > 0 ? React.createElement("div", Object.assign({}, classes('license')), React.createElement("div", Object.assign({}, classes('license__pricing')), React.createElement(PriceTag_1.default, Object.assign({ amount: track.price, size: "large" }, classes('price'))), React.createElement(AddToCartButton_1.default, { label: "License this track", item: track })), React.createElement("div", Object.assign({}, classes('license__details')), React.createElement(Label_1.Span, { variant: "description", text: "Prices for:", textColor: colors_1.bw7 }), React.createElement("div", Object.assign({}, classes('usages')), this.props.licenseUsages.map(function (usage) {
                return React.createElement(Button_1.default, Object.assign({ key: "license-usage-" + usage.medium.id }, classes('usage-button'), { label: React.createElement(Label_1.Span, { text: license_1.usageToString(usage), variant: "description", size: "large" }), variant: "text", size: "small", icon: React.createElement(Icon_1.IconEdit, null), iconPosition: "right" }));
            }), React.createElement(Button_1.default, Object.assign({}, classes('add-usage-button'), { label: "Add More Media", variant: "text", icon: React.createElement(Icon_1.IconAddCircle, null) }))))) : React.createElement("div", Object.assign({}, classes('license', 'no-terms')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('license__title')), "Want a price for this track?"), React.createElement(Button_1.default, { label: "Build Your License", colorScheme: "accent", icon: React.createElement(Icon_1.IconTerms, null) })));
        }
    }, {
        key: "renderTermsByTaxonomy",
        value: function renderTermsByTaxonomy(terms) {
            var _this4 = this;

            return terms.map(function (_ref4) {
                var id = _ref4.id,
                    name = _ref4.name;
                return React.createElement(Tag_1.default, { key: id, id: id, label: name, colorScheme: "white", onClick: function onClick() {
                        return _this4.props.addSearchFilter({ name: name });
                    } });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this5 = this;

            var track = this.props.track;

            var tempos = track.tempos || defaultList;
            var moods = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Moods, this.terms);
            var genres = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Genres, this.terms);
            var instruments = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Instruments, this.terms);
            var languages = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Languages, this.terms);
            var vocals = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Vocals, this.terms);
            var tags = taxonomy_1.getTermsByTaxonomy(taxonomy_1.TaxonomyType.Tags, this.terms);
            var defaultTrackAsset = track_2.getDefaultTrackAsset(track.assets);
            var featuredCollections = (track.collections.edges || defaultList).map(function (_ref5) {
                var node = _ref5.node;
                return node;
            });
            var duration = defaultTrackAsset && defaultTrackAsset.metadata ? date_1.getFormattedTime(defaultTrackAsset.metadata.duration) : null;
            var hasAttributes = !!track.stems_available || !!track.customizable;
            return React.createElement(Page_1.default, { id: "track", layout: "loose" }, React.createElement(helmet_1.default, { track: track }), React.createElement("section", { className: "page__main" }, this.renderHero(), this.renderHeader(), React.createElement("div", Object.assign({}, classes('content')), React.createElement("div", Object.assign({}, classes('content__wrapper')), React.createElement("div", Object.assign({}, classes('content__column', 'metadata')), React.createElement(Heading_1.default, { is: "h3" }, "Info"), React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Tempo" }), tempos.map(function (_ref6) {
                var id = _ref6.id,
                    name = _ref6.name,
                    value = _ref6.value;
                return React.createElement(Tag_1.default, { key: id, id: id, label: name, colorScheme: "white", onClick: function onClick() {
                        return _this5.onSetTempoFilter(value);
                    } });
            })), duration && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Duration" }), React.createElement(Tag_1.default, { id: "_", label: duration, colorScheme: "white" })), hasAttributes && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Attributes" }), track.stems_available && React.createElement(Tag_1.default, { id: "stems-available", label: "Stems available", colorScheme: "white" }), track.customizable && React.createElement(Tag_1.default, { id: "customizable", label: "Customizable", colorScheme: "white" }))), React.createElement("div", Object.assign({}, classes('content__column', 'facets')), React.createElement(Heading_1.default, { is: "h3" }, "Tags"), !!moods.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Moods" }), this.renderTermsByTaxonomy(moods)), !!genres.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Genres" }), this.renderTermsByTaxonomy(genres)), !!instruments.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Instruments" }), this.renderTermsByTaxonomy(instruments)), !!languages.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Languages" }), this.renderTermsByTaxonomy(languages)), !!vocals.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Vocals" }), this.renderTermsByTaxonomy(vocals)), !!tags.length && React.createElement("div", Object.assign({}, classes('tags-group'), { "data-title": "Tags" }), this.renderTermsByTaxonomy(tags))), React.createElement("div", Object.assign({}, classes('content__column', 'other-tracks')), React.createElement(TrackList_1.TrackListQuery, Object.assign({ actionSource: "track_page", cardProps: {
                    backgroundColor: 'bw3',
                    size: 'small',
                    options: ['PriceElement', 'AddToProject', 'ShowDetails']
                }, excludeSearchResults: [], searchQuery: {
                    count: 5,
                    filters: {
                        similarity: {
                            track_id: track.id,
                            feature: "Default" /* Default */
                        }
                    }
                }, title: "More like this" }, classes('from-same-artist'))), React.createElement(TrackList_1.TrackListQuery, Object.assign({ actionSource: "track_page", cardProps: {
                    backgroundColor: 'bw3',
                    size: 'small',
                    options: ['PriceElement', 'AddToProject', 'ShowDetails']
                }, excludeSearchResults: [track.id], searchQuery: {
                    count: 5,
                    filters: {
                        artist_slug: track.artist.slug
                    }
                }, title: "More from the same artist" }, classes('from-same-artist'))), React.createElement(LinkButtonWithLicense_1.default, { to: Artist_1.ArtistPagePath(track.artist.slug), external: true, label: "Go to Artist", icon: React.createElement(Icon_1.IconArrowRight, null), iconPosition: "right", colorScheme: "white", className: "show-all-tracks-button" }))), !!featuredCollections.length && React.createElement("div", Object.assign({}, classes('content__wrapper')), React.createElement("div", Object.assign({}, classes('content__column', 'collections')), React.createElement(Heading_1.default, { is: "h3" }, "Featured in Collections"), React.createElement(Collections_1.default, { data: featuredCollections, gridView: true, hideTitle: true }))))));
        }
    }]);

    return TrackPage;
}(React.Component);

var TrackPageWithLicenseBar = withLicenseBar_1.default(TrackPage);
var ConnectedTrackPage = react_redux_1.connect(function (_ref7, ownProps) {
    var license = _ref7.license,
        player = _ref7.player;
    var currentTrack = player.currentTrack,
        isTrackPlaying = player.isTrackPlaying;

    var currentTrackPlaying = '';
    var currentVersionPlaying = '';
    if (isTrackPlaying && currentTrack && currentTrack.trackId === ownProps.track.id) {
        currentTrackPlaying = currentTrack.trackId;
        currentVersionPlaying = currentTrack.versionId;
    }
    return {
        currentTrackPlaying: currentTrackPlaying,
        currentVersionPlaying: currentVersionPlaying,
        licenseUsages: license.usages
    };
}, function (dispatch) {
    return {
        pausePlayer: function pausePlayer() {
            dispatch(playerActions.pause());
        },
        playTrackVersion: function playTrackVersion(trackId) {
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        },
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.addTracksToQueue({ tracks: tracks }));
        }
    };
})(TrackPageWithLicenseBar);
var TrackPageWithQueryStringContext = function TrackPageWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref8) {
        var addSearchFilter = _ref8.addSearchFilter,
            addTempoFilter = _ref8.addTempoFilter;
        return React.createElement(ConnectedTrackPage, Object.assign({ addSearchFilter: addSearchFilter, addTempoFilter: addTempoFilter }, props));
    });
};
var RelayTrackPage = react_relay_1.createFragmentContainer(TrackPageWithQueryStringContext, track_1.TrackFragment);
exports.default = RelayTrackPage;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Address Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
function formatAddress(address, getCountryLabel, getStateLabel, printCountry) {
    if (address.hasOwnProperty('subdivision_code')) {
        var gqlAddress = address;
        return formatAddress({
            street: gqlAddress.line_1,
            unit: gqlAddress.line_2 || undefined,
            city: gqlAddress.city,
            postalCode: gqlAddress.postal_code,
            state: gqlAddress.subdivision_code,
            country: gqlAddress.country_code,
            company: {
                name: gqlAddress.company,
                type: gqlAddress.hasOwnProperty('company_type') && gqlAddress.company_type ? gqlAddress.company_type.name : ''
            }
        }, getCountryLabel, getStateLabel, printCountry);
    }
    var street = address.street,
        unit = address.unit,
        city = address.city,
        postalCode = address.postalCode,
        state = address.state,
        country = address.country;

    var countryName = getCountryLabel(country);
    var stateName = getStateLabel(state);
    var addressUnit = unit ? ", " + unit : "";
    var addressState = stateName ? ", " + stateName : '';
    var addressCountry = countryName ? countryName + "  " : '';
    var addressString = "" + street + addressUnit + "\n    " + city + addressState + "\n    " + postalCode + (printCountry ? " " + addressCountry : '');
    return addressString;
}
exports.formatAddress = formatAddress;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * React Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
function nl2br(str) {
  return str.split('\n').map(function (item, key) {
    return React.createElement("span", { key: key }, item, React.createElement("br", null));
  });
}
exports.nl2br = nl2br;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FormCell Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1606);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var classes = new BEM('form__cell');

var FormCell = function (_React$Component) {
    _inherits(FormCell, _React$Component);

    function FormCell() {
        _classCallCheck(this, FormCell);

        return _possibleConstructorReturn(this, (FormCell.__proto__ || Object.getPrototypeOf(FormCell)).apply(this, arguments));
    }

    _createClass(FormCell, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                minimumWidth = _props.minimumWidth,
                children = _props.children;

            var modifiers = {
                'no-margin-left': !!this.props.noMarginLeft,
                'is-spacer': !!this.props.spacer
            };
            return !this.shouldRender() ? null : React.createElement("div", Object.assign({}, classes('', modifiers), { "data-min-width": minimumWidth }), children);
        }
    }, {
        key: "shouldRender",
        value: function shouldRender() {
            return this.props.conditionalDisplay === true || this.props.conditionalDisplay == null;
        }
    }]);

    return FormCell;
}(React.Component);

exports.default = FormCell;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FormRow Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1608);
var classes = new BEM('form__row');
function FormRow(_ref) {
  var children = _ref.children;

  return React.createElement("div", Object.assign({}, classes()), children);
}
exports.default = FormRow;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TextFieldWithLabel Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1613);
var classNames = __webpack_require__(15);
var TextField_1 = __webpack_require__(83);
var Label_1 = __webpack_require__(8);
var classes = new BEM('textfield');

var TextFieldWithLabel = function (_React$Component) {
    _inherits(TextFieldWithLabel, _React$Component);

    function TextFieldWithLabel() {
        _classCallCheck(this, TextFieldWithLabel);

        return _possibleConstructorReturn(this, (TextFieldWithLabel.__proto__ || Object.getPrototypeOf(TextFieldWithLabel)).apply(this, arguments));
    }

    _createClass(TextFieldWithLabel, [{
        key: "focus",
        value: function focus() {
            this.textfield.focus();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                className = _a.className,
                label = _a.label,
                note = _a.note,
                fieldProps = __rest(_a, ["className", "label", "note"]);
            var classNameWithLabel = classNames(className, 'textfield--with-label');
            var optional = this.props.optional;
            var name = this.props.input ? this.props.input.name : this.props.name;
            var noteLabel = null;
            if (note || optional != null) {
                var noteProps = Object.assign({ size: 'small', variant: 'note' }, classes('note'));
                noteLabel = React.createElement(Label_1.default, Object.assign({}, noteProps), note || 'Optional');
            }
            return React.createElement(TextField_1.default, Object.assign({ ref: function ref(node) {
                    return _this2.textfield = node;
                }, className: classNameWithLabel }, fieldProps), React.createElement(Label_1.default, Object.assign({ text: label, size: "small", htmlFor: name }, classes('label'))), noteLabel, this.props.children);
        }
    }]);

    return TextFieldWithLabel;
}(React.Component);

exports.default = TextFieldWithLabel;

/***/ }),
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LocalStorage Reducer Helpers
 */

Object.defineProperty(exports, "__esModule", { value: true });
var date_1 = __webpack_require__(119);
var url_1 = __webpack_require__(183);
var lodash_1 = __webpack_require__(6);
var uuid = __webpack_require__(1791);
exports.localStorageSuffixSessionTerms = 'sessionTerms';
exports.localStorageSuffixCart = 'cart';
exports.localStorageSuffixCheckout = 'checkout';
exports.localStorageSuffixPreferences = 'prefs';
exports.localStorageKeySeparator = ':';
exports.localStoragePrefix = 'ams';
var localStorageSessionPrefix = "" + exports.localStoragePrefix + exports.localStorageKeySeparator + "session";
// tslint:disable-next-line:no-invalid-template-strings
// tslint:disable-next-line:max-line-length
var uniqueKeyTemplate = lodash_1.template("<%= prefix %>" + exports.localStorageKeySeparator + "<%= uniqueId %>" + exports.localStorageKeySeparator + "<%= suffix %>");
function getLocalStorageKeys(suffix) {
    return Object.keys(localStorage).filter(function (key) {
        if (suffix) {
            var regex = new RegExp(suffix + "$");
            return key.match(regex);
        }
        return true;
    });
}
exports.getLocalStorageKeys = getLocalStorageKeys;
function removeAllSessionItems() {
    var keys = Object.keys(localStorage).filter(function (key) {
        var regexp = new RegExp("^" + localStorageSessionPrefix);
        return key.match(regexp);
    });
    keys.forEach(function (key) {
        localStorage.removeItem(key);
    });
}
exports.removeAllSessionItems = removeAllSessionItems;
function updateStoredItem(key, value, merge) {
    var timestamp = date_1.getTimestamp();
    var storedItemKey = getLocalStorageKeys(key);
    if (storedItemKey.length > 0) {
        var storedItem = url_1.decodeFromUrl(localStorage.getItem(storedItemKey[0]));
        if (merge) {
            if (lodash_1.isArray(storedItem.data)) {
                storedItem.data.push(value);
            } else if (lodash_1.isObject(storedItem.data)) {
                storedItem.data = lodash_1.extend(storedItem.data, value);
            }
        } else {
            storedItem.data = value;
        }
        storedItem.updatedAt = timestamp;
        localStorage.setItem(storedItemKey[0], url_1.encodeForUrl(storedItem));
    } else {
        createItem(key, value);
    }
}
exports.updateStoredItem = updateStoredItem;
function createItem(key, value) {
    var timestamp = date_1.getTimestamp();
    var storageItem = {
        data: value,
        createdAt: timestamp,
        updatedAt: timestamp
    };
    var uniqueKey = uniqueKeyTemplate({
        prefix: localStorageSessionPrefix,
        uniqueId: uuid.create().toString(),
        suffix: key
    });
    localStorage.setItem(uniqueKey, url_1.encodeForUrl(storageItem));
}
exports.createItem = createItem;
function removeItem(key) {
    var storedItemKey = getLocalStorageKeys(key);
    if (storedItemKey.length > 0) {
        localStorage.removeItem(storedItemKey[0]);
        return true;
    }
    return false;
}
exports.removeItem = removeItem;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Projects Form
 */

Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = __webpack_require__(53);
var projects_1 = __webpack_require__(130);
var lodash_1 = __webpack_require__(6);
var redux_form_1 = __webpack_require__(37);
var defaultList = [];
var form = 'projectForm';
exports.selector = redux_form_1.formValueSelector(form);
exports.reinitializeForm = function (data) {
    return redux_form_1.initialize(form, data);
};
exports.submitForm = function () {
    return redux_form_1.submit(form);
};
exports.addProject = function () {
    return redux_form_1.change(form, 'createProject', '');
};
exports.removeProject = function (index) {
    return redux_form_1.arrayRemove(form, 'projects', index);
};
exports.replaceProject = function (index, replace) {
    return redux_form_1.arraySplice(form, 'projects', index, 1, replace);
};
exports.shareProject = function () {
    return redux_form_1.change(form, 'activeProject.isPublic', true);
};
exports.removeTrack = function (index) {
    return redux_form_1.arrayRemove(form, 'activeProject.tracks', index);
};
exports.moveTrack = function (oldIndex, newIndex) {
    return redux_form_1.arrayMove(form, 'activeProject.tracks', oldIndex, newIndex);
};
exports.ProjectsPageReduxForm = redux_form_1.reduxForm({
    form: form,
    onSubmit: function onSubmit(values, dispatch, props) {
        return new Promise(function (resolve, reject) {
            var nextProjects = values.projects.map(function (_ref) {
                var id = _ref.id;
                return id;
            });
            var prevProjects = props.viewer.projects.edges.map(function (_ref2) {
                var node = _ref2.node;
                return node.id;
            });
            var removedProject = lodash_1.difference(prevProjects, nextProjects);
            if (removedProject.length) {
                // Delete Project
                dispatch(projects_1.requestDeleteProject({
                    input: { id: removedProject[0] },
                    promise: { resolve: resolve, reject: reject }
                }));
            } else {
                // Update Project
                var activeProject = props.viewer.node;
                var mutationInput = {
                    id: activeProject.id
                };
                var nextName = values.activeProject.name;
                var prevName = activeProject.name;
                var tracksMutation = {};
                var nextTracks = values.activeProject.tracks.map(function (_ref3) {
                    var association_id = _ref3.association_id;
                    return association_id;
                });
                var prevTracks = activeProject.tracks.edges.map(function (_ref4) {
                    var id = _ref4.id;
                    return id;
                });
                var removedTracks = lodash_1.difference(prevTracks, nextTracks);
                var trackOrderChanged = !lodash_1.isMatch(prevTracks, nextTracks);
                var shouldPerformMutation = false;
                var updateProjectInList = function updateProjectInList(updatedValues) {
                    var projectIndex = values.projects.findIndex(function (_ref5) {
                        var id = _ref5.id;
                        return id === values.activeProject.id;
                    });
                    var updatedProject = Object.assign({}, values.projects[projectIndex], updatedValues);
                    dispatch(exports.replaceProject(projectIndex, updatedProject));
                };
                if (nextName !== prevName) {
                    shouldPerformMutation = true;
                    mutationInput.name = nextName;
                    updateProjectInList({ title: nextName });
                } else if (removedTracks.length) {
                    shouldPerformMutation = true;
                    tracksMutation.remove = removedTracks.map(function (id) {
                        return { id: id };
                    });
                } else if (trackOrderChanged) {
                    shouldPerformMutation = true;
                    tracksMutation.update = nextTracks.map(function (id) {
                        return {
                            id: id
                        };
                    });
                } else if (values.activeProject.isPublic && !activeProject.is_public) {
                    shouldPerformMutation = true;
                    mutationInput.is_public = true;
                    updateProjectInList({ isPublic: true });
                }
                mutationInput.tracks = tracksMutation;
                if (shouldPerformMutation) {
                    dispatch(projects_1.requestUpdateProject({
                        input: mutationInput,
                        promise: { resolve: resolve, reject: reject }
                    }));
                } else {
                    resolve();
                }
            }
        });
    },
    onSubmitFail: function onSubmitFail(errors, dispatch, submitError, props) {
        var activeProject = props.viewer.node;
        var allProjects = props.viewer.projects.edges.map(function (_ref6) {
            var node = _ref6.node;
            return node;
        });
        dispatch(exports.reinitializeForm({
            activeProject: generateActiveProjectItemProps(activeProject),
            projects: generateProjectItemsProps(allProjects, props.userProfile)
        }));
        dispatch(notifications_1.pushNotification({
            autoDismiss: false,
            message: 'Something went wront while updating playlist. Please try again later or contact us.',
            state: 'error'
        }));
    }
});
function generateProjectItemProps(project, userProfile) {
    return {
        id: project.id,
        isPublic: !!project.is_public,
        title: project.name,
        subtitle: (project.tracks && project.tracks.edges.length ? project.tracks.edges.length : 'No') + " tracks",
        userIsOwner: !project.owner || !!userProfile && userProfile.user_id === project.owner.user_id
    };
}
function generateActiveProjectItemProps(project) {
    return {
        id: project.id,
        isPublic: !!project.is_public,
        name: project.name,
        tracks: project.tracks ? project.tracks.edges.map(function (_ref7) {
            var associationId = _ref7.id,
                node = _ref7.node;
            return { id: node.id, association_id: associationId };
        }) : defaultList
    };
}
exports.generateActiveProjectItemProps = generateActiveProjectItemProps;
function generateProjectItemsProps(projects, userProfile) {
    return projects.map(function (project) {
        return generateProjectItemProps(project, userProfile);
    });
}
exports.generateProjectItemsProps = generateProjectItemsProps;

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Array Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
exports.defaultList = [];
function rotateArray(array, count) {
    /* tslint:disable:no-bitwise */
    var push = Array.prototype.push;
    var splice = Array.prototype.splice;
    var len = array.length >>> 0; // convert to uint
    count = count >> 0; // convert to int
    count = (count % len + len) % len;
    // use splice.call() instead of this.splice() to make function generic
    push.apply(array, splice.call(array, 0, count));
    return array;
}
exports.rotateArray = rotateArray;
function objectIsArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
}
exports.objectIsArray = objectIsArray;
var diffOnObjects = lodash_1.memoize(function (object, base) {
    return lodash_1.isObject(object) && lodash_1.isObject(base);
});
function diffCustomizer(object, base) {
    if (diffOnObjects(object, base)) {
        return lodash_1.isEqual(object, base);
    } else {
        return String(object) === String(base);
    }
}
exports.diff = function (object, base) {
    return lodash_1.transform(object, function (result, value, key) {
        if (base && key in base) {
            if (!lodash_1.isEqualWith(value, base[key], diffCustomizer)) {
                result[key] = diffOnObjects(value, base[key]) ? exports.diff(value, base[key]) : value;
            }
        } else {
            result[key] = value;
        }
    });
};

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('License');
exports.addMedium = actionCreator('ADD_USAGE_FOR_MEDIUM');
exports.removeMedium = actionCreator('REMOVE_USAGE_FOR_MEDIUM');
exports.setEditingUsageIndex = actionCreator('SET_EDITING_USAGE_INDEX');
exports.setComponentForUsage = actionCreator('ADD_COMPONENT_TO_USAGE');
exports.clearLicense = actionCreator('CLEAR_ALL');
exports.setUsages = actionCreator('SET_USAGES');

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FAQPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1277);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Page_1 = __webpack_require__(38);
var PageHeader_1 = __webpack_require__(144);
var grid_1 = __webpack_require__(58);
var content_1 = __webpack_require__(1279);
var FAQCategoryList_1 = __webpack_require__(1280);
var FAQView_1 = __webpack_require__(1332);
// Page Path
exports.FAQPagePath = '/help/faq';
exports.FAQPageSectionPath = function (section) {
    return "/help/faq/" + section;
};
var classes = new BEM('faq');

var FAQPage = function (_React$Component) {
    _inherits(FAQPage, _React$Component);

    function FAQPage(props) {
        _classCallCheck(this, FAQPage);

        var _this = _possibleConstructorReturn(this, (FAQPage.__proto__ || Object.getPrototypeOf(FAQPage)).call(this, props));

        _this.onSelectCategory = function (categoryId) {
            _this.setState({ activeCategory: content_1.FAQContent.find(function (_ref) {
                    var id = _ref.id;
                    return id === categoryId;
                }) });
        };
        if (!props.routeParams.id) {
            props.router.push(exports.FAQPagePath + "/" + content_1.FAQContent[0].id);
        }
        _this.state = {
            activeCategory: content_1.FAQContent.find(function (_ref2) {
                var id = _ref2.id;
                return id === props.routeParams.id;
            }) || content_1.FAQContent[0]
        };
        return _this;
    }

    _createClass(FAQPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var hash = this.props.match.location.hash;
            if (hash) {
                var anchorId = hash.substr(1);
                var anchorEl = document.getElementById(anchorId);
                if (!!anchorEl) {
                    var _anchorEl$getBounding = anchorEl.getBoundingClientRect(),
                        top = _anchorEl$getBounding.top;

                    window.scrollTo(0, top - grid_1.baseline * 15);
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(Page_1.default, Object.assign({ id: "faq" }, classes('')), React.createElement(PageHeader_1.default, { title: "Frequently Asked Questions" }), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement(FAQCategoryList_1.default, { categories: content_1.FAQContent, onSelectCategory: this.onSelectCategory }), React.createElement(FAQView_1.default, { data: this.state.activeCategory })));
        }
    }]);

    return FAQPage;
}(React.Component);

exports.default = FAQPage;

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Money Formatting Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__(416);
var Currency;
(function (Currency) {
    Currency["CAD"] = "CAD";
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["AUD"] = "AUD";
    Currency["NZD"] = "NZD";
})(Currency = exports.Currency || (exports.Currency = {}));
function getFormattedMoney(amount, currency) {
    var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return accounting_1.formatMoney(amount, { precision: precision, symbol: currency + ' ' });
}
exports.getFormattedMoney = getFormattedMoney;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LoadingButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1426);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var LoadingIndicator_1 = __webpack_require__(1428);
var classes = new BEM('loading-button');

var LoadingButton = function (_React$Component) {
    _inherits(LoadingButton, _React$Component);

    function LoadingButton(props) {
        _classCallCheck(this, LoadingButton);

        var _this = _possibleConstructorReturn(this, (LoadingButton.__proto__ || Object.getPrototypeOf(LoadingButton)).call(this, props));

        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick();
            }
            if (_this.props.isLoading === undefined && _this.props.onLoad) {
                _this.props.onLoad();
            }
        };
        _this.state = {
            isLoading: false
        };
        return _this;
    }

    _createClass(LoadingButton, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(_, prevState) {
            if (this.state.isLoading && !!!prevState.isLoading && this.props.onLoad) {
                this.onLoadTimer = window.setTimeout(this.props.onLoad, 350);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.clearTimeout(this.onLoadTimer);
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                buttonClassName = _a.buttonClassName,
                className = _a.className,
                isLoading = _a.isLoading,
                loadingIndicatorClassName = _a.loadingIndicatorClassName,
                onClick = _a.onClick,
                onLoad = _a.onLoad,
                buttonProps = __rest(_a, ["buttonClassName", "className", "isLoading", "loadingIndicatorClassName", "onClick", "onLoad"]);
            var classModifiers = {
                'is-loading': this.state.isLoading
            };
            return React.createElement("div", Object.assign({}, classes('', classModifiers, className)), React.createElement(LoadingIndicator_1.default, { className: loadingIndicatorClassName }), React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, className: buttonClassName }, buttonProps)));
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(_ref, prevState) {
            var isLoading = _ref.isLoading;

            if (isLoading !== prevState.isLoading) {
                return { isLoading: isLoading };
            }
            return null;
        }
    }]);

    return LoadingButton;
}(React.Component);

exports.default = LoadingButton;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AccountRegistrationPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var notificationActions = __webpack_require__(53);
var uiActions = __webpack_require__(29);
var userActions = __webpack_require__(50);
var profile_1 = __webpack_require__(288);
__webpack_require__(153);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Velocity = __webpack_require__(91);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var actions_1 = __webpack_require__(418);
// import Button from '../../../atoms/buttons/Button';
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var LoadingButton_1 = __webpack_require__(286);
var CheckboxWithLabel_1 = __webpack_require__(213);
var Discover_1 = __webpack_require__(221);
var config_1 = __webpack_require__(436);
var DotNavigation_1 = __webpack_require__(1670);
var RegistrationStepCompanyName_1 = __webpack_require__(1671);
var RegistrationStepIndustry_1 = __webpack_require__(1672);
var RegistrationStepJobType_1 = __webpack_require__(1673);
var RegistrationStepPhone_1 = __webpack_require__(1674);
var RegistrationStepUserName_1 = __webpack_require__(1675);
exports.RegistrationPagePath = '/registration';
var classes = new BEM('account-registration');
var defaultList = [];
var registrationSteps = [RegistrationStepUserName_1.default, RegistrationStepJobType_1.default, RegistrationStepCompanyName_1.ConnectedRegistrationStepCompanyName, RegistrationStepIndustry_1.default, RegistrationStepPhone_1.default];

var AccountRegistrationPage = function (_React$Component) {
    _inherits(AccountRegistrationPage, _React$Component);

    function AccountRegistrationPage(props) {
        _classCallCheck(this, AccountRegistrationPage);

        var _this = _possibleConstructorReturn(this, (AccountRegistrationPage.__proto__ || Object.getPrototypeOf(AccountRegistrationPage)).call(this, props));

        _this.askForUserName = true;
        _this.onClickDone = function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _props, query, router, redirectUrl;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props = this.props, query = _props.location.query, router = _props.router;

                                this.setState({ submitting: true });
                                _context.next = 4;
                                return this.updateProfile();

                            case 4:
                                redirectUrl = query && query.goto ? query.goto : Discover_1.DiscoverPagePath;

                                router.push(redirectUrl);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        };
        if (!_this.askForUserName) {
            registrationSteps.shift();
        }
        _this.state = {
            currentStep: 0,
            processCompleted: false,
            submitting: false
        };
        return _this;
    }

    _createClass(AccountRegistrationPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.props.initHeader();
            this.props.setUserSubscribesToNewsletter(true);
            setTimeout(function () {
                _this2.setState({ currentStep: 1 });
            }, 1500);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var el = react_dom_1.findDOMNode(this);
            var stepIndicator = el.getElementsByClassName('account-registration__step-indicator');
            if (stepIndicator.length) {
                Velocity.hook(stepIndicator[0], 'translateX', '-50%');
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.resetHeader();
        }
    }, {
        key: "onStepComplete",
        value: function onStepComplete(step) {
            if (step < registrationSteps.length) {
                var nextStep = step + 1;
                this.setState({ currentStep: nextStep });
                // Remove the "skip" button for the time being to force users to complete
                // the registration steps.
                // if (registrationSteps[nextStep - 1] === RegistrationStepJobType) {
                //   this.props.setHeaderActions([(
                //     <Button
                //       onClick={this.onClickDone}
                //       label="Skip"
                //       size="small-medium"
                //     />
                //   )]);
                // }
            } else {
                this.props.setHeaderActions([]);
                this.setState({ processCompleted: true });
            }
        }
    }, {
        key: "renderStep",
        value: function renderStep() {
            var _this3 = this;

            var RegistrationStep = registrationSteps[this.state.currentStep - 1];
            return React.createElement(RegistrationStep, { key: "step-" + this.state.currentStep, onComplete: function onComplete() {
                    return _this3.onStepComplete(_this3.state.currentStep);
                } });
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                currentStep = _state.currentStep,
                processCompleted = _state.processCompleted;

            return React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: Page_1.default, id: "account-registration", layout: "strict" }, classes(), { enter: { animation: 'transition.expandIn', duration: 500, delay: 350, display: 'flex' }, leave: { animation: 'transition.shrinkOut', duration: 350 }, runOnMount: true }), currentStep === 0 && React.createElement("div", Object.assign({}, classes('step')), React.createElement("div", { className: "signup-check" }, React.createElement(Icon_1.IconCheck, null)), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('step__title')), "Thanks for signing up!")), currentStep > 0 && !processCompleted && this.renderStep(), currentStep > 0 && !processCompleted && React.createElement(DotNavigation_1.default, Object.assign({ currentDot: currentStep, totalDots: registrationSteps.length }, classes('step-indicator'))), processCompleted && React.createElement("div", Object.assign({}, classes('step', 'process-complete')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('step__title')), "Thank you for taking the time.", React.createElement("br", null), "We really appreciate it."), React.createElement(Label_1.Span, { size: "large" }, "Sign up to the Music Discovery Club to receive trending music in your inbox every two weeks."), React.createElement(CheckboxWithLabel_1.default, { onChange: function onChange() {
                    return _this4.props.toggleUserSubscribesToNewsletter();
                }, checked: this.props.subscribesToNewsletter, label: "I would like to join the Music Discovery Club.", name: "newsletter-opt-in" }), React.createElement(LoadingButton_1.default, { onClick: this.onClickDone, isLoading: this.state.submitting, label: "Complete Registration", colorScheme: "dark", size: "medium" })));
        }
    }, {
        key: "updateProfile",
        value: function updateProfile() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _props2, pushNotification, requestUpdateUserProfile;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _props2 = this.props, pushNotification = _props2.pushNotification, requestUpdateUserProfile = _props2.requestUpdateUserProfile;
                                _context2.prev = 1;
                                _context2.next = 4;
                                return requestUpdateUserProfile();

                            case 4:
                                _context2.next = 10;
                                break;

                            case 6:
                                _context2.prev = 6;
                                _context2.t0 = _context2["catch"](1);

                                pushNotification({
                                    autoDismiss: false,
                                    message: locales_1.default.errors.genericMessage,
                                    state: 'error'
                                });
                                console.error(_context2.t0);

                            case 10:
                                return _context2.abrupt("return", true);

                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 6]]);
            }));
        }
    }]);

    return AccountRegistrationPage;
}(React.Component);

var ConnectedAccountRegistrationPage = react_redux_1.connect(function (_ref) {
    var _ref$user = _ref.user,
        profile = _ref$user.profile,
        registrationForm = _ref$user.registrationForm;
    return {
        profile: profile,
        registrationForm: registrationForm,
        subscribesToNewsletter: !!(registrationForm && registrationForm.optInToNewsletter)
    };
}, function (dispatch) {
    return {
        initHeader: function initHeader() {
            dispatch(uiActions.setHeaderType({ type: 'simple' }));
        },
        pushNotification: function pushNotification(notification) {
            dispatch(notificationActions.pushNotification(notification));
        },

        resetHeader: function resetHeader() {
            dispatch(uiActions.setHeaderType({ type: 'extended' }));
            dispatch(uiActions.setHeaderActions({ actions: defaultList }));
        },
        requestUpdateUserProfile: function requestUpdateUserProfile(payload) {
            dispatch(userActions.requestUpdateUserProfile(payload));
        },
        setHeaderActions: function setHeaderActions(actions) {
            dispatch(uiActions.setHeaderActions({ actions: actions }));
        },
        setUserSubscribesToNewsletter: function setUserSubscribesToNewsletter(value) {
            dispatch(userActions.setUserDetail({ key: 'optInToNewsletter', value: value }));
        },
        sendNewUserToPardot: function sendNewUserToPardot(payload) {
            return dispatch(actions_1.sendNewUser(payload));
        },
        sendNewsletterSignupToPardot: function sendNewsletterSignupToPardot(payload) {
            return dispatch(actions_1.sendNewsletterSignup(payload));
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, stateProps, dispatchProps, ownProps, { toggleUserSubscribesToNewsletter: function toggleUserSubscribesToNewsletter() {
            dispatchProps.setUserSubscribesToNewsletter(!stateProps.subscribesToNewsletter);
        }, requestUpdateUserProfile: function requestUpdateUserProfile() {
            var form = stateProps.registrationForm;
            var input = lodash_1.reduce(form, function (update, value, key) {
                update[lodash_1.snakeCase(key)] = value;
                return update;
            }, { is_new_user: false });
            dispatchProps.sendNewUserToPardot({
                email: stateProps.profile.email,
                first_name: input.first_name,
                last_name: input.last_name,
                phone: input.phone,
                company_name: input.company_name,
                company_type: (config_1.industries.find(function (val) {
                    return val.id === input.industry_id;
                }) || { label: undefined }).label,
                role: (config_1.jobTypes.find(function (val) {
                    return val.id === input.job_type_id;
                }) || { label: undefined }).label
            });
            // if (input.opt_in_to_newsletter) {
            //   input.opt_in_to_newsletter = false;
            //   dispatchProps.sendNewsletterSignupToPardot({ email: stateProps.profile.email! });
            // }
            return new Promise(function (resolve, reject) {
                dispatchProps.requestUpdateUserProfile({
                    input: input,
                    promise: { resolve: resolve, reject: reject },
                    viewerId: ownProps.viewer.id
                });
            });
        } });
})(AccountRegistrationPage);
var RelayAccountRegistration = react_relay_1.createFragmentContainer(ConnectedAccountRegistrationPage, profile_1.ProfileFragment);
exports.default = RelayAccountRegistration;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Profile
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.AccountPageQuery = function () {
  return __webpack_require__(1434);
};
exports.Profile = {
  data: function data() {
    return __webpack_require__(1435);
  }
};
exports.ProfileFragment = {
  viewer: function viewer() {
    return __webpack_require__(1436);
  }
};
exports.UpdateProfileMutation = function () {
  return __webpack_require__(1437);
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AddToCartButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = __webpack_require__(196);
var notifications_1 = __webpack_require__(53);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var track_1 = __webpack_require__(44);
__webpack_require__(1439);
var found_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
/* tslint:disable-next-line */
__webpack_require__(214);
var currency_1 = __webpack_require__(115);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Checkout_1 = __webpack_require__(290);
var Icon_1 = __webpack_require__(12);
var Button_1 = __webpack_require__(10);
var defaultList = [];

var AddToCartButton = function (_React$Component) {
    _inherits(AddToCartButton, _React$Component);

    function AddToCartButton(props) {
        _classCallCheck(this, AddToCartButton);

        var _this = _possibleConstructorReturn(this, (AddToCartButton.__proto__ || Object.getPrototypeOf(AddToCartButton)).call(this, props));

        _this.defaultButtonProps = {
            colorScheme: 'accent',
            icon: React.createElement(Icon_1.IconAddToCart, null),
            label: 'Add to Cart',
            size: 'xsmall'
        };
        _this.onClick = function (e) {
            if (_this.props.stopPropagationOnClick) {
                e.stopPropagation();
            }
            if (_this.props.onClick) {
                e.persist();
                _this.props.onClick(e);
            }
            _this.setState({ submitting: true }, function () {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var _props, addToCart, onItemAddedToCart, pushAddedToCartNotification, dispatch, message;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _props = this.props, addToCart = _props.addToCart, onItemAddedToCart = _props.onItemAddedToCart, pushAddedToCartNotification = _props.pushAddedToCartNotification, dispatch = _props.dispatch;
                                    _context.prev = 1;
                                    _context.next = 4;
                                    return addToCart();

                                case 4:
                                    if (onItemAddedToCart) {
                                        onItemAddedToCart();
                                    }
                                    pushAddedToCartNotification();
                                    _context.next = 13;
                                    break;

                                case 8:
                                    _context.prev = 8;
                                    _context.t0 = _context["catch"](1);
                                    message = _context.t0[0].message;

                                    dispatch(notifications_1.pushNotification({
                                        autoDismiss: false,
                                        /* tslint:disable-next-line */
                                        message: "We were unable to add this track to your cart. Please try again later or contact us. (" + message + ")",
                                        state: 'error'
                                    }));
                                    console.error('failed to add to cart', message);

                                case 13:
                                    if (this.isComponentMounted) {
                                        this.setState({ submitting: false });
                                    }

                                case 14:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[1, 8]]);
                }));
            });
        };
        _this.state = {
            submitting: false
        };
        return _this;
    }

    _createClass(AddToCartButton, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.isComponentMounted = true;
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.isComponentMounted = false;
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                addToCart = _a.addToCart,
                dispatch = _a.dispatch,
                item = _a.item,
                onClick = _a.onClick,
                onItemAddedToCart = _a.onItemAddedToCart,
                pushAddedToCartNotification = _a.pushAddedToCartNotification,
                stopPropagationOnClick = _a.stopPropagationOnClick,
                router = _a.router,
                buttonProps = __rest(_a, ["addToCart", "dispatch", "item", "onClick", "onItemAddedToCart", "pushAddedToCartNotification", "stopPropagationOnClick", "router"]);
            var props = lodash_1.merge(this.defaultButtonProps, buttonProps);
            return React.createElement(Button_1.default, Object.assign({ title: "Add this track to cart", disabled: this.state.submitting, submitting: this.state.submitting, onClick: this.onClick, className: "add-to-cart-button" }, props));
        }
    }]);

    return AddToCartButton;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedAddToCartButton = react_redux_1.connect(function (state, ownProps) {
    return {
        sessionLicense: selectors_1.licenseUsagesFromQueryStringSelector(state, ownProps),
        viewerId: state.user.viewerId,
        userIsLoggedIn: state.user.isLoggedIn
    };
}, function (dispatch, ownProps) {
    return {
        dispatch: dispatch,
        addToCart: function addToCart(terms, viewerId) {
            return new Promise(function (resolve, reject) {
                dispatch(cart_1.requestAddItemToCart({
                    lineItem: {
                        terms: terms,
                        track: ownProps.item
                    },
                    currencyCode: ownProps.currency,
                    viewerId: viewerId || '',
                    promise: { resolve: resolve, reject: reject }
                }));
            });
        }
    };
}, function (_ref, _ref2, _a) {
    var sessionLicense = _ref.sessionLicense,
        userIsLoggedIn = _ref.userIsLoggedIn,
        viewerId = _ref.viewerId;
    var _addToCart = _ref2.addToCart,
        dispatch = _ref2.dispatch;

    var currency = _a.currency,
        usages = _a.usages,
        ownProps = __rest(_a, ["currency", "usages"]);

    return Object.assign({}, ownProps, { dispatch: dispatch, addToCart: function addToCart() {
            return _addToCart(usages || sessionLicense || defaultList, viewerId);
        }, pushAddedToCartNotification: function pushAddedToCartNotification() {
            var trackTitle = ownProps.item.title;
            var trackThumbnail = track_1.getResponsiveTrackThumbnail(ownProps.item);
            dispatch(notifications_1.pushNotification({
                autoDismiss: 5000,
                image: trackThumbnail.medium[0].path,
                message: "Track <em>" + trackTitle + "</em> was added to your cart.",
                action: 'Checkout Now',
                onActionClick: function onActionClick() {
                    if (!userIsLoggedIn) {
                        dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: Checkout_1.CheckoutPagePath }));
                        dispatch(ui_1.showSignUpForm({ reason: 'checkout' }));
                    } else {
                        ownProps.router.push(Checkout_1.CheckoutPagePath);
                    }
                }
            }));
        } });
})(AddToCartButton);
var AddToCartButtonWithContext = function AddToCartButtonWithContext(props) {
    return React.createElement(currency_1.CurrencyContext.Consumer, null, function (_ref3) {
        var currency = _ref3.currency;
        return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref4) {
            var license_params = _ref4.license_params;
            return React.createElement(ConnectedAddToCartButton, Object.assign({ currency: currency, license_params: license_params }, props));
        });
    });
};
exports.default = found_1.withRouter(AddToCartButtonWithContext);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var countries_1 = __webpack_require__(222);
var ui_1 = __webpack_require__(29);
var selectors_1 = __webpack_require__(223);
var checkout_2 = __webpack_require__(635);
var checkout_3 = __webpack_require__(291);
var lineItem_1 = __webpack_require__(636);
var promise_1 = __webpack_require__(419);
var config_1 = __webpack_require__(80);
__webpack_require__(1449);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var react_script_loader_hoc_1 = __webpack_require__(1451);
var react_stripe_elements_1 = __webpack_require__(420);
var WindowSizeListener = __webpack_require__(124);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var notifications_1 = __webpack_require__(53);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var LoadingSpinner_1 = __webpack_require__(163);
var Heading_1 = __webpack_require__(9);
var PageHeader_1 = __webpack_require__(144);
var UserProfile_1 = __webpack_require__(639);
var Cart_1 = __webpack_require__(224);
var CheckoutComplete_1 = __webpack_require__(652);
var CheckoutPromoCode_1 = __webpack_require__(1603);
var CheckoutSteps_1 = __webpack_require__(1604);
var CheckoutSummary_1 = __webpack_require__(1626);
// Page Path
exports.CheckoutPagePath = '/my/checkout';
var classes = new BEM('checkout');
var defaultList = [];

var CheckoutPage = function (_React$Component) {
    _inherits(CheckoutPage, _React$Component);

    function CheckoutPage(props) {
        _classCallCheck(this, CheckoutPage);

        var _this = _possibleConstructorReturn(this, (CheckoutPage.__proto__ || Object.getPrototypeOf(CheckoutPage)).call(this, props));

        _this.onResize = function (_ref) {
            var windowWidth = _ref.windowWidth;

            var viewportWidth = window.innerWidth - 48;
            var inReviewWidth = viewportWidth < 1152 ? viewportWidth : viewportWidth * .9;
            if (inReviewWidth > 1152) {
                inReviewWidth = 1152;
            }
            var inReviewMargin = (viewportWidth - inReviewWidth) / 2;
            _this.setState({ inReviewMargin: inReviewMargin, inReviewWidth: inReviewWidth });
        };
        _this.state = {
            inReviewMargin: 0,
            inReviewWidth: 0,
            redirecting: !lineItem_1.checkoutLicenseLineItemsAreValid(props.viewer),
            shouldHideSidebarOnReview: false
        };
        return _this;
    }

    _createClass(CheckoutPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.fetchCountries();
            this.props.initHeader();
            this.props.retrieveFromLocalStorage();
            if (this.state.redirecting) {
                this.props.router.replace(Cart_1.CartPagePath);
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.userIsAtReviewStep && !this.props.userIsAtReviewStep) {
                this.onReview();
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.readyToPlaceOrder && this.props.readyToPlaceOrder) {
                this.onPlaceOrder();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.resetHeader();
        }
    }, {
        key: "onPlaceOrder",
        value: function onPlaceOrder() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var invoice_number;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this.props.placeOrder();

                            case 3:
                                invoice_number = this.props.viewer.checkout.invoice_number;

                                this.props.router.push(CheckoutComplete_1.CheckoutCompletePagePath + "?order=" + invoice_number);
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](0);

                                this.props.dispatch(notifications_1.pushNotification({
                                    autoDismiss: false,
                                    // tslint:disable-next-line:max-line-length
                                    message: 'Something went wrong while placing your order. Please contact us at +1 888-423-6665 (NA) or +33 1 70 38 73 50 (EU) so we can complete your order.',
                                    state: 'error'
                                }));

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 7]]);
            }));
        }
    }, {
        key: "onReview",
        value: function onReview() {
            var _props = this.props,
                billingAddress = _props.billingAddress,
                relay = _props.relay;

            var refetchVariables = {
                country_code: billingAddress.country,
                subdivision_code: billingAddress.state
            };
            relay.refetch(refetchVariables, null, null, { force: true });
        }
    }, {
        key: "renderSteps",
        value: function renderSteps() {
            var _props2 = this.props,
                userIsAtReviewStep = _props2.userIsAtReviewStep,
                _props2$viewer = _props2.viewer,
                checkout = _props2$viewer.checkout,
                company_types = _props2$viewer.company_types,
                representative_roles = _props2$viewer.representative_roles;

            var shouldHideSidebarOnReview = this.state.shouldHideSidebarOnReview && userIsAtReviewStep;
            return React.createElement(velocity_react_1.VelocityComponent, { animation: {
                    translateX: shouldHideSidebarOnReview ? this.state.inReviewMargin : 0,
                    minWidth: shouldHideSidebarOnReview ? this.state.inReviewWidth : 0
                }, delay: shouldHideSidebarOnReview ? 150 : 0, duration: 250 }, React.createElement(CheckoutSteps_1.default, { companyTypes: company_types, order: checkout, representativeRoles: representative_roles }));
        }
    }, {
        key: "renderSidebar",
        value: function renderSidebar() {
            var _props3 = this.props,
                userIsAtReviewStep = _props3.userIsAtReviewStep,
                checkout = _props3.viewer.checkout;

            var shouldHideSidebarOnReview = this.state.shouldHideSidebarOnReview && userIsAtReviewStep;
            return React.createElement(velocity_react_1.VelocityComponent, { animation: {
                    opacity: shouldHideSidebarOnReview ? 0 : 1,
                    translateX: shouldHideSidebarOnReview ? 200 : 0
                }, delay: shouldHideSidebarOnReview ? 0 : 150, duration: 250, display: shouldHideSidebarOnReview ? 'none' : 'block' }, React.createElement("aside", Object.assign({}, classes('sidebar')), React.createElement("div", Object.assign({}, classes('help-box')), React.createElement(Heading_1.default, { is: "h4" }, "Need Help?"), React.createElement(Heading_1.default, { is: "h5" }, "Call us toll free at +1 888-423-6665 (NA) / +33 1 70 38 73 50 (EU)"), React.createElement(Button_1.default, { className: "sample-license-button", hyperLinkProps: {
                    href: 'https://assets.boppermusic.com/docs/Bopper_Sample_License.pdf',
                    target: '_blank'
                }, wrapperComponent: "a", colorScheme: "light", variant: "pill", size: "small", label: "Preview License" })), React.createElement(CheckoutSummary_1.default, { order: checkout }), React.createElement(CheckoutPromoCode_1.default, null)));
        }
    }, {
        key: "render",
        value: function render() {
            var shouldHideSidebarOnReview = this.state.shouldHideSidebarOnReview && this.props.userIsAtReviewStep;
            var extraClasses = classNames({ 'review-step': shouldHideSidebarOnReview });
            return React.createElement(Page_1.default, { id: "checkout", className: extraClasses }, !this.state.redirecting && React.createElement(React.Fragment, null, !this.props.readyToPlaceOrder && React.createElement(PageHeader_1.default, { title: "Checkout", withCurrencySelect: true }), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div" }, classes('content-wrapper'), { enter: { animation: 'transition.expandIn', duration: 1000, delay: 750, display: 'flex' } }), this.props.readyToPlaceOrder ? React.createElement("div", Object.assign({ key: "checkout-processing" }, classes('content', 'processing')), React.createElement(LoadingSpinner_1.default, null), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('title')), "Thank you for your business!"), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), "Processing your license...")) : React.createElement("div", Object.assign({ key: "checkout-form" }, classes('content')), this.renderSteps(), this.renderSidebar()))), React.createElement(WindowSizeListener, { onResize: this.onResize }));
        }
    }]);

    return CheckoutPage;
}(React.Component);

var ConnectedCheckoutPage = react_redux_1.connect(function (state) {
    return {
        billingAddress: selectors_1.getBillingAddress(state),
        readyToPlaceOrder: checkout_2.isReadyToPlaceOrder(state),
        userIsAtReviewStep: checkout_2.isActiveStep(config_1.CheckoutStepId.review)(state)
    };
}, function (dispatch, ownProps) {
    return {
        dispatch: dispatch,
        fetchCountries: function fetchCountries() {
            return dispatch(countries_1.requestFetchCountries(promise_1.emptyPromiseActionPayload));
        },
        initHeader: function initHeader() {
            dispatch(ui_1.setHeaderType({ type: 'simple' }));
            dispatch(ui_1.setHeaderActions({
                actions: [React.createElement(LinkButton_1.default, { to: Cart_1.CartPagePath, label: "Back", size: "small-medium" }), React.createElement(UserProfile_1.default, { profile: ownProps.viewer.profile })]
            }));
        },
        placeOrder: function placeOrder() {
            return new Promise(function (resolve, reject) {
                dispatch(checkout_1.requestPlaceOrder({ promise: { resolve: resolve, reject: reject } }));
            });
        },
        resetHeader: function resetHeader() {
            dispatch(ui_1.setHeaderActions({ actions: defaultList }));
            dispatch(ui_1.setHeaderType({ type: 'simple' }));
        },
        retrieveFromLocalStorage: function retrieveFromLocalStorage() {
            return dispatch(checkout_1.requestSetCheckoutFromLocalStorage());
        }
    };
})(CheckoutPage);
var RelayCheckoutPage = react_relay_1.createRefetchContainer(ConnectedCheckoutPage, checkout_3.checkoutFragment, checkout_3.CheckoutPageQuery);
var CheckoutPageWithStripe = react_stripe_elements_1.injectStripe(RelayCheckoutPage);
function CheckoutWithStripe(_a) {
    var scriptsLoadedSuccessfully = _a.scriptsLoadedSuccessfully,
        props = __rest(_a, ["scriptsLoadedSuccessfully"]);
    return scriptsLoadedSuccessfully ? React.createElement(react_stripe_elements_1.StripeProvider, { apiKey: props.viewer.stripe.public_key }, React.createElement(react_stripe_elements_1.Elements, null, React.createElement(CheckoutPageWithStripe, Object.assign({}, props)))) : null;
}
var CheckoutWithStripeLoader = react_script_loader_hoc_1.default('https://js.stripe.com/v3/')(CheckoutWithStripe);
exports.default = CheckoutWithStripeLoader;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Checkout
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.CheckoutPageQuery = function () {
  return __webpack_require__(1441);
};
exports.checkoutFragment = {
  viewer: function viewer() {
    return __webpack_require__(1442);
  }
};
exports.CheckoutAttributesQuery = function () {
  return __webpack_require__(1443);
};
exports.checkoutAttributesFragment = {
  viewer: function viewer() {
    return __webpack_require__(1444);
  }
};
exports.AddPromoCodeMutation = function () {
  return __webpack_require__(1445);
};
exports.DeletePromoCodeMutation = function () {
  return __webpack_require__(1446);
};
exports.PlaceOrderMutation = function () {
  return __webpack_require__(1447);
};

/***/ }),
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Card Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var actions = __webpack_require__(29);
var player_1 = __webpack_require__(154);
var projects_1 = __webpack_require__(295);
var ui_1 = __webpack_require__(294);
var string_1 = __webpack_require__(47);
var track_1 = __webpack_require__(44);
__webpack_require__(1476);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_hover_observer_1 = __webpack_require__(1478);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var velocity_react_1 = __webpack_require__(19);
var AddToProjectButton_1 = __webpack_require__(423);
var Button_1 = __webpack_require__(10);
var DownloadButton_1 = __webpack_require__(296);
var FindSimilarButton_1 = __webpack_require__(642);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var grid_1 = __webpack_require__(58);
var DropdownMenu_1 = __webpack_require__(297);
var ThumbnailWithPlayButton_1 = __webpack_require__(298);
var selectors_1 = __webpack_require__(1563);
var classes = new BEM('card');
var defaultList = [];

var Card = function (_React$Component) {
    _inherits(Card, _React$Component);

    function Card(props) {
        _classCallCheck(this, Card);

        var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

        _this.onClickContent = function (e) {
            var _this$props = _this.props,
                hideDetails = _this$props.hideDetails,
                isSelected = _this$props.isSelected,
                onClick = _this$props.onClick,
                showDetails = _this$props.showDetails,
                trackId = _this$props.trackId;

            if (trackId) {
                isSelected ? hideDetails() : showDetails();
            } else if (onClick) {
                onClick();
            }
        };
        // Unused. Why?
        _this.onClickPlayButton = function () {
            _this.props.isPlaying ? _this.props.pause() : _this.props.play();
        };
        _this.onClickMoreButton = function () {
            _this.props.showDetails();
        };
        _this.onClickCardOptionProxy = function (func) {
            return function (e) {
                e.stopPropagation();
                if (func) {
                    func();
                }
            };
        };
        _this.onToggleDropdownMenu = function (downloadMenuOpen) {
            _this.setState({ downloadMenuOpen: downloadMenuOpen });
        };
        _this.state = {
            downloadMenuOpen: false,
            isAnimatingOverflow: false,
            isShrinked: false
        };
        return _this;
    }

    _createClass(Card, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            // Very fragile and unclear logic was commented out (see below)
            return true;
            // // Avoid updating the components uselessly when random mock data gets updated
            // for (const key in nextProps) {
            //   if (['image', 'description', 'play', 'pause', 'hideDetails', 'showDetails'].indexOf(String(key)) === -1) {
            //     if (!isEqual(nextProps[key], this.props[key])) {
            //       return true;
            //     }
            //   }
            // }
            // return !isEqual(nextState, this.state);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            var mouseEnter = !prevProps.isHovering && this.props.isHovering;
            var mouseLeave = prevProps.isHovering && !this.props.isHovering;
            if (mouseEnter || this.props.isHovering && this.state.isShrinked !== prevState.isShrinked) {
                this.checkForTitleOverflowTimer = window.setTimeout(function () {
                    _this2.checkForTitleOverflowTimer = null;
                    _this2.checkForTitleOverflow();
                }, 500);
            } else if (mouseLeave) {
                if (this.state.isAnimatingOverflow) {
                    this.setState({
                        isAnimatingOverflow: false
                    });
                } else {
                    window.clearTimeout(this.checkForTitleOverflowTimer);
                    this.checkForTitleOverflowTimer = null;
                }
            } else {
                // If is animating title overflow
                if (!prevState.isAnimatingOverflow && this.state.isAnimatingOverflow) {
                    this.animateTitleOverflow();
                } else if (prevState.isAnimatingOverflow && !this.state.isAnimatingOverflow) {
                    Velocity(this.titleLabel, 'stop');
                    this.titleLabel.removeAttribute('style');
                }
                var cardWidth = this.card.getBoundingClientRect().width;
                if (!this.state.isShrinked && cardWidth < 300) {
                    this.setState({ isShrinked: true });
                } else if (this.state.isShrinked && cardWidth >= 300) {
                    this.setState({ isShrinked: false });
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.checkForTitleOverflowTimer = null;
        }
    }, {
        key: "getCardTitle",
        value: function getCardTitle() {
            var _this3 = this;

            var _props = this.props,
                size = _props.size,
                title = _props.title;

            var titleHeading = void 0;
            switch (size) {
                case 'medium':
                    titleHeading = 'h4';
                    break;
                default:
                    titleHeading = 'h5';
                    break;
            }
            var props = Object.assign({ is: titleHeading, text: title }, classes('title'));
            return React.createElement(Heading_1.default, Object.assign({ ref: function ref(node) {
                    return _this3.title = react_dom_1.findDOMNode(node);
                } }, props));
        }
    }, {
        key: "getCardSubtitle",
        value: function getCardSubtitle() {
            var _props2 = this.props,
                size = _props2.size,
                subtitle = _props2.subtitle;

            var subtitleSize = void 0;
            switch (size) {
                case 'xlarge':
                    subtitleSize = 'medium';
                    break;
                default:
                    subtitleSize = size;
                    break;
            }
            return React.createElement(Label_1.Span, Object.assign({ text: subtitle, size: subtitleSize, textColor: "bw7" }, classes('subtitle')));
        }
    }, {
        key: "getCardPriceElement",
        value: function getCardPriceElement() {
            var PriceElement = this.props.PriceElement;

            return PriceElement ? React.cloneElement(PriceElement, Object.assign({}, PriceElement.props, { className: classNames(PriceElement.props.className, 'card__price-element') })) : null;
        }
    }, {
        key: "getCardDescription",
        value: function getCardDescription() {
            var _props3 = this.props,
                description = _props3.description,
                size = _props3.size;

            if (size === 'small' && this.state.isShrinked) {
                return;
            }
            var descriptionSize = size === 'medium' ? 'large' : 'medium';
            return description && React.createElement(Label_1.Span, Object.assign({ text: description, variant: "description", size: descriptionSize, textColor: "bw6" }, classes('description')));
        }
    }, {
        key: "getCardOptions",
        value: function getCardOptions() {
            var _this4 = this;

            var _props4 = this.props,
                actionSource = _props4.actionSource,
                options = _props4.options,
                trackResult = _props4.trackResult;

            var buttonProps = {
                variant: 'icon',
                size: 'small',
                className: 'card__option'
            };
            var downloadableAsset = track_1.getDefaultTrackAsset(trackResult.assets);
            var versions = track_1.getTrackAssets({
                assets: trackResult.assets || defaultList,
                format: 'mp3',
                type: 'track-preview'
            });
            var optionPriceElement = options.indexOf('PriceElement') > -1;
            var optionAddToProject = options.indexOf('AddToProject') > -1;
            var optionShowDetails = options.indexOf('ShowDetails') > -1;
            var optionDownload = options.indexOf('Download') > -1;
            var optionFindSimilar = options.indexOf('FindSimilar') > -1;
            var optionEditLicense = lodash_1.find(options, { option: 'EditLicense' });
            var optionRemoveFromCart = lodash_1.find(options, { option: 'RemoveFromCart' });
            var optionRemoveFromProject = lodash_1.find(options, { option: 'RemoveFromProject' });
            return React.createElement("div", Object.assign({ key: "card-options" }, classes('options')), optionAddToProject && React.createElement("div", null, versions.length > 1 ? React.createElement(DropdownMenu_1.default, { align: "left", Button: React.createElement(Button_1.default, Object.assign({ icon: this.props.isInProjects ? React.createElement(Icon_1.IconProjectSelected, null) : React.createElement(Icon_1.IconProject, null) }, buttonProps, { className: "card__option card__add-to-project" })), options: versions.map(function (asset) {
                    return React.createElement(AddToProjectButton_1.default, Object.assign({ key: "save-" + asset.version, showIcon: false, trackId: trackResult.id, trackVersion: asset.version, label: string_1.capitalizeString(asset.version), onClick: _this4.onClickCardOptionProxy() }, buttonProps));
                }), requestClose: this.state.downloadMenuOpen === false || !this.props.isHovering, disableOnClickOutside: this.state.downloadMenuOpen === false, onToggle: this.onToggleDropdownMenu }) : React.createElement(AddToProjectButton_1.default, Object.assign({ label: "", trackId: trackResult.id, onClick: this.onClickCardOptionProxy() }, buttonProps, { className: "card__option card__add-to-project" }))), optionShowDetails && React.createElement(Button_1.default, Object.assign({ title: "More Info", icon: React.createElement(Icon_1.IconMore, null) }, buttonProps)), optionFindSimilar && React.createElement(FindSimilarButton_1.FindSimilarButton, { actionSource: actionSource, track: this.props.trackResult, colorScheme: "black-outline", variant: "pill", size: "xsmall", className: "card__option card__find-similar" }), optionEditLicense && (optionEditLicense.element ? React.cloneElement(optionEditLicense.element, Object.assign({}, optionEditLicense.element.props, buttonProps)) : React.createElement(Button_1.default, Object.assign({ onClick: optionEditLicense.listener ? this.onClickCardOptionProxy(optionEditLicense.listener) : undefined, icon: React.createElement(Icon_1.IconEdit, null) }, buttonProps))), optionDownload && React.createElement(velocity_react_1.VelocityComponent, { animation: "fadeIn", duration: 300, runOnMount: true }, versions.length > 1 ? React.createElement(DropdownMenu_1.default, { align: "right", Button: React.createElement(Button_1.default, Object.assign({ icon: React.createElement(Icon_1.IconDownload, null) }, buttonProps)), options: versions.map(function (asset) {
                    return React.createElement(DownloadButton_1.default, { key: "download-" + asset.version, icon: React.createElement(Icon_1.IconMusicNote, null), label: string_1.capitalizeString(asset.version), assetPath: asset.path, stopPropagationOnClick: true, track: trackResult });
                }), requestClose: this.state.downloadMenuOpen === false || !this.props.isHovering, disableOnClickOutside: this.state.downloadMenuOpen === false, onToggle: this.onToggleDropdownMenu, className: "card__option card__download" }) : React.createElement(DownloadButton_1.default, Object.assign({ assetPath: downloadableAsset.path, stopPropagationOnClick: true, track: trackResult }, buttonProps, { className: "card__option card__download" }))), optionRemoveFromCart && React.createElement(Button_1.default, Object.assign({ onClick: optionRemoveFromCart.listener ? this.onClickCardOptionProxy(optionRemoveFromCart.listener) : undefined, icon: React.createElement(Icon_1.IconTrash, null), dangerous: true }, buttonProps)), optionRemoveFromProject && React.createElement(velocity_react_1.VelocityComponent, { animation: "fadeIn", duration: 250, runOnMount: true }, React.createElement(Button_1.default, Object.assign({ onClick: optionRemoveFromProject.listener ? this.onClickCardOptionProxy(optionRemoveFromProject.listener) : undefined, icon: React.createElement(Icon_1.IconTrash, null), dangerous: true }, buttonProps))), optionPriceElement && this.getCardPriceElement());
        }
    }, {
        key: "getCardImage",
        value: function getCardImage() {
            var _props5 = this.props,
                image = _props5.image,
                imageType = _props5.imageType,
                size = _props5.size,
                trackId = _props5.trackId,
                trackResult = _props5.trackResult;

            var imageSrc = typeof image === 'string' ? { src: image } : { responsiveAssets: image };
            return trackId ? React.createElement(ThumbnailWithPlayButton_1.default, Object.assign({ responsive: true, shape: imageType, size: size, trackId: trackId, trackResult: trackResult, onClick: this.props.showDetails, withShadow: true }, classes('image'), imageSrc)) : React.createElement(Thumbnail_1.default, Object.assign({ size: size, onClick: this.props.showDetails, withShadow: true }, classes('image'), imageSrc));
        }
    }, {
        key: "getCardContent",
        value: function getCardContent(side) {
            var _this5 = this;

            var _props6 = this.props,
                alwaysDisplayOptions = _props6.alwaysDisplayOptions,
                isHovering = _props6.isHovering,
                size = _props6.size;

            var showTitle = size === 'xlarge' ? !isHovering : true;
            if (side === 'left') {
                return React.createElement("div", Object.assign({}, classes('content__left')), showTitle && this.getCardTitle(), showTitle && this.getCardSubtitle(), size === 'medium' && this.getCardDescription());
            }
            // Right Side
            var contentRightProps = Object.assign({}, classes('content__right', '', { hover: alwaysDisplayOptions || isHovering }), { ref: function ref(node) {
                    return _this5.options = react_dom_1.findDOMNode(node);
                } });
            return React.createElement("div", Object.assign({}, contentRightProps), this.getCardOptions());
        }
    }, {
        key: "render",
        value: function render() {
            var _this6 = this;

            var _props7 = this.props,
                backgroundColor = _props7.backgroundColor,
                className = _props7.className,
                isHovering = _props7.isHovering,
                isInProjects = _props7.isInProjects,
                isPlaying = _props7.isPlaying,
                isSelected = _props7.isSelected,
                listened = _props7.listened,
                options = _props7.options,
                size = _props7.size,
                showListenedStatus = _props7.showListenedStatus;
            var isAnimatingOverflow = this.state.isAnimatingOverflow;

            var classModifiers = _defineProperty({
                'hover': isHovering,
                'animating-overflow': isAnimatingOverflow,
                'is-playing': isPlaying,
                'is-selected': isSelected,
                'listened': !!listened && !!showListenedStatus
            }, size, true);
            var extraClasses = classNames(backgroundColor && "with-bgcolor--" + (!isPlaying && listened && showListenedStatus ? 'bw3' : backgroundColor), className);
            var hasAddToProjectOption = options.indexOf('AddToProject') > -1;
            var shouldDisplayInProjectIndicator = isInProjects && hasAddToProjectOption && !isHovering;
            return React.createElement("div", Object.assign({}, classes('', classModifiers, extraClasses), { ref: function ref(node) {
                    return _this6.card = node;
                } }), React.createElement("div", Object.assign({}, classes('background'))), React.createElement("div", Object.assign({}, classes('wrapper')), this.getCardImage(), React.createElement("div", Object.assign({}, classes('content'), { ref: function ref(node) {
                    return _this6.content = node;
                }, onClick: this.onClickContent }), this.getCardContent('left'), this.getCardContent('right'))), shouldDisplayInProjectIndicator && React.createElement(Icon_1.IconProjectSelected, Object.assign({}, classes('in-project-indicator'))));
        }
    }, {
        key: "checkForTitleOverflow",
        value: function checkForTitleOverflow() {
            if (this.title) {
                if (this.getTitleTextOverflow() > 0) {
                    this.setState({
                        isAnimatingOverflow: true
                    });
                }
            }
        }
    }, {
        key: "animateTitleOverflow",
        value: function animateTitleOverflow(loop) {
            var _this7 = this;

            var translation = this.getTitleTextOverflow() + 10;
            var duration = lodash_1.clamp(translation / 100 * 3500, 0, 2000);
            var target = this.getTitleLabel();
            Velocity.RunSequence([{
                e: target,
                p: { translateX: [-translation, 0] },
                o: { delay: loop ? 1000 : 250, duration: duration, easing: 'easeInOutSine' }
            }, {
                e: target,
                p: { translateX: 0 },
                o: {
                    delay: 250,
                    duration: duration,
                    easing: 'easeInOutSine',
                    complete: function complete() {
                        if (_this7.props.isHovering) {
                            _this7.animateTitleOverflow(true);
                        }
                    }
                }
            }]);
        }
    }, {
        key: "getTitleLabel",
        value: function getTitleLabel() {
            if (!this.titleLabel) {
                this.titleLabel = this.title.getElementsByClassName('label')[0];
            }
            return this.titleLabel;
        }
    }, {
        key: "getTitleTextOverflow",
        value: function getTitleTextOverflow() {
            var titleLabel = this.getTitleLabel();
            if (!this.title) {
                return 0;
            }
            var contentWidth = this.content.getBoundingClientRect().width;
            var labelWidth = titleLabel.getBoundingClientRect().width;
            var optionsWidth = grid_1.baseline * 2; // padding for gradient
            if (this.options) {
                optionsWidth += this.options.getBoundingClientRect().width;
            }
            return labelWidth - (contentWidth - optionsWidth);
        }
    }]);

    return Card;
}(React.Component);

Card.defaultProps = {
    imageType: 'square',
    options: ['PriceElement', 'AddToProject', 'ShowDetails', 'FindSimilar'],
    size: 'small',
    showListenedStatus: true
};
var makeMapStateToProps = function makeMapStateToProps() {
    var isTrackPlaying = player_1.makeIsTrackPlaying();
    var isCardSelected = selectors_1.makeIsCardSelected();
    var isTrackInProject = projects_1.makeIsTrackInProjects(false);
    var isTrackListened = player_1.makeIsTrackListened();
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            isInProjects: isTrackInProject(state, props),
            isPlaying: isTrackPlaying(state, props),
            isSelected: isCardSelected(state, props),
            listened: isTrackListened(state, props),
            trackDetailsIsVisible: ui_1.trackDetailsPanelIsVisible(state)
        };
    };
    return mapStateToProps;
};
var ConnectedCard = react_redux_1.connect(makeMapStateToProps, function (dispatch, _ref) {
    var license = _ref.license,
        trackId = _ref.trackId,
        trackResult = _ref.trackResult;
    return {
        play: function play() {
            return dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        },
        pause: function pause() {
            return dispatch(playerActions.pause());
        },
        hideDetails: function hideDetails() {
            return dispatch(actions.toggleTrackDetailsVisibility(false));
        },
        showDetails: function showDetails() {
            return dispatch(actions.showTrackDetails({ license: license, trackInfo: trackResult }));
        }
    };
})(Card);
var CardWithHoverObserver = function CardWithHoverObserver(_a) {
    var className = _a.className,
        cardProps = __rest(_a, ["className"]);
    return React.createElement(react_hover_observer_1.default, { hoverDelayInMs: 16, className: className }, function (_ref2) {
        var isHovering = _ref2.isHovering;
        return React.createElement(ConnectedCard, Object.assign({}, cardProps, { isHovering: isHovering }));
    });
};
exports.default = CardWithHoverObserver;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * UI Selectors/Helpers
 */

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getUIState = function (_ref) {
    var ui = _ref.ui;
    return ui;
};
exports.getTrackDetailsTrackInfo = reselect_1.createSelector(exports.getUIState, function (_ref2) {
    var trackDetails = _ref2.trackDetails;

    if (trackDetails && trackDetails.trackInfo) {
        return trackDetails.trackInfo;
    }
    return undefined;
});
exports.getAddToProjectTrackId = reselect_1.createSelector(exports.getUIState, function (_ref3) {
    var addToProject = _ref3.addToProject;

    if (addToProject && addToProject.trackId) {
        return addToProject.trackId;
    }
    return undefined;
});
exports.uiComponentIsVisible = function (component) {
    return reselect_1.createSelector(exports.getUIState, function (state) {
        var Component = state[component];
        return !!Component && Component.visible;
    });
};
exports.trackDetailsPanelIsVisible = exports.uiComponentIsVisible('trackDetails');
exports.addToProjectPanelIsVisible = exports.uiComponentIsVisible('addToProject');

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Projects Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var track_1 = __webpack_require__(44);
var player_1 = __webpack_require__(154);
var ui_1 = __webpack_require__(294);
var lodash_1 = __webpack_require__(6);
var reselect_1 = __webpack_require__(49);
exports.getProjects = function (_ref) {
    var projects = _ref.projects;
    return projects;
};
exports.isTrackInProjects = function (projects, trackId) {
    return !!projects && !!trackId && lodash_1.some(projects, function (project) {
        return project.indexOf(trackId) > -1;
    });
};
exports.isCurrentPlayingTrackInProject = reselect_1.createSelector([exports.getProjects, player_1.getPlayerState], function (projects, _ref2) {
    var currentTrack = _ref2.currentTrack;

    if (!currentTrack) {
        return false;
    }
    return exports.isTrackInProjects(projects, currentTrack.trackInfo.id);
});
exports.makeIsTrackInProjects = function () {
    var withTrackId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var trackIdSelector = withTrackId ? track_1.getTrackIdFromProps : track_1.getTrackFromProps;
    // tslint:disable-next-line:max-line-length
    return reselect_1.createSelector([exports.getProjects, trackIdSelector], function (projects, track) {
        return track ? exports.isTrackInProjects(projects, typeof track === 'string' ? track : track.id) : false;
    });
};
exports.isAddToProjectOpen = reselect_1.createSelector([ui_1.addToProjectPanelIsVisible, ui_1.getAddToProjectTrackId, player_1.getPlayerState], function (isVisible, trackId, _ref3) {
    var currentTrack = _ref3.currentTrack;

    return isVisible && !!trackId && !!currentTrack && trackId === currentTrack.trackId;
});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DownloadButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var router_1 = __webpack_require__(27);
__webpack_require__(1486);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var download_1 = __webpack_require__(424);
var download_2 = __webpack_require__(402);
var Icon_1 = __webpack_require__(12);
var Button_1 = __webpack_require__(10);
var classes = new BEM('download-button');
// tslint:disable-next-line:no-invalid-template-strings
exports.downloadPathTemplate = lodash_1.template('/${path}?download');

var DownloadButton = function (_React$Component) {
    _inherits(DownloadButton, _React$Component);

    function DownloadButton(props) {
        _classCallCheck(this, DownloadButton);

        var _this = _possibleConstructorReturn(this, (DownloadButton.__proto__ || Object.getPrototypeOf(DownloadButton)).call(this, props));

        _this.onClickRequestDownload = function () {
            if (_this.props.onDownloadRequest) {
                _this.props.onDownloadRequest();
            }
            nextTick(function () {
                _this.props.signUpAndDownloadTrack(_this.state.downloadPath);
            });
        };
        _this.onClickDownload = function () {
            _this.props.setDownloadFilePath(_this.state.downloadPath, _this.props.track);
        };
        _this.onClick = function (e) {
            if (_this.props.stopPropagationOnClick) {
                e.stopPropagation();
            }
            if (!_this.props.isUserLoggedIn) {
                _this.onClickRequestDownload();
            } else if (_this.props.showAgreementModal) {
                _this.onClickDownload();
            } else {
                _this.props.sendDownloadTrackEvent();
            }
            if (_this.props.onClick) {
                e.persist();
                _this.props.onClick(e);
            }
        };
        _this.state = {
            downloadPath: exports.downloadPathTemplate({ path: _this.props.assetPath })
        };
        return _this;
    }

    _createClass(DownloadButton, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                className = _a.className,
                assetPath = _a.assetPath,
                isUserLoggedIn = _a.isUserLoggedIn,
                label = _a.label,
                location = _a.location,
                onClick = _a.onClick,
                onDownloadRequest = _a.onDownloadRequest,
                sendDownloadTrackEvent = _a.sendDownloadTrackEvent,
                setDownloadFilePath = _a.setDownloadFilePath,
                showAgreementModal = _a.showAgreementModal,
                stopPropagationOnClick = _a.stopPropagationOnClick,
                signUpAndDownloadTrack = _a.signUpAndDownloadTrack,
                track = _a.track,
                buttonProps = __rest(_a, ["className", "assetPath", "isUserLoggedIn", "label", "location", "onClick", "onDownloadRequest", "sendDownloadTrackEvent", "setDownloadFilePath", "showAgreementModal", "stopPropagationOnClick", "signUpAndDownloadTrack", "track"]);
            var buttonLabel = !buttonProps.variant || buttonProps.variant !== 'icon' ? label : undefined;
            return showAgreementModal || !isUserLoggedIn ? React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, label: buttonLabel, icon: React.createElement(Icon_1.IconDownload, null) }, classes('', '', className), buttonProps)) : React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, hyperLinkProps: {
                    href: this.state.downloadPath
                }, wrapperComponent: "a", label: buttonLabel, icon: React.createElement(Icon_1.IconDownload, null) }, classes('', '', className), buttonProps));
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.assetPath !== prevState.downloadPath) {
                return {
                    downloadPath: exports.downloadPathTemplate({ path: nextProps.assetPath })
                };
            }
            return null;
        }
    }]);

    return DownloadButton;
}(React.Component);

DownloadButton.defaultProps = {
    label: 'Download Preview MP3'
};
var ConnectedDownloadButton = react_redux_1.connect(function (state) {
    return {
        location: state.found.match.location,
        isUserLoggedIn: state.user.isLoggedIn
    };
}, function (dispatch, props) {
    return {
        sendDownloadTrackEvent: function sendDownloadTrackEvent() {
            return dispatch(download_2.downloadTrack({ track: props.track }));
        },
        signUpAndDownloadTrack: function signUpAndDownloadTrack(path, location) {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestDownload({
                path: path,
                page: router_1.createHref(location),
                // Full track search result is too big to pass as post-authentication
                // state, so we only take the essensials
                track: {
                    title: props.track.title,
                    artist: props.track.artist ? { name: props.track.artist.name } : undefined
                }
            }));
            nextTick(function () {
                return dispatch(ui_1.showSignUpForm({ reason: 'download' }));
            });
        }
    };
}, function (stateProps, _a, ownProps) {
    var sendDownloadTrackEvent = _a.sendDownloadTrackEvent,
        dispatchProps = __rest(_a, ["sendDownloadTrackEvent"]);
    return Object.assign({}, stateProps, ownProps, { sendDownloadTrackEvent: sendDownloadTrackEvent, signUpAndDownloadTrack: function signUpAndDownloadTrack(path) {
            dispatchProps.signUpAndDownloadTrack(path, stateProps.location);
        } });
})(DownloadButton);
var DownloadButtonWithDownloadContext = function DownloadButtonWithDownloadContext(props) {
    return React.createElement(download_1.DownloadContext.Consumer, null, function (_ref) {
        var agreementVisibility = _ref.agreementVisibility,
            setFilePath = _ref.setFilePath;

        return React.createElement(ConnectedDownloadButton, Object.assign({ setDownloadFilePath: setFilePath, showAgreementModal: agreementVisibility }, props));
    });
};
exports.SignUpGuardedDownloadButton = DownloadButtonWithDownloadContext;
exports.default = DownloadButtonWithDownloadContext;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DropdownMenu Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1488);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_onclickoutside_1 = __webpack_require__(643);
var velocity_react_1 = __webpack_require__(19);
var classes = new BEM('dropdown-menu');

var DropdownMenu = function (_React$Component) {
    _inherits(DropdownMenu, _React$Component);

    function DropdownMenu(props) {
        _classCallCheck(this, DropdownMenu);

        var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

        _this.dropdownButton = React.createRef();
        _this.onClickDropDownButton = function (e) {
            e.stopPropagation();
            _this.toggleMenu();
        };
        _this.handleClickOutside = function () {
            _this.toggleMenu(false);
        };
        _this.state = {
            active: false
        };
        return _this;
    }

    _createClass(DropdownMenu, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!!!prevProps.requestClose && !!this.props.requestClose) {
                if (this.state.active) {
                    this.toggleMenu(false, false);
                }
            }
        }
    }, {
        key: "toggleMenu",
        value: function toggleMenu() {
            var _this2 = this;

            var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.active;
            var triggerToggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.setState({ active: active }, function () {
                if (_this2.props.onToggle && triggerToggle) {
                    _this2.props.onToggle(_this2.state.active);
                }
            });
        }
    }, {
        key: "renderMenu",
        value: function renderMenu() {
            var _modifiers,
                _this3 = this;

            var modifiers = (_modifiers = {}, _defineProperty(_modifiers, this.props.align, true), _defineProperty(_modifiers, this.props.menu, true), _modifiers);
            return React.createElement("div", Object.assign({ onClick: this.handleClickOutside }, classes('', modifiers)), this.props.options.map(function (option, index) {
                if (option === '-') {
                    return React.createElement("div", Object.assign({ key: "sep-" + index }, classes('sep')));
                }
                var OptionButton = React.cloneElement(option, {
                    onClick: function onClick(e) {
                        e.persist();
                        _this3.toggleMenu(false);
                        if (option.props.onClick) {
                            option.props.onClick(e);
                        }
                    },
                    className: classNames('dropdown-menu__option-button', option.props.className)
                });
                return OptionButton;
            }));
        }
    }, {
        key: "render",
        value: function render() {
            var active = this.state.active;

            var DropdownButton = React.cloneElement(this.props.Button, Object.assign({}, this.props.Button.props, { ref: this.dropdownButton, onClick: this.onClickDropDownButton }, classes('dropdown-button', '', classNames(this.props.Button.props.className, active ? 'button--is-active' : '', this.props.className))));
            return React.createElement("div", Object.assign({}, classes('wrapper')), DropdownButton, React.createElement(velocity_react_1.VelocityComponent, { animation: active ? 'transition.slideDownIn' : 'transition.fadeOut', duration: 150, display: active ? 'block' : 'none' }, this.renderMenu()));
        }
    }]);

    return DropdownMenu;
}(React.Component);

DropdownMenu.defaultProps = {
    align: 'left'
};
var DropdownMenuWithOnClickOutside = react_onclickoutside_1.default(DropdownMenu);
exports.default = DropdownMenuWithOnClickOutside;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ThumbnailWithPlayButton Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var player_1 = __webpack_require__(154);
var react_redux_1 = __webpack_require__(5);
var component_1 = __webpack_require__(1490);
var player_2 = __webpack_require__(63);
var makeMapStateToProps = function makeMapStateToProps() {
    var isTrackPlaying = player_1.makeIsTrackPlaying();
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            isPlaying: isTrackPlaying(state, props)
        };
    };
    return mapStateToProps;
};
var ConnectedThumbnailWithPlayButton = react_redux_1.connect(makeMapStateToProps, function (dispatch, _ref) {
    var trackId = _ref.trackId,
        trackResult = _ref.trackResult;
    return {
        play: function play() {
            if (trackResult) {
                // Ensure that the clicked track is in the queue, which is not guaranteed to be the case.
                // E.g. similar tracks on the search results page aren't automatically added to the queue.
                dispatch(playerActions.addTracksToQueue({ tracks: player_2.getPlayerTracksFromResults([trackResult]) }));
            }
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        },
        pause: function pause() {
            return dispatch(playerActions.pause());
        }
    };
}, null, {
    areStatesEqual: function areStatesEqual(next, prev) {
        return next.player.isTrackPlaying === prev.player.isTrackPlaying && !!next.player.currentTrack && !!prev.player.currentTrack && next.player.currentTrack.trackId === prev.player.currentTrack.trackId;
    }
})(component_1.default);
exports.default = ConnectedThumbnailWithPlayButton;

/***/ }),
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SessionLicenseBuilderButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var _1 = __webpack_require__(225);

var SessionLicenseBuilderButton = function (_React$Component) {
    _inherits(SessionLicenseBuilderButton, _React$Component);

    function SessionLicenseBuilderButton() {
        _classCallCheck(this, SessionLicenseBuilderButton);

        var _this = _possibleConstructorReturn(this, (SessionLicenseBuilderButton.__proto__ || Object.getPrototypeOf(SessionLicenseBuilderButton)).apply(this, arguments));

        _this.onSaveLicense = function (usages) {
            if (usages.length > 0) {
                _this.props.saveLicense(license_1.licenseUsagesToSearchParams(usages));
            } else {
                _this.props.removeLicense();
            }
            if (!!_this.props.onSaveLicense) {
                _this.props.onSaveLicense(usages);
            }
            if (_this.props.onCloseLicenseBuilder) {
                _this.props.onCloseLicenseBuilder();
            }
        };
        return _this;
    }

    _createClass(SessionLicenseBuilderButton, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                dispatch = _a.dispatch,
                license_params = _a.license_params,
                unusedOnSaveLicense = _a.onSaveLicense,
                removeLicense = _a.removeLicense,
                saveLicense = _a.saveLicense,
                buttonProps = __rest(_a, ["dispatch", "license_params", "onSaveLicense", "removeLicense", "saveLicense"]);
            return React.createElement(_1.default, Object.assign({ onSaveLicense: this.onSaveLicense, onOpenLicenseBuilder: this.props.onOpenLicenseBuilder, onCloseLicenseBuilder: this.props.onCloseLicenseBuilder, scope: { type: 'Session' } }, buttonProps));
        }
    }]);

    return SessionLicenseBuilderButton;
}(React.Component);

var ConnectedSessionLicenseBuilderButton = react_redux_1.connect(function (state, ownProps) {
    return {
        usages: selectors_1.licenseUsagesFromQueryStringSelector(state, ownProps)
    };
})(SessionLicenseBuilderButton);
var SessionLicenseBuilderButtonWithContext = function SessionLicenseBuilderButtonWithContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref) {
        var license_params = _ref.license_params,
            removeLicense = _ref.removeLicense,
            saveLicense = _ref.saveLicense;
        return React.createElement(ConnectedSessionLicenseBuilderButton, Object.assign({ license_params: license_params, removeLicense: removeLicense, saveLicense: saveLicense }, props));
    });
};
exports.default = SessionLicenseBuilderButtonWithContext;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.trackSearchQuery = function () {
  return __webpack_require__(1536);
};
exports.trackSearchFragment = {
  viewer: function viewer() {
    return __webpack_require__(1537);
  }
};
exports.taxonomiesFragment = {
  viewer: function viewer() {
    return __webpack_require__(1538);
  }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * OrdersPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(222);
var countries_2 = __webpack_require__(128);
var order_1 = __webpack_require__(654);
var promise_1 = __webpack_require__(419);
var router_1 = __webpack_require__(27);
__webpack_require__(1575);
var classNames = __webpack_require__(15);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var NProgress_1 = __webpack_require__(228);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var PageHeader_1 = __webpack_require__(144);
var NotAuthorized_1 = __webpack_require__(655);
var OrderList_1 = __webpack_require__(1579);
var OrderView_1 = __webpack_require__(1585);
// Page Path
exports.OrdersPagePath = '/my/orders';
exports.OrderPagePath = function (id) {
    return "/my/orders/" + id;
};
var classes = new BEM('orders');

var OrdersPage = function (_React$Component) {
    _inherits(OrdersPage, _React$Component);

    function OrdersPage(props) {
        _classCallCheck(this, OrdersPage);

        var _this = _possibleConstructorReturn(this, (OrdersPage.__proto__ || Object.getPrototypeOf(OrdersPage)).call(this, props));

        _this.onSelectOrder = function (activeOrder) {
            if (activeOrder !== _this.state.activeOrder) {
                _this.setState({ fetching: true });
            }
        };
        _this.state = {
            activeOrder: props.routeParams.invoice_number || '',
            defaultDocument: props.location.query.view || undefined,
            fetching: props.hasOrders,
            settingsPanelOpen: false
        };
        if (_this.props.hasOrders) {
            _this.orders = _this.props.viewer.my_orders;
        }
        return _this;
    }

    _createClass(OrdersPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.hasOrders) {
                this.props.dispatch(countries_1.requestFetchCountries({
                    promise: {
                        resolve: function resolve() {
                            _this2.fetchActiveOrderAddressesStates();
                            _this2.initializeView();
                        },
                        reject: function reject() {
                            return null;
                        }
                    }
                }));
            }
        }
    }, {
        key: "initializeView",
        value: function initializeView() {
            if (!this.state.activeOrder) {
                var defaultInvoiceNumber = "" + this.orders[0].invoice_number;
                this.props.router.replace(router_1.linkWithCurrentQueryString(exports.OrderPagePath(defaultInvoiceNumber)));
            } else {
                this.setState({ fetching: false });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var _this3 = this;

            if (this.hasSwitchedOrder(prevProps)) {
                this.setState({
                    activeOrder: this.props.routeParams.invoice_number
                }, function () {
                    _this3.fetchActiveOrderAddressesStates();
                    _this3.fetchingTimer = window.setTimeout(function () {
                        _this3.setState({ fetching: false });
                    }, 1000);
                });
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            clearTimeout(this.fetchingTimer);
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                currentDocument = _state.currentDocument,
                defaultDocument = _state.defaultDocument,
                fetching = _state.fetching,
                settingsPanelOpen = _state.settingsPanelOpen;
            var _props = this.props,
                activeOrderExists = _props.activeOrderExists,
                hasOrders = _props.hasOrders,
                trackDetailsSidebarIsVisible = _props.trackDetailsSidebarIsVisible,
                userIsLoggedIn = _props.userIsLoggedIn;

            var extraClasses = classNames(settingsPanelOpen && 'settings-open', trackDetailsSidebarIsVisible && 'details-open', !userIsLoggedIn && 'not-authorized', userIsLoggedIn && (!activeOrderExists || !hasOrders) && 'order-not-found');
            if (!userIsLoggedIn) {
                return React.createElement(NotAuthorized_1.default, { message: "You must be logged in to access your orders." });
            }
            return React.createElement(Page_1.default, { id: "orders", className: extraClasses, noIndex: true }, React.createElement(PageHeader_1.default, { title: "My Orders", actions: !!activeOrderExists && React.createElement(Button_1.default, { label: "Print or Save as PDF", disabled: fetching || currentDocument === 'music', colorScheme: "transparent", icon: React.createElement(Icon_1.IconPrint, null), onClick: function onClick() {
                        return nextTick(window.print);
                    } }) }), React.createElement(NProgress_1.default, Object.assign({ active: fetching }, classes('loading-progress'))), React.createElement("div", Object.assign({}, classes('content-wrapper')), hasOrders ? React.createElement(React.Fragment, null, React.createElement(OrderList_1.default, { orders: this.orders, onSelectOrder: this.onSelectOrder }), activeOrderExists ? React.createElement(OrderView_1.default, { defaultDocument: defaultDocument, isFetching: fetching, order: this.getActiveOrder(), onSwitchDocument: function onSwitchDocument(document) {
                    return _this4.setState({ currentDocument: document });
                } }) : !fetching ? React.createElement(Heading_1.default, Object.assign({ is: "h2", textColor: "bw6" }, classes('error-message')), "Order Not Found") : null) : React.createElement(Heading_1.default, Object.assign({ is: "h2", textColor: "bw6" }, classes('error-message', 'no-order')), "You don't have any orders.")));
        }
    }, {
        key: "getActiveOrder",
        value: function getActiveOrder() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.viewer.order;
        }
    }, {
        key: "hasSwitchedOrder",
        value: function hasSwitchedOrder(prevProps) {
            return prevProps.routeParams.invoice_number !== this.props.routeParams.invoice_number;
        }
    }, {
        key: "fetchActiveOrderAddressesStates",
        value: function fetchActiveOrderAddressesStates() {
            if (this.state.activeOrder) {
                var activeOrder = this.getActiveOrder();
                if (activeOrder) {
                    if (activeOrder.licensee_address) {
                        this.props.dispatch(countries_1.requestFetchStatesForCountry(Object.assign({ country: this.props.getCountry(activeOrder.licensee_address.country_code) }, promise_1.emptyPromiseActionPayload)));
                    }
                    if (activeOrder.billing_address) {
                        this.props.dispatch(countries_1.requestFetchStatesForCountry(Object.assign({ country: this.props.getCountry(activeOrder.billing_address.country_code) }, promise_1.emptyPromiseActionPayload)));
                    }
                }
            }
        }
    }]);

    return OrdersPage;
}(React.Component);

var ConnectedOrdersPage = react_redux_1.connect(function (state, ownProps) {
    return {
        activeOrderExists: !!ownProps.routeParams.invoice_number && !!ownProps.viewer.order,
        getCountry: function getCountry(countryCode) {
            return countries_2.getCountryFromCode(countryCode)(state);
        },
        hasOrders: !!ownProps.viewer.my_orders && !!ownProps.viewer.my_orders.length,
        trackDetailsSidebarIsVisible: !!state.ui.trackDetails && state.ui.trackDetails.visible,
        userIsLoggedIn: state.user.isLoggedIn
    };
}, function (dispatch) {
    return { dispatch: dispatch };
})(OrdersPage);
var RelayOrdersPage = react_relay_1.createFragmentContainer(ConnectedOrdersPage, order_1.OrderPageFragment);
exports.default = RelayOrdersPage;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutStep Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var validation_1 = __webpack_require__(659);
var dom_1 = __webpack_require__(304);
__webpack_require__(1615);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var WindowSizeListener = __webpack_require__(124);
var Button_1 = __webpack_require__(10);
var FormError_1 = __webpack_require__(417);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var config_1 = __webpack_require__(80);
var classes = new BEM('checkout__step');

var CheckoutStep = function (_React$Component) {
    _inherits(CheckoutStep, _React$Component);

    function CheckoutStep(props) {
        _classCallCheck(this, CheckoutStep);

        var _this = _possibleConstructorReturn(this, (CheckoutStep.__proto__ || Object.getPrototypeOf(CheckoutStep)).call(this, props));

        _this.select = function () {
            _this.props.setActive();
            if (_this.props.onSelect) {
                _this.props.onSelect();
            }
        };
        _this.onResize = function () {
            if (_this.props.isActive) {
                var contentHeight = dom_1.outerHeight(_this.content);
                if (contentHeight !== _this.contentHeight) {
                    _this.contentHeight = contentHeight;
                    _this.contentWrapper.style.height = _this.contentHeight + "px";
                }
            }
        };
        _this.onSubmit = function (values, dispatch, props) {
            var _this$props = _this.props,
                customValidation = _this$props.customValidation,
                id = _this$props.id,
                isComplete = _this$props.isComplete;

            var validate = customValidation || _this.validate;
            return validate(values, dispatch, props).then(function () {
                return new Promise(function (resolve) {
                    var delay = id === config_1.CheckoutStepId.review ? 2000 : 0;
                    setTimeout(function () {
                        dispatch(checkout_1.completeStep({ id: id }));
                        dispatch(checkout_1.saveCheckoutStepToLocalStorage({ stepForm: _defineProperty({}, id, values) }));
                        resolve();
                    }, delay);
                });
            }).catch(function (err) {
                if (isComplete) {
                    dispatch(checkout_1.removeCompletedStep({ id: id }));
                }
                throw err;
            });
        };
        _this.validate = function (values) {
            return _this.props.formValidations ? validation_1.validateFields(values, _this.props.formValidations, {
                validatePostalCode: [values.hasOwnProperty('postalCodeValidationRegExp') && values.postalCodeValidationRegExp]
            }) : Promise.resolve();
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }

    _createClass(CheckoutStep, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.contentHeight = dom_1.outerHeight(this.content);
            this.isComponentMounted = true;
            this.props.register();
            if (this.props.defaultSelected) {
                this.props.setActive();
            }
            if (this.props.isActive) {
                this.toggleSlide(true, 0);
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var _this2 = this;

            this.onResize();
            if (prevProps.isActive !== this.props.isActive) {
                if (!this.props.isActive) {
                    this.setState({ isOpen: false }, function () {
                        _this2.toggleSlide(_this2.props.isActive);
                    });
                } else {
                    this.toggleSlide(this.props.isActive);
                    if (!this.props.defaultSelected) {
                        this.props.setActive();
                    }
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.isComponentMounted = false;
        }
    }, {
        key: "render",
        value: function render() {
            var _classModifiers,
                _this3 = this;

            var _props = this.props,
                error = _props.error,
                id = _props.id,
                isActive = _props.isActive,
                isComplete = _props.isComplete,
                handleSubmit = _props.handleSubmit,
                showNextStepButton = _props.showNextStepButton,
                submitting = _props.submitting;

            var classModifiers = (_classModifiers = {}, _defineProperty(_classModifiers, id, true), _defineProperty(_classModifiers, 'is-active', !!isActive), _defineProperty(_classModifiers, 'is-complete', !!isComplete), _defineProperty(_classModifiers, 'is-open', this.state.isOpen), _classModifiers);
            return React.createElement("section", Object.assign({}, classes('', classModifiers)), React.createElement("header", Object.assign({}, classes('header'), { onClick: function onClick() {
                    return !isActive && isComplete && _this3.select();
                } }), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('title')), this.props.title), error && React.createElement(FormError_1.default, { error: error }), isComplete && React.createElement("div", Object.assign({}, classes('check-complete')), React.createElement(Icon_1.IconCheck, null))), React.createElement("div", Object.assign({}, classes('content-wrapper'), { ref: function ref(node) {
                    return _this3.contentWrapper = node;
                } }), React.createElement("form", Object.assign({ ref: function ref(node) {
                    return _this3.content = node;
                }, onSubmit: handleSubmit && handleSubmit(this.props.onSubmit || this.onSubmit) }, classes('content')), this.props.children, showNextStepButton !== false && React.createElement("div", Object.assign({}, classes('footer')), React.createElement(Button_1.default, { label: "Next", icon: React.createElement(Icon_1.IconArrowRight, null), iconPosition: "right", colorScheme: "dark", disabled: !!submitting, isSubmit: true })))), React.createElement(WindowSizeListener, { onResize: this.onResize }));
        }
    }, {
        key: "toggleSlide",
        value: function toggleSlide() {
            var _this4 = this;

            var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

            var height = [this.contentHeight, 0];
            if (!toggle) {
                lodash_1.reverse(height);
            }
            Velocity(this.contentWrapper, { height: height }, {
                duration: duration,
                delay: toggle ? 500 : 0,
                easing: 'easeInOutQuint',
                complete: function complete() {
                    if (toggle && _this4.isComponentMounted) {
                        _this4.setState({ isOpen: true });
                    }
                }
            });
        }
    }]);

    return CheckoutStep;
}(React.Component);

var ConnectedCheckoutStep = react_redux_1.connect(function (state, ownProps) {
    return {
        isActive: state.checkout.activeStep === ownProps.id,
        isComplete: state.checkout.completedSteps.indexOf(ownProps.id) > -1
    };
}, function (dispatch, _ref) {
    var id = _ref.id;
    return {
        complete: function complete() {
            return dispatch(checkout_1.completeStep({ id: id }));
        },
        register: function register() {
            return dispatch(checkout_1.registerStep({ id: id }));
        },
        setActive: function setActive() {
            return dispatch(checkout_1.setActiveStep({ id: id }));
        }
    };
})(CheckoutStep);
exports.default = ConnectedCheckoutStep;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DOM Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
function preventDefault(e) {
    e.preventDefault();
}
exports.preventDefault = preventDefault;
function stopPropagation(e) {
    e.stopPropagation();
}
exports.stopPropagation = stopPropagation;
function deactivateTouchMove() {
    document.addEventListener('touchmove', preventDefault, {
        capture: false,
        passive: false
    });
}
exports.deactivateTouchMove = deactivateTouchMove;
function reactivateTouchMove() {
    document.removeEventListener('touchmove', preventDefault);
}
exports.reactivateTouchMove = reactivateTouchMove;
function getRelativeCoordinates(container, e) {
    var pos = {
        x: !!e.touches ? e.touches[0].pageX : e.pageX,
        y: !!e.touches ? e.touches[0].pageY : e.pageY
    };
    var offset = {
        left: container.offsetLeft,
        top: container.offsetTop
    };
    var ref = container.offsetParent;
    while (ref) {
        offset.left += ref.offsetLeft;
        offset.top += ref.offsetTop;
        ref = ref.offsetParent;
    }
    return {
        x: pos.x - offset.left,
        y: pos.y - offset.top
    };
}
exports.getRelativeCoordinates = getRelativeCoordinates;
function outerHeight(el) {
    var height = el.offsetHeight;
    var style = getComputedStyle(el);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
exports.outerHeight = outerHeight;
function isElementUnder(el, parentEl) {
    if (el.parentNode) {
        if (el.parentNode === parentEl) {
            return true;
        }
        return isElementUnder(el.parentNode, parentEl);
    }
    return false;
}
exports.isElementUnder = isElementUnder;
function simulateClick(elem) {
    var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });
    elem.dispatchEvent(evt);
}
exports.simulateClick = simulateClick;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Empty State
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.EmptyStateQuery = function () {
  return __webpack_require__(1629);
};
exports.EmptyStateFragment = {
  viewer: function viewer() {
    return __webpack_require__(1630);
  }
};

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Redux Saga Utils
 */
/* tslint:disable:space-before-function-paren */

Object.defineProperty(exports, "__esModule", { value: true });
var redux_saga_1 = __webpack_require__(73);
var typescript_fsa_redux_saga_1 = __webpack_require__(721);
exports.sagaAsyncActionWorkerFactory = function (action, asynFunc) {
  return typescript_fsa_redux_saga_1.bindAsyncAction(action)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var _redux_saga_1$effects;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_redux_saga_1$effects = redux_saga_1.effects).call.apply(_redux_saga_1$effects, [asynFunc, params].concat(args));

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
};

/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('LocalStorage');
exports.clearLocalStorage = actionCreator('CLEAR_LOCAL_STORAGE');
exports.removeFromLocalStorage = actionCreator('REMOVE_FROM_LOCAL_STORAGE');
exports.saveToLocalStorage = actionCreator('SAVE_TO_LOCAL_STORAGE');
// Async actions
exports.getItemFromLocalStorage = actionCreator.async('GET_ITEM_FROM_LOCAL_STORAGE');

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * User Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getUserState = function (_ref) {
  var user = _ref.user;
  return user;
};
exports.getViewerId = reselect_1.createSelector(exports.getUserState, function (_ref2) {
  var viewerId = _ref2.viewerId;
  return viewerId;
});
exports.getStripeToken = reselect_1.createSelector(exports.getUserState, function (_ref3) {
  var stripeToken = _ref3.stripeToken;
  return stripeToken;
});
exports.isUserLoggedIn = reselect_1.createSelector(exports.getUserState, function (_ref4) {
  var isLoggedIn = _ref4.isLoggedIn;
  return isLoggedIn;
});

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Projects
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.ProjectsQuery = function () {
  return __webpack_require__(1798);
};
exports.SharedProjectPageQuery = function () {
  return __webpack_require__(1799);
};
exports.ProjectListFragment = {
  viewer: function viewer() {
    return __webpack_require__(1800);
  }
};
exports.ShareProjectFragment = {
  viewer: function viewer() {
    return __webpack_require__(1801);
  }
};
exports.ProjectPageFragment = {
  viewer: function viewer() {
    return __webpack_require__(1802);
  }
};
exports.ProjectNode = {
  data: function data() {
    return __webpack_require__(1803);
  }
};
exports.ProjectNodeWithTracks = {
  data: function data() {
    return __webpack_require__(1804);
  }
};
exports.CreateProjectMutation = function () {
  return __webpack_require__(1805);
};
exports.DeleteProjectMutation = function () {
  return __webpack_require__(1806);
};
exports.UpdateProjectMutation = function () {
  return __webpack_require__(1807);
};
exports.JoinProjectMutation = function () {
  return __webpack_require__(1808);
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectsPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var license_1 = __webpack_require__(34);
var player_1 = __webpack_require__(63);
var staticData_1 = __webpack_require__(103);
var project_1 = __webpack_require__(318);
var relay_1 = __webpack_require__(226);
var router_1 = __webpack_require__(27);
var grid_1 = __webpack_require__(58);
var form_1 = __webpack_require__(239);
__webpack_require__(1828);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var LicenseBuilderButton_1 = __webpack_require__(225);
var NProgress_1 = __webpack_require__(228);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Tooltip_1 = __webpack_require__(172);
var PageHeader_1 = __webpack_require__(144);
var CurrencySelect_1 = __webpack_require__(350);
var colors_1 = __webpack_require__(57);
var NotAuthorized_1 = __webpack_require__(655);
var CreateProjectForm_1 = __webpack_require__(1830);
var ProjectList_1 = __webpack_require__(1831);
var ProjectSettings_1 = __webpack_require__(1837);
var ProjectView_1 = __webpack_require__(1850);
// Page Path
exports.ProjectsPagePath = '/my/playlists';
exports.ProjectPagePath = function (id) {
    return "/my/playlists/" + id;
};
var classes = new BEM('projects');
var defaultList = [];
function licenseParamsToUsages(_ref) {
    var licenseComponents = _ref.licenseComponents,
        viewer = _ref.viewer;

    if (viewer.node) {
        return license_1.setLicenseFromParams(licenseComponents, viewer.node.license_params || defaultList);
    }
    return defaultList;
}

var ProjectsPage = function (_React$Component) {
    _inherits(ProjectsPage, _React$Component);

    function ProjectsPage(props) {
        _classCallCheck(this, ProjectsPage);

        var _this = _possibleConstructorReturn(this, (ProjectsPage.__proto__ || Object.getPrototypeOf(ProjectsPage)).call(this, props));

        _this.onSelectProject = function (activeProjectId) {
            if (activeProjectId !== _this.state.activeProjectId) {
                _this.setState({ status: 'fetch' });
            }
        };
        _this.onToggleSettingsPanel = function () {
            _this.setState({ isSettingsPanelOpen: !_this.state.isSettingsPanelOpen });
        };
        _this.closeSettingsPanel = function () {
            _this.setState({ isSettingsPanelOpen: false });
        };
        _this.onCreateProject = function () {
            _this.setState({ status: 'create' });
        };
        _this.onDeleteProject = function () {
            _this.setState({ status: 'delete' });
        };
        _this.onSaveLicense = function (usages) {
            _this.setState({ activeProjectLicense: usages }, function () {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var _getProjectNode, license_params, licenseParams;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _getProjectNode = this.getProjectNode(), license_params = _getProjectNode.license_params;
                                    licenseParams = license_1.licenseUsagesToSearchParams(usages);

                                    if (lodash_1.isEqual(license_params, licenseParams)) {
                                        _context.next = 5;
                                        break;
                                    }

                                    _context.next = 5;
                                    return relay_1.processMutation(project_1.UpdateProjectMutation, {
                                        id: this.state.activeProjectId,
                                        license_params: licenseParams
                                    });

                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
            });
        };
        var activeProject = props.viewer.node;
        var status = false;
        var redirecting = false;
        if (!props.routeParams.id) {
            if (props.viewer.latest_project) {
                redirecting = true;
                var projectPath = exports.ProjectPagePath(props.viewer.latest_project.id);
                props.router.replace(router_1.linkWithCurrentQueryString(projectPath));
            }
        } else {
            if (activeProject) {
                _this.initActiveProject(activeProject, false);
                status = true;
            }
        }
        _this.state = {
            activeProjectId: props.routeParams.id || '',
            activeProjectLicense: licenseParamsToUsages(_this.props),
            status: status ? 'fetch' : null,
            isSettingsPanelOpen: true,
            redirecting: redirecting
        };
        return _this;
    }

    _createClass(ProjectsPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.state.status) {
                this.setState({ status: null });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (this.hasSwitchedProject(prevProps)) {
                this.setState({ redirecting: false, status: null }, function () {
                    _this2.initActiveProject();
                });
            } else if (this.hasSharedProjectViaSidebar(prevProps)) {
                this.onToggleSettingsPanel();
            } else if (this.hasDeletedLastProject(prevProps)) {
                this.redirect(exports.ProjectsPagePath, true);
            } else if (this.hasDeletedProject(prevProps)) {
                this.redirect(exports.ProjectPagePath(this.firstProjectInList().id));
            } else if (this.hasCreatedNewProject(prevProps)) {
                this.redirect(exports.ProjectPagePath(this.firstProjectInList().id));
            } else if (this.hasDeletedTrackInProject(prevProps)) {
                this.initActiveProject();
            }
        }
    }, {
        key: "renderHeader",
        value: function renderHeader() {
            var _state = this.state,
                activeProjectLicense = _state.activeProjectLicense,
                status = _state.status,
                isSettingsPanelOpen = _state.isSettingsPanelOpen;
            var _props = this.props,
                activeProjectExists = _props.activeProjectExists,
                submitting = _props.submitting;

            var projectHasLicense = activeProjectLicense.length > 0;
            var componentToRender = void 0;
            if (status || submitting) {
                var label = void 0;
                switch (status) {
                    case 'fetch':
                        label = 'Loading playlist...';
                        break;
                    case 'create':
                        label = 'Creating playlist...';
                        break;
                    case 'delete':
                        label = 'Deleting playlist...';
                        break;
                    default:
                        label = 'Saving playlist...';
                        break;
                }
                componentToRender = React.createElement(Label_1.Span, { size: "large", variant: "description", textColor: "bw6", style: { marginRight: grid_1.baseline } }, label);
            } else if (projectHasLicense) {
                var licenseTerms = license_1.getLicenseString(activeProjectLicense);
                componentToRender = React.createElement(React.Fragment, null, React.createElement(Icon_1.IconTerms, { className: colors_1.getTextColorClassName('bw6') }), React.createElement(Tooltip_1.Tooltip, { content: licenseTerms, size: "small", theme: "black", placement: "bottom-start", delay: [250, 0], arrow: false, animateFill: false }, React.createElement(LicenseBuilderButton_1.default, { label: React.createElement(Label_1.Span, Object.assign({ size: "large", variant: "description" }, classes('license__string')), licenseTerms), title: "Edit License Terms For This Playlist", variant: "text", size: "large", usages: this.state.activeProjectLicense, onSaveLicense: this.onSaveLicense, scope: {
                        type: 'Project',
                        id: this.state.activeProjectId
                    } })));
            } else if (activeProjectExists) {
                componentToRender = React.createElement(LicenseBuilderButton_1.default, { label: "Show Prices For This Playlist", colorScheme: "accent", variant: "pill", size: "xsmall", icon: React.createElement(Icon_1.IconTerms, null), scope: {
                        type: 'Project',
                        id: this.state.activeProjectId
                    }, onSaveLicense: this.onSaveLicense, withShadow: true });
            } else {
                componentToRender = null;
            }
            var project = this.getProjectNode();
            return React.createElement(React.Fragment, null, React.createElement("div", { style: { zIndex: 3 } }, React.createElement(PageHeader_1.default, Object.assign({ title: "My Playlists" }, classes('header')), React.createElement("div", Object.assign({}, classes('header__sidebar')), React.createElement(CreateProjectForm_1.default, { onCreateProject: this.onCreateProject })), React.createElement("div", Object.assign({}, classes('header__project')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: { animation: 'transition.slideUpIn', delay: 150, display: 'flex', duration: 150 }, leave: { animation: 'transition.slideUpOut', duration: 150 } }, classes('license')), componentToRender), activeProjectExists && React.createElement("div", Object.assign({}, classes('header__project__actions')), !!project.tracks && !!project.tracks.edges.length && React.createElement(Button_1.default, { wrapperComponent: "a", hyperLinkProps: {
                    href: "/projects/" + this.state.activeProjectId + "/download",
                    target: '_blank'
                }, label: "Download Tracks", colorScheme: "transparent", icon: React.createElement(Icon_1.IconDownload, null), disabled: this.isWorking }), React.createElement(Button_1.default, Object.assign({ label: "Settings", colorScheme: "transparent", icon: isSettingsPanelOpen ? React.createElement(Icon_1.IconX, null) : React.createElement(Icon_1.IconSettings, null), onClick: this.onToggleSettingsPanel, disabled: this.isWorking }, classes('project-settings-button', { open: isSettingsPanelOpen }))), projectHasLicense && React.createElement(CurrencySelect_1.default, null))))), React.createElement(NProgress_1.default, Object.assign({ active: this.isWorking }, classes('loading-progress'))));
        }
    }, {
        key: "render",
        value: function render() {
            var _state2 = this.state,
                isSettingsPanelOpen = _state2.isSettingsPanelOpen,
                redirecting = _state2.redirecting,
                status = _state2.status;
            var _props2 = this.props,
                activeProjectExists = _props2.activeProjectExists,
                handleSubmit = _props2.handleSubmit,
                userIsLoggedIn = _props2.userIsLoggedIn;

            var projects = this.getProjects();
            var projectNode = this.getProjectNode();
            var extraClasses = classNames(isSettingsPanelOpen && 'settings-open', !userIsLoggedIn && 'not-authorized', userIsLoggedIn && (!activeProjectExists || !projects.length) && 'project-not-found');
            if (!userIsLoggedIn) {
                return React.createElement(NotAuthorized_1.default, { message: "You must be logged in to access your projects." });
            }
            return React.createElement(Page_1.default, { id: "projects", className: extraClasses, noIndex: true }, this.renderHeader(), React.createElement("form", Object.assign({}, classes('form'), { onSubmit: handleSubmit }), !!projects.length ? React.createElement(React.Fragment, null, React.createElement(ProjectList_1.default, { onSelectProject: this.onSelectProject, onDeleteProject: this.onDeleteProject }), activeProjectExists ? React.createElement(React.Fragment, null, React.createElement(ProjectView_1.default, { project: projectNode, license: this.state.activeProjectLicense, onSaveLicense: this.onSaveLicense }), React.createElement(ProjectSettings_1.default, { submitting: !!this.props.submitting, project: projectNode, open: isSettingsPanelOpen, license: this.state.activeProjectLicense, onSaveLicense: this.onSaveLicense, onRequestClose: this.closeSettingsPanel })) : !status && !redirecting ? React.createElement(Heading_1.default, Object.assign({ is: "h2", textColor: "bw6" }, classes('error-message', 'not-found')), "Project not found.") : null) : React.createElement(Heading_1.default, Object.assign({ is: "h2", textColor: "bw6" }, classes('error-message', 'no-project')), "You don't have any projects.")));
        }
    }, {
        key: "initActiveProject",
        value: function initActiveProject() {
            var project = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getProjectNode();
            var reinitForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (reinitForm) {
                this.props.reinitializeForm({
                    activeProject: form_1.generateActiveProjectItemProps(project),
                    projects: form_1.generateProjectItemsProps(this.getProjects(), this.props.userProfile)
                });
            }
            var newTracks = player_1.getPlayerTracksFromResults(project.tracks.edges.map(function (_ref2) {
                var node = _ref2.node;
                return node;
            }));
            this.props.setPlayerQueue(newTracks);
        }
    }, {
        key: "getProjectNode",
        value: function getProjectNode() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.viewer.node;
        }
    }, {
        key: "edges",
        value: function edges() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.viewer.projects ? props.viewer.projects.edges : defaultList;
        }
    }, {
        key: "firstProjectInList",
        value: function firstProjectInList() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.edges(props)[0].node;
        }
    }, {
        key: "getProjects",
        value: function getProjects() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.edges(props).map(function (_ref3) {
                var node = _ref3.node;
                return node;
            });
        }
    }, {
        key: "hasDeletedTrackInProject",
        value: function hasDeletedTrackInProject(props) {
            var currentActiveProject = this.getProjectNode();
            var project = this.getProjectNode(props);
            if (currentActiveProject && project) {
                return this.state.activeProjectId && currentActiveProject.tracks.edges.length !== project.tracks.edges.length;
            }
            return false;
        }
    }, {
        key: "hasSwitchedProject",
        value: function hasSwitchedProject(props) {
            var currentActiveProject = this.getProjectNode();
            var project = this.getProjectNode(props);
            return currentActiveProject && (!!!project || currentActiveProject.id !== project.id);
        }
    }, {
        key: "hasDeletedLastProject",
        value: function hasDeletedLastProject(prevProps) {
            return this.edges(prevProps).length === 1 && this.edges().length === 0;
        }
    }, {
        key: "hasCreatedNewProject",
        value: function hasCreatedNewProject(prevProps) {
            return this.edges(prevProps).length < this.edges().length;
        }
    }, {
        key: "hasDeletedProject",
        value: function hasDeletedProject(prevProps) {
            return this.edges(prevProps).length > this.edges().length;
        }
    }, {
        key: "hasSharedProjectViaSidebar",
        value: function hasSharedProjectViaSidebar(prevProps) {
            var currentActiveProject = this.getProjectNode();
            var previousActiveProject = this.getProjectNode(prevProps);
            return currentActiveProject && previousActiveProject && !this.hasSwitchedProject(prevProps) && currentActiveProject.is_public && !previousActiveProject.is_public && !this.state.isSettingsPanelOpen;
        }
    }, {
        key: "redirect",
        value: function redirect(path) {
            var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var redirectDelay = 500; // Delay to let the progress bar animation complete
            var action = replace ? this.props.router.replace : this.props.router.push;
            this.setState({ status: null, redirecting: true }, function () {
                return setTimeout(function () {
                    return action(path);
                }, redirectDelay);
            });
        }
    }, {
        key: "isWorking",
        get: function get() {
            return !!this.state.status || !!this.props.submitting;
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.routeParams.id !== prevState.activeProjectId) {
                return {
                    activeProjectId: nextProps.routeParams.id,
                    activeProjectLicense: licenseParamsToUsages(nextProps)
                };
            }
            return null;
        }
    }]);

    return ProjectsPage;
}(React.Component);

var ProjectsPageForm = form_1.ProjectsPageReduxForm(ProjectsPage);
// tslint:disable-next-line:max-line-length
var ConnectedProjectsPageForm = react_redux_1.connect(function (state, ownProps) {
    var _state$user = state.user,
        isLoggedIn = _state$user.isLoggedIn,
        profile = _state$user.profile;

    var projects = [];
    var defaultProject = ownProps.routeParams.id && ownProps.viewer.node ? ownProps.viewer.node : ownProps.viewer.latest_project;
    if (isLoggedIn) {
        projects = ownProps.viewer.projects.edges.map(function (_ref4) {
            var node = _ref4.node;
            return node;
        });
    }
    return {
        licenseComponents: staticData_1.getLicenseComponents(state),
        initialValues: defaultProject ? {
            activeProject: form_1.generateActiveProjectItemProps(defaultProject),
            projects: form_1.generateProjectItemsProps(projects, profile)
        } : undefined,
        activeProjectExists: !!ownProps.routeParams.id && !!ownProps.viewer.node,
        userIsLoggedIn: isLoggedIn,
        userProfile: profile
    };
}, function (dispatch) {
    return {
        dispatch: dispatch,
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.replaceQueue({ tracks: tracks }));
        }
    };
}, function (stateProps, _a, ownProps) {
    var dispatch = _a.dispatch,
        dispatchProps = __rest(_a, ["dispatch"]);
    return Object.assign({}, stateProps, dispatchProps, ownProps, { reinitializeForm: function reinitializeForm(formFields) {
            dispatch(form_1.reinitializeForm(formFields));
        } });
}, {
    areStatesEqual: function areStatesEqual(nextState, prevState) {
        return lodash_1.isEqual(nextState.user, prevState.user);
    }
})(ProjectsPageForm);
var RelayProjectsPage = react_relay_1.createFragmentContainer(ConnectedProjectsPageForm, project_1.ProjectPageFragment);
exports.default = RelayProjectsPage;

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Preferences-related Redux Actions
 */
/* tslint:disable:max-line-length */
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Preferences');
exports.setLanguage = actionCreator('SET_PREFERRED_LANGUAGE');
// Request Async Actions
exports.requestSetPreferencesFromLocalStorage = actionCreator('REQUEST_SET_PREFERENCES_FROM_LOCAL_STORAGE');
// Async Actions
exports.setPreferencesFromLocalStorage = actionCreator.async('SET_PREFERENCES_FROM_LOCAL_STORAGE');

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var google_tag_manager_1 = __webpack_require__(962);
var redux_beacon_1 = __webpack_require__(496);
var account_1 = __webpack_require__(965);
var activecampaign_1 = __webpack_require__(499);
var budget_1 = __webpack_require__(966);
var cart_1 = __webpack_require__(500);
var checkout_1 = __webpack_require__(1355);
var downloads_1 = __webpack_require__(1356);
var impressions_1 = __webpack_require__(1357);
var licensing_1 = __webpack_require__(1358);
var search_1 = __webpack_require__(1359);
var gtm = google_tag_manager_1.default();
exports.eventsMap = Object.assign({}, licensing_1.licensingEventsMap, account_1.accountEventsMap, cart_1.cartEventsMap, checkout_1.checkoutEventsMap, activecampaign_1.acEventsMap, downloads_1.downloadsEventsMap, impressions_1.impressionsEventsMap, search_1.searchEventsMap, budget_1.budgetEventsMap);
exports.gtmMiddleware = redux_beacon_1.createMiddleware(exports.eventsMap, gtm);
exports.gtmMetaReducer = redux_beacon_1.createMetaReducer(exports.eventsMap, gtm);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CurrencySelect Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var staticData_1 = __webpack_require__(103);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var currency_1 = __webpack_require__(115);
var _1 = __webpack_require__(200);
var classes = new BEM('currency-select');
var form = 'currency-select';

var CurrencySelect = function (_React$Component) {
    _inherits(CurrencySelect, _React$Component);

    function CurrencySelect() {
        _classCallCheck(this, CurrencySelect);

        var _this = _possibleConstructorReturn(this, (CurrencySelect.__proto__ || Object.getPrototypeOf(CurrencySelect)).apply(this, arguments));

        _this.onSetCurrency = function (_ref) {
            var value = _ref.value;

            _this.props.setCurrency(value);
        };
        return _this;
    }

    _createClass(CurrencySelect, [{
        key: "render",
        value: function render() {
            return React.createElement("form", Object.assign({}, classes('', '', this.props.className)), React.createElement(_1.default, Object.assign({ form: form, name: "currencySelect", onUpdate: this.onSetCurrency, options: this.props.currencyOptions, updateOnMount: false, selectName: "currency-select", selectProps: {
                    autoBlur: true,
                    clearable: false,
                    searchable: false
                }, size: "small" }, this.props.selectProps)));
        }
    }]);

    return CurrencySelect;
}(React.Component);

var CurrencySelectForm = redux_form_1.reduxForm({
    form: form
})(CurrencySelect);
var ConnectedCurrencySelect = react_redux_1.connect(function (state, ownProps) {
    return {
        initialValues: {
            currencySelect: ownProps.currency
        },
        currencyOptions: staticData_1.getCurrencyOptions(state)
    };
})(CurrencySelectForm);
var CurrencySelectWithContext = function CurrencySelectWithContext(props) {
    return React.createElement(currency_1.CurrencyContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedCurrencySelect, Object.assign({}, ctx, props));
    });
};
exports.default = CurrencySelectWithContext;

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PageTemplate Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1249);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var classes = new BEM('page');

var PageTemplate = function (_React$Component) {
    _inherits(PageTemplate, _React$Component);

    function PageTemplate() {
        _classCallCheck(this, PageTemplate);

        return _possibleConstructorReturn(this, (PageTemplate.__proto__ || Object.getPrototypeOf(PageTemplate)).apply(this, arguments));
    }

    _createClass(PageTemplate, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                id = _props.id,
                layout = _props.layout;

            var classesModifiers = _defineProperty({}, id, true);
            return React.createElement("div", Object.assign({}, classes('', classesModifiers, className)), layout === 'strict' ? React.createElement("div", Object.assign({}, classes('main')), children) : children);
        }
    }]);

    return PageTemplate;
}(React.Component);

PageTemplate.defaultProps = {
    layout: 'strict'
};
exports.default = PageTemplate;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * withLicenseBar HOC
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var ui_1 = __webpack_require__(29);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
function withLicenseBar(UnwrappedComponent) {
    var WithLicenseBar = function (_React$Component) {
        _inherits(WithLicenseBar, _React$Component);

        function WithLicenseBar() {
            _classCallCheck(this, WithLicenseBar);

            return _possibleConstructorReturn(this, (WithLicenseBar.__proto__ || Object.getPrototypeOf(WithLicenseBar)).apply(this, arguments));
        }

        _createClass(WithLicenseBar, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.toggleVisibility(true);
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.toggleVisibility(false);
            }
        }, {
            key: "render",
            value: function render() {
                return React.createElement(UnwrappedComponent, Object.assign({}, this.props));
            }
        }]);

        return WithLicenseBar;
    }(React.Component);

    return react_redux_1.connect(null, function (dispatch) {
        return {
            toggleVisibility: function toggleVisibility(visible) {
                dispatch(ui_1.toggleLicenseBarVisibility(visible));
            }
        };
    })(WithLicenseBar);
}
exports.default = withLicenseBar;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * License in Query String
 */

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var types_1 = __webpack_require__(105);
// tslint:disable-next-line:max-line-length no-invalid-template-strings
var licenseStringTemplate = lodash_1.template('${medium}${sep}${term}${sep}${spot_count}${sep}${contextual_param}${sep}${contextual_param_type}');
var usageSeparator = '|';
var paramSeparator = ';';
var propSeparator = ':';
var shortNames = {
    BroadcastTerritory: 'bt',
    ProducerLocation: 'pl',
    AudienceSize: 'as',
    spot_count: 'c',
    medium: 'm',
    term: 't',
    contextual_param: 'p',
    contextual_param_type: 'pt'
};
function shortname(value) {
    return shortNames[value] || value;
}
function fullname(value) {
    return lodash_1.invert(shortNames)[value] || value;
}
var getSerializedProp = function getSerializedProp(license) {
    return function (prop) {
        var value = license[prop];
        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
            value = JSON.stringify(value);
        }
        return "" + shortname(prop) + propSeparator + shortname(value);
    };
};
exports.LicenseFilter = {
    serialize: function serialize(params) {
        return btoa(params.map(function (license) {
            var propSelector = getSerializedProp(license);
            var licenseString = licenseStringTemplate({
                medium: propSelector('medium'),
                term: propSelector('term'),
                spot_count: propSelector('spot_count'),
                contextual_param: propSelector('contextual_param'),
                contextual_param_type: propSelector('contextual_param_type'),
                sep: paramSeparator
            });
            return licenseString.replace(',,', ',');
        }).join(usageSeparator));
    },
    unserialize: function unserialize(query) {
        if (types_1.QueryStringParam.License in query) {
            var decodedString = atob(query[types_1.QueryStringParam.License]);
            // If the decoded license string contains the word `medium` in full, it means it's an old license url.
            // In this case, we simply do a JSON.parse to get our valid GQL.ILicenseUsageParamsInput[].
            if (decodedString.indexOf('medium') > -1) {
                return JSON.parse(decodedString);
            }
            var licenses = decodedString.split(usageSeparator);
            var licenseParamsReducer = [];
            var paramsReducer = {};
            return licenses.reduce(function (acc, license) {
                var params = license.split(paramSeparator);
                var usages = params.reduce(function (accParams, param) {
                    var value = void 0;

                    var _param$split = param.split(propSeparator),
                        _param$split2 = _slicedToArray(_param$split, 2),
                        key = _param$split2[0],
                        stringValue = _param$split2[1];

                    key = fullname(key);
                    stringValue = fullname(stringValue);
                    try {
                        value = JSON.parse(stringValue);
                    } catch (error) {
                        value = stringValue;
                    }
                    if (value === 'undefined') {
                        return accParams;
                    }
                    return Object.assign({}, accParams, _defineProperty({}, key, value));
                }, paramsReducer);
                acc.push(usages);
                return acc;
            }, licenseParamsReducer);
        }
        return [];
    }
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var types_1 = __webpack_require__(105);
var delimiter = '-';
exports.SortOrderSerializer = {
    serialize: function serialize(sort) {
        if (!sort) {
            return '';
        }
        return lodash_1.toLower("" + sort.field + delimiter + sort.order);
    },
    unserialize: function unserialize(query) {
        try {
            if (types_1.QueryStringParam.SortOrder in query) {
                var sortOrderStr = query[types_1.QueryStringParam.SortOrder];
                return this.unserializeStr(sortOrderStr);
            }
        } catch (e) {
            console.error(e);
        }
        return {
            field: "Featured" /* Featured */
            , order: "Desc" /* Desc */
        };
    },
    unserializeStr: function unserializeStr(sortOrderStr) {
        var _sortOrderStr$split = sortOrderStr.split(delimiter),
            _sortOrderStr$split2 = _slicedToArray(_sortOrderStr$split, 2),
            field = _sortOrderStr$split2[0],
            order = _sortOrderStr$split2[1];

        return {
            field: lodash_1.capitalize(field),
            order: lodash_1.capitalize(order)
        };
    }
};

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Onboarding Context
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.OnboardingContext = React.createContext({
    achievements: [],
    acknowledgeAchievement: function acknowledgeAchievement() {
        return null;
    },
    hasNewAchievement: function hasNewAchievement() {
        return false;
    },
    isNewAchievement: function isNewAchievement() {
        return false;
    },
    unlockAchievement: function unlockAchievement() {
        return null;
    }
});

/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Download');
exports.downloadTrack = actionCreator('DOWNLOAD_TRACK');

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Authentication');
exports.setAuthenticationConfig = actionCreator('SET_AUTHENTICATION_CONFIG');

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Log In/Sign Up
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.LoginPageQuery = function () {
  return __webpack_require__(1412);
};
exports.LoginFormFragment = {
  viewer: function viewer() {
    return __webpack_require__(1413);
  }
};
exports.LoginFormMutation = function () {
  return __webpack_require__(1414);
};

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FormError Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1422);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Label_1 = __webpack_require__(8);
var classes = new BEM('form-error');
var FormError = function FormError(_ref) {
  var error = _ref.error;
  return React.createElement("div", Object.assign({}, classes()), React.createElement(Label_1.Span, { size: "medium" }, error));
};
exports.default = FormError;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Pardot');
exports.sendNewUser = actionCreator('SEND_NEW_USER');
exports.sendNewsletterSignup = actionCreator('SEND_NEWSLETTER_SIGNUP');

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Promise Utils
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCancelable = function (promise) {
    var hasCanceled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (val) {
            return hasCanceled ? reject({ isCanceled: true }) : resolve(val);
        }, function (error) {
            return hasCanceled ? reject({ isCanceled: true }) : reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function cancel() {
            hasCanceled = true;
        }
    };
};
exports.emptyPromiseActionPayload = {
    promise: {
        resolve: function resolve() {
            return null;
        },
        reject: function reject() {
            return null;
        }
    }
};

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Cart
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.CartPageQuery = function () {
  return __webpack_require__(1460);
};
exports.cartFragment = {
  viewer: function viewer() {
    return __webpack_require__(1461);
  }
};
exports.CartNode = {
  data: function data() {
    return __webpack_require__(1462);
  }
};
exports.AddItemToCartMutation = function () {
  return __webpack_require__(1463);
};
exports.UpdateCartItemTermsMutation = function () {
  return __webpack_require__(1464);
};
exports.DeleteItemFromCartMutation = function () {
  return __webpack_require__(1465);
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AddToProjectButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var ui_1 = __webpack_require__(29);
var projects_1 = __webpack_require__(295);
__webpack_require__(1484);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Icon_1 = __webpack_require__(12);
var Button_1 = __webpack_require__(10);
var classes = new BEM('add-to-project-button');

var AddToProjectButton = function (_React$Component) {
    _inherits(AddToProjectButton, _React$Component);

    function AddToProjectButton() {
        _classCallCheck(this, AddToProjectButton);

        var _this = _possibleConstructorReturn(this, (AddToProjectButton.__proto__ || Object.getPrototypeOf(AddToProjectButton)).apply(this, arguments));

        _this.onClick = function (e) {
            e.persist();
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
            _this.props.addToProject();
        };
        return _this;
    }

    _createClass(AddToProjectButton, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                label = _props.label;

            var icon = this.props.showIcon !== false && (this.props.isTrackInProjects ? React.createElement(Icon_1.IconProjectSelected, null) : React.createElement(Icon_1.IconProject, null));
            return React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, label: label, icon: icon }, classes('', '', className)));
        }
    }]);

    return AddToProjectButton;
}(React.Component);

AddToProjectButton.defaultProps = {
    label: 'Save'
};
var makeMapStateToProps = function makeMapStateToProps() {
    var isTrackInProjects = projects_1.makeIsTrackInProjects();
    var mapStateToProps = function mapStateToProps(state, props) {
        return {
            isTrackInProjects: isTrackInProjects(state, props)
        };
    };
    return mapStateToProps;
};
var ConnectedAddToProjectButton = react_redux_1.connect(makeMapStateToProps, function (dispatch, _ref) {
    var trackId = _ref.trackId,
        trackVersion = _ref.trackVersion;
    return {
        addToProject: function addToProject() {
            return dispatch(ui_1.showAddTrackToProjectForm({ trackId: trackId, trackVersion: trackVersion || 'original' }));
        }
    };
})(AddToProjectButton);
exports.default = ConnectedAddToProjectButton;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Download Context
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.DownloadContext = React.createContext({
    agreementVisibility: true,
    clear: function clear() {
        return null;
    },
    setFilePath: function setFilePath() {
        return null;
    },
    setAgreementVisibility: function setAgreementVisibility() {
        return null;
    },
    dispatch: function dispatch() {
        return null;
    }
});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CardPlayButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1493);
var classNames = __webpack_require__(15);
var Icon_1 = __webpack_require__(12);
var classes = new BEM('card-play-button');

var CardPlayButton = function (_React$Component) {
    _inherits(CardPlayButton, _React$Component);

    function CardPlayButton() {
        _classCallCheck(this, CardPlayButton);

        var _this = _possibleConstructorReturn(this, (CardPlayButton.__proto__ || Object.getPrototypeOf(CardPlayButton)).apply(this, arguments));

        _this.button = React.createRef();
        _this.onClick = function () {
            _this.button.current.blur();
            if (_this.props.onClick) {
                _this.props.onClick();
            }
        };
        return _this;
    }

    _createClass(CardPlayButton, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                blurredImage = _props.blurredImage,
                className = _props.className,
                isPlaying = _props.isPlaying;

            var PlayIcon = isPlaying ? Icon_1.IconPlayerPause : Icon_1.IconPlayerPlay;
            var classModifiers = {
                'is-playing': !!isPlaying
            };
            var extraClasses = classNames(className, 'button');
            return React.createElement("button", Object.assign({ ref: this.button, onClick: this.onClick }, classes('', classModifiers, extraClasses)), blurredImage && React.createElement("img", Object.assign({}, classes('blurred-image'), { src: blurredImage, alt: "" })), React.createElement(PlayIcon, null));
        }
    }]);

    return CardPlayButton;
}(React.Component);

exports.default = CardPlayButton;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Picture Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1500);
var classNames = __webpack_require__(15);
var imageloaded = __webpack_require__(640);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var WindowSizeListener = __webpack_require__(124);
var velocity_react_1 = __webpack_require__(19);
var classes = new BEM('picture');

var Picture = function (_React$PureComponent) {
    _inherits(Picture, _React$PureComponent);

    function Picture(props) {
        _classCallCheck(this, Picture);

        var _this = _possibleConstructorReturn(this, (Picture.__proto__ || Object.getPrototypeOf(Picture)).call(this, props));

        _this.onInit = function () {
            var _this$image$getBoundi = _this.image.getBoundingClientRect(),
                width = _this$image$getBoundi.width,
                height = _this$image$getBoundi.height;

            var ratio = width / height;
            if (ratio && ratio !== Infinity) {
                if (ratio !== _this.imageRatio) {
                    _this.imageRatio = ratio;
                    _this.onResize();
                }
                _this.setState({ initialized: true });
            } else {
                setTimeout(_this.onInit, 100);
            }
        };
        _this.onResize = function () {
            var _this$element$getBoun = _this.element.getBoundingClientRect(),
                width = _this$element$getBoun.width,
                height = _this$element$getBoun.height;

            var pictureRatio = width / height;
            if (pictureRatio >= _this.imageRatio) {
                _this.setState(function (prevState) {
                    return prevState.fillWith !== 'width' ? Object.assign({}, _this.state, { fillWith: 'width' }) : prevState;
                });
            } else {
                _this.setState(function (prevState) {
                    return prevState.fillWith !== 'height' ? Object.assign({}, _this.state, { fillWith: 'height' }) : prevState;
                });
            }
        };
        var metadata = props.assets.large[0].metadata;
        _this.imageHeight = metadata.height;
        _this.imageWidth = metadata.width;
        _this.imageRatio = _this.imageWidth / _this.imageHeight;
        _this.state = {
            fillWith: 'width',
            initialized: false
        };
        return _this;
    }

    _createClass(Picture, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            imageloaded(this.element, function () {
                if (_this2.image) {
                    nextTick(function () {
                        _this2.onInit();
                    });
                }
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                alt = _props.alt,
                assets = _props.assets,
                className = _props.className;

            var xlargeWebp = lodash_1.find(assets.xlarge, { format: 'webp' });
            var xlargeImg = lodash_1.find(assets.xlarge, function (_ref) {
                var format = _ref.format;
                return format !== 'webp';
            });
            var largeWebp = lodash_1.find(assets.large, function (_ref2) {
                var format = _ref2.format;
                return format === 'webp';
            });
            var largeImg = lodash_1.find(assets.large, function (_ref3) {
                var format = _ref3.format;
                return format !== 'webp';
            });
            var mediumWebp = lodash_1.find(assets.medium, function (_ref4) {
                var format = _ref4.format;
                return format === 'webp';
            });
            var mediumImg = lodash_1.find(assets.medium, function (_ref5) {
                var format = _ref5.format;
                return format !== 'webp';
            });
            var smallWebp = lodash_1.find(assets.small, function (_ref6) {
                var format = _ref6.format;
                return format === 'webp';
            });
            var smallImg = lodash_1.find(assets.small, function (_ref7) {
                var format = _ref7.format;
                return format !== 'webp';
            });
            var blurredImg = lodash_1.find(assets.blur, function (_ref8) {
                var format = _ref8.format;
                return format !== 'webp';
            });
            var classesModifiers = _defineProperty({}, "fill-with-" + this.state.fillWith, true);
            var extraClasses = classNames(className);
            return React.createElement(velocity_react_1.VelocityComponent, { animation: this.state.initialized ? 'transition.fadeIn' : { opacity: 0, display: 'none' } }, React.createElement("picture", Object.assign({ ref: function ref(node) {
                    return _this3.element = node;
                } }, classes('', classesModifiers, extraClasses)), largeWebp && xlargeWebp && React.createElement("source", { type: "image/webp", srcSet: largeWebp.path + ", " + xlargeWebp.path + " 2x", media: "(min-width: 1440px)" }), mediumWebp && largeWebp && React.createElement("source", { type: "image/webp", srcSet: mediumWebp.path + ", " + largeWebp.path + " 2x", media: "(min-width: 900px)" }), smallWebp && mediumWebp && React.createElement("source", { type: "image/webp", srcSet: smallWebp.path + ", " + mediumWebp.path + " 2x" }), React.createElement("source", { srcSet: largeImg.path + ", " + xlargeImg.path + " 2x", media: "(min-width: 1440px)" }), React.createElement("source", { srcSet: mediumImg.path + ", " + largeImg.path + " 2x", media: "(min-width: 900px)" }), React.createElement("source", { srcSet: smallImg.path + ", " + mediumImg.path + " 2x" }), React.createElement("img", Object.assign({ ref: function ref(node) {
                    return _this3.image = node;
                }, src: blurredImg.path, alt: alt }, classes('image'))), React.createElement(WindowSizeListener, { onResize: this.onResize })));
        }
    }]);

    return Picture;
}(React.PureComponent);

exports.default = Picture;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Badge Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1505);
var Label_1 = __webpack_require__(8);
var classes = new BEM('badge');

var Badge = function (_React$Component) {
    _inherits(Badge, _React$Component);

    function Badge() {
        _classCallCheck(this, Badge);

        return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
    }

    _createClass(Badge, [{
        key: "render",
        value: function render() {
            var _classModifiers;

            var _props = this.props,
                className = _props.className,
                label = _props.label,
                variant = _props.variant;

            var colorScheme = variant === 'notification' ? 'red' : this.props.colorScheme;
            var classModifiers = (_classModifiers = {}, _defineProperty(_classModifiers, colorScheme, true), _defineProperty(_classModifiers, variant, true), _classModifiers);
            return React.createElement("div", Object.assign({}, classes('', classModifiers, className)), React.createElement(Label_1.default, Object.assign({ size: "small", WrappedComponent: "span" }, classes('label')), label));
        }
    }]);

    return Badge;
}(React.Component);

Badge.defaultProps = {
    colorScheme: 'white',
    variant: 'normal'
};
exports.default = Badge;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackListItem Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var impressions_1 = __webpack_require__(617);
var track_1 = __webpack_require__(44);
__webpack_require__(1546);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Browse_1 = __webpack_require__(61);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Card_1 = __webpack_require__(293);

var TrackListItem = function (_React$Component) {
    _inherits(TrackListItem, _React$Component);

    function TrackListItem() {
        _classCallCheck(this, TrackListItem);

        return _possibleConstructorReturn(this, (TrackListItem.__proto__ || Object.getPrototypeOf(TrackListItem)).apply(this, arguments));
    }

    _createClass(TrackListItem, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.sendTrackImpression(this.props.track);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                actionSource = _props.actionSource,
                cardProps = _props.cardProps,
                className = _props.className,
                _props$displayPriceEl = _props.displayPriceElement,
                displayPriceElement = _props$displayPriceEl === undefined ? true : _props$displayPriceEl,
                track = _props.track;
            var artist = track.artist,
                title = track.title,
                assets = track.assets;

            var classes = new BEM(className || 'track-list__item');
            var trackId = track_1.getDefaultTrackAsset(assets).id;
            var thumbnail = track_1.getResponsiveTrackThumbnail(track);
            var PriceElement = displayPriceElement ? track_1.getTrackPriceElement(track, {
                buttonProps: {
                    variant: 'pill'
                }
            }) : undefined;
            var trackInstrumentalId = void 0;
            if (this.props.hasInstrumentalFilter && location.pathname === Browse_1.BrowsePagePath) {
                trackInstrumentalId = track_1.getDefaultTrackInstrumentalAsset(assets).id;
            }
            return trackId ? React.createElement("li", Object.assign({}, classes()), React.createElement(Card_1.default, Object.assign({ actionSource: actionSource, trackId: trackInstrumentalId || trackId, title: title, subtitle: artist.name, image: thumbnail, PriceElement: PriceElement, trackResult: track }, cardProps))) : null;
        }
    }]);

    return TrackListItem;
}(React.Component);

var ConnectedTrackListItem = react_redux_1.connect(null, function (dispatch) {
    return {
        sendTrackImpression: function sendTrackImpression(track) {
            dispatch(impressions_1.trackImpression({ track: track }));
        }
    };
})(TrackListItem);
var TrackListItemWithContext = function TrackListItemWithContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedTrackListItem, Object.assign({ hasInstrumentalFilter: selectors_1.hasInstrumentalFilter(ctx) }, props));
    });
};
exports.default = TrackListItemWithContext;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ScrollableSection Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1549);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var SectionTitle_1 = __webpack_require__(230);
var classes = new BEM('scrollable-section');

var ScrollableSection = function (_React$Component) {
    _inherits(ScrollableSection, _React$Component);

    function ScrollableSection() {
        _classCallCheck(this, ScrollableSection);

        return _possibleConstructorReturn(this, (ScrollableSection.__proto__ || Object.getPrototypeOf(ScrollableSection)).apply(this, arguments));
    }

    _createClass(ScrollableSection, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                data = _props.data,
                id = _props.id,
                subtitle = _props.subtitle,
                title = _props.title;

            return React.createElement("div", Object.assign({}, classes('', id, className)), title && React.createElement(SectionTitle_1.default, Object.assign({ title: title, subtitle: subtitle }, classes('title', ''))), React.createElement("div", Object.assign({}, classes('list-wrapper')), React.createElement("ul", Object.assign({}, classes('list')), data.map(function (item, index) {
                return React.createElement("li", Object.assign({ key: id + "-" + index }, classes('list__item')), children(item, index));
            }))));
        }
    }]);

    return ScrollableSection;
}(React.Component);

exports.default = ScrollableSection;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutAmounts Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var selectors_1 = __webpack_require__(223);
var animation_1 = __webpack_require__(173);
__webpack_require__(1591);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var InvoicePriceTag_1 = __webpack_require__(431);
var classes = new BEM('checkout__amounts');

var CheckoutAmounts = function (_React$Component) {
    _inherits(CheckoutAmounts, _React$Component);

    function CheckoutAmounts() {
        _classCallCheck(this, CheckoutAmounts);

        var _this = _possibleConstructorReturn(this, (CheckoutAmounts.__proto__ || Object.getPrototypeOf(CheckoutAmounts)).apply(this, arguments));

        _this.onRemovePromoCode = function () {
            _this.props.deletePromoCode();
        };
        _this.renderTaxLineItem = function (_ref) {
            var amount = _ref.amount,
                id = _ref.id,
                rate = _ref.rate,
                tax_name = _ref.tax_name;
            return React.createElement("div", Object.assign({ key: id }, classes('item')), React.createElement("div", Object.assign({}, classes('item__wrapper')), _this.renderLineItemLabel(tax_name + " (" + rate + "%)"), _this.renderLineItemPriceTag(amount, _this.props.context === 'invoice')));
        };
        return _this;
    }

    _createClass(CheckoutAmounts, [{
        key: "renderLineItemLabel",
        value: function renderLineItemLabel(label) {
            return this.props.context === 'review' ? React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('item__label')), label) : React.createElement(Label_1.Span, Object.assign({ size: "medium" }, classes('item__label')), label);
        }
    }, {
        key: "renderLineItemPriceTag",
        value: function renderLineItemPriceTag(label, explicitCurrency) {
            var currency = this.props.order.currency_code;
            var rate = this.props.order.currency_rate;
            switch (this.props.context) {
                case 'invoice':
                    return React.createElement(InvoicePriceTag_1.default, Object.assign({ currency: currency, rate: rate, amount: label, explicitCurrency: explicitCurrency, size: "small" }, classes('item__amount')));
                case 'review':
                    return React.createElement(InvoicePriceTag_1.default, Object.assign({ currency: currency, rate: rate, amount: label, explicitCurrency: explicitCurrency, size: "medium" }, classes('item__amount')));
                default:
                    return React.createElement(InvoicePriceTag_1.default, Object.assign({ currency: currency, rate: rate, amount: label, explicitCurrency: explicitCurrency, size: "small" }, classes('item__amount')));
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                context = _props.context,
                _props$order = _props.order,
                discount = _props$order.discount,
                promo_code_line_item = _props$order.promo_code_line_item,
                subtotal = _props$order.subtotal,
                tax_line_items = _props$order.tax_line_items,
                total = _props$order.total;

            var AmountItemAnimations = animation_1.ListItemAnimations(context === 'review' ? 48 : 40);
            var taxLineItems = lodash_1.sortBy(tax_line_items, 'priority');
            return React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: { animation: AmountItemAnimations.In, stagger: 150 }, leave: { animation: AmountItemAnimations.Out } }, classes('', context)), promo_code_line_item && context !== 'invoice' && React.createElement("div", Object.assign({}, classes('item', 'promo-code')), React.createElement("div", Object.assign({}, classes('item__wrapper')), React.createElement("div", Object.assign({}, classes('item__background'))), this.renderLineItemLabel("Promo Code " + promo_code_line_item.code.toUpperCase()), this.renderLineItemPriceTag(-discount, this.props.context === 'invoice'), React.createElement(Button_1.default, Object.assign({ onClick: this.onRemovePromoCode, icon: React.createElement(Icon_1.IconX, null), variant: "icon", size: "xsmall" }, classes('item__button-remove'))))), React.createElement("div", Object.assign({}, classes('item')), React.createElement("div", Object.assign({}, classes('item__wrapper')), this.renderLineItemLabel(this.getSubtotalLabel()), this.renderLineItemPriceTag(subtotal, this.props.context === 'invoice'))), taxLineItems.map(this.renderTaxLineItem), React.createElement("div", Object.assign({}, classes('item')), React.createElement("div", Object.assign({}, classes('item__wrapper')), this.renderLineItemLabel('Total'), this.renderLineItemPriceTag(total, true))));
        }
    }, {
        key: "getSubtotalLabel",
        value: function getSubtotalLabel() {
            var _props2 = this.props,
                context = _props2.context,
                promo_code_line_item = _props2.order.promo_code_line_item;

            var showPromoCode = promo_code_line_item && context === 'invoice';
            return "Subtotal" + (showPromoCode ? " (includes promo code " + promo_code_line_item.code + ")" : '');
        }
    }]);

    return CheckoutAmounts;
}(React.Component);

var ConnectedCheckoutAmounts = react_redux_1.connect(function (state) {
    return {
        billingAddress: selectors_1.getBillingAddress(state)
    };
}, function (dispatch) {
    return {
        deletePromoCode: function deletePromoCode(payload) {
            return dispatch(checkout_1.requestDeletePromoCode(payload));
        }
    };
}, function (_ref2, dispatchProps, ownProps) {
    var billingAddress = _ref2.billingAddress;
    return Object.assign({}, ownProps, { deletePromoCode: function deletePromoCode() {
            dispatchProps.deletePromoCode({
                country_code: billingAddress ? billingAddress.country : undefined,
                subdivision_code: billingAddress ? billingAddress.state : undefined
            });
        } });
})(CheckoutAmounts);
exports.default = ConnectedCheckoutAmounts;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InvoicePriceTag Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(641);
var React = __webpack_require__(0);
var _1 = __webpack_require__(126);
var InvoicePriceTag = function InvoicePriceTag(props) {
  return React.createElement(_1.default, Object.assign({ explicitCurrency: true, precision: 2 }, props));
};
exports.default = InvoicePriceTag;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Licensing Context
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.TrackLicensingContext = React.createContext({
    clearAll: function clearAll() {
        return null;
    },
    setTrack: function setTrack() {
        return null;
    },
    setUsages: function setUsages() {
        return null;
    }
});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FeaturedArtistList Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1638);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var SectionTitle_1 = __webpack_require__(230);
var FeaturedArtist_1 = __webpack_require__(1640);
var classes = new BEM('featured-artist-list');
function FeaturedArtistList(_ref) {
    var data = _ref.data;

    return !!data.length ? React.createElement("div", Object.assign({}, classes()), React.createElement("div", Object.assign({}, classes('content-wrapper', '', 'container')), React.createElement(SectionTitle_1.default, Object.assign({ title: "Artists", subtitle: "Featured" }, classes('title'))), React.createElement("ul", Object.assign({}, classes('list')), data.map(function (track) {
        return React.createElement("li", Object.assign({}, classes('list__item'), { key: "featured-artist-" + track.artist.slug }), React.createElement(FeaturedArtist_1.default, { track: track }));
    })))) : null;
}
exports.default = FeaturedArtistList;

/***/ }),
/* 434 */,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * StaffPicks Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1668);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var TrackListItem_1 = __webpack_require__(428);
var SectionTitle_1 = __webpack_require__(230);
var classes = new BEM('staff-picks');
var StaffPicks = function StaffPicks(_ref) {
    var tracks = _ref.tracks,
        withBackground = _ref.withBackground;

    var classModifiers = {
        'with-background': !!withBackground
    };
    return React.createElement("div", Object.assign({}, classes('', classModifiers)), withBackground && React.createElement("div", Object.assign({ style: {
            backgroundImage: "url(https://orpheus-assets.s3.amazonaws.com/images/eric-nopanen-208576-unsplash.jpg)"
        } }, classes('background'))), React.createElement("div", Object.assign({}, classes('content-wrapper', '', 'container')), React.createElement(SectionTitle_1.default, Object.assign({ title: "New & Noteworthy", textColor: withBackground ? 'white' : undefined }, classes('title'))), React.createElement("ul", Object.assign({}, classes('track-list')), tracks.map(function (track) {
        return React.createElement(TrackListItem_1.default, Object.assign({ actionSource: "featured_tracks_list", key: track.id, track: track, cardProps: {
                backgroundColor: 'white'
            } }, classes('track-list__item')));
    }))));
};
exports.default = StaffPicks;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Registration Process Config
 */

Object.defineProperty(exports, "__esModule", { value: true });
function alphaSort(arr) {
    return arr.sort(function (a, b) {
        if (a.label === 'Other') {
            return 1;
        }
        if (b.label === 'Other') {
            return -1;
        }
        return a.label < b.label ? -1 : 1;
    });
}
exports.jobTypes = alphaSort([
// {
//   id: 'Sm9iVHlwZToxMDAx',
//   label: 'Administration',
// },
// {
//   id: 'Sm9iVHlwZToxMDAy',
//   label: 'Art Director',
// },
// {
//   id: 'Sm9iVHlwZToxMDAz',
//   label: 'Copywriter',
// },
{
    id: 'Sm9iVHlwZToxMDA0',
    label: 'Creative'
}, {
    id: 'Sm9iVHlwZToxMDA1',
    label: 'Editor/Post Producer'
}, {
    id: 'Sm9iVHlwZToxMDA2',
    label: 'Music Supervisor'
}, {
    id: 'Sm9iVHlwZToxMDA3',
    label: 'Producer'
}, {
    id: 'Sm9iVHlwZToxMDA4',
    label: 'Other'
}, {
    id: 'Sm9iVHlwZToxMDA5',
    label: 'Art Buyer'
}, {
    id: 'Sm9iVHlwZToxMDEw',
    label: 'Director'
}, {
    id: 'Sm9iVHlwZToxMDEx',
    label: 'Founder, Owner & President'
}, {
    id: 'Sm9iVHlwZToxMDEy',
    label: 'Artist'
}]);
exports.companySizes = alphaSort([{ id: '', label: "I'm self-employed" }, { id: '', label: '2-10' }, { id: '', label: '11-50' }, { id: '', label: '51-100' }, { id: '', label: '100+' }]);
exports.industries = alphaSort([{
    id: 'SW5kdXN0cnk6MzAwMQ==',
    label: 'Advertising Agency'
}, {
    id: 'SW5kdXN0cnk6MzAwMg==',
    label: 'Broadcast Network Studio'
}, {
    id: 'SW5kdXN0cnk6MzAwMw==',
    label: 'Advertising Production House'
}, {
    id: 'SW5kdXN0cnk6MzAwNA==',
    label: 'In-House Agency'
}, {
    id: 'SW5kdXN0cnk6MzAwNQ==',
    label: 'Music House'
},
// {
//   id: 'SW5kdXN0cnk6MzAwNg==',
//   label: 'Production House',
// },
{
    id: 'SW5kdXN0cnk6MzAwNw==',
    label: 'Other'
}, {
    id: 'SW5kdXN0cnk6MzAwOA==',
    label: 'Film & TV Production'
}, {
    id: 'SW5kdXN0cnk6MzAwOQ==',
    label: 'Trailer House'
}, {
    id: 'SW5kdXN0cnk6MzAxMA==',
    label: 'Artist'
}, {
    id: 'SW5kdXN0cnk6MzAxMQ==',
    label: 'Music and Sound Studio'
}]);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Log Out
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.LogoutPageQuery = function () {
  return __webpack_require__(1678);
};
exports.LogoutFormFragment = {
  viewer: function viewer() {
    return __webpack_require__(1679);
  }
};
exports.LogoutMutation = function () {
  return __webpack_require__(1680);
};

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1840);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Olark Chat API
 */

Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:no-string-literal
var olark = window['olark'];
function show() {
    olark('api.box.show');
}
function hide() {
    olark('api.box.hide');
}
function expand() {
    olark('api.box.expand');
}
exports.default = {
    expand: expand,
    hide: hide,
    show: show
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ModalBase Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _animation;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1871);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Position;
(function (Position) {
    Position["Center"] = "center";
    Position["Top"] = "top";
})(Position || (Position = {}));
exports.Position = Position;
var classes = new BEM('modal');
var backgroundAnimationProps = {
    animation: ['transition.fadeIn', 'transition.fadeOut'],
    duration: 350,
    delay: 750
};
var wrapperAnimationProps = {
    animation: (_animation = {}, _defineProperty(_animation, Position.Center, ['transition.expandIn', 'transition.shrinkOut']), _defineProperty(_animation, Position.Top, ['transition.slideDownBigIn', 'transition.slideUpBigOut']), _animation),
    duration: 350,
    delay: 350
};
var defaultProps = {
    position: Position.Center
};

var ModalBase = function (_React$Component) {
    _inherits(ModalBase, _React$Component);

    function ModalBase() {
        _classCallCheck(this, ModalBase);

        var _this = _possibleConstructorReturn(this, (ModalBase.__proto__ || Object.getPrototypeOf(ModalBase)).apply(this, arguments));

        _this.state = {
            visible: true
        };
        _this.onClickAction = function (_ref) {
            var target = _ref.target;

            var htmlTarget = target;
            var button = htmlTarget.closest('.modal__action');
            _this.setState({ visible: false }, function () {
                _this.transitionOutTimer = window.setTimeout(function () {
                    if (button && _this.props.onClose) {
                        _this.props.onClose(button.id);
                    }
                }, 2000);
            });
        };
        return _this;
    }

    _createClass(ModalBase, [{
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes('', _defineProperty({}, this.props.position, true), this.props.className)), React.createElement(Background, { visible: this.state.visible }), React.createElement(Wrapper, { visible: this.state.visible, position: this.props.position }, this.props.children, React.createElement("div", Object.assign({ onClick: this.onClickAction }, classes('actions')), this.props.actions)));
        }
    }]);

    return ModalBase;
}(React.Component);

ModalBase.defaultProps = defaultProps;
var Component = ModalBase;
exports.Component = Component;
// Modal Background
var Background = function Background(_ref2) {
    var visible = _ref2.visible;

    var _backgroundAnimationP = _slicedToArray(backgroundAnimationProps.animation, 2),
        In = _backgroundAnimationP[0],
        Out = _backgroundAnimationP[1];

    return React.createElement(velocity_react_1.VelocityComponent, { animation: visible ? In : Out, delay: visible ? 0 : backgroundAnimationProps.delay, duration: backgroundAnimationProps.duration, runOnMount: true }, React.createElement("div", Object.assign({}, classes('background'))));
};
exports.Background = Background;
// Modal Content Wrapper
var Wrapper = function Wrapper(_ref3) {
    var children = _ref3.children,
        position = _ref3.position,
        visible = _ref3.visible;

    var _wrapperAnimationProp = _slicedToArray(wrapperAnimationProps.animation[position], 2),
        In = _wrapperAnimationProp[0],
        Out = _wrapperAnimationProp[1];

    return React.createElement(velocity_react_1.VelocityComponent, { animation: visible ? In : Out, delay: visible ? wrapperAnimationProps.delay : 0, duration: wrapperAnimationProps.duration, runOnMount: true }, React.createElement("div", Object.assign({}, classes('wrapper')), children));
};
exports.Wrapper = Wrapper;
// Modal Content
var Content = function Content(_a) {
    var children = _a.children,
        className = _a.className,
        props = __rest(_a, ["children", "className"]);

    return React.createElement("div", Object.assign({}, classes('content', '', className), props), children);
};
exports.Content = Content;
// Modal Title
var Title = function Title(_a) {
    var children = _a.children,
        className = _a.className,
        is = _a.is,
        headingProps = __rest(_a, ["children", "className", "is"]);

    return React.createElement(Heading_1.default, Object.assign({ is: is || 'h4' }, classes('title', '', className), headingProps), children);
};
exports.Title = Title;
function getModalActionStyleProps(style) {
    switch (style) {
        case 'cancel':
            return {
                textColor: 'bw7'
            };
        case 'destructive':
            return {
                textColor: 'dangerous'
            };
        default:
            return {
                textColor: 'accent'
            };
    }
}
var Action = function Action(_ref4) {
    var Element = _ref4.Element,
        id = _ref4.id,
        style = _ref4.style;
    return React.cloneElement(Element, Object.assign({}, Element.props, { icon: null, colorScheme: 'transparent', size: 'xxlarge' }, getModalActionStyleProps(style), classes('action'), { id: id }));
};
exports.Action = Action;
var CancelAction = function CancelAction(props) {
    return React.createElement(Action, { Element: React.createElement(Button_1.default, Object.assign({}, props)), id: props.id || 'cancel', style: "cancel" });
};
exports.CancelAction = CancelAction;
var DefaultAction = function DefaultAction(props) {
    return React.createElement(Action, { Element: React.createElement(Button_1.default, Object.assign({}, props)), id: props.id || 'default', style: "default" });
};
exports.DefaultAction = DefaultAction;
var DestructiveAction = function DestructiveAction(props) {
    return React.createElement(Action, { Element: React.createElement(Button_1.default, Object.assign({}, props)), id: props.id || 'destructive', style: "destructive" });
};
exports.DestructiveAction = DestructiveAction;

/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var redux_beacon_1 = __webpack_require__(496);
var gtm_1 = __webpack_require__(349);
var types_1 = __webpack_require__(102);
/****************************************************************************
 * For Facebook Pixel, we re-use GTM's event map as there isn't much to gain
 * from redefining a new map to intercept exactly the same redux actions
 * and, additionally, the data and event structure produced by GTM's event
 * handlers are easy to translate to FBQ events.
 *
 * Therefore, FBQ events received here are in the form of
 * { event, action, label, category, ecommerce }.
 ****************************************************************************/
function processFbq(events) {
    // tslint:disable-next-line:no-string-literal
    if (!window['fbq']) {
        return;
    }
    events.forEach(function (event) {
        switch (event.event) {
            case types_1.AccountEvent.NewAccount:
                fbq('track', 'CompleteRegistration', {
                    content_name: event.event
                });
                break;
            case types_1.SearchEvent.Search:
                fbq('track', 'Search', {
                    search_string: event.label
                });
                break;
            case types_1.LicensingEvent.SetLicense:
                fbq('trackCustom', 'SetLicense', {
                    license: event.label
                });
                break;
            case types_1.CartEvent.AddToCart:
                var product = event.ecommerce.add.products[0];
                fbq('track', 'AddToCart', {
                    content_type: 'product',
                    content_ids: [product.id],
                    contents: [{
                        id: product.id,
                        quantity: 1,
                        item_price: product.price,
                        title: product.name,
                        artist: product.brand,
                        license: product.variant
                    }],
                    currency: event.ecommerce.currencyCode,
                    value: product.price
                });
                break;
            case types_1.CheckoutEvent.Checkout:
                fbq('track', 'InitiateCheckout');
                break;
            case types_1.CheckoutEvent.PlaceOrder:
                var products = event.ecommerce.purchase.products;
                fbq('track', 'Purchase', {
                    content_ids: products.map(function (p) {
                        return p.id;
                    }),
                    content_type: 'product',
                    contents: products.map(function (p) {
                        return {
                            id: p.id,
                            quantity: p.quantity,
                            item_price: p.price,
                            title: p.name,
                            artist: p.brand,
                            license: p.variant
                        };
                    }),
                    currency: event.ecommerce.currencyCode,
                    num_items: products.length,
                    value: event.ecommerce.purchase.actionField.revenue
                });
                break;
        }
    });
}
exports.fbqMiddleware = redux_beacon_1.createMiddleware(gtm_1.eventsMap, processFbq);
exports.fbqMetaReducer = redux_beacon_1.createMetaReducer(gtm_1.eventsMap, processFbq);

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:no-submodule-imports
var ActionTypes = __webpack_require__(195);
function acTrackVisit(email) {
    // tslint:disable:no-string-literal
    if (window['acTrackVisit']) {
        window['acTrackVisit'](email);
    }
    // tslint:enable:no-string-literal
}
exports.acTrackVisit = acTrackVisit;
exports.acTrackVisitOnSetProfile = function (_ref) {
    var payload = _ref.payload;

    acTrackVisit(payload.profile.email);
};
var trackVisit = function trackVisit(_, __, _ref2) {
    var user = _ref2.user;

    var profile = user.profile;
    if (profile && profile.email) {
        acTrackVisit(profile.email);
    }
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
        event: 'pageview',
        pathname: document.location.pathname
    });
};
exports.acEventsMap = _defineProperty({}, ActionTypes.RESOLVE_MATCH, trackVisit);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$cartEventsMa;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = __webpack_require__(196);
var license_1 = __webpack_require__(34);
var types_1 = __webpack_require__(102);
function licenseLineItemToLicenseStr(lineItem) {
    return lineItem.license.usages.map(function (usage) {
        return usage.components.map(function (c) {
            return c.name;
        });
    }).join(', ');
}
exports.licenseLineItemToLicenseStr = licenseLineItemToLicenseStr;
var addItemToCartEvent = function addItemToCartEvent(_ref) {
    var _ref$payload = _ref.payload,
        currencyCode = _ref$payload.currencyCode,
        lineItem = _ref$payload.lineItem;

    var license = license_1.getLicenseString(lineItem.terms);
    return {
        event: types_1.CartEvent.AddToCart,
        category: types_1.EventCategory.Cart,
        action: types_1.CartEvent.AddToCart,
        label: lineItem.track.title + " (" + license + ")",
        ecommerce: {
            currencyCode: currencyCode,
            add: {
                products: [{
                    name: lineItem.track.title,
                    id: lineItem.track.internal_id,
                    price: lineItem.track.price,
                    brand: lineItem.track.artist.name,
                    category: 'License',
                    variant: license,
                    quantity: 1,
                    list: window.location.pathname
                }]
            }
        }
    };
};
var removeItemFromCartEvent = function removeItemFromCartEvent(_ref2) {
    var _ref2$payload = _ref2.payload,
        currencyCode = _ref2$payload.currencyCode,
        lineItem = _ref2$payload.lineItem;

    var license = licenseLineItemToLicenseStr(lineItem);
    return {
        event: types_1.CartEvent.RemoveFromCart,
        category: types_1.EventCategory.Cart,
        action: types_1.CartEvent.RemoveFromCart,
        label: lineItem.track.title + " (" + license + ")",
        ecommerce: {
            currencyCode: currencyCode,
            remove: {
                products: [{
                    name: lineItem.track.title,
                    id: lineItem.track.internal_id,
                    price: lineItem.track.price,
                    brand: lineItem.track.artist.name,
                    category: 'License',
                    variant: license,
                    quantity: 1
                }]
            }
        }
    };
};
exports.cartEventsMap = (_exports$cartEventsMa = {}, _defineProperty(_exports$cartEventsMa, cart_1.requestAddItemToCart.type, addItemToCartEvent), _defineProperty(_exports$cartEventsMa, cart_1.requestRemoveItemFromCart.type, removeItemFromCartEvent), _exports$cartEventsMa);

/***/ }),
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SectionTemplate Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
__webpack_require__(1253);
var SectionTemplate = function SectionTemplate(_ref) {
  var children = _ref.children,
      id = _ref.id;
  return React.createElement("div", { className: "main__section", "data-section-id": id }, children);
};
exports.default = SectionTemplate;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var taxonomy_1 = __webpack_require__(106);
var types_1 = __webpack_require__(105);
var searchTypeDelimiter = ':';
exports.searchQueryKey = 'keywords' + searchTypeDelimiter;
exports.searchFilterExcludeChar = '!';
exports.searchDelimiter = ',';
exports.TaxonomyQueryStringKey = _defineProperty({}, taxonomy_1.TaxonomyType.Lyrics, 'lyrics' + searchTypeDelimiter);
exports.QueryStringKeyToTaxonomyType = lodash_1.invert(exports.TaxonomyQueryStringKey);
exports.taxonomyQueryStringKeyRegEx = new RegExp("^(" + lodash_1.values(exports.TaxonomyQueryStringKey).join('|') + ")(.+)");
exports.taxonomyIdToQueryKey = function (id) {
    return exports.TaxonomyQueryStringKey[taxonomy_1.TaxonomyIdToTaxonomyType[id]] || 'unknown';
};
exports.searchQueryTemplate = function (_ref) {
    var searchQuery = _ref.searchQuery;

    // Remove any non-word characters, especially the search delimiter, from the query
    // so there are no parsing issues during query string deserialization
    searchQuery = searchQuery.replace(/[\W]+/g, ' ').trim();
    return "" + exports.searchQueryKey + searchQuery;
};
exports.searchQueryRegEx = new RegExp(exports.searchQueryKey + "[\\w ]*", 'g');
function getSearchAsArray(query) {
    return lodash_1.compact(query[types_1.QueryStringParam.Search].split(exports.searchDelimiter));
}
exports.getSearchAsArray = getSearchAsArray;
function filterIsQuery(filter) {
    return filter.indexOf(exports.searchQueryKey) === 0;
}
function filterIsExcluded(filter) {
    return filter[0] === exports.searchFilterExcludeChar;
}
function parseTaxonomyQuery(filter) {
    var matches = filter.match(exports.taxonomyQueryStringKeyRegEx);
    return matches && {
        key: matches[1],
        value: matches[2]
    };
}
exports.parseTaxonomyQuery = parseTaxonomyQuery;
exports.SearchFilter = {
    searchParamsToArray: function searchParamsToArray(params) {
        if (params) {
            var filters = params.filters,
                query = params.query;

            var searchQuery = query ? [exports.searchQueryTemplate({ searchQuery: query })] : [];
            if (filters) {
                var termFilters = filters.term_filters ? filters.term_filters.map(function (name) {
                    return exports.SearchFilter.serializeTerm({ name: name }, false);
                }) : [];
                var excludedTermFilters = filters.not_term_filters ? filters.not_term_filters.map(function (name) {
                    return exports.SearchFilter.serializeTerm({ name: name }, true);
                }) : [];
                return searchQuery.concat(termFilters, excludedTermFilters);
            }
            return searchQuery;
        }
        return [];
    },
    serialize: function serialize(filters) {
        var encodedFilters = filters.map(function (filter) {
            var taxonomyQueryMatch = parseTaxonomyQuery(filter);
            if (filter.indexOf(exports.searchQueryKey) === 0) {
                var keywordsRegExp = new RegExp("^(" + exports.searchQueryKey + ")(.+)$");
                return filter.replace(keywordsRegExp, function (_, key, query) {
                    return "" + key + encodeURIComponent(query);
                });
            } else if (taxonomyQueryMatch) {
                return filter.replace(taxonomyQueryMatch.value, encodeURIComponent(taxonomyQueryMatch.value));
            }
            return encodeURIComponent(filter);
        });
        return "" + encodedFilters;
    },
    serializeTerm: function serializeTerm(term, exclude) {
        return exclude ? "" + exports.searchFilterExcludeChar + term.name : term.name;
    },
    serializeTaxonomyQuery: function serializeTaxonomyQuery(term) {
        var key = exports.taxonomyIdToQueryKey(term.taxonomy.id);
        return "" + key + term.name;
    },
    unserialize: function unserialize(query) {
        var state = {
            query: '',
            filters: {
                not_term_filters: [],
                term_filters: []
            }
        };
        if (types_1.QueryStringParam.Search in query) {
            var search = getSearchAsArray(query);
            state = search.reduce(function (acc, filter) {
                var taxonomyQueryMatch = parseTaxonomyQuery(filter);
                if (filterIsQuery(filter)) {
                    return Object.assign({}, acc, { query: decodeURIComponent(filter.substring(exports.searchQueryKey.length)) });
                } else if (filterIsExcluded(filter)) {
                    return Object.assign({}, acc, { filters: Object.assign({}, acc.filters, { not_term_filters: [].concat(_toConsumableArray(acc.filters.not_term_filters), [decodeURIComponent(filter.substring(exports.searchFilterExcludeChar.length))]) }) });
                } else if (taxonomyQueryMatch) {
                    return Object.assign({}, acc, { taxonomy_query: {
                            query: decodeURIComponent(taxonomyQueryMatch.value),
                            taxonomy_id: taxonomy_1.TaxonomyId[exports.QueryStringKeyToTaxonomyType[taxonomyQueryMatch.key]]
                        } });
                } else {
                    return Object.assign({}, acc, { filters: Object.assign({}, acc.filters, { term_filters: [].concat(_toConsumableArray(acc.filters.term_filters), [decodeURIComponent(filter)]) }) });
                }
            }, state);
        }
        if (types_1.QueryStringParam.Similarity in query) {
            state.filters.similarity = {
                track_id: query[types_1.QueryStringParam.Similarity],
                feature: "Default" /* Default */
            };
        }
        return state;
    }
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(105);
exports.TempoFilter = {
    serialize: function serialize(tempo) {
        if (tempo) {
            if (tempo.minimum) {
                if (tempo.maximum) {
                    return tempo.minimum === tempo.maximum ? "" + tempo.maximum : tempo.minimum + "-" + tempo.maximum;
                } else {
                    return ">" + tempo.minimum;
                }
            } else if (tempo.maximum) {
                return "<" + tempo.maximum;
            }
        }
        return '';
    },
    unserialize: function unserialize(query) {
        if (types_1.QueryStringParam.Tempo in query) {
            var tempo = query[types_1.QueryStringParam.Tempo];
            var parts = tempo.match(/^([<,>]?)(\d)-?(\d?)$/);
            if (parts != null) {
                var _parts = _slicedToArray(parts, 4),
                    symbol = _parts[1],
                    first = _parts[2],
                    second = _parts[3];

                var firstNumber = parseInt(first, 10);
                var secondNumber = parseInt(second, 10);
                switch (symbol) {
                    case '<':
                        return {
                            minimum: null,
                            maximum: firstNumber
                        };
                    case '>':
                        return {
                            minimum: firstNumber,
                            maximum: null
                        };
                    default:
                        return {
                            minimum: firstNumber,
                            maximum: secondNumber || firstNumber
                        };
                }
            }
        }
        return;
    }
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Checkbox Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var color_schemes_1 = __webpack_require__(143);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1265);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var classes = new BEM('checkbox');

var Checkbox = function (_React$Component) {
    _inherits(Checkbox, _React$Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.onChange = function () {
            _this.setState({
                checked: !_this.state.checked
            }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(_this.state.checked, _this.input);
                }
            });
        };
        _this.state = {
            checked: false
        };
        return _this;
    }

    _createClass(Checkbox, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.defaultChecked) {
                this.onChange();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                colorScheme = _props.colorScheme,
                input = _props.input,
                meta = _props.meta,
                size = _props.size,
                multiple = _props.multiple,
                checked = _props.checked;

            var name = input ? input.name : this.props.name;
            var Icon = multiple ? Icon_1.IconCheckMultiple : Icon_1.IconCheck;
            var inputControlProps = {
                onChange: this.onChange,
                checked: this.state.checked
            };
            if (input) {
                inputControlProps.onChange = function (e) {
                    _this2.onChange();input.onChange(e, e.target.value, null);
                };
                inputControlProps.checked = input.value;
            } else if (checked != null) {
                inputControlProps.checked = checked;
            }
            var extraClasses = classNames(colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme, 'checkbox'), className);
            var labelClasses = new BEM('label');
            return React.createElement("div", Object.assign({}, classes('', size, extraClasses)), React.createElement("input", Object.assign({ ref: function ref(node) {
                    return _this2.input = node;
                }, type: "checkbox", id: name, name: name }, inputControlProps)), React.createElement("label", Object.assign({ htmlFor: name }, classes('styled-input')), meta && (meta.error && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'error'), { size: "medium", textColor: "dangerous" }), meta.error) || meta.warning && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'warning'), { size: "medium" }), meta.warning)), React.createElement("div", Object.assign({}, classes('styled-input__fill'))), React.createElement(Icon, null)), children);
        }
    }]);

    return Checkbox;
}(React.Component);

Checkbox.defaultProps = {
    colorScheme: 'light',
    size: 'normal'
};
exports.default = Checkbox;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LocationCheckbox Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
var grid_1 = __webpack_require__(58);
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var Tooltip_1 = __webpack_require__(172);
var config_1 = __webpack_require__(142);
var FAQ_1 = __webpack_require__(277);
var CheckboxWithLabel_1 = __webpack_require__(213);
var LocationTooltip = function LocationTooltip(_ref) {
    var hint = _ref.hint;
    return React.createElement(Tooltip_1.Tooltip, { content: React.createElement("div", null, React.createElement(Label_1.Span, { size: "medium", block: true }, hint), React.createElement(Button_1.default, { label: "See FAQ for details", variant: "hyperlink", wrapperComponent: "a", hyperLinkProps: {
                href: router_1.linkWithCurrentQueryString(FAQ_1.FAQPagePath + "/licensing-music#license-territories-and-clusters"),
                target: '_blank'
            }, style: {
                marginTop: grid_1.baseline
            } })), distance: grid_1.baseline * 1.5, placement: "bottom", theme: "black", interactive: true }, React.createElement(Icon_1.IconInfoFilled, { className: "tooltip" }));
};

var LocationCheckbox = function (_React$PureComponent) {
    _inherits(LocationCheckbox, _React$PureComponent);

    function LocationCheckbox(props) {
        _classCallCheck(this, LocationCheckbox);

        var _this = _possibleConstructorReturn(this, (LocationCheckbox.__proto__ || Object.getPrototypeOf(LocationCheckbox)).call(this, props));

        _this.onChange = function (checked) {
            var _this$props = _this.props,
                id = _this$props.id,
                name = _this$props.name,
                onChange = _this$props.onChange;

            onChange({ id: id, name: name }, checked);
        };
        _this.componentHint = config_1.componentHints.find(function (comp) {
            return comp.id === props.id;
        });
        return _this;
    }

    _createClass(LocationCheckbox, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                checked = _props.checked,
                id = _props.id,
                name = _props.name;

            return React.createElement(CheckboxWithLabel_1.default, { checked: checked, onChange: this.onChange, label: name, name: "location[" + id + "]" }, !!this.componentHint && React.createElement(LocationTooltip, { hint: this.componentHint.hint }));
        }
    }]);

    return LocationCheckbox;
}(React.PureComponent);

exports.LocationCheckbox = LocationCheckbox;

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseBuilder Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var grid_1 = __webpack_require__(58);
var config_1 = __webpack_require__(142);
__webpack_require__(1339);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var onboarding_1 = __webpack_require__(400);
var types_1 = __webpack_require__(1341);
var license_1 = __webpack_require__(34);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Drawer_1 = __webpack_require__(215);
exports.getContextualParam = function (currentMedium) {
    return function (params) {
        return lodash_1.find(params, function (_ref) {
            var medium = _ref.medium,
                param = _ref.param;
            return medium.indexOf(currentMedium) > -1;
        });
    };
};
var classes = new BEM('license-builder');

var LicenseBuilder = function (_React$Component) {
    _inherits(LicenseBuilder, _React$Component);

    function LicenseBuilder(props) {
        _classCallCheck(this, LicenseBuilder);

        var _this = _possibleConstructorReturn(this, (LicenseBuilder.__proto__ || Object.getPrototypeOf(LicenseBuilder)).call(this, props));

        _this.drawerElement = React.createRef();
        _this.onClickSave = function () {
            _this.setState({ drawerOpen: false });
            _this.props.onSave(_this.props.licenseUsages);
        };
        _this.onClose = function (cancel) {
            if (cancel) {
                if (_this.props.licenseUsages.length === 0) {
                    // We send an empty array to save
                    _this.props.onSave([]);
                }
            } else {
                _this.props.onboarding.unlockAchievement(types_1.OnboardingAchievement.BuildLicense);
            }
            _this.props.onClose();
        };
        _this.state = {
            currentStep: 1,
            hasDeletedAllMedia: false,
            drawerOpen: true,
            previousTermsState: Object.assign({}, _this.props.termsState)
        };
        return _this;
    }

    _createClass(LicenseBuilder, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.setCurrentDisplayState();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            this.setCurrentDisplayState(prevProps);
            if (prevState.currentStep !== this.state.currentStep) {
                var scroller = this.drawerElement.current.getElementsByClassName('drawer__content')[0];
                var steps = this.drawerElement.current.getElementsByClassName('license-builder__step');
                Velocity(lodash_1.last(steps), 'scroll', {
                    axis: 'x',
                    container: scroller,
                    delay: 1500,
                    duration: 500
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                editingUsageIndex = _props.editingUsageIndex,
                licenseComponents = _props.licenseComponents,
                licenseUsages = _props.licenseUsages;
            var _state = this.state,
                currentStep = _state.currentStep,
                drawerOpen = _state.drawerOpen;

            var steps = [];
            var LicenseBuildingStep = void 0;
            var stepInfo = void 0;
            for (var step = 1; step <= currentStep; step++) {
                if (step === config_1.contextualParamStep) {
                    if (editingUsageIndex !== null) {
                        var currentUsage = licenseUsages[editingUsageIndex];
                        if (currentUsage) {
                            var currentMediumId = currentUsage.medium.id;
                            var contextualComponents = config_1.licenseBuildingSteps[step - 1];
                            var contextualParam = exports.getContextualParam(currentMediumId)(config_1.contextualParamMapping);
                            stepInfo = lodash_1.find(contextualComponents, { id: contextualParam.param });
                            stepInfo.title = license_1.getContextualParamTitle(currentUsage);
                        } else {
                            stepInfo = null;
                        }
                    } else {
                        stepInfo = null;
                    }
                } else {
                    // If the selected medium is a programming medium, then skip Term/SpotCount steps
                    if (editingUsageIndex !== null) {
                        var _currentUsage = licenseUsages[editingUsageIndex];
                        if (_currentUsage) {
                            var _currentMediumId = _currentUsage.medium.id;
                            if (config_1.programmingMedia.indexOf(_currentMediumId) > -1 && (step === config_1.termStep || step === config_1.spotCountStep)) {
                                continue;
                            }
                        }
                    }
                    stepInfo = config_1.licenseBuildingSteps[step - 1];
                }
                if (stepInfo != null) {
                    LicenseBuildingStep = stepInfo.component;
                    var connection = licenseComponents[stepInfo.id];
                    if (connection) {
                        var stepProps = {
                            data: connection.edges,
                            title: stepInfo.title
                        };
                        steps.push(React.createElement(LicenseBuildingStep, Object.assign({ key: stepInfo.id }, classes('step'), stepProps)));
                    }
                }
            }
            return React.createElement(React.Fragment, null, React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, "Set Your License")), React.createElement(Drawer_1.default, Object.assign({ closeButtonLabel: this.state.hasDeletedAllMedia ? 'Close' : 'Cancel', onClose: this.onClose, open: drawerOpen, ref: this.drawerElement, headerIcon: React.createElement(React.Fragment, null, React.createElement(Icon_1.LogoBopper, { style: { marginRight: grid_1.baseline } }), React.createElement(Heading_1.default, { is: "h4", textColor: "bw6" }, "Create your license to activate pricing.")), actionButton: !this.state.hasDeletedAllMedia && React.createElement(Button_1.default, { label: "Save", colorScheme: "accent", size: "small-medium", variant: "pill", onClick: this.onClickSave, disabled: !this.props.isLicenseValid }), position: "fullscreen" }, classes('', '', className)), !!steps.length ? steps : React.createElement("div", Object.assign({}, classes('error')), React.createElement(Icon_1.IconWarningLarge, null), React.createElement(Heading_1.default, { is: "h2" }, "Something went wrong."), React.createElement(Heading_1.default, { is: "h4" }, "Please try again later."))));
        }
    }, {
        key: "setCurrentDisplayState",
        value: function setCurrentDisplayState(prevProps) {
            var step = 1;
            if (this.props.editingUsageIndex !== null) {
                var usage = this.props.licenseUsages[this.props.editingUsageIndex];
                if (usage) {
                    step = usage.contextual_param || usage.spot_count ? config_1.contextualParamStep : usage.term ? config_1.spotCountStep : config_1.termStep;
                    if (config_1.programmingMedia.indexOf(usage.medium.id) > -1) {
                        step = config_1.contextualParamStep;
                    }
                }
            }
            var stateUpdate = {};
            if (step !== this.state.currentStep) {
                stateUpdate.currentStep = step || this.state.currentStep + 1;
                if (step > this.state.currentStep && this.state.hasDeletedAllMedia) {
                    stateUpdate.hasDeletedAllMedia = false;
                }
            }
            if (prevProps && prevProps.licenseUsages.length > 0 && this.props.licenseUsages.length === 0) {
                stateUpdate.hasDeletedAllMedia = true;
            }
            if (!lodash_1.isEmpty(stateUpdate)) {
                this.setState(stateUpdate);
            }
        }
    }]);

    return LicenseBuilder;
}(React.Component);

var ConnectedLicenseBuilder = react_redux_1.connect(function (_ref2) {
    var license = _ref2.license,
        licenseComponents = _ref2.staticData.licenseComponents;
    return {
        editingUsageIndex: license.editingUsageIndex,
        isLicenseValid: license.isValid,
        licenseComponents: licenseComponents,
        licenseUsages: license.usages,
        termsState: license
    };
})(LicenseBuilder);
var LicenseBuilderWithContexts = function LicenseBuilderWithContexts(props) {
    return React.createElement(onboarding_1.OnboardingContext.Consumer, null, function (_ref3) {
        var unlockAchievement = _ref3.unlockAchievement;
        return React.createElement(ConnectedLicenseBuilder, Object.assign({ onboarding: { unlockAchievement: unlockAchievement } }, props));
    });
};
exports.default = LicenseBuilderWithContexts;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('Impressions');
exports.trackImpression = actionCreator('TRACK');

/***/ }),
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AuthenticationDrawer Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var string_1 = __webpack_require__(47);
var url_1 = __webpack_require__(183);
__webpack_require__(1420);
var found_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Drawer_1 = __webpack_require__(215);
var Login_1 = __webpack_require__(152);
var EmailPasswordForm_1 = __webpack_require__(633);
var classes = new BEM('login-drawer');

var AuthenticationDrawer = function (_React$Component) {
    _inherits(AuthenticationDrawer, _React$Component);

    function AuthenticationDrawer(props) {
        _classCallCheck(this, AuthenticationDrawer);

        var _this = _possibleConstructorReturn(this, (AuthenticationDrawer.__proto__ || Object.getPrototypeOf(AuthenticationDrawer)).call(this, props));

        _this.close = function () {
            return new Promise(function (resolve, reject) {
                _this.setState({ isOpen: false }, resolve);
            });
        };
        _this.onClickLogIn = function () {
            if (_this.props.useAbsoluteLink) {
                _this.props.router.push(Login_1.LoginPagePath);
            } else {
                _this.close().then(_this.props.showLogInForm);
            }
        };
        _this.onClickSignUp = function () {
            if (_this.props.useAbsoluteLink) {
                _this.props.router.push(Login_1.SignupPagePath);
            } else {
                _this.close().then(_this.props.showSignUpForm);
            }
        };
        _this.onAuthenticateWithEmail = function (cognitoSession) {
            _this.close().then(function () {
                _this.props.authenticateWithEmail(cognitoSession);
            });
        };
        _this.onClose = function (action) {
            _this.props.close(action);
        };
        _this.state = {
            isOpen: true
        };
        return _this;
    }

    _createClass(AuthenticationDrawer, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                action = _props.action,
                className = _props.className,
                drawerProps = _props.drawerProps,
                facebookLoginUrl = _props.facebookLoginUrl,
                googleLoginUrl = _props.googleLoginUrl,
                match = _props.match,
                signUpReason = _props.signUpReason;

            var emailFormInitialValues = {
                email: '',
                password: ''
            };
            if (match.location.query.email) {
                emailFormInitialValues.email = match.location.query.email;
            }
            var hasReason = !!signUpReason;
            var introTitle = void 0;
            var introText = void 0;
            var onClickOppositeAction = void 0;
            if (action === 'login') {
                introTitle = locales_1.default.login.intro.title;
                introText = locales_1.default.login.intro.text;
                onClickOppositeAction = this.onClickSignUp;
            } else {
                // introTitle = tr.signup.intro[signUpReason].title;
                introTitle = lodash_1.get(locales_1.default, "signup.intro." + signUpReason + ".title", locales_1.default.signup.intro.default.title);
                introText = lodash_1.get(locales_1.default, "signup.intro." + signUpReason + ".text", locales_1.default.signup.intro.default.text);
                onClickOppositeAction = this.onClickLogIn;
            }
            var translations = locales_1.default[action];
            return React.createElement(Drawer_1.default, Object.assign({ closeButtonLabel: hasReason ? 'Cancel' : undefined, onClose: function onClose() {
                    return _this2.onClose(action);
                }, open: this.state.isOpen, position: "right" }, drawerProps, classes('', '', className)), React.createElement("div", Object.assign({}, classes('intro', '', 'drawer__content-group')), React.createElement(Heading_1.default, { is: "h4" }, React.createElement("span", { dangerouslySetInnerHTML: string_1.toInnerHTML(introTitle) })), introText && React.createElement("p", { dangerouslySetInnerHTML: string_1.toInnerHTML(introText) })), React.createElement("div", Object.assign({}, classes('email-method', '', 'drawer__content-group'), { "data-title": translations.userPasswordMethodTitle }), React.createElement(EmailPasswordForm_1.default, { key: action + "-form", form: action + "-form", action: action, initialValues: emailFormInitialValues, onClickOppositeAction: onClickOppositeAction, onSubmitSuccess: this.onAuthenticateWithEmail, onForgetPassword: function onForgetPassword() {
                    return _this2.close();
                } })), (!!googleLoginUrl || !!facebookLoginUrl) && React.createElement("div", Object.assign({}, classes('methods', '', 'drawer__button-list'), { "data-title": translations.methodsTitle }), googleLoginUrl && React.createElement(Button_1.default, { className: "drawer__button-list__button", icon: React.createElement(Icon_1.IconGoogle, null), label: translations.googleLabel, hyperLinkProps: { href: googleLoginUrl }, wrapperComponent: "a" }, React.createElement(Icon_1.IconExternalLink, null)), facebookLoginUrl && React.createElement(Button_1.default, { className: "drawer__button-list__button", icon: React.createElement(Icon_1.IconFacebook, null), label: translations.facebookLabel, hyperLinkProps: { href: facebookLoginUrl }, wrapperComponent: "a" }, React.createElement(Icon_1.IconExternalLink, null))));
        }
    }]);

    return AuthenticationDrawer;
}(React.Component);

AuthenticationDrawer.defaultProps = {
    action: 'login'
};
var ConnectedAuthenticationDrawer = react_redux_1.connect(function (_ref) {
    var authentication = _ref.authentication,
        postAuthenticationRequests = _ref.postAuthenticationRequests,
        ui = _ref.ui,
        user = _ref.user;

    var facebookLoginUrl = authentication.facebookLoginUrl;
    var googleLoginUrl = authentication.googleLoginUrl;
    // tslint:disable-next-line:no-invalid-template-strings
    var loginPageUrl = Login_1.LoginPagePath + '#id_token=${idToken}&access_token=${accessToken}';
    if (postAuthenticationRequests.length) {
        var state = url_1.encodeForUrl({
            stateType: 'PostAuthenticationRequests',
            postAuthenticationRequests: postAuthenticationRequests
        });
        facebookLoginUrl += "&state=" + state;
        googleLoginUrl += "&state=" + state;
        loginPageUrl += "&state=" + state;
    }
    return {
        cognitoSession: user.cognitoSession,
        facebookLoginUrl: facebookLoginUrl,
        googleLoginUrl: googleLoginUrl,
        loginPageUrl: loginPageUrl,
        signUpReason: ui.signUpForm && ui.signUpForm.reason || 'default'
    };
}, function (dispatch) {
    return {
        close: function close(which) {
            var action = which === 'login' ? ui_1.toggleLogInFormVisibility : ui_1.toggleSignUpFormVisibility;
            dispatch(postAuthenticationRequests_1.clearPostAuthenticationRequests());
            dispatch(action(false));
        },
        showLogInForm: function showLogInForm() {
            dispatch(ui_1.toggleLogInFormVisibility(true));
        },
        showSignUpForm: function showSignUpForm() {
            dispatch(ui_1.toggleSignUpFormVisibility(true));
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, stateProps, dispatchProps, ownProps, { authenticateWithEmail: function authenticateWithEmail(cognitoSession) {
            var idToken = cognitoSession.getIdToken().getJwtToken();
            var accessToken = cognitoSession.getAccessToken().getJwtToken();
            var routePath = lodash_1.template(stateProps.loginPageUrl)({
                idToken: idToken,
                accessToken: accessToken
            });
            ownProps.router.push(routePath);
        } });
}, {
    areStatesEqual: function areStatesEqual(nextState, prevState) {
        return lodash_1.isEqual(nextState.authentication, prevState.authentication);
    }
})(AuthenticationDrawer);
var AuthenticationDrawerWithRouter = found_1.withRouter(ConnectedAuthenticationDrawer);
exports.default = AuthenticationDrawerWithRouter;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * EmailPasswordForm Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var actions = __webpack_require__(50);
var utils_1 = __webpack_require__(125);
var string_1 = __webpack_require__(47);
var found_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var FormError_1 = __webpack_require__(417);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var LoadingButton_1 = __webpack_require__(286);
var ForgottenPassword_1 = __webpack_require__(634);
var classes = new BEM('email-password-form');

var EmailPasswordForm = function (_React$Component) {
    _inherits(EmailPasswordForm, _React$Component);

    function EmailPasswordForm(props) {
        _classCallCheck(this, EmailPasswordForm);

        var _this = _possibleConstructorReturn(this, (EmailPasswordForm.__proto__ || Object.getPrototypeOf(EmailPasswordForm)).call(this, props));

        _this.onSignUp = function (credentials) {
            return new Promise(function (resolve, reject) {
                _this.props.requestAuthentication(true, credentials, { resolve: resolve, reject: _this.onSignUpFailed(reject) });
            });
        };
        _this.onLogin = function (credentials) {
            return new Promise(function (resolve, reject) {
                _this.props.requestAuthentication(false, credentials, { resolve: resolve, reject: _this.onLoginFailed(reject) });
            });
        };
        _this.onSubmit = function (fields) {
            return _this.validate(fields).then(function () {
                return _this.onSubmitAction(fields);
            });
        };
        _this.onSignUpFailed = function (reject) {
            return function (err) {
                var message = '';
                var field = void 0;
                switch (err.name) {
                    case 'UsernameExistsException':
                        message = locales_1.default.errors.signup.alreadyExists;
                        field = 'email';
                        break;
                    case 'InvalidPasswordException':
                        message = lodash_1.template(locales_1.default.errors.signup.invalidPassword)({ passwordPolicy: locales_1.default.validations.password });
                        field = 'password';
                        break;
                    default:
                        message = locales_1.default.errors.signup.default;
                        field = '_error';
                        break;
                }
                reject(new redux_form_1.SubmissionError(_defineProperty({}, field, message)));
            };
        };
        _this.onLoginFailed = function (reject) {
            return function (err) {
                var message = '';
                var field = void 0;
                switch (err.name) {
                    case 'UserNotFoundException':
                        message = locales_1.default.errors.login.userNotFound;
                        field = 'email';
                        break;
                    default:
                        message = locales_1.default.errors.login.credentials;
                        field = '_error';
                        break;
                }
                reject(new redux_form_1.SubmissionError(_defineProperty({}, field, message)));
            };
        };
        _this.state = {
            submitting: false
        };
        if (props.action === 'login') {
            _this.actionLabel = locales_1.default.login.action;
            _this.oppositionActionLabel = locales_1.default.signup.action;
            _this.oppositionActionQuestion = locales_1.default.signup.actionQuestion;
            _this.onSubmitAction = _this.onLogin;
        } else {
            _this.actionLabel = locales_1.default.signup.action;
            _this.oppositionActionLabel = locales_1.default.login.action;
            _this.oppositionActionQuestion = locales_1.default.login.actionQuestion;
            _this.onSubmitAction = _this.onSignUp;
        }
        return _this;
    }

    _createClass(EmailPasswordForm, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !lodash_1.isEqual(nextState, this.state);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref3) {
            var submitting = _ref3.submitting;

            if (submitting !== this.props.submitting) {
                this.setState({ submitting: !!submitting });
            }
        }
    }, {
        key: "renderOppositeAction",
        value: function renderOppositeAction() {
            var _props = this.props,
                action = _props.action,
                disableOppositeAction = _props.disableOppositeAction,
                onClickOppositeAction = _props.onClickOppositeAction,
                onForgetPassword = _props.onForgetPassword,
                submitting = _props.submitting;

            return React.createElement("div", Object.assign({}, classes('opposite-action')), action === 'login' && React.createElement(LinkButton_1.default, Object.assign({ to: ForgottenPassword_1.ForgottenPasswordPagePath, onClick: onForgetPassword, label: "Forgot your password?", size: "medium", variant: "hyperlink", disabled: submitting }, classes('forget-password-button'))), !disableOppositeAction && React.createElement(Label_1.Span, Object.assign({ size: "medium" }, classes('opposite-action__question')), this.oppositionActionQuestion), !disableOppositeAction && React.createElement(Button_1.default, { onClick: onClickOppositeAction, label: this.oppositionActionLabel, colorScheme: "light", size: "small", disabled: submitting }));
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                action = _props2.action,
                className = _props2.className,
                error = _props2.error,
                handleSubmit = _props2.handleSubmit,
                submitting = _props2.submitting;

            return React.createElement(redux_form_1.Form, Object.assign({ onSubmit: handleSubmit(this.onSubmit) }, classes('', '', className)), error && React.createElement(FormError_1.default, { error: error }), React.createElement(utils_1.FieldEmail, { component: TextField_1.default, colorScheme: "light", icon: React.createElement(Icon_1.IconMail, null), name: "email", placeholder: locales_1.default.inputs.email, disabled: submitting, onlyValidateIfTouched: true, withoutBorder: true }), React.createElement(utils_1.FieldPassword, { component: TextField_1.default, colorScheme: "light", icon: React.createElement(Icon_1.IconLock, null), name: "password", placeholder: locales_1.default.inputs.password, disabled: submitting, warn: action === 'signup', withoutBorder: true }), React.createElement(LoadingButton_1.default, { isLoading: !!submitting, label: this.actionLabel, colorScheme: "dark", size: "medium-large", isSubmit: true }), this.renderOppositeAction());
        }
    }, {
        key: "validate",
        value: function validate(_ref4) {
            var _this2 = this;

            var email = _ref4.email,
                password = _ref4.password;

            return new Promise(function (resolve, reject) {
                var errors = {};
                if (!email) {
                    errors.email = locales_1.default.validations.required;
                } else if (!string_1.validateEmail(email)) {
                    errors.email = locales_1.default.validations.email;
                }
                if (!password) {
                    errors.password = locales_1.default.validations.required;
                } else if (_this2.props.action === 'signup' && !string_1.validatePassword(password)) {
                    errors.password = locales_1.default.validations.password;
                }
                if (lodash_1.size(errors)) {
                    reject(new redux_form_1.SubmissionError(errors));
                } else {
                    resolve();
                }
            });
        }
    }]);

    return EmailPasswordForm;
}(React.Component);

var ConnectedEmailPassword = react_redux_1.connect(function (_ref5) {
    var authentication = _ref5.authentication;
    return {
        userPool: authentication.userPool
    };
}, function (dispatch) {
    return {
        requestAuthentication: function requestAuthentication(isSignUp, credentials, promise) {
            var action = isSignUp ? actions.requestUserSignUp : actions.requestUserLogIn;
            dispatch(action({ credentials: credentials, promise: promise }));
        }
    };
})(EmailPasswordForm);
var ConnectedEmailPasswordReduxForm = redux_form_1.reduxForm({
    keepDirtyOnReinitialize: true
})(ConnectedEmailPassword);
var ConnectedEmailPasswordReduxFormWithRouter = found_1.withRouter(ConnectedEmailPasswordReduxForm);
exports.default = ConnectedEmailPasswordReduxFormWithRouter;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ForgottentPasswordPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var actions = __webpack_require__(50);
var utils_1 = __webpack_require__(125);
var string_1 = __webpack_require__(47);
__webpack_require__(1432);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var FormError_1 = __webpack_require__(417);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Login_1 = __webpack_require__(152);
exports.ForgottenPasswordPagePath = '/forgotten-password';
var classes = new BEM('forgotten-password');

var ForgottentPasswordPage = function (_React$Component) {
    _inherits(ForgottentPasswordPage, _React$Component);

    function ForgottentPasswordPage(props) {
        _classCallCheck(this, ForgottentPasswordPage);

        var _this = _possibleConstructorReturn(this, (ForgottentPasswordPage.__proto__ || Object.getPrototypeOf(ForgottentPasswordPage)).call(this, props));

        _this.onSubmit = function (fields) {
            return _this.validate(fields).then(function () {
                return new Promise(function (resolve, reject) {
                    var email = fields.email || _this.state.email || '';
                    var password = fields.password;
                    var failureHandler = password ? _this.onResetFailed : _this.onRequestFailed;
                    _this.props.requestResetPassword(email, resolve, failureHandler(reject), _this.state.verificationCode, password);
                });
            });
        };
        _this.onRequestFailed = function (reject) {
            return function (err) {
                var message = '';
                var field = void 0;
                switch (err.name) {
                    case 'UserNotFoundException':
                        message = 'Sorry, we don\'t know that email. Make sure it is well-written and maybe try again.';
                        field = 'email';
                        break;
                    case 'LimitExceededException':
                        message = 'Attempt limit exceeded, please try after some time.';
                        field = '_error';
                        break;
                    case 'InvalidParameterException':
                        /* tslint:disable-next-line */
                        message = 'It seems you haven\'t yet confirmed your email address. You should have received an email from us, shortly after signing up, containing a link to confirm your email. Click that link and then you\'ll be able to reset your password.';
                        field = '_error';
                        break;
                    default:
                        message = locales_1.default.errors.genericMessage;
                        field = '_error';
                        break;
                }
                reject(new redux_form_1.SubmissionError(_defineProperty({}, field, message)));
            };
        };
        _this.onResetFailed = function (reject) {
            return function (err) {
                var message = '';
                var field = void 0;
                switch (err.name) {
                    case 'InvalidPasswordException':
                        message = lodash_1.template(locales_1.default.errors.signup.invalidPassword)({ passwordPolicy: locales_1.default.validations.password });
                        field = 'password';
                        break;
                    case 'LimitExceededException':
                        message = 'Attempt limit exceeded, please try after some time.';
                        field = '_error';
                        break;
                    case 'ExpiredCodeException':
                        message = 'The provided code is expired. Enter your email and try again.';
                        field = '_error';
                        _this.setState({
                            email: undefined,
                            verificationCode: undefined
                        });
                        break;
                    default:
                        message = locales_1.default.errors.genericMessage;
                        field = '_error';
                        break;
                }
                reject(new redux_form_1.SubmissionError(_defineProperty({}, field, message)));
            };
        };
        _this.state = {
            email: props.location.query.email,
            error: props.location.query.error,
            verificationCode: props.location.query.code
        };
        return _this;
    }

    _createClass(ForgottentPasswordPage, [{
        key: "renderEmailSubmittedMessage",
        value: function renderEmailSubmittedMessage() {
            return React.createElement("div", Object.assign({ key: "forgottent-password-submitted" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title')), "All set!"), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), "We've just emailed you instructions on how to reset your password"), React.createElement(Label_1.Span, { variant: "note", size: "medium" }, "You may now close this window."));
        }
    }, {
        key: "renderResetSuccessMessage",
        value: function renderResetSuccessMessage() {
            var _this2 = this;

            return React.createElement("div", Object.assign({ key: "forgottent-password-success" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title')), "Great!"), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), "Your password was reset. Now try to log in again."), React.createElement(Button_1.default, { onClick: function onClick() {
                    return _this2.props.router.push(Login_1.LoginPagePath);
                }, label: "Log In", colorScheme: "dark", size: "small-medium" }));
        }
    }, {
        key: "renderForm",
        value: function renderForm() {
            var _props = this.props,
                handleSubmit = _props.handleSubmit,
                submitting = _props.submitting;
            var verificationCode = this.state.verificationCode;

            var error = this.props.error || this.state.error;
            var title = void 0;
            var subtitle = void 0;
            if (verificationCode) {
                title = '';
                subtitle = 'Enter a new password';
            } else {
                title = 'Forgot your password?';
                subtitle = "We'll email you instructions on how to reset it.";
            }
            return React.createElement("div", Object.assign({ key: "forgottent-password-form" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title')), title), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), subtitle), React.createElement(redux_form_1.Form, { onSubmit: handleSubmit(this.onSubmit) }, error && React.createElement(FormError_1.default, { error: error }), !verificationCode ? React.createElement(utils_1.FieldEmail, { component: TextField_1.default, colorScheme: "white", icon: React.createElement(Icon_1.IconMail, null), name: "email", placeholder: locales_1.default.inputs.email, inlineButton: React.createElement(Button_1.default, { isSubmit: true, label: "Send", colorScheme: "dark", size: "small-medium" }), disabled: submitting, onlyValidateIfTouched: true, autoFocus: true }) : React.createElement(utils_1.FieldPassword, { component: TextField_1.default, colorScheme: "white", icon: React.createElement(Icon_1.IconLock, null), name: "password", placeholder: locales_1.default.inputs.password, disabled: submitting, inlineButton: React.createElement(Button_1.default, { isSubmit: true, label: "Reset", colorScheme: "dark", size: "small-medium" }), warn: true, autoFocus: true })));
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(velocity_react_1.VelocityTransitionGroup, { component: Page_1.default, id: "forgotten-password", enter: { animation: 'transition.expandIn', duration: 500, delay: 350 }, leave: { animation: 'transition.shrinkOut', duration: 350 }, runOnMount: true }, this.props.submitSucceeded ? !this.state.verificationCode ? this.renderEmailSubmittedMessage() : this.renderResetSuccessMessage() : this.renderForm());
        }
    }, {
        key: "validate",
        value: function validate(_ref3) {
            var email = _ref3.email,
                password = _ref3.password;

            return new Promise(function (resolve, reject) {
                var errors = {};
                if (email) {
                    if (email === '') {
                        errors.email = locales_1.default.validations.required;
                    } else if (!string_1.validateEmail(email)) {
                        errors.email = locales_1.default.validations.email;
                    }
                }
                if (password) {
                    if (password === '') {
                        errors.password = locales_1.default.validations.required;
                    } else if (!string_1.validatePassword(password)) {
                        errors.password = locales_1.default.validations.password;
                    }
                }
                if (lodash_1.size(errors)) {
                    reject(new redux_form_1.SubmissionError(errors));
                } else {
                    resolve();
                }
            });
        }
    }]);

    return ForgottentPasswordPage;
}(React.Component);

var ConnectedForgottentPasswordPage = react_redux_1.connect(null, function (dispatch) {
    return {
        requestResetPassword: function requestResetPassword(email, resolve, reject, code, password) {
            dispatch(actions.requestResetPassword({
                code: code,
                email: email,
                promise: { resolve: resolve, reject: reject },
                password: password
            }));
        }
    };
})(ForgottentPasswordPage);
var ConnectedForgottentPasswordPageReduxForm = redux_form_1.reduxForm({
    form: 'forgotten-password'
})(ConnectedForgottentPasswordPage);
exports.default = ConnectedForgottentPasswordPageReduxForm;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Checkout Reducer Helper Function
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(93);
var checkout_1 = __webpack_require__(291);
var react_relay_1 = __webpack_require__(13);
exports.isActiveStep = function (stepId) {
    return function (_ref) {
        var checkout = _ref.checkout;
        return checkout.activeStep === stepId;
    };
};
exports.isReadyToPlaceOrder = function (_ref2) {
    var checkout = _ref2.checkout;
    return !!checkout.steps.length && checkout.completedSteps.length === checkout.steps.length;
};
exports.addPromoCode = function (_ref3) {
    var code = _ref3.code,
        country_code = _ref3.country_code,
        subdivision_code = _ref3.subdivision_code;

    var input = {
        code: code
    };
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: checkout_1.AddPromoCodeMutation,
            variables: {
                input: input,
                country_code: country_code,
                subdivision_code: subdivision_code
            },
            onCompleted: function onCompleted(response, errors) {
                return resolve(errors);
            },
            onError: reject
        });
    });
};
exports.deletePromoCode = function (_ref4) {
    var country_code = _ref4.country_code,
        subdivision_code = _ref4.subdivision_code;

    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: checkout_1.DeletePromoCodeMutation,
            variables: {
                input: {},
                country_code: country_code,
                subdivision_code: subdivision_code
            },
            onCompleted: function onCompleted(response, errors) {
                return resolve(errors);
            },
            onError: reject
        });
    });
};
exports.placeOrder = function (_ref5) {
    var input = _ref5.input,
        viewerId = _ref5.viewerId;

    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: checkout_1.PlaceOrderMutation,
            variables: { input: input },
            updater: function updater(storeProxy) {
                var viewerRecord = storeProxy.get(viewerId);
                viewerRecord.setValue(null, 'cart');
            },
            onCompleted: function onCompleted(response, errors) {
                if (!errors) {
                    // Induce a delay so the user feels something is processing in the background
                    setTimeout(function () {
                        return resolve(response.placeOrder);
                    }, 3000);
                } else {
                    reject(errors);
                }
            },
            onError: reject
        });
    });
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LineItem Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = __webpack_require__(637);
var checkout_1 = __webpack_require__(1448);
var reselect_1 = __webpack_require__(49);
var defaultList = [];
exports.hasValidLineItems = function (lineItems) {
    return !lineItems.some(function (_ref) {
        var amount = _ref.amount;
        return amount === 0;
    });
};
exports.getCheckoutLineItems = reselect_1.createSelector([checkout_1.getCheckout, checkout_1.hasValidCheckout], function (checkout, checkoutIsValid) {
    return checkoutIsValid ? checkout.license_line_items || defaultList : defaultList;
});
exports.getCartLineItems = reselect_1.createSelector([cart_1.getCart, cart_1.hasValidCart], function (cart, cartIsValid) {
    return cartIsValid ? cart.license_line_items || defaultList : defaultList;
});
exports.checkoutLicenseLineItemsAreValid = reselect_1.createSelector(exports.getCheckoutLineItems, exports.hasValidLineItems);
exports.cartLicenseLineItemsAreValid = reselect_1.createSelector(exports.getCartLineItems, exports.hasValidLineItems);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Cart Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getCart = function (_ref) {
  var cart = _ref.cart;
  return cart;
};
exports.hasValidCart = reselect_1.createSelector(exports.getCart, function (cart) {
  return !!cart && !!cart.license_line_items && cart.license_line_items.length > 0;
});
exports.getCartTotal = reselect_1.createSelector(exports.getCart, function (cart) {
  return !!cart ? cart.total : null;
});

/***/ }),
/* 638 */,
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * UserProfile Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var classes = new BEM('user-profile');

var UserProfile = function (_React$Component) {
    _inherits(UserProfile, _React$Component);

    function UserProfile() {
        _classCallCheck(this, UserProfile);

        return _possibleConstructorReturn(this, (UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).apply(this, arguments));
    }

    _createClass(UserProfile, [{
        key: "render",
        value: function render() {
            var profile = this.props.profile;
            var external_provider = profile.external_provider,
                picture = profile.picture;

            var profilePicture = picture;
            if (external_provider === 'Facebook' && profilePicture) {
                var facebookProfilePictureJson = JSON.parse(profilePicture);
                if (facebookProfilePictureJson.hasOwnProperty('data')) {
                    profilePicture = facebookProfilePictureJson.data.url;
                } else if (facebookProfilePictureJson.hasOwnProperty('source')) {
                    profilePicture = facebookProfilePictureJson.source;
                } else {
                    profilePicture = null;
                }
            }
            return React.createElement(React.Fragment, null, !!profilePicture ? React.createElement(Thumbnail_1.default, Object.assign({ src: profilePicture, size: "xsmall", shape: "circle" }, classes(''))) : React.createElement(Icon_1.IconUser, null));
        }
    }]);

    return UserProfile;
}(React.Component);

var ConnectedUserProfile = react_redux_1.connect(function (_ref, ownProps) {
    var authentication = _ref.authentication;
    return {
        logoutUrl: authentication.logoutUrl
    };
})(UserProfile);
exports.default = ConnectedUserProfile;

/***/ }),
/* 640 */,
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1475);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var Browse_1 = __webpack_require__(61);
var queryString_1 = __webpack_require__(30);
var helpers_1 = __webpack_require__(151);
var analytics_1 = __webpack_require__(161);
var player_1 = __webpack_require__(42);
var router_1 = __webpack_require__(27);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);

var FindSimilarButtonComponent = function (_React$Component) {
    _inherits(FindSimilarButtonComponent, _React$Component);

    function FindSimilarButtonComponent() {
        _classCallCheck(this, FindSimilarButtonComponent);

        var _this = _possibleConstructorReturn(this, (FindSimilarButtonComponent.__proto__ || Object.getPrototypeOf(FindSimilarButtonComponent)).apply(this, arguments));

        _this.defaultButtonProps = {
            colorScheme: 'black-outline',
            variant: 'pill',
            size: 'xsmall'
        };
        return _this;
    }

    _createClass(FindSimilarButtonComponent, [{
        key: "sendAnalyticsEvent",
        value: function sendAnalyticsEvent() {
            this.props.sendAnalyticsEvent({
                actionSource: this.props.actionSource,
                trackId: this.props.track.id + "-" + this.props.track.internal_id
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                track = _a.track,
                match = _a.match,
                router = _a.router,
                addToCurrentFilters = _a.addToCurrentFilters,
                actionSource = _a.actionSource,
                sendAnalyticsEvent = _a.sendAnalyticsEvent,
                pausePlayer = _a.pausePlayer,
                rest = __rest(_a, ["track", "match", "router", "addToCurrentFilters", "actionSource", "sendAnalyticsEvent", "pausePlayer"]);
            var buttonProps = Object.assign({}, this.defaultButtonProps, rest, { title: 'Find similar tracks based on a deep learning analysis of the audio.', label: React.createElement("span", null, "Find\xA0Similar") });
            if (addToCurrentFilters) {
                return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
                    return React.createElement(Button_1.default, Object.assign({ onClick: function onClick(e) {
                            e.stopPropagation();
                            _this2.sendAnalyticsEvent();
                            ctx.addSimilarityFilter(_this2.props.track.id);
                        } }, buttonProps));
                });
            }
            var qsState = helpers_1.getQueryStringStateForRoute(match);
            var linkQsState = Object.assign({}, qsState.license_params ? { license_params: qsState.license_params } : {}, { filters: {
                    similarity: {
                        track_id: track.id,
                        feature: "Default" /* Default */
                    }
                } });
            var linkQs = helpers_1.generateQueryStringFromState(linkQsState);
            var to = router_1.linkWithQueryString(Browse_1.BrowsePagePath, linkQs);
            return React.createElement(LinkButton_1.default, Object.assign({ to: to }, buttonProps, { onClick: function onClick(e) {
                    e.stopPropagation();
                    pausePlayer();
                    _this2.sendAnalyticsEvent();
                }, includeQsParams: false, external: true }));
        }
    }]);

    return FindSimilarButtonComponent;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedFindSimilarButton = react_redux_1.connect(null, function (dispatch) {
    return {
        pausePlayer: function pausePlayer() {
            return dispatch(player_1.pause());
        },
        sendAnalyticsEvent: function sendAnalyticsEvent(data) {
            return dispatch(analytics_1.similaritySearch(data));
        }
    };
})(FindSimilarButtonComponent);
exports.FindSimilarButton = found_1.withRouter(ConnectedFindSimilarButton);

/***/ }),
/* 643 */,
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Artist Page
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.ArtistPageQuery = function () {
  return __webpack_require__(1495);
};
exports.ArtistFragment = {
  artist: function artist() {
    return __webpack_require__(1496);
  }
};
exports.artistNode = {
  data: function data() {
    return __webpack_require__(1497);
  }
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CollectionCard Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
var router_1 = __webpack_require__(27);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1509);
var ImageLoaded_1 = __webpack_require__(185);
var CardPlayButton_1 = __webpack_require__(425);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Collection_1 = __webpack_require__(646);
var classes = new BEM('collection-card');

var CollectionCard = function (_React$Component) {
    _inherits(CollectionCard, _React$Component);

    function CollectionCard(props) {
        _classCallCheck(this, CollectionCard);

        var _this = _possibleConstructorReturn(this, (CollectionCard.__proto__ || Object.getPrototypeOf(CollectionCard)).call(this, props));

        _this.onMouseEnter = function () {
            return _this.toggleHover(true);
        };
        _this.onMouseLeave = function () {
            return _this.toggleHover(false);
        };
        _this.toggleHover = function (toggle) {
            _this.setState(function (prevState) {
                return {
                    isHover: toggle || !prevState.isHover
                };
            });
        };
        _this.state = {
            isHover: false,
            isPlaying: !!props.isPlaying
        };
        return _this;
    }

    _createClass(CollectionCard, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref) {
            var isPlaying = _ref.isPlaying;

            if (isPlaying !== this.props.isPlaying) {
                this.setState({
                    isPlaying: !!isPlaying
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                image = _props.image,
                size = _props.size,
                subtitle = _props.subtitle,
                title = _props.title,
                topic = _props.topic;
            var isHover = this.state.isHover;

            var classModifiers = _defineProperty({
                hover: isHover
            }, size, true);
            var imageSrc = image_1.getImagePathForSize(image, 'small');
            var blurredImageSrc = image.blur && image.blur.length ? image.blur[0].path : imageSrc;
            return React.createElement(ImageLoaded_1.default, { background: ".collection-card__image" }, function (_ref2) {
                var imageLoaded = _ref2.imageLoaded;

                return React.createElement(found_1.Link, Object.assign({ onMouseEnter: _this2.onMouseEnter, onMouseLeave: _this2.onMouseLeave }, classes('', Object.assign({}, classModifiers, { loading: !!!imageLoaded })), { to: router_1.linkWithCurrentQueryString(Collection_1.CollectionPagePath(_this2.props.slug)) }), React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement("div", Object.assign({ style: { backgroundImage: "url(" + imageSrc + ")" } }, classes('image'))), React.createElement("div", Object.assign({}, classes('title-wrapper')), React.createElement(Label_1.Span, { size: "small" }, subtitle), React.createElement(Heading_1.default, Object.assign({ is: "h3", text: title }, classes('title')))), React.createElement("div", Object.assign({}, classes('topic-wrapper')), React.createElement(Icon_1.LogoBopper, null), React.createElement(Label_1.Span, Object.assign({ size: "small" }, classes('topic')), topic)), React.createElement(CardPlayButton_1.default, { blurredImage: blurredImageSrc })));
            });
        }
    }]);

    return CollectionCard;
}(React.Component);

CollectionCard.defaultProps = {
    size: 'large',
    topic: 'Collection'
};
var CollectionCardWithRouter = found_1.withRouter(CollectionCard);
exports.default = CollectionCardWithRouter;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CollectionPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var ui_1 = __webpack_require__(29);
var collection_1 = __webpack_require__(647);
var colors_1 = __webpack_require__(57);
var grid_1 = __webpack_require__(58);
__webpack_require__(1516);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var raf_throttle_1 = __webpack_require__(299);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var WindowSizeListener = __webpack_require__(124);
var Page_1 = __webpack_require__(38);
var player_1 = __webpack_require__(63);
var image_1 = __webpack_require__(64);
var string_1 = __webpack_require__(47);
var DownloadButton_1 = __webpack_require__(296);
var LinkButton_1 = __webpack_require__(51);
var NProgress_1 = __webpack_require__(228);
var Picture_1 = __webpack_require__(426);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var LicenseBar_1 = __webpack_require__(648);
var TrackList_1 = __webpack_require__(229);
var sizes_1 = __webpack_require__(649);
var Discover_1 = __webpack_require__(221);
var helmet_1 = __webpack_require__(1548);
// Page Path
exports.CollectionPagePath = function (slug) {
    return "/collection/" + slug;
};
var classes = new BEM('collection');

var CollectionPage = function (_React$Component) {
    _inherits(CollectionPage, _React$Component);

    function CollectionPage(props) {
        _classCallCheck(this, CollectionPage);

        var _this = _possibleConstructorReturn(this, (CollectionPage.__proto__ || Object.getPrototypeOf(CollectionPage)).call(this, props));

        _this.tracks = [];
        _this.onResize = function () {
            _this.initIllustrationParallax();
        };
        _this.onScroll = function () {
            var scrollTop = window.scrollY / _this.contentScrollRange * _this.illustrationScrollRange;
            _this.illustrationNode.style.transform = "translate3d(-50%, -" + scrollTop + "px, 0)";
        };
        _this.initIllustrationParallax = function () {
            _this.illustrationNode = react_dom_1.findDOMNode(_this.illustration);
            var playerHeight = _this.props.termListIsVisible ? sizes_1.Size.playerWithTermListHeight : sizes_1.Size.playerHeight;
            var containerHeight = window.innerHeight - playerHeight;

            var _this$content$getBoun = _this.content.getBoundingClientRect(),
                contentHeight = _this$content$getBoun.height;

            var _this$illustrationNod = _this.illustrationNode.getBoundingClientRect(),
                pictureHeight = _this$illustrationNod.height;

            _this.contentScrollRange = contentHeight - containerHeight;
            _this.illustrationScrollRange = pictureHeight - containerHeight;
            _this.onScrollThrottled = raf_throttle_1.default(_this.onScroll);
            window.addEventListener('scroll', _this.onScrollThrottled);
        };
        _this.mapCollectionData();
        _this.state = {
            fetching: false
        };
        return _this;
    }

    _createClass(CollectionPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.props.initHeader();
            this.props.setPlayerQueue(player_1.getPlayerTracksFromResults(this.tracks));
            nextTick(function () {
                return _this2.initIllustrationParallax;
            });
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps() {
            if (this.state.fetching) {
                this.setState({ fetching: false });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.termListIsVisible !== this.props.termListIsVisible) {
                this.initIllustrationParallax();
            }
            if (prevState.fetching && !this.state.fetching) {
                this.mapCollectionData();
                this.forceUpdate();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.killIllustrationParallax();
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return !!this.tracks.length ? React.createElement(Page_1.default, { id: "collection" }, React.createElement(helmet_1.default, { collection: this.collection }), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement("div", Object.assign({}, classes('content'), { ref: function ref(node) {
                    return _this3.content = node;
                } }), React.createElement(LicenseBar_1.default, Object.assign({}, classes('license-bar'))), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('category')), this.collection.category.name), React.createElement(Heading_1.default, Object.assign({ is: "h1" }, classes('name')), React.createElement("span", { dangerouslySetInnerHTML: string_1.toInnerHTML(this.collection.name) })), this.collection.description && React.createElement(Label_1.Paragraph, Object.assign({ size: "xlarge", text: this.collection.description, variant: "description" }, classes('description'))), React.createElement("div", Object.assign({}, classes('download')), React.createElement(DownloadButton_1.SignUpGuardedDownloadButton, { label: "Download Tracks", track: {
                    title: "Collection: " + this.collection.name
                }, assetPath: "collections/" + this.collection.slug + "/download" })), React.createElement(TrackList_1.default, Object.assign({ cardProps: {
                    backgroundColor: colors_1.white,
                    size: 'medium',
                    showListenedStatus: false
                }, showSignUpCta: true, tracks: this.tracks, viewer: this.props.viewer }, classes('track-listing'))), React.createElement("div", Object.assign({}, classes('discover')), React.createElement(LinkButton_1.default, { label: "Discover More Music", colorScheme: "dark", size: "xlarge", variant: "pill", to: Discover_1.DiscoverPagePath }))), React.createElement(NProgress_1.default, { active: this.state.fetching, style: { top: grid_1.baseline * 4 } })), React.createElement("div", Object.assign({}, classes('illustration-wrapper')), React.createElement("div", Object.assign({}, classes('illustration')), React.createElement(Picture_1.default, { ref: function ref(node) {
                    return _this3.illustration = node;
                }, assets: image_1.getResponsiveAssets('cover', this.collection.assets) }))), React.createElement(WindowSizeListener, { onResize: this.onResize })) : React.createElement(Page_1.default, { id: "collection", className: "not-found" }, React.createElement(Heading_1.default, { is: "h2" }, "Collection Not Found"));
        }
    }, {
        key: "mapCollectionData",
        value: function mapCollectionData() {
            var _this4 = this;

            if (!this.props.viewer.trackSearch.edges.length) {
                return;
            }
            this.tracks = lodash_1.chain(this.getNodesFromEdges(this.props)).thru(function (tracks) {
                var collections = tracks[0].collections.edges.map(function (_ref) {
                    var node = _ref.node;
                    return node;
                });
                _this4.collection = lodash_1.find(collections, { slug: _this4.props.routeParams.slug });
                return tracks;
            }).sortBy(function (track) {
                return track.collections.edges.reduce(function (position, edge) {
                    return edge.node.id === _this4.collection.id ? edge.position : position;
                }, 0);
            }).value();
        }
    }, {
        key: "getNodesFromEdges",
        value: function getNodesFromEdges() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.viewer.trackSearch.edges.map(function (_ref2) {
                var node = _ref2.node;
                return node;
            });
        }
    }, {
        key: "killIllustrationParallax",
        value: function killIllustrationParallax() {
            window.removeEventListener('scroll', this.onScrollThrottled);
            this.onScrollThrottled = undefined;
        }
    }]);

    return CollectionPage;
}(React.Component);

var ConnectedCollectionPage = react_redux_1.connect(function (_ref3) {
    var player = _ref3.player,
        ui = _ref3.ui;
    var currentTrack = player.currentTrack,
        isTrackPlaying = player.isTrackPlaying;

    var currentTrackPlaying = '';
    if (isTrackPlaying && currentTrack) {
        currentTrackPlaying = currentTrack.trackId;
    }
    return {
        currentTrackPlaying: currentTrackPlaying,
        termListIsVisible: !!ui.player && ui.player.termListIsVisible
    };
}, function (dispatch) {
    return {
        initHeader: function initHeader() {
            dispatch(ui_1.setHeaderType({ type: 'simple' }));
        },
        pausePlayer: function pausePlayer() {
            dispatch(playerActions.pause());
        },
        playPlayer: function playPlayer() {
            dispatch(playerActions.playNext());
        },
        playTrackVersion: function playTrackVersion(trackId) {
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        },
        resetHeader: function resetHeader() {
            dispatch(ui_1.setHeaderType({ type: 'extended' }));
        },
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.replaceQueue({ tracks: tracks }));
        }
    };
})(CollectionPage);
var RelayCollectionPage = react_relay_1.createFragmentContainer(ConnectedCollectionPage, collection_1.CollectionPageFragment);
exports.default = RelayCollectionPage;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Collection
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.collectionNode = {
  data: function data() {
    return __webpack_require__(1511);
  }
};
exports.CollectionListQuery = function () {
  return __webpack_require__(1512);
};
exports.CollectionPageQuery = function () {
  return __webpack_require__(1513);
};
exports.CollectionPageFragment = {
  viewer: function viewer() {
    return __webpack_require__(1514);
  }
};
exports.CollectionsFragment = {
  viewer: function viewer() {
    return __webpack_require__(1515);
  }
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseBar Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
__webpack_require__(1521);
var classNames = __webpack_require__(15);
var raf_throttle_1 = __webpack_require__(299);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var WindowSizeListener = __webpack_require__(124);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var ui_1 = __webpack_require__(29);
var SessionLicenseBuilderButton_1 = __webpack_require__(300);
var Label_1 = __webpack_require__(8);
var SearchSortOrderSelect_1 = __webpack_require__(1523);
var FilterBar_1 = __webpack_require__(1526);
var Browse_1 = __webpack_require__(61);
var CurrencySelect_1 = __webpack_require__(350);
var classes = new BEM('license-bar');
var defaultList = [];

var LicenseBar = function (_React$Component) {
    _inherits(LicenseBar, _React$Component);

    function LicenseBar(props) {
        _classCallCheck(this, LicenseBar);

        var _this = _possibleConstructorReturn(this, (LicenseBar.__proto__ || Object.getPrototypeOf(LicenseBar)).call(this, props));

        _this.wrapper = React.createRef();
        _this.fixedGuard = React.createRef();
        _this.onLicenseBarResize = function () {
            if (_this.wrapper.current && _this.fixedGuard.current) {
                var newHeight = _this.wrapper.current.getBoundingClientRect().height;
                if (newHeight !== _this.props.heightPx) {
                    _this.fixedGuard.current.style.height = newHeight + "px";
                    _this.props.setLicenseBarHeight(newHeight);
                }
            }
        };
        _this.onResize = function () {
            _this.onLicenseBarResize();
        };
        _this.throttledResize = raf_throttle_1.default(_this.onResize, 100);
        _this.state = {};
        return _this;
    }

    _createClass(LicenseBar, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.licenseUsages.length !== this.props.licenseUsages.length) {
                this.onResize();
            }
            this.onLicenseBarResize();
        }
    }, {
        key: "renderNoLicenseMessage",
        value: function renderNoLicenseMessage(modifiers) {
            var hasFilters = this.props.hasFilters;

            var noTermsMods = {
                'no-terms': true,
                'no-filters': !hasFilters
            };
            return React.createElement("div", Object.assign({}, classes('', modifiers)), React.createElement("div", Object.assign({}, classes('scroll-wrapper')), this.renderSearchControls(), React.createElement("div", Object.assign({}, classes('scroller', 'no-terms', noTermsMods)), React.createElement(SessionLicenseBuilderButton_1.default, Object.assign({ label: React.createElement(Label_1.Span, { text: "Show Prices", variant: "description", size: "large" }), colorScheme: "accent", size: "small", variant: "pill", withShadow: true }, classes('button-set-terms'))))), this.renderSortControls());
        }
    }, {
        key: "renderLicenseUsages",
        value: function renderLicenseUsages() {
            var licenseUsages = this.props.licenseUsages;

            return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, classes('')), React.createElement("div", Object.assign({}, classes('scroll-wrapper')), this.renderSearchControls(), React.createElement("div", Object.assign({}, classes('scroller')), React.createElement("div", Object.assign({}, classes('usages')), licenseUsages.map(function (usage, index) {
                return React.createElement(SessionLicenseBuilderButton_1.default, Object.assign({ key: "license-usage-" + index + "-" + usage.medium.id }, classes('usage-button'), { label: React.createElement(Label_1.Span, { text: license_1.usageToString(usage), variant: "description", size: "large" }), colorScheme: "accent", variant: "pill", size: "small", selectedUsage: index }));
            }), React.createElement(CurrencySelect_1.default, Object.assign({}, classes('currency-select')))))), this.renderSortControls()));
        }
    }, {
        key: "renderSearchControls",
        value: function renderSearchControls() {
            var _props = this.props,
                showSearchControls = _props.showSearchControls,
                hasFilters = _props.hasFilters;

            return React.createElement(React.Fragment, null, hasFilters && showSearchControls && React.createElement(FilterBar_1.default, Object.assign({}, classes('filter-bar'))));
        }
    }, {
        key: "renderSortControls",
        value: function renderSortControls() {
            var _props2 = this.props,
                showSearchControls = _props2.showSearchControls,
                hasFilters = _props2.hasFilters;

            return React.createElement(React.Fragment, null, showSearchControls && hasFilters && React.createElement("div", Object.assign({}, classes('sort-wrapper')), React.createElement(Label_1.Span, Object.assign({ variant: "label", size: "medium" }, classes('sort-label')), "Sort\xA0by:"), React.createElement(SearchSortOrderSelect_1.SearchSortOrderSelectWithContext, null)));
        }
    }, {
        key: "render",
        value: function render() {
            var _props3 = this.props,
                className = _props3.className,
                fullWidth = _props3.fullWidth,
                licenseUsages = _props3.licenseUsages,
                showLicenseBar = _props3.showLicenseBar;

            var hasUsages = licenseUsages.length > 0;
            var wrapperExtraClasses = classNames(className);
            var modifiers = {
                'with-terms': hasUsages,
                'full-width': fullWidth
            };
            return showLicenseBar ? React.createElement(React.Fragment, null, React.createElement("div", Object.assign({ ref: this.fixedGuard }, classes('fixed-guard'))), React.createElement("div", Object.assign({ ref: this.wrapper }, classes('wrapper', modifiers, wrapperExtraClasses)), hasUsages ? this.renderLicenseUsages() : this.renderNoLicenseMessage(modifiers)), React.createElement(WindowSizeListener, { onResize: this.throttledResize })) : React.createElement(WindowSizeListener, { onResize: this.throttledResize });
        }
    }]);

    return LicenseBar;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedLicenseBar = react_redux_1.connect(function (_ref, _ref2) {
    var licenseComponents = _ref.staticData.licenseComponents,
        found = _ref.found,
        ui = _ref.ui;
    var params = _ref2.params,
        hasFilters = _ref2.hasFilters;
    return {
        showLicenseBar: ui.header.type === 'simple',
        showSearchControls: found.match.location.pathname === Browse_1.BrowsePagePath && hasFilters,
        fullWidth: found.match.location.pathname === Browse_1.BrowsePagePath,
        hasFilters: hasFilters,
        heightPx: ui.licenseBar.heightPx,
        licenseUsages: params ? license_1.getLicenseUsagesFromQueryString({
            components: licenseComponents,
            params: params
        }) : defaultList
    };
}, function (dispatch) {
    return {
        setLicenseBarHeight: function setLicenseBarHeight(heightPx) {
            return dispatch(ui_1.setLicenseBarHeight(heightPx));
        }
    };
})(LicenseBar);
var LicenseBarWithQueryStringContext = function LicenseBarWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedLicenseBar, Object.assign({ params: ctx.license_params, hasFilters: selectors_1.hasSearchFilters(ctx) }, props));
    });
};
exports.default = LicenseBarWithQueryStringContext;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Sizes
 */

Object.defineProperty(exports, "__esModule", { value: true });
var grid_1 = __webpack_require__(58);
exports.Size = {
    appHeaderHeight: grid_1.baseline * 4,
    pageHeaderHeight: grid_1.baseline * 7,
    pageWithHeaderMarginTop: grid_1.baseline * 11,
    playerHeight: grid_1.baseline * 7,
    playerWithTermListHeight: grid_1.baseline * 17,
    licenseBarHeight: grid_1.baseline * 7
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Track Page
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.TrackPageQuery = function () {
  return __webpack_require__(1554);
};
exports.TrackFragment = {
  track: function track() {
    return __webpack_require__(1555);
  }
};
exports.trackNode = {
  data: function data() {
    return __webpack_require__(1556);
  }
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LinkButtonWithLicense Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var router_1 = __webpack_require__(27);
__webpack_require__(1559);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var helpers_1 = __webpack_require__(151);
var LinkButton_1 = __webpack_require__(51);

var LinkButtonWithLicense = function (_React$PureComponent) {
    _inherits(LinkButtonWithLicense, _React$PureComponent);

    function LinkButtonWithLicense() {
        _classCallCheck(this, LinkButtonWithLicense);

        return _possibleConstructorReturn(this, (LinkButtonWithLicense.__proto__ || Object.getPrototypeOf(LinkButtonWithLicense)).apply(this, arguments));
    }

    _createClass(LinkButtonWithLicense, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                licenseParams = _a.licenseParams,
                lineItemLicense = _a.lineItemLicense,
                match = _a.match,
                to = _a.to,
                linkButtonProps = __rest(_a, ["licenseParams", "lineItemLicense", "match", "to"]);
            var queryStringState = helpers_1.getQueryStringStateForRoute(match);
            var license = queryStringState.license_params;
            if (lineItemLicense) {
                var usages = lineItemLicense.usages.map(function (_ref) {
                    var components = _ref.components;
                    return license_1.generateLicenseUsageFromComponents(components);
                });
                license = license_1.licenseUsagesToSearchParams(usages);
            } else if (!!licenseParams && license_1.isLicenseValid(licenseParams.usages)) {
                license = license_1.licenseUsagesToSearchParams(licenseParams.usages);
            }
            var query = helpers_1.generateQueryStringFromState(Object.assign({}, queryStringState, { license_params: license }));
            var link = router_1.getRouteLocation(to, query);
            return React.createElement(LinkButton_1.default, Object.assign({ to: router_1.createHref(link) }, linkButtonProps));
        }
    }]);

    return LinkButtonWithLicense;
}(React.PureComponent);

exports.default = found_1.withRouter(LinkButtonWithLicense);

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutCompletePage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1567);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var LinkButton_1 = __webpack_require__(51);
var Icon_1 = __webpack_require__(12);
var huge_icons_1 = __webpack_require__(653);
var Heading_1 = __webpack_require__(9);
var Orders_1 = __webpack_require__(302);
// Page Path
exports.CheckoutCompletePagePath = '/my/checkout/complete';
var classes = new BEM('checkout-complete');

var CheckoutCompletePage = function (_React$Component) {
    _inherits(CheckoutCompletePage, _React$Component);

    function CheckoutCompletePage(props) {
        _classCallCheck(this, CheckoutCompletePage);

        var _this = _possibleConstructorReturn(this, (CheckoutCompletePage.__proto__ || Object.getPrototypeOf(CheckoutCompletePage)).call(this, props));

        _this.state = {
            orderId: props.location.query.order || null
        };
        return _this;
    }

    _createClass(CheckoutCompletePage, [{
        key: "render",
        value: function render() {
            return React.createElement(velocity_react_1.VelocityTransitionGroup, { component: Page_1.default, id: "checkout-complete", enter: { animation: 'transition.expandIn', duration: 1000, delay: 750 }, leave: { animation: 'transition.shrinkOut', duration: 750 }, runOnMount: true }, this.state.orderId ? React.createElement("div", Object.assign({ key: "license-files" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('title')), "Here are your files:"), React.createElement("ul", Object.assign({}, classes('license-files-list')), React.createElement("li", Object.assign({}, classes('license-files-list__item')), React.createElement("div", Object.assign({}, classes('license-files-list__item__background'))), React.createElement(huge_icons_1.IconInvoiceHuge, Object.assign({}, classes('license-files-list__item__icon'))), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('license-files-list__item__title')), "Invoice"), React.createElement("div", Object.assign({}, classes('license-files-list__item__actions')), React.createElement(LinkButton_1.default, { to: {
                    pathname: Orders_1.OrderPagePath(this.state.orderId),
                    query: {
                        view: 'invoice'
                    }
                }, label: "View", colorScheme: "accent", variant: "pill", size: "small" }))), React.createElement("li", Object.assign({}, classes('license-files-list__item')), React.createElement("div", Object.assign({}, classes('license-files-list__item__background'))), React.createElement(huge_icons_1.IconLicenseHuge, Object.assign({}, classes('license-files-list__item__icon'))), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('license-files-list__item__title')), "License"), React.createElement("div", Object.assign({}, classes('license-files-list__item__actions')), React.createElement(LinkButton_1.default, { to: {
                    pathname: Orders_1.OrderPagePath(this.state.orderId),
                    search: '?view=license'
                }, label: "View", colorScheme: "accent", variant: "pill", size: "small" }))), React.createElement("li", Object.assign({}, classes('license-files-list__item')), React.createElement("div", Object.assign({}, classes('license-files-list__item__background'))), React.createElement(huge_icons_1.IconAudioHuge, Object.assign({}, classes('license-files-list__item__icon'))), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('license-files-list__item__title')), "Audio files"), React.createElement("div", Object.assign({}, classes('license-files-list__item__actions')), React.createElement(LinkButton_1.default, { to: {
                    pathname: Orders_1.OrderPagePath(this.state.orderId),
                    query: {
                        view: 'music'
                    }
                }, label: "View", colorScheme: "accent", variant: "pill", size: "small" }))))) : React.createElement("div", Object.assign({ key: "error" }, classes('content', 'error')), React.createElement(Icon_1.IconWarningLarge, null), React.createElement(Heading_1.default, { is: "h2" }, "Something went wrong."), React.createElement(Heading_1.default, { is: "h4" }, "Provided order ID is invalid. If this is unintended, please contact us at\xA0+1\xA0888-423-6665\xA0(NA) or +33\xA01\xA070\xA038\xA073\xA050\xA0(EU).")));
        }
    }]);

    return CheckoutCompletePage;
}(React.Component);

exports.default = CheckoutCompletePage;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Huge Icons Component
 */
/* tslint:disable:max-line-length */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
function IconWrapper(_a) {
    var children = _a.children,
        className = _a.className,
        id = _a.id,
        rest = __rest(_a, ["children", "className", "id"]);

    var classes = new BEM('huge-icon');
    return React.createElement("div", Object.assign({}, classes('', id, className), rest), children);
}
function IconLicenseHuge(_a) {
    var _a$className = _a.className,
        className = _a$className === undefined ? '' : _a$className,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "icon-license", className: className }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "95.7", height: "118.3", viewBox: "0 0 95.7 118.3" }, React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10" }, React.createElement("path", { className: "st0", d: "M53.5 2.5H13.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8v90.7c0 7.6 3.8 11.3 11.3 11.3h68c7.6 0 11.3-3.8 11.3-11.3V42.2L53.5 2.5z" }), React.createElement("path", { className: "st0", d: "M53.5 2.5v39.7h39.7M22.4 60h25.4M22.4 76.1h44.8M22.4 92.2h44.8" }))));
}
exports.IconLicenseHuge = IconLicenseHuge;
function IconAudioHuge(_a) {
    var _a$className2 = _a.className,
        className = _a$className2 === undefined ? '' : _a$className2,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "icon-audio", className: className }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "107", height: "107", viewBox: "0 0 107 107" }, React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10" }, React.createElement("path", { d: "M104.5 70.5H81.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8 0 7.6 3.8 11.3 11.3 11.3h11.3c7.6 0 11.3-3.8 11.3-11.3V70.5zm-68 11.3H13.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8 0 7.6 3.8 11.3 11.3 11.3h11.3c7.6 0 11.3-3.8 11.3-11.3V81.8z" }), React.createElement("path", { d: "M36.5 81.8v-68l68-11.3v68" }))));
}
exports.IconAudioHuge = IconAudioHuge;
function IconInvoiceHuge(_a) {
    var _a$className3 = _a.className,
        className = _a$className3 === undefined ? '' : _a$className3,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "icon-invoice", className: className }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "95.7", height: "107", viewBox: "0 0 95.7 107" }, React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10" }, React.createElement("path", { d: "M2.5 36.5h90.7M2.5 70.5h90.7M36.5 2.5l-11.3 102M70.5 2.5l-11.3 102" }))));
}
exports.IconInvoiceHuge = IconInvoiceHuge;
function IconProjectBoxHuge(_a) {
    var _a$className4 = _a.className,
        className = _a$className4 === undefined ? '' : _a$className4,
        props = __rest(_a, ["className"]);

    return React.createElement(IconWrapper, Object.assign({ id: "icon-project-prox", className: className }, props), React.createElement("svg", { width: "338", height: "363", viewBox: "0 0 338 363", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M-31 380h398V-18H-31z" }), React.createElement("path", { d: "M183.773 6.66L316.571 72.91c12.273 6.089 18.42 15.971 18.429 29.646V260.39c-.01 13.68-6.156 23.562-18.43 29.65L183.774 356.29c-9.905 4.948-19.81 4.948-29.714 0L21.257 290.04C8.988 283.87 2.905 273.935 3 260.226v-157.67c.006-13.676 6.147-23.558 18.426-29.647L154.223 6.66c9.852-4.881 19.698-4.881 29.55 0z", stroke: "#E4E8ED", strokeWidth: "6", strokeLinecap: "round", strokeLinejoin: "round" }), React.createElement("path", { stroke: "currentColor", strokeWidth: "6", strokeLinecap: "round", strokeLinejoin: "round", d: "M8 84l160.502 80L329 84M168 355V164M275.677 177.201c-7.271 3.607-13.479 9.181-18.608 16.74L252 201.41l-5.07-2.442c-5.143-2.471-11.35-1.897-18.622 1.695-7.257 3.607-13.464 9.167-18.608 16.74-5.143 7.557-7.7 14.885-7.7 21.969 0 7.083 2.557 11.853 7.7 14.325l5.07 2.442L252 274l37.215-54.729 5.07-7.471c5.143-7.543 7.715-14.871 7.715-21.97 0-7.083-2.572-11.853-7.715-14.324-5.129-2.472-11.336-1.897-18.608 1.695z" }))));
}
exports.IconProjectBoxHuge = IconProjectBoxHuge;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Orders
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.OrdersQuery = function () {
  return __webpack_require__(1569);
};
exports.OrderListQuery = function () {
  return __webpack_require__(1570);
};
exports.OrderListNode = {
  data: function data() {
    return __webpack_require__(1571);
  }
};
exports.OrderFragment = {
  data: function data() {
    return __webpack_require__(1572);
  }
};
exports.OrderListFragment = {
  viewer: function viewer() {
    return __webpack_require__(1573);
  }
};
exports.OrderPageFragment = {
  viewer: function viewer() {
    return __webpack_require__(1574);
  }
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NotAuthorizedPage Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var router_1 = __webpack_require__(27);
__webpack_require__(1577);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var classes = new BEM('not-authorized');
var NotAuthorizedPage = function NotAuthorizedPage(_ref) {
    var message = _ref.message,
        showLogInForm = _ref.showLogInForm;
    return React.createElement(Page_1.default, { id: "not-authorized", noIndex: true }, React.createElement(Heading_1.default, Object.assign({ is: "h2", textColor: "bw6" }, classes('error-message')), message), React.createElement(Button_1.default, { onClick: showLogInForm, label: "Log In", size: "large", colorScheme: "white", variant: "pill", withShadow: true }));
};
var ConnectedNotAuthorizedPage = react_redux_1.connect(null, function (dispatch, ownProps) {
    return {
        showLogInForm: function showLogInForm() {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: router_1.createHref(ownProps.match.location) }));
            dispatch(ui_1.toggleLogInFormVisibility(true));
        }
    };
})(NotAuthorizedPage);
exports.default = found_1.withRouter(ConnectedNotAuthorizedPage);

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PrintableDocument Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(128);
__webpack_require__(1593);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var address_1 = __webpack_require__(232);
var react_1 = __webpack_require__(233);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('document');

var PrintableDocument = function (_React$Component) {
    _inherits(PrintableDocument, _React$Component);

    function PrintableDocument() {
        _classCallCheck(this, PrintableDocument);

        return _possibleConstructorReturn(this, (PrintableDocument.__proto__ || Object.getPrototypeOf(PrintableDocument)).apply(this, arguments));
    }

    _createClass(PrintableDocument, [{
        key: "renderHeader",
        value: function renderHeader() {
            var _props = this.props,
                identification = _props.identification,
                metadata = _props.metadata,
                subtitle = _props.subtitle,
                title = _props.title;

            return React.createElement("div", Object.assign({}, classes('header')), React.createElement("div", null, React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), subtitle), React.createElement(Heading_1.default, Object.assign({ is: "h1" }, classes('title')), title), metadata && React.createElement("div", Object.assign({}, classes('metadata')), metadata)), React.createElement("div", Object.assign({}, classes('identification')), React.createElement(Icon_1.LogoBopper, Object.assign({}, classes('identification__logo'))), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('identification__title')), identification.title), identification.subtitle && React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('identification__subtitle')), identification.subtitle)));
        }
    }, {
        key: "renderFooter",
        value: function renderFooter() {
            var _props2 = this.props,
                _props2$businessInfor = _props2.businessInformation,
                legal_name = _props2$businessInfor.legal_name,
                address = _props2$businessInfor.address,
                gst_number = _props2$businessInfor.commercial_details.gst_number,
                getCountryLabel = _props2.getCountryLabel,
                getStateLabel = _props2.getStateLabel;

            return React.createElement("div", Object.assign({}, classes('footer')), React.createElement(Icon_1.LogoBopper, null), React.createElement("div", Object.assign({}, classes('footer__address')), React.createElement(Label_1.Paragraph, { size: "small" }, React.createElement("strong", null, legal_name), React.createElement("br", null), react_1.nl2br(address_1.formatAddress(address, getCountryLabel, getStateLabel, true)))), this.props.type === 'invoice' && React.createElement("div", null, React.createElement(Label_1.Paragraph, { size: "small" }, "TPS/GST: ", gst_number)));
        }
    }, {
        key: "render",
        value: function render() {
            var extraClasses = classNames(this.props.className, this.props.type);
            return React.createElement("div", Object.assign({}, classes('', '', extraClasses)), this.renderHeader(), React.createElement("article", Object.assign({}, classes('content')), this.props.children), this.renderFooter());
        }
    }]);

    return PrintableDocument;
}(React.Component);

var ConnectedPrintableDocument = react_redux_1.connect(function (state) {
    return {
        businessInformation: state.staticData.businessInformation,
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        }
    };
})(PrintableDocument);
exports.default = ConnectedPrintableDocument;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TableHeader Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Label_1 = __webpack_require__(8);
function TableHeader(props) {
  return React.createElement(Label_1.Span, { size: "small", block: true }, React.createElement("strong", null, props.label));
}
exports.TableHeader = TableHeader;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InvoicePaymentMethods Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(128);
var address_1 = __webpack_require__(232);
var money_1 = __webpack_require__(285);
var react_1 = __webpack_require__(233);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('invoice__payment-methods');

var InvoicePaymentMethods = function (_React$Component) {
    _inherits(InvoicePaymentMethods, _React$Component);

    function InvoicePaymentMethods() {
        _classCallCheck(this, InvoicePaymentMethods);

        return _possibleConstructorReturn(this, (InvoicePaymentMethods.__proto__ || Object.getPrototypeOf(InvoicePaymentMethods)).apply(this, arguments));
    }

    _createClass(InvoicePaymentMethods, [{
        key: "renderBankTransferInformation",
        value: function renderBankTransferInformation(currency) {
            if (!currency) {
                switch (this.props.currency) {
                    case money_1.Currency.CAD:
                        return this.renderBankTransferInformation(this.props.currency);
                    default:
                        return this.renderBankTransferInformation(money_1.Currency.USD);
                }
            }
            var _props = this.props,
                _props$businessInform = _props.businessInformation.commercial_details,
                financial_institution = _props$businessInform.financial_institution,
                bank_accounts = _props$businessInform.bank_accounts,
                getCountryLabel = _props.getCountryLabel,
                getStateLabel = _props.getStateLabel;

            var bankAccount = bank_accounts.find(function (acc) {
                return acc.currency === currency;
            });
            return React.createElement(React.Fragment, null, React.createElement(Heading_1.default, { is: "h6" }, "Bank Transfer"), React.createElement(Label_1.Paragraph, { variant: "description", size: "large" }, "Please include in description field:", React.createElement("br", null), React.createElement("em", null, "Beneficiary account in ", currency, " funds")), React.createElement(Label_1.Paragraph, Object.assign({ size: "small" }, classes('item__information')), React.createElement("strong", null, financial_institution.company), React.createElement("br", null), react_1.nl2br(address_1.formatAddress(financial_institution, getCountryLabel, getStateLabel, true)), React.createElement("br", null), "SWIFT Code: ", bankAccount.swift_code, React.createElement("br", null), "Branch ID: ", bankAccount.branch_id, React.createElement("br", null), "Account Number: ", bankAccount.account_number));
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                _props2$businessInfor = _props2.businessInformation,
                name = _props2$businessInfor.name,
                legalName = _props2$businessInfor.legal_name,
                address = _props2$businessInfor.address,
                getCountryLabel = _props2.getCountryLabel,
                getStateLabel = _props2.getStateLabel;

            return React.createElement("section", Object.assign({}, classes()), React.createElement("div", Object.assign({}, classes('header')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Payment methods"), React.createElement(Label_1.Span, { size: "large", variant: "description" }, "Payment must be received within 30 days of invoice date.")), React.createElement("div", Object.assign({}, classes('item')), this.renderBankTransferInformation()), renderChequePaymentInformation({
                address: address, legalName: legalName, name: name, getCountryLabel: getCountryLabel, getStateLabel: getStateLabel, includeHeading: true
            }));
        }
    }]);

    return InvoicePaymentMethods;
}(React.Component);

function renderChequePaymentInformation(options) {
    var includeHeading = options.includeHeading,
        address = options.address,
        legalName = options.legalName,
        name = options.name,
        getCountryLabel = options.getCountryLabel,
        getStateLabel = options.getStateLabel;

    return React.createElement("div", Object.assign({}, classes('item')), includeHeading ? React.createElement(Heading_1.default, { is: "h6" }, "Cheque") : '', React.createElement(Label_1.Paragraph, { variant: "description", size: "large" }, "Please make your cheque payable to ", name, " and allow at least five business days for processing."), React.createElement(Label_1.Paragraph, Object.assign({ size: "small" }, classes('item__information')), React.createElement("strong", null, "All cheques must be sent to:"), React.createElement("br", null), React.createElement("br", null), legalName, React.createElement("br", null), react_1.nl2br(address_1.formatAddress(address, getCountryLabel, getStateLabel, true))));
}
exports.renderChequePaymentInformation = renderChequePaymentInformation;
var ConnectedInvoicePaymentMethods = react_redux_1.connect(function (state) {
    return {
        businessInformation: state.staticData.businessInformation,
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        }
    };
})(InvoicePaymentMethods);
exports.default = ConnectedInvoicePaymentMethods;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Redux Form Validations
 */

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(6);
var redux_form_1 = __webpack_require__(37);
function validateFields(fields, validations) {
    var validationArguments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return new Promise(function (resolve, reject) {
        var errors = {};
        lodash_1.each(validations, function (_ref, key) {
            var error = _ref.error,
                validator = _ref.validator,
                validatorRequiresArguments = _ref.validatorRequiresArguments;

            var value = lodash_1.get(fields, key, '');
            if (value) {
                if (validator) {
                    if (validatorRequiresArguments) {
                        if (validationArguments.hasOwnProperty(validator.name)) {
                            if (!validator.apply(undefined, [value].concat(_toConsumableArray(validationArguments[validator.name])))) {
                                lodash_1.set(errors, key, error);
                            }
                        }
                    } else if (!validator(value)) {
                        lodash_1.set(errors, key, error);
                    }
                }
            } else {
                lodash_1.set(errors, key, error);
            }
        });
        if (lodash_1.size(errors)) {
            reject(new redux_form_1.SubmissionError(errors));
        } else {
            resolve();
        }
    });
}
exports.validateFields = validateFields;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AddressForm Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(222);
var utils_1 = __webpack_require__(125);
var relay_1 = __webpack_require__(93);
var checkout_1 = __webpack_require__(291);
var promise_1 = __webpack_require__(419);
var string_1 = __webpack_require__(47);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var redux_form_1 = __webpack_require__(37);
var FormCell_1 = __webpack_require__(234);
var FormRow_1 = __webpack_require__(235);
var Select_1 = __webpack_require__(200);
var TextFieldWithLabel_1 = __webpack_require__(236);
exports.getAddressFormValidations = function () {
    var _ref;

    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return _ref = {}, _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.company.name", {
        validator: string_1.validateString,
        error: 'Is it a valid company name?'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.company.type", {
        error: 'Please select a company type.'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.street", {
        validator: string_1.validateString,
        error: 'Is it a valid street address?'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.city", {
        validator: string_1.validateString,
        error: 'Is it a valid city name?'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.country", {
        error: 'Please select a country.'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.state", {
        error: 'Please select a state or province.'
    }), _defineProperty(_ref, (prefix && lodash_1.trimEnd(prefix, '.') + ".") + "address.postalCode", {
        validator: string_1.validatePostalCode,
        validatorRequiresArguments: true,
        error: 'Code format is not valid.'
    }), _ref;
};
var countriesForSelect = function countriesForSelect(countryOrState) {
    return lodash_1.map(countryOrState, function (_ref2) {
        var code = _ref2.code,
            name = _ref2.name;
        return {
            value: code,
            label: name
        };
    });
};
var classes = new BEM('address-form');

var AddressForm = function (_React$Component) {
    _inherits(AddressForm, _React$Component);

    function AddressForm(props) {
        _classCallCheck(this, AddressForm);

        var _this = _possibleConstructorReturn(this, (AddressForm.__proto__ || Object.getPrototypeOf(AddressForm)).call(this, props));

        _this.onSetCountry = function (item) {
            if (item) {
                var country = lodash_1.find(_this.props.countryList.countries, { code: String(item.value) });
                if (country && country.filename) {
                    return _this.props.setCountry(country);
                }
            }
            _this.props.setCountry();
        };
        _this.companyTypesForSelect = props.viewer.company_types.edges.map(function (_ref3) {
            var node = _ref3.node;

            return {
                value: node.id,
                label: node.name
            };
        });
        _this.companyTypesForSelect = lodash_1.sortBy(_this.companyTypesForSelect, 'label');
        return _this;
    }

    _createClass(AddressForm, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                countryId = _props.countryId,
                countryList = _props.countryList,
                formSectionName = _props.formSectionName,
                form = _props.form;

            return React.createElement(redux_form_1.FormSection, Object.assign({ name: formSectionName }, classes()), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(redux_form_1.Field, { name: "company.name", component: TextFieldWithLabel_1.default, label: "Company Name", colorScheme: "light" })), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(Select_1.default, { form: form, label: "Company Type", name: "company.type", options: this.companyTypesForSelect, selectName: "company-type-select", selectProps: {
                    autoBlur: true,
                    clearable: false
                } }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 11 }, React.createElement(redux_form_1.Field, { component: "input", name: "postalCodeValidationRegExp", type: "hidden" }), React.createElement(redux_form_1.Field, { name: "street", component: TextFieldWithLabel_1.default, label: "Street Address", colorScheme: "light" })), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 5 }, React.createElement(redux_form_1.Field, { name: "unit", component: TextFieldWithLabel_1.default, label: "Suite, unit", note: "Opt.", colorScheme: "light", optional: true }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 11 }, React.createElement(redux_form_1.Field, { name: "city", component: TextFieldWithLabel_1.default, label: "City", colorScheme: "light" })), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 5 }, React.createElement(utils_1.FieldPostalCode, { name: "postalCode", component: TextFieldWithLabel_1.default, label: "Postal/Zip Code", colorScheme: "light" }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(Select_1.default, { form: form, label: "Country", name: "country", onUpdate: this.onSetCountry, options: countriesForSelect(countryList.countries), selectName: "country-select", selectProps: {
                    autoBlur: true,
                    clearable: false
                } })), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(Select_1.default, { disabled: !!!countryId, form: form, label: "State or province", name: "state", options: countriesForSelect(countryList.states[countryId]), selectName: "state-select", selectProps: {
                    autoBlur: true,
                    clearable: false
                } }))));
        }
    }]);

    return AddressForm;
}(React.Component);

AddressForm.defaultProps = {
    formSectionName: 'address'
};
var ConnectedAddressForm = react_redux_1.connect(function (state, _ref4) {
    var form = _ref4.form,
        _ref4$formSectionName = _ref4.formSectionName,
        formSectionName = _ref4$formSectionName === undefined ? 'address' : _ref4$formSectionName;

    var formState = redux_form_1.getFormValues(form)(state);
    return {
        countryId: lodash_1.get(formState, formSectionName + ".country", ''),
        countryList: state.countryList
    };
}, function (dispatch, _ref5) {
    var form = _ref5.form,
        _ref5$formSectionName = _ref5.formSectionName,
        formSectionName = _ref5$formSectionName === undefined ? 'address' : _ref5$formSectionName;
    return {
        setCountry: function setCountry(country, postalCodeValidationRegExp) {
            var input = 'postalCodeValidationRegExp';
            dispatch(redux_form_1.change(form, input, postalCodeValidationRegExp));
            if (country) {
                dispatch(countries_1.requestFetchStatesForCountry(Object.assign({ country: country }, promise_1.emptyPromiseActionPayload)));
            }
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, { setCountry: function setCountry(country) {
            var postalCodeValidationRegExp = '';
            if (country && stateProps.countryList.postalCodes.hasOwnProperty(country.code)) {
                postalCodeValidationRegExp = stateProps.countryList.postalCodes[country.code];
            }
            dispatchProps.setCountry(country, postalCodeValidationRegExp);
        } });
})(AddressForm);
var RelayAddressForm = react_relay_1.createFragmentContainer(ConnectedAddressForm, checkout_1.checkoutAttributesFragment);
function AddressFormQueryRenderer(componentProps) {
    return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: checkout_1.CheckoutAttributesQuery, variables: {}, render: function render(_ref6) {
            var error = _ref6.error,
                props = _ref6.props;

            if (error) {
                return React.createElement("div", null, error.message);
            } else if (props) {
                return React.createElement(RelayAddressForm, Object.assign({}, props, componentProps));
            }
            return null;
        } });
}
exports.default = AddressFormQueryRenderer;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackLicenseBuilderButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var React = __webpack_require__(0);
var trackLicensing_1 = __webpack_require__(432);
var index_1 = __webpack_require__(225);
var SessionLicenseBuilderButton_1 = __webpack_require__(300);

var TrackLicenseBuilderButton = function (_React$Component) {
    _inherits(TrackLicenseBuilderButton, _React$Component);

    function TrackLicenseBuilderButton() {
        _classCallCheck(this, TrackLicenseBuilderButton);

        var _this = _possibleConstructorReturn(this, (TrackLicenseBuilderButton.__proto__ || Object.getPrototypeOf(TrackLicenseBuilderButton)).apply(this, arguments));

        _this.onClick = function (e) {
            _this.props.licensingContext.setTrack(_this.props.track);
            if (!!_this.props.onClick) {
                e.persist();
                _this.props.onClick(e);
            }
        };
        _this.onSaveLicense = function (usages) {
            if (usages.length === 0) {
                _this.props.licensingContext.clearAll();
            } else {
                _this.props.licensingContext.setUsages(license_1.licenseUsagesToSearchParams(usages));
            }
            if (!!_this.props.onSaveLicense) {
                _this.props.onSaveLicense(usages);
            }
        };
        return _this;
    }

    _createClass(TrackLicenseBuilderButton, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                unusedTrackLicensingContext = _a.licensingContext,
                unusedOnClick = _a.onClick,
                unusedOnSaveLicense = _a.onSaveLicense,
                scope = _a.scope,
                unusedTrack = _a.track,
                buttonProps = __rest(_a, ["licensingContext", "onClick", "onSaveLicense", "scope", "track"]);
            return !!scope && scope.type !== 'Session' ? React.createElement(index_1.default, Object.assign({ onClick: this.onClick, onSaveLicense: this.onSaveLicense, scope: scope }, buttonProps)) : React.createElement(SessionLicenseBuilderButton_1.default, Object.assign({ onClick: this.onClick, onSaveLicense: this.onSaveLicense }, buttonProps));
        }
    }]);

    return TrackLicenseBuilderButton;
}(React.Component);

var TrackLicenseBuilderButtonWithContexts = function TrackLicenseBuilderButtonWithContexts(props) {
    return React.createElement(trackLicensing_1.TrackLicensingContext.Consumer, null, function (ctx) {
        return React.createElement(TrackLicenseBuilderButton, Object.assign({ licensingContext: ctx }, props));
    });
};
exports.default = TrackLicenseBuilderButtonWithContexts;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * BlogPostsSection
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1633);
var React = __webpack_require__(0);
var ScrollableSection_1 = __webpack_require__(429);
var BlogPost_1 = __webpack_require__(1635);
var BlogPostsSection = ScrollableSection_1.default;
function BlogPosts(props) {
  return React.createElement(BlogPostsSection, Object.assign({ id: "blog-posts", title: "Latest Articles", subtitle: "Craft & Commerce" }, props), function (item, index) {
    return item ? React.createElement(BlogPost_1.default, { data: item, index: index }) : null;
  });
}
exports.default = BlogPosts;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Charts Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1636);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var TrackList_1 = __webpack_require__(229);
var SectionTitle_1 = __webpack_require__(230);
var chartsClasses = new BEM('charts');
var chartClasses = new BEM('chart');
function Chart(_ref) {
    var _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === undefined ? 'bw3' : _ref$backgroundColor,
        data = _ref.data;

    return React.createElement(React.Fragment, null, React.createElement(SectionTitle_1.default, Object.assign({ title: data.name, subtitle: "Best of" }, chartClasses('title'))), React.createElement(TrackList_1.default, Object.assign({ cardProps: {
            backgroundColor: backgroundColor,
            size: 'small'
        }, displayPriceElement: false, tracks: data.items }, chartClasses('item'))));
}
function Charts(_ref2) {
    var itemBackgroundColor = _ref2.itemBackgroundColor,
        data = _ref2.data;

    var hasValidCharts = data.some(function (_ref3) {
        var items = _ref3.items;
        return !!items && !!items.length;
    });
    return hasValidCharts ? React.createElement("div", Object.assign({}, chartsClasses()), React.createElement("div", Object.assign({}, chartsClasses('content-wrapper', '', 'container')), data.map(function (chart, index) {
        return !!chart.items && !!chart.items.length && React.createElement("div", Object.assign({ key: "chart-" + index }, chartClasses()), React.createElement(Chart, { data: chart, backgroundColor: itemBackgroundColor }));
    }))) : null;
}
exports.default = Charts;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * HeaderPostsSection
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1641);
var React = __webpack_require__(0);
var ScrollableSection_1 = __webpack_require__(429);
var HeaderPost_1 = __webpack_require__(1643);
var HeaderPostsSection = ScrollableSection_1.default;
function HeaderPosts(props) {
  return React.createElement(HeaderPostsSection, Object.assign({ id: "header-posts" }, props), function (item, index) {
    return item ? React.createElement(HeaderPost_1.default, { data: item, index: index }) : null;
  });
}
exports.default = HeaderPosts;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NewsletterPromo Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(125);
__webpack_require__(1644);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var WindowSizeListener = __webpack_require__(124);
var redux_form_1 = __webpack_require__(37);
var velocity_react_1 = __webpack_require__(19);
var actions_1 = __webpack_require__(418);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Login_1 = __webpack_require__(152);
var classes = new BEM('newsletter-promo');

var NewsletterPromo = function (_React$Component) {
    _inherits(NewsletterPromo, _React$Component);

    function NewsletterPromo() {
        _classCallCheck(this, NewsletterPromo);

        var _this = _possibleConstructorReturn(this, (NewsletterPromo.__proto__ || Object.getPrototypeOf(NewsletterPromo)).apply(this, arguments));

        _this.onResize = function () {
            _this.initParallaxEffect();
            _this.onScroll();
        };
        _this.onScroll = function () {
            var st = window.scrollY;
            if (st > _this.parallaxStartPosition && st < _this.parallaxEndPosition) {
                var factor = st / _this.parallaxEndPosition;
                _this.image.style.transform = "translate3d(-50%, " + -_this.parallaxLimit * factor + "px, 0)";
            }
        };
        return _this;
    }

    _createClass(NewsletterPromo, [{
        key: "setParallaxLimit",
        value: function setParallaxLimit() {
            var _this2 = this;

            if (this.image) {
                var _image$getBoundingCli = this.image.getBoundingClientRect(),
                    height = _image$getBoundingCli.height;

                if (!height) {
                    this.setParallaxLimitTimer = window.setTimeout(function () {
                        _this2.setParallaxLimit();
                    }, 100);
                } else {
                    this.parallaxLimit = height - this.clientRect.height;
                }
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.element = react_dom_1.findDOMNode(this);
            this.initParallaxEffect();
            window.addEventListener('scroll', this.onScroll);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.clearTimeout(this.setParallaxLimitTimer);
            window.removeEventListener('scroll', this.onScroll);
            this.element = null;
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return React.createElement("form", Object.assign({ onSubmit: this.props.handleSubmit }, classes()), React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement("div", Object.assign({}, classes('background')), React.createElement("img", { ref: function ref(node) {
                    return _this3.image = node;
                }, src: "https://orpheus-assets.s3.amazonaws.com/homepage/headphones.jpg", alt: "A pair of headphones on a yellow background" })), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: { animation: 'transition.slideUpIn', duration: 500, delay: 500 }, leave: { animation: 'transition.slideUpOut', duration: 500 } }, classes('content-wrapper', '', 'container')), this.props.submitSucceeded ?
            // tslint:disable:max-line-length
            React.createElement("div", Object.assign({ key: "success-message" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('title')), "Great Stuff."), React.createElement(Heading_1.default, { is: "h4" }, "Check your inbox for an introduction to the Music Discovery Club!"), !this.props.isUserLoggedIn ? React.createElement("div", Object.assign({}, classes('create-account')), React.createElement(LinkButton_1.default, { to: Login_1.SignupPagePath, label: "Create an account", colorScheme: "dark", size: "medium" }), "\xA0", React.createElement(Label_1.Span, { variant: "description", size: "large" }, "to save tracks to Playlists.")) : '')
            // tslint:enable:max-line-length
            : React.createElement("div", Object.assign({ key: "form" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('title')), "Sign up to the Music Discovery Club to receive trending music in your inbox every two weeks."), React.createElement(velocity_react_1.VelocityComponent, { animation: this.props.submitFailed ? 'callout.shake' : { opacity: 1 } }, React.createElement(utils_1.FieldEmail, Object.assign({ component: TextField_1.default, name: "email", inlineButton: React.createElement(Button_1.default, { label: "Submit", colorScheme: "dark", size: "medium", isSubmit: true }), icon: React.createElement(Icon_1.IconMail, null), placeholder: "Your email", colorScheme: "white" }, classes('textfield'), { onlyValidateIfTouched: true, withoutBorder: true })))))), React.createElement(WindowSizeListener, { onResize: this.onResize }));
        }
    }, {
        key: "initParallaxEffect",
        value: function initParallaxEffect() {
            this.clientRect = this.element.getBoundingClientRect();
            var height = this.clientRect.height;

            this.parallaxStartPosition = this.element.offsetTop - window.innerHeight;
            this.parallaxEndPosition = this.parallaxStartPosition + height * 2 + (window.innerHeight - height);
            this.setParallaxLimit();
        }
    }]);

    return NewsletterPromo;
}(React.Component);

var NewsletterPromoForm = redux_form_1.reduxForm({
    form: 'newsletter-signup',
    onSubmit: function onSubmit(_ref, dispatch) {
        var email = _ref.email;

        dispatch(actions_1.sendNewsletterSignup({ email: email }));
    }
})(NewsletterPromo);
exports.default = NewsletterPromoForm;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InstantSearchPortal Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var _1 = __webpack_require__(1649);

var InstantSearchPortal = function (_React$Component) {
    _inherits(InstantSearchPortal, _React$Component);

    function InstantSearchPortal() {
        _classCallCheck(this, InstantSearchPortal);

        return _possibleConstructorReturn(this, (InstantSearchPortal.__proto__ || Object.getPrototypeOf(InstantSearchPortal)).apply(this, arguments));
    }

    _createClass(InstantSearchPortal, [{
        key: "render",
        value: function render() {
            var selector = document.getElementsByClassName('instant-search-wrapper');
            return selector.length ? ReactDOM.createPortal(React.createElement(_1.InstantSearch, Object.assign({}, this.props)), selector[0]) : null;
        }
    }]);

    return InstantSearchPortal;
}(React.Component);

exports.InstantSearchPortal = InstantSearchPortal;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultLink Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
var string_1 = __webpack_require__(47);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var Artist_1 = __webpack_require__(186);
var Track_1 = __webpack_require__(231);

var ResultLink = function (_React$PureComponent) {
    _inherits(ResultLink, _React$PureComponent);

    function ResultLink() {
        _classCallCheck(this, ResultLink);

        return _possibleConstructorReturn(this, (ResultLink.__proto__ || Object.getPrototypeOf(ResultLink)).apply(this, arguments));
    }

    _createClass(ResultLink, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                className = _a.className,
                label = _a.label,
                buttonProps = __rest(_a, ["className", "label"]);
            var classes = new BEM(this.props.className);
            return React.createElement(Button_1.default, Object.assign({ variant: "hyperlink", label: typeof label === 'string' ? string_1.stripHTMLTagsFromString(label) : label, size: "large" }, buttonProps, classes()));
        }
    }]);

    return ResultLink;
}(React.PureComponent);

exports.ResultLink = ResultLink;
exports.ResultLinkArtist = found_1.withRouter(function (_a) {
    var className = _a.className,
        label = _a.label,
        slug = _a.slug,
        props = __rest(_a, ["className", "label", "slug"]);

    return React.createElement(ResultLink, { className: className, label: label, wrapperComponent: "a", hyperLinkProps: {
            href: router_1.linkWithQueryString(Artist_1.ArtistPagePath(slug), props.match.location.query),
            target: '_blank'
        } });
});
exports.ResultLinkTrack = found_1.withRouter(function (_a) {
    var className = _a.className,
        label = _a.label,
        slug = _a.slug,
        props = __rest(_a, ["className", "label", "slug"]);

    return React.createElement(ResultLink, { className: className, label: label, wrapperComponent: "a", hyperLinkProps: {
            href: router_1.linkWithQueryString(Track_1.TrackPagePath(slug), props.match.location.query),
            target: '_blank'
        } });
});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SearchTermsBox Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(669);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Label_1 = __webpack_require__(8);
var Tag_1 = __webpack_require__(127);
var SearchTerm_1 = __webpack_require__(1659);
var classes = new BEM('search-terms');

var SearchTermsBox = function (_React$Component) {
    _inherits(SearchTermsBox, _React$Component);

    function SearchTermsBox(props) {
        _classCallCheck(this, SearchTermsBox);

        return _possibleConstructorReturn(this, (SearchTermsBox.__proto__ || Object.getPrototypeOf(SearchTermsBox)).call(this, props));
    }

    _createClass(SearchTermsBox, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var terms = this.props.data[0].items;
            return React.createElement("div", Object.assign({}, classes('', '', this.props.className)), React.createElement("header", Object.assign({}, classes('header')), React.createElement(Label_1.Span, Object.assign({ variant: "description" }, classes('header__title')), "Get", React.createElement("br", null), "Inspired")), React.createElement("ul", Object.assign({}, classes('list')), terms.map(function (featuredTerm) {
                if (featuredTerm.name) {
                    var id = featuredTerm.id,
                        name = featuredTerm.name,
                        taxonomy = featuredTerm.taxonomy;

                    return React.createElement(SearchTerm_1.default, Object.assign({ key: id, id: id, name: name, taxonomy: taxonomy, colorScheme: _this2.props.colorScheme }, classes('term')));
                }
                var title = featuredTerm.title,
                    url = featuredTerm.url;

                return React.createElement(Tag_1.default, Object.assign({ key: title, label: title, wrappedComponent: "li", onClick: function onClick() {
                        return window.location.href = url;
                    }, size: "large" }, classes('term')));
            })));
        }
    }]);

    return SearchTermsBox;
}(React.Component);

exports.default = SearchTermsBox;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1658);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * VerifyEmailPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = __webpack_require__(53);
var ui_1 = __webpack_require__(29);
var actions = __webpack_require__(50);
var url_1 = __webpack_require__(183);
var colors_1 = __webpack_require__(57);
__webpack_require__(1676);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var EmailPasswordForm_1 = __webpack_require__(633);
var Login_1 = __webpack_require__(152);
var Browse_1 = __webpack_require__(61);
var Discover_1 = __webpack_require__(221);
exports.VerifyEmailPagePath = function (email, code) {
    return "/verify?email=" + email + "&code=" + code;
};
var classes = new BEM('verify-email');

var VerifyEmailPage = function (_React$Component) {
    _inherits(VerifyEmailPage, _React$Component);

    function VerifyEmailPage(props) {
        _classCallCheck(this, VerifyEmailPage);

        var _this = _possibleConstructorReturn(this, (VerifyEmailPage.__proto__ || Object.getPrototypeOf(VerifyEmailPage)).call(this, props));

        _this.onLoginSuccess = function (cognitoSession) {
            var idToken = cognitoSession.getIdToken().getJwtToken();
            var accessToken = cognitoSession.getAccessToken().getJwtToken();
            var state = url_1.encodeForUrl({
                stateType: 'EmailVerification',
                email: _this.state.email,
                code: _this.state.code
            });
            _this.props.router.push(Login_1.LoginPagePath + "#id_token=" + idToken + "&access_token=" + accessToken + "&state=" + state);
        };
        _this.state = {
            email: props.location.query.email,
            code: props.location.query.code
        };
        return _this;
    }

    _createClass(VerifyEmailPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _state = this.state,
                email = _state.email,
                code = _state.code;

            if (!code || !email) {
                this.props.router.replace(Discover_1.DiscoverPagePath);
            } else {
                this.props.toggleHeader(false);
                this.doVerifyEmail();
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.userMustLogIn && !this.state.userMustLogIn) {
                this.doVerifyEmail();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.toggleHeader(true);
        }
    }, {
        key: "doVerifyEmail",
        value: function doVerifyEmail() {
            var _this2 = this;

            var _state2 = this.state,
                email = _state2.email,
                code = _state2.code;

            if (code && email) {
                setTimeout(function () {
                    return __awaiter(_this2, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                        var _this3 = this;

                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.prev = 0;
                                        _context.next = 3;
                                        return this.props.requestVerifyUserEmail({ code: code, email: email });

                                    case 3:
                                        this.setState({ emailConfirmed: true });
                                        _context.next = 9;
                                        break;

                                    case 6:
                                        _context.prev = 6;
                                        _context.t0 = _context["catch"](0);

                                        if (_context.t0.name === 'CognitoUserNotFound') {
                                            this.setState({ userMustLogIn: true });
                                        } else {
                                            this.props.pushNotification({
                                                autoDismiss: false,
                                                message: _context.t0.message,
                                                state: 'error'
                                            });
                                            setTimeout(function () {
                                                return _this3.props.router.push(Discover_1.DiscoverPagePath);
                                            }, 2000);
                                        }

                                    case 9:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _callee, this, [[0, 6]]);
                    }));
                }, 1000);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state3 = this.state,
                code = _state3.code,
                email = _state3.email,
                emailConfirmed = _state3.emailConfirmed,
                userMustLogIn = _state3.userMustLogIn;

            return React.createElement(velocity_react_1.VelocityTransitionGroup, { component: Page_1.default, id: "verify-email", enter: { animation: 'transition.expandIn', duration: 500, delay: 350 }, leave: { animation: 'transition.shrinkOut', duration: 350 }, runOnMount: true }, emailConfirmed ? React.createElement("div", Object.assign({ key: "verify-email-success" }, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title')), "Great!"), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('subtitle')), "Your email has been verified!"), React.createElement(Button_1.default, { onClick: function onClick() {
                    return _this4.props.router.push(Browse_1.BrowsePagePath);
                }, icon: React.createElement(Icon_1.IconMusicNote, null), label: "Browse Music", colorScheme: "accent", size: "large" })) : userMustLogIn ? React.createElement("div", Object.assign({ key: "login-form" }, classes('content', 'form')), React.createElement(Heading_1.default, { is: "h3" }, "Please log in:"), React.createElement(EmailPasswordForm_1.default, Object.assign({ form: "login-form", action: "login", initialValues: {
                    email: this.props.location.query.email,
                    password: ''
                }, disableOppositeAction: true, onSubmitSuccess: this.onLoginSuccess }, classes('login-form')))) : email && code ? React.createElement("div", Object.assign({ key: "verifying-email" }, classes('content')), React.createElement(Heading_1.default, { is: "h1", textColor: colors_1.bw6 }, "Verifying your email...")) : React.createElement("div", Object.assign({ key: "verifying-email" }, classes('content')), React.createElement(Heading_1.default, { is: "h3", textColor: colors_1.dangerous }, "Error while verifying your email.", React.createElement("br", null), "Please try again later.")));
        }
    }]);

    return VerifyEmailPage;
}(React.Component);

var ConnectedVerifyEmailPage = react_redux_1.connect(null, function (dispatch) {
    return {
        pushNotification: function pushNotification(notification) {
            dispatch(notifications_1.pushNotification(notification));
        },
        requestVerifyUserEmail: function requestVerifyUserEmail(payload) {
            return new Promise(function (resolve, reject) {
                dispatch(actions.requestVerifyUserEmail(Object.assign({}, payload, { promise: { resolve: resolve, reject: reject } })));
            });
        },
        toggleHeader: function toggleHeader(toggle) {
            dispatch(ui_1.toggleHeaderVisibility(toggle));
        }
    };
})(VerifyEmailPage);
exports.default = ConnectedVerifyEmailPage;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Logout Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var notifications = __webpack_require__(53);
var ui_1 = __webpack_require__(29);
var user_1 = __webpack_require__(50);
var logout_1 = __webpack_require__(437);
__webpack_require__(1681);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var Heading_1 = __webpack_require__(9);
var Discover_1 = __webpack_require__(221);
// Page Path
exports.LogoutPagePath = '/logout';

var Logout = function (_React$Component) {
    _inherits(Logout, _React$Component);

    function Logout() {
        _classCallCheck(this, Logout);

        return _possibleConstructorReturn(this, (Logout.__proto__ || Object.getPrototypeOf(Logout)).apply(this, arguments));
    }

    _createClass(Logout, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.toggleHeader(false);
            this.logUserOut();
            // tslint:disable-next-line:no-string-literal
            this.olark = window['olark'];
            this.olark('api.box.hide');
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.toggleHeader(true);
            this.olark('api.box.show');
            this.olark = null;
        }
    }, {
        key: "logUserOut",
        value: function logUserOut() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _props, pushNotification, requestLogOut, router;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props = this.props, pushNotification = _props.pushNotification, requestLogOut = _props.requestLogOut, router = _props.router;
                                _context.prev = 1;
                                _context.next = 4;
                                return requestLogOut();

                            case 4:
                                pushNotification({
                                    message: locales_1.default.logout.successMessage,
                                    state: 'success'
                                });
                                setTimeout(function () {
                                    return router.replace(Discover_1.DiscoverPagePath);
                                }, 250);
                                _context.next = 13;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](1);

                                pushNotification({
                                    autoDismiss: false,
                                    message: 'We were unable to log you out. Please check your Internet connection and try again later.',
                                    state: 'error'
                                });
                                console.error(_context.t0);
                                setTimeout(function () {
                                    return router.go(-1);
                                }, 250);

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8]]);
            }));
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(Page_1.default, { id: "logout" }, React.createElement(Heading_1.default, { is: "h2", textColor: "bw6" }, "Logging you out..."));
        }
    }]);

    return Logout;
}(React.Component);

var ConnectedLogout = react_redux_1.connect(null, function (dispatch) {
    return {
        pushNotification: function pushNotification(notification) {
            dispatch(notifications.pushNotification(notification));
        },

        requestLogOut: function requestLogOut(payload) {
            dispatch(user_1.requestUserLogOut(payload));
        },
        toggleHeader: function toggleHeader(toggle) {
            dispatch(ui_1.toggleHeaderVisibility(toggle));
        }
    };
}, function (_, dispatchProps, ownProps) {
    return Object.assign({}, dispatchProps, ownProps, { requestLogOut: function requestLogOut() {
            return new Promise(function (resolve, reject) {
                dispatchProps.requestLogOut({
                    promise: { resolve: resolve, reject: reject },
                    viewerId: ownProps.viewer.id
                });
            });
        } });
})(Logout);
var RelayLogout = react_relay_1.createFragmentContainer(ConnectedLogout, logout_1.LogoutFormFragment);
exports.default = RelayLogout;

/***/ }),
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Static Data Reducer
 */

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(716);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var defaultList = [];
exports.initialState = {
    businessInformation: {},
    exchangeRates: defaultList,
    licenseComponents: {},
    taxonomies: defaultList,
    tempos: defaultList
};
var setStaticDataHandler = function setStaticDataHandler(state, newState) {
    return Object.assign({}, state, newState);
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(exports.initialState).case(actions.setStaticData, setStaticDataHandler);

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Actions for Static Data
 */

Object.defineProperty(exports, "__esModule", { value: true });
var typescript_fsa_1 = __webpack_require__(46);
var actionCreator = typescript_fsa_1.default('StaticData');
exports.setStaticData = actionCreator('SET_STATIC_DATA_STATE');

/***/ }),
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Projects Reducer Helper Function
 */

Object.defineProperty(exports, "__esModule", { value: true });
var project_1 = __webpack_require__(318);
var relay_1 = __webpack_require__(226);
exports.createProject = function (_ref, parentID) {
    var input = _ref.input;

    return relay_1.processAddMutation(project_1.CreateProjectMutation, input, {
        edgeName: 'new_project_edge',
        parentID: parentID,
        connectionInfo: [{
            key: 'list_projects',
            rangeBehavior: 'prepend'
        }]
    });
};
exports.addTrackToProject = function (_ref2) {
    var licenseParams = _ref2.licenseParams,
        projectId = _ref2.projectId,
        trackId = _ref2.trackId,
        trackVersion = _ref2.trackVersion;

    return relay_1.processMutation(project_1.UpdateProjectMutation, {
        id: projectId,
        tracks: {
            add: [{
                track_id: trackId,
                version: trackVersion
            }]
        },
        license_params: licenseParams
    });
};
exports.updateProject = function (_ref3, updater) {
    var input = _ref3.input;

    return relay_1.processMutation(project_1.UpdateProjectMutation, input, [], updater);
};
exports.joinProject = function (_ref4, updater) {
    var input = _ref4.input;

    return relay_1.processMutation(project_1.JoinProjectMutation, input, [], updater);
};
exports.deleteProject = function (_ref5, parentID) {
    var input = _ref5.input;

    return relay_1.processDeleteMutation(project_1.DeleteProjectMutation, input, {
        parentID: parentID,
        pathToConnection: ['viewer', 'projects'],
        connectionKeys: [{
            key: 'list_projects'
        }]
    });
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for App Container
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.AppRootQuery = function () {
  return __webpack_require__(1818);
};
exports.AppFragment = {
  viewer: function viewer() {
    return __webpack_require__(1819);
  }
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProfilePage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var profile_1 = __webpack_require__(288);
__webpack_require__(1823);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PageHeader_1 = __webpack_require__(144);
var grid_1 = __webpack_require__(58);
// Page Path
exports.ProfilePagePath = '/my/profile';
var classes = new BEM('profile');
var ProfileLineInfo = function ProfileLineInfo(_ref) {
    var isImage = _ref.isImage,
        label = _ref.label,
        value = _ref.value;
    return !!value ? React.createElement("div", Object.assign({}, classes('info__line')), React.createElement("div", Object.assign({}, classes('info__title')), React.createElement(Label_1.Span, { size: "medium", textColor: "bw7" }, label, ":")), React.createElement("div", Object.assign({}, classes('info__data')), isImage ? React.createElement(Thumbnail_1.default, { src: value, shape: "circle", size: 48, withShadow: false }) : React.createElement(Heading_1.default, { is: "h4", WrappedComponent: "span" }, value))) : null;
};

var ProfilePage = function (_React$Component) {
    _inherits(ProfilePage, _React$Component);

    function ProfilePage() {
        _classCallCheck(this, ProfilePage);

        return _possibleConstructorReturn(this, (ProfilePage.__proto__ || Object.getPrototypeOf(ProfilePage)).apply(this, arguments));
    }

    _createClass(ProfilePage, [{
        key: "render",
        value: function render() {
            var profile = this.props.viewer.profile;
            return React.createElement(Page_1.default, { id: "profile", noIndex: true }, React.createElement(PageHeader_1.default, { title: "My Profile", actions: React.createElement(React.Fragment, null, profile.external_provider && React.createElement(Label_1.Span, { variant: "description", textColor: "bw7", style: { marginRight: grid_1.baseline }, size: "large" }, "Connected using ", profile.external_provider, "."), React.createElement(Button_1.default, { hyperLinkProps: {
                        href: this.props.logoutUrl
                    }, wrapperComponent: "a", label: "Log out", variant: "hyperlink", size: "large" })) }), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement("div", Object.assign({}, classes('content')), profile.picture && React.createElement(ProfileLineInfo, { label: "Profile Picture", value: profile.picture, isImage: true }), React.createElement(ProfileLineInfo, { label: "Name", value: profile.first_name + " " + profile.last_name }), React.createElement(ProfileLineInfo, { label: "Email", value: profile.email }), profile.company_name && React.createElement(ProfileLineInfo, { label: "Company", value: profile.company_name }), profile.job_type && React.createElement(ProfileLineInfo, { label: "Role/Position", value: profile.job_type.name }), profile.industry && React.createElement(ProfileLineInfo, { label: "Industry", value: profile.industry.name }))));
        }
    }]);

    return ProfilePage;
}(React.Component);

var ConnectedProfilePage = react_redux_1.connect(function (_ref2) {
    var authentication = _ref2.authentication;
    return {
        logoutUrl: authentication.logoutUrl
    };
})(ProfilePage);
var RelayProfilePage = react_relay_1.createFragmentContainer(ConnectedProfilePage, profile_1.ProfileFragment);
exports.default = RelayProfilePage;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SharedProjectPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(42);
var postAuthenticationRequests_1 = __webpack_require__(81);
var projects_1 = __webpack_require__(130);
var ui_1 = __webpack_require__(29);
var license_1 = __webpack_require__(34);
var player_2 = __webpack_require__(63);
var staticData_1 = __webpack_require__(103);
var project_1 = __webpack_require__(318);
var grid_1 = __webpack_require__(58);
__webpack_require__(450);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var LoadingButton_1 = __webpack_require__(286);
var Projects_1 = __webpack_require__(319);
var SharedProjectTrackList_1 = __webpack_require__(1841);
// Page Path
exports.SharedProjectPagePath = function (opaqueId) {
    return "/playlist/" + opaqueId;
};
var classes = new BEM('shared-project');
var defaultList = [];

var SharedProjectPage = function (_React$Component) {
    _inherits(SharedProjectPage, _React$Component);

    function SharedProjectPage(props) {
        _classCallCheck(this, SharedProjectPage);

        var _this = _possibleConstructorReturn(this, (SharedProjectPage.__proto__ || Object.getPrototypeOf(SharedProjectPage)).call(this, props));

        _this.onJoinProject = function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.setState({ isProcessingJoinMutation: true });
                                _context.next = 4;
                                return this.props.joinProject();

                            case 4:
                                setTimeout(function () {
                                    return _this2.goToProjectPage;
                                }, 500);
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](0);

                                console.error(_context.t0);

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 7]]);
            }));
        };
        _this.state = {
            isProcessingJoinMutation: false,
            redirecting: false
        };
        return _this;
    }

    _createClass(SharedProjectPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var shared_project = this.props.viewer.shared_project;

            if (shared_project) {
                if (this.isUserACollaborator()) {
                    this.goToProjectPage();
                } else {
                    this.props.setPlayerQueue(player_2.getPlayerTracksFromResults(shared_project.tracks.edges.map(function (e) {
                        return e.node;
                    }) || defaultList));
                }
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(_ref) {
            var prevSharedProject = _ref.viewer.shared_project;
            var sharedProject = this.props.viewer.shared_project;

            if (sharedProject) {
                if (prevSharedProject) {
                    if (sharedProject.users.length !== prevSharedProject.users.length) {
                        if (this.isUserACollaborator()) {
                            this.goToProjectPage();
                        }
                    }
                } else if (this.isUserACollaborator()) {
                    this.goToProjectPage();
                }
            }
        }
    }, {
        key: "renderProject",
        value: function renderProject() {
            var project = this.props.viewer.shared_project;
            var hasOwner = !lodash_1.isEmpty(lodash_1.pickBy(lodash_1.pick(project.owner, ['first_name', 'last_name']), lodash_1.identity));
            var owner = project.owner.first_name + " " + project.owner.last_name;
            var projectHasTerms = !!project.license_params.length;
            var usages = projectHasTerms ? license_1.setLicenseFromParams(this.props.licenseComponents, project.license_params) : defaultList;
            var joinProjectButtonProps = Object.assign({ label: 'Join This Playlist', size: 'large', colorScheme: 'accent', variant: 'pill', withShadow: !this.state.isProcessingJoinMutation, icon: React.createElement(Icon_1.IconUserAdd, null) }, classes('join-button'));
            return React.createElement(React.Fragment, null, React.createElement(react_helmet_1.Helmet, { title: project.name + " \u2014 Owned by " + owner }), React.createElement(Icon_1.IconProjectBox, Object.assign({}, classes('icon'))), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('identification')), "Playlist"), hasOwner && React.createElement(Heading_1.default, Object.assign({ is: "h5", textColor: "bw6" }, classes('shared-by')), "Owned by ", owner), React.createElement(Heading_1.default, Object.assign({ is: "h1" }, classes('title')), project.name), projectHasTerms && React.createElement(Label_1.Span, Object.assign({ size: "large", variant: "description", textColor: "bw7" }, classes('license-string')), license_1.getLicenseString(usages)), React.createElement("div", Object.assign({}, classes('buttons')), this.props.isUserLoggedIn ? React.createElement(LoadingButton_1.default, Object.assign({ onClick: this.onJoinProject, isLoading: this.state.isProcessingJoinMutation }, joinProjectButtonProps)) : React.createElement(Button_1.default, Object.assign({ onClick: this.props.logInToJoinProject }, joinProjectButtonProps)), React.createElement(Button_1.default, Object.assign({ wrapperComponent: "a", hyperLinkProps: {
                    href: "/playlist/" + project.opaque_id + "/download",
                    target: '_blank'
                }, label: "Download Tracks",
                // colorScheme="transparent"
                size: "large", colorScheme: "light", variant: "pill", withShadow: true, icon: React.createElement(Icon_1.IconDownload, null) }, classes('download-button')))), project.tracks && project.tracks.edges && project.tracks.edges.length ? React.createElement(SharedProjectTrackList_1.SharedProjectTrackList, { license: usages, tracks: project.tracks }) : React.createElement("div", { style: { marginTop: grid_1.baseline * 10 } }, React.createElement(Heading_1.default, Object.assign({ is: "h3", textColor: "bw6" }, classes('no-tracks')), "There are no tracks in this playlist.")));
        }
    }, {
        key: "render",
        value: function render() {
            var project = this.props.viewer.shared_project;
            return React.createElement(Page_1.default, Object.assign({ id: "shared-project" }, classes(), { noIndex: true }), this.state.redirecting ? React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title', 'redirecting')), "Redirecting to playlist page...")) : React.createElement("div", Object.assign({}, classes('content-wrapper')), project ? this.renderProject() : React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('title', 'redirecting')), "playlist not found")));
        }
    }, {
        key: "goToProjectPage",
        value: function goToProjectPage() {
            var _this3 = this;

            this.setState({ redirecting: true }, function () {
                _this3.props.router.push(Projects_1.ProjectPagePath(_this3.props.viewer.shared_project.id));
            });
        }
    }, {
        key: "isUserACollaborator",
        value: function isUserACollaborator() {
            var _props$viewer = this.props.viewer,
                profile = _props$viewer.profile,
                shared_project = _props$viewer.shared_project;

            return shared_project && profile ? shared_project.users.some(function (_ref2) {
                var user_id = _ref2.user_id;
                return user_id === profile.user_id;
            }) : undefined;
        }
    }]);

    return SharedProjectPage;
}(React.Component);

var ConnectedSharedProjectPage = react_redux_1.connect(function (state) {
    return {
        isUserLoggedIn: !!state.user.profile,
        licenseComponents: staticData_1.getLicenseComponents(state)
    };
}, function (dispatch) {
    return {
        dispatch: dispatch,
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(player_1.replaceQueue({ tracks: tracks }));
        }
    };
}, function (stateProps, _a, ownProps) {
    var dispatch = _a.dispatch,
        dispatchProps = __rest(_a, ["dispatch"]);
    return Object.assign({}, stateProps, dispatchProps, ownProps, { joinProject: function joinProject() {
            return new Promise(function (resolve, reject) {
                dispatch(projects_1.requestJoinProject({
                    input: { opaque_id: ownProps.viewer.shared_project.opaque_id },
                    promise: { resolve: resolve, reject: reject }
                }));
            });
        }, logInToJoinProject: function logInToJoinProject() {
            var projectOpaqueId = ownProps.viewer.shared_project.opaque_id;
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestJoinProject({
                projectOpaqueId: projectOpaqueId,
                page: exports.SharedProjectPagePath(projectOpaqueId)
            }));
            dispatch(ui_1.toggleLogInFormVisibility(true));
        } });
})(SharedProjectPage);
var RelaySharedProjectsPage = react_relay_1.createFragmentContainer(ConnectedSharedProjectPage, project_1.ShareProjectFragment);
exports.default = RelaySharedProjectsPage;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Media Query Component
 */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_responsive_1 = __webpack_require__(1842);
exports.Phone = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 320 }, props), children);
};
exports.Phablet = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 480 }, props), children);
};
exports.TabletS = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 600 }, props), children);
};
exports.TabletM = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 768 }, props), children);
};
exports.TabletL = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 800 }, props), children);
};
exports.DesktopXS = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 864 }, props), children);
};
exports.DesktopS = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 960 }, props), children);
};
exports.Desktop = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1024 }, props), children);
};
exports.DesktopM = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1152 }, props), children);
};
exports.DesktopL = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1280 }, props), children);
};
exports.DesktopXL = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1440 }, props), children);
};
exports.DesktopXXL = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1600 }, props), children);
};
exports.DesktopHD = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 1920 }, props), children);
};
exports.DesktopXHD = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 2160 }, props), children);
};
exports.DesktopQHD = function (_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return React.createElement(react_responsive_1.default, Object.assign({ minWidth: 2560 }, props), children);
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectTrackList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var animation_1 = __webpack_require__(173);
var form_1 = __webpack_require__(239);
__webpack_require__(1843);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_sortable_hoc_1 = __webpack_require__(729);
var velocity_react_1 = __webpack_require__(19);
var mediaQueries_1 = __webpack_require__(727);
var EmptyProjectView_1 = __webpack_require__(1845);
var ProjectTrackItem_1 = __webpack_require__(1846);
// IMPORTANT: the transform property has to be reset once project track items
// have finished animating in order to ensure the download dropdown menu works
// properly.
function resetAnimTransform(els) {
    els.forEach(function (el) {
        if (el.style.transform) {
            el.style.transform = null;
        }
    });
}
var classes = new BEM('project-track-list');
function projectTrackTitle(track, version) {
    var versionLabel = version && version !== 'original' ? lodash_1.capitalize(version) : undefined;
    var title = versionLabel ? track.title + " (" + versionLabel + ")" : track.title;
    return title;
}
exports.projectTrackTitle = projectTrackTitle;
var ProjectTrackList = react_sortable_hoc_1.SortableContainer(function (_ref) {
    var items = _ref.items,
        onRemoveItem = _ref.onRemoveItem,
        onSaveLicense = _ref.onSaveLicense,
        license = _ref.license,
        project = _ref.project;
    return React.createElement(mediaQueries_1.Desktop, null, function (matches) {
        var cardHeight = matches ? 128 : 64;
        var TrackItemAnimations = animation_1.ListItemAnimations(cardHeight);
        var key = matches ? 'for-desktop' : 'for-tablet';
        return React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ key: key, component: "ul" }, classes(), {
            // tslint:disable-next-line:max-line-length
            enter: { animation: TrackItemAnimations.In, delay: 500, stagger: 150, height: 'auto', complete: resetAnimTransform }, leave: { animation: TrackItemAnimations.Out }, runOnMount: true }), items.map(function (_, index) {
            var trackItem = items.get(index);
            var edgeResult = !!project.tracks ? project.tracks.edges.find(function (edge) {
                return edge.id === trackItem.association_id;
            }) : undefined;
            var trackResult = edgeResult ? edgeResult.node : undefined;
            var title = trackResult && projectTrackTitle(trackResult, edgeResult && edgeResult.version);
            return trackResult ? React.createElement("li", Object.assign({ key: project.id + "-" + (edgeResult && edgeResult.id) }, classes('item')), React.createElement(ProjectTrackItem_1.ProjectTrackItem, Object.assign({ title: title, cardSize: matches ? 'medium' : 'small', index: index, license: license, projectId: project.id, remove: onRemoveItem(index), onSaveLicense: onSaveLicense, trackResult: trackResult, trackEdge: edgeResult }, trackItem))) : null;
        }));
    });
});

var ProjectTrackListWrapper = function (_React$Component) {
    _inherits(ProjectTrackListWrapper, _React$Component);

    function ProjectTrackListWrapper() {
        _classCallCheck(this, ProjectTrackListWrapper);

        var _this = _possibleConstructorReturn(this, (ProjectTrackListWrapper.__proto__ || Object.getPrototypeOf(ProjectTrackListWrapper)).apply(this, arguments));

        _this.onRemoveItem = lodash_1.memoize(function (index) {
            return function () {
                _this.props.dispatch(form_1.removeTrack(index));
                nextTick(function () {
                    return _this.props.dispatch(form_1.submitForm());
                });
            };
        });
        _this.onSortEnd = function (_ref2) {
            var oldIndex = _ref2.oldIndex,
                newIndex = _ref2.newIndex;

            _this.props.dispatch(form_1.moveTrack(oldIndex, newIndex));
            nextTick(function () {
                return _this.props.dispatch(form_1.submitForm());
            });
        };
        return _this;
    }

    _createClass(ProjectTrackListWrapper, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                project = _props.project,
                fields = _props.fields,
                license = _props.license,
                onSaveLicense = _props.onSaveLicense;

            return fields.length > 0 ? React.createElement(ProjectTrackList, { key: "tracks-array-" + project.id, project: project, distance: 10, items: fields, license: license, onRemoveItem: this.onRemoveItem, onSaveLicense: onSaveLicense, onSortEnd: this.onSortEnd, helperClass: "is-being-sorted" }) : React.createElement(EmptyProjectView_1.EmptyProjectView, null);
        }
    }]);

    return ProjectTrackListWrapper;
}(React.Component);

var ConnectedProjectTrackListWrapper = react_redux_1.connect()(ProjectTrackListWrapper);
exports.default = ConnectedProjectTrackListWrapper;

/***/ }),
/* 729 */,
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Cookie Consent Context
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var provider_1 = __webpack_require__(731);
exports.CookieContext = React.createContext({
    consentReceived: provider_1.getCookieConsentState(),
    clear: function clear() {
        return null;
    },
    handleConsent: function handleConsent() {
        return null;
    },
    dispatch: function dispatch() {
        return null;
    }
});

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Cookie Consent Context Provider Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var localStorage_1 = __webpack_require__(238);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var _1 = __webpack_require__(730);
exports.cookieConsentLocalStorageKey = "" + localStorage_1.localStoragePrefix + localStorage_1.localStorageKeySeparator + "cookie-consent-received";
exports.cookieConsentClientCookieKey = 'bopper-cookie-consented';
function getCookieConsentState() {
    try {
        if (localStorage.getItem(exports.cookieConsentLocalStorageKey) === 'true') {
            return true;
        }
    } catch (e) {
        console.error(e);
    }
    if (document.cookie && document.cookie.indexOf(exports.cookieConsentClientCookieKey) !== -1) {
        return true;
    }
    return false;
}
exports.getCookieConsentState = getCookieConsentState;
function setCookieConsent() {
    try {
        localStorage.setItem(exports.cookieConsentLocalStorageKey, 'true');
        if (localStorage.getItem(exports.cookieConsentLocalStorageKey) !== 'true') {
            throw new Error('Could not set cookie consent to local storage.');
        }
    } catch (e) {
        console.error(e);
        document.cookie = exports.cookieConsentClientCookieKey + "=true";
    }
}
exports.setCookieConsent = setCookieConsent;

var CookieContextProviderBase = function (_React$Component) {
    _inherits(CookieContextProviderBase, _React$Component);

    function CookieContextProviderBase(props) {
        _classCallCheck(this, CookieContextProviderBase);

        var _this = _possibleConstructorReturn(this, (CookieContextProviderBase.__proto__ || Object.getPrototypeOf(CookieContextProviderBase)).call(this, props));

        _this.clear = function () {
            return;
        };
        _this.handleConsent = function () {
            _this.setState({ consentReceived: true }, function () {
                setCookieConsent();
            });
        };
        _this.state = {
            dispatch: _this.props.dispatch,
            clear: _this.clear,
            handleConsent: _this.handleConsent,
            consentReceived: getCookieConsentState()
        };
        return _this;
    }

    _createClass(CookieContextProviderBase, [{
        key: "render",
        value: function render() {
            return React.createElement(_1.CookieContext.Provider, { value: this.state }, this.props.children);
        }
    }]);

    return CookieContextProviderBase;
}(React.Component);

exports.CookieContextProvider = react_redux_1.connect(function () {
    return {};
}, function (dispatch) {
    return { dispatch: dispatch };
})(CookieContextProviderBase);

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable:no-empty-interface

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
__webpack_require__(1907);
var classes = new BEM('brand-navigation');
exports.BlogPagePath = '/blog';
exports.PricingPagePath = '/pricing';
exports.AboutUsPagePath = '/about';

var BrandNavigation = function (_React$Component) {
    _inherits(BrandNavigation, _React$Component);

    function BrandNavigation(props) {
        _classCallCheck(this, BrandNavigation);

        return _possibleConstructorReturn(this, (BrandNavigation.__proto__ || Object.getPrototypeOf(BrandNavigation)).call(this, props));
    }

    _createClass(BrandNavigation, [{
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes()), React.createElement("div", Object.assign({}, classes('logo-wrapper')), React.createElement(Button_1.default, Object.assign({ wrapperComponent: "a", variant: "icon" }, classes('logo'), { hyperLinkProps: {
                    href: '/'
                } }), React.createElement(Icon_1.LogoBopperWithName, null)), React.createElement("h1", Object.assign({}, classes('tagline')), "Music Licensing")), React.createElement("div", Object.assign({}, classes('links')), React.createElement(Button_1.default, { wrapperComponent: "a", hyperLinkProps: {
                    href: exports.BlogPagePath,
                    target: '_blank'
                } }, "Blog"), React.createElement(Button_1.default, { wrapperComponent: "a", hyperLinkProps: {
                    href: exports.PricingPagePath,
                    target: '_blank'
                } }, "Pricing"), React.createElement(Button_1.default, { wrapperComponent: "a", hyperLinkProps: {
                    href: exports.AboutUsPagePath,
                    target: '_blank'
                } }, "About Us")));
        }
    }]);

    return BrandNavigation;
}(React.Component);

exports.BrandNavigation = BrandNavigation;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1913);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultsPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var playerAction = __webpack_require__(42);
var player_1 = __webpack_require__(63);
var trackSearch_1 = __webpack_require__(301);
__webpack_require__(1938);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var Page_1 = __webpack_require__(38);
var currency_1 = __webpack_require__(115);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var LoadingSpinner_1 = __webpack_require__(163);
var NProgress_1 = __webpack_require__(228);
var FacetedSearchNav_1 = __webpack_require__(1940);
var ResultList_1 = __webpack_require__(1987);
var EmptyState_1 = __webpack_require__(1993);
var NoMatchFound_1 = __webpack_require__(1996);
exports.ResultsPerPage = 15;
var classes = new BEM('results');
var defaultList = [];

var ResultsPage = function (_React$Component) {
    _inherits(ResultsPage, _React$Component);

    function ResultsPage(props) {
        _classCallCheck(this, ResultsPage);

        var _this = _possibleConstructorReturn(this, (ResultsPage.__proto__ || Object.getPrototypeOf(ResultsPage)).call(this, props));

        _this.onLoadMore = function () {
            _this.setState(function (_ref) {
                var displayPage = _ref.displayPage,
                    prevResults = _ref.prevResults;

                var newDisplayPage = displayPage + 1;
                var _this$props = _this.props,
                    filters = _this$props.filters,
                    license_params = _this$props.license_params,
                    relay = _this$props.relay,
                    query = _this$props.query,
                    taxonomy_query = _this$props.taxonomy_query,
                    sort = _this$props.sort;

                var refetchVariables = {
                    offset: exports.ResultsPerPage * (newDisplayPage - 1),
                    count: exports.ResultsPerPage,
                    filters: filters,
                    license_params: license_params,
                    taxonomy_query: taxonomy_query,
                    sort: sort,
                    query: query
                };
                relay.refetch(refetchVariables, null, null, { force: true });
                return {
                    prevResults: [].concat(_toConsumableArray(prevResults), _toConsumableArray(_this.props.viewer.trackSearch.edges)),
                    displayPage: newDisplayPage,
                    searching: true
                };
            });
        };
        _this.onToggleFacetMenu = function (open) {
            if (_this.state.hasFacetMenuOpen !== open) {
                _this.setState({ hasFacetMenuOpen: !!open });
            }
        };
        _this.state = {
            prevResults: [],
            displayPage: 1,
            hasFacetMenuOpen: false,
            searching: !!_this.props.searching
        };
        return _this;
    }

    _createClass(ResultsPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var tracks = player_1.getPlayerTracksFromResults(getTrackResultsFromEdges(this.props.viewer));
            this.props.setPlayerQueue(tracks);
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            // FIXME: this line is not clear at all...
            return nextState.displayPage <= this.state.displayPage && this.filtersWereTurnedOn(nextProps) === false;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!this.props.searching) {
                if (this.hasNewResults(prevProps)) {
                    var newTracks = player_1.getPlayerTracksFromResults(getTrackResultsFromEdges(this.props.viewer));
                    this.props.setPlayerQueue(newTracks);
                    if (this.isNewSearch(prevProps)) {
                        this.setState({ displayPage: 1, prevResults: [] });
                    }
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.clearTimeout(this.searchTimer);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                hasFilters = _props.hasFilters,
                viewer = _props.viewer;
            var _state = this.state,
                hasFacetMenuOpen = _state.hasFacetMenuOpen,
                searching = _state.searching;

            var results = viewer ? [].concat(_toConsumableArray(this.state.prevResults), _toConsumableArray(viewer.trackSearch.edges)) : defaultList;
            var totalResults = viewer ? viewer.trackSearch.total : 0;
            var contentClassModifiers = {
                'no-result': hasFilters && totalResults === 0
            };
            var extraClasses = classNames(hasFacetMenuOpen && 'has-facet-menu-open', searching && 'searching', !hasFilters && 'is-empty-state');
            return React.createElement(Page_1.default, { id: "results", className: extraClasses }, React.createElement(currency_1.CurrencyContext.Consumer, null, function (_ref2) {
                var currency = _ref2.currency;
                return React.createElement(FacetedSearchNav_1.default, { onToggleFacetMenu: _this2.onToggleFacetMenu, viewer: viewer, currency: currency });
            }), React.createElement(NProgress_1.default, { active: !!searching }), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement("div", Object.assign({}, classes('content', contentClassModifiers)), hasFilters ? totalResults > 0 ? React.createElement(ResultList_1.default, { results: results, totalResults: totalResults, onLoadMore: this.onLoadMore }) : searching ? React.createElement(LoadingSpinner_1.default, { center: true }) : React.createElement(NoMatchFound_1.NoMatchFound, null) : React.createElement(EmptyState_1.default, null))));
        }
    }, {
        key: "isNewSearch",
        value: function isNewSearch(prevProps) {
            var _getResults = this.getResults(prevProps),
                _getResults2 = _slicedToArray(_getResults, 2),
                prevResults = _getResults2[0],
                newResults = _getResults2[1];

            return prevResults.length === 0 && newResults.length > 0;
        }
    }, {
        key: "hasNewResults",
        value: function hasNewResults(prevProps) {
            var _getResults3 = this.getResults(prevProps),
                _getResults4 = _slicedToArray(_getResults3, 2),
                prevResults = _getResults4[0],
                newResults = _getResults4[1];

            if (prevResults.length !== newResults.length) {
                return true;
            }
            return !lodash_1.isEqualWith(prevResults, newResults, function (a, b) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = a.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ref3 = _step.value;

                        var _ref4 = _slicedToArray(_ref3, 1);

                        var i = _ref4[0];

                        if (a[i].node && b[i].node) {
                            if (a[i].node.id !== b[i].node.id) {
                                return false;
                            }
                        } else if (!!a[i].node && b[i].node || a[i].node && !!b[i].node) {
                            return false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return true;
            });
        }
    }, {
        key: "getResults",
        value: function getResults(prevProps) {
            var prevResults = lodash_1.get(prevProps, 'viewer.trackSearch.edges', defaultList);
            var newResults = lodash_1.get(this.props, 'viewer.trackSearch.edges', defaultList);
            return [prevResults, newResults];
        }
    }, {
        key: "filtersWereTurnedOn",
        value: function filtersWereTurnedOn(nextProps) {
            return !this.props.hasFilters && nextProps.hasFilters;
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(_ref5, prevState) {
            var searching = _ref5.searching;

            if (searching !== prevState.searching) {
                return {
                    searching: searching
                };
            }
            return null;
        }
    }]);

    return ResultsPage;
}(React.Component);

function getTrackResultsFromEdges(viewer) {
    if (!!!viewer || !!!viewer.trackSearch) {
        return [];
    }
    return viewer.trackSearch.edges.map(function (_ref6) {
        var node = _ref6.node;
        return node;
    });
}
var ConnectedResultsPage = react_redux_1.connect(null, function (dispatch) {
    return {
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerAction.replaceQueue({ tracks: tracks }));
        }
    };
})(ResultsPage);
var ResultPageWithQueryStringContext = function ResultPageWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        var hasFilters = selectors_1.hasSearchFilters(ctx);
        return React.createElement(ConnectedResultsPage, Object.assign({ filters: ctx.filters, hasFilters: hasFilters, license_params: ctx.license_params, query: ctx.query, sort: ctx.sort }, props));
    });
};
var RelayResultsPage = react_relay_1.createRefetchContainer(ResultPageWithQueryStringContext, trackSearch_1.trackSearchFragment, trackSearch_1.trackSearchQuery);
exports.default = RelayResultsPage;

/***/ }),
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(749);
__webpack_require__(750);
module.exports = __webpack_require__(952);


/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Entry Point
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
// import { AppContainer } from 'react-hot-loader';
function render() {
  var Root = __webpack_require__(953).default;
  ReactDOM.render(React.createElement(Root, null), document.getElementById('app'));
}
// if (module.hot) {
//   module.hot.accept('./containers/Root', () => {
//     setTimeout(render);
//   });
// }
render();

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Root Container
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(954);
var redux_1 = __webpack_require__(957);
var relay_1 = __webpack_require__(93);
var router_1 = __webpack_require__(1816);
var RouteConfig_1 = __webpack_require__(1817);
var found_relay_1 = __webpack_require__(1998);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);

var Root = function (_React$Component) {
    _inherits(Root, _React$Component);

    function Root(props) {
        _classCallCheck(this, Root);

        var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

        _this.store = redux_1.configureStore(RouteConfig_1.default);
        return _this;
    }

    _createClass(Root, [{
        key: "render",
        value: function render() {
            return React.createElement(react_redux_1.Provider, { store: this.store }, React.createElement(router_1.default, { matchContext: { store: this.store }, resolver: new found_relay_1.Resolver(relay_1.environment) }));
        }
    }]);

    return Root;
}(React.Component);

exports.default = Root;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./root.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./root.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}\n/*! sanitize.css v5.0.0 | CC0 License | github.com/jonathantneal/sanitize.css */*,:after,:before{background-repeat:no-repeat;-webkit-box-sizing:inherit;box-sizing:inherit}:after,:before{text-decoration:inherit;vertical-align:inherit}html{-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}article,aside,footer,header,nav,section{display:block}body{margin:0}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}nav ol,nav ul{list-style:none}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}::selection{background-color:#b3d4fc;color:#000;text-shadow:none}audio,canvas,iframe,img,svg,video{vertical-align:middle}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg{fill:currentColor}svg:not(:root){overflow:hidden}table{border-collapse:collapse}button,input,optgroup,select,textarea{margin:0}button,input,select,textarea{background-color:transparent;color:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto;resize:vertical}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[tabindex],a,area,button,input,label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}[hidden]{display:none}[aria-busy=true]{cursor:progress}[aria-controls]{cursor:pointer}[aria-hidden=false][hidden]:not(:focus){clip:rect(0,0,0,0);display:inherit;position:absolute}[aria-disabled]{cursor:default}.bgsize--small{border-radius:2px}.bgsize--medium{border-radius:4px}.bgsize--large{border-radius:8px}.bgsize--xlarge{border-radius:16px}.bgsize--circle{border-radius:50%}.color-scheme--transparent{background:none;border:1px solid;border-color:transparent;color:#101015}.color-scheme--white{background-color:#fff;border:1px solid;border-color:#fff;color:#101015}.color-scheme--white:hover{background-color:#101015;color:#fff}.color-scheme--white:active{background-color:#313140;color:#fff}.color-scheme--white.is-active{background-color:#101015;color:#fff}.color-scheme--black-outline{background-color:transparent;border:1px solid;border-color:#101015;color:#101015}.color-scheme--black-outline:hover{background-color:#101015;color:#fff}.color-scheme--black-outline:active{background-color:#313140;color:#fff}.color-scheme--black-outline.is-active{background-color:#101015;color:#fff}.color-scheme--light{background-color:#f0f6fa;border:1px solid;border-color:#f0f6fa;color:#101015}.color-scheme--light.is-active,.color-scheme--light:active,.color-scheme--light:hover{background-color:#e4e8ed}.color-scheme--accent{background-color:#4487ff;border:1px solid;border-color:#4487ff;color:#fff}.color-scheme--accent:hover{background-color:#377fff}.color-scheme--accent:active{background-color:#518fff}.color-scheme--accent2{background-color:#735aff;border:1px solid;border-color:#735aff;color:#fff}.color-scheme--accent2:hover{background-color:#684dff}.color-scheme--accent2:active{background-color:#7e67ff}.color-scheme--dark{background-color:#101015;border:1px solid;border-color:#101015;color:#fff}.color-scheme--dark:hover{background-color:#313140}.color-scheme--dark:active{background-color:#4487ff;border-color:#4487ff}.color-scheme--dangerous{color:#f75b5b}.color-scheme--positive{background-color:#75dbbe;border:1px solid;border-color:#75dbbe;color:#fff}.color-scheme--disabled{background-color:#f9fafb;border:1px solid;border-color:#e4e8ed;color:#b1b8c4}.color--black,.color--bw8,.color--dark{color:#101015}.color--bw7{color:#8a8f99}.color--bw6{color:#b1b8c4}.color--bw5{color:#d2d9e1}.color--bw4{color:#e4e8ed}.color--bw3{color:#f0f6fa}.color--bw2{color:#f9fafb}.color--bw1,.color--white{color:#fff}.color--accent{color:#4487ff}.color--accent-subtle{color:#f5faff}.color--accent-subtle2{color:#f0f6fa}.color--accent2{color:#735aff}.color--dangerous{color:#f75b5b}.color--dangerous-subtle{color:#fff5f5}.color--positive{color:#75dbbe}.color--positive-subtle{color:#e8faf5}.color--default{color:#101015}.color--none,.color--transparent{color:transparent}.bgcolor--black,.bgcolor--bw8,.bgcolor--dark{background-color:#101015}.bgcolor--bw7{background-color:#8a8f99}.bgcolor--bw6{background-color:#b1b8c4}.bgcolor--bw5{background-color:#d2d9e1}.bgcolor--bw4{background-color:#e4e8ed}.bgcolor--bw3{background-color:#f0f6fa}.bgcolor--bw2{background-color:#f9fafb}.bgcolor--bw1,.bgcolor--white{background-color:#fff}.bgcolor--accent{background-color:#4487ff}.bgcolor--accent-subtle{background-color:#f5faff}.bgcolor--accent-subtle2{background-color:#f0f6fa}.bgcolor--accent2{background-color:#735aff}.bgcolor--dangerous{background-color:#f75b5b}.bgcolor--dangerous-subtle{background-color:#fff5f5}.bgcolor--positive{background-color:#75dbbe}.bgcolor--positive-subtle{background-color:#e8faf5}.bgcolor--default{background-color:#101015}.bgcolor--none,.bgcolor--transparent{background-color:transparent}hr{height:1px;border:0;margin:0;background-color:#e4e8ed}.input-color-scheme--light .input__background{background-color:#f9fafb;border:1px solid #d2d9e1}.input-color-scheme--light.input--is-disabled{color:#b1b8c4}.input-color-scheme--light.input--is-disabled .input__background{background-color:#fff;border-color:#e4e8ed}.input-color-scheme--white .input__background{border-radius:2px;background-color:#fff;border:1px solid #e4e8ed}.input-color-scheme--white.input--is-disabled{color:#b1b8c4}.input-color-scheme--white.input--is-disabled .input__background{background-color:#f9fafb;border-color:#e4e8ed}.input-color-scheme--white.input--is-focus .input__background{border-color:#4487ff}.input+.input{margin-top:16px}html{-webkit-tap-highlight-color:rgba(0,0,0,0)}html,html *,html :after,html :before{position:relative}html{background-color:#f0f6fa}body,html{height:100%}body{width:100%;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-font-variant-ligatures:none;font-variant-ligatures:none;color:#101015;overflow-x:hidden}@media print{body{height:auto;overflow:visible}}nav ul{margin:0;padding:0}th{font-weight:400}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/sanitize.css/sanitize.css","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/components/atoms/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_color-scheme.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/components/atoms/_color-schemes.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/components/atoms/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/components/atoms/_hr.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/components/atoms/_input.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/styles/root.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA;AClDxE,gFAAgF,iBAa/E,4BAA4B,2BAC5B,kBAAmB,CACnB,eASA,wBAAwB,sBACD,CACvB,KASA,8BAAA,sBAAsB,eACP,0BACW,6BACI,CAC9B,wCAeA,aAAc,CACd,KAOA,QAAS,CACT,GAQA,cAAc,cACC,CACf,uBAaA,aAAc,CACd,OAOA,eAAgB,CAChB,GAQA,+BAAA,uBAAuB,SACd,gBACQ,CACjB,cAQA,eAAgB,CAChB,IAQA,gCAAiC,aACnB,CACd,EAWA,6BAA6B,oCACQ,CACrC,YAQA,mBAAmB,0BACO,yCAC1B,gCAAiC,CACjC,SAQA,oBAAoB,kBASD,CARnB,cAmBA,gCAAiC,aACnB,CACd,IAOA,iBAAkB,CAClB,KAOA,sBAAyB,UACX,CACd,MAOA,aAAc,CACd,QASA,cAAc,cACA,kBACI,uBACM,CACxB,IAGA,aAAc,CACd,IAGA,SAAU,CACV,YAcA,yBAAyB,WACX,gBACG,CACjB,kCAeA,qBAAsB,CACtB,YAQA,oBAAqB,CACrB,sBAOA,aAAa,QACJ,CACT,IAOA,iBAAkB,CAClB,IAOA,iBAAkB,CAClB,eAOA,eAAgB,CAChB,MAUA,wBAAyB,CACzB,sCAcA,QAAS,CACT,6BAUA,6BAA6B,cACf,kBACI,mBACE,CACpB,aASA,gBAAiB,CACjB,cASA,mBAAoB,CACpB,qDAYA,yBAA0B,CAC1B,wHAUA,kBAAkB,SACR,CACV,4GAUA,6BAA8B,CAC9B,OAUA,8BAAA,sBAAsB,cACR,cACA,eACC,UACL,kBACS,CACnB,SAQA,qBAAqB,uBACG,CACxB,SAQA,cAAc,eACE,CAChB,6BASA,8BAAA,sBAAsB,SACZ,CACV,kFAQA,WAAY,CACZ,cAQA,6BAA6B,mBACT,CACpB,qFAQA,uBAAwB,CACxB,6BAQA,0BAA0B,YACb,CACb,aAYA,aAAc,CACd,QAOA,iBAAkB,CAClB,OAUA,oBAAqB,CACrB,SAOA,YAAa,CACb,6DAmBA,8BAA8B,yBACJ,CAC1B,SAOA,YAAa,CACb,iBAUA,eAAgB,CAChB,gBAOA,cAAe,CACf,wCAOA,mBAAsB,gBACN,iBACE,CAClB,gBAQA,cAAe,CACf,eC3iBK,iBA1BgB,CCDlB,gBD2BE,iBAvBgB,CCJlB,eD2BE,iBApBgB,CCPlB,gBD2BE,kBAjBiB,CCVnB,gBD2BE,iBAdgB,CCb4C,2BC0I5D,gBA1Ic,iBACC,yBA8Hb,aCjIkB,CCExB,qBF+HM,sBAWF,iBAnIe,kBAwHb,aCjIkB,CCIvB,2BF6HK,yBAAA,UCnGM,CDsGR,4BALE,yBAV4D,UCvFtD,CDwGP,+BALC,yBAAA,UCnGM,CC5BZ,6BF+HM,6BAWF,iBAjHe,qBAsGb,aCjIkB,CCIvB,mCF6HK,yBAAA,UCnGM,CDsGR,oCALE,yBAV4D,UCvFtD,CDwGP,uCALC,yBAAA,UCnGM,CC5BZ,qBF+HM,yBAWF,iBA/Fe,qBAoFb,aCjIkB,CCIvB,sFF6HK,wBC1HmB,CCLzB,sBF+HM,yBAWF,iBAhFe,qBAqEb,UCnGM,CC1BX,4BF2HK,wBAR2D,CAa7D,6BALE,wBAV4D,CEnHlE,uBF+HM,yBAWF,iBApEe,qBAyDb,UCnGM,CC1BX,6BF2HK,wBAR2D,CAa7D,8BALE,wBAV4D,CEnHlE,oBF+HM,yBAWF,iBAxDe,qBA6Cb,UCnGM,CC1BX,0BF2HK,wBAV4D,CAe9D,2BAHE,yBAAA,oBCvHmB,CCRzB,yBF+HM,aCpHkB,CCXxB,wBF+HM,yBAWF,iBArCe,qBA0Bb,UCnGM,CC5BZ,wBF+HM,yBAWF,iBA/Be,qBAoBb,aC5HmB,CCDxB,uCCAc,aFJS,CEItB,YAAa,aFFO,CEEpB,YAAa,aFCU,CEDvB,YAAa,aFEM,CEFnB,YAAa,aFGU,CEHvB,YAAa,aFQU,CERvB,YAAa,aFKS,CELtB,0BAAa,UF0BH,CE1BV,eAAa,aFMU,CENvB,sBAAa,aFOS,CEPtB,uBAAa,aFQU,CERvB,gBAAa,aFae,CEb5B,kBAAa,aFSS,CETtB,yBAAa,aFUO,CEVpB,iBAAa,aFWO,CEXpB,wBAAa,aFYK,CEZlB,gBAAa,aFJS,CEItB,iCAAa,iBFqCE,CErCf,6CAAa,wBFJS,CEItB,cAAa,wBFFO,CEEpB,cAAa,wBFCU,CEDvB,cAAa,wBFEM,CEFnB,cAAa,wBFGU,CEHvB,cAAa,wBFQU,CERvB,cAAa,wBFKS,CELtB,8BAAa,qBF0BH,CE1BV,iBAAa,wBFMU,CENvB,wBAAa,wBFOS,CEPtB,yBAAa,wBFQU,CERvB,kBAAa,wBFae,CEb5B,oBAAa,wBFSS,CETtB,2BAAa,wBFUO,CEVpB,mBAAa,wBFWO,CEXpB,0BAAa,wBFYK,CEZlB,kBAAa,wBFJS,CEItB,qCAAa,4BFqCE,CErCqB,GCDtC,WAAW,SACF,SACA,wBHEgB,CGA1B,8CH8DG,yBA5DsB,wBAHH,CILpB,8CJ4EC,aAxEuB,CIJxB,iEJoEC,sBAvCU,oBAvBa,CIIpB,8CPkBD,kBA1BgB,sBG2BR,wBAvBa,CIOxB,8CJ+DC,aAxEuB,CISxB,iEJuDC,yBA5DsB,oBAFC,CIOxB,8DAeK,oBJnBmB,CIoBpB,cAML,eCL+C,CDMhD,KE8EC,yCAA6C,CAR/C,qCAKE,iBAAkB,CACjB,KN5CC,wBAzDuB,CM6G1B,UADC,WAAY,CAGd,KAEE,WAAW,mEAEZ,oCAAA,4BAA4B,cN/HH,iBMiIN,CAElB,aARF,KASI,YAAY,gBACK,CAEpB,CAAA,OAGA,SAAS,SACC,CACV,GAGC,eAAmB,CACpB","file":"root.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/*! sanitize.css v5.0.0 | CC0 License | github.com/jonathantneal/sanitize.css */\n\n/* Document (https://html.spec.whatwg.org/multipage/semantics.html#semantics)\n   ========================================================================== */\n\n/**\n * 1. Remove repeating backgrounds in all browsers (opinionated).\n * 2. Add box sizing inheritence in all browsers (opinionated).\n */\n\n*,\n::before,\n::after {\n\tbackground-repeat: no-repeat; /* 1 */\n\tbox-sizing: inherit; /* 2 */\n}\n\n/**\n * 1. Add text decoration inheritance in all browsers (opinionated).\n * 2. Add vertical alignment inheritence in all browsers (opinionated).\n */\n\n::before,\n::after {\n\ttext-decoration: inherit; /* 1 */\n\tvertical-align: inherit; /* 2 */\n}\n\n/**\n * 1. Add border box sizing in all browsers (opinionated).\n * 2. Add the default cursor in all browsers (opinionated).\n * 3. Prevent font size adjustments after orientation changes in IE and iOS.\n */\n\nhtml {\n\tbox-sizing: border-box; /* 1 */\n\tcursor: default; /* 2 */\n\t-ms-text-size-adjust: 100%; /* 3 */\n\t-webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/* Sections (https://html.spec.whatwg.org/multipage/semantics.html#sections)\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n\tdisplay: block;\n}\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n\tmargin: 0;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n\tfont-size: 2em;\n\tmargin: .67em 0;\n}\n\n/* Grouping content (https://html.spec.whatwg.org/multipage/semantics.html#grouping-content)\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n\tdisplay: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n\tmargin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n\tbox-sizing: content-box; /* 1 */\n\theight: 0; /* 1 */\n\toverflow: visible; /* 2 */\n}\n\n/**\n * Remove the list style on navigation lists in all browsers (opinionated).\n */\n\nnav ol,\nnav ul {\n\tlist-style: none;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n\tfont-family: monospace, monospace; /* 1 */\n\tfont-size: 1em; /* 2 */\n}\n\n/* Text-level semantics (https://html.spec.whatwg.org/multipage/semantics.html#text-level-semantics)\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n\tbackground-color: transparent; /* 1 */\n\t-webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n\tborder-bottom: none; /* 1 */\n\ttext-decoration: underline; /* 2 */\n\ttext-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n\tfont-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n\tfont-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n\tfont-family: monospace, monospace; /* 1 */\n\tfont-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n\tfont-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n\tbackground-color: #ffff00;\n\tcolor: #000000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n\tfont-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n\tvertical-align: baseline;\n}\n\nsub {\n\tbottom: -.25em;\n}\n\nsup {\n\ttop: -.5em;\n}\n\n/*\n * Remove the text shadow on text selections (opinionated).\n * 1. Restore the coloring undone by defining the text shadow (opinionated).\n */\n\n::-moz-selection {\n\tbackground-color: #b3d4fc; /* 1 */\n\tcolor: #000000; /* 1 */\n\ttext-shadow: none;\n}\n\n::selection {\n\tbackground-color: #b3d4fc; /* 1 */\n\tcolor: #000000; /* 1 */\n\ttext-shadow: none;\n}\n\n/* Embedded content (https://html.spec.whatwg.org/multipage/embedded-content.html#embedded-content)\n   ========================================================================== */\n\n/*\n * Change the alignment on media elements in all browers (opinionated).\n */\n\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n\tvertical-align: middle;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n\tdisplay: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n\tdisplay: none;\n\theight: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n\tborder-style: none;\n}\n\n/**\n * Change the fill color to match the text color in all browsers (opinionated).\n */\n\nsvg {\n\tfill: currentColor;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n\toverflow: hidden;\n}\n\n/* Tabular data (https://html.spec.whatwg.org/multipage/tables.html#tables)\n   ========================================================================== */\n\n/**\n * Collapse border spacing\n */\n\ntable {\n\tborder-collapse: collapse;\n}\n\n/* Forms (https://html.spec.whatwg.org/multipage/forms.html#forms)\n   ========================================================================== */\n\n/**\n * Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n\tmargin: 0;\n}\n\n/**\n * Inherit styling in all browsers (opinionated).\n */\n\nbutton,\ninput,\nselect,\ntextarea {\n\tbackground-color: transparent;\n\tcolor: inherit;\n\tfont-size: inherit;\n\tline-height: inherit;\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n\toverflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n\ttext-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n\t-webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n\tborder-style: none;\n\tpadding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n\toutline: 1px dotted ButtonText;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n\tbox-sizing: border-box; /* 1 */\n\tcolor: inherit; /* 2 */\n\tdisplay: table; /* 1 */\n\tmax-width: 100%; /* 1 */\n\tpadding: 0; /* 3 */\n\twhite-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n\tdisplay: inline-block; /* 1 */\n\tvertical-align: baseline; /* 2 */\n}\n\n/**\n * 1. Remove the default vertical scrollbar in IE.\n * 2. Change the resize direction on textareas in all browsers (opinionated).\n */\n\ntextarea {\n\toverflow: auto; /* 1 */\n\tresize: vertical; /* 2 */\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n\tbox-sizing: border-box; /* 1 */\n\tpadding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n\theight: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n\t-webkit-appearance: textfield; /* 1 */\n\toutline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n\t-webkit-appearance: button; /* 1 */\n\tfont: inherit; /* 2 */\n}\n\n/* Interactive elements (https://html.spec.whatwg.org/multipage/forms.html#interactive-elements)\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n\tdisplay: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n\tdisplay: list-item;\n}\n\n/* Scripting (https://html.spec.whatwg.org/multipage/scripting.html#scripting-3)\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n\tdisplay: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n\tdisplay: none;\n}\n\n/* User interaction (https://html.spec.whatwg.org/multipage/interaction.html#editing)\n   ========================================================================== */\n\n/*\n * Remove the tapping delay on clickable elements (opinionated).\n * 1. Remove the tapping delay in IE 10.\n */\n\na,\narea,\nbutton,\ninput,\nlabel,\nselect,\nsummary,\ntextarea,\n[tabindex] {\n\t-ms-touch-action: manipulation; /* 1 */\n\ttouch-action: manipulation;\n}\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n\tdisplay: none;\n}\n\n/* ARIA (https://w3c.github.io/html-aria/)\n   ========================================================================== */\n\n/**\n * Change the cursor on busy elements (opinionated).\n */\n\n[aria-busy=\"true\"] {\n\tcursor: progress;\n}\n\n/*\n * Change the cursor on control elements (opinionated).\n */\n\n[aria-controls] {\n\tcursor: pointer;\n}\n\n/*\n * Change the display on visually hidden accessible elements (opinionated).\n */\n\n[aria-hidden=\"false\"][hidden]:not(:focus) {\n\tclip: rect(0, 0, 0, 0);\n\tdisplay: inherit;\n\tposition: absolute;\n}\n\n/*\n * Change the cursor on disabled, not-editable, or otherwise\n * inoperable elements (opinionated).\n */\n\n[aria-disabled] {\n\tcursor: default;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Background Shape Classes\n */\n\n.bgsize{\n  @each $background-size, $attributes in $background-sizes {\n    &--#{$background-size} {  @include bgsize($background-size) }\n  }\n}\n","/**\n * Color Scheme\n */\n\n$color-schemes: (\n  transparent: (\n    background: none,\n    border: 1px solid,\n    border-color: transparent,\n    color: black,\n  ),\n  white: (\n    background-color: white,\n    border: 1px solid,\n    border-color: white,\n    color: black,\n    hover: (\n      background-color: black,\n      color: white,\n    ),\n    active: (\n      background-color: lighten black 15%,\n      color: white,\n    ),\n    is-active: (\n      background-color: black,\n      color: white,\n    ),\n  ),\n  black-outline: (\n    background-color: transparent,\n    border: 1px solid,\n    border-color: black,\n    color: black,\n    hover: (\n      background-color: black,\n      color: white,\n    ),\n    active: (\n      background-color: lighten black 15%,\n      color: white,\n    ),\n    is-active: (\n      background-color: black,\n      color: white,\n    ),\n  ),\n  light: (\n    background-color: bw3,\n    border: 1px solid,\n    border-color: bw3,\n    color: black,\n    hover: (\n      background-color: bw4,\n    ),\n    active: (\n      background-color: bw4,\n    ),\n    is-active: (\n      background-color: bw4,\n    ),\n  ),\n  accent: (\n    background-color: accent,\n    border: 1px solid,\n    border-color: accent,\n    color: white,\n    hover: (\n      background-color: darken accent 2.5%,\n    ),\n    active: (\n      background-color: lighten accent 2.5%,\n    ),\n  ),\n  accent2: (\n    background-color: accent2,\n    border: 1px solid,\n    border-color: accent2,\n    color: white,\n    hover: (\n      background-color: darken accent2 2.5%,\n    ),\n    active: (\n      background-color: lighten accent2 2.5%,\n    ),\n  ),\n  dark: (\n    background-color: black,\n    border: 1px solid,\n    border-color: black,\n    color: white,\n    hover: (\n      background-color: lighten black 15%,\n    ),\n    active: (\n      background-color: accent,\n      border-color: accent,\n    ),\n  ),\n  dangerous: (\n    // background-color: transparent,\n    // border: 1px solid,\n    // border-color: transparent,\n    color: dangerous,\n  ),\n  positive: (\n    background-color: positive,\n    border: 1px solid,\n    border-color: positive,\n    color: white,\n  ),\n  disabled: (\n    background-color: bw2,\n    border: 1px solid,\n    border-color: bw4,\n    color: bw6,\n  ),\n);\n\n@function color-transform($attributes) {\n  @if nth($attributes, 1) == lighten {\n    @return lighten(color(nth($attributes, 2)), nth($attributes, 3));\n  } @else if nth($attributes, 1) == darken {\n    @return darken(color(nth($attributes, 2)), nth($attributes, 3));\n  }\n}\n\n@mixin render-attributes($attributes) {\n  @each $key,$value in $attributes {\n    @if index((color, background-color, border-color), $key) {\n      @if type-of($value) == list {\n        #{$key}: color-transform($value);\n      } @else {\n        #{$key}: color($value);\n      }\n    } @else if (index((hover, active), $key)) {\n      &:#{$key} {\n        @include render-attributes($value);\n      }\n    } @else if (index((is-active), $key)) {\n      &.#{$key} {\n        @include render-attributes($value);\n      }\n    } @else {\n      #{$key}: $value;\n    }\n  }\n}\n\n@mixin color-scheme($color-scheme) {\n  @if map-has-key($color-schemes, $color-scheme) {\n    $attributes: map-get($color-schemes, $color-scheme);\n    @include render-attributes($attributes);\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Color Scheme Classes\n * (See config/color-scheme for definition)\n */\n\n@each $color-scheme,$attributes in $color-schemes {\n  .color-scheme--#{$color-scheme} {\n    @include color-scheme($color-scheme);\n  }\n}\n","/**\n * Color Classes\n * (See config/colors for color definition)\n */\n\n@each $class,$attribute in (color: color, bgcolor: background-color){\n  .#{$class} {\n  @each $key,$val in $colors{\n    &--#{$key} { #{$attribute}: $val; }\n  }\n  }\n}\n","/**\n * HR Component\n */\n\n$context: \"hr\";\n\n#{$context}{\n  height: 1px;\n  border: 0;\n  margin: 0;\n  background-color: uicolor(border);\n}\n","/**\n * Input Classes\n */\n\n.input-color-scheme{\n  &--light{\n    .input__background{\n      @include bgcolor(bw2);\n      border: 1px solid color(bw5);\n    }\n    &.input--is-disabled{\n      @include textcolor(bw6);\n      .input__background{\n        @include bgcolor(white);\n        border-color: uicolor(border);\n      }\n    }\n  }\n  &--white{\n    .input__background {\n      @include bgsize(small);\n      @include bgcolor(white);\n      border: 1px solid color(bw4);\n    }\n    &.input--is-disabled {\n      @include textcolor(bw6);\n      .input__background{\n        @include bgcolor(bw2);\n        border-color: uicolor(border);\n      }\n    }\n    &.input--is-focus {\n      .input__background{\n        border-color: color(accent);\n      }\n    }\n  }\n}\n\n.input + .input {\n  margin-top: baseline(2);\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Root Styles\n **/\n\n@import \"sanitize\";\n@import \"components/all\";\n\nhtml {\n  &,\n  *,\n\t*::before,\n\t*::after {\n\t\tposition: relative;\n  }\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhtml{\n  @include bgcolor(bw3);\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  width: 100%;\n\tfont-family: $font--default;\n\tfont-variant-ligatures: none;\n  color: color(dark);\n  overflow-x: hidden;\n\n  @media print{\n    height: auto;\n    overflow: visible;\n  }\n}\n\nnav ul {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nth{\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Redux Configuration
 */
/* tslint:disable:no-string-literal */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PreferencesActions = __webpack_require__(347);
var reducers_1 = __webpack_require__(958);
var sagas_1 = __webpack_require__(1774);
var farce_1 = __webpack_require__(306);
var found = __webpack_require__(32);
var redux_1 = __webpack_require__(145);
var redux_saga_1 = __webpack_require__(73);
var redux_thunk_1 = __webpack_require__(1814);
var fbq_1 = __webpack_require__(495);
var gtm_1 = __webpack_require__(349);
var transitionHook_1 = __webpack_require__(1815);
var anyFound = found;
exports.configureStore = function (routeConfig) {
    var saga = redux_saga_1.default();
    var store = redux_1.createStore(reducers_1.default, window['__REDUX_DEVTOOLS_EXTENSION__'] && window['__REDUX_DEVTOOLS_EXTENSION__']( true ? {
        actionsBlacklist: ['Authentication', 'LocalStorage', 'Player/UPDATE_CURRENT_TRACK_ELAPSED_TIME'],
        stateSanitizer: function stateSanitizer(_a) {
            var authentication = _a.authentication,
                postAuthenticationRequests = _a.postAuthenticationRequests,
                staticData = _a.staticData,
                user = _a.user,
                _b = _a.user,
                stripeToken = _b.stripeToken,
                stateUserState = __rest(_b, ["stripeToken"]),
                safeState = __rest(_a, ["authentication", "postAuthenticationRequests", "staticData", "user", "user"]);

            return Object.assign({}, safeState, { user: stateUserState });
        }
    } : {}), redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default, saga, gtm_1.gtmMiddleware, fbq_1.fbqMiddleware), farce_1.createHistoryEnhancer({
        protocol: new farce_1.BrowserProtocol(),
        middlewares: [farce_1.queryMiddleware]
    }), anyFound.createMatchEnhancer(new anyFound.Matcher(routeConfig))));
    saga.run(sagas_1.default);
    store.dispatch(farce_1.Actions.init());
    store.dispatch(PreferencesActions.requestSetPreferencesFromLocalStorage());
    store.farce.addTransitionHook(transitionHook_1.transitionHookCreator(store));
    // if (module.hot) {
    //   module.hot.accept('./reducers', () => {
    //     const nextRootReducer = require('./reducers').default;
    //     store.replaceReducer(nextRootReducer);
    //   });
    // }
    return store;
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var fbq_1 = __webpack_require__(495);
var gtm_1 = __webpack_require__(349);
var authentication_1 = __webpack_require__(1360);
var checkout_1 = __webpack_require__(1763);
var countries_1 = __webpack_require__(1764);
var license_1 = __webpack_require__(1765);
var notifications_1 = __webpack_require__(1766);
var player_1 = __webpack_require__(1767);
var postAuthenticationRequests_1 = __webpack_require__(1768);
var preferences_1 = __webpack_require__(1769);
var projects_1 = __webpack_require__(1770);
var staticData_1 = __webpack_require__(715);
var ui_1 = __webpack_require__(1771);
var user_1 = __webpack_require__(1772);
var found = __webpack_require__(32);
var redux_1 = __webpack_require__(145);
var redux_form_1 = __webpack_require__(37);
var anyFound = found;
exports.default = redux_1.combineReducers({
    authentication: authentication_1.default,
    checkout: checkout_1.default,
    countryList: countries_1.default,
    gtmMetaReducer: gtm_1.gtmMetaReducer,
    fbqMetaReducer: fbq_1.fbqMetaReducer,
    form: redux_form_1.reducer,
    found: anyFound.foundReducer,
    license: license_1.default,
    notifications: notifications_1.default,
    player: player_1.default,
    postAuthenticationRequests: postAuthenticationRequests_1.default,
    preferences: preferences_1.default,
    projects: projects_1.default,
    staticData: staticData_1.default,
    ui: ui_1.default,
    user: user_1.default
});

/***/ }),
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$accountEvent;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = __webpack_require__(50);
var types_1 = __webpack_require__(102);
var activecampaign_1 = __webpack_require__(499);
var trackAccountRegistration = function trackAccountRegistration(_ref) {
    var payload = _ref.payload;

    var profile = payload.result.updateProfile.profile;
    return {
        event: types_1.AccountEvent.NewAccount,
        category: types_1.EventCategory.Account,
        action: 'register-account',
        label: profile.user_id
    };
};
exports.accountEventsMap = (_exports$accountEvent = {}, _defineProperty(_exports$accountEvent, user_1.setUserProfile.type, activecampaign_1.acTrackVisitOnSetProfile), _defineProperty(_exports$accountEvent, user_1.trackNewUserRegistration.done.type, trackAccountRegistration), _exports$accountEvent);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = __webpack_require__(161);
var types_1 = __webpack_require__(102);
var trackSetBudgetEvent = function trackSetBudgetEvent(_ref) {
    var payload = _ref.payload;

    var budget = payload;
    return {
        event: types_1.FilterEvent.Budget,
        category: types_1.EventCategory.SetFilter,
        action: 'set-budget',
        label: budget.minimum + " - " + budget.maximum
    };
};
exports.budgetEventsMap = _defineProperty({}, analytics_1.trackSetBudget.type, trackSetBudgetEvent);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(968);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".icon svg{display:block}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/images/Icon/styles.scss"],"names":[],"mappings":"AA4GA,UAEI,aAAc,CAEf","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Icon Component\n */\n\n.icon{\n  svg{\n    display: block;\n    // height: 100%;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * License-related Icons
 */
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
function IconWrapper(_ref) {
    var children = _ref.children,
        className = _ref.className,
        id = _ref.id;

    var classes = new BEM('icon');
    return React.createElement("div", Object.assign({}, classes('', ['license', id], className)), children);
}
function IconLicenseAllMedia(_ref2) {
    var _ref2$className = _ref2.className,
        className = _ref2$className === undefined ? '' : _ref2$className;

    return React.createElement(IconWrapper, { id: "all-media", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M14.204 40.883l-3.45-3.421 5.69-5.64 3.45 3.42-5.69 5.64zm2.75-10.589l4.478 4.438c.28.272.288.72.016 1.001l-.016.016-6.716 6.662c-.137.134-.32.21-.512.21-.193.001-.379-.075-.516-.21l-4.473-4.443c-.28-.272-.288-.72-.016-1l.016-.017 6.712-6.657c.285-.28.742-.28 1.027 0zm23.52-4.748c.458 4.017-.957 8.02-3.835 10.86-2.515 2.494-5.915 3.891-9.457 3.885-.502.001-1.003-.025-1.503-.08-.397-.043-.683-.399-.641-.796.04-.393.392-.678.785-.638l.016.002c3.604.405 7.196-.844 9.772-3.396 2.57-2.527 3.832-6.096 3.421-9.676-.043-.397.243-.753.638-.797h.003c.39-.052.747.22.799.61l.003.026zm-2.769-14.815l3.451 3.42-5.69 5.645-3.446-3.42 5.685-5.645zm-2.75 10.593l-4.478-4.438c-.28-.283-.28-.739 0-1.022l6.717-6.661c.289-.27.738-.27 1.027 0l4.473 4.443c.28.274.286.724.011 1.005l-.011.011-6.712 6.662c-.137.136-.323.211-.516.21-.191 0-.375-.075-.51-.21zM26.15 34.07c2.24.324 4.501-.423 6.105-2.018 1.603-1.593 2.354-3.851 2.024-6.086-.06-.397.214-.767.61-.827.398-.06.768.215.828.611.684 4.697-2.567 9.058-7.263 9.743-.418.06-.84.09-1.262.09-.417.001-.834-.028-1.247-.085-.396-.048-.677-.408-.63-.804.049-.395.408-.676.804-.629l.031.005zm18.883-10.193c1.023 5.791-.86 11.716-5.04 15.853-3.42 3.379-8.034 5.272-12.841 5.269-1 0-1.999-.082-2.985-.245-.393-.067-.658-.439-.591-.832.066-.393.438-.658.83-.59 5.314.883 10.728-.835 14.562-4.619 3.844-3.807 5.575-9.257 4.633-14.585-.062-.397.21-.77.607-.83.386-.06.75.196.825.58zm-22.965 6.988c-2.022-2.52-1.812-6.16.486-8.43 2.307-2.28 5.95-2.486 8.5-.481l-2.225 2.206-.004.003-.012.011-.002.004-6.743 6.687zm6.744-2.058c-.818.732-1.986.8-2.879.264l3.352-3.324c.582.983.41 2.27-.473 3.06zm-1.575 2.007c1.001.012 1.966-.374 2.685-1.071 1.333-1.388 1.459-3.495.397-5.02l2.307-2.288c.28-.283.28-.74 0-1.022-3.079-3.036-8.025-3.036-11.104 0l-.039.039c-3.018 3.04-3 7.951.039 10.97.139.134.323.21.516.21s.378-.075.516-.21l2.348-2.329c.683.468 1.496.723 2.335.721z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseAllMedia = IconLicenseAllMedia;
function IconLicenseCaseStudy(_ref3) {
    var _ref3$className = _ref3.className,
        className = _ref3$className === undefined ? '' : _ref3$className;

    return React.createElement(IconWrapper, { id: "case-study", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M14.44 43.56V10.44h15.1v8.301c.002.396.325.715.72.714h8.3V43.56H14.44zm16.54-32.101l6.56 6.556h-6.56v-6.556zM40 18.735c0-.095-.02-.186-.053-.269l-.003-.009c-.035-.084-.086-.158-.148-.223-.002-.002-.003-.007-.006-.009L30.77 9.21c-.014-.015-.034-.02-.049-.033-.041-.034-.087-.065-.136-.09-.037-.018-.073-.032-.112-.045-.047-.014-.097-.024-.148-.029-.022-.002-.042-.013-.065-.013H13.72c-.397.002-.718.323-.72.72v34.56c.002.396.323.718.72.72h25.56c.397-.002.718-.324.72-.72V18.735zM21.96 35.47V23.04l9.945 6.215-9.945 6.215zm11.685-6.825L21.62 21.13c-.222-.139-.501-.146-.73-.02-.23.127-.373.368-.375.63v15.025c0 .263.143.505.375.63.107.06.227.09.35.09.134 0 .265-.036.38-.105l12.025-7.515c.095-.058.174-.138.233-.233.209-.337.104-.779-.233-.987z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseCaseStudy = IconLicenseCaseStudy;
function IconLicenseRadio(_ref4) {
    var _ref4$className = _ref4.className,
        className = _ref4$className === undefined ? '' : _ref4$className;

    return React.createElement(IconWrapper, { id: "radio", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M21.033 27.254c.013.389.332.696.72.696h.024c.399-.015.71-.35.696-.748l-.01-.202c0-2.506 2.03-4.537 4.536-4.538 2.505 0 4.537 2.029 4.537 4.535v.094l-.005.11c-.014.374.278.687.651.7l.03.001c.403-.004.734-.318.759-.72.005-.058.01-.12.01-.182 0-3.302-2.677-5.978-5.98-5.978-3.301 0-5.977 2.676-5.977 5.978 0 .062.01.254.01.254zM27 15.01C20.38 15.018 15.018 20.38 15.01 27c-.004 2.504.784 4.944 2.25 6.974.216.334.662.43.996.214.334-.215.43-.661.214-.995l-.038-.054c-3.4-4.732-2.32-11.324 2.411-14.724 4.732-3.4 11.325-2.32 14.725 2.411 2.643 3.679 2.643 8.634 0 12.313-.231.322-.157.77.164 1.001l.004.002c.321.231.77.158 1-.164l.003-.004c1.466-2.03 2.254-4.47 2.25-6.974-.008-6.619-5.371-11.982-11.99-11.99zM27 9C17.06 8.998 9 17.054 9 26.993c-.001 4.639 1.789 9.098 4.996 12.449.267.294.723.317 1.017.05.295-.267.318-.722.051-1.017-.008-.01-.017-.018-.026-.027-6.325-6.606-6.097-17.089.51-23.414 6.605-6.325 17.088-6.097 23.413.51 6.132 6.403 6.132 16.5 0 22.904-.274.288-.263.743.024 1.017.133.128.31.199.495.197.197.002.386-.078.523-.22 6.873-7.18 6.625-18.572-.555-25.446C36.098 10.79 31.638 9 27 9zm1.3 30.274l2.18-1.455 2.174 4.359-4.354-2.904zm-1.296.868l5.132 3.418H21.892l5.112-3.418zm-1.296-.868l-4.377 2.928 2.193-4.383 2.184 1.455zm3.476-4.042l.643 1.291-2.823 1.886-2.832-1.89.644-1.287h4.368zM27 30.864l1.464 2.928h-2.928L27 30.864zm.72-1.78v-2.838c0-.398-.323-.72-.72-.72-.398 0-.72.322-.72.72v2.837l-7.436 14.875c-.113.223-.102.489.03.701.132.211.364.34.614.341h15.024c.25-.001.481-.13.614-.34.131-.213.142-.479.029-.702L27.72 29.083z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseRadio = IconLicenseRadio;
function IconLicenseShowReel(_ref5) {
    var _ref5$className = _ref5.className,
        className = _ref5$className === undefined ? '' : _ref5$className;

    return React.createElement(IconWrapper, { id: "show-reel", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M14.445 34.545h25.61V14.95h-25.61v19.595zM11.44 13.51h31.62v-3.07H11.44v3.07zm17.345 28.515c0 .848-.688 1.535-1.535 1.535-.848 0-1.535-.688-1.535-1.535 0-.848.688-1.535 1.535-1.535.846.002 1.533.688 1.535 1.535zM43.78 14.95c.396-.002.718-.323.72-.72V9.72c-.002-.397-.324-.718-.72-.72H10.72c-.397.002-.718.323-.72.72v4.51c.002.397.323.718.72.72h2.285v19.595H10.75c-.398 0-.72.322-.72.72 0 .398.322.72.72.72h15.78v3.157c-1.295.322-2.255 1.489-2.255 2.883 0 1.643 1.332 2.975 2.975 2.975 1.642-.002 2.973-1.333 2.975-2.975 0-1.394-.96-2.561-2.255-2.883v-3.157h15.78c.398 0 .72-.322.72-.72 0-.398-.322-.72-.72-.72h-2.255V14.95h2.285zm-16.53 3.005c-3.752.001-6.792 3.044-6.79 6.795.001 3.752 3.043 6.792 6.795 6.79 3.751-.001 6.791-3.043 6.79-6.795-.006-3.75-3.046-6.787-6.795-6.79zm0 15.025c-4.547-.001-8.232-3.688-8.23-8.235.001-4.547 3.688-8.231 8.235-8.23 4.545.002 8.228 3.685 8.23 8.23-.006 4.546-3.689 8.23-8.235 8.235zm-.78-10.27l2.935 2.035-2.935 2.04V22.71zm-.72 6.17c.146-.002.29-.047.41-.13l4.915-3.41c.194-.136.31-.358.31-.595 0-.236-.116-.456-.31-.59L26.16 20.74c-.12-.083-.262-.127-.407-.128-.398-.001-.722.32-.723.718v6.843c.003.394.326.711.72.707z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseShowReel = IconLicenseShowReel;
function IconLicenseTheatrical(_ref6) {
    var _ref6$className = _ref6.className,
        className = _ref6$className === undefined ? '' : _ref6$className;

    return React.createElement(IconWrapper, { id: "theatrical", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M26.06 31.36c-.398.001-.72-.32-.722-.718 0-.192.076-.376.212-.512l2.725-2.73c.28-.281.736-.281 1.017-.001.281.281.282.737.002 1.018-.002 0-.003.002-.004.003l-2.725 2.73c-.134.135-.316.21-.505.21zm-2.725-2.73c-.398.001-.721-.32-.722-.718 0-.192.076-.376.212-.512l2.725-2.73c.282-.279.738-.276 1.017.007.278.28.277.734-.002 1.013l-2.72 2.73c-.135.136-.319.211-.51.21zm-4.43-.72l7.155 7.166 7.15-7.165-7.15-7.166-7.155 7.166zm7.155 8.905c-.191 0-.375-.074-.51-.21l-8.17-8.185c-.28-.282-.28-.737 0-1.02l8.17-8.185c.284-.27.73-.27 1.015 0l8.17 8.185c.28.283.28.738 0 1.02l-8.17 8.185c-.134.135-.316.21-.505.21zM38.765 26.09l-.905.91.905.91.91-.91-.91-.91zm-1.815-1.82l-.905.91.905.91.91-.91-.91-.91zm-1.815-1.815l-.905.905.905.91.91-.91-.91-.905zm-1.815-1.82l-.905.91.905.91.91-.91-.91-.91zm-1.815-1.82l-.91.91.91.91.91-.91-.91-.91zm-1.815-1.82l-.91.91.91.91.905-.91-.905-.91zm-1.815-1.82l-.91.91.91.91.905-.91-.905-.91zm-7.65 24.97l3.11 3.115L43.2 23.36l-3.11-3.11c-2.047 1.482-4.908 1.024-6.39-1.024-1.16-1.603-1.158-3.77.005-5.371l-3.11-3.115-19.86 19.9 3.11 3.115c2.043-1.482 4.901-1.028 6.384 1.015 1.164 1.604 1.162 3.773-.004 5.375zM23.335 45c-.191 0-.374-.076-.51-.21l-4.08-4.095c-.28-.274-.286-.723-.012-1.003l.012-.012c1.212-1.239 1.19-3.226-.05-4.437-1.218-1.192-3.165-1.193-4.385-.002-.28.279-.735.279-1.015 0L9.21 31.15c-.28-.282-.28-.738 0-1.02L30.09 9.21c.133-.134.315-.21.505-.21.191-.001.375.075.51.21l4.085 4.095c.28.28.28.735 0 1.015-1.226 1.224-1.228 3.209-.005 4.435 1.223 1.226 3.209 1.229 4.435.005.28-.28.735-.28 1.015 0l4.085 4.095c.28.272.288.719.016.999l-.016.016-20.875 20.92c-.135.135-.319.21-.51.21z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseTheatrical = IconLicenseTheatrical;
function IconLicenseTVEditorial(_ref7) {
    var _ref7$className = _ref7.className,
        className = _ref7$className === undefined ? '' : _ref7$className;

    return React.createElement(IconWrapper, { id: "tv-editorial", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M27.805 28.99h3.825c.177-.002.348.063.48.18l2.515 2.225v-1.69c.003-.398.327-.718.725-.715h.93v-5.145h-8.475v5.145zm7.545 4.73c-.178-.001-.348-.067-.48-.185l-3.515-3.11h-4.27c-.399.002-.723-.32-.725-.718v-6.582c0-.398.325-.721.723-.72H37c.398-.002.723.32.725.718v6.582c-.001.399-.325.72-.723.72h-.932V33c0 .283-.167.54-.425.655-.093.043-.193.066-.295.064zm-14.875-4.115c-.096-.001-.191-.02-.28-.056-.27-.11-.445-.373-.445-.665v-2.57h-1.755c-.399.001-.723-.32-.725-.72V15.72c.001-.397.325-.72.723-.719h15.702c.398-.002.723.32.724.718v5.346c.004.4-.316.726-.715.73-.4.003-.726-.317-.729-.717v-4.638h-14.26v8.436h1.76c.397 0 .72.322.72.72v1.55l2.07-2.06c.137-.135.322-.21.514-.21h.826c.398 0 .72.322.72.72 0 .398-.322.72-.72.72h-.526l-3.095 3.08c-.136.133-.319.208-.509.21zM48.55 36.74c-.003.644-.526 1.164-1.17 1.164H7.614c-.644 0-1.167-.52-1.17-1.164V11.604c.003-.643.526-1.164 1.17-1.164h39.764c.645 0 1.168.52 1.17 1.165V36.74zm-23.17 6.82h4.235v-4.216H25.38v4.216zM47.38 9H7.614C6.175 9 5.005 10.165 5 11.604V36.74c.005 1.44 1.175 2.604 2.615 2.604h16.32v4.216H18.03c-.398 0-.72.322-.72.72 0 .398.322.72.72.72h18.934c.398 0 .721-.322.721-.72 0-.398-.323-.72-.72-.72H31.06v-4.216h16.32c1.44 0 2.609-1.164 2.615-2.604V11.604C49.989 10.165 48.82 9 47.38 9z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseTVEditorial = IconLicenseTVEditorial;
function IconLicenseTVWeb(_ref8) {
    var _ref8$className = _ref8.className,
        className = _ref8$className === undefined ? '' : _ref8$className;

    return React.createElement(IconWrapper, { id: "tv-web", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M37.655 40.31l4.08-1.835c.218-.099.315-.355.217-.574-.044-.096-.12-.173-.217-.216l-4.08-1.83c-.218-.098-.473-.002-.572.216-.025.056-.038.117-.038.179v3.665c.003.24.2.434.441.431.058 0 .116-.013.17-.036h-.001zm10.465-2.275c0-.132.108-.24.24-.24.131-.002.239.103.24.234v.006c0 .265-.48.265-.48 0zm.24-1.2c-.663 0-1.2.537-1.2 1.2 0 .663.538 1.2 1.2 1.2.663 0 1.2-.538 1.2-1.2.002-.66-.532-1.197-1.192-1.2h-.008zm-18.944-1.2v4.8c0 .398.322.72.719.72.398 0 .72-.322.72-.72v-4.8c0-.398-.322-.72-.72-.72-.398 0-.72.322-.72.72zm20.144 2.4v4.315c.002.661-.532 1.198-1.194 1.2h-1.2V32.514h1.194c.663 0 1.2.537 1.2 1.2v4.32zM32.775 43.55h12.95V32.514h-12.95V43.55zm-1.44 0h-1.2c-.663 0-1.2-.537-1.2-1.2v-8.635c.002-.662.539-1.199 1.2-1.2h1.2V43.55zm-3.835.01h-4.215v-4.12h4.21v2.91c0 .005.005.01.005.015v1.195zm2.635-12.485c-1.457.002-2.638 1.183-2.64 2.64V38H5.605c-.643-.001-1.165-.617-1.165-1.26V11.605c0-.643.522-1.165 1.165-1.165H45.18c.642.003 1.163.523 1.165 1.165v19.47h-16.21zM48.36 44.99c1.458 0 2.64-1.182 2.64-2.64v-8.635c-.002-1.457-1.182-2.638-2.64-2.64h-.575v-19.47c-.002-1.438-1.167-2.603-2.604-2.605H5.605C4.167 9.002 3.003 10.168 3 11.605V36.74c.003 1.438 1.168 2.697 2.605 2.7h16.24v4.12H15.97c-.398 0-.72.322-.72.72 0 .398.322.72.72.72l14.165-.01H48.36z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseTVWeb = IconLicenseTVWeb;
function IconLicenseTV(_ref9) {
    var _ref9$className = _ref9.className,
        className = _ref9$className === undefined ? '' : _ref9$className;

    return React.createElement(IconWrapper, { id: "tv", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M7.615 9h39.764c1.441 0 2.61 1.165 2.616 2.604V36.74C49.989 38.18 48.82 39 47.38 39H31.06v4.5h5.905c.397 0 .72.382.72.78s-.323.72-.72.72H18.029c-.397 0-.719-.322-.719-.72 0-.398.322-.78.72-.78h5.905V39H7.615c-1.44 0-2.61-.82-2.615-2.26V11.604C5.005 10.165 6.175 9 7.615 9zM48.5 36.34V11.66c-.003-.644-.476-1.16-1.12-1.16H7.614c-.644 0-1.112.516-1.115 1.16v24.68c.003.644.47 1.16 1.115 1.16h39.764c.645 0 1.118-.516 1.121-1.16zM25.38 43.5h4.235V39H25.38v4.5z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseTV = IconLicenseTV;
function IconLicenseWeb(_ref10) {
    var _ref10$className = _ref10.className,
        className = _ref10$className === undefined ? '' : _ref10$className;

    return React.createElement(IconWrapper, { id: "web", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("path", { d: "M45.538 40c-.672.04-12.697.04-36.077 0-1.122-.044-1.996-1.09-1.955-2.212V34h39.987v3.788c.04 1.121-.753 2.212-1.955 2.212zm0-29.5c1.121.044 1.996.988 1.955 2.11V32.5H7.506V12.61c-.041-1.122.833-2.066 1.955-2.11h36.077zM9.46 9C7.51 9.046 5.964 11.05 6 13v24.788c-.037 1.95 1.509 3.667 3.46 3.712h17.288v1.997H14.87c-.414 0-.75.336-.75.75s.336.75.75.75H40.13c.436.04.79-.314.79-.75s-.354-.75-.79-.75h-11.88V41.5h17.289c1.95-.044 3.498-1.761 3.46-3.712V13c.038-1.95-1.51-3.956-3.46-4H9.46zM27.5 37.196c-.084 0-.151-.066-.152-.149.002-.081.068-.147.15-.15.083 0 .15.068.15.15-.001.082-.067.148-.149.15m.009-1.8c.909.004 1.645.742 1.645 1.65-.004.912-.743 1.65-1.655 1.65-.911-.002-1.647-.743-1.644-1.655.002-.91.743-1.647 1.654-1.644zm-4.433-8.963c-.05-.122-.075-.254-.076-.388v-8.092c.002-.53.395-.956.877-.954.123 0 .244.029.355.084l8.249 4.043c.44.213.639.777.444 1.258-.087.218-.246.391-.444.488l-8.249 4.043c-.44.216-.958 0-1.156-.482z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.IconLicenseWeb = IconLicenseWeb;
function IconLicenseIndustrial(_ref11) {
    var _ref11$className = _ref11.className,
        className = _ref11$className === undefined ? '' : _ref11$className;

    return React.createElement(IconWrapper, { id: "industrial", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "currentColor", fillRule: "nonzero" }, React.createElement("path", { d: "M11.5 42.5h31V33c0-.828.672-1.5 1.5-1.5h.5V18.667C44.5 17.528 43.995 17 43 17H11c-.995 0-1.5.528-1.5 1.667V31.5h.5c.828 0 1.5.672 1.5 1.5v9.5zM10 33H8V18.667c0-1.968 1.176-3.167 3-3.167h32c1.825 0 3 1.2 3 3.167V33h-2v11H10V33z" }), React.createElement("path", { d: "M22.5 33.5h10v-3h-10v3zM21 33v-2c0-1.105.895-2 2-2h9c1.105 0 2 .895 2 2v2c0 1.105-.895 2-2 2h-9c-1.105 0-2-.895-2-2zM34.5 15.5V15c0-1.971-1.766-3.5-4.166-3.5h-5.667c-2.4 0-4.167 1.53-4.167 3.5v.5h14zM36 17H19v-2c0-2.9 2.538-5 5.667-5h5.667C33.464 10 36 12.1 36 15v2z" }), React.createElement("path", { d: "M8.75 33c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h13c.414 0 .75.336.75.75s-.336.75-.75.75h-13zM33.25 33c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12c.414 0 .75.336.75.75s-.336.75-.75.75h-12z" }))));
}
exports.IconLicenseIndustrial = IconLicenseIndustrial;
function IconLicensePodcast(_ref12) {
    var _ref12$className = _ref12.className,
        className = _ref12$className === undefined ? '' : _ref12$className;

    return React.createElement(IconWrapper, { id: "podcast", className: className }, React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { id: "podcast", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, React.createElement("g", { id: "mic-1418319", transform: "translate(27.000000, 26.500000) scale(-1, 1) translate(-27.000000, -26.500000) translate(16.000000, 4.000000)", fill: "currentColor", fillRule: "nonzero" }, React.createElement("path", { d: "M11,34 C15.4111936,34 19,30.1178637 19,25.3459746 L19,8.65402542 C19,3.88213628 15.4111555,0 11,0 C6.58884447,0 3,3.88213628 3,8.65402542 L3,25.3459746 C3,30.1178637 6.58884447,34 11,34 Z M4.85646297,8.65402542 C4.85646297,4.92166292 7.61233581,1.88502376 11,1.88502376 C14.3874358,1.88502376 17.1431563,4.92150831 17.1431563,8.65402542 L17.1431563,25.3459746 C17.1431563,29.0783371 14.3872835,32.1149762 11,32.1149762 C7.61252618,32.1149762 4.85646297,29.0784917 4.85646297,25.3459746 L4.85646297,8.65402542 Z", id: "Shape" }), React.createElement("path", { d: "M21.2382815,17 C20.8178366,17 20.4769467,17.3361288 20.4769467,17.7508326 L20.4769467,28.2992611 C20.4769467,30.1038016 19.5154584,31.8194014 17.7696586,33.1299064 C15.9619486,34.4869436 13.5575374,35.2342957 10.9998082,35.2342957 C8.44207902,35.2342957 6.03778289,34.4869436 4.22995781,33.1299064 C2.48408132,31.8192879 1.52259302,30.103726 1.52259302,28.2992611 L1.52259302,17.7508326 C1.52259302,17.3361288 1.18177982,17 0.761296509,17 C0.340813195,17 0,17.3361288 0,17.7508326 L0,28.2992611 C0,32.7550008 4.52704258,36.4147755 10.2385884,36.7155322 L10.2385884,43.4982591 L5.91024166,43.4982591 L5.91024166,45 L16.0897583,45 L16.0897583,43.4982591 L11.7614116,43.4982591 L11.7614116,36.7155322 C17.4729574,36.4145485 22,32.7550008 22,28.2992611 L22,17.7508326 C22,17.3361288 21.6591484,17 21.2387035,17 L21.2382815,17 Z", id: "Path" })))));
}
exports.IconLicensePodcast = IconLicensePodcast;
function IconLicenseSocialMedia(_ref13) {
    var _ref13$className = _ref13.className,
        className = _ref13$className === undefined ? '' : _ref13$className;

    return React.createElement(IconWrapper, { id: "social-media", className: className }, React.createElement("svg", { width: "54", height: "54", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 54 54" }, React.createElement("g", { id: "social-media", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, React.createElement("g", { id: "social-media-(1)", transform: "translate(5.000000, 9.000000)", fill: "currentColor", fillRule: "nonzero" }, React.createElement("path", { d: "M7.6,26.92 C7.48,27.28 7.16,27.48 6.84,27.48 C6.76,27.48 6.68,27.48 6.6,27.44 C5.04,26.96 3.92,25.32 3.92,23.48 C3.92,20.4414434 3.92,18.4958593 3.92,17.6432477 C3.92,15.9180816 3.92,13.3303323 3.92,9.88 L0.44,8.16 C0.16,8.04 0,7.76 0,7.44 C0,7.12 0.16,6.84 0.44,6.72 L3.92,5 L3.92,4.12 C3.92,1.84 5.6,0 7.6,0 L40.72,0 C42.76,0 44.4,1.84 44.4,4.12 L44.4,20.48 C44.4,20.92 44.04,21.28 43.6,21.28 C43.16,21.28 42.8,20.92 42.8,20.48 L42.8,4.12 C42.8,2.72 41.88,1.6 40.72,1.6 L7.6,1.6 C6.48,1.6 5.52,2.72 5.52,4.12 L5.52,5.48 C5.52,5.8 5.36,6.08 5.08,6.2 L2.6,7.44 L5.08,8.68 C5.36,8.8 5.52,9.08 5.52,9.4 L5.52,23.48 C5.52,24.64 6.16,25.64 7.08,25.92 C7.52,26.08 7.76,26.52 7.6,26.92 Z", id: "Shape" })), React.createElement("g", { id: "social-media-(1)", transform: "translate(26.000000, 23.000000)", fill: "none", fillRule: "nonzero", stroke: "currentColor", strokeWidth: "1.6" }, React.createElement("path", { d: "M21,13.469504 C21,12.6825579 20.6602941,12.053001 20.3823529,11.6752668 C20.7220588,10.8568429 20.7220588,9.59772907 19.4867647,8.65339372 C18.2205882,7.64610268 16.2132353,7.8664476 14.6073529,8.1497482 C14.5147059,8.1497482 14.4220588,8.18122605 14.2058824,8.24418174 C14.0205882,8.30713743 13.5573529,8.43304881 13.2176471,8.4960045 C13.2485294,8.21270389 13.3102941,7.83496975 13.3720588,7.58314699 C13.4029412,7.48871346 13.4029412,7.36280208 13.4338235,7.26836854 C13.5264706,6.85915656 13.6191176,6.48142242 13.7426471,6.07221043 C13.7735294,5.91482121 13.8352941,5.78890983 13.8661765,5.6315206 L13.8661765,5.60004276 C14.2058824,4.40388465 14.6691176,2.79851455 13.8970588,1.50792291 C13.5573529,0.909843854 12.9705882,0.437676179 12.3220588,0.185853419 C11.1794118,-0.254836411 10.7779412,0.185853419 10.6235294,0.500631869 C10.3455882,1.03575523 10.2529412,1.66531213 10.1294118,2.23191334 C10.0676471,2.60964748 9.975,2.98738162 9.88235294,3.30216007 C9.57352941,4.24649542 9.11029412,5.15935293 8.70882353,6.00925474 L8.67794118,6.04073259 C8.15294118,7.04802363 7.62794118,8.11827036 6.97941176,9.03112786 C6.57794118,9.62920692 6.08382353,10.1328524 5.58970588,10.6994536 C5.46617647,10.825365 5.34264706,10.9512764 5.21911765,11.1086656 C4.91029412,10.8883207 4.57058824,10.7938872 4.16911765,10.7938872 L1.85294118,10.7938872 C0.833823529,10.7938872 0,11.643789 0,12.6825579 L0,19.7965509 C0,20.8353197 0.833823529,21.6852216 1.85294118,21.6852216 L4.16911765,21.6852216 C4.47794118,21.6852216 4.75588235,21.6222659 5.00294118,21.4648766 C5.89852941,21.4963545 6.97941176,21.590788 8.09117647,21.6852216 C9.82058824,21.8426108 11.7661765,22 13.3720588,22 C13.8352941,22 14.2985294,22 14.7,21.9685222 C16.0897059,21.8740886 18.0352941,21.590788 18.9308824,20.3946299 C19.2705882,19.9224622 19.4867647,19.3243832 19.4867647,18.6003927 C19.4867647,18.5374371 19.4867647,18.5059592 19.4558824,18.2226586 C20.5058824,17.3727568 20.4132353,15.8618202 20.2897059,15.1693076 C20.7529412,14.6341843 21,14.0990609 21,13.469504 Z", id: "Shape" })), React.createElement("line", { x1: "12.3", y1: "35.7", x2: "22.524836", y2: "35.7", id: "Line", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }))));
}
exports.IconLicenseSocialMedia = IconLicenseSocialMedia;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Player-related Icons
 */
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
function IconWrapper(_ref) {
    var children = _ref.children,
        className = _ref.className,
        id = _ref.id;

    var classes = new BEM('icon');
    return React.createElement("div", Object.assign({}, classes('', ['player', id], className)), children);
}
function IconPlayerPlay(_ref2) {
    var _ref2$className = _ref2.className,
        className = _ref2$className === undefined ? '' : _ref2$className;

    return React.createElement(IconWrapper, { id: "play", className: className }, React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M11.54 5.49L29.692 17.16c.465.298.6.917.3 1.382-.077.12-.179.223-.3.3L11.541 30.51c-.465.298-1.084.164-1.382-.3-.104-.162-.159-.35-.159-.542V6.332c0-.553.448-1 1-1 .192 0 .38.055.54.158z", fill: "currentColor" }))));
}
exports.IconPlayerPlay = IconPlayerPlay;
function IconPlayerPause(_ref3) {
    var _ref3$className = _ref3.className,
        className = _ref3$className === undefined ? '' : _ref3$className;

    return React.createElement(IconWrapper, { id: "pause", className: className }, React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M10 6h4c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1zM22 6h4c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1z", fill: "currentColor" }))));
}
exports.IconPlayerPause = IconPlayerPause;
function IconPlayerPrevious(_ref4) {
    var _ref4$className = _ref4.className,
        className = _ref4$className === undefined ? '' : _ref4$className;

    return React.createElement(IconWrapper, { id: "previous", className: className }, React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "matrix(-1 0 0 1 30 6)", fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M6.625 5.3l7.399 5.92c.431.344.501.973.156 1.405-.046.057-.098.11-.156.156l-7.4 5.92c-.43.344-1.06.274-1.405-.157-.142-.177-.219-.398-.219-.625V6.081c0-.553.448-1 1-1 .227 0 .447.077.625.219z", fill: "currentColor" }), React.createElement("rect", { fill: "currentColor", x: "16", y: "5", width: "2", height: "14", rx: "1" }))));
}
exports.IconPlayerPrevious = IconPlayerPrevious;
function IconPlayerNext(_ref5) {
    var _ref5$className = _ref5.className,
        className = _ref5$className === undefined ? '' : _ref5$className;

    return React.createElement(IconWrapper, { id: "next", className: className }, React.createElement("svg", { width: "36", height: "36", viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { transform: "translate(6 6)", fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M6.625 5.3l7.399 5.92c.431.344.501.973.156 1.405-.046.057-.098.11-.156.156l-7.4 5.92c-.43.344-1.06.274-1.405-.157-.142-.177-.219-.398-.219-.625V6.081c0-.553.448-1 1-1 .227 0 .447.077.625.219z", fill: "currentColor" }), React.createElement("rect", { fill: "currentColor", x: "16", y: "5", width: "2", height: "14", rx: "1" }))));
}
exports.IconPlayerNext = IconPlayerNext;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Social Icons
 */
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
function IconWrapper(_ref) {
    var children = _ref.children,
        className = _ref.className,
        id = _ref.id;

    var classes = new BEM('icon');
    return React.createElement("div", Object.assign({}, classes('', ['social', id], className)), children);
}
function IconFacebook(_ref2) {
    var _ref2$className = _ref2.className,
        className = _ref2$className === undefined ? '' : _ref2$className;

    return React.createElement(IconWrapper, { id: "facebook", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { fill: "#3c5a99", d: "M22.8 24c.6 0 1.1-.5 1.1-1.1V5.1c0-.6-.5-1.1-1.1-1.1H5.1C4.5 4 4 4.5 4 5.1v17.8c0 .6.5 1.1 1.1 1.1h17.7z" }), React.createElement("path", { fill: "#fefefe", d: "M17.9 24v-7.7h2.5l.4-3h-2.9v-1.9c0-.9.2-1.5 1.4-1.5h1.5V7.2c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.4-3.7 4v2.2h-2.5v3h2.5V24h3z" })));
}
exports.IconFacebook = IconFacebook;
function IconGoogle(_ref3) {
    var _ref3$className = _ref3.className,
        className = _ref3$className === undefined ? '' : _ref3$className;

    return React.createElement(IconWrapper, { id: "google", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { fill: "#fbbc05", d: "M8 14c0-.6.1-1.3.3-1.9L5 9.6c-.6 1.3-1 2.8-1 4.4s.4 3.1 1 4.4l3.3-2.6c-.2-.5-.3-1.2-.3-1.8z" }), React.createElement("path", { fill: "#ea4335", d: "M5 9.6l3.3 2.6c.8-2.4 2.9-4.1 5.5-4.1 1.4 0 2.6.5 3.6 1.3l2.9-2.9C18.6 5 16.3 4 13.8 4 10 4 6.6 6.3 5 9.6z" }), React.createElement("path", { fill: "#34a853", d: "M17.1 19c-.9.6-2 .9-3.3.9-2.6 0-4.8-1.7-5.5-4.1L5 18.4c1.6 3.3 4.9 5.6 8.8 5.6 3 0 4.8-1 6.4-2.5-.1-.1-3.1-2.5-3.1-2.5z" }), React.createElement("path", { fill: "#4285f4", d: "M20.2 21.5c.4-.4.9-.9 1.2-1.4.2-.3.3-.5.5-.8.1-.3.3-.5.4-.8v-.1c.1-.3.2-.5.3-.8 0-.1 0-.1.1-.2.1-.3.1-.5.2-.8 0-.1 0-.2.1-.2.1-.3.1-.6.1-.8v-.3c0-.4.1-.8.1-1.2 0-.6-.1-1.2-.2-1.8h-9.2V16h5.3l-.3.9s0 .1-.1.1c-.1.2-.2.5-.4.7v.1c-.2.2-.3.4-.5.6-.2.2-.5.4-.7.6l3.1 2.5z" })));
}
exports.IconGoogle = IconGoogle;
function IconSpotify(_ref4) {
    var _ref4$className = _ref4.className,
        className = _ref4$className === undefined ? '' : _ref4$className;

    return React.createElement(IconWrapper, { id: "spotify", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { fill: "#1ed660", d: "M12.2 16.1c2.4 0 4.5.6 6.4 1.7.3.2.4.3.4.7 0 .4-.3.7-.7.7-.2 0-.3-.1-.5-.2-1.6-1-3.6-1.5-5.7-1.5-1.2 0-2.4.2-3.5.4 0 .1-.2.1-.4.1-.4 0-.7-.3-.7-.7 0-.5.3-.7.6-.8 1.4-.2 2.7-.4 4.1-.4m-.1-3.6c2.9 0 5.6.7 7.8 2 .4.2.5.5.5.9 0 .5-.4.9-.9.9-.2 0-.4-.1-.5-.2-1.8-1.1-4.3-1.8-7-1.8-1.4 0-2.6.2-3.6.5-.2.1-.3.1-.5.1-.5 0-.9-.4-.9-.9s.2-.8.7-.9c1.3-.3 2.5-.6 4.4-.6m.2-3.8c3.2 0 6.6.7 9.1 2.1.3.2.6.5.6 1 0 .6-.5 1-1 1-.2 0-.4-.1-.6-.2-2-1.2-5.1-1.9-8-1.9-1.5 0-3 .2-4.4.5-.2 0-.4.1-.6.1-.6 0-1-.5-1-1.1 0-.6.4-.9.8-1.1 1.5-.1 3.2-.4 5.1-.4M13.9 3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11S20 3 13.9 3" })));
}
exports.IconSpotify = IconSpotify;
function IconTwitter(_ref5) {
    var _ref5$className = _ref5.className,
        className = _ref5$className === undefined ? '' : _ref5$className;

    return React.createElement(IconWrapper, { id: "twitter", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { d: "M25 7.92a8.2 8.2 0 0 1-2.36.65 4.12 4.12 0 0 0 1.8-2.27 8.22 8.22 0 0 1-2.61 1 4.11 4.11 0 0 0-7 3.74 11.65 11.65 0 0 1-8.44-4.29 4.11 4.11 0 0 0 1.27 5.48 4.09 4.09 0 0 1-1.86-.51v.05a4.11 4.11 0 0 0 3.29 4 4.11 4.11 0 0 1-1.85.07 4.11 4.11 0 0 0 3.83 2.85A8.23 8.23 0 0 1 6 20.47a8.35 8.35 0 0 1-1-.06 11.67 11.67 0 0 0 18-9.83v-.53a8.34 8.34 0 0 0 2-2.13z", fill: "#55acee" })));
}
exports.IconTwitter = IconTwitter;
function IconApple(_ref6) {
    var _ref6$className = _ref6.className,
        className = _ref6$className === undefined ? '' : _ref6$className;

    return React.createElement(IconWrapper, { id: "apple", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { d: "M22.42 17.66c-.12.33-.23.63-.35.93A11.88 11.88 0 0 1 21 20.52a9.53 9.53 0 0 1-1.39 1.67 2.67 2.67 0 0 1-1.78.78 4.46 4.46 0 0 1-1.64-.39 4.69 4.69 0 0 0-1.77-.39 4.85 4.85 0 0 0-1.82.39A4.79 4.79 0 0 1 11 23a2.57 2.57 0 0 1-1.82-.8 10.1 10.1 0 0 1-1.45-1.74 12 12 0 0 1-1.54-3 11.12 11.12 0 0 1-.64-3.63 6.64 6.64 0 0 1 .87-3.46 5.09 5.09 0 0 1 1.85-1.89 4.84 4.84 0 0 1 2.46-.7 5.78 5.78 0 0 1 1.91.44 6.15 6.15 0 0 0 1.52.44 9.15 9.15 0 0 0 1.67-.53 5.45 5.45 0 0 1 2.27-.4 4.86 4.86 0 0 1 3.79 2 4.21 4.21 0 0 0-2.23 3.83 4.19 4.19 0 0 0 1.39 3.18 4.28 4.28 0 0 0 1.37.92zM18.19 3v.4a4.28 4.28 0 0 1-1.1 2.8A3.73 3.73 0 0 1 14 7.73v-.38a4.43 4.43 0 0 1 1.16-2.83 4.57 4.57 0 0 1 1.41-1.06A4.25 4.25 0 0 1 18.19 3z" })));
}
exports.IconApple = IconApple;
function IconInstagram(_ref7) {
    var _ref7$className = _ref7.className,
        className = _ref7$className === undefined ? '' : _ref7$className;

    return React.createElement(IconWrapper, { id: "instagram", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("path", { d: "M14.08 5.88c2.67 0 3 0 4 .06a5.53 5.53 0 0 1 1.92.34 3.31 3.31 0 0 1 1.9 1.9 5.53 5.53 0 0 1 .32 1.82c0 1.05.06 1.37.06 4s0 3-.06 4a5.53 5.53 0 0 1-.34 2 3.31 3.31 0 0 1-1.9 1.9 5.53 5.53 0 0 1-1.86.34c-1.05 0-1.37.06-4 .06s-3 0-4-.06a5.53 5.53 0 0 1-1.86-.34A3.31 3.31 0 0 1 6.28 20a5.53 5.53 0 0 1-.34-1.86c0-1.05-.06-1.37-.06-4s0-3 .06-4a5.53 5.53 0 0 1 .34-1.86 3.31 3.31 0 0 1 1.9-1.9A5.53 5.53 0 0 1 10 5.94c1.05 0 1.37-.06 4-.06m0-1.8c-2.72 0-3.06 0-4.12.06a7.34 7.34 0 0 0-2.43.46A5.11 5.11 0 0 0 4.6 7.53 7.34 7.34 0 0 0 4.14 10c0 1.07-.06 1.41-.06 4.12s0 3.06.06 4.12a7.34 7.34 0 0 0 .46 2.43 5.11 5.11 0 0 0 2.92 2.92A7.34 7.34 0 0 0 10 24c1.07 0 1.41.06 4.12.06s3.06 0 4.12-.06a7.34 7.34 0 0 0 2.43-.46 5.11 5.11 0 0 0 2.92-2.92A7.34 7.34 0 0 0 24 18.2c0-1.07.06-1.41.06-4.12S24.07 11 24 10a7.34 7.34 0 0 0-.46-2.43 5.11 5.11 0 0 0-2.91-2.97 7.34 7.34 0 0 0-2.43-.46c-1.07 0-1.41-.06-4.12-.06z" }), React.createElement("path", { d: "M14.08 8.94a5.14 5.14 0 1 0 5.14 5.14 5.14 5.14 0 0 0-5.14-5.14zm0 8.47a3.33 3.33 0 1 1 3.33-3.33 3.33 3.33 0 0 1-3.33 3.33z" }), React.createElement("circle", { cx: "19.42", cy: "8.74", r: "1.2" })));
}
exports.IconInstagram = IconInstagram;
function IconBandCamp(_ref8) {
    var _ref8$className = _ref8.className,
        className = _ref8$className === undefined ? '' : _ref8$className;

    return React.createElement(IconWrapper, { id: "bandcamp", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("circle", { cx: "14", cy: "14", r: "11", fill: "#60909a" }), React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M16.14 17.46H8.11l3.75-6.92h8.03l-3.75 6.92" })));
}
exports.IconBandCamp = IconBandCamp;
function IconSoundCloud(_ref9) {
    var _ref9$className = _ref9.className,
        className = _ref9$className === undefined ? '' : _ref9$className;

    return React.createElement(IconWrapper, { id: "soundcloud", className: className }, React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, React.createElement("defs", null, React.createElement("linearGradient", { id: "a", x1: "14", y1: "47.21", x2: "14", y2: "36.79", gradientTransform: "matrix(1 0 0 -1 0 56)", gradientUnits: "userSpaceOnUse" }, React.createElement("stop", { offset: "0", stopColor: "#f79810" }), React.createElement("stop", { offset: "1", stopColor: "#f8310e" }))), React.createElement("path", { d: "M2.27 15a.1.1 0 0 0-.1.09L2 16.45l.18 1.31a.1.1 0 0 0 .1.09.1.1 0 0 0 .1-.09l.21-1.31-.21-1.33a.1.1 0 0 0-.11-.12zm1-.73a.1.1 0 0 0-.2 0l-.24 2.16.24 2.11a.1.1 0 0 0 .2 0l.27-2.11zm3.72-2a.19.19 0 0 0-.18.18l-.19 4L6.8 19a.18.18 0 0 0 .36 0l.21-2.56-.21-4a.19.19 0 0 0-.16-.13zm-1.94 1.41a.14.14 0 0 0-.14.14l-.21 2.63.21 2.55a.14.14 0 0 0 .28 0l.24-2.54-.24-2.63a.14.14 0 0 0-.14-.15zm3.88 5.51a.23.23 0 0 0 .22-.19l.18-2.52-.18-5.28a.22.22 0 0 0-.45 0l-.16 5.28.17 2.52a.22.22 0 0 0 .22.19zm4 0a.31.31 0 0 0 .3-.3l.13-2.45-.13-6.1a.3.3 0 0 0-.61 0l-.11 6.1.11 2.45a.31.31 0 0 0 .32.31zm-2 0a.27.27 0 0 0 .26-.26l.16-2.48-.16-5.32a.26.26 0 0 0-.53 0l-.14 5.32.14 2.48a.26.26 0 0 0 .26.27zM6 19.17a.16.16 0 0 0 .17-.17l.23-2.56L6.17 14a.16.16 0 0 0-.32 0l-.2 2.44.2 2.56a.16.16 0 0 0 .15.17zM4.1 19a.12.12 0 0 0 .12-.12l.25-2.46-.25-2.56a.12.12 0 0 0-.12-.12.12.12 0 0 0-.12.12l-.22 2.56.24 2.49a.12.12 0 0 0 .1.09zm7.82-8a.28.28 0 0 0-.28.28l-.13 5.12.13 2.47a.28.28 0 0 0 .57 0l.14-2.47-.14-5.12a.28.28 0 0 0-.29-.28zM8 19.2a.21.21 0 0 0 .2-.2l.2-2.55-.2-4.87a.2.2 0 0 0-.4 0l-.18 4.87.13 2.55a.2.2 0 0 0 .25.2zm2.16-.2l.17-2.5-.17-5.5a.24.24 0 0 0-.49 0l-.15 5.46.16 2.54a.24.24 0 0 0 .49 0zM23 13.31a3 3 0 0 0-1.14.23 5.21 5.21 0 0 0-5.19-4.75 5.28 5.28 0 0 0-1.89.35c-.22.09-.28.17-.28.35v9.37a.36.36 0 0 0 .32.35H23a3 3 0 0 0 0-5.9zm-9.06-3.83a.33.33 0 0 0-.33.32l-.13 6.65.13 2.41a.33.33 0 0 0 .65 0l.14-2.41-.13-6.65a.33.33 0 0 0-.33-.32z", fill: "url(#a)" })));
}
exports.IconSoundCloud = IconSoundCloud;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}button{background:none;border:0;color:inherit;cursor:pointer;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}button svg{display:block}button::-moz-focus-inner{border:0;padding:0}button:focus{outline:0}button[disabled]{cursor:not-allowed}a.button{display:inline-block}a.button:not([class*=color-scheme]){color:inherit}.button{text-decoration:none;border:1px solid transparent}.button.color-scheme--black-outline{border-color:#000}.button__flex,.button__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%}.button__active-background{position:absolute;top:3px;right:0;bottom:3px;left:0;border-radius:2px}.button.button--is-active .button__active-background:after{content:\"\";position:absolute;left:6px;bottom:3px;right:6px;height:3px;background:#4487ff;border-radius:3px;-webkit-animation:button-active-indicator-appear .2s ease-in-out;animation:button-active-indicator-appear .2s ease-in-out;-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}@-webkit-keyframes button-active-indicator-appear{0%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:0}to{-webkit-transform:scaleX(100%);transform:scaleX(100%);opacity:1}}@keyframes button-active-indicator-appear{0%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:0}to{-webkit-transform:scaleX(100%);transform:scaleX(100%);opacity:1}}.button--xxsmall{border-radius:2px}.button--xxsmall .button__wrapper{padding:5px 8px}.button--xxsmall .button__label{font-size:.625em;line-height:1.2}@media print{.button--xxsmall .button__label{font-size:.5208333331em}}.button--xxsmall .button__label em,.button--xxsmall .button__label i{font-weight:300}.button--xxsmall .button__label b,.button--xxsmall .button__label strong{font-weight:700}.button--xxsmall .description{font-size:.625em;line-height:1.2}@media print{.button--xxsmall .description{font-size:.5208333331em}}.button--xxsmall .description em,.button--xxsmall .description i{font-weight:300}.button--xxsmall .description b,.button--xxsmall .description strong{font-weight:700}.button--xxsmall.button--icon,.button--xxsmall.button--icon .button__wrapper{height:24px;width:24px}.button--xxsmall.button--pill{border-radius:12px}.button--xxsmall.button--pill .button__wrapper{padding-right:14px;padding-left:14px}.button--xxsmall.with--shadow{-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.button--xxsmall.with--icon .button__icon{min-height:20px}.button--xxsmall.with--icon.icon-position--left .button__wrapper{padding-left:26px}.button--xxsmall.with--icon.icon-position--left:not(.button--text) .button__icon{left:0}.button--xxsmall.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--xxsmall.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:30px}.button--xxsmall.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:4px}.button--xxsmall.with--icon.icon-position--right .button__wrapper{padding-right:26px}.button--xxsmall.with--icon.icon-position--right:not(.button--text) .button__icon{right:0}.button--xxsmall.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--xxsmall.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--xxsmall.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:30px}.button--xxsmall.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:4px}.button--xxsmall.button--text.with--icon .button__icon{height:20px;width:20px}.button--xxsmall.button--text.with--icon .button__icon svg{width:100%}.button--xsmall{border-radius:4px}.button--xsmall .button__wrapper{padding:5px 8px}.button--xsmall .button__label{font-size:.6875em;line-height:1.1}@media print{.button--xsmall .button__label{font-size:.5729166664em}}.button--xsmall .button__label em,.button--xsmall .button__label i{font-weight:300}.button--xsmall .button__label b,.button--xsmall .button__label strong{font-weight:700}.button--xsmall .description{font-size:.6875em;line-height:1.1}@media print{.button--xsmall .description{font-size:.5729166664em}}.button--xsmall .description em,.button--xsmall .description i{font-weight:300}.button--xsmall .description b,.button--xsmall .description strong{font-weight:700}.button--xsmall.button--icon,.button--xsmall.button--icon .button__wrapper{height:24px;width:24px}.button--xsmall.button--pill{border-radius:12px}.button--xsmall.button--pill .button__wrapper{padding-right:14px;padding-left:14px}.button--xsmall.with--shadow{-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.button--xsmall.with--icon .button__icon{min-height:20px}.button--xsmall.with--icon.icon-position--left .button__wrapper{padding-left:26px}.button--xsmall.with--icon.icon-position--left:not(.button--text) .button__icon{left:0}.button--xsmall.with--icon.icon-position--left.button--text .button__wrapper{padding-left:24px}.button--xsmall.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:30px}.button--xsmall.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:4px}.button--xsmall.with--icon.icon-position--right .button__wrapper{padding-right:26px}.button--xsmall.with--icon.icon-position--right:not(.button--text) .button__icon{right:0}.button--xsmall.with--icon.icon-position--right.button--text .button__wrapper{padding-right:24px}.button--xsmall.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--xsmall.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:30px}.button--xsmall.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:4px}.button--xsmall.button--text.with--icon .button__icon{height:20px;width:20px}.button--xsmall.button--text.with--icon .button__icon svg{width:100%}.button--small{border-radius:4px}.button--small .button__wrapper{padding:9px 12px}.button--small .button__label{font-size:.6875em;line-height:1.1}@media print{.button--small .button__label{font-size:.5729166664em}}.button--small .button__label em,.button--small .button__label i{font-weight:300}.button--small .button__label b,.button--small .button__label strong{font-weight:700}.button--small .description{font-size:.6875em;line-height:1.1}@media print{.button--small .description{font-size:.5729166664em}}.button--small .description em,.button--small .description i{font-weight:300}.button--small .description b,.button--small .description strong{font-weight:700}.button--small.button--icon,.button--small.button--icon .button__wrapper{height:32px;width:32px}.button--small.button--pill{border-radius:16px}.button--small.button--pill .button__wrapper{padding-right:18px;padding-left:18px}.button--small.with--shadow{-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.button--small.with--icon .button__icon{min-height:28px}.button--small.with--icon.icon-position--left .button__wrapper{padding-left:32px}.button--small.with--icon.icon-position--left:not(.button--text) .button__icon{left:4px}.button--small.with--icon.icon-position--left.button--text .button__wrapper{padding-left:26px}.button--small.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:36px}.button--small.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:8px}.button--small.with--icon.icon-position--right .button__wrapper{padding-right:32px}.button--small.with--icon.icon-position--right:not(.button--text) .button__icon{right:4px}.button--small.with--icon.icon-position--right.button--text .button__wrapper{padding-right:26px}.button--small.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--small.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:36px}.button--small.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:8px}.button--small.button--text.with--icon .button__icon{height:28px;width:28px}.button--small.button--text.with--icon .button__icon svg{width:100%}.button--small-medium{border-radius:4px}.button--small-medium .button__wrapper{padding:9px 12px}.button--small-medium .button__label{font-size:.8125em;line-height:1.34}@media print{.button--small-medium .button__label{font-size:.6770833331em}}.button--small-medium .button__label em,.button--small-medium .button__label i{font-weight:300}.button--small-medium .button__label b,.button--small-medium .button__label strong{font-weight:700}.button--small-medium .description{font-size:.8125em;line-height:1.34}@media print{.button--small-medium .description{font-size:.6770833331em}}.button--small-medium .description em,.button--small-medium .description i{font-weight:300}.button--small-medium .description b,.button--small-medium .description strong{font-weight:700}.button--small-medium.button--icon,.button--small-medium.button--icon .button__wrapper{height:36px;width:36px}.button--small-medium.button--pill{border-radius:18px}.button--small-medium.button--pill .button__wrapper{padding-right:18px;padding-left:18px}.button--small-medium.with--shadow{-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.button--small-medium.with--icon .button__icon{min-height:28px}.button--small-medium.with--icon.icon-position--left .button__wrapper{padding-left:32px}.button--small-medium.with--icon.icon-position--left:not(.button--text) .button__icon{left:2px}.button--small-medium.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--small-medium.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:36px}.button--small-medium.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:6px}.button--small-medium.with--icon.icon-position--right .button__wrapper{padding-right:32px}.button--small-medium.with--icon.icon-position--right:not(.button--text) .button__icon{right:2px}.button--small-medium.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--small-medium.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--small-medium.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:36px}.button--small-medium.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:6px}.button--small-medium.button--text.with--icon .button__icon{height:28px;width:28px}.button--small-medium.button--text.with--icon .button__icon svg{width:100%}.button--medium{border-radius:4px}.button--medium .button__wrapper{padding:11px 16px}.button--medium .button__label{font-size:.8125em;line-height:1.34}@media print{.button--medium .button__label{font-size:.6770833331em}}.button--medium .button__label em,.button--medium .button__label i{font-weight:300}.button--medium .button__label b,.button--medium .button__label strong{font-weight:700}.button--medium .description{font-size:.8125em;line-height:1.34}@media print{.button--medium .description{font-size:.6770833331em}}.button--medium .description em,.button--medium .description i{font-weight:300}.button--medium .description b,.button--medium .description strong{font-weight:700}.button--medium.button--icon,.button--medium.button--icon .button__wrapper{height:40px;width:40px}.button--medium.button--pill{border-radius:20px}.button--medium.button--pill .button__wrapper{padding-right:22px;padding-left:22px}.button--medium.with--shadow{-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25)}.button--medium.with--icon .button__icon{min-height:28px}.button--medium.with--icon.icon-position--left .button__wrapper{padding-left:38px}.button--medium.with--icon.icon-position--left:not(.button--text) .button__icon{left:8px}.button--medium.with--icon.icon-position--left.button--text .button__wrapper{padding-left:28px}.button--medium.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:42px}.button--medium.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:12px}.button--medium.with--icon.icon-position--right .button__wrapper{padding-right:38px}.button--medium.with--icon.icon-position--right:not(.button--text) .button__icon{right:8px}.button--medium.with--icon.icon-position--right.button--text .button__wrapper{padding-right:28px}.button--medium.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--medium.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:42px}.button--medium.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:12px}.button--medium.button--text.with--icon .button__icon{height:28px;width:28px}.button--medium.button--text.with--icon .button__icon svg{width:100%}.button--medium-large{border-radius:4px}.button--medium-large .button__wrapper{padding:11px 16px}.button--medium-large .button__label{font-size:.875em;line-height:1.142857143}@media print{.button--medium-large .button__label{font-size:.7291666664em}}.button--medium-large .button__label em,.button--medium-large .button__label i{font-weight:300}.button--medium-large .button__label b,.button--medium-large .button__label strong{font-weight:700}.button--medium-large .description{font-size:.875em;line-height:1.142857143}@media print{.button--medium-large .description{font-size:.7291666664em}}.button--medium-large .description em,.button--medium-large .description i{font-weight:300}.button--medium-large .description b,.button--medium-large .description strong{font-weight:700}.button--medium-large.button--icon,.button--medium-large.button--icon .button__wrapper{height:40px;width:40px}.button--medium-large.button--pill{border-radius:20px}.button--medium-large.button--pill .button__wrapper{padding-right:22px;padding-left:22px}.button--medium-large.with--shadow{-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25)}.button--medium-large.with--icon .button__icon{min-height:28px}.button--medium-large.with--icon.icon-position--left .button__wrapper{padding-left:38px}.button--medium-large.with--icon.icon-position--left:not(.button--text) .button__icon{left:8px}.button--medium-large.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--medium-large.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:42px}.button--medium-large.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:12px}.button--medium-large.with--icon.icon-position--right .button__wrapper{padding-right:38px}.button--medium-large.with--icon.icon-position--right:not(.button--text) .button__icon{right:8px}.button--medium-large.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--medium-large.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--medium-large.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:42px}.button--medium-large.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:12px}.button--medium-large.button--text.with--icon .button__icon{height:28px;width:28px}.button--medium-large.button--text.with--icon .button__icon svg{width:100%}.button--large{border-radius:4px}.button--large .button__wrapper{padding:15px 20px}.button--large .button__label{font-size:.875em;line-height:1.142857143}@media print{.button--large .button__label{font-size:.7291666664em}}.button--large .button__label em,.button--large .button__label i{font-weight:300}.button--large .button__label b,.button--large .button__label strong{font-weight:700}.button--large .description{font-size:.875em;line-height:1.142857143}@media print{.button--large .description{font-size:.7291666664em}}.button--large .description em,.button--large .description i{font-weight:300}.button--large .description b,.button--large .description strong{font-weight:700}.button--large.button--icon,.button--large.button--icon .button__wrapper{height:48px;width:48px}.button--large.button--pill{border-radius:24px}.button--large.button--pill .button__wrapper{padding-right:26px;padding-left:26px}.button--large.with--shadow{-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25)}.button--large.with--icon .button__icon{min-height:28px}.button--large.with--icon.icon-position--left .button__wrapper{padding-left:44px}.button--large.with--icon.icon-position--left:not(.button--text) .button__icon{left:12px}.button--large.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--large.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:48px}.button--large.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:16px}.button--large.with--icon.icon-position--right .button__wrapper{padding-right:44px}.button--large.with--icon.icon-position--right:not(.button--text) .button__icon{right:12px}.button--large.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--large.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--large.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:48px}.button--large.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:16px}.button--large.button--text.with--icon .button__icon{height:28px;width:28px}.button--large.button--text.with--icon .button__icon svg{width:100%}.button--xlarge{border-radius:4px}.button--xlarge .button__wrapper{padding:11px 24px 13px}.button--xlarge .button__label{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.125em;line-height:1.3333333333}@media print{.button--xlarge .button__label{font-size:.9374999996em}}.button--xlarge .button__label em,.button--xlarge .button__label i{font-weight:400}.button--xlarge .button__label b,.button--xlarge .button__label strong{font-weight:500}.button--xlarge .description{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.125em;line-height:1.3333333333}@media print{.button--xlarge .description{font-size:.9374999996em}}.button--xlarge .description em,.button--xlarge .description i{font-weight:400}.button--xlarge .description b,.button--xlarge .description strong{font-weight:500}.button--xlarge.button--icon,.button--xlarge.button--icon .button__wrapper{height:48px;width:48px}.button--xlarge.button--pill{border-radius:24px}.button--xlarge.button--pill .button__wrapper{padding-right:30px;padding-left:30px}.button--xlarge.with--shadow{-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25)}.button--xlarge.with--icon .button__icon{min-height:28px}.button--xlarge.with--icon .button__icon svg{width:36px}.button--xlarge.with--icon.icon-position--left .button__wrapper{padding-left:48px}.button--xlarge.with--icon.icon-position--left:not(.button--text) .button__icon{left:8px}.button--xlarge.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--xlarge.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:52px}.button--xlarge.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:12px}.button--xlarge.with--icon.icon-position--right .button__wrapper{padding-right:48px}.button--xlarge.with--icon.icon-position--right:not(.button--text) .button__icon{right:8px}.button--xlarge.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--xlarge.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--xlarge.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:52px}.button--xlarge.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:12px}.button--xlarge.button--text.with--icon .button__icon{height:28px;width:28px}.button--xlarge.button--text.with--icon .button__icon svg{width:100%}.button--xxlarge{border-radius:4px}.button--xxlarge .button__wrapper{padding:18px 32px 20px}.button--xxlarge .button__label{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.25em;line-height:1.2}@media print{.button--xxlarge .button__label{font-size:1.0416666663em}}.button--xxlarge .button__label em,.button--xxlarge .button__label i{font-weight:400}.button--xxlarge .button__label b,.button--xxlarge .button__label strong{font-weight:500}.button--xxlarge .description{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.25em;line-height:1.2}@media print{.button--xxlarge .description{font-size:1.0416666663em}}.button--xxlarge .description em,.button--xxlarge .description i{font-weight:400}.button--xxlarge .description b,.button--xxlarge .description strong{font-weight:500}.button--xxlarge.button--icon,.button--xxlarge.button--icon .button__wrapper{height:64px;width:64px}.button--xxlarge.button--pill{border-radius:32px}.button--xxlarge.button--pill .button__wrapper{padding-right:38px;padding-left:38px}.button--xxlarge.with--shadow{-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25)}.button--xxlarge.with--icon .button__icon{min-height:28px}.button--xxlarge.with--icon.icon-position--left .button__wrapper{padding-left:60px}.button--xxlarge.with--icon.icon-position--left:not(.button--text) .button__icon{left:20px}.button--xxlarge.with--icon.icon-position--left.button--text .button__wrapper{padding-left:32px}.button--xxlarge.with--icon.icon-position--left.button--pill .button__wrapper{padding-left:64px}.button--xxlarge.with--icon.icon-position--left.button--pill .button__wrapper .icon{left:24px}.button--xxlarge.with--icon.icon-position--right .button__wrapper{padding-right:60px}.button--xxlarge.with--icon.icon-position--right:not(.button--text) .button__icon{right:20px}.button--xxlarge.with--icon.icon-position--right.button--text .button__wrapper{padding-right:32px}.button--xxlarge.with--icon.icon-position--right.button--text .button__wrapper .icon{right:0}.button--xxlarge.with--icon.icon-position--right.button--pill .button__wrapper{padding-right:64px}.button--xxlarge.with--icon.icon-position--right.button--pill .button__wrapper .icon{right:24px}.button--xxlarge.button--text.with--icon .button__icon{height:28px;width:28px}.button--xxlarge.button--text.with--icon .button__icon svg{width:100%}.button--icon-no-padding .button__wrapper,.button--icon .button__wrapper{padding:0}.button--icon svg{height:100%;width:100%}.button.with--icon .button__icon{position:absolute;top:50%;bottom:0;left:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.button.with--icon .button__icon svg{height:100%}.button.with--icon.icon-position--right .icon{left:auto}.button.with--shadow{-webkit-transition:-webkit-transform 5s cubic-bezier(.175,.885,.32,1.275),-webkit-box-shadow .5s cubic-bezier(.445,.05,.55,.95);transition:-webkit-transform 5s cubic-bezier(.175,.885,.32,1.275),-webkit-box-shadow .5s cubic-bezier(.445,.05,.55,.95);-o-transition:transform 5s cubic-bezier(.175,.885,.32,1.275),box-shadow .5s cubic-bezier(.445,.05,.55,.95);transition:transform 5s cubic-bezier(.175,.885,.32,1.275),box-shadow .5s cubic-bezier(.445,.05,.55,.95);transition:transform 5s cubic-bezier(.175,.885,.32,1.275),box-shadow .5s cubic-bezier(.445,.05,.55,.95),-webkit-transform 5s cubic-bezier(.175,.885,.32,1.275),-webkit-box-shadow .5s cubic-bezier(.445,.05,.55,.95);z-index:auto}.button--hyperlink,.button--text{background-color:transparent!important;border-width:0!important}.button--hyperlink .button__wrapper,.button--text .button__wrapper{padding:0}.button--hyperlink.with--icon:not(.icon-position--right),.button--text.with--icon:not(.icon-position--right){margin-left:-4px}.button--hyperlink{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;text-decoration:underline}.button--submitting{cursor:progress!important}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/Button/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/Button/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,OC8DvE,gBAAgB,SACP,cACK,eACC,aACF,mBACM,iBACF,UACP,yBACV,sBAAA,qBAAA,gBAAiB,CATlB,WAWE,aAAc,CAXhB,yBAcE,SAAS,SACC,CAfZ,aAkBE,SAAU,CAlBZ,iBAsBE,kBAAmB,CACnB,SAID,oBAAqB,CADtB,oCAGI,aAAc,CACf,QAIF,qBAAqB,4BACS,CAF/B,oCAKI,iBAAmB,CACpB,+BAGD,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,WACX,CACZ,2BCnHA,kBDsH4B,QClHxB,QDkH0C,WClH1C,ODkH0C,iBEzJ1B,CFyItB,2DAsBM,WAAW,kBACO,SACT,WACE,UACD,WACC,mBAEX,kBAAkB,iEAElB,yDAAyD,8BAC5D,0BAAA,qBAAsB,CAEtB,kDACC,GAAK,4BAAA,oBAAqB,SAAY,CAAA,GAC/B,+BAAA,uBAAuB,SAAY,CAAA,CAF3C,0CACC,GAAK,4BAAA,oBAAqB,SAAY,CAAA,GAC/B,+BAAA,uBAAuB,SAAY,CAAA,CAAA,iBEnJxC,iBA1BgB,CFmLjB,kCG5FqB,eC3DuB,CJuJ5C,gCKrIC,iBA9Ce,eACD,CC6I4B,aNqC3C,gCKjIK,uBAA0B,CC4FY,CNqC3C,qEKvHC,eAAgB,CLuHjB,yEK/GC,eAAgB,CL+GjB,8BKrIC,iBA9Ce,eACD,CC8I0B,aNoCzC,8BKjIK,uBAA0B,CC6FU,CNoCzC,iEKvHC,eAAgB,CLuHjB,qEK/GC,eAAgB,CL+GjB,6EO/ID,YHR6C,UAAA,CJuJ5C,8BMzBD,kBF9H6C,CJuJ5C,+CGjGqB,mBCtDuB,iBAAA,CJuJ5C,8BQjKC,yDApBqD,gDAAA,CRqLtD,0CMVC,eF7I2C,CJuJ5C,iEMsBD,iBF7K6C,CJuJ5C,iFM0BD,MFjL6C,CJuJ5C,8EMsCG,iBF7LyC,CJuJ5C,8EMkDC,iBFzM2C,CJuJ5C,oFMoDG,QF3MyC,CJuJ5C,kEMsBD,kBF7K6C,CJuJ5C,kFM0BD,OFjL6C,CJuJ5C,+EMsCG,kBF7LyC,CJuJ5C,qFM0CK,OAAoB,CN1CzB,+EMkDC,kBFzM2C,CJuJ5C,qFMoDG,SF3MyC,CJuJ5C,uDMQC,YF/J2C,UAAA,CJuJ5C,2DMWG,UAAW,CNXf,gBEzJE,iBAvBgB,CFgLjB,iCG5FqB,eC3DuB,CJuJ5C,+BKrIC,kBA1CgB,eACF,CCyI4B,aNqC3C,+BKjIK,uBAA0B,CC4FY,CNqC3C,mEKvHC,eAAgB,CLuHjB,uEK/GC,eAAgB,CL+GjB,6BKrIC,kBA1CgB,eACF,CC0I0B,aNoCzC,6BKjIK,uBAA0B,CC6FU,CNoCzC,+DKvHC,eAAgB,CLuHjB,mEK/GC,eAAgB,CL+GjB,2EO/ID,YHR6C,UAAA,CJuJ5C,6BMzBD,kBF9H6C,CJuJ5C,8CGjGqB,mBCtDuB,iBAAA,CJuJ5C,6BQjKC,yDApBqD,gDAAA,CRqLtD,yCMVC,eF7I2C,CJuJ5C,gEMsBD,iBF7K6C,CJuJ5C,gFM0BD,MFjL6C,CJuJ5C,6EMgCG,iBFvLyC,CJuJ5C,6EMkDC,iBFzM2C,CJuJ5C,mFMoDG,QF3MyC,CJuJ5C,iEMsBD,kBF7K6C,CJuJ5C,iFM0BD,OFjL6C,CJuJ5C,8EMgCG,kBFvLyC,CJuJ5C,oFM0CK,OAAoB,CN1CzB,8EMkDC,kBFzM2C,CJuJ5C,oFMoDG,SF3MyC,CJuJ5C,sDMQC,YF/J2C,UAAA,CJuJ5C,0DMWG,UAAW,CNXf,eEzJE,iBAvBgB,CFgLjB,gCG5FqB,gBC3DuB,CJuJ5C,8BKrIC,kBA1CgB,eACF,CCyI4B,aNqC3C,8BKjIK,uBAA0B,CC4FY,CNqC3C,iEKvHC,eAAgB,CLuHjB,qEK/GC,eAAgB,CL+GjB,4BKrIC,kBA1CgB,eACF,CC0I0B,aNoCzC,4BKjIK,uBAA0B,CC6FU,CNoCzC,6DKvHC,eAAgB,CLuHjB,iEK/GC,eAAgB,CL+GjB,yEO/ID,YHR6C,UAAA,CJuJ5C,4BMzBD,kBF9H6C,CJuJ5C,6CGjGqB,mBCtDuB,iBAAA,CJuJ5C,4BQjKC,yDApBqD,gDAAA,CRqLtD,wCMVC,eF7I2C,CJuJ5C,+DMsBD,iBF7K6C,CJuJ5C,+EM0BD,QFjL6C,CJuJ5C,4EMkCG,iBFzLyC,CJuJ5C,4EMkDC,iBFzM2C,CJuJ5C,kFMoDG,QF3MyC,CJuJ5C,gEMsBD,kBF7K6C,CJuJ5C,gFM0BD,SFjL6C,CJuJ5C,6EMkCG,kBFzLyC,CJuJ5C,mFM0CK,OAAoB,CN1CzB,6EMkDC,kBFzM2C,CJuJ5C,mFMoDG,SF3MyC,CJuJ5C,qDMQC,YF/J2C,UAAA,CJuJ5C,yDMWG,UAAW,CNXf,sBEzJE,iBAvBgB,CFgLjB,uCG5FqB,gBC3DuB,CJuJ5C,qCKrIC,kBAtCgB,gBACD,CCqI2B,aNqC3C,qCKjIK,uBAA0B,CC4FY,CNqC3C,+EKvHC,eAAgB,CLuHjB,mFK/GC,eAAgB,CL+GjB,mCKrIC,kBAtCgB,gBACD,CCsIyB,aNoCzC,mCKjIK,uBAA0B,CC6FU,CNoCzC,2EKvHC,eAAgB,CLuHjB,+EK/GC,eAAgB,CL+GjB,uFO/ID,YHR6C,UAAA,CJuJ5C,mCMzBD,kBF9H6C,CJuJ5C,oDGjGqB,mBCtDuB,iBAAA,CJuJ5C,mCQjKC,yDApBqD,gDAAA,CRqLtD,+CMVC,eF7I2C,CJuJ5C,sEMsBD,iBF7K6C,CJuJ5C,sFM0BD,QFjL6C,CJuJ5C,mFMsCG,iBF7LyC,CJuJ5C,mFMkDC,iBFzM2C,CJuJ5C,yFMoDG,QF3MyC,CJuJ5C,uEMsBD,kBF7K6C,CJuJ5C,uFM0BD,SFjL6C,CJuJ5C,oFMsCG,kBF7LyC,CJuJ5C,0FM0CK,OAAoB,CN1CzB,oFMkDC,kBFzM2C,CJuJ5C,0FMoDG,SF3MyC,CJuJ5C,4DMQC,YF/J2C,UAAA,CJuJ5C,gEMWG,UAAW,CNXf,gBEzJE,iBAvBgB,CFgLjB,iCG5FqB,iBC3DuB,CJuJ5C,+BKrIC,kBAtCgB,gBACD,CCqI2B,aNqC3C,+BKjIK,uBAA0B,CC4FY,CNqC3C,mEKvHC,eAAgB,CLuHjB,uEK/GC,eAAgB,CL+GjB,6BKrIC,kBAtCgB,gBACD,CCsIyB,aNoCzC,6BKjIK,uBAA0B,CC6FU,CNoCzC,+DKvHC,eAAgB,CLuHjB,mEK/GC,eAAgB,CL+GjB,2EO/ID,YHR6C,UAAA,CJuJ5C,6BMzBD,kBF9H6C,CJuJ5C,8CGjGqB,mBCtDuB,iBAAA,CJuJ5C,6BQjKC,sDApBqD,6CAAA,CRqLtD,yCMVC,eF7I2C,CJuJ5C,gEMsBD,iBF7K6C,CJuJ5C,gFM0BD,QFjL6C,CJuJ5C,6EMoCG,iBF3LyC,CJuJ5C,6EMkDC,iBFzM2C,CJuJ5C,mFMoDG,SF3MyC,CJuJ5C,iEMsBD,kBF7K6C,CJuJ5C,iFM0BD,SFjL6C,CJuJ5C,8EMoCG,kBF3LyC,CJuJ5C,oFM0CK,OAAoB,CN1CzB,8EMkDC,kBFzM2C,CJuJ5C,oFMoDG,UF3MyC,CJuJ5C,sDMQC,YF/J2C,UAAA,CJuJ5C,0DMWG,UAAW,CNXf,sBEzJE,iBAvBgB,CFgLjB,uCG5FqB,iBC3DuB,CJuJ5C,qCKrIC,iBAlCe,uBACO,CCiIoB,aNqC3C,qCKjIK,uBAA0B,CC4FY,CNqC3C,+EKvHC,eAAgB,CLuHjB,mFK/GC,eAAgB,CL+GjB,mCKrIC,iBAlCe,uBACO,CCkIkB,aNoCzC,mCKjIK,uBAA0B,CC6FU,CNoCzC,2EKvHC,eAAgB,CLuHjB,+EK/GC,eAAgB,CL+GjB,uFO/ID,YHR6C,UAAA,CJuJ5C,mCMzBD,kBF9H6C,CJuJ5C,oDGjGqB,mBCtDuB,iBAAA,CJuJ5C,mCQjKC,sDApBqD,6CAAA,CRqLtD,+CMVC,eF7I2C,CJuJ5C,sEMsBD,iBF7K6C,CJuJ5C,sFM0BD,QFjL6C,CJuJ5C,mFMsCG,iBF7LyC,CJuJ5C,mFMkDC,iBFzM2C,CJuJ5C,yFMoDG,SF3MyC,CJuJ5C,uEMsBD,kBF7K6C,CJuJ5C,uFM0BD,SFjL6C,CJuJ5C,oFMsCG,kBF7LyC,CJuJ5C,0FM0CK,OAAoB,CN1CzB,oFMkDC,kBFzM2C,CJuJ5C,0FMoDG,UF3MyC,CJuJ5C,4DMQC,YF/J2C,UAAA,CJuJ5C,gEMWG,UAAW,CNXf,eEzJE,iBAvBgB,CFgLjB,gCG5FqB,iBC3DuB,CJuJ5C,8BKrIC,iBAlCe,uBACO,CCiIoB,aNqC3C,8BKjIK,uBAA0B,CC4FY,CNqC3C,iEKvHC,eAAgB,CLuHjB,qEK/GC,eAAgB,CL+GjB,4BKrIC,iBAlCe,uBACO,CCkIkB,aNoCzC,4BKjIK,uBAA0B,CC6FU,CNoCzC,6DKvHC,eAAgB,CLuHjB,iEK/GC,eAAgB,CL+GjB,yEO/ID,YHR6C,UAAA,CJuJ5C,4BMzBD,kBF9H6C,CJuJ5C,6CGjGqB,mBCtDuB,iBAAA,CJuJ5C,4BQjKC,sDApBqD,6CAAA,CRqLtD,wCMVC,eF7I2C,CJuJ5C,+DMsBD,iBF7K6C,CJuJ5C,+EM0BD,SFjL6C,CJuJ5C,4EMsCG,iBF7LyC,CJuJ5C,4EMkDC,iBFzM2C,CJuJ5C,kFMoDG,SF3MyC,CJuJ5C,gEMsBD,kBF7K6C,CJuJ5C,gFM0BD,UFjL6C,CJuJ5C,6EMsCG,kBF7LyC,CJuJ5C,mFM0CK,OAAoB,CN1CzB,6EMkDC,kBFzM2C,CJuJ5C,mFMoDG,UF3MyC,CJuJ5C,qDMQC,YF/J2C,UAAA,CJuJ5C,yDMWG,UAAW,CNXf,gBEzJE,iBAvBgB,CFgLjB,iCG5FqB,sBC3DuB,CJuJ5C,+BKrIC,mEAAA,kBA7BgB,wBACS,CC4HiB,aNqC3C,+BKjIK,uBAA0B,CC4FY,CNqC3C,mEKzHC,eAAgB,CLyHjB,uEKjHC,eAAgB,CLiHjB,6BKrIC,mEAAA,kBA7BgB,wBACS,CC6He,aNoCzC,6BKjIK,uBAA0B,CC6FU,CNoCzC,+DKzHC,eAAgB,CLyHjB,mEKjHC,eAAgB,CLiHjB,2EO/ID,YHR6C,UAAA,CJuJ5C,6BMzBD,kBF9H6C,CJuJ5C,8CGjGqB,mBCtDuB,iBAAA,CJuJ5C,6BQjKC,sDApBqD,6CAAA,CRqLtD,yCMVC,eF7I2C,CJuJ5C,6CMNK,UFjJuC,CJuJ5C,gEMsBD,iBF7K6C,CJuJ5C,gFM0BD,QFjL6C,CJuJ5C,6EMsCG,iBF7LyC,CJuJ5C,6EMkDC,iBFzM2C,CJuJ5C,mFMoDG,SF3MyC,CJuJ5C,iEMsBD,kBF7K6C,CJuJ5C,iFM0BD,SFjL6C,CJuJ5C,8EMsCG,kBF7LyC,CJuJ5C,oFM0CK,OAAoB,CN1CzB,8EMkDC,kBFzM2C,CJuJ5C,oFMoDG,UF3MyC,CJuJ5C,sDMQC,YF/J2C,UAAA,CJuJ5C,0DMWG,UAAW,CNXf,iBEzJE,iBAvBgB,CFgLjB,kCG5FqB,sBC3DuB,CJuJ5C,gCKrIC,mEAAA,iBAxBe,eACD,CCuH4B,aNqC3C,gCKjIK,wBAA0B,CC4FY,CNqC3C,qEKzHC,eAAgB,CLyHjB,yEKjHC,eAAgB,CLiHjB,8BKrIC,mEAAA,iBAxBe,eACD,CCwH0B,aNoCzC,8BKjIK,wBAA0B,CC6FU,CNoCzC,iEKzHC,eAAgB,CLyHjB,qEKjHC,eAAgB,CLiHjB,6EO/ID,YHR6C,UAAA,CJuJ5C,8BMzBD,kBF9H6C,CJuJ5C,+CGjGqB,mBCtDuB,iBAAA,CJuJ5C,8BQjKC,sDApBqD,6CAAA,CRqLtD,0CMVC,eF7I2C,CJuJ5C,iEMsBD,iBF7K6C,CJuJ5C,iFM0BD,SFjL6C,CJuJ5C,8EMsCG,iBF7LyC,CJuJ5C,8EMkDC,iBFzM2C,CJuJ5C,oFMoDG,SF3MyC,CJuJ5C,kEMsBD,kBF7K6C,CJuJ5C,kFM0BD,UFjL6C,CJuJ5C,+EMsCG,kBF7LyC,CJuJ5C,qFM0CK,OAAoB,CN1CzB,+EMkDC,kBFzM2C,CJuJ5C,qFMoDG,UF3MyC,CJuJ5C,uDMQC,YF/J2C,UAAA,CJuJ5C,2DMWG,UAAW,CNNjB,yEAEC,SAAU,CACV,kBOvJC,YPgKoB,UAAA,CA3DxB,iCCtGE,kBDuK2B,QAAK,SAAO,OAAE,mCACrC,+BAAA,0BAA2B,CAlEjC,qCAqEQ,WAAY,CArEpB,8CA2EI,SAAU,CA3Ed,qBAiFE,gIAAA,wHAAA,2GAAA,wGAAA,qNACE,YAAa,CACf,iCAGA,uCAAwC,wBACd,CAF1B,mEG9HE,SA9DiB,CH4LnB,6GASC,gBI3M8C,CJ4M9C,mBAIC,mEACA,yBAA0B,CAC3B,oBAGC,yBAA2B,CAC5B","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Button Component\n */\n\n@import \"./mixins\";\n\n/* button reset */\nbutton {\n\tbackground: none;\n\tborder: 0;\n\tcolor: inherit;\n\tcursor: pointer;\n\tfont: inherit;\n\tline-height: normal;\n\toverflow: visible;\n\tpadding: 0;\n\tuser-select: none;\n\tsvg {\n\t\tdisplay: block;\n\t}\n\t&::-moz-focus-inner {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t}\n\t&:focus {\n\t\toutline: 0;\n\t}\n\n\t&[disabled]{\n\t\tcursor: not-allowed;\n\t}\n}\n\na.button{\n\tdisplay: inline-block;\n  &:not([class*=\"color-scheme\"]) {\n    color: inherit;\n  }\n}\n\n.button{\n\ttext-decoration: none;\n  border: 1px solid transparent;\n\n  &.color-scheme--black-outline {\n    border-color: black;\n  }\n\n\t&__flex, &__wrapper{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 100%;\n\t}\n\n\t&__active-background{\n    @include position(absolute, baseline(.375) 0);\n    @include bgsize(small);\n  }\n\n  &.button--is-active .button__active-background {\n    &::after {\n      content: \"\";\n      position: absolute;\n      left: 6px;\n      bottom: 3px;\n      right: 6px;\n      height: 3px;\n      background: color(accent);\n      border-radius: 3px;\n\n      animation: button-active-indicator-appear .2s ease-in-out;\n\t\t\ttransform-origin: left;\n\n\t\t\t@keyframes button-active-indicator-appear {\n\t\t\t\t0% { transform: scaleX(0%); opacity: 0; }\n\t\t\t\t100% { transform: scaleX(100%); opacity: 1; }\n      }\n    }\n  }\n\n\t@each $button-size, $options in $button-sizes {\n    &--#{$button-size} {\n\t\t\t@include button-for-size(map-merge($options, (size: $button-size)));\n\t\t}\n\t}\n\n\t&--icon, &--icon-no-padding{\n\t\t.button__wrapper{\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t&--icon{\n\t\t// .button__icon{\n\t\t// \t@include position(absolute, 50% null null 50%);\n\t\t// \ttransform: translate(-50%, -50%);\n    // }\n    svg{\n      @include size(100%);\n    }\n\t}\n\n\t&.with--icon{\n\t\t.button__icon{\n\t\t\t@include position(absolute, 50% null 0 0);\n      transform: translateY(-50%);\n\n      svg{\n        height: 100%;\n      }\n\t\t}\n\n\t\t&.icon-position--right{\n\t\t\t.icon{\n\t\t\t\tleft: auto;\n\t\t\t}\n\t\t}\n\t}\n\n  &.with--shadow{\n\t\ttransition: transform 5s $ease-out-back, box-shadow .5s $ease-in-out-sine;\n    z-index: auto;\n\t}\n\n\t&--text, &--hyperlink{\n\t\tbackground-color: transparent !important;\n\t\tborder-width: 0 !important;\n\n\t\t.button__wrapper{\n\t\t\t@include padding(0);\n\t\t}\n\n\t\t&.with--icon:not(.icon-position--right){\n\t\t\tmargin-left: baseline(-.5); // compensate icon inner padding\n\t\t}\n  }\n\n  &--hyperlink{\n    font-family: $font--articulat;\n    text-decoration: underline;\n  }\n\n  &--submitting{\n    cursor: progress !important;\n  }\n}\n\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","/**\n * Button Component\n */\n\n@import \"../../text/Label/mixins\";\n\n/* Definitions */\n$button-sizes: (\n  xxsmall: (\n    height: 3,\n    h-padding: 1,\n    label: xsmall,\n    bg: small,\n    shadow: small,\n    icon: (\n      offset: 0,\n      h-padding: 3.25,\n      min-height: 2.5,\n    ),\n  ),\n  xsmall: (\n    height: 3,\n    h-padding: 1,\n    label: small,\n    bg: medium,\n    shadow: small,\n    icon: (\n      offset: 0,\n      h-padding: 3.25,\n      min-height: 2.5,\n    ),\n  ),\n  small: (\n    height: 4,\n    h-padding: 1.5,\n    label: small,\n    bg: medium,\n    shadow: small,\n    icon: (\n      offset: .5,\n      h-padding: 4,\n      min-height: 3.5,\n    ),\n  ),\n  small-medium: (\n    height: 4.5,\n    h-padding: 1.5,\n    label: medium,\n    bg: medium,\n    shadow: small,\n    icon: (\n      offset: .25,\n      h-padding: 4,\n      min-height: 3.5,\n    ),\n  ),\n  medium: (\n    height: 5,\n    h-padding: 2,\n    label: medium,\n    bg: medium,\n    shadow: medium,\n    icon: (\n      offset: 1,\n      h-padding: 4.75,\n      min-height: 3.5,\n    ),\n  ),\n  medium-large: (\n    height: 5,\n    h-padding: 2,\n    label: large,\n    bg: medium,\n    shadow: medium,\n    icon: (\n      offset: 1,\n      h-padding: 4.75,\n      min-height: 3.5,\n    ),\n  ),\n  large: (\n    height: 6,\n    h-padding: 2.5,\n    label: large,\n    bg: medium,\n    shadow: large,\n    icon: (\n      offset: 1.5,\n      h-padding: 5.5,\n      min-height: 3.5,\n    ),\n  ),\n  xlarge: (\n    height: 6,\n    h-padding: 3,\n    label: xlarge,\n    bg: medium,\n    shadow: large,\n    icon: (\n      offset: 1,\n      h-padding: 6,\n      min-height: 3.5,\n    ),\n    v-padding-fix: true,\n  ),\n  xxlarge: (\n    height: 8,\n    h-padding: 4,\n    label: xxlarge,\n    bg: medium,\n    shadow: large,\n    icon: (\n      offset: 2.5,\n      h-padding: 7.5,\n      min-height: 3.5,\n    ),\n    v-padding-fix: true,\n  ),\n);\n\n/* Mixins */\n$default-button-size-options: map-get($button-sizes, medium);\n@mixin button-for-size($options) {\n  $options: map-merge($default-button-size-options, $options);\n  $size: map-get($options, size);\n  $height: map-get($options, height);\n  $h-padding: map-get($options, h-padding);\n  $label: map-get($options, label);\n  $bg: map-get($options, bg);\n  $shadow: map-get($options, shadow);\n  $icon: map-get($options, icon);\n  $v-padding-fix: map-get($options, v-padding-fix);\n\n  $computed-height: baseline($height);\n  $label-height: get-label-height($label);\n  $padding: ceil(($computed-height - $label-height - 2) / 2);\n\n  @include bgsize($bg);\n\n  .button__wrapper{\n    @include padding(null baseline($h-padding));\n\n    @if $v-padding-fix {\n      @include padding($padding - 1 null $padding + 1);\n    } @else {\n      @include padding($padding null);\n    }\n  }\n\n  .button__label{ @include label-size($label) }\n  .description{ @include label-size($label) }\n\n  &.button--icon{\n    @include size($computed-height);\n\n    .button__wrapper{\n      @include size($computed-height);\n    }\n  }\n\n  &.button--pill{\n    border-radius: baseline($height / 2);\n\n    .button__wrapper{\n      @include padding(null baseline($h-padding + .75));\n    }\n  }\n\n  &.with--shadow{\n    @include shadow($shadow)\n  }\n\n  &.with--icon{\n    $min-height: map-get($icon, min-height);\n\n    .button__icon{\n      min-height: baseline($min-height);\n\n      @if $size == 'xlarge' {\n        svg{\n          width: baseline(4.5);\n        }\n      }\n    }\n\n    &.icon-position{\n      &--left{ @include button-with-icon(left, $size, $icon)}\n      &--right{ @include button-with-icon(right, $size, $icon)}\n    }\n  }\n\n  &.button--text.with--icon{\n    $height: map-get($icon, min-height);\n    .button__icon{\n      height: baseline($height);\n      width: baseline($height);\n      svg{\n        width: 100%;\n      }\n    }\n  }\n}\n\n@mixin button-with-icon($icon-position, $button-size, $icon-settings) {\n  $icon-offset: map-get($icon-settings, offset);\n  $h-padding: map-get($icon-settings, h-padding);\n\n  .button__wrapper{\n    padding-#{$icon-position}: baseline($h-padding);\n  }\n\n  &:not(.button--text) .button__icon{\n    #{$icon-position}: baseline($icon-offset);\n  }\n\n  &.button--text{\n    .button__wrapper{\n      @if $button-size == 'xsmall' {\n        padding-#{$icon-position}: baseline(3);\n      } @else if $button-size == 'small' {\n        padding-#{$icon-position}: baseline(3.25);\n      } @else if $button-size == 'medium' {\n        padding-#{$icon-position}: baseline(3.5);\n      } @else {\n        padding-#{$icon-position}: baseline(4);\n      }\n      .icon{\n        @if $icon-position == 'right' {\n          #{$icon-position}: 0;\n        }\n      }\n    }\n  }\n\n  &.button--pill{\n    .button__wrapper{\n      padding-#{$icon-position}: baseline($h-padding + .5);\n      .icon{\n        #{$icon-position}: baseline($icon-offset + .5);\n      }\n    }\n\n  }\n}\n\n@function get-button-height($size) {\n  @if map-has-key($button-sizes, $size) {\n    $button-size: map-get($button-sizes, $size);\n    @return map-get($button-size, height);\n  }\n  @return null;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.description,.label,.note{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out}.description--xsmall,.label--xsmall,.note--xsmall{font-size:.625em;line-height:1.2}@media print{.description--xsmall,.label--xsmall,.note--xsmall{font-size:.5208333331em}}.description--xsmall em,.description--xsmall i,.label--xsmall em,.label--xsmall i,.note--xsmall em,.note--xsmall i{font-weight:300}.description--xsmall b,.description--xsmall strong,.label--xsmall b,.label--xsmall strong,.note--xsmall b,.note--xsmall strong{font-weight:700}.description--small,.label--small,.note--small{font-size:.6875em;line-height:1.1}@media print{.description--small,.label--small,.note--small{font-size:.5729166664em}}.description--small em,.description--small i,.label--small em,.label--small i,.note--small em,.note--small i{font-weight:300}.description--small b,.description--small strong,.label--small b,.label--small strong,.note--small b,.note--small strong{font-weight:700}.description--medium,.label--medium,.note--medium{font-size:.8125em;line-height:1.34}@media print{.description--medium,.label--medium,.note--medium{font-size:.6770833331em}}.description--medium em,.description--medium i,.label--medium em,.label--medium i,.note--medium em,.note--medium i{font-weight:300}.description--medium b,.description--medium strong,.label--medium b,.label--medium strong,.note--medium b,.note--medium strong{font-weight:700}.description--large,.label--large,.note--large{font-size:.875em;line-height:1.142857143}@media print{.description--large,.label--large,.note--large{font-size:.7291666664em}}.description--large em,.description--large i,.label--large em,.label--large i,.note--large em,.note--large i{font-weight:300}.description--large b,.description--large strong,.label--large b,.label--large strong,.note--large b,.note--large strong{font-weight:700}.description--xlarge,.label--xlarge,.note--xlarge{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.125em;line-height:1.3333333333}@media print{.description--xlarge,.label--xlarge,.note--xlarge{font-size:.9374999996em}}.description--xlarge em,.description--xlarge i,.label--xlarge em,.label--xlarge i,.note--xlarge em,.note--xlarge i{font-weight:400}.description--xlarge b,.description--xlarge strong,.label--xlarge b,.label--xlarge strong,.note--xlarge b,.note--xlarge strong{font-weight:500}.description--xxlarge,.label--xxlarge,.note--xxlarge{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.25em;line-height:1.2}@media print{.description--xxlarge,.label--xxlarge,.note--xxlarge{font-size:1.0416666663em}}.description--xxlarge em,.description--xxlarge i,.label--xxlarge em,.label--xxlarge i,.note--xxlarge em,.note--xxlarge i{font-weight:400}.description--xxlarge b,.description--xxlarge strong,.label--xxlarge b,.label--xxlarge strong,.note--xxlarge b,.note--xxlarge strong{font-weight:500}.description small,.label small,.note small{font-style:italic;display:block;font-size:.8333em}.description small:not([class*=color--]),.label small:not([class*=color--]),.note small:not([class*=color--]){color:#b1b8c4}.note{font-style:italic}.note:not([class*=color--]){color:#b1b8c4}.description{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_fonts.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,0BC0BpE,mCAJqC,kCAKH,aC/BvB,8CACb,yCAAA,qCAAsC,CCkEpC,kDD5DE,iBA9Ce,eACD,CCyGwC,aAAxD,kDDxDM,uBAA0B,CCwDwB,CAAvD,mHD9CC,eAAgB,CC8CjB,+HDtCC,eAAgB,CCsClB,+CD5DE,kBA1CgB,eACF,CCqGwC,aAAxD,+CDxDM,uBAA0B,CCwDwB,CAAvD,6GD9CC,eAAgB,CC8CjB,yHDtCC,eAAgB,CCsClB,kDD5DE,kBAtCgB,gBACD,CCiGuC,aAAxD,kDDxDM,uBAA0B,CCwDwB,CAAvD,mHD9CC,eAAgB,CC8CjB,+HDtCC,eAAgB,CCsClB,+CD5DE,iBAlCe,uBACO,CC6FgC,aAAxD,+CDxDM,uBAA0B,CCwDwB,CAAvD,6GD9CC,eAAgB,CC8CjB,yHDtCC,eAAgB,CCsClB,kDD5DE,mEAAA,kBA7BgB,wBACS,CCwF6B,aAAxD,kDDxDM,uBAA0B,CCwDwB,CAAvD,mHDhDC,eAAgB,CCgDjB,+HDxCC,eAAgB,CCwClB,qDD5DE,mEAAA,iBAxBe,eACD,CCmFwC,aAAxD,qDDxDM,wBAA0B,CCwDwB,CAAvD,yHDhDC,eAAgB,CCgDjB,qIDxCC,eAAgB,CCqCtB,4CD1BE,kBCkCE,cAAc,iBACI,CATtB,8GC7BI,aAxEuB,CDiH3B,MDtCE,iBAAkB,CCsCpB,4BCzCI,aAxEuB,CDkH3B,aDnCE,kEGpF8E,CFyH/E","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Labels\n */\n\n@import \"./mixins\";\n\n.label, .note, .description{\n  @include label;\n  @each $label-size,$value in $label-sizes {\n    &--#{$label-size} {  @include label-size($label-size) }\n  }\n\n  small{\n    @include note;\n    display: block;\n    font-size: .8333em;\n  }\n}\n.note{ @include note }\n.description{\n  @include description;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Fonts\n **/\n\n$font--articulat: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--space-mono: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--default: $font--articulat;\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 976 */,
/* 977 */,
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".loading-spinner{display:block;-webkit-animation:loading-spinner 1s linear infinite;animation:loading-spinner 1s linear infinite}.loading-spinner--small .loading-spinner__icon{height:24px;width:24px;border-width:1px}.loading-spinner--medium .loading-spinner__icon{height:56px;width:56px;border-width:2px}.loading-spinner--large .loading-spinner__icon{height:128px;width:128px;border-width:3px}.loading-spinner__icon{border-style:solid;border-color:transparent;border-radius:50%}.loading-spinner__centered-wrapper{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loading-spinner__centered-wrapper--fixed{position:fixed}.loading-spinner--black .loading-spinner__icon,.loading-spinner--bw8 .loading-spinner__icon,.loading-spinner--dark .loading-spinner__icon{border-top-color:#101015;border-left-color:#101015}.loading-spinner--bw7 .loading-spinner__icon{border-top-color:#8a8f99;border-left-color:#8a8f99}.loading-spinner--bw6 .loading-spinner__icon{border-top-color:#b1b8c4;border-left-color:#b1b8c4}.loading-spinner--bw5 .loading-spinner__icon{border-top-color:#d2d9e1;border-left-color:#d2d9e1}.loading-spinner--bw4 .loading-spinner__icon{border-top-color:#e4e8ed;border-left-color:#e4e8ed}.loading-spinner--bw3 .loading-spinner__icon{border-top-color:#f0f6fa;border-left-color:#f0f6fa}.loading-spinner--bw2 .loading-spinner__icon{border-top-color:#f9fafb;border-left-color:#f9fafb}.loading-spinner--bw1 .loading-spinner__icon,.loading-spinner--white .loading-spinner__icon{border-top-color:#fff;border-left-color:#fff}.loading-spinner--accent .loading-spinner__icon{border-top-color:#4487ff;border-left-color:#4487ff}.loading-spinner--accent-subtle .loading-spinner__icon{border-top-color:#f5faff;border-left-color:#f5faff}.loading-spinner--accent-subtle2 .loading-spinner__icon{border-top-color:#f0f6fa;border-left-color:#f0f6fa}.loading-spinner--accent2 .loading-spinner__icon{border-top-color:#735aff;border-left-color:#735aff}.loading-spinner--dangerous .loading-spinner__icon{border-top-color:#f75b5b;border-left-color:#f75b5b}.loading-spinner--dangerous-subtle .loading-spinner__icon{border-top-color:#fff5f5;border-left-color:#fff5f5}.loading-spinner--positive .loading-spinner__icon{border-top-color:#75dbbe;border-left-color:#75dbbe}.loading-spinner--positive-subtle .loading-spinner__icon{border-top-color:#e8faf5;border-left-color:#e8faf5}.loading-spinner--default .loading-spinner__icon{border-top-color:#101015;border-left-color:#101015}.loading-spinner--none .loading-spinner__icon,.loading-spinner--transparent .loading-spinner__icon{border-top-color:transparent;border-left-color:transparent}@-webkit-keyframes loading-spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/LoadingSpinner/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/LoadingSpinner/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA8GA,iBAIE,cAAc,qDACd,4CAA6C,CAG1C,+CC3ED,YAMA,WCd6C,gBC7B5B,CHgHhB,gDC3ED,YAMA,WCd6C,gBCzB5B,CH4GhB,+CC3ED,aAMA,YCd6C,gBCrB5B,CH6GnB,uBACE,mBAAmB,yBACM,iBACP,CACnB,mCIrFD,kBJwF4B,QAAK,SAAc,uCAC7C,mCAAA,8BAAgC,CAChC,0CACE,cAAe,CAChB,0IAKC,yBACA,yBKxIoB,CLsItB,6CACE,yBACA,yBKtIkB,CLoIpB,6CACE,yBACA,yBKnIqB,CLiIvB,6CACE,yBACA,yBKlIiB,CLgInB,6CACE,yBACA,yBKjIqB,CL+HvB,6CACE,yBACA,yBK5HqB,CL0HvB,6CACE,yBACA,yBK/HoB,CL6HtB,4FACE,sBACA,sBK1GQ,CLwGV,gDACE,yBACA,yBK9HqB,CL4HvB,uDACE,yBACA,yBK7HoB,CL2HtB,wDACE,yBACA,yBK5HqB,CL0HvB,iDACE,yBACA,yBKvH0B,CLqH5B,mDACE,yBACA,yBK3HoB,CLyHtB,0DACE,yBACA,yBK1HkB,CLwHpB,kDACE,yBACA,yBKzHkB,CLuHpB,yDACE,yBACA,yBKxHgB,CLsHlB,iDACE,yBACA,yBKxIoB,CLsItB,mGACE,6BACA,6BK/Fa,CLgGd,mCAKH,GAAO,+BAAA,sBAAuB,CAAA,GACvB,gCAAA,uBAAyB,CAAA,CAFlC,2BACE,GAAO,+BAAA,sBAAuB,CAAA,GACvB,gCAAA,uBAAyB,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LoadingSpinner Component\n */\n\n@import './mixins';\n\n.loading-spinner {\n  // top: 50%;\n  // left: 50%;\n  // transform: translate(-50%, -50%);\n  display: block;\n  animation: loading-spinner 1s linear infinite;\n\n  @each $loading-spinner-size, $options in $loading-spinner-sizes {\n    &--#{$loading-spinner-size} {\n\t\t\t@include loading-spinner-for-size($options);\n\t\t}\n\t}\n\n  &__icon {\n    border-style: solid;\n    border-color: transparent;\n    border-radius: 50%;\n  }\n\n  &__centered-wrapper{\n    @include position(absolute, 50% null null 50%);\n    transform: translate(-50%, -50%);\n    &--fixed{\n      position: fixed;\n    }\n  }\n\n  @each $key, $color in $colors {\n    &--#{$key} &__icon {\n      border-top-color: $color;\n      border-left-color: $color;\n    }\n  }\n}\n\n@keyframes loading-spinner {\n  0%   { transform: rotate(0deg) }\n  100% { transform: rotate(360deg) }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * LoadingSpinner Component\n */\n\n$loading-spinner-sizes: (\n  small: (\n    border-width: 1px,\n    size: 3,\n  ),\n  medium: (\n    border-width: 2px,\n    size: 7,\n  ),\n  large: (\n    border-width: 3px,\n    size: 16,\n  ),\n);\n\n$default-loading-spinner-size-options: map-get($loading-spinner-sizes, medium);\n@mixin loading-spinner-for-size($options) {\n  $options: map-merge($default-loading-spinner-size-options, $options);\n  $border-width: map-get($options, border-width);\n  $size: map-get($options, size);\n\n  .loading-spinner__icon {\n    @include size(baseline($size));\n    border-width: $border-width;\n  }\n}\n\n\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page__header{position:fixed;top:64px;right:0;left:0;padding-right:12px;padding-left:16px;background-color:#fff;height:56px;-webkit-box-flex:0;-ms-flex:none;flex:none;z-index:2;-webkit-box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2);box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2)}.page__header__fixed-guard{height:56px}.page__header__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.page__header__title__dash{width:32px;height:1px;background-color:#101015;margin-right:8px}.page__header__actions{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:auto}.page__header__actions .button[disabled]{background:none}@media print{.page__header,.page__header__fixed-guard{display:none}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/blocks/PageHeader/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,cClEE,eDmEuB,SC/DnB,QD+DyC,OAAO,mBE1EL,kBAAA,sBF6E/C,YACA,mBAAA,cAAA,UAAU,UACA,sDACV,6CAA8D,CAE9D,2BACE,WEnF6C,CFoF9C,uBAGC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,YACP,mBACZ,cAAA,SAAU,CACX,2BAIG,WACA,WAAW,yBAEX,gBElG2C,CFmG5C,uBAID,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,gBACF,CAHlB,yCAMG,eAAgB,CACjB,aApCL,yCAyCM,YAAa,CACd,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * PageHeader Component\n */\n\n.page__header {\n  @include position(fixed, $app-header-height 0 null 0);\n  @include padding(null baseline(1.5) null baseline(2));\n  @include bgcolor(white);\n  height: $page-header-height;\n  flex: none;\n  z-index: 2;\n  box-shadow: 0 2px 8px -3px transparentize(uicolor(shadow), .8);\n\n  &__fixed-guard{\n    height: $page-header-height;\n  }\n\n  &__content {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    flex: auto;\n  }\n\n  &__title{\n    &__dash{\n      width: baseline(4);\n      height: 1px;\n      @include bgcolor(dark);\n      margin-right: baseline(1);\n    }\n  }\n\n  &__actions{\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n\n    .button[disabled] {\n      background: none;\n    }\n  }\n\n  @media print{\n    &, &__fixed-guard{\n      display: none;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out}.h1 .label,.h2 .label,.h3 .label,.h4 .label,.h5 .label,.h6 .label,h1 .label,h2 .label,h3 .label,h4 .label,h5 .label,h6 .label{display:inline-block}h1{font-size:2em;font-weight:300;line-height:1;margin:16px 0}@media screen and (min-width:600px){h1{font-size:2.5em}}@media screen and (min-width:864px){h1{font-size:3em}}@media screen and (min-width:1280px){h1{font-size:4em}}@media print{h1{font-size:3em}}h2{font-size:2.000001em;font-weight:400;line-height:1;margin:16px 0}@media screen and (min-width:864px){h2{font-size:2.499999em}}@media screen and (min-width:1280px){h2{font-size:3em}}h3{font-size:1.25em;font-weight:400;line-height:1.125;margin:8px 0}@media screen and (min-width:600px){h3{font-size:1.5em;font-weight:300}}@media screen and (min-width:864px){h3{font-size:2em;margin:16px 0}}h4{font-size:1em;font-weight:400;line-height:1.142857143;margin:8px 0}@media screen and (min-width:600px){h4{font-size:1.1249999998em;margin:16px 0}}@media screen and (min-width:864px){h4{font-size:1.3125em}}@media print{h4{font-size:1.1249999998em}}h5{font-size:.8125em;font-weight:400;line-height:1.230769231;margin:8px 0}@media screen and (min-width:600px){h5{font-size:.9375em;line-height:1.3333333333;margin:16px 0}}h6{font-size:.75em;font-weight:500;line-height:1.3333333333;margin:8px 0;text-transform:uppercase;letter-spacing:.3em}@media screen and (min-width:600px){h6{margin:16px 0}}.h1{font-size:2em;font-weight:300;line-height:1}@media screen and (min-width:600px){.h1{font-size:2.5em}}@media screen and (min-width:864px){.h1{font-size:3em}}@media screen and (min-width:1280px){.h1{font-size:4em}}@media print{.h1{font-size:3em}}.h2{font-size:2.000001em;font-weight:400;line-height:1}@media screen and (min-width:864px){.h2{font-size:2.499999em}}@media screen and (min-width:1280px){.h2{font-size:3em}}.h3{font-size:1.25em;font-weight:400;line-height:1.125}@media screen and (min-width:600px){.h3{font-size:1.5em;font-weight:300}}@media screen and (min-width:864px){.h3{font-size:2em}}.h4{font-size:1em;font-weight:400;line-height:1.142857143}@media screen and (min-width:600px){.h4{font-size:1.1249999998em}}@media screen and (min-width:864px){.h4{font-size:1.3125em}}@media print{.h4{font-size:1.1249999998em}}.h5{font-size:.8125em;font-weight:400;line-height:1.230769231}@media screen and (min-width:600px){.h5{font-size:.9375em;line-height:1.3333333333}}.h6{font-size:.75em;font-weight:500;line-height:1.3333333333;text-transform:uppercase;letter-spacing:.3em}.heading--no-margin{margin:0}.heading .icon{display:inline-block;vertical-align:middle;margin-right:4px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/styles.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,0CC0BpE,mCAJqC,kCAKH,mEChEpC,8CAAA,yCAAA,qCAAsC,CCqGxC,8HDlGI,oBAAqB,CCqGvB,GD/FA,cAA8B,gBACd,cACF,aAGS,CC0FyB,oCAAhD,GDtFE,eAAgC,CCsFc,CAAA,oCAAhD,GDnFE,aAA+B,CCmFe,CAAA,qCAAhD,GDhFE,aAjBiB,CCiG6B,CAAA,aAAhD,GD5EE,aAA+B,CC4Ee,CAAhD,GDtEA,qBAAmC,gBACnB,cACF,aAGS,CCiEyB,oCAAhD,GD7DE,oBAAmC,CC6DW,CAAA,qCAAhD,GD1DE,aAdiB,CCwE6B,CAAhD,GDpDA,iBAAgC,gBAChB,kBACE,YAGK,CC+CyB,oCAAhD,GD3CE,gBAA+B,eACf,CC0C8B,CAAA,oCAAhD,GDtCE,cAhBiB,aAmBM,CCmCuB,CAAhD,GD5BA,cAAc,gBACE,wBACQ,YAGD,CCuByB,oCAAhD,GDnBE,yBAAsC,aAGf,CCgBuB,CAAA,oCAAhD,GDXE,kBAnBsB,CC8BwB,CAAA,aAAhD,GDPE,wBAAsC,CCOQ,CAAhD,GDDA,kBAAkB,gBACF,wBACQ,YAGD,CCJyB,oCAAhD,GDQE,kBAXqB,yBAYI,aAGF,CCZuB,CAAhD,GDmBA,gBAFqB,gBAGL,yBACS,aAGF,yBAGE,mBACL,CC5B4B,oCAAhD,GDgCI,aAAqB,CChCuB,CAAA,ID/FhD,cAA8B,gBACd,aACF,CCgGwC,oCAAtD,IDzFE,eAAgC,CCyFoB,CAAA,oCAAtD,IDtFE,aAA+B,CCsFqB,CAAA,qCAAtD,IDnFE,aAjBiB,CCoGmC,CAAA,aAAtD,ID/EE,aAA+B,CC+EqB,CAAtD,IDzEA,qBAAmC,gBACnB,aACF,CCuEwC,oCAAtD,IDhEE,oBAAmC,CCgEiB,CAAA,qCAAtD,ID7DE,aAdiB,CC2EmC,CAAtD,IDvDA,iBAAgC,gBAChB,iBACE,CCqDoC,oCAAtD,ID9CE,gBAA+B,eACf,CC6CoC,CAAA,oCAAtD,IDzCE,aAhBiB,CCyDmC,CAAtD,ID/BA,cAAc,gBACE,uBACQ,CC6B8B,oCAAtD,IDtBE,wBAAsC,CCsBc,CAAA,oCAAtD,IDdE,kBAnBsB,CCiC8B,CAAA,aAAtD,IDVE,wBAAsC,CCUc,CAAtD,IDJA,kBAAkB,gBACF,uBACQ,CCE8B,oCAAtD,IDKE,kBAXqB,wBAYI,CCN2B,CAAtD,IDgBA,gBAFqB,gBAGL,yBACS,yBAMA,mBACL,CCzBkC,oBAKpD,QAAS,CAFb,eAMI,qBAAqB,sBACC,gBF/FuB,CEiG9C","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Headings\n */\n\n@import \"./mixins\";\n\n$headings: h1, h2, h3, h4, h5, h6;\n\n$simulated-headings: \".h1\", \".h2\", \".h3\", \".h4\", \".h5\", \".h6\";\n\n#{$headings}, #{$simulated-headings} { @include base-heading }\n\n@each $heading in $headings {\n  #{$heading}{ @include heading-proxy($heading) }\n}\n@each $heading in $simulated-headings {\n  #{$heading}{ @include heading-proxy($heading, true) }\n}\n\n.heading{\n  &--no-margin{\n    margin: 0;\n  }\n\n  .icon{\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: baseline(.5);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1139);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".select__label{margin-bottom:8px;display:block}.select__note{position:absolute;top:1px;right:2px}.select--small.select-color-scheme--light .Select{position:relative}.select--small.select-color-scheme--light .Select input::-webkit-contacts-auto-fill-button,.select--small.select-color-scheme--light .Select input::-webkit-credentials-auto-fill-button{display:none!important}.select--small.select-color-scheme--light .Select input::-ms-clear,.select--small.select-color-scheme--light .Select input::-ms-reveal{display:none!important}.select--small.select-color-scheme--light .Select,.select--small.select-color-scheme--light .Select div,.select--small.select-color-scheme--light .Select input,.select--small.select-color-scheme--light .Select span{-webkit-box-sizing:border-box;box-sizing:border-box}.select--small.select-color-scheme--light .Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}.select--small.select-color-scheme--light .Select.is-disabled>.Select-control{background-color:#fff}.select--small.select-color-scheme--light .Select.is-disabled>.Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--light .Select.is-searchable.is-focused:not(.is-open)>.Select-control,.select--small.select-color-scheme--light .Select.is-searchable.is-open>.Select-control{cursor:text}.select--small.select-color-scheme--light .Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#f9fafb;border-color:#b3bfcd #d2d9e1 #e1e6eb}.select--small.select-color-scheme--light .Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #101015;border-width:0 4px 4px}.select--small.select-color-scheme--light .Select.is-focused>.Select-control{background:#f9fafb}.select--small.select-color-scheme--light .Select.is-focused:not(.is-open)>.Select-control{border-color:#4487ff #5e97ff #5e97ff;-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--light .Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:35px}.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.select--small.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#101015}.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.select--small.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.select--small.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#4487ff;outline:none;text-decoration:underline}.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#f9fafb}.select--small.select-color-scheme--light .Select.has-value.is-pseudo-focused .Select-input{opacity:0}.select--small.select-color-scheme--light .Select.is-open .Select-arrow,.select--small.select-color-scheme--light .Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#b1b8c4}.select--small.select-color-scheme--light .Select.Select--rtl{direction:rtl;text-align:right}.select--small.select-color-scheme--light .Select-control{background-color:#f9fafb;border-color:#e1e6eb #d2d9e1 #b3bfcd;border-radius:2px;border:1px solid #d2d9e1;color:#101015;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:32px;outline:none;overflow:hidden;position:relative;width:100%}.select--small.select-color-scheme--light .Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--light .Select-control .Select-input:focus{outline:none;background:#f9fafb}.select--small.select-color-scheme--light .Select--single>.Select-control .Select-value,.select--small.select-color-scheme--light .Select-placeholder{bottom:0;color:#b1b8c4;left:0;line-height:30px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.select--small.select-color-scheme--light .Select-input{height:30px;padding-left:10px;padding-right:10px;vertical-align:middle}.select--small.select-color-scheme--light .Select-input>input{background:none transparent;border:0 none;-webkit-box-shadow:none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:6px 0 10px;-webkit-appearance:none}.is-focused .select--small.select-color-scheme--light .Select-input>input{cursor:text}.select--small.select-color-scheme--light .Select-control:not(.is-searchable)>.Select-input{outline:none}.select--small.select-color-scheme--light .Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}.select--small.select-color-scheme--light .Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;width:16px;height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;border:2px solid #d2d9e1;border-right-color:#101015;display:inline-block;position:relative;vertical-align:middle}.select--small.select-color-scheme--light .Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#b1b8c4;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:15px}.select--small.select-color-scheme--light .Select-clear-zone:hover{color:#f75b5b}.select--small.select-color-scheme--light .Select-clear{display:inline-block;font-size:16px;line-height:1}.select--small.select-color-scheme--light .Select--multi .Select-clear-zone{width:15px}.select--small.select-color-scheme--light .Select--multi .Select-multi-value-wrapper{display:inline-block}.select--small.select-color-scheme--light .Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}.select--small.select-color-scheme--light .Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:20px;padding-right:4px}.Select--rtl .select--small.select-color-scheme--light .Select-arrow-zone{padding-right:0;padding-left:4px}.select--small.select-color-scheme--light .Select-arrow{border-color:#101015 transparent transparent;border-style:solid;border-width:4px 4px 2px;display:inline-block;height:0;width:0;position:relative}.select--small.select-color-scheme--light .Select-menu-outer{border-bottom-right-radius:2px;border-bottom-left-radius:2px;background-color:#f9fafb;border:1px solid #d2d9e1;border-top-color:#e6eaee;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1000;-webkit-overflow-scrolling:touch}.select--small.select-color-scheme--light .Select-menu{max-height:198px;overflow-y:auto}.select--small.select-color-scheme--light .Select-option{-webkit-box-sizing:border-box;box-sizing:border-box;background-color:#fff;color:#3c3c4f;cursor:pointer;display:block;padding:8px 10px}.select--small.select-color-scheme--light .Select-option:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.select--small.select-color-scheme--light .Select-option.is-focused,.select--small.select-color-scheme--light .Select-option.is-selected{background-color:#f5faff;color:#101015}.select--small.select-color-scheme--light .Select-option.is-disabled{color:#b1b8c4;cursor:default}.select--small.select-color-scheme--light .Select-noresults{-webkit-box-sizing:border-box;box-sizing:border-box;color:#b1b8c4;cursor:default;display:block;padding:8px 10px}.select--small.select-color-scheme--light .Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.select--small.select-color-scheme--light .Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.select--small.select-color-scheme--light .Select--multi.has-value .Select-input{margin-left:4px}.select--small.select-color-scheme--light .Select--multi .Select-value{background-color:#101015;border-radius:2px;border:1px solid #101015;color:#fff;display:inline-block;font-size:.75em;margin-left:4px;margin-top:4px;vertical-align:top}.select--small.select-color-scheme--light .Select--multi .Select-value-icon,.select--small.select-color-scheme--light .Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.select--small.select-color-scheme--light .Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 4px}.select--small.select-color-scheme--light .Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none}.select--small.select-color-scheme--light .Select--multi a.Select-value-label:hover{text-decoration:underline}.select--small.select-color-scheme--light .Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #101015;padding:1px 4px 3px}.select--small.select-color-scheme--light .Select--multi .Select-value-icon:focus,.select--small.select-color-scheme--light .Select--multi .Select-value-icon:hover{background-color:#b1b8c4;color:#fff}.select--small.select-color-scheme--light .Select--multi .Select-value-icon:active{background-color:#101015}.select--small.select-color-scheme--light .Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:4px}.select--small.select-color-scheme--light .Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #101015}.select--small.select-color-scheme--light .Select--multi.is-disabled .Select-value{background-color:#e4e8ed;border:1px solid #e4e8ed;color:#8a8f99}.select--small.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e4e8ed}.select--small.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:active,.select--small.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:focus,.select--small.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:hover{background-color:#e4e8ed}.select--small.select-color-scheme--white .Select{position:relative}.select--small.select-color-scheme--white .Select input::-webkit-contacts-auto-fill-button,.select--small.select-color-scheme--white .Select input::-webkit-credentials-auto-fill-button{display:none!important}.select--small.select-color-scheme--white .Select input::-ms-clear,.select--small.select-color-scheme--white .Select input::-ms-reveal{display:none!important}.select--small.select-color-scheme--white .Select,.select--small.select-color-scheme--white .Select div,.select--small.select-color-scheme--white .Select input,.select--small.select-color-scheme--white .Select span{-webkit-box-sizing:border-box;box-sizing:border-box}.select--small.select-color-scheme--white .Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}.select--small.select-color-scheme--white .Select.is-disabled>.Select-control{background-color:#f0f6fa}.select--small.select-color-scheme--white .Select.is-disabled>.Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--white .Select.is-searchable.is-focused:not(.is-open)>.Select-control,.select--small.select-color-scheme--white .Select.is-searchable.is-open>.Select-control{cursor:text}.select--small.select-color-scheme--white .Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#c5ced9 #e4e8ed #f3f5f7}.select--small.select-color-scheme--white .Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #101015;border-width:0 4px 4px}.select--small.select-color-scheme--white .Select.is-focused>.Select-control{background:#fff}.select--small.select-color-scheme--white .Select.is-focused:not(.is-open)>.Select-control{border-color:#4487ff #5e97ff #5e97ff;-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--white .Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:35px}.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.select--small.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#101015}.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.select--small.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.select--small.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#4487ff;outline:none;text-decoration:underline}.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--small.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.select--small.select-color-scheme--white .Select.has-value.is-pseudo-focused .Select-input{opacity:0}.select--small.select-color-scheme--white .Select.is-open .Select-arrow,.select--small.select-color-scheme--white .Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#b1b8c4}.select--small.select-color-scheme--white .Select.Select--rtl{direction:rtl;text-align:right}.select--small.select-color-scheme--white .Select-control{background-color:#fff;border-color:#f3f5f7 #e4e8ed #c5ced9;border-radius:2px;border:1px solid #e4e8ed;color:#101015;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:32px;outline:none;overflow:hidden;position:relative;width:100%}.select--small.select-color-scheme--white .Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--small.select-color-scheme--white .Select-control .Select-input:focus{outline:none;background:#fff}.select--small.select-color-scheme--white .Select--single>.Select-control .Select-value,.select--small.select-color-scheme--white .Select-placeholder{bottom:0;color:#b1b8c4;left:0;line-height:30px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.select--small.select-color-scheme--white .Select-input{height:30px;padding-left:10px;padding-right:10px;vertical-align:middle}.select--small.select-color-scheme--white .Select-input>input{background:none transparent;border:0 none;-webkit-box-shadow:none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:6px 0 10px;-webkit-appearance:none}.is-focused .select--small.select-color-scheme--white .Select-input>input{cursor:text}.select--small.select-color-scheme--white .Select-control:not(.is-searchable)>.Select-input{outline:none}.select--small.select-color-scheme--white .Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}.select--small.select-color-scheme--white .Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;width:16px;height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;border:2px solid #e4e8ed;border-right-color:#101015;display:inline-block;position:relative;vertical-align:middle}.select--small.select-color-scheme--white .Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#b1b8c4;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:15px}.select--small.select-color-scheme--white .Select-clear-zone:hover{color:#f75b5b}.select--small.select-color-scheme--white .Select-clear{display:inline-block;font-size:16px;line-height:1}.select--small.select-color-scheme--white .Select--multi .Select-clear-zone{width:15px}.select--small.select-color-scheme--white .Select--multi .Select-multi-value-wrapper{display:inline-block}.select--small.select-color-scheme--white .Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}.select--small.select-color-scheme--white .Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:20px;padding-right:4px}.Select--rtl .select--small.select-color-scheme--white .Select-arrow-zone{padding-right:0;padding-left:4px}.select--small.select-color-scheme--white .Select-arrow{border-color:#101015 transparent transparent;border-style:solid;border-width:4px 4px 2px;display:inline-block;height:0;width:0;position:relative}.select--small.select-color-scheme--white .Select-menu-outer{border-bottom-right-radius:2px;border-bottom-left-radius:2px;background-color:#fff;border:1px solid #e4e8ed;border-top-color:#f2f4f6;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1000;-webkit-overflow-scrolling:touch}.select--small.select-color-scheme--white .Select-menu{max-height:198px;overflow-y:auto}.select--small.select-color-scheme--white .Select-option{-webkit-box-sizing:border-box;box-sizing:border-box;background-color:#fff;color:#3c3c4f;cursor:pointer;display:block;padding:8px 10px}.select--small.select-color-scheme--white .Select-option:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.select--small.select-color-scheme--white .Select-option.is-focused,.select--small.select-color-scheme--white .Select-option.is-selected{background-color:#f5faff;color:#101015}.select--small.select-color-scheme--white .Select-option.is-disabled{color:#b1b8c4;cursor:default}.select--small.select-color-scheme--white .Select-noresults{-webkit-box-sizing:border-box;box-sizing:border-box;color:#b1b8c4;cursor:default;display:block;padding:8px 10px}.select--small.select-color-scheme--white .Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.select--small.select-color-scheme--white .Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.select--small.select-color-scheme--white .Select--multi.has-value .Select-input{margin-left:4px}.select--small.select-color-scheme--white .Select--multi .Select-value{background-color:#101015;border-radius:2px;border:1px solid #101015;color:#fff;display:inline-block;font-size:.75em;margin-left:4px;margin-top:4px;vertical-align:top}.select--small.select-color-scheme--white .Select--multi .Select-value-icon,.select--small.select-color-scheme--white .Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.select--small.select-color-scheme--white .Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 4px}.select--small.select-color-scheme--white .Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none}.select--small.select-color-scheme--white .Select--multi a.Select-value-label:hover{text-decoration:underline}.select--small.select-color-scheme--white .Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #101015;padding:1px 4px 3px}.select--small.select-color-scheme--white .Select--multi .Select-value-icon:focus,.select--small.select-color-scheme--white .Select--multi .Select-value-icon:hover{background-color:#b1b8c4;color:#fff}.select--small.select-color-scheme--white .Select--multi .Select-value-icon:active{background-color:#101015}.select--small.select-color-scheme--white .Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:4px}.select--small.select-color-scheme--white .Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #101015}.select--small.select-color-scheme--white .Select--multi.is-disabled .Select-value{background-color:#e4e8ed;border:1px solid #e4e8ed;color:#8a8f99}.select--small.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e4e8ed}.select--small.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:active,.select--small.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:focus,.select--small.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:hover{background-color:#e4e8ed}.select--small .Select-arrow-zone{padding-right:2px;padding-left:8px}.select--medium.select-color-scheme--light .Select{position:relative}.select--medium.select-color-scheme--light .Select input::-webkit-contacts-auto-fill-button,.select--medium.select-color-scheme--light .Select input::-webkit-credentials-auto-fill-button{display:none!important}.select--medium.select-color-scheme--light .Select input::-ms-clear,.select--medium.select-color-scheme--light .Select input::-ms-reveal{display:none!important}.select--medium.select-color-scheme--light .Select,.select--medium.select-color-scheme--light .Select div,.select--medium.select-color-scheme--light .Select input,.select--medium.select-color-scheme--light .Select span{-webkit-box-sizing:border-box;box-sizing:border-box}.select--medium.select-color-scheme--light .Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}.select--medium.select-color-scheme--light .Select.is-disabled>.Select-control{background-color:#fff}.select--medium.select-color-scheme--light .Select.is-disabled>.Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--light .Select.is-searchable.is-focused:not(.is-open)>.Select-control,.select--medium.select-color-scheme--light .Select.is-searchable.is-open>.Select-control{cursor:text}.select--medium.select-color-scheme--light .Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#f9fafb;border-color:#b3bfcd #d2d9e1 #e1e6eb}.select--medium.select-color-scheme--light .Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #101015;border-width:0 4px 4px}.select--medium.select-color-scheme--light .Select.is-focused>.Select-control{background:#f9fafb}.select--medium.select-color-scheme--light .Select.is-focused:not(.is-open)>.Select-control{border-color:#4487ff #5e97ff #5e97ff;-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--light .Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:39px}.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.select--medium.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#101015}.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.select--medium.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.select--medium.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#4487ff;outline:none;text-decoration:underline}.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--light .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#f9fafb}.select--medium.select-color-scheme--light .Select.has-value.is-pseudo-focused .Select-input{opacity:0}.select--medium.select-color-scheme--light .Select.is-open .Select-arrow,.select--medium.select-color-scheme--light .Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#b1b8c4}.select--medium.select-color-scheme--light .Select.Select--rtl{direction:rtl;text-align:right}.select--medium.select-color-scheme--light .Select-control{background-color:#f9fafb;border-color:#e1e6eb #d2d9e1 #b3bfcd;border-radius:2px;border:1px solid #d2d9e1;color:#101015;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:40px;outline:none;overflow:hidden;position:relative;width:100%}.select--medium.select-color-scheme--light .Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--light .Select-control .Select-input:focus{outline:none;background:#f9fafb}.select--medium.select-color-scheme--light .Select--single>.Select-control .Select-value,.select--medium.select-color-scheme--light .Select-placeholder{bottom:0;color:#b1b8c4;left:0;line-height:38px;padding-left:12px;padding-right:12px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.select--medium.select-color-scheme--light .Select-input{height:38px;padding-left:12px;padding-right:12px;vertical-align:middle}.select--medium.select-color-scheme--light .Select-input>input{background:none transparent;border:0 none;-webkit-box-shadow:none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:10px 0 14px;-webkit-appearance:none}.is-focused .select--medium.select-color-scheme--light .Select-input>input{cursor:text}.select--medium.select-color-scheme--light .Select-control:not(.is-searchable)>.Select-input{outline:none}.select--medium.select-color-scheme--light .Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}.select--medium.select-color-scheme--light .Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;width:16px;height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;border:2px solid #d2d9e1;border-right-color:#101015;display:inline-block;position:relative;vertical-align:middle}.select--medium.select-color-scheme--light .Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#b1b8c4;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:19px}.select--medium.select-color-scheme--light .Select-clear-zone:hover{color:#f75b5b}.select--medium.select-color-scheme--light .Select-clear{display:inline-block;font-size:20px;line-height:1}.select--medium.select-color-scheme--light .Select--multi .Select-clear-zone{width:19px}.select--medium.select-color-scheme--light .Select--multi .Select-multi-value-wrapper{display:inline-block}.select--medium.select-color-scheme--light .Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}.select--medium.select-color-scheme--light .Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:20px;padding-right:4px}.Select--rtl .select--medium.select-color-scheme--light .Select-arrow-zone{padding-right:0;padding-left:4px}.select--medium.select-color-scheme--light .Select-arrow{border-color:#101015 transparent transparent;border-style:solid;border-width:4px 4px 2px;display:inline-block;height:0;width:0;position:relative}.select--medium.select-color-scheme--light .Select-menu-outer{border-bottom-right-radius:2px;border-bottom-left-radius:2px;background-color:#f9fafb;border:1px solid #d2d9e1;border-top-color:#e6eaee;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1000;-webkit-overflow-scrolling:touch}.select--medium.select-color-scheme--light .Select-menu{max-height:198px;overflow-y:auto}.select--medium.select-color-scheme--light .Select-option{-webkit-box-sizing:border-box;box-sizing:border-box;background-color:#fff;color:#3c3c4f;cursor:pointer;display:block;padding:8px 12px}.select--medium.select-color-scheme--light .Select-option:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.select--medium.select-color-scheme--light .Select-option.is-focused,.select--medium.select-color-scheme--light .Select-option.is-selected{background-color:#f5faff;color:#101015}.select--medium.select-color-scheme--light .Select-option.is-disabled{color:#b1b8c4;cursor:default}.select--medium.select-color-scheme--light .Select-noresults{-webkit-box-sizing:border-box;box-sizing:border-box;color:#b1b8c4;cursor:default;display:block;padding:8px 12px}.select--medium.select-color-scheme--light .Select--multi .Select-input{vertical-align:middle;margin-left:12px;padding:0}.select--medium.select-color-scheme--light .Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:12px}.select--medium.select-color-scheme--light .Select--multi.has-value .Select-input{margin-left:4px}.select--medium.select-color-scheme--light .Select--multi .Select-value{background-color:#101015;border-radius:2px;border:1px solid #101015;color:#fff;display:inline-block;font-size:.75em;margin-left:4px;margin-top:4px;vertical-align:top}.select--medium.select-color-scheme--light .Select--multi .Select-value-icon,.select--medium.select-color-scheme--light .Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.select--medium.select-color-scheme--light .Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 4px}.select--medium.select-color-scheme--light .Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none}.select--medium.select-color-scheme--light .Select--multi a.Select-value-label:hover{text-decoration:underline}.select--medium.select-color-scheme--light .Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #101015;padding:1px 4px 3px}.select--medium.select-color-scheme--light .Select--multi .Select-value-icon:focus,.select--medium.select-color-scheme--light .Select--multi .Select-value-icon:hover{background-color:#b1b8c4;color:#fff}.select--medium.select-color-scheme--light .Select--multi .Select-value-icon:active{background-color:#101015}.select--medium.select-color-scheme--light .Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:4px}.select--medium.select-color-scheme--light .Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #101015}.select--medium.select-color-scheme--light .Select--multi.is-disabled .Select-value{background-color:#e4e8ed;border:1px solid #e4e8ed;color:#8a8f99}.select--medium.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e4e8ed}.select--medium.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:active,.select--medium.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:focus,.select--medium.select-color-scheme--light .Select--multi.is-disabled .Select-value-icon:hover{background-color:#e4e8ed}.select--medium.select-color-scheme--white .Select{position:relative}.select--medium.select-color-scheme--white .Select input::-webkit-contacts-auto-fill-button,.select--medium.select-color-scheme--white .Select input::-webkit-credentials-auto-fill-button{display:none!important}.select--medium.select-color-scheme--white .Select input::-ms-clear,.select--medium.select-color-scheme--white .Select input::-ms-reveal{display:none!important}.select--medium.select-color-scheme--white .Select,.select--medium.select-color-scheme--white .Select div,.select--medium.select-color-scheme--white .Select input,.select--medium.select-color-scheme--white .Select span{-webkit-box-sizing:border-box;box-sizing:border-box}.select--medium.select-color-scheme--white .Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}.select--medium.select-color-scheme--white .Select.is-disabled>.Select-control{background-color:#f0f6fa}.select--medium.select-color-scheme--white .Select.is-disabled>.Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--white .Select.is-searchable.is-focused:not(.is-open)>.Select-control,.select--medium.select-color-scheme--white .Select.is-searchable.is-open>.Select-control{cursor:text}.select--medium.select-color-scheme--white .Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#c5ced9 #e4e8ed #f3f5f7}.select--medium.select-color-scheme--white .Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #101015;border-width:0 4px 4px}.select--medium.select-color-scheme--white .Select.is-focused>.Select-control{background:#fff}.select--medium.select-color-scheme--white .Select.is-focused:not(.is-open)>.Select-control{border-color:#4487ff #5e97ff #5e97ff;-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--white .Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:39px}.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.select--medium.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#101015}.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.select--medium.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.select--medium.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#4487ff;outline:none;text-decoration:underline}.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.select--medium.select-color-scheme--white .Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.select--medium.select-color-scheme--white .Select.has-value.is-pseudo-focused .Select-input{opacity:0}.select--medium.select-color-scheme--white .Select.is-open .Select-arrow,.select--medium.select-color-scheme--white .Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#b1b8c4}.select--medium.select-color-scheme--white .Select.Select--rtl{direction:rtl;text-align:right}.select--medium.select-color-scheme--white .Select-control{background-color:#fff;border-color:#f3f5f7 #e4e8ed #c5ced9;border-radius:2px;border:1px solid #e4e8ed;color:#101015;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:40px;outline:none;overflow:hidden;position:relative;width:100%}.select--medium.select-color-scheme--white .Select-control:hover{-webkit-box-shadow:none;box-shadow:none}.select--medium.select-color-scheme--white .Select-control .Select-input:focus{outline:none;background:#fff}.select--medium.select-color-scheme--white .Select--single>.Select-control .Select-value,.select--medium.select-color-scheme--white .Select-placeholder{bottom:0;color:#b1b8c4;left:0;line-height:38px;padding-left:12px;padding-right:12px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.select--medium.select-color-scheme--white .Select-input{height:38px;padding-left:12px;padding-right:12px;vertical-align:middle}.select--medium.select-color-scheme--white .Select-input>input{background:none transparent;border:0 none;-webkit-box-shadow:none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:10px 0 14px;-webkit-appearance:none}.is-focused .select--medium.select-color-scheme--white .Select-input>input{cursor:text}.select--medium.select-color-scheme--white .Select-control:not(.is-searchable)>.Select-input{outline:none}.select--medium.select-color-scheme--white .Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}.select--medium.select-color-scheme--white .Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;width:16px;height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;border:2px solid #e4e8ed;border-right-color:#101015;display:inline-block;position:relative;vertical-align:middle}.select--medium.select-color-scheme--white .Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#b1b8c4;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:19px}.select--medium.select-color-scheme--white .Select-clear-zone:hover{color:#f75b5b}.select--medium.select-color-scheme--white .Select-clear{display:inline-block;font-size:20px;line-height:1}.select--medium.select-color-scheme--white .Select--multi .Select-clear-zone{width:19px}.select--medium.select-color-scheme--white .Select--multi .Select-multi-value-wrapper{display:inline-block}.select--medium.select-color-scheme--white .Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}.select--medium.select-color-scheme--white .Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:20px;padding-right:4px}.Select--rtl .select--medium.select-color-scheme--white .Select-arrow-zone{padding-right:0;padding-left:4px}.select--medium.select-color-scheme--white .Select-arrow{border-color:#101015 transparent transparent;border-style:solid;border-width:4px 4px 2px;display:inline-block;height:0;width:0;position:relative}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.select--medium.select-color-scheme--white .Select-menu-outer{border-bottom-right-radius:2px;border-bottom-left-radius:2px;background-color:#fff;border:1px solid #e4e8ed;border-top-color:#f2f4f6;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1000;-webkit-overflow-scrolling:touch}.select--medium.select-color-scheme--white .Select-menu{max-height:198px;overflow-y:auto}.select--medium.select-color-scheme--white .Select-option{-webkit-box-sizing:border-box;box-sizing:border-box;background-color:#fff;color:#3c3c4f;cursor:pointer;display:block;padding:8px 12px}.select--medium.select-color-scheme--white .Select-option:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.select--medium.select-color-scheme--white .Select-option.is-focused,.select--medium.select-color-scheme--white .Select-option.is-selected{background-color:#f5faff;color:#101015}.select--medium.select-color-scheme--white .Select-option.is-disabled{color:#b1b8c4;cursor:default}.select--medium.select-color-scheme--white .Select-noresults{-webkit-box-sizing:border-box;box-sizing:border-box;color:#b1b8c4;cursor:default;display:block;padding:8px 12px}.select--medium.select-color-scheme--white .Select--multi .Select-input{vertical-align:middle;margin-left:12px;padding:0}.select--medium.select-color-scheme--white .Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:12px}.select--medium.select-color-scheme--white .Select--multi.has-value .Select-input{margin-left:4px}.select--medium.select-color-scheme--white .Select--multi .Select-value{background-color:#101015;border-radius:2px;border:1px solid #101015;color:#fff;display:inline-block;font-size:.75em;margin-left:4px;margin-top:4px;vertical-align:top}.select--medium.select-color-scheme--white .Select--multi .Select-value-icon,.select--medium.select-color-scheme--white .Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.select--medium.select-color-scheme--white .Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 4px}.select--medium.select-color-scheme--white .Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none}.select--medium.select-color-scheme--white .Select--multi a.Select-value-label:hover{text-decoration:underline}.select--medium.select-color-scheme--white .Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #101015;padding:1px 4px 3px}.select--medium.select-color-scheme--white .Select--multi .Select-value-icon:focus,.select--medium.select-color-scheme--white .Select--multi .Select-value-icon:hover{background-color:#b1b8c4;color:#fff}.select--medium.select-color-scheme--white .Select--multi .Select-value-icon:active{background-color:#101015}.select--medium.select-color-scheme--white .Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:4px}.select--medium.select-color-scheme--white .Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #101015}.select--medium.select-color-scheme--white .Select--multi.is-disabled .Select-value{background-color:#e4e8ed;border:1px solid #e4e8ed;color:#8a8f99}.select--medium.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e4e8ed}.select--medium.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:active,.select--medium.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:focus,.select--medium.select-color-scheme--white .Select--multi.is-disabled .Select-value-icon:hover{background-color:#e4e8ed}@keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}.select--error .select__label{color:#f75b5b;-webkit-animation:transform-to-error .15s ease-in-out .25s;animation:transform-to-error .15s ease-in-out .25s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.select--error .select__label:after{content:\":\"}.select .label--error,.select .label--warning{position:absolute;top:95%;left:8px;border-radius:2px;max-width:calc(100% - 16px);padding:4px 8px 5px;border:1px solid;-webkit-box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);z-index:1;text-align:left;-webkit-animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards;animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards}@-webkit-keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}.select .label--warning{background-color:#f5faff;color:#4487ff}.select .label--error{background-color:#fff5f5;color:#f75b5b}.Select{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34}@media print{.Select{font-size:.6770833331em}}.Select em,.Select i{font-weight:300}.Select b,.Select strong{font-weight:700}.Select span{position:static}.Select-input>input{padding:12px 0}.Select-input{background-color:transparent!important}.Select-clear-zone{-webkit-transform:translateX(4px);-ms-transform:translateX(4px);transform:translateX(4px)}.Select-clear{font-size:1.75em;line-height:38px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/Select/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/react-select/scss/control.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/react-select/scss/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/Select/_react-select.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/react-select/scss/spinner.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/react-select/scss/menu.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/react-select/scss/multi.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss"],"names":[],"mappings":"AA0IE,eACE,kBACA,aAAc,CACf,cCnGD,kBDsG4B,QE7GmB,SAAA,CF8G9C,kDGzIF,iBAAkB,CH2IhB,yLGtID,sBAAwB,CHsIvB,uIGhID,sBAAwB,CHgIvB,uNInGF,8BDrB+B,qBAAA,CHwH7B,iFGlHA,eAAe,mBACK,CHiHpB,8EG7GA,qBEJW,CLiHX,oFG3GC,wBAAA,eAAgB,CH2GjB,iMGhGA,WAAY,CHgGZ,0EIvHF,6BD4BiC,4BAAA,mBAEhC,oCAAwH,CHyFvH,wFGrFA,SAAS,6CAET,sBD7B8C,CFgH9C,6EG9ED,kBExDwB,CLsIvB,2FG1ED,qCAAwH,wBACxH,eGzDsC,CNkIrC,sHGpED,kBAA8D,CHoE7D,4QG9DA,aEjFuB,CL+IvB,8QG3DA,eAAe,oBACM,CH0DrB,ojBGtDC,cACA,aAAa,yBACa,CHoD3B,0RGhDC,kBEtFsB,CLsIvB,4FGzCD,SAAU,CHyCT,iKGpCD,wBEtGyB,CL0IxB,8DGjCD,cAAc,gBACG,CHgChB,0DGzBF,yBACA,qCAAwH,kBAExH,yBACA,cACA,eAAe,cACD,iBACG,yBACQ,YD/FuB,aCiGnC,gBACG,kBACE,UACP,CHYT,gEGTD,wBAAA,eGlHsC,CN2HrC,8EGLD,aAAa,kBEjIW,CLsIvB,sJGGF,SAAS,cAET,OAAO,iBAEP,kBDvHgD,mBAAA,kBCyH9B,QACV,MACF,eAGS,gBACC,0BAChB,uBAAuB,kBACJ,CHjBjB,wDGyBF,YACA,kBD1IgD,mBAAA,qBC4I1B,CH5BpB,8DG+BD,4BAA4B,cACd,wBACd,gBAAgB,eACD,qBACM,oBACD,kBACF,SAET,aACI,iBAEI,mBACuF,uBAChF,CAExB,0EACC,WAAY,CH/CZ,4FGuDF,YAAa,CHvDX,+DG4DF,eAAe,mBACI,kBACD,kBACA,sBACI,UDhL0B,CFgH9C,0DIzGF,4DAEA,oDAnCA,WF0BgD,YAAA,8BK1BhD,sBAAsB,kBACJ,yBFAI,2BANG,qBESJ,kBJ2MrB,qBAAsB,CHrEpB,6DIzGF,8CDqLiD,sCAAA,cAEjD,eAAe,mBACI,kBACD,kBACA,sBACI,UGrLgD,CNmGpE,mEGsFD,aExNwB,CLkIvB,wDG0FF,qBAAqB,eAErB,aAAc,CH5FZ,4EG+FF,UGlMsE,CNmGpE,qFGmGD,oBAAqB,CHnGpB,oEGsGF,kBAAkB,qBACG,WACV,UACD,YACE,mBACO,gBACH,UACL,CH7GT,6DGoHF,eAAe,mBACI,kBACD,kBACA,sBACI,WACU,iBDzOgB,CC4OhD,0EACC,gBAAgB,gBD7O+B,CFgH9C,wDGmIF,6CAAyD,mBACtC,yBAC4D,qBAC1D,SACZ,QACD,iBACU,CHzIhB,6DIvHF,+BACA,8BEdsC,yBDFb,yBAHH,yBGKkD,wBFSjC,gBAAA,8BEPvC,sBAAsB,gBACN,iBNiBgC,kBMf9B,SACT,WACE,aFQ4B,gCENN,CR2H/B,uDQpHF,iBAA2C,eAC3B,CRmHd,yDQ5GF,8BAAA,sBAAsB,sBHLT,cCAsD,eEQpD,cACD,gBNRkC,CFgH9C,oEIvHF,+BACA,6BEdsC,CNoIpC,yIQ3FD,yBHzCwB,aAXA,CL+IvB,qEQtFD,cHpDyB,cGqDV,CRqFd,4DQ5EF,8BAAA,sBAAsB,cH9DI,eGgEX,cACD,gBNvCkC,CFgH9C,uESxID,sBAAsB,iBPwByB,SOrBrC,CTqIT,mFSlID,cAAc,iBPkBiC,CFgH9C,iFS5HD,ePY+C,CFgH9C,uESvHD,yBJxBwB,kBH+BuB,yBG/BvB,WA8BZ,qBIFS,gBHiCkB,gBJ9BQ,eAAA,kBOC5B,CT+GlB,yJSzGD,qBAAqB,qBACC,CTwGrB,6EI5HF,+BFYgD,4BAAA,eOchC,ePdgC,CFgH9C,8ES9FD,WJnBY,eIoBG,oBACM,CT4FpB,oFSzFA,yBAA0B,CTyF1B,4ESnFD,eL/BD,8BFEgD,2BAAA,+BG/BvB,mBIiEwF,CT8E/G,oKS1EA,yBJhEwB,UAyBb,CLiHX,mFStEA,wBJzEuB,CL+IvB,mFShEC,cAAc,gBPhD+B,CFgH9C,wFS5DA,kBAAkB,6BJnFK,CL+IvB,mFSpDD,yBJpFyB,yBAAA,aALH,CL6IrB,wFS9CD,mBAAmB,8BJ1FM,CLwIxB,2RSxCA,wBJhGwB,CLwIxB,kDG3IF,iBAAkB,CH2IhB,yLGtID,sBAAwB,CHsIvB,uIGhID,sBAAwB,CHgIvB,uNInGF,8BDrB+B,qBAAA,CHwH7B,iFGlHA,eAAe,mBACK,CHiHpB,8EG7GA,wBEtBwB,CLmIxB,oFG3GC,wBAAA,eAAgB,CH2GjB,iMGhGA,WAAY,CHgGZ,0EIvHF,6BD4BiC,4BAAA,gBAEhC,oCAAwH,CHyFvH,wFGrFA,SAAS,6CAET,sBD7B8C,CFgH9C,6EG9ED,eEnCY,CLiHX,2FG1ED,qCAAwH,wBACxH,eGzDsC,CNkIrC,sHGpED,kBAA8D,CHoE7D,4QG9DA,aEjFuB,CL+IvB,8QG3DA,eAAe,oBACM,CH0DrB,ojBGtDC,cACA,aAAa,yBACa,CHoD3B,0RGhDC,eEjEU,CLiHX,4FGzCD,SAAU,CHyCT,iKGpCD,wBEtGyB,CL0IxB,8DGjCD,cAAc,gBACG,CHgChB,0DGzBF,sBACA,qCAAwH,kBAExH,yBACA,cACA,eAAe,cACD,iBACG,yBACQ,YD/FuB,aCiGnC,gBACG,kBACE,UACP,CHYT,gEGTD,wBAAA,eGlHsC,CN2HrC,8EGLD,aAAa,eE5GD,CLiHX,sJGGF,SAAS,cAET,OAAO,iBAEP,kBDvHgD,mBAAA,kBCyH9B,QACV,MACF,eAGS,gBACC,0BAChB,uBAAuB,kBACJ,CHjBjB,wDGyBF,YACA,kBD1IgD,mBAAA,qBC4I1B,CH5BpB,8DG+BD,4BAA4B,cACd,wBACd,gBAAgB,eACD,qBACM,oBACD,kBACF,SAET,aACI,iBAEI,mBACuF,uBAChF,CAExB,0EACC,WAAY,CH/CZ,4FGuDF,YAAa,CHvDX,+DG4DF,eAAe,mBACI,kBACD,kBACA,sBACI,UDhL0B,CFgH9C,0DIzGF,4DAEA,oDAnCA,WF0BgD,YAAA,8BK1BhD,sBAAsB,kBACJ,yBFCQ,2BAPD,qBESJ,kBJ2MrB,qBAAsB,CHrEpB,6DIzGF,8CDqLiD,sCAAA,cAEjD,eAAe,mBACI,kBACD,kBACA,sBACI,UGrLgD,CNmGpE,mEGsFD,aExNwB,CLkIvB,wDG0FF,qBAAqB,eAErB,aAAc,CH5FZ,4EG+FF,UGlMsE,CNmGpE,qFGmGD,oBAAqB,CHnGpB,oEGsGF,kBAAkB,qBACG,WACV,UACD,YACE,mBACO,gBACH,UACL,CH7GT,6DGoHF,eAAe,mBACI,kBACD,kBACA,sBACI,WACU,iBDzOgB,CC4OhD,0EACC,gBAAgB,gBD7O+B,CFgH9C,wDGmIF,6CAAyD,mBACtC,yBAC4D,qBAC1D,SACZ,QACD,iBACU,CHzIhB,6DIvHF,+BACA,8BEdsC,sBDmBzB,yBAvBa,yBGI8C,wBFSjC,gBAAA,8BEPvC,sBAAsB,gBACN,iBNiBgC,kBMf9B,SACT,WACE,aFQ4B,gCENN,CR2H/B,uDQpHF,iBAA2C,eAC3B,CRmHd,yDQ5GF,8BAAA,sBAAsB,sBHLT,cCAsD,eEQpD,cACD,gBNRkC,CFgH9C,oEIvHF,+BACA,6BEdsC,CNoIpC,yIQ3FD,yBHzCwB,aAXA,CL+IvB,qEQtFD,cHpDyB,cGqDV,CRqFd,4DQ5EF,8BAAA,sBAAsB,cH9DI,eGgEX,cACD,gBNvCkC,CFgH9C,uESxID,sBAAsB,iBPwByB,SOrBrC,CTqIT,mFSlID,cAAc,iBPkBiC,CFgH9C,iFS5HD,ePY+C,CFgH9C,uESvHD,yBJxBwB,kBH+BuB,yBG/BvB,WA8BZ,qBIFS,gBHiCkB,gBJ9BQ,eAAA,kBOC5B,CT+GlB,yJSzGD,qBAAqB,qBACC,CTwGrB,6EI5HF,+BFYgD,4BAAA,eOchC,ePdgC,CFgH9C,8ES9FD,WJnBY,eIoBG,oBACM,CT4FpB,oFSzFA,yBAA0B,CTyF1B,4ESnFD,eL/BD,8BFEgD,2BAAA,+BG/BvB,mBIiEwF,CT8E/G,oKS1EA,yBJhEwB,UAyBb,CLiHX,mFStEA,wBJzEuB,CL+IvB,mFShEC,cAAc,gBPhD+B,CFgH9C,wFS5DA,kBAAkB,6BJnFK,CL+IvB,mFSpDD,yBJpFyB,yBAAA,aALH,CL6IrB,wFS9CD,mBAAmB,8BJ1FM,CLwIxB,2RSxCA,wBJhGwB,CLwIxB,kCU1DuB,kBRtDuB,gBAAA,CFoH5C,mDG/IJ,iBAAkB,CHkJhB,2LG7ID,sBAAwB,CH6IvB,yIGvID,sBAAwB,CHuIvB,2NI1GF,8BDrB+B,qBAAA,CH+H7B,kFGzHA,eAAe,mBACK,CHwHpB,+EGpHA,qBEJW,CLwHX,qFGlHC,wBAAA,eAAgB,CHkHjB,mMGvGA,WAAY,CHuGZ,2EI9HF,6BD4BiC,4BAAA,mBAEhC,oCAAwH,CHgGvH,yFG5FA,SAAS,6CAET,sBD7B8C,CFuH9C,8EGrFD,kBExDwB,CL6IvB,4FGjFD,qCAAwH,wBACxH,eGzDsC,CNyIrC,uHG3ED,kBAA8D,CH2E7D,8QGrEA,aEjFuB,CLsJvB,gRGlEA,eAAe,oBACM,CHiErB,wjBG7DC,cACA,aAAa,yBACa,CH2D3B,4RGvDC,kBEtFsB,CL6IvB,6FGhDD,SAAU,CHgDT,mKG3CD,wBEtGyB,CLiJxB,+DGxCD,cAAc,gBACG,CHuChB,2DGhCF,yBACA,qCAAwH,kBAExH,yBACA,cACA,eAAe,cACD,iBACG,yBACQ,YD/FuB,aCiGnC,gBACG,kBACE,UACP,CHmBT,iEGhBD,wBAAA,eGlHsC,CNkIrC,+EGZD,aAAa,kBEjIW,CL6IvB,wJGJF,SAAS,cAET,OAAO,iBAEP,kBDvHgD,mBAAA,kBCyH9B,QACV,MACF,eAGS,gBACC,0BAChB,uBAAuB,kBACJ,CHVjB,yDGkBF,YACA,kBD1IgD,mBAAA,qBC4I1B,CHrBpB,+DGwBD,4BAA4B,cACd,wBACd,gBAAgB,eACD,qBACM,oBACD,kBACF,SAET,aACI,iBAEI,oBACuF,uBAChF,CAExB,2EACC,WAAY,CHxCZ,6FGgDF,YAAa,CHhDX,gEGqDF,eAAe,mBACI,kBACD,kBACA,sBACI,UDhL0B,CFuH9C,2DIhHF,4DAEA,oDAnCA,WF0BgD,YAAA,8BK1BhD,sBAAsB,kBACJ,yBFAI,2BANG,qBESJ,kBJ2MrB,qBAAsB,CH9DpB,8DIhHF,8CDqLiD,sCAAA,cAEjD,eAAe,mBACI,kBACD,kBACA,sBACI,UGrLgD,CN0GpE,oEG+ED,aExNwB,CLyIvB,yDGmFF,qBAAqB,eAErB,aAAc,CHrFZ,6EGwFF,UGlMsE,CN0GpE,sFG4FD,oBAAqB,CH5FpB,qEG+FF,kBAAkB,qBACG,WACV,UACD,YACE,mBACO,gBACH,UACL,CHtGT,8DG6GF,eAAe,mBACI,kBACD,kBACA,sBACI,WACU,iBDzOgB,CC4OhD,2EACC,gBAAgB,gBD7O+B,CFuH9C,yDG4HF,6CAAyD,mBACtC,yBAC4D,qBAC1D,SACZ,QACD,iBACU,CHlIhB,8DI9HF,+BACA,8BEdsC,yBDFb,yBAHH,yBGKkD,wBFSjC,gBAAA,8BEPvC,sBAAsB,gBACN,iBNiBgC,kBMf9B,SACT,WACE,aFQ4B,gCENN,CRkI/B,wDQ3HF,iBAA2C,eAC3B,CR0Hd,0DQnHF,8BAAA,sBAAsB,sBHLT,cCAsD,eEQpD,cACD,gBNRkC,CFuH9C,qEI9HF,+BACA,6BEdsC,CN2IpC,2IQlGD,yBHzCwB,aAXA,CLsJvB,sEQ7FD,cHpDyB,cGqDV,CR4Fd,6DQnFF,8BAAA,sBAAsB,cH9DI,eGgEX,cACD,gBNvCkC,CFuH9C,wES/ID,sBAAsB,iBPwByB,SOrBrC,CT4IT,oFSzID,cAAc,iBPkBiC,CFuH9C,kFSnID,ePY+C,CFuH9C,wES9HD,yBJxBwB,kBH+BuB,yBG/BvB,WA8BZ,qBIFS,gBHiCkB,gBJ9BQ,eAAA,kBOC5B,CTsHlB,2JShHD,qBAAqB,qBACC,CT+GrB,8EInIF,+BFYgD,4BAAA,eOchC,ePdgC,CFuH9C,+ESrGD,WJnBY,eIoBG,oBACM,CTmGpB,qFShGA,yBAA0B,CTgG1B,6ES1FD,eL/BD,8BFEgD,2BAAA,+BG/BvB,mBIiEwF,CTqF/G,sKSjFA,yBJhEwB,UAyBb,CLwHX,oFS7EA,wBJzEuB,CLsJvB,oFSvEC,cAAc,gBPhD+B,CFuH9C,yFSnEA,kBAAkB,6BJnFK,CLsJvB,oFS3DD,yBJpFyB,yBAAA,aALH,CLoJrB,yFSrDD,mBAAmB,8BJ1FM,CL+IxB,8RS/CA,wBJhGwB,CL+IxB,mDGlJF,iBAAkB,CHkJhB,2LG7ID,sBAAwB,CH6IvB,yIGvID,sBAAwB,CHuIvB,2NI1GF,8BDrB+B,qBAAA,CH+H7B,kFGzHA,eAAe,mBACK,CHwHpB,+EGpHA,wBEtBwB,CL0IxB,qFGlHC,wBAAA,eAAgB,CHkHjB,mMGvGA,WAAY,CHuGZ,2EI9HF,6BD4BiC,4BAAA,gBAEhC,oCAAwH,CHgGvH,yFG5FA,SAAS,6CAET,sBD7B8C,CFuH9C,8EGrFD,eEnCY,CLwHX,4FGjFD,qCAAwH,wBACxH,eGzDsC,CNyIrC,uHG3ED,kBAA8D,CH2E7D,8QGrEA,aEjFuB,CLsJvB,gRGlEA,eAAe,oBACM,CHiErB,wjBG7DC,cACA,aAAa,yBACa,CH2D3B,4RGvDC,eEjEU,CLwHX,6FGhDD,SAAU,CHgDT,mKG3CD,wBEtGyB,CLiJxB,+DGxCD,cAAc,gBACG,CHuChB,2DGhCF,sBACA,qCAAwH,kBAExH,yBACA,cACA,eAAe,cACD,iBACG,yBACQ,YD/FuB,aCiGnC,gBACG,kBACE,UACP,CHmBT,iEGhBD,wBAAA,eGlHsC,CNkIrC,+EGZD,aAAa,eE5GD,CLwHX,wJGJF,SAAS,cAET,OAAO,iBAEP,kBDvHgD,mBAAA,kBCyH9B,QACV,MACF,eAGS,gBACC,0BAChB,uBAAuB,kBACJ,CHVjB,yDGkBF,YACA,kBD1IgD,mBAAA,qBC4I1B,CHrBpB,+DGwBD,4BAA4B,cACd,wBACd,gBAAgB,eACD,qBACM,oBACD,kBACF,SAET,aACI,iBAEI,oBACuF,uBAChF,CAExB,2EACC,WAAY,CHxCZ,6FGgDF,YAAa,CHhDX,gEGqDF,eAAe,mBACI,kBACD,kBACA,sBACI,UDhL0B,CFuH9C,2DIhHF,4DAEA,oDAnCA,WF0BgD,YAAA,8BK1BhD,sBAAsB,kBACJ,yBFCQ,2BAPD,qBESJ,kBJ2MrB,qBAAsB,CH9DpB,8DIhHF,8CDqLiD,sCAAA,cAEjD,eAAe,mBACI,kBACD,kBACA,sBACI,UGrLgD,CN0GpE,oEG+ED,aExNwB,CLyIvB,yDGmFF,qBAAqB,eAErB,aAAc,CHrFZ,6EGwFF,UGlMsE,CN0GpE,sFG4FD,oBAAqB,CH5FpB,qEG+FF,kBAAkB,qBACG,WACV,UACD,YACE,mBACO,gBACH,UACL,CHtGT,8DG6GF,eAAe,mBACI,kBACD,kBACA,sBACI,WACU,iBDzOgB,CC4OhD,2EACC,gBAAgB,gBD7O+B,CFuH9C,yDG4HF,6CAAyD,mBACtC,yBAC4D,qBAC1D,SACZ,QACD,iBACU,CAClB,2CAWA,GAAO,SAAU,CAAA,GACZ,SAAU,CAAA,CAAA,mCAGf,GAAO,SAAU,CAAA,GACZ,SAAU,CAAA,CHnJb,8DI9HF,+BACA,8BEdsC,sBDmBzB,yBAvBa,yBGI8C,wBFSjC,gBAAA,8BEPvC,sBAAsB,gBACN,iBNiBgC,kBMf9B,SACT,WACE,aFQ4B,gCENN,CRkI/B,wDQ3HF,iBAA2C,eAC3B,CR0Hd,0DQnHF,8BAAA,sBAAsB,sBHLT,cCAsD,eEQpD,cACD,gBNRkC,CFuH9C,qEI9HF,+BACA,6BEdsC,CN2IpC,2IQlGD,yBHzCwB,aAXA,CLsJvB,sEQ7FD,cHpDyB,cGqDV,CR4Fd,6DQnFF,8BAAA,sBAAsB,cH9DI,eGgEX,cACD,gBNvCkC,CFuH9C,wES/ID,sBAAsB,iBPwByB,SOrBrC,CT4IT,oFSzID,cAAc,iBPkBiC,CFuH9C,kFSnID,ePY+C,CFuH9C,wES9HD,yBJxBwB,kBH+BuB,yBG/BvB,WA8BZ,qBIFS,gBHiCkB,gBJ9BQ,eAAA,kBOC5B,CTsHlB,2JShHD,qBAAqB,qBACC,CT+GrB,8EInIF,+BFYgD,4BAAA,eOchC,ePdgC,CFuH9C,+ESrGD,WJnBY,eIoBG,oBACM,CTmGpB,qFShGA,yBAA0B,CTgG1B,6ES1FD,eL/BD,8BFEgD,2BAAA,+BG/BvB,mBIiEwF,CTqF/G,sKSjFA,yBJhEwB,UAyBb,CLwHX,oFS7EA,wBJzEuB,CLsJvB,oFSvEC,cAAc,gBPhD+B,CFuH9C,yFSnEA,kBAAkB,6BJnFK,CLsJvB,oFS3DD,yBJpFyB,yBAAA,aALH,CLoJrB,yFSrDD,mBAAmB,8BJ1FM,CL+IxB,8RS/CA,wBJhGwB,CEO3B,iCACC,GAAK,gCAAA,uBAAwB,CAAA,CAAA,yCAG7B,GAAK,+BAAgC,CAAA,CPwIpC,8BK7EE,cLiFA,2DAAA,mDAAmD,iCACnD,wBAAyB,CAL1B,oCAQG,WAAY,CA7BlB,8CC/FE,kBDiI4B,QAAK,SExIc,kBF0I7C,4BAAsC,oBAEtC,iBAAiB,qDACjB,6CAA6D,UACnD,gBACM,mFAEhB,0EAAwD,CAExD,oCACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAP5B,4BACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CApDhC,wBKhEI,yBA1DsB,aADC,CL2H3B,sBKhEI,yBAvDoB,aADE,CLyLvB,QE9HC,mCAJqC,kCAKH,aS/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,gBACD,CXoMpB,aAPD,QWpJU,uBAA0B,CX2JnC,CAPD,qBW1IM,eAAgB,CX0ItB,yBWlIM,eAAgB,CXkItB,aAKI,eAAgB,CACjB,oBAID,cAAe,CAChB,cAGC,sCAAwC,CACzC,mBAGC,kCAAA,8BAAA,yBAAmC,CACpC,cAGC,iBAAiB,gBACW,CAC7B","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Select Component\n */\n\n@import '../../../atoms/text/Label/mixins';\n@import './mixins';\n\n@mixin select-for-size($size) {\n  $options: map-get($select-sizes, $size);\n  $select-input-height: baseline(map-get($options, input-height));\n  $select-padding-horizontal: baseline(map-get($options, padding-horizontal));\n\n  &.select-color-scheme--light{\n    $select-input-bg: color(bw2);\n    $select-input-bg-focus: $select-input-bg;\n    $select-input-border-color: color(bw5);\n    $select-option-bg: color(white);\n    $select-input-bg-disabled: color(white);\n    @import \"./react-select\";\n    @import \"components\";\n  }\n\n  &.select-color-scheme--white{\n    $select-input-bg: color(white);\n    $select-input-bg-focus: $select-input-bg;\n    $select-input-border-color: uicolor(border);\n    $select-option-bg: color(white);\n    $select-input-bg-disabled: color(bw3);\n    @import \"./react-select\";\n    @import \"components\";\n  }\n}\n\n.select{\n  &__label{\n    margin-bottom: baseline(1);\n    display: block;\n  }\n\n  &__note{\n    @include position(absolute, baseline(.125) baseline(.25) null null);\n  }\n\n  &--small{\n    @include select-for-size(small);\n    .Select-arrow-zone {\n      @include padding(null baseline(.25) null baseline(1));\n    }\n  }\n\n  &--medium{\n    @include select-for-size(medium);\n  }\n\n  &--error &__label{\n    $fz: 10;\n    @include textcolor(dangerous);\n\n    animation: transform-to-error .15s ease-in-out .25s;\n    animation-fill-mode: both;\n\n    &::after{\n      content: \":\";\n    }\n  }\n\n  .label--error, .label--warning{\n    @include position(absolute, 95% null null baseline(1));\n    @include bgsize(small);\n    max-width: calc(100% - #{baseline(2)});\n    padding: baseline(.5) baseline(1) baseline(.625);\n    border: 1px solid;\n    box-shadow: -1px 1px 4px transparentize(uicolor(shadow), .75);\n    z-index: 1;\n    text-align: left;\n\n    animation: show-label-error .25s $ease-out-back forwards;\n\n    @keyframes show-label-error {\n      0% {\n        opacity: 0;\n        transform: translateY(50%);\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .label--warning{\n    @include bgcolor(accent-subtle);\n    @include textcolor(accent);\n  }\n\n  .label--error{\n    @include bgcolor(dangerous-subtle);\n    @include textcolor(dangerous);\n  }\n}\n\n.Select{\n  @include label;\n  @include label-size(medium);\n\n  span{\n    position: static;\n  }\n}\n\n.Select-input > input {\n  padding: 12px 0;\n}\n\n.Select-input {\n  background-color: transparent !important;\n}\n\n.Select-clear-zone{\n  transform: translateX(baseline(.5));\n}\n\n.Select-clear{\n  font-size: 1.75em; // 21 on 12\n  line-height: baseline(5) - 2;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","//\n// Control\n// ------------------------------\n\n@import 'spinner';\n@import 'mixins';\n\n.Select {\n\tposition: relative;\n\n\t// disable some browser-specific behaviours that break the input\n\tinput::-webkit-contacts-auto-fill-button,\n\tinput::-webkit-credentials-auto-fill-button {\n\t\tdisplay: none !important;\n\t}\n\tinput::-ms-clear {\n\t\tdisplay: none !important;\n\t}\n\tinput::-ms-reveal {\n\t\tdisplay: none !important;\n\t}\n\n\t// preferred box model\n\t&,\n\t& div,\n\t& input,\n\t& span {\n\t\t@include box-sizing(border-box);\n\t}\n\n\t// handle disabled state\n\t&.is-disabled {\n\t\t.Select-arrow-zone {\n\t\t\tcursor: default;\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t> .Select-control {\n\t\t\tbackground-color: $select-input-bg-disabled;\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.is-searchable {\n\t\t&.is-open > .Select-control {\n\t\t\tcursor: text;\n\t\t}\n\n\t\t&.is-focused:not(.is-open) > .Select-control {\n\t\t\tcursor: text;\n\t\t}\n\t}\n\n\t&.is-open > .Select-control {\n\t\t@include border-bottom-radius( 0 );\n\t\tbackground: $select-input-bg;\n\t\tborder-color: darken($select-input-border-color, 10%) $select-input-border-color lighten($select-input-border-color, 5%);\n\n\t\t// flip the arrow so its pointing up when the menu is open\n\t\t.Select-arrow {\n\t\t\ttop: -2px;\n\t\t\tborder-color: transparent transparent $select-arrow-color;\n\t\t\tborder-width: 0 $select-arrow-width $select-arrow-width;\n\t\t}\n\t}\n\n\t&.is-focused > .Select-control {\n\t\tbackground: $select-input-bg-focus;\n\t}\n\n\t&.is-focused:not(.is-open) > .Select-control {\n\t\tborder-color: $select-input-border-focus lighten($select-input-border-focus, 5%) lighten($select-input-border-focus, 5%);\n\t\tbox-shadow: $select-input-box-shadow-focus;\n\t}\n\n\n\t&.has-value.is-clearable.Select--single > .Select-control .Select-value {\n\t\tpadding-right: ($select-clear-width + $select-arrow-width * 5);\n\t}\n\n\t&.has-value.Select--single > .Select-control .Select-value,\n\t&.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value {\n\t\t.Select-value-label {\n\t\t\tcolor: $select-text-color;\n\t\t}\n\t\ta.Select-value-label {\n\t\t\tcursor: pointer;\n\t\t\ttext-decoration: none;\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tcolor: $select-link-hover-color;\n\t\t\t\toutline: none;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\tbackground: $select-input-bg-focus;\n\t\t\t}\n\t\t}\n\t}\n\n\t// fake-hide the input when the control is pseudo-focused\n\t&.has-value.is-pseudo-focused .Select-input {\n\t\topacity: 0;\n\t}\n\n\t&.is-open .Select-arrow,\n\t.Select-arrow-zone:hover > .Select-arrow {\n\t\tborder-top-color: $select-arrow-color-hover;\n\t}\n\t&.Select--rtl {\n\t\tdirection: rtl;\n\t\ttext-align: right;\n\t}\n}\n\n// base\n\n.Select-control {\n\tbackground-color: $select-input-bg;\n\tborder-color: lighten($select-input-border-color, 5%) $select-input-border-color darken($select-input-border-color, 10%);\n\tborder-radius: $select-input-border-radius;\n\tborder: $select-input-border-width solid $select-input-border-color;\n\tcolor: $select-text-color;\n\tcursor: default;\n\tdisplay: table;\n\tborder-spacing: 0;\n\tborder-collapse: separate;\n\theight: $select-input-height;\n\toutline: none;\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbox-shadow: $select-input-hover-box-shadow;\n\t}\n\n\t.Select-input:focus {\n\t\toutline: none;\n\t\tbackground: $select-input-bg-focus;\n\t}\n}\n\n// placeholder\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n\tbottom: 0;\n\tcolor: $select-input-placeholder;\n\tleft: 0;\n\tline-height: $select-input-internal-height;\n\tpadding-left: $select-padding-horizontal;\n\tpadding-right: $select-padding-horizontal;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\n\t// crop text\n\tmax-width: 100%;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n\n// the <input> element users type in\n\n.Select-input {\n\t// inherits `display: inline-block` from \"react-input-autosize\"\n\theight: $select-input-internal-height;\n\tpadding-left: $select-padding-horizontal;\n\tpadding-right: $select-padding-horizontal;\n\tvertical-align: middle;\n\n\t> input {\n\t\tbackground: none transparent;\n\t\tborder: 0 none;\n\t\tbox-shadow: none;\n\t\tcursor: default;\n\t\tdisplay: inline-block;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\t// height: $select-input-internal-height;\n\t\tmargin: 0;\n\t\toutline: none;\n\t\t// padding: 0;\n\t\tline-height: 17px;  /* For IE 8 compatibility */\n\t\tpadding: (($select-input-internal-height - 14) / 2 - 2) 0 (($select-input-internal-height - 14) / 2 + 2);  /* For IE 8 compatibility */\n\t\t-webkit-appearance: none;\n\n\t\t.is-focused & {\n\t\t\tcursor: text;\n\t\t}\n\t}\n\n}\n\n// fake input\n.Select-control:not(.is-searchable) > .Select-input {\n\toutline: none;\n}\n\n// loading indicator\n.Select-loading-zone {\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: $select-loading-size;\n}\n.Select-loading {\n\t@include Select-spinner($select-loading-size, $select-loading-color-bg, $select-loading-color);\n\tvertical-align: middle;\n}\n\n\n// the little cross that clears the field\n\n.Select-clear-zone {\n\t@include animation( Select-animation-fadeIn 200ms );\n\tcolor: $select-clear-color;\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: $select-clear-width;\n\n\t&:hover {\n\t\tcolor: $select-clear-hover-color;\n\t}\n}\n.Select-clear {\n\tdisplay: inline-block;\n\tfont-size: $select-clear-size;\n\tline-height: 1;\n}\n.Select--multi .Select-clear-zone {\n\twidth: $select-clear-width;\n}\n\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n\tposition: absolute;\n\tdisplay: inline-block;\n\theight: 1px;\n\twidth: 1px;\n\tmargin: -1px;\n\tclip: rect(0,0,0,0);\n\toverflow: hidden;\n\tfloat: left;\n}\n\n\n// arrow indicator\n\n.Select-arrow-zone {\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: ($select-arrow-width * 5);\n\tpadding-right: $select-arrow-width;\n\n\t.Select--rtl & {\n\t\tpadding-right: 0;\n\t\tpadding-left: $select-arrow-width;\n\t}\n}\n\n.Select-arrow {\n\tborder-color: $select-arrow-color transparent transparent;\n\tborder-style: solid;\n\tborder-width: $select-arrow-width $select-arrow-width ($select-arrow-width / 2);\n\tdisplay: inline-block;\n\theight: 0;\n\twidth: 0;\n\tposition: relative;\n}\n\n\n\n\n// Animation\n// ------------------------------\n\n// fade in\n\n@-webkit-keyframes Select-animation-fadeIn {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n@keyframes Select-animation-fadeIn {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n","//\n// Mixins\n// ------------------------------\n\n\n// Utilities\n\n@mixin size($width, $height)\n{\n\twidth: $width;\n\theight: $height;\n}\n@mixin square($size)\n{\n\t@include size($size, $size);\n}\n@mixin border-top-radius($radius)\n{\n\tborder-top-right-radius: $radius;\n\tborder-top-left-radius: $radius;\n}\n@mixin border-right-radius($radius)\n{\n\tborder-bottom-right-radius: $radius;\n\tborder-top-right-radius: $radius;\n}\n@mixin border-bottom-radius($radius)\n{\n\tborder-bottom-right-radius: $radius;\n\tborder-bottom-left-radius: $radius;\n}\n@mixin border-left-radius($radius)\n{\n\tborder-bottom-left-radius: $radius;\n\tborder-top-left-radius: $radius;\n}\n\n\n// Vendor Prefixes\n\n@mixin animation($animation)\n{\n\t-webkit-animation: $animation;\n\t-o-animation: $animation;\n\tanimation: $animation;\n}\n@mixin box-sizing($boxmodel)\n{\n\t-webkit-box-sizing: $boxmodel;\n\t-moz-box-sizing: $boxmodel;\n\tbox-sizing: $boxmodel;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/JedWatson/react-select\n*/\n\n// Variables\n// ------------------------------\n\n// control options\n// $select-input-bg:                   color(white);\n// $select-input-bg-disabled:          color(bw3);\n// $select-input-border-color:         uicolor(border);\n$select-input-border-radius:        2px;\n$select-input-border-focus:         color(accent);\n$select-input-box-shadow-focus:     none;\n$select-input-border-width:         1px;\n// $select-input-height:               baseline(5);\n$select-input-internal-height:      ($select-input-height - ($select-input-border-width * 2)) !default;\n$select-input-placeholder:          color(bw6);\n$select-text-color:                 color(black);\n$select-link-hover-color:           $select-input-border-focus !default;\n$select-input-hover-box-shadow:     none;\n\n$select-padding-vertical:           baseline(1);\n// $select-padding-horizontal:         baseline(1.5);\n\n// menu options\n$select-menu-zindex:                1000 !default;\n$select-menu-max-height:            baseline(25);\n$select-menu-box-shadow:            $select-input-hover-box-shadow !default;\n\n$select-option-color:               lighten($select-text-color, 20%) !default;\n// $select-option-bg:                  $select-input-bg !default;\n$select-option-focused-color:       $select-text-color;\n$select-option-focused-bg:          color(accent-subtle);\n$select-option-selected-color:      color(black);\n$select-option-selected-bg:         color(accent-subtle);\n$select-option-disabled-color:      color(bw6);\n\n$select-noresults-color:            color(bw6);\n\n// clear \"x\" button\n$select-clear-size:                 floor(($select-input-height / 2)) !default;\n$select-clear-color:                color(bw6);\n$select-clear-hover-color:          color(dangerous);\n$select-clear-width:                ($select-input-internal-height / 2) !default;\n\n// arrow indicator\n$select-arrow-color:                color(black);\n$select-arrow-color-hover:          color(bw6);\n$select-arrow-width:                baseline(.5);\n\n// loading indicator\n$select-loading-size:               baseline(2);\n$select-loading-color:              $select-text-color !default;\n$select-loading-color-bg:           $select-input-border-color !default;\n\n// multi-select item\n$select-item-border-radius:         baseline(.25);\n$select-item-gutter:                baseline(.5);\n$select-item-padding-vertical:      baseline(.25);\n$select-item-padding-horizontal:    baseline(.5);\n$select-item-font-size:             .75em;\n$select-item-color:                 color(white);\n$select-item-bg:                    color(black);\n$select-item-border-color:          color(black);\n$select-item-hover-color:           color(white);\n$select-item-hover-bg:              color(bw6);\n$select-item-disabled-color:        color(bw7);\n$select-item-disabled-bg:           color(bw4);\n$select-item-disabled-border-color: color(bw4);\n","//\n// Spinner\n// ------------------------------\n@import 'mixins';\n\n@mixin Select-spinner($size, $orbit, $satellite)\n{\n\t@include animation( Select-animation-spin 400ms infinite linear );\n\t@include square($size);\n\tbox-sizing: border-box;\n\tborder-radius: 50%;\n\tborder: floor(($size / 8)) solid $orbit;\n\tborder-right-color: $satellite;\n\tdisplay: inline-block;\n\tposition: relative;\n\n}\n\n@keyframes Select-animation-spin {\n\tto { transform: rotate(1turn); }\n}\n@-webkit-keyframes Select-animation-spin {\n\tto { -webkit-transform: rotate(1turn); }\n}\n","//\n// Select Menu\n// ------------------------------\n\n\n// wrapper around the menu\n\n.Select-menu-outer {\n\t// Unfortunately, having both border-radius and allows scrolling using overflow defined on the same\n\t// element forces the browser to repaint on scroll.  However, if these definitions are split into an\n\t// outer and an inner element, the browser is able to optimize the scrolling behavior and does not\n\t// have to repaint on scroll.\n\t@include border-bottom-radius( $select-input-border-radius );\n\tbackground-color: $select-input-bg;\n\tborder: 1px solid $select-input-border-color;\n\tborder-top-color: mix($select-input-bg, $select-input-border-color, 50%);\n\tbox-shadow: $select-menu-box-shadow;\n\tbox-sizing: border-box;\n\tmargin-top: -1px;\n\tmax-height: $select-menu-max-height;\n\tposition: absolute;\n\ttop: 100%;\n\twidth: 100%;\n\tz-index: $select-menu-zindex;\n\t-webkit-overflow-scrolling: touch;\n}\n\n\n// wrapper\n\n.Select-menu {\n\tmax-height: ($select-menu-max-height - 2px);\n\toverflow-y: auto;\n}\n\n\n// options\n\n.Select-option {\n\tbox-sizing: border-box;\n\tbackground-color: $select-option-bg;\n\tcolor: $select-option-color;\n\tcursor: pointer;\n\tdisplay: block;\n\tpadding: $select-padding-vertical $select-padding-horizontal;\n\n\t&:last-child {\n\t\t@include border-bottom-radius( $select-input-border-radius );\n\t}\n\n\t&.is-selected {\n\t\tbackground-color: $select-option-selected-bg;\n\t\tcolor: $select-option-selected-color;\n\t}\n\n\t&.is-focused {\n\t\tbackground-color: $select-option-focused-bg;\n\t\tcolor: $select-option-focused-color;\n\t}\n\n\t&.is-disabled {\n\t\tcolor: $select-option-disabled-color;\n\t\tcursor: default;\n\t}\n\n}\n\n\n// no results\n\n.Select-noresults {\n\tbox-sizing: border-box;\n\tcolor: $select-noresults-color;\n\tcursor: default;\n\tdisplay: block;\n\tpadding: $select-padding-vertical $select-padding-horizontal;\n}\n","//\n// Multi-Select\n// ------------------------------\n\n\n// Base\n\n.Select--multi {\n\n\t// add margin to the input element\n\t.Select-input {\n\t\tvertical-align: middle;\n\t\t// border: 1px solid transparent;\n\t\tmargin-left: $select-padding-horizontal;\n\t\tpadding: 0;\n\t}\n\t&.Select--rtl .Select-input {\n\t\tmargin-left: 0;\n\t\tmargin-right: $select-padding-horizontal;\n\t}\n\n\t// reduce margin once there is value\n\t&.has-value .Select-input {\n\t\tmargin-left: $select-item-gutter;\n\t}\n\n\t// Items\n\t.Select-value {\n\t\tbackground-color: $select-item-bg;\n\t\tborder-radius: $select-item-border-radius;\n\t\tborder: 1px solid $select-item-border-color;\n\t\tcolor: $select-item-color;\n\t\tdisplay: inline-block;\n\t\tfont-size: $select-item-font-size;\n\t\tmargin-left: $select-item-gutter;\n\t\tmargin-top: $select-item-gutter;\n\t\tvertical-align: top;\n\t}\n\n\t// common\n\t.Select-value-icon,\n\t.Select-value-label {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n\n\t// label\n\t.Select-value-label {\n\t\t@include border-right-radius( $select-item-border-radius );\n\t\tcursor: default;\n\t\tpadding: $select-item-padding-vertical $select-item-padding-horizontal;\n\t}\n\ta.Select-value-label {\n\t\tcolor: $select-item-color;\n\t\tcursor: pointer;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n\n\t// icon\n\t.Select-value-icon {\n\t\tcursor: pointer;\n\t\t@include border-left-radius( $select-item-border-radius );\n\t\tborder-right: 1px solid $select-item-border-color;\n\n\t\t// move the baseline up by 1px\n\t\tpadding: ($select-item-padding-vertical - 1) $select-item-padding-horizontal ($select-item-padding-vertical + 1);\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground-color: $select-item-hover-bg;\n\t\t\tcolor: $select-item-hover-color;\n\t\t}\n\t\t&:active {\n\t\t\tbackground-color: $select-item-border-color;\n\t\t}\n\t}\n\n\t&.Select--rtl {\n\t\t.Select-value {\n\t\t  margin-left: 0;\n\t\t  margin-right: $select-item-gutter;\n\t\t}\n\t\t.Select-value-icon {\n\t\t\tborder-right: none;\n\t\t\tborder-left: 1px solid $select-item-border-color;\n\t\t}\n\t}\n}\n\n.Select--multi.is-disabled {\n\t.Select-value {\n\t\tbackground-color: $select-item-disabled-bg;\n\t\tborder: 1px solid $select-item-disabled-border-color;\n\t\tcolor: $select-item-disabled-color;\n\t}\n\t// icon\n\t.Select-value-icon {\n\t\tcursor: not-allowed;\n\t\tborder-right: 1px solid $select-item-disabled-border-color;\n\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground-color: $select-item-disabled-bg;\n\t\t}\n\t}\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1140 */,
/* 1141 */,
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SelectInput Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);

var SelectInput = function (_React$Component) {
    _inherits(SelectInput, _React$Component);

    function SelectInput() {
        _classCallCheck(this, SelectInput);

        return _possibleConstructorReturn(this, (SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).apply(this, arguments));
    }

    _createClass(SelectInput, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _props = this.props,
                value = _props.input.value,
                setInitialValue = _props.setInitialValue;

            if (value && setInitialValue) {
                setInitialValue(value);
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref) {
            var _ref$meta = _ref.meta,
                error = _ref$meta.error,
                warning = _ref$meta.warning;

            if (this.props.onError) {
                if (error && !this.props.meta.error) {
                    this.props.onError(error);
                } else if (!error && this.props.meta.error) {
                    this.props.onError();
                }
            }
            if (this.props.onWarning) {
                if (warning && !this.props.meta.warning) {
                    this.props.onWarning(warning);
                } else if (!warning && this.props.meta.warning) {
                    this.props.onWarning();
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("input", { type: "hidden", name: this.props.input.name, value: this.props.input.value });
        }
    }]);

    return SelectInput;
}(React.Component);

exports.default = SelectInput;

/***/ }),
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page__animation-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden}.page.not-found .page__main{color:#b1b8c4;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/templates/Page/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA6GE,yBACE,oBAAA,oBAAA,aAAa,eACG,CAHpB,4BC3BI,cDmCA,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,iBACD,CACnB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * PageTemplate Component\n */\n\n.page{\n  &__animation-wrapper{\n    display: flex;\n    overflow: hidden;\n  }\n\n  &.not-found &__main{\n    @include textcolor(bw6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1252);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1254);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var string_1 = __webpack_require__(47);

var EllipsisLabel = function (_React$Component) {
    _inherits(EllipsisLabel, _React$Component);

    function EllipsisLabel() {
        _classCallCheck(this, EllipsisLabel);

        return _possibleConstructorReturn(this, (EllipsisLabel.__proto__ || Object.getPrototypeOf(EllipsisLabel)).apply(this, arguments));
    }

    _createClass(EllipsisLabel, [{
        key: "createLabelMarkup",
        value: function createLabelMarkup() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.text;

            return string_1.toInnerHTML(text);
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                length = _a.length,
                tail = _a.tail,
                tailClassName = _a.tailClassName,
                text = _a.text,
                props = __rest(_a, ["length", "tail", "tailClassName", "text"]);
            var textWithoutHTML = string_1.stripHTMLTagsFromString(text);
            if (textWithoutHTML.length <= length || length < 0) {
                return React.createElement("span", Object.assign({ dangerouslySetInnerHTML: this.createLabelMarkup() }, props));
            }
            var displayText = length - tail.length <= 0 ? text : text.slice(0, length);
            return React.createElement("span", Object.assign({ title: text }, props), React.createElement("span", { dangerouslySetInnerHTML: this.createLabelMarkup(displayText) }), React.createElement("span", { className: tailClassName }, tail));
        }
    }]);

    return EllipsisLabel;
}(React.Component);

EllipsisLabel.defaultProps = {
    tail: '...',
    tailClassName: 'more'
};
exports.default = EllipsisLabel;

/***/ }),
/* 1256 */,
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseAudienceSize Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1258);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ConnectedLicenseBuilderComponent_1 = __webpack_require__(212);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var config_1 = __webpack_require__(142);
var classes = new BEM('license-builder__step');

var LicenseContextualParam = function (_React$Component) {
    _inherits(LicenseContextualParam, _React$Component);

    function LicenseContextualParam() {
        _classCallCheck(this, LicenseContextualParam);

        return _possibleConstructorReturn(this, (LicenseContextualParam.__proto__ || Object.getPrototypeOf(LicenseContextualParam)).apply(this, arguments));
    }

    _createClass(LicenseContextualParam, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.selectedParam !== this.props.selectedParam || nextProps.editingUsageIndex !== this.props.editingUsageIndex;
        }
    }, {
        key: "renderButton",
        value: function renderButton(_ref) {
            var _this2 = this;

            var internal_id = _ref.internal_id,
                name = _ref.name;

            var id = internal_id;
            var component = { id: id, name: name };
            var selectedParam = this.props.selectedParam && this.props.selectedParam[0];
            var extraClassName = classNames({ 'is-active': !!selectedParam && id === selectedParam.id });
            return React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                    _this2.props.setParam([component]);
                } }, classes('button', '', extraClassName), { label: name, size: "small", colorScheme: "white" }));
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                editingUsageIndex = _props.editingUsageIndex,
                medium = _props.medium,
                title = _props.title;

            var mediumDefinition = config_1.mediaTypeDefinitions.find(function (v) {
                return v.id === medium;
            });
            var subtitle = void 0;
            if (mediumDefinition) {
                subtitle = mediumDefinition.contextualSubtitle;
            }
            return React.createElement("div", Object.assign({}, classes('', 'audience-size')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), title, ":"), React.createElement("ul", null, this.props.data.map(function (_ref2) {
                var node = _ref2.node;
                return React.createElement("li", { key: editingUsageIndex + "-" + node.internal_id }, _this3.renderButton(node));
            })), React.createElement(Label_1.Span, Object.assign({ size: "medium", variant: "description" }, classes('note')), subtitle));
        }
    }]);

    return LicenseContextualParam;
}(React.Component);

var ConnectedLicenseContextualParam = ConnectedLicenseBuilderComponent_1.default(LicenseContextualParam, 'contextual_param');
exports.default = ConnectedLicenseContextualParam;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1259);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-builder__step--audience-size.license-builder__step{-webkit-box-flex:0;-ms-flex:0 0 360px;flex:0 0 360px}.license-builder__step--audience-size .license-builder__step__note{margin-top:28px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/license-builder/SelectContextualParam/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GC,4DAGG,mBAAA,mBAAA,cC5E6C,CDyEhD,mEAOG,eChF6C,CDiF9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseAudienceSize Component\n */\n\n .license-builder__step--audience-size{\n\n  &.license-builder__step{  // Force style override\n    flex: 0 0 baseline(45);\n  }\n\n  .license-builder__step__note {  // Force style override\n    margin-top: baseline(3.5);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseLocation Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1261);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ConnectedLicenseBuilderComponent_1 = __webpack_require__(212);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var config_1 = __webpack_require__(142);
var CheckboxWithLabel_1 = __webpack_require__(213);
var LocationCheckbox_1 = __webpack_require__(602);
var classes = new BEM('license-builder__step');

var LicenseLocation = function (_React$Component) {
    _inherits(LicenseLocation, _React$Component);

    function LicenseLocation(props) {
        _classCallCheck(this, LicenseLocation);

        var _this = _possibleConstructorReturn(this, (LicenseLocation.__proto__ || Object.getPrototypeOf(LicenseLocation)).call(this, props));

        _this.onSelectLocation = function (component) {
            _this.props.setParam(_this.isLocationSet(component.id) ? null : [component]);
        };
        _this.sortLocations();
        return _this;
    }

    _createClass(LicenseLocation, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (!lodash_1.isEqual(nextProps.data, this.props.data)) {
                this.sortLocations(nextProps);
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !lodash_1.isEqual(nextProps.selectedParam, this.props.selectedParam) || nextProps.editingUsageIndex === this.props.editingUsageIndex;
        }
    }, {
        key: "renderList",
        value: function renderList(list, title) {
            var _this2 = this;

            return !!list.length && React.createElement("ul", { "data-title": title }, list.map(function (_ref) {
                var id = _ref.internal_id,
                    name = _ref.name;
                return React.createElement("li", { key: _this2.props.editingUsageIndex + "-" + id }, React.createElement(LocationCheckbox_1.LocationCheckbox, { checked: _this2.isLocationSet(id), id: id, name: name, onChange: _this2.onSelectLocation }));
            }));
        }
    }, {
        key: "renderCheckbox",
        value: function renderCheckbox(id, name) {
            var _this3 = this;

            var component = { id: id, name: name };
            return React.createElement(CheckboxWithLabel_1.default, { checked: this.isLocationSet(id), onChange: function onChange() {
                    _this3.onSelectLocation(component);
                }, label: name, name: "location[" + id + "]" });
        }
    }, {
        key: "render",
        value: function render() {
            var medium = this.props.medium;

            var mediumDefinition = config_1.mediaTypeDefinitions.find(function (v) {
                return v.id === medium;
            });
            var locationSubtitle = void 0;
            if (mediumDefinition) {
                locationSubtitle = mediumDefinition.contextualSubtitle;
            }
            return React.createElement("div", Object.assign({}, classes('', 'location')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Your Location:"), React.createElement(Label_1.Span, Object.assign({ size: "medium", variant: "note" }, classes('note')), locationSubtitle), this.renderList(this.commonLocations, 'Commonly Used'), this.renderList(this.countryLocations, 'All Countries'));
        }
    }, {
        key: "isLocationSet",
        value: function isLocationSet(locationId) {
            var selectedLocation = this.props.selectedParam && this.props.selectedParam[0];
            return !!selectedLocation && selectedLocation.id === locationId;
        }
    }, {
        key: "sortLocations",
        value: function sortLocations() {
            var _this4 = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            this.commonLocations = [];
            this.countryLocations = [];
            props.data.forEach(function (edge) {
                var node = edge.node;
                var name = node.name;

                if (['United States of America', 'Canada', 'France'].indexOf(name) > -1) {
                    _this4.commonLocations.push(node);
                } else {
                    _this4.countryLocations.push(node);
                }
            });
            this.commonLocations = lodash_1.sortBy(this.commonLocations, 'name');
            this.countryLocations = lodash_1.sortBy(this.countryLocations, 'name');
        }
    }]);

    return LicenseLocation;
}(React.Component);

var ConnectedLicenseLocation = ConnectedLicenseBuilderComponent_1.default(LicenseLocation, 'contextual_param');
exports.default = ConnectedLicenseLocation;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1262);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.license-builder__step--location.license-builder__step{-webkit-box-flex:1;-ms-flex:1 0 360px;flex:1 0 360px}.license-builder__step--location.license-builder__step ul:before{content:attr(data-title);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.75em;font-weight:500;line-height:1.3333333333;margin:8px 0;text-transform:uppercase;letter-spacing:.3em;color:#b1b8c4;display:block;text-rendering:geometricPrecision}.license-builder__step--location.license-builder__step ul:before .label{display:inline-block}@media screen and (min-width:600px){.license-builder__step--location.license-builder__step ul:before{margin:16px 0}}.license-builder__step--location .checkbox{padding-top:8px;padding-bottom:8px}.license-builder__step--location .tooltip{color:#d2d9e1;margin-left:8px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/license-builder/SelectLocation/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,uDC+DpE,mBAAA,mBAAA,cC9E6C,CD4EjD,iEAMQ,yBAAyB,mCC7CQ,kCAKH,mEChEpC,8CAAA,yCAAA,sCAAsC,gBAyHjB,gBAGL,yBACS,aAGF,yBAGE,oBACL,cFxBd,cAAc,iCACoB,CAX1C,wEE/FI,oBAAqB,CACtB,oCF8FH,iEEsCM,aAAqB,CF1BpB,CAZP,2CG3BwB,gBFjDyB,kBAAA,CD4EjD,0CI9BI,cJoDA,eClG6C,CDmG9C","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseLocation Component\n */\n\n@import '../../../../atoms/text/Heading/mixins';\n\n\n.license-builder__step--location{\n  &.license-builder__step{  // Force style override\n    flex: 1 0 baseline(45);\n\n    ul{\n      &::before{\n        content: attr(data-title);\n        @include base-heading;\n        @include h6;\n        @include textcolor(bw6);\n        display: block;\n        text-rendering: geometricPrecision;\n      }\n    }\n  }\n\n  .checkbox{\n    @include padding(baseline(1) null);\n  }\n\n  .tooltip{\n    @include textcolor(bw5);\n    margin-left: baseline(1);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1264);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".checkbox__label{line-height:12px;margin-left:8px;font-size:.75em}.checkbox--large .checkbox__label{margin-left:16px;line-height:16px;font-size:.875em}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/CheckboxWithLabel/styles.scss"],"names":[],"mappings":"AA6GE,iBACE,iBACA,gBACA,eAAgB,CACjB,kCAIG,iBACA,iBACA,gBAAiB,CAClB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CheckboxWithLabel Component\n */\n\n.checkbox{\n  &__label{\n    line-height: baseline(1.5);\n    margin-left: baseline(1);\n    font-size: .75em;\n  }\n\n  &--large{\n    .checkbox__label{\n      margin-left: baseline(2);\n      line-height: baseline(2);\n      font-size: .875em;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1266);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".checkbox{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkbox label{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox__styled-input,.checkbox label{cursor:pointer}.checkbox__styled-input,.checkbox input[type=checkbox]{height:14px;width:14px;-webkit-box-flex:0;-ms-flex:none;flex:none}.checkbox__styled-input{position:absolute;top:50%;left:0;border-radius:2px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);border:1px solid #e4e8ed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkbox__styled-input__fill{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#101015;border-radius:50%;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .15s ease-in-out;transition:-webkit-transform .15s ease-in-out;-o-transition:transform .15s ease-in-out;transition:transform .15s ease-in-out;transition:transform .15s ease-in-out,-webkit-transform .15s ease-in-out}.checkbox__styled-input .icon--check{margin-left:-1px;display:none}.checkbox__styled-input .icon--check,.checkbox__styled-input .icon--check svg{width:inherit;height:inherit}.checkbox input[type=checkbox]{visibility:hidden}input[type=checkbox]:checked+.checkbox__styled-input{border-color:#101015;color:#fff}input[type=checkbox]:checked+.checkbox__styled-input .icon--check{display:block}input[type=checkbox]:checked+.checkbox__styled-input .checkbox__styled-input__fill{border-radius:0;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}.checkbox--large .checkbox__styled-input{border-radius:3px}.checkbox--large .checkbox__styled-input,.checkbox--large input[type=checkbox]{height:20px;width:20px}.checkbox:hover .icon--check{display:block}.checkbox .label--error,.checkbox .label--warning{position:absolute;bottom:calc(100% + 8px);left:0;border-radius:2px;min-width:200px;padding:4px 8px 5px;border:1px solid;-webkit-box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);z-index:1;text-align:left;-webkit-animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards;animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards}@-webkit-keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}.checkbox .label--warning{background-color:#f5faff;color:#4487ff}.checkbox .label--error{background-color:#fff5f5;color:#f75b5b}.checkbox-color-scheme--light .checkbox__styled-input{background-color:#f9fafb;color:#d2d9e1}.checkbox-color-scheme--white .checkbox__styled-input{background-color:#fff;color:#e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/forms/Checkbox/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,UAGE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAJrB,gBAOI,yBAAA,sBAAA,qBAAA,gBAAiB,CAClB,wCAGC,cAAe,CAChB,uDC7EC,YAMA,WD4EA,mBAAA,cAAA,SAAU,CACX,wBEpFD,kBFuF4B,QAAK,OAAY,kBAE3C,mCAAA,+BAAA,2BAA2B,yBAE3B,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAEnB,8BE9FF,kBF+F8B,MAAG,QAAA,SAAA,OAAA,yBAE7B,kBAAkB,2BAClB,uBAAA,mBAAmB,sDACnB,8CAAA,yCAAA,sCAAA,wEAAsC,CAbzC,qCAiBG,iBACA,YAAa,CAlBhB,8EAqBK,cAAc,cACC,CA1CvB,+BAgDI,iBAAkB,CACnB,qDAGC,qBG5JsB,UA8BZ,CH6HZ,kEAKI,aAAc,CALlB,mFASI,gBAAgB,2BAChB,uBAAA,kBAAmB,CACpB,yCAOC,iBAAkB,CAJrB,+EClIC,YAMA,UGd6C,CJyEjD,6BAgFM,aAAc,CAhFpB,kDElEE,kBFuJ4B,wBAAuC,OAAE,kBAEnE,gBACA,oBACA,iBAAiB,qDACjB,6CAA6D,UACnD,gBACM,mFAEhB,0EAAwD,CAExD,oCACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAP5B,4BACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAvGhC,0BGnCI,yBA1DsB,aADC,CH8F3B,wBGnCI,yBAvDoB,aADE,CH+MvB,sDGvJC,yBA5DsB,aAHH,CH2NpB,sDG5JC,sBAvCU,aAvBa,CH8NxB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Checkbox Component\n */\n\n.checkbox{\n  $size: baseline(1.75);\n\n  display: flex;\n  align-items: center;\n\n  label{\n    user-select: none;\n  }\n\n  &__styled-input, label {\n    cursor: pointer;\n  }\n\n  &__styled-input,\n  input[type='checkbox']{\n    @include size($size);\n    flex: none;\n  }\n\n  &__styled-input{\n    @include position(absolute, 50% null null 0);\n    @include bgsize(small);\n    transform: translateY(-50%);\n    border: 1px solid uicolor(border);\n    display: flex;\n    align-items: center;\n\n    &__fill{\n      @include position(absolute, 0);\n      @include bgcolor(black);\n      border-radius: 50%;\n      transform: scale(0);\n      transition: transform .15s ease-in-out;\n    }\n\n    .icon--check{\n      margin-left: baseline(-.125);\n      display: none;\n\n      &, svg{\n        width: inherit;\n        height: inherit;\n      }\n    }\n  }\n\n  input[type='checkbox'] {\n    visibility: hidden;\n  }\n\n  input[type='checkbox']:checked + &__styled-input {\n    border-color: color(black);\n    @include textcolor(white);\n\n    .icon--check{\n      display: block;\n    }\n\n    .checkbox__styled-input__fill{\n      border-radius: 0;\n      transform: scale(1);\n    }\n  }\n\n  &--large{\n    $size: baseline(2.5);\n\n    .checkbox__styled-input {\n      border-radius: 3px;\n    }\n\n    .checkbox__styled-input,\n    input[type='checkbox']{\n      @include size($size);\n    }\n  }\n\n  &:hover{\n    .icon--check{\n      display: block;\n    }\n  }\n\n  .label--error, .label--warning{\n    @include position(absolute, null null calc(100% + #{baseline(1)}) 0);\n    @include bgsize(small);\n    min-width: baseline(25);\n    padding: baseline(.5) baseline(1) baseline(.625);\n    border: 1px solid;\n    box-shadow: -1px 1px 4px transparentize(uicolor(shadow), .75);\n    z-index: 1;\n    text-align: left;\n\n    animation: show-label-error .25s $ease-out-back forwards;\n\n    @keyframes show-label-error {\n      0% {\n        opacity: 0;\n        transform: translateY(50%);\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .label--warning{\n    @include bgcolor(accent-subtle);\n    @include textcolor(accent);\n  }\n\n  .label--error{\n    @include bgcolor(dangerous-subtle);\n    @include textcolor(dangerous);\n  }\n\n  &-color-scheme--light &__styled-input{\n    @include bgcolor(bw2);\n    @include textcolor(bw5);\n  }\n  &-color-scheme--white &__styled-input{\n    @include bgcolor(white);\n    @include textcolor(bw4);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1268);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js??ref--3-1!../../postcss-loader/lib/index.js??ref--3-2!../../sass-loader/lib/loader.js??ref--3-3!../../sass-resources-loader/lib/loader.js??ref--3-4!./tippy.css", function() {
			var newContent = require("!!../../css-loader/index.js??ref--3-1!../../postcss-loader/lib/index.js??ref--3-2!../../sass-loader/lib/loader.js??ref--3-3!../../sass-resources-loader/lib/loader.js??ref--3-4!./tippy.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".tippy-iOS{cursor:pointer!important}.tippy-notransition{-webkit-transition:none!important;-o-transition:none!important;transition:none!important}.tippy-popper{-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;-webkit-transition-timing-function:cubic-bezier(.165,.84,.44,1);-o-transition-timing-function:cubic-bezier(.165,.84,.44,1);transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4;max-width:calc(100% - 10px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;-ms-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);-ms-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);-ms-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);-ms-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(60deg);transform:translateY(0) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden],.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px) scale(1);-ms-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);-ms-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);-ms-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;-ms-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);-ms-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);-ms-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);-ms-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;-ms-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-60deg);transform:translateY(0) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden],.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px) scale(1);-ms-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);-ms-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;-ms-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;-ms-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);-ms-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);-ms-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);-ms-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);-ms-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;-ms-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-60deg);transform:translateX(0) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden],.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);-ms-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);-ms-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px) scale(1);-ms-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);-ms-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;-ms-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);-ms-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;-ms-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;-ms-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);-ms-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);-ms-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);-ms-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);-ms-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(60deg);transform:translateX(0) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden],.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);-ms-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);-ms-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px) scale(1);-ms-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);-ms-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;max-width:350px;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{-webkit-transition-timing-function:cubic-bezier(.54,1.5,.38,1.11);-o-transition-timing-function:cubic-bezier(.54,1.5,.38,1.11);transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;-webkit-transition:all cubic-bezier(.46,.1,.52,.98);-o-transition:all cubic-bezier(.46,.1,.52,.98);transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{-webkit-transition-property:opacity;-o-transition-property:opacity;transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=visible]{opacity:1}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/tippy.js/dist/tippy.css"],"names":[],"mappings":"AAwGA,WAAW,wBAAwB,CAAC,oBAAoB,kCAAA,6BAAA,yBAAyB,CAAC,cAAc,0BAAyB,kBAAkB,aAAa,UAAU,gEAAC,2DAAA,wDAAuD,oBAAoB,gBAAgB,2BAA4B,CAAC,gDAAgD,yBAAyB,CAAC,kDAAkD,YAAW,+BAA+B,2BAAC,sBAAsB,CAAC,sDAAsD,kBAAiB,OAAO,iCAAiC,6BAAC,wBAAwB,CAAC,6CAA6C,0BAAyB,mCAAmC,kCAAkC,YAAY,aAAa,+BAA+B,2BAAC,sBAAsB,CAAC,gDAAgD,+BAA8B,2BAAC,sBAAsB,CAAC,oEAAoE,gDAA+C,4CAAC,uCAAuC,CAAC,mEAAmE,iDAAgD,6CAAC,yCAAwC,SAAU,CAAC,kFAAkF,oCAAmC,gCAAC,2BAA2B,CAAC,iFAAiF,UAAS,oCAAoC,gCAAC,2BAA2B,CAAC,6DAA6D,gCAA+B,4BAAC,uBAAuB,CAAC,iFAAiF,+CAA8C,sCAAuC,CAAC,gFAAgF,UAAS,+CAA+C,sCAAuC,CAAE,mJAAyE,oCAAmC,gCAAC,2BAA2B,CAAC,yEAAyE,SAAS,CAAiE,gFAAgF,oCAAmC,gCAAC,2BAA2B,CAAC,+EAA+E,UAAS,gCAAgC,4BAAC,uBAAuB,CAAC,2EAA2E,6CAA4C,yCAAC,oCAAoC,CAAC,0EAA0E,UAAS,0CAA0C,sCAAC,iCAAiC,CAAC,mDAAmD,yBAAyB,CAAC,qDAAqD,SAAQ,kCAAkC,8BAAC,yBAAyB,CAAC,yDAAyD,kBAAiB,OAAO,4BAA4B,wBAAC,mBAAmB,CAAC,gDAAgD,6BAA4B,mCAAmC,kCAAkC,SAAS,aAAa,kCAAkC,8BAAC,yBAAyB,CAAC,mDAAmD,gCAA+B,4BAAC,uBAAuB,CAAC,uEAAuE,gDAA+C,4CAAC,uCAAuC,CAAC,sEAAsE,4CAA2C,wCAAC,oCAAmC,SAAU,CAAC,qFAAqF,mCAAkC,+BAAC,0BAA0B,CAAC,oFAAoF,UAAS,mCAAmC,+BAAC,0BAA0B,CAAC,gEAAgE,6BAA4B,yBAAC,oBAAoB,CAAC,oFAAoF,8CAA6C,qCAAsC,CAAC,mFAAmF,UAAS,gDAAgD,uCAAwC,CAAE,yJAA4E,mCAAkC,+BAAC,0BAA0B,CAAC,4EAA4E,SAAS,CAA+D,mFAAmF,mCAAkC,+BAAC,0BAA0B,CAAC,kFAAkF,UAAS,gCAAgC,4BAAC,uBAAuB,CAAC,8EAA8E,4CAA2C,wCAAC,mCAAmC,CAAC,6EAA6E,UAAS,0CAA0C,sCAAC,iCAAiC,CAAC,iDAAiD,yBAAyB,CAAC,mDAAmD,YAAW,0CAA0C,sCAAC,iCAAiC,CAAC,uDAAuD,kBAAiB,OAAO,gCAAgC,4BAAC,uBAAuB,CAAC,8CAA8C,2BAA0B,iCAAiC,oCAAoC,WAAW,aAAa,+BAA+B,2BAAC,sBAAsB,CAAC,iDAAiD,+BAA8B,2BAAC,sBAAsB,CAAC,qEAAqE,gDAA+C,4CAAC,uCAAuC,CAAC,oEAAoE,iDAAgD,6CAAC,yCAAwC,SAAU,CAAC,mFAAmF,oCAAmC,gCAAC,2BAA2B,CAAC,kFAAkF,UAAS,oCAAoC,gCAAC,2BAA2B,CAAC,8DAA8D,+BAA8B,2BAAC,sBAAsB,CAAC,kFAAkF,+CAA8C,sCAAuC,CAAC,iFAAiF,UAAS,gDAAgD,uCAAwC,CAAE,qJAA0E,oCAAmC,gCAAC,2BAA2B,CAAC,0EAA0E,SAAS,CAAiE,iFAAiF,oCAAmC,gCAAC,2BAA2B,CAAC,gFAAgF,UAAS,gCAAgC,4BAAC,uBAAuB,CAAC,4EAA4E,6CAA4C,yCAAC,oCAAoC,CAAC,2EAA2E,UAAS,0CAA0C,sCAAC,iCAAiC,CAAC,kDAAkD,yBAAyB,CAAC,oDAAoD,WAAU,0CAA0C,sCAAC,iCAAiC,CAAC,wDAAwD,kBAAiB,OAAO,iCAAiC,6BAAC,wBAAwB,CAAC,+CAA+C,4BAA2B,iCAAiC,oCAAoC,UAAU,aAAa,kCAAkC,8BAAC,yBAAyB,CAAC,kDAAkD,gCAA+B,4BAAC,uBAAuB,CAAC,sEAAsE,gDAA+C,4CAAC,uCAAuC,CAAC,qEAAqE,iDAAgD,6CAAC,yCAAwC,SAAU,CAAC,oFAAoF,mCAAkC,+BAAC,0BAA0B,CAAC,mFAAmF,UAAS,mCAAmC,+BAAC,0BAA0B,CAAC,+DAA+D,8BAA6B,0BAAC,qBAAqB,CAAC,mFAAmF,8CAA6C,qCAAsC,CAAC,kFAAkF,UAAS,+CAA+C,sCAAuC,CAAE,uJAA2E,mCAAkC,+BAAC,0BAA0B,CAAC,2EAA2E,SAAS,CAA+D,kFAAkF,mCAAkC,+BAAC,0BAA0B,CAAC,iFAAiF,UAAS,gCAAgC,4BAAC,uBAAuB,CAAC,6EAA6E,4CAA2C,wCAAC,mCAAmC,CAAC,4EAA4E,UAAS,0CAA0C,sCAAC,iCAAiC,CAAC,eAAe,kBAAiB,WAAW,kBAAkB,gBAAgB,oBAAoB,gBAAgB,kBAAkB,sBAAsB,mCAAmC,kCAAkC,qBAAsB,CAAC,gCAAgC,oBAAmB,gBAAiB,CAAC,gCAAgC,oBAAmB,cAAe,CAAC,iCAAiC,gBAAe,4BAA6B,CAAC,uEAAuE,mBAAmB,CAAC,iDAAiD,kEAAA,6DAAA,yDAAyD,CAAC,gDAAgD,wCAAA,mCAAA,+BAA+B,CAAC,+BAA+B,kBAAiB,QAAQ,QAAS,CAAC,kBAAkB,WAAU,WAAW,UAAU,mBAAoB,CAAC,gBAAgB,kBAAiB,sBAAsB,sBAAsB,kBAAkB,wBAAwB,SAAS,QAAQ,WAAW,oDAAC,+CAAA,4CAA2C,mCAAmC,0BAA2B,CAAC,sBAAsB,WAAU,WAAW,gBAAiB,CAAC,+BAA+B,oCAAA,+BAAA,4BAA2B,mBAAoB,CAAC,mDAAmD,SAAS,CAAC,kDAAkD,SAAS,CAAE","file":"tippy.css","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../src/public/assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../src/public/assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../src/public/assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n.tippy-iOS{cursor:pointer!important}.tippy-notransition{transition:none!important}.tippy-popper{-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4;max-width:calc(100% - 10px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(60deg);transform:translateY(0) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-60deg);transform:translateY(0) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-60deg);transform:translateX(0) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(60deg);transform:translateX(0) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;max-width:350px;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=visible]{opacity:1}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1270);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip[class*=ams]{border-radius:4px;font-size:inherit;text-align:left;padding:0}.tippy-tooltip[class*=ams] .tooltip-content{padding:12px 16px}.tippy-tooltip[class*=ams] .tooltip-content--small,.tippy-tooltip[class*=ams] .tooltip-content--xsmall{padding:4px 6px}.tippy-tooltip[class*=ams] .tooltip-content--large{padding:20px 24px}.tippy-tooltip.ams-accent-theme{background-color:#4487ff;color:#fff;-webkit-box-shadow:0 5px 30px -2px hsla(220,7%,57%,.3);box-shadow:0 5px 30px -2px hsla(220,7%,57%,.3)}.tippy-tooltip.ams-accent-theme .tippy-backdrop{background-color:#4487ff}.tippy-tooltip.ams-accent-theme .tippy-roundarrow{color:#4487ff}.tippy-tooltip.ams-accent-theme[data-animatefill]{background-color:transparent}.tippy-popper[x-placement^=top] .tippy-tooltip.ams-accent-theme .tippy-arrow{border-top:8px solid #4487ff;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=bottom] .tippy-tooltip.ams-accent-theme .tippy-arrow{border-bottom:8px solid #4487ff;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=left] .tippy-tooltip.ams-accent-theme .tippy-arrow{border-left:8px solid #4487ff;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-popper[x-placement^=right] .tippy-tooltip.ams-accent-theme .tippy-arrow{border-right:8px solid #4487ff;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-tooltip.ams-white-theme{background-color:#fff;color:#101015;-webkit-box-shadow:0 5px 30px -2px rgba(16,16,21,.3);box-shadow:0 5px 30px -2px rgba(16,16,21,.3)}.tippy-tooltip.ams-white-theme .tippy-backdrop{background-color:#fff}.tippy-tooltip.ams-white-theme .tippy-roundarrow{color:#fff}.tippy-tooltip.ams-white-theme[data-animatefill]{background-color:transparent}.tippy-popper[x-placement^=top] .tippy-tooltip.ams-white-theme .tippy-arrow{border-top:8px solid #fff;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=bottom] .tippy-tooltip.ams-white-theme .tippy-arrow{border-bottom:8px solid #fff;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=left] .tippy-tooltip.ams-white-theme .tippy-arrow{border-left:8px solid #fff;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-popper[x-placement^=right] .tippy-tooltip.ams-white-theme .tippy-arrow{border-right:8px solid #fff;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-tooltip.ams-light-theme{background-color:#f0f6fa;color:#101015;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25)}.tippy-tooltip.ams-light-theme .tippy-backdrop{background-color:#f0f6fa}.tippy-tooltip.ams-light-theme .tippy-roundarrow{color:#f0f6fa}.tippy-tooltip.ams-light-theme[data-animatefill]{background-color:transparent}.tippy-popper[x-placement^=top] .tippy-tooltip.ams-light-theme .tippy-arrow{border-top:8px solid #f0f6fa;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=bottom] .tippy-tooltip.ams-light-theme .tippy-arrow{border-bottom:8px solid #f0f6fa;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=left] .tippy-tooltip.ams-light-theme .tippy-arrow{border-left:8px solid #f0f6fa;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-popper[x-placement^=right] .tippy-tooltip.ams-light-theme .tippy-arrow{border-right:8px solid #f0f6fa;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-tooltip.ams-dark-theme{background-color:#8a8f99;color:#fff;-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.tippy-tooltip.ams-dark-theme .tippy-backdrop{background-color:#8a8f99}.tippy-tooltip.ams-dark-theme .tippy-roundarrow{color:#8a8f99}.tippy-tooltip.ams-dark-theme[data-animatefill]{background-color:transparent}.tippy-popper[x-placement^=top] .tippy-tooltip.ams-dark-theme .tippy-arrow{border-top:8px solid #8a8f99;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=bottom] .tippy-tooltip.ams-dark-theme .tippy-arrow{border-bottom:8px solid #8a8f99;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=left] .tippy-tooltip.ams-dark-theme .tippy-arrow{border-left:8px solid #8a8f99;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-popper[x-placement^=right] .tippy-tooltip.ams-dark-theme .tippy-arrow{border-right:8px solid #8a8f99;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-tooltip.ams-black-theme{background-color:#101015;color:#f9fafb;-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25)}.tippy-tooltip.ams-black-theme .tippy-backdrop{background-color:#101015}.tippy-tooltip.ams-black-theme .tippy-roundarrow{color:#101015}.tippy-tooltip.ams-black-theme[data-animatefill]{background-color:transparent}.tippy-popper[x-placement^=top] .tippy-tooltip.ams-black-theme .tippy-arrow{border-top:8px solid #101015;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=bottom] .tippy-tooltip.ams-black-theme .tippy-arrow{border-bottom:8px solid #101015;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-popper[x-placement^=left] .tippy-tooltip.ams-black-theme .tippy-arrow{border-left:8px solid #101015;border-top:8px solid transparent;border-bottom:8px solid transparent}.tippy-popper[x-placement^=right] .tippy-tooltip.ams-black-theme .tippy-arrow{border-right:8px solid #101015;border-top:8px solid transparent;border-bottom:8px solid transparent}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Tooltip/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AAgJA,2BC/GM,kBDiHJ,kBAAkB,gBACF,SACN,CAJZ,4CAOI,iBEpH6C,CF6GjD,uGAUM,eEvH2C,CF6GjD,mDAcM,iBE3H2C,CF4H5C,gCGtFD,yBA3DuB,WHuJzB,uDAAA,8CAA0D,CAzD1D,gDGnCE,wBA3DuB,CHgGxB,kDG7BC,aAnEuB,CHoGxB,kDAGC,4BAA6B,CAC9B,6EAIG,6BACA,mCAA2C,iCACD,CAC3C,gFAEC,gCACA,mCAA2C,iCACD,CAC3C,8EAEC,8BACA,iCAAyC,mCACG,CAC7C,+EAEC,+BACA,iCAAyC,mCACG,CAC7C,+BGnED,sBAxCQ,cHyIV,qDAAA,4CAA0D,CA9D1D,+CGnCE,qBAxCQ,CH6ET,iDG7BC,UAhDQ,CHiFT,iDAGC,4BAA6B,CAC9B,4EAIG,0BACA,mCAA2C,iCACD,CAC3C,+EAEC,6BACA,mCAA2C,iCACD,CAC3C,6EAEC,2BACA,iCAAyC,mCACG,CAC7C,8EAEC,4BACA,iCAAyC,mCACG,CAC7C,+BGnED,yBAzDuB,cAZD,sDCCiC,6CAAA,CJuGzD,+CGnCE,wBAzDuB,CH8FxB,iDG7BC,aAjEuB,CHkGxB,iDAGC,4BAA6B,CAC9B,4EAIG,6BACA,mCAA2C,iCACD,CAC3C,+EAEC,gCACA,mCAA2C,iCACD,CAC3C,6EAEC,8BACA,iCAAyC,mCACG,CAC7C,8EAEC,+BACA,iCAAyC,mCACG,CAC7C,8BGnED,yBAnEoB,WA2BZ,yDC5B+C,gDAAA,CJuGzD,8CGnCE,wBAnEoB,CHwGrB,gDG7BC,aA3EoB,CH4GrB,gDAGC,4BAA6B,CAC9B,2EAIG,6BACA,mCAA2C,iCACD,CAC3C,8EAEC,gCACA,mCAA2C,iCACD,CAC3C,4EAEC,8BACA,iCAAyC,mCACG,CAC7C,6EAEC,+BACA,iCAAyC,mCACG,CAC7C,+BGnED,yBArEsB,cASA,yDCRiC,gDAAA,CJuGzD,+CGnCE,wBArEsB,CH0GvB,iDG7BC,aA7EsB,CH8GvB,iDAGC,4BAA6B,CAC9B,4EAIG,6BACA,mCAA2C,iCACD,CAC3C,+EAEC,gCACA,mCAA2C,iCACD,CAC3C,6EAEC,8BACA,iCAAyC,mCACG,CAC7C,8EAEC,+BACA,iCAAyC,mCACG,CAC7C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n@mixin tooltip-theme($bgcolor, $color, $arrow-size: baseline(1)) {\n  @include bgcolor($bgcolor);\n  @include textcolor($color);\n\n  .tippy-backdrop{\n    @include bgcolor($bgcolor);\n  }\n\n  .tippy-roundarrow{\n    @include textcolor($bgcolor);\n  }\n\n  &[data-animatefill]{\n    background-color: transparent;\n  }\n\n  .tippy-arrow{\n    .tippy-popper[x-placement^=top] &{\n      border-top: $arrow-size solid color($bgcolor);\n      border-right: $arrow-size solid transparent;\n      border-left: $arrow-size solid transparent;\n    }\n    .tippy-popper[x-placement^=bottom] &{\n      border-bottom: $arrow-size solid color($bgcolor);\n      border-right: $arrow-size solid transparent;\n      border-left: $arrow-size solid transparent;\n    }\n    .tippy-popper[x-placement^=left] &{\n      border-left: $arrow-size solid color($bgcolor);\n      border-top: $arrow-size solid transparent;\n      border-bottom: $arrow-size solid transparent;\n    }\n    .tippy-popper[x-placement^=right] &{\n      border-right: $arrow-size solid color($bgcolor);\n      border-top: $arrow-size solid transparent;\n      border-bottom: $arrow-size solid transparent;\n    }\n  }\n}\n\n.tippy-tooltip[class*=ams]{\n  @include bgsize(medium);\n  font-size: inherit;\n  text-align: left;\n  padding: 0;\n\n  .tooltip-content{\n    padding: baseline(1.5) baseline(2);\n\n    &--xsmall, &--small {\n      padding: baseline(.5) baseline(.75);\n    }\n\n    &--large {\n      padding: baseline(2.5) baseline(3);\n    }\n  }\n}\n\n.tippy-tooltip.ams-accent-theme{\n  @include tooltip-theme(accent, bw1);\n  box-shadow: 0 5px 30px -2px transparentize(color(bw7), .7);\n}\n\n.tippy-tooltip.ams-white-theme{\n  @include tooltip-theme(bw1, bw8);\n  box-shadow: 0 5px 30px -2px transparentize(color(bw8), .7);\n}\n\n.tippy-tooltip.ams-light-theme{\n  @include tooltip-theme(bw3, bw8);\n  @include shadow(large);\n}\n\n.tippy-tooltip.ams-dark-theme{\n  @include tooltip-theme(bw7, bw1);\n  @include shadow(small);\n}\n\n.tippy-tooltip.ams-black-theme{\n  @include tooltip-theme(bw8, bw2);\n  @include shadow(small);\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1278);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--faq .faq-category-list__wrapper{position:fixed;top:120px;bottom:0;left:0;width:25%;min-width:320px}.app-wrapper[data-player-visibility=true] .page--faq .faq-category-list__wrapper{bottom:56px}.app-wrapper[data-player-term-list-visibility=true] .page--faq .faq-category-list__wrapper{bottom:136px}.page--faq .faq-view{width:75%;max-width:calc(100% - 320px);margin-left:auto}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/FAQ/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,uCClEE,eD+BuB,UAxBgD,SAwBX,OAAE,UAG9D,eEzC+C,CFwB/C,iFACE,WAAwC,CACzC,2FAGC,YAAuD,CACxD,qBAeD,UAA0B,6BACiB,gBAC1B,CAoChB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FAQ Page\n */\n\n.page--faq{\n  $category-list-width: 25%;\n  $category-list-min-width: baseline(40);\n\n  .faq-category-list__wrapper{\n    @include page-aside($category-list-width, $category-list-min-width);\n  }\n\n  .faq-view{\n    @include page-with-aside-content($category-list-width, $category-list-min-width);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FAQ Content
 */
// tslint:disable:max-line-length

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
exports.FAQContent = [{
    id: 'bopper-vs-royalty-free',
    title: 'Bopper vs. Royalty-free',
    questions: [{
        id: 'is-bopper-another-royalty-free-music-directory?',
        question: 'Is Bopper another royalty-free music directory?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "No. Although you can buy the rights for a song as quickly and easily on Bopper, the majority of our catalog comes from recording artists whose music is of exceptional quality. In addition, our platform is built to meet the specific needs of brand content producers: Creatives, Producers, Video Editors and Music Supervisors, whether in Ad agencies, Trailer houses, TV productions, etc."))
    }, {
        id: 'what-do-you-offer-different-to-producers-of-brand-content?',
        question: 'What do you offer different to producers of brand content?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "The ability to license on-brief music from recording artists instantly. First, we remove all obstacles that prevent content producers from quickly licensing real music as an alternative to stock music or when deadlines for custom music are too tight. All tracks are pre-cleared. Secondly,  it\u2019s all about speeding-up the process. Our search engine was created specifically based on our clients\u2019 unique needs and the entire catalogue is curated to make sure all tracks are ad-friendly."), React.createElement(Label_1.Paragraph, null, "We also offer a free music search service and take care of licensing songs from top artists outside of our catalogue."))
    }]
}, {
    id: 'licensing-music',
    title: 'Licensing Music',
    questions: [{
        id: 'sample-license',
        question: 'Can I see the license agreement?',
        answer: React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement(Button_1.default, { className: "sample-license-button", hyperLinkProps: {
                href: 'https://assets.boppermusic.com/docs/Bopper_Sample_License.pdf',
                target: '_blank'
            }, wrapperComponent: "a", colorScheme: "light", variant: "pill", size: "small", label: "Preview License" })))
    }, {
        id: 'how-territory-affects-pricing',
        question: 'How territory affects pricing: Broadcast territory vs. Company location',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "When using our License Builder, some media options (tv, theatrical, radio) require you to select a broadcast territory. This information is used by our pricing algorithm to determine the price of a license. Other media settings, for instance, Paid Social, require that you select the location of your office. This is to account that it is generally tedious to track broadcast territories of digital media. The algorithm will then use the Licensee\u2019s office location to evaluate the cost of a license."))
    }, {
        id: 'how-do-i-set-the-territory-parameter',
        question: 'My content is going on the web, how do I set the territory parameter?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "All Web Streaming and Paid Social licenses on Bopper are for worldwide use. The price of a license will still vary according to the production company\u2019s office location. For example, a Web Streaming license for an ad agency based in Brazil will be less expensive than the same license for an agency based in the United States."))
    }, {
        id: 'payment-methods',
        question: 'Payment methods',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "We accept payments most major credit cards (Visa, Mastercard, AMEX), and also bank transfers and check payment within 30 days of purchasing a license. Our bank transfer info is at the bottom of our invoices. ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "Email us"), " if you can\u2019t find it."))
    }, {
        id: 'renewing-a-license',
        question: 'How do I renew a license?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "To renew a license for an additional period of time, simply purchase it again by setting your license terms, adding the track to your cart and checking out again. Some music might be removed from our platform from time to time. Even if that music cannot be found on the platform, you can renew a license for any consecutive term, by ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "contacting us"), "."))
    }, {
        id: 'regional-or-national-campaign',
        question: 'Is my campaign Regional or National?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "If you are licensing music in the United States you will need to select whether your campaign is a National (all states), or a Regional campaign. Regional is defined herein as the broadcast of content in less than four US Television Market Areas (TMAs)."), React.createElement(Label_1.Paragraph, null, "A full list of TMAs can be found ", React.createElement("a", { href: "https://en.wikipedia.org/wiki/List_of_United_States_television_markets" }, "here"), "."))
    }, {
        id: 'license-territories-and-clusters',
        question: 'License Territory Clusters',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "Bopper offers many territory clusters that are frequently used by media planners to speak to a language-defined audience. Here is a list of what each cluster includes. Can\u2019t find your perfect cluster? ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "Drop us a line"), " and we\u2019ll help to create a custom cluster just for you."), React.createElement(Heading_1.default, { is: "h6" }, "Baltic States"), React.createElement(Label_1.Paragraph, null, "The cluster comprises Estonia, Latvia, and Lithuania."), React.createElement(Heading_1.default, { is: "h6" }, "Eastern Europe"), React.createElement(Label_1.Paragraph, null, "Countries included in this region are Estonia, Latvia, Lithuania, Armenia, Azerbaijan, Georgia, Russia, Ukraine, Belarus, Moldova, Austria, Czech Republic, Hungary, Poland, Slovakia, Slovenia, Albania, Bosnia & Herzegovina, Bulgaria, Croatia, Cyprus, Greece, Macedonia, Montenegro, Romania, Serbia and Turkey."), React.createElement(Heading_1.default, { is: "h6" }, "GAS - DACH"), React.createElement(Label_1.Paragraph, null, "This cluster consists of Germany, Austria, and Switzerland."), React.createElement(Heading_1.default, { is: "h6" }, "Greater Chinese Region (GCR)"), React.createElement(Label_1.Paragraph, null, "GCR (Greater Chinese Region) is comprised of Mainland China, Hong Kong, Macao, and Taiwan."), React.createElement(Heading_1.default, { is: "h6" }, "Latin America and Caribean"), React.createElement(Label_1.Paragraph, null, "This cluster includes all Latin American and Caribean countries and territories, namely Anguilla, Antigua & Barbuda, Argentina, Aruba, Bahamas, Barbados, Belize, Bolivia, Brazil, Cayman Islands, Chile, Colombia, Costa Rica, Cuba, Curacao, Dominican Republic, Ecuador, En Cifras, El Salvador, Guatemala, Haiti, Honduras, Jamaica, Mexico, Montserrat, Nicaragua, Panama, Paraguay, Peru, Puerto Rico, Abre, Sint Maarten, St. Lucia, St. Vincent & the Grenadines, Suriname, Trinidad & Tobago, Turks & Caicos Islands, Uruguay, Venezuela, and Venescopio."), React.createElement(Heading_1.default, { is: "h6" }, "Middle East and North Africa (MENA)"), React.createElement(Label_1.Paragraph, null, "Middle East and North Africa is a geographical region consisting of the majority of Middle-Eastern and Maghreb countries. Countries included in the MENA group are Algeria, Armenia, Azerbaijan, Bahrain, Cyprus, Djibouti, Egypt, Georgia, Iran, Iraq, Israel, Jordan, Kuwait, Lebanon, Yemen, Malta, Somalia, Sudan, Turkey, United Arab Emirates, Libya, Morocco, Oman, West Bank & Gaza, Qatar, Saudi Arabia, Syria, Tunisia."), React.createElement(Heading_1.default, { is: "h6" }, "Netherlands, SSS, and ABC islands"), React.createElement(Label_1.Paragraph, null, "The Kingdom of the Netherlands including the Dutch-speaking islands of Aruba, Bonaire and Cura\xE7ao, Sint Eustatius, Saba and Sint Maarten."), React.createElement(Heading_1.default, { is: "h6" }, "Portugal, Brazil and CPLP"), React.createElement(Label_1.Paragraph, null, "The Community of Portuguese Language Countries (abbreviated as CPLP) comprises all Lusophone countries and territories. It includes Portugal, Brazil, Angola, Cape Verde, Guinea-Bissau, Mozambique, S\xE3o Tom\xE9 and Pr\xEDncipe, Timor-Leste, and Equatorial Guinea."), React.createElement(Heading_1.default, { is: "h6" }, "Russia and CIS"), React.createElement(Label_1.Paragraph, null, "Russian Federation (Russia) and all the members of the Commonwealth of Independent States (CIS) namely Armenia, Azerbaijan, Belarus, Georgia, Kazakhstan, Kyrgyzstan, Moldova, Russian Federation, Tajikistan, Turkmenistan, Ukraine, and Uzbekistan."), React.createElement(Heading_1.default, { is: "h6" }, "Southeast Asia"), React.createElement(Label_1.Paragraph, null, "Southeast Asia is a subregion of Asia, consisting of the countries that are geographically located south of China, east of India, west of New Guinea and north of Australia. Countries included in this region are Brunei, Cambodia, East Timor, Indonesia, Laos, Malaysia, Myanmar, Philippines, Singapore, Thailand, Vietnam, Christmas Island and the Cocos Islands."), React.createElement(Heading_1.default, { is: "h6" }, "UK and BOTs"), React.createElement(Label_1.Paragraph, null, "This cluster comprises the United Kingdom (England, Scotland, Wales and Northern Ireland) and the ", React.createElement("a", { href: "https://en.wikipedia.org/wiki/British_Overseas_Territories", target: "_blank" }, "17 British overseas territories"), "."), React.createElement(Heading_1.default, { is: "h6" }, "Western Europe"), React.createElement(Label_1.Paragraph, null, "Countries included in this region are Austria, Belgium, Denmark, Finland, France, Germany, Iceland, Ireland, Italy, Liechtenstein, Luxembourg, Monaco, Netherlands, Norway, Portugal, Spain, Sweden, Switzerland, the UK."))
    }, {
        id: 'instrumental-versions-cut-downs-edits',
        question: 'Instrumental versions / cut-downs & edits',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "To see if there is an instrumental version available for a track, simply click on the track, which will open the sidebar. There you will be able to see any instrumental/alternate versions of the track. Keep in mind that not all tracks have instrumental versions available. Once you\u2019ve purchased a license, you will gain access to all existing instrumental versions, alternative versions, cut-downs, etc. for the track(s) that you licensed. If you need custom modifications for any track please ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "contact us"), "."))
    }, {
        id: 'cut-downs-and-language-versions',
        question: 'Cut-downs and language versions',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "Unlimited cut-downs of a given piece of content are allowed. This includes translations in different languages. A single piece of content that is cut-down in various lengths and translated into many languages counts as one film/spot. If there is different filmed content in your final videos, they count as different spots."))
    }, {
        id: 'licensing-a-track',
        question: 'Licensing a track',
        answer: 'Once you’ve selected the track(s) you’d like to license, you can enter the terms of your project in our License Builder to determine the price of your license. You may then add the track(s) to your cart and check out with any major credit card, or you may opt to pay by cheque, in which case you have 30 days to pay for your license. After checking out you will be able to access your license, invoice and the high-res music files. These may be accessed at any time on your Account > My Orders page.'
    }, {
        id: 'dont-have-an-exact-air-date',
        question: 'I don’t have an exact air-date yet, what should I do?',
        answer: 'If you’re not sure of the exact start date of your campaign, please enter an approximate date within a three-week range of the actual air date.'
    }, {
        id: 'archival-use',
        question: 'Archival use',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "All licenses purchased on Bopper include archival rights. These additional rights are added for free to our license, and allow licensees to use the music on all digital media for archival purposes, in perpetuity. Examples of archival uses are unpromoted social media posts, unpromoted Youtube archives, and corporate websites. Whenever content is promoted, either by purchasing media or paying to drive traffic to a website, it is no longer considered an archival use, and an appropriate license must be purchased on Bopper."))
    }, {
        id: 'is-the-music-on-bopper-music-store-royalty-free',
        question: 'Is the music on Bopper royalty-free?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "\u201CRoyalty-free\u201D music refers to a type of music licensing that allows the purchaser to pay for a music license only once and have the rights to use the music in perpetuity, across all media. When licensing music on Bopper, you must specify the term, territory, and media for your production and your license will be valid for those terms. In that sense, the music on Bopper is not royalty-free. Rest assured though, once you purchase a license on Bopper, all the rights have been thoroughly cleared so that you won\u2019t have to pay anything other than your license fee."))
    }]
}, {
    id: 'submit-music',
    title: 'Submitting Music',
    questions: [{
        id: 'how-do-i-submit-music-for-consideration',
        question: 'How do I submit music for consideration?',
        answer: React.createElement(Label_1.Paragraph, null, "Please send a link (Dropbox, Wetransfer, etc.) to samples of your music to ", React.createElement("a", { href: "mailto:music@boppermusic.com" }, "music@boppermusic.com"), ". We listen to everything, but please give us 30 days to get back to you, as we receive an important amount of submissions.")
    }, {
        id: 'why-would-recording-artists-distribute-a-song-on-bopper',
        question: 'Why would recording artists distribute a song on Bopper?',
        answer: React.createElement(Label_1.Paragraph, null, "One of our values is to help recording artists get fair compensation for their work. Not only do we make it much easier to get their songs in front of brand content producers, but when a track gets chosen, we make sure the artist will get maximum compensation. In other words: Bopper provides equitable music catering to socially responsible brands.")
    }, {
        id: 'how-can-we-ensure-that-our-artists-get-maximum-compensation',
        question: 'How can we ensure that our artists get maximum compensation?',
        answer: React.createElement(Label_1.Paragraph, null, "Our proprietary pricing algorithm prices each track individually based on 24 different data points. To make it simple we take into account the license terms (market, campaign duration, number of films\u2026) AND the artist\u2019s reputation. Brand content producers can search songs based on the budget available making it a win-win for both parties. Depending on the license terms, compensation can range from a few hundred dollars to a few thousand.")
    }]
}, {
    id: 'other',
    title: 'Other Questions',
    questions: [{
        id: 'errors-and-omissions-insurance',
        question: 'What is your errors & omissions insurance coverage?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "All licenses obtained on Bopper are fully insured. Our errors and omissions (E&O) policy covers up to 2M$ USD per incident. If need be, we can explicitly name any end-user as a beneficiary. ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "Contact us"), " for any specific insurance needs."))
    }, {
        id: 'is-ams-on-omnicom-musiclink',
        question: 'Is Bopper on Omnicom MusicLink?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "Bopper is an approved vendor of MusicLink and the Omnicom Group. Any agency that\u2019s part of the Omnicom Group is therefore authorized to purchase music on Bopper. Most of our music is not posted on the MusicLink platform itself but any track that is displayed on Bopper is available to purchase by Omnicom agencies.  If the specific track that you need to purchase is not listed on MusicLink we can post it on MusicLink and ", React.createElement("a", { href: "mailto:everything@boppermusic.com" }, "assist you"), " with licensing it through that platform."))
    }, {
        id: 'why-cant-i-see-the-price-for-a-song',
        question: 'Why can’t I see the price for a song after selecting my license terms?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "A very small selection of tracks on Bopper cannot be licensed in certain territories. When that\u2019s the case, please reach out to us and we can make sure we provide you with the right license for your needs under these circumstances."))
    }, {
        id: 'is-your-music-under-any-union-contracts',
        question: 'Is your music under any union contracts?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "The music on Bopper is not recorded under AFofM, SAG, ACTRA, or UDA, or any other union agreement. This is a pre-requisite of many ad agencies around the world when using music libraries, mostly because of the complexity of calculating residual fees."))
    }, {
        id: 'didnt-find-what-you-were-looking-for',
        question: 'Didn’t find what you were looking for?',
        answer: React.createElement(React.Fragment, null, React.createElement(Label_1.Paragraph, null, "Our team of music supervisors is standing by ready to assist you in finding the perfect piece of music to suit your project. Simply start a chatbox with one of our team members in the chatbox below, email us, or call us toll-free at 1-888-423-6665 (US) / +33 1 70 38 73 50 (EU) and we\u2019ll be happy to help you."))
    }]
}];

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FAQCategoryList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var animation_1 = __webpack_require__(173);
__webpack_require__(1327);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Heading_1 = __webpack_require__(9);
var FAQCategoryButton_1 = __webpack_require__(1329);
var FAQCategoryListAnimation = animation_1.ListItemAnimations(128);
var classes = new BEM('faq-category-list');

var FAQCategoryList = function (_React$Component) {
    _inherits(FAQCategoryList, _React$Component);

    function FAQCategoryList() {
        _classCallCheck(this, FAQCategoryList);

        return _possibleConstructorReturn(this, (FAQCategoryList.__proto__ || Object.getPrototypeOf(FAQCategoryList)).apply(this, arguments));
    }

    _createClass(FAQCategoryList, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement(Heading_1.default, Object.assign({ is: "h4", textColor: "bw6" }, classes('title')), "Browse by Topic:"), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ul", enter: { animation: FAQCategoryListAnimation.In, stagger: 150 }, leave: { animation: FAQCategoryListAnimation.Out } }, classes()), this.props.categories.map(function (_ref) {
                var id = _ref.id,
                    title = _ref.title,
                    questions = _ref.questions;
                return React.createElement("li", Object.assign({ key: id }, classes('item')), React.createElement(FAQCategoryButton_1.default, { id: id, title: title, totalQuestions: questions.length, onSelect: function onSelect() {
                        return _this2.props.onSelectCategory(id);
                    } }));
            })));
        }
    }]);

    return FAQCategoryList;
}(React.Component);

exports.default = FAQCategoryList;

/***/ }),
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1328);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-category-list.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-category-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".faq-category-list{margin:0;padding:8px 32px 48px 16px;list-style:none}html.touchevents .faq-category-list__wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .faq-category-list__wrapper{overflow-x:hidden;overflow-y:auto}.faq-category-list__title{margin:56px 32px 8px}.faq-category-list__item{-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed;padding:8px 0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/FAQ/faq-category-list.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,mBACE,SAAS,2BAET,eAAgB,CAcjB,6CChHG,kBAAgD,kBACT,gCACN,CAClC,gDAEC,kBAAgD,eACX,CDkGvC,0BACE,oBCnF6C,CDoF9C,yBAGC,iCAAA,yBACA,aAAsB,CACvB","file":"faq-category-list.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FAQCategoryList Component\n */\n\n.faq-category-list{\n  margin: 0;\n  padding: baseline(1) baseline(4) baseline(6) baseline(2);\n  list-style: none;\n\n  &__wrapper{\n    @include scroll;\n  }\n\n  &__title{\n    margin: baseline(7) baseline(4) baseline(1) baseline(4);\n  }\n\n  &__item{\n    box-shadow: 0 1px uicolor(border);\n    padding: baseline(1) 0;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FAQCategoryButton Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1330);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var _1 = __webpack_require__(277);
var classes = new BEM({ name: 'faq-category-button', outputIsString: true });
function FAQCategoryButton(props) {
  return React.createElement(found_1.Link, { to: _1.FAQPageSectionPath(props.id), activeClassName: classes('', 'active'), className: classes(), onClick: props.onSelect }, React.createElement(Icon_1.IconList, { className: classes('icon') }), React.createElement("div", { className: classes('info') }, React.createElement(Heading_1.default, { is: "h5", text: props.title, maxTextLength: 25, noMargin: true, className: classes('title') }), React.createElement(Label_1.Span, { variant: "note", size: "medium", className: classes('subtitle') }, props.totalQuestions, " questions")));
}
exports.default = FAQCategoryButton;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1331);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-category-button.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-category-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".faq-category-button{color:#101015;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:32px;height:112px;overflow:hidden;-webkit-transform:scale(.96);-ms-transform:scale(.96);transform:scale(.96)}.faq-category-button,.faq-category-button__info{-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.faq-category-button__info{margin-left:16px;-webkit-transform:translateY(8px);-ms-transform:translateY(8px);transform:translateY(8px)}.faq-category-button__subtitle{display:block;opacity:0;margin-top:2px}.faq-category-button__actions{margin-left:auto;-ms-flex-item-align:stretch;align-self:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}.faq-category-button:not(.faq-category-button--active){cursor:pointer}.faq-category-button--active,.faq-category-button:hover{background-color:#fff;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);border-radius:8px}.faq-category-button--active,.faq-category-button--active .faq-category-button__info,.faq-category-button:hover,.faq-category-button:hover .faq-category-button__info{-webkit-transform:none;-ms-transform:none;transform:none}.faq-category-button--active .faq-category-button__subtitle,.faq-category-button:hover .faq-category-button__subtitle{opacity:1}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/FAQ/faq-category-button.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,qBC3BI,cD6BF,qBAAqB,oBACrB,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kBAEnB,aACA,gBAAgB,6BAEhB,yBAAA,oBAAqB,CAErB,gDAHA,0DAAA,qDAAA,iDE5F2D,CF+F3D,2BACE,iBAEA,kCAAA,8BAAA,yBAAkC,CACnC,+BAGC,cAAc,UACJ,cG5FmC,CH8F9C,8BAGC,iBAAiB,4BACjB,mBAAmB,oBACnB,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,oCACvB,+BAAA,4BAA4B,mCAC5B,+BAAA,0BAA2B,CA9B/B,uDAkCI,cAAe,CAChB,wDCtEC,sBAvCU,sDG7B6C,8CAAA,iBCQrC,CLyInB,sKADC,uBAAA,mBAAA,cAAe,CAMhB,sHAIC,SAAU,CACX","file":"faq-category-button.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FAQCategory Component\n */\n\n.faq-category-button{\n  @include textcolor(dark);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding-left: baseline(4);\n  height: baseline(14);\n  overflow: hidden;\n  transition: .25s $ease-out-back;\n  transform: scale(.96);\n\n  &__info{\n    margin-left: baseline(2);\n    transition: .25s $ease-out-back;\n    transform: translateY(baseline(1));\n  }\n\n  &__subtitle{\n    display: block;\n    opacity: 0;\n    margin-top: baseline(.25);\n  }\n\n  &__actions{\n    margin-left: auto;\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    transition: .15s ease-in-out;\n    transform: translateX(100%);\n  }\n\n  &:not(&--active) {\n    cursor: pointer;\n  }\n\n  &--active, &:hover{\n    @include bgcolor(white);\n    @include shadow(medium);\n    @include bgsize(large);\n    transform: none;\n  }\n\n  &--active &__info,\n  &:hover &__info{\n    transform: none;\n  }\n\n  &--active &__subtitle,\n  &:hover &__subtitle{\n    opacity: 1;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FAQView Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1333);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('faq-view');

var FAQView = function (_React$Component) {
    _inherits(FAQView, _React$Component);

    function FAQView() {
        _classCallCheck(this, FAQView);

        return _possibleConstructorReturn(this, (FAQView.__proto__ || Object.getPrototypeOf(FAQView)).apply(this, arguments));
    }

    _createClass(FAQView, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var extraClasses = classNames(this.props.className);
            return React.createElement("div", Object.assign({}, classes('', '', extraClasses)), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ol", enter: {
                    animation: 'transition.slideUpIn',
                    delay: 150,
                    duration: 250,
                    stagger: 150
                }, leave: {
                    animation: 'transition.fadeOut',
                    duration: 150,
                    stagger: 50
                } }, classes('list')), this.props.data.questions.map(function (_ref, index) {
                var id = _ref.id,
                    question = _ref.question,
                    answer = _ref.answer;
                return React.createElement("li", Object.assign({ key: "faq-" + _this2.props.data.id + "-" + index }, classes('list__item')), React.createElement("a", { id: id }), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('list__item__title')), question), typeof answer === 'string' ? React.createElement(Label_1.Paragraph, Object.assign({}, classes('list__item__text')), answer) : React.createElement("div", Object.assign({}, classes('list__item__text')), answer));
            })));
        }
    }]);

    return FAQView;
}(React.Component);

exports.default = FAQView;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1334);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-view.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./faq-view.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.faq-view{padding:40px 5vw 40px 32px}.faq-view__list{background-color:#fff;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);max-width:960px;padding:40px 64px 64px;list-style:none}.faq-view__list__item:not(:last-child){border-bottom:1px solid #e4e8ed;padding-bottom:32px;margin-bottom:40px}.faq-view__list__item__text{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:400;font-size:1em;line-height:1.4}.faq-view__list__item .heading--h6{margin-top:40px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/FAQ/faq-view.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,UC2DtE,0BC1E+C,CD4E/C,gBEtCE,sBAvCU,sDC7B6C,8CH6GvD,gBAEA,uBACA,eAAgB,CAEf,uCAEG,gCACA,oBACA,kBCxFyC,CDyF1C,4BAGC,mEACA,gBAAgB,cACF,eACE,CAXnB,mCAeG,eCnGyC,CDoG1C","file":"faq-view.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FAQView Component\n */\n\n.faq-view{\n  padding: baseline(5) 5vw baseline(5) baseline(4);\n\n  &__list{\n    @include bgcolor(white);\n    @include shadow(large);\n    max-width: baseline(120);\n    // margin: 0 baseline(7) 0 baseline(3);\n    padding: baseline(5) baseline(8) baseline(8);\n    list-style: none;\n\n    &__item{\n      &:not(:last-child){\n        border-bottom: 1px solid uicolor(border);\n        padding-bottom: baseline(4);\n        margin-bottom: baseline(5);\n      }\n\n      &__text{\n        font-family: $font--articulat;\n        font-weight: 400;\n        font-size: 1em;\n        line-height: 1.4;\n      }\n\n      .heading--h6{\n        margin-top: baseline(5);\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseMedia Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(276);
var license_1 = __webpack_require__(34);
var config_1 = __webpack_require__(142);
var animations_1 = __webpack_require__(1336);
__webpack_require__(1337);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
/* tslint:disable-next-line */
__webpack_require__(214);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var LicenseBuilder_1 = __webpack_require__(616);
var MediaButton_1 = __webpack_require__(1345);
var classes = new BEM('license-builder__step');

var LicenseMedia = function (_React$Component) {
    _inherits(LicenseMedia, _React$Component);

    function LicenseMedia(props) {
        _classCallCheck(this, LicenseMedia);

        var _this = _possibleConstructorReturn(this, (LicenseMedia.__proto__ || Object.getPrototypeOf(LicenseMedia)).call(this, props));

        _this.onSelectMedia = function (component) {
            var contextualParam = LicenseBuilder_1.getContextualParam(component.id)(config_1.contextualParamMapping);
            _this.props.addMediumToLicense(component, contextualParam.type);
        };
        _this.state = {
            selectedMedia: props.selectedMediaList.map(function (_ref) {
                var medium = _ref.medium;
                return medium.id;
            })
        };
        return _this;
    }

    _createClass(LicenseMedia, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref2) {
            var selectedMediaList = _ref2.selectedMediaList;

            if (selectedMediaList.length !== this.props.selectedMediaList.length) {
                var selectedMedia = selectedMediaList.map(function (_ref3) {
                    var medium = _ref3.medium;
                    return medium.id;
                });
                if (this.props.editingUsageIndex !== null && selectedMediaList.length < this.props.selectedMediaList.length) {
                    var editingUsageIndex = selectedMedia.length === 0 ? null : 0;
                    this.onSelectUsage(editingUsageIndex);
                }
                this.setState({ selectedMedia: selectedMedia });
            }
        }
    }, {
        key: "onSelectUsage",
        value: function onSelectUsage(index) {
            this.props.setEditingUsageIndex(index);
        }
    }, {
        key: "renderMediaButton",
        value: function renderMediaButton(_ref4) {
            var internal_id = _ref4.internal_id,
                name = _ref4.name;

            var id = internal_id;

            var _lodash_1$find = lodash_1.find(config_1.mediaTypeDefinitions, { id: id }),
                label = _lodash_1$find.label,
                icon = _lodash_1$find.icon,
                hint = _lodash_1$find.hint;

            return React.createElement(MediaButton_1.MediaButton, { onClick: this.onSelectMedia, hint: hint, id: id, icon: icon, name: label || name });
        }
    }, {
        key: "renderUsage",
        value: function renderUsage(id, index) {
            var _this2 = this;

            var _lodash_1$find2 = lodash_1.find(config_1.mediaTypeDefinitions, { id: id }),
                label = _lodash_1$find2.label,
                icon = _lodash_1$find2.icon;

            var name = '';
            this.props.data.forEach(function (_ref5) {
                var node = _ref5.node;

                if (node.internal_id === id) {
                    name = node.name;
                }
            });
            var usage = this.props.selectedMediaList[index];
            var isValid = license_1.isLicenseUsageValid(usage);
            var isActive = this.props.editingUsageIndex === index;
            var className = classNames({ 'is-active': isActive }, { 'is-valid': isValid });
            return React.createElement("li", { className: className, key: "usage-" + id + "-" + index, onClick: function onClick() {
                    return _this2.onSelectUsage(index);
                } }, React.createElement(Button_1.default, { className: "usage-button", icon: icon, label: React.createElement(Label_1.Span, { maxTextLength: isActive ? -1 : 18 }, label || name, " ", React.createElement("small", null, license_1.usageToString(usage, true))), size: "medium" }), React.createElement(Button_1.default, { onClick: function onClick(e) {
                    e.stopPropagation();
                    _this2.props.removeMediumFromLicense(usage.id);
                }, className: "remove-usage-button", icon: React.createElement(Icon_1.IconTrash, null), size: "small", variant: "icon", dangerous: true }), !isActive && React.createElement(Button_1.default, { className: "edit-usage-button", colorScheme: "light", icon: React.createElement(Icon_1.IconEdit, null), label: "Edit", size: "small" }), isValid && React.createElement("div", { className: "usage-is-valid-indicator" }, React.createElement(Icon_1.IconCheck, null)));
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var selectedMediaList = this.props.selectedMediaList;

            var hasUsages = !!selectedMediaList.length;
            var hasSelectedUsage = this.props.editingUsageIndex !== null;
            var extraClasses = classNames({ 'has-selected-usage': hasSelectedUsage });
            var selectedMediaListClasses = classNames('selected-media-list', { 'has-medias': hasUsages });
            var data = lodash_1.sortBy(this.props.data, function (a) {
                return config_1.mediaTypeDefinitions.findIndex(function (val) {
                    return val.id === a.node.internal_id;
                });
            });
            return React.createElement("div", Object.assign({}, classes('', 'media', extraClasses)), React.createElement("div", { className: "media-list" }, React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Add Media:"), React.createElement(Button_1.default, { className: "sample-license-button", hyperLinkProps: {
                    href: 'https://assets.boppermusic.com/docs/Bopper_Sample_License.pdf',
                    target: '_blank'
                }, wrapperComponent: "a", colorScheme: "black-outline", variant: "pill", size: "small", label: "Preview License" }), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('subtitle')), "Advertising"), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "ul", enter: { animation: animations_1.MediumItemAnimations.In }, leave: { animation: animations_1.MediumItemAnimations.Out, delay: 150 } }, data.map(function (_ref6) {
                var node = _ref6.node;
                return _this3.shouldDisplayMediaType(node.internal_id) && !_this3.isProgrammingMediaType(node.internal_id) && React.createElement("li", { key: node.internal_id }, _this3.renderMediaButton(node));
            })), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('subtitle')), "Programming"), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "ul", enter: { animation: animations_1.MediumItemAnimations.In }, leave: { animation: animations_1.MediumItemAnimations.Out, delay: 150 } }, data.map(function (_ref7) {
                var node = _ref7.node;
                return _this3.shouldDisplayMediaType(node.internal_id) && _this3.isProgrammingMediaType(node.internal_id) && React.createElement("li", { key: node.internal_id }, _this3.renderMediaButton(node));
            }))), React.createElement("div", { className: selectedMediaListClasses }, hasUsages && React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Edit Terms:"), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "ul", enter: { animation: animations_1.UsageItemAnimations.In, delay: 150 }, leave: { animation: animations_1.UsageItemAnimations.Out } }, this.props.selectedMediaList.map(function (_ref8, index) {
                var medium = _ref8.medium;
                return _this3.renderUsage(medium.id, index);
            })), React.createElement("div", { className: "global-actions" }, hasSelectedUsage && React.createElement(Button_1.default, { onClick: function onClick() {
                    return _this3.onSelectUsage(null);
                }, className: "add-more-media-button", label: "Add more media", icon: React.createElement(Icon_1.IconArrowLeft, null), colorScheme: "light" }))));
        }
    }, {
        key: "shouldDisplayMediaType",
        value: function shouldDisplayMediaType(id) {
            return !this.isMediaTypeExcluded(id);
        }
    }, {
        key: "isProgrammingMediaType",
        value: function isProgrammingMediaType(id) {
            return config_1.programmingMedia.indexOf(id) > -1 || id === 2011;
        }
    }, {
        key: "isMediaTypeExcluded",
        value: function isMediaTypeExcluded(id) {
            return config_1.excludedMediaType.indexOf(id) > -1;
        }
    }]);

    return LicenseMedia;
}(React.Component);

var ConnectedLicenseMedia = react_redux_1.connect(function (_ref9) {
    var _ref9$license = _ref9.license,
        editingUsageIndex = _ref9$license.editingUsageIndex,
        isValid = _ref9$license.isValid,
        usages = _ref9$license.usages;
    return {
        editingUsageIndex: editingUsageIndex,
        isLicenseValid: isValid,
        selectedMediaList: usages
    };
}, function (dispatch) {
    return {
        addMediumToLicense: function addMediumToLicense(medium, contextualParamType) {
            dispatch(actions.addMedium({ medium: medium, contextualParamType: contextualParamType }));
        },
        removeMediumFromLicense: function removeMediumFromLicense(id) {
            dispatch(actions.removeMedium({ id: id }));
        },
        setEditingUsageIndex: function setEditingUsageIndex(index) {
            dispatch(actions.setEditingUsageIndex({ index: index }));
        }
    };
})(LicenseMedia);
exports.default = ConnectedLicenseMedia;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var velocity_react_1 = __webpack_require__(19);
/* tslint:disable-next-line */
__webpack_require__(214);
var fx = velocity_react_1.velocityHelpers.registerEffect;
var itemHeight = 128;
exports.MediumItemAnimations = {
    In: fx({
        defaultDuration: 500,
        calls: [[{ height: [60, 0] }, 2 / 5], [{
            translateX: [0, 360]
        }, 3 / 5, { easing: 'easeOutSine' }]]
    }),
    Out: fx({
        defaultDuration: 500,
        calls: [[{
            translateX: 360
        }, 3 / 5, { easing: 'easeInSine' }], [{
            height: 0
        }, 2 / 5]],
        reset: { height: itemHeight }
    })
};
exports.UsageItemAnimations = {
    In: fx({
        defaultDuration: 500,
        calls: [[{ height: itemHeight }, 1 / 100], [{
            translateX: [0, -360]
        }, 99 / 100, { easing: 'easeOutSine' }]]
    }),
    Out: fx({
        defaultDuration: 500,
        calls: [[{
            translateX: -360
        }, 3 / 5, { easing: 'easeInSine' }], [{
            height: 0,
            padding: 0,
            margin: 0
        }, 2 / 5]]
    })
};

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1338);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-builder__step--media{display:-webkit-box;display:-ms-flexbox;display:flex}.license-builder__step--media.license-builder__step{background-color:transparent;-webkit-box-flex:0;-ms-flex:0 0 360px;flex:0 0 360px;padding:0;overflow:visible!important;margin-right:36px}.license-builder__step--media .license-builder__step__subtitle{text-transform:uppercase;letter-spacing:3px;font-size:12px;line-height:16px;margin-top:36px}.license-builder__step--media .media-list{background-color:#fff;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);-webkit-box-flex:1;-ms-flex:auto;flex:auto;padding:24px 0 24px 32px;-webkit-transition:-webkit-transform .35s ease-in-out .1s;transition:-webkit-transform .35s ease-in-out .1s;-o-transition:transform .35s ease-in-out .1s;transition:transform .35s ease-in-out .1s;transition:transform .35s ease-in-out .1s,-webkit-transform .35s ease-in-out .1s;-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}html.touchevents .license-builder__step--media .media-list{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .license-builder__step--media .media-list{overflow-x:hidden;overflow-y:auto}.license-builder__step--media .media-list ul{padding-right:32px}.license-builder__step--media .selected-media-list{position:absolute;top:0;bottom:0;left:calc(100% + 24px);width:100%;z-index:1;-webkit-transition:background-color .35s .5s,border-color 0s,-webkit-transform .35s ease-in-out;transition:background-color .35s .5s,border-color 0s,-webkit-transform .35s ease-in-out;-o-transition:transform .35s ease-in-out,background-color .35s .5s,border-color 0s;transition:transform .35s ease-in-out,background-color .35s .5s,border-color 0s;transition:transform .35s ease-in-out,background-color .35s .5s,border-color 0s,-webkit-transform .35s ease-in-out;padding-top:24px}html.touchevents .license-builder__step--media .selected-media-list{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .license-builder__step--media .selected-media-list{overflow-x:hidden;overflow-y:auto}.license-builder__step--media .selected-media-list.has-medias{background-color:#fff;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);-webkit-transition:background-color .35s,border-color 0s,-webkit-transform .35s ease-in-out;transition:background-color .35s,border-color 0s,-webkit-transform .35s ease-in-out;-o-transition:transform .35s ease-in-out,background-color .35s,border-color 0s;transition:transform .35s ease-in-out,background-color .35s,border-color 0s;transition:transform .35s ease-in-out,background-color .35s,border-color 0s,-webkit-transform .35s ease-in-out}.license-builder__step--media .selected-media-list h4{margin-left:32px}.license-builder__step--media .selected-media-list li{margin-right:16px;margin-left:16px;border-radius:2px;height:128px;cursor:pointer}html.touchevents .license-builder__step--media .selected-media-list li{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .license-builder__step--media .selected-media-list li{overflow-x:hidden;overflow-y:auto}.license-builder__step--media .selected-media-list li:hover{background-color:#f9fafb}.license-builder__step--media .selected-media-list li.is-active{background-color:#f0f6fa}.license-builder__step--media .selected-media-list li.is-active .remove-usage-button,.license-builder__step--media .selected-media-list li:hover .remove-usage-button{opacity:1;-webkit-transition-delay:.45s;-o-transition-delay:.45s;transition-delay:.45s}.license-builder__step--media .selected-media-list li.is-active .edit-usage-button,.license-builder__step--media .selected-media-list li:hover .edit-usage-button{background-color:#fff;-webkit-transition-delay:.25s;-o-transition-delay:.25s;transition-delay:.25s;-webkit-transform:translateX(-40px) translateY(-50%);-ms-transform:translateX(-40px) translateY(-50%);transform:translateX(-40px) translateY(-50%)}.license-builder__step--media .selected-media-list li.is-valid .remove-usage-button{opacity:0;-webkit-transition-delay:0s;-o-transition-delay:0s;transition-delay:0s}.license-builder__step--media .selected-media-list li.is-valid .edit-usage-button{display:none}.license-builder__step--media .selected-media-list li.is-valid:hover .remove-usage-button{opacity:1}.license-builder__step--media .selected-media-list li.is-valid:hover .usage-is-valid-indicator{-webkit-transform:scale(1.2) translateY(-50%);-ms-transform:scale(1.2) translateY(-50%);transform:scale(1.2) translateY(-50%);opacity:0}.license-builder__step--media .media-list,.license-builder__step--media .selected-media-list{border-radius:8px}html.touchevents .license-builder__step--media .media-list,html.touchevents .license-builder__step--media .selected-media-list{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .license-builder__step--media .media-list,html.no-touchevents .license-builder__step--media .selected-media-list{overflow-x:hidden;overflow-y:auto}.license-builder__step--media .media-button,.license-builder__step--media .usage-button{width:100%;height:60px;text-align:left}.license-builder__step--media .media-button .button__flex,.license-builder__step--media .usage-button .button__flex{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.license-builder__step--media .media-button .button__wrapper,.license-builder__step--media .usage-button .button__wrapper{padding-left:72px!important;padding-right:48px;-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.license-builder__step--media .media-button .icon:not(.media-button__tooltip),.license-builder__step--media .usage-button .icon:not(.media-button__tooltip){height:54px}.license-builder__step--media .media-button{-webkit-transition:-webkit-transform .15s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .15s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .15s cubic-bezier(.175,.885,.32,1.275);transition:transform .15s cubic-bezier(.175,.885,.32,1.275);transition:transform .15s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .15s cubic-bezier(.175,.885,.32,1.275)}.license-builder__step--media .media-button .button__active-background{border-radius:4px}.license-builder__step--media .media-button .button__icon{-webkit-transition:-webkit-transform .1s ease-out;transition:-webkit-transform .1s ease-out;-o-transition:transform .1s ease-out;transition:transform .1s ease-out;transition:transform .1s ease-out,-webkit-transform .1s ease-out;-webkit-transform:translate(-8px,-50%);-ms-transform:translate(-8px,-50%);transform:translate(-8px,-50%)}.license-builder__step--media .media-button__tooltip{color:#d2d9e1;margin-left:16px}.license-builder__step--media .media-button:hover{color:#fff}.license-builder__step--media .media-button:hover .button__active-background{background-color:#101015}.license-builder__step--media .media-button:hover .button__icon{-webkit-transform:translate(-4px,-50%);-ms-transform:translate(-4px,-50%);transform:translate(-4px,-50%)}.license-builder__step--media .media-button:hover .media-button__tooltip{color:inherit}.license-builder__step--media .media-button:active{-webkit-transform:scale(.95);-ms-transform:scale(.95);transform:scale(.95)}.license-builder__step--media .media-button.selected{color:#101015!important}.license-builder__step--media .media-button.selected .button__active-background{background-color:transparent!important}.license-builder__step--media .usage-button{left:2.5%;width:90%}.license-builder__step--media .remove-usage-button,.license-builder__step--media .usage-button{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.license-builder__step--media .remove-usage-button{right:16px;opacity:0;-webkit-transition:opacity .15s ease-in-out;-o-transition:opacity .15s ease-in-out;transition:opacity .15s ease-in-out}.license-builder__step--media .edit-usage-button{right:12px;-webkit-transition:-webkit-transform .15s ease-in-out .2s;transition:-webkit-transform .15s ease-in-out .2s;-o-transition:transform .15s ease-in-out .2s;transition:transform .15s ease-in-out .2s;transition:transform .15s ease-in-out .2s,-webkit-transform .15s ease-in-out .2s}.license-builder__step--media .edit-usage-button,.license-builder__step--media .usage-is-valid-indicator{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.license-builder__step--media .usage-is-valid-indicator{right:16px;height:32px;width:32px;background-color:#75dbbe;color:#fff;border-radius:50%;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-animation:show-usage-valid-indicator .5s cubic-bezier(.175,.885,.32,1.275) backwards;animation:show-usage-valid-indicator .5s cubic-bezier(.175,.885,.32,1.275) backwards;pointer-events:none}.license-builder__step--media .usage-is-valid-indicator .icon{height:100%;width:100%;-webkit-transform:scaleX(1.8) scaleY(1.6);-ms-transform:scaleX(1.8) scaleY(1.6);transform:scaleX(1.8) scaleY(1.6)}.license-builder__step--media .usage-is-valid-indicator .icon svg{height:100%;margin:0 auto}@-webkit-keyframes show-usage-valid-indicator{0%{-webkit-transform:translateY(-20%);transform:translateY(-20%)}to{-webkit-transform:translateY(-50%);transform:translateY(-50%)}}@keyframes show-usage-valid-indicator{0%{-webkit-transform:translateY(-20%);transform:translateY(-20%)}to{-webkit-transform:translateY(-50%);transform:translateY(-50%)}}.license-builder__step--media .global-actions{display:-webkit-box;display:-ms-flexbox;display:flex;padding:8px}.license-builder__step--media .global-actions .button{margin:8px}.license-builder__step--media .add-more-media-button{-webkit-box-flex:0;-ms-flex:none;flex:none}.license-builder__step--media .save-terms-button{-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-animation:show-save-button .25s ease-in-out .5s both;animation:show-save-button .25s ease-in-out .5s both}@-webkit-keyframes show-save-button{0%{opacity:0}to{opacity:1}}@keyframes show-save-button{0%{opacity:0}to{opacity:1}}.license-builder__step--media.has-selected-usage .media-list{-webkit-transform:scale(.95);-ms-transform:scale(.95);transform:scale(.95);-webkit-transition-delay:0s;-o-transition-delay:0s;transition-delay:0s}.license-builder__step--media.has-selected-usage .selected-media-list{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);-webkit-transition-delay:.1s;-o-transition-delay:.1s;transition-delay:.1s}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/license-builder/SelectMedia/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA4GA,8BACE,oBAAA,oBAAA,YAAa,CADf,oDCnCI,6BDwCA,mBAAA,mBAAA,eACA,UAAU,2BACkB,iBEhFiB,CFyEjD,+DAaM,yBAAyB,mBACN,eACJ,iBACE,eEzF0B,CFyEjD,0CCnCI,sBAvCU,sDE7B6C,8CHiIvD,mBAAA,cAAA,UAAU,yBAEV,0DAAA,kDAAA,6CAAA,0CAAA,iFAA0C,8BAC1C,0BAAA,qBAAsB,CAKvB,2DEjIC,kBAAgD,kBACT,gCACN,CAClC,8DAEC,kBAAgD,eACX,CFyFzC,6CAgCM,kBEzG2C,CFyEjD,mDIlEE,kBJ0G4B,MAAG,SAAO,uBAA4B,WAGrD,UACD,gGAPgF,wFAAA,mFAAA,gFAAA,mHAAA,gBE9G7C,CFiL9C,oEEvMC,kBAAgD,kBACT,gCACN,CAClC,uEAEC,kBAAgD,eACX,CFyFzC,8DCnCI,sBAvCU,sDE7B6C,8CH0JrD,4FAbsF,oFAAA,+EAAA,4EAAA,8GAAA,CAtC5F,sDAuDM,gBEhI2C,CFyEjD,sDKnB0B,kBHtDuB,iBAAA,kBFwI3C,aACA,cAAe,CAuChB,uEEtMD,kBAAgD,kBACT,gCACN,CAClC,0EAEC,kBAAgD,eACX,CFyFzC,4DCnCI,wBA5DsB,CD+F1B,gECnCI,wBAzDuB,CD4F3B,sKAwEU,UAAU,8BACV,yBAAA,qBAAsB,CAzEhC,kKCnCI,sBDiHM,8BAAA,yBAAA,sBAAsB,qDACtB,iDAAA,4CAAoD,CA/E9D,oFAqFU,UAAU,4BACV,uBAAA,mBAAoB,CAtF9B,kFAyFU,YAAa,CAzFvB,0FA8FY,SAAU,CA9FtB,+FAkGY,8CAAA,0CAAA,sCAAsC,SAC5B,CAnGtB,6FM3EM,iBApBgB,CN6MnB,+HE7MC,kBAAgD,kBACT,gCACN,CAClC,qIAEC,kBAAgD,eACX,CFyFzC,wFAkHI,WAAW,YAEX,eAAgB,CApHpB,oHAuHM,uBAAA,oBAAA,0BAA2B,CAvHjC,0HA2HM,4BAAoC,mBAEpC,mBAAA,cAAA,UAAU,uBACV,oBAAA,0BAA2B,CA9HjC,4JAkIM,WE3M2C,CFyEjD,4CAwII,4EAAA,oEAAA,+DAAA,4DAAA,oHO5NyD,CPoF7D,uEM3EM,iBAvBgB,CNkGtB,0DA+IM,kDAAA,0CAAA,qCAAA,kCAAA,iEAAkC,uCAClC,mCAAA,8BAAwC,CAhJ9C,qDC3BI,cDgLE,gBE9N2C,CFyEjD,kDC3BI,UA/CU,CD0Ed,6ECnCI,wBArEsB,CDwG1B,gEAgKQ,uCAAA,mCAAA,8BAAyC,CAhKjD,yEAqKM,aAAc,CArKpB,mDAyKM,6BAAA,yBAAA,oBAAqB,CAzK3B,qDA6KM,uBAA8B,CA7KpC,gFA+KQ,sCAAwC,CA/KhD,4CI9DM,UJmP4C,SACpC,CAtLd,+FIlEE,kBJuP4B,QAAK,mCAE/B,+BAAA,0BAA2B,CAvL/B,mDI9DM,WJ2PF,UAAU,4CACV,uCAAA,mCAAoC,CA9LxC,iDI9DM,WJkQF,0DAAA,kDAAA,6CAAA,0CAAA,gFAA0C,CApM9C,yGIlEE,kBJoQ4B,QAAK,mCAC/B,+BAAA,0BAA2B,CAnM/B,wDI9DM,WFX2C,YAAA,WDsC7C,yBAtDoB,WAeV,kBDwRV,oCAAA,+BAAA,4BAA4B,6FAC5B,qFAAkE,mBAC9C,CAhNxB,8DQjEI,YRoRoB,WAAA,0CAClB,sCAAA,iCAAkC,CApNxC,kEAuNQ,YAAY,aACE,CACf,8CAID,GAAK,mCAAA,0BAA2B,CAAA,GACzB,mCAAA,0BAA2B,CAAA,CAFpC,sCACE,GAAK,mCAAA,0BAA2B,CAAA,GACzB,mCAAA,0BAA2B,CAAA,CA9NxC,8CAmOI,oBAAA,oBAAA,aAAa,WE5SgC,CFyEjD,sDAsOa,UE/SoC,CFyEjD,qDA0OI,mBAAA,cAAA,SAAU,CA1Od,iDA8OI,mBAAA,cAAA,UAAU,6DAEV,oDAAqD,CAErD,oCACE,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CAFpB,4BACE,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CApPxB,6DA0PM,6BAAA,yBAAA,qBAAqB,4BACrB,uBAAA,mBAAoB,CA3P1B,sEA8PM,yCAAA,iCAAmC,6BACnC,wBAAA,oBAAqB,CACtB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseMedia Component\n */\n\n.license-builder__step--media{\n  display: flex;\n\n  &.license-builder__step{  // Force style override\n    @include bgcolor(transparent);\n    flex: 0 0 baseline(45);\n    padding: 0;\n    overflow: visible !important;\n    margin-right: baseline(4.5);\n  }\n\n  .license-builder__step {\n    &__subtitle {\n      text-transform: uppercase;\n      letter-spacing: 3px;\n      font-size: 12px;\n      line-height: 16px;\n      margin-top: baseline(4.5);\n    }\n  }\n\n  .media-list{\n    @include bgcolor(white);\n    @include shadow(medium);\n    @include scroll;\n\n    flex: auto;\n    padding: baseline(3) 0 baseline(3) baseline(4);\n    transition: transform .35s ease-in-out .1s;\n    transform-origin: left;\n\n    ul{\n      padding-right: baseline(4);\n    }\n  }\n\n  .selected-media-list{\n    $transition-normal: transform .35s ease-in-out, background-color .35s .5s, border-color 0s;\n    $transition-no-delay: transform .35s ease-in-out, background-color .35s, border-color 0s;\n\n    @include position(absolute, 0 null 0 calc(100% + #{baseline(3)}));\n    @include scroll;\n\n    width: 100%;\n    z-index: 1;\n    transition: $transition-normal;\n    padding-top: baseline(3);\n\n    &.has-medias{\n      @include bgcolor(white);\n      @include shadow(medium);\n      transition: $transition-no-delay;\n    }\n\n    h4 {\n      margin-left: baseline(4);\n    }\n\n    li{\n      @include margin(null baseline(2));\n      @include bgsize(small);\n      @include scroll;\n\n      height: baseline(16);\n      cursor: pointer;\n\n      &:hover{ @include bgcolor(bw2) }\n      &.is-active{ @include bgcolor(bw3) }\n\n      &:hover,\n      &.is-active{\n        .remove-usage-button{\n          opacity: 1;\n          transition-delay: .45s;\n        }\n\n        .edit-usage-button{\n          @include bgcolor(white);\n          transition-delay: .25s;\n          transform: translateX(baseline(-5)) translateY(-50%);\n        }\n      }\n\n      &.is-valid{\n        .remove-usage-button{\n          opacity: 0;\n          transition-delay: 0s;\n        }\n        .edit-usage-button{\n          display: none;\n        }\n\n        &:hover{\n          .remove-usage-button{\n            opacity: 1;\n          }\n\n          .usage-is-valid-indicator{\n            transform: scale(1.2) translateY(-50%);\n            opacity: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .media-list,\n  .selected-media-list{\n    @include bgsize(large);\n    @include scroll;\n  }\n\n\n  .media-button, .usage-button{\n    width: 100%;\n    height: baseline(7.5);\n    text-align: left;\n\n    .button__flex{\n      justify-content: flex-start;\n    }\n\n    .button__wrapper{\n      padding-left: baseline(9) !important;\n      padding-right: baseline(6);\n      flex: auto;\n      justify-content: flex-start;\n    }\n\n    .icon:not(.media-button__tooltip){\n      height: baseline(6.75);\n    }\n  }\n\n\n  .media-button{\n    transition: transform .15s $ease-out-back;\n\n    .button__active-background{\n      @include bgsize(medium);\n    }\n\n    .button__icon{\n      transition: transform .1s ease-out;\n      transform: translate(baseline(-1), -50%);\n    }\n\n    &__tooltip{\n      @include textcolor(bw5);\n      margin-left: baseline(2);\n    }\n\n    &:hover{\n      @include textcolor(white);\n\n      .button__active-background{\n        @include bgcolor(black);\n      }\n\n      .button__icon{\n        transform: translate(baseline(-.5), -50%);\n      }\n    }\n\n    &:hover .media-button__tooltip{\n      color: inherit;\n    }\n\n    &:active{\n      transform: scale(.95);\n    }\n\n    &.selected{\n      color: color(black) !important;\n      .button__active-background{\n        background-color: transparent !important;\n      }\n    }\n  }\n\n  .usage-button{\n    @include position(absolute, 50% null null 2.5%);\n    width: 90%;\n    transform: translateY(-50%);\n  }\n\n  .remove-usage-button{\n    @include position(absolute, 50% baseline(2) null null);\n    transform: translateY(-50%);\n    opacity: 0;\n    transition: opacity .15s ease-in-out;\n  }\n\n  .edit-usage-button{\n    @include position(absolute, 50% baseline(1.5) null null);\n    transform: translateY(-50%);\n    transition: transform .15s ease-in-out .2s;\n  }\n\n  .usage-is-valid-indicator{\n    @include position(absolute, 50% baseline(2) null null);\n    @include size(baseline(4));\n    @include bgcolor(positive);\n    @include textcolor(white);\n    @include bgsize(circle);\n    transform: translateY(-50%);\n    transition: .15s ease-in-out;\n    animation: show-usage-valid-indicator .5s $ease-out-back backwards;\n    pointer-events: none;\n\n    .icon{\n      @include size(100%);\n      transform: scaleX(1.8) scaleY(1.6);\n\n      svg{\n        height: 100%;\n        margin: 0 auto;\n      }\n    }\n\n    @keyframes show-usage-valid-indicator {\n      0% { transform: translateY(-20%) }\n      100% { transform: translateY(-50%) }\n    }\n  }\n\n  .global-actions{\n    display: flex;\n    padding: baseline(1);\n\n    .button{ margin: baseline(1) }\n  }\n\n  .add-more-media-button{\n    flex: none;\n  }\n\n  .save-terms-button{\n    flex: auto;\n\n    animation: show-save-button .25s ease-in-out .5s both;\n\n    @keyframes show-save-button {\n      0% { opacity: 0 }\n      100% { opacity: 1 }\n    }\n  }\n\n  &.has-selected-usage{\n    .media-list{\n      transform: scale(.95);\n      transition-delay: 0s;\n    }\n    .selected-media-list{\n      transform: translate3d(-100%, 0, 0);\n      transition-delay: .1s;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1340);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-builder .drawer__background{background-color:#f9fafb}.license-builder .drawer__header{padding:24px 32px;height:80px}.license-builder .drawer__content{padding-right:12px;padding-left:12px}.license-builder .drawer__content:after{height:12px;width:12px;content:\"\";-webkit-box-flex:0;-ms-flex:none;flex:none}.license-builder__error{color:#b1b8c4;-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;margin-bottom:88px}.license-builder__error .icon{height:64px;width:64px}.license-builder__error .icon svg{height:100%;width:100%}.license-builder__step{background-color:#fff;-webkit-box-flex:0;-ms-flex:0 0 320px;flex:0 0 320px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:24px 32px;-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left;margin:0 12px 24px;-webkit-animation:show-license-builder-step .25s ease-out both;animation:show-license-builder-step .25s ease-out both}html.touchevents .license-builder__step{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .license-builder__step{overflow-x:hidden;overflow-y:auto}.license-builder__step__button{margin-top:8px;margin-bottom:8px}.license-builder__step__button .label{font-size:1.125em}.license-builder__step__title+.license-builder__step__note{margin-top:-8px;margin-bottom:16px}.license-builder__step ul{margin:0;padding:0;list-style:none;-ms-flex-negative:0;flex-shrink:0}.license-builder__step:not(:first-child){-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);border-radius:8px}.license-builder__step:not(:first-child)>*{-webkit-animation:show-license-builder-step-content cubic-bezier(.39,.575,.565,1) .35s both;animation:show-license-builder-step-content cubic-bezier(.39,.575,.565,1) .35s both}@-webkit-keyframes show-license-builder-step-content{0%{opacity:0;-webkit-transform:translate3d(-10%,0,0);transform:translate3d(-10%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes show-license-builder-step-content{0%{opacity:0;-webkit-transform:translate3d(-10%,0,0);transform:translate3d(-10%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes show-license-builder-step{0%{opacity:0}0.01%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:1}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes show-license-builder-step{0%{opacity:0}0.01%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:1}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.license-builder__step:first-child{z-index:4}.license-builder__step:first-child > *{-webkit-animation-delay:.35s;animation-delay:.35s}.license-builder__step:nth-child(2){z-index:3}.license-builder__step:nth-child(2)>*{-webkit-animation-delay:.45s;animation-delay:.45s}.license-builder__step:nth-child(3){z-index:2}.license-builder__step:nth-child(3)>*{-webkit-animation-delay:.55s;animation-delay:.55s}.license-builder__step:nth-child(4){z-index:1}.license-builder__step:nth-child(4)>*{-webkit-animation-delay:.65s;animation-delay:.65s}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/forms/LicenseBuilder/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,qCCnCI,wBA5DsB,CD+F1B,iCAMI,kBACA,WEhF6C,CFyEjD,kCGnB0B,mBDtDuB,iBAAA,CFyEjD,wCIjEI,YFR6C,WFwF3C,WAAW,mBACX,cAAA,SAAU,CACX,wBC5CD,cDiDA,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,kBACD,kBEpG2B,CF6F9C,8BIrFC,YFR6C,UAAA,CF6F9C,kCIrFC,YJkGsB,UAAA,CACnB,uBCrEH,sBD6EA,mBAAA,mBAAA,eACA,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,kBAEtB,8BAAA,0BAAA,sBAAsB,mBAmCtB,+DAAA,sDAAuD,CAmBxD,wCEnMC,kBAAgD,kBACT,gCACN,CAClC,2CAEC,kBAAgD,eACX,CF0IrC,+BGzEoB,eDjDyB,iBAAA,CF0H5C,sCAGG,iBAAkB,CACnB,2DAID,gBACA,kBEnI2C,CF+G9C,0BAwBG,SAAS,UACC,gBACM,oBAChB,aAAc,CA3BjB,yCKzHG,sDApBqD,8CAAA,iBCQrC,CNqInB,2CAoCG,4FAAA,mFAAqE,CACrE,qDACE,GAAK,UAAU,wCAAE,+BAAkC,CAAA,GAC5C,UAAU,gCAAE,uBAA+B,CAAA,CAFpD,6CACE,GAAK,UAAU,wCAAE,+BAAkC,CAAA,GAC5C,UAAU,gCAAE,uBAA+B,CAAA,CAAA,6CAOpD,GAAK,SAAU,CAAA,MACP,4BAAA,oBAAoB,SAAY,CAAA,GACjC,4BAAA,mBAAoB,CAAA,CAH7B,qCACE,GAAK,SAAU,CAAA,MACP,4BAAA,oBAAoB,SAAY,CAAA,GACjC,4BAAA,mBAAoB,CAAA,CAhD9B,mCAwDK,SALG,CAnDR,uCA0DO,6BAAA,oBAAqC,CA1D5C,oCAwDK,SALG,CAnDR,sCA0DO,6BAAA,oBAAqC,CA1D5C,oCAwDK,SALG,CAnDR,sCA0DO,6BAAA,oBAAqC,CA1D5C,oCAwDK,SALG,CAnDR,sCA0DO,6BAAA,oBAAqC,CACtC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseBuilder Component\n */\n\n.license-builder{\n  .drawer__background{\n    @include bgcolor(bw2);\n  }\n\n  .drawer__header{\n    padding: baseline(3) baseline(4);\n    height: baseline(10);\n  }\n\n  .drawer__content{\n    @include padding(null baseline(1.5));\n\n    &::after{\n      @include size(baseline(1.5));\n      content: \"\";\n      flex: none;\n    }\n  }\n\n  &__error{\n    @include textcolor(bw6);\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin-bottom: baseline(11);\n\n    .icon{\n      @include size(baseline(8));\n      svg{\n        @include size(100%);\n      }\n    }\n  }\n\n  &__step{\n    @include bgcolor(white);\n    @include scroll;\n\n    flex: 0 0 baseline(40);\n    display: flex;\n    flex-direction: column;\n    padding: baseline(3) baseline(4);\n    transform-origin: left;\n    margin: 0 baseline(1.5) baseline(3) baseline(1.5);\n\n    &__button{\n      @include margin(baseline(1) null);\n      .label{\n        font-size: 1.125em;\n      }\n    }\n\n    &__title + &__note{\n      margin-top: baseline(-1);\n      margin-bottom: baseline(2);\n    }\n\n    ul{\n      margin: 0;\n      padding: 0;\n      list-style: none;\n      flex-shrink: 0;\n    }\n\n    &:not(:first-child) {\n      @include shadow(medium);\n      @include bgsize(large);\n    }\n\n    &:not(:first-child) > * {\n      animation: show-license-builder-step-content $ease-out-sine .35s both;\n      @keyframes show-license-builder-step-content {\n        0% { opacity: 0; transform: translate3d(-10%, 0, 0); }\n        100% { opacity: 1; transform: translate3d(0, 0, 0); }\n      }\n    }\n\n    animation: show-license-builder-step .25s ease-out both;\n\n    @keyframes show-license-builder-step {\n      0% { opacity: 0; }\n      0.01% { transform: scaleX(0); opacity: 1; }\n      100% { transform: scaleX(1) }\n    }\n\n    $max: 4;\n    $stagger: .1;\n    @for $i from 1 through $max {\n      &:nth-child(#{$i}) {\n        // animation-delay: $i * $stagger * 1s;\n        z-index: $max - $i + 1;\n        > * {\n          animation-delay: .25s + $i * $stagger;\n        }\n      }\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Onboarding Context Types
 */

Object.defineProperty(exports, "__esModule", { value: true });
var OnboardingAchievement;
(function (OnboardingAchievement) {
  OnboardingAchievement["BuildLicense"] = "build-license";
})(OnboardingAchievement = exports.OnboardingAchievement || (exports.OnboardingAchievement = {}));

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1343);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".drawer{position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:320px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-bottom:1px solid #e4e8ed}@media screen and (min-width:1152px){.drawer{width:400px}}@media screen and (min-width:1600px){.drawer{width:400px}}.drawer--right{margin:0;margin-left:auto}.drawer--left{margin:0;margin-right:auto}.drawer__mask{position:absolute;top:0;right:0;bottom:0;left:0;background-color:hsla(0,0%,100%,.35);cursor:pointer}.drawer__header{padding-right:8px;padding-left:16px;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;height:32px;z-index:2}.drawer__header .icon{margin-right:auto}.drawer__header button{height:100%;border-radius:0}.drawer__header button:first-of-type{margin-left:auto}.drawer__header button:not(:first-of-type){margin-left:12px}.drawer__header--floating{position:absolute;top:0;right:0;left:0}.drawer__header--dark{background-color:#101015;color:#fff}.drawer__content{height:100%;-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:1}html.touchevents .drawer__content{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .drawer__content{overflow-x:hidden;overflow-y:auto}.drawer:not(.drawer--fullscreen) .drawer__header--light:not(.drawer__header--floating){-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.drawer:not(.drawer--fullscreen) .drawer__content>*{-webkit-box-flex:0;-ms-flex:none;flex:none}.drawer__button-list:not(:first-child),.drawer__content-group:not(:first-child){border-top:1px solid #e4e8ed}.drawer__button-list:before,.drawer__content-group:before{position:absolute;top:-24px;right:0;left:5%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34;content:attr(data-title)}@media print{.drawer__button-list:before,.drawer__content-group:before{font-size:.6770833331em}}.drawer__button-list:before em,.drawer__button-list:before i,.drawer__content-group:before em,.drawer__content-group:before i{font-weight:300}.drawer__button-list:before b,.drawer__button-list:before strong,.drawer__content-group:before b,.drawer__content-group:before strong{font-weight:700}.drawer__button-list+.drawer__button-list,.drawer__button-list+.drawer__content-group,.drawer__content-group+.drawer__button-list,.drawer__content-group+.drawer__content-group{margin-top:48px}.drawer__content-group{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:16px}.drawer__button-list,.drawer__content-group{display:-webkit-box;display:-ms-flexbox;display:flex}.drawer__button-list{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 12px;border-bottom:1px solid #e4e8ed}.drawer__button-list__button{-webkit-box-flex:0;-ms-flex:none;flex:none;margin:1px auto;width:100%;text-align:left;border-radius:0}.drawer__button-list__button .button__flex,.drawer__button-list__button .button__wrapper{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.drawer__button-list__button:not([class*=color-scheme--]):hover .icon{color:#4487ff}.drawer__button-list__button:not(:last-child){-webkit-box-shadow:0 1px 0 #e4e8ed;box-shadow:0 1px 0 #e4e8ed}.drawer__button-list__button .icon--spotify{left:6px!important}.drawer__button-list hr{width:95%;-ms-flex-item-align:end;align-self:flex-end}.drawer__background{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#fff}.drawer--left{-webkit-animation:show-drawer-from-left .5s cubic-bezier(.785,.135,.15,.86) both;animation:show-drawer-from-left .5s cubic-bezier(.785,.135,.15,.86) both}.drawer--left.is-closing{-webkit-animation:hide-drawer-to-left .35s cubic-bezier(.785,.135,.15,.86) both;animation:hide-drawer-to-left .35s cubic-bezier(.785,.135,.15,.86) both}.drawer--right{-webkit-animation:show-drawer-from-right .5s cubic-bezier(.075,.82,.165,1) both;animation:show-drawer-from-right .5s cubic-bezier(.075,.82,.165,1) both}.drawer--right.is-closing{-webkit-animation:hide-drawer-to-right .35s cubic-bezier(.075,.82,.165,1) both;animation:hide-drawer-to-right .35s cubic-bezier(.075,.82,.165,1) both}.drawer__wrapper:not(.drawer--fullscreen) .drawer__mask{-webkit-animation:show-drawer-mask .25s ease-out both;animation:show-drawer-mask .25s ease-out both}.drawer--fullscreen{height:100%;width:100%}.drawer--fullscreen .drawer__mask{display:none}.drawer--fullscreen .drawer__background{-webkit-animation:show-drawer-background .5s ease-in-out both;animation:show-drawer-background .5s ease-in-out both}.drawer--fullscreen .drawer__header{-webkit-animation:show-drawer-content .25s ease-in-out .25s backwards;animation:show-drawer-content .25s ease-in-out .25s backwards}.drawer--fullscreen .drawer__content{-webkit-animation:show-drawer-content .25s ease-in-out .75s backwards;animation:show-drawer-content .25s ease-in-out .75s backwards;-webkit-transform-origin:top center;-ms-transform-origin:top center;transform-origin:top center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html.touchevents .drawer--fullscreen .drawer__content{overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .drawer--fullscreen .drawer__content{overflow-y:hidden;overflow-x:auto}.drawer--fullscreen.is-closing .drawer__background{-webkit-animation:hide-drawer-background .5s ease-in-out .25s both;animation:hide-drawer-background .5s ease-in-out .25s both}.drawer--fullscreen.is-closing .drawer__content,.drawer--fullscreen.is-closing .drawer__header{-webkit-animation:hide-drawer-content .25s ease-in-out forwards;animation:hide-drawer-content .25s ease-in-out forwards}.drawer--fullscreen.is-closing .drawer__content{-webkit-transform-origin:top left;-ms-transform-origin:top left;transform-origin:top left}.drawer__wrapper.is-closing .drawer__mask{-webkit-animation:hide-drawer-mask .25s cubic-bezier(.445,.05,.55,.95) .3s both;animation:hide-drawer-mask .25s cubic-bezier(.445,.05,.55,.95) .3s both}@-webkit-keyframes show-drawer-from-left{0%{-webkit-transform:translate3d(-120%,0,0);transform:translate3d(-120%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes show-drawer-from-left{0%{-webkit-transform:translate3d(-120%,0,0);transform:translate3d(-120%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes hide-drawer-to-left{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-120%,0,0);transform:translate3d(-120%,0,0)}}@keyframes hide-drawer-to-left{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-120%,0,0);transform:translate3d(-120%,0,0)}}@-webkit-keyframes show-drawer-from-right{0%{-webkit-transform:translate3d(120%,0,0);transform:translate3d(120%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes show-drawer-from-right{0%{-webkit-transform:translate3d(120%,0,0);transform:translate3d(120%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes hide-drawer-to-right{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(120%,0,0);transform:translate3d(120%,0,0)}}@keyframes hide-drawer-to-right{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(120%,0,0);transform:translate3d(120%,0,0)}}@-webkit-keyframes show-drawer-content{0%{-webkit-transform:scale(1.1);transform:scale(1.1);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes show-drawer-content{0%{-webkit-transform:scale(1.1);transform:scale(1.1);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes hide-drawer-content{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(1.1);transform:scale(1.1);opacity:0}}@keyframes hide-drawer-content{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(1.1);transform:scale(1.1);opacity:0}}@-webkit-keyframes show-drawer-background{0%{-webkit-transform-origin:left;transform-origin:left;-webkit-transform:scaleX(0);transform:scaleX(0)}to{-webkit-transform-origin:left;transform-origin:left;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes show-drawer-background{0%{-webkit-transform-origin:left;transform-origin:left;-webkit-transform:scaleX(0);transform:scaleX(0)}to{-webkit-transform-origin:left;transform-origin:left;-webkit-transform:scaleX(1);transform:scaleX(1)}}@-webkit-keyframes hide-drawer-background{0%{-webkit-transform-origin:right;transform-origin:right;-webkit-transform:scaleX(1);transform:scaleX(1)}to{-webkit-transform-origin:right;transform-origin:right;-webkit-transform:scaleX(0);transform:scaleX(0)}}@keyframes hide-drawer-background{0%{-webkit-transform-origin:right;transform-origin:right;-webkit-transform:scaleX(1);transform:scaleX(1)}to{-webkit-transform-origin:right;transform-origin:right;-webkit-transform:scaleX(0);transform:scaleX(0)}}@-webkit-keyframes show-drawer-mask{0%{opacity:0}to{opacity:1}}@keyframes show-drawer-mask{0%{opacity:0}to{opacity:1}}@-webkit-keyframes hide-drawer-mask{0%{opacity:1}to{opacity:0}}@keyframes hide-drawer-mask{0%{opacity:1}to{opacity:0}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/modals/Drawer/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA8GA,QCpEE,kBDqE0B,MAAG,QAAA,SAAA,OAAA,YACS,YAEtC,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,+BExGG,CFsX1B,qCAnRD,QAgBI,WG3F6C,CH8VhD,CAAA,qCAnRD,QAmBI,WG9F6C,CH8VhD,CA7PC,eACE,SAAS,gBACQ,CAClB,cAGC,SAAS,iBACS,CACnB,cClGD,kBDqG4B,MAAG,QAAA,SAAA,OAAA,qCACsB,cACpC,CAChB,gBIzDuB,kBDtDuB,kBHmH7C,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,uBACb,oBAAA,2BAA2B,yBAC3B,sBAAA,mBAAmB,kBACD,YAElB,SAAU,CARX,sBAWG,iBAAkB,CAXrB,uBAeG,YAAY,eACI,CAhBnB,qCAmBK,gBAAiB,CAnBtB,2CAuBK,gBGxIyC,CHyI1C,0BClIL,kBDsI8B,MAAG,QAAE,MAAO,CACvC,sBExGD,yBArEsB,UA6Bd,CFqJP,iBAKD,YAAY,mBACZ,cAAA,UAAU,oBACV,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,SACZ,CACX,kCGnLC,kBAAgD,kBACT,gCACN,CAClC,qCAEC,kBAAgD,eACX,CH2FzC,uFAqFI,iCAAA,wBExLuB,CFmG3B,oDAwFI,mBAAA,cAAA,SAAU,CACX,gFAMG,4BElMqB,CF8LxB,0DC/JD,kBDuK8B,UCnK1B,QDmK0C,QAAQ,mCGzIf,kCAKH,aE/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,iBLqMhB,wBAAyB,CAC1B,aAZF,0DKhJO,uBAA0B,CL4J/B,CAZF,8HKtIG,eAAgB,CLsInB,sIK9HG,eAAgB,CL8HnB,gLAeG,eGrL2C,CHsL5C,uBAKD,mBAAA,eAAe,YG3L8B,CH6L9C,4CAHC,oBAAA,oBAAA,YAAa,CAKf,qBAEE,4BAAA,6BAAA,0BAAA,sBAAsB,eAEtB,+BE3NuB,CF6NvB,6BAEE,mBAAA,cAAA,UAAU,gBACM,WACL,gBACK,eAEA,CAPjB,yFAUG,uBAAA,oBAAA,2BAA2B,mBAC3B,cAAA,SAAU,CAXb,sEEvJD,aAnEuB,CF0NtB,8CAmBG,mCAAA,0BEhPmB,CF6NtB,4CAuBG,kBAA8B,CA7BnC,wBAkCG,UAAU,wBACV,mBAAoB,CACrB,oBC5NH,kBDgO4B,MAAG,QAAA,SAAA,OAAA,qBExOnB,CF2PX,cAaC,iFAAA,wEAA2D,CAC5D,yBAEC,gFAAA,uEAA0D,CAC3D,eAGC,gFAAA,uEAAyD,CAC1D,0BAEC,+EAAA,sEAAwD,CACzD,wDAGC,sDAAA,6CAA8C,CAC/C,oBM9QC,YNiRkB,UAAA,CACnB,kCAEsB,YAAc,CAAE,wCACV,8DAAA,qDAAuD,CAAE,oCAC7D,sEAAA,6DAA+D,CAAE,qCAGxF,sEAAA,8DAA8D,oCAC9D,gCAAA,4BAA4B,8BAC5B,6BAAA,uBAAA,kBAAmB,CACpB,sDG1TC,kBAAgD,kBACT,gCACN,CAClC,yDAEC,kBAAgD,eACX,CHsTvC,mDAAwC,mEAAA,0DAA4D,CAAE,+FAClE,gEAAA,uDAAyD,CAC7F,gDAA+F,kCAAA,8BAAA,yBAA0B,CAAI,0CAG3H,gFAAA,uEAA2D,CAC5D,yCAGC,GAAK,yCAAA,gCAAmC,CAAA,GACjC,gCAAA,uBAA+B,CAAA,CAFxC,iCACE,GAAK,yCAAA,gCAAmC,CAAA,GACjC,gCAAA,uBAA+B,CAAA,CAAA,uCAEpC,GAAK,gCAAA,uBAA+B,CAAA,GAC7B,yCAAA,gCAAmC,CAAA,CAF5C,+BACE,GAAK,gCAAA,uBAA+B,CAAA,GAC7B,yCAAA,gCAAmC,CAAA,CAAA,0CAI5C,GACE,wCAAA,+BAAkC,CAAA,GAGlC,gCAAA,uBAA+B,CAAA,CALnC,kCACE,GACE,wCAAA,+BAAkC,CAAA,GAGlC,gCAAA,uBAA+B,CAAA,CAAA,wCAGjC,GACE,gCAAA,uBAA+B,CAAA,GAG/B,wCAAA,+BAAkC,CAAA,CALpC,gCACA,GACE,gCAAA,uBAA+B,CAAA,GAG/B,wCAAA,+BAAkC,CAAA,CAAA,uCAKpC,GAAK,6BAAA,qBAAqB,SAAa,CAAA,GAChC,2BAAA,mBAAmB,SAAa,CAAA,CAFzC,+BACE,GAAK,6BAAA,qBAAqB,SAAa,CAAA,GAChC,2BAAA,mBAAmB,SAAa,CAAA,CAAA,uCAEvC,GAAK,2BAAA,mBAAmB,SAAa,CAAA,GAC9B,6BAAA,qBAAqB,SAAa,CAAA,CAFzC,+BACA,GAAK,2BAAA,mBAAmB,SAAa,CAAA,GAC9B,6BAAA,qBAAqB,SAAa,CAAA,CAAA,0CAIzC,GAAK,8BAAA,sBAAsB,4BAAE,mBAAoB,CAAA,GAC1C,8BAAA,sBAAsB,4BAAE,mBAAoB,CAAA,CAFrD,kCACE,GAAK,8BAAA,sBAAsB,4BAAE,mBAAoB,CAAA,GAC1C,8BAAA,sBAAsB,4BAAE,mBAAoB,CAAA,CAAA,0CAEnD,GAAK,+BAAA,uBAAuB,4BAAE,mBAAoB,CAAA,GAC3C,+BAAA,uBAAuB,4BAAE,mBAAoB,CAAA,CAFpD,kCACA,GAAK,+BAAA,uBAAuB,4BAAE,mBAAoB,CAAA,GAC3C,+BAAA,uBAAuB,4BAAE,mBAAoB,CAAA,CAAA,oCAIpD,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CAFpB,4BACE,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CAAA,oCAElB,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CAFlB,4BACA,GAAK,SAAW,CAAA,GACT,SAAW,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Drawer Component\n */\n\n@import '../../../atoms/text/Label/mixins';\n\n.drawer{\n  @include position(absolute, 0);\n  @include size($drawer-width-small 100%);\n\n  display: flex;\n  flex-direction: column;\n\n  // box-shadow: -8px 24px 64px -24px uicolor(shadow);\n  // box-shadow: -1px 0 uicolor(border);\n  border-bottom: 1px solid uicolor(border);\n\n  &--fullscreen{\n    width: 100%;\n  }\n\n  @include media(breakpoint(desktop-m)) {\n    width: $drawer-width-medium;\n  }\n  @include media(breakpoint(desktop-xxl)) {\n    width: $drawer-width-large;\n  }\n\n  &--right{\n    margin: 0;\n    margin-left: auto;\n  }\n\n  &--left{\n    margin: 0;\n    margin-right: auto;\n  }\n\n  &__mask{\n    @include position(absolute, 0);\n    background-color: transparentize(color(white), .65);\n    cursor: pointer;\n  }\n\n  &__header{\n    @include padding(null baseline(1) null baseline(2));\n    flex: none;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    text-align: center;\n    height: baseline(4);\n    z-index: 2;\n\n    .icon{\n      margin-right: auto;\n    }\n\n    button{\n      height: 100%;\n      border-radius: 0;\n\n      &:first-of-type{\n        margin-left: auto;\n      }\n\n      &:not(:first-of-type){\n        margin-left: baseline(1.5);\n      }\n    }\n\n    &--floating{\n      @include position(absolute, 0 0 null 0);\n    }\n\n    &--dark{\n      @include bgcolor(dark);\n      @include textcolor(bw1);\n    }\n  }\n\n  &__content{\n    @include scroll;\n    height: 100%;\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    z-index: 1;\n  }\n\n  &:not(&--fullscreen) &__header--light:not(&__header--floating){\n    box-shadow: 0 1px uicolor(border);\n  }\n  &:not(&--fullscreen) &__content > *{\n    flex: none;\n  }\n\n  &__content-group,\n  &__button-list{\n\n    &:not(:first-child) {\n      border-top: 1px solid uicolor(border);\n    }\n\n    &::before{\n      @include position(absolute, baseline(-3) 0 null 5%);\n      @include label;\n      @include label-size(medium);\n      content: attr(data-title);\n    }\n\n    & + &{\n      margin-top: baseline(6);\n    }\n  }\n\n  &__content-group{\n    display: flex;\n    flex-wrap: wrap;\n    padding: baseline(2);\n  }\n\n  &__button-list{\n    display: flex;\n    flex-direction: column;\n    padding: 0 baseline(1.5);\n    border-bottom: 1px solid uicolor(border);\n\n    &__button{\n      // @include bgcolor(bw3);\n      flex: none;\n      margin: 1px auto;\n      width: 100%;\n      text-align: left;\n      // box-shadow: 0 2px 8px -2px transparentize(uicolor(shadow), .7);\n      border-radius: 0;\n\n      .button__flex, .button__wrapper{\n        justify-content: flex-start;\n        flex: auto;\n      }\n\n      &:not([class*=\"color-scheme--\"]):hover .icon{\n        @include textcolor(accent);\n      }\n\n      &:not(:last-child){\n        box-shadow: 0 1px 0 uicolor(border);\n      }\n\n      .icon--spotify{\n        left: baseline(3/4) !important;\n      }\n    }\n\n    hr{\n      width: 95%;\n      align-self: flex-end;\n    }\n  }\n\n  &__background{\n    @include position(absolute, 0);\n    @include bgcolor(white);\n\n    // &::after{\n    //   @include position(absolute, 0);\n    //   @include shadow(large);\n    //   content: \"\";\n    //   opacity: 0;\n    //   animation: background-appear .25s .51s forwards;\n    // }\n\n    // &.is-closing &__background::after{\n    //   display: none;\n    // }\n\n    @keyframes background-appear {\n      0% { opacity: 0 }\n      100% { opacity: 1 }\n    }\n  }\n\n  // &__wrapper{\n  //   @include position(fixed, 0);\n  //   display: flex;\n  //   z-index: 1;\n\n  //   [data-player-visibility=\"true\"] & {\n  //     bottom: baseline(7);\n  //   }\n  // }\n\n  &--left {\n    animation: show-drawer-from-left .5s $ease-in-out-circ both;\n  }\n  &--left.is-closing {\n    animation: hide-drawer-to-left .35s $ease-in-out-circ both;\n  }\n\n  &--right{\n    animation: show-drawer-from-right .5s $ease-out-circ both;\n  }\n  &--right.is-closing{\n    animation: hide-drawer-to-right .35s $ease-out-circ both;\n  }\n\n  &__wrapper:not(&--fullscreen) &__mask{\n    animation: show-drawer-mask .25s ease-out both;\n  }\n\n  &--fullscreen{\n    @include size(100%);\n  }\n\n  &--fullscreen &__mask{ display: none }\n  &--fullscreen &__background{ animation: show-drawer-background .5s ease-in-out both }\n  &--fullscreen &__header{ animation: show-drawer-content .25s ease-in-out .25s backwards }\n  &--fullscreen &__content{\n    @include scroll(x);\n    animation: show-drawer-content .25s ease-in-out .75s backwards;\n    transform-origin: top center;\n    flex-direction: row;\n  }\n\n  &--fullscreen.is-closing &__background{ animation: hide-drawer-background .5s ease-in-out .25s both }\n  &--fullscreen.is-closing &__header{ animation: hide-drawer-content .25s ease-in-out forwards }\n  &--fullscreen.is-closing &__content{ animation: hide-drawer-content .25s ease-in-out forwards; transform-origin: top left; }\n\n  &__wrapper.is-closing &__mask {\n    animation: hide-drawer-mask .25s $ease-in-out-sine .3s both;\n  }\n\n  @keyframes show-drawer-from-left {\n    0% { transform: translate3d(-120%, 0, 0) }\n    100% { transform: translate3d(0, 0, 0) }\n  } @keyframes hide-drawer-to-left {\n      0% { transform: translate3d(0, 0, 0) }\n      100% { transform: translate3d(-120%, 0, 0) }\n    }\n\n  @keyframes show-drawer-from-right {\n    0% {\n      transform: translate3d(120%, 0, 0);\n    }\n    100% {\n      transform: translate3d(0, 0, 0);\n    }\n  } @keyframes hide-drawer-to-right {\n    0% {\n      transform: translate3d(0, 0, 0);\n    }\n    100% {\n      transform: translate3d(120%, 0, 0);\n    }\n  }\n\n  @keyframes show-drawer-content {\n    0% { transform: scale(1.1); opacity: 0 }\n    100% { transform: scale(1); opacity: 1 }\n  } @keyframes hide-drawer-content {\n    0% { transform: scale(1); opacity: 1 }\n    100% { transform: scale(1.1); opacity: 0 }\n  }\n\n  @keyframes show-drawer-background {\n    0% { transform-origin: left; transform: scaleX(0); }\n    100% { transform-origin: left; transform: scaleX(1); }\n  } @keyframes hide-drawer-background {\n    0% { transform-origin: right; transform: scaleX(1) }\n    100% { transform-origin: right; transform: scaleX(0) }\n  }\n\n  @keyframes show-drawer-mask {\n    0% { opacity: 0 }\n    100% { opacity: 1 }\n  } @keyframes hide-drawer-mask {\n    0% { opacity: 1 }\n    100% { opacity: 0 }\n  }\n\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1344 */,
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * MediaButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Tooltip_1 = __webpack_require__(172);
var grid_1 = __webpack_require__(58);
var classes = new BEM('media-button');

var MediaButton = function (_React$PureComponent) {
    _inherits(MediaButton, _React$PureComponent);

    function MediaButton() {
        _classCallCheck(this, MediaButton);

        var _this = _possibleConstructorReturn(this, (MediaButton.__proto__ || Object.getPrototypeOf(MediaButton)).apply(this, arguments));

        _this.onClick = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                name = _this$props.name;

            _this.props.onClick({ id: id, name: name });
        };
        return _this;
    }

    _createClass(MediaButton, [{
        key: "render",
        value: function render() {
            return React.createElement(Button_1.default, Object.assign({ onClick: this.onClick, icon: this.props.icon, label: this.props.name, size: "medium" }, classes()), this.props.hint && React.createElement(Tooltip_1.Tooltip, { content: this.props.hint, distance: grid_1.baseline * 4, placement: "bottom", theme: "black" }, React.createElement(Icon_1.IconInfoFilled, Object.assign({}, classes('tooltip')))));
        }
    }]);

    return MediaButton;
}(React.PureComponent);

exports.MediaButton = MediaButton;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseSpotCount Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1347);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ConnectedLicenseBuilderComponent_1 = __webpack_require__(212);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('license-builder__step');

var LicenseSpotCount = function (_React$Component) {
    _inherits(LicenseSpotCount, _React$Component);

    function LicenseSpotCount() {
        _classCallCheck(this, LicenseSpotCount);

        return _possibleConstructorReturn(this, (LicenseSpotCount.__proto__ || Object.getPrototypeOf(LicenseSpotCount)).apply(this, arguments));
    }

    _createClass(LicenseSpotCount, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            var should = nextProps.selectedParam !== this.props.selectedParam || nextProps.editingUsageIndex !== this.props.editingUsageIndex;
            return should;
        }
    }, {
        key: "renderSpotCountButton",
        value: function renderSpotCountButton(_ref) {
            var _this2 = this;

            var internal_id = _ref.internal_id,
                name = _ref.name;

            var id = internal_id;
            var component = { id: id, name: name };
            var selectedParam = this.props.selectedParam;
            var extraClassName = classNames({ 'is-active': !!selectedParam && id === selectedParam.id });
            return React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                    _this2.props.setParam(component);
                } }, classes('button', '', extraClassName), { label: name, size: "small", colorScheme: "white" }));
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                editingUsageIndex = _props.editingUsageIndex,
                medium = _props.medium;

            return React.createElement("div", Object.assign({}, classes('', 'spot-count')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Number of ", medium === 2006 || medium === 2011 ? 'Spots' : 'Films', ":"), React.createElement(Label_1.Span, Object.assign({ size: "medium", variant: "note" }, classes('note')), "Unlimited cut-downs are included."), React.createElement("ul", null, this.props.data.map(function (_ref2) {
                var node = _ref2.node;
                return React.createElement("li", { key: editingUsageIndex + "-" + node.internal_id }, _this3.renderSpotCountButton(node));
            })));
        }
    }]);

    return LicenseSpotCount;
}(React.Component);

var ConnectedLicenseSpotCount = ConnectedLicenseBuilderComponent_1.default(LicenseSpotCount, 'spot_count');
exports.default = ConnectedLicenseSpotCount;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1348);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-builder__step--spot-count ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;max-width:224px}.license-builder__step--spot-count ul li{-ms-flex-preferred-size:25%;flex-basis:25%}.license-builder__step--spot-count .license-builder__step__button{margin-top:4px;margin-bottom:4px;height:48px;width:100%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/license-builder/SelectSpotCount/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GC,sCAEG,oBAAA,oBAAA,aAAa,8BACb,6BAAA,uBAAA,mBAAmB,eC5E0B,CDyEhD,yCAOK,4BAAA,cAAe,CAPpB,kEExBuB,eDjDyB,kBAAA,YAAA,UDsF3B,CACnB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseSpotCount Component\n */\n\n .license-builder__step--spot-count{\n  ul{\n    display: flex;\n    flex-flow: row wrap;\n    max-width: baseline(28);\n\n    li{\n      flex-basis: 25%;\n    }\n  }\n\n  .license-builder__step__button{\n    @include margin(baseline(.5) null);\n    @include size(100% baseline(6));\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseTerm Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1350);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ConnectedLicenseBuilderComponent_1 = __webpack_require__(212);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Tooltip_1 = __webpack_require__(172);
var classes = new BEM('license-builder__step');

var LicenseTerm = function (_React$Component) {
    _inherits(LicenseTerm, _React$Component);

    function LicenseTerm() {
        _classCallCheck(this, LicenseTerm);

        return _possibleConstructorReturn(this, (LicenseTerm.__proto__ || Object.getPrototypeOf(LicenseTerm)).apply(this, arguments));
    }

    _createClass(LicenseTerm, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.selectedParam !== this.props.selectedParam || nextProps.editingUsageIndex !== this.props.editingUsageIndex;
        }
    }, {
        key: "renderButton",
        value: function renderButton(_ref) {
            var _this2 = this;

            var internal_id = _ref.internal_id,
                name = _ref.name;

            var id = internal_id;
            var component = { id: id, name: name };
            var selectedParam = this.props.selectedParam;
            var extraClassName = classNames({ 'is-active': !!selectedParam && id === selectedParam.id });
            return React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                    _this2.props.setParam(component);
                } }, classes('button', '', extraClassName), { label: name, size: "small", colorScheme: "white" }));
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var editingUsageIndex = this.props.editingUsageIndex;

            var data = this.props.data.slice().sort(function (a, b) {
                return a.node.display_order - b.node.display_order;
            });
            // tslint:disable-next-line:max-line-length
            var tooltipContent = "\n    All licenses purchased on Bopper include archival rights for free\n    allowing licensees to use the music on all digital media for archival\n    purposes, in perpetuity. Examples of archival uses are unpromoted\n    social media posts or Youtube archives, and corporate websites.\n    Whenever content is promoted, either by purchasing media or paying\n    to drive traffic to a website, it is no longer considered an archival\n    use.";
            return React.createElement("div", Object.assign({}, classes('', 'term')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Campaign Duration:"), React.createElement(Label_1.Span, Object.assign({ size: "medium", variant: "note" }, classes('note')), React.createElement(Label_1.Span, null, "Archival rights are included.", React.createElement(Tooltip_1.Tooltip, { content: tooltipContent, placement: "bottom", theme: "black", interactive: true }, React.createElement(Icon_1.IconInfoFilled, { className: "tooltip" }))), React.createElement("br", null), React.createElement(Label_1.Span, null, "Learn more about the differences between perpetuity and archival uses\xA0", React.createElement(Button_1.default, { label: "here", variant: "hyperlink", wrapperComponent: "a", hyperLinkProps: {
                    href: 'https://www.boppermusic.com/blog/archival-rights-weve-got-you-covered/',
                    target: '_blank'
                } }), ".")), React.createElement("ul", null, data.map(function (_ref2) {
                var node = _ref2.node;
                return React.createElement("li", { key: editingUsageIndex + "-" + node.internal_id }, _this3.renderButton(node));
            })));
        }
    }]);

    return LicenseTerm;
}(React.Component);

var ConnectedLicenseTerm = ConnectedLicenseBuilderComponent_1.default(LicenseTerm, 'term');
exports.default = ConnectedLicenseTerm;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1351);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-builder__step .tooltip{display:inline-block;margin-left:8px}.license-builder__step .note .button__label{font-size:inherit}.license-builder__step .note span:first-child{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/license-builder/SelectTerm/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,gCAEI,qBAAqB,eC3EwB,CDyEjD,4CAQM,iBAAkB,CARxB,8CAYM,2BAAA,2BAAA,oBAAoB,yBACpB,sBAAA,kBAAmB,CACpB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseTerm Component\n */\n\n.license-builder__step {\n  .tooltip {\n    display: inline-block;\n    margin-left: baseline(1);\n  }\n\n  .note {\n    .button__label {\n      font-size: inherit;\n    }\n\n    span:first-child {\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseTerritory Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1353);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ConnectedLicenseBuilderComponent_1 = __webpack_require__(212);
var Heading_1 = __webpack_require__(9);
var LocationCheckbox_1 = __webpack_require__(602);
var filterComponent = function filterComponent(id) {
    return function (component) {
        return id === component.id;
    };
};
var classes = new BEM('license-builder__step');
var defaultList = [];

var LicenseTerritory = function (_React$Component) {
    _inherits(LicenseTerritory, _React$Component);

    function LicenseTerritory(props) {
        _classCallCheck(this, LicenseTerritory);

        var _this = _possibleConstructorReturn(this, (LicenseTerritory.__proto__ || Object.getPrototypeOf(LicenseTerritory)).call(this, props));

        _this.onSelectLocation = function (component) {
            var selectedLocations = _this.props.selectedParam ? [].concat(_toConsumableArray(_this.props.selectedParam)) : defaultList;
            if (_this.isLocationSet(component.id)) {
                lodash_1.remove(selectedLocations, filterComponent(component.id));
            } else {
                selectedLocations.push(component);
            }
            _this.props.setParam(lodash_1.uniqBy(selectedLocations, 'id'));
        };
        _this.sortLocations();
        return _this;
    }

    _createClass(LicenseTerritory, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (!lodash_1.isEqual(nextProps.data, this.props.data)) {
                this.sortLocations(nextProps);
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !lodash_1.isEqual(nextProps.selectedParam, this.props.selectedParam) || nextProps.editingUsageIndex === this.props.editingUsageIndex;
        }
    }, {
        key: "renderList",
        value: function renderList(list, title) {
            var _this2 = this;

            return !!list.length && React.createElement("ul", { "data-title": title }, list.map(function (_ref) {
                var id = _ref.internal_id,
                    name = _ref.name;
                return React.createElement("li", { key: _this2.props.editingUsageIndex + "-" + id }, React.createElement(LocationCheckbox_1.LocationCheckbox, { checked: _this2.isLocationSet(id), id: id, name: name, onChange: _this2.onSelectLocation }));
            }));
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes('', 'location')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Broadcast Territories:"), this.renderList(this.commonLocations, 'Commonly Used'), this.renderList(this.regionLocations, 'Regions'), this.renderList(this.countryLocations, 'Countries'));
        }
    }, {
        key: "isLocationSet",
        value: function isLocationSet(locationId) {
            var selectedLocations = this.props.selectedParam;
            return !!selectedLocations && lodash_1.findIndex(selectedLocations, filterComponent(locationId)) > -1;
        }
    }, {
        key: "sortLocations",
        value: function sortLocations() {
            var _this3 = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            this.commonLocations = [];
            this.regionLocations = [];
            this.countryLocations = [];
            props.data.forEach(function (edge) {
                var node = edge.node;
                var is_region = node.is_region,
                    internal_id = node.internal_id;

                switch (internal_id) {
                    case 4001 /* UsaNational */:
                        _this3.commonLocations[0] = node;
                        break;
                    case 4039 /* UsaRegional */:
                        _this3.commonLocations[1] = node;
                        break;
                    case 4002 /* Canada */:
                        _this3.commonLocations[2] = node;
                        break;
                    case 4019 /* France */:
                        _this3.commonLocations[3] = node;
                        break;
                    case 4018 /* UK */:
                        _this3.commonLocations[4] = node;
                        break;
                    default:
                        if (is_region) {
                            _this3.regionLocations.push(node);
                        } else {
                            _this3.countryLocations.push(node);
                        }
                        break;
                }
            });
            this.regionLocations = lodash_1.sortBy(this.regionLocations, 'name');
            this.countryLocations = lodash_1.sortBy(this.countryLocations, 'name');
        }
    }]);

    return LicenseTerritory;
}(React.Component);

var ConnectedLicenseTerritory = ConnectedLicenseBuilderComponent_1.default(LicenseTerritory, 'contextual_param');
exports.default = ConnectedLicenseTerritory;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1354);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$checkoutEven;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __webpack_require__(80);
var checkout_1 = __webpack_require__(92);
var types_1 = __webpack_require__(102);
var cart_1 = __webpack_require__(500);
var checkoutStepUpdate = function checkoutStepUpdate(_, prevState, nextState) {
    var prevActiveStep = prevState.checkout.activeStep;
    // If an order was just placed, don't track the setActiveStep action
    // as it's the form being reset.
    if (prevActiveStep === config_1.CheckoutStepId.orderPlaced) {
        return;
    }
    return {
        category: types_1.EventCategory.Checkout,
        event: types_1.CheckoutEvent.Checkout,
        action: types_1.CheckoutEvent.Checkout,
        label: "checkout-step:" + nextState.checkout.activeStep,
        ecommerce: {
            checkout: {
                actionField: { step: nextState.checkout.completedSteps.length + 1 }
            }
        }
    };
};
var placeOrderComplete = function placeOrderComplete(action) {
    var newOrder = action.payload.result.order;
    return {
        category: types_1.EventCategory.Checkout,
        event: types_1.CheckoutEvent.PlaceOrder,
        action: types_1.CheckoutEvent.PlaceOrder,
        label: "Invoice #" + newOrder.invoice_number,
        ecommerce: {
            currencyCode: newOrder.currency_code,
            purchase: {
                actionField: {
                    id: newOrder.invoice_number,
                    affiliation: '',
                    revenue: newOrder.total * newOrder.currency_rate,
                    tax: newOrder.tax_line_items ? newOrder.tax_line_items.reduce(function (total, cur) {
                        return total + cur.amount;
                    }, 0) : 0,
                    shipping: '',
                    coupon: newOrder.promo_code_line_item ? newOrder.promo_code_line_item.code : ''
                },
                products: newOrder.license_line_items.map(function (item) {
                    return {
                        name: item.track.title,
                        id: item.track.internal_id,
                        price: (item.amount - item.discount_amount) * newOrder.currency_rate,
                        brand: item.track.artist.name,
                        category: 'License',
                        variant: cart_1.licenseLineItemToLicenseStr(item),
                        quantity: 1,
                        coupon: ''
                    };
                })
            }
        }
    };
};
exports.checkoutEventsMap = (_exports$checkoutEven = {}, _defineProperty(_exports$checkoutEven, checkout_1.setActiveStep.type, checkoutStepUpdate), _defineProperty(_exports$checkoutEven, checkout_1.placeOrder.done.type, placeOrderComplete), _exports$checkoutEven);

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var download_1 = __webpack_require__(402);
var types_1 = __webpack_require__(102);
var downloadTrackEvent = function downloadTrackEvent(_ref) {
    var payload = _ref.payload;

    var track = payload.track;
    var label = track && track.title ? track.title : '';
    if (track.artist) {
        label = label + " by " + track.artist.name;
    }
    return {
        category: types_1.EventCategory.Download,
        event: types_1.ProductEvent.Download,
        action: types_1.ProductEvent.Download,
        label: label
    };
};
exports.downloadsEventsMap = _defineProperty({}, download_1.downloadTrack.type, downloadTrackEvent);

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$impressionsE;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var impressions_1 = __webpack_require__(617);
var player_1 = __webpack_require__(42);
var types_1 = __webpack_require__(102);
function productImpressionFromTrack(track) {
    return {
        id: track.internal_id,
        name: track.title,
        price: track.price ? track.price : undefined,
        brand: track.artist.name,
        category: 'License',
        list: window.location.pathname
    };
}
var trackImpressionEvent = function trackImpressionEvent(_ref) {
    var payload = _ref.payload;
    return {
        category: types_1.EventCategory.Impression,
        event: types_1.ProductEvent.Impression,
        action: 'show-track',
        label: "" + payload.track.internal_id,
        ecommerce: {
            impressions: [productImpressionFromTrack(payload.track)]
        }
    };
};
// Given that playing a track is the most important track "detail" a user can "view"
// that leads to its purchase, we use track play events to record "product details" views
var playTrackEvent = function playTrackEvent(_, __, _ref2) {
    var player = _ref2.player;

    var track = player.currentTrack.trackInfo;
    return {
        category: types_1.EventCategory.Impression,
        event: types_1.ProductEvent.Details,
        action: 'play-track',
        label: "" + track.internal_id,
        ecommerce: {
            actionField: { list: window.location.pathname },
            detail: {
                products: [productImpressionFromTrack(track)]
            }
        }
    };
};
exports.impressionsEventsMap = (_exports$impressionsE = {}, _defineProperty(_exports$impressionsE, impressions_1.trackImpression.type, trackImpressionEvent), _defineProperty(_exports$impressionsE, player_1.playTrackFromQueue.type, playTrackEvent), _exports$impressionsE);

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = __webpack_require__(161);
var types_1 = __webpack_require__(102);
var setLicenseEvent = function setLicenseEvent(_ref) {
    var payload = _ref.payload;

    var label = payload;
    return {
        category: types_1.EventCategory.Licensing,
        event: types_1.LicensingEvent.SetLicense,
        action: types_1.LicensingEvent.SetLicense,
        label: label
    };
};
exports.licensingEventsMap = _defineProperty({}, analytics_1.setLicense.type, setLicenseEvent);

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exports$searchEvents;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = __webpack_require__(161);
var types_1 = __webpack_require__(102);
var trackSearch = function trackSearch(action) {
    return {
        category: types_1.EventCategory.Search,
        event: types_1.SearchEvent.Search,
        action: 'set-search-state',
        label: JSON.stringify(action)
    };
};
var trackSimilaritySearch = function trackSimilaritySearch(action) {
    return {
        category: types_1.EventCategory.Search,
        event: types_1.SearchEvent.SimilaritySearch,
        action: 'click',
        track_id: action.payload.trackId,
        action_source: action.payload.actionSource
    };
};
exports.searchEventsMap = (_exports$searchEvents = {}, _defineProperty(_exports$searchEvents, analytics_1.setSearch.type, trackSearch), _defineProperty(_exports$searchEvents, analytics_1.similaritySearch.type, trackSimilaritySearch), _exports$searchEvents);

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Config Redux Reducer
 */

Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = __webpack_require__(1361);
var action = __webpack_require__(403);
var amazon_cognito_identity_js_1 = __webpack_require__(680);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var initialState = {
    facebookLoginUrl: '',
    googleLoginUrl: '',
    logoutUrl: '',
    userPool: null
};
var setAuthenticationConfigHandler = function setAuthenticationConfigHandler(state, _ref) {
    var client_id = _ref.client_id,
        cognito_domain_url = _ref.cognito_domain_url,
        user_pool_id = _ref.user_pool_id;

    var baseFederatedLoginUrl = authentication_1.compileFederatedLoginUrl({ client_id: client_id, cognito_domain_url: cognito_domain_url });
    return {
        facebookLoginUrl: baseFederatedLoginUrl + "&identity_provider=Facebook",
        googleLoginUrl: baseFederatedLoginUrl + "&identity_provider=Google",
        logoutUrl: authentication_1.compileLogoutUrl({ client_id: client_id, cognito_domain_url: cognito_domain_url }),
        userPool: new amazon_cognito_identity_js_1.CognitoUserPool({ ClientId: client_id, UserPoolId: user_pool_id })
    };
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(action.setAuthenticationConfig, setAuthenticationConfigHandler);

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var lodash_1 = __webpack_require__(6);
var Login_1 = __webpack_require__(152);
var Logout_1 = __webpack_require__(679);
var loginRedirectUrl = encodeURIComponent("https://" + location.hostname + Login_1.LoginPagePath);
var logoutRedirectUrl = encodeURIComponent("https://" + location.hostname + Logout_1.LogoutPagePath);
var scope = encodeURIComponent('email profile openid phone');
exports.compileFederatedLoginUrl = lodash_1.template("https://<%= cognito_domain_url %>/oauth2/authorize?redirect_uri=" + loginRedirectUrl + "&response_type=token&client_id=<%= client_id %>&scope=" + scope);
exports.compileLogoutUrl = lodash_1.template("https://<%= cognito_domain_url %>" + Logout_1.LogoutPagePath + "?logout_uri=" + logoutRedirectUrl + "&client_id=<%= client_id %>");

/***/ }),
/* 1362 */,
/* 1363 */,
/* 1364 */
/***/ (function(module, exports) {

module.exports = {"pageTitles":{"default":"Find & License Music | Bopper","template":"%s | Bopper","artistAndTrackTemplate":"${entity} on Bopper | Music Licensing"},"metaDescriptions":{"default":"License music instantly from trendy recording artists. Search by Mood, Genre, Lyrics, and more.","artistDefaultTemplate":"${artist} is licensing his music through Bopper, a premium marketplace for pre-cleared music to license for ads & brand content. Curated by industry veterans, instant pricing, immediate licensing."},"inputs":{"email":"Email address","password":"Password"},"errors":{"genericMessage":"Something went wrong! Please try again later.","login":{"credentials":"Incorrect email or password.","userNotFound":"We did not find an account for the given email. Try to sign up instead?","mutationError":"We were unable to sign you in. Please check your Internet connection and try again later."},"signup":{"alreadyExists":"An account with the given email already exists. Try to log in instead?","default":"Something wrong happened while signing you up. Please try again later.","invalidPassword":"${passwordPolicy}"}},"validations":{"email":"Invalid email","password":"Password must have at least 8 characters and contain at least one capital letter and one number.","required":"Required","date":"That is not a valid date"},"login":{"action":"Log In","actionQuestion":"Already have an account?","facebookLabel":"Facebook","googleLabel":"Google","intro":{"title":"Welcome back!","text":""},"methodsTitle":"Or continue with:","userPasswordMethodTitle":"","successMessage":"Good to see you ${first_name}!"},"logout":{"successMessage":"You were successfully logged&nbsp;out!"},"signup":{"action":"Sign Up","actionQuestion":"Don't have an account?","facebookLabel":"Facebook","googleLabel":"Google","intro":{"default":{"title":"<b>Download&nbspMusic</b><br /><b>Create&nbsp;&amp;&nbsp;Share</b>&nbspPlaylists<br />Get&nbsp;our&nbsp;<b>Staff&nbsp;Picks</b>","text":"No credit card needed."},"download":{"title":"Create an account and download any track.","text":""},"checkout":{"title":"You're almost done!<br />Sign up to checkout.","text":"With your free account, you can also download tracks and create playlists."}},"methodsTitle":"Or sign up with:","userPasswordMethodTitle":"","successMessage":"Welcome, thanks for signing up for Bopper!"},"search":{"placeholder":"Search for lyrics, artists, genres, moods, instruments, and more..."}}

/***/ }),
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash c60b71c5eb23c3d3f4936c7a1649106f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type login_viewer$ref = any;
export type login_QueryVariables = {| |};
export type login_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: login_viewer$ref,
  |},
|};
*/

/*
query login_Query {
  viewer {
    ...login_viewer
    id
  }
}

fragment login_viewer on Viewer {
  id
  authentication_info {
    user_pool_id
    client_id
    cognito_domain_url
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, v0];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "login_Query",
    "id": null,
    "text": "query login_Query {\n  viewer {\n    ...login_viewer\n    id\n  }\n}\n\nfragment login_viewer on Viewer {\n  id\n  authentication_info {\n    user_pool_id\n    client_id\n    cognito_domain_url\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "login_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "login_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "login_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [v0, {
          "kind": "LinkedField",
          "alias": null,
          "name": "authentication_info",
          "storageKey": null,
          "args": null,
          "concreteType": "AuthenticationInfo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "user_pool_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "client_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "cognito_domain_url",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "ga_account_goal_sent",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_provider",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_new_user",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "user_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v1
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v1
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v1
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '11ccea2f2b1f9329bcfcfa3a943ccf91';
module.exports = node;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type login_viewer$ref: FragmentReference;
export type login_viewer = {|
  +id: string,
  +authentication_info: ?{|
    +user_pool_id: string,
    +client_id: string,
    +cognito_domain_url: string,
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +$refType: login_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "login_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": null,
      "name": "authentication_info",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthenticationInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "user_pool_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "client_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "cognito_domain_url",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "ga_account_goal_sent",
        "args": null,
        "storageKey": null
      }, v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "external_provider",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_new_user",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "user_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "company_size",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanySize",
        "plural": false,
        "selections": v1
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "industry",
        "storageKey": null,
        "args": null,
        "concreteType": "Industry",
        "plural": false,
        "selections": v1
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "job_type",
        "storageKey": null,
        "args": null,
        "concreteType": "JobType",
        "plural": false,
        "selections": v1
      }]
    }]
  };
}();
node /*: any*/.hash = '6b9fc556ac307d1a960dcfb76450b8ec';
module.exports = node;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash f9a095f0767f3e42b07e175dd0cc3f74
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type login_MutationVariables = {|
  input: {
    id_token: string,
    clientMutationId?: ?string,
  },
|};
export type login_MutationResponse = {|
  +login: ?{|
    +profile: ?{|
      +id: string,
      +user_id: string,
      +email: ?string,
      +external_provider: ?string,
      +first_name: ?string,
      +is_new_user: boolean,
      +ga_account_goal_sent: boolean,
      +last_name: ?string,
      +picture: ?string,
      +company_name: ?string,
      +company_size: ?{|
        +name: ?string,
      |},
      +industry: ?{|
        +name: ?string,
      |},
      +job_type: ?{|
        +name: ?string,
      |},
    |},
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
      |}>,
    |},
  |},
|};
*/

/*
mutation login_Mutation(
  $input: LoginInput!
) {
  login(input: $input) {
    profile {
      id
      user_id
      email
      external_provider
      first_name
      is_new_user
      ga_account_goal_sent
      last_name
      picture
      company_name
      company_size {
        name
        id
      }
      industry {
        name
        id
      }
      job_type {
        name
        id
      }
    }
    cart {
      id
      license_line_items {
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LoginInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "LoginInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "ga_account_goal_sent",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "external_provider",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_new_user",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "picture",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_name",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v13 = [v12],
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "cart",
    "storageKey": null,
    "args": null,
    "concreteType": "Cart",
    "plural": false,
    "selections": [v3, {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseLineItem",
      "plural": true,
      "selections": [v3]
    }]
  },
      v15 = [v12, v3];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "login_Mutation",
    "id": null,
    "text": "mutation login_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    profile {\n      id\n      user_id\n      email\n      external_provider\n      first_name\n      is_new_user\n      ga_account_goal_sent\n      last_name\n      picture\n      company_name\n      company_size {\n        name\n        id\n      }\n      industry {\n        name\n        id\n      }\n      job_type {\n        name\n        id\n      }\n    }\n    cart {\n      id\n      license_line_items {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "login_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "login",
        "storageKey": null,
        "args": v1,
        "concreteType": "LoginPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v13
          }]
        }, v14]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "login_Mutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "login",
        "storageKey": null,
        "args": v1,
        "concreteType": "LoginPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v15
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v15
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v15
          }]
        }, v14]
      }]
    }
  };
}();
node /*: any*/.hash = 'dc91de9249b719734b5255792394d8ee';
module.exports = node;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1416);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--login{background-color:#f0f6fa}.page--login.is-callback .page__main{height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;padding:5vw 48px}@media screen and (min-width:1280px){.page--login.is-callback .page__main{padding:20vw 96px}}.page--login.is-callback h1{color:#b1b8c4}.login-page__illustration{position:fixed;top:0;left:0;height:100%;width:65%;min-width:calc(100% - 520px);max-width:calc(100% - 400px);overflow:hidden;background-image:url(https://orpheus-assets.s3.amazonaws.com/images/artists-mosaic-2.jpg);background-size:cover}.login-page__form.drawer{position:relative;top:auto;right:auto;bottom:auto;left:auto;max-width:520px;min-width:400px;min-height:100vh;width:35%;height:auto;-webkit-box-shadow:none;box-shadow:none;border:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.login-page__form.drawer .drawer__content{padding:15vh 0;max-width:360px;min-width:360px}@media screen and (min-width:1280px){.login-page__form.drawer .heading{font-size:2em}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Login/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA8GA,aCrCI,wBAzDuB,CD8F3B,qCAKM,aAAa,oBACb,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,kBACD,gBEpFyB,CF0F5C,qCAfL,qCAaQ,iBExFyC,CF0F5C,CAfL,4BC7BI,aAxEuB,CDwHtB,0BGvFH,eHiGyB,MAAG,OAAY,YACG,UAAL,6BACQ,6BACA,gBAC5B,0FAC4E,qBACtE,CACvB,yBGxGD,kBH2G4B,SAAM,WAAA,YAAA,UAAA,gBAEhC,gBACA,iBAAiB,UAlBD,YAoBJ,wBACZ,gBAAgB,SACP,yBACT,sBAAA,kBAAmB,CATpB,0CI7CC,eJ0DE,gBACA,eE/H2C,CFgI5C,qCAfF,kCAmBK,aAAc,CACf,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Login Page Component\n */\n\n@import \"../../../atoms/text/Heading/mixins\";\n\n.page--login{\n  @include bgcolor(bw3);\n\n  &.is-callback{\n    .page__main{\n      height: 100vh;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n      padding: 5vw baseline(6);\n\n      @include media(breakpoint(desktop-l)) {\n        padding: 20vw baseline(12);\n      }\n    }\n\n    h1{\n      @include textcolor(bw6);\n    }\n  }\n}\n\n.login-page{\n  $drawer-width: 35%;\n  $drawer-min-width: baseline(50);\n  $drawer-max-width: baseline(65);\n\n  &__illustration{\n    @include position(fixed, 0 null null 0);\n    @include size((100% - $drawer-width) 100%);\n    min-width: calc(100% - #{$drawer-max-width});\n    max-width: calc(100% - #{$drawer-min-width});\n    overflow: hidden;\n    background-image: url(\"https://orpheus-assets.s3.amazonaws.com/images/artists-mosaic-2.jpg\");\n    background-size: cover;\n  }\n\n  &__form.drawer{\n    @include position(relative, auto);\n    max-width: $drawer-max-width;\n    min-width: $drawer-min-width;\n    min-height: 100vh;\n    width: $drawer-width;\n    height: auto;\n    box-shadow: none;\n    border: 0;\n    align-items: center;\n\n    .drawer__content{\n      @include padding(15vh baseline(0));\n      max-width: baseline(45);\n      min-width: baseline(45);\n    }\n\n    @include media(breakpoint(desktop-l)) {\n      .heading{\n        font-size: 2em;\n      }\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1421);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.email-password-form{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}.email-password-form>*{-webkit-box-flex:0;-ms-flex:none;flex:none}.email-password-form .loading-button{margin-top:16px}.email-password-form .loading-button .button{width:100%}.email-password-form__opposite-action{margin:16px auto 0;text-align:center}.email-password-form__opposite-action>*{vertical-align:middle}.email-password-form__opposite-action__question{margin-right:8px}.email-password-form__forget-password-button.button{margin-bottom:16px;display:block}.login-drawer{min-width:392px}.login-drawer__intro{padding:32px 16px 8px}.login-drawer__intro h4{font-size:1.5em}.login-drawer__intro .heading{margin-right:auto;margin-left:auto;font-size:1.8em;font-weight:300}.login-drawer__intro .heading b{font-weight:900}.login-drawer__intro p{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34;margin:0 auto;text-align:center}@media print{.login-drawer__intro p{font-size:.6770833331em}}.login-drawer__intro p em,.login-drawer__intro p i{font-weight:300}.login-drawer__intro p b,.login-drawer__intro p strong{font-weight:700}.login-drawer .drawer__header{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:8px;margin-bottom:8px}.login-drawer .drawer__header button{margin-left:0;margin-right:8px}.login-drawer .drawer__content-group{padding-top:0}.login-drawer .drawer__button-list,.login-drawer .drawer__content-group{border:0;text-align:center}.login-drawer .drawer__button-list:before,.login-drawer .drawer__content-group:before{left:0}.login-drawer .drawer__content{padding:15vh 24px;width:100%;overflow:auto}.login-drawer .drawer__button-list+.drawer__content-group,.login-drawer .drawer__content-group+.drawer__button-list{margin-top:72px}.login-drawer .drawer__button-list{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.login-drawer .drawer__button-list__button{margin-right:2px;margin-left:2px;background-color:#f0f6fa;border-radius:4px;-webkit-box-shadow:none;box-shadow:none;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.login-drawer__methods .drawer__button-list__button .label{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.9375em;line-height:1.0667;margin-left:4px}.login-drawer__methods .drawer__button-list__button:hover{color:#4487ff}.login-drawer__methods .icon--external-link{position:absolute;top:50%;right:8px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);opacity:.2}.login-drawer__methods .icon--social{width:28px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/AuthenticationDrawer/_email-password-form.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/AuthenticationDrawer/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,qBC7CtE,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,UACX,CAHb,uBAMI,mBAAA,cAAA,SAAU,CANd,qCAUI,eCqB6C,CD/BjD,6CAcI,UAAW,CACZ,sCAGC,mBAA0B,iBACR,CAFnB,wCAKG,qBAAsB,CACvB,gDAGC,gBCK2C,CDJ5C,oDAID,mBACA,aAAc,CACf,cE4ED,eD9E+C,CCgF/C,qBACE,qBDjF6C,CCgF9C,wBAIG,eAAgB,CAJnB,8BC1BuB,kBDkCK,iBAAA,gBACT,eACA,CAVnB,gCAYK,eAAgB,CAZrB,uBDvCC,mCAJqC,kCAKH,aG/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,iBFuHhB,cAAc,iBACI,CACnB,aArBF,uBE1DO,uBAA0B,CF+E/B,CArBF,mDEhDG,eAAgB,CFgDnB,uDExCG,eAAgB,CFoCtB,8BA8BI,yBAAA,sBAAA,8BAA8B,eD1Ge,iBAAA,CC4EjD,qCAkCM,cAAc,gBD9G6B,CC4EjD,qCA0CI,aAAc,CA1ClB,wEA+CI,SAAS,iBACS,CAhDtB,sFAqDI,MAAO,CArDX,+BCRI,kBFpE6C,WCsIlC,aACG,CA3DlB,oHAgEI,eD5I6C,CC4EjD,mCAoEI,8BAAA,6BAAA,uBAAA,kBAAmB,CApEvB,2CCtB0B,iBFtDuB,gBAAA,yBInBtB,kBHyKrB,wBAAA,gBAAgB,mBAChB,cAAA,SAAU,CACX,2DAMG,mEACA,kBAAkB,mBACC,eDhKsB,CC2J9C,0DG7GC,aAnEuB,CHgLxB,4CIpJD,kBJmK8B,QAAK,UD1KY,mCC2K3C,+BAAA,2BAA2B,UAChB,CAjBd,qCAqBG,UDhL2C,CCiL5C","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n * Email and Password Form Component\n */\n\n.email-password-form{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  > * {\n    flex: none;\n  }\n\n  .loading-button{\n    margin-top: baseline(2);\n  }\n\n  .loading-button .button{\n    width: 100%;\n  }\n\n  &__opposite-action{\n    margin: baseline(2) auto 0;\n    text-align: center;\n\n    > * {\n      vertical-align: middle;\n    }\n\n    &__question{\n      margin-right: baseline(1);\n    }\n  }\n\n  &__forget-password-button.button{\n    margin-bottom: baseline(2);\n    display: block;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Log In Drawer Component\n */\n\n@import '../../../atoms/text/Label/mixins';\n@import './email-password-form';\n\n.login-drawer{\n\n  min-width: baseline(49);\n\n  &__intro{\n    padding: baseline(4) baseline(2) baseline(1);\n\n    h4{\n      font-size: 1.5em;\n    }\n\n    .heading{\n      @include margin(null auto);\n      font-size: 1.8em;\n      font-weight: 300;\n      b {\n        font-weight: 900;\n      }\n    }\n\n    p {\n      @include label;\n      @include label-size(medium);\n      margin: 0 auto;\n      text-align: center;\n    }\n\n  }\n\n  .drawer__header{\n    justify-content: space-between;\n\n    // > * { @include margin(null baseline(2)) }\n    button {\n      margin-left: 0;\n      margin-right: baseline(1);\n    }\n\n    @include margin(baseline(1) null);\n  }\n\n  .drawer__content-group{\n    padding-top: 0;\n  }\n\n  .drawer__button-list,\n  .drawer__content-group {\n    border: 0;\n    text-align: center;\n  }\n\n  .drawer__button-list:before,\n  .drawer__content-group:before{\n    left: 0;\n  }\n\n  .drawer__content{\n    @include padding(15vh baseline(3));\n    width: 100%;\n    overflow: auto;\n  }\n\n  .drawer__content-group + .drawer__button-list,\n  .drawer__button-list + .drawer__content-group {\n    margin-top: baseline(9);\n  }\n\n  .drawer__button-list{\n    flex-direction: row;\n\n    &__button{\n      @include margin(null baseline(.25));\n      @include bgcolor(bw3);\n      @include bgsize(medium);\n      box-shadow: none;\n      flex: auto;\n    }\n  }\n\n  &__methods{\n    .drawer__button-list__button{\n      .label{\n        font-family: $font--articulat;\n        font-size: .9375em;\n        line-height: 1.0667;\n        margin-left: baseline(.5);\n      }\n\n      &:hover{\n        @include textcolor(accent);\n      }\n    }\n\n    .icon--external-link{\n      @include position(absolute, 50% baseline(1) null null);\n      transform: translateY(-50%);\n      opacity: .2;\n    }\n\n    .icon--social{\n      width: baseline(3.5);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1423);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".form-error{background-color:#fff5f5;color:#f75b5b;border-radius:2px;border:1px solid;padding:8px 12px;top:-16px;-webkit-animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275);animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275)}.form-error .label{display:block}@-webkit-keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(20%);transform:translateY(20%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(20%);transform:translateY(20%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/FormError/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AA4GA,YCnCI,yBAvDoB,cADE,kBDgGxB,iBAAiB,iBAEjB,UAEA,0EAAA,iEE7F2D,CFoF7D,mBAYI,aAAc,CACf,oCAGC,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAP5B,4BACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FormError Component\n */\n\n.form-error{\n  @include bgcolor(dangerous-subtle);\n  @include textcolor(dangerous);\n  @include bgsize(small);\n\n  border: 1px solid;\n  padding: baseline(1) baseline(1.5);\n  top: baseline(-2);\n\n  animation: show-label-error .25s $ease-out-back;\n\n  .label{\n    display: block;\n  }\n\n  @keyframes show-label-error {\n    0% {\n      opacity: 0;\n      transform: translateY(20%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1425);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.textfield{padding:1px}.textfield--small .textfield__background{border-radius:4px;height:36px}.textfield--small .textfield__input{padding-top:9px;padding-bottom:10px;padding-left:12px;width:100%;height:34px;font-size:.8125em}.textfield--small.textfield--is-readonly .textfield__input{font-size:.9479166694em}.textfield--small .textfield__inline-button{right:4px;bottom:4px;height:28px}.textfield--medium .textfield__background{border-radius:4px;height:40px}.textfield--medium .textfield__input{padding-top:11px;padding-bottom:12px;padding-left:12px;width:100%;height:38px;font-size:.8125em}.textfield--medium.textfield--is-readonly .textfield__input{font-size:.9479166694em}.textfield--medium .textfield__inline-button{right:4px;bottom:4px;height:32px}.textfield--large .textfield__background{border-radius:4px;height:56px}.textfield--large .textfield__input{padding-top:19px;padding-bottom:20px;padding-left:24px;width:100%;height:54px;font-size:.875em}.textfield--large.textfield--is-readonly .textfield__input{font-size:1.0208333362em}.textfield--large .textfield__inline-button{right:4px;bottom:4px;height:48px}.textfield--xlarge .textfield__background{border-radius:4px;height:56px}.textfield--xlarge .textfield__input{padding-top:7px;padding-bottom:8px;padding-left:16px;width:100%;height:54px;font-size:.875em}.textfield--xlarge.textfield--is-readonly .textfield__input{font-size:1.0208333362em}.textfield--xlarge .textfield__inline-button{right:4px;bottom:4px;height:48px}.textfield__background{position:absolute;right:0;bottom:0;left:0;background-color:#f0f6fa}.textfield--is-disabled .textfield__background{background-color:#f9fafb}.textfield__input{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;border:0}.textfield__input::-webkit-input-placeholder{color:#b1b8c4}.textfield__input::-ms-input-placeholder{color:#b1b8c4}.textfield__input::placeholder{color:#b1b8c4}.textfield__input::-ms-clear{display:none}.textfield__input:focus{outline:0}.textfield__input:invalid{-webkit-box-shadow:none;box-shadow:none}.textfield__input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #f5faff inset;box-shadow:inset 0 0 0 1000px #f5faff}.textfield--is-disabled .textfield__input::-webkit-input-placeholder{color:rgba(177,184,196,.5)}.textfield--is-disabled .textfield__input::-ms-input-placeholder{color:rgba(177,184,196,.5)}.textfield--is-disabled .textfield__input::placeholder{color:rgba(177,184,196,.5)}.with--icon .textfield__input{padding-left:40px}.textfield--is-readonly .textfield__input{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif}.textfield__icon{position:absolute;left:8px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.textfield--error .textfield__icon{color:#f75b5b}.textfield--warning .textfield__icon{color:#4487ff}.textfield__inline-button{position:absolute}.textfield .label--error,.textfield .label--warning{position:absolute;top:95%;left:8px;border-radius:2px;max-width:calc(100% - 16px);padding:4px 8px 5px;border:1px solid;-webkit-box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);z-index:1;text-align:left;-webkit-animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards;animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards}@-webkit-keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}.textfield .label--warning{background-color:#f5faff;color:#4487ff}.textfield .label--error{background-color:#fff5f5;color:#f75b5b}.textfield-color-scheme--light .textfield__background{background-color:#f9fafb;border:1px solid #d2d9e1}.textfield-color-scheme--light.textfield--no-border .textfield__background{background-color:#f0f6fa}.textfield-color-scheme--light.textfield--is-disabled{color:#b1b8c4}.textfield-color-scheme--light.textfield--is-disabled .textfield__background{background-color:#fff;border-color:#e4e8ed}.textfield-color-scheme--light.textfield--is-focus .textfield__background{border-color:#4487ff}.textfield-color-scheme--white .textfield__background{background-color:#fff;border:1px solid #e4e8ed}.textfield-color-scheme--white.textfield--is-disabled{color:#b1b8c4}.textfield-color-scheme--white.textfield--is-disabled .textfield__background{background-color:#f9fafb;border-color:#e4e8ed}.textfield-color-scheme--white.textfield--is-focus .textfield__background{border-color:#4487ff}.textfield-color-scheme--transparent .textfield__background{background-color:transparent}.textfield-color-scheme--transparent.textfield--is-disabled{color:#b1b8c4}.textfield--no-border .textfield__background{border-color:transparent}.textfield+.textfield{margin-top:16px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/forms/TextField/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/forms/TextField/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_fonts.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,WC+DtE,WAAY,CAIP,yCCpFD,kBAvBgB,WCyB2B,CFkF1C,oCGpDH,gBAA2B,oBAX6B,kBAgBxD,WAAW,YACmB,iBCxDZ,CJsGf,2DGxCH,uBAAkC,CHwC/B,4CGpCH,UACA,WAEA,WAAqD,CHiClD,0CCpFD,kBAvBgB,WCyB2B,CFkF1C,qCGpDH,iBAA2B,oBAX6B,kBAgBxD,WAAW,YACmB,iBCxDZ,CJsGf,4DGxCH,uBAAkC,CHwC/B,6CGpCH,UACA,WAEA,WAAqD,CHiClD,yCCpFD,kBAvBgB,WCyB2B,CFkF1C,oCGpDH,iBAA2B,oBAX6B,kBAgBxD,WAAW,YACmB,gBCpDb,CJkGd,2DGxCH,wBAAkC,CHwC/B,4CGpCH,UACA,WAEA,WAAqD,CHiClD,0CCpFD,kBAvBgB,WCyB2B,CFkF1C,qCGpDH,gBAA2B,mBAG3B,kBAEA,WAAW,YACmB,gBCpDb,CJkGd,4DGxCH,wBAAkC,CHwC/B,6CGpCH,UACA,WAEA,WAAqD,CHuCvD,uBKjFA,kBLkF4B,QAAQ,SAAE,OAAE,wBM5Gf,CN+GvB,+CMtDA,wBA5DsB,CNoHrB,kBErDD,mCAJqC,kCAKH,aE/BvB,8CACb,yCAAA,sCJuFE,QAAS,CAFV,6CMnDC,aAxEuB,CN2HxB,yCMnDC,aAxEuB,CN2HxB,+BMnDC,aAxEuB,CN2HxB,6BASG,YAAa,CAThB,wBAaG,SAAU,CAbb,0BAiBG,wBAAA,eAAgB,CAjBnB,mCAqBG,8CAAA,qCAAqD,CACtD,qEAGC,0BAAqC,CADvC,iEACE,0BAAqC,CADvC,uDACE,0BAAqC,CACtC,8BAGC,iBE9H2C,CF+H5C,0CAGC,kEOjK0E,CPkK3E,iBK5HH,kBLgI4B,SAC1B,QAAQ,mCACR,+BAAA,0BAA2B,CAE3B,mCM7FA,aAhEsB,CN+JrB,qCM/FD,aAnEuB,CNqKtB,0BKzIH,iBL6I4B,CAxE9B,oDKrEE,kBLiJ4B,QAAK,SC1J7B,kBD4JF,4BAAsC,oBAEtC,iBAAiB,qDACjB,6CAA6D,UACnD,gBACM,mFAEhB,0EAAwD,CAExD,oCACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAP5B,4BACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CA9FhC,2BMtCI,yBA1DsB,aADC,CNiG3B,yBMtCI,yBAvDoB,aADE,CNyMvB,sDMjJC,yBNwJE,wBMvNiB,CNoNpB,2EMrJC,wBAzDuB,CN8MxB,sDM7IC,aAxEuB,CNqNxB,6EMrJC,sBNmKI,oBMjOmB,CNmNxB,0EAmBK,oBMnOmB,CNoOpB,sDMzKH,sBN+KE,wBM7OqB,CN0OxB,sDMpKC,aAxEuB,CN4OxB,6EM5KC,yBNqLI,oBMnPmB,CN0OxB,0EAcK,oBMrPmB,CNsPpB,4DM3LH,4BA7BsB,CN2NvB,4DMtLC,aAxEuB,CNoQtB,6CAKH,wBAAyB,CAC1B,sBAGC,eEnP+C,CFoPhD","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * TextField Component\n */\n\n@import '../../text/Label/mixins';\n@import './mixins';\n\n.textfield{\n  $padding: 2;\n  padding: 1px; // Adjustment for borders\n\n  @each $textfield-size, $options in $textfield-sizes {\n    @if $textfield-size != default {\n      &--#{$textfield-size} {\n        @include textfield-for-size(map-merge($options, (size: $textfield-size)));\n      }\n    }\n  }\n\n  &__background{\n    @include position(absolute, null 0 0 0);\n    @include bgcolor(bw3);\n\n    .textfield--is-disabled & {\n      @include bgcolor(bw2);\n    }\n  }\n\n  &__input{\n    @include label;\n    border: 0;\n\n    &::placeholder{\n      @include textcolor(bw6);\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &:focus{\n      outline: 0;\n    }\n\n    &:invalid {\n      box-shadow: none;\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0px 1000px color(accent-subtle) inset;\n    }\n\n    .textfield--is-disabled &::placeholder{\n      color: transparentize(color(bw6), .5);\n    }\n\n    .with--icon & {\n      padding-left: baseline(5);\n    }\n\n    .textfield--is-readonly & {\n      font-family: $font--articulat;\n    }\n  }\n\n  &__icon{\n    @include position(absolute, 50% null nulll baseline($padding / 2));\n    top: 50%;\n    transform: translateY(-50%);\n\n    .textfield--error & {\n      @include textcolor(dangerous);\n    }\n    .textfield--warning & {\n      @include textcolor(accent);\n    }\n  }\n\n  &__inline-button{\n    @include position(absolute);\n  }\n\n  .label--error, .label--warning{\n    @include position(absolute, 95% null null baseline(1));\n    @include bgsize(small);\n    max-width: calc(100% - #{baseline(2)});\n    padding: baseline(.5) baseline(1) baseline(.625);\n    border: 1px solid;\n    box-shadow: -1px 1px 4px transparentize(uicolor(shadow), .75);\n    z-index: 1;\n    text-align: left;\n\n    animation: show-label-error .25s $ease-out-back forwards;\n\n    @keyframes show-label-error {\n      0% {\n        opacity: 0;\n        transform: translateY(50%);\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .label--warning{\n    @include bgcolor(accent-subtle);\n    @include textcolor(accent);\n  }\n\n  .label--error{\n    @include bgcolor(dangerous-subtle);\n    @include textcolor(dangerous);\n  }\n}\n\n.textfield-color-scheme{\n  &--light{\n    .textfield__background{\n      @include bgcolor(bw2);\n      border: 1px solid color(bw5);\n    }\n    &.textfield--no-border{\n      .textfield__background{\n        @include bgcolor(bw3);\n      }\n    }\n    &.textfield--is-disabled{\n      @include textcolor(bw6);\n      .textfield__background{\n        @include bgcolor(white);\n        border-color: uicolor(border);\n      }\n    }\n    &.textfield--is-focus {\n      .textfield__background{\n        border-color: color(accent);\n      }\n    }\n  }\n  &--white{\n    .textfield__background {\n      @include bgcolor(white);\n      border: 1px solid color(bw4);\n    }\n    &.textfield--is-disabled {\n      @include textcolor(bw6);\n      .textfield__background{\n        @include bgcolor(bw2);\n        border-color: uicolor(border);\n      }\n    }\n    &.textfield--is-focus {\n      .textfield__background{\n        border-color: color(accent);\n      }\n    }\n  }\n  &--transparent{\n    .textfield__background {\n      @include bgcolor(transparent);\n    }\n    &.textfield--is-disabled {\n      @include textcolor(bw6);\n    }\n  }\n}\n\n.textfield--no-border .textfield__background{\n  border-color: transparent;\n}\n\n.textfield + .textfield {\n  margin-top: baseline(2);\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * TextField Component\n */\n\n @import \"../../buttons/Button/mixins\";\n @import \"../../text/Label/mixins\";\n\n/* Definitions */\n$textfield-sizes: (\n  default: (\n    label: large,\n    h-padding: 2,\n    bg: medium,\n    button-size: small-medium,\n  ),\n  small: (\n    label: medium,\n    h-padding: 1.5,\n    height: 4.5,\n  ),\n  medium: (\n    label: medium,\n    h-padding: 1.5,\n    height: 5,\n  ),\n  large: (\n    h-padding: 3,\n    height: 7,\n    button-size: medium,\n  ),\n  xlarge: (\n    h-padding: 2,\n    v-padding: 1,\n    height: 7,\n  )\n);\n\n/* Mixins */\n$default-textfield-size-options: map-get($textfield-sizes, default);\n@mixin textfield-for-size($options) {\n  $options: map-merge($default-textfield-size-options, $options);\n  $height: map-get($options, height);\n  $h-padding: map-get($options, h-padding);\n  $label: map-get($options, label);\n  $bg: map-get($options, bg);\n  $button-size: map-get($options, button-size);\n  $font-size: map-get(map-get($label-sizes, $label), 'font-size');\n\n  $computed-height: baseline($height);\n  $label-height: get-label-height($label);\n  $v-padding: map-get($options, v-padding);\n  $inline-button-margin: baseline(.5);\n\n  @if $v-padding == null {\n    $v-padding: ceil(($computed-height - $label-height) / 2);\n  } @else {\n    $v-padding: baseline($v-padding);\n  }\n\n  .textfield__background{\n    @include bgsize($bg);\n    height: baseline($height);\n  }\n\n  .textfield__input{\n    padding-top: $v-padding - 1;\n    // padding-right: baseline($h-padding);\n    padding-bottom: $v-padding;\n    padding-left: baseline($h-padding);\n\n    width: 100%;\n    height: $computed-height - 2px;\n\n    font-size: $font-size;\n  }\n\n  &.textfield--is-readonly .textfield__input {\n    font-size: $font-size * 1.16666667;\n  }\n\n  .textfield__inline-button{\n    right: $inline-button-margin;\n    bottom: $inline-button-margin;\n    // height: calc(100% - #{$inline-button-margin * 2});\n    height: baseline($height) - $inline-button-margin * 2;\n  }\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Fonts\n **/\n\n$font--articulat: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--space-mono: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--default: $font--articulat;\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1427);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".loading-button .button{display:block;margin:0 auto;-webkit-transition:.35s cubic-bezier(.6,-.28,.735,.045);-o-transition:.35s cubic-bezier(.6,-.28,.735,.045);transition:.35s cubic-bezier(.6,-.28,.735,.045)}.loading-button .button__wrapper{-webkit-transition:.25s ease-out;-o-transition:.25s ease-out;transition:.25s ease-out}.loading-button--is-loading .button{background-color:rgba(68,135,255,.1);-webkit-transform:scale(.7);-ms-transform:scale(.7);transform:scale(.7);border-radius:24px}.loading-button--is-loading .button__wrapper{opacity:0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/buttons/LoadingButton/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,wBAEI,cAAc,cACA,wDACd,mDAAA,+CCjGyD,CD6F7D,iCAQI,iCAAA,4BAAA,wBAAyB,CAC1B,oCAIG,qCAAmD,4BAEnD,wBAAA,oBAAoB,kBExFuB,CFoF9C,6CAQG,SAAU,CACX","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LoadingButton Component\n */\n\n.loading-button{\n  .button{\n    display: block;\n    margin: 0 auto;\n    transition: .35s $ease-in-back;\n  }\n\n  .button__wrapper{\n    transition: .25s ease-out;\n  }\n\n  &--is-loading{\n    .button{\n      background-color: transparentize(color(accent), .9);\n      // border-color: transparentize(color(accent), .8);\n      transform: scale(.7);\n      border-radius: baseline(3);\n    }\n    .button__wrapper{\n      opacity: 0;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LoadingIndicator Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1429);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_loaders_1 = __webpack_require__(1431);
var classes = new BEM('loading-indicator');
var LoadingIndicator = function LoadingIndicator(_ref) {
  var className = _ref.className;

  var extraClasses = classNames(className);
  return React.createElement("div", Object.assign({}, classes('', '', extraClasses)), React.createElement(react_loaders_1.default, { active: true, type: "ball-pulse" }));
};
exports.default = LoadingIndicator;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes scale{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);opacity:.7}80%{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes scale{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);opacity:.7}80%{-webkit-transform:scale(1);transform:scale(1);opacity:1}}.ball-pulse>div:nth-child(0){-webkit-animation:scale .75s -.36s infinite cubic-bezier(.2,.68,.18,1.08);animation:scale .75s -.36s infinite cubic-bezier(.2,.68,.18,1.08)}.ball-pulse>div:first-child{-webkit-animation:scale .75s -.24s infinite cubic-bezier(.2,.68,.18,1.08);animation:scale .75s -.24s infinite cubic-bezier(.2,.68,.18,1.08)}.ball-pulse>div:nth-child(2){-webkit-animation:scale .75s -.12s infinite cubic-bezier(.2,.68,.18,1.08);animation:scale .75s -.12s infinite cubic-bezier(.2,.68,.18,1.08)}.ball-pulse>div:nth-child(3){-webkit-animation:scale .75s 0s infinite cubic-bezier(.2,.68,.18,1.08);animation:scale .75s 0s infinite cubic-bezier(.2,.68,.18,1.08)}.ball-pulse>div{background-color:#fff;width:15px;height:15px;border-radius:100%;margin:2px;-webkit-animation-fill-mode:both;animation-fill-mode:both;display:inline-block}.loading-indicator{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.ball-pulse{display:-webkit-box;display:-ms-flexbox;display:flex}.ball-pulse>div{background-color:#4487ff;height:8px;width:8px;-webkit-box-flex:0;-ms-flex:none;flex:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/loaders.css/src/animations/ball-pulse.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/loaders.css/src/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/LoadingIndicator/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AAIA,yBACE,GACE,2BAAA,mBAAmB,SACT,CAAA,IAGV,4BAAA,oBAAqB,UACT,CAAA,IAGZ,2BAAA,mBAAmB,SACT,CAAA,CAXd,iBACE,GACE,2BAAA,mBAAmB,SACT,CAAA,IAGV,4BAAA,oBAAqB,UACT,CAAA,IAGZ,2BAAA,mBAAmB,SACT,CAAA,CAAA,6BAQR,0EAAA,iEAAkF,CADpF,4BACE,0EAAA,iEAAkF,CADpF,6BACE,0EAAA,iEAAkF,CADpF,6BACE,uEAAA,8DAAkF,CACnF,gBCvBH,sBAUA,WACA,YACA,mBAAmB,WARnB,iCAAA,yBD8BE,oBAAqB,CACtB,mBEMD,kBCqE0B,QAAK,SAAc,uCAC7C,mCAAA,8BAAgC,CACjC,YAGC,oBAAA,oBAAA,YAAa,CADf,gBC1CI,yBA3DuB,WCmCvB,UFwEA,mBAAA,cAAA,SAAU,CACX","file":"styles.scss","sourcesContent":["@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// mixins should be separated out\n@mixin ball-pulse($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: scale 0.75s delay(0.12s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.ball-pulse {\n  @include ball-pulse();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LoadingIndicator Component\n */\n\n@import \"ball-pulse\";\n\n.loading-indicator {\n  @include position(absolute, 50% null null 50%);\n  transform: translate(-50%, -50%);\n}\n\n.ball-pulse {\n  display: flex;\n\n  > div {\n    @include bgcolor(accent);\n    @include size(baseline(1));\n    flex: none;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1431 */,
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1433);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--forgotten-password .page__main{min-height:calc(100vh - 64px);width:90%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;max-width:640px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 auto;padding-bottom:64px}.page--forgotten-password form{width:320px;margin:0 auto}.page--forgotten-password .forgotten-password__title{margin-bottom:0}.page--forgotten-password .forgotten-password__subtitle{margin-bottom:32px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/ForgottenPassword/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,sCAvCE,8BAAyE,UA0C7D,oBACV,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,kBACJ,gBAElB,yBAAA,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,cACT,mBCnF+B,CDyEjD,+BAeI,YACA,aAAc,CAhBlB,qDAqBM,eAAgB,CArBtB,wDAwBM,kBCjG2C,CDkG5C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ForgottentPasswordPage Component\n */\n\n.page--forgotten-password{\n  .page__main{\n    @include page-is-at-least-full-height(-$page-header-height);\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    max-width: baseline(80);\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    padding-bottom: baseline(8);\n  }\n\n  form{\n    width: baseline(40);\n    margin: 0 auto;\n  }\n\n  .forgotten-password{\n    &__title{\n      margin-bottom: 0;\n    }\n    &__subtitle{\n      margin-bottom: baseline(4);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 7c170cae41d70417ea00acfe19538d70
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type profile_viewer$ref = any;
export type profile_QueryVariables = {| |};
export type profile_QueryResponse = {|
  +viewer: ?{|
    +id: string,
    +$fragmentRefs: profile_viewer$ref,
  |},
|};
*/

/*
query profile_Query {
  viewer {
    id
    ...profile_viewer
  }
}

fragment profile_viewer on Viewer {
  id
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, v0];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "profile_Query",
    "id": null,
    "text": "query profile_Query {\n  viewer {\n    id\n    ...profile_viewer\n  }\n}\n\nfragment profile_viewer on Viewer {\n  id\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "profile_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [v0, {
          "kind": "FragmentSpread",
          "name": "profile_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "profile_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [v0, {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "ga_account_goal_sent",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_provider",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_new_user",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "user_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v1
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v1
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v1
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = 'bd9b692fffd4cf29b6a035e04eaa181e';
module.exports = node;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type profile$ref: FragmentReference;
export type profile = {|
  +id: string,
  +user_id: string,
  +email: ?string,
  +external_provider: ?string,
  +first_name: ?string,
  +is_new_user: boolean,
  +ga_account_goal_sent: boolean,
  +last_name: ?string,
  +picture: ?string,
  +company_name: ?string,
  +company_size: ?{|
    +name: ?string,
  |},
  +industry: ?{|
    +name: ?string,
  |},
  +job_type: ?{|
    +name: ?string,
  |},
  +$refType: profile$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "profile",
    "type": "Profile",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "ga_account_goal_sent",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "external_provider",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "is_new_user",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "user_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "picture",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "company_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "company_size",
      "storageKey": null,
      "args": null,
      "concreteType": "CompanySize",
      "plural": false,
      "selections": v0
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "industry",
      "storageKey": null,
      "args": null,
      "concreteType": "Industry",
      "plural": false,
      "selections": v0
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "job_type",
      "storageKey": null,
      "args": null,
      "concreteType": "JobType",
      "plural": false,
      "selections": v0
    }]
  };
}();
node /*: any*/.hash = '4d76d55762729bc24eca1e17332a0efd';
module.exports = node;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type profile_viewer$ref: FragmentReference;
export type profile_viewer = {|
  +id: string,
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +$refType: profile_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "profile_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "ga_account_goal_sent",
        "args": null,
        "storageKey": null
      }, v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "external_provider",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_new_user",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "user_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "company_size",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanySize",
        "plural": false,
        "selections": v1
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "industry",
        "storageKey": null,
        "args": null,
        "concreteType": "Industry",
        "plural": false,
        "selections": v1
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "job_type",
        "storageKey": null,
        "args": null,
        "concreteType": "JobType",
        "plural": false,
        "selections": v1
      }]
    }]
  };
}();
node /*: any*/.hash = '944596e5a3114cb4e8486d2e03652e6d';
module.exports = node;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash d440e35c46bc309cee4a96db09ab3f02
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type profile_MutationVariables = {|
  profileInput: {
    first_name?: ?string,
    last_name?: ?string,
    email?: ?string,
    phone?: ?string,
    job_type_id?: ?string,
    company_size_id?: ?string,
    company_name?: ?string,
    industry_id?: ?string,
    opt_in_to_newsletter?: ?boolean,
    is_new_user?: ?boolean,
    ga_account_goal_sent?: ?boolean,
    clientMutationId?: ?string,
  },
|};
export type profile_MutationResponse = {|
  +updateProfile: ?{|
    +profile: ?{|
      +id: string,
      +user_id: string,
      +email: ?string,
      +external_provider: ?string,
      +first_name: ?string,
      +is_new_user: boolean,
      +ga_account_goal_sent: boolean,
      +last_name: ?string,
      +picture: ?string,
      +company_name: ?string,
      +company_size: ?{|
        +name: ?string,
      |},
      +industry: ?{|
        +name: ?string,
      |},
      +job_type: ?{|
        +name: ?string,
      |},
    |},
  |},
|};
*/

/*
mutation profile_Mutation(
  $profileInput: UpdateProfileInput!
) {
  updateProfile(input: $profileInput) {
    profile {
      id
      user_id
      email
      external_provider
      first_name
      is_new_user
      ga_account_goal_sent
      last_name
      picture
      company_name
      company_size {
        name
        id
      }
      industry {
        name
        id
      }
      job_type {
        name
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "profileInput",
    "type": "UpdateProfileInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "profileInput",
    "type": "UpdateProfileInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "ga_account_goal_sent",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "external_provider",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_new_user",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "picture",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_name",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v13 = [v12],
      v14 = [v12, v3];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "profile_Mutation",
    "id": null,
    "text": "mutation profile_Mutation(\n  $profileInput: UpdateProfileInput!\n) {\n  updateProfile(input: $profileInput) {\n    profile {\n      id\n      user_id\n      email\n      external_provider\n      first_name\n      is_new_user\n      ga_account_goal_sent\n      last_name\n      picture\n      company_name\n      company_size {\n        name\n        id\n      }\n      industry {\n        name\n        id\n      }\n      job_type {\n        name\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "profile_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProfile",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProfilePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v13
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "profile_Mutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProfile",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProfilePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v14
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v14
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v14
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '6c36db606619d593bbb4d539bc0a64d7';
module.exports = node;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.dot-navigation{padding:56px 0}.dot-navigation__progress{position:absolute;top:0;right:0;left:0;color:#b1b8c4;text-align:center}.dot-navigation__dots{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dot-navigation__dot{height:8px;width:8px;background-color:#e4e8ed;border-radius:50%;margin:0 4px}.dot-navigation__dot--current{position:absolute;top:0;left:0;background-color:#101015;-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275) .15s;transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275) .15s;-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275) .15s;transition:transform .25s cubic-bezier(.175,.885,.32,1.275) .15s;transition:transform .25s cubic-bezier(.175,.885,.32,1.275) .15s,-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275) .15s;pointer-events:none}.dot-navigation__dot--current.position--2{-webkit-transform:translateX(16px);-ms-transform:translateX(16px);transform:translateX(16px)}.dot-navigation__dot--current.position--3{-webkit-transform:translateX(32px);-ms-transform:translateX(32px);transform:translateX(32px)}.dot-navigation__dot--current.position--4{-webkit-transform:translateX(48px);-ms-transform:translateX(48px);transform:translateX(48px)}.dot-navigation__dot--current.position--5{-webkit-transform:translateX(64px);-ms-transform:translateX(64px);transform:translateX(64px)}.dot-navigation--interactive .dot-navigation__dot{cursor:pointer}.page--account-registration{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:calc(100vh - 64px)}.page--account-registration .page__main{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.page--account-registration ul{margin:0;padding:0;list-style:none}.page--account-registration .signup-check{height:48px;width:48px;background-color:#75dbbe;color:#fff;border-radius:50%;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;margin-bottom:32px}.page--account-registration .signup-check .icon{position:absolute;top:50%;left:50%;width:80%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.page--account-registration .signup-check .icon svg{height:100%;width:100%;margin:0 auto}.account-registration__step{position:absolute;top:0;right:0;bottom:48px;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.account-registration__step__title{margin:0 auto 32px}.account-registration__step--user-name .input-message{height:24px}.account-registration__step--process-complete{left:calc(50% - 320px);right:calc(50% - 320px)}.account-registration__step--process-complete>:not(:first-child):not(:last-child){margin-bottom:32px}.account-registration__step-indicator{position:fixed;bottom:0;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}.account-registration__answer-button{margin:8px auto;background-color:transparent;border-color:transparent;display:block}.account-registration__answer-button .label{font-size:1.125em}.account-registration__answer-button:hover{background-color:#101015}.account-registration__textfield{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:2em;font-weight:300;line-height:1;margin:16px 0;border:0;width:100%;text-align:center}.account-registration__textfield .label{display:inline-block}@media screen and (min-width:600px){.account-registration__textfield{font-size:2.5em}}@media screen and (min-width:864px){.account-registration__textfield{font-size:3em}}@media screen and (min-width:1280px){.account-registration__textfield{font-size:4em}}@media print{.account-registration__textfield{font-size:3em}}.account-registration__textfield:focus{outline:none}.account-registration__textfield::-webkit-input-placeholder{color:#e4e8ed}.account-registration__textfield::-ms-input-placeholder{color:#e4e8ed}.account-registration__textfield::placeholder{color:#e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Registration/_dot-navigation.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Registration/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,gBC7CtE,cAAsB,CAEtB,0BCmCA,kBDlC4B,MAAG,QAAE,OAAO,cAEtC,iBAAkB,CACnB,sBAGC,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,kBAAmB,CACpB,qBE0BC,WAMA,UCwBA,yBA9DuB,kBHYvB,YIY6C,CJV7C,8BCiBF,kBDhB8B,MAAG,OAAY,yBAEzC,iFAAA,yEAAA,oEAAA,iEAAA,+HAA8C,mBAC1B,CAJrB,0CAMgB,mCAAA,+BAAA,0BAAkC,CANlD,0CAOgB,mCAAA,+BAAA,0BAAkC,CAPlD,0CAQgB,mCAAA,+BAAA,0BAAkC,CARlD,0CASgB,mCAAA,+BAAA,0BAAkC,CAAG,kDAKtD,cAAe,CAChB,4BKwED,oBAAA,oBAAA,aAAa,6BACkC,CAFjD,wCAKI,mBAAA,cAAA,SAAU,CALd,+BASI,SAAS,UACC,eACM,CAXpB,0CHpEI,YAMA,WCwBA,yBAtDoB,WAeV,kBGfQ,oCD+GlB,+BAAA,4BAA4B,kBD/FiB,CC4EjD,gDJrEE,kBAII,QAAA,SIwF6C,UACnC,uCACV,mCAAA,8BAAgC,CAzBtC,oDHpEI,YAMA,WG0FsB,aACJ,CACf,4BJnGL,kBAII,MAAA,QAAA,YAAA,OIsG2C,oBAC7C,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,iBACD,CAElB,mCACE,kBDzH2C,CC0H5C,sDAIG,WD9HyC,CC+H1C,8CAID,uBAAiC,uBACC,CAFnC,kFAKG,kBDvIyC,CCwI1C,sCJjIL,eAII,SAAA,SIkIsC,mCACxC,+BAAA,0BAA2B,CAC5B,qCE3EC,gBJ9BA,6BA7BsB,yBE2IG,aACX,CAJf,4CAMG,iBAAkB,CANrB,2CF3GC,wBArEsB,CE2LrB,iCDnHD,mCAJqC,kCAKH,mEIhEpC,8CAAA,yCAAA,sCAAsC,cASR,gBACd,cACF,cH6KZ,SAAS,WACE,iBACO,CALnB,wCGlLC,oBAAqB,CACtB,oCHiLD,iCGnKE,eAAgC,CHiLjC,CAAA,oCAdD,iCGhKE,aAA+B,CH8KhC,CAAA,qCAdD,iCG7JE,aAjBiB,CH4LlB,CAAA,aAdD,iCGzJE,aAA+B,CHuKhC,CAdA,uCAQG,YAAa,CARhB,4DFjHC,aAtEuB,CEuLxB,wDFjHC,aAtEuB,CEuLxB,8CFjHC,aAtEuB,CEoMtB","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n * Dot Navigation Component\n */\n\n.dot-navigation{\n  padding: baseline(7) 0;\n\n  &__progress{\n    @include position(absolute, 0 0 null 0);\n    @include textcolor(bw6);\n    text-align: center;\n  }\n\n  &__dots{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__dot{\n    @include size(baseline(1));\n    @include bgcolor(bw4);\n    @include bgsize(circle);\n    margin: 0 baseline(.5);\n\n    &--current{\n      @include position(absolute, 0 null null 0);\n      @include bgcolor(black);\n      transition: transform .25s $ease-out-back .15s;\n      pointer-events: none;\n\n      &.position--2{ transform: translateX(baseline(2)) }\n      &.position--3{ transform: translateX(baseline(4)) }\n      &.position--4{ transform: translateX(baseline(6)) }\n      &.position--5{ transform: translateX(baseline(8)) }\n    }\n  }\n\n  &--interactive &__dot{\n    cursor: pointer;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Account Registration Component\n */\n\n@import '../../../atoms/text/Heading/mixins';\n@import './dot-navigation';\n\n.page--account-registration{\n  display: flex;\n  min-height: calc(100vh - #{$app-header-height});\n\n  .page__main{\n    flex: auto;\n  }\n\n  ul{\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  .signup-check{\n    @include size(baseline(6));\n    @include bgcolor(positive);\n    @include textcolor(white);\n    @include bgsize(circle);\n    transition: .15s ease-in-out;\n    margin-bottom: baseline(4);\n\n    .icon{\n      @include position(absolute, 50% null null 50%);\n      width: 80%;\n      transform: translate(-50%, -50%);\n\n      svg{\n        @include size(100%);\n        margin: 0 auto;\n      }\n    }\n  }\n}\n\n.account-registration{\n  &__step{\n    @include position(absolute, 0 0 baseline(6) 0);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    &__title{\n      margin: 0 auto baseline(4);\n    }\n\n    &--user-name{\n      .input-message{\n        height: baseline(3);\n      }\n    }\n\n    &--process-complete{\n      left: calc(50% - #{baseline(40)});\n      right: calc(50% - #{baseline(40)});\n\n      > *:not(:first-child):not(:last-child) {\n        margin-bottom: baseline(4);\n      }\n    }\n  }\n\n  &__step-indicator{\n    @include position(fixed, null null 0 50%);\n    transform: translateX(-50%);\n  }\n\n  &__answer-button{\n    @include margin(baseline(1) auto);\n    @include bgcolor(transparent);\n    border-color: transparent;\n    display: block;\n    .label{\n      font-size: 1.125em;\n    }\n\n    &:hover{\n      @include bgcolor(black);\n    }\n  }\n\n  &__textfield{\n    @include base-heading;\n    @include h1;\n    border: 0;\n    width: 100%;\n    text-align: center;\n\n    &:focus{\n      outline: none;\n    }\n\n    &::placeholder{\n      @include textcolor(bw4);\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1440);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 2218ea071b61b5c6154a5359af85ca78
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type checkout_viewer$ref = any;
export type checkout_QueryVariables = {|
  country_code?: ?string,
  subdivision_code?: ?string,
|};
export type checkout_QueryResponse = {|
  +viewer: ?{|
    +stripe: ?{|
      +public_key: string,
    |},
    +$fragmentRefs: checkout_viewer$ref,
  |},
|};
*/

/*
query checkout_Query(
  $country_code: String
  $subdivision_code: String
) {
  viewer {
    ...checkout_viewer
    stripe {
      public_key
    }
    id
  }
}

fragment checkout_viewer on Viewer {
  checkout(country_code: $country_code, subdivision_code: $subdivision_code) {
    id
    currency_code
    currency_rate
    discount
    invoice_number
    order_date
    payment_due_date
    payment_received_date
    payment_status
    subtotal
    total
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    general_line_items {
      id
      description
      amount
      discount_amount
    }
    promo_code_line_item {
      id
      code
      discount_type
      discount_type_amount
    }
    tax_line_items {
      id
      priority
      tax_name
      rate
      amount
    }
    licensee_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    billing_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
    authorized_representative {
      name
      email
      phone
      role_id
      role {
        id
        name
      }
    }
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
  company_types {
    edges {
      node {
        id
        name
      }
    }
  }
  representative_roles {
    edges {
      node {
        id
        name
      }
    }
  }
  selected_currency
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "country_code",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "subdivision_code",
    "type": "String",
    "defaultValue": null
  }],
      v1 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "stripe",
    "storageKey": null,
    "args": null,
    "concreteType": "StripeSettings",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "public_key",
      "args": null,
      "storageKey": null
    }]
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v7, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v10 = [v2, v9],
      v11 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v2, v9, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v10
  }, v7, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v13 = [v9, v2];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "checkout_Query",
    "id": null,
    "text": "query checkout_Query(\n  $country_code: String\n  $subdivision_code: String\n) {\n  viewer {\n    ...checkout_viewer\n    stripe {\n      public_key\n    }\n    id\n  }\n}\n\nfragment checkout_viewer on Viewer {\n  checkout(country_code: $country_code, subdivision_code: $subdivision_code) {\n    id\n    currency_code\n    currency_rate\n    discount\n    invoice_number\n    order_date\n    payment_due_date\n    payment_received_date\n    payment_status\n    subtotal\n    total\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    general_line_items {\n      id\n      description\n      amount\n      discount_amount\n    }\n    promo_code_line_item {\n      id\n      code\n      discount_type\n      discount_type_amount\n    }\n    tax_line_items {\n      id\n      priority\n      tax_name\n      rate\n      amount\n    }\n    licensee_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    billing_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n    authorized_representative {\n      name\n      email\n      phone\n      role_id\n      role {\n        id\n        name\n      }\n    }\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n  company_types {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  representative_roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  selected_currency\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "checkout_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "checkout_viewer",
          "args": null
        }, v1]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "checkout_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "checkout",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "country_code",
            "variableName": "country_code",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "subdivision_code",
            "variableName": "subdivision_code",
            "type": "String"
          }],
          "concreteType": "Order",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "subtotal",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_rate",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "discount",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "invoice_number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "order_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_due_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_received_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseLineItem",
            "plural": true,
            "selections": [v2, v3, v4, {
              "kind": "LinkedField",
              "alias": null,
              "name": "track",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [v2, v5, {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              }, v6, v8, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [v2, v9, v6, v8]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [v2, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_highlighted",
                      "args": null,
                      "storageKey": null
                    }, v9, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "parent_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [v2, v5, v9]
                    }]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "license",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicense",
              "plural": false,
              "selections": [v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "usages",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicenseUsage",
                "plural": true,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "license_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "air_date",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "components",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsageComponent",
                  "plural": true,
                  "selections": [v2, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "component_id",
                    "args": null,
                    "storageKey": null
                  }, v9, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "general_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "GeneralLineItem",
            "plural": true,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            }, v3, v4]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "promo_code_line_item",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeLineItem",
            "plural": false,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_type",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_type_amount",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tax_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxLineItem",
            "plural": true,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "priority",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "tax_name",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "rate",
              "args": null,
              "storageKey": null
            }, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "licensee_address",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderAddress",
            "plural": false,
            "selections": v11
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "billing_address",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderAddress",
            "plural": false,
            "selections": v11
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "project_details",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectDetails",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "brand",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "product",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "reference",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "po_number",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "notes",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "authorized_representative",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthorizedRepresentative",
            "plural": false,
            "selections": [v9, v12, {
              "kind": "ScalarField",
              "alias": null,
              "name": "phone",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "role_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "role",
              "storageKey": null,
              "args": null,
              "concreteType": "RepresentativeRole",
              "plural": false,
              "selections": v10
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "ga_account_goal_sent",
            "args": null,
            "storageKey": null
          }, v2, v12, {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_provider",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_new_user",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "user_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v13
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v13
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "company_types",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyTypeConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanyTypeEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CompanyType",
              "plural": false,
              "selections": v10
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "representative_roles",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRoleConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "RepresentativeRoleEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "RepresentativeRole",
              "plural": false,
              "selections": v10
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency",
          "args": null,
          "storageKey": null
        }, v1, v2]
      }]
    }
  };
}();
node /*: any*/.hash = '2b5a7101fc895e0f8dc0b185dcc87421';
module.exports = node;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type checkout_viewer$ref: FragmentReference;
export type checkout_viewer = {|
  +checkout: ?{|
    +id: string,
    +currency_code: ?string,
    +currency_rate: ?number,
    +discount: ?number,
    +invoice_number: ?number,
    +order_date: ?any,
    +payment_due_date: ?any,
    +payment_received_date: ?any,
    +payment_status: ?OrderPaymentStatus,
    +subtotal: ?number,
    +total: ?number,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +general_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +description: ?string,
      +amount: ?number,
      +discount_amount: ?number,
    |}>,
    +promo_code_line_item: ?{|
      +id: string,
      +code: ?string,
      +discount_type: ?PromoCodeDiscountType,
      +discount_type_amount: ?number,
    |},
    +tax_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +priority: ?number,
      +tax_name: ?string,
      +rate: ?number,
      +amount: ?number,
    |}>,
    +licensee_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +billing_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +project_details: ?{|
      +brand: ?string,
      +product: ?string,
      +reference: ?string,
      +po_number: ?string,
      +notes: ?string,
    |},
    +authorized_representative: ?{|
      +name: ?string,
      +email: ?string,
      +phone: ?string,
      +role_id: ?string,
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
    |},
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +company_types: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +representative_roles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +selected_currency: ?Currency,
  +$refType: checkout_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v8 = [v0, v7],
      v9 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v0, v7, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v8
  }, v5, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }],
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v11 = [v7];
  return {
    "kind": "Fragment",
    "name": "checkout_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "country_code",
      "type": "String"
    }, {
      "kind": "RootArgument",
      "name": "subdivision_code",
      "type": "String"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "checkout",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "country_code",
        "variableName": "country_code",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "subdivision_code",
        "variableName": "subdivision_code",
        "type": "String"
      }],
      "concreteType": "Order",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "subtotal",
        "args": null,
        "storageKey": null
      }, v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_rate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoice_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "order_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_due_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_received_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v0, v1, v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v0, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v4, v6, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v0, v7, v4, v6]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v7, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v0, v3, v7]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v7, v5]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "general_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "GeneralLineItem",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, v1, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "promo_code_line_item",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeLineItem",
        "plural": false,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type_amount",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "tax_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxLineItem",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "priority",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tax_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate",
          "args": null,
          "storageKey": null
        }, v1]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "licensee_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v9
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "billing_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v9
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "project_details",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectDetails",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "product",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "reference",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "po_number",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorized_representative",
        "storageKey": null,
        "args": null,
        "concreteType": "AuthorizedRepresentative",
        "plural": false,
        "selections": [v7, v10, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "role",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v8
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "ga_account_goal_sent",
        "args": null,
        "storageKey": null
      }, v0, v10, {
        "kind": "ScalarField",
        "alias": null,
        "name": "external_provider",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_new_user",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "user_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "company_size",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanySize",
        "plural": false,
        "selections": v11
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "industry",
        "storageKey": null,
        "args": null,
        "concreteType": "Industry",
        "plural": false,
        "selections": v11
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "job_type",
        "storageKey": null,
        "args": null,
        "concreteType": "JobType",
        "plural": false,
        "selections": v11
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "company_types",
      "storageKey": null,
      "args": null,
      "concreteType": "CompanyTypeConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanyTypeEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyType",
          "plural": false,
          "selections": v8
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "representative_roles",
      "storageKey": null,
      "args": null,
      "concreteType": "RepresentativeRoleConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "RepresentativeRoleEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v8
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = 'af693b65b79c7991f3acf9c902a551b7';
module.exports = node;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 9027f8d1e7f5d2aea909536790937829
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type checkoutAttributes_viewer$ref = any;
export type checkoutAttributes_QueryVariables = {| |};
export type checkoutAttributes_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: checkoutAttributes_viewer$ref,
  |},
|};
*/

/*
query checkoutAttributes_Query {
  viewer {
    ...checkoutAttributes_viewer
    id
  }
}

fragment checkoutAttributes_viewer on Viewer {
  company_types {
    edges {
      node {
        id
        name
      }
    }
  }
  representative_roles {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [v0, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "checkoutAttributes_Query",
    "id": null,
    "text": "query checkoutAttributes_Query {\n  viewer {\n    ...checkoutAttributes_viewer\n    id\n  }\n}\n\nfragment checkoutAttributes_viewer on Viewer {\n  company_types {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  representative_roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "checkoutAttributes_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "checkoutAttributes_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "checkoutAttributes_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "company_types",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyTypeConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanyTypeEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CompanyType",
              "plural": false,
              "selections": v1
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "representative_roles",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRoleConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "RepresentativeRoleEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "RepresentativeRole",
              "plural": false,
              "selections": v1
            }]
          }]
        }, v0]
      }]
    }
  };
}();
node /*: any*/.hash = 'ff7d17e6ce4365c678dd5915825651b5';
module.exports = node;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type checkoutAttributes_viewer$ref: FragmentReference;
export type checkoutAttributes_viewer = {|
  +company_types: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +representative_roles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +$refType: checkoutAttributes_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "checkoutAttributes_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "company_types",
      "storageKey": null,
      "args": null,
      "concreteType": "CompanyTypeConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanyTypeEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyType",
          "plural": false,
          "selections": v0
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "representative_roles",
      "storageKey": null,
      "args": null,
      "concreteType": "RepresentativeRoleConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "RepresentativeRoleEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v0
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = 'f198b57ed81d47705f121d4c02dea55f';
module.exports = node;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 2ab9d3c646b33825067f1bc606827540
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
export type checkoutAddPromoCode_MutationVariables = {|
  input: {
    code: string,
    clientMutationId?: ?string,
  },
  country_code?: ?string,
  subdivision_code?: ?string,
|};
export type checkoutAddPromoCode_MutationResponse = {|
  +addPromoCode: ?{|
    +checkout: ?{|
      +id: string,
      +currency_code: ?string,
      +currency_rate: ?number,
      +discount: ?number,
      +invoice_number: ?number,
      +order_date: ?any,
      +payment_due_date: ?any,
      +payment_received_date: ?any,
      +payment_status: ?OrderPaymentStatus,
      +subtotal: ?number,
      +total: ?number,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +general_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +description: ?string,
        +amount: ?number,
        +discount_amount: ?number,
      |}>,
      +promo_code_line_item: ?{|
        +id: string,
        +code: ?string,
        +discount_type: ?PromoCodeDiscountType,
        +discount_type_amount: ?number,
      |},
      +tax_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +priority: ?number,
        +tax_name: ?string,
        +rate: ?number,
        +amount: ?number,
      |}>,
      +licensee_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +billing_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +project_details: ?{|
        +brand: ?string,
        +product: ?string,
        +reference: ?string,
        +po_number: ?string,
        +notes: ?string,
      |},
      +authorized_representative: ?{|
        +name: ?string,
        +email: ?string,
        +phone: ?string,
        +role_id: ?string,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
    |},
  |},
|};
*/

/*
mutation checkoutAddPromoCode_Mutation(
  $input: AddPromoCodeInput!
  $country_code: String
  $subdivision_code: String
) {
  addPromoCode(input: $input) {
    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {
      id
      currency_code
      currency_rate
      discount
      invoice_number
      order_date
      payment_due_date
      payment_received_date
      payment_status
      subtotal
      total
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      general_line_items {
        id
        description
        amount
        discount_amount
      }
      promo_code_line_item {
        id
        code
        discount_type
        discount_type_amount
      }
      tax_line_items {
        id
        priority
        tax_name
        rate
        amount
      }
      licensee_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      billing_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      project_details {
        brand
        product
        reference
        po_number
        notes
      }
      authorized_representative {
        name
        email
        phone
        role_id
        role {
          id
          name
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddPromoCodeInput!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "country_code",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "subdivision_code",
    "type": "String",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v6, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v9 = [v1, v8],
      v10 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v1, v8, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v9
  }, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }],
      v11 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addPromoCode",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddPromoCodeInput!"
    }],
    "concreteType": "AddPromoCodePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "checkout",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "country_code",
        "variableName": "country_code",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "subdivision_code",
        "variableName": "subdivision_code",
        "type": "String"
      }],
      "concreteType": "Order",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "subtotal",
        "args": null,
        "storageKey": null
      }, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_rate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoice_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "order_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_due_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_received_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, v2, v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v5, v7, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v8, v5, v7]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v4, v8]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v8, v6]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "general_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "GeneralLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, v2, v3]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "promo_code_line_item",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeLineItem",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type_amount",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "tax_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "priority",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tax_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "licensee_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "billing_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "project_details",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectDetails",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "product",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "reference",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "po_number",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorized_representative",
        "storageKey": null,
        "args": null,
        "concreteType": "AuthorizedRepresentative",
        "plural": false,
        "selections": [v8, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "role",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v9
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "checkoutAddPromoCode_Mutation",
    "id": null,
    "text": "mutation checkoutAddPromoCode_Mutation(\n  $input: AddPromoCodeInput!\n  $country_code: String\n  $subdivision_code: String\n) {\n  addPromoCode(input: $input) {\n    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {\n      id\n      currency_code\n      currency_rate\n      discount\n      invoice_number\n      order_date\n      payment_due_date\n      payment_received_date\n      payment_status\n      subtotal\n      total\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      general_line_items {\n        id\n        description\n        amount\n        discount_amount\n      }\n      promo_code_line_item {\n        id\n        code\n        discount_type\n        discount_type_amount\n      }\n      tax_line_items {\n        id\n        priority\n        tax_name\n        rate\n        amount\n      }\n      licensee_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      billing_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      project_details {\n        brand\n        product\n        reference\n        po_number\n        notes\n      }\n      authorized_representative {\n        name\n        email\n        phone\n        role_id\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "checkoutAddPromoCode_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v11
    },
    "operation": {
      "kind": "Operation",
      "name": "checkoutAddPromoCode_Mutation",
      "argumentDefinitions": v0,
      "selections": v11
    }
  };
}();
node /*: any*/.hash = '87c05da92c6bff5f40586aefc8932628';
module.exports = node;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 3d46af01314462810c7313a2744aae26
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
export type checkoutDeletePromoCode_MutationVariables = {|
  input: {
    clientMutationId?: ?string,
  },
  country_code?: ?string,
  subdivision_code?: ?string,
|};
export type checkoutDeletePromoCode_MutationResponse = {|
  +deletePromoCode: ?{|
    +checkout: ?{|
      +id: string,
      +currency_code: ?string,
      +currency_rate: ?number,
      +discount: ?number,
      +invoice_number: ?number,
      +order_date: ?any,
      +payment_due_date: ?any,
      +payment_received_date: ?any,
      +payment_status: ?OrderPaymentStatus,
      +subtotal: ?number,
      +total: ?number,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +general_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +description: ?string,
        +amount: ?number,
        +discount_amount: ?number,
      |}>,
      +promo_code_line_item: ?{|
        +id: string,
        +code: ?string,
        +discount_type: ?PromoCodeDiscountType,
        +discount_type_amount: ?number,
      |},
      +tax_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +priority: ?number,
        +tax_name: ?string,
        +rate: ?number,
        +amount: ?number,
      |}>,
      +licensee_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +billing_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +project_details: ?{|
        +brand: ?string,
        +product: ?string,
        +reference: ?string,
        +po_number: ?string,
        +notes: ?string,
      |},
      +authorized_representative: ?{|
        +name: ?string,
        +email: ?string,
        +phone: ?string,
        +role_id: ?string,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
    |},
  |},
|};
*/

/*
mutation checkoutDeletePromoCode_Mutation(
  $input: DeletePromoCodeInput!
  $country_code: String
  $subdivision_code: String
) {
  deletePromoCode(input: $input) {
    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {
      id
      currency_code
      currency_rate
      discount
      invoice_number
      order_date
      payment_due_date
      payment_received_date
      payment_status
      subtotal
      total
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      general_line_items {
        id
        description
        amount
        discount_amount
      }
      promo_code_line_item {
        id
        code
        discount_type
        discount_type_amount
      }
      tax_line_items {
        id
        priority
        tax_name
        rate
        amount
      }
      licensee_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      billing_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      project_details {
        brand
        product
        reference
        po_number
        notes
      }
      authorized_representative {
        name
        email
        phone
        role_id
        role {
          id
          name
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePromoCodeInput!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "country_code",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "subdivision_code",
    "type": "String",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v6, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v9 = [v1, v8],
      v10 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v1, v8, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v9
  }, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }],
      v11 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePromoCode",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePromoCodeInput!"
    }],
    "concreteType": "DeletePromoCodePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "checkout",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "country_code",
        "variableName": "country_code",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "subdivision_code",
        "variableName": "subdivision_code",
        "type": "String"
      }],
      "concreteType": "Order",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "subtotal",
        "args": null,
        "storageKey": null
      }, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_rate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoice_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "order_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_due_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_received_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, v2, v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v5, v7, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v8, v5, v7]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v4, v8]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v8, v6]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "general_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "GeneralLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, v2, v3]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "promo_code_line_item",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeLineItem",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type_amount",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "tax_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "priority",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tax_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "licensee_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "billing_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "project_details",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectDetails",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "product",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "reference",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "po_number",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorized_representative",
        "storageKey": null,
        "args": null,
        "concreteType": "AuthorizedRepresentative",
        "plural": false,
        "selections": [v8, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "role",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v9
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "checkoutDeletePromoCode_Mutation",
    "id": null,
    "text": "mutation checkoutDeletePromoCode_Mutation(\n  $input: DeletePromoCodeInput!\n  $country_code: String\n  $subdivision_code: String\n) {\n  deletePromoCode(input: $input) {\n    checkout(country_code: $country_code, subdivision_code: $subdivision_code) {\n      id\n      currency_code\n      currency_rate\n      discount\n      invoice_number\n      order_date\n      payment_due_date\n      payment_received_date\n      payment_status\n      subtotal\n      total\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      general_line_items {\n        id\n        description\n        amount\n        discount_amount\n      }\n      promo_code_line_item {\n        id\n        code\n        discount_type\n        discount_type_amount\n      }\n      tax_line_items {\n        id\n        priority\n        tax_name\n        rate\n        amount\n      }\n      licensee_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      billing_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      project_details {\n        brand\n        product\n        reference\n        po_number\n        notes\n      }\n      authorized_representative {\n        name\n        email\n        phone\n        role_id\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "checkoutDeletePromoCode_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v11
    },
    "operation": {
      "kind": "Operation",
      "name": "checkoutDeletePromoCode_Mutation",
      "argumentDefinitions": v0,
      "selections": v11
    }
  };
}();
node /*: any*/.hash = '54484882fddcb0f4bbcc54e901e28e1b';
module.exports = node;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash a7b09c5881c104088e1db29181c01eac
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentMethod = ('Cheque' | 'Stripe' | 'Wire' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
export type checkoutPlaceOrder_MutationVariables = {|
  input: {
    payment_method: OrderPaymentMethod,
    readonly_payment_info_json: string,
    billing_address_same_as_licensee: boolean,
    licensee_address: {
      name: string,
      company?: ?string,
      company_type_id?: ?string,
      line_1: string,
      line_2?: ?string,
      city: string,
      postal_code: string,
      subdivision_code: string,
      country_code: string,
    },
    billing_address?: ?{
      name: string,
      company?: ?string,
      company_type_id?: ?string,
      line_1: string,
      line_2?: ?string,
      city: string,
      postal_code: string,
      subdivision_code: string,
      country_code: string,
    },
    project_details: {
      brand?: ?string,
      product?: ?string,
      reference?: ?string,
      po_number?: ?string,
      notes?: ?string,
    },
    authorized_representative: {
      name?: ?string,
      email?: ?string,
      phone?: ?string,
      role_id?: ?string,
    },
    air_dates?: ?$ReadOnlyArray<?{
      usage_id: string,
      date?: ?any,
    }>,
    clientMutationId?: ?string,
  },
|};
export type checkoutPlaceOrder_MutationResponse = {|
  +placeOrder: ?{|
    +order: ?{|
      +id: string,
      +currency_code: ?string,
      +currency_rate: ?number,
      +discount: ?number,
      +invoice_number: ?number,
      +order_date: ?any,
      +payment_due_date: ?any,
      +payment_received_date: ?any,
      +payment_status: ?OrderPaymentStatus,
      +subtotal: ?number,
      +total: ?number,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +general_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +description: ?string,
        +amount: ?number,
        +discount_amount: ?number,
      |}>,
      +promo_code_line_item: ?{|
        +id: string,
        +code: ?string,
        +discount_type: ?PromoCodeDiscountType,
        +discount_type_amount: ?number,
      |},
      +tax_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +priority: ?number,
        +tax_name: ?string,
        +rate: ?number,
        +amount: ?number,
      |}>,
      +licensee_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +billing_address: ?{|
        +id: string,
        +type: OrderAddressType,
        +name: string,
        +company: ?string,
        +company_type_id: ?string,
        +company_type: ?{|
          +id: string,
          +name: ?string,
        |},
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +country_code: string,
      |},
      +project_details: ?{|
        +brand: ?string,
        +product: ?string,
        +reference: ?string,
        +po_number: ?string,
        +notes: ?string,
      |},
      +authorized_representative: ?{|
        +name: ?string,
        +email: ?string,
        +phone: ?string,
        +role_id: ?string,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
    |},
  |},
|};
*/

/*
mutation checkoutPlaceOrder_Mutation(
  $input: PlaceOrderInput!
) {
  placeOrder(input: $input) {
    order {
      id
      currency_code
      currency_rate
      discount
      invoice_number
      order_date
      payment_due_date
      payment_received_date
      payment_status
      subtotal
      total
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      general_line_items {
        id
        description
        amount
        discount_amount
      }
      promo_code_line_item {
        id
        code
        discount_type
        discount_type_amount
      }
      tax_line_items {
        id
        priority
        tax_name
        rate
        amount
      }
      licensee_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      billing_address {
        id
        type
        name
        company
        company_type_id
        company_type {
          id
          name
        }
        line_1
        line_2
        city
        postal_code
        subdivision_code
        country_code
      }
      project_details {
        brand
        product
        reference
        po_number
        notes
      }
      authorized_representative {
        name
        email
        phone
        role_id
        role {
          id
          name
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "PlaceOrderInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v6, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v9 = [v1, v8],
      v10 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v1, v8, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v9
  }, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }],
      v11 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "placeOrder",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "PlaceOrderInput!"
    }],
    "concreteType": "PlaceOrderPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "order",
      "storageKey": null,
      "args": null,
      "concreteType": "Order",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "subtotal",
        "args": null,
        "storageKey": null
      }, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_rate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoice_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "order_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_due_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_received_date",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "payment_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, v2, v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v5, v7, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v8, v5, v7]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v4, v8]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v8, v6]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "general_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "GeneralLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, v2, v3]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "promo_code_line_item",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeLineItem",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_type_amount",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "tax_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "priority",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tax_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "licensee_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "billing_address",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderAddress",
        "plural": false,
        "selections": v10
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "project_details",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectDetails",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "product",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "reference",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "po_number",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorized_representative",
        "storageKey": null,
        "args": null,
        "concreteType": "AuthorizedRepresentative",
        "plural": false,
        "selections": [v8, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "role",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRole",
          "plural": false,
          "selections": v9
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "checkoutPlaceOrder_Mutation",
    "id": null,
    "text": "mutation checkoutPlaceOrder_Mutation(\n  $input: PlaceOrderInput!\n) {\n  placeOrder(input: $input) {\n    order {\n      id\n      currency_code\n      currency_rate\n      discount\n      invoice_number\n      order_date\n      payment_due_date\n      payment_received_date\n      payment_status\n      subtotal\n      total\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      general_line_items {\n        id\n        description\n        amount\n        discount_amount\n      }\n      promo_code_line_item {\n        id\n        code\n        discount_type\n        discount_type_amount\n      }\n      tax_line_items {\n        id\n        priority\n        tax_name\n        rate\n        amount\n      }\n      licensee_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      billing_address {\n        id\n        type\n        name\n        company\n        company_type_id\n        company_type {\n          id\n          name\n        }\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        country_code\n      }\n      project_details {\n        brand\n        product\n        reference\n        po_number\n        notes\n      }\n      authorized_representative {\n        name\n        email\n        phone\n        role_id\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "checkoutPlaceOrder_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v11
    },
    "operation": {
      "kind": "Operation",
      "name": "checkoutPlaceOrder_Mutation",
      "argumentDefinitions": v0,
      "selections": v11
    }
  };
}();
node /*: any*/.hash = '64baf6fe133d3f933b117986bac464f0';
module.exports = node;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Checkout Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getCheckout = function (_ref) {
  var checkout = _ref.checkout;
  return checkout;
};
exports.hasValidCheckout = reselect_1.createSelector(exports.getCheckout, function (checkout) {
  return !!checkout && !!checkout.license_line_items && checkout.license_line_items.length > 0;
});

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1450);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--checkout .page__main{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;overflow:hidden}.checkout__content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-flex:1;-ms-flex:auto;flex:auto}html.touchevents .checkout__content-wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .checkout__content-wrapper{overflow-x:hidden;overflow-y:auto}.checkout__content{-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:24px}.checkout__content--processing{min-height:calc(100vh - 64px);padding-bottom:64px;-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.checkout__content--processing .checkout__title{margin-bottom:0}.checkout__content--processing .checkout__subtitle{color:#b1b8c4;margin-bottom:32px}.checkout__steps{-webkit-box-flex:31;-ms-flex:31 1 auto;flex:31 1 auto;margin-right:24px;-webkit-transition:.5s ease-in-out .5s;-o-transition:.5s ease-in-out .5s;transition:.5s ease-in-out .5s;max-width:1152px}.review-step .checkout__steps{margin-right:0}.checkout__sidebar{-webkit-box-flex:13;-ms-flex:13 0 288px;flex:13 0 288px;-webkit-transition:.5s ease-in-out .5s;-o-transition:.5s ease-in-out .5s;transition:.5s ease-in-out .5s;-webkit-transform-origin:-500px center;-ms-transform-origin:-500px center;transform-origin:-500px center}.checkout__sidebar>*{border-radius:4px;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);padding:26px 24px;margin-bottom:24px}.checkout__sidebar>* .heading{margin:0}@media screen and (min-width:1024px){.checkout__sidebar>*{padding:26px 32px}}.checkout__help-box{background-color:#8a8f99;color:#fff}.checkout__help-box .heading--h5{margin-top:4px}.checkout__help-box .sample-license-button{margin-top:16px}.checkout__promo-code{background-color:#fff;padding:8px 8px 8px 0}@media screen and (min-width:1024px){.checkout__promo-code{padding:12px 16px 12px 8px}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GA,4BAEI,4BAAA,6BAAA,0BAAA,sBAAsB,0BACtB,uBAAA,oBAAoB,eACJ,CACjB,2BAMC,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,mBACvB,cAAA,SAAU,CACX,4CC7GC,kBAAgD,kBACT,gCACN,CAClC,+CAEC,kBAAgD,eACX,CDyGvC,mBACE,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,YC5FsB,CD+F7C,+BA7DF,8BAAyE,oBAgErE,4BAAA,mBAAmB,4BACnB,6BAAA,0BAAA,sBAAsB,yBACtB,sBAAA,mBAAmB,wBACnB,qBAAA,sBAAuB,CANxB,gDASG,eAAgB,CATnB,mDEjDD,cF+DI,kBC7GyC,CD8G1C,iBAKH,oBAAA,mBAAA,eAAe,kBAEf,uCAAA,kCAAA,+BAA+B,gBCrHc,CDwH7C,8BACE,cAAe,CAChB,mBAID,oBAAA,oBAAA,gBACA,uCAAA,kCAAA,+BAA+B,uCAC/B,mCAAA,8BAA+B,CAHhC,qBG/HG,kBAvBgB,sDCLqC,8CAAA,kBJoKrD,kBCtI2C,CD6H9C,8BAYK,QAAS,CACV,qCAbJ,qBKzDC,iBJpE6C,CD+I5C,CAAA,oBEzGD,yBAnEoB,UA4BV,CFmJX,iCAKG,cCvJ2C,CDkJ9C,2CASG,eC3J2C,CD4J5C,sBEtHD,sBF2HA,qBAA8C,CAK/C,qCAPD,sBAKI,0BCpK2C,CDsK9C,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Checkout Page Component\n */\n\n.page--checkout{\n  .page__main{\n    flex-direction: column;\n    align-items: stretch;\n    overflow: hidden;\n  }\n}\n\n.checkout{\n  &__content-wrapper{\n    @include scroll;\n    display: flex;\n    align-items: flex-start;\n    flex: auto;\n  }\n\n  &__content{\n    flex: auto;\n    display: flex;\n    align-items: flex-start;\n    padding: baseline(3);\n\n    &--processing{\n      @include page-is-at-least-full-height(-$page-header-height);\n      padding-bottom: baseline(8);\n      align-self: stretch;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n      .checkout__title{\n        margin-bottom: 0;\n      }\n\n      .checkout__subtitle{\n        @include textcolor(bw6);\n        margin-bottom: baseline(4);\n      }\n    }\n  }\n\n  &__steps{\n    flex: 31 1 auto;\n    margin-right: baseline(3);\n    transition: .5s ease-in-out .5s;\n    max-width: baseline(144);\n\n    .review-step & {\n      margin-right: 0;\n    }\n  }\n\n  &__sidebar{\n    flex: 13 0 baseline(36);\n    transition: .5s ease-in-out .5s;\n    transform-origin: -500px center;\n\n    > * {\n      @include bgsize(medium);\n      @include shadow(large);\n      @include padding(baseline(3.25) baseline(3));\n      margin-bottom: baseline(3);\n\n      .heading{\n        margin: 0;\n      }\n\n      @include media(breakpoint(desktop)) {\n        @include padding(baseline(3.25) baseline(4));\n      }\n    }\n  }\n\n  &__help-box{\n    @include bgcolor(bw7);\n    @include textcolor(white);\n\n    .heading--h5{\n      margin-top: baseline(.5);\n    }\n\n    .sample-license-button {\n      margin-top: baseline(2);\n    }\n  }\n\n  &__promo-code{\n    @include bgcolor(white);\n    padding: baseline(1) baseline(1) baseline(1) 0;\n\n    @include media(breakpoint(desktop)) {\n      padding: baseline(1.5) baseline(2) baseline(1.5) baseline(1);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1458);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.thumbnail--loading{background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1s linear infinite;animation:gradient-cycle 1s linear infinite}.thumbnail:before{content:\"\";display:block;width:100%}.thumbnail__inner{position:absolute;top:0;right:0;bottom:0;left:0;background-position:50%;background-size:cover;-webkit-transform:translateZ(0);transform:translateZ(0)}.thumbnail__inner img{height:100%}.thumbnail__inner:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0}.thumbnail.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 10px 20px -3px rgba(16,16,21,.2);box-shadow:0 10px 20px -3px rgba(16,16,21,.2)}.thumbnail.shape--square,.thumbnail.shape--square .thumbnail__inner{border-radius:8px}.thumbnail.shape--circle,.thumbnail.shape--circle .thumbnail__inner,.thumbnail.shape--circle .thumbnail__inner:after{border-radius:50%}.thumbnail.ratio--square:before{padding-top:100%;display:block;width:100%}.thumbnail.ratio--four-thirds:before{padding-top:75%;display:block;width:100%}.thumbnail.clickable{cursor:pointer}.thumbnail--initials .thumbnail__inner{background-color:#4487ff}.thumbnail--initials .thumbnail__inner:after{content:attr(data-initials);position:absolute;top:50%;left:50%;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:1.25em;font-weight:400;line-height:1.125;margin:8px 0;margin:0!important;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-transform:uppercase}@media screen and (min-width:600px){.thumbnail--initials .thumbnail__inner:after{font-size:1.5em;font-weight:300}}@media screen and (min-width:864px){.thumbnail--initials .thumbnail__inner:after{font-size:2em;margin:16px 0}}.thumbnail:not(.thumbnail--is-responsive).thumbnail--xxsmall{width:24px}.thumbnail--xxsmall .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:2px;content:\"\"}.thumbnail--xxsmall.shape--square,.thumbnail--xxsmall.shape--square .thumbnail__inner{border-radius:2px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--xsmall{width:40px}.thumbnail--xsmall .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:4px;content:\"\"}.thumbnail--xsmall.shape--square,.thumbnail--xsmall.shape--square .thumbnail__inner{border-radius:4px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--small{width:72px}.thumbnail--small .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:4px;content:\"\"}.thumbnail--small.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 10px 20px -3px rgba(16,16,21,.2);box-shadow:0 10px 20px -3px rgba(16,16,21,.2)}.thumbnail--small.shape--square,.thumbnail--small.shape--square .thumbnail__inner{border-radius:4px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--medium{width:96px}.thumbnail--medium .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:4px;content:\"\"}.thumbnail--medium.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 20px 40px 0 rgba(16,16,21,.2);box-shadow:0 20px 40px 0 rgba(16,16,21,.2)}.thumbnail--medium.shape--square,.thumbnail--medium.shape--square .thumbnail__inner{border-radius:4px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--large{width:200px}.thumbnail--large .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;content:\"\"}.thumbnail--large.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 30px 60px 0 rgba(16,16,21,.2);box-shadow:0 30px 60px 0 rgba(16,16,21,.2)}.thumbnail--large.shape--square,.thumbnail--large.shape--square .thumbnail__inner{border-radius:8px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--xlarge{width:256px}.thumbnail--xlarge .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;content:\"\"}.thumbnail--xlarge.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 30px 60px 0 rgba(16,16,21,.2);box-shadow:0 30px 60px 0 rgba(16,16,21,.2)}.thumbnail--xlarge.shape--square,.thumbnail--xlarge.shape--square .thumbnail__inner{border-radius:8px}.thumbnail:not(.thumbnail--is-responsive).thumbnail--xxlarge{width:320px}.thumbnail--xxlarge .thumbnail__inner:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;content:\"\"}.thumbnail--xxlarge.with-shadow .thumbnail__inner:after{-webkit-box-shadow:0 30px 60px 0 rgba(16,16,21,.2);box-shadow:0 30px 60px 0 rgba(16,16,21,.2)}.thumbnail--xxlarge.shape--square,.thumbnail--xxlarge.shape--square .thumbnail__inner{border-radius:8px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/images/Thumbnail/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/images/Thumbnail/mixins.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,oBAPlC,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,oDAC1B,2CAAgE,CAelE,kBAMI,WAAW,cACG,UACH,CACZ,kBC9ED,kBDiF4B,MAAG,QAAA,SAAA,OAAA,wBACF,sBACL,gCACtB,uBAAwB,CAJzB,sBAOG,WAAY,CAPf,wBAWG,WAAW,kBACe,MAAG,QAAA,SAAA,MAAA,CAvBnC,+CEtFM,sDFmHuD,6CAAA,CA7B7D,oEG9EM,iBApBgB,CHkGtB,qHG9EM,iBAdgB,CH4FtB,gCA+CM,iBAAiB,cACH,UACH,CAjDjB,qCAoDM,gBAAgB,cACF,UACH,CAtDjB,qBA2DI,cAAe,CAChB,uCIlGC,wBA3DuB,CJ+JxB,6CAKK,4BAA4B,kBACF,QAAK,SAAc,WIjJvC,mCCsC2B,kCAKH,iBCZJ,gBAChB,kBACE,aNoHZ,mBAAoB,uCACpB,mCAAA,+BAAgC,wBACP,CAC1B,oCAbJ,6CMnGC,gBAA+B,eACf,CN+Gb,CAAA,oCAbJ,6CM9FC,cAhBiB,aAmBM,CNwGpB,CAAA,6DO1ID,UFb2C,CEc5C,4CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBA1BgB,UIgDP,CACZ,sFJvBG,iBA1BgB,CIuCpB,4DAEI,UFb2C,CEc5C,2CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBAvBgB,UI6CP,CACZ,oFJvBG,iBAvBgB,CIoCpB,2DAEI,UFb2C,CEc5C,0CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBAvBgB,UI6CP,CACZ,sDL/BG,sDAAA,6CKkCuD,CAC1D,kFJ3BG,iBAvBgB,CIoCpB,4DAEI,UFb2C,CEc5C,2CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBAvBgB,UI6CP,CACZ,uDL/BG,mDAAA,0CKkCuD,CAC1D,oFJ3BG,iBAvBgB,CIoCpB,2DAEI,WFb2C,CEc5C,0CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBApBgB,UI0CP,CACZ,sDL/BG,mDAAA,0CKkCuD,CAC1D,kFJ3BG,iBApBgB,CIiCpB,4DAEI,WFb2C,CEc5C,2CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBApBgB,UI0CP,CACZ,uDL/BG,mDAAA,0CKkCuD,CAC1D,oFJ3BG,iBApBgB,CIiCpB,6DAEI,WFb2C,CEc5C,4CNPH,kBAII,MAAA,QAAA,SAAA,OEbA,kBApBgB,UI0CP,CACZ,wDL/BG,mDAAA,0CKkCuD,CAC1D,sFJ3BG,iBApBgB,CIoDjB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Thumbnail Component\n */\n\n@import '../../../atoms/text/Heading/mixins';\n@import './mixins';\n\n.thumbnail{\n  &--loading {\n    @include loading-placeholder(1s);\n  }\n\n  &::before{\n    content: \"\";\n    display: block;\n    width: 100%;\n  }\n\n  &__inner{\n    @include position(absolute, 0);\n    background-position: center;\n    background-size: cover;\n    transform: translateZ(0);\n\n    img{\n      height: 100%;\n    }\n\n    &::after{\n      content: \"\";\n      @include position(absolute, 0);\n    }\n  }\n\n  &.with-shadow &__inner{\n    &::after{\n      @include shadow(small, transparentize(color(black), .8));\n    }\n  }\n\n  &.shape--square{\n    &, .thumbnail__inner{\n      @include bgsize(large);\n    }\n  }\n\n  &.shape--circle{\n    &, .thumbnail__inner, .thumbnail__inner::after{\n      @include bgsize(circle);\n    }\n  }\n\n  &.ratio{\n    &--square::before{\n      padding-top: 100%;\n      display: block;\n      width: 100%;\n    }\n    &--four-thirds::before{\n      padding-top: 75%;\n      display: block;\n      width: 100%;\n    }\n  }\n\n  &.clickable{\n    cursor: pointer;\n  }\n\n  &--initials{\n    .thumbnail__inner{\n      @include bgcolor(accent);\n\n      &::after{\n        content: attr(data-initials);\n        @include position(absolute, 50% null null 50%);\n        @include textcolor(white);\n        @include font-smoothing;\n        @include h3;\n        margin: 0 !important;\n        transform: translate(-50%, -50%);\n        text-transform: uppercase;\n      }\n    }\n  }\n\n}\n\n@each $thumbnail-size, $options in $thumbnail-sizes {\n  @include thumbnail-for-size($thumbnail-size);\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","/**\n * Thumbnail Component\n */\n\n$thumbnail-sizes: (\n  xxsmall: (\n    bg: small,\n    width: 3,\n  ),\n  xsmall: (\n    bg: medium,\n    width: 5,\n  ),\n  small: (\n    bg: medium,\n    shadow: small,\n    width: 9,\n  ),\n  medium: (\n    bg: medium,\n    shadow: medium,\n    width: 12,\n  ),\n  large: (\n    bg: large,\n    shadow: large,\n    width: 25,\n  ),\n  xlarge: (\n    bg: large,\n    shadow: large,\n    width: 32,\n  ),\n  xxlarge: (\n    bg: large,\n    shadow: large,\n    width: 40,\n  ),\n);\n\n@mixin thumbnail-for-size($size) {\n  $options: map-get($thumbnail-sizes, $size);\n  $bgsize: map-get($options, bg);\n  $shadow: map-get($options, shadow);\n  $width: map-get($options, width);\n\n  .thumbnail:not(.thumbnail--is-responsive){\n    &.thumbnail--#{$size}{\n      width: baseline($width);\n    }\n  }\n\n  .thumbnail--#{$size} .thumbnail__inner::after{\n    @include position(absolute, 0);\n    @include bgsize($bgsize);\n    content: \"\";\n  }\n\n  .thumbnail--#{$size}.with-shadow .thumbnail__inner::after{\n    @include shadow($shadow, transparentize(color(black), .8));\n  }\n\n  .thumbnail--#{$size}.shape--square{\n    &, .thumbnail__inner{\n      @include bgsize($bgsize);\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1459 */,
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 1c4455722772914ee0deb379579ae24a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type cart_viewer$ref = any;
export type cart_QueryVariables = {| |};
export type cart_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: cart_viewer$ref,
  |},
|};
*/

/*
query cart_Query {
  viewer {
    ...cart_viewer
    id
  }
}

fragment cart_viewer on Viewer {
  selected_currency_rate
  cart {
    id
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    total
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
  selected_currency
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = [v5, v0];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "cart_Query",
    "id": null,
    "text": "query cart_Query {\n  viewer {\n    ...cart_viewer\n    id\n  }\n}\n\nfragment cart_viewer on Viewer {\n  selected_currency_rate\n  cart {\n    id\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    total\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n  selected_currency\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "cart_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "cart_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "cart_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency_rate",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "cart",
          "storageKey": null,
          "args": null,
          "concreteType": "Cart",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseLineItem",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_amount",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "track",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [v0, v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              }, v2, v4, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [v0, v5, v2, v4]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [v0, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_highlighted",
                      "args": null,
                      "storageKey": null
                    }, v5, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "parent_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [v0, v1, v5]
                    }]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "license",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicense",
              "plural": false,
              "selections": [v0, {
                "kind": "LinkedField",
                "alias": null,
                "name": "usages",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicenseUsage",
                "plural": true,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "license_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "air_date",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "components",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsageComponent",
                  "plural": true,
                  "selections": [v0, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "component_id",
                    "args": null,
                    "storageKey": null
                  }, v5, v3]
                }]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "ga_account_goal_sent",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_provider",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_new_user",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "user_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v6
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v6
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v6
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency",
          "args": null,
          "storageKey": null
        }, v0]
      }]
    }
  };
}();
node /*: any*/.hash = 'b0d7bec8b85f17bc5854b4bee7b4e18b';
module.exports = node;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type cart_viewer$ref: FragmentReference;
export type cart_viewer = {|
  +selected_currency_rate: ?number,
  +cart: ?{|
    +id: string,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +total: ?number,
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +selected_currency: ?Currency,
  +$refType: cart_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = [v5];
  return {
    "kind": "Fragment",
    "name": "cart_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency_rate",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [v0, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v0, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v2, v4, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v0, v5, v2, v4]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v0, v1, v5]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v5, v3]
            }]
          }]
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "ga_account_goal_sent",
        "args": null,
        "storageKey": null
      }, v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "external_provider",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_new_user",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "user_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "company_size",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanySize",
        "plural": false,
        "selections": v6
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "industry",
        "storageKey": null,
        "args": null,
        "concreteType": "Industry",
        "plural": false,
        "selections": v6
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "job_type",
        "storageKey": null,
        "args": null,
        "concreteType": "JobType",
        "plural": false,
        "selections": v6
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = '6ac42563a5a97568011d512fd6209d82';
module.exports = node;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type cartNode$ref: FragmentReference;
export type cartNode = {|
  +id: string,
  +license_line_items: ?$ReadOnlyArray<?{|
    +id: string,
    +amount: ?number,
    +discount_amount: ?number,
    +track: ?{|
      +id: string,
      +internal_id: ?number,
      +title: ?string,
      +added_to_cart: ?boolean,
      +slug: ?string,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +id: string,
        +name: ?string,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +internal_id: ?number,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |},
    +license: ?{|
      +id: string,
      +usages: ?$ReadOnlyArray<?{|
        +id: string,
        +license_id: ?number,
        +air_date: ?any,
        +components: ?$ReadOnlyArray<?{|
          +id: string,
          +component_id: ?number,
          +name: ?string,
          +type: ?string,
        |}>,
      |}>,
    |},
  |}>,
  +total: ?number,
  +$refType: cartNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "cartNode",
    "type": "Cart",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseLineItem",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount_amount",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [v0, v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v2, v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [v0, v5, v2, v4]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v5, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v0, v1, v5]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license",
        "storageKey": null,
        "args": null,
        "concreteType": "StandardLicense",
        "plural": false,
        "selections": [v0, {
          "kind": "LinkedField",
          "alias": null,
          "name": "usages",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicenseUsage",
          "plural": true,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "license_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "air_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "components",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsageComponent",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "component_id",
              "args": null,
              "storageKey": null
            }, v5, v3]
          }]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "total",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = 'a70ca21880623ca4e6d961dde5dc1664';
module.exports = node;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash b2c91a70d2bf92b69325aa095cc85681
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartAddItem_MutationVariables = {|
  input: {
    license_item: {
      track_id?: ?string,
      usages?: ?$ReadOnlyArray<?{
        spot_count?: ?number,
        term?: ?number,
        medium: number,
        contextual_param?: ?$ReadOnlyArray<?number>,
        contextual_param_type: string,
        air_date?: ?any,
      }>,
    },
    clientMutationId?: ?string,
  },
|};
export type cartAddItem_MutationResponse = {|
  +addItem: ?{|
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +total: ?number,
    |},
  |},
|};
*/

/*
mutation cartAddItem_Mutation(
  $input: AddItemInput!
) {
  addItem(input: $input) {
    cart {
      id
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      total
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddItemInput!"
    }],
    "concreteType": "AddItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [v1, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v3, v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v6, v3, v5]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v2, v6]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v6, v4]
            }]
          }]
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "cartAddItem_Mutation",
    "id": null,
    "text": "mutation cartAddItem_Mutation(\n  $input: AddItemInput!\n) {\n  addItem(input: $input) {\n    cart {\n      id\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      total\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "cartAddItem_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "cartAddItem_Mutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
node /*: any*/.hash = '1d167a7b3bde173b4b897d58abad0ef1';
module.exports = node;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 9aca062cc4328290f4904cad35c8a054
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartUpdateItem_MutationVariables = {|
  input: {
    license_item: {
      id: string,
      track_id?: ?string,
      usages?: ?$ReadOnlyArray<?{
        spot_count?: ?number,
        term?: ?number,
        medium: number,
        contextual_param?: ?$ReadOnlyArray<?number>,
        contextual_param_type: string,
        air_date?: ?any,
      }>,
    },
    clientMutationId?: ?string,
  },
|};
export type cartUpdateItem_MutationResponse = {|
  +updateItem: ?{|
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +total: ?number,
    |},
  |},
|};
*/

/*
mutation cartUpdateItem_Mutation(
  $input: UpdateItemInput!
) {
  updateItem(input: $input) {
    cart {
      id
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      total
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateItemInput!"
    }],
    "concreteType": "UpdateItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [v1, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v3, v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v6, v3, v5]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v2, v6]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v6, v4]
            }]
          }]
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "cartUpdateItem_Mutation",
    "id": null,
    "text": "mutation cartUpdateItem_Mutation(\n  $input: UpdateItemInput!\n) {\n  updateItem(input: $input) {\n    cart {\n      id\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      total\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "cartUpdateItem_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "cartUpdateItem_Mutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
node /*: any*/.hash = 'a81930a4e79b97ed501f9cba6a90cd0a';
module.exports = node;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 6774d11a115583b0cfb29415745c5273
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartDeleteItem_MutationVariables = {|
  input: {
    id: string,
    clientMutationId?: ?string,
  },
|};
export type cartDeleteItem_MutationResponse = {|
  +deleteItem: ?{|
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +total: ?number,
    |},
  |},
|};
*/

/*
mutation cartDeleteItem_Mutation(
  $input: DeleteItemInput!
) {
  deleteItem(input: $input) {
    cart {
      id
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      total
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteItemInput!"
    }],
    "concreteType": "DeleteItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [v1, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v1, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v3, v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v1, v6, v3, v5]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, v2, v6]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v6, v4]
            }]
          }]
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "cartDeleteItem_Mutation",
    "id": null,
    "text": "mutation cartDeleteItem_Mutation(\n  $input: DeleteItemInput!\n) {\n  deleteItem(input: $input) {\n    cart {\n      id\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      total\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "cartDeleteItem_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "cartDeleteItem_Mutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
node /*: any*/.hash = '182c9a98bc2b7bbd5f7385d5e30d68c0';
module.exports = node;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1467);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".cart .alert{position:fixed;top:120px;right:0;left:0}.cart--empty .page__main{margin-bottom:88px}.cart__title-empty{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.cart__footer{background-color:#f5faff;position:fixed;right:0;bottom:0;left:0;height:144px;-webkit-box-flex:0;-ms-flex:none;flex:none}@supports ((-webkit-backdrop-filter:blur(20px)) or (backdrop-filter:blur(20px))){.cart__footer{background-color:rgba(245,250,255,.9);-webkit-backdrop-filter:blur(20px) saturate(200%);backdrop-filter:blur(20px) saturate(200%)}}.app-wrapper[data-player-visibility=true] .cart__footer{bottom:56px}.app-wrapper[data-player-term-list-visibility=true] .cart__footer{bottom:136px}.cart__footer__content{padding-right:88px;padding-left:64px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.cart__footer__content__right{text-align:right}.cart__footer__title-total{margin-top:0;margin-bottom:8px}.cart__footer__fine-prints{color:#b1b8c4;display:block}.cart-width{width:90%;margin:0 auto;max-width:920px}.cart__content-wrapper{z-index:0}.cart__content{position:absolute;top:-120px;right:0;left:0;padding:192px 72px 216px;min-height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.app-wrapper[data-player-visibility=true] .cart__content{padding-bottom:272px}.app-wrapper[data-player-term-list-visibility=true] .cart__content{padding-bottom:352px}.cart__content ul{list-style:none;margin:0 auto;padding:0;max-width:960px;width:100%}.cart__line-item{margin:16px 0}.cart__line-item__red-dot{position:absolute;top:calc(50% - 4px);right:-32px;height:8px;width:8px;background-color:#f75b5b;border-radius:50%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Cart/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,aClEE,eDuEyB,UAhE8C,QAgEd,MAAO,CAC/D,yBAIG,kBEnF2C,CFoF5C,mBC7EH,kBDiF4B,QAAK,SAAc,uCAC7C,mCAAA,8BAAgC,CACjC,cAvCD,yBC5CA,eDuFyB,QAAQ,SAAE,OAAE,aAGnC,mBAAA,cAAA,SAAU,CA7C0B,iFAwCtC,cAvCE,sCAHiF,kDAIjF,yCAA0C,CAiE3C,CA/FD,wDACE,WAAwC,CACzC,kEAGC,YAAuD,CACxD,uBGwBuB,mBDtDuB,kBFqG3C,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,WACP,CAEZ,8BACE,gBAAiB,CAClB,2BG3DiB,aA3CH,iBDN4B,CFiH5C,2BInED,cJuEE,aAAc,CACf,YAID,UAAU,cACI,eE3H+B,CF6H9C,uBAQC,SAAU,CACX,eC/HD,kBDkI4B,WA3H2C,QA2HV,OAAO,yBAC6C,iBAE9F,oBACjB,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAtHrB,yDACE,oBAAwC,CACzC,mEAGC,oBAAuD,CACxD,kBAmHG,gBAAgB,cACF,UACJ,gBAEV,UAAW,CACZ,iBAID,aAAqB,CAErB,0BCrJF,kBDsJ8B,oBAA6B,YE7JZ,WAAA,UAAA,yBElBvB,iBCEJ,CLiLjB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CartPage Component\n */\n\n.cart {\n  $content-padding: baseline(9);\n  $footer-height: baseline(18);\n\n  .alert{\n    @include position(fixed, $page-with-header-margin-top 0 null 0);\n  }\n\n  &--empty {\n    .page__main {\n      margin-bottom: baseline(11);\n    }\n  }\n\n  &__title-empty {\n    @include position(absolute, 50% null null 50%);\n    transform: translate(-50%, -50%);\n  }\n\n  &__footer {\n    @include translucent(color(accent-subtle));\n    @include position(fixed, null 0 0 0);\n    @include react-to-player-visibility;\n    height: $footer-height;\n    flex: none;\n\n    &__content {\n      @include padding(null baseline(11) null baseline(8));\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      height: 100%;\n\n      &__right {\n        text-align: right;\n      }\n    }\n\n    &__title-total {\n      @include margin(0 null baseline(1));\n    }\n\n    &__fine-prints {\n      @include textcolor(bw6);\n      display: block;\n    }\n  }\n\n  &-width {\n    width: 90%;\n    margin: 0 auto;\n    max-width: baseline(115);\n  }\n\n  &__content-wrapper {\n    // display: flex;\n    // flex-direction: column;\n    // justify-content: center;\n    // padding-bottom: $page-with-header-margin-top;\n    // min-height: calc(100vh - #{$page-with-header-margin-top + $footer-height});\n    z-index: 0;\n  }\n\n  &__content {\n    @include position(absolute, -$page-with-header-margin-top 0 null 0);\n    padding: ($page-with-header-margin-top + $content-padding) $content-padding ($footer-height + $content-padding);\n    @include react-to-player-visibility(padding-bottom, $footer-height + $content-padding);\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n\n    ul {\n      list-style: none;\n      margin: 0 auto;\n      padding: 0;\n      max-width: baseline(120);\n      width: 100%;\n    }\n  }\n\n  &__line-item {\n    margin: baseline(2) 0;\n\n    &__red-dot{\n      @include position(absolute, calc(50% - #{baseline(.5)}) baseline(-4) null null);\n      @include size(baseline(1));\n      @include bgcolor(dangerous);\n      @include bgsize(circle);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1469);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LicenseBuilder Component Portal
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(276);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var _1 = __webpack_require__(616);
var defaultList = [];

var LicenseBuilderPortalBase = function (_React$Component) {
    _inherits(LicenseBuilderPortalBase, _React$Component);

    function LicenseBuilderPortalBase() {
        _classCallCheck(this, LicenseBuilderPortalBase);

        return _possibleConstructorReturn(this, (LicenseBuilderPortalBase.__proto__ || Object.getPrototypeOf(LicenseBuilderPortalBase)).apply(this, arguments));
    }

    _createClass(LicenseBuilderPortalBase, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.setUsages();
            this.props.setEditingUsageIndex();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.clearLicense();
        }
    }, {
        key: "render",
        value: function render() {
            return ReactDOM.createPortal(React.createElement(_1.default, { onClose: this.props.onClose, onSave: this.props.onSaveLicense }), document.getElementsByClassName('drawer-wrapper')[0]);
        }
    }]);

    return LicenseBuilderPortalBase;
}(React.Component);

exports.LicenseBuilderPortal = react_redux_1.connect(null, function (dispatch, _ref) {
    var scope = _ref.scope,
        selectedUsage = _ref.selectedUsage,
        usages = _ref.usages;
    return {
        clearLicense: function clearLicense() {
            return dispatch(license_1.clearLicense());
        },
        setEditingUsageIndex: function setEditingUsageIndex() {
            if (selectedUsage != null) {
                dispatch(license_1.setEditingUsageIndex({ index: selectedUsage }));
            }
        },
        setUsages: function setUsages() {
            return dispatch(license_1.setUsages({ scope: scope, usages: usages || defaultList }));
        }
    };
})(LicenseBuilderPortalBase);

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Drawer_1 = __webpack_require__(215);
var BEM = __webpack_require__(1);
var config_1 = __webpack_require__(142);
var default_presets_1 = __webpack_require__(1472);
__webpack_require__(1473);
var classes = new BEM('license-presets-menu');
function blockMouseEvents(e) {
    e.stopPropagation();
}

var LicensePresetsMenu = function (_React$Component) {
    _inherits(LicensePresetsMenu, _React$Component);

    function LicensePresetsMenu(props) {
        _classCallCheck(this, LicensePresetsMenu);

        var _this = _possibleConstructorReturn(this, (LicensePresetsMenu.__proto__ || Object.getPrototypeOf(LicensePresetsMenu)).call(this, props));

        _this.onClose = function () {
            _this.setState({ isOpen: false }, function () {
                _this.props.onClose();
            });
        };
        _this.renderLicensePresetListItem = function (usage, index) {
            var _config_1$mediaTypeDe = config_1.mediaTypeDefinitionsMap[usage.medium.internal_id],
                label = _config_1$mediaTypeDe.label,
                icon = _config_1$mediaTypeDe.icon;

            var name = usage.medium.value_label;
            var content = React.createElement(React.Fragment, null, React.createElement("span", Object.assign({}, classes('preset-name')), label || name), usage.contextual_param ? React.createElement("span", null, React.createElement("small", { className: "param" }, usage.contextual_param[0].label, ": "), React.createElement("small", { className: "value" }, usage.contextual_param[0].value_label), React.createElement("br", null)) : null, React.createElement("span", null, React.createElement("small", { className: "param" }, usage.term ? usage.term.label : 'Duration', ": "), React.createElement("small", { className: "value" }, usage.term ? usage.term.value_label : 'Perpetuity')));
            return _this.renderListItem({
                key: "preset-" + index,
                icon: icon,
                content: content,
                onClick: function onClick() {
                    return _this.props.onSelectPreset(usage);
                }
            });
        };
        _this.renderCustomLicenseListItem = function () {
            var label = 'Custom License';
            return _this.renderListItem({
                key: 'custom-license-btn',
                icon: React.createElement(Icon_1.IconAddCircle, null),
                content: React.createElement("span", Object.assign({}, classes('preset-name')), label),
                onClick: function onClick() {
                    return _this.props.onOpenLicenseBuilder();
                },
                className: 'custom-license-list-item'
            });
        };
        _this.renderListItem = function (_ref) {
            var key = _ref.key,
                onClick = _ref.onClick,
                icon = _ref.icon,
                content = _ref.content,
                className = _ref.className;

            return React.createElement("li", { key: key, onClick: onClick, className: className }, React.createElement(Button_1.default, { variant: "icon", icon: icon, size: "large" }), React.createElement(Label_1.Span, Object.assign({ size: "medium" }, classes('preset-description')), content), React.createElement(Button_1.default, { className: "select-license-preset-button", colorScheme: "accent", label: "Select", variant: "pill", size: "small" }));
        };
        _this.state = {
            isOpen: true
        };
        return _this;
    }

    _createClass(LicensePresetsMenu, [{
        key: "render",
        value: function render() {
            return React.createElement(Drawer_1.default, Object.assign({ position: "left", closeButtonLabel: "Cancel", open: this.state.isOpen, onClose: this.onClose }, classes()), React.createElement("div", Object.assign({}, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h4", textColor: "black" }, classes('title')), "Select a License"), React.createElement("div", null, React.createElement(Button_1.default, { className: "sample-license-button", hyperLinkProps: {
                    href: 'https://assets.boppermusic.com/docs/Bopper_Sample_License.pdf',
                    target: '_blank'
                }, wrapperComponent: "a", colorScheme: "black-outline", variant: "pill", size: "small", label: "Preview License" })), React.createElement("ul", Object.assign({}, classes('presets-list')), default_presets_1.defaultLicensePresets(this.props.userProducerLocation).map(this.renderLicensePresetListItem), this.renderCustomLicenseListItem())));
        }
    }]);

    return LicensePresetsMenu;
}(React.Component);

exports.LicensePresetsMenu = LicensePresetsMenu;

var LicensePresetsMenuPortalContent = function (_React$Component2) {
    _inherits(LicensePresetsMenuPortalContent, _React$Component2);

    function LicensePresetsMenuPortalContent() {
        _classCallCheck(this, LicensePresetsMenuPortalContent);

        return _possibleConstructorReturn(this, (LicensePresetsMenuPortalContent.__proto__ || Object.getPrototypeOf(LicensePresetsMenuPortalContent)).apply(this, arguments));
    }

    _createClass(LicensePresetsMenuPortalContent, [{
        key: "render",
        value: function render() {
            var onClose = this.props.onClose;

            return React.createElement("div", { className: "license-presets-menu-portal", onClick: function blockClickEvents(e) {
                    e.stopPropagation();onClose();
                }, onMouseEnter: blockMouseEvents, onMouseLeave: blockMouseEvents, onMouseOver: blockMouseEvents, onMouseMove: blockMouseEvents, onPointerEnter: blockMouseEvents, onPointerLeave: blockMouseEvents, onPointerOver: blockMouseEvents, onPointerMove: blockMouseEvents }, React.createElement(LicensePresetsMenu, Object.assign({}, this.props)));
        }
    }]);

    return LicensePresetsMenuPortalContent;
}(React.Component);
// tslint:disable-next-line:max-classes-per-file class-name


var LicensePresetsMenuPortal_ = function (_React$Component3) {
    _inherits(LicensePresetsMenuPortal_, _React$Component3);

    function LicensePresetsMenuPortal_() {
        _classCallCheck(this, LicensePresetsMenuPortal_);

        return _possibleConstructorReturn(this, (LicensePresetsMenuPortal_.__proto__ || Object.getPrototypeOf(LicensePresetsMenuPortal_)).apply(this, arguments));
    }

    _createClass(LicensePresetsMenuPortal_, [{
        key: "render",
        value: function render() {
            return ReactDOM.createPortal(React.createElement(LicensePresetsMenuPortalContent, Object.assign({}, this.props)), document.getElementsByClassName('drawer-wrapper')[0]);
        }
    }]);

    return LicensePresetsMenuPortal_;
}(React.Component);

function getUserProducerLocation(licenseComponents) {
    var producerLocation = void 0;
    try {
        var node = licenseComponents.producer_locations.edges.find(function (edge) {
            return edge.node.is_user_location;
        }).node;
        producerLocation = {
            id: node.internal_id,
            name: node.name
        };
    } catch (_a) {
        producerLocation = {
            id: 5177,
            name: 'United States of America'
        };
    }
    return producerLocation;
}
exports.LicensePresetsMenuPortal = react_redux_1.connect(function (_ref2, props) {
    var license = _ref2.license,
        licenseComponents = _ref2.staticData.licenseComponents;
    return Object.assign({ userProducerLocation: getUserProducerLocation(licenseComponents) }, props);
})(LicensePresetsMenuPortal_);

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IMPORTANT: This is the language we settled on, don't change it without running it by
// Phil/Gab/Greg
// const archivalTerm = 'Lifetime Archival';

Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:max-line-length
var query = JSON.stringify({ operationName: null, variables: null, query: 'query LicensePresets {\n  viewer {\n    license_presets {\n      ...licensePreset\n    }\n  }\n}\n\nfragment licensePreset on LicensePreset {\n  enabled\n  medium {\n    ...licensePresetComponent\n  }\n  spot_count {\n    ...licensePresetComponent\n  }\n  term {\n    ...licensePresetComponent\n  }\n  contextual_param {\n    ...licensePresetComponent\n  }\n  contextual_param_type\n}\n\nfragment licensePresetComponent on LicensePresetComponent {\n  internal_id\n  label\n  value_label\n  autodetect\n  locked\n}' });
exports.licensePresets = { presets: [] };
(function loadLicensePresets() {
    function reqListener() {
        exports.licensePresets.presets = JSON.parse(this.responseText).data.viewer.license_presets;
    }
    var req = new XMLHttpRequest();
    req.addEventListener('load', reqListener);
    req.open('POST', '/graphql');
    req.setRequestHeader('Content-Type', 'application/json');
    req.send(query);
})();
exports.defaultLicensePresets = function (location) {
    var presets = exports.licensePresets.presets.map(function (preset) {
        if (preset.contextual_param.length === undefined) {
            if (preset.contextual_param_type === 'ProducerLocation') {
                preset.contextual_param = Object.assign({}, preset.contextual_param, { internal_id: location.id, value_label: location.name });
            }
            preset.contextual_param = [Object.assign({}, preset.contextual_param, { id: preset.contextual_param.internal_id })];
        }
        ['medium', 'term', 'spot_count'].forEach(function (param) {
            if (preset[param] && preset[param].internal_id) {
                preset[param] = Object.assign({}, preset[param], { id: preset[param].internal_id, name: preset[param].label });
            } else {
                delete preset[param];
            }
        });
        return preset;
    });
    return presets.filter(function (preset) {
        return preset.enabled;
    });
};
// export const defaultLicensePresets = (location: ILicenseComponent) => [
//   {
//     medium: {
//       id: 2012,
//       name: 'Social Media',
//     },
//     spot_count: {
//       id: 1,
//       name: '1 film',
//     },
//     term: {
//       id: 1005,
//       name: `1 Year + ${archivalTerm}`,
//     },
//     contextual_param_type: 'ProducerLocation',
//     contextual_param_label: 'Location',
//     contextual_param: [{
//       id: location.id,
//       name: location.name,
//     }],
//   },
//   // {
//   //   medium: {
//   //     id: 2004,
//   //     name: 'Web Streaming',
//   //   },
//   //   spot_count: {
//   //     id: 1,
//   //     name: '1 film',
//   //   },
//   //   term: {
//   //     id: 1005,
//   //     name: `1 Year + ${archivalTerm}`,
//   //   },
//   //   contextual_param_type: 'ProducerLocation',
//   //   contextual_param_label: 'Location',
//   //   contextual_param: [{
//   //   id: location.id,
//   //   name: location.name,
//   //   }],
//   // },
//   {
//     medium: {
//       id: 2013,
//       name: 'TV Show',
//     },
//     contextual_param_type: 'EpisodeBudget',
//     contextual_param_label: 'Episode Budget',
//     contextual_param: [{
//       id: 7003,
//       name: '200K to 400K',
//     }],
//   },
// ] as ILicenseUsage[];

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1474);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".drawer.license-presets-menu{width:100%}@media screen and (min-width:600px){.drawer.license-presets-menu{width:496px}}@media screen and (min-width:1600px){.drawer.license-presets-menu{width:496px}}.license-presets-menu__content{padding:0 48px;height:100%}.license-presets-menu__title{font-size:26px;line-height:30px;font-weight:600;margin-top:40px;margin-bottom:16px}.license-presets-menu .sample-license-button{margin-bottom:20px}.license-presets-menu__presets-list{padding:0;margin-bottom:24px}.license-presets-menu__presets-list li{border-radius:8px;border:1px solid #e4e8ed;list-style-type:none;margin:0 0 8px;padding:28px 17.6px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.license-presets-menu__presets-list li .select-license-preset-button{opacity:0}.license-presets-menu__presets-list li:hover{border:1px solid #4487ff;cursor:pointer}.license-presets-menu__presets-list li:hover .select-license-preset-button{-webkit-transition:opacity .2s ease-in-out;-o-transition:opacity .2s ease-in-out;transition:opacity .2s ease-in-out;opacity:1}.license-presets-menu__presets-list li.custom-license-list-item{color:#4487ff}.license-presets-menu__presets-list li.custom-license-list-item svg{width:32px;height:32px;stroke-width:1.5px}.license-presets-menu__presets-list small.param,.license-presets-menu__presets-list small.value{display:inline;font-size:14px;line-height:19px}.license-presets-menu__presets-list small.value{color:#101015}.license-presets-menu__preset-name{display:block;font-weight:500;font-size:18px;line-height:26px}.license-presets-menu__preset-description{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:left;padding-left:16px}.license-presets-menu-portal{height:100%;width:100%;background-color:rgba(0,0,0,.3);-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;transition:all .3s ease-in-out;pointer-events:all}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/forms/LicensePresetsMenu/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AAwGA,6BACE,UAAW,CAQZ,oCATD,6BAII,WCzE6C,CD8EhD,CAAA,qCATD,6BAOI,WC5E6C,CD8EhD,CAAA,+BAIG,eACA,WAAY,CACb,6BAGC,eAAe,iBACE,gBACD,gBAEhB,kBC3F6C,CDgFjD,6CAeI,kBC/F6C,CDgG9C,oCAGC,UAAU,kBCnGmC,CDkG9C,uCEpGG,kBF0GA,yBAEA,qBAAqB,eAEI,oBAGzB,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,yBACnB,sBAAA,8BAA8B,0CAE9B,qCAAA,iCAAkC,CAjBrC,qEAoBK,SAAU,CApBf,6CAwBK,yBACA,cAAe,CAzBpB,2EA4BO,2CAAA,sCAAA,mCAAmC,SACzB,CA7BjB,gEAmCG,aG1JqB,CHuHxB,oEAqCK,WAAW,YACC,kBACO,CAvCxB,gGA4CG,eAAe,eACA,gBACE,CA9CpB,gDAkDG,aGnLoB,CHoLrB,mCAID,cAAc,gBACE,eACD,gBACE,CAClB,0CAGC,mBAAA,WAAA,OAAO,gBACS,iBCjK6B,CDmK9C,6BAID,YAAY,WACD,gCACsB,uCACjC,kCAAA,+BAA+B,kBACZ,CACpB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n.drawer.license-presets-menu {\n  width: 100%;\n\n  @include media(breakpoint(tablet)) {\n    width: baseline(62);\n  }\n  @include media(breakpoint(desktop-xxl)) {\n    width: baseline(62);\n  }\n}\n\n.license-presets-menu {\n  &__content {\n    padding: 0 baseline(6);\n    height: 100%;\n  }\n\n  &__title {\n    font-size: 26px;\n    line-height: 30px;\n    font-weight: 600;\n    margin-top: baseline(5);\n    margin-bottom: baseline(2);\n  }\n\n  .sample-license-button {\n    margin-bottom: baseline(2.5);\n  }\n\n  &__presets-list {\n    padding: 0;\n    margin-bottom: baseline(3);\n\n    li {\n      @include bgsize(large);\n      border: 1px solid color(bw4);\n\n      list-style-type: none;\n\n      margin: 0 0 baseline(1) 0;\n      padding: baseline(3.5) baseline(2.2);\n\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      transition: border .2s ease-in-out;\n\n      .select-license-preset-button {\n        opacity: 0;\n      }\n\n      &:hover {\n        border: 1px solid color(accent);\n        cursor: pointer;\n\n        .select-license-preset-button {\n          transition: opacity .2s ease-in-out;\n          opacity: 1;\n        }\n      }\n    }\n\n    li.custom-license-list-item {\n      color: color(accent);\n      svg {\n        width: 32px;\n        height: 32px;\n        stroke-width: 1.5px;\n      }\n    }\n\n    small.param, small.value {\n      display: inline;\n      font-size: 14px;\n      line-height: 19px;\n    }\n\n    small.value {\n      color: color(black);\n    }\n  }\n\n  &__preset-name {\n    display: block;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 26px;\n  }\n\n  &__preset-description {\n    flex: 1;\n    text-align: left;\n    padding-left: baseline(2);\n  }\n}\n\n.license-presets-menu-portal {\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0,0,0,0.3);\n  transition: all .3s ease-in-out;\n  pointer-events: all;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".price-tag{white-space:nowrap}.price-tag--line-through{color:#f75b5b;text-decoration:line-through}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/PriceTag/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,WACE,kBAAmB,CAEnB,yBC9BE,cDgCA,4BAA6B,CAC9B","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Price Tag Component\n */\n\n.price-tag{\n  white-space: nowrap;\n\n  &--line-through{\n    @include textcolor(dangerous);\n    text-decoration: line-through;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1477);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".card{-webkit-transition:.1s ease-in-out;-o-transition:.1s ease-in-out;transition:.1s ease-in-out}.card.with-bgcolor--black .card__content__left:after,.card.with-bgcolor--black .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--black .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--black .card__content__right{background-color:#101015}.card.card--xlarge.with-bgcolor--black .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--black .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.card--xlarge.with-bgcolor--black .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--dark .card__content__left:after,.card.with-bgcolor--dark .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--dark .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--dark .card__content__right{background-color:#101015}.card.card--xlarge.with-bgcolor--dark .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--dark .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.card--xlarge.with-bgcolor--dark .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--bw8 .card__content__left:after,.card.with-bgcolor--bw8 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--bw8 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--bw8 .card__content__right{background-color:#101015}.card.card--xlarge.with-bgcolor--bw8 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw8 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.card--xlarge.with-bgcolor--bw8 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--bw7 .card__content__left:after,.card.with-bgcolor--bw7 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#8a8f99),to(hsla(220,7%,57%,0)));background-image:-webkit-linear-gradient(right,#8a8f99,hsla(220,7%,57%,0));background-image:-o-linear-gradient(right,#8a8f99,hsla(220,7%,57%,0));background-image:linear-gradient(270deg,#8a8f99,hsla(220,7%,57%,0))}.card.with-bgcolor--bw7 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#8a8f99),to(hsla(220,7%,57%,0)));background-image:-webkit-linear-gradient(left,#8a8f99,hsla(220,7%,57%,0));background-image:-o-linear-gradient(left,#8a8f99,hsla(220,7%,57%,0));background-image:linear-gradient(90deg,#8a8f99,hsla(220,7%,57%,0))}.card.with-bgcolor--bw7 .card__content__right{background-color:#8a8f99}.card.card--xlarge.with-bgcolor--bw7 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw7 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#8a8f99),to(hsla(220,7%,57%,0)));background-image:-webkit-linear-gradient(right,#8a8f99,hsla(220,7%,57%,0));background-image:-o-linear-gradient(right,#8a8f99,hsla(220,7%,57%,0));background-image:linear-gradient(270deg,#8a8f99,hsla(220,7%,57%,0))}.card.card--xlarge.with-bgcolor--bw7 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#8a8f99),to(hsla(220,7%,57%,0)));background-image:-webkit-linear-gradient(left,#8a8f99,hsla(220,7%,57%,0));background-image:-o-linear-gradient(left,#8a8f99,hsla(220,7%,57%,0));background-image:linear-gradient(90deg,#8a8f99,hsla(220,7%,57%,0))}.card.with-bgcolor--bw6 .card__content__left:after,.card.with-bgcolor--bw6 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#b1b8c4),to(rgba(177,184,196,0)));background-image:-webkit-linear-gradient(right,#b1b8c4,rgba(177,184,196,0));background-image:-o-linear-gradient(right,#b1b8c4,rgba(177,184,196,0));background-image:linear-gradient(270deg,#b1b8c4,rgba(177,184,196,0))}.card.with-bgcolor--bw6 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#b1b8c4),to(rgba(177,184,196,0)));background-image:-webkit-linear-gradient(left,#b1b8c4,rgba(177,184,196,0));background-image:-o-linear-gradient(left,#b1b8c4,rgba(177,184,196,0));background-image:linear-gradient(90deg,#b1b8c4,rgba(177,184,196,0))}.card.with-bgcolor--bw6 .card__content__right{background-color:#b1b8c4}.card.card--xlarge.with-bgcolor--bw6 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw6 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#b1b8c4),to(rgba(177,184,196,0)));background-image:-webkit-linear-gradient(right,#b1b8c4,rgba(177,184,196,0));background-image:-o-linear-gradient(right,#b1b8c4,rgba(177,184,196,0));background-image:linear-gradient(270deg,#b1b8c4,rgba(177,184,196,0))}.card.card--xlarge.with-bgcolor--bw6 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#b1b8c4),to(rgba(177,184,196,0)));background-image:-webkit-linear-gradient(left,#b1b8c4,rgba(177,184,196,0));background-image:-o-linear-gradient(left,#b1b8c4,rgba(177,184,196,0));background-image:linear-gradient(90deg,#b1b8c4,rgba(177,184,196,0))}.card.with-bgcolor--bw5 .card__content__left:after,.card.with-bgcolor--bw5 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#d2d9e1),to(rgba(210,217,225,0)));background-image:-webkit-linear-gradient(right,#d2d9e1,rgba(210,217,225,0));background-image:-o-linear-gradient(right,#d2d9e1,rgba(210,217,225,0));background-image:linear-gradient(270deg,#d2d9e1,rgba(210,217,225,0))}.card.with-bgcolor--bw5 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#d2d9e1),to(rgba(210,217,225,0)));background-image:-webkit-linear-gradient(left,#d2d9e1,rgba(210,217,225,0));background-image:-o-linear-gradient(left,#d2d9e1,rgba(210,217,225,0));background-image:linear-gradient(90deg,#d2d9e1,rgba(210,217,225,0))}.card.with-bgcolor--bw5 .card__content__right{background-color:#d2d9e1}.card.card--xlarge.with-bgcolor--bw5 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw5 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#d2d9e1),to(rgba(210,217,225,0)));background-image:-webkit-linear-gradient(right,#d2d9e1,rgba(210,217,225,0));background-image:-o-linear-gradient(right,#d2d9e1,rgba(210,217,225,0));background-image:linear-gradient(270deg,#d2d9e1,rgba(210,217,225,0))}.card.card--xlarge.with-bgcolor--bw5 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#d2d9e1),to(rgba(210,217,225,0)));background-image:-webkit-linear-gradient(left,#d2d9e1,rgba(210,217,225,0));background-image:-o-linear-gradient(left,#d2d9e1,rgba(210,217,225,0));background-image:linear-gradient(90deg,#d2d9e1,rgba(210,217,225,0))}.card.with-bgcolor--bw4 .card__content__left:after,.card.with-bgcolor--bw4 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#e4e8ed),to(rgba(228,232,237,0)));background-image:-webkit-linear-gradient(right,#e4e8ed,rgba(228,232,237,0));background-image:-o-linear-gradient(right,#e4e8ed,rgba(228,232,237,0));background-image:linear-gradient(270deg,#e4e8ed,rgba(228,232,237,0))}.card.with-bgcolor--bw4 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#e4e8ed),to(rgba(228,232,237,0)));background-image:-webkit-linear-gradient(left,#e4e8ed,rgba(228,232,237,0));background-image:-o-linear-gradient(left,#e4e8ed,rgba(228,232,237,0));background-image:linear-gradient(90deg,#e4e8ed,rgba(228,232,237,0))}.card.with-bgcolor--bw4 .card__content__right{background-color:#e4e8ed}.card.card--xlarge.with-bgcolor--bw4 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw4 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#e4e8ed),to(rgba(228,232,237,0)));background-image:-webkit-linear-gradient(right,#e4e8ed,rgba(228,232,237,0));background-image:-o-linear-gradient(right,#e4e8ed,rgba(228,232,237,0));background-image:linear-gradient(270deg,#e4e8ed,rgba(228,232,237,0))}.card.card--xlarge.with-bgcolor--bw4 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#e4e8ed),to(rgba(228,232,237,0)));background-image:-webkit-linear-gradient(left,#e4e8ed,rgba(228,232,237,0));background-image:-o-linear-gradient(left,#e4e8ed,rgba(228,232,237,0));background-image:linear-gradient(90deg,#e4e8ed,rgba(228,232,237,0))}.card.with-bgcolor--bw3 .card__content__left:after,.card.with-bgcolor--bw3 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(270deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--bw3 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(90deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--bw3 .card__content__right{background-color:#f0f6fa}.card.card--xlarge.with-bgcolor--bw3 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw3 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(270deg,#f0f6fa,rgba(240,246,250,0))}.card.card--xlarge.with-bgcolor--bw3 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(90deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--bw2 .card__content__left:after,.card.with-bgcolor--bw2 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f9fafb),to(rgba(249,250,251,0)));background-image:-webkit-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:-o-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:linear-gradient(270deg,#f9fafb,rgba(249,250,251,0))}.card.with-bgcolor--bw2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f9fafb),to(rgba(249,250,251,0)));background-image:-webkit-linear-gradient(left,#f9fafb,rgba(249,250,251,0));background-image:-o-linear-gradient(left,#f9fafb,rgba(249,250,251,0));background-image:linear-gradient(90deg,#f9fafb,rgba(249,250,251,0))}.card.with-bgcolor--bw2 .card__content__right{background-color:#f9fafb}.card.card--xlarge.with-bgcolor--bw2 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw2 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#f9fafb),to(rgba(249,250,251,0)));background-image:-webkit-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:-o-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:linear-gradient(270deg,#f9fafb,rgba(249,250,251,0))}.card.card--xlarge.with-bgcolor--bw2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f9fafb),to(rgba(249,250,251,0)));background-image:-webkit-linear-gradient(left,#f9fafb,rgba(249,250,251,0));background-image:-o-linear-gradient(left,#f9fafb,rgba(249,250,251,0));background-image:linear-gradient(90deg,#f9fafb,rgba(249,250,251,0))}.card.with-bgcolor--bw1 .card__content__left:after,.card.with-bgcolor--bw1 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(270deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--bw1 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--bw1 .card__content__right{background-color:#fff}.card.card--xlarge.with-bgcolor--bw1 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--bw1 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(270deg,#fff,hsla(0,0%,100%,0))}.card.card--xlarge.with-bgcolor--bw1 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--white .card__content__left:after,.card.with-bgcolor--white .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(270deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--white .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--white .card__content__right{background-color:#fff}.card.card--xlarge.with-bgcolor--white .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--white .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(270deg,#fff,hsla(0,0%,100%,0))}.card.card--xlarge.with-bgcolor--white .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(left,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.card.with-bgcolor--accent .card__content__left:after,.card.with-bgcolor--accent .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#4487ff),to(rgba(68,135,255,0)));background-image:-webkit-linear-gradient(right,#4487ff,rgba(68,135,255,0));background-image:-o-linear-gradient(right,#4487ff,rgba(68,135,255,0));background-image:linear-gradient(270deg,#4487ff,rgba(68,135,255,0))}.card.with-bgcolor--accent .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#4487ff),to(rgba(68,135,255,0)));background-image:-webkit-linear-gradient(left,#4487ff,rgba(68,135,255,0));background-image:-o-linear-gradient(left,#4487ff,rgba(68,135,255,0));background-image:linear-gradient(90deg,#4487ff,rgba(68,135,255,0))}.card.with-bgcolor--accent .card__content__right{background-color:#4487ff}.card.card--xlarge.with-bgcolor--accent .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--accent .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#4487ff),to(rgba(68,135,255,0)));background-image:-webkit-linear-gradient(right,#4487ff,rgba(68,135,255,0));background-image:-o-linear-gradient(right,#4487ff,rgba(68,135,255,0));background-image:linear-gradient(270deg,#4487ff,rgba(68,135,255,0))}.card.card--xlarge.with-bgcolor--accent .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#4487ff),to(rgba(68,135,255,0)));background-image:-webkit-linear-gradient(left,#4487ff,rgba(68,135,255,0));background-image:-o-linear-gradient(left,#4487ff,rgba(68,135,255,0));background-image:linear-gradient(90deg,#4487ff,rgba(68,135,255,0))}.card.with-bgcolor--accent-subtle .card__content__left:after,.card.with-bgcolor--accent-subtle .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f5faff),to(rgba(245,250,255,0)));background-image:-webkit-linear-gradient(right,#f5faff,rgba(245,250,255,0));background-image:-o-linear-gradient(right,#f5faff,rgba(245,250,255,0));background-image:linear-gradient(270deg,#f5faff,rgba(245,250,255,0))}.card.with-bgcolor--accent-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f5faff),to(rgba(245,250,255,0)));background-image:-webkit-linear-gradient(left,#f5faff,rgba(245,250,255,0));background-image:-o-linear-gradient(left,#f5faff,rgba(245,250,255,0));background-image:linear-gradient(90deg,#f5faff,rgba(245,250,255,0))}.card.with-bgcolor--accent-subtle .card__content__right{background-color:#f5faff}.card.card--xlarge.with-bgcolor--accent-subtle .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--accent-subtle .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#f5faff),to(rgba(245,250,255,0)));background-image:-webkit-linear-gradient(right,#f5faff,rgba(245,250,255,0));background-image:-o-linear-gradient(right,#f5faff,rgba(245,250,255,0));background-image:linear-gradient(270deg,#f5faff,rgba(245,250,255,0))}.card.card--xlarge.with-bgcolor--accent-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f5faff),to(rgba(245,250,255,0)));background-image:-webkit-linear-gradient(left,#f5faff,rgba(245,250,255,0));background-image:-o-linear-gradient(left,#f5faff,rgba(245,250,255,0));background-image:linear-gradient(90deg,#f5faff,rgba(245,250,255,0))}.card.with-bgcolor--accent-subtle2 .card__content__left:after,.card.with-bgcolor--accent-subtle2 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(270deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--accent-subtle2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(90deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--accent-subtle2 .card__content__right{background-color:#f0f6fa}.card.card--xlarge.with-bgcolor--accent-subtle2 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--accent-subtle2 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(270deg,#f0f6fa,rgba(240,246,250,0))}.card.card--xlarge.with-bgcolor--accent-subtle2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(left,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(90deg,#f0f6fa,rgba(240,246,250,0))}.card.with-bgcolor--accent2 .card__content__left:after,.card.with-bgcolor--accent2 .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#735aff),to(rgba(115,90,255,0)));background-image:-webkit-linear-gradient(right,#735aff,rgba(115,90,255,0));background-image:-o-linear-gradient(right,#735aff,rgba(115,90,255,0));background-image:linear-gradient(270deg,#735aff,rgba(115,90,255,0))}.card.with-bgcolor--accent2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#735aff),to(rgba(115,90,255,0)));background-image:-webkit-linear-gradient(left,#735aff,rgba(115,90,255,0));background-image:-o-linear-gradient(left,#735aff,rgba(115,90,255,0));background-image:linear-gradient(90deg,#735aff,rgba(115,90,255,0))}.card.with-bgcolor--accent2 .card__content__right{background-color:#735aff}.card.card--xlarge.with-bgcolor--accent2 .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--accent2 .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#735aff),to(rgba(115,90,255,0)));background-image:-webkit-linear-gradient(right,#735aff,rgba(115,90,255,0));background-image:-o-linear-gradient(right,#735aff,rgba(115,90,255,0));background-image:linear-gradient(270deg,#735aff,rgba(115,90,255,0))}.card.card--xlarge.with-bgcolor--accent2 .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#735aff),to(rgba(115,90,255,0)));background-image:-webkit-linear-gradient(left,#735aff,rgba(115,90,255,0));background-image:-o-linear-gradient(left,#735aff,rgba(115,90,255,0));background-image:linear-gradient(90deg,#735aff,rgba(115,90,255,0))}.card.with-bgcolor--dangerous .card__content__left:after,.card.with-bgcolor--dangerous .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f75b5b),to(rgba(247,91,91,0)));background-image:-webkit-linear-gradient(right,#f75b5b,rgba(247,91,91,0));background-image:-o-linear-gradient(right,#f75b5b,rgba(247,91,91,0));background-image:linear-gradient(270deg,#f75b5b,rgba(247,91,91,0))}.card.with-bgcolor--dangerous .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f75b5b),to(rgba(247,91,91,0)));background-image:-webkit-linear-gradient(left,#f75b5b,rgba(247,91,91,0));background-image:-o-linear-gradient(left,#f75b5b,rgba(247,91,91,0));background-image:linear-gradient(90deg,#f75b5b,rgba(247,91,91,0))}.card.with-bgcolor--dangerous .card__content__right{background-color:#f75b5b}.card.card--xlarge.with-bgcolor--dangerous .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--dangerous .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#f75b5b),to(rgba(247,91,91,0)));background-image:-webkit-linear-gradient(right,#f75b5b,rgba(247,91,91,0));background-image:-o-linear-gradient(right,#f75b5b,rgba(247,91,91,0));background-image:linear-gradient(270deg,#f75b5b,rgba(247,91,91,0))}.card.card--xlarge.with-bgcolor--dangerous .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#f75b5b),to(rgba(247,91,91,0)));background-image:-webkit-linear-gradient(left,#f75b5b,rgba(247,91,91,0));background-image:-o-linear-gradient(left,#f75b5b,rgba(247,91,91,0));background-image:linear-gradient(90deg,#f75b5b,rgba(247,91,91,0))}.card.with-bgcolor--dangerous-subtle .card__content__left:after,.card.with-bgcolor--dangerous-subtle .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff5f5),to(hsla(0,100%,98%,0)));background-image:-webkit-linear-gradient(right,#fff5f5,hsla(0,100%,98%,0));background-image:-o-linear-gradient(right,#fff5f5,hsla(0,100%,98%,0));background-image:linear-gradient(270deg,#fff5f5,hsla(0,100%,98%,0))}.card.with-bgcolor--dangerous-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff5f5),to(hsla(0,100%,98%,0)));background-image:-webkit-linear-gradient(left,#fff5f5,hsla(0,100%,98%,0));background-image:-o-linear-gradient(left,#fff5f5,hsla(0,100%,98%,0));background-image:linear-gradient(90deg,#fff5f5,hsla(0,100%,98%,0))}.card.with-bgcolor--dangerous-subtle .card__content__right{background-color:#fff5f5}.card.card--xlarge.with-bgcolor--dangerous-subtle .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--dangerous-subtle .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#fff5f5),to(hsla(0,100%,98%,0)));background-image:-webkit-linear-gradient(right,#fff5f5,hsla(0,100%,98%,0));background-image:-o-linear-gradient(right,#fff5f5,hsla(0,100%,98%,0));background-image:linear-gradient(270deg,#fff5f5,hsla(0,100%,98%,0))}.card.card--xlarge.with-bgcolor--dangerous-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#fff5f5),to(hsla(0,100%,98%,0)));background-image:-webkit-linear-gradient(left,#fff5f5,hsla(0,100%,98%,0));background-image:-o-linear-gradient(left,#fff5f5,hsla(0,100%,98%,0));background-image:linear-gradient(90deg,#fff5f5,hsla(0,100%,98%,0))}.card.with-bgcolor--positive .card__content__left:after,.card.with-bgcolor--positive .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#75dbbe),to(rgba(117,219,190,0)));background-image:-webkit-linear-gradient(right,#75dbbe,rgba(117,219,190,0));background-image:-o-linear-gradient(right,#75dbbe,rgba(117,219,190,0));background-image:linear-gradient(270deg,#75dbbe,rgba(117,219,190,0))}.card.with-bgcolor--positive .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#75dbbe),to(rgba(117,219,190,0)));background-image:-webkit-linear-gradient(left,#75dbbe,rgba(117,219,190,0));background-image:-o-linear-gradient(left,#75dbbe,rgba(117,219,190,0));background-image:linear-gradient(90deg,#75dbbe,rgba(117,219,190,0))}.card.with-bgcolor--positive .card__content__right{background-color:#75dbbe}.card.card--xlarge.with-bgcolor--positive .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--positive .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#75dbbe),to(rgba(117,219,190,0)));background-image:-webkit-linear-gradient(right,#75dbbe,rgba(117,219,190,0));background-image:-o-linear-gradient(right,#75dbbe,rgba(117,219,190,0));background-image:linear-gradient(270deg,#75dbbe,rgba(117,219,190,0))}.card.card--xlarge.with-bgcolor--positive .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#75dbbe),to(rgba(117,219,190,0)));background-image:-webkit-linear-gradient(left,#75dbbe,rgba(117,219,190,0));background-image:-o-linear-gradient(left,#75dbbe,rgba(117,219,190,0));background-image:linear-gradient(90deg,#75dbbe,rgba(117,219,190,0))}.card.with-bgcolor--positive-subtle .card__content__left:after,.card.with-bgcolor--positive-subtle .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#e8faf5),to(rgba(232,250,245,0)));background-image:-webkit-linear-gradient(right,#e8faf5,rgba(232,250,245,0));background-image:-o-linear-gradient(right,#e8faf5,rgba(232,250,245,0));background-image:linear-gradient(270deg,#e8faf5,rgba(232,250,245,0))}.card.with-bgcolor--positive-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#e8faf5),to(rgba(232,250,245,0)));background-image:-webkit-linear-gradient(left,#e8faf5,rgba(232,250,245,0));background-image:-o-linear-gradient(left,#e8faf5,rgba(232,250,245,0));background-image:linear-gradient(90deg,#e8faf5,rgba(232,250,245,0))}.card.with-bgcolor--positive-subtle .card__content__right{background-color:#e8faf5}.card.card--xlarge.with-bgcolor--positive-subtle .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--positive-subtle .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#e8faf5),to(rgba(232,250,245,0)));background-image:-webkit-linear-gradient(right,#e8faf5,rgba(232,250,245,0));background-image:-o-linear-gradient(right,#e8faf5,rgba(232,250,245,0));background-image:linear-gradient(270deg,#e8faf5,rgba(232,250,245,0))}.card.card--xlarge.with-bgcolor--positive-subtle .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#e8faf5),to(rgba(232,250,245,0)));background-image:-webkit-linear-gradient(left,#e8faf5,rgba(232,250,245,0));background-image:-o-linear-gradient(left,#e8faf5,rgba(232,250,245,0));background-image:linear-gradient(90deg,#e8faf5,rgba(232,250,245,0))}.card.with-bgcolor--default .card__content__left:after,.card.with-bgcolor--default .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--default .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--default .card__content__right{background-color:#101015}.card.card--xlarge.with-bgcolor--default .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--default .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(right,#101015,rgba(16,16,21,0));background-image:linear-gradient(270deg,#101015,rgba(16,16,21,0))}.card.card--xlarge.with-bgcolor--default .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(#101015),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:-o-linear-gradient(left,#101015,rgba(16,16,21,0));background-image:linear-gradient(90deg,#101015,rgba(16,16,21,0))}.card.with-bgcolor--transparent .card__content__left:after,.card.with-bgcolor--transparent .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(right,transparent,transparent);background-image:-o-linear-gradient(right,transparent,transparent);background-image:linear-gradient(270deg,transparent,transparent)}.card.with-bgcolor--transparent .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(left,transparent,transparent);background-image:-o-linear-gradient(left,transparent,transparent);background-image:linear-gradient(90deg,transparent,transparent)}.card.with-bgcolor--transparent .card__content__right{background-color:transparent}.card.card--xlarge.with-bgcolor--transparent .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--transparent .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(right,transparent,transparent);background-image:-o-linear-gradient(right,transparent,transparent);background-image:linear-gradient(270deg,transparent,transparent)}.card.card--xlarge.with-bgcolor--transparent .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(left,transparent,transparent);background-image:-o-linear-gradient(left,transparent,transparent);background-image:linear-gradient(90deg,transparent,transparent)}.card.with-bgcolor--none .card__content__left:after,.card.with-bgcolor--none .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(right,transparent,transparent);background-image:-o-linear-gradient(right,transparent,transparent);background-image:linear-gradient(270deg,transparent,transparent)}.card.with-bgcolor--none .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(left,transparent,transparent);background-image:-o-linear-gradient(left,transparent,transparent);background-image:linear-gradient(90deg,transparent,transparent)}.card.with-bgcolor--none .card__content__right{background-color:transparent}.card.card--xlarge.with-bgcolor--none .card__content__right:before{background-image:none}.card.card--xlarge.with-bgcolor--none .card__content__right.hover:before{background-image:-webkit-gradient(linear,right top,left top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(right,transparent,transparent);background-image:-o-linear-gradient(right,transparent,transparent);background-image:linear-gradient(270deg,transparent,transparent)}.card.card--xlarge.with-bgcolor--none .card__title:before{background-image:-webkit-gradient(linear,left top,right top,from(transparent),to(transparent));background-image:-webkit-linear-gradient(left,transparent,transparent);background-image:-o-linear-gradient(left,transparent,transparent);background-image:linear-gradient(90deg,transparent,transparent)}.card.card--xlarge.with-bgcolor--bw3 .card__content__left.hover:before,.card.card--xlarge.with-bgcolor--bw3 .card__content__left:after,.card.card--xlarge.with-bgcolor--bw3 .card__content__right,.card.card--xlarge.with-bgcolor--bw3 .card__content__right.hover:before,.card.card--xlarge.with-bgcolor--bw3 .card__title:before{background-color:transparent;background-image:none}.card--xsmall{height:72px}.card--xsmall .card__content__left{padding-top:8px;padding-bottom:8px;padding-left:8px}.card--xsmall.with-bgcolor--black .card__background,.card--xsmall.with-bgcolor--bw8 .card__background,.card--xsmall.with-bgcolor--dark .card__background{background-color:#101015}.card--xsmall.with-bgcolor--bw7 .card__background{background-color:#8a8f99}.card--xsmall.with-bgcolor--bw6 .card__background{background-color:#b1b8c4}.card--xsmall.with-bgcolor--bw5 .card__background{background-color:#d2d9e1}.card--xsmall.with-bgcolor--bw4 .card__background{background-color:#e4e8ed}.card--xsmall.with-bgcolor--bw3 .card__background{background-color:#f0f6fa}.card--xsmall.with-bgcolor--bw2 .card__background{background-color:#f9fafb}.card--xsmall.with-bgcolor--bw1 .card__background,.card--xsmall.with-bgcolor--white .card__background{background-color:#fff}.card--xsmall.with-bgcolor--accent .card__background{background-color:#4487ff}.card--xsmall.with-bgcolor--accent-subtle .card__background{background-color:#f5faff}.card--xsmall.with-bgcolor--accent-subtle2 .card__background{background-color:#f0f6fa}.card--xsmall.with-bgcolor--accent2 .card__background{background-color:#735aff}.card--xsmall.with-bgcolor--dangerous .card__background{background-color:#f75b5b}.card--xsmall.with-bgcolor--dangerous-subtle .card__background{background-color:#fff5f5}.card--xsmall.with-bgcolor--positive .card__background{background-color:#75dbbe}.card--xsmall.with-bgcolor--positive-subtle .card__background{background-color:#e8faf5}.card--xsmall.with-bgcolor--default .card__background{background-color:#101015}.card--xsmall.with-bgcolor--none .card__background,.card--xsmall.with-bgcolor--transparent .card__background{background-color:transparent}.card--xsmall .card__background{border-radius:8px;-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-webkit-transform:translateZ(0);transform:translateZ(0)}.card--xsmall .card__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.card--xsmall .card__image{max-width:56px;width:35%}.card--xsmall .card__image,.card--xsmall .card__image .thumbnail__inner{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out}.card--xsmall .card__content{margin-left:8px}.card--xsmall .card__content__left{position:absolute;top:50%;right:0;left:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.card--xsmall .card__content__right{top:4px;bottom:4px}.card--xsmall:not(.card--listened) .card__background:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;-webkit-box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);content:\"\";z-index:-1;-webkit-transition:opacity .15s ease-in-out;-o-transition:opacity .15s ease-in-out;transition:opacity .15s ease-in-out}.card--xsmall.card--is-playing .card__background{border:2px solid #4487ff;-webkit-animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite;animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite}@-webkit-keyframes bounce-card{0%{-webkit-transform:scale(1.01);transform:scale(1.01)}50%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1.01);transform:scale(1.01)}}.card--xsmall.card--is-playing .card__background:after,.card--xsmall.card--is-playing .card__image .thumbnail__inner:after{opacity:0}.card--xsmall.card--is-playing .card__image .thumbnail__inner{-webkit-transform:scale(.98);-ms-transform:scale(.98);transform:scale(.98)}.card--xsmall.card--is-selected .card__background{border:2px solid #4487ff}.card--xsmall.card--is-selected .card__background:after,.card--xsmall.card--is-selected .card__image:after{opacity:0}.card--xsmall.card--listened:not(.card--is-playing):not(.card--is-selected) .card__background{border:1px solid #e4e8ed}.card--small{height:104px;padding-right:16px;padding-left:16px}.card--small .card__content__left{padding-top:8px;padding-bottom:8px;padding-left:8px}.card--small.with-bgcolor--black .card__background,.card--small.with-bgcolor--bw8 .card__background,.card--small.with-bgcolor--dark .card__background{background-color:#101015}.card--small.with-bgcolor--bw7 .card__background{background-color:#8a8f99}.card--small.with-bgcolor--bw6 .card__background{background-color:#b1b8c4}.card--small.with-bgcolor--bw5 .card__background{background-color:#d2d9e1}.card--small.with-bgcolor--bw4 .card__background{background-color:#e4e8ed}.card--small.with-bgcolor--bw3 .card__background{background-color:#f0f6fa}.card--small.with-bgcolor--bw2 .card__background{background-color:#f9fafb}.card--small.with-bgcolor--bw1 .card__background,.card--small.with-bgcolor--white .card__background{background-color:#fff}.card--small.with-bgcolor--accent .card__background{background-color:#4487ff}.card--small.with-bgcolor--accent-subtle .card__background{background-color:#f5faff}.card--small.with-bgcolor--accent-subtle2 .card__background{background-color:#f0f6fa}.card--small.with-bgcolor--accent2 .card__background{background-color:#735aff}.card--small.with-bgcolor--dangerous .card__background{background-color:#f75b5b}.card--small.with-bgcolor--dangerous-subtle .card__background{background-color:#fff5f5}.card--small.with-bgcolor--positive .card__background{background-color:#75dbbe}.card--small.with-bgcolor--positive-subtle .card__background{background-color:#e8faf5}.card--small.with-bgcolor--default .card__background{background-color:#101015}.card--small.with-bgcolor--none .card__background,.card--small.with-bgcolor--transparent .card__background{background-color:transparent}.card--small .card__background{border-radius:8px;-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-webkit-transform:translateZ(0);transform:translateZ(0)}.card--small .card__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.card--small .card__image{max-width:72px;width:35%}.card--small .card__image,.card--small .card__image .thumbnail__inner{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out}.card--small .card__content{margin-left:8px}.card--small .card__content__left{position:absolute;top:50%;right:0;left:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.card--small .card__content__right{top:4px;bottom:4px}.card--small:not(.card--listened) .card__background:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;-webkit-box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);content:\"\";z-index:-1;-webkit-transition:opacity .15s ease-in-out;-o-transition:opacity .15s ease-in-out;transition:opacity .15s ease-in-out}.card--small.card--is-playing .card__background{border:2px solid #4487ff;-webkit-animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite;animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite}.card--small.card--is-playing .card__background:after,.card--small.card--is-playing .card__image .thumbnail__inner:after{opacity:0}.card--small.card--is-playing .card__image .thumbnail__inner{-webkit-transform:scale(.98);-ms-transform:scale(.98);transform:scale(.98)}.card--small.card--is-selected .card__background{border:2px solid #4487ff}.card--small.card--is-selected .card__background:after,.card--small.card--is-selected .card__image:after{opacity:0}.card--small.card--listened:not(.card--is-playing):not(.card--is-selected) .card__background{border:1px solid #e4e8ed}.card--small .card__content__left{right:15%}.card--medium{height:144px;padding-right:24px;padding-left:24px}.card--medium .card__content__left{padding-top:8px;padding-bottom:8px;padding-left:24px;width:70%}.card--medium.with-bgcolor--black .card__background,.card--medium.with-bgcolor--bw8 .card__background,.card--medium.with-bgcolor--dark .card__background{background-color:#101015}.card--medium.with-bgcolor--bw7 .card__background{background-color:#8a8f99}.card--medium.with-bgcolor--bw6 .card__background{background-color:#b1b8c4}.card--medium.with-bgcolor--bw5 .card__background{background-color:#d2d9e1}.card--medium.with-bgcolor--bw4 .card__background{background-color:#e4e8ed}.card--medium.with-bgcolor--bw3 .card__background{background-color:#f0f6fa}.card--medium.with-bgcolor--bw2 .card__background{background-color:#f9fafb}.card--medium.with-bgcolor--bw1 .card__background,.card--medium.with-bgcolor--white .card__background{background-color:#fff}.card--medium.with-bgcolor--accent .card__background{background-color:#4487ff}.card--medium.with-bgcolor--accent-subtle .card__background{background-color:#f5faff}.card--medium.with-bgcolor--accent-subtle2 .card__background{background-color:#f0f6fa}.card--medium.with-bgcolor--accent2 .card__background{background-color:#735aff}.card--medium.with-bgcolor--dangerous .card__background{background-color:#f75b5b}.card--medium.with-bgcolor--dangerous-subtle .card__background{background-color:#fff5f5}.card--medium.with-bgcolor--positive .card__background{background-color:#75dbbe}.card--medium.with-bgcolor--positive-subtle .card__background{background-color:#e8faf5}.card--medium.with-bgcolor--default .card__background{background-color:#101015}.card--medium.with-bgcolor--none .card__background,.card--medium.with-bgcolor--transparent .card__background{background-color:transparent}.card--medium .card__background{border-radius:8px;-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-webkit-transform:translateZ(0);transform:translateZ(0)}.card--medium .card__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.card--medium .card__image{max-width:104px;width:35%}.card--medium .card__image,.card--medium .card__image .thumbnail__inner{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out}.card--medium .card__content{margin-left:8px}.card--medium .card__content__left{position:absolute;top:50%;right:0;left:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.card--medium .card__content__right{top:4px;bottom:4px}.card--medium:not(.card--listened) .card__background:after{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;-webkit-box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);box-shadow:0 3px 30px -10px hsla(220,7%,57%,.5);content:\"\";z-index:-1;-webkit-transition:opacity .15s ease-in-out;-o-transition:opacity .15s ease-in-out;transition:opacity .15s ease-in-out}.card--medium.card--is-playing .card__background{border:2px solid #4487ff;-webkit-animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite;animation:bounce-card .75s cubic-bezier(.175,.885,.32,1.275) infinite}@keyframes bounce-card{0%{-webkit-transform:scale(1.01);transform:scale(1.01)}50%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1.01);transform:scale(1.01)}}.card--medium.card--is-playing .card__background:after,.card--medium.card--is-playing .card__image .thumbnail__inner:after{opacity:0}.card--medium.card--is-playing .card__image .thumbnail__inner{-webkit-transform:scale(.98);-ms-transform:scale(.98);transform:scale(.98)}.card--medium.card--is-selected .card__background{border:2px solid #4487ff}.card--medium.card--is-selected .card__background:after,.card--medium.card--is-selected .card__image:after{opacity:0}.card--medium.card--listened:not(.card--is-playing):not(.card--is-selected) .card__background{border:1px solid #e4e8ed}.card--xlarge{min-width:160px;max-width:256px}.card--xlarge .card__content__left{padding-top:8px;padding-bottom:8px;padding-left:8px}.card--xlarge .card__background{display:none}.card--xlarge .card__wrapper{position:absolute;top:0;right:0;bottom:0;left:0}.card--xlarge:before{content:\"\";display:block;width:100%;padding-top:120%}.card--xlarge:hover .card__image{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}.card--xlarge:hover .card__image:after{opacity:.5}.card--xlarge .card__image{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-transform-origin:bottom center;-ms-transform-origin:bottom center;transform-origin:bottom center;height:83.3333%}.card--xlarge .card__image:after{-webkit-transition:opacity .25s;-o-transition:opacity .25s;transition:opacity .25s}.card--xlarge .card__content{height:16.6667%;margin-left:0}.card--xlarge .card__content__right{top:0;bottom:0}.card__background{position:absolute;top:0;right:0;bottom:0;left:0}.card .card-play-button{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out}html.no-touchevents .card:not(.card--is-playing) .card-play-button{opacity:0}html.no-touchevents .card:hover .card-play-button{opacity:1}.card__content__right{z-index:auto}.card__content hr{z-index:3}.card__image{z-index:auto;-webkit-box-flex:0;-ms-flex:none;flex:none}.card__content{-webkit-box-flex:1;-ms-flex:auto;flex:auto;-ms-flex-item-align:stretch;align-self:stretch;cursor:pointer}.card__content__left{overflow:hidden}.card__content__left:after{position:absolute;top:0;right:0;bottom:0;content:\"\";width:40px}.card__content__right{position:absolute;right:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card--xlarge .card__content__right>.add-to-cart-button,.card__content__right .card__options>:not(.add-to-cart-button):not(.card__price-element){display:none;visibility:hidden;opacity:0;-webkit-transition:opacity .25s ease-in-out;-o-transition:.25s opacity ease-in-out;transition:opacity .25s ease-in-out}.card__content__right:before{position:absolute;top:0;bottom:0;left:-40px;content:\"\";width:40px}.card__content__right.hover .card__options>:not(.add-to-cart-button):not(.card__price-element){display:block;visibility:visible;opacity:1}.card__content hr{background-color:#e4e8ed;-ms-flex-preferred-size:100%;flex-basis:100%;height:1px;border:0;margin:0;-ms-flex-item-align:start;align-self:flex-start;top:-1px}.card__subtitle,.card__title{display:block;max-width:80%}.card--xlarge .card__subtitle,.card--xlarge .card__title{white-space:normal;max-width:60%}.card__title{margin:0}.card--listened .card__title{color:#8a8f99}.card--is-playing .card__title{color:#4487ff}.card__options{z-index:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.card__options .card__price-element{margin-left:8px}.card__options .card__price-element.button--icon{border-radius:12px;width:40px}.card__options .add-to-cart-button,.card__options .card__download,.card__options .card__find-similar{margin-left:8px}.card__options .button--medium.card__add-to-project .button__wrapper{padding:11px 14px}.card__option .icon--project-selected,.card__option:not([class*=color-scheme]):hover{color:#4487ff}.card__in-project-indicator{position:absolute;top:4px;right:4px;height:16px;width:16px;color:#4487ff;z-index:1000000}.card__in-project-indicator svg{height:100%;width:100%}.card--animating-overflow .card__title{padding-left:8px;left:-8px;width:calc(100% + 8px)}.card--animating-overflow .card__title:before{position:absolute;top:0;bottom:0;left:0;content:\"\";width:16px;z-index:1}.card .button.button--is-active .button__active-background{display:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/media/Card/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/media/Card/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA8GA,MACE,mCAAA,8BAAA,0BAA2B,CAD7B,4GAOQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAPnF,8CAUQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAVpF,gDAaQ,wBCvHkB,CD0G1B,oEAmBQ,qBAAsB,CAnB9B,0EAsBQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAtBnF,2DAyBQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAzBpF,0GAOQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAPnF,6CAUQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAVpF,+CAaQ,wBCvHkB,CD0G1B,mEAmBQ,qBAAsB,CAnB9B,yEAsBQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAtBnF,0DAyBQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAzBpF,wGAOQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAPnF,4CAUQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAVpF,8CAaQ,wBCvHkB,CD0G1B,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAtBnF,yDAyBQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAzBpF,wGAOQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAPnF,4CAUQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAVpF,8CAaQ,wBCrHgB,CDwGxB,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAtBnF,yDAyBQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAzBpF,wGAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,4CAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,8CAaQ,wBClHmB,CDqG3B,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,yDAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,wGAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,4CAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,8CAaQ,wBCjHe,CDoGvB,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,yDAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,wGAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,4CAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,8CAaQ,wBChHmB,CDmG3B,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,yDAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,wGAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,4CAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,8CAaQ,wBC3GmB,CD8F3B,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,yDAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,wGAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,4CAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,8CAaQ,wBC9GkB,CDiG1B,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,yDAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,wGAOQ,8FAAA,uEAAA,kEAAA,+DAA2E,CAPnF,4CAUQ,8FAAA,sEAAA,iEAAA,8DAA4E,CAVpF,8CAaQ,qBC1FI,CD6EZ,kEAmBQ,qBAAsB,CAnB9B,wEAsBQ,8FAAA,uEAAA,kEAAA,+DAA2E,CAtBnF,yDAyBQ,8FAAA,sEAAA,iEAAA,8DAA4E,CAzBpF,4GAOQ,8FAAA,uEAAA,kEAAA,+DAA2E,CAPnF,8CAUQ,8FAAA,sEAAA,iEAAA,8DAA4E,CAVpF,gDAaQ,qBCzFM,CD4Ed,oEAmBQ,qBAAsB,CAnB9B,0EAsBQ,8FAAA,uEAAA,kEAAA,+DAA2E,CAtBnF,2DAyBQ,8FAAA,sEAAA,iEAAA,8DAA4E,CAzBpF,8GAOQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAPnF,+CAUQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAVpF,iDAaQ,wBC7GmB,CDgG3B,qEAmBQ,qBAAsB,CAnB9B,2EAsBQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAtBnF,4DAyBQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAzBpF,4HAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,sDAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,wDAaQ,wBC5GkB,CD+F1B,4EAmBQ,qBAAsB,CAnB9B,kFAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,mEAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,8HAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,uDAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,yDAaQ,wBC3GmB,CD8F3B,6EAmBQ,qBAAsB,CAnB9B,mFAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,oEAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,gHAOQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAPnF,gDAUQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAVpF,kDAaQ,wBCtGwB,CDyFhC,sEAmBQ,qBAAsB,CAnB9B,4EAsBQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAtBnF,6DAyBQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAzBpF,oHAOQ,iGAAA,0EAAA,qEAAA,kEAA2E,CAPnF,kDAUQ,iGAAA,yEAAA,oEAAA,iEAA4E,CAVpF,oDAaQ,wBC1GkB,CD6F1B,wEAmBQ,qBAAsB,CAnB9B,8EAsBQ,iGAAA,0EAAA,qEAAA,kEAA2E,CAtBnF,+DAyBQ,iGAAA,yEAAA,oEAAA,iEAA4E,CAzBpF,kIAOQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAPnF,yDAUQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAVpF,2DAaQ,wBCzGgB,CD4FxB,+EAmBQ,qBAAsB,CAnB9B,qFAsBQ,kGAAA,2EAAA,sEAAA,mEAA2E,CAtBnF,sEAyBQ,kGAAA,0EAAA,qEAAA,kEAA4E,CAzBpF,kHAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,iDAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,mDAaQ,wBCxGgB,CD2FxB,uEAmBQ,qBAAsB,CAnB9B,6EAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,8DAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,gIAOQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAPnF,wDAUQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAVpF,0DAaQ,wBCvGc,CD0FtB,8EAmBQ,qBAAsB,CAnB9B,oFAsBQ,mGAAA,4EAAA,uEAAA,oEAA2E,CAtBnF,qEAyBQ,mGAAA,2EAAA,sEAAA,mEAA4E,CAzBpF,gHAOQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAPnF,gDAUQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAVpF,kDAaQ,wBCvHkB,CD0G1B,sEAmBQ,qBAAsB,CAnB9B,4EAsBQ,gGAAA,yEAAA,oEAAA,iEAA2E,CAtBnF,6DAyBQ,gGAAA,wEAAA,mEAAA,gEAA4E,CAzBpF,wHAOQ,+FAAA,wEAAA,mEAAA,gEAA2E,CAPnF,oDAUQ,+FAAA,uEAAA,kEAAA,+DAA4E,CAVpF,sDAaQ,4BC/EkB,CDkE1B,0EAmBQ,qBAAsB,CAnB9B,gFAsBQ,+FAAA,wEAAA,mEAAA,gEAA2E,CAtBnF,iEAyBQ,+FAAA,uEAAA,kEAAA,+DAA4E,CAzBpF,0GAOQ,+FAAA,wEAAA,mEAAA,gEAA2E,CAPnF,6CAUQ,+FAAA,uEAAA,kEAAA,+DAA4E,CAVpF,+CAaQ,4BC9EW,CDiEnB,mEAmBQ,qBAAsB,CAnB9B,yEAsBQ,+FAAA,wEAAA,mEAAA,gEAA2E,CAtBnF,0DAyBQ,+FAAA,uEAAA,kEAAA,+DAA4E,CAzBpF,mUAgCM,6BAA6B,qBACP,CACvB,cEvFD,WCtB6C,CHiH5C,mCIhEmB,gBDjDyB,mBAAA,gBAAA,CHiH5C,yJC3ED,wBArEsB,CDgJrB,kDC3ED,wBAnEoB,CD8InB,kDC3ED,wBAhEuB,CD2ItB,kDC3ED,wBA/DmB,CD0IlB,kDC3ED,wBA9DuB,CDyItB,kDC3ED,wBAzDuB,CDoItB,kDC3ED,wBA5DsB,CDuIrB,sGC3ED,qBAvCU,CDkHT,qDC3ED,wBA3DuB,CDsItB,4DC3ED,wBA1DsB,CDqIrB,6DC3ED,wBAzDuB,CDoItB,sDC3ED,wBApD4B,CD+H3B,wDC3ED,wBAxDsB,CDmIrB,+DC3ED,wBAvDoB,CDkInB,uDC3ED,wBAtDoB,CDiInB,8DC3ED,wBArDkB,CDgIjB,sDC3ED,wBArEsB,CDgJrB,6GC3ED,4BA5Be,CDuGd,gCKnHC,kBHoCA,4EAAA,oEAAA,+DAAA,4DAAA,qHACA,gCAAA,uBAAwB,CF8EzB,6BE1EC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,WACP,CFwEb,2BEpEC,eACA,SAAU,CFmEX,wEEhEG,oCAAA,+BAAA,2BAA4B,CFgE/B,6BE3DC,eCtD2C,CHiH5C,mCM1GH,kBJkDgC,QAAK,QAAE,OAAO,mCACxC,+BAAA,0BAA2B,CFuD9B,oCEnDG,QACA,UC/DyC,CHiH5C,2DM1GH,kBJoEgC,MAAG,QAAA,SAAA,OAAA,kBAE7B,wDAAA,gDAAgE,WACrD,WACA,4CACX,uCAAA,mCAAoC,CFiCvC,iDE3BG,yBD3GmB,8EC4GnB,qEAAmD,CACnD,+BACE,GAAI,8BAAA,qBAAsB,CAAA,IACrB,2BAAA,kBAAmB,CAAA,GAClB,8BAAA,qBAAsB,CAAA,CFsBjC,2HEhBa,SAAW,CFgBxB,8DEZG,6BAAA,yBAAA,oBAAqB,CFYxB,kDENG,wBDhImB,CDsItB,2GEDa,SAAW,CFCxB,8FEKG,wBD9ImB,CDyIvB,aE3FA,aCtB6C,mBAAA,iBAAA,CHiH5C,kCIhEmB,gBDjDyB,mBAAA,gBAAA,CHiH5C,sJC3ED,wBArEsB,CDgJrB,iDC3ED,wBAnEoB,CD8InB,iDC3ED,wBAhEuB,CD2ItB,iDC3ED,wBA/DmB,CD0IlB,iDC3ED,wBA9DuB,CDyItB,iDC3ED,wBAzDuB,CDoItB,iDC3ED,wBA5DsB,CDuIrB,oGC3ED,qBAvCU,CDkHT,oDC3ED,wBA3DuB,CDsItB,2DC3ED,wBA1DsB,CDqIrB,4DC3ED,wBAzDuB,CDoItB,qDC3ED,wBApD4B,CD+H3B,uDC3ED,wBAxDsB,CDmIrB,8DC3ED,wBAvDoB,CDkInB,sDC3ED,wBAtDoB,CDiInB,6DC3ED,wBArDkB,CDgIjB,qDC3ED,wBArEsB,CDgJrB,2GC3ED,4BA5Be,CDuGd,+BKnHC,kBHoCA,4EAAA,oEAAA,+DAAA,4DAAA,qHACA,gCAAA,uBAAwB,CF8EzB,4BE1EC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,WACP,CFwEb,0BEpEC,eACA,SAAU,CFmEX,sEEhEG,oCAAA,+BAAA,2BAA4B,CFgE/B,4BE3DC,eCtD2C,CHiH5C,kCM1GH,kBJkDgC,QAAK,QAAE,OAAO,mCACxC,+BAAA,0BAA2B,CFuD9B,mCEnDG,QACA,UC/DyC,CHiH5C,0DM1GH,kBJoEgC,MAAG,QAAA,SAAA,OAAA,kBAE7B,wDAAA,gDAAgE,WACrD,WACA,4CACX,uCAAA,mCAAoC,CFiCvC,gDE3BG,yBD3GmB,8EC4GnB,qEAAmD,CF0BtD,yHEhBa,SAAW,CFgBxB,6DEZG,6BAAA,yBAAA,oBAAqB,CFYxB,iDENG,wBDhImB,CDsItB,yGEDa,SAAW,CFCxB,6FEKG,wBD9ImB,CDyItB,kCEcuB,SAAW,CFdnC,cE3FA,aCtB6C,mBAAA,iBAAA,CHiH5C,mCIhEmB,gBDjDyB,mBAAA,kBDgBzC,SAAU,CFiGb,yJC3ED,wBArEsB,CDgJrB,kDC3ED,wBAnEoB,CD8InB,kDC3ED,wBAhEuB,CD2ItB,kDC3ED,wBA/DmB,CD0IlB,kDC3ED,wBA9DuB,CDyItB,kDC3ED,wBAzDuB,CDoItB,kDC3ED,wBA5DsB,CDuIrB,sGC3ED,qBAvCU,CDkHT,qDC3ED,wBA3DuB,CDsItB,4DC3ED,wBA1DsB,CDqIrB,6DC3ED,wBAzDuB,CDoItB,sDC3ED,wBApD4B,CD+H3B,wDC3ED,wBAxDsB,CDmIrB,+DC3ED,wBAvDoB,CDkInB,uDC3ED,wBAtDoB,CDiInB,8DC3ED,wBArDkB,CDgIjB,sDC3ED,wBArEsB,CDgJrB,6GC3ED,4BA5Be,CDuGd,gCKnHC,kBHoCA,4EAAA,oEAAA,+DAAA,4DAAA,qHACA,gCAAA,uBAAwB,CF8EzB,6BE1EC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,WACP,CFwEb,2BEpEC,gBACA,SAAU,CFmEX,wEEhEG,oCAAA,+BAAA,2BAA4B,CFgE/B,6BE3DC,eCtD2C,CHiH5C,mCM1GH,kBJkDgC,QAAK,QAAE,OAAO,mCACxC,+BAAA,0BAA2B,CFuD9B,oCEnDG,QACA,UC/DyC,CHiH5C,2DM1GH,kBJoEgC,MAAG,QAAA,SAAA,OAAA,kBAE7B,wDAAA,gDAAgE,WACrD,WACA,4CACX,uCAAA,mCAAoC,CFiCvC,iDE3BG,yBD3GmB,8EC4GnB,qEAAmD,CACnD,uBACE,GAAI,8BAAA,qBAAsB,CAAA,IACrB,2BAAA,kBAAmB,CAAA,GAClB,8BAAA,qBAAsB,CAAA,CFsBjC,2HEhBa,SAAW,CFgBxB,8DEZG,6BAAA,yBAAA,oBAAqB,CFYxB,kDENG,wBDhImB,CDsItB,2GEDa,SAAW,CFCxB,8FEKG,wBD9ImB,CDyIvB,cEoEE,gBACA,eCtL2C,CHiH5C,mCIhEmB,gBDjDyB,mBAAA,gBAAA,CHiH5C,gCEyBC,YAAa,CFzBd,6BM1GH,kBJsI8B,MAAG,QAAA,SAAA,MAAA,CF5B9B,qBEgCC,WAAW,cACG,WACH,gBACM,CFnClB,iCEuCC,8BAAA,0BAAA,qBAAsB,CFvCvB,uCE0CG,UAAW,CF1Cd,2BE+CC,oCAAA,+BAAA,4BAA4B,uCAC5B,mCAAA,+BAA+B,eACf,CFjDjB,iCEoDG,gCAAA,2BAAA,uBAAwB,CFpD3B,6BEyDC,gBAAgB,aAEF,CF3Df,oCE8DG,MAAM,QACG,CF1Df,kBM/GA,kBNgH4B,MAAG,QAAA,SAAA,MAAA,CA5CjC,wBAgDI,oCAAA,+BAAA,2BAA4B,CAC7B,mEAGyB,SAAW,CAAE,kDAGb,SAAW,CAAE,sBAGpB,YAAc,CAAE,kBACpB,SAAW,CAAE,aAClB,aAAc,mBAEd,cAAA,SAAW,CAFK,eAKxB,mBAAA,cAAA,UAAU,4BACV,mBAAmB,cACJ,CAEf,qBACE,eAAgB,CADjB,2BMzIH,kBN8IgC,MAAG,QAAE,SAAE,WACtB,UGtJ8B,CHwJ1C,sBMjJL,kBNqJ8B,UAgB1B,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,sBACtB,mBAAA,qBAAqB,wBACrB,qBAAA,sBAAuB,CAVvB,iJACE,aAAa,kBACK,UACR,4CACV,uCAAA,mCAAoC,CAdvC,6BMpJH,kBN4KgC,MAAG,SAAO,WACpC,WAAW,UGpL8B,CHsL1C,+FAKC,cAAc,mBACK,SACT,CAlDf,kBCnGC,yBD2JE,6BAAA,gBAAgB,WACL,SACF,SACA,0BAET,sBAAsB,QACb,CACV,6BAID,cAAc,aACA,CAEd,yDACE,mBAAmB,aACL,CACf,aAID,QAAS,CAET,6BC5KA,aA3EoB,CDyPnB,+BC9KD,aAnEuB,CDoPtB,eAID,aAAa,oBACb,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,qBACnB,kBAAA,wBAAyB,CAJ1B,oCIjKuB,eDjEuB,CHkO9C,iDAUK,mBACA,UG7OyC,CHkO9C,qGIjKuB,eDjEuB,CHkO9C,qEAqBK,iBAAkB,CACnB,qFC1MH,aAnEuB,CDwRtB,4BM5PH,kBNgQ4B,QGvQmB,UAAA,YAAA,WF8C7C,cDiOA,eAAgB,CATjB,gCO9PC,YPoQoB,UAAA,CACnB,uCAMD,iBACA,UACA,sBAAkC,CAHnC,8CM3QD,kBNiR8B,MAAG,SAAO,OAAE,WAC3B,WAEX,SAAU,CAhNhB,2DAqNI,YAAa,CACd","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Card Component\n */\n\n@import './mixins';\n\n.card{\n  transition: .1s ease-in-out;\n\n  @each $color, $code in $colors {\n    &.with-bgcolor--#{$color}{\n      .card__content__right::before,\n      .card__content__left::after{\n        background-image: linear-gradient(to left, $code, transparentize($code, 1));\n      }\n      .card__title::before{\n        background-image: linear-gradient(to right, $code, transparentize($code, 1));\n      }\n      .card__content__right{\n        background-color: $code;\n      }\n    }\n\n    &.card--xlarge.with-bgcolor--#{$color}{\n      .card__content__right::before {\n        background-image: none;\n      }\n      .card__content__right.hover::before {\n        background-image: linear-gradient(to left, $code, transparentize($code, 1));\n      }\n      .card__title::before{\n        background-image: linear-gradient(to right, $code, transparentize($code, 1));\n      }\n    }\n  }\n\n  &.card--xlarge.with-bgcolor--bw3 {\n    .card__content__right, .card__content__left::after, .card__content__left.hover::before, .card__content__right.hover::before, .card__title::before {\n      background-color: transparent;\n      background-image: none;\n    }\n  }\n\n  @each $card-size, $options in $card-sizes {\n    &--#{$card-size}{\n      @include card-for-size($card-size);\n    }\n  }\n\n  &__background{\n    @include position(absolute, 0);\n  }\n\n  .card-play-button{\n    transition: .15s ease-in-out;\n  }\n\n  &:not(&--is-playing) .card-play-button{\n    html.no-touchevents & { opacity: 0 }\n  }\n  &:hover .card-play-button{\n    html.no-touchevents & { opacity: 1 }\n  }\n\n  &__content__right{ z-index: auto }\n  &__content hr{ z-index: 3 }\n  &__image{ z-index: auto }\n\n  &__image{ flex: none }\n\n  &__content{\n    flex: auto;\n    align-self: stretch;\n    cursor: pointer;\n\n    &__left{\n      overflow: hidden;\n\n      &::after{\n        $width: 5;\n        @include position(absolute, 0 0 0 null);\n        content: \"\";\n        width: baseline($width);\n      }\n    }\n\n    &__right{\n      @include position(absolute, null baseline(1) null null);\n\n      .card__options > *:not(.add-to-cart-button):not(.card__price-element) {\n        display: none;\n        visibility: hidden;\n        opacity: 0;\n        transition: .25s opacity ease-in-out;\n      }\n\n      .card--xlarge & > .add-to-cart-button {\n        display: none;\n        visibility: hidden;\n        opacity: 0;\n        transition: .25s opacity ease-in-out;\n      }\n\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      justify-content: center;\n\n      &::before{\n        $width: 5;\n        @include position(absolute, 0 null 0 baseline(-$width));\n        content: \"\";\n        width: baseline($width);\n      }\n    }\n\n    &__right.hover {\n      .card__options > *:not(.add-to-cart-button):not(.card__price-element) {\n        display: block;\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n\n    hr{\n      @include bgcolor(border);\n      flex-basis: 100%;\n      height: 1px;\n      border: 0;\n      margin: 0;\n\n      align-self: flex-start;\n      top: -1px;\n    }\n  }\n\n  &__title, &__subtitle{\n    display: block;\n    max-width: 80%;\n\n    .card--xlarge & {\n      white-space: normal;\n      max-width: 60%;\n    }\n  }\n\n  &__title{\n    margin: 0;\n\n    .card--listened &{\n      @include textcolor(bw7);\n    }\n    .card--is-playing &{\n      @include textcolor(accent);\n    }\n  }\n\n  &__options{\n    z-index: auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    .card__price-element {\n      @include margin(null null null baseline(1));\n\n      &.button--icon{\n        border-radius: baseline(1.5);\n        width: baseline(5);\n      }\n    }\n\n    .card__find-similar, .add-to-cart-button, .card__download {\n      @include margin(null null null baseline(1));\n    }\n\n    .button--medium.card__add-to-project {\n      .button__wrapper {\n        padding: 11px 14px;\n      }\n    }\n  }\n\n  &__option{\n    &:not([class*=\"color-scheme\"]):hover{\n      @include textcolor(accent);\n    }\n\n    .icon--project-selected{\n      @include textcolor(accent);\n    }\n  }\n\n  &__in-project-indicator{\n    @include position(absolute, baseline(.5) baseline(.5) null null);\n    @include size(baseline(2));\n    @include textcolor(accent);\n\n    svg{\n      @include size(100%);\n    }\n\n    z-index: 1000000;\n  }\n\n  &--animating-overflow &__title{\n    padding-left: baseline(1);\n    left: baseline(-1);\n    width: calc(100% + #{baseline(1)});\n    &::before{\n      $width: 2;\n      @include position(absolute, 0 null 0 0);\n      content: \"\";\n      width: baseline($width);\n      z-index: 1;\n    }\n  }\n\n  .button.button--is-active .button__active-background {\n    display: none;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Cards\n */\n\n@import '../../../atoms/buttons/CardPlayButton/mixins';\n\n$card-sizes: (\n  xsmall: (\n    height: 9,\n    image-height: 7,\n    content-padding: 1,\n    orientation: horizontal,\n  ),\n  small: (\n    height: 13,\n    image-height: 9,\n    content-padding: 1,\n    orientation: horizontal,\n  ),\n  medium: (\n    height: 18,\n    image-height: 13,\n    content-padding: 3,\n    orientation: horizontal,\n  ),\n  xlarge: (\n    height: 40,\n    image-height: 32,\n    content-padding: 1,\n    orientation: vertical,\n  ),\n);\n\n@function get-card-height($size) {\n  @if map-has-key($card-sizes, $size) {\n    @return map-get(map-get($card-sizes, $size), height);\n  }\n  @return 0;\n}\n\n@mixin card-for-size($size) {\n  $options: map-get($card-sizes, $size);\n  $height: map-get($options, height);\n  $image-height: map-get($options, image-height);\n  $content-padding: map-get($options, content-padding);\n  $orientation: map-get($options, orientation);\n\n  .card__content{\n    &__left{\n      @include padding(baseline(1) null baseline(1) baseline($content-padding));\n      @if $size == 'medium' {\n        width: 70%;\n      }\n    }\n  }\n\n  @if $orientation == 'horizontal' {\n    height: baseline($height);\n\n    @each $color, $code in $colors {\n      &.with-bgcolor--#{$color}{\n        .card__background{\n          @include bgcolor($color);\n        }\n      }\n    }\n\n    .card__background{\n      @include bgsize(large);\n      transition: transform .25s $ease-out-back;\n      transform: translateZ(0);\n    }\n\n    .card__wrapper{\n      display: flex;\n      align-items: center;\n      height: 100%;\n    }\n\n    .card__image{\n      max-width: baseline($image-height);\n      width: 35%;\n\n      &, .thumbnail__inner{\n        transition: .15s ease-in-out;\n      }\n    }\n\n    .card__content{\n      margin-left: baseline(1);\n\n      &__left{\n        @include position(absolute, 50% 0 null 0);\n        transform: translateY(-50%);\n      }\n\n      &__right{\n        top: baseline(.5);\n        bottom: baseline(.5);\n      }\n    }\n\n    // &:not(.card--is-playing):not(.card--is-selected):hover{\n    //   .card__background{\n    //     transform: scale(1.03);\n    //   }\n    // }\n\n    &:not(.card--listened){\n      .card__background::after{\n        @include position(absolute, 0);\n        @include bgsize(large);\n        box-shadow: 0 3px 30px -10px transparentize(uicolor(shadow), .5);\n        content: \"\";\n        z-index: -1;\n        transition: opacity .15s ease-in-out;\n      }\n    }\n\n    &.card--is-playing{\n      .card__background{\n        border: 2px solid color(accent);\n        animation: bounce-card .75s $ease-out-back infinite;\n        @keyframes bounce-card {\n          0% {transform: scale(1.01);}\n          50% {transform: scale(1);}\n          100% {transform: scale(1.01);}\n        }\n      }\n\n      .card__background,\n      .card__image .thumbnail__inner{\n        &::after{ opacity: 0 }\n      }\n\n      .card__image .thumbnail__inner{\n        transform: scale(.98);\n      }\n    }\n\n    &.card--is-selected{\n      .card__background{\n        border: 2px solid color(accent);\n      }\n\n      .card__background,\n      .card__image{\n        &::after{ opacity: 0 }\n      }\n    }\n\n    &.card--listened:not(.card--is-playing):not(.card--is-selected){\n      .card__background{\n        border: 1px solid uicolor(border);\n      }\n      // .card__image .thumbnail__inner{\n      //   &::after{ opacity: 0 }\n      // }\n    }\n\n    @if $size == 'small' {\n      @include padding(null baseline(2));\n      .card__content__left{ right: 15% }\n    }\n\n    @if $size == 'medium' {\n      @include padding(null baseline(3));\n    }\n  }\n\n  @if $orientation == 'vertical' {\n\n    .card__background{\n      display: none;\n    }\n    .card__wrapper{\n      @include position(absolute, 0);\n    }\n\n    &::before{\n      content: \"\";\n      display: block;\n      width: 100%;\n      padding-top: 120%;\n    }\n\n    &:hover .card__image{\n      transform: scale(1.03);\n\n      &::after{\n        opacity: .5;\n      }\n    }\n\n    .card__image{\n      transition: .15s ease-in-out;\n      transform-origin: bottom center;\n      height: 83.3333%;\n\n      &::after{\n        transition: opacity .25s;\n      }\n    }\n\n    .card__content{\n      height: 16.6667%;\n      // max-height: baseline(8);\n      margin-left: 0;\n\n      &__right{\n        top: 0;\n        bottom: 0;\n      }\n    }\n\n    @if $size == 'xlarge' {\n      min-width: baseline(20);\n      max-width: baseline($image-height);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1485);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1487);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".dropdown-menu{position:absolute;top:42px;background-color:#fff;border-radius:2px;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);border:1px solid #e4e8ed;display:inline-block;min-width:192px;padding:4px 0;z-index:100000}.dropdown-menu--left{left:0}.dropdown-menu--right{right:0}.dropdown-menu--justify{left:0;right:0}.dropdown-menu--help{min-width:216px}.dropdown-menu--account{position:absolute;top:42px;min-width:192px}.dropdown-menu__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;z-index:auto}.dropdown-menu__sep{background-color:#e4e8ed;margin:4px 0;height:1px}.dropdown-menu__dropdown-button{display:block}.dropdown-menu__option-button{border-radius:0;width:100%}.dropdown-menu__option-button.button:hover{background-color:#f0f6fa}.dropdown-menu__option-button .button__flex,.dropdown-menu__option-button .button__wrapper{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-flex:1;-ms-flex:auto;flex:auto}span.dropdown-menu__option-button{display:block;padding:10px 13px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/blocks/DropdownMenu/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,eClEE,kBDmE0B,SE1EqB,sBCDnC,kBC3BQ,sDCFqC,8CL4GzD,yBACA,qBAAqB,gBAErB,cAAuB,cACR,CAEf,qBAAS,MAAQ,CAAE,sBACT,OAAS,CAAE,wBACT,OAAO,OAAW,CAAE,qBACvB,eEvFsC,CFuFX,wBChFpC,kBDkF4B,SAC1B,eE1F6C,CF2F9C,wBAGC,oBAAA,oBAAA,aAAa,YACA,CACd,oBGxDC,yBH4DA,aAAsB,UACX,CACZ,gCAGC,aAAc,CACf,8BAGC,gBAAgB,UACL,CAFZ,2CGtEC,wBAzDuB,CH+HxB,2FASG,uBAAA,oBAAA,2BAA2B,mBAC3B,cAAA,SAAU,CACX,kCAKH,cAAc,iBE5HiC,CF8HhD","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * DropdownMenu Component\n */\n\n.dropdown-menu{\n  @include position(absolute, baseline(5.25) null null);\n  @include bgcolor(white);\n  @include bgsize(small);\n  @include shadow(medium);\n  border: 1px solid uicolor(border);\n  display: inline-block;\n  min-width: baseline(24);\n  padding: baseline(.5) 0;\n  z-index: 100000;\n\n  &--left{ left: 0 }\n  &--right{ right: 0 }\n  &--justify{ left: 0; right: 0 }\n  &--help{ min-width: baseline(27); }\n  &--account{\n    @include position(absolute, baseline(5.25) null null);\n    min-width: baseline(24);\n  }\n\n  &__wrapper{\n    display: flex;\n    z-index: auto;\n  }\n\n  &__sep{\n    @include bgcolor(border);\n    margin: baseline(.5) 0;\n    height: 1px;\n  }\n\n  &__dropdown-button{\n    display: block;\n  }\n\n  &__option-button{\n    border-radius: 0;\n    width: 100%;\n\n    &.button:hover{\n      @include bgcolor(bw3);\n    }\n\n    .button__flex, .button__wrapper{\n      justify-content: flex-start;\n      flex: auto;\n    }\n  }\n}\n\nspan.dropdown-menu__option-button{\n  display: block;\n  padding: baseline(1.25) baseline(1.625);\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
__webpack_require__(1491);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var CardPlayButton_1 = __webpack_require__(425);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Artist_1 = __webpack_require__(186);
var Track_1 = __webpack_require__(231);
var classes = new BEM('thumbnail');

var ThumbnailWithPlayButton = function (_React$Component) {
    _inherits(ThumbnailWithPlayButton, _React$Component);

    function ThumbnailWithPlayButton() {
        _classCallCheck(this, ThumbnailWithPlayButton);

        var _this = _possibleConstructorReturn(this, (ThumbnailWithPlayButton.__proto__ || Object.getPrototypeOf(ThumbnailWithPlayButton)).apply(this, arguments));

        _this.onClickPlayButton = function () {
            var _this$props = _this.props,
                isPlaying = _this$props.isPlaying,
                pause = _this$props.pause,
                play = _this$props.play;

            isPlaying ? pause() : play();
        };
        return _this;
    }

    _createClass(ThumbnailWithPlayButton, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            // WTF is all this?
            return nextProps.trackId !== this.props.trackId || nextProps.displayButtonOnHover !== this.props.displayButtonOnHover || nextProps.isPlaying !== this.props.isPlaying || !lodash_1.isEqual(nextProps.title, this.props.title) || !lodash_1.isEqual(nextProps.artist, this.props.artist);
        }
    }, {
        key: "renderTrackInfo",
        value: function renderTrackInfo() {
            return React.createElement("div", Object.assign({}, classes('track-info')), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('track-info__title'), { text: this.props.title.title, maxTextLength: 25, hyperLinkProps: {
                    href: router_1.linkWithCurrentQueryString(Track_1.TrackPagePath(this.props.title.slug))
                } })), React.createElement(Label_1.Span, Object.assign({ size: "small" }, classes('track-info__artist'), { text: this.props.artist.name, maxTextLength: 20, hyperLinkProps: {
                    href: router_1.linkWithCurrentQueryString(Artist_1.ArtistPagePath(this.props.artist.slug))
                } })));
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                artist = _a.artist,
                className = _a.className,
                displayButtonOnHover = _a.displayButtonOnHover,
                isPlaying = _a.isPlaying,
                unusedPause = _a.pause,
                unusedPlay = _a.play,
                title = _a.title,
                unusedTrackId = _a.trackId,
                thumbnailProps = __rest(_a, ["artist", "className", "displayButtonOnHover", "isPlaying", "pause", "play", "title", "trackId"]);
            var showTrackInfo = !!artist && !!title;
            var classModifiers = {
                'with-play-button': true,
                'button-on-hover': !!displayButtonOnHover,
                'with-track-info': showTrackInfo,
                'is-playing': isPlaying
            };
            var blurredImage = thumbnailProps.responsiveAssets && thumbnailProps.responsiveAssets.blur ? thumbnailProps.responsiveAssets.blur[0].path : null;
            return React.createElement(Thumbnail_1.default, Object.assign({}, classes('', classModifiers, className), thumbnailProps), showTrackInfo && this.renderTrackInfo(), React.createElement(CardPlayButton_1.default, Object.assign({ blurredImage: blurredImage, isPlaying: isPlaying, onClick: this.onClickPlayButton }, classes('play-button'))));
        }
    }]);

    return ThumbnailWithPlayButton;
}(React.Component);

exports.default = ThumbnailWithPlayButton;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1492);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".thumbnail__track-info{position:absolute;right:0;bottom:0;left:0;color:#fff;background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(16,16,21,.5)),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(bottom,rgba(16,16,21,.5),rgba(16,16,21,0));background-image:-o-linear-gradient(bottom,rgba(16,16,21,.5),rgba(16,16,21,0));background-image:linear-gradient(0deg,rgba(16,16,21,.5),rgba(16,16,21,0));display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:12px}.thumbnail__track-info__artist,.thumbnail__track-info__title{margin:0}.thumbnail__track-info__artist{margin-top:4px}.thumbnail.thumbnail--xxsmall .thumbnail__track-info{border-radius:0 0 2px 2px}.thumbnail.thumbnail--medium .thumbnail__track-info,.thumbnail.thumbnail--small .thumbnail__track-info,.thumbnail.thumbnail--xsmall .thumbnail__track-info{border-radius:0 0 4px 4px}.thumbnail.thumbnail--large .thumbnail__track-info,.thumbnail.thumbnail--xlarge .thumbnail__track-info,.thumbnail.thumbnail--xxlarge .thumbnail__track-info{border-radius:0 0 8px 8px}.thumbnail.thumbnail--xsmall.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:80%;height:80%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xsmall.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:175%;height:175%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xsmall.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-40% + 0px);bottom:calc(-40% + 0px);width:80%;height:80%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xsmall.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--37.5% + 0px);left:calc(--37.5% + 0px);width:175%;height:175%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xsmall.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:60.0015000375%;height:80%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xsmall.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:233.3275%;height:175%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xsmall.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-30.0007500188% + 0px);bottom:calc(-40% + 0px);width:60.0015000375%;height:80%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xsmall.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--37.5% + 0px);left:calc(--16.66875% + 0px);width:233.3275%;height:175%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--small.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:66.6666666667%;height:66.6666666667%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--small.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:210%;height:210%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--small.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-33.3333333333% + 0px);bottom:calc(-33.3333333333% + 0px);width:66.6666666667%;height:66.6666666667%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--small.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--25% + 0px);left:calc(--25% + 0px);width:210%;height:210%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--small.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:50.0012500313%;height:66.6666666667%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--small.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:279.993%;height:210%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--small.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-25.0006250156% + 0px);bottom:calc(-33.3333333333% + 0px);width:50.0012500313%;height:66.6666666667%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--small.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--25% + 0px);left:calc(--0.0025% + 0px);width:279.993%;height:210%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--medium.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:58.3333333333%;height:58.3333333333%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--medium.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:240%;height:240%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--medium.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-29.1666666667% + 0px);bottom:calc(-29.1666666667% + 0px);width:58.3333333333%;height:58.3333333333%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--medium.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--14.2857142857% + 0px);left:calc(--14.2857142857% + 0px);width:240%;height:240%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--medium.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;top:50%;left:50%;width:43.7510937773%;height:58.3333333333%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--medium.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:50%;left:50%;width:319.992%;height:240%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--medium.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-21.8755468887% + 0px);bottom:calc(-29.1666666667% + 0px);width:43.7510937773%;height:58.3333333333%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--medium.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(--14.2857142857% + 0px);left:calc(-14.2828571429% + 0px);width:319.992%;height:240%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--large.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-10% + 8px);left:calc(10% + 8px);width:20%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--large.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(250% - 8px);width:700%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--large.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-10% + 8px);bottom:calc(-10% + 8px);width:20%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--large.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(-150% + 8px);width:700%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--large.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-10% + 8px);left:calc(7.5001875047% + 8px);width:15.0003750094%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--large.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(333.325% - 8px);width:933.31%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--large.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-7.5001875047% + 8px);bottom:calc(-10% + 8px);width:15.0003750094%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--large.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(-233.325% + 8px);width:933.31%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xlarge.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-9.375% + 8px);left:calc(9.375% + 8px);width:18.75%;height:18.75%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xlarge.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-166.666666667% + 8px);left:calc(266.666666667% - 8px);width:746.666666667%;height:746.666666667%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xlarge.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-9.375% + 8px);bottom:calc(-9.375% + 8px);width:18.75%;height:18.75%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xlarge.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-166.666666667% + 8px);left:calc(-166.666666667% + 8px);width:746.666666667%;height:746.666666667%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xlarge.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-9.375% + 8px);left:calc(7.0314257856% + 8px);width:14.0628515713%;height:18.75%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xlarge.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-166.666666667% + 8px);left:calc(355.546666667% - 8px);width:995.530666667%;height:746.666666667%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xlarge.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-7.0314257856% + 8px);bottom:calc(-9.375% + 8px);width:14.0628515713%;height:18.75%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xlarge.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-166.666666667% + 8px);left:calc(-255.546666667% + 8px);width:995.530666667%;height:746.666666667%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xxlarge.ratio--square:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-10% + 8px);left:calc(10% + 8px);width:20%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xxlarge.ratio--square:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(250% - 8px);width:700%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xxlarge.ratio--square.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-10% + 8px);bottom:calc(-10% + 8px);width:20%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xxlarge.ratio--square.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(-150% + 8px);width:700%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xxlarge.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button{position:absolute;bottom:calc(-10% + 8px);left:calc(7.5001875047% + 8px);width:15.0003750094%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xxlarge.ratio--four-thirds:not(.thumbnail--with-track-info) .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(333.325% - 8px);width:933.31%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail.thumbnail--xxlarge.ratio--four-thirds.thumbnail--with-track-info .card-play-button{position:absolute;right:calc(-7.5001875047% + 8px);bottom:calc(-10% + 8px);width:15.0003750094%;height:20%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.thumbnail.thumbnail--xxlarge.ratio--four-thirds.thumbnail--with-track-info .card-play-button__blurred-image{position:absolute;top:calc(-150% + 8px);left:calc(-233.325% + 8px);width:933.31%;height:700%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail--large .thumbnail__play-button .icon,.thumbnail--small .thumbnail__play-button .icon{height:60%}.thumbnail--large .thumbnail__play-button .icon svg,.thumbnail--small .thumbnail__play-button .icon svg{width:100%}html.no-touchevents .thumbnail--button-on-hover .thumbnail__play-button,html.no-touchevents .thumbnail--button-on-hover .thumbnail__track-info{opacity:0}html.no-touchevents .thumbnail--button-on-hover.thumbnail--is-playing .thumbnail__play-button,html.no-touchevents .thumbnail--button-on-hover.thumbnail--is-playing .thumbnail__track-info,html.no-touchevents .thumbnail--button-on-hover:hover .thumbnail__play-button,html.no-touchevents .thumbnail--button-on-hover:hover .thumbnail__track-info{opacity:1}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/buttons/ThumbnailWithPlayButton/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/CardPlayButton/mixins.scss"],"names":[],"mappings":"AAgJE,uBCtGA,kBDuG4B,QAAQ,SAAE,OAAE,WAEtC,4GAAA,oFAAA,+EAAA,0EAA4G,oBAC5G,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,YEnHsB,CFsH7C,6DACE,QAAS,CACV,+BAGC,cE3H2C,CF4GjD,qDAuBM,yBG/JgB,CHwItB,2JAuBM,yBG5JgB,CHqItB,4JAuBM,yBGzJgB,CHkItB,8FCrGE,kBAII,QAAA,SGboC,UA2BV,WACE,qDAE9B,4CAA8C,CJgFlD,6GCrGE,kBAII,QAAA,SGZgC,WAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,wFCrGE,kBAII,uBAAA,wBGtBiE,UAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,uGCrGE,kBAII,wBAAA,yBGlByF,WA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,mGCrGE,kBAII,QAAA,SGboC,qBA2BV,WACE,qDAE9B,4CAA8C,CJgFlD,kHCrGE,kBAII,QAAA,SGZgC,gBAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,6FCrGE,kBAII,kCAAA,wBGtBiE,qBAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,4GCrGE,kBAII,wBAAA,6BGlByF,gBA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,6FCrGE,kBAII,QAAA,SGboC,qBA2BV,sBACE,qDAE9B,4CAA8C,CJgFlD,4GCrGE,kBAII,QAAA,SGZgC,WAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,uFCrGE,kBAII,kCAAA,mCGtBiE,qBAoCvC,sBACE,qDAE9B,4CAA8C,CJgFlD,sGCrGE,kBAII,sBAAA,uBGlByF,WA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,kGCrGE,kBAII,QAAA,SGboC,qBA2BV,sBACE,qDAE9B,4CAA8C,CJgFlD,iHCrGE,kBAII,QAAA,SGZgC,eAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,4FCrGE,kBAII,kCAAA,mCGtBiE,qBAoCvC,sBACE,qDAE9B,4CAA8C,CJgFlD,2GCrGE,kBAII,sBAAA,2BGlByF,eA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,8FCrGE,kBAII,QAAA,SGboC,qBA2BV,sBACE,qDAE9B,4CAA8C,CJgFlD,6GCrGE,kBAII,QAAA,SGZgC,WAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,wFCrGE,kBAII,kCAAA,mCGtBiE,qBAoCvC,sBACE,qDAE9B,4CAA8C,CJgFlD,uGCrGE,kBAII,iCAAA,kCGlByF,WA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,mGCrGE,kBAII,QAAA,SGboC,qBA2BV,sBACE,qDAE9B,4CAA8C,CJgFlD,kHCrGE,kBAII,QAAA,SGZgC,eAsCU,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,6FCrGE,kBAII,kCAAA,mCGtBiE,qBAoCvC,sBACE,qDAE9B,4CAA8C,CJgFlD,4GCrGE,kBAII,iCAAA,iCGlByF,eA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,6FCrGE,kBAII,wBAAA,qBGrByE,UAmC/C,WACE,qDAE9B,4CAA8C,CJgFlD,4GCrGE,kBAII,sBAAA,sBGhB+E,WA0CrC,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,uFCrGE,kBAII,uBAAA,wBGtBiE,UAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,sGCrGE,kBAII,sBAAA,uBGlByF,WA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,kGCrGE,kBAII,wBAAA,+BGrByE,qBAmC/C,WACE,qDAE9B,4CAA8C,CJgFlD,iHCrGE,kBAII,sBAAA,0BGhB+E,cA0CrC,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,4FCrGE,kBAII,iCAAA,wBGtBiE,qBAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,2GCrGE,kBAII,sBAAA,2BGlByF,cA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,8FCrGE,kBAII,2BAAA,wBGrByE,aAmC/C,cACE,qDAE9B,4CAA8C,CJgFlD,6GCrGE,kBAII,gCAAA,gCGhB+E,qBA0CrC,sBACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,wFCrGE,kBAII,0BAAA,2BGtBiE,aAoCvC,cACE,qDAE9B,4CAA8C,CJgFlD,uGCrGE,kBAII,gCAAA,iCGlByF,qBA4C/C,sBACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,mGCrGE,kBAII,2BAAA,+BGrByE,qBAmC/C,cACE,qDAE9B,4CAA8C,CJgFlD,kHCrGE,kBAII,gCAAA,gCGhB+E,qBA0CrC,sBACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,6FCrGE,kBAII,iCAAA,2BGtBiE,qBAoCvC,cACE,qDAE9B,4CAA8C,CJgFlD,4GCrGE,kBAII,gCAAA,iCGlByF,qBA4C/C,sBACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,+FCrGE,kBAII,wBAAA,qBGrByE,UAmC/C,WACE,qDAE9B,4CAA8C,CJgFlD,8GCrGE,kBAII,sBAAA,sBGhB+E,WA0CrC,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,yFCrGE,kBAII,uBAAA,wBGtBiE,UAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,wGCrGE,kBAII,sBAAA,uBGlByF,WA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,oGCrGE,kBAII,wBAAA,+BGrByE,qBAmC/C,WACE,qDAE9B,4CAA8C,CJgFlD,mHCrGE,kBAII,sBAAA,0BGhB+E,cA0CrC,YACR,uCAGpC,mCAAA,8BAAgC,CJmEpC,8FCrGE,kBAII,iCAAA,wBGtBiE,qBAoCvC,WACE,qDAE9B,4CAA8C,CJgFlD,6GCrGE,kBAII,sBAAA,2BGlByF,cA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CJ2HjC,gGAEG,UAAW,CAFd,wGAIK,UAAW,CACZ,+IAOuB,SAAW,CAAE,sVAOb,SAAW,CAAE","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ThumbnailWithPlayButton Component\n */\n\n@import '../../../atoms/buttons/CardPlayButton/mixins';\n@import '../../../atoms/images/Thumbnail/mixins';\n\n$thumbnail-play-default-size-options: (\n  button-position: center,\n  button-margin: 0,\n);\n\n$thumbnail-play-sizes: (\n  xsmall: (\n    button-size: 4,\n  ),\n  small: (\n    button-size: 6,\n  ),\n  medium: (\n    button-size: 7,\n  ),\n  large: (\n    button-position: \"bottom left\",\n    button-margin: 1,\n    button-size: 5,\n  ),\n  xlarge: (\n    button-position: \"bottom left\",\n    button-margin: 1,\n    button-size: 6,\n  ),\n  xxlarge: (\n    button-position: \"bottom left\",\n    button-margin: 1,\n    button-size: 8,\n  ),\n);\n\n.thumbnail{\n  &__track-info{\n    @include position(absolute, null 0 0 0);\n    @include textcolor(white);\n    background-image: linear-gradient(to top, transparentize(color(black), .5), transparentize(color(black), 1));\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: baseline(1.5);\n\n    &__title, &__artist{\n      margin: 0;\n    }\n\n    &__artist{\n      margin-top: baseline(.5);\n    }\n  }\n\n  @each $size, $options in $thumbnail-sizes {\n    $bgsize: map-get($options, bg);\n\n    &.thumbnail--#{$size} &__track-info{\n      border-radius: 0 0 radius($bgsize) radius($bgsize);\n    }\n  }\n\n  // &:not(.thumbnail--is-responsive){\n    @each $size, $options in $thumbnail-play-sizes {\n      $options: map-merge($thumbnail-play-default-size-options, $options);\n      $button-margin: map-get($options, button-margin);\n      $button-position: map-get($options, button-position);\n      $button-size: map-get($options, button-size);\n      $width: map-get(map-get($thumbnail-sizes, $size), width);\n\n      &.thumbnail--#{$size}{\n        &.ratio--square{\n          &:not(.thumbnail--with-track-info){\n            @include position-card-play-button($button-position, $button-size, $width, $button-margin);\n          }\n          &.thumbnail--with-track-info{\n            @include position-card-play-button(\"bottom right\", $button-size, $width, $button-margin);\n          }\n        }\n        &.ratio--four-thirds{\n          &:not(.thumbnail--with-track-info){\n            @include position-card-play-button($button-position, $button-size, $width, $button-margin, 1.3333);\n          }\n          &.thumbnail--with-track-info{\n            @include position-card-play-button(\"bottom right\", $button-size, $width, $button-margin, 1.3333);\n          }\n        }\n      }\n    }\n  // }\n\n  &--small, &--large{\n    .thumbnail__play-button .icon{\n      height: 60%;\n      svg{\n        width: 100%;\n      }\n    }\n  }\n\n  &--button-on-hover{\n    .thumbnail__play-button,\n    .thumbnail__track-info{\n      html.no-touchevents & { opacity: 0 }\n    }\n\n    &:hover .thumbnail__play-button,\n    &:hover .thumbnail__track-info,\n    &.thumbnail--is-playing .thumbnail__play-button,\n    &.thumbnail--is-playing .thumbnail__track-info{\n      html.no-touchevents & { opacity: 1 }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Card Play Button Component\n */\n\n$context: \".card-play-button\";\n\n@mixin card-play-button-hover(){\n  @include textcolor(accent);\n  #{$context}__blurred-image{\n    opacity: .2;\n  }\n}\n\n@mixin position-card-play-button($position, $height, $container-height, $margin: 0, $ratio: 1) {\n  $height-percent: $height / $container-height;\n  $width-percent: $height-percent / $ratio;\n  $image-height: (1 / $height-percent);\n  $computed-half-size-percent: ($height-percent / 2) * 100%;\n  $computed-margin: baseline($margin);\n  $container-position: null;\n  $image-position: null;\n\n  $top:     calc(#{$computed-half-size-percent} + #{$computed-margin});\n  $right:   calc(#{-$computed-half-size-percent / $ratio} + #{$computed-margin});\n  $bottom:  calc(#{-$computed-half-size-percent} + #{$computed-margin});\n  $left:    calc(#{$computed-half-size-percent / $ratio} + #{$computed-margin});\n\n  $image-top:     calc(#{($image-height / 2) * 100%} - #{$computed-margin});\n  $image-right:   calc(-#{(($image-height * $ratio * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-bottom:  calc(-#{(($image-height * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-left:    calc(#{($image-height  / 2) * $ratio * 100%} - #{$computed-margin});\n\n  @if $position == \"center\" {\n    $container-position: 50% null null 50%;\n    $image-position: 50% null null 50%;\n  }\n\n  @if $position == \"top left\" {\n    $container-position: $top null null $left;\n    $image-position: $image-top null null $image-left;\n  }\n\n  @if $position == \"top right\" {\n    $container-position: $top $right null null;\n    $image-position: $image-top null null $image-right;\n  }\n\n  @if $position == \"bottom left\" {\n    $container-position: null null $bottom $left;\n    $image-position: $image-bottom null null $image-left;\n  }\n\n  @if $position == \"bottom right\" {\n    $container-position: null $right $bottom null;\n    $image-position: $image-bottom null null $image-right;\n  }\n\n  // Render\n  #{$context}{\n    @include position(absolute, $container-position);\n    width: $width-percent * 100%;\n    height: $height-percent * 100%;\n\n    transform: translate(-50%, -50%) translateZ(0);\n  }\n\n  #{$context}__blurred-image{\n    @include position(absolute, $image-position);\n\n    @if $ratio > 1.3333 {\n      width: $image-height * $ratio * 100%;\n    } @else {\n      width: $image-height * $ratio * 1.4 * 100%;\n      height: $image-height * 1.4 * 100%;\n    }\n\n    transform: translate(-50%, -50%);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1494);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".card-play-button{background-color:#fff;border-radius:50%;-webkit-box-shadow:0 1px 2px rgba(16,16,21,.15);box-shadow:0 1px 2px rgba(16,16,21,.15);overflow:hidden;border:none}.card-play-button__blurred-image{-webkit-transition:opacity .15s;-o-transition:opacity .15s;transition:opacity .15s;opacity:.4}.card-play-button .icon{height:64%}.card-play-button .icon svg{margin-right:auto;margin-left:auto;height:100%}.card-play-button:hover{color:#4487ff}.card-play-button:hover .card-play-button__blurred-image{opacity:.2}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/CardPlayButton/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/CardPlayButton/mixins.scss"],"names":[],"mappings":"AA8GA,kBCrCI,sBDuCF,kBAAkB,gDAClB,wCAAuD,gBACvC,WACJ,CAGZ,iCACE,gCAAA,2BAAA,wBAAwB,UACb,CAVf,wBAcI,UAAW,CAdf,4BErB0B,kBFsCK,iBAAA,WACb,CAlBlB,wBC7BI,aAnEuB,CDgG3B,yDGrGI,UAAW,CACZ","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Card Play Button Component\n */\n\n@import './mixins';\n\n.card-play-button{\n  @include bgcolor(white);\n  border-radius: 50%;\n  box-shadow: 0 1px 2px transparentize(color(black), .85);\n  overflow: hidden;\n  border: none;\n  // animation: card-play-button-appear .15s ease-in-out;\n\n  &__blurred-image{\n    transition: opacity .15s;\n    opacity: .4;\n  }\n\n  .icon{\n    height: 64%;\n\n    svg{\n      @include margin(null auto);\n      height: 100%;\n    }\n  }\n\n  &:hover{ @include card-play-button-hover; }\n\n  @keyframes card-play-button-appear {\n    0% {\n      transform: translateX(-50%) translateY(-25%) translateZ(0);\n      opacity: 0;\n    }\n    100% {\n      transform: translateX(-50%) translateY(-50%) translateZ(0);\n      opacity: 1;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Card Play Button Component\n */\n\n$context: \".card-play-button\";\n\n@mixin card-play-button-hover(){\n  @include textcolor(accent);\n  #{$context}__blurred-image{\n    opacity: .2;\n  }\n}\n\n@mixin position-card-play-button($position, $height, $container-height, $margin: 0, $ratio: 1) {\n  $height-percent: $height / $container-height;\n  $width-percent: $height-percent / $ratio;\n  $image-height: (1 / $height-percent);\n  $computed-half-size-percent: ($height-percent / 2) * 100%;\n  $computed-margin: baseline($margin);\n  $container-position: null;\n  $image-position: null;\n\n  $top:     calc(#{$computed-half-size-percent} + #{$computed-margin});\n  $right:   calc(#{-$computed-half-size-percent / $ratio} + #{$computed-margin});\n  $bottom:  calc(#{-$computed-half-size-percent} + #{$computed-margin});\n  $left:    calc(#{$computed-half-size-percent / $ratio} + #{$computed-margin});\n\n  $image-top:     calc(#{($image-height / 2) * 100%} - #{$computed-margin});\n  $image-right:   calc(-#{(($image-height * $ratio * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-bottom:  calc(-#{(($image-height * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-left:    calc(#{($image-height  / 2) * $ratio * 100%} - #{$computed-margin});\n\n  @if $position == \"center\" {\n    $container-position: 50% null null 50%;\n    $image-position: 50% null null 50%;\n  }\n\n  @if $position == \"top left\" {\n    $container-position: $top null null $left;\n    $image-position: $image-top null null $image-left;\n  }\n\n  @if $position == \"top right\" {\n    $container-position: $top $right null null;\n    $image-position: $image-top null null $image-right;\n  }\n\n  @if $position == \"bottom left\" {\n    $container-position: null null $bottom $left;\n    $image-position: $image-bottom null null $image-left;\n  }\n\n  @if $position == \"bottom right\" {\n    $container-position: null $right $bottom null;\n    $image-position: $image-bottom null null $image-right;\n  }\n\n  // Render\n  #{$context}{\n    @include position(absolute, $container-position);\n    width: $width-percent * 100%;\n    height: $height-percent * 100%;\n\n    transform: translate(-50%, -50%) translateZ(0);\n  }\n\n  #{$context}__blurred-image{\n    @include position(absolute, $image-position);\n\n    @if $ratio > 1.3333 {\n      width: $image-height * $ratio * 100%;\n    } @else {\n      width: $image-height * $ratio * 1.4 * 100%;\n      height: $image-height * 1.4 * 100%;\n    }\n\n    transform: translate(-50%, -50%);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 0e21de423adda669f5cd9e2e8ff43de6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type artistFragment_artist$ref = any;
export type artist_QueryVariables = {|
  slug?: ?string,
|};
export type artist_QueryResponse = {|
  +artist: ?{|
    +$fragmentRefs: artistFragment_artist$ref,
  |},
|};
*/

/*
query artist_Query(
  $slug: String
) {
  artist(slug: $slug) {
    ...artistFragment_artist
    id
  }
}

fragment artistFragment_artist on Artist {
  id
  name
  slug
  bio
  bandcamp
  facebook
  instagram
  itunes
  soundcloud
  spotify
  twitter
  wiki
  youtube
  homebase
  assets {
    id
    version
    type
    file_format
    path
    metadata
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "artist_Query",
    "id": null,
    "text": "query artist_Query(\n  $slug: String\n) {\n  artist(slug: $slug) {\n    ...artistFragment_artist\n    id\n  }\n}\n\nfragment artistFragment_artist on Artist {\n  id\n  name\n  slug\n  bio\n  bandcamp\n  facebook\n  instagram\n  itunes\n  soundcloud\n  spotify\n  twitter\n  wiki\n  youtube\n  homebase\n  assets {\n    id\n    version\n    type\n    file_format\n    path\n    metadata\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "artist_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "artist",
        "storageKey": null,
        "args": v1,
        "concreteType": "Artist",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "artistFragment_artist",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "artist_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "artist",
        "storageKey": null,
        "args": v1,
        "concreteType": "Artist",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "itunes",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "bio",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "bandcamp",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "facebook",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "instagram",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "soundcloud",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "spotify",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "twitter",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "wiki",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "youtube",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "homebase",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "assets",
          "storageKey": null,
          "args": null,
          "concreteType": "Asset",
          "plural": true,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "version",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "file_format",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "path",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "metadata",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = 'd902fd0e087423bc3d884bfa035fcf85';
module.exports = node;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type artistFragment_artist$ref: FragmentReference;
export type artistFragment_artist = {|
  +id: string,
  +name: ?string,
  +slug: ?string,
  +bio: ?string,
  +bandcamp: ?string,
  +facebook: ?string,
  +instagram: ?string,
  +itunes: ?string,
  +soundcloud: ?string,
  +spotify: ?string,
  +twitter: ?string,
  +wiki: ?string,
  +youtube: ?string,
  +homebase: ?string,
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +$refType: artistFragment_artist$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "artistFragment_artist",
    "type": "Artist",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "itunes",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bio",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bandcamp",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "facebook",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "instagram",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "soundcloud",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "spotify",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "twitter",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "wiki",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "youtube",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "homebase",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "assets",
      "storageKey": null,
      "args": null,
      "concreteType": "Asset",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "version",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "file_format",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "path",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "metadata",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
node /*: any*/.hash = 'c0334c45bde2f4a17f40f6bc238867c1';
module.exports = node;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type artistNode$ref: FragmentReference;
export type artistNode = {|
  +id: string,
  +name: ?string,
  +slug: ?string,
  +bio: ?string,
  +bandcamp: ?string,
  +facebook: ?string,
  +instagram: ?string,
  +itunes: ?string,
  +soundcloud: ?string,
  +spotify: ?string,
  +twitter: ?string,
  +wiki: ?string,
  +youtube: ?string,
  +homebase: ?string,
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +$refType: artistNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "artistNode",
    "type": "Artist",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "itunes",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bio",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bandcamp",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "facebook",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "instagram",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "soundcloud",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "spotify",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "twitter",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "wiki",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "youtube",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "homebase",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "assets",
      "storageKey": null,
      "args": null,
      "concreteType": "Asset",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "version",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "file_format",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "path",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "metadata",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
node /*: any*/.hash = '101f98bb26c3ab10f4922a64a7d6e655';
module.exports = node;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1499);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.artist__artist-picture:before,.artist__header__margin:before,[data-header-layout=vertical] .artist__header:before{content:\"\";display:block;width:100%;padding-top:30vw}[data-header-layout=vertical] .artist__artist-picture:before,[data-header-layout=vertical] .artist__header:before,[data-header-layout=vertical] .artist__header__margin:before{padding-top:42vw}.page--artist .artist-list+.track-list,.page--artist .track-list+.track-list{margin-top:48px}.page--artist .artist-list .card,.page--artist .track-list .card{height:96px;padding:0}.page--artist .artist-list .card:hover,.page--artist .track-list .card:hover{z-index:auto}.page--artist .artist-list .card__background,.page--artist .track-list .card__background{display:none}.page--artist .artist-list .card__image,.page--artist .track-list .card__image{z-index:auto}.page--artist .artist-list .card__content,.page--artist .track-list .card__content{border-bottom:1px solid #e4e8ed}.page--artist .artist-list .card__content__right,.page--artist .track-list .card__content__right{z-index:auto}.page--artist .artist-list__item:first-child .card__content,.page--artist .track-list__item:first-child .card__content{border-top:1px solid #e4e8ed}.page--artist .show-all-tracks-button{display:block;margin-left:auto}.artist__artist-picture{position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none;overflow:hidden;z-index:0}.artist__artist-picture__inner{position:absolute;top:0;right:0;bottom:0;left:0;background-size:cover;background-position:50%}[data-header-layout=vertical] .artist__artist-picture{left:50%}.artist__header{background-color:#fff;position:relative;height:56px;-webkit-box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2);box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2);overflow:hidden}.artist__header,.artist__header__content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.artist__header__content-wrapper{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.artist__header__margin{width:50%}[data-header-layout=horizontal] .artist__header__content-wrapper{padding-left:16px}[data-header-layout=vertical] .artist__header{position:fixed;top:64px;bottom:0;left:0;height:auto;width:50%;background-color:#101015;color:#fff}[data-header-layout=vertical] .artist__header__content-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.artist__header .artist__details{-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.artist__action:hover{color:#4487ff}.artist__info{margin-right:8px;margin-left:8px}.artist__info__title{margin:0}.artist__info__subtitle{color:#8a8f99;display:block}.artist__content{background-color:#f9fafb;padding-bottom:48px}.artist__content__wrapper{padding-top:48px;padding-bottom:48px;width:90%;max-width:1152px;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex}.artist__content__column{padding-right:24px;padding-left:24px}.artist__content__column:first-child{padding-left:0}.artist__content__column:last-child{padding-right:0}.artist__content__column--bio{-webkit-box-flex:7;-ms-flex:7;flex:7}.artist__content__column--tracks{-webkit-box-flex:12;-ms-flex:12;flex:12}.artist__content__column--social{-webkit-box-flex:5;-ms-flex:5;flex:5}.artist__content__column--collections{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.artist__tags-group{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:16px 0 16px -4px}.artist__tags-group:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34;content:attr(data-title);margin-left:4px;margin-bottom:4px;-ms-flex-preferred-size:100%;flex-basis:100%}@media print{.artist__tags-group:before{font-size:.6770833331em}}.artist__tags-group:before em,.artist__tags-group:before i{font-weight:300}.artist__tags-group:before b,.artist__tags-group:before strong{font-weight:700}.artist__social-links .button{display:block;left:-8px}.artist__social-links .button__flex{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.artist__social-links .button__label{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.875em}.artist__about{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34}@media print{.artist__about{font-size:.6770833331em}}.artist__about em,.artist__about i{font-weight:300}.artist__about b,.artist__about strong{font-weight:700}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Artist/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,mHC8DtE,WAAW,cACG,WACH,gBACM,CAKlB,+KAFG,gBAAiB,CAClB,6EAMG,eC1F2C,CDuFjD,iEAOM,YACA,SAAU,CARhB,6EAWQ,YAAa,CAXrB,yFAeM,YAAa,CAfnB,+EAkBM,YAAa,CAlBnB,mFAqBM,+BEpIqB,CF+G3B,iGAuBQ,YAAa,CAvBrB,uHA4BQ,4BE3ImB,CF+G3B,sCAkCI,cAAc,gBACG,CAClB,wBGpHD,eHyHyB,MAAG,QAAE,SAAE,OAAE,oBACZ,gBACJ,SACN,CAMV,+BGlIF,kBHmI8B,MAAG,QAAA,SAAA,OAAA,sBACP,uBACK,CAC5B,sDAGC,QAAS,CACV,gBE3GD,sBFgHA,kBAAkB,YAElB,sDAAA,8CAA8D,eAG9C,CAEhB,iDAJA,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAGnB,iCGtJF,kBHuJ8B,MAAG,QAAA,SAAA,OAAA,yBAG7B,sBAAA,8BAA8B,mBAC9B,cAAA,SAAU,CACX,wBAGC,SAAU,CAIX,iEAIG,iBC9KyC,CD+K1C,8CGxKL,eH4K2B,SCnLoB,SDmLO,OAAE,YAC9B,UAAL,yBEnNG,UA8BZ,CFkMT,+DAJG,4BAAA,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,iBACL,CACnB,iCAKH,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,sBE1JC,aAnEuB,CFkOtB,cIvJqB,iBHtDuB,eAAA,CDmN7C,qBACE,QAAS,CACV,wBEvKD,cF2KE,aAAc,CACf,iBEpLD,yBFyLA,mBC/N6C,CDiO7C,0BIhLoB,iBHjDyB,oBDmO3C,UAAU,iBAEV,cAAc,oBACd,oBAAA,YAAa,CACd,yBIjLqB,mBHtDuB,iBAAA,CDyO5C,qCAGgB,cAAgB,CAHhC,oCAIe,eAAiB,CAAE,8BAEzB,mBAAA,WAAA,MAAQ,CAAE,iCACP,oBAAA,YAAA,OAAS,CAAE,iCACX,mBAAA,WAAA,MAAQ,CAAE,sCACL,mBAAA,cAAA,SAAW,CAAE,oBAK/B,oBAAA,oBAAA,aAAa,mBACb,eAAe,uBCxP8B,CDsP9C,2BC7MC,mCAJqC,kCAKH,aI/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,iBLkRhB,yBAAyB,gBAEzB,kBACA,6BAAA,eAAgB,CACjB,aAZF,2BKhOO,uBAA0B,CL4O/B,CAZF,2DKtNG,eAAgB,CLsNnB,+DK9MG,eAAgB,CL6NnB,8BAEG,cAAc,SCvQ6B,CDqQ9C,oCAMK,uBAAA,oBAAA,0BAA2B,CANhC,qCAUK,mEACA,gBAAiB,CAClB,eCxOH,mCAJqC,kCAKH,aI/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,gBACD,CL2SlB,aAHD,eK/PQ,uBAA0B,CLkQjC,CAHA,mCKrPG,eAAgB,CLqPnB,uCK7OG,eAAgB,CAEnB","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Artist Page Component\n */\n\n@import '../../atoms/text/Label/mixins';\n$hero-height: baseline(47);\n\n%square-constraint {\n  content: \"\";\n  display: block;\n  width: 100%;\n  padding-top: 30vw;\n\n  [data-header-layout=\"vertical\"] & {\n    padding-top: 42vw;\n  }\n}\n\n.page--artist{\n  .track-list, .artist-list{\n    & + .track-list{\n      margin-top: baseline(6);\n    }\n\n    .card{\n      height: baseline(12);\n      padding: 0;\n\n      &:hover{\n        z-index: auto;\n      }\n    }\n    .card__background{\n      display: none;\n    }\n    .card__image{\n      z-index: auto;\n    }\n    .card__content{\n      border-bottom: 1px solid uicolor(border);\n      &__right{\n        z-index: auto;\n      }\n    }\n    &__item:first-child{\n      .card__content{\n        border-top: 1px solid uicolor(border);\n      }\n    }\n  }\n\n  .show-all-tracks-button{\n    display: block;\n    margin-left: auto;\n  }\n}\n\n.artist{\n  &__artist-picture{\n    @include position(fixed, 0 0 0 0);\n    pointer-events: none;\n    overflow: hidden;\n    z-index: 0;\n\n    &::before{\n      @extend %square-constraint;\n    }\n\n    &__inner{\n      @include position(absolute, 0);\n      background-size: cover;\n      background-position: center;\n    }\n\n    [data-header-layout=\"vertical\"] & {\n      left: 50%;\n    }\n  }\n\n  &__header{\n    @include bgcolor(white);\n    position: relative;\n    height: $page-header-height;\n    box-shadow: 0 2px 8px -3px transparentize(uicolor(shadow), .8);\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n\n    &__content-wrapper{\n      @include position(absolute, 0);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex: auto;\n    }\n\n    &__margin{\n      width: 50%;\n      &::before{\n        @extend %square-constraint;\n      }\n    }\n\n    [data-header-layout=\"horizontal\"] & {\n      &__content-wrapper{\n        padding-left: baseline(2);\n      }\n    }\n\n    [data-header-layout=\"vertical\"] & {\n      @include position(fixed, $app-header-height null 0 0);\n      @include size(50% auto);\n      @include bgcolor(black);\n      @include textcolor(white);\n\n      &::before{\n        @extend %square-constraint;\n      }\n\n      &__content-wrapper{\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n      }\n    }\n  }\n\n  &__header &__details {\n    flex: none;\n    display: flex;\n    align-items: center;\n  }\n\n  &__action{\n    &:hover{\n      @include textcolor(accent);\n    }\n  }\n\n  &__info{\n    @include margin(null baseline(1));\n\n    &__title{\n      margin: 0;\n    }\n\n    &__subtitle{\n      @include textcolor(bw7);\n      display: block;\n    }\n  }\n\n  &__content{\n    @include bgcolor(bw2);\n    padding-bottom: baseline(6);\n\n    &__wrapper{\n      @include padding(baseline(6) null);\n      width: 90%;\n      max-width: baseline(144);\n      margin: 0 auto;\n      display: flex;\n    }\n\n    &__column{\n      @include padding(null baseline(3));\n\n      &:first-child{ padding-left: 0 }\n      &:last-child{ padding-right: 0 }\n\n      &--bio{ flex: 7 }\n      &--tracks{ flex: 12 }\n      &--social{ flex: 5 }\n      &--collections{ flex: auto }\n    }\n  }\n\n  &__tags-group{\n    display: flex;\n    flex-wrap: wrap;\n    margin: baseline(2) 0 baseline(2) baseline(-.5);\n\n    &::before{\n      @include label;\n      @include label-size(medium);\n      content: attr(data-title);\n      margin-left: baseline(.5);\n      margin-bottom: baseline(.5);\n      flex-basis: 100%;\n    }\n  }\n\n  &__social-links{\n    .button{\n      display: block;\n      left: baseline(-1);\n\n      &__flex{\n        justify-content: flex-start;\n      }\n\n      &__label{\n        font-family: $font--articulat;\n        font-size: .875em;\n      }\n    }\n  }\n\n  &__about{\n    @include label;\n    @include label-size(medium);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1501);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".picture{display:block}.picture__image{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.picture--fill-with-width .picture__image{width:100%}.picture--fill-with-height .picture__image{height:100%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/images/Picture/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AA4GA,SACE,aAAc,CAEd,gBCrEA,kBDsE4B,QAAK,SAAc,uCAC7C,mCAAA,8BAAgC,CACjC,0CAGC,UAAW,CACZ,2CAGC,WAAY,CACb","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Picture Component\n */\n\n.picture{\n  display: block;\n\n  &__image{\n    @include position(absolute, 50% null null 50%);\n    transform: translate(-50%, -50%);\n  }\n\n  &--fill-with-width &__image{\n    width: 100%;\n  }\n\n  &--fill-with-height &__image{\n    height: 100%;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Background Sizes
 */

Object.defineProperty(exports, "__esModule", { value: true });
function getBackgroundSizeClassName(size) {
  return size ? "bgsize--" + size : '';
}
exports.getBackgroundSizeClassName = getBackgroundSizeClassName;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1504);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".tag{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:4px;cursor:pointer}.tag--small{border-radius:4px}.tag--small .tag__wrapper{padding:7px 10px}.tag--small .tag__label{font-size:.8125em;line-height:1.34}@media print{.tag--small .tag__label{font-size:.6770833331em}}.tag--small .tag__label em,.tag--small .tag__label i{font-weight:300}.tag--small .tag__label b,.tag--small .tag__label strong{font-weight:700}.tag--small .tag__button--exclude:not(.visible){position:absolute;top:-1px;bottom:-1px;left:-16px}.tag--small .tag__button--remove{right:0}.tag--medium{border-radius:4px}.tag--medium .tag__wrapper{padding:9px 12px}.tag--medium .tag__label{font-size:.8125em;line-height:1.34}@media print{.tag--medium .tag__label{font-size:.6770833331em}}.tag--medium .tag__label em,.tag--medium .tag__label i{font-weight:300}.tag--medium .tag__label b,.tag--medium .tag__label strong{font-weight:700}.tag--medium .tag__button--exclude:not(.visible){position:absolute;top:50%;left:-8px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);border-radius:50%}.tag--medium .tag__button--remove{right:4px}.tag--large{border-radius:4px}.tag--large .tag__wrapper{padding:15px 24px}.tag--large .tag__label{font-size:.875em;line-height:1.142857143}@media print{.tag--large .tag__label{font-size:.7291666664em}}.tag--large .tag__label em,.tag--large .tag__label i{font-weight:300}.tag--large .tag__label b,.tag--large .tag__label strong{font-weight:700}.tag--large .tag__button--exclude:not(.visible){position:absolute;top:50%;left:-8px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);border-radius:50%}.tag--large .tag__button--remove{right:4px}.tag.color-scheme--transparent .tag__button--exclude{border-bottom-right-radius:0;border-top-right-radius:0}.tag.color-scheme--transparent .tag__button--exclude,.tag.color-scheme--transparent:hover{background-color:#fff;-webkit-box-shadow:0 1px 0 #e4e8ed;box-shadow:0 1px 0 #e4e8ed}.tag.color-scheme--transparent:hover .tag__badge{background-color:#f0f6fa}.tag.color-scheme--light{color:#8a8f99}.tag.color-scheme--light:hover{background-color:#e4e8ed;border-color:#e4e8ed}.tag.color-scheme--light:hover .tag__badge{background-color:#f0f6fa}.tag.color-scheme--white{-webkit-box-shadow:0 1px 0 #e4e8ed;box-shadow:0 1px 0 #e4e8ed}.tag.color-scheme--white:hover{background-color:#fff;color:#101015;border-color:#fff}.tag.color-scheme--white:hover .tag__badge{background-color:#f0f6fa}.tag--no-link .tag__wrapper{cursor:default}.tag--exclude{background-color:#f64343;border-color:#f64343}.tag--exclude:hover{background-color:#f75b5b;border-color:#f75b5b}.tag--disabled.tag{cursor:not-allowed}.tag--disabled.tag,.tag--disabled.tag:hover{background-color:#f9fafb;color:#d2d9e1;border-color:#f9fafb}.tag--disabled.tag:hover{-webkit-transform:none;-ms-transform:none;transform:none}.tag em{font-style:normal;font-weight:700}.tag--removed{display:none}.tag--filter{padding-right:24px;-webkit-transform:bottom left;-ms-transform:bottom left;transform:bottom left}.tag--button{color:#101015}.tag__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:left}.tag__wrapper .button__wrapper{padding:0}.tag__button--exclude.visible+.tag__wrapper{padding-left:0}.tag__button{display:none}.tag__button--exclude{color:#d2d9e1}.color-scheme--transparent .tag__button--exclude{background-color:#f0f6fa}.tag--button:hover .tag__button--exclude,.tag__button--exclude.visible{display:-webkit-box;display:-ms-flexbox;display:flex}.tag__button--exclude:hover{color:#f75b5b}.tag__button--remove{position:absolute;top:0;bottom:0}.tag--filter .tag__button--remove{display:block}.tag__button--subtags.button{background-color:#f5faff;border-radius:50%;height:20px;width:20px;margin-right:4px;display:block}.tag__button--subtags.button .icon,.tag__button--subtags.button .icon svg{width:100%}.tag__label{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.tag__badge{margin-left:16px;-webkit-box-flex:0;-ms-flex:none;flex:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/Tag/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/Tag/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA8GA,KACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,WAEnB,cAAe,CAGb,YCpFE,iBAvBgB,CD2GjB,0BEvBqB,gBC3DuB,CHkF5C,wBIhEC,kBAtCgB,gBACD,CCuCwB,aL8DxC,wBI5DK,uBAA0B,CCFS,CL8DxC,qDIlDC,eAAgB,CJkDjB,yDI1CC,eAAgB,CJ0CjB,gDM3EH,kBDkBgC,SAAM,YAAU,UFzBD,CHkF5C,iCKhDG,OAAQ,CLgDZ,aCpFE,iBAvBgB,CD2GjB,2BEvBqB,gBC3DuB,CHkF5C,yBIhEC,kBAtCgB,gBACD,CCuCwB,aL8DxC,yBI5DK,uBAA0B,CCFS,CL8DxC,uDIlDC,eAAgB,CJkDjB,2DI1CC,eAAgB,CJ0CjB,iDM3EH,kBDoBgC,QAAK,UF3BU,mCE4BzC,+BAAA,2BAA2B,iBACT,CLqDrB,kCK9CG,SFpCyC,CHkF7C,YCpFE,iBAvBgB,CD2GjB,0BEvBqB,iBC3DuB,CHkF5C,wBIhEC,iBAlCe,uBACO,CCmCiB,aL8DxC,wBI5DK,uBAA0B,CCFS,CL8DxC,qDIlDC,eAAgB,CJkDjB,yDI1CC,eAAgB,CJ0CjB,gDM3EH,kBDoBgC,QAAK,UF3BU,mCE4BzC,+BAAA,2BAA2B,iBACT,CLqDrB,iCK9CG,SFpCyC,CH2EjD,qDAgBM,6BAA6B,yBACH,CAjBhC,0FAcM,sBAAuB,mCACvB,0BOlHqB,CPmG3B,iDOrCI,wBAzDuB,CP8F3B,yBO7BI,aA3EoB,CPwGxB,+BOrCI,yBPuEE,oBOrIqB,CPmG3B,2COrCI,wBAzDuB,CP8F3B,yBA2CI,mCAAA,0BO9IuB,CPmG3B,+BOrCI,sBAvCU,cP4HR,iBO5HQ,CP4Ed,2COrCI,wBAzDuB,CPkJpB,4BAKH,cAAe,CAChB,cAIC,yBAA8C,oBACJ,CAH3C,oBAMG,yBACA,oBOhKoB,CPiKrB,mBAID,kBAAmB,CADpB,4CO5GC,yBA5DsB,cP8KpB,oBO9KoB,CPwKvB,yBAUG,uBAAA,mBAAA,cAAe,CAjFrB,QAsFI,kBAAkB,eACD,CAClB,cAGC,YAAa,CACd,aAGC,mBACA,8BAAA,0BAAA,qBAAsB,CAYvB,aOzIC,aA7EsB,CP0NvB,cAGC,oBAAA,oBAAA,aAAa,mBACb,cAAA,UAAU,yBACV,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,eACH,CALjB,+BAQG,SAAU,CACX,4CAGC,cAAe,CAChB,aAID,YAAa,CAEb,sBOlKA,aAvEmB,CP4OjB,iDO7KF,wBAzDuB,CPmOtB,uEAQG,oBAAA,oBAAA,YAAa,CARhB,4BOlKD,aAhEsB,CP+OnB,qBMtNL,kBN0N8B,MAAG,QAAO,CAEpC,kCACE,aAAc,CACf,6BO/LH,yBNxCE,kBAdgB,YEgB2B,WH4O3C,iBACA,aAAc,CALf,0EAOmB,UAAY,CAAE,YAKlC,mBAAA,cAAA,SAAU,CACX,YAGC,iBACA,mBAAA,cAAA,SAAU,CACX","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Tag Component\n */\n\n@import \"./mixins\";\n\n.tag{\n  display: flex;\n  align-items: center;\n  margin: baseline(.5);\n  cursor: pointer;\n\n  @each $tag-size, $options in $tag-sizes {\n    &--#{$tag-size} {\n\t\t\t@include tag-for-size(map-merge($options, (size: $tag-size)));\n\t\t}\n  }\n\n  &.color-scheme--transparent{\n    .tag__button--exclude{\n      background-color: white;\n      box-shadow: 0 1px 0 color(bw4);\n      border-bottom-right-radius: 0;\n      border-top-right-radius: 0;\n    }\n    &:hover{\n      background-color: white;\n      box-shadow: 0 1px 0 color(bw4);\n\n      .tag__badge{\n        @include bgcolor(bw3);\n      }\n    }\n  }\n\n  &.color-scheme--light{\n    @include textcolor(bw7);\n\n    &:hover{\n      @include bgcolor(bw4);\n      border-color: color(bw4);\n\n      .tag__badge{\n        @include bgcolor(bw3);\n      }\n    }\n  }\n\n  &.color-scheme--white{\n    box-shadow: 0 1px 0 color(bw4);\n\n    &:hover{\n      @include bgcolor(white);\n      @include textcolor(dark);\n      border-color: color(white);\n\n      .tag__badge{\n        @include bgcolor(bw3);\n      }\n    }\n  }\n\n  &--no-link &__wrapper{\n    cursor: default;\n  }\n\n  &--exclude{\n    // @include bgcolor(dangerous);\n    background-color: darken(color(dangerous), 5%);\n    border-color: darken(color(dangerous), 5%);\n\n    &:hover{\n      background-color: color(dangerous);\n      border-color: color(dangerous);\n    }\n  }\n\n  &--disabled.tag{\n    cursor: not-allowed;\n\n    &, &:hover{\n      @include bgcolor(bw2);\n      @include textcolor(bw5);\n      border-color: color(bw2);\n    }\n\n    &:hover{\n      transform: none;\n    }\n  }\n\n  em{\n    font-style: normal;\n    font-weight: bold;\n  }\n\n  &--removed{\n    display: none;\n  }\n\n  &--filter{\n    padding-right: baseline(3);\n    transform: bottom left;\n    // animation: show-tag-filter .5s $ease-out-back;\n    // animation-fill-mode: both;\n\n    @keyframes show-tag-filter{\n      0% {\n        transform: rotateX(90deg) scaleX(.6) translateZ(-40px);\n      }\n      100% {\n        transform: rotateX(0deg) scaleX(1) translateZ(0);\n      }\n    }\n  }\n\n  &--button{\n    @include textcolor(bw8);\n  }\n\n  &__wrapper{\n    display: flex;\n    flex: auto;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n\n    .button__wrapper{\n      padding: 0;\n    }\n\n    .tag__button--exclude.visible + & {\n      padding-left: 0;\n    }\n  }\n\n  &__button{\n    display: none;\n\n    &--exclude{\n      @include textcolor(bw5);\n\n      .color-scheme--transparent & {\n        @include bgcolor(bw3);\n      }\n\n      &.visible, .tag--button:hover &{\n        display: flex;\n      }\n\n      &:hover{\n        @include textcolor(dangerous);\n      }\n    }\n\n    &--remove{\n      @include position(absolute, 0 null 0 null);\n\n      .tag--filter &{\n        display: block;\n      }\n    }\n\n    &--subtags.button{\n      @include bgcolor(accent-subtle);\n      @include bgsize(circle);\n      @include size(baseline(2.5));\n      margin-right: baseline(.5);\n      display: block;\n\n      .icon, .icon svg{ width: 100% }\n    }\n  }\n\n  &__label{\n    flex: auto;\n  }\n\n  &__badge{\n    margin-left: baseline(2);\n    flex: none;\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","/**\n * Tags\n */\n\n@import \"../../atoms/text/Label/mixins\";\n\n/* Definitions */\n$tag-sizes: (\n  small: (\n    bg: medium,\n    h-padding: 1.25,\n    height: 3.75,\n    label: medium,\n  ),\n  medium: (\n    bg: medium,\n    h-padding: 1.5,\n    height: 4.25,\n    label: medium,\n  ),\n  large: (\n    bg: medium,\n    h-padding: 3,\n    height: 5.75,\n    label: large,\n  ),\n);\n\n/* Mixins */\n$default-tag-size-options: map-get($tag-sizes, medium);\n@mixin tag-for-size($options) {\n  $options: map-merge($default-tag-size-options, $options);\n  $size: map-get($options, size);\n  $height: map-get($options, height);\n  $h-padding: map-get($options, h-padding);\n  $label: map-get($options, label);\n  $bg: map-get($options, bg);\n  $v-padding-fix: map-get($options, v-padding-fix);\n\n  $computed-height: baseline($height);\n  $label-height: get-label-height($label);\n  $padding: ceil(($computed-height - $label-height) / 2);\n\n  @include bgsize($bg);\n\n  .tag__wrapper{\n    @include padding(null baseline($h-padding));\n\n    @if $v-padding-fix {\n      @include padding($padding - 1 null $padding + 1);\n    } @else {\n      @include padding($padding null);\n    }\n  }\n\n  .tag__label{ @include label-size($label) }\n\n  .tag__button{\n    &--exclude:not(.visible){\n      @if $size == 'small' {\n        @include position(absolute, -1px null -1px baseline(-2));\n      } @else {\n        @include position(absolute, 50% null null baseline(-1));\n        transform: translateY(-50%);\n        border-radius: 50%;\n      }\n    }\n    &--remove{\n      @if $size == 'small' {\n        right: 0;\n      } @else {\n        right: baseline(.5);\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1506);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".badge{text-align:center;border-radius:8px;min-width:26px;padding-right:6px;padding-left:6px}.badge--white{background-color:#fff;color:#8a8f99}.badge--light{background-color:#f0f6fa;color:#8a8f99}.badge--red{background-color:#4487ff;color:#fff}.badge__label{display:block;line-height:1.455}.badge--notification{min-width:16px;padding-right:4px;padding-left:4px}.badge--notification .badge__label{font-size:.5625em;line-height:1.777777778}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/Badge/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,OACE,kBAAkB,kBAElB,eC5E+C,kBAAA,gBAAA,CDgF/C,cE1CE,sBAvCU,aA5BU,CFgHrB,cE7CC,yBAzDuB,aAVH,CFoHrB,YEjDC,yBA3DuB,UAoBb,CF4FX,cAGC,cAAc,iBACI,CACnB,qBAGC,eCnG6C,kBAAA,gBAAA,CDqG9C,mCACC,kBAAkB,uBACM,CACzB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Badge Component\n */\n\n.badge{\n  text-align: center;\n  border-radius: baseline(1);\n  min-width: baseline(3.25);\n\n  @include padding(null baseline(.75));\n\n  &--white{\n    @include bgcolor(white);\n    @include textcolor(bw7);\n  }\n  &--light{\n    @include bgcolor(bw3);\n    @include textcolor(bw7);\n  }\n  &--red{\n    @include bgcolor(accent);\n    @include textcolor(white);\n  }\n\n  &__label{\n    display: block;\n    line-height: 1.455;\n  }\n\n  &--notification{\n    min-width: baseline(2);\n    @include padding(null baseline(.5));\n  } &--notification &__label{\n    font-size: .5625em;\n    line-height: 1.777777778;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1508);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".collection-list .collection-card{-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom;-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}html.no-touchevents .collection-list .collection-card:hover,html.touchevents .collection-list .collection-card:active{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}.collection-list .collection-card:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;z-index:-1}.collection-list--grid-view .collection-list__list{list-style:none;margin:24px 0 0 -8px;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.collection-list--grid-view .collection-list__list__item{padding:8px;-ms-flex-preferred-size:50%;flex-basis:50%}@media screen and (min-width:960px){.collection-list--grid-view .collection-list__list__item{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%}}@media screen and (min-width:1024px){.collection-list--grid-view .collection-list__list__item{-ms-flex-preferred-size:25%;flex-basis:25%}}@media screen and (min-width:1600px){.collection-list--grid-view .collection-list__list__item{-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/Collections/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AA4GA,kCAEI,gCAAA,4BAAA,wBAAwB,0DACxB,qDAAA,iDCvFyD,CDoG1D,sHAVG,8BAAA,0BAAA,qBAAsB,CAN5B,wCAUM,WAAW,kBACe,MAAG,QAAA,SAAA,OAAA,kBAG7B,UAAW,CACZ,mDAID,gBAAgB,qBAEhB,UAAU,oBACV,oBAAA,aAAa,mBACb,cAAe,CAChB,yDAGC,YACA,4BAAA,cAAe,CAWhB,oCAbD,yDAKI,qCAAA,uBAAwB,CAQ3B,CAAA,qCAbD,yDAQI,4BAAA,cAAe,CAKlB,CAAA,qCAbD,yDAWI,kCAAA,oBAAqB,CAExB,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Collections Component\n */\n\n.collection-list{\n  .collection-card{\n    transform-origin: bottom;\n    transition: .25s $ease-out-back;\n\n    @include hover{\n      transform: scale(1.03);\n    }\n\n    &::after{\n      content: \"\";\n      @include position(absolute, 0);\n      // @include shadow(large);\n      @include bgsize(large);\n      z-index: -1;\n    }\n  }\n\n  &--grid-view &__list {\n    list-style: none;\n    margin: baseline(3) 0 0 baseline(-1);\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &--grid-view &__list__item{\n    padding: baseline(1);\n    flex-basis: 50%;\n\n    @include media(breakpoint(desktop-s)) {\n      flex-basis: 33.33333333%;\n    }\n    @include media(breakpoint(desktop)) {\n      flex-basis: 25%;\n    }\n    @include media(breakpoint(desktop-xxl)) {\n      flex-basis: 16.66667%;\n    }\n  }\n}\n\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1510);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.collection-card{cursor:pointer;display:block;color:#101015}.collection-card--loading{background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1s linear infinite;animation:gradient-cycle 1s linear infinite}.collection-card:before{content:\"\";display:block;width:100%}.collection-card:hover .card-play-button{color:#4487ff}.collection-card:hover .card-play-button .card-play-button__blurred-image{opacity:.2}.collection-card--medium:before{padding-top:56.249999993%}.collection-card--medium,.collection-card--medium .collection-card__wrapper{border-radius:8px}.collection-card--medium .collection-card__title-wrapper{position:absolute;top:8px;right:20%;left:16px}.collection-card--medium .collection-card__topic-wrapper{position:absolute;bottom:16px;left:16px}.collection-card--medium .card-play-button{position:absolute;right:calc(-6.1523437492% + 12px);bottom:calc(-10.9375% + 12px);width:12.3046874985%;height:21.875%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.collection-card--medium .card-play-button__blurred-image{position:absolute;top:calc(-128.571428571% + 12px);left:calc(-306.3492064% + 12px);width:812.6984128%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.collection-card--large:before{padding-top:83.248730978%}.collection-card--large,.collection-card--large .collection-card__wrapper{border-radius:8px}.collection-card--large .collection-card__title-wrapper{position:absolute;top:16px;right:20%;left:24px}.collection-card--large .collection-card__topic-wrapper{position:absolute;bottom:16px;left:16px}.collection-card--large .card-play-button{position:absolute;right:calc(-9.1053299507% + 12px);bottom:calc(-10.9375% + 12px);width:18.2106599014%;height:21.875%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.collection-card--large .card-play-button__blurred-image{position:absolute;top:calc(-128.571428571% + 12px);left:calc(-174.564459886% + 12px);width:768.78048768%;height:640%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.collection-card--vertical:before{padding-top:138.888888889%}.collection-card--vertical,.collection-card--vertical .collection-card__wrapper{border-radius:8px}.collection-card--vertical .collection-card__title-wrapper{position:absolute;top:8px;right:20%;left:16px}.collection-card--vertical .collection-card__topic-wrapper{position:absolute;bottom:16px;left:16px}.collection-card--vertical .card-play-button{position:absolute;right:calc(-9.7222222222% + 12px);bottom:calc(-7% + 12px);width:19.4444444444%;height:14%;-webkit-transform:translate(-50%,-50%) translateZ(0);transform:translate(-50%,-50%) translateZ(0)}.collection-card--vertical .card-play-button__blurred-image{position:absolute;top:calc(-257.142857143% + 12px);left:calc(-157.142857143% + 12px);width:720%;height:1000%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.collection-card__wrapper{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-mask-image:-webkit-radial-gradient(#fff,#000);overflow:hidden}.collection-card__image{position:absolute;top:0;right:0;bottom:0;left:0;background-position:50%;background-size:cover;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-transition:.75s ease-in-out;-o-transition:.75s ease-in-out;transition:.75s ease-in-out;opacity:.9}.collection-card__wrapper:hover .collection-card__image{-webkit-transition-duration:8s;-o-transition-duration:8s;transition-duration:8s;-webkit-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out;-webkit-transform:scale(1.2) translateZ(0);transform:scale(1.2) translateZ(0)}.collection-card__image-mask{position:absolute;top:0;right:0;bottom:0;left:0;background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(16,16,21,.5)),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(bottom,rgba(16,16,21,.5),rgba(16,16,21,0));background-image:-o-linear-gradient(bottom,rgba(16,16,21,.5) 0,rgba(16,16,21,0) 100%);background-image:linear-gradient(0deg,rgba(16,16,21,.5) 0,rgba(16,16,21,0))}.collection-card__title-wrapper{color:#fff}.collection-card__title-wrapper .label{font-weight:500}.collection-card__title{margin:0;font-weight:500}.collection-card__topic-wrapper{color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.collection-card__topic-wrapper .icon svg{height:baselin(2.5)}.collection-card__topic{margin-left:8px;font-weight:500}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/media/CollectionCard/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/buttons/CardPlayButton/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/media/CollectionCard/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,iBAUlC,eAAe,cACD,aC5GU,CD+GxB,0BArBA,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,oDAC1B,2CAAgE,CAclE,wBAUI,WAAW,cACG,UACH,CAZf,yCC7BI,aAnEuB,CDgG3B,0EErGI,UAAW,CF2HV,gCG9DD,yBAA0B,CH8DzB,4EInGC,iBApBgB,CJuHjB,yDK1FH,kBFoC4B,QEhCxB,UF3B4B,SGgBe,CNiG5C,yDK1FH,kBFwC4B,YEpCxB,SCX2C,CNiG5C,2CK1FH,kBHiB4B,kCApCkD,8BACT,qBAoCvC,eACE,qDAE9B,4CAA8C,CFqE7C,0DK1FH,kBHyB4B,iCAtCwD,gCADS,mBA0CrD,uCAMtC,mCAAA,8BAAgC,CFwD/B,+BG9DD,yBAA0B,CH8DzB,0EInGC,iBApBgB,CJuHjB,wDK1FH,kBFoC4B,SEhCxB,UFb4B,SGEe,CNiG5C,wDK1FH,kBFwC4B,YEpCxB,SCX2C,CNiG5C,0CK1FH,kBHiB4B,kCApCkD,8BACT,qBAoCvC,eACE,qDAE9B,4CAA8C,CFqE7C,yDK1FH,kBHyB4B,iCAtCwD,kCADS,oBA4C/C,YACR,uCAGpC,mCAAA,8BAAgC,CFwD/B,kCG9DD,0BAA0B,CH8DzB,gFInGC,iBApBgB,CJuHjB,2DK1FH,kBFoC4B,QEhCxB,UFC4B,SGZe,CNiG5C,2DK1FH,kBFwC4B,YEpCxB,SCX2C,CNiG5C,6CK1FH,kBHiB4B,kCApCkD,wBACT,qBAoCvC,WACE,qDAE9B,4CAA8C,CFqE7C,4DK1FH,kBHyB4B,iCAtCwD,kCADS,WA4C/C,aACR,uCAGpC,mCAAA,8BAAgC,CF6DlC,0BK/FA,kBLgG4B,MAAG,QAAA,SAAA,OAAA,sDAC4B,eACzC,CACjB,wBKnGD,kBLsG4B,MAAG,QAAA,SAAA,OAAA,wBACF,sBACL,gCACtB,wBAAwB,oCACxB,+BAAA,4BAA4B,UACjB,CAEX,wDACE,+BAAA,0BAAA,uBAAuB,4CACvB,uCAAA,oCAAoC,2CACpC,kCAAmC,CACpC,6BKjHH,kBLqH4B,MAAG,QAAA,SAAA,OAAA,4GAC7B,oFAAA,sFAAA,2EAAkH,CACnH,gCChFC,UA/CU,CDiIX,uCAIG,eAAgB,CACjB,wBAID,SAAS,eAEO,CACjB,gCC9FC,WDmGA,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAJpB,0CAOG,mBAAoB,CACrB,wBAID,gBACA,eAAgB,CACjB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Card Component\n */\n\n@import './mixins';\n\n.collection-card{\n  cursor: pointer;\n  display: block;\n  @include textcolor(dark);\n\n  &--loading {\n    @include loading-placeholder(1s);\n  }\n\n  &::before{\n    content: \"\";\n    display: block;\n    width: 100%;\n  }\n\n  &:hover{\n    .card-play-button{\n      @include card-play-button-hover;\n    }\n  }\n\n  @each $card-size, $options in $collection-card-sizes {\n    &--#{$card-size}{\n      @include collection-card-for-size($card-size);\n    }\n  }\n\n  &__wrapper{\n    @include position(absolute, 0);\n    -webkit-mask-image: -webkit-radial-gradient(white, black);\n    overflow: hidden;\n  }\n\n  &__image{\n    @include position(absolute, 0);\n    background-position: center;\n    background-size: cover;\n    transform: translateZ(0);\n    transition: .75s ease-in-out;\n    opacity: .9; // more matte, less obstrusive\n\n    .collection-card__wrapper:hover & {\n      transition-duration: 8s;\n      transition-timing-function: ease-out;\n      transform: scale(1.2) translateZ(0);\n    }\n  }\n\n  &__image-mask{\n    @include position(absolute, 0);\n    background-image: linear-gradient(to top, transparentize(color(dark), .5) 0%, transparentize(color(dark), 1) 100%);\n  }\n\n  &__title-wrapper{\n    @include textcolor(white);\n\n    .label {\n      font-weight: 500;\n    }\n  }\n\n  &__title{\n    margin: 0;\n    // max-width: 90%;\n    font-weight: 500;\n  }\n\n  &__topic-wrapper{\n    @include textcolor(white);\n\n    display: flex;\n    align-items: center;\n\n    .icon svg{\n      height: baselin(2.5);\n    }\n  }\n\n  &__topic{\n    margin-left: baseline(1);\n    font-weight: 500;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Card Play Button Component\n */\n\n$context: \".card-play-button\";\n\n@mixin card-play-button-hover(){\n  @include textcolor(accent);\n  #{$context}__blurred-image{\n    opacity: .2;\n  }\n}\n\n@mixin position-card-play-button($position, $height, $container-height, $margin: 0, $ratio: 1) {\n  $height-percent: $height / $container-height;\n  $width-percent: $height-percent / $ratio;\n  $image-height: (1 / $height-percent);\n  $computed-half-size-percent: ($height-percent / 2) * 100%;\n  $computed-margin: baseline($margin);\n  $container-position: null;\n  $image-position: null;\n\n  $top:     calc(#{$computed-half-size-percent} + #{$computed-margin});\n  $right:   calc(#{-$computed-half-size-percent / $ratio} + #{$computed-margin});\n  $bottom:  calc(#{-$computed-half-size-percent} + #{$computed-margin});\n  $left:    calc(#{$computed-half-size-percent / $ratio} + #{$computed-margin});\n\n  $image-top:     calc(#{($image-height / 2) * 100%} - #{$computed-margin});\n  $image-right:   calc(-#{(($image-height * $ratio * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-bottom:  calc(-#{(($image-height * 100%) - 200%) / 2} + #{$computed-margin});\n  $image-left:    calc(#{($image-height  / 2) * $ratio * 100%} - #{$computed-margin});\n\n  @if $position == \"center\" {\n    $container-position: 50% null null 50%;\n    $image-position: 50% null null 50%;\n  }\n\n  @if $position == \"top left\" {\n    $container-position: $top null null $left;\n    $image-position: $image-top null null $image-left;\n  }\n\n  @if $position == \"top right\" {\n    $container-position: $top $right null null;\n    $image-position: $image-top null null $image-right;\n  }\n\n  @if $position == \"bottom left\" {\n    $container-position: null null $bottom $left;\n    $image-position: $image-bottom null null $image-left;\n  }\n\n  @if $position == \"bottom right\" {\n    $container-position: null $right $bottom null;\n    $image-position: $image-bottom null null $image-right;\n  }\n\n  // Render\n  #{$context}{\n    @include position(absolute, $container-position);\n    width: $width-percent * 100%;\n    height: $height-percent * 100%;\n\n    transform: translate(-50%, -50%) translateZ(0);\n  }\n\n  #{$context}__blurred-image{\n    @include position(absolute, $image-position);\n\n    @if $ratio > 1.3333 {\n      width: $image-height * $ratio * 100%;\n    } @else {\n      width: $image-height * $ratio * 1.4 * 100%;\n      height: $image-height * 1.4 * 100%;\n    }\n\n    transform: translate(-50%, -50%);\n  }\n}\n","/**\n * Collection Card\n */\n\n\n@import '../../../atoms/buttons/CardPlayButton/mixins';\n\n$collection-card-sizes: (\n  medium: (\n    button-play: (\n      position: \"bottom right\",\n      height: 7,\n      container-height: 32,\n      margin: 1.5,\n    ),\n    bg: large,\n    height: 32,\n    image-blur: 20px,\n    ratio: 1 / 1.777777778,\n    title-padding: baseline(1) 20% null baseline(2),\n    topic-padding: null null baseline(2) baseline(2),\n  ),\n  large: (\n    button-play: (\n      position: \"bottom right\",\n      height: 7,\n      container-height: 32,\n      margin: 1.5,\n    ),\n    bg: large,\n    height: 42,\n    image-blur: 30px,\n    ratio: 1 / 1.201219512,\n    title-padding: baseline(2) 20% null baseline(3),\n    topic-padding: null null baseline(2) baseline(2),\n  ),\n  vertical: (\n    button-play: (\n      position: \"bottom right\",\n      height: 7,\n      container-height: 50,\n      margin: 1.5,\n    ),\n    bg: large,\n    height: 50,\n    image-blur: 30px,\n    ratio: 1 / .72,\n    title-padding: baseline(1) 20% null baseline(2),\n    topic-padding: null null baseline(2) baseline(2),\n  ),\n);\n\n@function get-collection-card-height($size) {\n  @if map-has-key($collection-card-sizes, $size) {\n    @return map-get(map-get($collection-card-sizes, $size), height);\n  }\n  @return 0;\n}\n\n@mixin collection-card-for-size($size) {\n  $options: map-get($collection-card-sizes, $size);\n  $button-play: map-get($options, button-play);\n  $bgsize: map-get($options, bg);\n  $height: map-get($options, height);\n  $image-blur: map-get($options, image-blur);\n  $ratio: map-get($options, ratio);\n  $title-padding: map-get($options, title-padding);\n  $topic-padding: map-get($options, topic-padding);\n\n  &::before{\n    padding-top: $ratio * 100%;\n  }\n\n  &, .collection-card__wrapper{\n    @include bgsize($bgsize);\n  }\n\n  .collection-card__title-wrapper{\n    @include position(absolute, $title-padding);\n  }\n\n  .collection-card__topic-wrapper{\n    @include position(absolute, $topic-padding);\n  }\n\n  @include position-card-play-button(\n    $position: map-get($button-play, position),\n    $height: map-get($button-play, height),\n    $container-height: map-get($button-play, container-height),\n    $margin: map-get($button-play, margin),\n    $ratio: 1 / $ratio\n  );\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type collectionNode$ref: FragmentReference;
export type collectionNode = {|
  +id: string,
  +description: ?string,
  +name: string,
  +slug: ?string,
  +category: ?{|
    +id: string,
    +name: ?string,
  |},
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +$refType: collectionNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "collectionNode",
    "type": "Collection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionCategory",
      "plural": false,
      "selections": [v0, v1]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "assets",
      "storageKey": null,
      "args": null,
      "concreteType": "Asset",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "version",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "file_format",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "path",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "metadata",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
node /*: any*/.hash = '0cf570960dbf6035680fd47b3d8da980';
module.exports = node;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 108eb1b26fa00e7482868f819bb62e56
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type collectionList_viewer$ref = any;
export type collectionList_QueryVariables = {| |};
export type collectionList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: collectionList_viewer$ref,
  |},
|};
*/

/*
query collectionList_Query {
  viewer {
    ...collectionList_viewer
    id
  }
}

fragment collectionList_viewer on Viewer {
  id
  collections(first: 1000) {
    total
    edges {
      node {
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        tracks {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  collection_categories(first: 1000) {
    edges {
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "Literal",
    "name": "first",
    "value": 1000,
    "type": "Int"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "collectionList_Query",
    "id": null,
    "text": "query collectionList_Query {\n  viewer {\n    ...collectionList_viewer\n    id\n  }\n}\n\nfragment collectionList_viewer on Viewer {\n  id\n  collections(first: 1000) {\n    total\n    edges {\n      node {\n        id\n        description\n        name\n        slug\n        category {\n          id\n          name\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        tracks {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  collection_categories(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "collectionList_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "collectionList_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "collectionList_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [v0, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collections",
          "storageKey": "collections(first:1000)",
          "args": v1,
          "concreteType": "CollectionConnection",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategory",
                "plural": false,
                "selections": [v0, v2]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "assets",
                "storageKey": null,
                "args": null,
                "concreteType": "Asset",
                "plural": true,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "version",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "file_format",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "metadata",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "tracks",
                "storageKey": null,
                "args": null,
                "concreteType": "Track",
                "plural": true,
                "selections": [v0]
              }, v3]
            }, v4]
          }, v5]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "collections",
          "args": v1,
          "handle": "connection",
          "key": "list_collections",
          "filters": []
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collection_categories",
          "storageKey": "collection_categories(first:1000)",
          "args": v1,
          "concreteType": "CollectionCategoryConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionCategoryEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionCategory",
              "plural": false,
              "selections": [v0, v2, v3]
            }, v4]
          }, v5]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "collection_categories",
          "args": v1,
          "handle": "connection",
          "key": "list_collection_categories",
          "filters": []
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '3e4aa194cfd265b0954cfab39b85eb6e';
module.exports = node;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash cfaeca8c21cff66dbb3cb7efc69c106f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type collection_viewer$ref = any;
export type TrackSimilarityFeature = ('Default' | '%future added value');
export type collectionPage_QueryVariables = {|
  query?: ?string,
  filters?: ?{
    term_filters?: ?$ReadOnlyArray<?string>,
    not_term_filters?: ?$ReadOnlyArray<?string>,
    collection_slug?: ?string,
    artist_slug?: ?string,
    budget?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    duration?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    tempo?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    similarity?: ?{
      track_id: string,
      feature: TrackSimilarityFeature,
    },
  },
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
|};
export type collectionPage_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: collection_viewer$ref,
  |},
|};
*/

/*
query collectionPage_Query(
  $query: String
  $filters: TrackSearchFilters
  $license_params: [LicenseUsageParamsInput]
) {
  viewer {
    ...collection_viewer
    id
  }
}

fragment collection_viewer on Viewer {
  ...signUpCta_viewer
  trackSearch(first: 100, offset: 0, query: $query, filters: $filters, license_params: $license_params) {
    edges {
      node {
        id
        internal_id
        price
        base_price
        title
        added_to_cart
        slug
        duration
        score
        boosted_score
        stems_available
        customizable
        matched_exclusions
        tempos {
          id
          name
          value
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          bio
          bandcamp
          facebook
          instagram
          itunes
          soundcloud
          spotify
          twitter
          wiki
          youtube
          homebase
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms(first: 100) {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
        collections {
          edges {
            node {
              id
              description
              name
              slug
              category {
                id
                name
              }
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            id
          }
        }
        association_id
        selected_version
        __typename
      }
      id
      cursor
    }
    total
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment signUpCta_viewer on Viewer {
  home_page {
    sign_up_cta_images
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "filters",
    "type": "TrackSearchFilters",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "collectionPage_Query",
    "id": null,
    "text": "query collectionPage_Query(\n  $query: String\n  $filters: TrackSearchFilters\n  $license_params: [LicenseUsageParamsInput]\n) {\n  viewer {\n    ...collection_viewer\n    id\n  }\n}\n\nfragment collection_viewer on Viewer {\n  ...signUpCta_viewer\n  trackSearch(first: 100, offset: 0, query: $query, filters: $filters, license_params: $license_params) {\n    edges {\n      node {\n        id\n        internal_id\n        price\n        base_price\n        title\n        added_to_cart\n        slug\n        duration\n        score\n        boosted_score\n        stems_available\n        customizable\n        matched_exclusions\n        tempos {\n          id\n          name\n          value\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          bio\n          bandcamp\n          facebook\n          instagram\n          itunes\n          soundcloud\n          spotify\n          twitter\n          wiki\n          youtube\n          homebase\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms(first: 100) {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n        collections {\n          edges {\n            node {\n              id\n              description\n              name\n              slug\n              category {\n                id\n                name\n              }\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            id\n          }\n        }\n        association_id\n        selected_version\n        __typename\n      }\n      id\n      cursor\n    }\n    total\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment signUpCta_viewer on Viewer {\n  home_page {\n    sign_up_cta_images\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "collectionPage_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "collection_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "collectionPage_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "home_page",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePageContent",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "sign_up_cta_images",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "trackSearch",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters",
            "type": "TrackSearchFilters"
          }, v1, {
            "kind": "Variable",
            "name": "license_params",
            "variableName": "license_params",
            "type": "[LicenseUsageParamsInput]"
          }, {
            "kind": "Literal",
            "name": "offset",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String"
          }],
          "concreteType": "TrackSearchResultConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResultEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "stems_available",
                "args": null,
                "storageKey": null
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "price",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "base_price",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              }, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "duration",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "score",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "boosted_score",
                "args": null,
                "storageKey": null
              }, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "customizable",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "matched_exclusions",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "tempos",
                "storageKey": null,
                "args": null,
                "concreteType": "Tempo",
                "plural": true,
                "selections": [v2, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }]
              }, v6, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "itunes",
                  "args": null,
                  "storageKey": null
                }, v2, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bio",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bandcamp",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "facebook",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "instagram",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "soundcloud",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "spotify",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "twitter",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "wiki",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "youtube",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "homebase",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": "terms(first:100)",
                "args": [v1],
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [v2, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_highlighted",
                      "args": null,
                      "storageKey": null
                    }, v5, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "parent_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [v2, v4, v5]
                    }]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "collections",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionTrackConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Collection",
                    "plural": false,
                    "selections": [v2, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "description",
                      "args": null,
                      "storageKey": null
                    }, v5, v3, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "category",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CollectionCategory",
                      "plural": false,
                      "selections": [v2, v5]
                    }, v6]
                  }, v2]
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "association_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected_version",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "trackSearch",
          "args": [{
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters",
            "type": "TrackSearchFilters"
          }, v1, {
            "kind": "Variable",
            "name": "license_params",
            "variableName": "license_params",
            "type": "[LicenseUsageParamsInput]"
          }, {
            "kind": "Literal",
            "name": "offset",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String"
          }],
          "handle": "connection",
          "key": "collection_trackSearch",
          "filters": ["offset", "query", "filters", "license_params"]
        }, v2]
      }]
    }
  };
}();
node /*: any*/.hash = 'ec82ec5329f871003cdb944fb6525316';
module.exports = node;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type signUpCta_viewer$ref = any;
import type { FragmentReference } from 'relay-runtime';
declare export opaque type collection_viewer$ref: FragmentReference;
export type collection_viewer = {|
  +trackSearch: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +price: ?number,
        +base_price: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +duration: ?number,
        +score: ?number,
        +boosted_score: ?number,
        +stems_available: ?boolean,
        +customizable: ?boolean,
        +matched_exclusions: ?$ReadOnlyArray<?number>,
        +tempos: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +value: ?number,
        |}>,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +bio: ?string,
          +bandcamp: ?string,
          +facebook: ?string,
          +instagram: ?string,
          +itunes: ?string,
          +soundcloud: ?string,
          +spotify: ?string,
          +twitter: ?string,
          +wiki: ?string,
          +youtube: ?string,
          +homebase: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
        +collections: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +description: ?string,
              +name: string,
              +slug: ?string,
              +category: ?{|
                +id: string,
                +name: ?string,
              |},
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
          |}>,
        |},
        +association_id: ?string,
        +selected_version: ?string,
      |},
    |}>,
    +total: ?number,
  |},
  +$fragmentRefs: signUpCta_viewer$ref,
  +$refType: collection_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "collection_viewer",
    "type": "Viewer",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["trackSearch"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    }, {
      "kind": "RootArgument",
      "name": "filters",
      "type": "TrackSearchFilters"
    }, {
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }],
    "selections": [{
      "kind": "FragmentSpread",
      "name": "signUpCta_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": "trackSearch",
      "name": "__collection_trackSearch_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters",
        "type": "TrackSearchFilters"
      }, {
        "kind": "Variable",
        "name": "license_params",
        "variableName": "license_params",
        "type": "[LicenseUsageParamsInput]"
      }, {
        "kind": "Literal",
        "name": "offset",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String"
      }],
      "concreteType": "TrackSearchResultConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResultEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "stems_available",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "base_price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "score",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "boosted_score",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "customizable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "matched_exclusions",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tempos",
            "storageKey": null,
            "args": null,
            "concreteType": "Tempo",
            "plural": true,
            "selections": [v0, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            }]
          }, v4, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "itunes",
              "args": null,
              "storageKey": null
            }, v0, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bio",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bandcamp",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "facebook",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "instagram",
              "args": null,
              "storageKey": null
            }, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "soundcloud",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "spotify",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "twitter",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "wiki",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "youtube",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "homebase",
              "args": null,
              "storageKey": null
            }, v4]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": "terms(first:100)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 100,
              "type": "Int"
            }],
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v0, v2, v3]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "collections",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionTrackEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Collection",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, v3, v1, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "category",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionCategory",
                  "plural": false,
                  "selections": [v0, v3]
                }, v4]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "association_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_version",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = '0fef4d0fc71fef37de4b93a9abf5c3fe';
module.exports = node;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type collectionList_viewer$ref: FragmentReference;
export type collectionList_viewer = {|
  +id: string,
  +collections: ?{|
    +total: ?number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +name: string,
        +slug: ?string,
        +category: ?{|
          +id: string,
          +name: ?string,
        |},
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +tracks: ?$ReadOnlyArray<?{|
          +id: string,
        |}>,
      |},
    |}>,
  |},
  +collection_categories: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +$refType: collectionList_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "collectionList_viewer",
    "type": "Viewer",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["collections"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["collection_categories"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "collections",
      "name": "__list_collections_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionConnection",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CollectionEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Collection",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionCategory",
            "plural": false,
            "selections": [v0, v1]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "assets",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "version",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "file_format",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "metadata",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tracks",
            "storageKey": null,
            "args": null,
            "concreteType": "Track",
            "plural": true,
            "selections": [v0]
          }, v2]
        }, v3]
      }, v4]
    }, {
      "kind": "LinkedField",
      "alias": "collection_categories",
      "name": "__list_collection_categories_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionCategoryConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CollectionCategoryEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionCategory",
          "plural": false,
          "selections": [v0, v1, v2]
        }, v3]
      }, v4]
    }]
  };
}();
node /*: any*/.hash = '2fcc550fc42ee3e2cec2bc95589f8d07';
module.exports = node;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1517);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.page--collection{background-color:#fff;margin-top:-64px;height:100%}.page--collection .page__main{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.page--collection .track-list .card{height:144px;padding:0}.page--collection .track-list .card__background{display:none}.page--collection .track-list .card__content{border-bottom:1px solid #e4e8ed}.page--collection .track-list .sign-up-card+li .card__content,.page--collection .track-list__item:first-child .card__content{border-top:1px solid #e4e8ed}.page--collection:not(.with-track-details) .collection__track-details-wrapper{pointer-events:none}.collection{height:100%}.collection__content-wrapper{height:100%;background-color:#fff;-webkit-box-flex:2;-ms-flex:2;flex:2}.collection__content{padding:112px 56px 0}.collection__license-bar{position:absolute;top:32px;right:0;left:0}.collection__illustration-wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1;pointer-events:none}.collection__illustration{position:fixed;top:0;right:0;bottom:0;width:45.4545454545%;overflow:hidden}.collection__illustration picture{height:100%;top:0;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}.collection__description{margin-top:32px}.collection__track-listing{margin-top:0}.collection__track-details-wrapper{position:fixed;top:16px;right:16px;bottom:72px;width:320px;z-index:1}.collection__track-details-wrapper .track-details{height:100%;width:100%}.collection__discover{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;margin:64px auto;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.collection__download{margin-top:64px;margin-bottom:4px;text-align:right}@media screen and (min-width:1024px){.collection__content-wrapper{-webkit-box-flex:6;-ms-flex:6;flex:6}.collection__illustration-wrapper{-webkit-box-flex:5;-ms-flex:5;flex:5}.collection__content{padding:136px 7.77778vw 0}.collection__description{margin-top:48px}.collection__download{margin-top:80px}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Collection/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,kBCuBpE,sBCqCF,iBACA,WAAY,CAHd,8BAMI,oBAAA,oBAAA,aAAa,wBACb,qBAAA,sBAAuB,CAP3B,oCAYM,aACA,SAAU,CAbhB,gDAgBM,YAAa,CAhBnB,6CAoBM,+BDrHqB,CCiG3B,6HAwBQ,4BDzHmB,CCiG3B,8EA8BI,mBAAoB,CACrB,YAID,WAAY,CAGZ,6BACE,YAAY,sBAEZ,mBAAA,WAAA,MAAO,CACR,qBC/CC,oBA5DiB,CD+GlB,yBEhHD,kBFmH4B,SG1HmB,QH0HJ,MAAO,CACjD,kCAGC,mBAAA,WAAA,OAAO,mBACa,CACrB,0BEzHD,eF4HyB,MAAG,QAAE,SAAE,qBAtBE,eAwBhB,CAHjB,kCAOG,YADa,MAEP,SACG,mCACT,+BAAA,0BAA2B,CAC5B,yBAID,eGjJ6C,CHkJ9C,2BAGC,YAAa,CACd,mCE/ID,eFkJyB,SGzJsB,WAAA,YH0J7C,YACA,SAAU,CAHX,kDIhJC,YJsJoB,UAAA,CACnB,sBAID,mEACA,iBAAwB,0BACxB,uBAAA,iBAAkB,CACnB,sBAGC,gBACA,kBACA,gBAAiB,CAClB,qCAGC,6BAAoB,mBAAA,WAAA,MAAQ,CAAE,kCACL,mBAAA,WAAA,MAAQ,CAAE,qBC5GnC,yBA5DiB,CD2KhB,yBAEC,eGrL2C,CHsL5C,sBAEC,eGxL2C,CHyL5C,CAAA","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Collection Page Component\n */\n\n.page--collection{\n  @include bgcolor(white);\n  margin-top: -$app-header-height;\n  height: 100%;\n\n  .page__main{\n    display: flex;\n    align-items: flex-start;\n  }\n\n  .track-list{\n    .card{\n      height: baseline(18);\n      padding: 0;\n    }\n    .card__background{\n      display: none;\n    }\n\n    .card__content{\n      border-bottom: 1px solid uicolor(border);\n    }\n    &__item:first-child, .sign-up-card + li {\n      .card__content{\n        border-top: 1px solid uicolor(border);\n      }\n    }\n  }\n\n  &:not(.with-track-details) .collection__track-details-wrapper{\n    pointer-events: none;\n  }\n}\n\n.collection{\n  height: 100%;\n  $illustration-width: 5 / 11 * 100%;\n\n  &__content-wrapper{\n    height: 100%;\n    @include bgcolor(white);\n    flex: 2;\n  }\n\n  &__content{\n    @include padding(baseline(14) baseline(7) baseline(0));\n  }\n\n  &__license-bar{\n    @include position(absolute, baseline(4) 0 null 0);\n  }\n\n  &__illustration-wrapper{\n    flex: 1;\n    pointer-events: none;\n  }\n\n  &__illustration{\n    @include position(fixed, 0 0 0 null);\n    width: $illustration-width;\n    overflow: hidden;\n\n    picture{\n      $height: 100%;\n      height: $height;\n      top: 0;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &__description{\n    margin-top: baseline(4);\n  }\n\n  &__track-listing{\n    margin-top: 0;\n  }\n\n  &__track-details-wrapper{\n    @include position(fixed, baseline(2) baseline(2) baseline(9) null);\n    width: baseline(40);\n    z-index: 1;\n\n    .track-details{\n      @include size(100%);\n    }\n  }\n\n  &__discover {\n    font-family: $font--articulat;\n    margin: baseline(8) auto;\n    width: fit-content;\n  }\n\n  &__download {\n    margin-top: baseline(8);\n    margin-bottom: baseline(0.5);\n    text-align: right;\n  }\n\n  @include media(breakpoint(desktop)) {\n    &__content-wrapper{ flex: 6 }\n    &__illustration-wrapper{ flex: 5 }\n    &__content{\n      @include padding(baseline(17) 7.77778vw baseline(0));\n    }\n    &__description{\n      margin-top: baseline(6);\n    }\n    &__download{\n      margin-top: baseline(10);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1519);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".nprogress-wrapper{position:absolute;right:0;left:0;height:2px;overflow:hidden;z-index:1}.nprogress-wrapper #nprogress .bar,.nprogress-wrapper #nprogress .spinner{position:absolute}#nprogress{height:100%;width:100%;pointer-events:none}#nprogress .bar{background-color:#4487ff;width:100%;height:2px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;-webkit-box-shadow:0 0 10px #4487ff,0 0 5px #4487ff;box-shadow:0 0 10px #4487ff,0 0 5px #4487ff;opacity:1;-webkit-transform:rotate(3deg) translateY(-4px);-ms-transform:rotate(3deg) translateY(-4px);transform:rotate(3deg) translateY(-4px)}#nprogress .spinner{display:block;position:fixed;z-index:1031;top:15px;right:15px}#nprogress .spinner-icon{width:18px;height:18px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:nprogress-spinner .4s linear infinite;animation:nprogress-spinner .4s linear infinite}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/feedback/NProgress/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GC,mBClEC,kBDmE0B,QAAQ,OAAO,WAC9B,gBACK,SACN,CAJX,0EASK,iBAAkB,CACnB,WE3ED,YFgFgB,WAAA,mBACE,CAFtB,gBGjDI,yBH6DA,WAAW,UACA,CAbf,gBAkBI,cAAc,kBACI,QACR,YACE,YACA,oDACZ,4CACA,UAAU,gDAEV,4CAAA,uCAA4C,CA1BhD,oBA+BI,cAAc,eACC,aACF,SACJ,UACE,CAnCf,yBAuCI,WAAW,YACC,8BACZ,sBAAsB,6BAEO,sBACP,uBACC,kBACL,wDAElB,+CAAgD,CACjD,qCAID,GAAO,+BAAA,sBAAuB,CAAA,GACvB,gCAAA,uBAAyB,CAAA,CAFlC,6BACE,GAAO,+BAAA,sBAAuB,CAAA,GACvB,gCAAA,uBAAyB,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * NProgress Component\n */\n\n .nprogress-wrapper {\n  @include position(absolute, null 0 null 0);\n  height: 2px;\n  overflow: hidden;\n  z-index: 1;\n\n  #nprogress {\n    .spinner,\n    .bar {\n      position: absolute;\n    }\n  }\n}\n\n#nprogress {\n  @include size(100%);\n  pointer-events: none;\n\n  .bar {\n    @include bgcolor(accent);\n\n    // position: fixed;\n    // z-index: 1031;\n    // top: 0;\n    // left: 0;\n\n    width: 100%;\n    height: 2px;\n  }\n\n  /* Fancy blur effect */\n  .peg {\n    display: block;\n    position: absolute;\n    right: 0px;\n    width: 100px;\n    height: 100%;\n    box-shadow: 0 0 10px color(accent), 0 0 5px color(accent);\n    opacity: 1;\n\n    transform: rotate(3deg) translate(0px, -4px);\n  }\n\n  /* Remove these to get rid of the spinner */\n  .spinner {\n    display: block;\n    position: fixed;\n    z-index: 1031;\n    top: 15px;\n    right: 15px;\n  }\n\n  .spinner-icon {\n    width: 18px;\n    height: 18px;\n    box-sizing: border-box;\n\n    border: solid 2px transparent;\n    border-top-color: #29d;\n    border-left-color: #29d;\n    border-radius: 50%;\n\n    animation: nprogress-spinner .4s linear infinite;\n  }\n}\n\n@keyframes nprogress-spinner {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1520 */,
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1522);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-bar{height:100%;border-radius:8px;background:rgba(16,16,21,.8);-webkit-backdrop-filter:blur(40px);backdrop-filter:blur(40px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:8px;padding-right:8px}.license-bar:after,.license-bar:before{content:\"\";position:absolute;top:0;bottom:0;width:12px;pointer-events:none;z-index:1;-webkit-transition:-webkit-transform .1s;transition:-webkit-transform .1s;-o-transition:transform .1s;transition:transform .1s;transition:transform .1s,-webkit-transform .1s}.license-bar:before{right:0;background-image:-webkit-gradient(linear,right top,left top,from(rgba(16,16,21,.1)),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,rgba(16,16,21,.1),rgba(16,16,21,0));background-image:-o-linear-gradient(right,rgba(16,16,21,.1) 0,rgba(16,16,21,0) 100%);background-image:linear-gradient(270deg,rgba(16,16,21,.1) 0,rgba(16,16,21,0));-webkit-transform:scaleX(0);-ms-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;-ms-transform-origin:right;transform-origin:right}.license-bar:after{left:0;background-image:-webkit-gradient(linear,left top,right top,from(rgba(16,16,21,.1)),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(left,rgba(16,16,21,.1),rgba(16,16,21,0));background-image:-o-linear-gradient(left,rgba(16,16,21,.1) 0,rgba(16,16,21,0) 100%);background-image:linear-gradient(90deg,rgba(16,16,21,.1) 0,rgba(16,16,21,0));-webkit-transform:scaleX(0);-ms-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}.license-bar__fixed-guard{height:65px}.license-bar__wrapper{position:fixed;top:64px;right:0;left:0;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px}.app-wrapper[data-header-type=extended] .license-bar__wrapper{position:absolute;top:0;right:0;left:0}.license-bar__wrapper.has-scroll .license-bar:before,.license-bar__wrapper.is-scrolled .license-bar:after{-webkit-transform:scaleX(1);-ms-transform:scaleX(1);transform:scaleX(1)}.license-bar__wrapper.is-scrolled-max .license-bar:before{-webkit-transform:scaleX(0);-ms-transform:scaleX(0);transform:scaleX(0)}.license-bar__wrapper--with-terms .license-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.license-bar__wrapper--full-width .license-bar{width:100%}.license-bar__scroll-wrapper{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-flex:1;-ms-flex:1;flex:1;padding-top:8px}.license-bar__scroll-wrapper>*{padding:0}.license-bar__scroller{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap}.license-bar__scroller--no-terms.no-filters{width:100%}.license-bar__scroller--no-terms>*{margin-bottom:8px}.license-bar__usages{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.license-bar__usages button{border:0}.license-bar__usages>*{margin-bottom:8px}.license-bar .description{font-size:.8125em;line-height:1;font-weight:700}.license-bar__usage-button{margin-right:2px}.license-bar__usage-button:first-child{border-top-left-radius:16px;border-bottom-left-radius:16px;border-top-right-radius:2px;border-bottom-right-radius:2px}.license-bar__usage-button:first-child .button__wrapper{padding-left:16px;padding-right:12px}.license-bar__usage-button:not(:first-child){border-radius:2px}.license-bar__usage-button:not(:first-child) .button__wrapper{padding-left:12px;padding-right:12px}.license-bar__currency-select{margin-left:0;width:68px;font-weight:700!important}.license-bar__currency-select .Select-menu-outer{-webkit-box-shadow:0 10px 27px -15px rgba(0,0,0,.67)!important;box-shadow:0 10px 27px -15px rgba(0,0,0,.67)!important;border:none!important}.license-bar__currency-select .Select-control{background-color:#fff!important;border:none!important;border-top-left-radius:2px!important;border-bottom-left-radius:2px!important;border-top-right-radius:16px!important;border-bottom-right-radius:16px!important}.license-bar__currency-select .is-open>.Select-control{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.license-bar__currency-select .Select-menu-outer,.license-bar__currency-select .Select-option:last-child{border-bottom-right-radius:16px!important;border-bottom-left-radius:16px!important}.license-bar__currency-select .Select-menu-outer{z-index:-1!important}.license-bar__currency-select .Select-value{padding-left:12px!important;line-height:32px!important}.license-bar__currency-select .Select-option{padding-left:15px!important}.license-bar__sort-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:flex-end;padding-left:8px}.license-bar__sort-label{margin-left:4px;margin-right:8px;color:#b1b8c4;font-weight:700}.license-bar__button-clear{margin-right:8px}.license-bar__filter-bar .tag{font-weight:700;margin-bottom:0;margin:0 6px 8px 0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/blocks/LicenseBar/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA8GA,aACE,YAAY,kBAEZ,6BAAiC,mCACjC,2BAA2B,oBAC3B,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,iBAEnB,iBCnF+C,CD2EjD,uCAYI,WAAW,kBACe,MAAG,SAAO,WAEpC,oBAAoB,UACV,yCACV,iCAAA,4BAAA,yBAAA,8CAA0B,CAjB9B,oBAqBI,QAAQ,0GACR,mFAAA,qFAAA,8EAIC,4BACD,wBAAA,oBAAoB,+BACpB,2BAAA,sBAAuB,CA5B3B,mBAgCI,OAAO,0GACP,kFAAA,oFAAA,6EAIC,4BACD,wBAAA,oBAAoB,8BACpB,0BAAA,qBAAsB,CACvB,0BAGC,WApGkC,CAqGnC,sBEhHD,eFmHyB,SC1HsB,QD0HG,OAAO,UAC7C,oBAEV,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,WC9H0B,CDgI9C,8DEzHD,kBF4H4B,MAAG,QAAE,MAAO,CACvC,0GAOC,4BAAA,wBAAA,mBAAoB,CACrB,0DAGC,4BAAA,wBAAA,mBAAoB,CACrB,+CAGC,oBAAA,oBAAA,aAAa,qBACb,kBAAA,yBAAyB,yBACzB,sBAAA,kBAAmB,CACpB,+CAGC,UAAW,CACZ,6BAGC,WAAW,oBACX,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,mBACnB,eAAe,mBACf,WAAA,OAAO,eCjKsC,CD2J9C,+BGvFC,SA9DiB,CHgKhB,uBAID,YAAY,oBAEZ,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kBACA,CAElB,4CAEG,UAAW,CAFd,mCAKG,iBCrLyC,CDsL1C,qBAKH,oBAAA,oBAAA,aAAa,mBAIb,cAAe,CALhB,4BAGG,QAAS,CAHZ,uBAOG,iBCjM2C,CD2EjD,0BA2HI,kBAAmB,cACL,eACG,CAClB,2BAcC,gBCvN6C,CD2M9C,uCAEG,4BAA4B,+BACG,4BACH,8BACG,CALlC,wDAOK,kBACA,kBCnNyC,CD2M9C,6CAeG,iBAAkB,CAfrB,8DAiBK,kBACA,kBC7NyC,CD8N1C,8BAKH,cAAc,WAEd,yBAA4B,CAH7B,iDAMG,+DAAA,uDAA2D,qBACpC,CAP1B,8CAWG,gCAAiC,sBACV,qCACe,wCACG,uCACD,yCACG,CAhB9C,uDAoBG,sCAAuC,sCACC,CArB3C,yGAyBG,0CAA2C,wCACD,CA1B7C,iDA8BG,oBAAsB,CA9BzB,4CAkCG,4BAA6B,0BACD,CAnC/B,6CAuCG,2BAA6B,CAC9B,2BAID,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,uBACI,gBChRsB,CDkR9C,yBAGC,gBACA,iBACA,cAAc,eACG,CAClB,2BAGC,gBC5R6C,CD6R9C,8BAMG,gBAAiB,gBAED,kBACF,CAGf","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * LicenseBar Component\n */\n\n $license-bar-padding: baseline(1);\n\n.license-bar {\n  height: 100%;\n  border-radius: baseline(1);\n  background: rgba(16, 16, 21, 0.8);\n  backdrop-filter: blur(40px);\n  display: flex;\n  align-items: center;\n  padding-left: $license-bar-padding;\n  padding-right: $license-bar-padding;\n\n  &::before,\n  &::after {\n    content: \"\";\n    @include position(absolute, 0 null 0 null);\n    width: baseline(1.5);\n    pointer-events: none;\n    z-index: 1;\n    transition: transform 0.1s;\n  }\n\n  &::before {\n    right: 0;\n    background-image: linear-gradient(\n      to left,\n      transparentize(color(black), 0.9) 0%,\n      transparentize(color(black), 1) 100%\n    );\n    transform: scaleX(0);\n    transform-origin: right;\n  }\n\n  &::after {\n    left: 0;\n    background-image: linear-gradient(\n      to right,\n      transparentize(color(black), 0.9) 0%,\n      transparentize(color(black), 1) 100%\n    );\n    transform: scaleX(0);\n    transform-origin: left;\n  }\n\n  &__fixed-guard{\n    height: $license-bar-height;\n  }\n\n  &__wrapper {\n    @include position(fixed, $app-nav-height-fixed 0 null 0);\n    z-index: 1;\n    // height: $license-bar-height;\n    display: flex;\n    align-items: center;\n    padding: $license-bar-padding;\n  }\n\n  .app-wrapper[data-header-type=\"extended\"] &__wrapper {\n    @include position(absolute, 0 0 null 0);\n  }\n\n  &__wrapper.has-scroll &::before {\n    transform: scaleX(1);\n  }\n\n  &__wrapper.is-scrolled &::after {\n    transform: scaleX(1);\n  }\n\n  &__wrapper.is-scrolled-max &::before {\n    transform: scaleX(0);\n  }\n\n  &__wrapper--with-terms & {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  &__wrapper--full-width & {\n    width: 100%;\n  }\n  &__scroll-wrapper{\n    // @include scroll(x);\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    flex: 1;\n    padding-top: baseline(1);\n\n    & > * {\n      @include padding(0);\n    }\n  }\n\n  &__scroller {\n    height: 100%;\n\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n\n    &--no-terms {\n      &.no-filters {\n        width: 100%;\n      }\n      & > * {\n        margin-bottom: baseline(1);\n      }\n    }\n  }\n\n  &__usages {\n    display: flex;\n    button {\n      border: 0;\n    }\n    flex-wrap: wrap;\n    & > * {\n      margin-bottom: baseline(1);\n    }\n  }\n\n  .description {\n    font-size: 0.8125em;\n    line-height: 1;\n    font-weight: bold;\n  }\n\n  &__usage-button {\n    &:first-child {\n      border-top-left-radius: 16px;\n      border-bottom-left-radius: 16px;\n      border-top-right-radius: 2px;\n      border-bottom-right-radius: 2px;\n      .button__wrapper {\n        padding-left: baseline(2);\n        padding-right: baseline(1.5);\n      }\n    }\n\n    margin-right: baseline(0.25);\n\n    &:not(:first-child) {\n      border-radius: 2px;\n      .button__wrapper {\n        padding-left: baseline(1.5);\n        padding-right: baseline(1.5);\n      }\n    }\n  }\n\n  &__currency-select {\n    margin-left: 0;\n    width: baseline(8.5);\n    font-weight: bold !important;\n\n    .Select-menu-outer {\n      box-shadow: 0px 10px 27px -15px rgba(0,0,0,0.67) !important;\n      border: none !important;\n    }\n\n    .Select-control {\n      background-color: #fff !important;\n      border: none !important;\n      border-top-left-radius: 2px !important;\n      border-bottom-left-radius: 2px !important;\n      border-top-right-radius: 16px !important;\n      border-bottom-right-radius: 16px !important;\n    }\n\n    .is-open > .Select-control {\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n\n    .Select-menu-outer, .Select-option:last-child {\n      border-bottom-right-radius: 16px !important;\n      border-bottom-left-radius: 16px !important;\n    }\n\n    .Select-menu-outer {\n      z-index: -1 !important;\n    }\n\n    .Select-value {\n      padding-left: 12px !important;\n      line-height: 32px !important;\n    }\n\n    .Select-option {\n      padding-left: 15px !important;\n    }\n  }\n\n  &__sort-wrapper {\n    display: flex;\n    align-items: center;\n    justify-items: flex-end;\n    padding-left: baseline(1);\n  }\n\n  &__sort-label{\n    margin-left: baseline(0.5);\n    margin-right: baseline(1);\n    color: #B1B8C4;\n    font-weight: bold;\n  }\n\n  &__button-clear {\n    margin-right: baseline(1);\n  }\n\n  &__filter-bar {\n    // flex: 2;\n\n    .tag {\n      font-weight: bold;\n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: 0;\n      margin-right: baseline(0.75);\n      margin-bottom: baseline(1);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SearchSortOrderSelect Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var queryString_1 = __webpack_require__(30);
var sortOrder_1 = __webpack_require__(394);
var _1 = __webpack_require__(200);
__webpack_require__(1524);
var classes = new BEM('sort-order-select');
var form = 'sort-order-select';
var sortingOptions = [{
    label: 'Featured',
    value: sortOrder_1.SortOrderSerializer.serialize({
        field: "Featured" /* Featured */
        , order: "Desc" /* Desc */
    })
}, {
    label: 'Rating',
    value: sortOrder_1.SortOrderSerializer.serialize({
        field: "Score" /* Score */
        , order: "Desc" /* Desc */
    })
}, {
    label: 'Newest',
    value: sortOrder_1.SortOrderSerializer.serialize({
        field: "Date" /* Date */
        , order: "Desc" /* Desc */
    })
}, {
    label: 'Price - High to Low',
    value: sortOrder_1.SortOrderSerializer.serialize({
        field: "Price" /* Price */
        , order: "Desc" /* Desc */
    })
}, {
    label: 'Price - Low to High',
    value: sortOrder_1.SortOrderSerializer.serialize({
        field: "Price" /* Price */
        , order: "Asc" /* Asc */
    })
}];

var SearchSortOrderSelect = function (_React$Component) {
    _inherits(SearchSortOrderSelect, _React$Component);

    function SearchSortOrderSelect() {
        _classCallCheck(this, SearchSortOrderSelect);

        var _this = _possibleConstructorReturn(this, (SearchSortOrderSelect.__proto__ || Object.getPrototypeOf(SearchSortOrderSelect)).apply(this, arguments));

        _this.onSetSortOrder = function (_ref) {
            var value = _ref.value;

            _this.props.setSearchSortOrder(sortOrder_1.SortOrderSerializer.unserializeStr(value));
        };
        return _this;
    }

    _createClass(SearchSortOrderSelect, [{
        key: "render",
        value: function render() {
            var sort = this.props.sort;

            var selectWidthClass = sort && sort.field === "Price" /* Price */ ? 'md' : 'sm';
            return React.createElement("form", Object.assign({}, classes('', selectWidthClass)), React.createElement(_1.default, Object.assign({ form: form, name: "sortSelect", onUpdate: this.onSetSortOrder, options: this.props.sortingOptions, updateOnMount: false, selectName: "sort-order-select", selectProps: {
                    clearable: false,
                    searchable: false,
                    autosize: true
                }, size: "small" }, this.props.selectProps)));
        }
    }]);

    return SearchSortOrderSelect;
}(React.Component);

var SearchSortOrderSelectForm = redux_form_1.reduxForm({
    form: form
})(SearchSortOrderSelect);
var ConnectedSearchSortOrderSelect = react_redux_1.connect(function (state, ownProps) {
    return {
        initialValues: {
            sortSelect: ownProps.sort ? sortOrder_1.SortOrderSerializer.serialize(ownProps.sort) : sortingOptions[0].value
        },
        sort: ownProps.sort,
        sortingOptions: sortingOptions
    };
})(SearchSortOrderSelectForm);
exports.SearchSortOrderSelectWithContext = function (props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedSearchSortOrderSelect, Object.assign({}, ctx, props));
    });
};

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1525);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./sort-order-select.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./sort-order-select.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".sort-order-select{font-weight:700!important}.sort-order-select--sm{width:172px}.sort-order-select--md{width:188px}.sort-order-select .Select-menu-outer{-webkit-box-shadow:0 10px 27px -15px rgba(0,0,0,.67)!important;box-shadow:0 10px 27px -15px rgba(0,0,0,.67)!important;border:none!important}.sort-order-select .Select-control{background-color:#fff!important;border:none!important;border-radius:16px!important}.sort-order-select .is-open>.Select-control{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.sort-order-select .Select-menu-outer,.sort-order-select .Select-option:last-child{border-bottom-right-radius:16px!important;border-bottom-left-radius:16px!important}.sort-order-select .Select-menu-outer{z-index:-1!important}.sort-order-select .Select-value{line-height:32px!important;padding-left:15px!important}.sort-order-select .Select-option{padding-left:15px!important}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/Select/sort-order-select.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AAwGA,mBASE,yBAA4B,CAR5B,uBACE,WCvE6C,CDwE9C,uBAGC,WC3E6C,CDqEjD,sCAYI,+DAAA,uDAA2D,qBACpC,CAb3B,mCAiBI,gCAAiC,sBACV,4BACO,CAnBlC,4CAuBI,sCAAuC,sCACC,CAxB5C,mFA4BI,0CAA2C,wCACD,CA7B9C,sCAiCI,oBAAsB,CAjC1B,iCAqCI,2BAA4B,2BACC,CAtCjC,kCA0CI,2BAA6B,CAC9B","file":"sort-order-select.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n.sort-order-select {\n  &--sm {\n    width: baseline(21.5);\n  }\n\n  &--md {\n    width: baseline(23.5);\n  }\n\n  font-weight: bold !important;\n\n  .Select-menu-outer {\n    box-shadow: 0px 10px 27px -15px rgba(0,0,0,0.67) !important;\n    border: none !important;\n  }\n\n  .Select-control {\n    background-color: #fff !important;\n    border: none !important;\n    border-radius: 16px !important;\n  }\n\n  .is-open > .Select-control {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n\n  .Select-menu-outer, .Select-option:last-child {\n    border-bottom-right-radius: 16px !important;\n    border-bottom-left-radius: 16px !important;\n  }\n\n  .Select-menu-outer {\n    z-index: -1 !important;\n  }\n\n  .Select-value {\n    line-height: 32px !important;\n    padding-left: 15px !important;\n  }\n\n  .Select-option {\n    padding-left: 15px !important;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FiltersBar Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1527);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var FilterList_1 = __webpack_require__(1529);
var classes = new BEM('filter-bar');

var FilterBar = function (_React$Component) {
    _inherits(FilterBar, _React$Component);

    function FilterBar(props) {
        _classCallCheck(this, FilterBar);

        var _this = _possibleConstructorReturn(this, (FilterBar.__proto__ || Object.getPrototypeOf(FilterBar)).call(this, props));

        _this.state = {
            searchInput: ''
        };
        return _this;
    }

    _createClass(FilterBar, [{
        key: "render",
        value: function render() {
            var classModifiers = {
                normal: true
            };
            return React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ enter: { animation: 'transition.fadeIn', display: 'flex', delay: 500 }, leave: { animation: 'transition.fadeOut' } }, classes('', classModifiers, this.props.className)), React.createElement(FilterList_1.default, null));
        }
    }]);

    return FilterBar;
}(React.Component);

exports.default = FilterBar;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1528);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".filter-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.filter-bar--normal{margin-top:0}.filter-bar--large{height:88px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/FilterBar/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA8GA,YACE,oBAAA,oBAAA,aAAa,yBAWb,sBAAA,kBAAmB,CARnB,oBACE,YAAa,CACd,mBAGC,WCpF6C,CDqF9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FilterBar Component\n */\n\n@import '../../../atoms/text/Heading/mixins';\n\n.filter-bar {\n  display: flex;\n  // transition: .15s ease-in-out;\n\n  &--normal {\n    margin-top: 0;\n  }\n\n  &--large {\n    height: baseline(11);\n  }\n\n  align-items: center;\n\n  // @include media(breakpoint(desktop-s)) {\n  //   &__left{\n  //     flex-basis: 66.6667%;\n  //   }\n  // }\n\n  // @include media(breakpoint(desktop-xl)) {\n  //   &__left{\n  //     flex-basis: 77.5%;\n  //   }\n  // }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FilterList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var selectors_1 = __webpack_require__(65);
__webpack_require__(1530);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_helmet_1 = __webpack_require__(78);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
var currency_1 = __webpack_require__(115);
var queryString_1 = __webpack_require__(30);
var relay_1 = __webpack_require__(93);
var filterList_1 = __webpack_require__(1532);
var taxonomy_1 = __webpack_require__(106);
var Label_1 = __webpack_require__(8);
var Browse_1 = __webpack_require__(61);
var FilterTag_1 = __webpack_require__(1535);
var searchQueryTagID = 'search-query';
var taxonomyQueryTagID = 'taxonomy-query';
var budgetFilterTagID = 'budget';
var tempoFilterTagID = 'tempo';
var similarityFilterTagID = 'similarity';
var classes = new BEM('filter-list');

var FilterList = function (_React$Component) {
    _inherits(FilterList, _React$Component);

    function FilterList() {
        _classCallCheck(this, FilterList);

        var _this = _possibleConstructorReturn(this, (FilterList.__proto__ || Object.getPrototypeOf(FilterList)).apply(this, arguments));

        _this.onRemoveFilter = function (type) {
            return function (filter, exclude) {
                switch (type) {
                    case searchQueryTagID:
                        _this.props.clearSearchQuery();
                        break;
                    case similarityFilterTagID:
                        _this.props.removeSimilarityFilter();
                        break;
                    case budgetFilterTagID:
                        _this.props.removeBudgetFilter();
                        break;
                    case tempoFilterTagID:
                        _this.props.removeTempoFilter();
                        break;
                    case taxonomyQueryTagID:
                        _this.props.removeTaxonomyQuery(filter);
                        break;
                    default:
                        _this.props.removeSearchFilter(filter, exclude);
                        break;
                }
            };
        };
        return _this;
    }

    _createClass(FilterList, [{
        key: "renderBudgetFilter",
        value: function renderBudgetFilter(budgetFilter) {
            var _this2 = this;

            return React.createElement(currency_1.CurrencyContext.Consumer, null, function (_ref) {
                var currency = _ref.currency;
                return React.createElement(FilterTag_1.BudgetFilterTag, Object.assign({ budget: budgetFilter, currency: currency, onRemove: _this2.onRemoveFilter(budgetFilterTagID) }, classes('filter')));
            });
        }
    }, {
        key: "renderQueryFilter",
        value: function renderQueryFilter() {
            return React.createElement(FilterTag_1.QueryFilterTag, Object.assign({ query: this.props.searchQuery, onRemove: this.onRemoveFilter(searchQueryTagID) }, classes('filter')));
        }
    }, {
        key: "renderSimilarityFilter",
        value: function renderSimilarityFilter() {
            if (!this.props.similaritySeed) {
                return;
            }
            var track = this.props.similaritySeed;
            var trackTitle = track.title + " by " + track.artist.name;
            return React.createElement(FilterTag_1.SimilarityFilterTag, Object.assign({ trackTitle: trackTitle, onRemove: this.onRemoveFilter(similarityFilterTagID) }, classes('filter')));
        }
    }, {
        key: "renderTaxonomyQuery",
        value: function renderTaxonomyQuery() {
            var taxonomyQuery = this.props.taxonomyQuery;
            var filter = {
                name: taxonomyQuery.query,
                taxonomy: {
                    id: taxonomyQuery.taxonomy_id,
                    name: taxonomy_1.TaxonomyIdToTaxonomyType[taxonomyQuery.taxonomy_id]
                }
            };
            return React.createElement(FilterTag_1.TaxonomyQueryTag, Object.assign({ filter: filter, taxonomyQuery: this.props.taxonomyQuery, onRemove: this.onRemoveFilter(taxonomyQueryTagID) }, classes('filter')));
        }
    }, {
        key: "renderTempoFilter",
        value: function renderTempoFilter() {
            return React.createElement(FilterTag_1.TempoFilterTag, Object.assign({ tempo: this.props.tempoFilter, onRemove: this.onRemoveFilter(tempoFilterTagID) }, classes('filter')));
        }
    }, {
        key: "renderFilter",
        value: function renderFilter(filter, exclude) {
            return React.createElement(FilterTag_1.FilterTag, Object.assign({ key: filter.name, exclude: !!exclude, label: filter.name, filter: filter, onRemove: this.onRemoveFilter() }, classes('filter')));
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                budgetFilter = _props.budgetFilter,
                excludedSearchFilters = _props.excludedSearchFilters,
                searchFilters = _props.searchFilters,
                hasFilters = _props.hasFilters,
                searchQuery = _props.searchQuery,
                similarityFilter = _props.similarityFilter,
                taxonomyQuery = _props.taxonomyQuery,
                tempoFilter = _props.tempoFilter;

            return React.createElement("div", Object.assign({}, classes()), hasFilters && document.location.pathname === Browse_1.BrowsePagePath && React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, similarityFilter ? 'Similar Tracks' : "Results for " + lodash_1.trim([].concat(_toConsumableArray(searchFilters.map(function (f) {
                return f.name;
            })), [searchQuery]).join(', '), ', '))), React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: { animation: 'transition.slideRightIn', duration: 250, delay: 500 }, leave: { animation: 'transition.fadeOut', duration: 250 } }, classes('scroller')), searchFilters.map(function (filter) {
                return _this3.renderFilter(filter, false);
            }), searchQuery && this.renderQueryFilter(), similarityFilter && this.renderSimilarityFilter(), taxonomyQuery && this.renderTaxonomyQuery(), tempoFilter && this.renderTempoFilter(), budgetFilter && this.renderBudgetFilter(budgetFilter), excludedSearchFilters.map(function (filter) {
                return _this3.renderFilter(filter, true);
            }))));
        }
    }]);

    return FilterList;
}(React.Component);

var FilterListWithQueryStringContext = function FilterListWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        var similaritySeedId = ctx.filters && ctx.filters.similarity && ctx.filters.similarity.track_id;
        return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: filterList_1.filterListQuery, variables: {
                // Can't pass undefined/null value as the node.id parameter is non-nullable
                // and is statically validated
                similarity_seed_id: similaritySeedId || '',
                similarity_search: !!similaritySeedId
            }, render: function render(_ref2) {
                var error = _ref2.error,
                    propsFromQuery = _ref2.props;

                if (error) {
                    return React.createElement(Label_1.Span, { size: "small", textColor: "dangerous" }, error.message);
                }
                // tslint:disable-next-line:max-line-length
                var similaritySeed = propsFromQuery && propsFromQuery.viewer && propsFromQuery.viewer.node ? propsFromQuery.viewer.node : undefined;
                return React.createElement(FilterList, Object.assign({ budgetFilter: selectors_1.getBudgetFilter(ctx), tempoFilter: selectors_1.getTempoFilter(ctx), excludedSearchFilters: selectors_1.getExcludedSearchFilters(ctx), hasFilters: selectors_1.hasSearchFilters(ctx), searchQuery: selectors_1.getSearchQuery(ctx), searchFilters: selectors_1.getSearchFilters(ctx), similarityFilter: selectors_1.getSimilarityFilter(ctx), similaritySeed: similaritySeed, taxonomyQuery: selectors_1.getTaxonomyQuery(ctx), removeBudgetFilter: ctx.removeBudgetFilter, removeSearchFilter: ctx.removeSearchFilter, removeSimilarityFilter: ctx.removeSimilarityFilter, removeTempoFilter: ctx.removeTempoFilter, removeTaxonomyQuery: ctx.removeTaxonomyQuery, clearSearchQuery: ctx.clearSearchQuery }, props));
            } });
    });
};
exports.default = FilterListWithQueryStringContext;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1531);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".filter-list{-webkit-box-flex:1;-ms-flex:1 0 48px;flex:1 0 48px}.filter-list__wrapper{height:100%;width:100%}.filter-list__scroller{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-perspective:1200px;perspective:1200px;-ms-flex-wrap:wrap;flex-wrap:wrap}.filter-list .tag{-webkit-box-flex:0;-ms-flex:none;flex:none}.filter-list .tag .tag__label{color:#101015;font-weight:700}.filter-list .tag--exclude .tag__label{color:#fff}.filter-list:after{position:absolute;top:0;right:0;bottom:0;width:16px;background-image:-webkit-gradient(linear,right top,left top,from(rgba(16,16,21,.1)),to(rgba(16,16,21,0)));background-image:-webkit-linear-gradient(right,rgba(16,16,21,.1),rgba(16,16,21,0));background-image:-o-linear-gradient(right,rgba(16,16,21,.1),rgba(16,16,21,0));background-image:linear-gradient(270deg,rgba(16,16,21,.1),rgba(16,16,21,0))}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/FilterList/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AA4GA,aACE,mBAAA,kBAAA,aC1E+C,CD4E/C,sBACE,YAAY,UACD,CACZ,uBAKC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,2BACnB,mBAAmB,mBACnB,cAAe,CAdnB,kBAkBI,mBAAA,cAAA,SAAU,CAlBd,8BAoBM,cACA,eAAiB,CArBvB,uCA0BQ,UEpGM,CF0Ed,mBGlEE,kBHkG4B,MAAG,QAAE,SAAE,WAGjC,0GAAA,mFAAA,8EAAA,2EAA2G,CAC5G","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FilterList Component\n */\n\n.filter-list{\n  flex: 1 0 baseline(6);\n\n  &__wrapper{\n    height: 100%;\n    width: 100%;\n  }\n\n  &__scroller{\n    // @include position(absolute, 0);\n    // @include scroll(x);\n    display: flex;\n    align-items: center;\n    perspective: 1200px;\n    flex-wrap: wrap;\n  }\n\n  .tag{\n    flex: none;\n    .tag__label {\n      color: color(\"black\");\n      font-weight: bold;\n    }\n\n    &--exclude {\n      .tag__label {\n        color: color(white);\n      }\n    }\n  }\n\n  &::after{\n    @include position(absolute, 0 0 0 null);\n    // content: \"\";\n    width: baseline(2);\n    background-image: linear-gradient(to left, transparentize(color(dark), .9), transparentize(color(dark), 1));\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.filterListQuery = function () {
  return __webpack_require__(1533);
};
exports.similaritySeed = {
  viewer: function viewer() {
    return __webpack_require__(1534);
  }
};

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash c4ae2157ad3979482d0212229e49b6a3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type filterListQueryVariables = {|
  similarity_search: boolean,
  similarity_seed_id: string,
|};
export type filterListQueryResponse = {|
  +viewer: ?{|
    +node?: ?{|
      +title?: ?string,
      +artist?: ?{|
        +name: ?string,
      |},
    |},
  |},
|};
*/

/*
query filterListQuery(
  $similarity_search: Boolean!
  $similarity_seed_id: ID!
) {
  viewer {
    node(id: $similarity_seed_id) @include(if: $similarity_search) {
      __typename
      ... on TrackSearchResult {
        title
        artist {
          name
          id
        }
      }
      id
    }
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "similarity_search",
    "type": "Boolean!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "similarity_seed_id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "similarity_seed_id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "filterListQuery",
    "id": null,
    "text": "query filterListQuery(\n  $similarity_search: Boolean!\n  $similarity_seed_id: ID!\n) {\n  viewer {\n    node(id: $similarity_seed_id) @include(if: $similarity_search) {\n      __typename\n      ... on TrackSearchResult {\n        title\n        artist {\n          name\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "filterListQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "Condition",
          "passingValue": true,
          "condition": "similarity_search",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": v1,
            "concreteType": null,
            "plural": false,
            "selections": [{
              "kind": "InlineFragment",
              "type": "TrackSearchResult",
              "selections": [v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [v3]
              }]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "filterListQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [v4, {
          "kind": "Condition",
          "passingValue": true,
          "condition": "similarity_search",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": v1,
            "concreteType": null,
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "__typename",
              "args": null,
              "storageKey": null
            }, v4, {
              "kind": "InlineFragment",
              "type": "TrackSearchResult",
              "selections": [v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [v3, v4]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = 'd804b091397711a17589481ff54e1b7d';
module.exports = node;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type filterList_viewer$ref: FragmentReference;
export type filterList_viewer = {|
  +node?: ?{|
    +title?: ?string,
    +artist?: ?{|
      +name: ?string,
    |},
  |},
  +$refType: filterList_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "filterList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "similarity_seed_id",
    "type": "ID!"
  }, {
    "kind": "RootArgument",
    "name": "similarity_search",
    "type": "Boolean"
  }],
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "similarity_search",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "similarity_seed_id",
        "type": "ID!"
      }],
      "concreteType": null,
      "plural": false,
      "selections": [{
        "kind": "InlineFragment",
        "type": "TrackSearchResult",
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }]
  }]
};
node /*: any*/.hash = '224dd5a717819fc791ae0de3e3d34167';
module.exports = node;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Filter Tag Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _this2 = this;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var money_1 = __webpack_require__(285);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var budgetFilter_1 = __webpack_require__(211);
var taxonomy_1 = __webpack_require__(106);
var Tag_1 = __webpack_require__(127);

var FilterTag = function (_React$PureComponent) {
    _inherits(FilterTag, _React$PureComponent);

    function FilterTag() {
        _classCallCheck(this, FilterTag);

        var _this = _possibleConstructorReturn(this, (FilterTag.__proto__ || Object.getPrototypeOf(FilterTag)).apply(this, arguments));

        _this.onRemove = function () {
            _this.props.onRemove(_this.props.filter, !!_this.props.exclude);
        };
        return _this;
    }

    _createClass(FilterTag, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                exclude = _props.exclude,
                label = _props.label,
                prefix = _props.prefix;

            return React.createElement(Tag_1.default, { colorScheme: exclude ? 'dark' : 'light', exclude: exclude, id: label, label: label, size: "small", variant: "filter", prefix: prefix, onRemove: this.onRemove, className: className });
        }
    }]);

    return FilterTag;
}(React.PureComponent);

exports.FilterTag = FilterTag;
exports.QueryFilterTag = function (_a) {
    var query = _a.query,
        tagProps = __rest(_a, ["query"]);
    return React.createElement(FilterTag, Object.assign({ label: query, prefix: "Keywords" }, tagProps));
};
exports.SimilarityFilterTag = function (_a) {
    var trackTitle = _a.trackTitle,
        tagProps = __rest(_a, ["trackTitle"]);
    return React.createElement(FilterTag, Object.assign({ label: trackTitle, prefix: "Similar to" }, tagProps));
};
exports.TaxonomyQueryTag = function (_a) {
    var taxonomyQuery = _a.taxonomyQuery,
        tagProps = __rest(_a, ["taxonomyQuery"]);
    return React.createElement(FilterTag, Object.assign({ label: taxonomyQuery.query, prefix: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyIdToTaxonomyType[taxonomyQuery.taxonomy_id]), onRemove: _this2.onRemove }, tagProps));
};
exports.BudgetFilterTag = function (_a) {
    var budget = _a.budget,
        currency = _a.currency,
        tagProps = __rest(_a, ["budget", "currency"]);

    var budgetMinimum = money_1.getFormattedMoney(budget.minimum || 0, currency);
    var budgetMaximum = money_1.getFormattedMoney(budget.maximum || 0, currency);
    var label = budgetMinimum + "-" + budgetMaximum;
    if (budget.minimum === 0) {
        label = "Up to " + budgetMaximum;
    } else if (budget.maximum === budgetFilter_1.budgetFilterMaximum) {
        label = "Starts at " + budgetMinimum;
    }
    return React.createElement(FilterTag, Object.assign({ label: label, prefix: "Budget" }, tagProps));
};
exports.TempoFilterTag = react_redux_1.connect(function (state) {
    return { tempos: state.staticData.tempos };
})(function (_a) {
    var tempo = _a.tempo,
        tempos = _a.tempos,
        tagProps = __rest(_a, ["tempo", "tempos"]);

    var tempoMinimum = tempos.find(function (_ref) {
        var value = _ref.value;
        return value === tempo.minimum;
    });
    var tempoMaximum = tempos.find(function (_ref2) {
        var value = _ref2.value;
        return value === tempo.maximum;
    });
    var label = '';
    if (tempoMinimum) {
        label += tempoMinimum.name;
        if (tempoMaximum && tempoMaximum.value !== tempoMinimum.value) {
            label += "\u2014" + tempoMaximum.name;
        }
    } else if (tempoMaximum) {
        label += tempoMaximum.name;
    }
    return React.createElement(FilterTag, Object.assign({ label: label, prefix: "Tempo" }, tagProps));
});

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash eca69a8958e797ee6b0da44e24add347
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type trackSearch_viewer$ref = any;
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type SearchSortField = ('Date' | 'Featured' | 'Price' | 'Score' | '%future added value');
export type SearchSortOrderDirection = ('Asc' | 'Desc' | '%future added value');
export type TrackSimilarityFeature = ('Default' | '%future added value');
export type trackSearchQueryVariables = {|
  offset?: ?number,
  count?: ?number,
  query?: ?string,
  filters?: ?{
    term_filters?: ?$ReadOnlyArray<?string>,
    not_term_filters?: ?$ReadOnlyArray<?string>,
    collection_slug?: ?string,
    artist_slug?: ?string,
    budget?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    duration?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    tempo?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    similarity?: ?{
      track_id: string,
      feature: TrackSimilarityFeature,
    },
  },
  taxonomy_query?: ?{
    query: string,
    taxonomy_id: number,
  },
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
  sort?: ?{
    field: SearchSortField,
    order: SearchSortOrderDirection,
  },
  currency?: ?Currency,
|};
export type trackSearchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: trackSearch_viewer$ref,
  |},
|};
*/

/*
query trackSearchQuery(
  $offset: Int
  $count: Int
  $query: String
  $filters: TrackSearchFilters
  $taxonomy_query: TaxonomyQuery
  $license_params: [LicenseUsageParamsInput]
  $sort: SearchSortOrder
  $currency: Currency
) {
  viewer {
    ...trackSearch_viewer
    id
  }
}

fragment trackSearch_viewer on Viewer {
  ...signUpCta_viewer
  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {
    edges {
      node {
        id
        internal_id
        price
        base_price
        title
        added_to_cart
        slug
        duration
        score
        boosted_score
        stems_available
        customizable
        matched_exclusions
        tempos {
          id
          name
          value
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          bio
          bandcamp
          facebook
          instagram
          itunes
          soundcloud
          spotify
          twitter
          wiki
          youtube
          homebase
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms(first: 100) {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
        collections {
          edges {
            node {
              id
              description
              name
              slug
              category {
                id
                name
              }
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            id
          }
        }
        association_id
        selected_version
        __typename
      }
      id
      cursor
    }
    total
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...trackSearchTaxonomies_viewer
}

fragment signUpCta_viewer on Viewer {
  home_page {
    sign_up_cta_images
  }
}

fragment trackSearchTaxonomies_viewer on Viewer {
  selected_currency
  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {
    edges {
      node {
        id
        __typename
      }
      id
      cursor
    }
    taxonomy_cardinalities
    term_cardinalities
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "filters",
    "type": "TrackSearchFilters",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "taxonomy_query",
    "type": "TaxonomyQuery",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "SearchSortOrder",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "currency",
    "type": "Currency",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "trackSearchQuery",
    "id": null,
    "text": "query trackSearchQuery(\n  $offset: Int\n  $count: Int\n  $query: String\n  $filters: TrackSearchFilters\n  $taxonomy_query: TaxonomyQuery\n  $license_params: [LicenseUsageParamsInput]\n  $sort: SearchSortOrder\n  $currency: Currency\n) {\n  viewer {\n    ...trackSearch_viewer\n    id\n  }\n}\n\nfragment trackSearch_viewer on Viewer {\n  ...signUpCta_viewer\n  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {\n    edges {\n      node {\n        id\n        internal_id\n        price\n        base_price\n        title\n        added_to_cart\n        slug\n        duration\n        score\n        boosted_score\n        stems_available\n        customizable\n        matched_exclusions\n        tempos {\n          id\n          name\n          value\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          bio\n          bandcamp\n          facebook\n          instagram\n          itunes\n          soundcloud\n          spotify\n          twitter\n          wiki\n          youtube\n          homebase\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms(first: 100) {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n        collections {\n          edges {\n            node {\n              id\n              description\n              name\n              slug\n              category {\n                id\n                name\n              }\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            id\n          }\n        }\n        association_id\n        selected_version\n        __typename\n      }\n      id\n      cursor\n    }\n    total\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...trackSearchTaxonomies_viewer\n}\n\nfragment signUpCta_viewer on Viewer {\n  home_page {\n    sign_up_cta_images\n  }\n}\n\nfragment trackSearchTaxonomies_viewer on Viewer {\n  selected_currency\n  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      id\n      cursor\n    }\n    taxonomy_cardinalities\n    term_cardinalities\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "trackSearchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "trackSearch_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "trackSearchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "home_page",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePageContent",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "sign_up_cta_images",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "trackSearch",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "currency",
            "variableName": "currency",
            "type": "Currency"
          }, {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters",
            "type": "TrackSearchFilters"
          }, {
            "kind": "Variable",
            "name": "first",
            "variableName": "count",
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "license_params",
            "variableName": "license_params",
            "type": "[LicenseUsageParamsInput]"
          }, {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset",
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort",
            "type": "SearchSortOrder"
          }, {
            "kind": "Variable",
            "name": "taxonomy_query",
            "variableName": "taxonomy_query",
            "type": "TaxonomyQuery"
          }],
          "concreteType": "TrackSearchResultConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResultEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "stems_available",
                "args": null,
                "storageKey": null
              }, v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "price",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "base_price",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "duration",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "score",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "boosted_score",
                "args": null,
                "storageKey": null
              }, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "customizable",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "matched_exclusions",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "tempos",
                "storageKey": null,
                "args": null,
                "concreteType": "Tempo",
                "plural": true,
                "selections": [v1, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }]
              }, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "itunes",
                  "args": null,
                  "storageKey": null
                }, v1, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bio",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bandcamp",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "facebook",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "instagram",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "soundcloud",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "spotify",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "twitter",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "wiki",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "youtube",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "homebase",
                  "args": null,
                  "storageKey": null
                }, v5]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": "terms(first:100)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 100,
                  "type": "Int"
                }],
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [v1, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_highlighted",
                      "args": null,
                      "storageKey": null
                    }, v4, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "parent_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [v1, v3, v4]
                    }]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "collections",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionTrackConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Collection",
                    "plural": false,
                    "selections": [v1, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "description",
                      "args": null,
                      "storageKey": null
                    }, v4, v2, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "category",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CollectionCategory",
                      "plural": false,
                      "selections": [v1, v4]
                    }, v5]
                  }, v1]
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "association_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected_version",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "taxonomy_cardinalities",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "term_cardinalities",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "trackSearch",
          "args": [{
            "kind": "Variable",
            "name": "currency",
            "variableName": "currency",
            "type": "Currency"
          }, {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters",
            "type": "TrackSearchFilters"
          }, {
            "kind": "Variable",
            "name": "first",
            "variableName": "count",
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "license_params",
            "variableName": "license_params",
            "type": "[LicenseUsageParamsInput]"
          }, {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset",
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort",
            "type": "SearchSortOrder"
          }, {
            "kind": "Variable",
            "name": "taxonomy_query",
            "variableName": "taxonomy_query",
            "type": "TaxonomyQuery"
          }],
          "handle": "connection",
          "key": "trackSearch_trackSearch",
          "filters": ["offset", "query", "filters", "taxonomy_query", "license_params", "sort", "currency"]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency",
          "args": null,
          "storageKey": null
        }, v1]
      }]
    }
  };
}();
node /*: any*/.hash = 'f5653da549fcebe72877bd10d4ddef41';
module.exports = node;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type signUpCta_viewer$ref = any;
type trackSearchTaxonomies_viewer$ref = any;
import type { FragmentReference } from 'relay-runtime';
declare export opaque type trackSearch_viewer$ref: FragmentReference;
export type trackSearch_viewer = {|
  +trackSearch: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +price: ?number,
        +base_price: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +duration: ?number,
        +score: ?number,
        +boosted_score: ?number,
        +stems_available: ?boolean,
        +customizable: ?boolean,
        +matched_exclusions: ?$ReadOnlyArray<?number>,
        +tempos: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +value: ?number,
        |}>,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +bio: ?string,
          +bandcamp: ?string,
          +facebook: ?string,
          +instagram: ?string,
          +itunes: ?string,
          +soundcloud: ?string,
          +spotify: ?string,
          +twitter: ?string,
          +wiki: ?string,
          +youtube: ?string,
          +homebase: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
        +collections: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +description: ?string,
              +name: string,
              +slug: ?string,
              +category: ?{|
                +id: string,
                +name: ?string,
              |},
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
          |}>,
        |},
        +association_id: ?string,
        +selected_version: ?string,
      |},
    |}>,
    +total: ?number,
  |},
  +$fragmentRefs: (signUpCta_viewer$ref & trackSearchTaxonomies_viewer$ref),
  +$refType: trackSearch_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "trackSearch_viewer",
    "type": "Viewer",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": null,
        "direction": "forward",
        "path": ["trackSearch"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    }, {
      "kind": "RootArgument",
      "name": "offset",
      "type": "Int"
    }, {
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    }, {
      "kind": "RootArgument",
      "name": "filters",
      "type": "TrackSearchFilters"
    }, {
      "kind": "RootArgument",
      "name": "taxonomy_query",
      "type": "TaxonomyQuery"
    }, {
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }, {
      "kind": "RootArgument",
      "name": "sort",
      "type": "SearchSortOrder"
    }, {
      "kind": "RootArgument",
      "name": "currency",
      "type": "Currency"
    }],
    "selections": [{
      "kind": "FragmentSpread",
      "name": "signUpCta_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": "trackSearch",
      "name": "__trackSearch_trackSearch_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency",
        "type": "Currency"
      }, {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters",
        "type": "TrackSearchFilters"
      }, {
        "kind": "Variable",
        "name": "license_params",
        "variableName": "license_params",
        "type": "[LicenseUsageParamsInput]"
      }, {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset",
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "SearchSortOrder"
      }, {
        "kind": "Variable",
        "name": "taxonomy_query",
        "variableName": "taxonomy_query",
        "type": "TaxonomyQuery"
      }],
      "concreteType": "TrackSearchResultConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResultEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "stems_available",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "base_price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "score",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "boosted_score",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "customizable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "matched_exclusions",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tempos",
            "storageKey": null,
            "args": null,
            "concreteType": "Tempo",
            "plural": true,
            "selections": [v0, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            }]
          }, v4, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "itunes",
              "args": null,
              "storageKey": null
            }, v0, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bio",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bandcamp",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "facebook",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "instagram",
              "args": null,
              "storageKey": null
            }, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "soundcloud",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "spotify",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "twitter",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "wiki",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "youtube",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "homebase",
              "args": null,
              "storageKey": null
            }, v4]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": "terms(first:100)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 100,
              "type": "Int"
            }],
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v0, v2, v3]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "collections",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionTrackEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Collection",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, v3, v1, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "category",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionCategory",
                  "plural": false,
                  "selections": [v0, v3]
                }, v4]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "association_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_version",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "trackSearchTaxonomies_viewer",
      "args": null
    }]
  };
}();
node /*: any*/.hash = 'df245e3c217a018fb35510622ca731b8';
module.exports = node;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type trackSearchTaxonomies_viewer$ref: FragmentReference;
export type trackSearchTaxonomies_viewer = {|
  +selected_currency: ?Currency,
  +trackSearch: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
      |},
    |}>,
    +taxonomy_cardinalities: ?any,
    +term_cardinalities: ?any,
  |},
  +$refType: trackSearchTaxonomies_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "trackSearchTaxonomies_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [{
      "count": "count",
      "cursor": null,
      "direction": "forward",
      "path": ["trackSearch"]
    }]
  },
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "count",
    "type": "Int"
  }, {
    "kind": "RootArgument",
    "name": "offset",
    "type": "Int"
  }, {
    "kind": "RootArgument",
    "name": "query",
    "type": "String"
  }, {
    "kind": "RootArgument",
    "name": "filters",
    "type": "TrackSearchFilters"
  }, {
    "kind": "RootArgument",
    "name": "taxonomy_query",
    "type": "TaxonomyQuery"
  }, {
    "kind": "RootArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]"
  }, {
    "kind": "RootArgument",
    "name": "sort",
    "type": "SearchSortOrder"
  }, {
    "kind": "RootArgument",
    "name": "currency",
    "type": "Currency"
  }],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "selected_currency",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "trackSearch",
    "name": "__trackSearch_trackSearch_connection",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "currency",
      "variableName": "currency",
      "type": "Currency"
    }, {
      "kind": "Variable",
      "name": "filters",
      "variableName": "filters",
      "type": "TrackSearchFilters"
    }, {
      "kind": "Variable",
      "name": "license_params",
      "variableName": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }, {
      "kind": "Variable",
      "name": "offset",
      "variableName": "offset",
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "query",
      "variableName": "query",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "sort",
      "variableName": "sort",
      "type": "SearchSortOrder"
    }, {
      "kind": "Variable",
      "name": "taxonomy_query",
      "variableName": "taxonomy_query",
      "type": "TaxonomyQuery"
    }],
    "concreteType": "TrackSearchResultConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TrackSearchResultEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "taxonomy_cardinalities",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "term_cardinalities",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "pageInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "PageInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }]
    }]
  }]
};
node /*: any*/.hash = 'bb7a6320cd8dc10c379722c4037206a5';
module.exports = node;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1540);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".track-list ul{margin:0;padding:0;list-style:none}.track-list--loading{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.track-list--loading .track-list__title+.track-list__loading-spinner{margin-left:16px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/TrackList/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,eAEI,SAAS,UACC,eACM,CACjB,qBAGC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,qEAGC,gBCtF6C,CDuF9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * TrackList Component\n */\n\n.track-list{\n  ul{\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &--loading{\n    display: flex;\n    align-items: center;\n  }\n\n  &--loading  &__title + &__loading-spinner{\n    margin-left: baseline(2);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SignUpCtaCard Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
var ImageLoaded_1 = __webpack_require__(185);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var router_1 = __webpack_require__(27);
var signUpCta_1 = __webpack_require__(1542);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
__webpack_require__(1544);
var classes = new BEM('sign-up-cta-card');

var SignUpCtaCardInternal = function (_React$PureComponent) {
    _inherits(SignUpCtaCardInternal, _React$PureComponent);

    function SignUpCtaCardInternal() {
        _classCallCheck(this, SignUpCtaCardInternal);

        return _possibleConstructorReturn(this, (SignUpCtaCardInternal.__proto__ || Object.getPrototypeOf(SignUpCtaCardInternal)).apply(this, arguments));
    }

    _createClass(SignUpCtaCardInternal, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var viewer = this.props.viewer;

            var images = viewer.home_page.sign_up_cta_images;
            var randomImage = images[Math.floor(Math.random() * images.length)];
            return React.createElement(ImageLoaded_1.default, null, function (_ref) {
                var imageLoaded = _ref.imageLoaded;
                return React.createElement("div", Object.assign({}, classes('', { loading: !imageLoaded, ready: imageLoaded })), React.createElement("div", Object.assign({}, classes('image')), React.createElement(velocity_react_1.VelocityComponent, { animation: imageLoaded ? 'fadeIn' : 'fadeOut' }, React.createElement("img", { src: randomImage }))), React.createElement("div", Object.assign({}, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), React.createElement("b", null, "Download Music"), React.createElement("br", null), React.createElement("b", null, "Create & Share"), " Playlists", React.createElement("br", null), "Get our ", React.createElement("b", null, "Staff Picks")), React.createElement(Button_1.default, Object.assign({ label: "Create your account", colorScheme: "dark", onClick: function onClick() {
                        return _this2.props.showSignUpForm();
                    } }, classes('sign-up-button'))), React.createElement("br", null), React.createElement(Label_1.Span, { size: "small" }, "No credit card required.")));
            });
        }
    }]);

    return SignUpCtaCardInternal;
}(React.PureComponent);

var Connected = react_redux_1.connect(function (_ref2, props) {
    var found = _ref2.found,
        user = _ref2.user;
    return Object.assign({}, props, { currentLocation: found.match.location, isUserLoggedIn: user.isLoggedIn });
}, function (dispatch) {
    return { dispatch: dispatch };
}, function (stateProps, _ref3) {
    var dispatch = _ref3.dispatch;
    return Object.assign({}, stateProps, { showSignUpForm: function showSignUpForm() {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: router_1.createHref(stateProps.currentLocation) }));
            dispatch(ui_1.toggleSignUpFormVisibility(true));
        } });
})(SignUpCtaCardInternal);
exports.SignUpCtaCard = react_relay_1.createFragmentContainer(Connected, signUpCta_1.SignUpCtaFragment);

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.SignUpCtaFragment = {
  viewer: function viewer() {
    return __webpack_require__(1543);
  }
};

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type signUpCta_viewer$ref: FragmentReference;
export type signUpCta_viewer = {|
  +home_page: ?{|
    +sign_up_cta_images: ?$ReadOnlyArray<?string>,
  |},
  +$refType: signUpCta_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "signUpCta_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "home_page",
    "storageKey": null,
    "args": null,
    "concreteType": "HomePageContent",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sign_up_cta_images",
      "args": null,
      "storageKey": null
    }]
  }]
};
node /*: any*/.hash = 'c4cf077f99a4b273b6b3393125599734';
module.exports = node;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1545);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.sign-up-cta-card{background-color:#f9fafb;color:#101015;border-radius:16px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom;margin:24px 0}.sign-up-cta-card--ready:before{content:\"\";border-radius:8px;position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;-webkit-transition:.5s ease-in-out;-o-transition:.5s ease-in-out;transition:.5s ease-in-out}.sign-up-cta-card--loading .sign-up-cta-card__title{border-radius:2px;height:16px;width:240px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite}.sign-up-cta-card--loading .sign-up-cta-card__title .label{display:none}.sign-up-cta-card--loading{margin-top:40px;width:240px}.sign-up-cta-card--loading,.sign-up-cta-card--loading:after,.sign-up-cta-card--loading:before{border-radius:2px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite;height:8px}.sign-up-cta-card--loading:after,.sign-up-cta-card--loading:before{content:\"\";display:block;margin:8px 0}.sign-up-cta-card--loading:before{top:-16px;width:248px}.sign-up-cta-card--loading:after{width:200px}.sign-up-cta-card--loading span{display:none}.sign-up-cta-card--loading{opacity:0}.sign-up-cta-card--loading:before{content:\"\";border-radius:2px;height:8px;width:96px;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite;display:block;top:24px}.sign-up-cta-card--loading .sign-up-cta-card__image,.sign-up-cta-card--loading:before{background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto}.sign-up-cta-card--loading .sign-up-cta-card__image{-webkit-animation:gradient-cycle 2s linear infinite;animation:gradient-cycle 2s linear infinite;cursor:default}.sign-up-cta-card--loading .sign-up-cta-card__image img{opacity:0}.sign-up-cta-card__title{margin:0 0 4px}@media screen and (min-width:864px){.sign-up-cta-card__title{font-size:1.5em}}.sign-up-cta-card__image{border-radius:16px 0 0 16px;height:240px;overflow:hidden;-webkit-box-flex:2;-ms-flex:2;flex:2}.sign-up-cta-card__image img{left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);height:100%}.sign-up-cta-card__content{-webkit-box-flex:3;-ms-flex:3;flex:3;padding:32px 64px 32px 48px}.sign-up-cta-card__sign-up-button{margin-top:24px;margin-bottom:8px}.sign-up-cta-card--ready{-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.sign-up-cta-card--ready:before{opacity:1}html.no-touchevents .sign-up-cta-card--ready:hover,html.touchevents .sign-up-cta-card--ready:active{-webkit-transform:scale(1.02);-ms-transform:scale(1.02);transform:scale(1.02)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/media/SignUpCtaCard/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,kBC5BhC,yBA5DsB,cATA,mBD6GxB,qBAAqB,oBACrB,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,gCACnB,4BAAA,wBAAwB,aAEH,CAErB,gCACE,WAAW,kBE5GO,kBF8GQ,MAAG,QAAA,SAAA,OAAA,UACnB,mCACV,8BAAA,0BAA2B,CAC5B,oDE7FG,kBA1BgB,YC0ClB,YH6CF,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,8CAAgE,CAgC/D,2DAMG,YAAa,CACd,2BAID,gBACA,WIzG6C,CJuG9C,8FEzGG,kBF6DJ,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,+CAAgE,UI7DjB,CJuG9C,mEAWG,WAAW,cACG,YACO,CAbxB,kCAiBG,UACA,WIzH2C,CJuG9C,iCAsBG,WI7H2C,CJuG9C,gCA0BG,YAAa,CACd,2BAID,SAAU,CADX,kCAIG,WAAW,kBErKK,WC0ClB,WH+CF,uDAAA,+CAAgE,cAgF9C,QI7I6B,CJ+I5C,sFApFH,iIAAA,+EAAA,0EAAA,wEAAoG,yBAC1E,CAsF1B,oDArFA,oDAAA,4CAAgE,cAuF/C,CAFhB,wDAKG,SAAU,CACX,yBAID,cAA2B,CAK5B,oCAND,yBAII,eAAgB,CAEnB,CAAA,yBAGC,4BACA,aACA,gBAAgB,mBAChB,WAAA,MAAO,CAJR,6BAOG,SAAS,mCACT,+BAAA,2BAA2B,WACf,CACb,2BAID,mBAAA,WAAA,OAAO,2BIjLsC,CJmL9C,kCAGC,gBACA,iBIvL6C,CJwL9C,yBAGC,0DAAA,qDAAA,iDKtMyD,CLqM1D,gCAIG,SAAU,CACX,oGAGC,8BAAA,0BAAA,qBAAsB,CI1MzB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SignUpCtaCard Component\n */\n\n.sign-up-cta-card {\n  @include bgcolor(bw2);\n  @include textcolor(black);\n  @include bgsize(xlarge);\n\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  transform-origin: bottom;\n\n  margin: baseline(3) 0;\n\n  &--ready::before{\n    content: \"\";\n    @include bgsize(large);\n    @include position(absolute, 0);\n    opacity: 0;\n    transition: .5s ease-in-out;\n  }\n\n  &--loading &__title{\n    @include bgsize(small);\n    @include size(baseline(30) baseline(2));\n    @include loading-placeholder(1.25s);\n\n    .label{\n      display: none;\n    }\n  }\n\n  &--loading {\n    margin-top: baseline(5);\n    width: baseline(30);\n\n    &, &::before, &::after{\n      @include bgsize(small);\n      @include loading-placeholder(1.25s);\n      height: baseline(1);\n    }\n\n    &::before, &::after{\n      content: \"\";\n      display: block;\n      margin: baseline(1) 0;\n    }\n\n    &::before{\n      top: baseline(-2);\n      width: baseline(31);\n    }\n\n    &::after{\n      width: baseline(25);\n    }\n\n    span {\n      display: none;\n    }\n  }\n\n  &--loading {\n    opacity: 0;\n\n    &::before{\n      content: \"\";\n      @include bgsize(small);\n      @include size(baseline(12) baseline(1));\n      @include loading-placeholder(1.25s);\n      display: block;\n      top: baseline(3);\n    }\n  }\n\n  &--loading &__image{\n    @include loading-placeholder;\n    cursor: default;\n\n    img{\n      opacity: 0;\n    }\n  }\n\n  &__title{\n    margin: 0 0 baseline(0.5) 0;\n\n    @include media(breakpoint(desktop-xs)){\n      font-size: 1.5em;\n    }\n  }\n\n  &__image{\n    border-radius: radius(xlarge) 0 0 radius(xlarge);\n    height: baseline(30);\n    overflow: hidden;\n    flex: 2;\n\n    img{\n      left: 50%;\n      transform: translateX(-50%);\n      height: 100%;\n    }\n  }\n\n  &__content{\n    flex: 3;\n    padding: baseline(4) baseline(8) baseline(4) baseline(6);\n  }\n\n  &__sign-up-button {\n    margin-top: baseline(3);\n    margin-bottom: baseline(1);\n  }\n\n  &--ready {\n    transition: .25s $ease-out-back;\n\n    &::before{\n      opacity: 1;\n    }\n\n    @include hover{\n      transform: scale(1.02);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1547);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Helmet for Collection
 */

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var image_1 = __webpack_require__(64);
var router_1 = __webpack_require__(27);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var defaultList = [];
function CollectionHelmet(props) {
    var _props$collection = props.collection,
        assets = _props$collection.assets,
        description = _props$collection.description,
        name = _props$collection.name;

    var title = "Collection " + name;
    var coverAssets = image_1.getResponsiveAssets('cover', assets || defaultList);
    var image = coverAssets.xlarge && coverAssets.xlarge.find(function (_ref) {
        var format = _ref.format;
        return format !== 'webp';
    });
    var imageHasMetadata = !!image && !!image.metadata;
    return React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, title), !!description && React.createElement("meta", { name: "description", property: "og:description", content: description }), React.createElement("meta", { property: "og:determiner", content: "a" }), React.createElement("meta", { property: "og:title", content: title }), image && [React.createElement("meta", { key: "og:image", property: "og:image", content: "" + router_1.getOriginLocation() + image.path }), React.createElement("meta", { key: "og:image:type", property: "og:image:type", content: "image/jpeg" }), imageHasMetadata && [React.createElement("meta", { key: "og:image:width", property: "og:image:width", content: image.metadata.width.toString() }), React.createElement("meta", { key: "og:image:width", property: "og:image:height", content: image.metadata.height.toString() })], React.createElement("meta", { key: "og:image:alt", property: "og:image:alt", content: "Collection " + name + " image on " + locales_1.default.pageTitles.default })]);
}
exports.default = CollectionHelmet;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".scrollable-section{width:100%;padding:0 3.3333%}.scrollable-section__list{position:absolute;top:0;left:0;padding:0 calc(3.3333% - 8px);margin:0;list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex}.scrollable-section__list-wrapper{left:-3.5713903061%;right:-3.5713903061%;width:107.142780612%}html.touchevents .scrollable-section__list-wrapper{overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .scrollable-section__list-wrapper{overflow-y:hidden;overflow-x:auto}.scrollable-section__list__item{-webkit-perspective:2000px;perspective:2000px;height:100%;-webkit-box-flex:0;-ms-flex:none;flex:none;margin:0 8px}.scrollable-section__list__item__thumbnail{-webkit-transition:.35s cubic-bezier(.175,.885,.32,1.275);-o-transition:.35s cubic-bezier(.175,.885,.32,1.275);transition:.35s cubic-bezier(.175,.885,.32,1.275);-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}.scrollable-section__list__item__thumbnail:hover{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}.scrollable-section--header-posts .scrollable-section__list-wrapper{padding-top:16px;height:400px}.scrollable-section--header-posts .scrollable-section__list{top:16px}.scrollable-section--header-posts .scrollable-section__list__item{width:496px}.scrollable-section--blog-posts .scrollable-section__list-wrapper{padding-top:32px;height:408px}.scrollable-section--blog-posts .scrollable-section__list{top:32px}.scrollable-section--blog-posts .scrollable-section__list__item{width:576px}.scrollable-section--collections .scrollable-section__list-wrapper{padding-top:32px;height:448px}.scrollable-section--collections .scrollable-section__list{top:32px}.scrollable-section--collections .scrollable-section__list__item{width:288px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/ScrollableSection/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,oBAGE,WAAW,iBADQ,CAInB,0BCxEA,kBDyE4B,MAAG,OAAY,8BACM,SACtC,gBACO,oBAChB,oBAAA,YAAa,CACb,kCAGE,oBAFgE,qBAAA,oBAI1B,CACvC,mDEjHD,kBAAgD,kBACT,gCACN,CAClC,sDAEC,kBAAgD,eACX,CF4GrC,gCACE,2BAAA,mBAAmB,YACP,mBACZ,cAAA,UAAU,YE/FiC,CFiG3C,2CACE,0DAAA,qDAAA,kDACA,gCAAA,4BAAA,uBAAwB,CAFzB,iDAIG,8BAAA,0BAAA,qBAAsB,CACvB,oEAML,iBACA,YE7G6C,CF8G9C,4DAEC,QEhH6C,CFiH9C,kEAEC,WEnH6C,CFoH9C,kEAGC,iBACA,YExH6C,CFyH9C,0DAEC,QE3H6C,CF4H9C,gEAEC,WE9H6C,CF+H9C,mEAGC,iBACA,YEnI6C,CFoI9C,2DAEC,QEtI6C,CFuI9C,iEAEC,WEzI6C,CF0I9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ScrollableSection Component\n */\n\n.scrollable-section{\n  $container-margin: 7.777777778%;\n  $padding-h: 3.3333%;\n  width: 100%;\n  padding: 0 $padding-h;\n\n  &__list {\n    @include position(absolute, 0 null null 0);\n    padding: 0 calc(#{$padding-h} - #{baseline(1)});\n    margin: 0;\n    list-style: none;\n    display: flex;\n    &-wrapper {\n      $list-wrapper-margin: $padding-h/(100 - ($padding-h * 2)) * 100%;\n      @include scroll(x);\n      left: -$list-wrapper-margin;\n      right: -$list-wrapper-margin;\n      width: 100% + $list-wrapper-margin * 2;\n    }\n    &__item {\n      perspective: 2000px;\n      height: 100%;\n      flex: none;\n      margin: 0 baseline(1);\n      &__thumbnail {\n        transition: .35s $ease-out-back;\n        transform-origin: bottom;\n        &:hover {\n          transform: scale(1.03);\n        }\n      }\n    }\n  }\n\n  &--header-posts &__list-wrapper{\n    padding-top: baseline(2);\n    height: baseline(50);\n  }\n  &--header-posts &__list{\n    top: baseline(2);\n  }\n  &--header-posts &__list__item{\n    width: baseline(62);\n  }\n\n  &--blog-posts &__list-wrapper{\n    padding-top: baseline(4);\n    height: baseline(51);\n  }\n  &--blog-posts &__list{\n    top: baseline(4);\n  }\n  &--blog-posts &__list__item{\n    width: baseline(72);\n  }\n\n  &--collections &__list-wrapper{\n    padding-top: baseline(4);\n    height: baseline(56);\n  }\n  &--collections &__list{\n    top: baseline(4);\n  }\n  &--collections &__list__item{\n    width: baseline(36);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".section-title__subtitle{margin-left:4px;margin-bottom:4px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/SectionTitle/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA6GE,yBACE,gBACA,iBC5E6C,CD6E9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SectionTitle Component\n */\n\n.section-title{\n  &__subtitle{\n    margin-left: baseline(.5);\n    margin-bottom: baseline(.5);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Helmet for Artist
 */

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var image_1 = __webpack_require__(64);
var router_1 = __webpack_require__(27);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var string_1 = __webpack_require__(47);
var defaultList = [];
function ArtistHelmet(props) {
  var _props$artist = props.artist,
      assets = _props$artist.assets,
      bio = _props$artist.bio,
      name = _props$artist.name,
      twitter = _props$artist.twitter,
      tracks = props.tracks;

  var title = lodash_1.template(locales_1.default.pageTitles.artistAndTrackTemplate)({ entity: name });
  var coverAssets = image_1.getResponsiveAssets('cover', assets || defaultList);
  var image = coverAssets.xlarge.find(function (_ref) {
    var format = _ref.format;
    return format !== 'webp';
  });
  var imageHasMetadata = !!image && !!image.metadata;
  var description = bio || lodash_1.template(locales_1.default.metaDescriptions.artistDefaultTemplate)({ artist: name });
  return React.createElement(react_helmet_1.Helmet, { titleTemplate: undefined }, React.createElement("title", null, title), React.createElement("meta", { name: "description", property: "og:description", content: description }), React.createElement("meta", { property: "og:determiner", content: "an" }), React.createElement("meta", { property: "og:title", content: title }), React.createElement("meta", { property: "og:image", content: "" + router_1.getOriginLocation() + image.path }), React.createElement("meta", { property: "og:image:type", content: "image/jpeg" }), imageHasMetadata && [React.createElement("meta", { key: "og:image:width", property: "og:image:width", content: image.metadata.width.toString() }), React.createElement("meta", { key: "og:image:width", property: "og:image:height", content: image.metadata.height.toString() })], React.createElement("meta", { property: "og:image:alt", content: "Picture of artist " + name + " available on " + locales_1.default.pageTitles.default }), !!twitter && React.createElement("meta", { name: "twitter:creator", content: "@" + (string_1.twitterHandleFromURL(twitter) || twitter) }), React.createElement("script", { type: "application/ld+json" }, "{\n        \"@context\": \"http://schema.org\",\n        \"@type\": \"MusicGroup\",\n        \"name\": \"" + name + "\",\n        \"description\": \"" + description + "\",\n        \"track\": {\n          \"@type\": \"ItemList\",\n          \"numberOfItems\": " + tracks.length + ",\n          \"itemListElement\": [\n            " + tracks.map(function (track, index) {
    return "\n              {\n                \"@type\": \"ListItem\",\n                \"position\": " + (index + 1) + ",\n                \"item\": {\n                  \"@type\": \"MusicRecording\",\n                  \"name\": \"" + track.title + "\"\n                }\n              }\n            ";
  }) + "\n          ]\n        }\n      }"));
}
var ConnectedArtistHelmet = react_redux_1.connect(function (_ref2) {
  var staticData = _ref2.staticData;
  return {
    businessInformation: staticData.businessInformation
  };
})(ArtistHelmet);
exports.default = ConnectedArtistHelmet;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash bd25eab9fa0c9b514128e73da6a03e86
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type trackFragment_track$ref = any;
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type track_QueryVariables = {|
  id?: ?number,
  slug?: ?string,
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
  currency?: ?Currency,
|};
export type track_QueryResponse = {|
  +track: ?{|
    +$fragmentRefs: trackFragment_track$ref,
  |},
|};
*/

/*
query track_Query(
  $id: Int
  $slug: String
  $license_params: [LicenseUsageParamsInput]
  $currency: Currency
) {
  track(id: $id, slug: $slug, license_params: $license_params, currency: $currency) {
    ...trackFragment_track
    id
  }
}

fragment trackFragment_track on TrackSearchResult {
  id
  internal_id
  price
  base_price
  title
  added_to_cart
  slug
  duration
  score
  boosted_score
  stems_available
  customizable
  matched_exclusions
  tempos {
    id
    name
    value
  }
  assets {
    id
    version
    type
    file_format
    path
    metadata
  }
  artist {
    id
    name
    slug
    bio
    bandcamp
    facebook
    instagram
    itunes
    soundcloud
    spotify
    twitter
    wiki
    youtube
    homebase
    assets {
      id
      version
      type
      file_format
      path
      metadata
    }
  }
  terms(first: 100) {
    edges {
      node {
        id
        is_highlighted
        name
        parent_id
        taxonomy {
          id
          internal_id
          name
        }
      }
    }
  }
  collections {
    edges {
      node {
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
      }
      id
    }
  }
  association_id
  selected_version
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "currency",
    "type": "Currency",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "currency",
    "variableName": "currency",
    "type": "Currency"
  }, {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "Int"
  }, {
    "kind": "Variable",
    "name": "license_params",
    "variableName": "license_params",
    "type": "[LicenseUsageParamsInput]"
  }, {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "track_Query",
    "id": null,
    "text": "query track_Query(\n  $id: Int\n  $slug: String\n  $license_params: [LicenseUsageParamsInput]\n  $currency: Currency\n) {\n  track(id: $id, slug: $slug, license_params: $license_params, currency: $currency) {\n    ...trackFragment_track\n    id\n  }\n}\n\nfragment trackFragment_track on TrackSearchResult {\n  id\n  internal_id\n  price\n  base_price\n  title\n  added_to_cart\n  slug\n  duration\n  score\n  boosted_score\n  stems_available\n  customizable\n  matched_exclusions\n  tempos {\n    id\n    name\n    value\n  }\n  assets {\n    id\n    version\n    type\n    file_format\n    path\n    metadata\n  }\n  artist {\n    id\n    name\n    slug\n    bio\n    bandcamp\n    facebook\n    instagram\n    itunes\n    soundcloud\n    spotify\n    twitter\n    wiki\n    youtube\n    homebase\n    assets {\n      id\n      version\n      type\n      file_format\n      path\n      metadata\n    }\n  }\n  terms(first: 100) {\n    edges {\n      node {\n        id\n        is_highlighted\n        name\n        parent_id\n        taxonomy {\n          id\n          internal_id\n          name\n        }\n      }\n    }\n  }\n  collections {\n    edges {\n      node {\n        id\n        description\n        name\n        slug\n        category {\n          id\n          name\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n      }\n      id\n    }\n  }\n  association_id\n  selected_version\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "track_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "trackFragment_track",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "track_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "stems_available",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "base_price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "duration",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "score",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "boosted_score",
          "args": null,
          "storageKey": null
        }, v4, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customizable",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "matched_exclusions",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tempos",
          "storageKey": null,
          "args": null,
          "concreteType": "Tempo",
          "plural": true,
          "selections": [v2, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          }]
        }, v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "itunes",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bio",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bandcamp",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "soundcloud",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "spotify",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "wiki",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtube",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "homebase",
            "args": null,
            "storageKey": null
          }, v6]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": "terms(first:100)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
          }],
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v5, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v2, v4, v5]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collections",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionTrackConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v5, v3, {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategory",
                "plural": false,
                "selections": [v2, v5]
              }, v6]
            }, v2]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "association_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_version",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '9e288e87434f031cdeb24a630c962dc5';
module.exports = node;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type trackFragment_track$ref: FragmentReference;
export type trackFragment_track = {|
  +id: string,
  +internal_id: ?number,
  +price: ?number,
  +base_price: ?number,
  +title: ?string,
  +added_to_cart: ?boolean,
  +slug: ?string,
  +duration: ?number,
  +score: ?number,
  +boosted_score: ?number,
  +stems_available: ?boolean,
  +customizable: ?boolean,
  +matched_exclusions: ?$ReadOnlyArray<?number>,
  +tempos: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +value: ?number,
  |}>,
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +artist: ?{|
    +id: string,
    +name: ?string,
    +slug: ?string,
    +bio: ?string,
    +bandcamp: ?string,
    +facebook: ?string,
    +instagram: ?string,
    +itunes: ?string,
    +soundcloud: ?string,
    +spotify: ?string,
    +twitter: ?string,
    +wiki: ?string,
    +youtube: ?string,
    +homebase: ?string,
    +assets: ?$ReadOnlyArray<?{|
      +id: string,
      +version: ?string,
      +type: ?string,
      +file_format: ?string,
      +path: ?string,
      +metadata: ?any,
    |}>,
  |},
  +terms: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_highlighted: ?boolean,
        +name: ?string,
        +parent_id: ?string,
        +taxonomy: ?{|
          +id: string,
          +internal_id: ?number,
          +name: ?string,
        |},
      |},
    |}>,
  |},
  +collections: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +name: string,
        +slug: ?string,
        +category: ?{|
          +id: string,
          +name: ?string,
        |},
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
    |}>,
  |},
  +association_id: ?string,
  +selected_version: ?string,
  +$refType: trackFragment_track$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "trackFragment_track",
    "type": "TrackSearchResult",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "stems_available",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "base_price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "added_to_cart",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "duration",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "score",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "boosted_score",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "customizable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "matched_exclusions",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "tempos",
      "storageKey": null,
      "args": null,
      "concreteType": "Tempo",
      "plural": true,
      "selections": [v0, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
      }]
    }, v4, {
      "kind": "LinkedField",
      "alias": null,
      "name": "artist",
      "storageKey": null,
      "args": null,
      "concreteType": "Artist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "itunes",
        "args": null,
        "storageKey": null
      }, v0, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bio",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bandcamp",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "facebook",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "instagram",
        "args": null,
        "storageKey": null
      }, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "soundcloud",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "spotify",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "twitter",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "wiki",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "youtube",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "homebase",
        "args": null,
        "storageKey": null
      }, v4]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "terms",
      "storageKey": "terms(first:100)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 100,
        "type": "Int"
      }],
      "concreteType": "TaxonomyTermConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTermEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_highlighted",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "parent_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "taxonomy",
            "storageKey": null,
            "args": null,
            "concreteType": "Taxonomy",
            "plural": false,
            "selections": [v0, v2, v3]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "collections",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionTrackConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CollectionTrackEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Collection",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, v3, v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionCategory",
            "plural": false,
            "selections": [v0, v3]
          }, v4]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "association_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_version",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = '3ea3b96c1b193511223b4897e69e1204';
module.exports = node;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type trackNode$ref: FragmentReference;
export type trackNode = {|
  +id: string,
  +internal_id: ?number,
  +price: ?number,
  +base_price: ?number,
  +title: ?string,
  +added_to_cart: ?boolean,
  +slug: ?string,
  +duration: ?number,
  +score: ?number,
  +boosted_score: ?number,
  +stems_available: ?boolean,
  +customizable: ?boolean,
  +matched_exclusions: ?$ReadOnlyArray<?number>,
  +tempos: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +value: ?number,
  |}>,
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +artist: ?{|
    +id: string,
    +name: ?string,
    +slug: ?string,
    +bio: ?string,
    +bandcamp: ?string,
    +facebook: ?string,
    +instagram: ?string,
    +itunes: ?string,
    +soundcloud: ?string,
    +spotify: ?string,
    +twitter: ?string,
    +wiki: ?string,
    +youtube: ?string,
    +homebase: ?string,
    +assets: ?$ReadOnlyArray<?{|
      +id: string,
      +version: ?string,
      +type: ?string,
      +file_format: ?string,
      +path: ?string,
      +metadata: ?any,
    |}>,
  |},
  +terms: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_highlighted: ?boolean,
        +name: ?string,
        +parent_id: ?string,
        +taxonomy: ?{|
          +id: string,
          +internal_id: ?number,
          +name: ?string,
        |},
      |},
    |}>,
  |},
  +collections: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +name: string,
        +slug: ?string,
        +category: ?{|
          +id: string,
          +name: ?string,
        |},
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
    |}>,
  |},
  +association_id: ?string,
  +selected_version: ?string,
  +$refType: trackNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "trackNode",
    "type": "TrackSearchResult",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "stems_available",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "base_price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "added_to_cart",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "duration",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "score",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "boosted_score",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "customizable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "matched_exclusions",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "tempos",
      "storageKey": null,
      "args": null,
      "concreteType": "Tempo",
      "plural": true,
      "selections": [v0, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
      }]
    }, v4, {
      "kind": "LinkedField",
      "alias": null,
      "name": "artist",
      "storageKey": null,
      "args": null,
      "concreteType": "Artist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "itunes",
        "args": null,
        "storageKey": null
      }, v0, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bio",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bandcamp",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "facebook",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "instagram",
        "args": null,
        "storageKey": null
      }, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "soundcloud",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "spotify",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "twitter",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "wiki",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "youtube",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "homebase",
        "args": null,
        "storageKey": null
      }, v4]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "terms",
      "storageKey": "terms(first:100)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 100,
        "type": "Int"
      }],
      "concreteType": "TaxonomyTermConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTermEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_highlighted",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "parent_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "taxonomy",
            "storageKey": null,
            "args": null,
            "concreteType": "Taxonomy",
            "plural": false,
            "selections": [v0, v2, v3]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "collections",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionTrackConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CollectionTrackEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Collection",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, v3, v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionCategory",
            "plural": false,
            "selections": [v0, v3]
          }, v4]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "association_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_version",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = '6a6d7a5fcb09ae82dce934ae9979a1ff';
module.exports = node;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1558);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.page--track{padding-top:70vh}.page--track .track-list+.track-list{margin-top:48px}.page--track .track-list .card{height:96px;padding:0}.page--track .track-list .card:hover{z-index:auto}.page--track .track-list .card__background{display:none}.page--track .track-list .card__image{z-index:auto}.page--track .track-list .card__content{border-bottom:1px solid #e4e8ed}.page--track .track-list .card__content__right{z-index:auto}.page--track .track-list__item:first-child .card__content{border-top:1px solid #e4e8ed}.page--track .show-all-tracks-button{-ms-flex-item-align:start;align-self:flex-start;margin:16px 0}.track__artist-picture{position:absolute;top:-65px;right:0;bottom:0;left:0;pointer-events:none;overflow:hidden}.track__artist-picture:after{content:\"\";position:absolute;top:-56px;right:0;bottom:0;left:0;background-color:rgba(16,16,21,.75)}.track__hero{position:fixed;top:129px;right:0;left:0;color:#fff;height:70vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;pointer-events:none;padding-top:16px}.track__hero .button{pointer-events:all}.track__hero .thumbnail:after{-webkit-box-shadow:0 30px 60px 0 rgba(16,16,21,.5);box-shadow:0 30px 60px 0 rgba(16,16,21,.5)}.track__hero .track__title{margin-top:24px;margin-bottom:8px}.track__hero .track__artist{margin-top:8px;margin-bottom:0}.track__hero .track__cover-image{color:#101015;margin:0 auto}.track__header{background-color:#fff;position:relative;height:56px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 16px;-webkit-box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2);box-shadow:0 2px 8px -3px hsla(220,7%,57%,.2)}.track__header,.track__header__actions{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.track__header__actions{margin-left:auto}.track__header .track__details{-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-animation:show-track-details .25s ease-out .25s backwards;animation:show-track-details .25s ease-out .25s backwards}@-webkit-keyframes show-track-details{0%{-webkit-transform:translateX(-50%);transform:translateX(-50%);opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}}@keyframes show-track-details{0%{-webkit-transform:translateX(-50%);transform:translateX(-50%);opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}}.track__action.button:hover{color:#4487ff}.track__info{margin-right:8px;margin-left:8px}.track__info__title{margin:0}.track__info__subtitle{display:block}.track__versions-and-license{background-color:#fff;border-top:1px solid #e4e8ed;border-bottom:1px solid #e4e8ed;min-height:176px}.track__versions,.track__versions-and-license{display:-webkit-box;display:-ms-flexbox;display:flex}.track__versions{-webkit-box-flex:2;-ms-flex:2;flex:2;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;margin-top:32px}.track__versions__title{font-size:.625em;margin:8px auto}.track__versions__player{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:16px auto;padding:0 24px}.track__versions__player__play-button{height:48px;width:48px;-webkit-box-flex:0;-ms-flex:none;flex:none;margin-right:24px}.track__versions__player__waveform{color:#d2d9e1}.track__versions__player__waveform svg{height:100%;width:100%}.track__license{background-color:#f5faff;-webkit-box-flex:1;-ms-flex:1;flex:1;border-left:1px solid #e4e8ed}.track__license__pricing{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e4e8ed}.track__license__details,.track__license__pricing{padding:16px 16px 16px 20px}.track__license--no-terms{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.track__license--no-terms .track__license__title{margin-top:0}.track__license .track__price{margin:0}.track__usage-button .description{font-size:.875em;line-height:1}.track__content{background-color:#f0f6fa;padding-top:24px;padding-bottom:48px;min-height:100vh}.track__content__wrapper{padding-top:24px;padding-bottom:24px;width:90%;max-width:1152px;margin:0 auto}.track__content__column,.track__content__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.track__content__column{padding-right:24px;padding-left:24px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.track__content__column--metadata{-webkit-box-flex:4;-ms-flex:4;flex:4}.track__content__column--facets,.track__content__column--other-tracks{-webkit-box-flex:10;-ms-flex:10;flex:10}.track__content__column--collections{-webkit-box-flex:1;-ms-flex:auto;flex:auto}@media screen and (min-width:1152px){.track__content__column--metadata{-webkit-box-flex:5;-ms-flex:5;flex:5}.track__content__column--facets{-webkit-box-flex:12;-ms-flex:12;flex:12}.track__content__column--other-tracks{-webkit-box-flex:7;-ms-flex:7;flex:7}}.track__tags-group{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:16px 0 16px -4px}.track__tags-group:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;line-height:1.34;content:attr(data-title);margin-left:4px;margin-bottom:4px;-ms-flex-preferred-size:100%;flex-basis:100%}@media print{.track__tags-group:before{font-size:.6770833331em}}.track__tags-group:before em,.track__tags-group:before i{font-weight:300}.track__tags-group:before b,.track__tags-group:before strong{font-weight:700}.buttons-group{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif}.buttons-group .button{border:1px solid #8a8f99;border-radius:0}.buttons-group .button .label{font-size:.875em;line-height:1}.buttons-group .button:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}.buttons-group .button:not(:first-child):not(:last-child){border-radius:0}.buttons-group .button:not(:last-child){border-right:0}.buttons-group .button:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px}.buttons-group .button.is-active{background-color:#8a8f99}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Track/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_fonts.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,aC8DtE,gBAHgB,CAElB,qCAKM,eCjF2C,CD4EjD,+BASM,YACA,SAAU,CAVhB,qCAaQ,YAAa,CAbrB,2CAiBM,YAAa,CAjBnB,sCAoBM,YAAa,CApBnB,wCAuBM,+BE3HqB,CFoG3B,+CAyBQ,YAAa,CAzBrB,0DA8BQ,4BElImB,CFoG3B,qCAoCI,0BAAA,sBAAsB,aACD,CACtB,uBG3GD,kBHgH4B,UArGQ,QAqGgB,SAAE,OAAF,oBAC9B,eACJ,CAHjB,6BAKG,WAAW,kBACe,UC5HiB,QD4HD,SAAE,OAAF,mCACQ,CACnD,aGvHH,eH2HyB,UAA0C,QAAE,OAAO,WAE1E,YA1Dc,oBA2Dd,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,kBACD,oBACE,gBCzIyB,CDiI9C,qBAYG,kBAAmB,CAZtB,8BI3IG,mDJ2JsD,0CAAA,CACvD,2BAID,gBACA,iBCvJ6C,CDwJ9C,4BAGC,eACA,eAAgB,CACjB,iCE/GC,cFmHA,aAAc,CACf,eE5HC,sBFgIA,kBAAkB,YAIlB,yBAAA,sBAAA,8BAA8B,eAG9B,sDAAA,6CAA8D,CAE9D,uCANA,oBAAA,oBAAA,aAAa,yBAEb,sBAAA,kBAAmB,CAInB,wBACE,gBAAiB,CAGlB,+BAID,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kEAEnB,yDAA0D,CAE1D,sCACE,GAAK,mCAAA,2BAA2B,SAAa,CAAA,GACtC,gCAAA,wBAAwB,SAAa,CAAA,CAF9C,8BACE,GAAK,mCAAA,2BAA2B,SAAa,CAAA,GACtC,gCAAA,wBAAwB,SAAa,CAAA,CAAA,4BEjJ9C,aAnEuB,CF2NtB,aKhJqB,iBJtDuB,eAAA,CD4M7C,oBACE,QAAS,CACV,uBAGC,aAAc,CACf,6BE5KD,sBFiLA,6BACA,gCAEA,gBC1N6C,CD2N9C,8CAFC,oBAAA,oBAAA,YAAa,CAIf,iBACE,mBAAA,WAAA,OAAO,4BAEP,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,kBACL,eClO2B,CDqO7C,wBACE,iBAAiB,eACO,CACzB,yBAGC,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,iBACC,cC7OmB,CDgP3C,sCMxOF,YLR6C,WDkPzC,mBAAA,cAAA,UAAU,iBClP+B,CDoP1C,mCEtMH,aAvEmB,CF+QhB,uCM9OH,YNkPwB,UAAA,CACnB,gBErNL,yBF4NA,mBAAA,WAAA,OAAO,6BE1RgB,CF6RvB,yBACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,+BEhSE,CFkStB,kDAGC,2BC7Q2C,CD8Q5C,0BAGC,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,kBAAmB,CACpB,iDACC,YAAa,CACd,8BAID,QAAS,CACV,kCAIG,iBAAiB,aACH,CACf,gBE5PD,yBFiQA,iBACA,oBACA,gBAAiB,CAEjB,yBK1PoB,iBJjDyB,oBD6S3C,UAAU,iBAEV,aAAc,CAEf,iDADC,oBAAA,oBAAA,YAAa,CAGf,wBK7PsB,mBJtDuB,kBDsT3C,4BAAA,6BAAA,0BAAA,qBAAsB,CACtB,kCAAa,mBAAA,WAAA,MAAQ,CAAE,sEAEN,oBAAA,YAAA,OAAS,CAAE,qCACZ,mBAAA,cAAA,SAAW,CAAE,qCAG3B,kCAAa,mBAAA,WAAA,MAAQ,CAAE,gCACZ,oBAAA,YAAA,OAAS,CAAE,sCACL,mBAAA,WAAA,MAAQ,CAAE,CAAA,mBAM/B,oBAAA,oBAAA,aAAa,mBACb,eAAe,uBCtU8B,CDoU9C,0BC3RC,mCAJqC,kCAKH,aM/BvB,8CACb,yCAAA,sCAAsC,kBAhClB,iBPgWhB,yBAAyB,gBAEzB,kBACA,6BAAA,eAAgB,CACjB,aAZF,0BO9SO,uBAA0B,CP0T/B,CAZF,yDOpSG,eAAgB,CPoSnB,6DO5RG,eAAgB,CP4StB,eACE,kEQpX8E,CRmXhF,uBAKI,yBACA,eAAgB,CANpB,8BASM,iBAAiB,aACH,CAVpB,mCAcM,2BACA,6BCnW2C,CDoVjD,0DAmBM,eAAgB,CAnBtB,wCAuBM,cAAe,CAvBrB,kCA2BM,4BACA,8BChX2C,CDoVjD,iCAgCM,wBEjZkB,CFkZnB","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Track Page Component\n */\n\n@import '../../atoms/text/Label/mixins';\n$hero-height: 70vh;\n\n.page--track{\n  padding-top: $hero-height;\n\n  .track-list{\n    & + .track-list{\n      margin-top: baseline(6);\n    }\n\n    .card{\n      height: baseline(12);\n      padding: 0;\n\n      &:hover{\n        z-index: auto;\n      }\n    }\n    .card__background{\n      display: none;\n    }\n    .card__image{\n      z-index: auto;\n    }\n    .card__content{\n      border-bottom: 1px solid uicolor(border);\n      &__right{\n        z-index: auto;\n      }\n    }\n    &__item:first-child{\n      .card__content{\n        border-top: 1px solid uicolor(border);\n      }\n    }\n  }\n\n  .show-all-tracks-button{\n    align-self: flex-start;\n    margin: baseline(2) 0;\n  }\n}\n\n.track{\n  &__artist-picture{\n    @include position(absolute, -$license-bar-height 0 0);\n    pointer-events: none;\n    overflow: hidden;\n    &::after{\n      content: \"\";\n      @include position(absolute, baseline(-7) 0 0);\n      background-color: transparentize(color(dark), .25);\n    }\n  }\n\n  &__hero{\n    @include position(fixed, $app-header-height + $license-bar-height 0 null 0);\n    @include textcolor(white);\n    height: $hero-height;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    pointer-events: none;\n    padding-top: baseline(2);\n\n    .button{\n      pointer-events: all;\n    }\n\n    .thumbnail::after{\n      @include shadow(large, transparentize(color(dark), .5));\n    }\n  }\n\n  &__hero &__title{\n    margin-top: baseline(3);\n    margin-bottom: baseline(1);\n  }\n\n  &__hero &__artist{\n    margin-top: baseline(1);\n    margin-bottom: 0;\n  }\n\n  &__hero &__cover-image{\n    @include textcolor(black);\n    margin: 0 auto;\n  }\n\n  &__header{\n    @include bgcolor(white);\n    position: relative;\n\n    height: $page-header-height;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 baseline(2);\n    box-shadow: 0 2px 8px -3px transparentize(uicolor(shadow), .8);\n\n    &__actions{\n      margin-left: auto;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  &__header &__details {\n    flex: none;\n    display: flex;\n    align-items: center;\n\n    animation: show-track-details .25s ease-out .25s backwards;\n\n    @keyframes show-track-details {\n      0% { transform: translateX(-50%); opacity: 0 }\n      100% { transform: translateX(0); opacity: 1 }\n    }\n  }\n\n  &__action.button{\n    &:hover{\n      @include textcolor(accent);\n    }\n  }\n\n  &__info{\n    @include margin(null baseline(1));\n\n    &__title{\n      margin: 0;\n    }\n\n    &__subtitle{\n      display: block;\n    }\n  }\n\n  &__versions-and-license{\n    @include bgcolor(white);\n    border-top: 1px solid uicolor(border);\n    border-bottom: 1px solid uicolor(border);\n    display: flex;\n    min-height: baseline(22);\n  }\n\n  &__versions{\n    flex: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    margin-top: baseline(4);\n\n    &__title{\n      font-size: .625em;\n      margin: baseline(1) auto;\n    }\n\n    &__player{\n      display: flex;\n      justify-content: center;\n      margin: baseline(2) auto;\n      padding: 0 baseline(3);\n\n      &__play-button{\n        @include size(baseline(6));\n        flex: none;\n        margin-right: baseline(3);\n      }\n\n      &__waveform{\n        @include textcolor(bw5);\n\n        svg{\n          @include size(100%);\n        }\n      }\n    }\n  }\n\n  &__license{\n    @include bgcolor(accent-subtle);\n    flex: 1;\n    border-left: 1px solid uicolor(border);\n\n    &__pricing{\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      border-bottom: 1px solid uicolor(border);\n    }\n\n    &__pricing, &__details{\n      padding: baseline(2) baseline(2) baseline(2) baseline(2.5);\n    }\n\n    &--no-terms{\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    } &--no-terms &__title{\n      margin-top: 0;\n    }\n  }\n\n  &__license &__price{\n    margin: 0;\n  }\n\n  &__usage-button{\n    .description{\n      font-size: .875em;\n      line-height: 1;\n    }\n  }\n\n  &__content{\n    @include bgcolor(bw3);\n    padding-top: baseline(3);\n    padding-bottom: baseline(6);\n    min-height: 100vh;\n\n    &__wrapper{\n      @include padding(baseline(3) null);\n      width: 90%;\n      max-width: baseline(144);\n      margin: 0 auto;\n      display: flex;\n    }\n\n    &__column{\n      @include padding(null baseline(3));\n      display: flex;\n      flex-direction: column;\n      &--metadata{ flex: 4 }\n      &--facets{ flex: 10 }\n      &--other-tracks{ flex: 10 }\n      &--collections{ flex: auto }\n\n      @include media(breakpoint(desktop-m)) {\n        &--metadata{ flex: 5 }\n        &--facets{ flex: 12 }\n        &--other-tracks{ flex: 7 }\n      }\n    }\n  }\n\n  &__tags-group{\n    display: flex;\n    flex-wrap: wrap;\n    margin: baseline(2) 0 baseline(2) baseline(-.5);\n\n    &::before{\n      @include label;\n      @include label-size(medium);\n      content: attr(data-title);\n      margin-left: baseline(.5);\n      margin-bottom: baseline(.5);\n      flex-basis: 100%;\n    }\n  }\n}\n\n.buttons-group{\n  font-family: $font--articulat;\n\n  .button{\n    $border-radius: baseline(.5);\n    border: 1px solid color(bw7);\n    border-radius: 0;\n\n    .label{\n      font-size: .875em;\n      line-height: 1;\n    }\n\n    &:first-child{\n      border-top-left-radius: $border-radius;\n      border-bottom-left-radius: $border-radius;\n    }\n\n    &:not(:first-child):not(:last-child){\n      border-radius: 0;\n    }\n\n    &:not(:last-child){\n      border-right: 0;\n    }\n\n    &:last-child{\n      border-top-right-radius: $border-radius;\n      border-bottom-right-radius: $border-radius;\n    }\n\n    &.is-active{\n      background-color: color(bw7);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","/**\n *   Fonts\n **/\n\n$font--articulat: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--space-mono: \"Articulat CF\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$font--default: $font--articulat;\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1560);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * WaveformPlaceholder Component
 */
/* tslint:disable:max-line-length */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var classes = new BEM('waveform-placeholder');
function WaveformPlaceholder(_a) {
    var className = _a.className,
        rest = __rest(_a, ["className"]);
    return React.createElement("div", Object.assign({}, classes('', '', className), rest), React.createElement("svg", { width: "822", height: "45", viewBox: "0 0 822 45", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, React.createElement("path", { d: "M0 16h1v13H0zM11.443 14h1v16h-1zM22.885 7h1v31h-1zM34.328 10h1v25h-1zM45.77 6h1v33h-1zM57.213 18h1v9h-1zM68.655 9h1v26h-1zM80.098 11h1v22h-1zM91.54 9h1v26h-1zM102.983 9h1v27h-1zM114.425 8h1v29h-1zM125.868 3h1v39h-1zM137.31 2h1v40h-1zM148.753 12h1v21h-1zM160.195 13h1v19h-1zM171.638 4h1v37h-1zM183.08 16h1v13h-1zM194.523 3h1v39h-1zM205.965 10h1v25h-1zM217.408 17h1v11h-1zM228.85 9h1v26h-1zM240.293 12h1v21h-1zM251.735 17h1v11h-1zM263.178 11h1v22h-1zM274.62 4h1v37h-1zM286.063 15h1v15h-1zM297.505 17h1v11h-1zM308.948 17h1v10h-1zM320.39 14h1v16h-1zM331.833 2h1v40h-1zM343.275 7h1v31h-1zM354.718 6h1v32h-1zM366.16 4h1v36h-1zM377.603 4h1v37h-1zM389.045 2h1v40h-1zM400.488 15h1v15h-1zM5.721 1h1v42h-1zM17.164 6h1v33h-1zM28.606 11h1v23h-1zM40.049 9h1v27h-1zM51.491 1h1v43h-1zM62.934 12h1v21h-1zM74.376 10h1v24h-1zM85.819 4h1v36h-1zM97.261 11h1v23h-1zM108.704 9h1v27h-1zM120.146 13h1v19h-1zM131.589 11h1v23h-1zM143.031 1h1v43h-1zM154.474 2h1v41h-1zM165.916 13h1v18h-1zM177.359 9h1v27h-1zM188.801 4h1v36h-1zM200.244 12h1v21h-1zM211.686 18h1v9h-1zM223.129 2h1v40h-1zM234.571 5h1v34h-1zM246.014 8h1v28h-1zM257.456 6h1v32h-1zM268.899 7h1v30h-1zM280.341 8h1v29h-1zM291.784 13h1v19h-1zM303.226 11h1v22h-1zM314.669 11h1v23h-1zM326.111 16h1v13h-1zM337.554 1h1v43h-1zM348.997 15h1v14h-1zM360.439 6h1v33h-1zM371.882 9h1v27h-1zM383.324 3h1v38h-1zM394.767 16h1v13h-1zM406.209 12h1v21h-1zM2.861 10h1v24h-1zM14.303 1h1v42h-1zM25.746 0h1v45h-1zM37.188 8h1v28h-1zM48.631 17h1v11h-1zM60.073 3h1v38h-1zM71.516 11h1v23h-1zM82.958 14h1v16h-1zM94.401 13h1v18h-1zM105.843 9h1v26h-1zM117.286 2h1v41h-1zM128.728 0h1v45h-1zM140.171 14h1v17h-1zM151.613 3h1v38h-1zM163.056 6h1v33h-1zM174.498 14h1v16h-1zM185.941 6h1v33h-1zM197.383 15h1v14h-1zM208.826 3h1v38h-1zM220.268 8h1v29h-1zM231.711 18h1v9h-1zM243.153 17h1v11h-1zM254.596 10h1v24h-1zM266.038 12h1v21h-1zM277.481 8h1v29h-1zM288.923 0h1v44h-1zM300.366 2h1v40h-1zM311.808 1h1v42h-1zM323.251 9h1v26h-1zM334.693 2h1v40h-1zM346.136 6h1v32h-1zM357.578 6h1v33h-1zM369.021 8h1v29h-1zM380.463 8h1v29h-1zM391.906 12h1v21h-1zM403.348 12h1v21h-1zM8.582 2h1v41h-1zM20.024 0h1v45h-1zM31.467 10h1v25h-1zM42.909 13h1v18h-1zM54.352 5h1v35h-1zM65.794 1h1v42h-1zM77.237 9h1v27h-1zM88.679 8h1v28h-1zM100.122 11h1v23h-1zM111.564 15h1v15h-1zM123.007 17h1v10h-1zM134.449 15h1v14h-1zM145.892 13h1v18h-1zM157.334 8h1v29h-1zM168.777 16h1v12h-1zM180.22 0h1v44h-1zM191.662 7h1v30h-1zM203.105 3h1v39h-1zM214.547 7h1v31h-1zM225.99 10h1v24h-1zM237.432 11h1v23h-1zM248.875 10h1v24h-1zM260.317 14h1v16h-1zM271.76 11h1v23h-1zM283.202 15h1v15h-1zM294.645 16h1v13h-1zM306.087 0h1v44h-1zM317.53 15h1v15h-1zM328.972 14h1v16h-1zM340.415 7h1v30h-1zM351.857 15h1v14h-1zM363.3 16h1v12h-1zM374.742 7h1v31h-1zM386.185 7h1v31h-1zM397.627 11h1v23h-1zM409.07 14h1v16h-1zM411.93 13h1v18h-1zM423.373 13h1v18h-1zM434.815 16h1v12h-1zM446.258 9h1v26h-1zM457.7 10h1v24h-1zM469.143 2h1v41h-1zM480.585 6h1v33h-1zM492.028 6h1v33h-1zM503.47 8h1v28h-1zM514.913 5h1v35h-1zM526.355 1h1v43h-1zM537.798 6h1v33h-1zM549.24 11h1v23h-1zM560.683 6h1v33h-1zM572.125 12h1v21h-1zM583.568 14h1v16h-1zM595.01 6h1v33h-1zM606.453 16h1v12h-1zM617.895 6h1v33h-1zM629.338 7h1v30h-1zM640.78 6h1v33h-1zM652.223 10h1v25h-1zM663.666 8h1v29h-1zM675.108 1h1v42h-1zM686.551 8h1v29h-1zM697.993 14h1v17h-1zM709.436 11h1v23h-1zM720.878 6h1v33h-1zM732.321 3h1v38h-1zM743.763 3h1v38h-1zM755.206 4h1v37h-1zM766.648 17h1v10h-1zM778.091 3h1v39h-1zM789.533 12h1v21h-1zM800.976 17h1v11h-1zM812.418 2h1v41h-1zM417.652 11h1v23h-1zM429.094 3h1v38h-1zM440.537 9h1v26h-1zM451.979 13h1v18h-1zM463.422 5h1v35h-1zM474.864 16h1v12h-1zM486.307 12h1v20h-1zM497.749 1h1v43h-1zM509.192 10h1v25h-1zM520.634 0h1v44h-1zM532.077 2h1v41h-1zM543.519 5h1v34h-1zM554.962 12h1v20h-1zM566.404 12h1v20h-1zM577.847 16h1v13h-1zM589.289 9h1v27h-1zM600.732 10h1v25h-1zM612.174 13h1v19h-1zM623.617 16h1v13h-1zM635.059 11h1v23h-1zM646.502 9h1v26h-1zM657.944 16h1v12h-1zM669.387 6h1v32h-1zM680.829 5h1v34h-1zM692.272 12h1v21h-1zM703.714 2h1v40h-1zM715.157 7h1v30h-1zM726.599 2h1v40h-1zM738.042 12h1v20h-1zM749.484 2h1v40h-1zM760.927 7h1v30h-1zM772.369 1h1v42h-1zM783.812 4h1v36h-1zM795.254 12h1v20h-1zM806.697 4h1v37h-1zM818.139 16h1v12h-1zM414.791 0h1v44h-1zM426.233 14h1v17h-1zM437.676 5h1v34h-1zM449.118 14h1v16h-1zM460.561 1h1v43h-1zM472.003 5h1v35h-1zM483.446 9h1v26h-1zM494.889 17h1v11h-1zM506.331 5h1v34h-1zM517.774 11h1v23h-1zM529.216 4h1v37h-1zM540.659 12h1v21h-1zM552.101 12h1v20h-1zM563.544 8h1v28h-1zM574.986 1h1v43h-1zM586.429 1h1v43h-1zM597.871 5h1v34h-1zM609.314 1h1v43h-1zM620.756 8h1v28h-1zM632.199 6h1v32h-1zM643.641 14h1v17h-1zM655.084 1h1v43h-1zM666.526 16h1v12h-1zM677.969 12h1v21h-1zM689.411 16h1v13h-1zM700.854 15h1v14h-1zM712.296 12h1v20h-1zM723.739 11h1v22h-1zM735.181 1h1v43h-1zM746.624 14h1v17h-1zM758.066 17h1v10h-1zM769.509 17h1v11h-1zM780.951 7h1v30h-1zM792.394 7h1v31h-1zM803.836 0h1v44h-1zM815.279 12h1v21h-1zM420.512 14h1v17h-1zM431.955 5h1v34h-1zM443.397 9h1v27h-1zM454.84 11h1v23h-1zM466.282 4h1v36h-1zM477.725 15h1v15h-1zM489.167 8h1v29h-1zM500.61 5h1v35h-1zM512.052 4h1v37h-1zM523.495 13h1v19h-1zM534.937 16h1v13h-1zM546.38 11h1v23h-1zM557.822 18h1v9h-1zM569.265 11h1v22h-1zM580.707 16h1v13h-1zM592.15 11h1v22h-1zM603.592 1h1v42h-1zM615.035 11h1v22h-1zM626.477 9h1v27h-1zM637.92 12h1v21h-1zM649.362 13h1v18h-1zM660.805 17h1v11h-1zM672.247 9h1v26h-1zM683.69 6h1v32h-1zM695.132 8h1v28h-1zM706.575 5h1v35h-1zM718.017 13h1v18h-1zM729.46 4h1v36h-1zM740.902 13h1v19h-1zM752.345 11h1v23h-1zM763.787 17h1v10h-1zM775.23 2h1v40h-1zM786.672 17h1v11h-1zM798.115 1h1v43h-1zM809.557 12h1v20h-1zM821 7h1v30h-1z" }))));
}
exports.default = WaveformPlaceholder;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Helmet for Track
 */

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var image_1 = __webpack_require__(64);
var router_1 = __webpack_require__(27);
var string_1 = __webpack_require__(47);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var defaultList = [];
function TrackHelmet(props) {
    var _props$track = props.track,
        artist = _props$track.artist,
        assets = _props$track.assets,
        title = _props$track.title;

    var trackInfo = title + " by " + artist.name;
    var pageTitle = lodash_1.template(locales_1.default.pageTitles.artistAndTrackTemplate)({ entity: trackInfo });
    var coverAssets = image_1.getResponsiveAssets('thumb', assets || defaultList);
    var image = coverAssets.xlarge.find(function (_ref) {
        var format = _ref.format;
        return format !== 'webp';
    });
    var coverImagePath = "" + router_1.getOriginLocation() + image.path;
    var imageHasMetadata = !!image && !!image.metadata;
    var description = lodash_1.template(locales_1.default.metaDescriptions.artistDefaultTemplate)({ artist: artist.name });
    return React.createElement(react_helmet_1.Helmet, { titleTemplate: undefined }, React.createElement("title", null, pageTitle), React.createElement("meta", { name: "description", property: "og:description", content: description }), React.createElement("meta", { property: "og:determiner", content: "an" }), React.createElement("meta", { property: "og:title", content: pageTitle }), React.createElement("meta", { property: "og:image", content: coverImagePath }), React.createElement("meta", { property: "og:image:type", content: "image/jpeg" }), imageHasMetadata && [React.createElement("meta", { key: "og:image:width", property: "og:image:width", content: image.metadata.width.toString() }), React.createElement("meta", { key: "og:image:width", property: "og:image:height", content: image.metadata.height.toString() })], React.createElement("meta", { property: "og:image:alt", content: "Cover art for track " + trackInfo + " available on " + locales_1.default.pageTitles.default }), !!artist.twitter && React.createElement("meta", { name: "twitter:creator", content: "@" + (string_1.twitterHandleFromURL(artist.twitter) || artist.twitter) }), React.createElement("script", { type: "application/ld+json" }, "{\n        \"@context\": \"http://schema.org\",\n        \"@type\": \"MusicRecording\",\n        \"name\": \"" + title + "\",\n        \"byArtist\": {\n          \"@type\": \"MusicGroup\",\n          \"name\": \"" + artist.name + "\",\n          \"description\": \"" + description + "\"\n        },\n        \"thumbnailUrl\": \"" + coverImagePath + "\"\n      }"));
}
var ConnectedTrackHelmet = react_redux_1.connect(function (_ref2) {
    var staticData = _ref2.staticData;
    return {
        businessInformation: staticData.businessInformation
    };
})(TrackHelmet);
exports.default = ConnectedTrackHelmet;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Card Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var ui_1 = __webpack_require__(294);
var track_1 = __webpack_require__(44);
var reselect_1 = __webpack_require__(49);
exports.makeIsCardSelected = function () {
    return reselect_1.createSelector([ui_1.getUIState, track_1.getTrackFromProps], function (_ref, track) {
        var trackDetails = _ref.trackDetails;

        return !!trackDetails && !!track && trackDetails.visible && !!trackDetails.trackInfo && trackDetails.trackInfo.id === track.id;
    });
};

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Alert Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1565);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Label_1 = __webpack_require__(8);
var classes = new BEM('alert');

var Alert = function (_React$Component) {
    _inherits(Alert, _React$Component);

    function Alert() {
        _classCallCheck(this, Alert);

        return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));
    }

    _createClass(Alert, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                message = _props.message,
                visible = _props.visible;

            var extraClasses = classNames(className);
            return React.createElement(velocity_react_1.VelocityComponent, { animation: { translateY: visible ? 0 : '-100%' } }, React.createElement("div", Object.assign({}, classes('', '', extraClasses)), React.createElement(Label_1.Span, { variant: "description" }, message)));
        }
    }]);

    return Alert;
}(React.Component);

exports.default = Alert;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1566);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".alert{background-color:#fff5f5;color:#f75b5b;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:56px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/messaging/Alert/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,OCnCI,yBAvDoB,cD6FtB,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,WE9E4B,CFgFhD","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Alert Component\n */\n\n.alert{\n  @include bgcolor(dangerous-subtle);\n  @include textcolor(dangerous);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: baseline(7);\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1568);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--checkout-complete .page__main{min-height:calc(100vh - 64px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;width:90%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 auto;padding-bottom:64px}.checkout-complete__title{margin-bottom:0}.checkout-complete__subtitle{color:#b1b8c4;margin-bottom:32px}.checkout-complete__license-files-list{list-style:none;margin:32px 0 48px;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex}.checkout-complete__license-files-list__item{margin-right:16px;margin-left:16px;height:288px;width:216px;-webkit-animation:show-license-file .5s ease-in-out backwards;animation:show-license-file .5s ease-in-out backwards}.checkout-complete__license-files-list__item:first-child{-webkit-transform-origin:center right;-ms-transform-origin:center right;transform-origin:center right}.checkout-complete__license-files-list__item:nth-child(2){-webkit-transform-origin:center center;-ms-transform-origin:center center;transform-origin:center center;-webkit-animation-delay:.15s;animation-delay:.15s}.checkout-complete__license-files-list__item:nth-child(3){-webkit-transform-origin:center left;-ms-transform-origin:center left;transform-origin:center left;-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes show-license-file{0%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes show-license-file{0%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}.checkout-complete__license-files-list__item:before{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);content:\"\"}.checkout-complete__license-files-list__item__background{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#fff;border-radius:4px;-webkit-transition:.35s cubic-bezier(.19,1,.22,1);-o-transition:.35s cubic-bezier(.19,1,.22,1);transition:.35s cubic-bezier(.19,1,.22,1)}.checkout-complete__license-files-list__item__icon{position:absolute;top:42%;left:50%;color:#e4e8ed;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transition:2s cubic-bezier(.19,1,.22,1);-o-transition:2s cubic-bezier(.19,1,.22,1);transition:2s cubic-bezier(.19,1,.22,1)}.checkout-complete__license-files-list__item__title{position:absolute;right:5%;bottom:8%;left:5%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:.35s cubic-bezier(.19,1,.22,1) .1s;-o-transition:.35s cubic-bezier(.19,1,.22,1) .1s;transition:.35s cubic-bezier(.19,1,.22,1) .1s}.checkout-complete__license-files-list__item__actions{position:absolute;right:5%;bottom:0;left:5%;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-transition:.35s cubic-bezier(.19,1,.22,1);-o-transition:.35s cubic-bezier(.19,1,.22,1);transition:.35s cubic-bezier(.19,1,.22,1);opacity:0}.checkout-complete__license-files-list__item:hover{z-index:1}.checkout-complete__license-files-list__item:hover .checkout-complete__license-files-list__item__background{-webkit-transform:scale(1.1) translateY(-2%);-ms-transform:scale(1.1) translateY(-2%);transform:scale(1.1) translateY(-2%)}.checkout-complete__license-files-list__item:hover .checkout-complete__license-files-list__item__icon{-webkit-transform:scale(1.1) translate(-50%,-50%);-ms-transform:scale(1.1) translate(-50%,-50%);transform:scale(1.1) translate(-50%,-50%)}.checkout-complete__license-files-list__item:hover .checkout-complete__license-files-list__item__title{-webkit-transform:translateY(-24px);-ms-transform:translateY(-24px);transform:translateY(-24px)}.checkout-complete__license-files-list__item:hover .checkout-complete__license-files-list__item__actions{opacity:1;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition-delay:.25s;-o-transition-delay:.25s;transition-delay:.25s}.checkout-complete__content--error{color:#b1b8c4;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.checkout-complete__content--error .icon{height:64px;width:64px;margin:0 auto}.checkout-complete__content--error .icon svg{height:100%;width:100%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/CheckoutComplete/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA4GA,qCAvCE,8BAAyE,oBA0CvE,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,kBACJ,UACR,yBACV,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,cACT,mBClF+B,CDoF9C,0BAKC,eAAgB,CACjB,6BE5CC,cFgDA,kBC9F6C,CD+F9C,uCAGC,gBAAgB,mBAEhB,UAAU,oBACV,oBAAA,YAAa,CAIb,6CGnDsB,kBFtDuB,iBAAA,aAAA,YD6G3C,8DAAA,qDAAsD,CAJvD,yDAMkB,sCAAA,kCAAA,6BAA8B,CANhD,0DAOkB,uCAAA,mCAAA,+BAA+B,6BAAE,oBAAsB,CAPzE,0DAQkB,qCAAA,iCAAA,6BAA6B,4BAAE,mBAAqB,CAAE,qCAGrE,GACE,4BAAA,mBAAoB,CAAA,GAGpB,2BAAA,kBAAmB,CAAA,CALvB,6BACE,GACE,4BAAA,mBAAoB,CAAA,GAGpB,2BAAA,kBAAmB,CAAA,CAfxB,oDIlGH,kBJ2HgC,MAAG,QAAA,SAAA,OAAA,sDKhKsB,8CLkKnD,UAAW,CACZ,yDI9HL,kBJiIgC,MAAG,QAAA,SAAA,OAAA,sBEzIvB,kBF4IN,kDAAA,6CAAA,yCMxJqD,CNyJtD,mDIrIL,kBJwIgC,QAAK,SAAc,cAE7C,uCAAA,mCAAA,+BAAgC,gDAChC,2CAAA,uCM/JqD,CNgKtD,oDI5IL,kBJ+IgC,SAAS,UAAG,QAAG,mCACzC,+BAAA,2BAA2B,sDAC3B,iDAAA,6CAAmC,CACpC,sDIlJL,kBJqJgC,SAAS,SAAE,QAAG,gCACxC,wBAAwB,kDACxB,6CAAA,0CACA,SAAU,CAtDb,mDA0DG,SAAU,CA1Db,4GA8DG,6CAAA,yCAAA,oCAAqC,CA9DxC,sGAkEG,kDAAA,8CAAA,yCAA2C,CAlE9C,uGAsEG,oCAAA,gCAAA,2BAAmC,CAtEtC,yGA0EG,UAAU,mCACV,+BAAA,2BAA2B,8BAC3B,yBAAA,qBAAsB,CACvB,mCExIH,cF8IA,WAAW,oBACX,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,iBACD,CAPnB,yCOlLC,YNR6C,WDqM3C,aAAc,CAXjB,6COlLC,YP+LsB,UAAA,CACnB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CheckoutCompletePage Component\n */\n\n.page--checkout-complete{\n  .page__main{\n    @include page-is-at-least-full-height(-$page-header-height);\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    width: 90%;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    padding-bottom: baseline(8);\n  }\n}\n\n.checkout-complete{\n  &__title{\n    margin-bottom: 0;\n  }\n\n  &__subtitle{\n    @include textcolor(bw6);\n    margin-bottom: baseline(4);\n  }\n\n  &__license-files-list{\n    list-style: none;\n    margin: baseline(4) 0 baseline(6);\n    padding: 0;\n    display: flex;\n\n    // perspective: 2000px;\n\n    &__item{\n      @include margin(null baseline(2));\n      @include size(baseline(27) baseline(36));\n\n      animation: show-license-file .5s ease-in-out backwards;\n\n      &:nth-child(1) { transform-origin: center right; }\n      &:nth-child(2) { transform-origin: center center; animation-delay: .15s }\n      &:nth-child(3) { transform-origin: center left; animation-delay: .3s }\n\n      @keyframes show-license-file {\n        0% {\n          transform: scale(.5);\n        }\n        100% {\n          transform: scale(1);\n        }\n      }\n\n      // &:nth-child(1) &__background{ transform-origin: right }\n      // &:nth-child(1) &__icon{ transform-origin: right }\n      // &:nth-child(3) &__background{ transform-origin: left }\n      // &:nth-child(3) &__icon{ transform-origin: left }\n\n      &::before{\n        @include position(absolute, 0);\n        @include shadow(large);\n        content: \"\";\n      }\n\n      &__background{\n        @include position(absolute, 0);\n        @include bgcolor(white);\n        @include bgsize(medium);\n        transition: .35s $ease-out-expo;\n      }\n\n      &__icon{\n        @include position(absolute, 42% null null 50%);\n        @include textcolor(bw4);\n        transform: translate(-50%, -50%);\n        transition: 2s $ease-out-expo;\n      }\n\n      &__title{\n        @include position(absolute, null 5% 8% 5%);\n        transform: translateY(-50%);\n        transition: .35s $ease-out-expo .1s;\n      }\n\n      &__actions{\n        @include position(absolute, null 5% 0 5%);\n        transform: translateZ(0);\n        transition: .35s $ease-out-expo;\n        opacity: 0;\n      }\n\n      &:hover{\n        z-index: 1;\n      }\n\n      &:hover &__background{\n        transform: scale(1.1) translateY(-2%);\n      }\n\n      &:hover &__icon{\n        transform: scale(1.1) translate(-50%, -50%);\n      }\n\n      &:hover &__title{\n        transform: translateY(baseline(-3));\n      }\n\n      &:hover &__actions{\n        opacity: 1;\n        transform: translateY(-50%);\n        transition-delay: .25s;\n      }\n    }\n  }\n\n  &__content--error{\n    @include textcolor(bw6);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    .icon{\n      @include size(baseline(8));\n      margin: 0 auto;\n      svg{\n        @include size(100%);\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 8ac1bd9be88ba3b691cda75f1edf6a5e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type order_viewer$ref = any;
export type order_QueryVariables = {|
  invoice_number?: ?number,
  isDefaultRoute: boolean,
|};
export type order_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: order_viewer$ref,
  |},
|};
*/

/*
query order_Query(
  $invoice_number: Int
  $isDefaultRoute: Boolean!
) {
  viewer {
    ...order_viewer
    id
  }
}

fragment order_viewer on Viewer {
  my_orders {
    id
    currency_code
    currency_rate
    invoice_number
    order_date
    payment_due_date
    payment_status
    total
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
  }
  order(invoice_number: $invoice_number) @skip(if: $isDefaultRoute) {
    id
    currency_code
    currency_rate
    discount
    invoice_number
    order_date
    payment_due_date
    payment_received_date
    payment_status
    subtotal
    total
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    general_line_items {
      id
      description
      amount
      discount_amount
    }
    promo_code_line_item {
      id
      code
      discount_type
      discount_type_amount
    }
    tax_line_items {
      id
      priority
      tax_name
      rate
      amount
    }
    licensee_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    billing_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
    authorized_representative {
      name
      email
      phone
      role_id
      role {
        id
        name
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "invoice_number",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "isDefaultRoute",
    "type": "Boolean!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_code",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_rate",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "invoice_number",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "order_date",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_due_date",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_status",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "total",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "project_details",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectDetails",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "brand",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "product",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "reference",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "po_number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }]
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v14, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = [v1, v16],
      v18 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v1, v16, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v17
  }, v14, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "order_Query",
    "id": null,
    "text": "query order_Query(\n  $invoice_number: Int\n  $isDefaultRoute: Boolean!\n) {\n  viewer {\n    ...order_viewer\n    id\n  }\n}\n\nfragment order_viewer on Viewer {\n  my_orders {\n    id\n    currency_code\n    currency_rate\n    invoice_number\n    order_date\n    payment_due_date\n    payment_status\n    total\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n  }\n  order(invoice_number: $invoice_number) @skip(if: $isDefaultRoute) {\n    id\n    currency_code\n    currency_rate\n    discount\n    invoice_number\n    order_date\n    payment_due_date\n    payment_received_date\n    payment_status\n    subtotal\n    total\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    general_line_items {\n      id\n      description\n      amount\n      discount_amount\n    }\n    promo_code_line_item {\n      id\n      code\n      discount_type\n      discount_type_amount\n    }\n    tax_line_items {\n      id\n      priority\n      tax_name\n      rate\n      amount\n    }\n    licensee_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    billing_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n    authorized_representative {\n      name\n      email\n      phone\n      role_id\n      role {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "order_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "order_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "order_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "my_orders",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": true,
          "selections": [v1, v2, v3, v4, v5, v6, v7, v8, v9]
        }, v1, {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isDefaultRoute",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": [{
              "kind": "Variable",
              "name": "invoice_number",
              "variableName": "invoice_number",
              "type": "Int"
            }],
            "concreteType": "Order",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "subtotal",
              "args": null,
              "storageKey": null
            }, v1, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount",
              "args": null,
              "storageKey": null
            }, v4, v5, v6, {
              "kind": "ScalarField",
              "alias": null,
              "name": "payment_received_date",
              "args": null,
              "storageKey": null
            }, v7, v2, v8, {
              "kind": "LinkedField",
              "alias": null,
              "name": "license_line_items",
              "storageKey": null,
              "args": null,
              "concreteType": "LicenseLineItem",
              "plural": true,
              "selections": [v1, v10, v11, {
                "kind": "LinkedField",
                "alias": null,
                "name": "track",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [v1, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "added_to_cart",
                  "args": null,
                  "storageKey": null
                }, v13, v15, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artist",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Artist",
                  "plural": false,
                  "selections": [v1, v16, v13, v15]
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTerm",
                      "plural": false,
                      "selections": [v1, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_highlighted",
                        "args": null,
                        "storageKey": null
                      }, v16, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "parent_id",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "taxonomy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Taxonomy",
                        "plural": false,
                        "selections": [v1, v12, v16]
                      }]
                    }]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "license",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicense",
                "plural": false,
                "selections": [v1, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "usages",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsage",
                  "plural": true,
                  "selections": [v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "license_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "air_date",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "components",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StandardLicenseUsageComponent",
                    "plural": true,
                    "selections": [v1, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "component_id",
                      "args": null,
                      "storageKey": null
                    }, v16, v14]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "general_line_items",
              "storageKey": null,
              "args": null,
              "concreteType": "GeneralLineItem",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v10, v11]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "promo_code_line_item",
              "storageKey": null,
              "args": null,
              "concreteType": "PromoCodeLineItem",
              "plural": false,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount_type",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount_type_amount",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "tax_line_items",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxLineItem",
              "plural": true,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "priority",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "tax_name",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "rate",
                "args": null,
                "storageKey": null
              }, v10]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "licensee_address",
              "storageKey": null,
              "args": null,
              "concreteType": "OrderAddress",
              "plural": false,
              "selections": v18
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "billing_address",
              "storageKey": null,
              "args": null,
              "concreteType": "OrderAddress",
              "plural": false,
              "selections": v18
            }, v9, {
              "kind": "LinkedField",
              "alias": null,
              "name": "authorized_representative",
              "storageKey": null,
              "args": null,
              "concreteType": "AuthorizedRepresentative",
              "plural": false,
              "selections": [v16, {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "role",
                "storageKey": null,
                "args": null,
                "concreteType": "RepresentativeRole",
                "plural": false,
                "selections": v17
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '413235e38e764921e234c0c8dc999721';
module.exports = node;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 660c4996f1aba47af8f3363c1fa25f3e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type orderList_viewer$ref = any;
export type orderList_QueryVariables = {| |};
export type orderList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: orderList_viewer$ref,
  |},
|};
*/

/*
query orderList_Query {
  viewer {
    ...orderList_viewer
    id
  }
}

fragment orderList_viewer on Viewer {
  my_orders {
    id
    currency_code
    currency_rate
    invoice_number
    order_date
    payment_due_date
    payment_status
    total
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "orderList_Query",
    "id": null,
    "text": "query orderList_Query {\n  viewer {\n    ...orderList_viewer\n    id\n  }\n}\n\nfragment orderList_viewer on Viewer {\n  my_orders {\n    id\n    currency_code\n    currency_rate\n    invoice_number\n    order_date\n    payment_due_date\n    payment_status\n    total\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "orderList_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "orderList_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "orderList_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "my_orders",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": true,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency_rate",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "invoice_number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "order_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_due_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "project_details",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectDetails",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "brand",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "product",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "reference",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "po_number",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "notes",
              "args": null,
              "storageKey": null
            }]
          }]
        }, v0]
      }]
    }
  };
}();
node /*: any*/.hash = '81c0c6aa1deec5c6cc0baa75fcf89c6e';
module.exports = node;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type orderListNode$ref: FragmentReference;
export type orderListNode = {|
  +id: string,
  +currency_code: ?string,
  +currency_rate: ?number,
  +invoice_number: ?number,
  +order_date: ?any,
  +payment_due_date: ?any,
  +payment_status: ?OrderPaymentStatus,
  +total: ?number,
  +project_details: ?{|
    +brand: ?string,
    +product: ?string,
    +reference: ?string,
    +po_number: ?string,
    +notes: ?string,
  |},
  +$refType: orderListNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "orderListNode",
  "type": "Order",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_rate",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "invoice_number",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "order_date",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_due_date",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_status",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "total",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "project_details",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectDetails",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "brand",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "product",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "reference",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "po_number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }]
  }]
};
node /*: any*/.hash = '4d7b3dbe197364bdc1bb219627198d0e';
module.exports = node;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type orderNode$ref: FragmentReference;
export type orderNode = {|
  +id: string,
  +currency_code: ?string,
  +currency_rate: ?number,
  +discount: ?number,
  +invoice_number: ?number,
  +order_date: ?any,
  +payment_due_date: ?any,
  +payment_received_date: ?any,
  +payment_status: ?OrderPaymentStatus,
  +subtotal: ?number,
  +total: ?number,
  +license_line_items: ?$ReadOnlyArray<?{|
    +id: string,
    +amount: ?number,
    +discount_amount: ?number,
    +track: ?{|
      +id: string,
      +internal_id: ?number,
      +title: ?string,
      +added_to_cart: ?boolean,
      +slug: ?string,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +id: string,
        +name: ?string,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +internal_id: ?number,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |},
    +license: ?{|
      +id: string,
      +usages: ?$ReadOnlyArray<?{|
        +id: string,
        +license_id: ?number,
        +air_date: ?any,
        +components: ?$ReadOnlyArray<?{|
          +id: string,
          +component_id: ?number,
          +name: ?string,
          +type: ?string,
        |}>,
      |}>,
    |},
  |}>,
  +general_line_items: ?$ReadOnlyArray<?{|
    +id: string,
    +description: ?string,
    +amount: ?number,
    +discount_amount: ?number,
  |}>,
  +promo_code_line_item: ?{|
    +id: string,
    +code: ?string,
    +discount_type: ?PromoCodeDiscountType,
    +discount_type_amount: ?number,
  |},
  +tax_line_items: ?$ReadOnlyArray<?{|
    +id: string,
    +priority: ?number,
    +tax_name: ?string,
    +rate: ?number,
    +amount: ?number,
  |}>,
  +licensee_address: ?{|
    +id: string,
    +type: OrderAddressType,
    +name: string,
    +company: ?string,
    +company_type_id: ?string,
    +company_type: ?{|
      +id: string,
      +name: ?string,
    |},
    +line_1: string,
    +line_2: ?string,
    +city: string,
    +postal_code: string,
    +subdivision_code: string,
    +country_code: string,
  |},
  +billing_address: ?{|
    +id: string,
    +type: OrderAddressType,
    +name: string,
    +company: ?string,
    +company_type_id: ?string,
    +company_type: ?{|
      +id: string,
      +name: ?string,
    |},
    +line_1: string,
    +line_2: ?string,
    +city: string,
    +postal_code: string,
    +subdivision_code: string,
    +country_code: string,
  |},
  +project_details: ?{|
    +brand: ?string,
    +product: ?string,
    +reference: ?string,
    +po_number: ?string,
    +notes: ?string,
  |},
  +authorized_representative: ?{|
    +name: ?string,
    +email: ?string,
    +phone: ?string,
    +role_id: ?string,
    +role: ?{|
      +id: string,
      +name: ?string,
    |},
  |},
  +$refType: orderNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v8 = [v0, v7],
      v9 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v0, v7, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v8
  }, v5, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "orderNode",
    "type": "Order",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "subtotal",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_rate",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "discount",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "invoice_number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "order_date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_due_date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_received_date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_status",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_code",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "total",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseLineItem",
      "plural": true,
      "selections": [v0, v1, v2, {
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [v0, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v4, v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [v0, v7, v4, v6]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v7, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v0, v3, v7]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license",
        "storageKey": null,
        "args": null,
        "concreteType": "StandardLicense",
        "plural": false,
        "selections": [v0, {
          "kind": "LinkedField",
          "alias": null,
          "name": "usages",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicenseUsage",
          "plural": true,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "license_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "air_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "components",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsageComponent",
            "plural": true,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "component_id",
              "args": null,
              "storageKey": null
            }, v7, v5]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "general_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "GeneralLineItem",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }, v1, v2]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "promo_code_line_item",
      "storageKey": null,
      "args": null,
      "concreteType": "PromoCodeLineItem",
      "plural": false,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount_type",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "discount_type_amount",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "tax_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxLineItem",
      "plural": true,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "priority",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "tax_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "rate",
        "args": null,
        "storageKey": null
      }, v1]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "licensee_address",
      "storageKey": null,
      "args": null,
      "concreteType": "OrderAddress",
      "plural": false,
      "selections": v9
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "billing_address",
      "storageKey": null,
      "args": null,
      "concreteType": "OrderAddress",
      "plural": false,
      "selections": v9
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "project_details",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectDetails",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "brand",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "product",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "reference",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "po_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "authorized_representative",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthorizedRepresentative",
      "plural": false,
      "selections": [v7, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "phone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "role_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "role",
        "storageKey": null,
        "args": null,
        "concreteType": "RepresentativeRole",
        "plural": false,
        "selections": v8
      }]
    }]
  };
}();
node /*: any*/.hash = '4552c33d650dd9a3d914459a14c1d205';
module.exports = node;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type orderList_viewer$ref: FragmentReference;
export type orderList_viewer = {|
  +my_orders: ?$ReadOnlyArray<?{|
    +id: string,
    +currency_code: ?string,
    +currency_rate: ?number,
    +invoice_number: ?number,
    +order_date: ?any,
    +payment_due_date: ?any,
    +payment_status: ?OrderPaymentStatus,
    +total: ?number,
    +project_details: ?{|
      +brand: ?string,
      +product: ?string,
      +reference: ?string,
      +po_number: ?string,
      +notes: ?string,
    |},
  |}>,
  +$refType: orderList_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "orderList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "my_orders",
    "storageKey": null,
    "args": null,
    "concreteType": "Order",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_code",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_rate",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "invoice_number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "order_date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_due_date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_status",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "total",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "project_details",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectDetails",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "brand",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "product",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "reference",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "po_number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }]
};
node /*: any*/.hash = '113a8a18c357284024698fb3526b16d4';
module.exports = node;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type order_viewer$ref: FragmentReference;
export type order_viewer = {|
  +my_orders: ?$ReadOnlyArray<?{|
    +id: string,
    +currency_code: ?string,
    +currency_rate: ?number,
    +invoice_number: ?number,
    +order_date: ?any,
    +payment_due_date: ?any,
    +payment_status: ?OrderPaymentStatus,
    +total: ?number,
    +project_details: ?{|
      +brand: ?string,
      +product: ?string,
      +reference: ?string,
      +po_number: ?string,
      +notes: ?string,
    |},
  |}>,
  +order?: ?{|
    +id: string,
    +currency_code: ?string,
    +currency_rate: ?number,
    +discount: ?number,
    +invoice_number: ?number,
    +order_date: ?any,
    +payment_due_date: ?any,
    +payment_received_date: ?any,
    +payment_status: ?OrderPaymentStatus,
    +subtotal: ?number,
    +total: ?number,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +general_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +description: ?string,
      +amount: ?number,
      +discount_amount: ?number,
    |}>,
    +promo_code_line_item: ?{|
      +id: string,
      +code: ?string,
      +discount_type: ?PromoCodeDiscountType,
      +discount_type_amount: ?number,
    |},
    +tax_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +priority: ?number,
      +tax_name: ?string,
      +rate: ?number,
      +amount: ?number,
    |}>,
    +licensee_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +billing_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +project_details: ?{|
      +brand: ?string,
      +product: ?string,
      +reference: ?string,
      +po_number: ?string,
      +notes: ?string,
    |},
    +authorized_representative: ?{|
      +name: ?string,
      +email: ?string,
      +phone: ?string,
      +role_id: ?string,
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
    |},
  |},
  +$refType: order_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_code",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "currency_rate",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "invoice_number",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "order_date",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_due_date",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "payment_status",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "total",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "project_details",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectDetails",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "brand",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "product",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "reference",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "po_number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "discount_amount",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v13, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v16 = [v0, v15],
      v17 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, v0, v15, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v16
  }, v13, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "order_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "invoice_number",
      "type": "Int"
    }, {
      "kind": "RootArgument",
      "name": "isDefaultRoute",
      "type": "Boolean"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "my_orders",
      "storageKey": null,
      "args": null,
      "concreteType": "Order",
      "plural": true,
      "selections": [v0, v1, v2, v3, v4, v5, v6, v7, v8]
    }, {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isDefaultRoute",
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": [{
          "kind": "Variable",
          "name": "invoice_number",
          "variableName": "invoice_number",
          "type": "Int"
        }],
        "concreteType": "Order",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "subtotal",
          "args": null,
          "storageKey": null
        }, v0, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount",
          "args": null,
          "storageKey": null
        }, v3, v4, v5, {
          "kind": "ScalarField",
          "alias": null,
          "name": "payment_received_date",
          "args": null,
          "storageKey": null
        }, v6, v1, v7, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "LicenseLineItem",
          "plural": true,
          "selections": [v0, v9, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "track",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResult",
            "plural": false,
            "selections": [v0, v11, {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "added_to_cart",
              "args": null,
              "storageKey": null
            }, v12, v14, {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [v0, v15, v12, v14]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTerm",
                  "plural": false,
                  "selections": [v0, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_highlighted",
                    "args": null,
                    "storageKey": null
                  }, v15, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "parent_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "taxonomy",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Taxonomy",
                    "plural": false,
                    "selections": [v0, v11, v15]
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicense",
            "plural": false,
            "selections": [v0, {
              "kind": "LinkedField",
              "alias": null,
              "name": "usages",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsage",
              "plural": true,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "license_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "air_date",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "components",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicenseUsageComponent",
                "plural": true,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "component_id",
                  "args": null,
                  "storageKey": null
                }, v15, v13]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "general_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "GeneralLineItem",
          "plural": true,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, v9, v10]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "promo_code_line_item",
          "storageKey": null,
          "args": null,
          "concreteType": "PromoCodeLineItem",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "discount_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "discount_type_amount",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tax_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxLineItem",
          "plural": true,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "priority",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "tax_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "rate",
            "args": null,
            "storageKey": null
          }, v9]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "licensee_address",
          "storageKey": null,
          "args": null,
          "concreteType": "OrderAddress",
          "plural": false,
          "selections": v17
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "billing_address",
          "storageKey": null,
          "args": null,
          "concreteType": "OrderAddress",
          "plural": false,
          "selections": v17
        }, v8, {
          "kind": "LinkedField",
          "alias": null,
          "name": "authorized_representative",
          "storageKey": null,
          "args": null,
          "concreteType": "AuthorizedRepresentative",
          "plural": false,
          "selections": [v15, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "role_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "role",
            "storageKey": null,
            "args": null,
            "concreteType": "RepresentativeRole",
            "plural": false,
            "selections": v16
          }]
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = 'e555601b865a8109db0d5da399ecca48';
module.exports = node;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1576);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@media print{.page--orders .order-list__wrapper{display:none}.page--orders .order-view{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.page--orders .order-view__nav{display:none}.page--orders .order-view__document{-webkit-box-shadow:none;box-shadow:none;-webkit-box-flex:1;-ms-flex:auto;flex:auto;margin:0}.page--orders .order-view__document .thumbnail{display:none}.page--orders .order-view__document__content{padding:0 8px}}.orders__loading-progress{position:fixed;top:120px;z-index:2}.orders__error-message{position:absolute;top:calc(50% - 60px);padding-right:64px;padding-left:64px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);text-align:center}.orders__error-message--no-order{left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.orders__error-message:not(.orders__error-message--no-order){width:75%;max-width:calc(100% - 320px);margin-left:auto;right:0}.orders__content-wrapper{min-height:calc(100vh - 120px);display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden}@media only screen{.orders__content-wrapper .order-list__wrapper{position:fixed;top:120px;bottom:0;left:0;width:25%;min-width:320px}.app-wrapper[data-player-visibility=true] .orders__content-wrapper .order-list__wrapper{bottom:56px}.app-wrapper[data-player-term-list-visibility=true] .orders__content-wrapper .order-list__wrapper{bottom:136px}.orders__content-wrapper .order-view{width:75%;max-width:calc(100% - 320px);margin-left:auto}}.orders__track-details-wrapper .track-details{margin:16px;width:320px;height:calc(100% - 32px)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Orders/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AA6GE,aADF,mCAGM,YAAa,CAHnB,0BAWM,mBAAA,cAAA,SAAU,CAXhB,+BAcQ,YAAa,CAdrB,oCAkBQ,wBAAA,gBAAgB,mBAChB,cAAA,UAAU,QACD,CApBjB,+CAuBU,YAAa,CAvBvB,6CA2BU,aCpGuC,CDqGxC,CAAA,0BAWL,eAAe,UAlGsD,SAoG3D,CACX,uBE5GD,kBF+G4B,qBAA+C,mBCtH5B,kBDwH7C,mCAAA,+BAAA,2BAA2B,iBACT,CAElB,iCACE,SAAS,uCACT,mCAAA,8BAAgC,CARnC,6DAxED,UAA0B,6BACiB,iBAC1B,OAmFL,CACT,yBAjGH,+BAAyE,oBAsGvE,oBAAA,aAAa,eACG,CAEhB,mBALD,8CE/HD,eF+BuB,UAxBgD,SAwBX,OAAE,UAG9D,eCzC+C,CDwB/C,wFACE,WAAwC,CACzC,kGAGC,YAAuD,CACxD,qCAeD,UAA0B,6BACiB,gBAC1B,CAkGZ,CAAA,8CAMD,YACA,YACA,wBAAmC,CACpC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * OrdersPage Component\n */\n\n.page--orders{\n  @media print {\n    .order-list__wrapper{\n      display: none;\n    }\n\n    // .orders__content-wrapper{\n    //   height: 100%;\n    // }\n\n    .order-view{\n      flex: auto;\n\n      &__nav{\n        display: none;\n      }\n\n      &__document{\n        box-shadow: none;\n        flex: auto;\n        margin: 0;\n\n        .thumbnail{\n          display: none;\n        }\n\n        &__content{\n          padding: 0 baseline(1);\n        }\n      }\n    }\n  }\n}\n\n.orders{\n  $order-list-width: 25%;\n  $order-list-min-width: baseline(40);\n\n  &__loading-progress{\n    position: fixed;\n    top: $page-with-header-margin-top;\n    z-index: 2;\n  }\n\n  &__error-message{\n    @include position(absolute, calc(50% - #{$page-with-header-margin-top/2}) null null null);\n    @include padding(null baseline(8));\n    transform: translateY(-50%);\n    text-align: center;\n\n    &--no-order{\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &:not(&--no-order) {\n      @include page-with-aside-content($order-list-width, $order-list-min-width);\n      right: 0;\n    }\n  }\n\n  &__content-wrapper{\n    @include page-is-at-least-full-height;\n    display: flex;\n    overflow: hidden;\n\n    @media only screen {\n      .order-list__wrapper{\n        @include page-aside($order-list-width, $order-list-min-width);\n      }\n      .order-view{\n        @include page-with-aside-content($order-list-width, $order-list-min-width);\n      }\n    }\n  }\n\n  &__track-details-wrapper {\n    .track-details {\n      margin: baseline(2);\n      width: baseline(40);\n      height: calc(100% - #{baseline(4)});\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1578);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--not-authorized .page__main{min-height:calc(100vh - 64px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-bottom:32px}.not-authorized__error-message{text-align:center;margin:32px auto}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/NotAuthorized/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,kCAvCE,8BAAyE,oBA0CvE,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,mBC/E0B,CDiF9C,+BAKC,kBAAkB,gBACM,CACzB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * NotAuthorized Page\n */\n\n.page--not-authorized{\n  .page__main {\n    @include page-is-at-least-full-height(-$page-header-height);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: baseline(4);\n  }\n}\n\n.not-authorized{\n  &__error-message{\n    text-align: center;\n    margin: baseline(4) auto;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * OrderList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var animation_1 = __webpack_require__(173);
var date_1 = __webpack_require__(119);
__webpack_require__(1580);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
var OrderButton_1 = __webpack_require__(1582);
var OrderListAnimation = animation_1.ListItemAnimations(128);
var classes = new BEM('order-list');

var OrderList = function (_React$Component) {
    _inherits(OrderList, _React$Component);

    function OrderList() {
        _classCallCheck(this, OrderList);

        return _possibleConstructorReturn(this, (OrderList.__proto__ || Object.getPrototypeOf(OrderList)).apply(this, arguments));
    }

    _createClass(OrderList, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ul", enter: { animation: OrderListAnimation.In, stagger: 150 }, leave: { animation: OrderListAnimation.Out } }, classes()), this.props.orders.map(function (order, index) {
                /* tslint:disable-next-line */
                var title = "#" + order.invoice_number + " | " + order.project_details.brand + " \u2022 " + order.project_details.product;
                var subtitle = order.order_date ? date_1.getFormattedDateFromGraphQL(order.order_date) : '';
                return React.createElement("li", Object.assign({ key: order.id }, classes('item')), React.createElement(OrderButton_1.default, { id: "" + order.invoice_number, title: title, subtitle: subtitle, onSelect: function onSelect() {
                        return _this2.props.onSelectOrder("" + order.invoice_number);
                    }, isPastDue: date_1.isPastDue(order.payment_due_date) && order.payment_status !== 'PaymentReceived' }));
            })));
        }
    }]);

    return OrderList;
}(React.Component);

var ConnectedOrderList = react_redux_1.connect()(OrderList);
exports.default = ConnectedOrderList;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1581);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-list.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".order-list{margin:0;padding:8px 32px 48px 16px;list-style:none}html.touchevents .order-list__wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .order-list__wrapper{overflow-x:hidden;overflow-y:auto}.order-list__item{-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed;padding:8px 0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Orders/order-list.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,YACE,SAAS,2BAET,eAAgB,CAUjB,sCC5GG,kBAAgD,kBACT,gCACN,CAClC,yCAEC,kBAAgD,eACX,CDkGvC,kBACE,iCAAA,yBACA,aAAsB,CACvB","file":"order-list.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * OrderList Component\n */\n\n.order-list{\n  margin: 0;\n  padding: baseline(1) baseline(4) baseline(6) baseline(2);\n  list-style: none;\n\n  &__wrapper{\n    @include scroll;\n  }\n\n  &__item{\n    box-shadow: 0 1px uicolor(border);\n    padding: baseline(1) 0;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * OrderButton Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
__webpack_require__(1583);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var _1 = __webpack_require__(302);
var classes = new BEM({ name: 'order-button', outputIsString: true });
function OrderButton(props) {
  return React.createElement(found_1.Link, { to: router_1.linkWithCurrentQueryString(_1.OrderPagePath(props.id)), activeClassName: classes('', 'active'), className: classes(), onClick: props.onSelect }, props.isPastDue ? React.createElement(Icon_1.IconWarningLarge, { className: classes('icon', 'warning') }) : React.createElement(Icon_1.IconTermsLarge, { className: classes('icon') }), React.createElement("div", { className: classes('info') }, React.createElement(Heading_1.default, { is: "h5", text: props.title, maxTextLength: 25, noMargin: true, className: classes('title') }), React.createElement(Label_1.Span, { variant: "note", size: "medium", className: classes('subtitle') }, props.subtitle)));
}
var OrderedProjectButton = react_redux_1.connect()(OrderButton);
exports.default = OrderedProjectButton;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1584);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-button.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".order-button{color:#101015;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:32px;height:112px;overflow:hidden;-webkit-transform:scale(.96);-ms-transform:scale(.96);transform:scale(.96)}.order-button,.order-button__info{-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.order-button__info{margin-left:16px;-webkit-transform:translateY(8px);-ms-transform:translateY(8px);transform:translateY(8px)}.order-button__subtitle{display:block;opacity:0;margin-top:2px}.order-button__icon{-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-transform:scale(1.041666667);-ms-transform:scale(1.041666667);transform:scale(1.041666667)}.order-button__icon--warning{color:#f75b5b}.order-button:not(.order-button--active){cursor:pointer}.order-button--active,.order-button:hover{background-color:#fff;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);border-radius:8px}.order-button--active,.order-button--active .order-button__info,.order-button:hover,.order-button:hover .order-button__info{-webkit-transform:none;-ms-transform:none;transform:none}.order-button--active .order-button__subtitle,.order-button:hover .order-button__subtitle{opacity:1}.order-button--active .order-button__icon,.order-button:hover .order-button__icon{-webkit-transform:none;-ms-transform:none;transform:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Orders/order-button.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,cC3BI,cD6BF,qBAAqB,oBACrB,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kBAEnB,aACA,gBAAgB,6BAEhB,yBAAA,oBAAqB,CAErB,kCAHA,0DAAA,qDAAA,iDE5F2D,CF+F3D,oBACE,iBAEA,kCAAA,8BAAA,yBAAkC,CACnC,wBAGC,cAAc,UACJ,cG5FmC,CH8F9C,oBAGC,oCAAA,+BAAA,4BAA4B,qCAC5B,iCAAA,4BAA6B,CAE7B,6BCtDA,aAhEsB,CD2F1B,yCAiCI,cAAe,CAChB,0CCrEC,sBAvCU,sDG7B6C,8CAAA,iBCQrC,CLwInB,4HADC,uBAAA,mBAAA,cAAe,CAMhB,0FAIC,SAAU,CACX,kFAIC,uBAAA,mBAAA,cAAe,CAChB","file":"order-button.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * OrderButton Component\n */\n\n.order-button{\n  @include textcolor(dark);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding-left: baseline(4);\n  height: baseline(14);\n  overflow: hidden;\n  transition: .25s $ease-out-back;\n  transform: scale(.96);\n\n  &__info{\n    margin-left: baseline(2);\n    transition: .25s $ease-out-back;\n    transform: translateY(baseline(1));\n  }\n\n  &__subtitle{\n    display: block;\n    opacity: 0;\n    margin-top: baseline(.25);\n  }\n\n  &__icon{\n    transition: .15s ease-in-out;\n    transform: scale(1.041666667);\n\n    &--warning{\n      @include textcolor(dangerous);\n    }\n  }\n\n  &:not(&--active) {\n    cursor: pointer;\n  }\n\n  &--active, &:hover{\n    @include bgcolor(white);\n    @include shadow(medium);\n    @include bgsize(large);\n    transform: none;\n  }\n\n  &--active &__info,\n  &:hover &__info{\n    transform: none;\n  }\n\n  &--active &__subtitle,\n  &:hover &__subtitle{\n    opacity: 1;\n  }\n\n  &--active &__icon,\n  &:hover &__icon{\n    transform: none;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * OrderView Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1586);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Invoice_1 = __webpack_require__(1588);
var License_1 = __webpack_require__(1597);
var OrderFileList_1 = __webpack_require__(1600);
var classes = new BEM('order-view');

var OrderView = function (_React$Component) {
    _inherits(OrderView, _React$Component);

    function OrderView(props) {
        _classCallCheck(this, OrderView);

        var _this = _possibleConstructorReturn(this, (OrderView.__proto__ || Object.getPrototypeOf(OrderView)).call(this, props));

        _this.state = {
            currentDocument: props.defaultDocument || 'invoice'
        };
        return _this;
    }

    _createClass(OrderView, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.order.id !== this.props.order.id) {
                if (!nextProps.order.license_line_items.length && this.state.currentDocument !== 'invoice') {
                    this.setState({ currentDocument: 'invoice' });
                }
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(_, prevState) {
            if (prevState.currentDocument !== this.state.currentDocument) {
                if (this.props.onSwitchDocument) {
                    this.props.onSwitchDocument(this.state.currentDocument);
                }
            }
        }
    }, {
        key: "renderDocument",
        value: function renderDocument() {
            var Component = void 0;
            switch (this.state.currentDocument) {
                case 'license':
                    Component = License_1.default;
                    break;
                case 'music':
                    Component = OrderFileList_1.default;
                    break;
                default:
                    Component = Invoice_1.default;
                    break;
            }
            return React.createElement(Component, { key: this.state.currentDocument, data: this.props.order });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isFetching = _props.isFetching,
                order = _props.order;

            return React.createElement("div", Object.assign({}, classes('', { fetching: !!isFetching })), React.createElement("div", Object.assign({}, classes('nav')), React.createElement(Button_1.default, Object.assign({ label: "Invoice", icon: React.createElement(Icon_1.IconInvoice, null), onClick: function onClick() {
                    return _this2.setState({ currentDocument: 'invoice' });
                }, disabled: isFetching }, classes('nav__button', { active: this.state.currentDocument === 'invoice' }))), !!order.license_line_items.length && React.createElement(React.Fragment, null, React.createElement(Button_1.default, Object.assign({ label: "License", icon: React.createElement(Icon_1.IconTerms, null), onClick: function onClick() {
                    return _this2.setState({ currentDocument: 'license' });
                }, disabled: isFetching }, classes('nav__button', { active: this.state.currentDocument === 'license' }))), React.createElement(Button_1.default, Object.assign({ label: "Files", icon: React.createElement(Icon_1.IconMusicNote, null), onClick: function onClick() {
                    return _this2.setState({ currentDocument: 'music' });
                }, disabled: isFetching }, classes('nav__button', { active: this.state.currentDocument === 'music' }))))), React.createElement("div", Object.assign({}, classes('document')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: {
                    animation: isFetching ? 'transition.shrinkIn' : 'transition.slideUpIn',
                    delay: 250,
                    display: 'block',
                    duration: 250
                }, leave: {
                    animation: 'transition.fadeOut',
                    duration: 150
                } }, classes('document__content')), isFetching ? React.createElement("div", Object.assign({ key: "fetching" }, classes('fetching')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('fetching__title')), "Retrieving order...")) : this.renderDocument())));
        }
    }]);

    return OrderView;
}(React.Component);

exports.default = OrderView;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1587);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-view.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./order-view.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".order-view{-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-ms-flex-line-pack:start;align-content:flex-start}.order-view__document,.order-view__nav{margin-right:56px;margin-left:24px;-webkit-box-flex:0;-ms-flex:0 1 960px;flex:0 1 960px}@media screen and (min-width:2400px){.order-view__document,.order-view__nav{-webkit-box-flex:0;-ms-flex:0 1 51%;flex:0 1 51%}}.order-view__nav{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:16px}.order-view__nav__button--active{background-color:#fff;border-radius:4px 4px 0 0}.order-view__nav__button--active:not([disabled]){background-color:#fff;color:#101015}.order-view__nav__button[disabled]:not(.order-view__nav__button--active){background:transparent}.order-view__document{min-height:calc(100vh - 176px);background-color:#fff;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:32px}.order-view__document__content{padding:32px;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.order-view__fetching{color:#b1b8c4;height:100%;width:100%;min-height:320px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;padding:64px 0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Orders/order-view.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,YAGE,mBAAA,eAAe,oBACf,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,wBACvB,qBAAA,uBAAuB,yBACvB,wBAAyB,CAEzB,uCC5BwB,kBAWA,iBDmBtB,mBAAA,mBAAA,cEpF6C,CFsF7C,qCAJF,uCAKI,mBAAA,iBAAA,YAAa,CAEhB,CAAA,iBAGC,oBAAA,oBAAA,aAAa,eE5FgC,CF+F7C,iCGzDA,sBH2DE,yBAAgD,CACjD,iDG5DD,sBAvCU,aA9BY,CHqIrB,yEAEC,sBAAuB,CACxB,sBAvEH,+BAAyE,sBGnC7D,sDC7B6C,8CJ8IvD,oBAAA,oBAAA,aAAa,kBEhHgC,CFgI7C,+BAEE,aACA,mBAAA,cAAA,SAAU,CACX,sBGtFD,cAxEuB,YHmKL,WAAA,iBAElB,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,kBACD,cACI,CAKvB","file":"order-view.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * OrderView Component\n */\n\n.order-view{\n  $nav-height: baseline(7);\n\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n\n  &__nav, &__document{\n    @include margin(null baseline(7) null baseline(3));\n    flex: 0 1 baseline(120);\n\n    @media screen and (min-width: baseline(300)) {\n      flex: 0 1 51%;\n    }\n  }\n\n  &__nav{\n    display: flex;\n    margin-top: baseline(2);\n\n    &__button--active{\n      @include bgcolor(white);\n      border-radius: radius(medium) radius(medium) 0 0;\n    }\n    &__button--active:not([disabled]) {\n      @include bgcolor(white);\n      @include textcolor(black);\n    }\n    &__button[disabled]:not(&__button--active){\n      background: transparent;\n    }\n  }\n\n  &__document{\n    @include page-is-at-least-full-height($nav-height);\n    @include bgcolor(white);\n    @include shadow(large);\n    display: flex;\n    margin-bottom: baseline(4);\n\n    // &::before{\n    //   content: \"\";\n    //   display: block;\n    //   width: 100%;\n    //   padding-top: 129.4117647%;\n    //   transition: padding-top .35s $ease-in-out-circ;\n\n    //   .order-view--fetching & {\n    //     padding-top: 33.3333%;\n    //     will-change: padding-top;\n    //   }\n    // }\n\n    &__content{\n      // @include position(absolute, 0);\n      padding: baseline(4);\n      flex: auto;\n    }\n  }\n\n  &__fetching{\n    @include textcolor(bw6);\n    @include size(100%);\n    min-height: baseline(40);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: baseline(8) 0;\n\n    &__title{\n      // margin: 0;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Invoice Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var date_1 = __webpack_require__(119);
__webpack_require__(1589);
var React = __webpack_require__(0);
var Label_1 = __webpack_require__(8);
var CheckoutAmounts_1 = __webpack_require__(430);
var PrintableDocument_1 = __webpack_require__(656);
var InvoiceInformation_1 = __webpack_require__(1595);
var InvoiceLineItems_1 = __webpack_require__(1596);
var InvoicePaymentMethods_1 = __webpack_require__(658);

var Invoice = function (_React$Component) {
    _inherits(Invoice, _React$Component);

    function Invoice() {
        _classCallCheck(this, Invoice);

        return _possibleConstructorReturn(this, (Invoice.__proto__ || Object.getPrototypeOf(Invoice)).apply(this, arguments));
    }

    _createClass(Invoice, [{
        key: "renderDate",
        value: function renderDate(date) {
            return date_1.getFormattedDateFromGraphQL(date);
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.data;

            var isPaid = data.payment_status === 'PaymentReceived';
            return React.createElement(PrintableDocument_1.default, { type: "invoice", identification: {
                    title: 'Invoice',
                    subtitle: isPaid ? "Paid on " + this.renderDate(data.payment_received_date) : React.createElement("span", { className: date_1.isPastDue(data.payment_due_date) ? 'color--dangerous' : '' }, "Due date: ", this.renderDate(data.payment_due_date))
                }, title: data.project_details.brand, subtitle: data.project_details.product, metadata: React.createElement(React.Fragment, null, React.createElement(Label_1.Span, { variant: "description", size: "large", textColor: "bw7" }, "Invoice #" + data.invoice_number), React.createElement(Label_1.Span, { variant: "description", size: "large", textColor: "bw7" }, this.renderDate(data.order_date))) }, React.createElement(InvoiceInformation_1.default, { order: data }), React.createElement(InvoiceLineItems_1.default, { order: data }), React.createElement(CheckoutAmounts_1.default, { order: data, context: "invoice" }), !isPaid && React.createElement(InvoicePaymentMethods_1.default, { currency: data.currency_code }));
        }
    }]);

    return Invoice;
}(React.Component);

exports.default = Invoice;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1590);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".invoice__line-items{margin-top:24px;width:100%}.invoice__line-items thead{background-color:#f0f6fa;-webkit-print-color-adjust:exact}.invoice__line-items td,.invoice__line-items th{padding:6px 8px;text-align:left}.invoice__line-items td:not(:last-child),.invoice__line-items th:not(:last-child){border-right:1px solid #e4e8ed}.invoice__line-items td:last-child,.invoice__line-items th:last-child{padding-right:16px;text-align:right}.invoice__line-items tbody tr,.invoice__line-items thead tr{border-bottom:1px solid #e4e8ed}.invoice__line-items td{padding-top:16px;padding-bottom:16px}.invoice__line-item{border-top:1px solid #e4e8ed}.invoice__line-item__description{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.invoice__line-item__info{margin:4px 8px}.invoice__line-item__info__title{margin:0}.invoice__line-item__info__subtitle{display:block}.invoice__line-item__amount{margin-top:4px;margin-bottom:4px}.invoice__line-item__discount-amount{margin-left:8px}.invoice__line-item__amount,.invoice__line-item__usage{margin-left:auto}.invoice__information{padding-top:8px;padding-right:24px;padding-left:8px;display:-webkit-box;display:-ms-flexbox;display:flex}.invoice__information__section:not(.invoice__information__section--project){-webkit-box-flex:2;-ms-flex:2;flex:2}.invoice__information__section--project{-webkit-box-flex:1;-ms-flex:1;flex:1}.invoice .checkout__amounts{-webkit-box-shadow:0 -1px #e4e8ed;box-shadow:0 -1px #e4e8ed}.invoice .checkout__amounts__item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.invoice__payment-methods{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:8px}.invoice__payment-methods__header{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%}.invoice__payment-methods__title{margin-bottom:0}.invoice__payment-methods__item{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-right:32px}.invoice__payment-methods__item__information{background-color:#f0f6fa;min-height:128px;padding:16px;-webkit-print-color-adjust:exact}@media print{.invoice__line-item__info{margin-left:0}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/account/Invoice/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA6GE,qBACE,gBACA,UAAW,CAFZ,2BCpCC,yBD0CE,gCAAiC,CANpC,gDAUG,gBACA,eAAgB,CAXnB,kFAcK,8BChHmB,CDkGxB,sEAkBK,mBACA,gBAAiB,CAnBtB,4DAwBG,+BC1HqB,CDkGxB,wBEzBqB,iBCjDyB,mBAAA,CHuG5C,oBAID,4BCnIuB,CDqIvB,iCACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,0BE5CD,cCpE6C,CHqH3C,iCACE,QAAS,CACV,oCAGC,aAAc,CACf,4BE1EiB,eCjDyB,iBAAA,CHgI5C,qCAGC,eGnI2C,CHoI5C,uDAGC,gBAAiB,CAClB,sBEvFmB,gBCjDyB,mBAAA,iBH6I7C,oBAAA,oBAAA,YAAa,CAEZ,4EAEG,mBAAA,WAAA,MAAO,CACR,wCAEC,mBAAA,WAAA,MAAO,CA3Ef,4BAiFI,kCAAA,yBClLuB,CDiG3B,kCAoFM,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,iCACnB,wBCxLqB,CDyLtB,0BAID,oBAAA,oBAAA,aAAa,mBACb,eAAe,WGtK8B,CHyK7C,kCACE,mBAAA,kBAAA,aAAc,CACf,iCAGC,eAAgB,CACjB,gCAGC,mBAAA,WAAA,OAAO,iBGlLoC,CHqL3C,6CC/IF,yBDiJI,iBACA,aACA,gCAAiC,CAClC,aAKH,0BACE,aAAc,CACf,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Invoice Component\n */\n\n.invoice{\n  &__line-items{\n    margin-top: baseline(3);\n    width: 100%;\n\n    thead{\n      @include bgcolor(bw3);\n      -webkit-print-color-adjust: exact;\n    }\n\n    th, td{\n      padding: baseline(.75) baseline(1);\n      text-align: left;\n\n      &:not(:last-child) {\n        border-right: 1px solid uicolor(border);\n      }\n\n      &:last-child{\n        padding-right: baseline(2);\n        text-align: right;\n      }\n    }\n\n    thead tr, tbody tr{\n      border-bottom: 1px solid uicolor(border);\n    }\n\n    td{\n      @include padding(baseline(2) null);\n    }\n  }\n\n  &__line-item{\n    border-top: 1px solid uicolor(border);\n\n    &__description{\n      display: flex;\n      align-items: center;\n    }\n\n    &__info{\n      @include margin(baseline(.5) baseline(1));\n\n      &__title{\n        margin: 0;\n      }\n\n      &__subtitle{\n        display: block;\n      }\n    }\n\n    &__amount{\n      @include margin(baseline(.5) null);\n    }\n\n    &__discount-amount{\n      margin-left: baseline(1);\n    }\n\n    &__usage, &__amount{\n      margin-left: auto;\n    }\n  }\n\n  &__information{\n    @include padding(baseline(1) baseline(3) null baseline(1));\n    display: flex;\n\n    &__section{\n      &:not(&--project){\n        flex: 2;\n      }\n      &--project{\n        flex: 1;\n      }\n    }\n  }\n\n  .checkout__amounts{\n    box-shadow: 0 -1px uicolor(border);\n\n    &__item{\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      box-shadow: 0 1px uicolor(border);\n    }\n  }\n\n  &__payment-methods{\n    display: flex;\n    flex-wrap: wrap;\n    padding: baseline(1);\n\n    &__header{\n      flex: 0 0 100%;\n    }\n\n    &__title{\n      margin-bottom: 0;\n    }\n\n    &__item{\n      flex: 1;\n      margin-right: baseline(4);\n\n      &__information{\n        @include bgcolor(bw3);\n        min-height: baseline(16);\n        padding: baseline(2);\n        -webkit-print-color-adjust: exact;\n      }\n    }\n  }\n\n  @media print{\n    &__line-item__info {\n      margin-left: 0;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1592);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-amounts.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-amounts.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".checkout__amounts__item__wrapper{position:absolute;top:0;right:0;bottom:0;left:0;padding:12px 16px 12px 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkout__amounts__item__amount{margin-left:auto}.checkout__amounts__item__button-remove{margin-right:-8px;margin-left:8px;color:#b1b8c4}.checkout__amounts__item--promo-code .checkout__amounts__item__background{position:absolute;top:4px;right:-4px;bottom:4px;left:-4px;background-color:#e8faf5;-webkit-filter:blur(5px);filter:blur(5px);-webkit-animation:show-promo-code-background .25s ease-in-out .25s backwards;animation:show-promo-code-background .25s ease-in-out .25s backwards;-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}@-webkit-keyframes show-promo-code-background{0%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);opacity:1}}@keyframes show-promo-code-background{0%{-webkit-transform:scaleX(0);transform:scaleX(0);opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);opacity:1}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/checkout-amounts.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA+GI,kCCrEF,kBDsE8B,MAAG,QAAA,SAAA,OAAA,2BAI7B,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,iCAGC,gBAAiB,CAClB,wCEjCqB,kBCtDuB,gBAAA,aC1BtB,CJsHtB,0ECrFH,kBDwF8B,QCpF1B,WAAA,WAAA,UEX2C,yBHiG3C,yBAAA,iBAAiB,6EAEjB,qEAAqE,8BACrE,0BAAA,qBAAsB,CAEtB,8CACE,GACE,4BAAA,oBAAoB,SACV,CAAA,GAGV,4BAAA,oBAAoB,SACV,CAAA,CAPd,sCACE,GACE,4BAAA,oBAAoB,SACV,CAAA,GAGV,4BAAA,oBAAoB,SACV,CAAA,CAAA","file":"checkout-amounts.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CheckoutAmounts Component\n */\n\n.checkout__amounts{\n  &__item{\n\n    &__wrapper{\n      @include position(absolute, 0);\n      // padding: baseline(2);\n      padding: baseline(1.5) baseline(2) baseline(1.5) baseline(1);\n\n      display: flex;\n      align-items: center;\n    }\n\n    &__amount{\n      margin-left: auto;\n    }\n\n    &__button-remove{\n      @include margin(null baseline(-1) null baseline(1));\n      @include textcolor(bw6);\n    }\n\n    &--promo-code &__background{\n      @include position(absolute, baseline(.5) baseline(-.5) baseline(.5) baseline(-.5));\n      @include bgcolor(positive-subtle);\n      filter: blur(5px);\n\n      animation: show-promo-code-background .25s ease-in-out .25s backwards;\n      transform-origin: left;\n\n      @keyframes show-promo-code-background {\n        0% {\n          transform: scaleX(0);\n          opacity: 0;\n        }\n        100% {\n          transform: scaleX(1);\n          opacity: 1;\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1594);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".document__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;border-bottom:1px solid #e4e8ed;padding-bottom:16px}.document__title{margin-top:0;margin-bottom:8px}.document__subtitle{margin:0}.document__metadata>*{margin-right:24px}.document__identification{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.document__identification__logo{height:38px;width:38px}.document__identification__logo svg{height:100%;width:100%}.document__identification__title{margin:0}.document__identification__subtitle{margin:13px 0 0}.document__footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-top:auto;padding-top:32px}.document__footer__address{-ms-flex-preferred-size:46%;flex-basis:46%}.document__footer p{margin:0 0 0 16px}@media print{@page :blank{@top-center{.document{content:\"This page is intentionally left blank.\"}}}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/account/PrintableDocument/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA6GE,kBACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,wBAC9B,qBAAA,uBAAuB,gCAEvB,mBC/E6C,CDgF9C,iBAGC,aAAa,iBCnFgC,CDqF9C,oBAGC,QAAS,CACV,sBAIG,iBC7F2C,CD8F5C,0BAID,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,sBACtB,mBAAA,oBAAqB,CAErB,gCE9FA,YDR6C,UAAA,CDsG5C,oCE9FD,YFkGsB,UAAA,CACnB,iCAID,QAAS,CACV,oCAGC,eAA2B,CAC5B,kBAID,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,gBACP,gBC1H6B,CD6H7C,2BACE,4BAAA,cAAe,CAPlB,oBAWG,iBClI2C,CDmI5C,aAID,aACE,YA/DL,UA+DmB,gDAAkD,CAGrE,CAAA,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * PrintedDocument Component\n */\n\n .document{\n  &__header{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    border-bottom: 1px solid uicolor(border);\n    padding-bottom: baseline(2);\n  }\n\n  &__title{\n    margin-top: 0;\n    margin-bottom: baseline(1);\n  }\n\n  &__subtitle{\n    margin: 0;\n  }\n\n  &__metadata{\n    & > * {\n      margin-right: baseline(3);\n    }\n  }\n\n  &__identification{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n\n    &__logo{\n      @include size(baseline(4.75));\n\n      svg{\n        @include size(100%);\n      }\n    }\n\n    &__title{\n      margin: 0;\n    }\n\n    &__subtitle{\n      margin: baseline(1.625) 0 0;\n    }\n  }\n\n  &__footer{\n    display: flex;\n    align-items: flex-start;\n    margin-top: auto;\n    padding-top: baseline(4);\n\n    &__address{\n      flex-basis: 46%;\n    }\n\n    p{\n      margin: 0 0 0 baseline(2);\n    }\n  }\n\n  @media print {\n    @page :blank {\n      @top-center { content: \"This page is intentionally left blank.\" }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InvoiceInformation Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(128);
var address_1 = __webpack_require__(232);
var react_1 = __webpack_require__(233);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var config_1 = __webpack_require__(80);
var classes = new BEM('invoice__information');

var InvoiceInformation = function (_React$Component) {
    _inherits(InvoiceInformation, _React$Component);

    function InvoiceInformation() {
        _classCallCheck(this, InvoiceInformation);

        return _possibleConstructorReturn(this, (InvoiceInformation.__proto__ || Object.getPrototypeOf(InvoiceInformation)).apply(this, arguments));
    }

    _createClass(InvoiceInformation, [{
        key: "renderInformation",
        value: function renderInformation(label, value) {
            return value && React.createElement("div", Object.assign({}, classes('item')), React.createElement(Label_1.Span, Object.assign({ size: "medium", textColor: "bw6" }, classes('item__title')), label, ":"), React.createElement(Heading_1.default, { is: "h5", WrappedComponent: "div" }, value));
        }
    }, {
        key: "renderRepresentativeInformation",
        value: function renderRepresentativeInformation() {
            var rep = this.props.order.authorized_representative;
            var str = rep.name + "\n" + rep.role.name + "\n" + rep.email + (rep.phone ? "\n" + rep.phone : "");
            return this.renderInformation('Authorized Representative', react_1.nl2br(str));
        }
    }, {
        key: "renderAddress",
        value: function renderAddress(address) {
            var addressString = address_1.formatAddress(address, this.props.getCountryLabel, this.props.getStateLabel, true);
            return this.renderInformation('Address', react_1.nl2br(addressString));
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.order;

            return React.createElement("section", Object.assign({}, classes()), !!lodash_1.size(data.licensee_address) && React.createElement("section", Object.assign({}, classes('section', 'license')), React.createElement("header", Object.assign({}, classes('section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Licensee Information")), this.renderInformation('Company Name', data.licensee_address.company), this.renderInformation('Company Type', data.licensee_address.company_type.name), this.renderAddress(data.licensee_address), this.renderRepresentativeInformation()), !!lodash_1.size(data.billing_address) ? React.createElement("section", Object.assign({}, classes('section', 'billing')), React.createElement("header", Object.assign({}, classes('section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Billing Information")), this.renderInformation('Company Name', data.billing_address.company), this.renderInformation('Company Type', data.billing_address.company_type.name), this.renderAddress(data.billing_address)) : !!lodash_1.size(data.licensee_address) ? React.createElement("section", Object.assign({}, classes('section', 'billing')), React.createElement("header", Object.assign({}, classes('section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Billing Information")), this.renderInformation('Company Name', data.licensee_address.company), this.renderInformation('Company Type', data.licensee_address.company_type.name), this.renderAddress(data.licensee_address)) : null, !!lodash_1.size(data.project_details) && React.createElement("section", Object.assign({}, classes('section', 'project')), React.createElement("header", Object.assign({}, classes('section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Project Details")), this.renderInformation('Brand', data.project_details.brand || config_1.kCheckoutNoInputLabel), this.renderInformation('Project Title', data.project_details.product || config_1.kCheckoutNoInputLabel), this.renderInformation('Reference', data.project_details.reference), this.renderInformation('PO Number', data.project_details.po_number), this.renderInformation('Notes', data.project_details.notes)));
        }
    }]);

    return InvoiceInformation;
}(React.Component);

var ConnectedInvoiceInformation = react_redux_1.connect(function (state) {
    return {
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        }
    };
})(InvoiceInformation);
exports.default = ConnectedInvoiceInformation;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InvoiceLineItems Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var track_1 = __webpack_require__(44);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var InvoicePriceTag_1 = __webpack_require__(431);
var TableHeader_1 = __webpack_require__(657);
var classes = new BEM('invoice__line-items');
var itemClasses = new BEM('invoice__line-item');

var InvoiceLineItems = function (_React$Component) {
    _inherits(InvoiceLineItems, _React$Component);

    function InvoiceLineItems() {
        _classCallCheck(this, InvoiceLineItems);

        var _this = _possibleConstructorReturn(this, (InvoiceLineItems.__proto__ || Object.getPrototypeOf(InvoiceLineItems)).apply(this, arguments));

        _this.renderLicenseLineItem = function (lineItem) {
            var track = lineItem.track;
            var image = track_1.getResponsiveTrackThumbnail(track);
            var usages = lineItem.license.usages.map(function (_ref) {
                var air_date = _ref.air_date,
                    components = _ref.components;
                return license_1.generateLicenseUsageFromComponents(components, undefined, air_date);
            });
            var licenseString = license_1.getLicenseString(usages);
            return React.createElement("tr", Object.assign({ key: lineItem.id }, itemClasses('', 'license')), React.createElement("td", null, React.createElement("div", Object.assign({}, itemClasses('description')), React.createElement(Thumbnail_1.default, Object.assign({ responsiveAssets: image, size: "xsmall" }, itemClasses('image'))), React.createElement("div", Object.assign({}, itemClasses('info')), React.createElement(Heading_1.default, Object.assign({ is: "h5", text: track.title }, itemClasses('info__title'))), React.createElement(Label_1.Span, Object.assign({ text: track.artist.name, size: "small", textColor: "bw7" }, itemClasses('info__subtitle')))))), React.createElement("td", null, React.createElement(Label_1.Span, Object.assign({ variant: "description", size: "large" }, itemClasses('terms')), licenseString)), React.createElement("td", null, _this.renderAmount(lineItem)));
        };
        _this.renderGeneralLineItem = function (lineItem) {
            return React.createElement("tr", Object.assign({ key: lineItem.id }, itemClasses('', 'general')), React.createElement("td", null, React.createElement(Label_1.Span, Object.assign({ variant: "description", size: "large" }, itemClasses('description')), lineItem.description)), React.createElement("td", null), React.createElement("td", null, _this.renderAmount(lineItem)));
        };
        return _this;
    }

    _createClass(InvoiceLineItems, [{
        key: "renderAmount",
        value: function renderAmount(lineItem) {
            var currencyProps = {
                currency: this.props.order.currency_code,
                rate: this.props.order.currency_rate
            };
            return lineItem.discount_amount ? React.createElement(React.Fragment, null, React.createElement(InvoicePriceTag_1.default, Object.assign({ strikeThrough: true, amount: lineItem.amount, size: "small" }, currencyProps, itemClasses('amount'))), React.createElement(InvoicePriceTag_1.default, Object.assign({ isDiscount: true, amount: lineItem.amount - lineItem.discount_amount, size: "small" }, currencyProps, itemClasses('discount-amount')))) : React.createElement(InvoicePriceTag_1.default, Object.assign({ amount: lineItem.amount, size: "small" }, currencyProps, itemClasses('amount')));
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("table", Object.assign({}, classes()), React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Item" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Description" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Amount" })))), React.createElement("tbody", null, this.props.order.license_line_items.map(this.renderLicenseLineItem), this.props.order.general_line_items.map(this.renderGeneralLineItem)));
        }
    }]);

    return InvoiceLineItems;
}(React.Component);

exports.default = InvoiceLineItems;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * License Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var countries_1 = __webpack_require__(128);
var license_1 = __webpack_require__(34);
var address_1 = __webpack_require__(232);
var react_1 = __webpack_require__(233);
__webpack_require__(1598);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var date_1 = __webpack_require__(119);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var InvoicePriceTag_1 = __webpack_require__(431);
var TableHeader_1 = __webpack_require__(657);
var config_1 = __webpack_require__(80);
var PrintableDocument_1 = __webpack_require__(656);
var classes = new BEM('license');
var LicenseParagraph = function LicenseParagraph(props) {
    return React.createElement(Label_1.Paragraph, Object.assign({ variant: "description", size: "large" }, props));
};

var License = function (_React$Component) {
    _inherits(License, _React$Component);

    function License() {
        _classCallCheck(this, License);

        return _possibleConstructorReturn(this, (License.__proto__ || Object.getPrototypeOf(License)).apply(this, arguments));
    }

    _createClass(License, [{
        key: "renderInformation",
        value: function renderInformation(label, value) {
            return value && React.createElement("div", null, React.createElement(Label_1.Span, { size: "medium", textColor: "bw6" }, label, ":"), React.createElement(Heading_1.default, { is: "h5", WrappedComponent: "div" }, value));
        }
    }, {
        key: "renderAddress",
        value: function renderAddress(address) {
            var addressString = address_1.formatAddress(address, this.props.getCountryLabel, this.props.getStateLabel);
            return react_1.nl2br(addressString);
        }
    }, {
        key: "renderRepresentativeInformation",
        value: function renderRepresentativeInformation() {
            var rep = this.props.data.authorized_representative;
            var str = rep.name + "\n" + rep.role.name + "\n" + rep.email + (rep.phone ? "\n" + rep.phone : "");
            return react_1.nl2br(str);
        }
    }, {
        key: "renderParties",
        value: function renderParties() {
            var _props = this.props,
                address = _props.businessInformation.address,
                getCountryLabel = _props.getCountryLabel,
                getStateLabel = _props.getStateLabel;

            return React.createElement("table", Object.assign({}, classes('information')), React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Licensor" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Licensee" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Represented By" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Project Details" })))), React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, React.createElement(Label_1.Paragraph, { size: "medium" }, "Bopper", React.createElement("br", null), react_1.nl2br(address_1.formatAddress(address, getCountryLabel, getStateLabel, true)))), React.createElement("td", null, React.createElement(Label_1.Paragraph, { size: "medium" }, React.createElement("strong", null, this.props.data.licensee_address.company), React.createElement("br", null), this.renderAddress(this.props.data.licensee_address))), React.createElement("td", null, React.createElement(Label_1.Paragraph, { size: "medium" }, this.renderRepresentativeInformation())), React.createElement("td", Object.assign({}, classes('information__project')), this.renderInformation('Brand', this.props.data.project_details.brand || config_1.kCheckoutNoInputLabel), this.renderInformation('Project Title', this.props.data.project_details.product || config_1.kCheckoutNoInputLabel), this.renderInformation('Reference', this.props.data.project_details.reference), this.renderInformation('PO Number', this.props.data.project_details.po_number), this.renderInformation('Notes', this.props.data.project_details.notes)))));
        }
    }, {
        key: "renderUsages",
        value: function renderUsages() {
            return React.createElement("table", Object.assign({}, classes('usages')), React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Composition" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Medium" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Term" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "# of films" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Air date (approx.)" })), React.createElement("th", null, React.createElement(TableHeader_1.TableHeader, { label: "Contextual parameter" })))), React.createElement("tbody", null, this.props.data.license_line_items.map(function (lineItem) {
                var track = lineItem.track;
                var usages = lineItem.license.usages.map(function (_ref) {
                    var air_date = _ref.air_date,
                        components = _ref.components;
                    return license_1.generateLicenseUsageFromComponents(components, undefined, air_date);
                });
                return usages.map(function (usage) {
                    return React.createElement("tr", { key: lineItem.id }, React.createElement("td", null, React.createElement("div", Object.assign({}, classes('track-info')), React.createElement(Heading_1.default, Object.assign({ is: "h5", text: track.title }, classes('track-info__title'))), React.createElement(Label_1.Span, Object.assign({ text: track.artist.name, size: "small", textColor: "bw7" }, classes('track-info__subtitle'))))), React.createElement("td", null, React.createElement(Label_1.Span, { size: "medium" }, usage.medium.name)), React.createElement("td", null, React.createElement(Label_1.Span, { size: "medium" }, usage.term ? usage.term.name : 'n/a')), React.createElement("td", null, React.createElement(Label_1.Span, { size: "medium" }, usage.spot_count ? usage.spot_count.name : 'n/a')), React.createElement("td", null, React.createElement(Label_1.Span, { size: "medium" }, usage.airDate ? date_1.getFormattedDateFromGraphQL(usage.airDate) : 'to be confirmed')), React.createElement("td", null, React.createElement(Label_1.Span, { size: "medium" }, license_1.getContextualParamTitle(usage), ": ", license_1.getContextualParamAsString(usage))));
                });
            })));
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.data;

            return React.createElement(PrintableDocument_1.default, { type: "license", identification: {
                    title: 'License'
                }, title: data.project_details.brand, subtitle: data.project_details.product, metadata: React.createElement(React.Fragment, null, React.createElement(Label_1.Span, { variant: "description", size: "large", textColor: "bw7" }, date_1.getFormattedDateFromGraphQL(data.order_date))) }, React.createElement("section", null, this.renderParties()), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "Composition(s) Subject to this Agreement"), this.renderUsages()), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "Grant of Rights"), React.createElement(LicenseParagraph, null, "Bopper hereby grants to the Licensee a non-exclusive license, for the Term, Territory, Media and Type of Use of this Agreement, to:"), React.createElement(LicenseParagraph, null, "Synchronize, reproduce and perform the Composition and the Recording, or portions thereof in timed relation with the Production, for the sole purpose of exploiting the Production."), React.createElement(LicenseParagraph, null, "Upon execution of this Agreement, Bopper shall deliver to the Licensee a digital copy of the Recording suitable for the purposes of producing the Production as contemplated hereunder.")), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "License Fee"), React.createElement(InvoicePriceTag_1.default, Object.assign({ size: "large", currency: data.currency_code, rate: data.currency_rate, amount: data.total, textColor: "accent" }, classes('amount'))), React.createElement(LicenseParagraph, null, "License fee shall be payable upon order confirmation, or no later than (30) days thereafter. Licensee's payment to Bopper of the License Fee by said Due Date is a condition precedent of this Agreement, and Licensor conveys no rights in or to the Composition under this Agreement absent Licensor's timely receipt of the License Fee.")), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "Limitation of Rights"), React.createElement(LicenseParagraph, null, "Bopper reserves all rights and uses in and to the Composition and the Recording except the limited use expressly licensed hereunder."), React.createElement(LicenseParagraph, null, "Bopper and Composer shall remain entitled to receive all worldwide public performance moneys which may be payable to music publishers, composers and songwriters in relation with the use of the Composition. Bopper shall receive these moneys directly from its rights collection agency.")), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "Representations"), React.createElement(LicenseParagraph, null, "Bopper warrants and represents that the Composition is an original musical composition, that the Recording is an original sound recording, and that it has the full right and capacity to enter into this Agreement and to grant the rights granted herein free from any third party claims. Bopper shall indemnify, defend and hold harmless Licensee from and against any loss or damage suffered by Licensee as a result of any third-party claim based on the breach of any representation or warranty of Licensor contained in this Agreement; provided, however, that in no event shall Licensor's total liability in connection therewith exceed the amount of consideration received by Licensor as of the date of Licensor's receipt of Licensee's notice of alleged breach pursuant to the following sentence. Licensee shall promptly notify Licensor of any alleged breach of this Agreement by sending written notice to Licensor specifying in detail the alleged breach.")), React.createElement("section", null, React.createElement(Heading_1.default, { is: "h4" }, "General Provisions"), React.createElement(LicenseParagraph, null, "This agreement is subject to the laws of the province of Alberta, Canada, and the parties hereby attorn to the courts of the judicial district of Edmonton."), React.createElement(LicenseParagraph, null, "Nothing in the present agreement shall be interpreted to demonstrate the intention to create a joint venture or a partnership between the Parties."), React.createElement(LicenseParagraph, null, "This is the entire Agreement between the Parties. Amendments to this Agreement shall be in writing and signed by the Parties hereto."), React.createElement(LicenseParagraph, null, "As a condition precedent to any claim of default, Parties shall advise each other in writing, and the notified party shall be allowed a period of thirty (30) days after receipt of written notice within which to cure such default. To that end, notices shall be sent by registered mail to the Parties respective addresses as described above."), React.createElement(LicenseParagraph, null, "The Parties hereto have required that this Agreement be drafted in English. Les parties ont exig\xE9 que ce contrat soit r\xE9dig\xE9 en anglais.")));
        }
    }]);

    return License;
}(React.Component);

var ConnectedLicense = react_redux_1.connect(function (state) {
    return {
        businessInformation: state.staticData.businessInformation,
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        }
    };
})(License);
exports.default = ConnectedLicense;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1599);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license section{margin-bottom:32px}.license .document__header{border-bottom:0}.license__information,.license__usages{width:100%}.license__information thead,.license__usages thead{background-color:#f0f6fa;-webkit-print-color-adjust:exact}.license__information td,.license__information th,.license__usages td,.license__usages th{padding:6px 8px;text-align:left;vertical-align:top}.license__information td:not(:last-child),.license__information th:not(:last-child),.license__usages td:not(:last-child),.license__usages th:not(:last-child){border-right:1px solid #e4e8ed}.license__information tbody tr,.license__information thead tr,.license__usages tbody tr,.license__usages thead tr{border-bottom:1px solid #e4e8ed}.license__track-info{margin-top:4px;margin-bottom:4px}.license__track-info__title{margin:0}.license__track-info__subtitle{display:block}.license__information td,.license__information th{width:25%}.license__information__project{padding-top:7px;padding-bottom:8px!important}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/account/License/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GC,iBAGG,kBC5E6C,CDyEhD,2BAOG,eAAgB,CACjB,uCAGC,UAAW,CADZ,mDE7CC,yBFkDE,gCAAiC,CALpC,0FASG,gBACA,gBAAgB,kBACG,CAXtB,8JAcK,8BEzHmB,CF2GxB,kHAmBG,+BE9HqB,CF+HtB,qBGtDmB,eFjDyB,iBAAA,CD6G7C,4BACE,QAAS,CACV,+BAGC,aAAc,CACf,kDAKC,SAAU,CACX,+BAGC,gBACA,4BAAsC,CACvC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * License Component\n */\n\n .license{\n\n  section{\n    margin-bottom: baseline(4);\n  }\n\n  .document__header{\n    border-bottom: 0;\n  }\n\n  &__information, &__usages{\n    width: 100%;\n\n    thead{\n      @include bgcolor(bw3);\n      -webkit-print-color-adjust: exact;\n    }\n\n    th, td{\n      padding: baseline(.75) baseline(1);\n      text-align: left;\n      vertical-align: top;\n\n      &:not(:last-child) {\n        border-right: 1px solid uicolor(border);\n      }\n    }\n\n    thead tr, tbody tr{\n      border-bottom: 1px solid uicolor(border);\n    }\n  }\n\n  &__track-info{\n    @include margin(baseline(.5) null);\n\n    &__title{\n      margin: 0;\n    }\n\n    &__subtitle{\n      display: block;\n    }\n  }\n\n  &__information{\n    th, td{\n      width: 25%;\n    }\n\n    &__project{\n      padding-top: baseline(.875);\n      padding-bottom: baseline(1) !important;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * OrderFileList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var player_1 = __webpack_require__(63);
var string_1 = __webpack_require__(47);
var track_1 = __webpack_require__(44);
__webpack_require__(1601);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('file-list');
var defaultList = [];

var OrderFileList = function (_React$Component) {
    _inherits(OrderFileList, _React$Component);

    function OrderFileList() {
        _classCallCheck(this, OrderFileList);

        return _possibleConstructorReturn(this, (OrderFileList.__proto__ || Object.getPrototypeOf(OrderFileList)).apply(this, arguments));
    }

    _createClass(OrderFileList, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.dispatch(playerActions.toggleShouldOnlyPlayOriginalTracks(false));
            this.props.setPlayerQueue();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.dispatch(playerActions.toggleShouldOnlyPlayOriginalTracks(true));
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                currentFilePlaying = _props.currentFilePlaying,
                data = _props.data,
                pausePlayer = _props.pausePlayer,
                playTrackVersion = _props.playTrackVersion;

            var tracks = data.license_line_items.map(function (_ref) {
                var track = _ref.track;
                return track;
            });
            return React.createElement("div", Object.assign({}, classes()), React.createElement("ul", Object.assign({}, classes('list')), tracks.map(function (track) {
                var audioAssets = track_1.getTrackAssets({
                    assets: track.assets || defaultList,
                    type: 'track-preview'
                }).concat(track_1.getTrackAssets({
                    assets: track.assets || defaultList,
                    type: 'track',
                    format: 'wav'
                }));
                var accumulator = {};
                var versions = audioAssets.reduce(function (acc, asset) {
                    if (Object.keys(acc).indexOf(asset.version) === -1) {
                        acc[asset.version] = [];
                    }
                    acc[asset.version].push(asset);
                    return acc;
                }, accumulator);
                var thumbnail = track_1.getResponsiveTrackThumbnail(track);
                return React.createElement("li", Object.assign({ key: track.id }, classes('list__item')), React.createElement("div", Object.assign({}, classes('track-info')), React.createElement(Thumbnail_1.default, { responsiveAssets: thumbnail, size: "medium" }), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('track-info__title')), track.title), React.createElement(Label_1.Span, { size: "small", textColor: "bw7" }, track.artist.name)), React.createElement("ul", Object.assign({}, classes('version-list')), lodash_1.map(versions, function (versionAssets, key) {
                    return React.createElement("li", Object.assign({ key: key }, classes('version-list__item')), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('version-list__title')), string_1.capitalizeString(key), " Version"), React.createElement("ul", Object.assign({}, classes('format-list')), versionAssets.map(function (_ref2) {
                        var file_format = _ref2.file_format,
                            path = _ref2.path,
                            id = _ref2.id,
                            version = _ref2.version;

                        var PlayButton = currentFilePlaying === id ? Icon_1.IconPlayerPause : Icon_1.IconPlayerPlay;
                        return React.createElement("li", Object.assign({ key: id }, classes('format-list__item')), React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                                return currentFilePlaying === id ? pausePlayer() : playTrackVersion(id);
                            }, label: file_format.toUpperCase() + " file", icon: React.createElement(PlayButton, null), size: "xsmall" }, classes('format-list__item__play-button'))), React.createElement(Button_1.default, Object.assign({ hyperLinkProps: {
                                href: "/" + path + "?download&invoice_number=" + data.invoice_number
                            }, wrapperComponent: "a", label: "Download", icon: React.createElement(Icon_1.IconDownload, null), size: "small" }, classes('format-list__item__download-button'))));
                    })));
                })));
            })), React.createElement(Button_1.default, Object.assign({ hyperLinkProps: {
                    href: "/orders/" + data.invoice_number + "/download"
                }, label: "Download All", variant: "pill", colorScheme: "accent", size: "large", icon: React.createElement(Icon_1.IconDownload, null), withShadow: true, wrapperComponent: "a" }, classes('button-download-all'))));
        }
    }]);

    return OrderFileList;
}(React.Component);

var ConnectedOrderFileList = react_redux_1.connect(function (_ref3) {
    var _ref3$player = _ref3.player,
        currentTrack = _ref3$player.currentTrack,
        isTrackPlaying = _ref3$player.isTrackPlaying;
    return {
        currentFilePlaying: !!currentTrack && isTrackPlaying ? currentTrack.versionId : null
    };
}, function (dispatch) {
    return {
        dispatch: dispatch,
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(playerActions.replaceQueue({ tracks: tracks }));
        },
        pausePlayer: function pausePlayer() {
            dispatch(playerActions.pause());
        },
        playTrackVersion: function playTrackVersion(trackId) {
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        }
    };
}, function (stateProps, _a, ownProps) {
    var _setPlayerQueue = _a.setPlayerQueue,
        dispatchProps = __rest(_a, ["setPlayerQueue"]);
    return Object.assign({}, stateProps, dispatchProps, ownProps, { setPlayerQueue: function setPlayerQueue() {
            _setPlayerQueue(player_1.getPlayerTracksFromResults(track_1.getTrackResultsFromLineItems(ownProps.data.license_line_items), false));
        } });
})(OrderFileList);
exports.default = ConnectedOrderFileList;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1602);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".file-list{-webkit-box-flex:1;-ms-flex:auto;flex:auto;text-align:center}.file-list__button-download-all{margin:40px auto 0}.file-list__list{text-align:left;padding:0}.file-list__list,.file-list__list ul{list-style:none;margin:0;width:100%}.file-list__list__item+.file-list__list__item{margin-top:8px}.file-list li{width:100%}.file-list__track-info,.file-list li{display:-webkit-box;display:-ms-flexbox;display:flex}.file-list__track-info{background-color:#f5faff;padding:24px 56px;border-radius:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;-webkit-box-flex:1;-ms-flex:1;flex:1}.file-list__track-info__title{margin-bottom:4px}.file-list__version-list{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:8px;-webkit-box-flex:4;-ms-flex:4;flex:4}.file-list__version-list__item{background-color:#f9fafb;border-radius:4px;padding-right:16px;padding-left:24px;-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:72px}.file-list__version-list__item:not(:last-child){margin-bottom:8px}.file-list__version-list__title{min-width:120px}.file-list__format-list__item{min-height:48px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.file-list__format-list__item:not(:last-child){border-bottom:1px solid #e4e8ed}.file-list__format-list__item__play-button .icon{width:20px}.file-list__format-list__item__play-button .icon svg{width:100%}.file-list__format-list__item__download-button{margin-left:auto}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/account/OrderFileList/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GA,WACE,mBAAA,cAAA,UAAU,iBACQ,CAElB,gCACE,kBAA0B,CAC3B,iBAGC,gBAAgB,SACN,CAFX,qCAKG,gBAAgB,SACP,UACE,CACZ,8CAIG,cC7FyC,CDyEjD,cA2BI,UAAW,CACZ,qCAFC,oBAAA,oBAAA,YAAa,CAIf,uBEjEE,yBA1DsB,kBDoBuB,kBD6G7C,wBAAA,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,4BACnB,6BAAA,0BAAA,sBAAsB,kBACJ,mBAElB,WAAA,MAAO,CAEP,8BACE,iBCrH2C,CDsH5C,yBAID,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,iBAGtB,mBAAA,WAAA,MAAO,CAEP,+BE1FA,yBA5DsB,kBC4EA,mBFtDuB,kBDqI3C,mBAAA,cAAA,UAAU,yBACV,sBAAA,mBAAmB,eCtIwB,CDgI5C,gDAUG,iBC1IyC,CD2I1C,gCAGD,eC9I2C,CD+I5C,8BAKC,gBACA,yBAAA,sBAAA,kBAAmB,CAFpB,+CAKG,+BEhLmB,CFiLpB,iDAIG,UC7JuC,CD2J1C,qDAIK,UAAW,CACZ,+CAKH,gBAAiB,CAClB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * OrderFileList Component\n */\n\n.file-list{\n  flex: auto;\n  text-align: center;\n\n  &__button-download-all{\n    margin: baseline(5) auto 0;\n  }\n\n  &__list{\n    text-align: left;\n    padding: 0;\n\n    &, ul {\n      list-style: none;\n      margin: 0;\n      width: 100%;\n    }\n\n    &__item{\n      & + & {\n        margin-top: baseline(1);\n      }\n    }\n  }\n\n  li{\n    display: flex;\n    width: 100%;\n  }\n\n  &__track-info{\n    @include bgcolor(accent-subtle);\n    @include padding(baseline(3) baseline(7));\n    @include bgsize(medium);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n\n    flex: 1;\n\n    &__title{\n      margin-bottom: baseline(.5);\n    }\n  }\n\n  &__version-list{\n    display: flex;\n    flex-direction: column;\n    padding-left: baseline(1);\n\n    flex: 4;\n\n    &__item{\n      @include bgcolor(bw2);\n      @include bgsize(medium);\n      @include padding(null baseline(2) null baseline(3));\n\n      flex: auto;\n      align-items: center;\n      min-height: baseline(9);\n\n      &:not(:last-child){\n        margin-bottom: baseline(1);\n      }\n    }\n    &__title{\n      min-width: baseline(15);\n    }\n  }\n\n  &__format-list{\n    &__item{\n      min-height: baseline(6);\n      align-items: center;\n\n      &:not(:last-child){\n        border-bottom: 1px solid uicolor(border);\n      }\n\n      &__play-button{\n        .icon{\n          width: baseline(2.5);\n          svg{\n            width: 100%;\n          }\n        }\n      }\n\n      &__download-button{\n        margin-left: auto;\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutPromoCode Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var selectors_1 = __webpack_require__(223);
var utils_1 = __webpack_require__(125);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(10);
var TextField_1 = __webpack_require__(83);
var classes = new BEM('checkout__promo-code');

var CheckoutPromoCode = function (_React$Component) {
    _inherits(CheckoutPromoCode, _React$Component);

    function CheckoutPromoCode() {
        _classCallCheck(this, CheckoutPromoCode);

        return _possibleConstructorReturn(this, (CheckoutPromoCode.__proto__ || Object.getPrototypeOf(CheckoutPromoCode)).apply(this, arguments));
    }

    _createClass(CheckoutPromoCode, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                handleSubmit = _props.handleSubmit,
                submitting = _props.submitting;

            return React.createElement("form", Object.assign({ onSubmit: handleSubmit }, classes()), React.createElement(utils_1.FieldUppercase, { component: TextField_1.default, name: "code", colorScheme: "transparent", inlineButton: React.createElement(Button_1.default, { label: "Apply", colorScheme: "dark", isSubmit: true }), placeholder: "Got a promo code?", size: "large", disabled: submitting }));
        }
    }]);

    return CheckoutPromoCode;
}(React.Component);

var CheckoutPromoCodeForm = redux_form_1.reduxForm({
    form: 'checkout-promo-code',
    onSubmit: function onSubmit(_ref, dispatch, _ref2) {
        var code = _ref.code;
        var billingAddress = _ref2.billingAddress;
        return new Promise(function (resolve, reject) {
            dispatch(checkout_1.requestAddPromoCode({
                code: code,
                country_code: billingAddress ? billingAddress.country : undefined,
                promise: { resolve: resolve, reject: reject },
                subdivision_code: billingAddress ? billingAddress.state : undefined
            }));
        }).then(function (err) {
            if (err) {
                throw new redux_form_1.SubmissionError({ code: 'The entered code is not valid.' });
            }
        }).catch(function (err) {
            throw new redux_form_1.SubmissionError({ code: 'The entered code is not valid.' });
        });
    },
    onSubmitSuccess: function onSubmitSuccess(res, dispatch, _ref3) {
        var reset = _ref3.reset;

        reset();
    }
})(CheckoutPromoCode);
var ConnectedCheckoutPromoCodeForm = react_redux_1.connect(function (state) {
    return {
        billingAddress: selectors_1.getBillingAddress(state)
    };
})(CheckoutPromoCodeForm);
exports.default = ConnectedCheckoutPromoCodeForm;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutSteps Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var CheckoutStepBilling_1 = __webpack_require__(1605);
var CheckoutStepLicense_1 = __webpack_require__(1617);
var CheckoutStepProject_1 = __webpack_require__(1618);
var CheckoutStepReview_1 = __webpack_require__(1625);
var classes = new BEM('checkout__steps');
function CheckoutSteps(_ref) {
    var companyTypes = _ref.companyTypes,
        order = _ref.order,
        representativeRoles = _ref.representativeRoles;

    return React.createElement("div", Object.assign({}, classes('')), React.createElement(CheckoutStepProject_1.default, { order: order }), React.createElement(CheckoutStepLicense_1.default, { representativeRoles: representativeRoles }), React.createElement(CheckoutStepBilling_1.default, null), React.createElement(CheckoutStepReview_1.default, { companyTypes: companyTypes, order: order, representativeRoles: representativeRoles }));
}
exports.default = CheckoutSteps;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutStepBilling Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var user_1 = __webpack_require__(50);
var validation_1 = __webpack_require__(659);
var config_1 = __webpack_require__(80);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_stripe_elements_1 = __webpack_require__(420);
var redux_form_1 = __webpack_require__(37);
var selectors_1 = __webpack_require__(223);
var countries_1 = __webpack_require__(128);
// import { logComponentUpdate } from '../../../utils/log';
var Heading_1 = __webpack_require__(9);
var CheckboxWithLabel_1 = __webpack_require__(213);
var FormCell_1 = __webpack_require__(234);
var FormRow_1 = __webpack_require__(235);
var Select_1 = __webpack_require__(200);
var StripeCardElement_1 = __webpack_require__(1610);
var TextFieldWithLabel_1 = __webpack_require__(236);
var InvoicePaymentMethods_1 = __webpack_require__(658);
var AddressForm_1 = __webpack_require__(660);
var CheckoutStep_1 = __webpack_require__(303);
var formValidations = AddressForm_1.getAddressFormValidations();
var stepId = config_1.CheckoutStepId.billing;
var form = config_1.CheckoutStepFormName.billing;
var classes = new BEM("checkout__step--" + stepId);
var paymentMethodOptions = [{ label: 'Credit Card', value: "Stripe" /* Stripe */ }, { label: 'Cheque', value: "Cheque" /* Cheque */ }];

var CheckoutStepBilling = function (_React$Component) {
    _inherits(CheckoutStepBilling, _React$Component);

    function CheckoutStepBilling(props) {
        _classCallCheck(this, CheckoutStepBilling);

        var _this = _possibleConstructorReturn(this, (CheckoutStepBilling.__proto__ || Object.getPrototypeOf(CheckoutStepBilling)).call(this, props));

        _this.validate = function (values, dispatch) {
            var _this$props = _this.props,
                sameAddressAsLicensee = _this$props.sameAddressAsLicensee,
                paymentMethod = _this$props.paymentMethod;

            var promises = [];
            if (paymentMethod === "Stripe" /* Stripe */) {
                    promises.push(_this.createStripeToken(values, dispatch));
                }
            if (!sameAddressAsLicensee) {
                promises.push(validation_1.validateFields(values, formValidations, {
                    validatePostalCode: [values.hasOwnProperty('postalCodeValidationRegExp') && values.postalCodeValidationRegExp]
                }));
            }
            return Promise.all(promises);
        };
        _this.state = {};
        return _this;
    }

    _createClass(CheckoutStepBilling, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.consumeLocalStorage();
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            // return nextProps.isActive || !isEqual(this.props.address, nextProps.address);
            return nextProps.isActive;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            // logComponentUpdate('Checkout Billing:', this.props, prevProps);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                error = _props.error,
                handleSubmit = _props.handleSubmit,
                paymentMethod = _props.paymentMethod,
                sameAddressAsLicensee = _props.sameAddressAsLicensee,
                submitting = _props.submitting;

            return React.createElement(CheckoutStep_1.default, { customValidation: this.validate, error: error, id: stepId, handleSubmit: handleSubmit, submitting: submitting, title: "Billing Information" }, React.createElement("div", null, React.createElement(Heading_1.default, { is: "h5" }, "Billing Address"), React.createElement(redux_form_1.Field, { component: CheckboxWithLabel_1.default, className: "checkbox-same-address", name: "sameAddressAsLicensee", label: "Same as Licensee Address" }), React.createElement("div", Object.assign({}, classes('form')), !sameAddressAsLicensee && React.createElement(AddressForm_1.default, Object.assign({ form: form }, classes('address-form'))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(Select_1.default, { form: form, label: "Payment Method", name: "paymentMethod", options: paymentMethodOptions, selectName: "payment-method", selectProps: {
                    autoBlur: true,
                    clearable: false
                } }))), paymentMethod === "Stripe" /* Stripe */ ? this.renderStripeElement() : '', paymentMethod === "Cheque" /* Cheque */ ? this.renderChequeElement() : '')));
        }
    }, {
        key: "renderChequeElement",
        value: function renderChequeElement() {
            var _props2 = this.props,
                _props2$businessInfor = _props2.businessInformation,
                name = _props2$businessInfor.name,
                legalName = _props2$businessInfor.legal_name,
                address = _props2$businessInfor.address,
                getCountryLabel = _props2.getCountryLabel,
                getStateLabel = _props2.getStateLabel;

            return React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, null, InvoicePaymentMethods_1.renderChequePaymentInformation({
                address: address, legalName: legalName, name: name, getCountryLabel: getCountryLabel, getStateLabel: getStateLabel, includeHeading: false
            })));
        }
    }, {
        key: "renderStripeElement",
        value: function renderStripeElement() {
            var address = this.props.address;

            var postalCode = address ? address.postalCode : '';
            var stripeError = this.state.stripeError;

            return React.createElement(React.Fragment, null, React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 10 }, React.createElement(redux_form_1.Field, { name: "nameOnCard", component: TextFieldWithLabel_1.default, label: "Cardholder Name", colorScheme: "light" }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 10 }, React.createElement(StripeCardElement_1.default, { error: stripeError, label: "Credit or Debit Card", value: { postalCode: postalCode } }))));
        }
    }, {
        key: "createStripeToken",
        value: function createStripeToken(values, dispatch) {
            var _this2 = this;

            var _props3 = this.props,
                address = _props3.address,
                stripe = _props3.stripe;

            return new Promise(function (resolve, reject) {
                var cardData = {
                    name: values.nameOnCard,
                    address_line1: address.street,
                    address_line2: address.unit,
                    address_city: address.city,
                    address_state: address.state,
                    address_country: address.country
                };
                stripe.createToken(cardData).then(function (_ref) {
                    var error = _ref.error,
                        token = _ref.token;

                    if (error) {
                        _this2.setState({ stripeError: error.message }, function () {
                            reject(new redux_form_1.SubmissionError());
                        });
                    } else {
                        var country = lodash_1.get(_this2.props, 'address.country', '');
                        var postalCode = lodash_1.get(_this2.props, 'address.postalCode', '');
                        if (country && postalCode) {
                            if (token.card.country !== country) {
                                return _this2.setState({
                                    stripeError: "Card's country of origin does not match the billing address."
                                }, function () {
                                    reject(new redux_form_1.SubmissionError());
                                });
                            }
                        }
                        dispatch(user_1.setUserStripeToken({ token: token }));
                        resolve();
                    }
                });
            });
        }
    }]);

    return CheckoutStepBilling;
}(React.Component);

var CheckoutStepBillingForm = redux_form_1.reduxForm({
    forceUnregisterOnUnmount: true,
    form: form
})(CheckoutStepBilling);
var ConnectedCheckoutStepBillingForm = react_redux_1.connect(function (state) {
    var formState = redux_form_1.getFormValues(form)(state);
    var localStorage = lodash_1.get(state.checkout.localStorage, stepId);
    var initialValuesFromLocalStorage = !!localStorage;
    var initialValues = {
        sameAddressAsLicensee: config_1.DefaultBillingAddressIsSameAsLicensee,
        paymentMethod: "Stripe" /* Stripe */
    };
    if (localStorage) {
        initialValues = lodash_1.extend(initialValues, localStorage);
    }
    var sameAddressAsLicensee = initialValues.sameAddressAsLicensee;
    if (formState) {
        sameAddressAsLicensee = lodash_1.get(formState, 'sameAddressAsLicensee', sameAddressAsLicensee);
    }
    return {
        address: selectors_1.getBillingAddress(state),
        sameAddressAsLicensee: sameAddressAsLicensee,
        paymentMethod: lodash_1.get(formState, 'paymentMethod'),
        businessInformation: state.staticData.businessInformation,
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        },
        initialValues: initialValues,
        initialValuesFromLocalStorage: initialValuesFromLocalStorage,
        isActive: state.checkout.activeStep === stepId
    };
}, function (dispatch) {
    return {
        consumeLocalStorage: function consumeLocalStorage() {
            return dispatch(checkout_1.consumeLocallyStoredStep({ id: stepId }));
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, { consumeLocalStorage: function consumeLocalStorage() {
            return stateProps.initialValuesFromLocalStorage && dispatchProps.consumeLocalStorage();
        } });
})(CheckoutStepBillingForm);
var WithStripe = react_stripe_elements_1.injectStripe(ConnectedCheckoutStepBillingForm);
exports.default = WithStripe;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1607);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".form__cell{padding-top:8px;padding-bottom:8px}.form__cell--is-spacer{display:none}@media screen and (min-width:960px){.form__cell{-ms-flex-negative:0;flex-shrink:0;padding:0;border-bottom:0}.form__cell--no-margin-left{margin-left:18px!important}.form__cell--is-spacer{display:block}.form__cell:not([data-min-width]){-webkit-box-flex:.35;-ms-flex-positive:.35;flex-grow:.35;-ms-flex-negative:1;flex-shrink:1}.form__cell[data-min-width=full]{-ms-flex-preferred-size:100%;flex-basis:100%}.form__cell[data-min-width=\"1\"]{-ms-flex-preferred-size:5.8823529412%;flex-basis:5.8823529412%}.form__cell[data-min-width=\"2\"]{-ms-flex-preferred-size:11.7647058824%;flex-basis:11.7647058824%}.form__cell[data-min-width=\"3\"]{-ms-flex-preferred-size:17.6470588235%;flex-basis:17.6470588235%}.form__cell[data-min-width=\"4\"]{-ms-flex-preferred-size:23.5294117647%;flex-basis:23.5294117647%}.form__cell[data-min-width=\"5\"]{-ms-flex-preferred-size:29.4117647059%;flex-basis:29.4117647059%}.form__cell[data-min-width=\"6\"]{-ms-flex-preferred-size:35.2941176471%;flex-basis:35.2941176471%}.form__cell[data-min-width=\"7\"]{-ms-flex-preferred-size:41.1764705882%;flex-basis:41.1764705882%}.form__cell[data-min-width=\"8\"]{-ms-flex-preferred-size:47.0588235294%;flex-basis:47.0588235294%}.form__cell[data-min-width=\"9\"]{-ms-flex-preferred-size:52.9411764706%;flex-basis:52.9411764706%}.form__cell[data-min-width=\"10\"]{-ms-flex-preferred-size:58.8235294118%;flex-basis:58.8235294118%}.form__cell[data-min-width=\"11\"]{-ms-flex-preferred-size:64.7058823529%;flex-basis:64.7058823529%}.form__cell[data-min-width=\"12\"]{-ms-flex-preferred-size:70.5882352941%;flex-basis:70.5882352941%}.form__cell[data-min-width=\"13\"]{-ms-flex-preferred-size:76.4705882353%;flex-basis:76.4705882353%}.form__cell[data-min-width=\"14\"]{-ms-flex-preferred-size:82.3529411765%;flex-basis:82.3529411765%}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/FormCell/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA8GA,YC1BwB,gBASE,kBC1DuB,CF+E/C,uBACE,YAAa,CACd,oCANH,YASI,oBAAA,cAAc,UACJ,eACM,CAMhB,4BACE,0BAA4B,CAC7B,uBAGC,aAAc,CAtBpB,kCAyB8B,qBAAA,sBAAA,cAAc,oBAAE,aAAc,CAzB5D,iCA0B+B,6BAAA,eAAgB,CA1B/C,gCA2B4B,sCAAA,wBE7FC,CFkE7B,gCA4B4B,uCAAA,yBE9FC,CFkE7B,gCA6B4B,uCAAA,yBE/FC,CFkE7B,gCA8B4B,uCAAA,yBEhGC,CFkE7B,gCA+B4B,uCAAA,yBEjGC,CFkE7B,gCAgC4B,uCAAA,yBElGC,CFkE7B,gCAiC4B,uCAAA,yBEnGC,CFkE7B,gCAkC4B,uCAAA,yBEpGC,CFkE7B,gCAmC4B,uCAAA,yBErGC,CFkE7B,iCAoC6B,uCAAA,yBEtGA,CFkE7B,iCAqC6B,uCAAA,yBEvGA,CFkE7B,iCAsC6B,uCAAA,yBExGA,CFkE7B,iCAuC6B,uCAAA,yBEzGA,CFkE7B,iCAwC6B,uCAAA,yBE1GA,CF0G8B,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FormCell Component\n */\n\n$context: \".form__cell\";\n\n#{$context}{\n\n  @include padding(baseline(1) null);\n\n  &--is-spacer{\n    display: none;\n  }\n\n  @include media(breakpoint(desktop-s)){\n    flex-shrink: 0;\n    padding: 0;\n    border-bottom: 0;\n\n    // &:not(:first-child) {\n    //   margin-left: column(.5, 17);\n    // }\n\n    &--no-margin-left{\n      margin-left: 18px !important;\n    }\n\n    &--is-spacer{\n      display: block;\n    }\n\n    &:not([data-min-width]) { flex-grow: .35; flex-shrink: 1; }\n    &[data-min-width=\"full\"] { flex-basis: 100%; }\n    &[data-min-width=\"1\"] { flex-basis: column(1, 17); }\n    &[data-min-width=\"2\"] { flex-basis: column(2, 17); }\n    &[data-min-width=\"3\"] { flex-basis: column(3, 17); }\n    &[data-min-width=\"4\"] { flex-basis: column(4, 17); }\n    &[data-min-width=\"5\"] { flex-basis: column(5, 17); }\n    &[data-min-width=\"6\"] { flex-basis: column(6, 17); }\n    &[data-min-width=\"7\"] { flex-basis: column(7, 17); }\n    &[data-min-width=\"8\"] { flex-basis: column(8, 17); }\n    &[data-min-width=\"9\"] { flex-basis: column(9, 17); }\n    &[data-min-width=\"10\"] { flex-basis: column(10, 17); }\n    &[data-min-width=\"11\"] { flex-basis: column(11, 17); }\n    &[data-min-width=\"12\"] { flex-basis: column(12, 17); }\n    &[data-min-width=\"13\"] { flex-basis: column(13, 17); }\n    &[data-min-width=\"14\"] { flex-basis: column(14, 17); }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1609);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@media screen and (min-width:960px){.form__row{padding-top:8px;padding-bottom:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.form:not([data-form-width])>.form__row{padding-right:5.2631578947%;padding-left:5.2631578947%}.form[data-form-width=\"10\"]>.form__row{padding-right:10%;padding-left:10%}.form[data-form-width=\"11\"]>.form__row{padding-right:9.0909090909%;padding-left:9.0909090909%}.form[data-form-width=\"12\"]>.form__row{padding-right:8.3333333333%;padding-left:8.3333333333%}.form[data-form-width=\"13\"]>.form__row{padding-right:7.6923076923%;padding-left:7.6923076923%}.form[data-form-width=\"14\"]>.form__row{padding-right:7.1428571429%;padding-left:7.1428571429%}.form[data-form-width=\"15\"]>.form__row{padding-right:6.6666666667%;padding-left:6.6666666667%}.form[data-form-width=\"16\"]>.form__row{padding-right:6.25%;padding-left:6.25%}.form[data-form-width=\"17\"]>.form__row{padding-right:5.8823529412%;padding-left:5.8823529412%}.form[data-form-width=\"18\"]>.form__row{padding-right:5.5555555556%;padding-left:5.5555555556%}.form[data-form-width=\"19\"]>.form__row{padding-right:5.2631578947%;padding-left:5.2631578947%}.form[data-form-width=\"20\"]>.form__row{padding-right:5%;padding-left:5%}.form[data-form-width=\"21\"]>.form__row{padding-right:4.7619047619%;padding-left:4.7619047619%}.form[data-form-width=\"22\"]>.form__row{padding-right:4.5454545455%;padding-left:4.5454545455%}.form[data-form-width=\"23\"]>.form__row{padding-right:4.347826087%;padding-left:4.347826087%}.form[data-form-width=\"24\"]>.form__row{padding-right:4.1666666667%;padding-left:4.1666666667%}.form[data-form-width=\"25\"]>.form__row{padding-right:4%;padding-left:4%}.form[data-form-width=\"26\"]>.form__row{padding-right:3.8461538462%;padding-left:3.8461538462%}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon-neat/app/assets/stylesheets/grid/_media.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/FormRow/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AAsFI,oCCwBJ,WC1BwB,gBASE,mBDoBtB,oBAAA,oBAAA,aAAa,wBACb,qBAAA,sBAAuB,CAGrB,wCC5BoB,4BAKA,0BClDG,CFyEmD,uCC5BtD,kBAKA,gBClDG,CF0EkD,uCC7BrD,4BAKA,0BClDG,CF2EkD,uCC9BrD,4BAKA,0BClDG,CF4EkD,uCC/BrD,4BAKA,0BClDG,CF6EkD,uCChCrD,4BAKA,0BClDG,CF8EkD,uCCjCrD,4BAKA,0BClDG,CF+EkD,uCClCrD,oBAKA,kBClDG,CFgFkD,uCCnCrD,4BAKA,0BClDG,CFiFkD,uCCpCrD,4BAKA,0BClDG,CFkFkD,uCCrCrD,4BAKA,0BClDG,CFmFkD,uCCtCrD,iBAKA,eClDG,CFoFkD,uCCvCrD,4BAKA,0BClDG,CFqFkD,uCCxCrD,4BAKA,0BClDG,CFsFkD,uCCzCrD,2BAKA,yBClDG,CFuFkD,uCC1CrD,4BAKA,0BClDG,CFwFkD,uCC3CrD,iBAKA,eClDG,CFyFkD,uCC5CrD,4BAKA,0BClDG,CF0FkD,CAAA","file":"styles.scss","sourcesContent":["@charset \"UTF-8\";\n\n/// Outputs a media-query block with an optional grid context (the total number of columns used in the grid).\n///\n/// @param {List} $query\n///   A list of media query features and values, where each `$feature` should have a corresponding `$value`.\n///   For a list of valid values for `$feature`, click [here](http://www.w3.org/TR/css3-mediaqueries/#media1).\n///\n///   If there is only a single `$value` in `$query`, `$default-feature` is going to be used.\n///\n///   The number of total columns in the grid can be set by passing `$columns` at the end of the list (overrides `$total-columns`).\n///\n///\n/// @param {Number (unitless)} $total-columns [$grid-columns]\n///   - Number of columns to use in the new grid context. Can be set as a shorthand in the first parameter.\n///\n/// @example scss - Usage\n///   .responsive-element {\n///      @include media(769px) {\n///        @include span-columns(6);\n///      }\n///   }\n///\n///  .new-context-element {\n///    @include media(min-width 320px max-width 480px, 6) {\n///      @include span-columns(6);\n///    }\n///  }\n///\n/// @example css - CSS Output\n///  @media screen and (min-width: 769px) {\n///    .responsive-element {\n///      display: block;\n///      float: left;\n///      margin-right: 2.35765%;\n///      width: 48.82117%;\n///    }\n///\n///    .responsive-element:last-child {\n///      margin-right: 0;\n///    }\n///  }\n///\n///  @media screen and (min-width: 320px) and (max-width: 480px) {\n///    .new-context-element {\n///      display: block;\n///      float: left;\n///      margin-right: 4.82916%;\n///      width: 100%;\n///    }\n///\n///    .new-context-element:last-child {\n///      margin-right: 0;\n///    }\n///  }\n\n@mixin media($query: $feature $value $columns, $total-columns: $grid-columns) {\n  @if length($query) == 1 {\n    @media screen and ($default-feature: nth($query, 1)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: $total-columns !global;\n      @content;\n      $grid-columns: $default-grid-columns !global;\n    }\n  } @else {\n    $loop-to: length($query);\n    $media-query: \"screen and \";\n    $default-grid-columns: $grid-columns;\n    $grid-columns: $total-columns !global;\n\n    @if is-not(is-even(length($query))) {\n      $grid-columns: nth($query, $loop-to) !global;\n      $loop-to: $loop-to - 1;\n    }\n\n    $i: 1;\n    @while $i <= $loop-to {\n      $media-query: $media-query + \"(\" + nth($query, $i) + \": \" + nth($query, $i + 1) + \") \";\n\n      @if ($i + 1) != $loop-to {\n        $media-query: $media-query + \"and \";\n      }\n\n      $i: $i + 2;\n    }\n\n    @media #{$media-query} {\n      @content;\n      $grid-columns: $default-grid-columns !global;\n    }\n  }\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FormRow Component\n */\n\n$context: \".form__row\";\n\n#{$context}{\n  @include media(breakpoint(desktop-s)) {\n    @include padding(baseline(1) null);\n    display: flex;\n    align-items: flex-start;\n\n    @at-root{\n      .form:not([data-form-width]) > & { @include padding(null column(1, 19)) }\n      .form[data-form-width=\"10\"] > & { @include padding(null column(1, 10)) }\n      .form[data-form-width=\"11\"] > & { @include padding(null column(1, 11)) }\n      .form[data-form-width=\"12\"] > & { @include padding(null column(1, 12)) }\n      .form[data-form-width=\"13\"] > & { @include padding(null column(1, 13)) }\n      .form[data-form-width=\"14\"] > & { @include padding(null column(1, 14)) }\n      .form[data-form-width=\"15\"] > & { @include padding(null column(1, 15)) }\n      .form[data-form-width=\"16\"] > & { @include padding(null column(1, 16)) }\n      .form[data-form-width=\"17\"] > & { @include padding(null column(1, 17)) }\n      .form[data-form-width=\"18\"] > & { @include padding(null column(1, 18)) }\n      .form[data-form-width=\"19\"] > & { @include padding(null column(1, 19)) }\n      .form[data-form-width=\"20\"] > & { @include padding(null column(1, 20)) }\n      .form[data-form-width=\"21\"] > & { @include padding(null column(1, 21)) }\n      .form[data-form-width=\"22\"] > & { @include padding(null column(1, 22)) }\n      .form[data-form-width=\"23\"] > & { @include padding(null column(1, 23)) }\n      .form[data-form-width=\"24\"] > & { @include padding(null column(1, 24)) }\n      .form[data-form-width=\"25\"] > & { @include padding(null column(1, 25)) }\n      .form[data-form-width=\"26\"] > & { @include padding(null column(1, 26)) }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * StripCardElement Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = __webpack_require__(143);
var colors_1 = __webpack_require__(57);
__webpack_require__(1611);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_stripe_elements_1 = __webpack_require__(420);
var lodash_1 = __webpack_require__(6);
var Label_1 = __webpack_require__(8);
var classes = new BEM('stripe-card');
var labelClasses = new BEM('label');

var StripCardElement = function (_React$Component) {
    _inherits(StripCardElement, _React$Component);

    function StripCardElement(props) {
        _classCallCheck(this, StripCardElement);

        var _this = _possibleConstructorReturn(this, (StripCardElement.__proto__ || Object.getPrototypeOf(StripCardElement)).call(this, props));

        _this.onToggleFocus = function (isFocus) {
            _this.setState({ isFocus: isFocus });
        };
        _this.onChange = function (_ref) {
            var error = _ref.error;

            _this.setState({ error: error && error.message });
        };
        _this.state = {
            isFocus: false
        };
        return _this;
    }

    _createClass(StripCardElement, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref2) {
            var error = _ref2.error;

            if (!lodash_1.isEqual(error, this.props.error)) {
                this.setState({ error: error });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                colorScheme = _props.colorScheme,
                label = _props.label,
                note = _props.note,
                value = _props.value;
            var _state = this.state,
                error = _state.error,
                isFocus = _state.isFocus;

            var modifiers = {
                'is-focus': isFocus,
                // 'is-disabled': disabled,
                // [size!]: size,
                'error': !!error
            };
            var noteLabel = null;
            if (note != null) {
                var noteProps = Object.assign({ size: 'small', variant: 'note' }, classes('note'));
                noteLabel = React.createElement(Label_1.default, Object.assign({}, noteProps), note || 'Optional');
            }
            var extraClasses = classNames(colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme, 'stripe-card'), className);
            /* tslint:disable-next-line */
            var shouldHidePostalCode = !!value && value.hasOwnProperty('postalCode') && value['postalCode'] !== '';
            return React.createElement("div", Object.assign({}, classes('', modifiers, extraClasses)), React.createElement("div", Object.assign({}, classes('background'))), label && React.createElement(Label_1.default, Object.assign({ text: label, size: "small" }, classes('label'))), noteLabel, React.createElement(react_stripe_elements_1.CardElement, Object.assign({}, classes('input'), { hidePostalCode: shouldHidePostalCode, onFocus: function onFocus() {
                    return _this2.onToggleFocus(true);
                }, onBlur: function onBlur() {
                    return _this2.onToggleFocus(false);
                }, onChange: this.onChange, style: {
                    base: {
                        'fontFamily': 'Space Mono, monospace',
                        'fontSize': '12px',
                        'fontSmoothing': 'antialiased',
                        '::placeholder': {
                            color: colors_1.bw6Hex
                        }
                    },
                    invalid: {
                        color: colors_1.dangerousHex,
                        iconColor: colors_1.dangerousHex
                    }
                }, value: shouldHidePostalCode ? value : {} })), error && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'error'), { size: "medium", textColor: "dangerous" }), error));
        }
    }]);

    return StripCardElement;
}(React.Component);

StripCardElement.defaultProps = {
    colorScheme: 'light'
};
exports.default = StripCardElement;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1612);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".stripe-card__background{position:absolute;right:0;bottom:0;left:0;background-color:#f0f6fa;border-radius:2px;height:40px;-webkit-transition:-webkit-transform .1s ease-in-out;transition:-webkit-transform .1s ease-in-out;-o-transition:transform .1s ease-in-out;transition:transform .1s ease-in-out;transition:transform .1s ease-in-out,-webkit-transform .1s ease-in-out}.stripe-card--is-disabled .stripe-card__background{background-color:#f9fafb}.stripe-card__input{padding:11px 8px 12px 12px;width:100%;height:38px}.stripe-card__label{margin-bottom:8px;display:block}.stripe-card__note{position:absolute;top:1px;right:2px}.stripe-card--error .stripe-card__label{color:#f75b5b;-webkit-animation:transform-to-error .15s ease-in-out .25s;animation:transform-to-error .15s ease-in-out .25s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.stripe-card--error .stripe-card__label:after{content:\":\"}.stripe-card .label--error,.stripe-card .label--warning{position:absolute;top:95%;left:8px;border-radius:2px;max-width:calc(100% - 16px);padding:4px 8px 5px;border:1px solid;-webkit-box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);box-shadow:-1px 1px 4px hsla(220,7%,57%,.25);z-index:1;text-align:left;-webkit-animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards;animation:show-label-error .25s cubic-bezier(.175,.885,.32,1.275) forwards}@-webkit-keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-label-error{0%{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}.stripe-card .label--warning{background-color:#f5faff;color:#4487ff}.stripe-card .label--error{background-color:#fff5f5;color:#f75b5b}.stripe-card-color-scheme--light .stripe-card__background{background-color:#f9fafb;border:1px solid #d2d9e1}.stripe-card-color-scheme--light.stripe-card--is-disabled{color:#b1b8c4}.stripe-card-color-scheme--light.stripe-card--is-disabled .stripe-card__background{background-color:#fff;border-color:#e4e8ed}.stripe-card-color-scheme--white .stripe-card__background{border-radius:2px;background-color:#fff;border:1px solid #e4e8ed}.stripe-card-color-scheme--white.stripe-card--is-disabled{color:#b1b8c4}.stripe-card-color-scheme--white.stripe-card--is-disabled .stripe-card__background{background-color:#f9fafb;border-color:#e4e8ed}.stripe-card-color-scheme--white.stripe-card--is-focus .stripe-card__background{border-color:#4487ff}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/StripeCardElement/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_input.scss"],"names":[],"mappings":"AA+GE,yBCrEA,kBDsE4B,QAAQ,SAAE,OAAE,yBEhGf,kBFoGvB,YACA,qDAAA,6CAAA,wCAAA,qCAAA,sEAAqC,CACtC,mDE7CC,wBA5DsB,CF2GvB,oBASC,2BAGA,WAAW,WACmB,CAC/B,oBAGC,kBACA,aAAc,CACf,mBCjGD,kBDoG4B,QChGxB,SEX2C,CH4G9C,wCE9DC,cFoEA,2DAAA,mDAAmD,iCACnD,wBAAyB,CAL1B,8CAQG,WAAY,CA3ClB,wDCpEE,kBDoH4B,QAAK,SI7H7B,kBJ+HF,4BAAsC,oBAEtC,iBAAiB,qDACjB,6CAA6D,UACnD,gBACM,mFAEhB,0EAAwD,CAExD,oCACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAP5B,4BACE,GACE,UAAU,kCACV,yBAA0B,CAAA,GAG1B,UAAU,gCACV,uBAAwB,CAAA,CAlEhC,6BErCI,yBA1DsB,aADC,CFgG3B,2BErCI,yBAvDoB,aADE,CF4KvB,0DEpHC,yBA5DsB,wBAHH,CGJlB,0DH2ED,aAxEuB,CGHtB,mFHmED,sBAvCU,oBAvBa,CGKlB,0DDiBH,kBFwCF,sBAvCU,wBAvBa,CGQtB,0DH8DD,aAxEuB,CGUtB,mFHsDD,yBA5DsB,oBAFC,CGQtB,gFAeK,oBHpBiB,CGqBlB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * StripeCardElement Component\n */\n\n@import \"../../../atoms/text/Label/mixins\";\n\n.stripe-card{\n  &__background{\n    @include position(absolute, null 0 0 0);\n    @include bgcolor(bw3);\n    @include bgsize(small);\n\n    height: baseline(5);\n    transition: transform .1s ease-in-out;\n  } &--is-disabled &__background {\n    @include bgcolor(bw2);\n  }\n\n  &__input{\n    $computed-height: baseline(5);\n    $label-height: get-label-height(medium);\n    $v-padding: ceil(($computed-height - $label-height) / 2);\n\n    padding-top: $v-padding - 1;\n    padding-bottom: $v-padding;\n    padding-left: baseline(1.5);\n    padding-right: baseline(1);\n\n    width: 100%;\n    height: $computed-height - 2px;\n  }\n\n  &__label{\n    margin-bottom: baseline(1);\n    display: block;\n  }\n\n  &__note{\n    @include position(absolute, baseline(.125) baseline(.25) null null);\n  }\n\n  &--error &__label{\n    $fz: 10;\n    @include textcolor(dangerous);\n\n    animation: transform-to-error .15s ease-in-out .25s;\n    animation-fill-mode: both;\n\n    &::after{\n      content: \":\";\n    }\n  }\n\n  .label--error, .label--warning{\n    @include position(absolute, 95% null null baseline(1));\n    @include bgsize(small);\n    max-width: calc(100% - #{baseline(2)});\n    padding: baseline(.5) baseline(1) baseline(.625);\n    border: 1px solid;\n    box-shadow: -1px 1px 4px transparentize(uicolor(shadow), .75);\n    z-index: 1;\n    text-align: left;\n\n    animation: show-label-error .25s $ease-out-back forwards;\n\n    @keyframes show-label-error {\n      0% {\n        opacity: 0;\n        transform: translateY(50%);\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .label--warning{\n    @include bgcolor(accent-subtle);\n    @include textcolor(accent);\n  }\n\n  .label--error{\n    @include bgcolor(dangerous-subtle);\n    @include textcolor(dangerous);\n  }\n}\n\n@include set-input-color-schemes(stripe-card);\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Input Mixins\n */\n\n@mixin set-input-color-schemes($scope) {\n  .#{$scope}-color-scheme{\n    &--light{\n      .#{$scope}__background{\n        @include bgcolor(bw2);\n        border: 1px solid color(bw5);\n      }\n      &.#{$scope}--is-disabled{\n        @include textcolor(bw6);\n        .#{$scope}__background{\n          @include bgcolor(white);\n          border-color: uicolor(border);\n        }\n      }\n    }\n    &--white{\n      .#{$scope}__background {\n        @include bgsize(small);\n        @include bgcolor(white);\n        border: 1px solid color(bw4);\n      }\n      &.#{$scope}--is-disabled {\n        @include textcolor(bw6);\n        .#{$scope}__background{\n          @include bgcolor(bw2);\n          border-color: uicolor(border);\n        }\n      }\n      &.#{$scope}--is-focus {\n        .#{$scope}__background{\n          border-color: color(accent);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1614);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".textfield__label{margin-bottom:8px;display:block}.textfield__note{position:absolute;top:1px;right:2px}.textfield--error .textfield__label{color:#f75b5b;-webkit-animation:transform-to-error .15s ease-in-out .25s;animation:transform-to-error .15s ease-in-out .25s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.textfield--error .textfield__label:after{content:\":\"}.textfield--is-disabled .textfield__label{color:rgba(177,184,196,.5)}@-webkit-keyframes transform-to-error{to{padding-right:0}}@keyframes transform-to-error{to{padding-right:0}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/TextFieldWithLabel/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA+GE,kBACE,kBACA,aAAc,CACf,iBCxED,kBD2E4B,QElFmB,SAAA,CFmF9C,oCGrCC,cH+CE,2DAAA,mDAAmD,iCACnD,wBAAyB,CAT5B,0CAYK,WAAY,CACb,0CAMD,0BAAqC,CACtC,sCAKH,GACE,eAAgB,CAAA,CAFpB,8BACE,GACE,eAAgB,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * TextFieldWithLabel Component\n */\n\n$context: \".textfield\";\n\n#{$context}{\n  &__label{\n    margin-bottom: baseline(1);\n    display: block;\n  }\n\n  &__note{\n    @include position(absolute, baseline(.125) baseline(.25) null null);\n  }\n\n  &--error{\n    #{$context}__label{\n      $fz: 10;\n      @include textcolor(dangerous);\n      // @include padding(baseline(1) baseline(1.5));\n      // margin-left: baseline(-1.5);\n      // background-color: transparentize(color(dangerous), .9);\n\n      animation: transform-to-error .15s ease-in-out .25s;\n      animation-fill-mode: both;\n\n      &::after{\n        content: \":\";\n      }\n    }\n  }\n\n  &--is-disabled{\n    #{$context}__label{\n      color: transparentize(color(bw6), .5);\n    }\n  }\n}\n\n@keyframes transform-to-error {\n  100%{\n    padding-right: 0;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1616);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-step.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-step.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".checkout__step{background-color:#f9fafb;border-bottom:1px solid #e4e8ed}.checkout__step--is-active{background-color:#fff}.checkout__step__header{padding:30px 32px;-webkit-transition:padding .25s ease-in-out;-o-transition:padding .25s ease-in-out;transition:padding .25s ease-in-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkout__step__header .form-error{top:0}@media screen and (min-width:1152px){.checkout__step__header{padding-right:72px;padding-left:48px}}.checkout__step__title{margin:0}.checkout__step__content-wrapper{margin-right:32px;margin-left:32px;height:0;overflow:hidden}@media screen and (min-width:1152px){.checkout__step__content-wrapper{margin-right:48px;margin-left:48px}.review-step .checkout__step__content-wrapper{margin-right:48px}}.checkout__step__content{position:absolute;top:0;right:0;left:0;border-radius:8px;margin-bottom:120px}.checkout__step__content .heading:first-child{margin-top:0}.checkout__step__content .heading:last-child{margin-bottom:0}.checkout__step__content>div+div{margin-top:24px}@media screen and (min-width:1152px){.checkout__step__content{display:-webkit-box;display:-ms-flexbox;display:flex}.checkout__step__content>div+div{margin-top:0}}.checkout__step__footer{position:absolute;right:0;bottom:-64px;left:0}.checkout__step__check-complete{height:24px;width:24px;background-color:#75dbbe;color:#fff;border-radius:50%;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-animation:show-check-complete .35s cubic-bezier(.175,.885,.32,1.275) .5s backwards;animation:show-check-complete .35s cubic-bezier(.175,.885,.32,1.275) .5s backwards}.checkout__step__check-complete .icon{position:absolute;top:50%;left:50%;width:100%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.checkout__step__check-complete .icon svg{margin:0 auto;width:100%}@-webkit-keyframes show-check-complete{0%{-webkit-transform:scale(0) rotate(45deg);transform:scale(0) rotate(45deg);opacity:0}to{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0);opacity:1}}@keyframes show-check-complete{0%{-webkit-transform:scale(0) rotate(45deg);transform:scale(0) rotate(45deg);opacity:0}to{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0);opacity:1}}.checkout__step--is-active .checkout__step__header{padding-top:40px;padding-bottom:40px}.checkout__step--is-complete .checkout__step__header{cursor:pointer}.checkout__step--is-complete .checkout__step__title{color:#b1b8c4}.checkout__step--is-open .checkout__step__content-wrapper{overflow:visible}.checkout__step--project-details{border-radius:4px 4px 0 0}.checkout__step--project-details__licenses{border-top:1px solid #e4e8ed;padding-top:32px;-ms-flex-preferred-size:100%;flex-basis:100%}.checkout__step--project-details__license-item{background-color:#f9fafb;border-radius:4px;padding-top:16px;padding-right:16px;padding-left:16px;border-bottom:1px solid #d2d9e1}.checkout__step--project-details__license-item+.checkout__step--project-details__license-item{margin-top:16px}.checkout__step--project-details__license-item>:first-child{-webkit-box-flex:1;-ms-flex:1;flex:1}.checkout__step--project-details__license-item>:nth-child(2){-webkit-box-flex:2;-ms-flex:2;flex:2}.checkout__step--project-details__license-item__track{padding-right:16px;padding-bottom:16px;padding-left:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:calc(100% + 32px);left:-16px;border-bottom:1px solid #e4e8ed;margin-bottom:16px}.checkout__step--project-details__license-item__track__info{margin:4px 16px}.checkout__step--project-details__license-item__track__info__title{margin:0}.checkout__step--project-details__license-item__track__info__subtitle{display:block}.checkout__step--project-details__license-item__usages{padding-left:16px}.checkout__step--project-details__license-item__usage{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-bottom:8px}.checkout__step--project-details__license-item__usage:last-child{padding-bottom:16px}.checkout__step--project-details__license-item__usage>:first-child{-webkit-box-flex:1;-ms-flex:1;flex:1}.checkout__step--project-details__license-item__usage>:nth-child(2){-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:128px}@media screen and (min-width:1152px){.checkout__step--project-details .checkout__step__content{-ms-flex-wrap:wrap;flex-wrap:wrap}.checkout__step--project-details__internal-data,.checkout__step--project-details__product-data{padding-top:56px;padding-bottom:32px}.checkout__step--project-details__internal-data>.heading,.checkout__step--project-details__product-data>.heading{position:absolute;top:0}.checkout__step--project-details__product-data{-webkit-box-flex:10;-ms-flex:10;flex:10;padding-right:32px;border-right:1px solid #e4e8ed}.checkout__step--project-details__internal-data{-webkit-box-flex:13;-ms-flex:13;flex:13;padding-left:32px}.checkout__step--project-details__license-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.checkout__step--project-details__license-item__track{padding-bottom:0;border-bottom:0;margin-bottom:0}.checkout__step--project-details__license-item__usages{padding-left:0}.checkout__step--project-details__license-item__usage{padding-bottom:16px}.checkout__step--project-details__license-item__usage+.checkout__step--project-details__license-item__usage{border-top:1px solid #e4e8ed;padding-top:16px}}@media screen and (min-width:1024px){.checkout__step--license-information .checkout__step__content>:first-child{-webkit-box-flex:2;-ms-flex:2;flex:2;padding-right:32px;border-right:1px solid #e4e8ed}.checkout__step--license-information .checkout__step__content>:nth-child(2){-webkit-box-flex:1;-ms-flex:1;flex:1;padding-left:32px}}.checkout__step--billing-information .checkout__step__content .checkbox-same-address+.checkout__step--billing-information__form,.checkout__step--billing-information .checkout__step__content .checkbox-same-address+.heading{margin-top:32px}.checkout__step--billing-information .address-form{border-bottom:1px solid #e4e8ed;padding-bottom:32px;margin-bottom:24px}.checkout__step--billing-information .invoice__payment-methods__item{margin-right:32px}.checkout__step--billing-information .invoice__payment-methods__item__information{background-color:#f0f6fa;min-height:auto;padding:16px;-webkit-print-color-adjust:exact}@media screen and (min-width:1024px){.checkout__step--billing-information .checkout__step__content>:first-child{-ms-flex-preferred-size:66.6667%;flex-basis:66.6667%}}.checkout__step--review{border-radius:0 0 4px 4px}.checkout__step--review .checkout__step__content{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:0}@media screen and (min-width:1024px){.checkout__step--review .checkout__step__content{margin-bottom:16px}}.checkout__step--review__licenses{border-top:1px solid #e4e8ed;left:-16px;width:calc(100% + 32px);margin-bottom:32px}.checkout__step--review__license-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e4e8ed;padding:8px 16px}.checkout__step--review__license-item>div{margin-right:16px}.checkout__step--review__license-item>:first-child{-webkit-box-flex:3;-ms-flex:3;flex:3}.checkout__step--review__license-item>:nth-child(2){-webkit-box-flex:6;-ms-flex:6;flex:6}.checkout__step--review__license-item>:nth-child(3){-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:right}.checkout__step--review__information{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:32px;left:-16px;width:calc(100% + 32px);padding-left:16px}.checkout__step--review__information__section{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;padding-right:16px}.checkout__step--review__information__section__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkout__step--review__information__section__header .heading{margin:0}.checkout__step--review__information__item{margin-top:12px;margin-bottom:12px}.checkout__step--review__information__item__title{display:block}@media screen and (min-width:1024px){.checkout__step--review__information{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.checkout__step--review__information__section{-webkit-box-flex:1;-ms-flex:1;flex:1}}.checkout__step--review__summary{background-color:#f9fafb;border-radius:4px;left:-32px;width:calc(100% + 64px);padding:8px 32px 32px;overflow:hidden}.checkout__step--review .checkout__amounts{margin-bottom:24px}.checkout__step--review .checkout__amounts__item{left:-16px;width:calc(100% + 32px)}.checkout__step--review .checkout__amounts__item:not(:last-child){-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.checkout__step--review .checkout__amounts__item .heading{margin:0}.checkout__step--review__agreements{margin-bottom:32px}.checkout__step--review__agreements__item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.checkout__step--review__agreements__item .checkbox{-webkit-box-flex:0;-ms-flex:none;flex:none}.checkout__step--review__agreements__item__text{margin-left:8px;top:-1px}.checkout__step--review__button-order{width:100%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/checkout-step.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/_checkout-step--project.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon-neat/app/assets/stylesheets/grid/_media.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/_checkout-step--license.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/_checkout-step--billing.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/_checkout-step--review.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,gBCnCI,yBDqCF,+BCnGyB,CDqGzB,2BCvCE,qBAvCU,CDgFX,wBEXC,kBFeA,4CAAA,uCAAA,oCAAoC,oBACpC,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,kBAAmB,CALpB,oCAQG,KAAM,CACP,qCATH,wBAYI,mBACA,iBG9F2C,CHgG9C,CAAA,uBAGC,QAAS,CACV,iCE9CuB,kBAKA,iBF6CtB,SAAS,eACO,CASjB,qCAZD,iCEhDwB,kBAKA,gBC3DuB,CH8G3C,8CACE,iBG/GyC,CHgH1C,CAAA,yBIzGL,kBJ8G4B,MAAG,QAAE,OAAO,kBAEtC,mBGvH6C,CHoH9C,8CAKuB,YAAc,CALrC,6CAMsB,eAAiB,CANvC,iCAQe,eG5H+B,CH4HL,qCAR1C,yBAWI,oBAAA,oBAAA,YAAa,CAXhB,iCAYiB,YAAc,CAAE,CAAA,wBIzHlC,kBJ8H4B,QAAQ,aGrIW,MHqII,CAClD,gCK9HC,YFR6C,WFsC7C,yBAtDoB,WAeV,kBD8IV,oCAAA,+BAAA,4BAA4B,2FAE5B,kFAAgE,CAPjE,sCIjID,kBJ2I8B,QAAK,SAAc,WAClC,uCACX,mCAAA,8BAAgC,CAZnC,0CAeK,cAAc,UACH,CACZ,uCAID,GACE,yCAAA,iCAAiC,SACvB,CAAA,GAGV,qCAAA,6BAA6B,SACnB,CAAA,CAPd,+BACE,GACE,yCAAA,iCAAiC,SACvB,CAAA,GAGV,qCAAA,6BAA6B,SACnB,CAAA,CAAA,mDElHM,iBASE,mBC1DuB,CH0K9C,qDAGC,cAAe,CAChB,oDChIC,aAxEuB,CD4MxB,0DAGC,gBAAiB,CAClB,iCMlND,yBAAgD,CAEhD,2CACE,6BLCuB,iBEwBsB,6BGvB7C,eAAgB,CACjB,+CL4DC,yBA5DsB,kBCuEF,iBAKE,mBAQA,kBC9DuB,+BFzB1B,CKKpB,8FAOG,eHa2C,CGpB9C,4DAUmB,mBAAA,WAAA,MAAQ,CAV3B,6DAWmB,mBAAA,WAAA,MAAQ,CAAE,sDJ+DN,mBAOA,oBACA,kBC9DuB,oBGL3C,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,wBACe,WHGS,gCFxBtB,kBEwBsB,CGG3C,4DJiEF,eCpE6C,CGMzC,mEACE,QAAS,CACV,sEAGC,aAAc,CACf,uDAKH,iBHjB2C,CGkB5C,sDAGC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kBHtBwB,CGoB5C,iEAMG,mBH1ByC,CGoB5C,mEASmB,mBAAA,WAAA,MAAQ,CAT3B,oEAUmB,mBAAA,WAAA,OAAO,eH9BkB,CImD7C,qCDhFJ,0DAiEM,mBAAA,cAAe,CAChB,+FAGC,iBHxC2C,mBAAA,CGuC5C,iHFhCH,kBAII,KEiC+B,CAC9B,+CAID,oBAAA,YAAA,QAAQ,mBHjDmC,8BFxBtB,CK4EtB,gDAGC,oBAAA,YAAA,QAAQ,iBHvDmC,CGyD5C,+CAGC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,wBAC9B,qBAAA,sBAAuB,CAEvB,sDACE,iBAAiB,gBACD,eACA,CACjB,uDAGC,cAAe,CAChB,sDAGC,mBH3EyC,CG0E1C,4GAIG,6BLtGiB,gBEwBsB,CGgFxC,CC7BL,qCChFJ,2EAIQ,mBAAA,WAAA,OAAO,mBLyBkC,8BFxBtB,COL3B,4EASQ,mBAAA,WAAA,OAAO,iBLoBkC,CKlB1C,CAAA,8NCPD,eNyB2C,CM7BjD,mDASI,gCRJuB,oBEwBsB,kBAAA,CM7BjD,qEAgBM,iBNa2C,CM7BjD,kFRmEI,yBAzDuB,gBQUH,aNSyB,gCMPR,CF0DrC,qCEhFJ,2EA8BQ,iCAAA,mBAAoB,CACrB,CAAA,wBChCL,yBCKoB,CDNtB,iDAII,4BAAA,6BAAA,0BAAA,sBAAsB,eACN,CH6EhB,qCGlFJ,iDAQM,kBPuB2C,COrB9C,CAAA,kCAGC,6BTNuB,WEwBsB,wBOhBX,kBPgBW,COd9C,sCAGC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,gCTfI,gBEwBsB,COZ9C,0CAQS,iBPIqC,COZ9C,mDAUmB,mBAAA,WAAA,MAAQ,CAV3B,oDAWmB,mBAAA,WAAA,MAAQ,CAX3B,oDAYmB,mBAAA,WAAA,OAAO,gBAAmB,CAAI,qCAIhD,oBAAA,oBAAA,aAAa,mBACb,eAAe,mBPL8B,WAAA,wBOQX,iBPRW,COW7C,8CACE,mBAAA,iBAAA,aAAa,kBPZ8B,COgB3C,sDACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAFpB,+DAIW,QAAU,CAAE,2CR6BN,gBASE,kBC1DuB,CO0B3C,kDACE,aAAc,CHwBlB,qCGhDF,qCA6BI,qBAAA,gBAAiB,CACjB,8CAAY,mBAAA,WAAA,MAAQ,CAAE,CAAA,iCTKxB,yBA5DsB,kBUHJ,WRyB2B,wBOyCX,sBPzCW,eO2C7B,CA1EpB,2CA8EI,kBP/C6C,CO/BjD,iDAiFM,WPlD2C,uBOmDT,CAlFxC,kEAqFQ,iCT9EmB,wBAAA,CSP3B,0DAwFgB,QAAU,CAAE,oCAKxB,kBP9D6C,COgE7C,0CACE,oBAAA,oBAAA,aAAa,wBACb,qBAAA,sBAAuB,CAFxB,oDAKG,mBAAA,cAAA,SAAU,CACX,gDAGC,gBPzEyC,QO0EhC,CACV,sCAKH,UAAW,CACZ","file":"checkout-step.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CheckoutStep Component\n */\n\n.checkout__step{\n  @include bgcolor(bw2);\n  border-bottom: 1px solid uicolor(border);\n\n  &--is-active{\n    @include bgcolor(white);\n  }\n\n  &__header{\n    @include padding(baseline(3.75) baseline(4) baseline(3.75) baseline(4));\n    transition: padding .25s ease-in-out;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .form-error{\n      top: 0;\n    }\n\n    @include media(breakpoint(desktop-m)) {\n      padding-right: baseline(9);\n      padding-left: baseline(6);\n    }\n  }\n\n  &__title{\n    margin: 0;\n  }\n\n  &__content-wrapper{\n    @include margin(null baseline(4) null baseline(4));\n    height: 0;\n    overflow: hidden;\n\n    @include media(breakpoint(desktop-m)) {\n      @include margin(null baseline(6) null baseline(6));\n\n      .review-step & {\n        margin-right: baseline(6);\n      }\n    }\n  }\n\n  &__content{\n    @include position(absolute, 0 0 null 0);\n    @include bgsize(large);\n    margin-bottom: baseline(15);\n\n    .heading:first-child{ margin-top: 0 }\n    .heading:last-child{ margin-bottom: 0 }\n\n    > div + div { margin-top: baseline(3) }\n\n    @include media(breakpoint(desktop-m)) {\n      display: flex;\n      > div + div { margin-top: 0 }\n    }\n  }\n\n  &__footer{\n    @include position(absolute, null 0 baseline(-8) 0);\n  }\n\n  &__check-complete{\n    @include size(baseline(3));\n    @include bgcolor(positive);\n    @include textcolor(white);\n    @include bgsize(circle);\n    transition: .15s ease-in-out;\n\n    animation: show-check-complete .35s $ease-out-back .5s backwards;\n\n    .icon{\n      @include position(absolute, 50% null null 50%);\n      width: 100%;\n      transform: translate(-50%, -50%);\n\n      svg{\n        margin: 0 auto;\n        width: 100%;\n      }\n    }\n\n    @keyframes show-check-complete {\n      0% {\n        transform: scale(0) rotate(45deg);\n        opacity: 0;\n      }\n      100% {\n        transform: scale(1) rotate(0);\n        opacity: 1;\n      }\n    }\n  }\n\n  &--is-active &__header{\n    @include padding(baseline(5) null);\n  }\n\n  &--is-complete &__header{\n    cursor: pointer;\n  }\n\n  &--is-complete &__title{\n    @include textcolor(bw6);\n  }\n\n  &--is-open &__content-wrapper{\n    overflow: visible;\n  }\n}\n\n@import\n  \"checkout-step--project\",\n  \"checkout-step--license\",\n  \"checkout-step--billing\",\n  \"checkout-step--review\";\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Checkout Step: Project Details Component\n */\n\n$context: \".checkout__step\";\n\n#{$context}--project-details{\n  border-radius: radius(medium) radius(medium) 0 0;\n\n  &__licenses{\n    border-top: 1px solid uicolor(border);\n    padding-top: baseline(4);\n    flex-basis: 100%;\n  }\n\n  &__license-item{\n    @include bgcolor(bw2);\n    @include bgsize(medium);\n    @include padding(baseline(2) baseline(2) null);\n    border-bottom: 1px solid color(bw5);\n\n    & + & {\n      margin-top: baseline(2);\n    }\n\n    > :nth-child(1) { flex: 1 }\n    > :nth-child(2) { flex: 2 }\n\n    &__track{\n      @include padding(null baseline(2) baseline(2));\n      display: flex;\n      align-items: center;\n      width: calc(100% + #{baseline(4)});\n      left: baseline(-2);\n\n      border-bottom: 1px solid uicolor(border);\n      margin-bottom: baseline(2);\n\n      &__info{\n        @include margin(baseline(.5) baseline(2));\n\n        &__title{\n          margin: 0;\n        }\n\n        &__subtitle{\n          display: block;\n        }\n      }\n    }\n\n    &__usages{\n      padding-left: baseline(2);\n    }\n\n    &__usage{\n      display: flex;\n      align-items: center;\n      padding-bottom: baseline(1);\n\n      &:last-child{\n        padding-bottom: baseline(2);\n      }\n\n      > :nth-child(1) { flex: 1 }\n      > :nth-child(2) { flex: 1; max-width: baseline(16) }\n    }\n  }\n\n  @include media(breakpoint(desktop-m)) {\n    #{$context}__content{\n      flex-wrap: wrap;\n    }\n\n    &__product-data, &__internal-data {\n      padding-top: baseline(7);\n      padding-bottom: baseline(4);\n\n      > .heading {\n        @include position(absolute, 0 null null);\n      }\n    }\n\n    &__product-data{\n      flex: 10;\n      padding-right: baseline(4);\n      border-right: 1px solid uicolor(border);\n    }\n\n    &__internal-data{\n      flex: 13;\n      padding-left: baseline(4);\n    }\n\n    &__license-item{\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      &__track{\n        padding-bottom: 0;\n        border-bottom: 0;\n        margin-bottom: 0;\n      }\n\n      &__usages{\n        padding-left: 0;\n      }\n\n      &__usage{\n        padding-bottom: baseline(2);\n\n        & + & {\n          border-top: 1px solid uicolor(border);\n          padding-top: baseline(2);\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Outputs a media-query block with an optional grid context (the total number of columns used in the grid).\n///\n/// @param {List} $query\n///   A list of media query features and values, where each `$feature` should have a corresponding `$value`.\n///   For a list of valid values for `$feature`, click [here](http://www.w3.org/TR/css3-mediaqueries/#media1).\n///\n///   If there is only a single `$value` in `$query`, `$default-feature` is going to be used.\n///\n///   The number of total columns in the grid can be set by passing `$columns` at the end of the list (overrides `$total-columns`).\n///\n///\n/// @param {Number (unitless)} $total-columns [$grid-columns]\n///   - Number of columns to use in the new grid context. Can be set as a shorthand in the first parameter.\n///\n/// @example scss - Usage\n///   .responsive-element {\n///      @include media(769px) {\n///        @include span-columns(6);\n///      }\n///   }\n///\n///  .new-context-element {\n///    @include media(min-width 320px max-width 480px, 6) {\n///      @include span-columns(6);\n///    }\n///  }\n///\n/// @example css - CSS Output\n///  @media screen and (min-width: 769px) {\n///    .responsive-element {\n///      display: block;\n///      float: left;\n///      margin-right: 2.35765%;\n///      width: 48.82117%;\n///    }\n///\n///    .responsive-element:last-child {\n///      margin-right: 0;\n///    }\n///  }\n///\n///  @media screen and (min-width: 320px) and (max-width: 480px) {\n///    .new-context-element {\n///      display: block;\n///      float: left;\n///      margin-right: 4.82916%;\n///      width: 100%;\n///    }\n///\n///    .new-context-element:last-child {\n///      margin-right: 0;\n///    }\n///  }\n\n@mixin media($query: $feature $value $columns, $total-columns: $grid-columns) {\n  @if length($query) == 1 {\n    @media screen and ($default-feature: nth($query, 1)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: $total-columns !global;\n      @content;\n      $grid-columns: $default-grid-columns !global;\n    }\n  } @else {\n    $loop-to: length($query);\n    $media-query: \"screen and \";\n    $default-grid-columns: $grid-columns;\n    $grid-columns: $total-columns !global;\n\n    @if is-not(is-even(length($query))) {\n      $grid-columns: nth($query, $loop-to) !global;\n      $loop-to: $loop-to - 1;\n    }\n\n    $i: 1;\n    @while $i <= $loop-to {\n      $media-query: $media-query + \"(\" + nth($query, $i) + \": \" + nth($query, $i + 1) + \") \";\n\n      @if ($i + 1) != $loop-to {\n        $media-query: $media-query + \"and \";\n      }\n\n      $i: $i + 2;\n    }\n\n    @media #{$media-query} {\n      @content;\n      $grid-columns: $default-grid-columns !global;\n    }\n  }\n}\n","/**\n * Checkout Step: License Information Component\n */\n\n$context: \".checkout__step\";\n\n#{$context}--license-information{\n  @include media(breakpoint(desktop)) {\n    #{$context}__content{\n      > :nth-child(1){\n        flex: 2;\n        padding-right: baseline(4);\n        border-right: 1px solid uicolor(border);\n      }\n      > :nth-child(2){\n        flex: 1;\n        padding-left: baseline(4);\n      }\n    }\n  }\n}\n","/**\n * Checkout Step: Billing Information Component\n */\n\n$context: \".checkout__step\";\n\n#{$context}--billing-information{\n  #{$context}__content{\n    .checkbox-same-address+.heading,\n    .checkbox-same-address+.checkout__step--billing-information__form{\n      margin-top: baseline(4);\n    }\n  }\n\n  .address-form{\n    border-bottom: 1px solid uicolor(border);\n    padding-bottom: baseline(4);\n    margin-bottom: baseline(3);\n  }\n\n  .invoice__payment-methods {\n    &__item{\n      margin-right: baseline(4);\n\n      &__information{\n        @include bgcolor(bw3);\n        min-height: auto;\n        padding: baseline(2);\n        -webkit-print-color-adjust: exact;\n      }\n    }\n  }\n\n  @include media(breakpoint(desktop)) {\n    #{$context}__content{\n      > :nth-child(1){\n        flex-basis: 66.6667%;\n      }\n    }\n  }\n}\n","/**\n * Checkout Step: Review Component\n */\n\n.checkout__step--review{\n  border-radius: 0 0 radius(medium) radius(medium);\n\n  .checkout__step__content{\n    flex-direction: column;\n    margin-bottom: 0;\n\n    @include media(breakpoint(desktop)) {\n      margin-bottom: baseline(2);\n    }\n  }\n\n  &__licenses{\n    border-top: 1px solid uicolor(border);\n    left: baseline(-2);\n    width: calc(100% + #{baseline(4)});\n    margin-bottom: baseline(4);\n  }\n\n  &__license-item{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    border-bottom: 1px solid uicolor(border);\n    padding: baseline(1) baseline(2);\n\n    > div { margin-right: baseline(2) }\n\n    > :nth-child(1) { flex: 3 }\n    > :nth-child(2) { flex: 6 }\n    > :nth-child(3) { flex: 1; text-align: right; }\n  }\n\n  &__information{\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: baseline(4);\n    left: baseline(-2);\n    width: calc(100% + #{baseline(4)});\n    padding-left: baseline(2);\n\n    &__section{\n      flex: 0 0 50%;\n\n      padding-right: baseline(2);\n\n      &__header{\n        display: flex;\n        align-items: center;\n\n        .heading{ margin: 0 }\n      }\n    }\n\n    &__item{\n      @include margin(baseline(1.5) null);\n      &__title{\n        display: block;\n      }\n    }\n\n    @include media(breakpoint(desktop)) {\n      flex-wrap: nowrap;\n      &__section{ flex: 1 }\n    }\n  }\n\n  &__summary{\n    @include bgcolor(bw2);\n    @include bgsize(medium);\n    left: baseline(-4);\n    width: calc(100% + #{baseline(8)});\n    padding: baseline(1) baseline(4) baseline(4);\n    overflow: hidden;\n  }\n\n  .checkout__amounts{\n    margin-bottom: baseline(3);\n\n    &__item{\n      left: baseline(-2);\n      width: calc(100% + #{baseline(4)});\n\n      &:not(:last-child) {\n        box-shadow: 0 1px uicolor(border);\n      }\n\n      .heading{ margin: 0 }\n    }\n  }\n\n  &__agreements{\n    margin-bottom: baseline(4);\n\n    &__item{\n      display: flex;\n      align-items: flex-start;\n\n      .checkbox{\n        flex: none;\n      }\n\n      &__text{\n        margin-left: baseline(1);\n        top: -1px;\n      }\n    }\n  }\n\n  &__button-order{\n    width: 100%;\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutStepLicense Component
 */
/* tslint:disable:no-submodule-imports */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __webpack_require__(52);
var checkout_1 = __webpack_require__(92);
var string_1 = __webpack_require__(47);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var utils_1 = __webpack_require__(125);
var Heading_1 = __webpack_require__(9);
var FormCell_1 = __webpack_require__(234);
var FormRow_1 = __webpack_require__(235);
var Select_1 = __webpack_require__(200);
var TextFieldWithLabel_1 = __webpack_require__(236);
var AddressForm_1 = __webpack_require__(660);
var CheckoutStep_1 = __webpack_require__(303);
var config_1 = __webpack_require__(80);
var stepId = config_1.CheckoutStepId.license;
var form = config_1.CheckoutStepFormName.license;
var formValidations = lodash_1.extend({
    'representative.email': {
        validator: string_1.validateEmail,
        error: locales_1.default.validations.email
    },
    'representative.role': {
        error: 'Please select the authorized representative role.'
    }
}, AddressForm_1.getAddressFormValidations());

var CheckoutStepLicense = function (_React$Component) {
    _inherits(CheckoutStepLicense, _React$Component);

    function CheckoutStepLicense(props) {
        _classCallCheck(this, CheckoutStepLicense);

        var _this = _possibleConstructorReturn(this, (CheckoutStepLicense.__proto__ || Object.getPrototypeOf(CheckoutStepLicense)).call(this, props));

        _this.representativeRolesForSelect = props.representativeRoles.edges.map(function (_ref) {
            var node = _ref.node;

            return {
                value: node.id,
                label: node.name
            };
        });
        _this.representativeRolesForSelect = lodash_1.sortBy(_this.representativeRolesForSelect, 'label');
        return _this;
    }

    _createClass(CheckoutStepLicense, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.consumeLocalStorage();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                error = _props.error,
                handleSubmit = _props.handleSubmit,
                submitting = _props.submitting;

            return React.createElement(CheckoutStep_1.default, { error: error, formValidations: formValidations, id: stepId, handleSubmit: handleSubmit, submitting: submitting, title: "Licensee Information" }, React.createElement("div", null, React.createElement(Heading_1.default, { is: "h5" }, "Tell us about your company."), React.createElement(AddressForm_1.default, { form: form })), React.createElement("div", null, React.createElement(Heading_1.default, { is: "h5" }, "Authorized Representative"), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(redux_form_1.Field, { name: "representative.name", component: TextFieldWithLabel_1.default, label: "Name", colorScheme: "light" }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(Select_1.default, { form: form, label: "Role", name: "representative.role", options: this.representativeRolesForSelect, selectName: "representative-role-select", selectProps: {
                    autoBlur: true,
                    clearable: false
                } }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(utils_1.FieldEmail, { name: "representative.email", component: TextFieldWithLabel_1.default, label: "Email address", colorScheme: "light", onlyValidateIfTouched: true }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(redux_form_1.Field, { name: "representative.phone", component: TextFieldWithLabel_1.default, label: "Phone Number", colorScheme: "light", optional: true })))));
        }
    }]);

    return CheckoutStepLicense;
}(React.Component);

var CheckoutStepLicenseForm = redux_form_1.reduxForm({
    form: form
})(CheckoutStepLicense);
var ConnectedCheckoutStepLicense = react_redux_1.connect(function (_ref2, ownProps) {
    var localStorage = _ref2.checkout.localStorage;
    return {
        initialValues: localStorage && lodash_1.get(localStorage, stepId, {})
    };
}, function (dispatch) {
    return {
        consumeLocalStorage: function consumeLocalStorage() {
            return dispatch(checkout_1.consumeLocallyStoredStep({ id: stepId }));
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, { consumeLocalStorage: function consumeLocalStorage() {
            return !lodash_1.isEmpty(stateProps.initialValues) && dispatchProps.consumeLocalStorage();
        } });
})(CheckoutStepLicenseForm);
exports.default = ConnectedCheckoutStepLicense;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutStepProject Component
 */
/* tslint:disable:no-submodule-imports */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var checkout_1 = __webpack_require__(92);
var utils_1 = __webpack_require__(125);
var license_1 = __webpack_require__(34);
// import { validateString } from '../../../utils/string';
var track_1 = __webpack_require__(44);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var TextField_1 = __webpack_require__(83);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var FormCell_1 = __webpack_require__(234);
var FormRow_1 = __webpack_require__(235);
var TextAreaWithLabel_1 = __webpack_require__(1619);
var TextFieldWithLabel_1 = __webpack_require__(236);
var CheckoutStep_1 = __webpack_require__(303);
var config_1 = __webpack_require__(80);
var formValidations = {
    // brand: {
    //   validator: validateString,
    //   error: 'Is it a valid brand name?',
    // },
    // product: {
    //   validator: validateString,
    //   error: 'Is it a valid product name?',
    // },
};
var stepId = config_1.CheckoutStepId.project;
var form = config_1.CheckoutStepFormName.project;
var classes = new BEM("checkout__step--" + stepId);

var CheckoutStepProject = function (_React$Component) {
    _inherits(CheckoutStepProject, _React$Component);

    function CheckoutStepProject() {
        _classCallCheck(this, CheckoutStepProject);

        var _this = _possibleConstructorReturn(this, (CheckoutStepProject.__proto__ || Object.getPrototypeOf(CheckoutStepProject)).apply(this, arguments));

        _this.renderAirDates = function (lineItem, index) {
            var track = lineItem.track;
            var image = track_1.getResponsiveTrackThumbnail(track);
            var usages = lineItem.license.usages.map(function (_ref) {
                var id = _ref.id,
                    components = _ref.components;
                return license_1.generateLicenseUsageFromComponents(components, id);
            });
            return React.createElement("div", Object.assign({ key: lineItem.id }, classes('license-item')), React.createElement("div", Object.assign({}, classes('license-item__track')), React.createElement(Thumbnail_1.default, Object.assign({ responsiveAssets: image, size: "xsmall" }, classes('license-item__track__image'))), React.createElement("div", Object.assign({}, classes('license-item__track__info')), React.createElement(Heading_1.default, Object.assign({ is: "h5", text: track.title, maxTextLength: 15 }, classes('license-item__track__info__title'))), React.createElement(Label_1.Span, Object.assign({ text: track.artist.name, size: "small", textColor: "bw7" }, classes('license-item__track__info__subtitle'))))), React.createElement("div", Object.assign({}, classes('license-item__usages')), usages.map(function (usage, i) {
                return React.createElement("div", Object.assign({ key: "usage-" + track.id + "-" + i }, classes('license-item__usage')), React.createElement(Heading_1.default, { is: "h5", WrappedComponent: "div" }, usage.medium.name), React.createElement(utils_1.FieldDate, { component: TextField_1.default, name: "airDate." + usage.id, colorScheme: "white", placeholder: "YYYY/MM/DD", onlyValidateIfTouched: true }));
            })));
        };
        return _this;
    }

    _createClass(CheckoutStepProject, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.consumeLocalStorage();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                order = _props.order,
                error = _props.error,
                handleSubmit = _props.handleSubmit,
                submitting = _props.submitting;

            return React.createElement(CheckoutStep_1.default, { defaultSelected: true, error: error, formValidations: formValidations, id: stepId, handleSubmit: handleSubmit, submitting: submitting, title: "Project Details" }, React.createElement("div", Object.assign({}, classes('product-data')), React.createElement(Heading_1.default, { is: "h5" }, "Tell us about your project."), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(redux_form_1.Field, { name: "brand", component: TextFieldWithLabel_1.default, label: "Brand", colorScheme: "light", autoFocus: true }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(redux_form_1.Field, { name: "product", component: TextFieldWithLabel_1.default, label: "Project Title", colorScheme: "light" })))), React.createElement("div", Object.assign({}, classes('internal-data')), React.createElement(Heading_1.default, { is: "h5" }, "This information is for your own use.", React.createElement("br", null), "It will be displayed on your invoice."), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(redux_form_1.Field, { name: "poNumber", component: TextFieldWithLabel_1.default, label: "PO Number", colorScheme: "light", optional: true })), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement(redux_form_1.Field, { name: "reference", component: TextFieldWithLabel_1.default, label: "Reference", colorScheme: "light", optional: true }))), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: "full" }, React.createElement(redux_form_1.Field, { name: "notes", component: TextAreaWithLabel_1.default, label: "Notes", colorScheme: "light", optional: true })))), React.createElement("div", Object.assign({}, classes('licenses')), React.createElement(Heading_1.default, { is: "h5" }, "Approximate air date for each media:"), order.license_line_items.map(this.renderAirDates)));
        }
    }]);

    return CheckoutStepProject;
}(React.Component);

var CheckoutStepProjectForm = redux_form_1.reduxForm({
    form: form
})(CheckoutStepProject);
var ConnectedCheckoutStepProject = react_redux_1.connect(function (_ref2, ownProps) {
    var localStorage = _ref2.checkout.localStorage;
    return {
        initialValues: localStorage && lodash_1.get(localStorage, stepId, {})
    };
}, function (dispatch) {
    return {
        consumeLocalStorage: function consumeLocalStorage() {
            return dispatch(checkout_1.consumeLocallyStoredStep({ id: stepId }));
        }
    };
}, function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, { consumeLocalStorage: function consumeLocalStorage() {
            return !lodash_1.isEmpty(stateProps.initialValues) && dispatchProps.consumeLocalStorage();
        } });
})(CheckoutStepProjectForm);
exports.default = ConnectedCheckoutStepProject;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TextAreaWithLabel Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1620);
var TextArea_1 = __webpack_require__(1622);
var Label_1 = __webpack_require__(8);
var classes = new BEM('textfield');

var TextAreaWithLabel = function (_React$Component) {
    _inherits(TextAreaWithLabel, _React$Component);

    function TextAreaWithLabel() {
        _classCallCheck(this, TextAreaWithLabel);

        return _possibleConstructorReturn(this, (TextAreaWithLabel.__proto__ || Object.getPrototypeOf(TextAreaWithLabel)).apply(this, arguments));
    }

    _createClass(TextAreaWithLabel, [{
        key: "focus",
        value: function focus() {
            this.textfield.focus();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                label = _a.label,
                note = _a.note,
                fieldProps = __rest(_a, ["label", "note"]);
            var optional = this.props.optional;
            var name = this.props.input ? this.props.input.name : this.props.name;
            var noteLabel = null;
            if (note || optional != null) {
                var noteProps = Object.assign({ size: 'small', variant: 'note' }, classes('note'));
                noteLabel = React.createElement(Label_1.default, Object.assign({}, noteProps), note || 'Optional');
            }
            return React.createElement(TextArea_1.default, Object.assign({ ref: function ref(node) {
                    return _this2.textfield = node;
                } }, fieldProps), React.createElement(Label_1.default, Object.assign({ text: label, size: "small", htmlFor: name }, classes('label'))), noteLabel, this.props.children);
        }
    }]);

    return TextAreaWithLabel;
}(React.Component);

exports.default = TextAreaWithLabel;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1621);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".textarea__label{margin-bottom:8px;display:block}.textarea__note{position:absolute;top:1px;right:2px}.textarea--error .textarea__label{color:#f75b5b;-webkit-animation:transform-to-error .15s ease-in-out .25s;animation:transform-to-error .15s ease-in-out .25s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.textarea--error .textarea__label:after{content:\":\"}.textarea--is-disabled .textarea__label{color:rgba(177,184,196,.5)}@-webkit-keyframes transform-to-error{to{padding-right:0}}@keyframes transform-to-error{to{padding-right:0}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/forms/TextAreaWithLabel/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA+GE,iBACE,kBACA,aAAc,CACf,gBCxED,kBD2E0B,QElFqB,SAAA,CFmF9C,kCGrCC,cH+CE,2DAAA,mDAAmD,iCACnD,wBAAyB,CAT5B,wCAYK,WAAY,CACb,wCAMD,0BAAqC,CACtC,sCAKH,GACE,eAAgB,CAAA,CAFpB,8BACE,GACE,eAAgB,CAAA,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n* TextAreaWithLabel Component\n*/\n\n$context: \".textarea\";\n\n#{$context}{\n  &__label{\n    margin-bottom: baseline(1);\n    display: block;\n  }\n\n  &__note{\n  @include position(absolute, baseline(.125) baseline(.25) null null);\n  }\n\n  &--error{\n    #{$context}__label{\n      $fz: 10;\n      @include textcolor(dangerous);\n      // @include padding(baseline(1) baseline(1.5));\n      // margin-left: baseline(-1.5);\n      // background-color: transparentize(color(dangerous), .9);\n\n      animation: transform-to-error .15s ease-in-out .25s;\n      animation-fill-mode: both;\n\n      &::after{\n        content: \":\";\n      }\n    }\n  }\n\n  &--is-disabled{\n    #{$context}__label{\n      color: transparentize(color(bw6), .5);\n    }\n  }\n}\n\n@keyframes transform-to-error {\n  100%{\n    padding-right: 0;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TextArea Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = __webpack_require__(143);
__webpack_require__(1623);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Label_1 = __webpack_require__(8);
var classes = new BEM('textarea');

var TextArea = function (_React$Component) {
    _inherits(TextArea, _React$Component);

    function TextArea(props) {
        _classCallCheck(this, TextArea);

        var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

        _this.onChange = function (e) {
            var event = lodash_1.clone(e);
            var newValue = e.target.value;
            _this.setState({ value: newValue }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(event, newValue);
                }
            });
        };
        _this.onToggleFocus = function (e) {
            var event = lodash_1.clone(e);
            var eventType = e.type;
            var value = _this.state.value;

            if (eventType === 'focus') {
                e.target.select();
            }
            _this.setState({
                isFocus: eventType === 'focus' ? true : false
            }, function () {
                /* tslint:disable:no-unused-expression */
                eventType === 'focus' && _this.props.onFocus && _this.props.onFocus(event, value);
                eventType === 'blur' && _this.props.onBlur && _this.props.onBlur(event, value);
            });
        };
        _this.state = {
            isFocus: false,
            value: _this.props.value || ''
        };
        return _this;
    }

    _createClass(TextArea, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.isControlled || !nextProps.value) {
                return;
            }
            if (this.state.value !== nextProps.value) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(lodash_1.isEqual(nextProps, this.props) && lodash_1.isEqual(nextState, this.state));
        }
    }, {
        key: "render",
        value: function render() {
            var _modifiers,
                _this2 = this;

            /* tslint:disable:no-unused-variable */
            var _props = this.props,
                autoFocus = _props.autoFocus,
                children = _props.children,
                className = _props.className,
                colorScheme = _props.colorScheme,
                disabled = _props.disabled,
                input = _props.input,
                inputProps = _props.inputProps,
                meta = _props.meta,
                _props$name = _props.name,
                name = _props$name === undefined ? this.props.input ? this.props.input.name : '' : _props$name,
                onlyValidateIfTouched = _props.onlyValidateIfTouched,
                placeholder = _props.placeholder,
                size = _props.size,
                style = _props.style;

            var modifiers = (_modifiers = {
                'is-focus': this.state.isFocus,
                'is-disabled': disabled
            }, _defineProperty(_modifiers, size, size), _defineProperty(_modifiers, 'error', meta && meta.touched && meta.error), _defineProperty(_modifiers, 'warning', meta && meta.touched && meta.warning), _modifiers);
            var extraClasses = classNames(colorScheme && color_schemes_1.getColorSchemeClassName(colorScheme, 'textarea'), className);
            var inputControlProps = input ? {
                onFocus: function onFocus(e) {
                    _this2.onToggleFocus(e);input.onFocus(e, e.target.value, null);
                },
                onBlur: function onBlur(e) {
                    _this2.onToggleFocus(e);input.onBlur(e, e.target.value, null);
                },
                onChange: function onChange(e) {
                    _this2.onChange(e);input.onChange(e, e.target.value, null);
                },
                value: input.value
            } : {
                onFocus: this.onToggleFocus,
                onBlur: this.onToggleFocus,
                onChange: this.onChange,
                value: this.state.value
            };
            var labelClasses = new BEM('label');
            return React.createElement("div", Object.assign({}, classes('', modifiers, extraClasses), { style: style }), React.createElement("div", Object.assign({}, classes('background'))), children, meta && ((onlyValidateIfTouched && meta.touched || !onlyValidateIfTouched) && meta.error && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'error'), { size: "medium", textColor: "dangerous" }), meta.error) || meta.warning && React.createElement(Label_1.Span, Object.assign({}, labelClasses('', 'warning'), { size: "medium" }), meta.warning)), React.createElement("textarea", Object.assign({ id: name, name: name }, classes('input'), { placeholder: placeholder, autoFocus: autoFocus }, inputControlProps, inputProps)));
        }
    }]);

    return TextArea;
}(React.Component);

TextArea.defaultProps = {
    optional: false,
    size: 'medium'
};
exports.default = TextArea;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1624);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".textarea{padding:1px}.textarea--small .textarea__background{border-radius:4px;height:60px}.textarea--small .textarea__input{padding-top:9px;padding-bottom:9px;padding-left:12px;width:100%;height:58px;font-size:.8125em}.textarea--medium .textarea__background{border-radius:4px;height:108px}.textarea--medium .textarea__input{padding-top:9px;padding-bottom:9px;padding-left:12px;width:100%;height:106px;font-size:.8125em}.textarea--large .textarea__background{border-radius:4px;height:176px}.textarea--large .textarea__input{padding-top:18px;padding-bottom:18px;padding-left:24px;width:100%;height:174px;font-size:.875em}.textarea__background{position:absolute;right:0;bottom:0;left:0;background-color:#f0f6fa;-webkit-transition:-webkit-transform .1s ease-in-out;transition:-webkit-transform .1s ease-in-out;-o-transition:transform .1s ease-in-out;transition:transform .1s ease-in-out;transition:transform .1s ease-in-out,-webkit-transform .1s ease-in-out}.textfield--is-disabled .textarea__background{background-color:#f9fafb}.textarea__input{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font:inherit;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;display:block;border:0;resize:none}.textarea__input::-webkit-input-placeholder{color:#b1b8c4}.textarea__input::-ms-input-placeholder{color:#b1b8c4}.textarea__input::placeholder{color:#b1b8c4}.textarea__input:focus{outline:0}.textarea__input:invalid{-webkit-box-shadow:none;box-shadow:none}.textarea__input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #f5faff inset;box-shadow:inset 0 0 0 1000px #f5faff}.textarea--is-disabled .textarea__input::-webkit-input-placeholder{color:rgba(177,184,196,.5)}.textarea--is-disabled .textarea__input::-ms-input-placeholder{color:rgba(177,184,196,.5)}.textarea--is-disabled .textarea__input::placeholder{color:rgba(177,184,196,.5)}.textarea-color-scheme--light .textarea__background{background-color:#f9fafb;border:1px solid #d2d9e1}.textarea-color-scheme--light.textarea--is-disabled{color:#b1b8c4}.textarea-color-scheme--light.textarea--is-disabled .textarea__background{background-color:#fff;border-color:#e4e8ed}.textarea-color-scheme--light.textarea--is-focus .textarea__background{border-color:#4487ff}.textarea-color-scheme--white .textarea__background{border-radius:2px;background-color:#fff;border:1px solid #e4e8ed}.textarea-color-scheme--white.textarea--is-disabled{color:#b1b8c4}.textarea-color-scheme--white.textarea--is-disabled .textarea__background{background-color:#f9fafb;border-color:#e4e8ed}.textarea-color-scheme--white.textarea--is-focus .textarea__background{border-color:#4487ff}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/forms/TextArea/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/forms/TextArea/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Label/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA+GA,UACE,WAAY,CAIP,uCCnFD,kBAvBgB,WCyB2B,CFiF1C,kCGvEH,gBACA,mBACA,kBAEA,WAAW,YACmB,iBCnCZ,CJqGf,wCCnFD,kBAvBgB,YCyB2B,CFiF1C,mCGvEH,gBACA,mBACA,kBAEA,WAAW,aACmB,iBCnCZ,CJqGf,uCCnFD,kBAvBgB,YCyB2B,CFiF1C,kCGvEH,iBACA,oBACA,kBAEA,WAAW,aACmB,gBC/Bb,CJuGnB,sBKhFA,kBLiF4B,QAAQ,SAAE,OAAE,yBAEtC,qDAAA,6CAAA,wCAAA,qCAAA,sEAAqC,CAErC,8CMtDA,wBA5DsB,CNoHrB,iBErDD,mCAJqC,kCAKH,aE/BvB,8CACb,yCAAA,sCJuFE,cAAc,SACL,WACG,CAJb,4CMnDC,aAxEuB,CN2HxB,wCMnDC,aAxEuB,CN2HxB,8BMnDC,aAxEuB,CN2HxB,uBAWG,SAAU,CAXb,yBAeG,wBAAA,eAAgB,CAfnB,kCAmBG,8CAAA,qCAAqD,CACtD,mEAGC,0BAAqC,CADvC,+DACE,0BAAqC,CADvC,qDACE,0BAAqC,CACtC,oDMnFD,yBN2FE,wBM1JiB,CNuJpB,oDMhFC,aAxEuB,CNwJxB,0EMxFC,sBNiGI,oBM/JmB,CNsJxB,uEAcK,oBMjKmB,CNkKpB,oDC/ID,kBA1BgB,sBDgLhB,wBM5KqB,CNwKxB,oDMlGC,aAxEuB,CN0KxB,0EM1GC,yBNoHI,oBMlLmB,CNwKxB,uEAeK,oBMpLmB,CNqLpB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * TextArea Component\n */\n\n@import '../../text/Label/mixins';\n@import './mixins';\n\n.textarea{\n  padding: 1px; // Adjustment for borders\n\n  @each $textarea-size, $options in $textarea-sizes {\n    @if $textarea-size != default {\n      &--#{$textarea-size} {\n        @include textarea-for-size(map-merge($options, (size: $textarea-size)));\n      }\n    }\n  }\n\n  &__background{\n    @include position(absolute, null 0 0 0);\n    @include bgcolor(bw3);\n    transition: transform .1s ease-in-out;\n\n    .textfield--is-disabled & {\n      @include bgcolor(bw2);\n    }\n  }\n\n  &__input{\n    @include label;\n    display: block;\n    border: 0;\n    resize: none;\n\n    &::placeholder{\n      @include textcolor(bw6);\n    }\n\n    &:focus{\n      outline: 0;\n    }\n\n    &:invalid {\n      box-shadow: none;\n    }\n\n    &:-webkit-autofill {\n      box-shadow: 0 0 0px 1000px color(accent-subtle) inset;\n    }\n\n    .textarea--is-disabled &::placeholder{\n      color: transparentize(color(bw6), .5);\n    }\n  }\n}\n\n.textarea-color-scheme{\n  &--light{\n    .textarea__background{\n      @include bgcolor(bw2);\n      border: 1px solid color(bw5);\n    }\n    &.textarea--is-disabled{\n      @include textcolor(bw6);\n      .textarea__background{\n        @include bgcolor(white);\n        border-color: uicolor(border);\n      }\n    }\n    &.textarea--is-focus {\n      .textarea__background{\n        border-color: color(accent);\n      }\n    }\n  }\n  &--white{\n    .textarea__background{\n      @include bgsize(small);\n      @include bgcolor(white);\n      border: 1px solid color(bw4);\n    }\n    &.textarea--is-disabled{\n      @include textcolor(bw6);\n      .textarea__background{\n        @include bgcolor(bw2);\n        border-color: uicolor(border);\n      }\n    }\n    &.textarea--is-focus {\n      .textarea__background{\n        border-color: color(accent);\n      }\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * TextArea Component\n */\n\n @import \"../../buttons/Button/mixins\";\n @import \"../../text/Label/mixins\";\n\n/* Definitions */\n$textarea-sizes: (\n  default: (\n    h-padding: 1.5,\n    bg: medium,\n  ),\n  small: (\n    label: medium,\n    height: 7.5,\n  ),\n  medium: (\n    label: medium,\n    height: 13.5,\n  ),\n  large: (\n    label: large,\n    h-padding: 3,\n    height: 22,\n  )\n);\n\n/* Mixins */\n$default-textarea-size-options: map-get($textarea-sizes, default);\n@mixin textarea-for-size($options) {\n  $options: map-merge($default-textarea-size-options, $options);\n  $height: map-get($options, height);\n  $h-padding: map-get($options, h-padding);\n  $label: map-get($options, label);\n  $bg: map-get($options, bg);\n\n  $computed-height: baseline($height);\n\n  .textarea__background{\n    @include bgsize($bg);\n    height: baseline($height);\n  }\n\n  .textarea__input{\n    padding-top: baseline($h-padding * .75);\n    padding-bottom: baseline($h-padding * .75);\n    padding-left: baseline($h-padding);\n\n    width: 100%;\n    height: $computed-height - 2px;\n\n    font-size: map-get(map-get($label-sizes, $label), 'font-size');\n  }\n}\n","/**\n * Labels\n */\n\n/* Definitions */\n$label-sizes: (\n  xsmall: (\n    font-size: .625em,\n    line-height: 1.2,\n  ),\n  small: (\n    font-size: .6875em,\n    line-height: 1.1,\n  ),\n  medium: (\n    font-size: .8125em,\n    line-height: 1.34,\n  ),\n  large: (\n    font-size: .875em,\n    line-height: 1.142857143,\n  ),\n  xlarge: (\n    font-family: $font--articulat,\n    font-size: 1.125em,\n    line-height: 1.333333333333,\n  ),\n  xxlarge: (\n    font-family: $font--articulat,\n    font-size: 1.25em,\n    line-height: 1.2,\n  ),\n);\n\n/* Mixins */\n@function get-label-height($size) {\n  @if map-has-key($label-sizes, $size) {\n    $label-size: map-get($label-sizes, $size);\n    $font-size: map-get($label-size, 'font-size');\n    $line-height: map-get($label-size, 'line-height');\n    @return strip-unit($font-size) * $line-height * 16;\n  }\n  @return null;\n}\n@mixin label(){\n  @include font-smoothing;\n  font: inherit;\n  transition: font-size .15s ease-in-out;\n}\n\n@mixin label-size($size) {\n  @if map-has-key($label-sizes, $size) {\n    @each $key,$val in map-get($label-sizes, $size){\n      #{$key}: $val;\n\n      @if $key == font-size {\n        @media print {\n          #{$key}: $val * .833333333;\n        }\n      }\n    }\n  }\n\n  i, em{\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 400;\n    } @else {\n      font-weight: 300;\n    }\n  }\n\n  b, strong {\n    @if $size == 'xlarge' or $size == 'xxlarge' {\n      font-weight: 500;\n    } @else {\n      font-weight: 700;\n    }\n  }\n}\n\n@mixin note(){\n  &:not([class*='color--']) {\n    @include textcolor(bw6);\n  }\n  font-style: italic;\n}\n\n@mixin description(){\n  font-family: $font--articulat;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutStepReview Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var cartActions = __webpack_require__(196);
var checkoutActions = __webpack_require__(92);
var countries_1 = __webpack_require__(128);
var license_1 = __webpack_require__(34);
var address_1 = __webpack_require__(232);
var react_1 = __webpack_require__(233);
var colors_1 = __webpack_require__(57);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var Velocity = __webpack_require__(91);
var Button_1 = __webpack_require__(10);
var LicenseBuilderButton_1 = __webpack_require__(225);
var Checkbox_1 = __webpack_require__(601);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PriceTag_1 = __webpack_require__(126);
var FormCell_1 = __webpack_require__(234);
var FormRow_1 = __webpack_require__(235);
var CheckoutAmounts_1 = __webpack_require__(430);
var CheckoutStep_1 = __webpack_require__(303);
var config_1 = __webpack_require__(80);
var formValidations = {
    checkTerms: {
        error: 'You must agree to both terms and obligations.'
    },
    obligationsTerms: {
        error: 'You must agree to both terms and obligations.'
    }
};
var stepId = config_1.CheckoutStepId.review;
var form = config_1.CheckoutStepFormName.review;
var classes = new BEM("checkout__step--" + stepId);

var CheckoutStepReview = function (_React$Component) {
    _inherits(CheckoutStepReview, _React$Component);

    function CheckoutStepReview() {
        _classCallCheck(this, CheckoutStepReview);

        var _this = _possibleConstructorReturn(this, (CheckoutStepReview.__proto__ || Object.getPrototypeOf(CheckoutStepReview)).apply(this, arguments));

        _this.onSaveLicenseLineItem = function (itemId) {
            return function (usages) {
                _this.props.updateCartItemTerms(itemId, usages);
            };
        };
        _this.renderLicense = function (order, lineItem) {
            var projectDetails = _this.props.projectDetails;

            var track = lineItem.track;
            var usages = lineItem.license.usages.map(function (_ref) {
                var id = _ref.id,
                    components = _ref.components;
                return license_1.generateLicenseUsageFromComponents(components, id);
            });
            return React.createElement("div", Object.assign({ key: track.id }, classes('license-item')), React.createElement(Heading_1.default, { is: "h5", WrappedComponent: "div" }, track.title), React.createElement("div", null, usages.map(function (usage, i) {
                return React.createElement(Heading_1.default, Object.assign({ is: "h5", WrappedComponent: "div" }, classes('license-item__usage'), { key: "license-usage-" + i }), license_1.usageToString(usage), projectDetails && projectDetails.airDate ? React.createElement(Label_1.Span, { textColor: colors_1.bw6 }, "\xA0(", projectDetails.airDate[usage.id], ")") : '');
            })), React.createElement(PriceTag_1.default, { amount: lineItem.amount, rate: order.currency_rate, currency: order.currency_code, size: "medium" }), React.createElement(LicenseBuilderButton_1.default, Object.assign({ variant: "icon", icon: React.createElement(Icon_1.IconEdit, null), textColor: colors_1.bw5, scope: {
                    type: 'CartLineItem',
                    id: lineItem.id
                }, onSaveLicense: _this.onSaveLicenseLineItem(lineItem.id) }, classes('license-item__button-edit'))));
        };
        return _this;
    }

    _createClass(CheckoutStepReview, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref2) {
            var isActive = _ref2.isActive,
                license = _ref2.license;

            if (license.scope && license.scope.type === 'CartLineItem') {
                if (lodash_1.isEqual(license.scope, this.props.license.scope)) {
                    if (!lodash_1.isEqual(license.usages, this.props.license.usages)) {
                        this.props.updateCartItemTerms(license.scope.id, license.usages);
                    }
                }
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.isActive;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.isActive && this.props.isActive) {
                var container = document.getElementsByClassName('checkout__content-wrapper')[0];
                var scrollPosition = container.scrollTop;
                var offset = -scrollPosition + 24;
                Velocity(react_dom_1.findDOMNode(this), 'scroll', { container: container, offset: offset, delay: 500 });
            }
        }
    }, {
        key: "renderInformation",
        value: function renderInformation(label, value) {
            return value && React.createElement("div", Object.assign({}, classes('information__item')), React.createElement(Label_1.Span, Object.assign({ size: "medium", textColor: colors_1.bw6 }, classes('information__item__title')), label, ":"), React.createElement(Heading_1.default, { is: "h5", WrappedComponent: "div" }, value));
        }
    }, {
        key: "renderAddress",
        value: function renderAddress(address) {
            var addressString = address_1.formatAddress(address, this.props.getCountryLabel, this.props.getStateLabel);
            return this.renderInformation('Address', react_1.nl2br(addressString));
        }
    }, {
        key: "renderBillingAddress",
        value: function renderBillingAddress() {
            var billing = this.props.billingInformation;
            return billing.sameAddressAsLicensee === false && billing.address ? this.renderAddress(billing.address) : this.renderAddress(this.props.licenseInformation.address);
        }
    }, {
        key: "renderRepresentativeInformation",
        value: function renderRepresentativeInformation() {
            var rep = this.props.licenseInformation.representative;
            var role = lodash_1.find(this.props.representativeRoles.edges.map(function (_ref3) {
                var node = _ref3.node;
                return node;
            }), { id: rep.role }).name;
            var str = rep.name + "\n" + role + "\n" + rep.email + (rep.phone ? "\n" + rep.phone : "");
            return this.renderInformation('Authorized Representative', react_1.nl2br(str));
        }
    }, {
        key: "renderCardExpiration",
        value: function renderCardExpiration() {
            var stripeToken = this.props.stripeToken;

            var expMonth = stripeToken.card.exp_month;
            var expYear = stripeToken.card.exp_year;
            return this.renderInformation('Card Expiration', (expMonth < 10 ? "0" + expMonth : expMonth) + " / " + expYear);
        }
    }, {
        key: "renderPaymentInformation",
        value: function renderPaymentInformation() {
            var _this2 = this;

            var _props = this.props,
                billingInformation = _props.billingInformation,
                licenseInformation = _props.licenseInformation,
                stripeToken = _props.stripeToken;

            var paymentMethod = billingInformation.paymentMethod;
            var cardInfo = function cardInfo() {
                return React.createElement(React.Fragment, null, _this2.renderInformation('Card', "**** **** **** " + stripeToken.card.last4), _this2.renderCardExpiration());
            };
            var chequeInfo = React.createElement(React.Fragment, null, this.renderInformation('Payment Method', 'Cheque'));
            return React.createElement(React.Fragment, null, this.renderInformation("Cardholder's Name", billingInformation ? billingInformation.nameOnCard : licenseInformation.representative.name), this.renderBillingAddress(), paymentMethod === "Stripe" /* Stripe */ ? cardInfo() : chequeInfo);
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                billingInformation = _props2.billingInformation,
                companyTypes = _props2.companyTypes,
                error = _props2.error,
                handleSubmit = _props2.handleSubmit,
                licenseInformation = _props2.licenseInformation,
                _props2$projectDetail = _props2.projectDetails,
                projectDetails = _props2$projectDetail === undefined ? {} : _props2$projectDetail,
                order = _props2.order,
                setActiveStep = _props2.setActiveStep,
                submitting = _props2.submitting;

            var lineItems = order.license_line_items;
            return React.createElement(CheckoutStep_1.default, { formValidations: formValidations, error: error, handleSubmit: handleSubmit, id: stepId, showNextStepButton: false, title: "Review" }, React.createElement(Heading_1.default, { is: "h6" }, "License(s)"), React.createElement("div", Object.assign({}, classes('licenses')), lineItems.map(function (item) {
                return _this3.renderLicense(order, item);
            })), React.createElement("div", Object.assign({}, classes('information')), React.createElement("section", Object.assign({}, classes('information__section', 'project')), React.createElement("header", Object.assign({}, classes('information__section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Project Details"), React.createElement(Button_1.default, { onClick: function onClick() {
                    return setActiveStep(config_1.CheckoutStepId.project);
                }, variant: "icon", icon: React.createElement(Icon_1.IconEdit, null), textColor: colors_1.bw5 })), this.renderInformation('Brand', projectDetails.brand || config_1.kCheckoutNoInputLabel), this.renderInformation('Project Title', projectDetails.product || config_1.kCheckoutNoInputLabel), this.renderInformation('Reference', projectDetails.reference), this.renderInformation('PO Number', projectDetails.poNumber), this.renderInformation('Notes', projectDetails.notes)), lodash_1.size(licenseInformation) && React.createElement("section", Object.assign({}, classes('information__section', 'license')), React.createElement("header", Object.assign({}, classes('information__section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Licensee Information"), React.createElement(Button_1.default, { onClick: function onClick() {
                    return setActiveStep(config_1.CheckoutStepId.license);
                }, variant: "icon", icon: React.createElement(Icon_1.IconEdit, null), textColor: colors_1.bw5 })), this.renderInformation('Company Name', licenseInformation.address.company.name), this.renderInformation('Company Type', lodash_1.find(companyTypes.edges.map(function (_ref4) {
                var node = _ref4.node;
                return node;
            }), { id: licenseInformation.address.company.type }).name), this.renderAddress(this.props.licenseInformation.address), this.renderRepresentativeInformation()), lodash_1.size(licenseInformation) && lodash_1.size(billingInformation) && React.createElement("section", Object.assign({}, classes('information__section', 'billing')), React.createElement("header", Object.assign({}, classes('information__section__header')), React.createElement(Heading_1.default, { is: "h6" }, "Billing Information"), React.createElement(Button_1.default, { onClick: function onClick() {
                    return setActiveStep(config_1.CheckoutStepId.billing);
                }, variant: "icon", icon: React.createElement(Icon_1.IconEdit, null), textColor: colors_1.bw5 })), this.renderPaymentInformation())), React.createElement("div", Object.assign({}, classes('summary')), React.createElement(CheckoutAmounts_1.default, { context: "review", order: order }), React.createElement("div", Object.assign({}, classes('agreements')), React.createElement(FormRow_1.default, null, React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement("label", Object.assign({}, classes('agreements__item')), React.createElement(redux_form_1.Field, { name: "checkTerms", component: Checkbox_1.default, size: "large", colorScheme: "white" }), React.createElement(Label_1.Span, Object.assign({}, classes('agreements__item__text'), { variant: "description", size: "large" }), "I have the authority to enter this license agreement on behalf of the licensee."))), React.createElement(FormCell_1.default, { spacer: true, minimumWidth: 1 }), React.createElement(FormCell_1.default, { minimumWidth: 8 }, React.createElement("label", Object.assign({}, classes('agreements__item')), React.createElement(redux_form_1.Field, { name: "obligationsTerms", component: Checkbox_1.default, size: "large", colorScheme: "white" }), React.createElement(Label_1.Span, Object.assign({}, classes('agreements__item__text'), { variant: "description", size: "large" }), "I have read the Terms and Conditions, and I specifically certify that I will not use or facilitate the use of the music obtained on Bopper in conjunction with any audio or video material that could be deemed overtly racist, sexist or discriminatory or promotes, or is funded by, a political organization or campaign, or that promotes cigarettes or any firearms-related subjects, such as firearms products, their use, or any related legislative agenda, in accordance with our Terms and Conditions."))))), React.createElement(Button_1.default, Object.assign({}, classes('button-order'), { label: "Place Order", size: "xlarge", colorScheme: "accent", disabled: submitting, submitting: submitting, isSubmit: true }))));
        }
    }]);

    return CheckoutStepReview;
}(React.Component);

var CheckoutStepReviewForm = redux_form_1.reduxForm({
    form: form
})(CheckoutStepReview);
var ConnectedCheckoutStepReview = react_redux_1.connect(function (state) {
    return {
        billingInformation: redux_form_1.getFormValues(config_1.CheckoutStepFormName.billing)(state),
        getCountryLabel: function getCountryLabel(countryCode) {
            return countries_1.getCountryLabelFromCode(countryCode)(state);
        },
        getStateLabel: function getStateLabel(stateCode) {
            return countries_1.getStateLabelFromCode(stateCode)(state);
        },
        isActive: state.checkout.activeStep === stepId,
        license: state.license,
        licenseInformation: redux_form_1.getFormValues(config_1.CheckoutStepFormName.license)(state),
        projectDetails: redux_form_1.getFormValues(config_1.CheckoutStepFormName.project)(state),
        stripeToken: state.user.stripeToken
    };
}, function (dispatch) {
    return {
        setActiveStep: function setActiveStep(id) {
            return dispatch(checkoutActions.setActiveStep({ id: id }));
        },
        updateCartItemTerms: function updateCartItemTerms(lineItemId, terms) {
            return new Promise(function (resolve, reject) {
                dispatch(cartActions.requestUpdateCartItemTerms({
                    lineItemId: lineItemId,
                    promise: { resolve: resolve, reject: reject },
                    terms: terms
                }));
            });
        }
    };
})(CheckoutStepReviewForm);
exports.default = ConnectedCheckoutStepReview;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CheckoutSummary Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var track_1 = __webpack_require__(44);
var colors_1 = __webpack_require__(57);
__webpack_require__(1627);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PriceTag_1 = __webpack_require__(126);
var CheckoutAmounts_1 = __webpack_require__(430);
var classes = new BEM('checkout__order-summary');

var CheckoutSummary = function (_React$Component) {
    _inherits(CheckoutSummary, _React$Component);

    function CheckoutSummary() {
        _classCallCheck(this, CheckoutSummary);

        return _possibleConstructorReturn(this, (CheckoutSummary.__proto__ || Object.getPrototypeOf(CheckoutSummary)).apply(this, arguments));
    }

    _createClass(CheckoutSummary, [{
        key: "renderLineItem",
        value: function renderLineItem(order, lineItem) {
            var track = lineItem.track;
            var image = track_1.getResponsiveTrackThumbnail(track);
            var usages = lineItem.license.usages.map(function (_ref) {
                var components = _ref.components;
                return license_1.generateLicenseUsageFromComponents(components);
            });
            var licenseString = license_1.getLicenseString(usages);
            var itemClasses = new BEM('checkout__order-summary__line-item');
            return React.createElement("div", Object.assign({ key: lineItem.id }, itemClasses()), React.createElement(Thumbnail_1.default, Object.assign({ responsiveAssets: image, size: "xsmall" }, itemClasses('image'))), React.createElement("div", Object.assign({}, itemClasses('info')), React.createElement(Heading_1.default, Object.assign({ is: "h5", text: track.title, maxTextLength: 15 }, itemClasses('info__title'))), React.createElement(Label_1.Span, Object.assign({ text: track.artist.name, size: "small", textColor: "bw7" }, itemClasses('info__subtitle'))), React.createElement(Label_1.Span, Object.assign({ size: "small", textColor: colors_1.bw6 }, itemClasses('terms-title'), { block: true }), "License Terms"), React.createElement(Label_1.Span, Object.assign({ variant: "description", size: "large" }, itemClasses('terms'), { block: true }), licenseString)), React.createElement(PriceTag_1.default, Object.assign({ currency: order.currency_code, rate: order.currency_rate, amount: lineItem.amount, size: "small" }, itemClasses('price'))));
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var order = this.props.order;

            var lineItems = order.license_line_items;
            return React.createElement("div", Object.assign({}, classes()), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), "Summary"), lineItems.map(function (item, index) {
                return _this2.renderLineItem(order, item);
            }), React.createElement(CheckoutAmounts_1.default, { context: "sidebar", order: order }));
        }
    }]);

    return CheckoutSummary;
}(React.Component);

exports.default = CheckoutSummary;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1628);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-summary.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./checkout-summary.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".checkout__order-summary{background-color:#fff}.checkout__order-summary>.heading{margin-bottom:24px}.checkout__order-summary__line-item{border-top:1px solid #e4e8ed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:16px;padding-left:0}.checkout__order-summary__line-item__info{margin:4px 16px}.checkout__order-summary__line-item__info__title{margin:0}.checkout__order-summary__line-item__info__subtitle{display:block}.checkout__order-summary__line-item__price{margin-top:4px;margin-bottom:4px;margin-left:auto}.checkout__order-summary__line-item__terms-title{margin:16px 0 4px}.checkout__order-summary .checkout__amounts{-webkit-box-shadow:0 -1px #e4e8ed;box-shadow:0 -1px #e4e8ed}.checkout__order-summary .checkout__amounts__item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Checkout/checkout-summary.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA8GA,yBCrCI,qBAvCU,CD4Ed,kCAII,kBE/E6C,CFgF9C,oCAGC,6BACA,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,aAEvB,cAAe,CAEf,0CGrBA,eDpE6C,CF4F3C,iDACE,QAAS,CACV,oDAGC,aAAc,CACf,2CGjDiB,eDjDyB,kBAAA,gBFsGQ,CACpD,iDAGC,iBE1G2C,CF2EjD,4CAoCI,kCAAA,yBCvIuB,CDmG3B,kDAuCM,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,iCACnB,wBC7IqB,CD+ItB","file":"checkout-summary.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Checkout Summary Component\n */\n\n$context: \".checkout__order-summary\";\n\n#{$context}{\n  @include bgcolor(white);\n\n  > .heading{\n    margin-bottom: baseline(3);\n  }\n\n  &__line-item{\n    border-top: 1px solid uicolor(border);\n    display: flex;\n    align-items: flex-start;\n    padding: baseline(2);\n    padding-left: 0;\n\n    &__info{\n      @include margin(baseline(.5) baseline(2));\n\n      &__title{\n        margin: 0;\n      }\n\n      &__subtitle{\n        display: block;\n      }\n    }\n\n    &__price{\n      @include margin(baseline(.5) null baseline(.5) auto);\n    }\n\n    &__terms-title{\n      margin: baseline(2) 0 baseline(.5);\n    }\n  }\n\n  .checkout__amounts{\n    box-shadow: 0 -1px uicolor(border);\n\n    &__item{\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      box-shadow: 0 1px uicolor(border);\n      // padding: baseline(1.5) baseline(2) baseline(1.5) baseline(1);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 858f76de275c7722aaeb3322fcc136c4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type emptyState_viewer$ref = any;
export type emptyState_QueryVariables = {|
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
|};
export type emptyState_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: emptyState_viewer$ref,
  |},
|};
*/

/*
query emptyState_Query(
  $license_params: [LicenseUsageParamsInput]
) {
  viewer {
    ...emptyState_viewer
    id
  }
}

fragment emptyState_viewer on Viewer {
  home_page(license_params: $license_params) {
    featured_artist_tracks {
      id
      title
      slug
      price
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
      artist {
        name
        slug
        bio
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        id
      }
      terms {
        edges {
          node {
            id
            is_highlighted
            name
            parent_id
            taxonomy {
              id
              name
            }
          }
        }
      }
    }
    featured_collections {
      id
      description
      name
      slug
      category {
        id
        name
      }
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
    }
    featured_tracks {
      id
      title
      slug
      price
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
      artist {
        name
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        id
      }
      terms {
        edges {
          node {
            id
            is_highlighted
            name
            parent_id
            taxonomy {
              id
              name
            }
          }
        }
      }
    }
    featured_terms {
      name
      items {
        __typename
        ... on TaxonomyTerm {
          id
          is_highlighted
          name
          parent_id
          taxonomy {
            id
            internal_id
            name
          }
        }
        ... on HomePageLink {
          title
          url
        }
        ... on Node {
          id
        }
      }
    }
    header_posts {
      title
      subtitle
      post_url
      image_url
    }
    blog_posts {
      title
      excerpt
      author
      post_url
      image_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_highlighted",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "parent_id",
    "args": null,
    "storageKey": null
  },
      v9 = [v1, v6],
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "terms",
    "storageKey": null,
    "args": null,
    "concreteType": "TaxonomyTermConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTerm",
        "plural": false,
        "selections": [v1, v7, v6, v8, {
          "kind": "LinkedField",
          "alias": null,
          "name": "taxonomy",
          "storageKey": null,
          "args": null,
          "concreteType": "Taxonomy",
          "plural": false,
          "selections": v9
        }]
      }]
    }]
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "post_url",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "image_url",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "emptyState_Query",
    "id": null,
    "text": "query emptyState_Query(\n  $license_params: [LicenseUsageParamsInput]\n) {\n  viewer {\n    ...emptyState_viewer\n    id\n  }\n}\n\nfragment emptyState_viewer on Viewer {\n  home_page(license_params: $license_params) {\n    featured_artist_tracks {\n      id\n      title\n      slug\n      price\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n      artist {\n        name\n        slug\n        bio\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        id\n      }\n      terms {\n        edges {\n          node {\n            id\n            is_highlighted\n            name\n            parent_id\n            taxonomy {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    featured_collections {\n      id\n      description\n      name\n      slug\n      category {\n        id\n        name\n      }\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n    }\n    featured_tracks {\n      id\n      title\n      slug\n      price\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n      artist {\n        name\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        id\n      }\n      terms {\n        edges {\n          node {\n            id\n            is_highlighted\n            name\n            parent_id\n            taxonomy {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    featured_terms {\n      name\n      items {\n        __typename\n        ... on TaxonomyTerm {\n          id\n          is_highlighted\n          name\n          parent_id\n          taxonomy {\n            id\n            internal_id\n            name\n          }\n        }\n        ... on HomePageLink {\n          title\n          url\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n    header_posts {\n      title\n      subtitle\n      post_url\n      image_url\n    }\n    blog_posts {\n      title\n      excerpt\n      author\n      post_url\n      image_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "emptyState_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "emptyState_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "emptyState_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "home_page",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "license_params",
            "variableName": "license_params",
            "type": "[LicenseUsageParamsInput]"
          }],
          "concreteType": "HomePageContent",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "featured_artist_tracks",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResult",
            "plural": true,
            "selections": [v1, v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [v6, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "bio",
                "args": null,
                "storageKey": null
              }, v5, v1]
            }, v10]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "featured_collections",
            "storageKey": null,
            "args": null,
            "concreteType": "Collection",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            }, v6, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "category",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionCategory",
              "plural": false,
              "selections": v9
            }, v5]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "featured_tracks",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResult",
            "plural": true,
            "selections": [v1, v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [v6, v3, v5, v1]
            }, v10]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "featured_terms",
            "storageKey": null,
            "args": null,
            "concreteType": "HomePageFeaturedTermsList",
            "plural": true,
            "selections": [v6, {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }, v1, {
                "kind": "InlineFragment",
                "type": "HomePageLink",
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "InlineFragment",
                "type": "TaxonomyTerm",
                "selections": [v7, v6, v8, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "internal_id",
                    "args": null,
                    "storageKey": null
                  }, v6]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "header_posts",
            "storageKey": null,
            "args": null,
            "concreteType": "HomePagePost",
            "plural": true,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "subtitle",
              "args": null,
              "storageKey": null
            }, v11, v12]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "blog_posts",
            "storageKey": null,
            "args": null,
            "concreteType": "BlogPost",
            "plural": true,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "excerpt",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "author",
              "args": null,
              "storageKey": null
            }, v11, v12]
          }]
        }, v1]
      }]
    }
  };
}();
node /*: any*/.hash = 'f501b96fcdfda14a1f3da558b5e61828';
module.exports = node;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type emptyState_viewer$ref: FragmentReference;
export type emptyState_viewer = {|
  +home_page: ?{|
    +featured_artist_tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +slug: ?string,
      +price: ?number,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +name: ?string,
        +slug: ?string,
        +bio: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |}>,
    +featured_collections: ?$ReadOnlyArray<?{|
      +id: string,
      +description: ?string,
      +name: string,
      +slug: ?string,
      +category: ?{|
        +id: string,
        +name: ?string,
      |},
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
    |}>,
    +featured_tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +slug: ?string,
      +price: ?number,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +name: ?string,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |}>,
    +featured_terms: ?$ReadOnlyArray<?{|
      +name: ?string,
      +items: ?$ReadOnlyArray<?{|
        +id?: string,
        +is_highlighted?: ?boolean,
        +name?: ?string,
        +parent_id?: ?string,
        +taxonomy?: ?{|
          +id: string,
          +internal_id: ?number,
          +name: ?string,
        |},
        +title?: string,
        +url?: string,
      |}>,
    |}>,
    +header_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +subtitle: string,
      +post_url: string,
      +image_url: string,
    |}>,
    +blog_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +excerpt: string,
      +author: string,
      +post_url: string,
      +image_url: string,
    |}>,
  |},
  +$refType: emptyState_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_highlighted",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "parent_id",
    "args": null,
    "storageKey": null
  },
      v8 = [v0, v5],
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "terms",
    "storageKey": null,
    "args": null,
    "concreteType": "TaxonomyTermConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTerm",
        "plural": false,
        "selections": [v0, v6, v5, v7, {
          "kind": "LinkedField",
          "alias": null,
          "name": "taxonomy",
          "storageKey": null,
          "args": null,
          "concreteType": "Taxonomy",
          "plural": false,
          "selections": v8
        }]
      }]
    }]
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "post_url",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "image_url",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "emptyState_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "home_page",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "license_params",
        "variableName": "license_params",
        "type": "[LicenseUsageParamsInput]"
      }],
      "concreteType": "HomePageContent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "featured_artist_tracks",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": true,
        "selections": [v0, v1, v2, v3, v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [v5, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bio",
            "args": null,
            "storageKey": null
          }, v4]
        }, v9]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "featured_collections",
        "storageKey": null,
        "args": null,
        "concreteType": "Collection",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, v5, v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionCategory",
          "plural": false,
          "selections": v8
        }, v4]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "featured_tracks",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": true,
        "selections": [v0, v1, v2, v3, v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [v5, v2, v4]
        }, v9]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "featured_terms",
        "storageKey": null,
        "args": null,
        "concreteType": "HomePageFeaturedTermsList",
        "plural": true,
        "selections": [v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [{
            "kind": "InlineFragment",
            "type": "HomePageLink",
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "InlineFragment",
            "type": "TaxonomyTerm",
            "selections": [v0, v6, v5, v7, {
              "kind": "LinkedField",
              "alias": null,
              "name": "taxonomy",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "internal_id",
                "args": null,
                "storageKey": null
              }, v5]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "header_posts",
        "storageKey": null,
        "args": null,
        "concreteType": "HomePagePost",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "subtitle",
          "args": null,
          "storageKey": null
        }, v10, v11]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "blog_posts",
        "storageKey": null,
        "args": null,
        "concreteType": "BlogPost",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "excerpt",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "author",
          "args": null,
          "storageKey": null
        }, v10, v11]
      }]
    }]
  };
}();
node /*: any*/.hash = '0403861f11becf0652c09e458b0a05d6';
module.exports = node;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--discover,.page--discover .page__main{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.page--discover .page__main{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:40px 0}.page--discover .page__main>*{-ms-flex-negative:0;flex-shrink:0}.page--discover .container{margin-right:auto;margin-left:auto;padding-right:3.33333333%;padding-left:3.33333333%;max-width:1920px}.page--discover .featured-artist-list{margin-top:96px}.page--discover .charts,.page--discover .scrollable-section--blog-posts{margin-top:64px}.discover__welcome-license{margin-top:-40px;margin-bottom:32px}.discover__welcome-license__content{background-color:#fff;text-align:center;padding:144px 80px 80px;background-image:-webkit-gradient(linear,left bottom,left top,from(#f0f6fa),color-stop(60%,rgba(240,246,250,0)));background-image:-webkit-linear-gradient(bottom,#f0f6fa,rgba(240,246,250,0) 60%);background-image:-o-linear-gradient(bottom,#f0f6fa 0,rgba(240,246,250,0) 60%);background-image:linear-gradient(0deg,#f0f6fa 0,rgba(240,246,250,0) 60%)}.discover__welcome-license__title{margin:28px auto 36px}.discover__welcome-license__cta{-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/browse/Discover/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,4CACE,4BAAA,6BAAA,0BAAA,qBAAsB,CADxB,4BAKI,0BAAA,uBAAA,oBAAoB,cACE,CAN1B,8BASY,oBAAA,aAAe,CAT3B,2BCnB0B,kBDgCG,iBAAA,0BACQ,yBAAA,gBEvFY,CFyEjD,sCAmBI,eE5F6C,CFyEjD,wEA2BI,eEpG6C,CFqG9C,2BAKC,iBACA,kBE3G6C,CF6G7C,oCGvEA,sBHyEE,kBAAkB,wBAElB,iHAAA,iFAAA,8EAAA,wEAA8G,CAC/G,kCAGC,qBErH2C,CFsH5C,gCIhIC,sDApBqD,6CAAA,CJwJtD","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * DiscoverPage Component\n */\n\n.page--discover{\n  flex-direction: column;\n\n  .page__main{\n    flex-direction: column;\n    align-items: stretch;\n    padding: baseline(5) 0;\n\n    // Fix for Safari 9 (see https://github.com/philipwalton/flexbugs#flexbug-1)\n    & > * { flex-shrink: 0 }\n  }\n\n  .container{\n    @include margin(null auto);\n    @include padding(null 3.33333333%);\n    max-width: baseline(240);\n  }\n\n  .featured-artist-list{\n    margin-top: baseline(12);\n  }\n\n  .scrollable-section--blog-posts{\n    margin-top: baseline(8);\n  }\n\n  .charts{\n    margin-top: baseline(8);\n  }\n}\n\n.discover{\n  &__welcome-license{\n    margin-top: baseline(-5);\n    margin-bottom: baseline(4);\n\n    &__content{\n      @include bgcolor(white);\n      text-align: center;\n      padding: baseline(18) baseline(10) baseline(10);\n      background-image: linear-gradient(to top, transparentize(color(bw3), 0) 0%, transparentize(color(bw3), 1) 60%);\n    }\n\n    &__title{\n      margin: baseline(3.5) auto baseline(4.5);\n    }\n\n    &__cta{\n      @include shadow(medium);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1634);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.blog-post{background-color:#fff;color:#101015;border-radius:8px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}.blog-post--ready:before{content:\"\";-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);border-radius:8px;position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;-webkit-transition:.5s ease-in-out;-o-transition:.5s ease-in-out;transition:.5s ease-in-out}.blog-post--loading .blog-post__title{border-radius:2px;height:16px;width:240px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite}.blog-post--loading .blog-post__title .label{display:none}.blog-post--loading .blog-post__excerpt{margin-top:40px;width:240px}.blog-post--loading .blog-post__excerpt,.blog-post--loading .blog-post__excerpt:after,.blog-post--loading .blog-post__excerpt:before{border-radius:2px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite;height:8px}.blog-post--loading .blog-post__excerpt:after,.blog-post--loading .blog-post__excerpt:before{content:\"\";display:block;margin:8px 0}.blog-post--loading .blog-post__excerpt:before{top:-16px;width:248px}.blog-post--loading .blog-post__excerpt:after{width:200px}.blog-post--loading .blog-post__excerpt span{display:none}.blog-post--loading .blog-post__credit{opacity:0}.blog-post--loading .blog-post__credit:before{content:\"\";border-radius:2px;height:8px;width:96px;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite;display:block;top:24px}.blog-post--loading .blog-post__credit:before,.blog-post--loading .blog-post__image{background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto}.blog-post--loading .blog-post__image{-webkit-animation:gradient-cycle 2s linear infinite;animation:gradient-cycle 2s linear infinite;cursor:default}.blog-post--loading .blog-post__image img{opacity:0}.blog-post__title{margin-top:0}.blog-post__image{border-radius:8px 0 0 8px;height:296px;overflow:hidden;-webkit-box-flex:2;-ms-flex:2;flex:2}.blog-post__image img{left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);height:100%}.blog-post__content{-webkit-box-flex:3;-ms-flex:3;flex:3;padding:32px 64px 32px 48px}.blog-post__excerpt{line-height:1.3333;margin:24px 0 16px}.blog-post--ready{cursor:pointer;-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.blog-post--ready:before{opacity:1}html.no-touchevents .blog-post--ready:hover,html.touchevents .blog-post--ready:active{-webkit-transform:scale(1.02);-ms-transform:scale(1.02);transform:scale(1.02)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/BlogPosts/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,WC5BhC,sBAvCU,cA9BY,kBD6GxB,qBAAqB,oBACrB,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,gCACnB,4BAAA,uBAAwB,CAExB,yBACE,WAAW,sDElH4C,8CC4BrD,kBApBgB,kBH6GQ,MAAG,QAAA,SAAA,OAAA,UACnB,mCACV,8BAAA,0BAA2B,CAC5B,sCG5FG,kBA1BgB,YC0ClB,YJ6CF,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,8CAAgE,CA+B/D,6CAMG,YAAa,CACd,wCAID,gBACA,WKxG6C,CLsG9C,qIGxGG,kBH6DJ,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,+CAAgE,UK7DjB,CLsG9C,6FAWG,WAAW,cACG,YACO,CAbxB,+CAiBG,UACA,WKxH2C,CLsG9C,8CAsBG,WK5H2C,CLsG9C,6CA0BG,YAAa,CACd,uCAID,SAAU,CADX,8CAIG,WAAW,kBGpKK,WC0ClB,WJ+CF,uDAAA,+CAAgE,cA+E9C,QK5I6B,CL8I5C,oFAnFH,iIAAA,+EAAA,0EAAA,wEAAoG,yBAC1E,CAqF1B,sCApFA,oDAAA,4CAAgE,cAsF/C,CAFhB,0CAKG,SAAU,CACX,kBAID,YAAa,CACd,kBAGC,0BACA,aACA,gBAAgB,mBAChB,WAAA,MAAO,CAJR,sBAOG,SAAS,mCACT,+BAAA,2BAA2B,WACf,CACb,oBAID,mBAAA,WAAA,OAAO,2BK5KsC,CL8K9C,oBAGC,mBAAmB,kBKjL0B,CLmL9C,kBAGC,eAAe,0DACf,qDAAA,iDMlMyD,CNgM1D,yBAKG,SAAU,CACX,sFAGC,8BAAA,0BAAA,qBAAsB,CKtMzB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * BlogPost Component\n */\n\n.blog-post{\n  @include bgcolor(white);\n  @include textcolor(black);\n  @include bgsize(large);\n\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  transform-origin: bottom;\n\n  &--ready::before{\n    content: \"\";\n    @include shadow(large);\n    @include bgsize(large);\n    @include position(absolute, 0);\n    opacity: 0;\n    transition: .5s ease-in-out;\n  }\n\n  &--loading &__title{\n    @include bgsize(small);\n    @include size(baseline(30) baseline(2));\n    @include loading-placeholder(1.25s);\n\n    .label{\n      display: none;\n    }\n  }\n\n  &--loading &__excerpt {\n    margin-top: baseline(5);\n    width: baseline(30);\n\n    &, &::before, &::after{\n      @include bgsize(small);\n      @include loading-placeholder(1.25s);\n      height: baseline(1);\n    }\n\n    &::before, &::after{\n      content: \"\";\n      display: block;\n      margin: baseline(1) 0;\n    }\n\n    &::before{\n      top: baseline(-2);\n      width: baseline(31);\n    }\n\n    &::after{\n      width: baseline(25);\n    }\n\n    span {\n      display: none;\n    }\n  }\n\n  &--loading &__credit{\n    opacity: 0;\n\n    &::before{\n      content: \"\";\n      @include bgsize(small);\n      @include size(baseline(12) baseline(1));\n      @include loading-placeholder(1.25s);\n      display: block;\n      top: baseline(3);\n    }\n  }\n\n  &--loading &__image{\n    @include loading-placeholder;\n    cursor: default;\n\n    img{\n      opacity: 0;\n    }\n  }\n\n  &__title{\n    margin-top: 0;\n  }\n\n  &__image{\n    border-radius: radius(large) 0 0 radius(large);\n    height: baseline(37);\n    overflow: hidden;\n    flex: 2;\n\n    img{\n      left: 50%;\n      transform: translateX(-50%);\n      height: 100%;\n    }\n  }\n\n  &__content{\n    flex: 3;\n    padding: baseline(4) baseline(8) baseline(4) baseline(6);\n  }\n\n  &__excerpt{\n    line-height: 1.3333;\n    margin: baseline(3) 0 baseline(2);\n  }\n\n  &--ready{\n    cursor: pointer;\n    transition: .25s $ease-out-back;\n\n    &::before{\n      opacity: 1;\n    }\n\n    @include hover{\n      transform: scale(1.02);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * BlogPost Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var ImageLoaded_1 = __webpack_require__(185);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('blog-post');

var BlogPost = function (_React$PureComponent) {
    _inherits(BlogPost, _React$PureComponent);

    function BlogPost() {
        _classCallCheck(this, BlogPost);

        return _possibleConstructorReturn(this, (BlogPost.__proto__ || Object.getPrototypeOf(BlogPost)).apply(this, arguments));
    }

    _createClass(BlogPost, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                data = _props.data,
                index = _props.index;

            return React.createElement(ImageLoaded_1.default, null, function (_ref) {
                var imageLoaded = _ref.imageLoaded;
                return React.createElement("a", Object.assign({ href: data.post_url, target: "_blank" }, classes('', { loading: !imageLoaded, ready: imageLoaded })), React.createElement("div", Object.assign({ style: {
                        animationDelay: .5 * index + "s"
                    } }, classes('image')), React.createElement(velocity_react_1.VelocityComponent, { animation: imageLoaded ? 'fadeIn' : 'fadeOut' }, React.createElement("img", { src: data.image_url, alt: "" + data.title }))), React.createElement("div", Object.assign({}, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h4", text: data.title, maxTextLength: 100 }, classes('title'))), React.createElement(Label_1.Paragraph, Object.assign({ size: "medium", text: data.excerpt, maxTextLength: 140 }, classes('excerpt'))), data.author && React.createElement(Label_1.Span, Object.assign({ size: "large", variant: "description" }, classes('credit')), data.author)));
            });
        }
    }]);

    return BlogPost;
}(React.PureComponent);

exports.default = BlogPost;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1637);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".charts .chart{margin-bottom:48px}@media screen and (min-width:960px){.charts__content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.charts__content-wrapper .chart{-ms-flex-preferred-size:30%;flex-basis:30%;margin-bottom:0}}.chart__title{margin-bottom:16px}@media screen and (min-width:960px){.chart__title{margin-bottom:32px}}.chart .card{height:96px;padding:0}.chart .card:hover{z-index:1}.chart .card__background{display:none}.chart .card__image{z-index:1}.chart .card__content{border-bottom:1px solid #e4e8ed}.chart .track-list__item:first-child .card__content{border-top:1px solid #e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/Charts/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,eAEI,kBC3E6C,CD4E9C,oCAEC,yBACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,wBAC9B,qBAAA,sBAAuB,CAHxB,gCAKG,4BAAA,eAAe,eACC,CACjB,CAAA,cAOH,kBC5F6C,CDiG9C,oCAND,cAII,kBC/F2C,CDiG9C,CAPH,aAUI,YACA,SAAU,CAXd,mBAcM,SAAU,CAdhB,yBAkBI,YAAa,CAlBjB,oBAqBI,SAAU,CArBd,sBAwBI,+BE1IuB,CFkH3B,oDA4BM,4BE9IqB,CF+ItB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Charts Component\n */\n\n.charts{\n  .chart{\n    margin-bottom: baseline(6);\n  }\n  @include media(breakpoint(desktop-s)) {\n    &__content-wrapper{\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      .chart{\n        flex-basis: 30%;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.chart{\n  &__title{\n    margin-bottom: baseline(2);\n\n    @include media(breakpoint(desktop-s)) {\n      margin-bottom: baseline(4);\n    }\n  }\n\n  .card{\n    height: baseline(12);\n    padding: 0;\n\n    &:hover{\n      z-index: 1;\n    }\n  }\n  .card__background{\n    display: none;\n  }\n  .card__image{\n    z-index: 1;\n  }\n  .card__content{\n    border-bottom: 1px solid uicolor(border);\n  }\n  .track-list__item:first-child{\n    .card__content{\n      border-top: 1px solid uicolor(border);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1639);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.featured-artist-list__title{margin-bottom:32px}.featured-artist-list__list{display:-webkit-box;display:-ms-flexbox;display:flex;list-style:none;margin:0 -16px;padding:0}.featured-artist-list__list__item{-webkit-box-flex:1;-ms-flex:1;flex:1;margin:0 16px}.featured-artist--loading .featured-artist__title{border-radius:2px;height:32px;width:288px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite}.featured-artist--loading .featured-artist__title .label{display:none}.featured-artist--loading .featured-artist__bio{margin-top:40px}.featured-artist--loading .featured-artist__bio,.featured-artist--loading .featured-artist__bio:after,.featured-artist--loading .featured-artist__bio:before{border-radius:2px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite;height:8px}.featured-artist--loading .featured-artist__bio:after,.featured-artist--loading .featured-artist__bio:before{content:\"\";display:block;margin:8px 0}.featured-artist--loading .featured-artist__bio:before{top:-16px;width:90%}.featured-artist--loading .featured-artist__bio:after{width:85%}.featured-artist--loading .featured-artist__bio span{display:none}.featured-artist__thumbnail{-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom;-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}html.no-touchevents .featured-artist__thumbnail:hover,html.touchevents .featured-artist__thumbnail:active{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}.featured-artist__content-wrapper{padding:0 16px}.featured-artist__bio{line-height:1.33333}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/FeaturedArtists/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,6BAShC,kBC3E6C,CD4E9C,4BAGC,oBAAA,oBAAA,aAAa,gBACG,eAEhB,SAAU,CAEV,kCACE,mBAAA,WAAA,OAAO,aCrFoC,CDuF5C,kDEzFC,kBA1BgB,YD4B2B,YD2D/C,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,8CAAgE,CA+B/D,yDAMG,YAAa,CACd,gDAID,eCvG6C,CDsG9C,6JExGG,kBF6DJ,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,+CAAgE,UC7DjB,CDsG9C,6GAUG,WAAW,cACG,YACO,CAZxB,uDAgBG,UACA,SAAU,CAjBb,sDAqBG,SAAU,CArBb,qDAyBG,YAAa,CACd,4BAID,gCAAA,4BAAA,wBAAwB,0DACxB,qDAAA,iDGhJyD,CHoJ1D,0GAFG,8BAAA,0BAAA,qBAAsB,CAI1B,kCACE,cC5I6C,CD6I9C,sBAGC,mBAAoB,CACrB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FeaturedArtistList Component\n */\n\n.featured-artist-list{\n  &__title{\n    margin-bottom: baseline(4);\n  }\n\n  &__list{\n    display: flex;\n    list-style: none;\n    margin: 0 baseline(-2);\n    padding: 0;\n\n    &__item{\n      flex: 1;\n      margin: 0 baseline(2);\n    }\n  }\n}\n\n.featured-artist{\n  &--loading &__title{\n    @include bgsize(small);\n    @include size(baseline(36) baseline(4));\n    @include loading-placeholder(1.25s);\n\n    .label{\n      display: none;\n    }\n  }\n\n  &--loading &__bio{\n    margin-top: baseline(5);\n\n    &, &::before, &::after{\n      @include bgsize(small);\n      @include loading-placeholder(1.25s);\n      height: baseline(1);\n    }\n\n    &::before, &::after{\n      content: \"\";\n      display: block;\n      margin: baseline(1) 0;\n    }\n\n    &::before{\n      top: baseline(-2);\n      width: 90%;\n    }\n\n    &::after{\n      width: 85%;\n    }\n\n    span {\n      display: none;\n    }\n  }\n\n  &__thumbnail{\n    transform-origin: bottom;\n    transition: .25s $ease-out-back;\n    @include hover{\n      transform: scale(1.03);\n    }\n  }\n\n  &__content-wrapper{\n    padding: 0 baseline(2);\n  }\n\n  &__bio{\n    line-height: 1.33333;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FeaturedArtist Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
var router_1 = __webpack_require__(27);
var track_1 = __webpack_require__(44);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var ImageLoaded_1 = __webpack_require__(185);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var ThumbnailWithPlayButton_1 = __webpack_require__(298);
var classes = new BEM('featured-artist');
var defaultList = [];

var FeaturedArtist = function (_React$PureComponent) {
    _inherits(FeaturedArtist, _React$PureComponent);

    function FeaturedArtist() {
        _classCallCheck(this, FeaturedArtist);

        return _possibleConstructorReturn(this, (FeaturedArtist.__proto__ || Object.getPrototypeOf(FeaturedArtist)).apply(this, arguments));
    }

    _createClass(FeaturedArtist, [{
        key: "render",
        value: function render() {
            var track = this.props.track;

            return React.createElement(ImageLoaded_1.default, null, function (_ref) {
                var imageLoaded = _ref.imageLoaded;
                return React.createElement("div", Object.assign({}, classes('', { loading: !imageLoaded, ready: imageLoaded })), React.createElement(ThumbnailWithPlayButton_1.default, Object.assign({ displayButtonOnHover: true, hyperLinkProps: {
                        href: router_1.linkWithCurrentQueryString(track_1.getArtistPagePath(track))
                    }, ratio: "four-thirds", responsiveAssets: image_1.getResponsiveAssets('cover', track.artist.assets || defaultList), responsive: true, size: "xxlarge", trackId: track_1.getDefaultTrackAsset(track.assets).id }, classes('thumbnail'))), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement(Heading_1.default, Object.assign({ is: "h3", hyperLinkProps: {
                        href: track_1.getArtistPagePath(track)
                    }, maxTextLength: 32, text: track.artist.name }, classes('title'))), React.createElement(Label_1.Paragraph, Object.assign({}, classes('bio'), { text: track.artist.bio || '', maxTextLength: 280, size: "small" }))));
            });
        }
    }]);

    return FeaturedArtist;
}(React.PureComponent);

exports.default = FeaturedArtist;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1642);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes gradient-cycle{0%{background-position:100% 50%}to{background-position:0 50%}}.header-post{-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}.header-post--loading .header-post__title{border-radius:2px;height:16px;width:240px;background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 1.25s linear infinite;animation:gradient-cycle 1.25s linear infinite}.header-post--loading .header-post__subtitle,.header-post--loading .header-post__title .label{display:none}.header-post--loading .header-post__image{background-image:-webkit-gradient(linear,left top,right top,color-stop(25%,#e4e8ed),color-stop(#f0f2f5),color-stop(75%,#e4e8ed));background-image:-webkit-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:-o-linear-gradient(left,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-image:linear-gradient(90deg,#e4e8ed 25%,#f0f2f5,#e4e8ed 75%);background-size:500% auto;-webkit-animation:gradient-cycle 2s linear infinite;animation:gradient-cycle 2s linear infinite;cursor:default}.header-post--loading .header-post__image img{opacity:0}.header-post__text{opacity:0;-webkit-transition:opacity .3s ease-in-out;-o-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out;position:absolute;width:100%;height:60px;left:0;bottom:0;padding:9.6px 16px;background:rgba(16,16,21,.8);-webkit-backdrop-filter:blur(10px) saturate(200%);backdrop-filter:blur(10px) saturate(200%);border-radius:0 0 8px 8px}.header-post__text__title{color:#fff;font-style:normal;font-weight:400;font-size:15px;line-height:16px;margin:0}.header-post__text__subtitle{color:#b1b8c4;font-style:normal;font-weight:700;font-size:10px;line-height:16px}.header-post__text a{text-decoration:none}.header-post__image{display:block}.header-post__image,.header-post__image:before,.header-post__image img{border-radius:8px}.header-post__image img{width:100%}.header-post--ready{cursor:pointer;-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}html.no-touchevents .header-post--ready:hover,html.touchevents .header-post--ready:active{-webkit-transform:scale(1.02);-ms-transform:scale(1.02);transform:scale(1.02)}.header-post--ready .header-post__image:before,.header-post--ready:hover .header-post__text{opacity:1}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/HeaderPosts/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AAmGA,kCACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAFpC,0BACE,GAAI,4BAA8B,CAAA,GAC5B,yBAA4B,CAAA,CAAA,aAQlC,gCAAA,4BAAA,uBAAwB,CAExB,0CC9EI,kBA1BgB,YC0ClB,YF6CF,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,uDAC1B,8CAAgE,CAuB/D,8FAGC,YAAa,CACd,0CA7BD,iIAAA,+EAAA,0EAAA,wEAAoG,0BAC1E,oDAC1B,4CAAgE,cA+B/C,CAFhB,8CAKG,SAAU,CACX,mBAID,UAAU,2CACV,sCAAA,mCAAoC,kBAElB,WACP,YACC,OACH,SACE,mBAIX,6BAAiC,kDACjC,0CAA0C,yBAGZ,CAE9B,0BGvEA,WHyEE,kBAAkB,gBACC,eACJ,iBACE,QACR,CACV,6BG9ED,cHkFE,kBAAkB,gBACD,eACF,gBACE,CAhCpB,qBAoCG,oBAAqB,CACtB,oBAID,aAAc,CADf,uEC7IG,iBApBgB,CDiKnB,wBAgBG,UAAW,CACZ,oBAID,eAAe,0DACf,qDAAA,iDI5KyD,CJ8KzD,0FAEE,8BAAA,0BAAA,qBAAsB,CACvB,4FAQD,SAAU,CACX","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * HeaderPost Component\n */\n\n.header-post{\n  transform-origin: bottom;\n\n  &--loading &__title{\n    @include bgsize(small);\n    @include size(baseline(30) baseline(2));\n    @include loading-placeholder(1.25s);\n\n    .label{\n      display: none;\n    }\n  }\n\n  &--loading &__subtitle{\n    display: none;\n  }\n\n  &--loading &__image{\n    @include loading-placeholder;\n    cursor: default;\n\n    img{\n      opacity: 0;\n    }\n  }\n\n  &__text {\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n\n    position: absolute;\n    width: 100%;\n    height: 60px;\n    left: 0px;\n    bottom: 0px;\n\n    padding: baseline(1.2) baseline(2);\n\n    background: rgba(16, 16, 21, 0.8);\n    backdrop-filter: blur(10px) saturate(200%);\n    /* Note: backdrop-filter has minimal browser support */\n\n    border-radius: 0px 0px 8px 8px;\n\n    &__title{\n      @include textcolor(bw1);\n      font-style: normal;\n      font-weight: normal;\n      font-size: 15px;\n      line-height: 16px;\n      margin: 0;\n    }\n\n    &__subtitle{\n      @include textcolor(bw6);\n      font-style: normal;\n      font-weight: bold;\n      font-size: 10px;\n      line-height: 16px;\n    }\n\n    a {\n      text-decoration: none;\n    }\n  }\n\n  &__image{\n    display: block;\n\n    &, &::before, img{\n      @include bgsize(large);\n    }\n\n    // &::before{\n    //   content: \"\";\n    //   @include shadow(small);\n    //   @include position(absolute, 0);\n    //   opacity: 0;\n    //   transition: .5s ease-in-out;\n    // }\n\n    img{\n      width: 100%;\n    }\n  }\n\n  &--ready{\n    cursor: pointer;\n    transition: .25s $ease-out-back;\n\n    html.touchevents &:active,\n    html.no-touchevents &:hover{\n      transform: scale(1.02);\n    }\n\n    &:hover .header-post__text {\n      opacity: 1;\n    }\n  }\n\n  &--ready &__image::before{\n    opacity: 1;\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * HeaderPost Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var ImageLoaded_1 = __webpack_require__(185);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('header-post');

var HeaderPost = function (_React$PureComponent) {
    _inherits(HeaderPost, _React$PureComponent);

    function HeaderPost() {
        _classCallCheck(this, HeaderPost);

        return _possibleConstructorReturn(this, (HeaderPost.__proto__ || Object.getPrototypeOf(HeaderPost)).apply(this, arguments));
    }

    _createClass(HeaderPost, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                data = _props.data,
                index = _props.index;

            return React.createElement(ImageLoaded_1.default, null, function (_ref) {
                var imageLoaded = _ref.imageLoaded;
                return React.createElement("div", Object.assign({}, classes('', { loading: !imageLoaded, ready: imageLoaded })), React.createElement("a", Object.assign({ href: data.post_url, style: {
                        animationDelay: .5 * index + "s"
                    } }, classes('image')), React.createElement(velocity_react_1.VelocityComponent, { animation: imageLoaded ? 'fadeIn' : 'fadeOut' }, React.createElement("img", { src: data.image_url, alt: data.subtitle + " - " + data.title }))), React.createElement("div", Object.assign({}, classes('text')), React.createElement("a", { href: data.post_url }, React.createElement("div", null, React.createElement(Label_1.Span, Object.assign({ size: "small" }, classes('text__subtitle')), data.subtitle), React.createElement(Heading_1.default, Object.assign({ is: "h4", text: data.title, maxTextLength: 60, style: {
                        animationDelay: .3125 * index + "s"
                    } }, classes('text__title')))))));
            });
        }
    }]);

    return HeaderPost;
}(React.PureComponent);

exports.default = HeaderPost;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1645);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".newsletter-promo{border-radius:8px;min-height:384px}.newsletter-promo:before{content:\"\";padding-top:26.66667%;display:block;width:100%}.newsletter-promo__wrapper{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.newsletter-promo__background{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;overflow:hidden}.newsletter-promo__background img{left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:100%}.newsletter-promo__content-wrapper{-webkit-box-flex:1;-ms-flex:auto;flex:auto;padding:96px 0}.newsletter-promo__content>*{max-width:384px}.newsletter-promo__title{margin:0 0 32px}.newsletter-promo__create-account{margin:32px 0 0}.newsletter-promo__textfield{-webkit-box-shadow:0 20px 40px 0 rgba(16,16,21,.2);box-shadow:0 20px 40px 0 rgba(16,16,21,.2)}.newsletter-promo__textfield .textfield__background{height:48px}.newsletter-promo__textfield .textfield__input{height:46px}.newsletter-promo__textfield .textfield__inline-button{height:40px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/NewsletterPromo/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,kBC3EM,kBDoFJ,gBElF+C,CFyEjD,yBAEI,WAAW,sBACW,cACR,UACH,CACZ,2BGxED,kBH8E4B,MAAG,QAAA,SAAA,OAAA,oBAC7B,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,8BGjFD,kBHoF4B,MAAG,QAAA,SAAA,OAAA,kBAE7B,eAAgB,CAHjB,kCAQG,SAAS,mCACT,+BAAA,2BAA2B,UAChB,CACZ,mCAID,mBAAA,cAAA,UAAU,cACa,CACxB,6BAGC,eE9G6C,CF+G9C,yBAGC,eElH6C,CFmH9C,kCAGC,eAAuB,CACxB,6BIjIG,mDJoIsD,0CAAA,CADzD,oDAGG,WE5H2C,CFyH9C,+CAMG,WE/H2C,CFyH9C,uDASG,WElI2C,CFmI5C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * NewsletterPromo Component\n */\n\n.newsletter-promo{\n  &::before{\n    content: \"\";\n    padding-top: 26.66667%;\n    display: block;\n    width: 100%;\n  }\n\n  @include bgsize(large);\n  min-height: baseline(48);\n\n  &__wrapper{\n    @include position(absolute, 0);\n    display: flex;\n    align-items: center;\n  }\n\n  &__background{\n    @include position(absolute, 0);\n    @include bgsize(large);\n    overflow: hidden;\n\n\n\n    img{\n      left: 50%;\n      transform: translateX(-50%);\n      width: 100%;\n    }\n  }\n\n  &__content-wrapper{\n    flex: auto;\n    padding: baseline(12) 0;\n  }\n\n  &__content > * {\n    max-width: baseline(48);\n  }\n\n  &__title{\n    margin: 0 0 baseline(4);\n  }\n\n  &__create-account{\n    margin: baseline(4) 0 0;\n  }\n\n  &__textfield{\n    @include shadow(medium, transparentize(color(black), .8));\n    .textfield__background{\n      height: baseline(6);\n    }\n    .textfield__input{\n      height: baseline(5.75);\n    }\n    .textfield__inline-button{\n      height: baseline(5);\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SearchArea Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1647);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var portal_1 = __webpack_require__(666);
var SearchTermsBox_1 = __webpack_require__(668);
var locales_1 = __webpack_require__(52);
var classes = new BEM('search-area');

var SearchArea = function (_React$Component) {
    _inherits(SearchArea, _React$Component);

    function SearchArea(props) {
        _classCallCheck(this, SearchArea);

        var _this = _possibleConstructorReturn(this, (SearchArea.__proto__ || Object.getPrototypeOf(SearchArea)).call(this, props));

        _this.onSearchInput = function (_ref) {
            var target = _ref.target;

            _this.setState({ searchInput: target.value });
        };
        _this.onCloseInstantSearch = function () {
            _this.setState({ searchInput: '' });
        };
        _this.state = {
            searchInput: ''
        };
        return _this;
    }

    _createClass(SearchArea, [{
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes('', '', this.props.className)), React.createElement("div", Object.assign({}, classes('content-wrapper', '', 'container')), React.createElement(TextField_1.default, Object.assign({ name: "search-box", placeholder: locales_1.default.search.placeholder, size: "xlarge", colorScheme: "white", inlineButton: React.createElement(Button_1.default, { variant: "icon", size: "xxsmall", icon: React.createElement(Icon_1.IconSearch, null) }), onChange: this.onSearchInput, value: this.state.searchInput, isControlled: true }, classes('search-box__input'))), this.state.searchInput !== '' && React.createElement(portal_1.InstantSearchPortal, { initialInput: this.state.searchInput, onSearchInput: this.onSearchInput, onClose: this.onCloseInstantSearch }), React.createElement(SearchTermsBox_1.default, Object.assign({ data: this.props.data }, classes('search-terms')))));
        }
    }]);

    return SearchArea;
}(React.Component);

exports.default = SearchArea;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1648);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.search-area{padding:24px 0}.search-area__search-box__input--with-results .textfield__background{border-radius:4px 4px 0 0}.search-area__search-box__input .textfield__input{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:1em;font-weight:400;line-height:1.142857143;height:70px;padding-left:24px}.search-area__search-box__input .textfield__input .label{display:inline-block}@media screen and (min-width:600px){.search-area__search-box__input .textfield__input{font-size:1.1249999998em}}@media screen and (min-width:864px){.search-area__search-box__input .textfield__input{font-size:1.3125em}}@media print{.search-area__search-box__input .textfield__input{font-size:1.1249999998em}}.search-area__search-box__input .textfield__background{-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);border-color:#fff;height:70px}.search-area__search-box__input.textfield--is-focus .textfield__background{border-color:#fff}.search-area__search-box__input .textfield__inline-button{right:24px;bottom:0;height:70px}.search-area__search-box__input .textfield__inline-button .button__icon{width:32px}.search-area__search-box__input .textfield__inline-button .button__icon svg{height:100%;width:100%}.search-area__search-box .search-box__instant-search{top:72px;left:0;right:0;width:auto;max-height:50vh;border:1px solid #fff;border-top:0;border-radius:0 0 4px 4px;-webkit-animation:show-home-instant-search .5s ease-in-out;animation:show-home-instant-search .5s ease-in-out}@-webkit-keyframes show-home-instant-search{0%{opacity:0}to{opacity:1}}@keyframes show-home-instant-search{0%{opacity:0}to{opacity:1}}.search-area__search-terms{margin-top:32px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/SearchArea/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,aC6DtE,cAAsB,CAKrB,qEACC,yBAA4C,CAF7C,kDCvCC,mCAJqC,kCAKH,mEChEpC,8CAAA,yCAAA,sCAAsC,cA4ExB,gBACE,wBFgCV,YACA,iBCxFyC,CDgF9C,yDEnGC,oBAAqB,CACtB,oCFkGA,kDEjBC,wBAAsC,CF0BnC,CAAA,oCATJ,kDETC,kBAnBsB,CFqCnB,CAAA,aATJ,kDELC,wBAAsC,CFcnC,CATJ,uDG1FG,sDApBqD,8CH0HnD,kBACA,WC7FyC,CDgF9C,2EAiBK,iBIlGM,CJiFX,0DAqBK,WACA,SAAS,WCtGgC,CDgF9C,wEA0BO,UC1GuC,CDgF9C,4EKxEC,YLoG0B,UAAA,CA9B5B,qDAoCC,SACA,OAAO,QACC,WACG,gBACK,sBAEhB,aAAa,0BAEb,2DAAA,kDAAmD,CACnD,4CACC,GACC,SAAU,CAAA,GAGV,SAAU,CAAA,CALZ,oCACC,GACC,SAAU,CAAA,GAGV,SAAU,CAAA,CAAA,2BAOX,eCvI6C,CDwI9C","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SearchArea Component\n */\n\n@import '../../../atoms/text/Heading/mixins';\n\n.search-area{\n  padding: baseline(3) 0;\n\n\t&__search-box {\n    $textfield-height: 8.75;\n\t\t&__input {\n\t\t\t&--with-results .textfield__background {\n\t\t\t\tborder-radius: baseline(.5) baseline(.5) 0 0;\n      }\n\t\t\t.textfield__input {\n        @include base-heading;\n        @include h4(true);\n        height: baseline($textfield-height);\n        padding-left: baseline(3);\n      }\n      .textfield__background{\n        @include shadow(large);\n        border-color: color(white);\n        height: baseline($textfield-height);\n      }\n\n      &.textfield--is-focus .textfield__background{\n        border-color: color(white);\n      }\n\n      .textfield__inline-button{\n        right: baseline(3);\n        bottom: 0;\n        height: baseline($textfield-height);\n\n        .button__icon{\n          width: baseline(4);\n          svg{\n            @include size(100%);\n          }\n        }\n      }\n\t\t}\n\t\t.search-box__instant-search {\n\t\t\ttop: baseline(9);\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\twidth: auto;\n\t\t\tmax-height: 50vh;\n\t\t\tborder: 1px solid color(white);\n\t\t\tborder-top: 0;\n\t\t\tborder-radius: 0 0 baseline(.5) baseline(.5);\n\t\t\tanimation: show-home-instant-search .5s ease-in-out;\n\t\t\t@keyframes show-home-instant-search {\n\t\t\t\t0% {\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t\t100% {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n  }\n\n  &__search-terms{\n    margin-top: baseline(4);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * InstantSearch Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1650);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_hot_keys_1 = __webpack_require__(401);
var velocity_react_1 = __webpack_require__(19);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var ResultList_1 = __webpack_require__(1652);
var locales_1 = __webpack_require__(52);
var classes = new BEM('instant-search-v2');

var InternalInstantSearch = function (_React$Component) {
    _inherits(InternalInstantSearch, _React$Component);

    function InternalInstantSearch(props) {
        _classCallCheck(this, InternalInstantSearch);

        var _this = _possibleConstructorReturn(this, (InternalInstantSearch.__proto__ || Object.getPrototypeOf(InternalInstantSearch)).call(this, props));

        _this.onSearchInput = function (e) {
            e.persist();
            _this.setState({ searchInput: e.target.value }, function () {
                if (_this.props.onSearchInput && _this.state.searchInput !== '') {
                    _this.props.onSearchInput(e);
                }
            });
        };
        _this.onClickShowAll = function () {
            _this.onClickClose();
            _this.props.setSearchQuery(_this.state.searchInput);
        };
        _this.onClickClose = function () {
            _this.setState({ closing: true }, function () {
                _this.closeTimeout = window.setTimeout(function () {
                    _this.props.onClose();
                }, 500);
            });
        };
        _this.state = {
            closing: false,
            searchInput: _this.props.initialInput
        };
        return _this;
    }

    _createClass(InternalInstantSearch, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (this.props.filters.length > prevProps.filters.length || !lodash_1.isEqual(this.props.taxonomyQuery, prevProps.taxonomyQuery)) {
                this.onClickClose();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.clearTimeout(this.closeTimeout);
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(react_hot_keys_1.default, { keyName: "esc", onKeyDown: this.onClickClose }, React.createElement(velocity_react_1.VelocityComponent, { animation: this.state.closing ? 'transition.fadeOut' : 'transition.fadeIn', display: "flex", duration: 150, runOnMount: true }, React.createElement("div", Object.assign({}, classes()), React.createElement(velocity_react_1.VelocityComponent, { animation: "transition.slideDownBigIn", display: "flex", duration: 250, runOnMount: true }, React.createElement("div", Object.assign({}, classes('input')), React.createElement(react_hot_keys_1.default, { keyName: "enter", onKeyDown: this.onClickShowAll }, React.createElement("input", Object.assign({ type: "text", placeholder: locales_1.default.search.placeholder, value: this.state.searchInput, onChange: this.onSearchInput, autoFocus: true }, classes('input__textfield')))), React.createElement(Button_1.default, Object.assign({ label: "Show All Results", size: "xsmall", variant: "pill", colorScheme: "light", icon: React.createElement(Icon_1.IconSearch, null), iconPosition: "right", onClick: this.onClickShowAll }, classes('input__button', 'show-all'))), React.createElement(Button_1.default, Object.assign({ variant: "icon", icon: React.createElement(Icon_1.IconX, null), size: "large", colorScheme: "transparent", textColor: "bw5", onClick: this.onClickClose }, classes('input__button', 'close'))))), React.createElement(ResultList_1.ResultList, Object.assign({ query: this.state.searchInput }, classes('results'))))));
        }
    }]);

    return InternalInstantSearch;
}(React.Component);

exports.InstantSearch = function (props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(InternalInstantSearch, Object.assign({ filters: selectors_1.getSearchFilters(ctx), taxonomyQuery: selectors_1.getTaxonomyQuery(ctx), setSearchQuery: ctx.setSearchQuery }, props));
    });
};

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1651);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.instant-search-wrapper{position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none}.instant-search-v2{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;min-height:100%;pointer-events:all}.instant-search-v2,.instant-search-v2__input{display:-webkit-box;display:-ms-flexbox;display:flex}.instant-search-v2__input{background-color:#fff;height:18vh;padding:40px 48px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@supports ((-webkit-backdrop-filter:blur(20px)) or (backdrop-filter:blur(20px))){.instant-search-v2__input{background-color:hsla(0,0%,100%,.9);-webkit-backdrop-filter:blur(20px) saturate(200%);backdrop-filter:blur(20px) saturate(200%)}}.instant-search-v2__input__textfield{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:2.000001em;font-weight:400;line-height:1;margin:16px 0;top:-4px;-webkit-box-flex:1;-ms-flex:auto;flex:auto;border:0}.instant-search-v2__input__textfield .label{display:inline-block}@media screen and (min-width:864px){.instant-search-v2__input__textfield{font-size:2.499999em}}@media screen and (min-width:1280px){.instant-search-v2__input__textfield{font-size:3em}}.instant-search-v2__input__textfield::-webkit-input-placeholder{color:#d2d9e1}.instant-search-v2__input__textfield::-ms-input-placeholder{color:#d2d9e1}.instant-search-v2__input__textfield::placeholder{color:#d2d9e1}.instant-search-v2__input__textfield::-ms-clear{display:none}.instant-search-v2__input__textfield:focus{outline:0}.instant-search-v2__input__textfield:invalid{-webkit-box-shadow:none;box-shadow:none}.instant-search-v2__input__button{-webkit-box-flex:0;-ms-flex:none;flex:none}.instant-search-v2__input__button--close .icon{height:100%;width:100%}.instant-search-v2__results{background-color:rgba(245,250,255,.96);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;height:82vh}@supports ((-webkit-backdrop-filter:blur(20px)) or (backdrop-filter:blur(20px))){.instant-search-v2__results{background-color:rgba(245,250,255,.9);-webkit-backdrop-filter:blur(20px) saturate(200%);backdrop-filter:blur(20px) saturate(200%)}}html.touchevents .instant-search-v2__results{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .instant-search-v2__results{overflow-x:hidden;overflow-y:auto}.instant-search-v2__results__link{font-weight:600;text-align:left}.instant-search-v2__results__category-result-list{padding-right:24px;padding-bottom:24px;padding-left:48px;-ms-flex-preferred-size:100%;flex-basis:100%;opacity:0}.instant-search-v2__results__category-result-list:before{position:absolute;top:0;right:0;left:0;background-color:rgba(210,217,225,.5);content:\"\";height:64px}.instant-search-v2__results__category-result-list__title{margin-top:24px;margin-bottom:48px}.instant-search-v2__results__category-result-list__list{margin:0;padding:0;list-style:none}.instant-search-v2__results__category-result-list__list__item{margin-top:12px;margin-bottom:12px}@media screen and (min-width:600px){.instant-search-v2__results__category-result-list{-ms-flex-preferred-size:50%;flex-basis:50%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}@media screen and (min-width:768px){.instant-search-v2__results__category-result-list{-ms-flex-preferred-size:33.3333333333%;flex-basis:33.3333333333%}}@media screen and (min-width:1024px){.instant-search-v2__results__category-result-list{-ms-flex-preferred-size:25%;flex-basis:25%}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/InstantSearch/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,wBCRtE,eCqEuB,MAAG,QAAA,SAAA,OAAA,mBACN,CACrB,mBAIC,4BAAA,6BAAA,0BAAA,sBAAsB,WACX,gBACK,kBACG,CAEnB,6CANA,oBAAA,oBAAA,YAAa,CAMb,0BApCA,sBAuCE,YAAY,kBAGZ,yBAAA,sBAAA,kBAAmB,CAzCiB,iFAmCtC,0BAlCE,oCAHiF,kDAIjF,yCAA0C,CA0E3C,CAjCC,qCCtDA,mCAJqC,kCAKH,mEChEpC,8CAAA,yCAAA,sCAAsC,qBAkCH,gBACnB,cACF,cFoFV,SACA,mBAAA,cAAA,UAAU,QACD,CALV,4CElHD,oBAAqB,CACtB,oCFiHC,qCE1EA,oBAAmC,CFgGlC,CAAA,qCAtBD,qCEvEA,aAdiB,CF2GhB,CAtBA,gEGjDD,aAvEmB,CHwHlB,4DGjDD,aAvEmB,CHwHlB,kDGjDD,aAvEmB,CHwHlB,gDAYG,YAAa,CAZhB,2CAgBG,SAAU,CAhBb,6CAoBG,wBAAA,eAAgB,CACjB,kCAID,mBAAA,cAAA,SAAU,CAET,+CIlHH,YJoHwB,UAAA,CACnB,4BA1EP,uCAgFgE,oBAE9D,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,mBACvB,eAAe,WACH,CApFwB,iFA8EtC,4BA7EE,sCACA,kDAAA,yCAA0C,CA8H3C,CAAA,6CC1MC,kBAAgD,kBACT,gCACN,CAClC,gDAEC,kBAAgD,eACX,CD0JrC,kCACE,gBAAgB,eACA,CACjB,kDKvFqB,mBJtDuB,oBAAA,kBDiJ3C,6BAAA,gBAAgB,SACN,CAHX,yDDxIH,kBC8IgC,MAAG,QAAE,OAAO,sCACU,WACrC,WCvJ8B,CDyJ1C,yDKxGiB,gBJjDyB,kBAAA,CD6J1C,wDAGC,SAAS,UACC,eACM,CAEhB,8DKnHgB,gBJjDyB,kBAAA,CDsKxC,oCAvBL,kDA2BI,4BAAA,eAAe,mBACf,oBAAA,WAAY,CAQf,CAAA,oCApCD,kDA+BI,uCAAA,yBAA0B,CAK7B,CAAA,qCApCD,kDAkCI,4BAAA,cAAe,CAElB,CAAA","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * InstantSearch Component\n */\n\n@import \"../../../atoms/text/Heading/mixins\";\n\n.instant-search-wrapper{\n  @include position(fixed, 0);\n  pointer-events: none;\n}\n\n.instant-search-v2{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  pointer-events: all;\n\n  &__input{\n    // $bgcolor: transparentize(color(bw1), .04);\n    @include translucent(color(bw1));\n    height: 18vh;\n    padding: baseline(5) baseline(6);\n    display: flex;\n    align-items: center;\n\n    &__textfield{\n      @include base-heading;\n      @include h2;\n      top: baseline(-.5);\n      flex: auto;\n      border: 0;\n\n      &::placeholder{\n        @include textcolor(bw5);\n      }\n\n      &::-ms-clear {\n        display: none;\n      }\n\n      &:focus{\n        outline: 0;\n      }\n\n      &:invalid {\n        box-shadow: none;\n      }\n    }\n\n    &__button{\n      flex: none;\n\n      &--close{\n        .icon{\n          @include size(100%);\n        }\n      }\n    }\n  }\n\n  &__results{\n    @include translucent(transparentize(color(accent-subtle), .04), transparentize(color(accent-subtle), .1));\n    @include scroll;\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    height: 82vh;\n\n    &__link{\n      font-weight: 600;\n      text-align: left;\n    }\n\n    &__category-result-list{\n      @include padding(null baseline(3) baseline(3) baseline(6));\n      flex-basis: 100%;\n      opacity: 0;\n\n      &::before{\n        @include position(absolute, 0 0 null 0);\n        background-color: transparentize(color(bw5), .5);\n        content: \"\";\n        height: baseline(8);\n      }\n\n      &__title{\n        @include margin(baseline(3) null baseline(6));\n      }\n\n      &__list{\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        &__item{\n          @include margin(baseline(1.5) null);\n        }\n      }\n\n      @include media(breakpoint(tablet)) {\n        flex-basis: 50%;\n        flex-grow: 1;\n      }\n      @include media(breakpoint(tablet-l)) {\n        flex-basis: 33.3333333333%;\n      }\n      @include media(breakpoint(desktop)) {\n        flex-basis: 25%;\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(93);
var instantSearch_1 = __webpack_require__(1653);
var taxonomy_1 = __webpack_require__(106);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_relay_1 = __webpack_require__(13);
var reselect_1 = __webpack_require__(49);
var NProgress_1 = __webpack_require__(228);
var Label_1 = __webpack_require__(8);
var CategoryResultList_1 = __webpack_require__(1656);
var ResultLink_1 = __webpack_require__(667);
var ResultLinkFilter_1 = __webpack_require__(1657);
var defaultList = [];
var getInstantSearch = function getInstantSearch(_ref) {
    var viewer = _ref.viewer;
    return viewer ? viewer.trackInstantSearch : null;
};
var getInstantSearchResult = reselect_1.createSelector(getInstantSearch, function (instantSearch) {
    return lodash_1.memoize(function (type) {
        return instantSearch ? instantSearch[type] : defaultList;
    });
});
var getInstantSearchTaxonomyResults = reselect_1.createSelector(getInstantSearchResult, function (selector) {
    return lodash_1.memoize(function (type) {
        var taxonomies = selector('taxonomies');
        var taxonomy = lodash_1.find(taxonomies, ['name', type]);
        if (taxonomy) {
            var terms = taxonomy.terms,
                rest = __rest(taxonomy, ["terms"]);
            var termsWithTaxonomy = (terms || []).map(function (term) {
                return Object.assign({}, term, { taxonomy: Object.assign({}, rest, { terms: [] }) });
            });
            return termsWithTaxonomy;
        }
        return defaultList;
    });
});

var InternalResultList = function (_React$Component) {
    _inherits(InternalResultList, _React$Component);

    function InternalResultList() {
        _classCallCheck(this, InternalResultList);

        return _possibleConstructorReturn(this, (InternalResultList.__proto__ || Object.getPrototypeOf(InternalResultList)).apply(this, arguments));
    }

    _createClass(InternalResultList, [{
        key: "renderLinkFilter",
        value: function renderLinkFilter(label, term) {
            var isTaxonomyQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var filter = {
                name: term.name,
                taxonomy: {
                    id: term.taxonomy.internal_id,
                    name: term.taxonomy.name
                }
            };
            return React.createElement(ResultLinkFilter_1.ResultLinkFilter, Object.assign({ filter: filter, isTaxonomyQuery: isTaxonomyQuery, label: label }, this.getClassName()('link')));
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var classes = this.getClassName();

            var _getResultsByCategory = this.getResultsByCategory(),
                tracks = _getResultsByCategory.tracks,
                artists = _getResultsByCategory.artists,
                moods = _getResultsByCategory.moods,
                genres = _getResultsByCategory.genres,
                lyrics = _getResultsByCategory.lyrics,
                references = _getResultsByCategory.references,
                industries = _getResultsByCategory.industries,
                instruments = _getResultsByCategory.instruments,
                catalogs = _getResultsByCategory.catalogs,
                vocals = _getResultsByCategory.vocals,
                languages = _getResultsByCategory.languages;

            var props = Object.assign({}, classes('category-result-list'));
            return React.createElement("div", Object.assign({}, classes()), React.createElement(NProgress_1.default, { active: !!!this.props.viewer }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#moods", index: 0, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Moods), results: moods }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#genres", index: 1, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Genres), results: genres }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#industries", index: 2, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Industries), results: industries }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#instruments", index: 3, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Instruments), results: instruments }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#references", index: 4, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.References), results: references }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#vocals", index: 5, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Vocals), results: vocals }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#languages", index: 6, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Languages), results: languages }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#lyrics", index: 7, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Lyrics), results: lyrics }, props), function (term) {
                // IMPORTANT: lyrics should actually be searched by the query the user entered
                // and NOT the value of the clicked lyric
                var label = term.name;
                term.name = _this2.props.query;
                return _this2.renderLinkFilter(label, term, true);
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#tracks", index: 8, category: "tracks", title: "Track Titles", results: tracks }, props), function (_ref2) {
                var artist = _ref2.artist,
                    slug = _ref2.slug,
                    title = _ref2.title;
                return React.createElement(ResultLink_1.ResultLinkTrack, Object.assign({ label: title + " by " + artist.name, slug: slug }, classes('link')));
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#artists", index: 9, category: "artists", title: "Artists", results: artists }, props), function (_ref3) {
                var name = _ref3.name,
                    slug = _ref3.slug;
                return React.createElement(ResultLink_1.ResultLinkArtist, Object.assign({ label: name, slug: slug }, classes('link')));
            }), React.createElement(CategoryResultList_1.CategoryResultList, Object.assign({ key: this.props.query + "#catalogs", index: 10, category: "taxonomies", title: taxonomy_1.getTaxonomyTitle(taxonomy_1.TaxonomyType.Catalogs), results: catalogs }, props), function (term) {
                return _this2.renderLinkFilter(term.name, term);
            }));
        }
    }, {
        key: "getClassName",
        value: function getClassName() {
            return new BEM(this.props.className);
        }
    }, {
        key: "getResultsByCategory",
        value: function getResultsByCategory() {
            var allResults = getInstantSearchResult(this.props);
            this.results = {
                tracks: allResults('tracks'),
                artists: allResults('artists'),
                moods: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Moods),
                genres: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Genres),
                lyrics: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Lyrics),
                references: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.References),
                industries: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Industries),
                instruments: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Instruments),
                catalogs: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Catalogs),
                vocals: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Vocals),
                languages: getInstantSearchTaxonomyResults(this.props)(taxonomy_1.TaxonomyType.Languages)
            };
            return this.results;
        }
    }]);

    return InternalResultList;
}(React.Component);

exports.InternalResultList = InternalResultList;
var RelayContainer = react_relay_1.createRefetchContainer(InternalResultList, instantSearch_1.instantSearchFragment, instantSearch_1.instantSearchRefetchQuery);
exports.ResultList = function (ownProps) {
    return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: instantSearch_1.instantSearchRefetchQuery, variables: { query: ownProps.query }, render: function render(_ref4) {
            var error = _ref4.error,
                props = _ref4.props;

            if (error) {
                return React.createElement(Label_1.Span, { size: "small", textColor: "dangerous" }, error.message);
            }
            return React.createElement(RelayContainer, Object.assign({}, props ? props : { viewer: null }, ownProps));
            // return (
            //   <div className={ownProps.className}>
            //     <NProgress active />
            //   </div>
            // );
        } });
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.instantSearchFragment = {
  viewer: function viewer() {
    return __webpack_require__(1654);
  }
};
exports.instantSearchRefetchQuery = function () {
  return __webpack_require__(1655);
};

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type instantSearch_viewer$ref: FragmentReference;
export type instantSearch_viewer = {|
  +trackInstantSearch: ?{|
    +artists: ?$ReadOnlyArray<?{|
      +id: string,
      +name: ?string,
      +slug: ?string,
    |}>,
    +tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +slug: ?string,
      +title: ?string,
      +artist: ?{|
        +name: ?string,
      |},
    |}>,
    +taxonomies: ?$ReadOnlyArray<?{|
      +id: string,
      +internal_id: ?number,
      +name: ?string,
      +terms: ?$ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
      |}>,
    |}>,
  |},
  +$refType: instantSearch_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "instantSearch_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "trackInstantSearch",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String"
      }],
      "concreteType": "InstantSearchResult",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "artists",
        "storageKey": null,
        "args": null,
        "concreteType": "Artist",
        "plural": true,
        "selections": [v0, v1, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "tracks",
        "storageKey": null,
        "args": null,
        "concreteType": "Track",
        "plural": true,
        "selections": [v0, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [v1]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "taxonomies",
        "storageKey": null,
        "args": null,
        "concreteType": "Taxonomy",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "internal_id",
          "args": null,
          "storageKey": null
        }, v1, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": true,
          "selections": [v0, v1]
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = 'bf1040f94f14d841b1c77a1a077bc8b1';
module.exports = node;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 6dff3ead9e85d0b5a7e755e946608a4b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type instantSearch_viewer$ref = any;
export type instantSearchRefetchQueryVariables = {|
  query?: ?string,
|};
export type instantSearchRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: instantSearch_viewer$ref,
  |},
|};
*/

/*
query instantSearchRefetchQuery(
  $query: String
) {
  viewer {
    ...instantSearch_viewer
    id
  }
}

fragment instantSearch_viewer on Viewer {
  trackInstantSearch(query: $query) {
    artists {
      id
      name
      slug
    }
    tracks {
      id
      slug
      title
      artist {
        name
        id
      }
    }
    taxonomies {
      id
      internal_id
      name
      terms {
        id
        name
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "instantSearchRefetchQuery",
    "id": null,
    "text": "query instantSearchRefetchQuery(\n  $query: String\n) {\n  viewer {\n    ...instantSearch_viewer\n    id\n  }\n}\n\nfragment instantSearch_viewer on Viewer {\n  trackInstantSearch(query: $query) {\n    artists {\n      id\n      name\n      slug\n    }\n    tracks {\n      id\n      slug\n      title\n      artist {\n        name\n        id\n      }\n    }\n    taxonomies {\n      id\n      internal_id\n      name\n      terms {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "instantSearchRefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "instantSearch_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "instantSearchRefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "trackInstantSearch",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String"
          }],
          "concreteType": "InstantSearchResult",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "artists",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": true,
            "selections": [v1, v2, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tracks",
            "storageKey": null,
            "args": null,
            "concreteType": "Track",
            "plural": true,
            "selections": [v1, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [v2, v1]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "taxonomies",
            "storageKey": null,
            "args": null,
            "concreteType": "Taxonomy",
            "plural": true,
            "selections": [v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "internal_id",
              "args": null,
              "storageKey": null
            }, v2, {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": true,
              "selections": [v1, v2]
            }]
          }]
        }, v1]
      }]
    }
  };
}();
node /*: any*/.hash = '8f72b42ec38b01b5e377b3614dbed99c';
module.exports = node;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CategoryResultList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var Heading_1 = __webpack_require__(9);

var CategoryResultList = function (_React$PureComponent) {
    _inherits(CategoryResultList, _React$PureComponent);

    function CategoryResultList() {
        _classCallCheck(this, CategoryResultList);

        return _possibleConstructorReturn(this, (CategoryResultList.__proto__ || Object.getPrototypeOf(CategoryResultList)).apply(this, arguments));
    }

    _createClass(CategoryResultList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                index = _props.index,
                results = _props.results,
                title = _props.title;

            var classes = new BEM(className);
            return results && results.length ? React.createElement(velocity_react_1.VelocityComponent, { animation: "transition.slideUpIn", duration: 250, delay: 50 * index, runOnMount: true }, React.createElement("div", Object.assign({}, classes()), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('title')), title), React.createElement("ul", Object.assign({}, classes('list')), results.map(function (result) {
                return React.createElement("li", Object.assign({ key: result.id }, classes('list__item')), children(result));
            })))) : null;
        }
    }]);

    return CategoryResultList;
}(React.PureComponent);

exports.CategoryResultList = CategoryResultList;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultLinkFilter Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = __webpack_require__(47);
var React = __webpack_require__(0);
var queryString_1 = __webpack_require__(30);
var ResultLink_1 = __webpack_require__(667);

var InternalResultLinkFilter = function (_React$PureComponent) {
    _inherits(InternalResultLinkFilter, _React$PureComponent);

    function InternalResultLinkFilter() {
        _classCallCheck(this, InternalResultLinkFilter);

        var _this = _possibleConstructorReturn(this, (InternalResultLinkFilter.__proto__ || Object.getPrototypeOf(InternalResultLinkFilter)).apply(this, arguments));

        _this.onClick = function () {
            var filter = _this.props.filter;

            _this.props.addSearchFilter({ name: string_1.stripHTMLTagsFromString(filter.name), taxonomy: filter.taxonomy });
            if (_this.props.onAddSearchFilter) {
                _this.props.onAddSearchFilter(filter);
            }
        };
        return _this;
    }

    _createClass(InternalResultLinkFilter, [{
        key: "render",
        value: function render() {
            return React.createElement(ResultLink_1.ResultLink, { onClick: this.onClick, className: this.props.className, label: this.props.label });
        }
    }]);

    return InternalResultLinkFilter;
}(React.PureComponent);

exports.ResultLinkFilter = function (props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref) {
        var addSearchFilter = _ref.addSearchFilter,
            addTaxonomyQuery = _ref.addTaxonomyQuery;

        var operation = props.isTaxonomyQuery ? addTaxonomyQuery : addSearchFilter;
        return React.createElement(InternalResultLinkFilter, Object.assign({ addSearchFilter: operation }, props));
    });
};

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".search-terms{border-radius:8px;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);background:-webkit-linear-gradient(335.65deg,rgba(255,249,238,.38) .02%,hsla(0,0%,100%,0) 54.65%),#8a8f99;background:-o-linear-gradient(335.65deg,rgba(255,249,238,.38) .02%,hsla(0,0%,100%,0) 54.65%),#8a8f99;background:linear-gradient(114.35deg,rgba(255,249,238,.38) .02%,hsla(0,0%,100%,0) 54.65%),#8a8f99;display:-webkit-box;display:-ms-flexbox;display:flex}.search-terms__header{padding:40px}.search-terms__header__title{font-style:normal;font-weight:400;font-size:48px;line-height:45px;color:#fff}.search-terms__list{margin:0;padding:32px 40px 32px 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;min-height:112px}.search-terms__term{border-width:0;border-radius:64px;background:hsla(0,0%,100%,.2);font-style:normal;font-weight:500;font-size:21px;line-height:24px;-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275)}.search-terms__term .tag__label{color:#fff}.search-terms__term:hover{-webkit-transform:scale(1.05);-ms-transform:scale(1.05);transform:scale(1.05)}.search-terms__term:hover .tag__label{color:#8a8f99}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/SearchTermsBox/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,cC3EM,kBApBgB,sDCRqC,8CF2GzD,0GAAA,qGAAA,kGAA+G,oBAE/G,oBAAA,YAAa,CAEb,sBGbE,YCpE6C,CJoF7C,6BACE,kBAAkB,gBACC,eACJ,iBACE,UACH,CACf,oBAID,SAAS,2BAET,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,mBACnB,eAAe,gBIlG8B,CJoG9C,oBAGC,eAAe,mBAEf,8BAAoC,kBAClB,gBACF,eACD,iBACE,4EAMjB,oEAAA,+DAAA,4DAAA,oHK9HyD,CLiH1D,gCAUG,UAAY,CAVf,0BAeG,8BAAA,0BAAA,qBAAsB,CAfzB,sCAkBK,aMrJgB,CNsJjB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SearchTerms Component\n */\n\n.search-terms{\n  @include bgsize(large);\n  @include shadow(large);\n\n  background: linear-gradient(114.35deg, rgba(255, 249, 238, 0.38) 0.02%, rgba(255, 255, 255, 0) 54.65%), #8A8F99;\n\n  display: flex;\n\n  &__header{\n    @include padding(baseline(5) baseline(5));\n\n    &__title{\n      font-style: normal;\n      font-weight: normal;\n      font-size: 48px;\n      line-height: 45px;\n      color: #FFFFFF;\n    }\n  }\n\n  &__list {\n    margin: 0;\n    @include padding(baseline(4) baseline(5) baseline(4) baseline(1));\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    min-height: baseline(14);\n  }\n\n  &__term{\n    border-width: 0;\n    border-radius: baseline(8);\n    background: rgba(255, 255, 255, 0.2);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 21px;\n    line-height: 24px;\n\n    .tag__label {\n      color: white;\n    }\n\n    transition: transform .25s $ease-out-back;\n    &:hover{\n      transform: scale(1.05);\n\n      & .tag__label {\n        color: color(bw7);\n      }\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SearchTerm Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(669);
var farce_1 = __webpack_require__(306);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Tag_1 = __webpack_require__(127);
var Browse_1 = __webpack_require__(61);

var SearchTerm = function (_React$Component) {
    _inherits(SearchTerm, _React$Component);

    function SearchTerm() {
        _classCallCheck(this, SearchTerm);

        var _this = _possibleConstructorReturn(this, (SearchTerm.__proto__ || Object.getPrototypeOf(SearchTerm)).apply(this, arguments));

        _this.onClick = function () {
            var _this$props = _this.props,
                addSearchFilter = _this$props.addSearchFilter,
                gotoBrowsePage = _this$props.gotoBrowsePage,
                isInSearchFilters = _this$props.isInSearchFilters,
                name = _this$props.name,
                taxonomy = _this$props.taxonomy;

            if (isInSearchFilters) {
                gotoBrowsePage();
            } else {
                addSearchFilter({ name: name, taxonomy: { id: taxonomy.internal_id, name: taxonomy.name } });
            }
        };
        return _this;
    }

    _createClass(SearchTerm, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                name = _a.name,
                tagProps = __rest(_a, ["name"]);
            return React.createElement(Tag_1.default, Object.assign({ label: name, wrappedComponent: "li", onClick: this.onClick, size: "large" }, tagProps));
        }
    }]);

    return SearchTerm;
}(React.Component);

SearchTerm.defaultProps = {
    colorScheme: 'light'
};
var ConnectedSearchTerm = react_redux_1.connect(null, function (dispatch) {
    return {
        gotoBrowsePage: function gotoBrowsePage() {
            dispatch(farce_1.Actions.push(Browse_1.BrowsePagePath));
        }
    };
})(SearchTerm);
var SearchTermWithQueryStringContext = function SearchTermWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedSearchTerm, Object.assign({ addSearchFilter: ctx.addSearchFilter, isInSearchFilters: selectors_1.getSearchFilters(ctx).some(function (term) {
                return term.name === props.name;
            }) }, props));
    });
};
exports.default = SearchTermWithQueryStringContext;

/***/ }),
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1669);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".staff-picks--with-background{min-height:calc(100vh - 64px);padding-top:64px;padding-bottom:64px;background-color:#b1b8c4;margin-top:80px}.staff-picks__background{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;background-size:cover;background-attachment:fixed;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0)}.staff-picks__title{margin-bottom:16px}.staff-picks__track-list{margin:-8px 0 0 -8px;padding:0;list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.staff-picks__track-list__item{-ms-flex-preferred-size:calc(100% - 16px);flex-basis:calc(100% - 16px);margin:8px}.staff-picks__track-list__item__thumbnail{width:100%;-webkit-transition:.35s cubic-bezier(.175,.885,.32,1.275);-o-transition:.35s cubic-bezier(.175,.885,.32,1.275);transition:.35s cubic-bezier(.175,.885,.32,1.275);-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}.staff-picks__track-list__item__thumbnail:hover{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}@media screen and (min-width:600px){.staff-picks__track-list__item{-ms-flex-preferred-size:calc(100% - 16px);flex-basis:calc(100% - 16px)}}@media screen and (min-width:864px){.staff-picks__track-list__item{-ms-flex-preferred-size:calc(100% / 2 - 16px);flex-basis:calc(100% / 2 - 16px)}}@media screen and (min-width:1440px){.staff-picks__track-list__item{-ms-flex-preferred-size:calc(100% / 3 - 16px);flex-basis:calc(100% / 3 - 16px)}}@media screen and (min-width:768px){.staff-picks--with-video-background{padding-top:128px;padding-bottom:160px}.staff-picks__title{margin-bottom:32px}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/content/StaffPicks/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AA6GE,8BAxCA,8BAAyE,iBCwBjD,oBC1DuB,yBF8E7C,eE9E6C,CF+E9C,yBGxED,kBH2E4B,MAAG,QAAA,SAAA,OAAA,gBACb,sBACM,4BACM,mCAC5B,2BAA2B,gCAC3B,uBAAwB,CACzB,oBAGC,kBE3F6C,CF4F9C,yBAIC,qBACA,UAAU,gBACM,oBAChB,oBAAA,aAAa,mBACb,cAAe,CAEf,+BACE,0CAAA,6BAAsD,UEvGX,CF0G3C,0CACE,WAAW,0DACX,qDAAA,kDACA,gCAAA,4BAAA,uBAAwB,CAHzB,gDAKG,8BAAA,0BAAA,qBAAsB,CACvB,oCAKH,+BACE,0CAAA,4BAAsD,CACvD,CAAA,oCAID,+BACE,8CAAA,gCAA0D,CAC3D,CAAA,qCAID,+BACE,8CAAA,gCAA0D,CAC3D,CAAA,oCAKH,oCCvFoB,kBAYE,oBC7DuB,CF0I5C,oBAGC,kBE7I2C,CF8I5C,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * StaffPicks Component\n */\n\n.staff-picks{\n  &--with-background{\n    @include page-is-at-least-full-height(-$page-header-height);\n    @include padding(baseline(8) null);\n    @include bgcolor(bw6);\n    margin-top: baseline(10);\n  }\n\n  &__background{\n    @include position(absolute, 0);\n    overflow: hidden;\n    background-size: cover;\n    background-attachment: fixed;\n    backface-visibility: hidden;\n    transform: translateZ(0);\n  }\n\n  &__title{\n    margin-bottom: baseline(2);\n  }\n\n  &__track-list{\n    $item-margin: 1;\n    margin: baseline(-$item-margin) 0 0 baseline(-$item-margin);\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n\n    &__item{\n      flex-basis: calc(100% - #{baseline($item-margin * 2)});\n      margin: baseline($item-margin);\n\n      &__thumbnail{\n        width: 100%;\n        transition: .35s $ease-out-back;\n        transform-origin: bottom;\n        &:hover {\n          transform: scale(1.03);\n        }\n      }\n    }\n\n    @include media(breakpoint(tablet)) {\n      &__item{\n        flex-basis: calc(100% - #{baseline($item-margin * 2)});\n      }\n    }\n\n    @include media(breakpoint(desktop-xs)) {\n      &__item{\n        flex-basis: calc(100% / 2 - #{baseline($item-margin * 2)});\n      }\n    }\n\n    @include media(breakpoint(desktop-xl)) {\n      &__item{\n        flex-basis: calc(100% / 3 - #{baseline($item-margin * 2)});\n      }\n    }\n  }\n\n  @include media(breakpoint(tablet-l)) {\n    &--with-video-background{\n      @include padding(baseline(16) null baseline(20));\n    }\n\n    &__title{\n      margin-bottom: baseline(4);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DotNavigation Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(153);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Heading_1 = __webpack_require__(9);
var classes = new BEM('dot-navigation');

var DotNavigation = function (_React$Component) {
    _inherits(DotNavigation, _React$Component);

    function DotNavigation(props) {
        _classCallCheck(this, DotNavigation);

        var _this = _possibleConstructorReturn(this, (DotNavigation.__proto__ || Object.getPrototypeOf(DotNavigation)).call(this, props));

        _this.state = {
            currentDot: null
        };
        return _this;
    }

    _createClass(DotNavigation, [{
        key: "onMouseEnterDot",
        value: function onMouseEnterDot(dot) {
            this.setState({ currentDot: dot });
        }
    }, {
        key: "onMouseLeaveDot",
        value: function onMouseLeaveDot() {
            this.setState({ currentDot: null });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                interactive = _props.interactive,
                totalDots = _props.totalDots;

            var classModifiers = {
                interactive: !!interactive
            };
            var currentDot = this.state.currentDot || this.props.currentDot;
            return React.createElement("div", Object.assign({}, classes('', classModifiers, className)), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('progress')), this.props.currentDot + " / " + totalDots), React.createElement("div", Object.assign({}, classes('dots')), lodash_1.times(totalDots, function (n) {
                return React.createElement("div", Object.assign({ key: "dot-" + n, onMouseEnter: function onMouseEnter() {
                        return interactive && _this2.onMouseEnterDot(n + 1);
                    }, onMouseLeave: function onMouseLeave() {
                        return interactive && _this2.onMouseLeaveDot();
                    } }, classes('dot')));
            }), React.createElement("div", Object.assign({}, classes('dot', 'current', "position--" + currentDot)))));
        }
    }]);

    return DotNavigation;
}(React.Component);

exports.default = DotNavigation;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * RegistrationStepCompanyName Component
 */
var user_1 = __webpack_require__(50);
__webpack_require__(153);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('account-registration');

var RegistrationStepCompanyName = function (_React$Component) {
    _inherits(RegistrationStepCompanyName, _React$Component);

    function RegistrationStepCompanyName(props) {
        _classCallCheck(this, RegistrationStepCompanyName);

        var _this = _possibleConstructorReturn(this, (RegistrationStepCompanyName.__proto__ || Object.getPrototypeOf(RegistrationStepCompanyName)).call(this, props));

        _this.state = {
            error: '',
            companyNameInput: ''
        };
        return _this;
    }

    _createClass(RegistrationStepCompanyName, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.input.focus();
                _this2.forceUpdate();
            }, 500);
        }
    }, {
        key: "onInputChange",
        value: function onInputChange(companyNameInput) {
            this.setState({
                companyNameInput: companyNameInput
            });
        }
    }, {
        key: "onInputKeyDown",
        value: function onInputKeyDown(key, input) {
            if (key === 'Enter') {
                this.nextStep();
            }
        }
    }, {
        key: "nextStep",
        value: function nextStep() {
            var _this3 = this;

            var minLength = 2;
            var name = lodash_1.trim(this.state.companyNameInput);
            if (name.length >= minLength) {
                this.props.setCompanyName(name);
                setTimeout(this.props.onComplete, 0);
            } else {
                this.setState({
                    error: "Company name must be " + minLength + " characters or longer."
                }, function () {
                    Velocity(_this3.input, 'callout.shake', { duration: 500 });
                });
            }
        }
    }, {
        key: "onClickNext",
        value: function onClickNext(e) {
            this.nextStep();
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var error = this.state.error;

            return React.createElement("div", Object.assign({}, classes('step', 'company-name')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('step__title')), "Which company do you work for?"), React.createElement("input", Object.assign({ ref: function ref(node) {
                    return _this4.input = node;
                }, name: "company-name", onChange: function onChange(_ref) {
                    var target = _ref.target;
                    return _this4.onInputChange(target.value);
                }, onKeyDown: function onKeyDown(_ref2) {
                    var key = _ref2.key,
                        target = _ref2.target;
                    return _this4.onInputKeyDown(key, target);
                }, onBlur: function onBlur() {
                    return setTimeout(function () {
                        return _this4.input.focus();
                    }, 100);
                }, placeholder: "Company name", type: "text", value: this.state.companyNameInput, maxLength: 100 }, classes('textfield'))), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "div", className: "input-message", enter: { animation: 'transition.fadeIn', duration: 500 } }, React.createElement("div", null, React.createElement(Label_1.Span, { variant: "note", size: "medium" }, "Hit enter when you're done.")), error && React.createElement(Label_1.Span, { variant: "note", size: "medium", textColor: "dangerous" }, error), React.createElement("br", null), React.createElement("br", null), React.createElement(Button_1.default, { onClick: function onClick(e) {
                    return _this4.onClickNext(e);
                }, label: "Next", colorScheme: "dark", size: "medium" })));
        }
    }]);

    return RegistrationStepCompanyName;
}(React.Component);

exports.ConnectedRegistrationStepCompanyName = react_redux_1.connect(null, function (dispatch) {
    return {
        setCompanyName: function setCompanyName(name) {
            dispatch(user_1.setUserDetail({ key: 'companyName', value: name }));
        }
    };
})(RegistrationStepCompanyName);

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * RegistrationStepIndustry Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = __webpack_require__(50);
__webpack_require__(153);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var config_1 = __webpack_require__(436);
var classes = new BEM('account-registration');

var RegistrationStepIndustry = function (_React$Component) {
    _inherits(RegistrationStepIndustry, _React$Component);

    function RegistrationStepIndustry() {
        _classCallCheck(this, RegistrationStepIndustry);

        return _possibleConstructorReturn(this, (RegistrationStepIndustry.__proto__ || Object.getPrototypeOf(RegistrationStepIndustry)).apply(this, arguments));
    }

    _createClass(RegistrationStepIndustry, [{
        key: "onClickButton",
        value: function onClickButton(industry) {
            this.props.setUserIndustry(industry);
            setTimeout(this.props.onComplete, 0);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement("div", Object.assign({}, classes('step', 'company-type')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('step__title')), "What does your company do?"), React.createElement("ul", null, config_1.industries.map(function (_ref) {
                var id = _ref.id,
                    label = _ref.label;
                return React.createElement("li", { key: "job-type-" + id }, React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                        return _this2.onClickButton(id);
                    }, colorScheme: "white", label: label, size: "small" }, classes('answer-button'))));
            })));
        }
    }]);

    return RegistrationStepIndustry;
}(React.Component);

var ConnectedRegistrationStepIndustry = react_redux_1.connect(null, function (dispatch) {
    return {
        setUserIndustry: function setUserIndustry(value) {
            dispatch(user_1.setUserDetail({ key: 'industryId', value: value }));
        }
    };
})(RegistrationStepIndustry);
exports.default = ConnectedRegistrationStepIndustry;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * RegistrationStepJobType Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = __webpack_require__(50);
__webpack_require__(153);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var config_1 = __webpack_require__(436);
var classes = new BEM('account-registration');

var RegistrationStepJobType = function (_React$Component) {
    _inherits(RegistrationStepJobType, _React$Component);

    function RegistrationStepJobType() {
        _classCallCheck(this, RegistrationStepJobType);

        return _possibleConstructorReturn(this, (RegistrationStepJobType.__proto__ || Object.getPrototypeOf(RegistrationStepJobType)).apply(this, arguments));
    }

    _createClass(RegistrationStepJobType, [{
        key: "onClickButton",
        value: function onClickButton(jobType) {
            this.props.setUserJobType(jobType);
            setTimeout(this.props.onComplete, 0);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var userFirstName = this.props.userFirstName;

            var question = "What do you do," + (userFirstName && " " + userFirstName) + "?";
            return React.createElement("div", Object.assign({}, classes('step', 'job-type')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('step__title')), question), React.createElement("ul", null, config_1.jobTypes.map(function (_ref) {
                var id = _ref.id,
                    label = _ref.label;
                return React.createElement("li", { key: "job-type-" + id }, React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                        return _this2.onClickButton(id);
                    }, colorScheme: "white", label: label, size: "small" }, classes('answer-button'))));
            })));
        }
    }]);

    return RegistrationStepJobType;
}(React.Component);

var ConnectedRegistrationStepJobType = react_redux_1.connect(function (_ref2) {
    var registrationForm = _ref2.user.registrationForm;
    return {
        userFirstName: registrationForm && registrationForm.firstName
    };
}, function (dispatch) {
    return {
        setUserJobType: function setUserJobType(value) {
            dispatch(user_1.setUserDetail({ key: 'jobTypeId', value: value }));
        }
    };
})(RegistrationStepJobType);
exports.default = ConnectedRegistrationStepJobType;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * RegistrationStepPhone Component
 */
var user_1 = __webpack_require__(50);
__webpack_require__(153);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('account-registration');

var RegistrationStepPhone = function (_React$Component) {
    _inherits(RegistrationStepPhone, _React$Component);

    function RegistrationStepPhone(props) {
        _classCallCheck(this, RegistrationStepPhone);

        var _this = _possibleConstructorReturn(this, (RegistrationStepPhone.__proto__ || Object.getPrototypeOf(RegistrationStepPhone)).call(this, props));

        _this.state = {
            error: '',
            phoneInput: ''
        };
        return _this;
    }

    _createClass(RegistrationStepPhone, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.input.focus();
                _this2.forceUpdate();
            }, 500);
        }
    }, {
        key: "onPhoneInputChange",
        value: function onPhoneInputChange(phoneInput) {
            this.setState({
                phoneInput: phoneInput
            });
        }
    }, {
        key: "onPhoneInputKeyDown",
        value: function onPhoneInputKeyDown(key, input) {
            if (key === 'Enter') {
                this.nextStep();
            }
        }
    }, {
        key: "nextStep",
        value: function nextStep() {
            var _this3 = this;

            var phone = lodash_1.trim(this.state.phoneInput);
            var digits = phone.replace(/[^\d]+/g, '');
            if (digits.length >= 10) {
                this.props.setPhone(phone);
                setTimeout(this.props.onComplete, 0);
            } else {
                this.setState({
                    error: "Your phone number doesn't seem right... Make sure to include the area code."
                }, function () {
                    Velocity(_this3.input, 'callout.shake', { duration: 500 });
                });
            }
        }
    }, {
        key: "onClickNext",
        value: function onClickNext(e) {
            this.nextStep();
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var error = this.state.error;

            return React.createElement("div", Object.assign({}, classes('step', 'phone')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('step__title')), "What's the best phone number to reach you?"), React.createElement("input", Object.assign({ ref: function ref(node) {
                    return _this4.input = node;
                }, name: "phone", onChange: function onChange(_ref) {
                    var target = _ref.target;
                    return _this4.onPhoneInputChange(target.value);
                }, onKeyDown: function onKeyDown(_ref2) {
                    var key = _ref2.key,
                        target = _ref2.target;
                    return _this4.onPhoneInputKeyDown(key, target);
                }, onBlur: function onBlur() {
                    return setTimeout(function () {
                        return _this4.input.focus();
                    }, 100);
                }, placeholder: "Phone number", type: "text", value: this.state.phoneInput, maxLength: 50 }, classes('textfield'))), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "div", className: "input-message", enter: { animation: 'transition.fadeIn', duration: 500 } }, React.createElement("div", null, React.createElement(Label_1.Span, { variant: "note", size: "medium" }, "Hit enter when you're done.")), error && React.createElement(Label_1.Span, { variant: "note", size: "medium", textColor: "dangerous" }, error), React.createElement("br", null), React.createElement("br", null), React.createElement(Button_1.default, { onClick: function onClick(e) {
                    return _this4.onClickNext(e);
                }, label: "Next", colorScheme: "dark", size: "medium" })));
        }
    }]);

    return RegistrationStepPhone;
}(React.Component);

var ConnectedRegistrationStepPhone = react_redux_1.connect(null, function (dispatch) {
    return {
        setPhone: function setPhone(phone) {
            dispatch(user_1.setUserDetail({ key: 'phone', value: phone }));
        }
    };
})(RegistrationStepPhone);
exports.default = ConnectedRegistrationStepPhone;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * RegistrationStepUserName Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = __webpack_require__(50);
__webpack_require__(153);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM('account-registration');

var RegistrationStepUserName = function (_React$Component) {
    _inherits(RegistrationStepUserName, _React$Component);

    function RegistrationStepUserName(props) {
        _classCallCheck(this, RegistrationStepUserName);

        var _this = _possibleConstructorReturn(this, (RegistrationStepUserName.__proto__ || Object.getPrototypeOf(RegistrationStepUserName)).call(this, props));

        _this.state = {
            error: '',
            nameInput: '',
            userFirstName: '',
            userLastName: ''
        };
        return _this;
    }

    _createClass(RegistrationStepUserName, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.input.focus();
                _this2.forceUpdate();
            }, 500);
        }
    }, {
        key: "onNameInputChange",
        value: function onNameInputChange(nameInput) {
            var firstNameIsSet = lodash_1.trim(nameInput).match(/(\S{2,})/);
            var userFirstName = this.state.userFirstName ? this.state.userFirstName : firstNameIsSet ? firstNameIsSet[1] : undefined;
            var error = this.state.error && !userFirstName ? this.state.error : '';
            this.setState({
                error: error,
                nameInput: nameInput,
                userFirstName: userFirstName
            });
        }
    }, {
        key: "onNameInputKeyDown",
        value: function onNameInputKeyDown(key, input) {
            if (key === 'Enter') {
                this.nextStep();
            }
        }
    }, {
        key: "nextStep",
        value: function nextStep() {
            var _this3 = this;

            if (this.state.userFirstName && this.state.userFirstName !== '') {
                var userFullName = lodash_1.trim(this.state.nameInput).match(/(\S+)\s?(.*)$/);
                this.props.setUserName(userFullName[1], userFullName[2]);
                setTimeout(this.props.onComplete, 0);
            } else {
                this.setState({
                    error: "This field is required."
                }, function () {
                    Velocity(_this3.input, 'callout.shake', { duration: 500 });
                });
            }
        }
    }, {
        key: "onClickNext",
        value: function onClickNext(e) {
            this.nextStep();
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var error = this.state.error;

            return React.createElement("div", Object.assign({}, classes('step', 'user-name')), React.createElement(Heading_1.default, Object.assign({ is: "h3" }, classes('step__title')), "Enter your full name:"), React.createElement("input", Object.assign({ ref: function ref(node) {
                    return _this4.input = node;
                }, name: "fullname", onChange: function onChange(_ref) {
                    var target = _ref.target;
                    return _this4.onNameInputChange(target.value);
                }, onKeyDown: function onKeyDown(_ref2) {
                    var key = _ref2.key,
                        target = _ref2.target;
                    return _this4.onNameInputKeyDown(key, target);
                }, onBlur: function onBlur() {
                    return setTimeout(function () {
                        return _this4.input.focus();
                    }, 100);
                }, placeholder: "First and last name", type: "text", value: this.state.nameInput }, classes('textfield'))), React.createElement(velocity_react_1.VelocityTransitionGroup, { component: "div", className: "input-message", enter: { animation: 'transition.fadeIn', duration: 500 } }, React.createElement("div", null, React.createElement(Label_1.Span, { variant: "note", size: "medium" }, "Hit enter when you're done.")), error && React.createElement(Label_1.Span, { variant: "note", size: "medium", textColor: "dangerous" }, error), React.createElement("br", null), React.createElement("br", null), React.createElement(Button_1.default, { onClick: function onClick(e) {
                    return _this4.onClickNext(e);
                }, label: "Next", colorScheme: "dark", size: "medium" })));
        }
    }]);

    return RegistrationStepUserName;
}(React.Component);

var ConnectedRegistrationStepUserName = react_redux_1.connect(null, function (dispatch) {
    return {
        setUserName: function setUserName(firstName, lastName) {
            dispatch(user_1.setUserDetail({ key: 'firstName', value: firstName }));
            dispatch(user_1.setUserDetail({ key: 'lastName', value: lastName }));
        }
    };
})(RegistrationStepUserName);
exports.default = ConnectedRegistrationStepUserName;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1677);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--verify-email .page__main{min-height:calc(100vh - 64px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;width:90%;max-width:640px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 auto;padding-bottom:64px}.verify-email__title{margin-bottom:0}.verify-email__subtitle{margin-bottom:32px}.verify-email__login-form{width:320px}.verify-email__content--form{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);max-width:416px;width:90%;padding:48px 32px}.verify-email__content--form .heading{margin-bottom:16px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/VerifyEmail/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,gCAvCE,8BAAyE,oBA0CvE,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,kBACJ,UACR,gBAEV,yBAAA,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,cACT,mBCnF+B,CDqF9C,qBAKC,eAAgB,CACjB,wBAEC,kBC7F6C,CD8F9C,0BAEC,WChG6C,CDiG9C,6BE3DC,sBAxCQ,kBCvBU,sDCLqC,8CJqIrD,gBACA,UAAU,iBCxGiC,CDmG5C,sCASG,kBC5GyC,CD6G1C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * VerifyEmailPage Component\n */\n\n.page--verify-email{\n  .page__main{\n    @include page-is-at-least-full-height(-$page-header-height);\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    width: 90%;\n    max-width: baseline(80);\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    padding-bottom: baseline(8);\n  }\n}\n\n.verify-email{\n  &__title{\n    margin-bottom: 0;\n  }\n  &__subtitle{\n    margin-bottom: baseline(4);\n  }\n  &__login-form{\n    width: baseline(40);\n  }\n  &__content{\n    &--form{\n      @include bgcolor(bw1);\n      @include bgsize(medium);\n      @include shadow(large);\n      max-width: baseline(52);\n      width: 90%;\n      padding: baseline(6) baseline(4);\n\n      .heading{\n        margin-bottom: baseline(2);\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 1089bf6d937d67b936b079c675300ec7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type logout_viewer$ref = any;
export type logout_QueryVariables = {| |};
export type logout_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: logout_viewer$ref,
  |},
|};
*/

/*
query logout_Query {
  viewer {
    ...logout_viewer
    id
  }
}

fragment logout_viewer on Viewer {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "logout_Query",
  "id": null,
  "text": "query logout_Query {\n  viewer {\n    ...logout_viewer\n    id\n  }\n}\n\nfragment logout_viewer on Viewer {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "logout_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "Viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "logout_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "logout_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "Viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
node /*: any*/.hash = '361f226c76aca92b9953f37cf9a0ff44';
module.exports = node;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type logout_viewer$ref: FragmentReference;
export type logout_viewer = {|
  +id: string,
  +$refType: logout_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "logout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
node /*: any*/.hash = '7bc4208322a88c8e19a7ee5045d18a85';
module.exports = node;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash b1335c97f855e9fc870e1234d2a75013
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type logout_MutationVariables = {|
  input: {
    clientMutationId?: ?string,
  },
|};
export type logout_MutationResponse = {|
  +logout: ?{|
    +clientMutationId: ?string,
  |},
|};
*/

/*
mutation logout_Mutation(
  $input: LogoutInput!
) {
  logout(input: $input) {
    clientMutationId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogoutInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logout",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogoutInput!"
    }],
    "concreteType": "LogoutPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "clientMutationId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "logout_Mutation",
    "id": null,
    "text": "mutation logout_Mutation(\n  $input: LogoutInput!\n) {\n  logout(input: $input) {\n    clientMutationId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "logout_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "logout_Mutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
node /*: any*/.hash = 'd5df01013d601245a477479fd0cd048a';
module.exports = node;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1682);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--logout{background-color:#f0f6fa}.page--logout .page__main{height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;padding:5vw 48px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Logout/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GC,cCnCG,wBAzDuB,CD4F1B,0BAGG,aAAa,oBACb,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,kBACD,gBEhF2B,CFkF9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Logout Page Component\n */\n\n .page--logout{\n   @include bgcolor(bw3);\n  .page__main{\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 5vw baseline(6);\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing"},"costexplorer":{"prefix":"ce","name":"CostExplorer"},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData"},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend"},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia"},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia"},"kinesisvideo":{"name":"KinesisVideo"},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate"},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups"},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"}}

/***/ }),
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"Schema":{"shape":"S5h"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5r"},"WriteAttributes":{"shape":"S5r"},"ExplicitAuthFlows":{"shape":"S5t"},"SupportedIdentityProviders":{"shape":"S5v"},"CallbackURLs":{"shape":"S5w"},"LogoutURLs":{"shape":"S5y"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S5z"},"AllowedOAuthScopes":{"shape":"S61"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S63"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S66"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S66"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4f"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4j"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7p"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7p"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5r"},"WriteAttributes":{"shape":"S5r"},"ExplicitAuthFlows":{"shape":"S5t"},"SupportedIdentityProviders":{"shape":"S5v"},"CallbackURLs":{"shape":"S5w"},"LogoutURLs":{"shape":"S5y"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S5z"},"AllowedOAuthScopes":{"shape":"S61"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S63"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S66"}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3p":{"type":"string","sensitive":true},"S3r":{"type":"structure","members":{"EncodedData":{}}},"S40":{"type":"map","key":{},"value":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S46":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4a":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4f":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"S4j":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4r":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S4u":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4z":{"type":"list","member":{}},"S54":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S59":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S5c":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5d":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5h":{"type":"list","member":{"shape":"S4"}},"S5i":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5l":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5h"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"S5r":{"type":"list","member":{}},"S5t":{"type":"list","member":{}},"S5v":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S5y":{"type":"list","member":{}},"S5z":{"type":"list","member":{}},"S61":{"type":"list","member":{}},"S63":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S66":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5r"},"WriteAttributes":{"shape":"S5r"},"ExplicitAuthFlows":{"shape":"S5t"},"SupportedIdentityProviders":{"shape":"S5v"},"CallbackURLs":{"shape":"S5w"},"LogoutURLs":{"shape":"S5y"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S5z"},"AllowedOAuthScopes":{"shape":"S61"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S63"}}},"S6r":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"},"LastModifiedDate":{"type":"timestamp"}}},"S6s":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S6x":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S6z"},"NoActionEmail":{"shape":"S6z"},"MfaEmail":{"shape":"S6z"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S73"},"MediumAction":{"shape":"S73"},"HighAction":{"shape":"S73"}}}}},"S6z":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S73":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S76":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7p":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S81":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8b":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5c"}}},"S8c":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9c":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1761 */,
/* 1762 */,
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Checkout Redux Reducer
 */

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(92);
var update = __webpack_require__(446);
var lodash_1 = __webpack_require__(6);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var config_1 = __webpack_require__(80);
var defaultList = [];
var initialState = {
    activeStep: '',
    completedSteps: defaultList,
    steps: defaultList
};
var registerStepHandler = function registerStepHandler(state, _ref) {
    var id = _ref.id;
    return Object.assign({}, state, { steps: lodash_1.union(state.steps, [id]) });
};
var setActiveStepHandler = function setActiveStepHandler(state, _ref2) {
    var id = _ref2.id;

    var activeStepIndex = config_1.CheckoutStepsOrder[id];
    var completedSteps = state.completedSteps.reduce(function (acc, step) {
        if (config_1.CheckoutStepsOrder[step] < activeStepIndex) {
            acc.push(step);
        }
        return acc;
    }, []);
    return Object.assign({}, state, { activeStep: id, completedSteps: completedSteps });
};
var completeStepHandler = function completeStepHandler(state, _ref3) {
    var id = _ref3.id;
    return Object.assign({}, state, {
        // IMPORTANT: active step should be set to 'order placed' at the end of the
        // checkout process to make sure that the 'project-details' checkout step
        // that gets set immediately after this step can be distinguished from the
        // initial 'project-details' step that gets set when the user lands on it
        // at the beginning of the checkout process. This is needed for correctly
        // recording analytics. See /public/analytics/events/checkout.ts.
        activeStep: state.steps[state.steps.indexOf(id) + 1] || config_1.CheckoutStepId.orderPlaced, completedSteps: lodash_1.union(state.completedSteps, [id]) });
};
var removeCompletedStepHandler = function removeCompletedStepHandler(state, _ref4) {
    var id = _ref4.id;
    return Object.assign({}, state, { completedSteps: update(state.completedSteps, {
            $splice: [[state.completedSteps.indexOf(id), 1]]
        }) });
};
var consumeLocallyStoredStepHandler = function consumeLocallyStoredStepHandler(state, _ref5) {
    var id = _ref5.id;
    return Object.assign({}, state, { localStorage: update(state.localStorage, {
            $unset: [id]
        }) });
};
var setCheckoutFromLocalStorageHandler = function setCheckoutFromLocalStorageHandler(state, _ref6) {
    var result = _ref6.result;

    return Object.assign({}, state, { localStorage: result });
};
var placeOrderCompleteHandler = function placeOrderCompleteHandler() {
    return Object.assign({}, initialState, { activeStep: config_1.CheckoutStepId.orderPlaced });
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(actions.registerStep, registerStepHandler).case(actions.setActiveStep, setActiveStepHandler).case(actions.completeStep, completeStepHandler).case(actions.removeCompletedStep, removeCompletedStepHandler).case(actions.consumeLocallyStoredStep, consumeLocallyStoredStepHandler).case(actions.setCheckoutFromLocalStorage.done, setCheckoutFromLocalStorageHandler).case(actions.placeOrder.done, placeOrderCompleteHandler);

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Country List Redux Reducer
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(222);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var defaultList = [];
var initialState = {
    countries: defaultList,
    postalCodes: {},
    states: {}
};
var receiveCountriesHandler = function receiveCountriesHandler(state, _ref) {
    var _ref$result = _ref.result,
        countries = _ref$result.countries,
        postalCodes = _ref$result.postalCodes;
    return Object.assign({}, state, { countries: countries,
        postalCodes: postalCodes });
};
var receiveStatesForCountryHandler = function receiveStatesForCountryHandler(state, payload) {
    return Object.assign({}, state, { states: Object.assign({}, state.states, _defineProperty({}, payload.result.countryId, payload.result.states)) });
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(actions.fetchCountries.done, receiveCountriesHandler).case(actions.fetchStatesForCountry.done, receiveStatesForCountryHandler);

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

Object.defineProperty(exports, "__esModule", { value: true });
var action = __webpack_require__(276);
var license_1 = __webpack_require__(34);
var update = __webpack_require__(446);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var defaultList = [];
var initialState = {
    currentMediumEdit: null,
    editingUsageIndex: null,
    isValid: false,
    usages: defaultList
};
var setEditingUsageIndexHandler = function setEditingUsageIndexHandler(state, _ref) {
    var index = _ref.index;
    return Object.assign({}, state, { editingUsageIndex: index });
};
var setUsagesHandler = function setUsagesHandler(state, _ref2) {
    var scope = _ref2.scope,
        usages = _ref2.usages;

    var currentMediumEdit = !!usages.length ? usages[0].medium.id : null;
    return Object.assign({}, state, { currentMediumEdit: currentMediumEdit, isValid: license_1.isLicenseValid(usages), scope: scope || state.scope, usages: usages });
};
var addMediumHandler = function addMediumHandler(state, usage) {
    return Object.assign({}, state, { isValid: false, usages: [].concat(_toConsumableArray(state.usages), [{
            id: license_1.generateUsageId(usage, state.usages.length),
            medium: usage.medium,
            contextual_param_type: usage.contextualParamType
        }]) });
};
var removeMediumHandler = function removeMediumHandler(state, _ref3) {
    var id = _ref3.id;

    var usages = update(state.usages, {
        $splice: [[license_1.getUsageIndexById(id)(state), 1]]
    });
    return Object.assign({}, state, { isValid: license_1.isLicenseValid(usages), usages: usages });
};
var setComponentForUsageHandler = function setComponentForUsageHandler(state, _ref4) {
    var component = _ref4.component,
        index = _ref4.index,
        value = _ref4.value;

    if (index < state.usages.length) {
        var updatedUsage = license_1.setComponentForUsage(index, component, value)(state);
        var usages = update(state.usages, {
            $splice: [[index, 1, updatedUsage]]
        });
        return Object.assign({}, state, { isValid: license_1.isLicenseValid(usages), usages: usages });
    }
    return state;
};
var clearLicenseHandler = function clearLicenseHandler() {
    return initialState;
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(action.setUsages, setUsagesHandler).case(action.addMedium, addMediumHandler).case(action.removeMedium, removeMediumHandler).case(action.setEditingUsageIndex, setEditingUsageIndexHandler).case(action.setComponentForUsage, setComponentForUsageHandler).case(action.clearLicense, clearLicenseHandler);

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Notification Redux Reducer
 */

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

Object.defineProperty(exports, "__esModule", { value: true });
var update = __webpack_require__(446);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var actions = __webpack_require__(53);
var initialState = [];
var pushNotificationHandler = function pushNotificationHandler(state, payload) {
  return [].concat(_toConsumableArray(state), [payload]);
};
var consumeNotificationHandler = function consumeNotificationHandler(state) {
  return update(state, { $splice: [[0, 1]] });
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(actions.pushNotification, pushNotificationHandler).case(actions.consumeNotification, consumeNotificationHandler);

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(256);
var actions = __webpack_require__(42);
var player_1 = __webpack_require__(63);
var lodash_1 = __webpack_require__(6);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var defaultList = [];
var initialState = {
    currentTrack: null,
    history: defaultList,
    isTrackPlaying: false,
    queue: defaultList,
    shouldOnlyPlayOriginalTracks: true
};
var addTrackToQueueHandler = function addTrackToQueueHandler(state, _ref) {
    var track = _ref.track;
    return Object.assign({}, state, { queue: [].concat(_toConsumableArray(state.queue), [track]) });
};
var addTracksToQueueHandler = function addTracksToQueueHandler(state, _ref2) {
    var tracks = _ref2.tracks,
        replace = _ref2.replace;

    var newState = Object.assign({}, state);
    newState.queue = replace ? tracks : lodash_1.uniqBy([].concat(_toConsumableArray(state.queue), _toConsumableArray(tracks)), 'versionId');
    newState.queue.forEach(function (track) {
        track.isFirstInQueue = false;
        track.isLastInQueue = false;
    });
    if (newState.queue.length) {
        lodash_1.first(newState.queue).isFirstInQueue = true;
        lodash_1.last(newState.queue).isLastInQueue = true;
    }
    if (state.currentTrack) {
        var currentTrackIndex = lodash_1.findIndex(newState.queue, { versionId: state.currentTrack.versionId });
        if (currentTrackIndex > -1) {
            newState.queue = array_1.rotateArray([].concat(_toConsumableArray(newState.queue)), currentTrackIndex + 1);
        }
    }
    return newState;
};
var clearQueueHandler = function clearQueueHandler(state) {
    return initialState;
};
var replaceQueueHandler = function replaceQueueHandler(state, _ref3) {
    var tracks = _ref3.tracks;
    return addTracksToQueueHandler(state, { tracks: tracks, replace: true });
};
var playHandler = function playHandler(state) {
    return Object.assign({}, state, { isTrackPlaying: true });
};
var pauseHandler = function pauseHandler(state) {
    return Object.assign({}, state, { isTrackPlaying: false });
};
var togglePlayHandler = function togglePlayHandler(state) {
    return Object.assign({}, state, { isTrackPlaying: !state.isTrackPlaying });
};
var playNextHandler = function playNextHandler(state) {
    return player_1.changeTrack(state, 1);
};
var playPreviousHandler = function playPreviousHandler(state) {
    return player_1.changeTrack(state, -1);
};
var playTrackFromQueueHandler = function playTrackFromQueueHandler(state, _ref4) {
    var trackId = _ref4.trackId;
    return player_1.changeTrack(state, trackId);
};
var updateCurrentTrackElapsedTimeHandler = function updateCurrentTrackElapsedTimeHandler(state, _ref5) {
    var elapsedTime = _ref5.elapsedTime;
    return Object.assign({}, state, { currentTrack: Object.assign({}, state.currentTrack, { elapsedTime: elapsedTime }) });
};
var toggleShouldOnlyPlayOriginalTracksHandler = function toggleShouldOnlyPlayOriginalTracksHandler(state, shouldOnlyPlayOriginalTracks) {
    return Object.assign({}, state, { shouldOnlyPlayOriginalTracks: shouldOnlyPlayOriginalTracks });
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(actions.addTrackToQueue, addTrackToQueueHandler).case(actions.addTracksToQueue, addTracksToQueueHandler).case(actions.replaceQueue, replaceQueueHandler).case(actions.clearQueue, clearQueueHandler).case(actions.pause, pauseHandler).case(actions.play, playHandler).case(actions.playNext, playNextHandler).case(actions.playPrevious, playPreviousHandler).case(actions.playTrackFromQueue, playTrackFromQueueHandler).case(actions.togglePlay, togglePlayHandler).case(actions.updateCurrentTrackElapsedTime, updateCurrentTrackElapsedTimeHandler).case(actions.toggleShouldOnlyPlayOriginalTracks, toggleShouldOnlyPlayOriginalTracksHandler);

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Post Authentication Requests Redux Reducer
 */

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var postAuthenticationRequests_1 = __webpack_require__(81);
var lodash_1 = __webpack_require__(6);
var luxon_1 = __webpack_require__(280);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var initialState = [];
var clearPostAuthenticationRequestsHandler = function clearPostAuthenticationRequestsHandler() {
    return initialState;
};
var pushPostAuthenticationRequestHandler = function pushPostAuthenticationRequestHandler(state, payload) {
    return [].concat(_toConsumableArray(state), [payload]);
};
var pushAuthenticationRequestFactory = function pushAuthenticationRequestFactory(requestType) {
    return function (state, payload) {
        var _a = payload,
            page = _a.page,
            restPayload = __rest(_a, ["page"]);
        return pushPostAuthenticationRequestHandler(state, {
            requestedAt: luxon_1.DateTime.local().toISO(),
            requestType: requestType,
            page: page,
            payload: lodash_1.isEmpty(restPayload) ? undefined : restPayload
        });
    };
};
var recoverPostAuthenticationRequestsHandler = function recoverPostAuthenticationRequestsHandler(_, payload) {
    return payload;
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(postAuthenticationRequests_1.pushPostAuthenticationRequestPage, pushAuthenticationRequestFactory('page')).case(postAuthenticationRequests_1.pushPostAuthenticationRequestDownload, pushAuthenticationRequestFactory('downloadTrack')).case(postAuthenticationRequests_1.pushPostAuthenticationRequestCreateProject, pushAuthenticationRequestFactory('createProject')).case(postAuthenticationRequests_1.pushPostAuthenticationRequestJoinProject, pushAuthenticationRequestFactory('joinProject')).case(postAuthenticationRequests_1.recoverPostAuthenticationRequests, recoverPostAuthenticationRequestsHandler).case(postAuthenticationRequests_1.clearPostAuthenticationRequests, clearPostAuthenticationRequestsHandler);

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Preferences Redux Reducer
 */

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(347);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var locales_1 = __webpack_require__(52);
var initialState = {
    language: locales_1.getUserLanguage()
};
var setLanguageHandler = function setLanguageHandler(state, _ref) {
    var language = _ref.language;
    return Object.assign({}, state, { language: language });
};
var setPreferencesFromLocalStorageHandler = function setPreferencesFromLocalStorageHandler(state, _ref2) {
    var result = _ref2.result;
    return result;
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(actions.setLanguage, setLanguageHandler).case(actions.setPreferencesFromLocalStorage.done, setPreferencesFromLocalStorageHandler);

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Projects Redux Reducer
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

Object.defineProperty(exports, "__esModule", { value: true });
var action = __webpack_require__(130);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var defaultList = [];
var initialState = {};
var setProjectsHandler = function setProjectsHandler(state, _ref) {
    var projects = _ref.projects;
    return projects.reduce(function (acc, project) {
        acc[project.id] = project.tracks ? project.tracks.edges.map(function (_ref2) {
            var id = _ref2.id;
            return id;
        }) : defaultList;
        return acc;
    }, {});
};
var addTrackToProjectHandler = function addTrackToProjectHandler(state, _ref3) {
    var _ref3$params = _ref3.params,
        projectId = _ref3$params.projectId,
        trackId = _ref3$params.trackId;
    return Object.assign({}, state, _defineProperty({}, projectId, [].concat(_toConsumableArray(state.hasOwnProperty(projectId) ? state[projectId] : defaultList), [trackId])));
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(action.setProjects, setProjectsHandler).case(action.addTrackToProject.done, addTrackToProjectHandler);

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * UI Reducers
 */
/* tslint:disable:max-line-length */
var action = __webpack_require__(29);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var initialState = {
    header: {
        type: 'simple',
        visible: true
    },
    licenseBar: {
        heightPx: 64,
        visible: false
    }
};
var pageIsScrollingHandler = function pageIsScrollingHandler(state, pageIsScrolling) {
    return Object.assign({}, state, { pageIsScrolling: pageIsScrolling });
};
var toggleLicenseBarVisibilityHandler = function toggleLicenseBarVisibilityHandler(state, visible) {
    return Object.assign({}, state, { licenseBar: Object.assign({}, state.licenseBar, { visible: visible }) });
};
var setLicenseBarHeightHandler = function setLicenseBarHeightHandler(state, heightPx) {
    return Object.assign({}, state, { licenseBar: Object.assign({}, state.licenseBar, { heightPx: heightPx }) });
};
var toggleHeaderVisibilityHandler = function toggleHeaderVisibilityHandler(state, visible) {
    return Object.assign({}, state, { header: Object.assign({}, state.header, { visible: visible }) });
};
var toggleTrackDetailsVisibilityHandler = function toggleTrackDetailsVisibilityHandler(state, visible) {
    return Object.assign({}, state, { trackDetails: Object.assign({}, state.trackDetails, { visible: visible }) });
};
var toggleAddToProjectVisibilityHandler = function toggleAddToProjectVisibilityHandler(state, visible) {
    return Object.assign({}, state, { addToProject: visible ? Object.assign({}, state.addToProject ? state.addToProject : { trackId: undefined, trackVersion: undefined }, { visible: visible }) : undefined });
};
var showTrackDetailsHandler = function showTrackDetailsHandler(state, _ref) {
    var cartLineItemId = _ref.cartLineItemId,
        license = _ref.license,
        trackInfo = _ref.trackInfo;
    return Object.assign({}, state, { trackDetails: {
            visible: true,
            license: license,
            trackInfo: trackInfo,
            cartLineItemId: cartLineItemId
        } });
};
var toggleSignUpFormVisibilityHandler = function toggleSignUpFormVisibilityHandler(state, visible) {
    return Object.assign({}, state, { signUpForm: { visible: visible } });
};
var toggleLogInFormVisibilityHandler = function toggleLogInFormVisibilityHandler(state, visible) {
    return Object.assign({}, state, { logInForm: { visible: visible } });
};
var togglePlayerTermListVisibilityHandler = function togglePlayerTermListVisibilityHandler(state, visible) {
    return Object.assign({}, state, { player: { termListIsVisible: visible, visible: visible } });
};
var showAddTrackToProjectFormHandler = function showAddTrackToProjectFormHandler(state, _ref2) {
    var trackId = _ref2.trackId,
        trackVersion = _ref2.trackVersion;
    return Object.assign({}, state, { addToProject: {
            visible: true,
            trackId: trackId,
            trackVersion: trackVersion
        } });
};
var showDownloadAgreementModalHandler = function showDownloadAgreementModalHandler(state, _ref3) {
    var filePath = _ref3.filePath,
        track = _ref3.track;
    return Object.assign({}, state, { downloadAgreementModal: {
            filePath: filePath,
            track: track
        } });
};
var showSignUpFormHandler = function showSignUpFormHandler(state, _ref4) {
    var reason = _ref4.reason;
    return Object.assign({}, state, { signUpForm: {
            visible: true,
            reason: reason
        } });
};
var setHeaderTypeHandler = function setHeaderTypeHandler(state, _ref5) {
    var type = _ref5.type;
    return Object.assign({}, state, { header: Object.assign({}, state.header, { type: type }) });
};
var setHeaderActionsHandler = function setHeaderActionsHandler(state, _ref6) {
    var actions = _ref6.actions;
    return Object.assign({}, state, { header: Object.assign({}, state.header, { actions: actions }) });
};
var clearUIStateHandler = function clearUIStateHandler(state, key) {
    return Object.assign({}, state, _defineProperty({}, key, undefined));
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(action.pageIsScrolling, pageIsScrollingHandler).case(action.showAddTrackToProjectForm, showAddTrackToProjectFormHandler).case(action.toggleLicenseBarVisibility, toggleLicenseBarVisibilityHandler).case(action.setLicenseBarHeight, setLicenseBarHeightHandler).case(action.toggleLogInFormVisibility, toggleLogInFormVisibilityHandler).case(action.toggleHeaderVisibility, toggleHeaderVisibilityHandler).case(action.toggleTrackDetailsVisibility, toggleTrackDetailsVisibilityHandler).case(action.toggleAddToProjectVisibility, toggleAddToProjectVisibilityHandler).case(action.showTrackDetails, showTrackDetailsHandler).case(action.toggleSignUpFormVisibility, toggleSignUpFormVisibilityHandler).case(action.togglePlayerTermListVisibility, togglePlayerTermListVisibilityHandler).case(action.showSignUpForm, showSignUpFormHandler).case(action.setHeaderType, setHeaderTypeHandler).case(action.setHeaderActions, setHeaderActionsHandler).case(action.showDownloadAgreementModal, showDownloadAgreementModalHandler).case(action.clearUIState, clearUIStateHandler);

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * User Redux Reducer
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
var stripeTokenMock_1 = __webpack_require__(1773);
var action = __webpack_require__(50);
var typescript_fsa_reducers_1 = __webpack_require__(84);
var initialState = {
    isLoggedIn: false,
    stripeToken: stripeTokenMock_1.stripeToken
};
var setViewerIdHandler = function setViewerIdHandler(state, _ref) {
    var viewerId = _ref.viewerId;
    return Object.assign({}, state, { viewerId: viewerId });
};
var setUserLoginStatusHandler = function setUserLoginStatusHandler(state, isLoggedIn) {
    return Object.assign({}, state, { isLoggedIn: isLoggedIn });
};
var setUserDetailHandler = function setUserDetailHandler(state, _ref2) {
    var key = _ref2.key,
        value = _ref2.value;
    return Object.assign({}, state, { registrationForm: Object.assign({}, state.registrationForm, _defineProperty({}, key, value)) });
};
var setUserProfileHandler = function setUserProfileHandler(state, _ref3) {
    var profile = _ref3.profile;
    return Object.assign({}, state, { profile: profile });
};
var setCognitoUserHandler = function setCognitoUserHandler(state, cognitoUser) {
    return Object.assign({}, state, { cognitoUser: cognitoUser });
};
var userLogInDoneHandler = function userLogInDoneHandler(state, success) {
    return Object.assign({}, state, { cognitoSession: success.result });
};
var userSignUpDoneHandler = function userSignUpDoneHandler(state, success) {
    return Object.assign({}, state, { cognitoUser: success.result });
};
var setUserStripeTokenHandler = function setUserStripeTokenHandler(state, _ref4) {
    var token = _ref4.token;
    return Object.assign({}, state, { stripeToken: token });
};
exports.default = typescript_fsa_reducers_1.reducerWithInitialState(initialState).case(action.setUserProfile, setUserProfileHandler).case(action.setViewerId, setViewerIdHandler).case(action.setUserLoginStatus, setUserLoginStatusHandler).case(action.setUserDetail, setUserDetailHandler).case(action.setCognitoUser, setCognitoUserHandler).case(action.setUserStripeToken, setUserStripeTokenHandler).case(action.logInUser.done, userLogInDoneHandler).case(action.signUpUser.done, userSignUpDoneHandler);

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.stripeToken = {
    id: 'tok_1BG6E6CChxYzY8x2qwa4ci1B',
    object: 'token',
    card: {
        id: 'card_1BG6E6CChxYzY8x2wXB5WnrC',
        object: 'card',
        address_city: 'Montreal',
        address_country: 'CA',
        address_line1: '4015, rue Drolet',
        address_line1_check: 'unchecked',
        address_state: 'CA-QC',
        address_zip: 'H2W 2L3',
        address_zip_check: 'unchecked',
        brand: 'Visa',
        country: 'CA',
        cvc_check: 'unchecked',
        dynamic_last4: '',
        exp_month: 9,
        exp_year: 2019,
        fingerprint: '',
        funding: 'credit',
        last4: '4033',
        metadata: {},
        name: 'Simon Chevalier',
        tokenization_method: undefined
    },
    client_ip: '66.11.43.114',
    created: 1508766262,
    livemode: false,
    type: 'card',
    used: false
};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

Object.defineProperty(exports, "__esModule", { value: true });
var redux_saga_1 = __webpack_require__(73);
var CartSaga = __webpack_require__(1781);
var CheckoutSaga = __webpack_require__(1790);
var CountriesSaga = __webpack_require__(1792);
var LocalStorageSaga = __webpack_require__(1793);
var PardotSaga = __webpack_require__(1794);
var PlayerSaga = __webpack_require__(1796);
var PostAuthenticationRequests = __webpack_require__(1797);
var PreferencesSaga = __webpack_require__(1809);
var ProjectsSaga = __webpack_require__(1810);
var UserSaga = __webpack_require__(1811);
function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(CartSaga.init), redux_saga_1.effects.call(CheckoutSaga.init), redux_saga_1.effects.call(CountriesSaga.init), redux_saga_1.effects.call(LocalStorageSaga.init), redux_saga_1.effects.call(PostAuthenticationRequests.init), redux_saga_1.effects.call(PreferencesSaga.init), redux_saga_1.effects.call(ProjectsSaga.init), redux_saga_1.effects.call(UserSaga.init), redux_saga_1.effects.call(PardotSaga.init), redux_saga_1.effects.call(PlayerSaga.init)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.default = rootSaga;

/***/ }),
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Cart Saga
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForAddItemToCart),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForRemoveItemFromCart),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchForUpdateCartItemTerms);

Object.defineProperty(exports, "__esModule", { value: true });
var saga_1 = __webpack_require__(314);
var actions = __webpack_require__(196);
var cart_1 = __webpack_require__(1789);
var redux_saga_1 = __webpack_require__(73);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForAddItemToCart), redux_saga_1.effects.call(watchForRemoveItemFromCart), redux_saga_1.effects.call(watchForUpdateCartItemTerms)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function watchForAddItemToCart() {
    var _ref, payload, worker, _ref2, response, errors;

    return regeneratorRuntime.wrap(function watchForAddItemToCart$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 20;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take(actions.requestAddItemToCart);

                case 3:
                    _ref = _context2.sent;
                    payload = _ref.payload;
                    _context2.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.addItemToCart, cart_1.addItemToCart);
                    _context2.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    _ref2 = _context2.sent;
                    response = _ref2.response;
                    errors = _ref2.errors;

                    if (errors) {
                        payload.promise.reject(errors);
                    } else {
                        payload.promise.resolve(response);
                    }
                    _context2.next = 18;
                    break;

                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](5);

                    payload.promise.reject(_context2.t0);

                case 18:
                    _context2.next = 0;
                    break;

                case 20:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[5, 15]]);
}
function watchForRemoveItemFromCart() {
    var _ref3, payload, worker;

    return regeneratorRuntime.wrap(function watchForRemoveItemFromCart$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 17;
                        break;
                    }

                    _context3.next = 3;
                    return redux_saga_1.effects.take(actions.requestRemoveItemFromCart);

                case 3:
                    _ref3 = _context3.sent;
                    payload = _ref3.payload;
                    _context3.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.removeItemFromCart, cart_1.removeItemFromCart);
                    _context3.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    payload.promise.resolve();
                    _context3.next = 15;
                    break;

                case 12:
                    _context3.prev = 12;
                    _context3.t0 = _context3["catch"](5);

                    payload.promise.reject(_context3.t0);

                case 15:
                    _context3.next = 0;
                    break;

                case 17:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[5, 12]]);
}
function watchForUpdateCartItemTerms() {
    var _ref4, payload, worker;

    return regeneratorRuntime.wrap(function watchForUpdateCartItemTerms$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 17;
                        break;
                    }

                    _context4.next = 3;
                    return redux_saga_1.effects.take(actions.requestUpdateCartItemTerms);

                case 3:
                    _ref4 = _context4.sent;
                    payload = _ref4.payload;
                    _context4.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.updateCartItemTerms, cart_1.updateCartItemTerms);
                    _context4.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    payload.promise.resolve();
                    _context4.next = 15;
                    break;

                case 12:
                    _context4.prev = 12;
                    _context4.t0 = _context4["catch"](5);

                    payload.promise.reject(_context4.t0);

                case 15:
                    _context4.next = 0;
                    break;

                case 17:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[5, 12]]);
}

/***/ }),
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Cart Reducer Helper Function
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(93);
var cart_1 = __webpack_require__(422);
var license_1 = __webpack_require__(34);
var react_relay_1 = __webpack_require__(13);
exports.addItemToCart = function (_ref) {
    var lineItem = _ref.lineItem,
        viewerId = _ref.viewerId;

    var input = {
        license_item: {
            track_id: lineItem.track.id,
            usages: license_1.licenseUsagesToSearchParams(lineItem.terms)
        }
    };
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: cart_1.AddItemToCartMutation,
            variables: { input: input },
            updater: function updater(storeProxy) {
                var viewerRecord = storeProxy.get(viewerId);
                var record = storeProxy.getRootField('addItem');
                if (record) {
                    var newCartRecord = record.getLinkedRecord('cart');
                    viewerRecord.setLinkedRecord(newCartRecord, 'cart');
                }
            },
            onCompleted: function onCompleted(response, errors) {
                return resolve({ response: response, errors: errors });
            },
            onError: reject
        });
    });
};
exports.updateCartItemTerms = function (_ref2) {
    var lineItemId = _ref2.lineItemId,
        terms = _ref2.terms;

    var input = {
        license_item: {
            id: lineItemId,
            usages: license_1.licenseUsagesToSearchParams(terms)
        }
    };
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: cart_1.UpdateCartItemTermsMutation,
            variables: { input: input },
            onCompleted: function onCompleted(response, errors) {
                return resolve({ response: response, errors: errors });
            },
            onError: reject
        });
    });
};
exports.removeItemFromCart = function (_ref3) {
    var lineItem = _ref3.lineItem;

    var input = {
        id: lineItem.id
    };
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: cart_1.DeleteItemFromCartMutation,
            variables: { input: input },
            onCompleted: function onCompleted(response, errors) {
                return resolve({ response: response, errors: errors });
            },
            onError: reject
        });
    });
};

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Checkout Saga
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(retrieveCheckoutFromLocalStorage),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForSaveStepToLocalStorage),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchForAddPromoCode),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchForDeletePromoCode),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(prepareOrderData),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchForPlaceOrder);

Object.defineProperty(exports, "__esModule", { value: true });
var saga_1 = __webpack_require__(314);
var actions = __webpack_require__(92);
var localStorage_1 = __webpack_require__(316);
var selectors_1 = __webpack_require__(223);
var checkout_1 = __webpack_require__(635);
var localStorage_2 = __webpack_require__(238);
var user_1 = __webpack_require__(317);
var lodash_1 = __webpack_require__(6);
var redux_saga_1 = __webpack_require__(73);
var config_1 = __webpack_require__(80);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(retrieveCheckoutFromLocalStorage), redux_saga_1.effects.call(watchForSaveStepToLocalStorage), redux_saga_1.effects.call(watchForAddPromoCode), redux_saga_1.effects.call(watchForDeletePromoCode), redux_saga_1.effects.call(watchForPlaceOrder)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function retrieveCheckoutFromLocalStorage() {
    var res;
    return regeneratorRuntime.wrap(function retrieveCheckoutFromLocalStorage$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 14;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take(actions.requestSetCheckoutFromLocalStorage);

                case 3:
                    _context2.next = 5;
                    return redux_saga_1.effects.put(actions.setCheckoutFromLocalStorage.started);

                case 5:
                    _context2.next = 7;
                    return redux_saga_1.effects.put(localStorage_1.getItemFromLocalStorage.started({ key: localStorage_2.localStorageSuffixCheckout }));

                case 7:
                    _context2.next = 9;
                    return redux_saga_1.effects.take(localStorage_1.getItemFromLocalStorage.done);

                case 9:
                    res = _context2.sent;
                    _context2.next = 12;
                    return redux_saga_1.effects.put(actions.setCheckoutFromLocalStorage.done({
                        params: undefined,
                        result: res.payload.result.data
                    }));

                case 12:
                    _context2.next = 0;
                    break;

                case 14:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
function watchForSaveStepToLocalStorage() {
    var _ref, payload;

    return regeneratorRuntime.wrap(function watchForSaveStepToLocalStorage$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 3;
                    return redux_saga_1.effects.take(actions.saveCheckoutStepToLocalStorage);

                case 3:
                    _ref = _context3.sent;
                    payload = _ref.payload;
                    _context3.next = 7;
                    return redux_saga_1.effects.put(localStorage_1.saveToLocalStorage({ key: localStorage_2.localStorageSuffixCheckout, value: payload.stepForm, merge: true }));

                case 7:
                    _context3.next = 0;
                    break;

                case 9:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
function watchForAddPromoCode() {
    var _ref2, payload, worker, err;

    return regeneratorRuntime.wrap(function watchForAddPromoCode$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 18;
                        break;
                    }

                    _context4.next = 3;
                    return redux_saga_1.effects.take(actions.requestAddPromoCode);

                case 3:
                    _ref2 = _context4.sent;
                    payload = _ref2.payload;
                    _context4.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.addPromoCode, checkout_1.addPromoCode);
                    _context4.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    err = _context4.sent;

                    if (err) {
                        payload.promise.reject();
                    } else {
                        payload.promise.resolve();
                    }
                    _context4.next = 16;
                    break;

                case 13:
                    _context4.prev = 13;
                    _context4.t0 = _context4["catch"](5);

                    payload.promise.reject();

                case 16:
                    _context4.next = 0;
                    break;

                case 18:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[5, 13]]);
}
function watchForDeletePromoCode() {
    var _ref3, payload, worker;

    return regeneratorRuntime.wrap(function watchForDeletePromoCode$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (false) {
                        _context5.next = 10;
                        break;
                    }

                    _context5.next = 3;
                    return redux_saga_1.effects.take(actions.requestDeletePromoCode);

                case 3:
                    _ref3 = _context5.sent;
                    payload = _ref3.payload;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.deletePromoCode, checkout_1.deletePromoCode);
                    _context5.next = 8;
                    return redux_saga_1.effects.call(worker, payload);

                case 8:
                    _context5.next = 0;
                    break;

                case 10:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}
function prepareOrderData() {
    var stripeToken, projectInformation, licenseInformation, billingInformation, orderData;
    return regeneratorRuntime.wrap(function prepareOrderData$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return redux_saga_1.effects.select(user_1.getStripeToken);

                case 2:
                    stripeToken = _context6.sent;
                    _context6.next = 5;
                    return redux_saga_1.effects.select(selectors_1.getForm(config_1.CheckoutStepFormName.project));

                case 5:
                    _context6.t0 = _context6.sent;

                    if (_context6.t0) {
                        _context6.next = 8;
                        break;
                    }

                    _context6.t0 = {};

                case 8:
                    projectInformation = _context6.t0;
                    _context6.next = 11;
                    return redux_saga_1.effects.select(selectors_1.getForm(config_1.CheckoutStepFormName.license));

                case 11:
                    licenseInformation = _context6.sent;
                    _context6.next = 14;
                    return redux_saga_1.effects.select(selectors_1.getForm(config_1.CheckoutStepFormName.billing));

                case 14:
                    billingInformation = _context6.sent;
                    orderData = {
                        payment_method: billingInformation.paymentMethod,
                        readonly_payment_info_json: stripeToken ? JSON.stringify(stripeToken) : '',
                        billing_address_same_as_licensee: !!billingInformation.sameAddressAsLicensee,
                        licensee_address: {
                            name: licenseInformation.representative.name,
                            company: licenseInformation.address.company.name,
                            company_type_id: licenseInformation.address.company.type,
                            line_1: licenseInformation.address.street,
                            line_2: licenseInformation.address.unit,
                            city: licenseInformation.address.city,
                            postal_code: licenseInformation.address.postalCode,
                            subdivision_code: licenseInformation.address.state,
                            country_code: licenseInformation.address.country
                        },
                        billing_address: !!!billingInformation.sameAddressAsLicensee ? {
                            name: billingInformation.nameOnCard || licenseInformation.representative.name || '',
                            company: billingInformation.address.company.name,
                            company_type_id: billingInformation.address.company.type,
                            line_1: billingInformation.address.street,
                            line_2: billingInformation.address.unit,
                            city: billingInformation.address.city,
                            postal_code: billingInformation.address.postalCode,
                            subdivision_code: billingInformation.address.state,
                            country_code: billingInformation.address.country
                        } : null,
                        project_details: {
                            brand: projectInformation.brand,
                            product: projectInformation.product,
                            reference: projectInformation.reference,
                            po_number: projectInformation.poNumber,
                            notes: projectInformation.notes
                        },
                        authorized_representative: {
                            name: licenseInformation.representative.name,
                            email: licenseInformation.representative.email,
                            phone: licenseInformation.representative.phone,
                            role_id: licenseInformation.representative.role
                        },
                        air_dates: lodash_1.map(projectInformation.airDate, function (date, id) {
                            return { usage_id: id, date: date };
                        })
                    };
                    return _context6.abrupt("return", orderData);

                case 17:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}
function watchForPlaceOrder() {
    var _ref4, payload, worker, input, viewerId, response;

    return regeneratorRuntime.wrap(function watchForPlaceOrder$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    if (false) {
                        _context7.next = 26;
                        break;
                    }

                    _context7.next = 3;
                    return redux_saga_1.effects.take(actions.requestPlaceOrder);

                case 3:
                    _ref4 = _context7.sent;
                    payload = _ref4.payload;
                    _context7.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.placeOrder, checkout_1.placeOrder);
                    _context7.next = 9;
                    return redux_saga_1.effects.call(prepareOrderData);

                case 9:
                    input = _context7.sent;
                    _context7.next = 12;
                    return redux_saga_1.effects.select(user_1.getViewerId);

                case 12:
                    viewerId = _context7.sent;
                    _context7.next = 15;
                    return redux_saga_1.effects.call(worker, { input: input, viewerId: viewerId });

                case 15:
                    response = _context7.sent;
                    _context7.next = 18;
                    return redux_saga_1.effects.put(localStorage_1.removeFromLocalStorage({ key: localStorage_2.localStorageSuffixCheckout }));

                case 18:
                    payload.promise.resolve(response);
                    _context7.next = 24;
                    break;

                case 21:
                    _context7.prev = 21;
                    _context7.t0 = _context7["catch"](5);

                    payload.promise.reject();

                case 24:
                    _context7.next = 0;
                    break;

                case 26:
                case "end":
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[5, 21]]);
}

/***/ }),
/* 1791 */,
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Countries and States Saga
 */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForFetchCountries),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForFetchStatesForCountry),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(processFetchStatesForCountry);

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(222);
var notifications_1 = __webpack_require__(53);
var countries_1 = __webpack_require__(128);
var redux_saga_1 = __webpack_require__(73);
var saga_1 = __webpack_require__(314);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForFetchCountries), redux_saga_1.effects.call(watchForFetchStatesForCountry)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function watchForFetchCountries() {
    var _ref, promise, alreadyFetch, worker, result;

    return regeneratorRuntime.wrap(function watchForFetchCountries$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 35;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take(actions.requestFetchCountries);

                case 3:
                    _ref = _context2.sent;
                    promise = _ref.payload.promise;
                    _context2.next = 7;
                    return redux_saga_1.effects.select(countries_1.areCountriesAlreadyFetched());

                case 7:
                    alreadyFetch = _context2.sent;

                    if (alreadyFetch) {
                        _context2.next = 24;
                        break;
                    }

                    _context2.prev = 9;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.fetchCountries, countries_1.fetchCountriesAndPostalCodes);
                    _context2.next = 13;
                    return redux_saga_1.effects.call(worker, {});

                case 13:
                    result = _context2.sent;

                    promise.resolve(result);
                    _context2.next = 22;
                    break;

                case 17:
                    _context2.prev = 17;
                    _context2.t0 = _context2["catch"](9);

                    promise.reject(_context2.t0);
                    _context2.next = 22;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        message: "Error while fetching country list",
                        autoDismiss: false,
                        state: 'error'
                    }));

                case 22:
                    _context2.next = 33;
                    break;

                case 24:
                    _context2.t1 = promise;
                    _context2.next = 27;
                    return redux_saga_1.effects.select(countries_1.getCountryList);

                case 27:
                    _context2.t2 = _context2.sent;
                    _context2.next = 30;
                    return redux_saga_1.effects.select(countries_1.getPostalCodes);

                case 30:
                    _context2.t3 = _context2.sent;
                    _context2.t4 = {
                        countries: _context2.t2,
                        postalCodes: _context2.t3
                    };

                    _context2.t1.resolve.call(_context2.t1, _context2.t4);

                case 33:
                    _context2.next = 0;
                    break;

                case 35:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[9, 17]]);
}
function watchForFetchStatesForCountry() {
    return regeneratorRuntime.wrap(function watchForFetchStatesForCountry$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return redux_saga_1.effects.takeEvery(actions.requestFetchStatesForCountry, processFetchStatesForCountry);

                case 2:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
function processFetchStatesForCountry(_ref2) {
    var _ref2$payload = _ref2.payload,
        country = _ref2$payload.country,
        promise = _ref2$payload.promise;
    var alreadyFetched, worker, result;
    return regeneratorRuntime.wrap(function processFetchStatesForCountry$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return redux_saga_1.effects.select(countries_1.areCountryStatesAlreadyFetched(country.code));

                case 2:
                    alreadyFetched = _context4.sent;

                    if (alreadyFetched) {
                        _context4.next = 19;
                        break;
                    }

                    _context4.prev = 4;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.fetchStatesForCountry, countries_1.fetchStatesForCountry);
                    _context4.next = 8;
                    return redux_saga_1.effects.call(worker, country);

                case 8:
                    result = _context4.sent;

                    promise.resolve(result);
                    _context4.next = 17;
                    break;

                case 12:
                    _context4.prev = 12;
                    _context4.t0 = _context4["catch"](4);

                    promise.reject(_context4.t0);
                    _context4.next = 17;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        message: "Error while fetching states for `" + country.name + "`",
                        autoDismiss: false,
                        state: 'error'
                    }));

                case 17:
                    _context4.next = 26;
                    break;

                case 19:
                    _context4.t1 = promise;
                    _context4.next = 22;
                    return redux_saga_1.effects.select(countries_1.getStateList);

                case 22:
                    _context4.t2 = _context4.sent;
                    _context4.t3 = country.code;
                    _context4.t4 = {
                        states: _context4.t2,
                        countryId: _context4.t3
                    };

                    _context4.t1.resolve.call(_context4.t1, _context4.t4);

                case 26:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[4, 12]]);
}

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Local Storage Saga
 */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(removeFromLocalStorage),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(saveToLocalStorage),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getItemFromLocalStorage),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(clearLocalStorage);

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(316);
var localStorage_1 = __webpack_require__(238);
var redux_saga_1 = __webpack_require__(73);
var url_1 = __webpack_require__(183);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.takeEvery(actions.clearLocalStorage, clearLocalStorage), redux_saga_1.effects.takeEvery(actions.removeFromLocalStorage, removeFromLocalStorage), redux_saga_1.effects.takeEvery(actions.saveToLocalStorage, saveToLocalStorage), redux_saga_1.effects.takeEvery(actions.getItemFromLocalStorage.started, getItemFromLocalStorage)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function removeFromLocalStorage(_ref) {
    var key = _ref.payload.key;
    return regeneratorRuntime.wrap(function removeFromLocalStorage$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    return _context2.abrupt("return", localStorage_1.removeItem(key));

                case 1:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
function saveToLocalStorage(_ref2) {
    var _ref2$payload = _ref2.payload,
        key = _ref2$payload.key,
        merge = _ref2$payload.merge,
        replace = _ref2$payload.replace,
        value = _ref2$payload.value;
    return regeneratorRuntime.wrap(function saveToLocalStorage$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    replace || merge ? localStorage_1.updateStoredItem(key, value, merge) : localStorage_1.createItem(key, value);

                case 1:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
function getItemFromLocalStorage(_ref3) {
    var payload = _ref3.payload;
    var storedItemKey, data, error;
    return regeneratorRuntime.wrap(function getItemFromLocalStorage$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    storedItemKey = localStorage_1.getLocalStorageKeys(payload.key);

                    if (!(storedItemKey.length > 0)) {
                        _context4.next = 7;
                        break;
                    }

                    data = url_1.decodeFromUrl(localStorage.getItem(storedItemKey[0]));
                    _context4.next = 5;
                    return redux_saga_1.effects.put(actions.getItemFromLocalStorage.done({ params: payload, result: data }));

                case 5:
                    _context4.next = 10;
                    break;

                case 7:
                    error = { message: "No local storage item found for suffix " + payload.key };
                    _context4.next = 10;
                    return redux_saga_1.effects.put(actions.getItemFromLocalStorage.failed({ params: payload, error: error }));

                case 10:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}
function clearLocalStorage() {
    return regeneratorRuntime.wrap(function clearLocalStorage$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    localStorage_1.removeAllSessionItems();

                case 1:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchForSendNewUser),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForSendNewsletterSignup),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(init);

Object.defineProperty(exports, "__esModule", { value: true });
var redux_saga_1 = __webpack_require__(73);
var actions_1 = __webpack_require__(418);
var endpoints_1 = __webpack_require__(1795);
function watchForSendNewUser() {
    var _ref, payload, body;

    return regeneratorRuntime.wrap(function watchForSendNewUser$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.take(actions_1.sendNewUser);

                case 2:
                    _ref = _context.sent;
                    payload = _ref.payload;

                    // This is simply a field that needs to be set in Pardot to differentiate leads
                    // that have accounts and those that don't
                    payload.has_account = true;
                    body = formBodyFromObject(payload);

                    createHiddenIFrame(endpoints_1.newUserEndpoint + '?' + body);

                case 7:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
function watchForSendNewsletterSignup() {
    var _ref2, payload, body;

    return regeneratorRuntime.wrap(function watchForSendNewsletterSignup$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return redux_saga_1.effects.take(actions_1.sendNewsletterSignup);

                case 2:
                    _ref2 = _context2.sent;
                    payload = _ref2.payload;
                    body = formBodyFromObject(payload);

                    createHiddenIFrame(endpoints_1.newsletterSignupEndpoint + '?' + body);

                case 6:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
function formBodyFromObject(payload) {
    return Object.keys(payload).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]);
    }).join('&');
}
function createHiddenIFrame(url) {
    // @ts-ignore
    if (!isProduction) {
        console.log('Skipping sending of Pardot event since not in production.');
        return;
    }
    try {
        var iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.width = '1px';
        iframe.height = '1px';
        iframe.style.zIndex = '0';
        iframe.style.position = 'absolute';
        iframe.style.left = '0';
        iframe.style.top = '0';
        document.body.appendChild(iframe);
    } catch (e) {
        console.error(e);
    }
}
function init() {
    return regeneratorRuntime.wrap(function init$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForSendNewUser), redux_saga_1.effects.call(watchForSendNewsletterSignup)]);

                case 2:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
exports.init = init;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.newUserEndpoint = 'https://go.boppermusic.com/l/1042251/2023-10-09/6yjgf2';
exports.newsletterSignupEndpoint = 'https://go.boppermusic.com/l/1042251/2023-10-09/6yjtmv';

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Player Saga
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForPlayTrack),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForChangeTrack);

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var ui_1 = __webpack_require__(29);
var player_1 = __webpack_require__(154);
var redux_saga_1 = __webpack_require__(73);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForPlayTrack), redux_saga_1.effects.call(watchForChangeTrack)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
var getTrackDetailsDrawerUIState = function getTrackDetailsDrawerUIState(_ref) {
    var ui = _ref.ui;
    return ui.trackDetails;
};
function watchForPlayTrack() {
    var _ref2, trackId;

    return regeneratorRuntime.wrap(function watchForPlayTrack$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 11;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take([playerActions.playNext, playerActions.playPrevious, playerActions.playTrackFromQueue]);

                case 3:
                    _context2.next = 5;
                    return redux_saga_1.effects.select(player_1.getPlayerTrack);

                case 5:
                    _ref2 = _context2.sent;
                    trackId = _ref2.trackId;
                    _context2.next = 9;
                    return redux_saga_1.effects.put(playerActions.changeTrack({ trackId: trackId }));

                case 9:
                    _context2.next = 0;
                    break;

                case 11:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
function watchForChangeTrack() {
    var _ref3, trackId, trackDetails, trackInfoSelector, trackInfo;

    return regeneratorRuntime.wrap(function watchForChangeTrack$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 20;
                        break;
                    }

                    _context3.next = 3;
                    return redux_saga_1.effects.take(playerActions.changeTrack);

                case 3:
                    _ref3 = _context3.sent;
                    trackId = _ref3.payload.trackId;
                    _context3.next = 7;
                    return redux_saga_1.effects.select(getTrackDetailsDrawerUIState);

                case 7:
                    trackDetails = _context3.sent;

                    if (!(!!!trackDetails || trackDetails.visible === false)) {
                        _context3.next = 10;
                        break;
                    }

                    return _context3.abrupt("continue", 0);

                case 10:
                    if (!(trackId === trackDetails.trackInfo.id)) {
                        _context3.next = 12;
                        break;
                    }

                    return _context3.abrupt("continue", 0);

                case 12:
                    _context3.next = 14;
                    return redux_saga_1.effects.select(player_1.getTrackInfoFromQueue);

                case 14:
                    trackInfoSelector = _context3.sent;
                    trackInfo = trackInfoSelector(trackId);
                    _context3.next = 18;
                    return redux_saga_1.effects.put(ui_1.showTrackDetails({ trackInfo: trackInfo }));

                case 18:
                    _context3.next = 0;
                    break;

                case 20:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Post Authentication Requests Saga
 */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForConsume),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(onCreateProject),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(redirect),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(onCreateProjectAndAddTrack);

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:space-before-function-paren */
var notifications_1 = __webpack_require__(53);
var postAuthenticationRequests_1 = __webpack_require__(81);
var projectActions = __webpack_require__(130);
var ui_1 = __webpack_require__(29);
var projects_1 = __webpack_require__(723);
var user_1 = __webpack_require__(317);
var farce_1 = __webpack_require__(306);
var lodash_1 = __webpack_require__(6);
var luxon_1 = __webpack_require__(280);
var redux_saga_1 = __webpack_require__(73);
var Registration_1 = __webpack_require__(287);
var Browse_1 = __webpack_require__(61);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForConsume)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
var getPostAuthenticationRequests = function getPostAuthenticationRequests(_ref) {
    var postAuthenticationRequests = _ref.postAuthenticationRequests;
    return postAuthenticationRequests;
};
var getUserProfile = function getUserProfile(state) {
    return state.user.profile;
};
function watchForConsume() {
    var _this = this;

    var _loop;

    return regeneratorRuntime.wrap(function watchForConsume$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                        var dateIsValid, requests, userProfile, validRequests, pageToRedirect, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, currentRequest, payload, page, requestType, filePath, track, projectOpaqueId;

                        return regeneratorRuntime.wrap(function _loop$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        _context2.next = 2;
                                        return redux_saga_1.effects.take(postAuthenticationRequests_1.consumePostAuthenticationRequests);

                                    case 2:
                                        dateIsValid = function dateIsValid(dateString) {
                                            return luxon_1.DateTime.fromISO(dateString).plus({ hours: 1 }) >= luxon_1.DateTime.local();
                                        };

                                        _context2.next = 5;
                                        return redux_saga_1.effects.select(getPostAuthenticationRequests);

                                    case 5:
                                        requests = _context2.sent;
                                        _context2.next = 8;
                                        return redux_saga_1.effects.select(getUserProfile);

                                    case 8:
                                        userProfile = _context2.sent;
                                        validRequests = lodash_1.chain(requests).filter(function (_ref2) {
                                            var requestedAt = _ref2.requestedAt;
                                            return dateIsValid(requestedAt);
                                        }).uniqBy(getUniqueRequestIdentifier).value();
                                        pageToRedirect = Browse_1.BrowsePagePath;

                                        if (!validRequests.length) {
                                            _context2.next = 52;
                                            break;
                                        }

                                        _iteratorNormalCompletion = true;
                                        _didIteratorError = false;
                                        _iteratorError = undefined;
                                        _context2.prev = 15;
                                        _iterator = validRequests[Symbol.iterator]();

                                    case 17:
                                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                            _context2.next = 38;
                                            break;
                                        }

                                        currentRequest = _step.value;
                                        payload = currentRequest.payload, page = currentRequest.page, requestType = currentRequest.requestType;

                                        if (page) {
                                            pageToRedirect = page;
                                        }
                                        _context2.t0 = requestType;
                                        _context2.next = _context2.t0 === 'createProject' ? 24 : _context2.t0 === 'downloadTrack' ? 27 : _context2.t0 === 'joinProject' ? 31 : 35;
                                        break;

                                    case 24:
                                        _context2.next = 26;
                                        return redux_saga_1.effects.call(onCreateProject, payload);

                                    case 26:
                                        return _context2.abrupt("break", 35);

                                    case 27:
                                        filePath = payload.path, track = payload.track;
                                        _context2.next = 30;
                                        return redux_saga_1.effects.put(ui_1.showDownloadAgreementModal({ filePath: filePath, track: track }));

                                    case 30:
                                        return _context2.abrupt("break", 35);

                                    case 31:
                                        projectOpaqueId = payload.projectOpaqueId;
                                        _context2.next = 34;
                                        return redux_saga_1.effects.put(projectActions.requestJoinProject({
                                            input: {
                                                opaque_id: projectOpaqueId
                                            },
                                            promise: {
                                                resolve: function resolve() {
                                                    return null;
                                                },
                                                reject: function reject() {
                                                    return null;
                                                }
                                            }
                                        }));

                                    case 34:
                                        return _context2.abrupt("break", 35);

                                    case 35:
                                        _iteratorNormalCompletion = true;
                                        _context2.next = 17;
                                        break;

                                    case 38:
                                        _context2.next = 44;
                                        break;

                                    case 40:
                                        _context2.prev = 40;
                                        _context2.t1 = _context2["catch"](15);
                                        _didIteratorError = true;
                                        _iteratorError = _context2.t1;

                                    case 44:
                                        _context2.prev = 44;
                                        _context2.prev = 45;

                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }

                                    case 47:
                                        _context2.prev = 47;

                                        if (!_didIteratorError) {
                                            _context2.next = 50;
                                            break;
                                        }

                                        throw _iteratorError;

                                    case 50:
                                        return _context2.finish(47);

                                    case 51:
                                        return _context2.finish(44);

                                    case 52:
                                        _context2.next = 54;
                                        return redux_saga_1.effects.put(postAuthenticationRequests_1.clearPostAuthenticationRequests());

                                    case 54:
                                        _context2.next = 56;
                                        return redux_saga_1.effects.call(redirect, userProfile && userProfile.is_new_user ? {
                                            pathname: Registration_1.RegistrationPagePath,
                                            search: "?goto=" + pageToRedirect
                                        } : pageToRedirect);

                                    case 56:
                                    case "end":
                                        return _context2.stop();
                                }
                            }
                        }, _loop, _this, [[15, 40, 44, 52], [45,, 47, 51]]);
                    });

                case 1:
                    if (false) {
                        _context3.next = 5;
                        break;
                    }

                    return _context3.delegateYield(_loop(), "t0", 3);

                case 3:
                    _context3.next = 1;
                    break;

                case 5:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}
function onCreateProject(payload) {
    return regeneratorRuntime.wrap(function onCreateProject$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return redux_saga_1.effects.call(onCreateProjectAndAddTrack, payload);

                case 2:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked3, this);
}
function redirect(path) {
    return regeneratorRuntime.wrap(function redirect$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return redux_saga_1.effects.put(farce_1.Actions.push(path));

                case 2:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked4, this);
}
function getUniqueRequestIdentifier(_ref3) {
    var payload = _ref3.payload,
        requestType = _ref3.requestType;

    return requestType + ":" + JSON.stringify(payload);
}
function onCreateProjectAndAddTrack(_ref4) {
    var projectName = _ref4.projectName,
        trackId = _ref4.trackId,
        trackVersion = _ref4.trackVersion,
        searchState = _ref4.searchState;

    var input, viewerId, _ref5, response, errors, projectId, licenseParams;

    return regeneratorRuntime.wrap(function onCreateProjectAndAddTrack$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    input = { name: projectName };
                    _context6.next = 3;
                    return redux_saga_1.effects.select(user_1.getViewerId);

                case 3:
                    viewerId = _context6.sent;
                    _context6.prev = 4;
                    _context6.next = 7;
                    return redux_saga_1.effects.call(projects_1.createProject, { input: input }, viewerId);

                case 7:
                    _ref5 = _context6.sent;
                    response = _ref5.response;
                    errors = _ref5.errors;

                    if (!errors) {
                        _context6.next = 15;
                        break;
                    }

                    _context6.next = 13;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        autoDismiss: false,
                        message: 'An error occurred while creating playlist. Please try again.',
                        state: 'error'
                    }));

                case 13:
                    _context6.next = 28;
                    break;

                case 15:
                    projectId = response.createProject.new_project_edge.node.id;
                    _context6.prev = 16;
                    licenseParams = searchState.license_params;
                    _context6.next = 20;
                    return redux_saga_1.effects.call(projects_1.addTrackToProject, { licenseParams: licenseParams, projectId: projectId, trackId: trackId, trackVersion: trackVersion });

                case 20:
                    _context6.next = 22;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        message: 'A track was saved to playlist successfully!',
                        state: 'success'
                    }));

                case 22:
                    _context6.next = 28;
                    break;

                case 24:
                    _context6.prev = 24;
                    _context6.t0 = _context6["catch"](16);
                    _context6.next = 28;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        autoDismiss: false,
                        message: 'An error occurred while saving this track to a new playlist. Please try again.',
                        state: 'error'
                    }));

                case 28:
                    _context6.next = 34;
                    break;

                case 30:
                    _context6.prev = 30;
                    _context6.t1 = _context6["catch"](4);
                    _context6.next = 34;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        autoDismiss: false,
                        message: 'An error occurred while creating playlist. Please try again.',
                        state: 'error'
                    }));

                case 34:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked5, this, [[4, 30], [16, 24]]);
}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 931e3d721737ed7d1b755593529171ef
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type project_viewer$ref = any;
export type project_QueryVariables = {|
  id: string,
  isDefaultRoute: boolean,
|};
export type project_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: project_viewer$ref,
  |},
|};
*/

/*
query project_Query(
  $id: ID!
  $isDefaultRoute: Boolean!
) {
  viewer {
    ...project_viewer
    id
  }
}

fragment project_viewer on Viewer {
  latest_project {
    id
    is_public
    name
    notes
    opaque_id
    tracks(first: 100) {
      edges {
        id
        version
        node {
          id
          internal_id
          price
          base_price
          title
          added_to_cart
          slug
          duration
          score
          boosted_score
          stems_available
          customizable
          matched_exclusions
          tempos {
            id
            name
            value
          }
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            bio
            bandcamp
            facebook
            instagram
            itunes
            soundcloud
            spotify
            twitter
            wiki
            youtube
            homebase
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms(first: 100) {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
          collections {
            edges {
              node {
                id
                description
                name
                slug
                category {
                  id
                  name
                }
                assets {
                  id
                  version
                  type
                  file_format
                  path
                  metadata
                }
              }
              id
            }
          }
          association_id
          selected_version
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    owner {
      id
      first_name
      last_name
      user_id
    }
    users {
      id
      first_name
      last_name
      user_id
      role
    }
    license_params {
      spot_count
      term
      medium
      contextual_param
      contextual_param_type
    }
  }
  projects(first: 100, scope: CurrentUser) {
    edges {
      node {
        id
        is_public
        name
        notes
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        owner {
          id
          first_name
          last_name
          user_id
        }
        users {
          id
          first_name
          last_name
          user_id
          role
        }
        license_params {
          spot_count
          term
          medium
          contextual_param
          contextual_param_type
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  node(id: $id) @skip(if: $isDefaultRoute) {
    __typename
    ... on Project {
      id
      is_public
      name
      notes
      opaque_id
      tracks(first: 100) {
        edges {
          id
          version
          node {
            id
            internal_id
            price
            base_price
            title
            added_to_cart
            slug
            duration
            score
            boosted_score
            stems_available
            customizable
            matched_exclusions
            tempos {
              id
              name
              value
            }
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
            artist {
              id
              name
              slug
              bio
              bandcamp
              facebook
              instagram
              itunes
              soundcloud
              spotify
              twitter
              wiki
              youtube
              homebase
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            terms(first: 100) {
              edges {
                node {
                  id
                  is_highlighted
                  name
                  parent_id
                  taxonomy {
                    id
                    internal_id
                    name
                  }
                }
              }
            }
            collections {
              edges {
                node {
                  id
                  description
                  name
                  slug
                  category {
                    id
                    name
                  }
                  assets {
                    id
                    version
                    type
                    file_format
                    path
                    metadata
                  }
                }
                id
              }
            }
            association_id
            selected_version
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      owner {
        id
        first_name
        last_name
        user_id
      }
      users {
        id
        first_name
        last_name
        user_id
        role
      }
      license_params {
        spot_count
        term
        medium
        contextual_param
        contextual_param_type
      }
    }
    id
  }
  selected_currency
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "isDefaultRoute",
    "type": "Boolean!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_public",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "opaque_id",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  },
      v7 = [v6],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, v8, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "tracks",
    "storageKey": "tracks(first:100)",
    "args": v7,
    "concreteType": "ProjectTrackConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectTrackEdge",
      "plural": true,
      "selections": [v1, v8, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "stems_available",
          "args": null,
          "storageKey": null
        }, v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "base_price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v9, {
          "kind": "ScalarField",
          "alias": null,
          "name": "duration",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "score",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "boosted_score",
          "args": null,
          "storageKey": null
        }, v10, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customizable",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "matched_exclusions",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tempos",
          "storageKey": null,
          "args": null,
          "concreteType": "Tempo",
          "plural": true,
          "selections": [v1, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          }]
        }, v11, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "itunes",
            "args": null,
            "storageKey": null
          }, v1, v9, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bio",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bandcamp",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "soundcloud",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "spotify",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "wiki",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtube",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "homebase",
            "args": null,
            "storageKey": null
          }, v11]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": "terms(first:100)",
          "args": v7,
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v1, v10, v3]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collections",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionTrackConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v3, v9, {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategory",
                "plural": false,
                "selections": [v1, v3]
              }, v11]
            }, v1]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "association_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_version",
          "args": null,
          "storageKey": null
        }, v12]
      }, v13]
    }, v14]
  },
      v16 = {
    "kind": "LinkedHandle",
    "alias": null,
    "name": "tracks",
    "args": v7,
    "handle": "connection",
    "key": "project_tracks",
    "filters": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "owner",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectUser",
    "plural": false,
    "selections": [v1, v17, v18, v19]
  },
      v21 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "users",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectUser",
    "plural": true,
    "selections": [v1, v17, v18, v19, {
      "kind": "ScalarField",
      "alias": null,
      "name": "role",
      "args": null,
      "storageKey": null
    }]
  },
      v22 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "license_params",
    "storageKey": null,
    "args": null,
    "concreteType": "LicenseUsageParams",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "project_Query",
    "id": null,
    "text": "query project_Query(\n  $id: ID!\n  $isDefaultRoute: Boolean!\n) {\n  viewer {\n    ...project_viewer\n    id\n  }\n}\n\nfragment project_viewer on Viewer {\n  latest_project {\n    id\n    is_public\n    name\n    notes\n    opaque_id\n    tracks(first: 100) {\n      edges {\n        id\n        version\n        node {\n          id\n          internal_id\n          price\n          base_price\n          title\n          added_to_cart\n          slug\n          duration\n          score\n          boosted_score\n          stems_available\n          customizable\n          matched_exclusions\n          tempos {\n            id\n            name\n            value\n          }\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            bio\n            bandcamp\n            facebook\n            instagram\n            itunes\n            soundcloud\n            spotify\n            twitter\n            wiki\n            youtube\n            homebase\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms(first: 100) {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n          collections {\n            edges {\n              node {\n                id\n                description\n                name\n                slug\n                category {\n                  id\n                  name\n                }\n                assets {\n                  id\n                  version\n                  type\n                  file_format\n                  path\n                  metadata\n                }\n              }\n              id\n            }\n          }\n          association_id\n          selected_version\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    owner {\n      id\n      first_name\n      last_name\n      user_id\n    }\n    users {\n      id\n      first_name\n      last_name\n      user_id\n      role\n    }\n    license_params {\n      spot_count\n      term\n      medium\n      contextual_param\n      contextual_param_type\n    }\n  }\n  projects(first: 100, scope: CurrentUser) {\n    edges {\n      node {\n        id\n        is_public\n        name\n        notes\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        owner {\n          id\n          first_name\n          last_name\n          user_id\n        }\n        users {\n          id\n          first_name\n          last_name\n          user_id\n          role\n        }\n        license_params {\n          spot_count\n          term\n          medium\n          contextual_param\n          contextual_param_type\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  node(id: $id) @skip(if: $isDefaultRoute) {\n    __typename\n    ... on Project {\n      id\n      is_public\n      name\n      notes\n      opaque_id\n      tracks(first: 100) {\n        edges {\n          id\n          version\n          node {\n            id\n            internal_id\n            price\n            base_price\n            title\n            added_to_cart\n            slug\n            duration\n            score\n            boosted_score\n            stems_available\n            customizable\n            matched_exclusions\n            tempos {\n              id\n              name\n              value\n            }\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n            artist {\n              id\n              name\n              slug\n              bio\n              bandcamp\n              facebook\n              instagram\n              itunes\n              soundcloud\n              spotify\n              twitter\n              wiki\n              youtube\n              homebase\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            terms(first: 100) {\n              edges {\n                node {\n                  id\n                  is_highlighted\n                  name\n                  parent_id\n                  taxonomy {\n                    id\n                    internal_id\n                    name\n                  }\n                }\n              }\n            }\n            collections {\n              edges {\n                node {\n                  id\n                  description\n                  name\n                  slug\n                  category {\n                    id\n                    name\n                  }\n                  assets {\n                    id\n                    version\n                    type\n                    file_format\n                    path\n                    metadata\n                  }\n                }\n                id\n              }\n            }\n            association_id\n            selected_version\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      owner {\n        id\n        first_name\n        last_name\n        user_id\n      }\n      users {\n        id\n        first_name\n        last_name\n        user_id\n        role\n      }\n      license_params {\n        spot_count\n        term\n        medium\n        contextual_param\n        contextual_param_type\n      }\n    }\n    id\n  }\n  selected_currency\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "project_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "project_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "project_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "latest_project",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v1, v2, v3, v4, v5, v15, v16, v20, v21, v22]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "projects",
          "storageKey": "projects(first:100,scope:\"CurrentUser\")",
          "args": [v6, {
            "kind": "Literal",
            "name": "scope",
            "value": "CurrentUser",
            "type": "QueryScopeEnumType!"
          }],
          "concreteType": "ProjectConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [v1, v2, v3, v4, {
                "kind": "LinkedField",
                "alias": null,
                "name": "tracks",
                "storageKey": "tracks(first:100)",
                "args": v7,
                "concreteType": "ProjectTrackConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectTrackEdge",
                  "plural": true,
                  "selections": [v1, v13, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TrackSearchResult",
                    "plural": false,
                    "selections": [v12, v1]
                  }]
                }, v14]
              }, v16, v20, v21, v22, v12]
            }, v13]
          }, v14]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "projects",
          "args": [v6, {
            "kind": "Literal",
            "name": "scope",
            "value": "CurrentUser",
            "type": "QueryScopeEnumType!"
          }],
          "handle": "connection",
          "key": "list_projects",
          "filters": []
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency",
          "args": null,
          "storageKey": null
        }, v1, {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isDefaultRoute",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": [{
              "kind": "Variable",
              "name": "id",
              "variableName": "id",
              "type": "ID!"
            }],
            "concreteType": null,
            "plural": false,
            "selections": [v12, v1, {
              "kind": "InlineFragment",
              "type": "Project",
              "selections": [v2, v3, v4, v5, v15, v16, v20, v21, v22]
            }]
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '5e6fe59ea62415891e084c8a07585553';
module.exports = node;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 2255e82de5412bb1287cdb83f30945c4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type projectShared_viewer$ref = any;
export type project_sharedProject_QueryVariables = {|
  opaque_id: string,
|};
export type project_sharedProject_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: projectShared_viewer$ref,
  |},
|};
*/

/*
query project_sharedProject_Query(
  $opaque_id: String!
) {
  viewer {
    ...projectShared_viewer
    id
  }
}

fragment projectShared_viewer on Viewer {
  profile {
    user_id
    id
  }
  shared_project(opaque_id: $opaque_id) {
    id
    is_public
    name
    notes
    opaque_id
    tracks(first: 100) {
      edges {
        id
        version
        node {
          id
          internal_id
          price
          base_price
          title
          added_to_cart
          slug
          duration
          score
          boosted_score
          stems_available
          customizable
          matched_exclusions
          tempos {
            id
            name
            value
          }
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            bio
            bandcamp
            facebook
            instagram
            itunes
            soundcloud
            spotify
            twitter
            wiki
            youtube
            homebase
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms(first: 100) {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
          collections {
            edges {
              node {
                id
                description
                name
                slug
                category {
                  id
                  name
                }
                assets {
                  id
                  version
                  type
                  file_format
                  path
                  metadata
                }
              }
              id
            }
          }
          association_id
          selected_version
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    owner {
      id
      first_name
      last_name
      user_id
    }
    users {
      id
      first_name
      last_name
      user_id
      role
    }
    license_params {
      spot_count
      term
      medium
      contextual_param
      contextual_param_type
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "opaque_id",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = [{
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  }],
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "project_sharedProject_Query",
    "id": null,
    "text": "query project_sharedProject_Query(\n  $opaque_id: String!\n) {\n  viewer {\n    ...projectShared_viewer\n    id\n  }\n}\n\nfragment projectShared_viewer on Viewer {\n  profile {\n    user_id\n    id\n  }\n  shared_project(opaque_id: $opaque_id) {\n    id\n    is_public\n    name\n    notes\n    opaque_id\n    tracks(first: 100) {\n      edges {\n        id\n        version\n        node {\n          id\n          internal_id\n          price\n          base_price\n          title\n          added_to_cart\n          slug\n          duration\n          score\n          boosted_score\n          stems_available\n          customizable\n          matched_exclusions\n          tempos {\n            id\n            name\n            value\n          }\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            bio\n            bandcamp\n            facebook\n            instagram\n            itunes\n            soundcloud\n            spotify\n            twitter\n            wiki\n            youtube\n            homebase\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms(first: 100) {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n          collections {\n            edges {\n              node {\n                id\n                description\n                name\n                slug\n                category {\n                  id\n                  name\n                }\n                assets {\n                  id\n                  version\n                  type\n                  file_format\n                  path\n                  metadata\n                }\n              }\n              id\n            }\n          }\n          association_id\n          selected_version\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    owner {\n      id\n      first_name\n      last_name\n      user_id\n    }\n    users {\n      id\n      first_name\n      last_name\n      user_id\n      role\n    }\n    license_params {\n      spot_count\n      term\n      medium\n      contextual_param\n      contextual_param_type\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "project_sharedProject_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "projectShared_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "project_sharedProject_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [v1, v2]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "shared_project",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "opaque_id",
            "variableName": "opaque_id",
            "type": "String!"
          }],
          "concreteType": "Project",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_public",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "opaque_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tracks",
            "storageKey": "tracks(first:100)",
            "args": v4,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v2, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "stems_available",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "base_price",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "added_to_cart",
                  "args": null,
                  "storageKey": null
                }, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "score",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "boosted_score",
                  "args": null,
                  "storageKey": null
                }, v7, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "customizable",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "matched_exclusions",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "tempos",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Tempo",
                  "plural": true,
                  "selections": [v2, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "value",
                    "args": null,
                    "storageKey": null
                  }]
                }, v8, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artist",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Artist",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itunes",
                    "args": null,
                    "storageKey": null
                  }, v2, v6, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bio",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bandcamp",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "facebook",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "instagram",
                    "args": null,
                    "storageKey": null
                  }, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "soundcloud",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "spotify",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "twitter",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "wiki",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "youtube",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "homebase",
                    "args": null,
                    "storageKey": null
                  }, v8]
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": "terms(first:100)",
                  "args": v4,
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTerm",
                      "plural": false,
                      "selections": [v2, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_highlighted",
                        "args": null,
                        "storageKey": null
                      }, v3, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "parent_id",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "taxonomy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Taxonomy",
                        "plural": false,
                        "selections": [v2, v7, v3]
                      }]
                    }]
                  }]
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "collections",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionTrackEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Collection",
                      "plural": false,
                      "selections": [v2, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      }, v3, v6, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CollectionCategory",
                        "plural": false,
                        "selections": [v2, v3]
                      }, v8]
                    }, v2]
                  }]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "association_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "selected_version",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "tracks",
            "args": v4,
            "handle": "connection",
            "key": "project_tracks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "owner",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": false,
            "selections": [v2, v9, v10, v1]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "users",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": true,
            "selections": [v2, v9, v10, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "role",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_params",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseUsageParams",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "spot_count",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "term",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "medium",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param_type",
              "args": null,
              "storageKey": null
            }]
          }]
        }, v2]
      }]
    }
  };
}();
node /*: any*/.hash = '9515f3e1725185e464e8284224e10f34';
module.exports = node;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type projectList_viewer$ref: FragmentReference;
export type projectList_viewer = {|
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +$refType: projectList_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "projectList_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "projects",
      "storageKey": "projects(first:100,scope:\"CurrentUser\")",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 100,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "scope",
        "value": "CurrentUser",
        "type": "QueryScopeEnumType!"
      }],
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_public",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "tracks",
            "name": "__project_tracks_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "owner",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": false,
            "selections": [v0, v1, v2, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "users",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": true,
            "selections": [v0, v1, v2, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "role",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_params",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseUsageParams",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "spot_count",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "term",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "medium",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param_type",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = '9d73deb81e95b0ab23f969d1dd14042f';
module.exports = node;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type projectShared_viewer$ref: FragmentReference;
export type projectShared_viewer = {|
  +profile: ?{|
    +user_id: string,
  |},
  +shared_project: ?{|
    +id: string,
    +is_public: ?boolean,
    +name: string,
    +notes: ?string,
    +opaque_id: ?string,
    +tracks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +id: string,
        +version: string,
        +node: ?{|
          +id: string,
          +internal_id: ?number,
          +price: ?number,
          +base_price: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +duration: ?number,
          +score: ?number,
          +boosted_score: ?number,
          +stems_available: ?boolean,
          +customizable: ?boolean,
          +matched_exclusions: ?$ReadOnlyArray<?number>,
          +tempos: ?$ReadOnlyArray<?{|
            +id: string,
            +name: ?string,
            +value: ?number,
          |}>,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +bio: ?string,
            +bandcamp: ?string,
            +facebook: ?string,
            +instagram: ?string,
            +itunes: ?string,
            +soundcloud: ?string,
            +spotify: ?string,
            +twitter: ?string,
            +wiki: ?string,
            +youtube: ?string,
            +homebase: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
          +collections: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +description: ?string,
                +name: string,
                +slug: ?string,
                +category: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +assets: ?$ReadOnlyArray<?{|
                  +id: string,
                  +version: ?string,
                  +type: ?string,
                  +file_format: ?string,
                  +path: ?string,
                  +metadata: ?any,
                |}>,
              |},
            |}>,
          |},
          +association_id: ?string,
          +selected_version: ?string,
        |},
      |}>,
    |},
    +owner: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
    |},
    +users: ?$ReadOnlyArray<?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
      +role: UserProjectRoleEnumType,
    |}>,
    +license_params: ?$ReadOnlyArray<?{|
      +spot_count: ?number,
      +term: ?number,
      +medium: number,
      +contextual_param: ?$ReadOnlyArray<?number>,
      +contextual_param_type: string,
    |}>,
  |},
  +$refType: projectShared_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v1, v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "projectShared_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "opaque_id",
      "type": "String!"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "shared_project",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "opaque_id",
        "variableName": "opaque_id",
        "type": "String!"
      }],
      "concreteType": "Project",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_public",
        "args": null,
        "storageKey": null
      }, v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "opaque_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": "tracks",
        "name": "__project_tracks_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectTrackConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectTrackEdge",
          "plural": true,
          "selections": [v1, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResult",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "stems_available",
              "args": null,
              "storageKey": null
            }, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "price",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "base_price",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "added_to_cart",
              "args": null,
              "storageKey": null
            }, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "duration",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "score",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "boosted_score",
              "args": null,
              "storageKey": null
            }, v5, {
              "kind": "ScalarField",
              "alias": null,
              "name": "customizable",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "matched_exclusions",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "tempos",
              "storageKey": null,
              "args": null,
              "concreteType": "Tempo",
              "plural": true,
              "selections": [v1, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "value",
                "args": null,
                "storageKey": null
              }]
            }, v6, {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "itunes",
                "args": null,
                "storageKey": null
              }, v1, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "bio",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "bandcamp",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "facebook",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "instagram",
                "args": null,
                "storageKey": null
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "soundcloud",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "spotify",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "twitter",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "wiki",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "youtube",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "homebase",
                "args": null,
                "storageKey": null
              }, v6]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": "terms(first:100)",
              "args": [{
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }],
              "concreteType": "TaxonomyTermConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTerm",
                  "plural": false,
                  "selections": [v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_highlighted",
                    "args": null,
                    "storageKey": null
                  }, v2, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "parent_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "taxonomy",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Taxonomy",
                    "plural": false,
                    "selections": [v1, v5, v2]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "collections",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionTrackConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionTrackEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Collection",
                  "plural": false,
                  "selections": [v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  }, v2, v4, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionCategory",
                    "plural": false,
                    "selections": [v1, v2]
                  }, v6]
                }]
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "association_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "selected_version",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "__typename",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "endCursor",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasNextPage",
            "args": null,
            "storageKey": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "owner",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectUser",
        "plural": false,
        "selections": [v1, v7, v8, v0]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "users",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectUser",
        "plural": true,
        "selections": [v1, v7, v8, v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_params",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseUsageParams",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "spot_count",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "term",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "medium",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "contextual_param",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "contextual_param_type",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = 'e53c137d7109858cd18b42e1c7c12989';
module.exports = node;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type project_viewer$ref: FragmentReference;
export type project_viewer = {|
  +latest_project: ?{|
    +id: string,
    +is_public: ?boolean,
    +name: string,
    +notes: ?string,
    +opaque_id: ?string,
    +tracks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +id: string,
        +version: string,
        +node: ?{|
          +id: string,
          +internal_id: ?number,
          +price: ?number,
          +base_price: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +duration: ?number,
          +score: ?number,
          +boosted_score: ?number,
          +stems_available: ?boolean,
          +customizable: ?boolean,
          +matched_exclusions: ?$ReadOnlyArray<?number>,
          +tempos: ?$ReadOnlyArray<?{|
            +id: string,
            +name: ?string,
            +value: ?number,
          |}>,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +bio: ?string,
            +bandcamp: ?string,
            +facebook: ?string,
            +instagram: ?string,
            +itunes: ?string,
            +soundcloud: ?string,
            +spotify: ?string,
            +twitter: ?string,
            +wiki: ?string,
            +youtube: ?string,
            +homebase: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
          +collections: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +description: ?string,
                +name: string,
                +slug: ?string,
                +category: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +assets: ?$ReadOnlyArray<?{|
                  +id: string,
                  +version: ?string,
                  +type: ?string,
                  +file_format: ?string,
                  +path: ?string,
                  +metadata: ?any,
                |}>,
              |},
            |}>,
          |},
          +association_id: ?string,
          +selected_version: ?string,
        |},
      |}>,
    |},
    +owner: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
    |},
    +users: ?$ReadOnlyArray<?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
      +role: UserProjectRoleEnumType,
    |}>,
    +license_params: ?$ReadOnlyArray<?{|
      +spot_count: ?number,
      +term: ?number,
      +medium: number,
      +contextual_param: ?$ReadOnlyArray<?number>,
      +contextual_param_type: string,
    |}>,
  |},
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +node?: ?{|
    +id?: string,
    +is_public?: ?boolean,
    +name?: string,
    +notes?: ?string,
    +opaque_id?: ?string,
    +tracks?: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +id: string,
        +version: string,
        +node: ?{|
          +id: string,
          +internal_id: ?number,
          +price: ?number,
          +base_price: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +duration: ?number,
          +score: ?number,
          +boosted_score: ?number,
          +stems_available: ?boolean,
          +customizable: ?boolean,
          +matched_exclusions: ?$ReadOnlyArray<?number>,
          +tempos: ?$ReadOnlyArray<?{|
            +id: string,
            +name: ?string,
            +value: ?number,
          |}>,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +bio: ?string,
            +bandcamp: ?string,
            +facebook: ?string,
            +instagram: ?string,
            +itunes: ?string,
            +soundcloud: ?string,
            +spotify: ?string,
            +twitter: ?string,
            +wiki: ?string,
            +youtube: ?string,
            +homebase: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
          +collections: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +description: ?string,
                +name: string,
                +slug: ?string,
                +category: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +assets: ?$ReadOnlyArray<?{|
                  +id: string,
                  +version: ?string,
                  +type: ?string,
                  +file_format: ?string,
                  +path: ?string,
                  +metadata: ?any,
                |}>,
              |},
            |}>,
          |},
          +association_id: ?string,
          +selected_version: ?string,
        |},
      |}>,
    |},
    +owner?: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
    |},
    +users?: ?$ReadOnlyArray<?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
      +role: UserProjectRoleEnumType,
    |}>,
    +license_params?: ?$ReadOnlyArray<?{|
      +spot_count: ?number,
      +term: ?number,
      +medium: number,
      +contextual_param: ?$ReadOnlyArray<?number>,
      +contextual_param_type: string,
    |}>,
  |},
  +selected_currency: ?Currency,
  +$refType: project_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_public",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "owner",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectUser",
    "plural": false,
    "selections": [v0, v11, v12, v13]
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "users",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectUser",
    "plural": true,
    "selections": [v0, v11, v12, v13, {
      "kind": "ScalarField",
      "alias": null,
      "name": "role",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "license_params",
    "storageKey": null,
    "args": null,
    "concreteType": "LicenseUsageParams",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = [v0, v1, v2, v3, {
    "kind": "ScalarField",
    "alias": null,
    "name": "opaque_id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "tracks",
    "name": "__project_tracks_connection",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectTrackConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectTrackEdge",
      "plural": true,
      "selections": [v0, v4, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "stems_available",
          "args": null,
          "storageKey": null
        }, v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "base_price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v5, {
          "kind": "ScalarField",
          "alias": null,
          "name": "duration",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "score",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "boosted_score",
          "args": null,
          "storageKey": null
        }, v6, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customizable",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "matched_exclusions",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tempos",
          "storageKey": null,
          "args": null,
          "concreteType": "Tempo",
          "plural": true,
          "selections": [v0, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          }]
        }, v7, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "itunes",
            "args": null,
            "storageKey": null
          }, v0, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bio",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bandcamp",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "soundcloud",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "spotify",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "wiki",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtube",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "homebase",
            "args": null,
            "storageKey": null
          }, v7]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": "terms(first:100)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
          }],
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v0, v6, v2]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collections",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionTrackConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v2, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategory",
                "plural": false,
                "selections": [v0, v2]
              }, v7]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "association_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_version",
          "args": null,
          "storageKey": null
        }, v8]
      }, v9]
    }, v10]
  }, v14, v15, v16];
  return {
    "kind": "Fragment",
    "name": "project_viewer",
    "type": "Viewer",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["projects"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "id",
      "type": "ID!"
    }, {
      "kind": "RootArgument",
      "name": "isDefaultRoute",
      "type": "Boolean"
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "latest_project",
      "storageKey": null,
      "args": null,
      "concreteType": "Project",
      "plural": false,
      "selections": v17
    }, {
      "kind": "LinkedField",
      "alias": "projects",
      "name": "__list_projects_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v0, v1, v2, v3, {
            "kind": "LinkedField",
            "alias": "tracks",
            "name": "__project_tracks_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v0, v9, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [v8]
              }]
            }, v10]
          }, v14, v15, v16, v8]
        }, v9]
      }, v10]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    }, {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isDefaultRoute",
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": [{
          "kind": "Variable",
          "name": "id",
          "variableName": "id",
          "type": "ID!"
        }],
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "type": "Project",
          "selections": v17
        }]
      }]
    }]
  };
}();
node /*: any*/.hash = 'b9664a1a6532247f0b8b56db1d25f777';
module.exports = node;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type projectNode$ref: FragmentReference;
export type projectNode = {|
  +id: string,
  +is_public: ?boolean,
  +name: string,
  +notes: ?string,
  +tracks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +id: string,
    |}>,
  |},
  +owner: ?{|
    +id: string,
    +first_name: ?string,
    +last_name: ?string,
    +user_id: string,
  |},
  +users: ?$ReadOnlyArray<?{|
    +id: string,
    +first_name: ?string,
    +last_name: ?string,
    +user_id: string,
    +role: UserProjectRoleEnumType,
  |}>,
  +license_params: ?$ReadOnlyArray<?{|
    +spot_count: ?number,
    +term: ?number,
    +medium: number,
    +contextual_param: ?$ReadOnlyArray<?number>,
    +contextual_param_type: string,
  |}>,
  +$refType: projectNode$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "projectNode",
    "type": "Project",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["tracks"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "is_public",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "tracks",
      "name": "__project_tracks_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectTrackConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectTrackEdge",
        "plural": true,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "owner",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectUser",
      "plural": false,
      "selections": [v0, v1, v2, v3]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "users",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectUser",
      "plural": true,
      "selections": [v0, v1, v2, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_params",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseUsageParams",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "spot_count",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "term",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "medium",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "contextual_param",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "contextual_param_type",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
node /*: any*/.hash = 'f616f33dafa432290edc4057a8a72c6f';
module.exports = node;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type projectNodeWithTracks$ref: FragmentReference;
export type projectNodeWithTracks = {|
  +id: string,
  +is_public: ?boolean,
  +name: string,
  +notes: ?string,
  +opaque_id: ?string,
  +tracks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +id: string,
      +version: string,
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +price: ?number,
        +base_price: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +duration: ?number,
        +score: ?number,
        +boosted_score: ?number,
        +stems_available: ?boolean,
        +customizable: ?boolean,
        +matched_exclusions: ?$ReadOnlyArray<?number>,
        +tempos: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +value: ?number,
        |}>,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +bio: ?string,
          +bandcamp: ?string,
          +facebook: ?string,
          +instagram: ?string,
          +itunes: ?string,
          +soundcloud: ?string,
          +spotify: ?string,
          +twitter: ?string,
          +wiki: ?string,
          +youtube: ?string,
          +homebase: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
        +collections: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +description: ?string,
              +name: string,
              +slug: ?string,
              +category: ?{|
                +id: string,
                +name: ?string,
              |},
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
          |}>,
        |},
        +association_id: ?string,
        +selected_version: ?string,
      |},
    |}>,
  |},
  +owner: ?{|
    +id: string,
    +first_name: ?string,
    +last_name: ?string,
    +user_id: string,
  |},
  +users: ?$ReadOnlyArray<?{|
    +id: string,
    +first_name: ?string,
    +last_name: ?string,
    +user_id: string,
    +role: UserProjectRoleEnumType,
  |}>,
  +license_params: ?$ReadOnlyArray<?{|
    +spot_count: ?number,
    +term: ?number,
    +medium: number,
    +contextual_param: ?$ReadOnlyArray<?number>,
    +contextual_param_type: string,
  |}>,
  +$refType: projectNodeWithTracks$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "projectNodeWithTracks",
    "type": "Project",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["tracks"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "is_public",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "opaque_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "tracks",
      "name": "__project_tracks_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectTrackConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectTrackEdge",
        "plural": true,
        "selections": [v0, v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "stems_available",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "base_price",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "score",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "boosted_score",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "customizable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "matched_exclusions",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tempos",
            "storageKey": null,
            "args": null,
            "concreteType": "Tempo",
            "plural": true,
            "selections": [v0, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            }]
          }, v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "itunes",
              "args": null,
              "storageKey": null
            }, v0, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bio",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "bandcamp",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "facebook",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "instagram",
              "args": null,
              "storageKey": null
            }, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "soundcloud",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "spotify",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "twitter",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "wiki",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "youtube",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "homebase",
              "args": null,
              "storageKey": null
            }, v5]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": "terms(first:100)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 100,
              "type": "Int"
            }],
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "parent_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v0, v4, v1]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "collections",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionTrackEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Collection",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, v1, v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "category",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionCategory",
                  "plural": false,
                  "selections": [v0, v1]
                }, v5]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "association_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_version",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "owner",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectUser",
      "plural": false,
      "selections": [v0, v6, v7, v8]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "users",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectUser",
      "plural": true,
      "selections": [v0, v6, v7, v8, {
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_params",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseUsageParams",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "spot_count",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "term",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "medium",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "contextual_param",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "contextual_param_type",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
node /*: any*/.hash = 'b6c2a8a55fd82ada3ee725cf039fefb6';
module.exports = node;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash d7d64c829bd03a6ee98b5be461750727
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectCreate_MutationVariables = {|
  input: {
    name: string,
    owner_id?: ?string,
    notes?: ?string,
    tracks?: ?$ReadOnlyArray<?{
      track_id: string,
      version: string,
    }>,
    clientMutationId?: ?string,
  },
|};
export type projectCreate_MutationResponse = {|
  +createProject: ?{|
    +new_project_edge: ?{|
      +node: ?{|
        +id: string,
        +name: string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
      |},
    |},
  |},
|};
*/

/*
mutation projectCreate_Mutation(
  $input: CreateProjectInput!
) {
  createProject(input: $input) {
    new_project_edge {
      node {
        id
        name
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateProjectInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "projectCreate_Mutation",
    "id": null,
    "text": "mutation projectCreate_Mutation(\n  $input: CreateProjectInput!\n) {\n  createProject(input: $input) {\n    new_project_edge {\n      node {\n        id\n        name\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["createProject", "new_project_edge", "node", "tracks"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "projectCreate_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateProjectPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_project_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Project",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": "tracks",
              "name": "__project_tracks_connection",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectTrackEdge",
                "plural": true,
                "selections": [v2, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TrackSearchResult",
                  "plural": false,
                  "selections": [v5]
                }]
              }, v6]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "projectCreate_Mutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateProjectPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_project_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Project",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "tracks",
              "storageKey": "tracks(first:100)",
              "args": [{
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }],
              "concreteType": "ProjectTrackConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectTrackEdge",
                "plural": true,
                "selections": [v2, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TrackSearchResult",
                  "plural": false,
                  "selections": [v5, v2]
                }]
              }, v6]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "tracks",
              "args": [{
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }],
              "handle": "connection",
              "key": "project_tracks",
              "filters": null
            }]
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '7f2bb0bfd9f93c1a950586fdc89c24e5';
module.exports = node;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 1df483da3f750e9337532caeab4f8834
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectDelete_MutationVariables = {|
  input: {
    id: string,
    clientMutationId?: ?string,
  },
|};
export type projectDelete_MutationResponse = {|
  +deleteProject: ?{|
    +deleted_id: ?string,
    +deleted_count: ?number,
  |},
|};
*/

/*
mutation projectDelete_Mutation(
  $input: DeleteProjectInput!
) {
  deleteProject(input: $input) {
    deleted_id
    deleted_count
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProjectInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteProject",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteProjectInput!"
    }],
    "concreteType": "DeleteProjectPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deleted_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "deleted_count",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "projectDelete_Mutation",
    "id": null,
    "text": "mutation projectDelete_Mutation(\n  $input: DeleteProjectInput!\n) {\n  deleteProject(input: $input) {\n    deleted_id\n    deleted_count\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "projectDelete_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "projectDelete_Mutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
node /*: any*/.hash = 'e883c2109eeae8e4aac944ed16db59e4';
module.exports = node;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 08ec106c3626f7ec6f00727cd1cdbcf8
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProjectTrackStatusEnum = ('Active' | 'Deleted' | '%future added value');
export type projectUpdate_MutationVariables = {|
  input: {
    id: string,
    name?: ?string,
    nodes?: ?string,
    license_params?: ?$ReadOnlyArray<?{
      spot_count?: ?number,
      term?: ?number,
      medium: number,
      contextual_param?: ?$ReadOnlyArray<?number>,
      contextual_param_type: string,
    }>,
    is_public?: ?boolean,
    tracks?: ?{
      add?: ?$ReadOnlyArray<?{
        track_id: string,
        version: string,
      }>,
      update?: ?$ReadOnlyArray<?{
        id: string,
        version?: ?string,
        status?: ?ProjectTrackStatusEnum,
      }>,
      remove?: ?$ReadOnlyArray<?{
        id: string,
      }>,
    },
    clientMutationId?: ?string,
  },
|};
export type projectUpdate_MutationResponse = {|
  +updateProject: ?{|
    +project: ?{|
      +id: string,
      +is_public: ?boolean,
      +name: string,
      +tracks: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +id: string,
          +version: string,
          +node: ?{|
            +id: string,
            +internal_id: ?number,
            +price: ?number,
            +base_price: ?number,
            +title: ?string,
            +added_to_cart: ?boolean,
            +slug: ?string,
            +duration: ?number,
            +score: ?number,
            +boosted_score: ?number,
            +stems_available: ?boolean,
            +customizable: ?boolean,
            +matched_exclusions: ?$ReadOnlyArray<?number>,
            +tempos: ?$ReadOnlyArray<?{|
              +id: string,
              +name: ?string,
              +value: ?number,
            |}>,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
            +artist: ?{|
              +id: string,
              +name: ?string,
              +slug: ?string,
              +bio: ?string,
              +bandcamp: ?string,
              +facebook: ?string,
              +instagram: ?string,
              +itunes: ?string,
              +soundcloud: ?string,
              +spotify: ?string,
              +twitter: ?string,
              +wiki: ?string,
              +youtube: ?string,
              +homebase: ?string,
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
            +terms: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +is_highlighted: ?boolean,
                  +name: ?string,
                  +parent_id: ?string,
                  +taxonomy: ?{|
                    +id: string,
                    +internal_id: ?number,
                    +name: ?string,
                  |},
                |},
              |}>,
            |},
            +collections: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +description: ?string,
                  +name: string,
                  +slug: ?string,
                  +category: ?{|
                    +id: string,
                    +name: ?string,
                  |},
                  +assets: ?$ReadOnlyArray<?{|
                    +id: string,
                    +version: ?string,
                    +type: ?string,
                    +file_format: ?string,
                    +path: ?string,
                    +metadata: ?any,
                  |}>,
                |},
              |}>,
            |},
            +association_id: ?string,
            +selected_version: ?string,
          |},
        |}>,
      |},
      +license_params: ?$ReadOnlyArray<?{|
        +spot_count: ?number,
        +term: ?number,
        +medium: number,
        +contextual_param: ?$ReadOnlyArray<?number>,
        +contextual_param_type: string,
      |}>,
    |},
  |},
|};
*/

/*
mutation projectUpdate_Mutation(
  $input: UpdateProjectInput!
) {
  updateProject(input: $input) {
    project {
      id
      is_public
      name
      tracks(first: 100) {
        edges {
          id
          version
          node {
            id
            internal_id
            price
            base_price
            title
            added_to_cart
            slug
            duration
            score
            boosted_score
            stems_available
            customizable
            matched_exclusions
            tempos {
              id
              name
              value
            }
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
            artist {
              id
              name
              slug
              bio
              bandcamp
              facebook
              instagram
              itunes
              soundcloud
              spotify
              twitter
              wiki
              youtube
              homebase
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            terms(first: 100) {
              edges {
                node {
                  id
                  is_highlighted
                  name
                  parent_id
                  taxonomy {
                    id
                    internal_id
                    name
                  }
                }
              }
            }
            collections {
              edges {
                node {
                  id
                  description
                  name
                  slug
                  category {
                    id
                    name
                  }
                  assets {
                    id
                    version
                    type
                    file_format
                    path
                    metadata
                  }
                }
                id
              }
            }
            association_id
            selected_version
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      license_params {
        spot_count
        term
        medium
        contextual_param
        contextual_param_type
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateProjectInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "is_public",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "version",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "stems_available",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "base_price",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "added_to_cart",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "duration",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "score",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "boosted_score",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "customizable",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "matched_exclusions",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "tempos",
    "storageKey": null,
    "args": null,
    "concreteType": "Tempo",
    "plural": true,
    "selections": [v2, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    }]
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v20 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "artist",
    "storageKey": null,
    "args": null,
    "concreteType": "Artist",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "itunes",
      "args": null,
      "storageKey": null
    }, v2, v11, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bio",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "bandcamp",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "facebook",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "instagram",
      "args": null,
      "storageKey": null
    }, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "soundcloud",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "spotify",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "twitter",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "wiki",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "youtube",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "homebase",
      "args": null,
      "storageKey": null
    }, v19]
  },
      v21 = [{
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  }],
      v22 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "terms",
    "storageKey": "terms(first:100)",
    "args": v21,
    "concreteType": "TaxonomyTermConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTerm",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "is_highlighted",
          "args": null,
          "storageKey": null
        }, v4, {
          "kind": "ScalarField",
          "alias": null,
          "name": "parent_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "taxonomy",
          "storageKey": null,
          "args": null,
          "concreteType": "Taxonomy",
          "plural": false,
          "selections": [v2, v15, v4]
        }]
      }]
    }]
  },
      v23 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "node",
    "storageKey": null,
    "args": null,
    "concreteType": "Collection",
    "plural": false,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }, v4, v11, {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionCategory",
      "plural": false,
      "selections": [v2, v4]
    }, v19]
  },
      v24 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "association_id",
    "args": null,
    "storageKey": null
  },
      v25 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "selected_version",
    "args": null,
    "storageKey": null
  },
      v26 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v27 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v28 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v29 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "license_params",
    "storageKey": null,
    "args": null,
    "concreteType": "LicenseUsageParams",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "projectUpdate_Mutation",
    "id": null,
    "text": "mutation projectUpdate_Mutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    project {\n      id\n      is_public\n      name\n      tracks(first: 100) {\n        edges {\n          id\n          version\n          node {\n            id\n            internal_id\n            price\n            base_price\n            title\n            added_to_cart\n            slug\n            duration\n            score\n            boosted_score\n            stems_available\n            customizable\n            matched_exclusions\n            tempos {\n              id\n              name\n              value\n            }\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n            artist {\n              id\n              name\n              slug\n              bio\n              bandcamp\n              facebook\n              instagram\n              itunes\n              soundcloud\n              spotify\n              twitter\n              wiki\n              youtube\n              homebase\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            terms(first: 100) {\n              edges {\n                node {\n                  id\n                  is_highlighted\n                  name\n                  parent_id\n                  taxonomy {\n                    id\n                    internal_id\n                    name\n                  }\n                }\n              }\n            }\n            collections {\n              edges {\n                node {\n                  id\n                  description\n                  name\n                  slug\n                  category {\n                    id\n                    name\n                  }\n                  assets {\n                    id\n                    version\n                    type\n                    file_format\n                    path\n                    metadata\n                  }\n                }\n                id\n              }\n            }\n            association_id\n            selected_version\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      license_params {\n        spot_count\n        term\n        medium\n        contextual_param\n        contextual_param_type\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["updateProject", "project", "tracks"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "projectUpdate_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProjectPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "project",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "LinkedField",
            "alias": "tracks",
            "name": "__project_tracks_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v2, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [v6, v2, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v22, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "collections",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionTrackEdge",
                    "plural": true,
                    "selections": [v23]
                  }]
                }, v24, v25, v26]
              }, v27]
            }, v28]
          }, v29]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "projectUpdate_Mutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProjectPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "project",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "LinkedField",
            "alias": null,
            "name": "tracks",
            "storageKey": "tracks(first:100)",
            "args": v21,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v2, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [v6, v2, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v22, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "collections",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionTrackEdge",
                    "plural": true,
                    "selections": [v23, v2]
                  }]
                }, v24, v25, v26]
              }, v27]
            }, v28]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "tracks",
            "args": v21,
            "handle": "connection",
            "key": "project_tracks",
            "filters": null
          }, v29]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = 'a62040275d0b4d3aedfe1a5e92617e31';
module.exports = node;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash ea73b43fcbc392656626cae91a58fe59
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectJoin_MutationVariables = {|
  input: {
    opaque_id: string,
    clientMutationId?: ?string,
  },
|};
export type projectJoin_MutationResponse = {|
  +joinProject: ?{|
    +project: ?{|
      +id: string,
      +name: string,
      +users: ?$ReadOnlyArray<?{|
        +id: string,
        +user_id: string,
      |}>,
    |},
  |},
|};
*/

/*
mutation projectJoin_Mutation(
  $input: JoinProjectInput!
) {
  joinProject(input: $input) {
    project {
      id
      name
      users {
        id
        user_id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "JoinProjectInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "joinProject",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "JoinProjectInput!"
    }],
    "concreteType": "JoinProjectPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "project",
      "storageKey": null,
      "args": null,
      "concreteType": "Project",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "users",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectUser",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "user_id",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "projectJoin_Mutation",
    "id": null,
    "text": "mutation projectJoin_Mutation(\n  $input: JoinProjectInput!\n) {\n  joinProject(input: $input) {\n    project {\n      id\n      name\n      users {\n        id\n        user_id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "projectJoin_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v2
    },
    "operation": {
      "kind": "Operation",
      "name": "projectJoin_Mutation",
      "argumentDefinitions": v0,
      "selections": v2
    }
  };
}();
node /*: any*/.hash = 'd3aca7d81ccf26ed5c7d2d192087718e';
module.exports = node;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Preferences Saga
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(retrieveCheckoutFromLocalStorage);

Object.defineProperty(exports, "__esModule", { value: true });
var localStorage_1 = __webpack_require__(316);
var actions = __webpack_require__(347);
var redux_saga_1 = __webpack_require__(73);
var localStorage_2 = __webpack_require__(238);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.call(retrieveCheckoutFromLocalStorage);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function retrieveCheckoutFromLocalStorage() {
    var res;
    return regeneratorRuntime.wrap(function retrieveCheckoutFromLocalStorage$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 14;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take(actions.requestSetPreferencesFromLocalStorage);

                case 3:
                    _context2.next = 5;
                    return redux_saga_1.effects.put(actions.setPreferencesFromLocalStorage.started);

                case 5:
                    _context2.next = 7;
                    return redux_saga_1.effects.put(localStorage_1.getItemFromLocalStorage.started({ key: localStorage_2.localStorageSuffixPreferences }));

                case 7:
                    _context2.next = 9;
                    return redux_saga_1.effects.take(localStorage_1.getItemFromLocalStorage.done);

                case 9:
                    res = _context2.sent;
                    _context2.next = 12;
                    return redux_saga_1.effects.put(actions.setPreferencesFromLocalStorage.done({
                        params: undefined,
                        result: res.payload.result.data
                    }));

                case 12:
                    _context2.next = 0;
                    break;

                case 14:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Project Saga
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForCreateProject),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForUpdateProject),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchForDeleteProject),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchForJoinProject),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchForAddTrackToProject);

Object.defineProperty(exports, "__esModule", { value: true });
var saga_1 = __webpack_require__(314);
var notifications_1 = __webpack_require__(53);
var actions = __webpack_require__(130);
var projects_1 = __webpack_require__(723);
var user_1 = __webpack_require__(317);
var redux_saga_1 = __webpack_require__(73);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForCreateProject), redux_saga_1.effects.call(watchForUpdateProject), redux_saga_1.effects.call(watchForDeleteProject), redux_saga_1.effects.call(watchForAddTrackToProject), redux_saga_1.effects.call(watchForJoinProject)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
function watchForCreateProject() {
    var _ref, _ref$payload, input, promise, viewerId, worker, _ref2, response, errors;

    return regeneratorRuntime.wrap(function watchForCreateProject$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 25;
                        break;
                    }

                    _context2.next = 3;
                    return redux_saga_1.effects.take(actions.requestCreateProject);

                case 3:
                    _ref = _context2.sent;
                    _ref$payload = _ref.payload;
                    input = _ref$payload.input;
                    promise = _ref$payload.promise;
                    _context2.next = 9;
                    return redux_saga_1.effects.select(user_1.getViewerId);

                case 9:
                    viewerId = _context2.sent;
                    _context2.prev = 10;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.createProject, projects_1.createProject);
                    _context2.next = 14;
                    return redux_saga_1.effects.call(worker, { input: input }, viewerId);

                case 14:
                    _ref2 = _context2.sent;
                    response = _ref2.response;
                    errors = _ref2.errors;

                    if (errors) {
                        promise.reject(errors);
                    } else {
                        promise.resolve(response);
                    }
                    _context2.next = 23;
                    break;

                case 20:
                    _context2.prev = 20;
                    _context2.t0 = _context2["catch"](10);

                    promise.reject(_context2.t0);

                case 23:
                    _context2.next = 0;
                    break;

                case 25:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[10, 20]]);
}
function watchForUpdateProject() {
    var _ref3, payload, worker, _ref4, response, errors;

    return regeneratorRuntime.wrap(function watchForUpdateProject$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 20;
                        break;
                    }

                    _context3.next = 3;
                    return redux_saga_1.effects.take(actions.requestUpdateProject);

                case 3:
                    _ref3 = _context3.sent;
                    payload = _ref3.payload;
                    _context3.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.updateProject, projects_1.updateProject);
                    _context3.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    _ref4 = _context3.sent;
                    response = _ref4.response;
                    errors = _ref4.errors;

                    if (errors) {
                        payload.promise.reject(errors);
                    } else {
                        payload.promise.resolve(response);
                    }
                    _context3.next = 18;
                    break;

                case 15:
                    _context3.prev = 15;
                    _context3.t0 = _context3["catch"](5);

                    payload.promise.reject(_context3.t0);

                case 18:
                    _context3.next = 0;
                    break;

                case 20:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[5, 15]]);
}
function watchForDeleteProject() {
    var _ref5, payload, viewerId, worker, _ref6, response, errors;

    return regeneratorRuntime.wrap(function watchForDeleteProject$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 23;
                        break;
                    }

                    _context4.next = 3;
                    return redux_saga_1.effects.take(actions.requestDeleteProject);

                case 3:
                    _ref5 = _context4.sent;
                    payload = _ref5.payload;
                    _context4.next = 7;
                    return redux_saga_1.effects.select(user_1.getViewerId);

                case 7:
                    viewerId = _context4.sent;
                    _context4.prev = 8;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.deleteProject, projects_1.deleteProject);
                    _context4.next = 12;
                    return redux_saga_1.effects.call(worker, payload, viewerId);

                case 12:
                    _ref6 = _context4.sent;
                    response = _ref6.response;
                    errors = _ref6.errors;

                    if (errors) {
                        payload.promise.reject(errors);
                    } else {
                        payload.promise.resolve(response);
                    }
                    _context4.next = 21;
                    break;

                case 18:
                    _context4.prev = 18;
                    _context4.t0 = _context4["catch"](8);

                    payload.promise.reject(_context4.t0);

                case 21:
                    _context4.next = 0;
                    break;

                case 23:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[8, 18]]);
}
function watchForJoinProject() {
    var _ref7, payload, worker, _ref8, response, errors, projectName;

    return regeneratorRuntime.wrap(function watchForJoinProject$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (false) {
                        _context5.next = 31;
                        break;
                    }

                    _context5.next = 3;
                    return redux_saga_1.effects.take(actions.requestJoinProject);

                case 3:
                    _ref7 = _context5.sent;
                    payload = _ref7.payload;
                    _context5.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.joinProject, projects_1.joinProject);
                    _context5.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    _ref8 = _context5.sent;
                    response = _ref8.response;
                    errors = _ref8.errors;

                    if (!errors) {
                        _context5.next = 18;
                        break;
                    }

                    _context5.next = 15;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        autoDismiss: false,
                        state: 'error',
                        message: "Something went wrong: " + JSON.stringify(errors)
                    }));

                case 15:
                    payload.promise.reject(errors);
                    _context5.next = 22;
                    break;

                case 18:
                    projectName = response.joinProject.project.name;
                    _context5.next = 21;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        state: 'success',
                        message: "Congratulations! You are now a collaborator on playlist " + projectName + "."
                    }));

                case 21:
                    payload.promise.resolve(response);

                case 22:
                    _context5.next = 29;
                    break;

                case 24:
                    _context5.prev = 24;
                    _context5.t0 = _context5["catch"](5);
                    _context5.next = 28;
                    return redux_saga_1.effects.put(notifications_1.pushNotification({
                        autoDismiss: false,
                        state: 'error',
                        message: "Something went wrong: " + _context5.t0
                    }));

                case 28:
                    payload.promise.reject(_context5.t0);

                case 29:
                    _context5.next = 0;
                    break;

                case 31:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[5, 24]]);
}
function watchForAddTrackToProject() {
    var _ref9, payload, worker, _ref10, response, errors;

    return regeneratorRuntime.wrap(function watchForAddTrackToProject$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 20;
                        break;
                    }

                    _context6.next = 3;
                    return redux_saga_1.effects.take(actions.requestAddTrackToProject);

                case 3:
                    _ref9 = _context6.sent;
                    payload = _ref9.payload;
                    _context6.prev = 5;
                    worker = saga_1.sagaAsyncActionWorkerFactory(actions.addTrackToProject, projects_1.addTrackToProject);
                    _context6.next = 9;
                    return redux_saga_1.effects.call(worker, payload);

                case 9:
                    _ref10 = _context6.sent;
                    response = _ref10.response;
                    errors = _ref10.errors;

                    if (errors) {
                        payload.promise.reject(errors);
                    } else {
                        payload.promise.resolve(response);
                    }
                    _context6.next = 18;
                    break;

                case 15:
                    _context6.prev = 15;
                    _context6.t0 = _context6["catch"](5);

                    payload.promise.reject(_context6.t0);

                case 18:
                    _context6.next = 0;
                    break;

                case 20:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[5, 15]]);
}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Authentication Sagas
 */
/* tslint:disable:space-before-function-paren */

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserLogIn),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserSignUp),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchForSendConfirmationEmail),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchForEmailVerification),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserAuthenticationWithToken),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserProfileUpdate),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchForTrackUserRegistration),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserResetPassword),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchForUserLogOut);

Object.defineProperty(exports, "__esModule", { value: true });
var localStorage_1 = __webpack_require__(316);
var actions = __webpack_require__(50);
var authentication_1 = __webpack_require__(1812);
var user_1 = __webpack_require__(1813);
var redux_saga_1 = __webpack_require__(73);
var typescript_fsa_redux_saga_1 = __webpack_require__(721);
function init() {
    return regeneratorRuntime.wrap(function init$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return redux_saga_1.effects.all([redux_saga_1.effects.call(watchForUserLogIn), redux_saga_1.effects.call(watchForUserLogOut), redux_saga_1.effects.call(watchForUserSignUp), redux_saga_1.effects.call(watchForUserResetPassword), redux_saga_1.effects.call(watchForUserAuthenticationWithToken), redux_saga_1.effects.call(watchForUserProfileUpdate), redux_saga_1.effects.call(watchForTrackUserRegistration), redux_saga_1.effects.call(watchForSendConfirmationEmail), redux_saga_1.effects.call(watchForEmailVerification)]);

                case 2:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
exports.init = init;
var userSagaWorkerFactory = function userSagaWorkerFactory(action, asynFunc) {
    return typescript_fsa_redux_saga_1.bindAsyncAction(action)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var _redux_saga_1$effects;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (_redux_saga_1$effects = redux_saga_1.effects).call.apply(_redux_saga_1$effects, [asynFunc, params].concat(args));

                    case 2:
                        return _context2.abrupt("return", _context2.sent);

                    case 3:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee, this);
    }));
};
var logInWorker = userSagaWorkerFactory(actions.logInUser, user_1.logInUser);
var signUpWorker = userSagaWorkerFactory(actions.signUpUser, user_1.signUpUser);
var logOutWorker = userSagaWorkerFactory(actions.logOutUser, user_1.logOutUser);
var authenticateWithTokenWorker = userSagaWorkerFactory(actions.authenticateUserWithToken, user_1.authenticateWithToken);
var resetPasswordWorker = userSagaWorkerFactory(actions.resetPassword, user_1.resetPassword);
var updateProfileWorker = userSagaWorkerFactory(actions.updateUserProfile, user_1.updateProfile);
var trackUserRegistrationWorker = userSagaWorkerFactory(actions.trackNewUserRegistration, user_1.updateProfile);
var sendConfirmationEmailWorker = userSagaWorkerFactory(actions.sendConfirmationEmail, user_1.sendConfirmationEmail);
var verifyEmailWorker = userSagaWorkerFactory(actions.verifyUserEmail, user_1.verifyUserEmail);
function watchForUserLogIn() {
    var _ref, _ref$payload, credentials, promise, userPool, session;

    return regeneratorRuntime.wrap(function watchForUserLogIn$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 22;
                        break;
                    }

                    _context3.next = 3;
                    return redux_saga_1.effects.take(actions.requestUserLogIn);

                case 3:
                    _ref = _context3.sent;
                    _ref$payload = _ref.payload;
                    credentials = _ref$payload.credentials;
                    promise = _ref$payload.promise;
                    _context3.prev = 7;
                    _context3.next = 10;
                    return redux_saga_1.effects.select(authentication_1.getUserPool);

                case 10:
                    userPool = _context3.sent;
                    _context3.next = 13;
                    return redux_saga_1.effects.call(logInWorker, credentials, userPool);

                case 13:
                    session = _context3.sent;

                    promise.resolve(session);
                    _context3.next = 20;
                    break;

                case 17:
                    _context3.prev = 17;
                    _context3.t0 = _context3["catch"](7);

                    promise.reject(_context3.t0);

                case 20:
                    _context3.next = 0;
                    break;

                case 22:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked2, this, [[7, 17]]);
}
function watchForUserSignUp() {
    var _ref2, _ref2$payload, credentials, promise, userPool;

    return regeneratorRuntime.wrap(function watchForUserSignUp$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 22;
                        break;
                    }

                    _context4.next = 3;
                    return redux_saga_1.effects.take(actions.requestUserSignUp);

                case 3:
                    _ref2 = _context4.sent;
                    _ref2$payload = _ref2.payload;
                    credentials = _ref2$payload.credentials;
                    promise = _ref2$payload.promise;
                    _context4.next = 9;
                    return redux_saga_1.effects.select(authentication_1.getUserPool);

                case 9:
                    userPool = _context4.sent;
                    _context4.prev = 10;
                    _context4.next = 13;
                    return redux_saga_1.effects.call(signUpWorker, credentials, userPool);

                case 13:
                    _context4.next = 15;
                    return redux_saga_1.effects.put(actions.requestUserLogIn({ credentials: credentials, promise: promise }));

                case 15:
                    _context4.next = 20;
                    break;

                case 17:
                    _context4.prev = 17;
                    _context4.t0 = _context4["catch"](10);

                    promise.reject(_context4.t0);

                case 20:
                    _context4.next = 0;
                    break;

                case 22:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked3, this, [[10, 17]]);
}
function watchForSendConfirmationEmail() {
    var _ref3, promise, userPool;

    return regeneratorRuntime.wrap(function watchForSendConfirmationEmail$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (false) {
                        _context5.next = 19;
                        break;
                    }

                    _context5.next = 3;
                    return redux_saga_1.effects.take(actions.requestSendConfirmationEmail);

                case 3:
                    _ref3 = _context5.sent;
                    promise = _ref3.payload.promise;
                    _context5.prev = 5;
                    _context5.next = 8;
                    return redux_saga_1.effects.select(authentication_1.getUserPool);

                case 8:
                    userPool = _context5.sent;
                    _context5.next = 11;
                    return redux_saga_1.effects.call(sendConfirmationEmailWorker, undefined, userPool);

                case 11:
                    promise.resolve();
                    _context5.next = 17;
                    break;

                case 14:
                    _context5.prev = 14;
                    _context5.t0 = _context5["catch"](5);

                    promise.reject(_context5.t0);

                case 17:
                    _context5.next = 0;
                    break;

                case 19:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked4, this, [[5, 14]]);
}
function watchForEmailVerification() {
    var _ref4, _ref4$payload, code, email, promise, userPool;

    return regeneratorRuntime.wrap(function watchForEmailVerification$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 22;
                        break;
                    }

                    _context6.next = 3;
                    return redux_saga_1.effects.take(actions.requestVerifyUserEmail);

                case 3:
                    _ref4 = _context6.sent;
                    _ref4$payload = _ref4.payload;
                    code = _ref4$payload.code;
                    email = _ref4$payload.email;
                    promise = _ref4$payload.promise;
                    _context6.prev = 8;
                    _context6.next = 11;
                    return redux_saga_1.effects.select(authentication_1.getUserPool);

                case 11:
                    userPool = _context6.sent;
                    _context6.next = 14;
                    return redux_saga_1.effects.call(verifyEmailWorker, { email: email, code: code }, userPool);

                case 14:
                    promise.resolve();
                    _context6.next = 20;
                    break;

                case 17:
                    _context6.prev = 17;
                    _context6.t0 = _context6["catch"](8);

                    promise.reject(_context6.t0);

                case 20:
                    _context6.next = 0;
                    break;

                case 22:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked5, this, [[8, 17]]);
}
function watchForUserAuthenticationWithToken() {
    var _ref5, _ref5$payload, idToken, promise, viewerId, result;

    return regeneratorRuntime.wrap(function watchForUserAuthenticationWithToken$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    if (false) {
                        _context7.next = 20;
                        break;
                    }

                    _context7.next = 3;
                    return redux_saga_1.effects.take(actions.requestUserAuthenticationWithToken);

                case 3:
                    _ref5 = _context7.sent;
                    _ref5$payload = _ref5.payload;
                    idToken = _ref5$payload.idToken;
                    promise = _ref5$payload.promise;
                    viewerId = _ref5$payload.viewerId;
                    _context7.prev = 8;
                    _context7.next = 11;
                    return redux_saga_1.effects.call(authenticateWithTokenWorker, { idToken: idToken, viewerId: viewerId });

                case 11:
                    result = _context7.sent;

                    promise.resolve(result);
                    _context7.next = 18;
                    break;

                case 15:
                    _context7.prev = 15;
                    _context7.t0 = _context7["catch"](8);

                    promise.reject(_context7.t0);

                case 18:
                    _context7.next = 0;
                    break;

                case 20:
                case "end":
                    return _context7.stop();
            }
        }
    }, _marked6, this, [[8, 15]]);
}
function watchForUserProfileUpdate() {
    var _ref6, _ref6$payload, input, promise, viewerId, result;

    return regeneratorRuntime.wrap(function watchForUserProfileUpdate$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 20;
                        break;
                    }

                    _context8.next = 3;
                    return redux_saga_1.effects.take(actions.requestUpdateUserProfile);

                case 3:
                    _ref6 = _context8.sent;
                    _ref6$payload = _ref6.payload;
                    input = _ref6$payload.input;
                    promise = _ref6$payload.promise;
                    viewerId = _ref6$payload.viewerId;
                    _context8.prev = 8;
                    _context8.next = 11;
                    return redux_saga_1.effects.call(updateProfileWorker, { input: input, viewerId: viewerId });

                case 11:
                    result = _context8.sent;

                    promise.resolve(result);
                    _context8.next = 18;
                    break;

                case 15:
                    _context8.prev = 15;
                    _context8.t0 = _context8["catch"](8);

                    promise.reject(_context8.t0);

                case 18:
                    _context8.next = 0;
                    break;

                case 20:
                case "end":
                    return _context8.stop();
            }
        }
    }, _marked7, this, [[8, 15]]);
}
function watchForTrackUserRegistration() {
    var _ref7, _ref7$payload, promise, viewerId, input, result;

    return regeneratorRuntime.wrap(function watchForTrackUserRegistration$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    if (false) {
                        _context9.next = 20;
                        break;
                    }

                    _context9.next = 3;
                    return redux_saga_1.effects.take(actions.requestTrackUserRegistration);

                case 3:
                    _ref7 = _context9.sent;
                    _ref7$payload = _ref7.payload;
                    promise = _ref7$payload.promise;
                    viewerId = _ref7$payload.viewerId;
                    input = {
                        ga_account_goal_sent: true
                    };
                    _context9.prev = 8;
                    _context9.next = 11;
                    return redux_saga_1.effects.call(trackUserRegistrationWorker, { input: input, viewerId: viewerId });

                case 11:
                    result = _context9.sent;

                    promise.resolve(result);
                    _context9.next = 18;
                    break;

                case 15:
                    _context9.prev = 15;
                    _context9.t0 = _context9["catch"](8);

                    promise.reject(_context9.t0);

                case 18:
                    _context9.next = 0;
                    break;

                case 20:
                case "end":
                    return _context9.stop();
            }
        }
    }, _marked8, this, [[8, 15]]);
}
function watchForUserResetPassword() {
    var _ref8, _ref8$payload, code, email, promise, password, userPool;

    return regeneratorRuntime.wrap(function watchForUserResetPassword$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 23;
                        break;
                    }

                    _context10.next = 3;
                    return redux_saga_1.effects.take(actions.requestResetPassword);

                case 3:
                    _ref8 = _context10.sent;
                    _ref8$payload = _ref8.payload;
                    code = _ref8$payload.code;
                    email = _ref8$payload.email;
                    promise = _ref8$payload.promise;
                    password = _ref8$payload.password;
                    _context10.prev = 9;
                    _context10.next = 12;
                    return redux_saga_1.effects.select(authentication_1.getUserPool);

                case 12:
                    userPool = _context10.sent;
                    _context10.next = 15;
                    return redux_saga_1.effects.call(resetPasswordWorker, { code: code, email: email, password: password }, userPool);

                case 15:
                    promise.resolve();
                    _context10.next = 21;
                    break;

                case 18:
                    _context10.prev = 18;
                    _context10.t0 = _context10["catch"](9);

                    promise.reject(_context10.t0);

                case 21:
                    _context10.next = 0;
                    break;

                case 23:
                case "end":
                    return _context10.stop();
            }
        }
    }, _marked9, this, [[9, 18]]);
}
function watchForUserLogOut() {
    var _ref9, _ref9$payload, promise, viewerId, result;

    return regeneratorRuntime.wrap(function watchForUserLogOut$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    if (false) {
                        _context11.next = 21;
                        break;
                    }

                    _context11.next = 3;
                    return redux_saga_1.effects.take(actions.requestUserLogOut);

                case 3:
                    _ref9 = _context11.sent;
                    _ref9$payload = _ref9.payload;
                    promise = _ref9$payload.promise;
                    viewerId = _ref9$payload.viewerId;
                    _context11.prev = 7;
                    _context11.next = 10;
                    return redux_saga_1.effects.call(logOutWorker, { viewerId: viewerId });

                case 10:
                    result = _context11.sent;
                    _context11.next = 13;
                    return redux_saga_1.effects.put(localStorage_1.clearLocalStorage());

                case 13:
                    promise.resolve(result);
                    _context11.next = 19;
                    break;

                case 16:
                    _context11.prev = 16;
                    _context11.t0 = _context11["catch"](7);

                    promise.reject(_context11.t0);

                case 19:
                    _context11.next = 0;
                    break;

                case 21:
                case "end":
                    return _context11.stop();
            }
        }
    }, _marked10, this, [[7, 16]]);
}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getAuthenticationConfig = function (state) {
  return state.authentication;
};
exports.getUserPool = reselect_1.createSelector(exports.getAuthenticationConfig, function (authentication) {
  return authentication.userPool;
});

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * User Reducer Helper Function
 */

Object.defineProperty(exports, "__esModule", { value: true });
var relay_1 = __webpack_require__(93);
var login_1 = __webpack_require__(404);
var logout_1 = __webpack_require__(437);
var profile_1 = __webpack_require__(288);
var amazon_cognito_identity_js_1 = __webpack_require__(680);
var react_relay_1 = __webpack_require__(13);
exports.logInUser = function (_ref, userPool) {
    var email = _ref.email,
        password = _ref.password;
    return new Promise(function (resolve, reject) {
        var authenticationData = {
            Username: email,
            Password: password
        };
        var userData = {
            Username: email,
            Pool: userPool
        };
        var authenticationDetails = new amazon_cognito_identity_js_1.AuthenticationDetails(authenticationData);
        var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: resolve,
            onFailure: reject,
            newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
                // User was signed up by an admin and must provide new
                // password and required attributes, if any, to complete
                // authentication.
                // The api doesn't accept this field back
                delete userAttributes.email_verified;
                var newPassword = prompt('Enter your new password') || '';
                // Get new password. This same workflow applies for password reset.
                cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
                    onSuccess: function onSuccess(cognitoSession) {
                        resolve(cognitoSession);
                    },
                    onFailure: function onFailure(err) {
                        reject(err);
                    }
                });
            }
        });
    });
};
exports.signUpUser = function (_ref2, userPool) {
    var email = _ref2.email,
        password = _ref2.password;
    return new Promise(function (resolve, reject) {
        var attributeData = [{ Name: 'given_name', Value: '' }, { Name: 'family_name', Value: '' }, { Name: 'email', Value: email }];
        var userAttributes = attributeData.map(function (data) {
            return new amazon_cognito_identity_js_1.CognitoUserAttribute(data);
        });
        userPool.signUp(email, password, userAttributes, [], function (err, result) {
            err ? reject(err) : resolve(result.user);
        });
    });
};
exports.resetPassword = function (_ref3, userPool) {
    var email = _ref3.email,
        code = _ref3.code,
        password = _ref3.password;
    return new Promise(function (resolve, reject) {
        var userData = {
            Username: email,
            Pool: userPool
        };
        var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
        if (code && password) {
            cognitoUser.confirmPassword(code, password, {
                onSuccess: resolve,
                onFailure: reject
            });
        } else {
            cognitoUser.forgotPassword({
                onSuccess: resolve,
                onFailure: reject
            });
        }
    });
};
exports.authenticateWithToken = function (_ref4) {
    var idToken = _ref4.idToken,
        viewerId = _ref4.viewerId;
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: login_1.LoginFormMutation,
            updater: function updater(storeProxy) {
                var viewerRecord = storeProxy.get(viewerId);
                var loginRecord = storeProxy.getRootField('login');
                if (loginRecord) {
                    var newProfileRecord = loginRecord.getLinkedRecord('profile');
                    var cartRecord = loginRecord.getLinkedRecord('cart');
                    viewerRecord.setLinkedRecord(newProfileRecord, 'profile');
                    viewerRecord.setLinkedRecord(cartRecord, 'cart');
                }
            },
            variables: { input: { id_token: idToken } },
            onCompleted: function onCompleted(_, errors) {
                return resolve(errors);
            },
            onError: reject
        });
    });
};
exports.updateProfile = function (_ref5) {
    var input = _ref5.input,
        viewerId = _ref5.viewerId;
    return new Promise(function (resolve, reject) {
        var variables = {
            profileInput: input
        };
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: profile_1.UpdateProfileMutation,
            updater: function updater(store) {
                var viewerRecord = store.get(viewerId);
                var updateProfileRecord = store.getRootField('updateProfile');
                if (updateProfileRecord) {
                    var newProfileRecord = updateProfileRecord.getLinkedRecord('profile');
                    viewerRecord.setLinkedRecord(newProfileRecord, 'profile');
                }
            },
            variables: variables,
            onCompleted: function onCompleted(response, errors) {
                return resolve(response);
            },
            onError: reject
        });
    });
};
exports.logOutUser = function (_ref6) {
    var viewerId = _ref6.viewerId;
    return new Promise(function (resolve, reject) {
        react_relay_1.commitMutation(relay_1.environment, {
            mutation: logout_1.LogoutMutation,
            updater: function updater(storeProxy, errors) {
                var viewerRecord = storeProxy.get(viewerId);
                var profileRecord = viewerRecord.getLinkedRecord('profile');
                if (profileRecord) {
                    var id = profileRecord.getDataID();
                    storeProxy.delete(id);
                }
                // IMPORTANT: the cart needs to be unset to prevent the anonymous user
                // from modifying a logged in user's cart.
                viewerRecord.setValue(null, 'cart');
            },
            variables: { input: {} },
            onCompleted: function onCompleted(response, errors) {
                return resolve({ response: response, errors: errors });
            },
            onError: reject
        });
    });
};
exports.sendConfirmationEmail = function (_, userPool) {
    return new Promise(function (resolve, reject) {
        var cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
            cognitoUser.getSession(function (error, session) {
                if (error) {
                    reject(error);
                    return;
                }
                cognitoUser.getAttributeVerificationCode('email', {
                    onSuccess: resolve,
                    onFailure: function onFailure(failureError) {
                        return reject(failureError);
                    },
                    inputVerificationCode: resolve
                });
            });
        } else {
            reject(new Error('Cognito user not found.'));
        }
    });
};
exports.verifyUserEmail = function (_ref7, userPool) {
    var email = _ref7.email,
        code = _ref7.code;
    return new Promise(function (resolve, reject) {
        var cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
            // verifyAttribute requires a valid access token, so we need to
            // call getSession to make sure we get a valid access token if
            // the old one has expired
            // If the user accesses the verification link in a browser where
            // they are not logged in, we need to have them log in and then
            // auto-redirect back to the verification page with the code/email.
            cognitoUser.getSession(function (error, session) {
                if (error) {
                    reject(error);
                    return;
                }
                cognitoUser.verifyAttribute('email', code, {
                    onSuccess: resolve,
                    onFailure: function onFailure(failureError) {
                        return reject(failureError);
                    }
                });
            });
        } else {
            reject({
                name: 'CognitoUserNotFound',
                message: 'User must be logged in in order to verify his email.'
            });
        }
    });
};

/***/ }),
/* 1814 */,
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Farce TransitionHook
 */

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var UIActions = __webpack_require__(29);
var router_1 = __webpack_require__(27);
var farce_1 = __webpack_require__(306);
var nextTick = __webpack_require__(82);
var Cart_1 = __webpack_require__(224);
var Checkout_1 = __webpack_require__(290);
exports.transitionHookCreator = function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (location) {
        var state = getState();
        var found = state.found,
            player = state.player,
            ui = state.ui;

        var goingBackOrForward = 'delta' in location;
        // If pathname didn't change, we don't do anything
        if (location.pathname === found.match.location.pathname) {
            return true;
        }
        switch (location.pathname) {
            case Cart_1.CartPagePath:
                // If going to Cart, we make sure to remove the current playing track term list
                if (player.currentTrack && ui.player && ui.player.termListIsVisible) {
                    dispatch(UIActions.togglePlayerTermListVisibility(false));
                }
                break;
            case Checkout_1.CheckoutPagePath:
                // If going to Checkout, we make sure to kill the player because it becomes a distraction
                if (player.currentTrack) {
                    if (player.isTrackPlaying) {
                        dispatch(playerActions.pause());
                    }
                    dispatch(playerActions.clearQueue());
                    if (ui.player && ui.player.termListIsVisible) {
                        dispatch(UIActions.togglePlayerTermListVisibility(false));
                    }
                }
                break;
            default:
                break;
        }
        // We apply the persistent query string middleware to keep the query string when navigating
        if (goingBackOrForward) {
            // If user is navigation back or forward, we want to keep the current query string
            nextTick(function () {
                dispatch(farce_1.Actions.replace(router_1.getRouteLocation(location.pathname, found.match.location.query)));
            });
        }
        // If Track Details Component is open in current page, we close it to avoid
        // design issues with pages where Track Details is not available
        if (ui.trackDetails && ui.trackDetails.visible) {
            dispatch(UIActions.toggleTrackDetailsVisibility(false));
        }
        return true;
    };
};

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Router
 */

Object.defineProperty(exports, "__esModule", { value: true });
var found = __webpack_require__(32);
var React = __webpack_require__(0);
var anyFound = found;
exports.default = anyFound.createConnectedRouter({
    render: anyFound.createRender({
        renderError: function renderError(_ref) {
            var error = _ref.error;
            return React.createElement("div", null, error.status === 404 ? 'Not found' : 'Error');
        }
    })
});

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(724);
var cart_1 = __webpack_require__(422);
var checkout_1 = __webpack_require__(291);
var collection_1 = __webpack_require__(647);
var emptyState_1 = __webpack_require__(305);
var login_1 = __webpack_require__(404);
var logout_1 = __webpack_require__(437);
var order_1 = __webpack_require__(654);
var profile_1 = __webpack_require__(288);
var project_1 = __webpack_require__(318);
var router_1 = __webpack_require__(27);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
// tslint:disable-next-line:no-submodule-imports
// import * as hotRouteConfig from 'found/lib/hotRouteConfig';
var _404_1 = __webpack_require__(1820);
var ForgottenPassword_1 = __webpack_require__(634);
var Login_1 = __webpack_require__(152);
var Logout_1 = __webpack_require__(679);
var Orders_1 = __webpack_require__(302);
var Profile_1 = __webpack_require__(725);
var Registration_1 = __webpack_require__(287);
var VerifyEmail_1 = __webpack_require__(678);
var Browse_1 = __webpack_require__(61);
var Discover_1 = __webpack_require__(221);
var Cart_1 = __webpack_require__(224);
var Checkout_1 = __webpack_require__(290);
var CheckoutComplete_1 = __webpack_require__(652);
var Collection_1 = __webpack_require__(646);
var FAQ_1 = __webpack_require__(277);
var Success_1 = __webpack_require__(1825);
var Projects_1 = __webpack_require__(319);
var SharedProject_1 = __webpack_require__(726);
var Section_1 = __webpack_require__(598);
var App_1 = __webpack_require__(1853);
var ArtistPage_1 = __webpack_require__(1936);
var ResultsPage_1 = __webpack_require__(1937);
var TrackPage_1 = __webpack_require__(1997);
// tslint:disable-next-line:prefer-const
var routeConfig = found_1.makeRouteConfig(React.createElement(found_1.Route, { path: "/" }, React.createElement(found_1.Route, { path: "login", title: "Log In to Bopper", Component: Login_1.default, query: login_1.LoginPageQuery }), React.createElement(found_1.Route, { path: "signup", title: "Sign Up for Bopper", Component: Login_1.default, query: login_1.LoginPageQuery, render: router_1.renderLoadableRoute({ extraProps: { action: 'signup' } }) }), React.createElement(found_1.Route, { path: "logout", title: "Logging you out...", Component: Logout_1.default, query: logout_1.LogoutPageQuery }), React.createElement(found_1.Route, { Component: App_1.default, query: app_1.AppRootQuery }, React.createElement(found_1.Redirect, { from: "/", to: '/browse' + location.search }), React.createElement(found_1.Redirect, { from: "/discover", to: '/browse' + location.search }), React.createElement(found_1.Route, { key: "discover-route", path: "discover", Component: Discover_1.default, query: emptyState_1.EmptyStateQuery, prepareVariables: router_1.prepareVariablesForDiscoverPage, render: router_1.renderLoadableRoute({ extraProps: { withCarousel: true } }) }), React.createElement(found_1.Route, { path: "browse", Component: Browse_1.default }, ResultsPage_1.ResultsPageRoute), ArtistPage_1.ArtistPageRoute, TrackPage_1.TrackPageRoute, React.createElement(found_1.Route, { path: "collection/:slug", Component: Collection_1.default, query: collection_1.CollectionPageQuery, prepareVariables: router_1.prepareVariablesForCollectionPage, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: "my", Component: Section_1.default }, React.createElement(found_1.Route, { path: "profile", Component: Profile_1.default, query: profile_1.AccountPageQuery, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: "playlists" }, React.createElement(found_1.Route, { Component: Projects_1.default, query: project_1.ProjectsQuery, prepareVariables: router_1.prepareVariablesForProjectsPage, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: ":id", Component: Projects_1.default, query: project_1.ProjectsQuery, prepareVariables: router_1.prepareVariablesForProjectsPage })), React.createElement(found_1.Route, { path: "projects" }, React.createElement(found_1.Route, { Component: Projects_1.default, query: project_1.ProjectsQuery, prepareVariables: router_1.prepareVariablesForProjectsPage, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: ":id", Component: Projects_1.default, query: project_1.ProjectsQuery, prepareVariables: router_1.prepareVariablesForProjectsPage })), React.createElement(found_1.Route, { path: "orders" }, React.createElement(found_1.Route, { Component: Orders_1.default, query: order_1.OrdersQuery, prepareVariables: router_1.prepareVariablesForOrdersPage, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: ":invoice_number", Component: Orders_1.default, query: order_1.OrdersQuery, prepareVariables: router_1.prepareVariablesForOrdersPage })), React.createElement(found_1.Route, { path: "cart", title: "Cart", Component: Cart_1.default, query: cart_1.CartPageQuery, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: "checkout/complete", title: "Checkout Complete", Component: CheckoutComplete_1.default }), React.createElement(found_1.Route, { path: "checkout", title: "Checkout", Component: Checkout_1.default, query: checkout_1.CheckoutPageQuery, render: router_1.renderLoadableRoute() })), React.createElement(found_1.Route, { path: "/playlist/:opaque_id" }, React.createElement(found_1.Route, { Component: SharedProject_1.default, query: project_1.SharedProjectPageQuery, render: router_1.renderLoadableRoute() })), React.createElement(found_1.Route, { path: "/project/:opaque_id" }, React.createElement(found_1.Route, { Component: SharedProject_1.default, query: project_1.SharedProjectPageQuery, render: router_1.renderLoadableRoute() })), React.createElement(found_1.Route, { path: "/help", Component: Section_1.default }, React.createElement(found_1.Route, { path: "faq/:id", title: "FAQ Category", Component: FAQ_1.default }), React.createElement(found_1.Route, { path: "faq", title: "FAQ", Component: FAQ_1.default })), React.createElement(found_1.Route, { path: "registration", title: "Complete your registration", Component: Registration_1.default, query: profile_1.AccountPageQuery }), React.createElement(found_1.Route, { path: "forgotten-password", title: "Forgot your password?", Component: ForgottenPassword_1.default }), React.createElement(found_1.Route, { path: "verify", title: "Verifying your email...", Component: VerifyEmail_1.default }), React.createElement(found_1.Route, { path: "newsletter/success", Component: Success_1.default, query: emptyState_1.EmptyStateQuery, render: router_1.renderLoadableRoute() }), React.createElement(found_1.Route, { path: "404", Component: _404_1.default }), React.createElement(found_1.Redirect, { from: "*", to: "/404" }))));
// if (process.env.NODE_ENV !== 'production') {
//   routeConfig = hotRouteConfig(routeConfig);
// }
exports.default = routeConfig;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 3801edba30fb6db3e2de5d8fc06e49b1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type app_viewer$ref = any;
export type app_QueryVariables = {| |};
export type app_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: app_viewer$ref,
  |},
|};
*/

/*
query app_Query {
  viewer {
    ...app_viewer
    id
  }
}

fragment app_viewer on Viewer {
  id
  authentication_info {
    user_pool_id
    client_id
    cognito_domain_url
  }
  business_information {
    ams {
      id
      name
      legal_name
      website
      logo
      emails {
        email
        type
      }
      phone_numbers {
        type
        phone_number
        is_toll_free
      }
      social_media {
        image
        facebook
        twitter
        instagram
        youtube
      }
      opening_hours
      address {
        id
        name
        company
        line_1
        line_2
        city
        postal_code
        subdivision_code
        subdivision_name
        country_code
        country_name
      }
      commercial_details {
        financial_institution {
          id
          name
          company
          line_1
          line_2
          city
          postal_code
          subdivision_code
          subdivision_name
          country_code
          country_name
        }
        bank_accounts {
          currency
          swift_code
          branch_id
          account_number
        }
        gst_number
        pst_number
      }
    }
  }
  cart {
    id
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    total
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
  latest_exchange_rates {
    id
    from_currency
    to_currency
    rate
    rate_date
  }
  license_components {
    media(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    spot_counts(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    terms(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    broadcast_territories(first: 300) {
      edges {
        node {
          internal_id
          display_order
          name
          is_region
          id
        }
      }
    }
    producer_locations(first: 300) {
      edges {
        node {
          internal_id
          display_order
          name
          is_user_location
          id
        }
      }
    }
    audience_sizes(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    production_budgets(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    episode_budgets(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    id
  }
  projects(first: 100, scope: CurrentUser) {
    edges {
      node {
        id
        is_public
        name
        notes
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        owner {
          id
          first_name
          last_name
          user_id
        }
        users {
          id
          first_name
          last_name
          user_id
          role
        }
        license_params {
          spot_count
          term
          medium
          contextual_param
          contextual_param_type
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  taxonomies(first: 10000000) {
    edges {
      node {
        id
        internal_id
        name
        terms {
          id
          internal_id
          parent_id
          name
          children {
            edges {
              node {
                id
                internal_id
                parent_id
                name
              }
            }
          }
        }
      }
    }
  }
  tempos {
    edges {
      node {
        id
        name
        value
      }
    }
  }
  ...selectedCurrency_viewer
  ...header_viewer
}

fragment selectedCurrency_viewer on Viewer {
  selected_currency
}

fragment header_viewer on Viewer {
  home_page {
    header_posts {
      title
      subtitle
      post_url
      image_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  },
      v1 = [v0],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "display_order",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v6 = [v2, v3, v4, v5],
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 300,
    "type": "Int"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v10 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, v5, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, v4, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_name",
    "args": null,
    "storageKey": null
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v9, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "parent_id",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v18 = [v4, v5],
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "app_Query",
    "id": null,
    "text": "query app_Query {\n  viewer {\n    ...app_viewer\n    id\n  }\n}\n\nfragment app_viewer on Viewer {\n  id\n  authentication_info {\n    user_pool_id\n    client_id\n    cognito_domain_url\n  }\n  business_information {\n    ams {\n      id\n      name\n      legal_name\n      website\n      logo\n      emails {\n        email\n        type\n      }\n      phone_numbers {\n        type\n        phone_number\n        is_toll_free\n      }\n      social_media {\n        image\n        facebook\n        twitter\n        instagram\n        youtube\n      }\n      opening_hours\n      address {\n        id\n        name\n        company\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        subdivision_name\n        country_code\n        country_name\n      }\n      commercial_details {\n        financial_institution {\n          id\n          name\n          company\n          line_1\n          line_2\n          city\n          postal_code\n          subdivision_code\n          subdivision_name\n          country_code\n          country_name\n        }\n        bank_accounts {\n          currency\n          swift_code\n          branch_id\n          account_number\n        }\n        gst_number\n        pst_number\n      }\n    }\n  }\n  cart {\n    id\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    total\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n  latest_exchange_rates {\n    id\n    from_currency\n    to_currency\n    rate\n    rate_date\n  }\n  license_components {\n    media(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    spot_counts(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    terms(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    broadcast_territories(first: 300) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          is_region\n          id\n        }\n      }\n    }\n    producer_locations(first: 300) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          is_user_location\n          id\n        }\n      }\n    }\n    audience_sizes(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    production_budgets(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    episode_budgets(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    id\n  }\n  projects(first: 100, scope: CurrentUser) {\n    edges {\n      node {\n        id\n        is_public\n        name\n        notes\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        owner {\n          id\n          first_name\n          last_name\n          user_id\n        }\n        users {\n          id\n          first_name\n          last_name\n          user_id\n          role\n        }\n        license_params {\n          spot_count\n          term\n          medium\n          contextual_param\n          contextual_param_type\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  taxonomies(first: 10000000) {\n    edges {\n      node {\n        id\n        internal_id\n        name\n        terms {\n          id\n          internal_id\n          parent_id\n          name\n          children {\n            edges {\n              node {\n                id\n                internal_id\n                parent_id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  tempos {\n    edges {\n      node {\n        id\n        name\n        value\n      }\n    }\n  }\n  ...selectedCurrency_viewer\n  ...header_viewer\n}\n\nfragment selectedCurrency_viewer on Viewer {\n  selected_currency\n}\n\nfragment header_viewer on Viewer {\n  home_page {\n    header_posts {\n      title\n      subtitle\n      post_url\n      image_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "app_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "app_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "app_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "license_components",
          "storageKey": null,
          "args": null,
          "concreteType": "LicenseComponents",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "media",
            "storageKey": "media(first:100)",
            "args": v1,
            "concreteType": "MediumConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MediumEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Medium",
                "plural": false,
                "selections": v6
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "spot_counts",
            "storageKey": "spot_counts(first:100)",
            "args": v1,
            "concreteType": "SpotCountConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SpotCountEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "SpotCount",
                "plural": false,
                "selections": v6
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": "terms(first:100)",
            "args": v1,
            "concreteType": "TermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Term",
                "plural": false,
                "selections": v6
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "broadcast_territories",
            "storageKey": "broadcast_territories(first:300)",
            "args": v7,
            "concreteType": "BroadcastTerritoryConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "BroadcastTerritoryEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "BroadcastTerritory",
                "plural": false,
                "selections": [v2, v3, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_region",
                  "args": null,
                  "storageKey": null
                }, v5]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "producer_locations",
            "storageKey": "producer_locations(first:300)",
            "args": v7,
            "concreteType": "ProducerLocationConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProducerLocationEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ProducerLocation",
                "plural": false,
                "selections": [v2, v3, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_user_location",
                  "args": null,
                  "storageKey": null
                }, v5]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "audience_sizes",
            "storageKey": "audience_sizes(first:100)",
            "args": v1,
            "concreteType": "AudienceSizeConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "AudienceSizeEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AudienceSize",
                "plural": false,
                "selections": v6
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "production_budgets",
            "storageKey": "production_budgets(first:100)",
            "args": v1,
            "concreteType": "ProductionBudgetConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProductionBudgetEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ProductionBudget",
                "plural": false,
                "selections": v6
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "episode_budgets",
            "storageKey": "episode_budgets(first:100)",
            "args": v1,
            "concreteType": "EpisodeBudgetConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EpisodeBudgetEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EpisodeBudget",
                "plural": false,
                "selections": v6
              }]
            }]
          }, v5]
        }, v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "business_information",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessInformationDirectory",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "ams",
            "storageKey": null,
            "args": null,
            "concreteType": "BusinessInformation",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "emails",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessEmail",
              "plural": true,
              "selections": [v8, v9]
            }, v5, {
              "kind": "ScalarField",
              "alias": null,
              "name": "legal_name",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "website",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo",
              "args": null,
              "storageKey": null
            }, v4, {
              "kind": "LinkedField",
              "alias": null,
              "name": "phone_numbers",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessPhoneNumber",
              "plural": true,
              "selections": [v9, {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone_number",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_toll_free",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "social_media",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessSocialMedia",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "image",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "facebook",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "twitter",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "instagram",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "youtube",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "opening_hours",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "address",
              "storageKey": null,
              "args": null,
              "concreteType": "Address",
              "plural": false,
              "selections": v10
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "commercial_details",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessCommercialDetails",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "financial_institution",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v10
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "bank_accounts",
                "storageKey": null,
                "args": null,
                "concreteType": "BusinessBankAccount",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "swift_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "branch_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "account_number",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "gst_number",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "pst_number",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "cart",
          "storageKey": null,
          "args": null,
          "concreteType": "Cart",
          "plural": false,
          "selections": [v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseLineItem",
            "plural": true,
            "selections": [v5, {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_amount",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "track",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [v5, v2, v11, {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              }, v12, v13, {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [v5, v4, v12, v13]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [v5, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_highlighted",
                      "args": null,
                      "storageKey": null
                    }, v4, v14, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [v5, v2, v4]
                    }]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "license",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicense",
              "plural": false,
              "selections": [v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "usages",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicenseUsage",
                "plural": true,
                "selections": [v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "license_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "air_date",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "components",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsageComponent",
                  "plural": true,
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "component_id",
                    "args": null,
                    "storageKey": null
                  }, v4, v9]
                }]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "ga_account_goal_sent",
            "args": null,
            "storageKey": null
          }, v5, v8, {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_provider",
            "args": null,
            "storageKey": null
          }, v15, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_new_user",
            "args": null,
            "storageKey": null
          }, v16, v17, {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_size",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanySize",
            "plural": false,
            "selections": v18
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "industry",
            "storageKey": null,
            "args": null,
            "concreteType": "Industry",
            "plural": false,
            "selections": v18
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "job_type",
            "storageKey": null,
            "args": null,
            "concreteType": "JobType",
            "plural": false,
            "selections": v18
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "latest_exchange_rates",
          "storageKey": null,
          "args": null,
          "concreteType": "ExchangeRate",
          "plural": true,
          "selections": [v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "from_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "to_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "rate",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "rate_date",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "authentication_info",
          "storageKey": null,
          "args": null,
          "concreteType": "AuthenticationInfo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "user_pool_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "client_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "cognito_domain_url",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "projects",
          "storageKey": "projects(first:100,scope:\"CurrentUser\")",
          "args": [v0, {
            "kind": "Literal",
            "name": "scope",
            "value": "CurrentUser",
            "type": "QueryScopeEnumType!"
          }],
          "concreteType": "ProjectConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [v5, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_public",
                "args": null,
                "storageKey": null
              }, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "tracks",
                "storageKey": "tracks(first:100)",
                "args": v1,
                "concreteType": "ProjectTrackConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectTrackEdge",
                  "plural": true,
                  "selections": [v5, v19, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TrackSearchResult",
                    "plural": false,
                    "selections": [v20, v5]
                  }]
                }, v21]
              }, {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "tracks",
                "args": v1,
                "handle": "connection",
                "key": "project_tracks",
                "filters": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "owner",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectUser",
                "plural": false,
                "selections": [v5, v15, v17, v16]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "users",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectUser",
                "plural": true,
                "selections": [v5, v15, v17, v16, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "role",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "license_params",
                "storageKey": null,
                "args": null,
                "concreteType": "LicenseUsageParams",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "spot_count",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "term",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "medium",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contextual_param",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contextual_param_type",
                  "args": null,
                  "storageKey": null
                }]
              }, v20]
            }, v19]
          }, v21]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "projects",
          "args": [v0, {
            "kind": "Literal",
            "name": "scope",
            "value": "CurrentUser",
            "type": "QueryScopeEnumType!"
          }],
          "handle": "connection",
          "key": "list_projects",
          "filters": []
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "taxonomies",
          "storageKey": "taxonomies(first:10000000)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 10000000,
            "type": "Int"
          }],
          "concreteType": "TaxonomyConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": [v5, v2, v4, {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": true,
                "selections": [v5, v2, v14, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "children",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTerm",
                      "plural": false,
                      "selections": [v5, v2, v14, v4]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tempos",
          "storageKey": null,
          "args": null,
          "concreteType": "TempoConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TempoEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Tempo",
              "plural": false,
              "selections": [v5, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "value",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_currency",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "home_page",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePageContent",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "header_posts",
            "storageKey": null,
            "args": null,
            "concreteType": "HomePagePost",
            "plural": true,
            "selections": [v11, {
              "kind": "ScalarField",
              "alias": null,
              "name": "subtitle",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "post_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "image_url",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }
  };
}();
node /*: any*/.hash = 'c49d8c116c42c2d8f2ace8e018bf4aed';
module.exports = node;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type header_viewer$ref = any;
type selectedCurrency_viewer$ref = any;
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type app_viewer$ref: FragmentReference;
export type app_viewer = {|
  +id: string,
  +authentication_info: ?{|
    +user_pool_id: string,
    +client_id: string,
    +cognito_domain_url: string,
  |},
  +business_information: ?{|
    +ams: {|
      +id: string,
      +name: string,
      +legal_name: string,
      +website: string,
      +logo: ?string,
      +emails: ?$ReadOnlyArray<?{|
        +email: string,
        +type: string,
      |}>,
      +phone_numbers: ?$ReadOnlyArray<?{|
        +type: string,
        +phone_number: string,
        +is_toll_free: ?boolean,
      |}>,
      +social_media: ?{|
        +image: ?string,
        +facebook: ?string,
        +twitter: ?string,
        +instagram: ?string,
        +youtube: ?string,
      |},
      +opening_hours: ?string,
      +address: {|
        +id: string,
        +name: string,
        +company: ?string,
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +subdivision_name: ?string,
        +country_code: string,
        +country_name: ?string,
      |},
      +commercial_details: {|
        +financial_institution: {|
          +id: string,
          +name: string,
          +company: ?string,
          +line_1: string,
          +line_2: ?string,
          +city: string,
          +postal_code: string,
          +subdivision_code: string,
          +subdivision_name: ?string,
          +country_code: string,
          +country_name: ?string,
        |},
        +bank_accounts: ?$ReadOnlyArray<?{|
          +currency: ?Currency,
          +swift_code: string,
          +branch_id: string,
          +account_number: string,
        |}>,
        +gst_number: ?string,
        +pst_number: ?string,
      |},
    |},
  |},
  +cart: ?{|
    +id: string,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +total: ?number,
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +latest_exchange_rates: ?$ReadOnlyArray<?{|
    +id: string,
    +from_currency: string,
    +to_currency: string,
    +rate: number,
    +rate_date: any,
  |}>,
  +license_components: ?{|
    +media: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +spot_counts: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +terms: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +broadcast_territories: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
          +is_region: ?boolean,
        |},
      |}>,
    |},
    +producer_locations: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
          +is_user_location: ?boolean,
        |},
      |}>,
    |},
    +audience_sizes: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +production_budgets: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +episode_budgets: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
  |},
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +taxonomies: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +name: ?string,
        +terms: ?$ReadOnlyArray<?{|
          +id: string,
          +internal_id: ?number,
          +parent_id: ?string,
          +name: ?string,
          +children: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +internal_id: ?number,
                +parent_id: ?string,
                +name: ?string,
              |},
            |}>,
          |},
        |}>,
      |},
    |}>,
  |},
  +tempos: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +value: ?number,
      |},
    |}>,
  |},
  +$fragmentRefs: (selectedCurrency_viewer$ref & header_viewer$ref),
  +$refType: app_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = [{
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "display_order",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = [v1, v2, v3],
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 300,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  },
      v9 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  }, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  }, v3, {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_name",
    "args": null,
    "storageKey": null
  }],
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v6, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, v8, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "parent_id",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "user_id",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v16 = [v3],
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "app_viewer",
    "type": "Viewer",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["projects"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "license_components",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseComponents",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "media",
        "storageKey": "media(first:100)",
        "args": v0,
        "concreteType": "MediumConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "MediumEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Medium",
            "plural": false,
            "selections": v4
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "spot_counts",
        "storageKey": "spot_counts(first:100)",
        "args": v0,
        "concreteType": "SpotCountConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "SpotCountEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "SpotCount",
            "plural": false,
            "selections": v4
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "terms",
        "storageKey": "terms(first:100)",
        "args": v0,
        "concreteType": "TermConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TermEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Term",
            "plural": false,
            "selections": v4
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "broadcast_territories",
        "storageKey": "broadcast_territories(first:300)",
        "args": v5,
        "concreteType": "BroadcastTerritoryConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "BroadcastTerritoryEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "BroadcastTerritory",
            "plural": false,
            "selections": [v1, v2, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "is_region",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "producer_locations",
        "storageKey": "producer_locations(first:300)",
        "args": v5,
        "concreteType": "ProducerLocationConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProducerLocationEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ProducerLocation",
            "plural": false,
            "selections": [v1, v2, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "is_user_location",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "audience_sizes",
        "storageKey": "audience_sizes(first:100)",
        "args": v0,
        "concreteType": "AudienceSizeConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "AudienceSizeEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "AudienceSize",
            "plural": false,
            "selections": v4
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "production_budgets",
        "storageKey": "production_budgets(first:100)",
        "args": v0,
        "concreteType": "ProductionBudgetConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProductionBudgetEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductionBudget",
            "plural": false,
            "selections": v4
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "episode_budgets",
        "storageKey": "episode_budgets(first:100)",
        "args": v0,
        "concreteType": "EpisodeBudgetConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "EpisodeBudgetEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "EpisodeBudget",
            "plural": false,
            "selections": v4
          }]
        }]
      }]
    }, v6, {
      "kind": "LinkedField",
      "alias": null,
      "name": "business_information",
      "storageKey": null,
      "args": null,
      "concreteType": "BusinessInformationDirectory",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "ams",
        "storageKey": null,
        "args": null,
        "concreteType": "BusinessInformation",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "emails",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessEmail",
          "plural": true,
          "selections": [v7, v8]
        }, v6, {
          "kind": "ScalarField",
          "alias": null,
          "name": "legal_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "website",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "logo",
          "args": null,
          "storageKey": null
        }, v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "phone_numbers",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessPhoneNumber",
          "plural": true,
          "selections": [v8, {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone_number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_toll_free",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "social_media",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessSocialMedia",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "image",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtube",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "opening_hours",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "address",
          "storageKey": null,
          "args": null,
          "concreteType": "Address",
          "plural": false,
          "selections": v9
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "commercial_details",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessCommercialDetails",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "financial_institution",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": v9
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "bank_accounts",
            "storageKey": null,
            "args": null,
            "concreteType": "BusinessBankAccount",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "currency",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "swift_code",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "branch_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "account_number",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "gst_number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pst_number",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [v6, {
        "kind": "LinkedField",
        "alias": null,
        "name": "license_line_items",
        "storageKey": null,
        "args": null,
        "concreteType": "LicenseLineItem",
        "plural": true,
        "selections": [v6, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [v6, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          }, v10, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v6, v3, v10, v11]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTerm",
                "plural": false,
                "selections": [v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_highlighted",
                  "args": null,
                  "storageKey": null
                }, v3, v12, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "taxonomy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Taxonomy",
                  "plural": false,
                  "selections": [v6, v1, v3]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [v6, {
            "kind": "LinkedField",
            "alias": null,
            "name": "usages",
            "storageKey": null,
            "args": null,
            "concreteType": "StandardLicenseUsage",
            "plural": true,
            "selections": [v6, {
              "kind": "ScalarField",
              "alias": null,
              "name": "license_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "air_date",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "components",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsageComponent",
              "plural": true,
              "selections": [v6, {
                "kind": "ScalarField",
                "alias": null,
                "name": "component_id",
                "args": null,
                "storageKey": null
              }, v3, v8]
            }]
          }]
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "ga_account_goal_sent",
        "args": null,
        "storageKey": null
      }, v6, v7, {
        "kind": "ScalarField",
        "alias": null,
        "name": "external_provider",
        "args": null,
        "storageKey": null
      }, v13, {
        "kind": "ScalarField",
        "alias": null,
        "name": "is_new_user",
        "args": null,
        "storageKey": null
      }, v14, v15, {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "company_size",
        "storageKey": null,
        "args": null,
        "concreteType": "CompanySize",
        "plural": false,
        "selections": v16
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "industry",
        "storageKey": null,
        "args": null,
        "concreteType": "Industry",
        "plural": false,
        "selections": v16
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "job_type",
        "storageKey": null,
        "args": null,
        "concreteType": "JobType",
        "plural": false,
        "selections": v16
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "latest_exchange_rates",
      "storageKey": null,
      "args": null,
      "concreteType": "ExchangeRate",
      "plural": true,
      "selections": [v6, {
        "kind": "ScalarField",
        "alias": null,
        "name": "from_currency",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "to_currency",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "rate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "rate_date",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "authentication_info",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthenticationInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "user_pool_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "client_id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "cognito_domain_url",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "projects",
      "name": "__list_projects_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Project",
          "plural": false,
          "selections": [v6, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_public",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "tracks",
            "name": "__project_tracks_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectTrackConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProjectTrackEdge",
              "plural": true,
              "selections": [v6, v17, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [v18]
              }]
            }, v19]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "owner",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": false,
            "selections": [v6, v13, v15, v14]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "users",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": true,
            "selections": [v6, v13, v15, v14, {
              "kind": "ScalarField",
              "alias": null,
              "name": "role",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_params",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseUsageParams",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "spot_count",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "term",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "medium",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "contextual_param_type",
              "args": null,
              "storageKey": null
            }]
          }, v18]
        }, v17]
      }, v19]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "taxonomies",
      "storageKey": "taxonomies(first:10000000)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 10000000,
        "type": "Int"
      }],
      "concreteType": "TaxonomyConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Taxonomy",
          "plural": false,
          "selections": [v6, v1, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTerm",
            "plural": true,
            "selections": [v6, v1, v12, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "children",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTerm",
                  "plural": false,
                  "selections": [v6, v1, v12, v3]
                }]
              }]
            }]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "tempos",
      "storageKey": null,
      "args": null,
      "concreteType": "TempoConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TempoEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Tempo",
          "plural": false,
          "selections": [v6, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "selectedCurrency_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "header_viewer",
      "args": null
    }]
  };
}();
node /*: any*/.hash = '45fedc39dabf74af04411ef480a81940';
module.exports = node;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NotAvailable Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
__webpack_require__(1821);
var Page_1 = __webpack_require__(38);
var PageNotFound = function PageNotFound() {
  return React.createElement(Page_1.default, { id: "404" }, React.createElement("h2", null, "404 \u2014 Page Not Found"));
};
exports.default = PageNotFound;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1822);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--404 .page__main{min-height:calc(100vh - 64px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-bottom:32px}.page--404 h2{background-color:#000;color:#fff;font-weight:300;padding:10px 20px 12px;display:inline-block;margin:0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/404/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,uBAvCE,8BAAyE,oBA0CvE,oBAAA,aAAa,mBACb,cAAA,UAAU,yBACV,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,mBC/EsB,CDyEjD,cAUI,sBAAuB,WACX,gBACI,uBACO,qBACF,QACZ,CACV","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * PageNotFound Component\n */\n\n.page--404{\n  .page__main {\n    @include page-is-at-least-full-height(-$page-header-height);\n    display: flex;\n    flex: auto;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: baseline(4);\n  }\n  h2 {\n    background-color: black;\n    color: white;\n    font-weight: 300;\n    padding: 10px 20px 12px;\n    display: inline-block;\n    margin: 0;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1824);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--profile .page__main{flex-direction:column}.page--profile .page__main,.profile__content-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column}.profile__content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;-webkit-box-flex:1;-ms-flex:auto;flex:auto}html.touchevents .profile__content-wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .profile__content-wrapper{overflow-x:hidden;overflow-y:auto}.profile__content{background-color:#fff;-webkit-box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);box-shadow:0 30px 60px 0 hsla(220,7%,57%,.25);margin:56px auto;-webkit-box-flex:1;-ms-flex:auto;flex:auto;width:90%;max-width:960px}.profile__info__line{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:96px;border-bottom:1px solid #e4e8ed;padding:0 64px}.profile__info__title{-webkit-box-flex:1;-ms-flex:1;flex:1}.profile__info__data{-webkit-box-flex:3;-ms-flex:3;flex:3}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/account/Profile/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,2BAEI,qBAAsB,CACvB,qDADC,4BAAA,6BAAA,yBAAsB,CAKxB,0BAEE,oBAAA,oBAAA,aAAa,sBACS,mBACtB,cAAA,SAAU,CACX,2CC3GC,kBAAgD,kBACT,gCACN,CAClC,8CAEC,kBAAgD,eACX,CDuGvC,kBEjDE,sBAvCU,sDC7B6C,8CHwHvD,iBAAwB,mBACxB,cAAA,UAAU,UACA,eC5FmC,CD8F9C,qBAIG,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,YAEnB,gCACA,cCtG2C,CDwG5C,sBAEC,mBAAA,WAAA,MAAO,CACR,qBAGC,mBAAA,WAAA,MAAO,CACR","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProfilePage Component\n */\n\n.page--profile{\n  .page__main{\n    flex-direction: column;\n  }\n}\n\n.profile{\n  &__content-wrapper{\n    @include scroll;\n    display: flex;\n    flex-direction: column;\n    flex: auto;\n  }\n\n  &__content{\n    @include bgcolor(white);\n    @include shadow(large);\n    margin: baseline(7) auto;\n    flex: auto;\n    width: 90%;\n    max-width: baseline(120);\n  }\n\n  &__info{\n    &__line{\n      display: flex;\n      align-items: center;\n      height: baseline(12);\n      border-bottom: 1px solid uicolor(border);\n      padding: 0 baseline(8);\n\n    }\n    &__title{\n      flex: 1;\n    }\n\n    &__data{\n      flex: 3;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NewsletterSuccessPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(42);
var player_2 = __webpack_require__(63);
var emptyState_1 = __webpack_require__(305);
__webpack_require__(1826);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
var Page_1 = __webpack_require__(38);
var LinkButton_1 = __webpack_require__(51);
var Heading_1 = __webpack_require__(9);
var BlogPosts_1 = __webpack_require__(662);
var Charts_1 = __webpack_require__(663);
var Collections_1 = __webpack_require__(227);
var FeaturedArtists_1 = __webpack_require__(433);
var StaffPicks_1 = __webpack_require__(435);
var Browse_1 = __webpack_require__(61);
exports.NewsletterSuccessPagePath = '/email/reconfirm';
var classes = new BEM('newsletter-success');
var defaultList = [];

var NewsletterSuccessPage = function (_React$Component) {
    _inherits(NewsletterSuccessPage, _React$Component);

    function NewsletterSuccessPage() {
        _classCallCheck(this, NewsletterSuccessPage);

        return _possibleConstructorReturn(this, (NewsletterSuccessPage.__proto__ || Object.getPrototypeOf(NewsletterSuccessPage)).apply(this, arguments));
    }

    _createClass(NewsletterSuccessPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var data = this.props.viewer.home_page;
            var allTracks = [].concat(_toConsumableArray(data.featured_artist_tracks || defaultList), _toConsumableArray(data.featured_tracks || defaultList));
            this.props.setPlayerQueue(player_2.getPlayerTracksFromResults(allTracks));
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.viewer.home_page;
            var staffPicks = data.featured_tracks || defaultList;
            var featuredArtists = data.featured_artist_tracks || defaultList;
            var featuredCollections = data.featured_collections || defaultList;
            var charts = data.track_charts || defaultList;
            var blogPosts = data.blog_posts || defaultList;
            return React.createElement(Page_1.default, { id: "newsletter-success", layout: "loose" }, React.createElement(react_helmet_1.Helmet, null, React.createElement("title", null, "Thanks For Signing Up!"), React.createElement("meta", { name: "description", content: "Helmet application" })), React.createElement("div", { className: "page__main" }, React.createElement("div", Object.assign({}, classes('message')), React.createElement("div", Object.assign({}, classes('message__content-wrapper')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: { animation: 'transition.slideUpIn', stagger: 150 }, runOnMount: true }, classes('message__content')), React.createElement(Heading_1.default, { is: "h6" }, "Great Stuff!"), React.createElement(Heading_1.default, Object.assign({ is: "h2" }, classes('message__title')), "Did you know we\u2019ve redesigned our instant licensing app?"), React.createElement(LinkButton_1.default, Object.assign({ to: Browse_1.BrowsePagePath, label: "Browse Music", size: "xlarge", colorScheme: "accent", variant: "pill" }, classes('message__cta')))))), React.createElement(StaffPicks_1.default, { tracks: staffPicks, withBackground: true }), React.createElement(FeaturedArtists_1.default, { data: featuredArtists }), React.createElement(BlogPosts_1.default, { data: blogPosts }), React.createElement(Collections_1.default, { data: featuredCollections }), React.createElement(Charts_1.default, { data: charts })));
        }
    }]);

    return NewsletterSuccessPage;
}(React.Component);

var ConnectedNewsletterSuccessPage = react_redux_1.connect(null, function (dispatch) {
    return {
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(player_1.replaceQueue({ tracks: tracks }));
        }
    };
})(NewsletterSuccessPage);
var RelayNewsletterSuccessPage = react_relay_1.createFragmentContainer(ConnectedNewsletterSuccessPage, emptyState_1.EmptyStateFragment);
exports.default = RelayNewsletterSuccessPage;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1827);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page--newsletter-success .page__main{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:40px 0}.page--newsletter-success .page__main>*{-ms-flex-negative:0;flex-shrink:0}.page--newsletter-success .container{margin-right:auto;margin-left:auto;padding-right:3.33333333%;padding-left:3.33333333%;max-width:1920px}.page--newsletter-success .featured-artist-list{margin-top:96px}.page--newsletter-success .charts,.page--newsletter-success .scrollable-section--blog-posts{margin-top:64px}.newsletter-success__message{margin-top:-40px;margin-bottom:32px}.newsletter-success__message__content{background-color:#fff;text-align:center;padding:144px 80px 80px;background-image:-webkit-gradient(linear,left bottom,left top,from(#f0f6fa),color-stop(60%,rgba(240,246,250,0)));background-image:-webkit-linear-gradient(bottom,#f0f6fa,rgba(240,246,250,0) 60%);background-image:-o-linear-gradient(bottom,#f0f6fa 0,rgba(240,246,250,0) 60%);background-image:linear-gradient(0deg,#f0f6fa 0,rgba(240,246,250,0) 60%)}.newsletter-success__message__title{margin:28px auto 36px}.newsletter-success__message__cta{-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/newsletter/Success/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,sCAEI,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,0BACtB,uBAAA,oBAAoB,cACE,CAL1B,wCAQY,oBAAA,aAAe,CAR3B,qCCnB0B,kBD+BG,iBAAA,0BACQ,yBAAA,gBEtFY,CFyEjD,gDAkBI,eE3F6C,CFyEjD,4FA0BI,eEnG6C,CFoG9C,6BAKC,iBACA,kBE1G6C,CF4G7C,sCGtEA,sBHwEE,kBAAkB,wBAElB,iHAAA,iFAAA,8EAAA,wEAA8G,CAC/G,oCAGC,qBEpH2C,CFqH5C,kCI/HC,sDApBqD,6CAAA,CJuJtD","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * NewsletterSuccessPage Component\n */\n\n.page--newsletter-success{\n  .page__main{\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: baseline(5) 0;\n\n    // Fix for Safari 9 (see https://github.com/philipwalton/flexbugs#flexbug-1)\n    & > * { flex-shrink: 0 }\n  }\n\n  .container{\n    @include margin(null auto);\n    @include padding(null 3.33333333%);\n    max-width: baseline(240);\n  }\n\n  .featured-artist-list{\n    margin-top: baseline(12);\n  }\n\n  .scrollable-section--blog-posts{\n    margin-top: baseline(8);\n  }\n\n  .charts{\n    margin-top: baseline(8);\n  }\n}\n\n.newsletter-success{\n  &__message{\n    margin-top: baseline(-5);\n    margin-bottom: baseline(4);\n\n    &__content{\n      @include bgcolor(white);\n      text-align: center;\n      padding: baseline(18) baseline(10) baseline(10);\n      background-image: linear-gradient(to top, transparentize(color(bw3), 0) 0%, transparentize(color(bw3), 1) 60%);\n    }\n\n    &__title{\n      margin: baseline(3.5) auto baseline(4.5);\n    }\n\n    &__cta{\n      @include shadow(medium);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1829);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".projects__header{position:fixed;top:64px;right:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:0;z-index:2}.projects__header__sidebar{padding-right:32px;padding-left:16px;-ms-flex-preferred-size:25%;flex-basis:25%;min-width:320px}.projects__header__project{padding-left:16px;-webkit-box-flex:1;-ms-flex:auto;flex:auto;-ms-flex-item-align:stretch;align-self:stretch}.projects__header__project,.projects__header__project__actions{padding-right:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.projects__header__project__actions{position:fixed;top:64px;right:0;background-color:#fff;height:56px}.projects__header__project__actions:before{content:\"\";background-image:-webkit-gradient(linear,right top,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(right,#fff,hsla(0,0%,100%,0));background-image:linear-gradient(270deg,#fff,hsla(0,0%,100%,0));position:absolute;top:0;bottom:0;left:-48px;width:48px}@media screen and (min-width:1024px){.projects__header__project{padding-left:48px}}.projects__header .button[disabled]{background:none}.projects__project-settings-button{border-radius:0}.projects__project-settings-button--open{color:#8a8f99}.projects__license{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:auto;flex:auto;white-space:nowrap}.projects__license__string{padding-right:24px}html.touchevents .projects__license__string{overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .projects__license__string{overflow-y:hidden;overflow-x:auto}.projects__loading-progress{position:fixed;top:120px}.projects__error-message{position:absolute;top:calc(50% - 60px);-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);text-align:center}.projects__error-message--no-project{left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.projects__error-message:not(.projects__error-message--no-project){width:75%;max-width:calc(100% - 320px);margin-left:auto;right:0}.projects__form{min-height:calc(100vh - 120px);display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden}.projects__form .project-list__wrapper{position:fixed;top:120px;bottom:0;left:0;width:25%;min-width:320px}.app-wrapper[data-player-visibility=true] .projects__form .project-list__wrapper{bottom:56px}.app-wrapper[data-player-term-list-visibility=true] .projects__form .project-list__wrapper{bottom:136px}.projects__form .project-view{width:75%;max-width:calc(100% - 320px);margin-left:auto;-webkit-transition:.25s ease-in-out;-o-transition:.25s ease-in-out;transition:.25s ease-in-out;max-width:960px;margin-left:320px;padding-top:16px;padding-left:16px;padding-right:32px}.page.settings-open .projects__form .project-view{width:50%;margin-right:25%}@media screen and (min-width:1152px){.projects__form .project-view{margin-left:25%}.page.settings-open .projects__form .project-view{width:50%;margin-right:25%}}.projects__form .project-settings{position:fixed;top:120px;right:0;bottom:0;width:25%;min-width:25%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AAmHE,kBCzEA,eD0EyB,SCtErB,QDsE2C,OAAO,oBACpD,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,eACJ,SAIL,CAEV,2BEpCsB,mBCtDuB,kBH4F3C,4BAhBoB,eAAA,eG5EuB,CH8F5C,2BEnCqB,kBFuCpB,mBAAA,cAAA,UAAU,4BACV,kBAAmB,CAInB,+DEjDoB,mBF8CpB,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAEnB,oCChGJ,eDiG6B,SC7FzB,QD6F+C,sBAI7C,WG5GyC,CHuG1C,2CASG,WAAW,8FACX,uEAAA,kEAAA,gEAA6G,kBACnF,MAAG,SAAO,WACpC,UGnHuC,CHoHxC,qCApBL,2BAwBI,iBGxHyC,CH0H5C,CA1CF,oCA6CG,eAAgB,CACjB,mCAID,eAAgB,CAChB,yCIrFA,aA3EoB,CJmKnB,mBAID,oBAAA,oBAAA,aAAa,4BACb,mBAAmB,yBACnB,sBAAA,mBAAmB,mBACnB,cAAA,UAAU,kBACS,CAEnB,2BAEE,kBGlJ2C,CHmJ5C,4CGzKD,kBAAgD,kBACT,gCACN,CAClC,+CAEC,kBAAgD,eACX,CHsKvC,4BACE,eAAe,SAzIsD,CA2ItE,yBClJD,kBDqJ4B,qBAA+C,mCACzE,+BAAA,2BAA2B,iBACT,CAElB,qCACE,SAAS,uCACT,mCAAA,8BAAgC,CAPnC,mEA9GD,UAA0B,6BACiB,iBAC1B,OAuHL,CACT,gBArIH,+BAAyE,oBA0IvE,oBAAA,aAAa,eACG,CAHjB,uCCnKD,eD+BuB,UAxBgD,SAwBX,OAAE,UAG9D,eGzC+C,CHwB/C,iFACE,WAAwC,CACzC,2FAGC,YAAuD,CACxD,8BAeD,UAA0B,6BACiB,iBAC1B,oCAsIb,+BAAA,4BAA4B,gBAE5B,kBACA,iBACA,kBACA,kBG1L2C,CH4L3C,kDACE,UAA2D,gBAjHzC,CAmHnB,qCArBJ,8BAwBK,eAtHkB,CAuHlB,kDACE,UAA2D,gBAxH3C,CA0HjB,CA5BN,kCCnKD,eDoM2B,UA7L4C,QA6LZ,SAAE,UA/HrC,aAAA,CAkIrB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectsPage Component\n */\n\n.projects{\n  $header-bgcolor: white;\n  $project-list-min-width: baseline(40);\n  $project-list-width: 25%;\n  $project-settings-min-width: $project-list-width;\n  $project-settings-width: $project-list-width;\n\n  &__header{\n    @include position(fixed, $app-header-height 0 null 0);\n    display: flex;\n    align-items: center;\n    padding-left: 0;\n    // FIXME: This z-index value gets mysteriously overriden upon\n    // rendering the page and thus has no effect. An inline z-index value\n    // for this header is defined in JSX code.\n    z-index: 2;\n\n    &__sidebar{\n      @include padding(null baseline(4) null baseline(2));\n      flex-basis: $project-list-width;\n      min-width: $project-list-min-width;\n    }\n\n    &__project{\n      @include padding(null baseline(2) null baseline(2));\n      flex: auto;\n      align-self: stretch;\n      display: flex;\n      align-items: center;\n\n      &__actions{\n        @include position(fixed, $app-header-height 0 null null);\n        @include bgcolor($header-bgcolor);\n        display: flex;\n        align-items: center;\n        height: $page-header-height;\n        padding-right: baseline(2);\n\n        &::before{\n          content: \"\";\n          background-image: linear-gradient(to left, color($header-bgcolor), transparentize(color($header-bgcolor), 1));\n          @include position(absolute, 0 null 0 baseline(-6));\n          width: baseline(6);\n        }\n      }\n\n      @include media(breakpoint(desktop)) {\n        padding-left: baseline(6);\n      }\n    }\n\n    .button[disabled] {\n      background: none;\n    }\n  }\n\n  &__project-settings-button{\n    border-radius: 0;\n    &--open{\n      // @include bgcolor(bw3);\n      @include textcolor(bw7);\n    }\n  }\n\n  &__license{\n    display: flex;\n    align-self: stretch;\n    align-items: center;\n    flex: auto;\n    white-space: nowrap;\n\n    &__string{\n      @include scroll(x);\n      padding-right: baseline(3);\n    }\n  }\n\n  &__loading-progress{\n    position: fixed;\n    top: $page-with-header-margin-top;\n  }\n\n  &__error-message{\n    @include position(absolute, calc(50% - #{$page-with-header-margin-top/2}) null null null);\n    transform: translateY(-50%);\n    text-align: center;\n\n    &--no-project{\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n    &:not(&--no-project) {\n      @include page-with-aside-content($project-list-width, $project-list-min-width);\n      right: 0;\n    }\n  }\n\n  &__form{\n    @include page-is-at-least-full-height;\n    display: flex;\n    overflow: hidden;\n\n    .project-list__wrapper{\n      @include page-aside($project-list-width, $project-list-min-width);\n    }\n\n    .project-view{\n      @include page-with-aside-content($project-list-width, $project-list-min-width);\n      transition: .25s ease-in-out;\n      max-width: baseline(120);\n      margin-left: $project-list-min-width;\n      padding-top: baseline(2);\n      padding-left: baseline(2);\n      padding-right: baseline(4);\n\n      .page.settings-open & {\n        width: 100% - $project-list-width - $project-settings-width;\n        margin-right: $project-settings-min-width;\n      }\n\n      @include media(breakpoint(desktop-m)) {\n        margin-left: $project-list-width;\n        .page.settings-open & {\n          width: 100% - $project-list-width - $project-settings-width;\n          margin-right: $project-settings-min-width;\n        }\n      }\n    }\n\n    .project-settings{\n      @include position(fixed, $page-with-header-margin-top 0 0 null);\n      width: $project-settings-width;\n      min-width: $project-settings-min-width;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CreateProjectForm Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = __webpack_require__(53);
var projects_1 = __webpack_require__(130);
var form_1 = __webpack_require__(239);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);

var CreateProjectForm = function (_React$Component) {
    _inherits(CreateProjectForm, _React$Component);

    function CreateProjectForm(props) {
        _classCallCheck(this, CreateProjectForm);

        var _this = _possibleConstructorReturn(this, (CreateProjectForm.__proto__ || Object.getPrototypeOf(CreateProjectForm)).call(this, props));

        _this.onCreateProject = function (name) {
            if (!name) {
                _this.setState({ hasError: true });
                return;
            }
            _this.props.dispatch(form_1.addProject());
            _this.props.onCreateProject();
            _this.props.dispatch(projects_1.requestCreateProject({
                input: { name: name },
                promise: {
                    resolve: function resolve() {
                        return null;
                    },
                    reject: function reject(error) {
                        _this.props.dispatch(notifications_1.pushNotification({
                            autoDismiss: false,
                            message: 'An error occured while creating the playlist. Please try again later.',
                            state: 'error'
                        }));
                    }
                }
            }));
        };
        _this.state = {};
        return _this;
    }

    _createClass(CreateProjectForm, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement(velocity_react_1.VelocityComponent, { animation: this.state.hasError ? 'callout.shake' : undefined, complete: function complete() {
                    return _this2.setState({ hasError: false });
                } }, React.createElement(redux_form_1.Field, { component: TextField_1.default, name: "createProject", placeholder: "New Playlist", icon: React.createElement(Icon_1.IconAddCircle, null), inlineButton: React.createElement(Button_1.default, { label: "Create", colorScheme: "dark", onClick: this.onCreateProject }), colorScheme: "light", size: "small", submitOnEnter: true, withoutBorder: true }));
        }
    }]);

    return CreateProjectForm;
}(React.Component);

var ConnectedCreateProjectForm = react_redux_1.connect(null)(CreateProjectForm);
exports.default = ConnectedCreateProjectForm;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var animation_1 = __webpack_require__(173);
var form_1 = __webpack_require__(239);
__webpack_require__(1832);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var velocity_react_1 = __webpack_require__(19);
var ProjectButton_1 = __webpack_require__(1834);
var ProjectListAnimation = animation_1.ListItemAnimations(128);
var classes = new BEM('project-list');

var ProjectList = function (_React$Component) {
    _inherits(ProjectList, _React$Component);

    function ProjectList() {
        _classCallCheck(this, ProjectList);

        var _this = _possibleConstructorReturn(this, (ProjectList.__proto__ || Object.getPrototypeOf(ProjectList)).apply(this, arguments));

        _this.onDelete = function (id) {
            var index = _this.props.projectList.findIndex(function (_ref) {
                var projectId = _ref.id;
                return projectId === id;
            });
            _this.props.dispatch(form_1.removeProject(index));
            _this.props.onDeleteProject(id);
            nextTick(function () {
                return _this.props.dispatch(form_1.submitForm());
            });
        };
        _this.onShareProject = function () {
            _this.props.dispatch(form_1.shareProject());
            nextTick(function () {
                _this.props.dispatch(form_1.submitForm());
            });
        };
        _this.renderProjectButtons = function (_ref2) {
            var fields = _ref2.fields;

            var allProjects = fields.getAll();
            if (!allProjects) {
                return null;
            }
            var sharedProjects = allProjects.filter(function (project) {
                return project.isPublic;
            });
            var privateProjects = lodash_1.differenceWith(allProjects, sharedProjects, lodash_1.isEqual);
            return React.createElement(React.Fragment, null, !!sharedProjects.length && _this.renderProjectButtonList('Shared Playlists', sharedProjects), !!privateProjects.length && _this.renderProjectButtonList('Private Playlists', privateProjects));
        };
        return _this;
    }

    _createClass(ProjectList, [{
        key: "renderProjectButtonList",
        value: function renderProjectButtonList(listTitle, projects) {
            var _this2 = this;

            return React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ul", enter: { animation: ProjectListAnimation.In, stagger: 150 }, leave: { animation: ProjectListAnimation.Out }, "data-title": listTitle }, classes(), { runOnMount: true }), projects.map(function (project, index) {
                return React.createElement("li", Object.assign({ key: project.id }, classes('item')), React.createElement(ProjectButton_1.default, Object.assign({ index: index, onSelect: _this2.props.onSelectProject, onDelete: _this2.onDelete, onShare: _this2.onShareProject }, project)));
            }));
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement(redux_form_1.FieldArray, { name: "projects", component: this.renderProjectButtons }));
        }
    }]);

    return ProjectList;
}(React.Component);

var ConnectedProjectList = react_redux_1.connect(function (state) {
    return {
        projectList: form_1.selector(state, 'projects')
    };
})(ProjectList);
exports.default = ConnectedProjectList;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1833);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-list.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-list{margin:0;padding:24px 32px 0 16px;list-style:none}.project-list[data-title]:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:attr(data-title);font-size:.6875em;padding-left:4px;padding-bottom:8px;display:block;-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.project-list__wrapper{padding-bottom:48px}html.touchevents .project-list__wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .project-list__wrapper{overflow-x:hidden;overflow-y:auto}.project-list__item{-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed;padding:8px 0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/project-list.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,cACE,SAAS,yBAET,eAAgB,CAHlB,iCChCI,mCAJqC,kCD2CrC,yBAAyB,kBACP,iBAElB,mBACA,cAAc,iCACd,wBE7GuB,CF8GxB,uBAIC,mBC1F6C,CD2F9C,wCCjHC,kBAAgD,kBACT,gCACN,CAClC,2CAEC,kBAAgD,eACX,CD6GvC,oBACE,iCAAA,yBACA,aAAsB,CACvB","file":"project-list.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectList Component\n */\n\n.project-list{\n  margin: 0;\n  padding: baseline(3) baseline(4) 0 baseline(2);\n  list-style: none;\n\n  &[data-title]::before {\n    @include font-smoothing;\n    content: attr(data-title);\n    font-size: .6875em;\n    padding-left: baseline(.5);\n    padding-bottom: baseline(1);\n    display: block;\n    box-shadow: 0 1px uicolor(border);\n  }\n\n  &__wrapper{\n    @include scroll;\n    padding-bottom: baseline(6);\n  }\n\n  &__item{\n    box-shadow: 0 1px uicolor(border);\n    padding: baseline(1) 0;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
__webpack_require__(1835);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var __1 = __webpack_require__(319);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var classes = new BEM({ name: 'project-button', outputIsString: true });

var ProjectButton = function (_React$Component) {
    _inherits(ProjectButton, _React$Component);

    function ProjectButton() {
        _classCallCheck(this, ProjectButton);

        var _this = _possibleConstructorReturn(this, (ProjectButton.__proto__ || Object.getPrototypeOf(ProjectButton)).apply(this, arguments));

        _this.onSelect = function () {
            _this.props.onSelect(_this.props.id);
        };
        _this.onDelete = function () {
            _this.props.onDelete(_this.props.id);
        };
        return _this;
    }

    _createClass(ProjectButton, [{
        key: "render",
        value: function render() {
            return React.createElement(found_1.Link, { to: router_1.linkWithCurrentQueryString(__1.ProjectPagePath(this.props.id)), activeClassName: classes('', 'active'), className: classes(), onClick: this.onSelect }, React.createElement(Icon_1.IconProjectBox, { className: classes('icon') }), React.createElement("div", { className: classes('info') }, React.createElement(Heading_1.default, { is: "h5", text: this.props.title, maxTextLength: 25, noMargin: true, className: classes('title') }), React.createElement(Label_1.Span, { variant: "note", size: "medium", className: classes('subtitle') }, this.props.subtitle)), this.props.userIsOwner && React.createElement("div", { className: classes('actions') }, !this.props.isPublic && React.createElement(Button_1.default, { onClick: this.props.onShare, variant: "icon", icon: React.createElement(Icon_1.IconUserAdd, null), className: classes('project-action') }), React.createElement(Button_1.default, { onClick: this.onDelete, variant: "icon", icon: React.createElement(Icon_1.IconTrash, null), className: classes('project-action'), dangerous: true })));
        }
    }]);

    return ProjectButton;
}(React.Component);

var ConnectedProjectButton = react_redux_1.connect()(ProjectButton);
exports.default = ConnectedProjectButton;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1836);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-button.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-button{color:#101015;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:32px;height:112px;overflow:hidden;-webkit-transform:scale(.96);-ms-transform:scale(.96);transform:scale(.96)}.project-button,.project-button__info{-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.project-button__info{margin-left:16px;-webkit-transform:translateY(8px);-ms-transform:translateY(8px);transform:translateY(8px)}.project-button__subtitle{display:block;opacity:0;margin-top:2px}.project-button__actions{margin-left:auto;-ms-flex-item-align:stretch;align-self:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out;-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}.project-button__project-action.button{border-radius:0;height:33.3333%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.project-button__project-action.button .button__wrapper{height:auto}.project-button__project-action.button:not(:last-child){-webkit-box-shadow:0 1px #f0f6fa;box-shadow:0 1px #f0f6fa}.project-button__project-action.button[disabled]{background-color:transparent}.project-button:not(.project-button--active){cursor:pointer}.project-button--active,.project-button:hover{background-color:#fff;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);border-radius:8px}.project-button--active,.project-button--active .project-button__info,.project-button:hover,.project-button:hover .project-button__info{-webkit-transform:none;-ms-transform:none;transform:none}.project-button--active .project-button__subtitle,.project-button:hover .project-button__subtitle{opacity:1}.project-button--active .project-button__actions{-webkit-transform:none;-ms-transform:none;transform:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/projectList/project-button.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,gBC3BI,cD6BF,qBAAqB,oBACrB,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,kBAEnB,aACA,gBAAgB,6BAEhB,yBAAA,oBAAqB,CAErB,sCAHA,0DAAA,qDAAA,iDE5F2D,CF+F3D,sBACE,iBAEA,kCAAA,8BAAA,yBAAkC,CACnC,0BAGC,cAAc,UACJ,cG5FmC,CH8F9C,yBAGC,iBAAiB,4BACjB,mBAAmB,oBACnB,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,oCACvB,+BAAA,4BAA4B,mCAC5B,+BAAA,0BAA2B,CAC5B,uCAGC,gBAAgB,gBACA,mBAChB,oBAAA,WAAY,CAHb,wDAMG,WAAY,CANf,wDAUG,iCAAA,wBCvIqB,CD6HxB,iDCpEC,4BA5Be,CD+DnB,6CAoDI,cAAe,CAChB,8CCxFC,sBAvCU,sDG7B6C,8CAAA,iBCQrC,CL2JnB,wIADC,uBAAA,mBAAA,cAAe,CAMhB,kGAIC,SAAU,CACX,iDAGC,uBAAA,mBAAA,cAAe,CAChB","file":"project-button.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectButton Component\n */\n\n.project-button{\n  @include textcolor(dark);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding-left: baseline(4);\n  height: baseline(14);\n  overflow: hidden;\n  transition: .25s $ease-out-back;\n  transform: scale(.96);\n\n  &__info{\n    margin-left: baseline(2);\n    transition: .25s $ease-out-back;\n    transform: translateY(baseline(1));\n  }\n\n  &__subtitle{\n    display: block;\n    opacity: 0;\n    margin-top: baseline(.25);\n  }\n\n  &__actions{\n    margin-left: auto;\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    transition: .15s ease-in-out;\n    transform: translateX(100%);\n  }\n\n  &__project-action.button{\n    border-radius: 0;\n    height: 33.3333%;\n    flex-grow: 1;\n\n    .button__wrapper{\n      height: auto;\n    }\n\n    &:not(:last-child) {\n      box-shadow: 0 1px color(bw3);\n    }\n\n    &[disabled] {\n      @include bgcolor(none);\n    }\n  }\n\n  &:not(&--active) {\n    cursor: pointer;\n  }\n\n  &--active, &:hover{\n    @include bgcolor(white);\n    @include shadow(medium);\n    @include bgsize(large);\n    transform: none;\n  }\n\n  &--active &__info,\n  &:hover &__info{\n    transform: none;\n  }\n\n  &--active &__subtitle,\n  &:hover &__subtitle{\n    opacity: 1;\n  }\n\n  &--active &__actions{\n    transform: none;\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectSettings Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(27);
var form_1 = __webpack_require__(239);
__webpack_require__(1838);
var lodash_1 = __webpack_require__(6);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var TextFieldWithLabel_1 = __webpack_require__(236);
var SharedProject_1 = __webpack_require__(726);
var classes = new BEM('project-settings');

var ProjectSettings = function (_React$Component) {
    _inherits(ProjectSettings, _React$Component);

    function ProjectSettings() {
        _classCallCheck(this, ProjectSettings);

        var _this = _possibleConstructorReturn(this, (ProjectSettings.__proto__ || Object.getPrototypeOf(ProjectSettings)).apply(this, arguments));

        _this.onRenameProject = function () {
            _this.props.dispatch(form_1.submitForm());
        };
        _this.onShareProject = function () {
            _this.props.dispatch(form_1.shareProject());
            nextTick(function () {
                _this.props.dispatch(form_1.submitForm());
            });
        };
        _this.renderCollaborator = function (_ref) {
            var first_name = _ref.first_name,
                last_name = _ref.last_name,
                role = _ref.role,
                user_id = _ref.user_id;

            var collaboratorIsUser = _this.props.userProfile && _this.props.userProfile.user_id === user_id;
            var name = first_name && last_name ? first_name + " " + last_name : 'Unregistred user';
            return React.createElement("li", Object.assign({ key: user_id }, classes('collaborator-list__item')), React.createElement(Label_1.Span, { variant: "description", size: "large", textColor: "bw7" }, collaboratorIsUser ? 'You' : name), role === 'owner' && React.createElement(Label_1.Span, { size: "small" }, "Owner"));
        };
        return _this;
    }

    _createClass(ProjectSettings, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.project.id !== this.props.project.id || !lodash_1.isEqual(nextProps.license, this.props.license) || nextProps.open !== this.props.open || nextProps.submitting !== this.props.submitting;
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                open = _props.open,
                _props$project = _props.project,
                is_public = _props$project.is_public,
                opaque_id = _props$project.opaque_id,
                users = _props$project.users,
                submitting = _props.submitting;

            return React.createElement("div", Object.assign({}, classes('', { open: open })), React.createElement("div", Object.assign({}, classes('section')), React.createElement(redux_form_1.Field, { name: "activeProject.name", component: TextFieldWithLabel_1.default, label: "Rename Playlist", colorScheme: "white", size: "medium", inlineButton: React.createElement(Button_1.default, { label: "Save", onClick: this.onRenameProject, colorScheme: "dark" }), disabled: submitting })), React.createElement("div", Object.assign({}, classes('section')), React.createElement(redux_form_1.Field, { component: "input", type: "hidden", name: "activeProject.isPublic", disabled: submitting }), is_public ? React.createElement(TextFieldWithLabel_1.default, { name: "activeProject.sharingUrl", label: "Playlist Sharing URL", colorScheme: "white", value: "" + router_1.getOriginLocation() + SharedProject_1.SharedProjectPagePath(opaque_id), isControlled: true, readOnly: true }) : React.createElement(Button_1.default, Object.assign({ onClick: this.onShareProject, label: "Share Playlist", colorScheme: "accent2", size: "small", variant: "pill", icon: React.createElement(Icon_1.IconUserAdd, null), disabled: submitting, withShadow: true }, classes('share-project-button')))), is_public && users && users.length > 1 && React.createElement("div", Object.assign({}, classes('section')), React.createElement(Label_1.Span, { size: "small" }, "Collaborators"), React.createElement("ul", Object.assign({}, classes('collaborator-list')), users.map(this.renderCollaborator))));
        }
    }]);

    return ProjectSettings;
}(React.Component);

var ConnectedProjectSettings = react_redux_1.connect(function (_ref2) {
    var userProfile = _ref2.user.profile;
    return { userProfile: userProfile };
})(ProjectSettings);
exports.default = ConnectedProjectSettings;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1839);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-settings.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-settings.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-settings{background-color:#f0f6fa;z-index:auto;-webkit-transition:-webkit-transform .35s cubic-bezier(.39,.575,.565,1);transition:-webkit-transform .35s cubic-bezier(.39,.575,.565,1);-o-transition:transform .35s cubic-bezier(.39,.575,.565,1);transition:transform .35s cubic-bezier(.39,.575,.565,1);transition:transform .35s cubic-bezier(.39,.575,.565,1),-webkit-transform .35s cubic-bezier(.39,.575,.565,1);-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%);border-left:1px solid #e4e8ed}.project-settings--open{-webkit-transform:none;-ms-transform:none;transform:none}.project-settings--open .project-settings__header:before{content:\"\";background-image:-webkit-gradient(linear,right top,left top,from(#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa,rgba(240,246,250,0));background-image:linear-gradient(270deg,#f0f6fa,rgba(240,246,250,0));position:absolute;top:0;bottom:0;left:-49px;width:48px}.project-settings__header{padding-right:8px;padding-left:16px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:56px}.project-settings__header,.project-settings__section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.project-settings__section{padding:24px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.project-settings__open-license-builder-button,.project-settings__share-project-button{-ms-flex-item-align:start;align-self:flex-start}span+.project-settings__open-license-builder-button,span+.project-settings__share-project-button{margin-top:8px}.project-settings__usages__list{list-style:none;padding:0;margin:16px 0 6px}.project-settings__usages__list__item{background-color:#e4e8ed;padding:8px 10px}.project-settings__usages__list__item+.project-settings__usages__list__item{margin-top:1px}.project-settings__usages__list__item:first-child:not(:last-child){border-radius:4px 4px 0 0}.project-settings__usages__list__item:last-child:not(:first-child){border-radius:0 0 4px 4px}.project-settings__usages__list__item:first-child:last-child{border-radius:4px}.project-settings__collaborator-list{list-style:none;margin:8px 0 0;padding:0;border-top:1px solid #e4e8ed}.project-settings__collaborator-list__item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px 4px;border-bottom:1px solid #e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/project-settings.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,kBCnCI,yBDqCF,aAAa,wEAEb,gEAAA,2DAAA,wDAAA,6GACA,mCAAA,+BAAA,2BAA2B,6BCtGF,CDyGzB,wBACE,uBAAA,mBAAA,cAAe,CAChB,yDAGC,WAAW,mGACX,4EAAA,uEAAA,qEAAqF,kBAC3D,MAAG,SAAO,WACpC,UEzF6C,CF0F9C,0BGpCuB,kBDtDuB,kBF+F7C,yBAAA,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,WEhG0B,CFmG9C,qDALC,oBAAA,oBAAA,aAAa,iCAIb,wBC1HuB,CD6HzB,2BGjCE,aHoCA,4BAAA,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,sBAAuB,CAExB,uFAOC,0BAAA,qBAAsB,CAHtB,iGACE,cEhH2C,CFiH5C,gCAMC,gBAAgB,UACN,iBExHiC,CF2H3C,sCCrFF,yBDuFI,gBE7HyC,CF2H1C,4EAMG,cAAe,CANlB,mEAUG,yBAAkC,CAVrC,mEAcG,yBIlKY,CJoJf,6DAkBG,iBItKY,CJuKb,qCAML,gBAAgB,eACO,UACb,4BC9Ka,CDiLvB,2CACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,gBAEnB,+BCtLqB,CDuLtB","file":"project-settings.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectSettings Component\n */\n\n.project-settings{\n  @include bgcolor(bw3);\n  z-index: auto;\n\n  transition: transform .35s $ease-out-sine;\n  transform: translateX(100%);\n  border-left: 1px solid uicolor(border);\n\n  &--open{\n    transform: none;\n  }\n\n  &--open &__header::before{\n    content: \"\";\n    background-image: linear-gradient(to left, color(bw3), transparentize(color(bw3), 1));\n    @include position(absolute, 0 null 0 baseline(-6.125));\n    width: baseline(6);\n  }\n\n  &__header{\n    @include padding(null baseline(1) null baseline(2));\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: baseline(7);\n    box-shadow: 0 1px uicolor(border);\n  }\n\n  &__section{\n    @include padding(baseline(3));\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-shadow: 0 1px uicolor(border);\n  }\n\n  &__open-license-builder-button,\n  &__share-project-button{\n    span + & {\n      margin-top: baseline(1);\n    }\n    align-self: flex-start;\n  }\n\n  &__usages{\n    &__list{\n      list-style: none;\n      padding: 0;\n      margin: baseline(2) 0 baseline(.75);\n\n      &__item{\n        @include bgcolor(bw4);\n        padding: baseline(1) baseline(1.25);\n        $radius: radius(medium);\n\n        & + & {\n          margin-top: 1px;\n        }\n\n        &:first-child:not(:last-child){\n          border-radius: $radius $radius 0 0;\n        }\n\n        &:last-child:not(:first-child){\n          border-radius: 0 0 $radius $radius;\n        }\n\n        &:first-child:last-child{\n          border-radius: $radius;\n        }\n      }\n    }\n  }\n\n  &__collaborator-list{\n    list-style: none;\n    margin: baseline(1) 0 0;\n    padding: 0;\n    border-top: 1px solid uicolor(border);\n\n    &__item{\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: baseline(1) baseline(.5);\n      border-bottom: 1px solid uicolor(border);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".shared-project__content-wrapper{padding-top:32px;padding-bottom:64px;min-height:calc(100vh - 64px);-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.shared-project__icon{height:48px;width:48px;color:#d2d9e1;margin-top:32px}.shared-project__icon svg{width:100%}.shared-project__identification{margin-top:8px;margin-bottom:0}.shared-project__shared-by{margin-top:0}.shared-project__title{margin-top:40px;margin-bottom:0}.shared-project__title--redirecting{color:#b1b8c4;margin:auto}.shared-project__license-string{margin-top:16px}.shared-project__buttons{margin-top:64px;display:-webkit-box;display:-ms-flexbox;display:flex}.shared-project__buttons,.shared-project__join-button{-webkit-box-flex:0;-ms-flex:none;flex:none}.shared-project__download-button{margin-left:12px;border-width:1px;border-color:#101015}.shared-project__signup-to-join-message{background-color:#f5faff;border-radius:8px;margin:64px 0 0;width:90%;max-width:600px;padding:32px 96px 48px}.shared-project__track-list{-webkit-box-flex:0;-ms-flex:none;flex:none;list-style:none;margin:80px auto 0;padding:0;width:90%;max-width:600px}.shared-project__track-list__item{text-align:left}.shared-project__track-list__item .card__content{-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.shared-project__track-list__item:first-child .card__content{-webkit-box-shadow:0 -1px #e4e8ed,0 1px #e4e8ed;box-shadow:0 -1px #e4e8ed,0 1px #e4e8ed}.shared-project__track-list__item .card:not(.card--is-selected){padding-right:0}.shared-project__track-list__item .card:not(.card--is-selected) .card__background{display:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/SharedProject/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA6GE,iCCzBsB,iBAYE,oBD3BxB,8BAAyE,mBA2CvE,cAAA,UAAU,oBACV,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,uBACtB,oBAAA,2BAA2B,yBAC3B,sBAAA,mBAAmB,iBACD,CACnB,sBE3EC,YCR6C,WAAA,cHwF7C,eGxF6C,CHqF9C,0BAMG,UAAW,CACZ,gCAID,eACA,eAAgB,CACjB,2BAGC,YAAa,CACd,uBAGC,gBACA,eAAgB,CAEhB,oCI9DA,cJgEE,WAAY,CACb,gCAID,eGnH6C,CHoH9C,yBAGC,gBACA,oBAAA,oBAAA,YAAa,CAEd,sDADC,mBAAA,cAAA,SAAU,CAKX,iCAGC,iBACA,iBAAiB,oBIjKK,CJmKvB,wCI9FC,yBA1DsB,kBJ6JtB,gBAAuB,UACb,gBAEV,sBG5I6C,CH6I9C,4BAGC,mBAAA,cAAA,UAAU,gBACM,mBACW,UACjB,UACA,eGpJmC,CHuJ7C,kCACE,eAAgB,CADjB,iDAIG,iCAAA,wBInLmB,CJ+KtB,6DASK,gDAAA,uCIxLiB,CJ+KtB,gEAcG,eAAgB,CAdnB,kFAesB,YAAc,CAAE","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SharedProjectPage Component\n */\n\n.shared-project{\n  &__content-wrapper{\n    @include padding(baseline(4) null baseline(8));\n    @include page-is-at-least-full-height(-$page-header-height);\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    text-align: center;\n  }\n\n  &__icon{\n    @include size(baseline(6));\n    @include textcolor(bw5);\n    margin-top: baseline(4);\n\n    svg{\n      width: 100%;\n    }\n  }\n\n  &__identification{\n    margin-top: baseline(1);\n    margin-bottom: 0;\n  }\n\n  &__shared-by{\n    margin-top: 0;\n  }\n\n  &__title{\n    margin-top: baseline(5);\n    margin-bottom: 0;\n\n    &--redirecting{\n      @include textcolor(bw6);\n      margin: auto;\n    }\n  }\n\n  &__license-string{\n    margin-top: baseline(2);\n  }\n\n  &__buttons {\n    margin-top: baseline(8);\n    display: flex;\n    flex: none;\n  }\n\n  &__join-button{\n    flex: none;\n  }\n\n  &__download-button{\n    margin-left: baseline(1.5);\n    border-width: 1px;\n    border-color: uicolor(black);\n  }\n\n  &__signup-to-join-message{\n    @include bgcolor(accent-subtle);\n    @include bgsize(large);\n    margin: baseline(8) 0 0;\n    width: 90%;\n    max-width: baseline(75);\n    padding: baseline(4) baseline(12) baseline(6);\n  }\n\n  &__track-list{\n    flex: none;\n    list-style: none;\n    margin: baseline(10) auto 0;\n    padding: 0;\n    width: 90%;\n    max-width: baseline(75);\n\n    &__item{\n      text-align: left;\n\n      .card__content{\n        box-shadow: 0 1px uicolor(border);\n      }\n\n      &:first-child{\n        .card__content{\n          box-shadow: 0 -1px uicolor(border), 0 1px uicolor(border);\n        }\n      }\n\n      .card:not(.card--is-selected){\n        padding-right: 0;\n        .card__background{ display: none }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SharedProjectTrackList Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(450);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var mediaQueries_1 = __webpack_require__(727);
var ProjectTrackList_1 = __webpack_require__(728);
var SharedProjectTrackItem_1 = __webpack_require__(1849);
var classes = new BEM('shared-project__track-list');
exports.SharedProjectTrackList = function (props) {
    return React.createElement(mediaQueries_1.TabletS, null, function (matches) {
        return React.createElement("ul", Object.assign({}, classes()), props.tracks.edges.map(function (edge) {
            var track = edge && edge.node;
            var title = track && ProjectTrackList_1.projectTrackTitle(track, edge && edge.version);
            return React.createElement("li", Object.assign({ key: edge.id }, classes('item')), React.createElement(SharedProjectTrackItem_1.SharedProjectTrackItem, { title: title, license: props.license, track: edge.node, version: edge.version, size: matches ? 'medium' : 'small' }));
        }));
    });
};

/***/ }),
/* 1842 */,
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1844);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-track-list.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-track-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-track-list{list-style:none;margin:0;padding:0}.project-track-list__item{padding:0 16px 0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;list-style:none}.project-track-list__item:before{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);content:\"\";opacity:0;-webkit-transition:opacity .25s ease-in-out;-o-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out}.project-track-list__item .card__content{-webkit-box-shadow:0 1px #e4e8ed;box-shadow:0 1px #e4e8ed}.project-track-list__item--placeholder{background-color:transparent;height:48px;border-bottom:0}.project-track-list__item__thumb--placeholder{height:24px;width:24px;background-color:#e4e8ed;border-radius:3px}.project-track-list__item__title--placeholder{height:12px;width:90%;background-color:#e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/projectView/project-track-list.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,oBACE,gBAAgB,SACP,SACC,CAEV,0BACE,mBAA0B,yBAC1B,sBAAA,qBAAA,iBAAiB,eACD,CAHjB,iCCvED,kBD6E8B,MAAG,QAAA,SAAA,OAAA,sDElHwB,8CFoHrD,WAAW,UACD,4CACV,uCAAA,mCAAoC,CAVvC,yCAcG,iCAAA,wBGpHqB,CHqHtB,uCGvDD,6BH+DE,YACA,eAAgB,CACjB,8CI/FD,YCR6C,WFsC7C,yBHsEE,iBAAkB,CACnB,8CIrGD,YCR6C,ULgH1B,wBGxII,CH0ItB","file":"project-track-list.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * SortableTrackList Component\n */\n\n.project-track-list{\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  &__item{\n    padding: 0 baseline(2) 0 0;\n    user-select: none;\n    list-style: none;\n\n    &::before{\n      @include position(absolute, 0);\n      @include shadow(medium);\n      content: \"\";\n      opacity: 0;\n      transition: opacity .25s ease-in-out;\n    }\n\n    .card__content{\n      box-shadow: 0 1px uicolor(border);\n    }\n\n    // &:not(&--placeholder):hover{\n    //   @include bgcolor(bw2);\n    // }\n\n    &--placeholder{\n      @include bgcolor(none);\n      height: baseline(6);\n      border-bottom: 0;\n    }\n\n    &__thumb--placeholder{\n      @include size(baseline(3));\n      @include bgcolor(bw4);\n      border-radius: 3px;\n    }\n\n    &__title--placeholder{\n      @include size(90% baseline(1.5));\n      @include bgcolor(bw4);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * EmptyProjectView Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var LinkButton_1 = __webpack_require__(51);
var Icon_1 = __webpack_require__(12);
var huge_icons_1 = __webpack_require__(653);
var Browse_1 = __webpack_require__(61);
var classes = new BEM('project-view__empty');
function EmptyProjectView() {
  return React.createElement("div", Object.assign({}, classes()), React.createElement(huge_icons_1.IconProjectBoxHuge, Object.assign({}, classes('icon'))), React.createElement("h2", Object.assign({}, classes('title')), "There are no tracks in this playlist."), React.createElement(LinkButton_1.default, { to: Browse_1.BrowsePagePath, colorScheme: "white", variant: "pill", label: "Browse Music", icon: React.createElement(Icon_1.IconMusicNote, null), size: "large", withShadow: true }));
}
exports.EmptyProjectView = EmptyProjectView;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectTrackItem Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var track_1 = __webpack_require__(44);
__webpack_require__(1847);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_sortable_hoc_1 = __webpack_require__(729);
var Card_1 = __webpack_require__(293);
var classes = new BEM('project-track');
exports.ProjectTrackItem = react_sortable_hoc_1.SortableElement(function (props) {
    var cardSize = props.cardSize,
        license = props.license,
        onSaveLicense = props.onSaveLicense,
        projectId = props.projectId,
        remove = props.remove,
        title = props.title,
        trackEdge = props.trackEdge,
        trackResult = props.trackResult;
    var artist = trackResult.artist,
        assets = trackResult.assets;

    var options = ['FindSimilar', 'Download', {
        option: 'RemoveFromProject',
        listener: remove
    }, 'PriceElement'];
    var trackId = track_1.getDefaultTrackAsset(assets, trackEdge.version).id;
    var thumbnail = track_1.getResponsiveTrackThumbnail(trackResult);
    var PriceElement = track_1.getTrackPriceElement(trackResult, {
        buttonProps: {
            variant: 'pill',
            size: 'small',
            withShadow: true
        },
        addToCartButtonProps: {
            usages: license
        },
        licenseBuilderButtonProps: {
            onSaveLicense: onSaveLicense,
            scope: {
                type: 'Project',
                id: projectId
            }
        }
    });
    return React.createElement("div", Object.assign({}, classes()), React.createElement(Card_1.default, Object.assign({ actionSource: "project_list", backgroundColor: "bw3", trackId: trackId, title: title, subtitle: artist.name, image: thumbnail, license: license, PriceElement: PriceElement, trackResult: trackResult, size: cardSize, options: options }, classes('card'))));
});

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1848);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-track-item.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-track-item.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-track{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.project-track__checkbox{-webkit-box-flex:0;-ms-flex:none;flex:none}.project-track__card{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.project-track .card--small{height:64px}.project-track .card--small .thumbnail{width:48px}.project-track .card--medium{height:128px}.project-track .card:not(.card--is-selected){padding-right:0}.project-track .card:not(.card--is-selected) .card__background{display:none}.project-track.is-being-sorted{background-color:#f9fafb;border-radius:8px;-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);z-index:1}.project-track.is-being-sorted:before{opacity:1}.project-track.is-being-sorted .card__content__right{background-color:#f9fafb}.project-track.is-being-sorted .card__content__left:after,.project-track.is-being-sorted .card__content__right:before{background-image:-webkit-gradient(linear,right top,left top,from(#f9fafb),to(rgba(249,250,251,0)));background-image:-webkit-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:-o-linear-gradient(right,#f9fafb,rgba(249,250,251,0));background-image:linear-gradient(270deg,#f9fafb,rgba(249,250,251,0))}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/projectView/project-track-item.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,eACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAEnB,yBACE,mBAAA,cAAA,SAAU,CACX,qBAGC,mBAAA,cAAA,SAAU,CATd,4BAaI,WCtF6C,CDyEjD,uCAgBM,UCzF2C,CDyEjD,6BAqBI,YC9F6C,CDyEjD,6CAyBI,eAAgB,CAzBpB,+DA0BuB,YAAc,CA1BrC,+BEnCI,yBA5DsB,kBCAJ,yDCRqC,iDJwIvD,SAAU,CAjCd,sCAoCM,SAAU,CApChB,qDEnCI,wBA5DsB,CF+F1B,sHA4CM,mGAAA,4EAAA,uEAAA,oEAAqF,CACtF","file":"project-track-item.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectTrackItem Component\n */\n\n.project-track{\n  display: flex;\n  align-items: center;\n\n  &__checkbox{\n    flex: none;\n  }\n\n  &__card{\n    flex: auto;\n  }\n\n  .card--small{\n    height: baseline(8);\n\n    .thumbnail{\n      width: baseline(6);\n    }\n  }\n\n  .card--medium{\n    height: baseline(16);\n  }\n\n  .card:not(.card--is-selected){\n    padding-right: 0;\n    .card__background{ display: none }\n  }\n\n  &.is-being-sorted{\n    @include bgcolor(bw2);\n    @include bgsize(large);\n    @include shadow(small);\n    z-index: 1;\n\n    &::before{\n      opacity: 1;\n    }\n\n    .card__content__right{\n      @include bgcolor(bw2);\n    }\n    .card__content__left::after,\n    .card__content__right::before{\n      background-image: linear-gradient(to left, color(bw2), transparentize(color(bw2), 1));\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SharedProjectTrackItem Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var track_1 = __webpack_require__(44);
__webpack_require__(450);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Card_1 = __webpack_require__(293);
var classes = new BEM('shared-project__track-item');
exports.SharedProjectTrackItem = function (props) {
    var license = props.license,
        size = props.size,
        title = props.title,
        track = props.track,
        version = props.version;
    var artist = track.artist,
        assets = track.assets;

    return React.createElement(Card_1.default, Object.assign({ actionSource: "shared_project_list", backgroundColor: "bw3", image: track_1.getResponsiveTrackThumbnail(track), options: ['PriceElement', 'ShowDetails', 'FindSimilar'], PriceElement: track_1.getTrackPriceElement(track, {
            buttonProps: {
                variant: 'pill',
                size: size === 'small' ? 'xsmall' : 'small',
                withShadow: true
            },
            addToCartButtonProps: {
                usages: license
            }
        }), size: size, subtitle: artist.name, title: title, trackId: track_1.getDefaultTrackAsset(assets, version).id, trackResult: track }, classes('card')));
};

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ProjectView Component
 */

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1851);
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var redux_form_1 = __webpack_require__(37);
var ProjectTrackList_1 = __webpack_require__(728);
var classes = new BEM('project-view');
var ProjectView = function ProjectView(_a) {
    var children = _a.children,
        className = _a.className,
        passDownProps = __rest(_a, ["children", "className"]);

    return React.createElement("div", Object.assign({}, classes('', '', classNames(className))), React.createElement("div", Object.assign({}, classes('tracks-actions'))), React.createElement(redux_form_1.FieldArray, { name: "activeProject.tracks", component: ProjectTrackList_1.default, props: passDownProps }));
};
exports.default = ProjectView;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1852);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-view.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./project-view.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".project-view{padding:8px 0 40px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.project-view,.project-view__tracks-actions{display:-webkit-box;display:-ms-flexbox;display:flex}.project-view__tracks-actions{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.project-view__empty,.project-view__track-list-wrapper{-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.project-view__empty{color:#b1b8c4;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.project-view__empty__title{margin-bottom:32px}.project-view__empty__icon{position:absolute;top:50%;left:50%;color:#e4e8ed;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:.35;width:400px}.project-view__empty__icon svg{width:100%}.project-view__button-download-all{margin:40px auto 0}@media screen and (min-width:1024px){.project-view{padding:8px 5vw 40px 24px}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/Projects/project-view.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss"],"names":[],"mappings":"AA4GA,cACE,mBAEA,4BAAA,6BAAA,0BAAA,qBAAsB,CAEtB,4CAHA,oBAAA,oBAAA,YAAa,CAGb,8BAEE,qBAAA,kBAAA,wBAAyB,CAE1B,uDAGC,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAGrB,qBC5CE,cDiDA,4BAAA,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,iBAEL,CAElB,4BACE,kBErG2C,CFsG5C,2BG/FH,kBHkG8B,QAAK,SAAc,cAE7C,uCAAA,mCAAA,+BAAgC,YACpB,WE5G+B,CFwG5C,+BAQG,UAAW,CACZ,mCAKH,kBAA0B,CAC3B,qCA9CH,cAiDI,yBE1H6C,CF4HhD,CAAA","file":"project-view.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ProjectView Component\n */\n\n.project-view{\n  padding: baseline(1) 0 baseline(5);\n  display: flex;\n  flex-direction: column;\n\n  &__tracks-actions{\n    display: flex;\n    justify-content: flex-end;\n    // margin-bottom: baseline(6);\n  }\n\n  &__track-list-wrapper{\n    flex: auto;\n    display: flex;\n    align-items: center;\n  }\n\n  &__empty{\n    @include textcolor(bw6);\n\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    &__title{\n      margin-bottom: baseline(4);\n    }\n\n    &__icon{\n      @include position(absolute, 50% null null 50%);\n      @include textcolor(bw4);\n      transform: translate(-50%, -50%);\n      opacity: .35;\n      width: baseline(50);\n\n      svg{\n        width: 100%;\n      }\n    }\n  }\n\n  &__button-download-all{\n    margin: baseline(5) auto 0;\n  }\n\n  @include media(breakpoint(desktop)) {\n    padding: baseline(1) 5vw baseline(5) baseline(3);\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * App Container
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var provider_1 = __webpack_require__(1854);
var authentication_1 = __webpack_require__(403);
var projects_1 = __webpack_require__(130);
var staticData_1 = __webpack_require__(716);
var user_1 = __webpack_require__(50);
var staticData_2 = __webpack_require__(715);
var app_1 = __webpack_require__(724);
var projects_2 = __webpack_require__(1855);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var AppWrapper_1 = __webpack_require__(1857);
var provider_2 = __webpack_require__(731);
var provider_3 = __webpack_require__(1927);
var provider_4 = __webpack_require__(1932);
var provider_5 = __webpack_require__(1933);
var provider_6 = __webpack_require__(1934);
var google_optimize_1 = __webpack_require__(1935);
var defaultList = [];

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.hydrateState();
        return _this;
    }

    _createClass(App, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // this.enableWhyDidYouUpdate();
            google_optimize_1.activateOptimize();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.viewer.profile !== this.props.viewer.profile) {
                this.props.dispatch(user_1.setUserLoginStatus(!!this.props.viewer.profile));
            }
            if (!lodash_1.isEqual(prevProps.projects, this.props.projects)) {
                this.hydrateProjects();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                main = _props.main,
                viewer = _props.viewer;

            return React.createElement(provider_1.QueryStringContextProvider, null, React.createElement(provider_3.CurrencyContextProvider, { viewer: viewer }, React.createElement(provider_6.TrackLicensingContextProvider, null, React.createElement(provider_2.CookieContextProvider, null, React.createElement(provider_4.DownloadContextProvider, null, React.createElement(provider_5.OnboardingContextProvider, null, React.createElement(AppWrapper_1.default, { cartInfo: viewer.cart, projects: this.getProjectsFromViewer(), userProfile: viewer.profile, viewer: viewer }, main || children)))))));
        }
        // @ts-ignore

    }, {
        key: "enableWhyDidYouUpdate",
        value: function enableWhyDidYouUpdate() {
            if (false) {
                var _require = require('why-did-you-update'),
                    whyDidYouUpdate = _require.whyDidYouUpdate;

                whyDidYouUpdate(React);
            }
        }
    }, {
        key: "hydrateState",
        value: function hydrateState() {
            this.hydrateUserState();
            this.hydrateStaticData();
            this.hydrateAuthenticationConfig();
        }
    }, {
        key: "hydrateUserState",
        value: function hydrateUserState() {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                viewer = _props2.viewer;

            var isUserLoggedIn = !!viewer.profile;
            dispatch(user_1.setUserLoginStatus(isUserLoggedIn));
            dispatch(user_1.setViewerId({ viewerId: viewer.id }));
            if (isUserLoggedIn) {
                dispatch(user_1.setUserProfile({ profile: viewer.profile }));
                this.hydrateProjects();
            }
            if (viewer.profile && !viewer.profile.ga_account_goal_sent) {
                var promise = new Promise(function (resolve, reject) {
                    dispatch(user_1.requestTrackUserRegistration({
                        viewerId: viewer.id,
                        promise: { resolve: resolve, reject: reject }
                    }));
                });
                promise.then(function (mutationResult) {
                    var payload = mutationResult.updateProfile;
                    dispatch(user_1.setUserProfile({ profile: payload.profile }));
                });
            }
        }
    }, {
        key: "hydrateProjects",
        value: function hydrateProjects() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
                dispatch = _ref.dispatch,
                viewer = _ref.viewer;

            var projects = this.getProjectsFromViewer(viewer);
            dispatch(projects_1.setProjects({ projects: projects }));
        }
    }, {
        key: "hydrateStaticData",
        value: function hydrateStaticData() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
                dispatch = _ref2.dispatch,
                viewer = _ref2.viewer;

            var staticDataState = staticData_2.initialState;
            if (viewer.taxonomies) {
                staticDataState.taxonomies = viewer.taxonomies.edges.map(function (_ref3) {
                    var node = _ref3.node;
                    return node;
                });
            }
            if (viewer.tempos) {
                staticDataState.tempos = viewer.tempos.edges.map(function (_ref4) {
                    var node = _ref4.node;
                    return node;
                });
            }
            if (viewer.license_components) {
                staticDataState.licenseComponents = viewer.license_components;
            }
            if (viewer.business_information) {
                staticDataState.businessInformation = viewer.business_information.ams;
            }
            if (viewer.latest_exchange_rates) {
                staticDataState.exchangeRates = viewer.latest_exchange_rates;
            }
            dispatch(staticData_1.setStaticData(staticDataState));
        }
    }, {
        key: "hydrateAuthenticationConfig",
        value: function hydrateAuthenticationConfig() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
                dispatch = _ref5.dispatch,
                viewer = _ref5.viewer;

            if (viewer.authentication_info) {
                dispatch(authentication_1.setAuthenticationConfig(viewer.authentication_info));
            }
        }
    }, {
        key: "getProjectsFromViewer",
        value: function getProjectsFromViewer() {
            var viewer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.viewer;

            return viewer.projects ? viewer.projects.edges.map(function (_ref6) {
                var node = _ref6.node;
                return node;
            }) : defaultList;
        }
    }]);

    return App;
}(React.Component);

var ConnectedApp = react_redux_1.connect(function (_, ownProps) {
    return {
        projects: projects_2.getProjectsFromViewer(ownProps)
    };
}, function (dispatch) {
    return { dispatch: dispatch };
})(App);
var AppWithRelay = react_relay_1.createFragmentContainer(ConnectedApp, app_1.AppFragment);
exports.default = AppWithRelay;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * QueryString Context Provider
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsActions = __webpack_require__(161);
var found_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var license_1 = __webpack_require__(34);
var staticData_1 = __webpack_require__(103);
var _1 = __webpack_require__(30);
var helpers_1 = __webpack_require__(151);
var types_1 = __webpack_require__(105);

var InternalQueryStringContextProvider = function (_React$Component) {
    _inherits(InternalQueryStringContextProvider, _React$Component);

    function InternalQueryStringContextProvider(props) {
        _classCallCheck(this, InternalQueryStringContextProvider);

        var _this = _possibleConstructorReturn(this, (InternalQueryStringContextProvider.__proto__ || Object.getPrototypeOf(InternalQueryStringContextProvider)).call(this, props));

        _this.state = Object.assign({}, helpers_1.getQueryStringStateForRoute(_this.props.match), { addBudgetFilter: function addBudgetFilter(budget) {
                _this.apply(_1.addBudgetFilterToContext, budget);
            }, addTempoFilter: function addTempoFilter(tempo) {
                _this.apply(_1.addTempoFilterToContext, tempo);
            }, addSearchFilter: function addSearchFilter(term, exclude) {
                _this.apply(_1.addSearchFilterToContext, [term, !!exclude]);
            }, clearFilters: function clearFilters() {
                _this.apply(_1.clearFiltersFromContext);
            }, removeFilter: function removeFilter(key) {
                _this.apply(_1.removeQsParamFromContext, key);
            }, removeBudgetFilter: function removeBudgetFilter() {
                return _this.state.removeFilter(types_1.QueryStringParam.Budget);
            }, removeLicense: function removeLicense() {
                return _this.state.removeFilter(types_1.QueryStringParam.License);
            }, removeSearchFilter: function removeSearchFilter(term, exclude) {
                _this.apply(_1.removeSearchFilterFromContext, [term, !!exclude]);
            }, removeSimilarityFilter: function removeSimilarityFilter() {
                return _this.state.removeFilter(types_1.QueryStringParam.Similarity);
            }, addTaxonomyQuery: function addTaxonomyQuery(term) {
                _this.apply(_1.addTaxonomyQueryToContext, term);
            }, addSimilarityFilter: function addSimilarityFilter(trackId) {
                _this.apply(_1.addSimilarityFilterToContext, trackId);
            }, removeTaxonomyQuery: function removeTaxonomyQuery(term) {
                _this.apply(_1.removeTaxonomyQueryFromContext, term);
            }, removeTempoFilter: function removeTempoFilter() {
                return _this.state.removeFilter(types_1.QueryStringParam.Tempo);
            }, saveLicense: function saveLicense(licenseParams) {
                _this.apply(_1.saveLicenseToContext, licenseParams);
            }, clearSearchQuery: function clearSearchQuery() {
                _this.apply(_1.clearSearchQueryFromContext);
            }, setSearchQuery: function setSearchQuery(searchQuery) {
                _this.apply(_1.setSearchQueryInContext, searchQuery);
            }, setSearchSortOrder: function setSearchSortOrder(sortOrder) {
                _this.apply(_1.setSearchSortOrderInContext, sortOrder);
            } });
        return _this;
    }

    _createClass(InternalQueryStringContextProvider, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(props, prevState) {
            if (!lodash_1.isEqual(this.state.license_params, prevState.license_params)) {
                var usages = license_1.getLicenseUsagesFromQueryString({
                    components: this.props.licenseComponents,
                    params: this.state.license_params
                });
                this.props.AnalyticsDispatch.setLicense(license_1.getLicenseString(usages));
            }
            if (this.searchHasChanged(prevState)) {
                this.props.AnalyticsDispatch.setSearch(this.state);
            }
        }
    }, {
        key: "apply",
        value: function apply(action, arg) {
            var _this2 = this;

            this.setState(function () {
                var _props = _this2.props,
                    match = _props.match,
                    router = _props.router;

                var args = [_this2.state, { match: match, router: router }];
                if (arg) {
                    args.unshift(arg);
                }
                return action.apply(null, args);
            });
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(_1.QueryStringContext.Provider, { value: this.state }, this.props.children);
        }
    }, {
        key: "searchHasChanged",
        value: function searchHasChanged(prevState) {
            var keys = ['filters', 'query', 'sort', 'license_params'];
            return !lodash_1.isEqual(lodash_1.pick(prevState, keys), lodash_1.pick(this.state, keys));
        }
    }]);

    return InternalQueryStringContextProvider;
}(React.Component);

var ConnectedQueryStringContextProvider = react_redux_1.connect(function (state) {
    return {
        licenseComponents: staticData_1.getLicenseComponents(state)
    };
}, function (dispatch) {
    return {
        AnalyticsDispatch: {
            setLicense: function setLicense(licenseString) {
                dispatch(AnalyticsActions.setLicense(licenseString));
            },
            setSearch: function setSearch(_ref) {
                var filters = _ref.filters,
                    query = _ref.query;

                dispatch(AnalyticsActions.setSearch({ filters: filters, query: query }));
            }
        }
    };
})(InternalQueryStringContextProvider);
exports.QueryStringContextProvider = found_1.withRouter(ConnectedQueryStringContextProvider);

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
var relay_1 = __webpack_require__(226);
var viewer_1 = __webpack_require__(1856);
/**
 * Projects Selector
 */
var defaultList = [];
exports.getProjectsFromViewer = reselect_1.createSelector(viewer_1.getViewer, function (viewer) {
  return viewer ? viewer.projects ? relay_1.extractNodeFromConnection(viewer.projects) : defaultList : defaultList;
});

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Viewer Selector
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewer = function (_ref) {
  var viewer = _ref.viewer;
  return viewer;
};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * App Wrapper
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var olark_1 = __webpack_require__(451);
__webpack_require__(1858);
var picturefill = __webpack_require__(1860);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var NotificationManager_1 = __webpack_require__(1861);
var onboarding_1 = __webpack_require__(400);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var ui_1 = __webpack_require__(29);
var license_1 = __webpack_require__(34);
var LicenseBar_1 = __webpack_require__(648);
var Registration_1 = __webpack_require__(287);
var Browse_1 = __webpack_require__(61);
var AddToProjectDrawer_1 = __webpack_require__(1865);
var AuthenticationDrawer_1 = __webpack_require__(632);
var CookieConsentModal_1 = __webpack_require__(1868);
var DownloadAgreementModal_1 = __webpack_require__(1873);
var LicenseThisTrackModal_1 = __webpack_require__(1876);
var TrackDetails_1 = __webpack_require__(1883);
var ErrorBoundary_1 = __webpack_require__(1892);
var Header_1 = __webpack_require__(1895);
var Player_1 = __webpack_require__(1912);
var helmet_1 = __webpack_require__(1926);
var classes = new BEM('app-wrapper');

var AppWrapper = function (_React$Component) {
    _inherits(AppWrapper, _React$Component);

    function AppWrapper() {
        _classCallCheck(this, AppWrapper);

        var _this = _possibleConstructorReturn(this, (AppWrapper.__proto__ || Object.getPrototypeOf(AppWrapper)).apply(this, arguments));

        _this.drawerWrapper = React.createRef();
        return _this;
    }

    _createClass(AppWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            picturefill();
            if (this.props.showExtendedHeader) {
                this.props.dispatch(ui_1.setHeaderType({ type: 'extended' }));
            } else {
                this.props.dispatch(ui_1.setHeaderType({ type: 'simple' }));
            }
            window.addEventListener('scroll', this.onScroll.bind(this));
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!this.props.playerIsVisible) {
                if (this.hasDrawer()) {
                    olark_1.default.hide();
                } else {
                    olark_1.default.show();
                }
            } else if (!prevProps.playerIsVisible) {
                olark_1.default.show();
            }
            if (prevProps.path !== this.props.path && this.props.showExtendedHeader) {
                window.scrollTo(0, 0);
                this.props.dispatch(ui_1.setHeaderType({ type: 'extended' }));
            }
            if (!prevProps.showExtendedHeader && this.props.showExtendedHeader) {
                this.props.dispatch(ui_1.setHeaderType({ type: 'extended' }));
            }
            if (!this.props.showExtendedHeader && this.props.headerType !== 'simple') {
                window.scrollTo(0, 0);
                this.props.dispatch(ui_1.setHeaderType({ type: 'simple' }));
            }
        }
    }, {
        key: "onScroll",
        value: function onScroll() {
            if (!this.props.showExtendedHeader) {
                return;
            }
            var headerTransitionY = 375;
            if (window.scrollY >= headerTransitionY && this.props.headerType !== 'hybrid') {
                this.props.dispatch(ui_1.setHeaderType({ type: 'hybrid' }));
            } else if (window.scrollY < headerTransitionY && this.props.headerType !== 'extended') {
                this.props.dispatch(ui_1.setHeaderType({ type: 'extended' }));
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                addToProjectIsVisible = _props.addToProjectIsVisible,
                cartInfo = _props.cartInfo,
                children = _props.children,
                headerIsVisible = _props.headerIsVisible,
                headerType = _props.headerType,
                licenseBarIsVisible = _props.licenseBarIsVisible,
                logInFormIsVisible = _props.logInFormIsVisible,
                playerIsVisible = _props.playerIsVisible,
                playerTermListIsVisible = _props.playerTermListIsVisible,
                projects = _props.projects,
                signUpFormIsVisible = _props.signUpFormIsVisible,
                trackDetailsSidebarIsVisible = _props.trackDetailsSidebarIsVisible,
                userProfile = _props.userProfile,
                showHeader = _props.showHeader,
                viewer = _props.viewer;

            return React.createElement("div", Object.assign({ "data-header-visibility": headerIsVisible, "data-header-type": headerType, "data-player-visibility": playerIsVisible, "data-player-term-list-visibility": playerTermListIsVisible, "data-drawer-visibility": this.hasDrawer() }, classes()), React.createElement(helmet_1.default, null), React.createElement(ErrorBoundary_1.default, null, showHeader ? React.createElement(Header_1.default, { type: headerType, cartInfo: cartInfo, userProfile: userProfile, viewer: viewer }) : null, React.createElement("div", Object.assign({}, classes('main')), licenseBarIsVisible && React.createElement(LicenseBar_1.default, null), children), playerIsVisible && React.createElement(Player_1.default, null), React.createElement("div", { className: "instant-search-wrapper" }), React.createElement("div", { ref: this.drawerWrapper, className: "drawer-wrapper" }, trackDetailsSidebarIsVisible && React.createElement(TrackDetails_1.default, { currency: viewer.selected_currency, cartInfo: cartInfo }), addToProjectIsVisible && React.createElement(AddToProjectDrawer_1.default, { projects: projects }), signUpFormIsVisible && React.createElement(AuthenticationDrawer_1.default, { action: "signup" }), logInFormIsVisible && React.createElement(AuthenticationDrawer_1.default, { action: "login" }), React.createElement(CookieConsentModal_1.default, null), React.createElement(onboarding_1.OnboardingContext.Consumer, null, function (_ref) {
                var hasNewAchievement = _ref.hasNewAchievement;
                return !hasNewAchievement() ? React.createElement(React.Fragment, null, React.createElement(LicenseThisTrackModal_1.default, null), React.createElement(DownloadAgreementModal_1.default, null)) : null;
            }))), React.createElement(NotificationManager_1.default, null));
        }
    }, {
        key: "hasDrawer",
        value: function hasDrawer() {
            return this.drawerWrapper.current && this.drawerWrapper.current.childNodes.length > 0;
        }
    }]);

    return AppWrapper;
}(React.Component);

var ConnectedAppWrapper = react_redux_1.connect(function (_ref2, _ref3) {
    var player = _ref2.player,
        ui = _ref2.ui,
        found = _ref2.found,
        licenseComponents = _ref2.staticData.licenseComponents;
    var licenseParams = _ref3.licenseParams,
        hasFilters = _ref3.hasFilters;

    var licenseUsages = licenseParams ? license_1.getLicenseUsagesFromQueryString({
        components: licenseComponents,
        params: licenseParams
    }) : [];
    var hasUsages = licenseUsages.length > 0;
    var showHeader = found.match.location.pathname !== Registration_1.RegistrationPagePath;
    var showExtendedHeader = found.match.location.pathname === Browse_1.BrowsePagePath && !hasFilters && !hasUsages;
    return {
        path: found.match.location.pathname,
        showHeader: showHeader,
        showExtendedHeader: showExtendedHeader,
        hasUsages: hasUsages,
        addToProjectIsVisible: !!ui.addToProject && ui.addToProject.visible,
        headerIsVisible: ui.header.visible,
        headerType: ui.header.type,
        licenseBarIsVisible: !!ui.licenseBar && ui.licenseBar.visible,
        logInFormIsVisible: !!ui.logInForm && ui.logInForm.visible,
        playerIsVisible: player.currentTrack != null,
        playerTermListIsVisible: player.currentTrack != null && !!ui.player && ui.player.termListIsVisible,
        signUpFormIsVisible: !!ui.signUpForm && ui.signUpForm.visible,
        trackDetailsSidebarIsVisible: !!ui.trackDetails && ui.trackDetails.visible
    };
}, function (dispatch) {
    return { dispatch: dispatch };
})(AppWrapper);
var AppWrapperWithQueryStringContext = function AppWrapperWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        var hasFilters = selectors_1.hasSearchFilters(ctx);
        var licenseParams = ctx.license_params;
        return React.createElement(ConnectedAppWrapper, Object.assign({}, Object.assign({ hasFilters: hasFilters, licenseParams: licenseParams }, props)));
    });
};
exports.default = AppWrapperWithQueryStringContext;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1859);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "#app .app-wrapper__main{width:100%;z-index:auto}#app .app-wrapper .app-header{z-index:7}#app .app-wrapper .instant-search-wrapper{z-index:10}#app .app-wrapper .player{z-index:auto}#app .app-wrapper .drawer-wrapper{z-index:10}#app .app-wrapper .notification{z-index:7}#app .app-wrapper .drawer-wrapper{position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none}#app .app-wrapper .drawer-wrapper .drawer{pointer-events:auto}#app .app-wrapper[data-header-visibility=false] .app-header{display:none}#app .app-wrapper[data-player-visibility=true] .page__main{padding-bottom:56px}#app .app-wrapper[data-player-visibility=true] .drawer-wrapper,#app .app-wrapper[data-player-visibility=true] .faceted-search-nav{bottom:56px}#app .app-wrapper[data-player-term-list-visibility=true] .page__main{padding-bottom:136px}#app .app-wrapper[data-player-term-list-visibility=true] .faceted-search-nav{bottom:136px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/AppWrapper/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,wBAGM,WAAW,YACE,CAJnB,8BAOiB,SAAW,CAP5B,0CAQ6B,UAAY,CARzC,0BASa,YAAc,CAT3B,kCAUqB,UAAY,CAVjC,gCAWmB,SAAW,CAX9B,kCClEE,eDgF2B,MAAG,QAAA,SAAA,OAAA,mBACN,CAf1B,0CAkBQ,mBAAoB,CAlB5B,4DAwBQ,YAAa,CAxBrB,2DA6BmB,mBEtG8B,CFyEjD,kIA8B4C,WEvGK,CFyEjD,qEAkCmB,oBE3G8B,CFyEjD,6EAmC2B,YE5GsB,CF4GkB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * App Container Component\n */\n\n#app {\n  .app-wrapper {\n    &__main{\n      width: 100%;\n      z-index: auto;\n    }\n\n    .app-header{ z-index: 7 }\n    .instant-search-wrapper{ z-index: 10 }\n    .player{ z-index: auto }\n    .drawer-wrapper{ z-index: 10 }\n    .notification{ z-index: 7 }\n\n    .drawer-wrapper{\n      @include position(fixed, 0);\n      pointer-events: none;\n\n      .drawer{\n        pointer-events: auto;\n      }\n    }\n\n    &[data-header-visibility=\"false\"]{\n      .app-header{\n        display: none;\n      }\n    }\n\n    &[data-player-visibility=\"true\"]{\n      .page__main{ padding-bottom: $player-height }\n      .faceted-search-nav, .drawer-wrapper{ bottom: $player-height }\n    }\n\n    &[data-player-term-list-visibility=\"true\"]{\n      .page__main{ padding-bottom: $player-with-term-list-height }\n      .faceted-search-nav{ bottom: $player-with-term-list-height }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1860 */,
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NotificationManager Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(53);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var Notification_1 = __webpack_require__(1862);

var NotificationManager = function (_React$Component) {
    _inherits(NotificationManager, _React$Component);

    function NotificationManager(props) {
        _classCallCheck(this, NotificationManager);

        var _this = _possibleConstructorReturn(this, (NotificationManager.__proto__ || Object.getPrototypeOf(NotificationManager)).call(this, props));

        _this.globalNotificationProps = {
            open: true,
            onRequestClose: function onRequestClose() {
                return _this.onNotificationDismiss();
            }
        };
        _this.onNotificationDismiss = function () {
            _this.setState({
                currentNotification: Object.assign({}, _this.state.currentNotification, { open: false })
            }, function () {
                return setTimeout(_this.notificationDismissed, 750);
            });
        };
        _this.notificationDismissed = function () {
            if (_this.props.nextNotification) {
                _this.consumeNotification();
            } else {
                _this.setState({ currentNotification: null });
            }
        };
        _this.state = {
            currentNotification: null
        };
        return _this;
    }

    _createClass(NotificationManager, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.nextNotification) {
                this.consumeNotification();
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref) {
            var nextNotification = _ref.nextNotification;

            if (nextNotification && this.state.currentNotification === null) {
                this.consumeNotification(nextNotification);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.state.currentNotification && React.createElement(Notification_1.default, Object.assign({}, this.state.currentNotification));
        }
    }, {
        key: "consumeNotification",
        value: function consumeNotification() {
            var notification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.nextNotification;

            this.setState({
                currentNotification: this.prepareNotification(notification)
            }, this.props.onConsumed);
        }
    }, {
        key: "prepareNotification",
        value: function prepareNotification(notification) {
            return lodash_1.merge({}, notification, this.globalNotificationProps);
        }
    }]);

    return NotificationManager;
}(React.Component);

var ConnectedNotificationManager = react_redux_1.connect(function (_ref2) {
    var notifications = _ref2.notifications;
    return {
        nextNotification: lodash_1.first(notifications)
    };
}, function (dispatch) {
    return {
        onConsumed: function onConsumed() {
            dispatch(actions.consumeNotification());
        }
    };
})(NotificationManager);
exports.default = ConnectedNotificationManager;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Notification Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
__webpack_require__(1863);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var Label_1 = __webpack_require__(8);
var classes = new BEM('notification');

var Notification = function (_React$Component) {
    _inherits(Notification, _React$Component);

    function Notification(props) {
        _classCallCheck(this, Notification);

        var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

        _this.isReady = false;
        _this.onActionClick = function () {
            if (_this.autoHideTimer) {
                clearTimeout(_this.autoHideTimer);
                _this.autoHideTimer = undefined;
            }
            if (_this.props.onActionClick) {
                _this.props.onActionClick();
            }
            _this.onDismiss();
        };
        _this.onDismiss = function () {
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose('click');
            } else {
                _this.setState({ open: false });
            }
        };
        _this.state = {
            autoOpen: _this.props.open,
            open: false
        };
        return _this;
    }

    _createClass(Notification, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(_ref) {
            var open = _ref.open;

            if (this.isReady && this.state.open !== open) {
                this.setState({ open: open });
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if (this.state.autoOpen) {
                setTimeout(function () {
                    _this2.setState({ open: true });
                    _this2.isReady = true;
                }, 100);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _modifiers;

            var _props = this.props,
                action = _props.action,
                autoDismiss = _props.autoDismiss,
                image = _props.image,
                message = _props.message,
                state = _props.state;
            var open = this.state.open;

            var modifiers = (_modifiers = {
                'open': !!open
            }, _defineProperty(_modifiers, state, !!state), _defineProperty(_modifiers, 'custom-action', action !== 'close'), _defineProperty(_modifiers, 'xsmall', message.length > 140), _modifiers);
            if (open && autoDismiss && !!autoDismiss) {
                this.startAutoHide();
            }
            return React.createElement("div", Object.assign({}, classes('', modifiers)), React.createElement("div", Object.assign({}, classes('content')), image ? React.createElement(Thumbnail_1.default, { src: image, size: "small", withShadow: true }) : state === 'error' && React.createElement(Icon_1.IconWarning, Object.assign({}, classes('context-icon'))), React.createElement(Label_1.Span, Object.assign({}, classes('message'), { variant: "description", text: message })), action === 'close' ? React.createElement(Button_1.default, Object.assign({ onClick: this.onActionClick, variant: "icon", icon: state !== 'success' ? React.createElement(Icon_1.IconX, null) : React.createElement(Icon_1.IconCheck, null), size: "small" }, classes('action'))) : React.createElement(Button_1.default, Object.assign({ onClick: this.onActionClick, label: action, size: "medium" }, classes('action')))));
        }
    }, {
        key: "startAutoHide",
        value: function startAutoHide() {
            var _this3 = this;

            if (this.autoHideTimer) {
                return;
            }
            this.autoHideTimer = setTimeout(function () {
                clearTimeout(_this3.autoHideTimer);
                _this3.autoHideTimer = undefined;
                _this3.onDismiss();
            }, this.props.autoDismiss);
        }
    }]);

    return Notification;
}(React.Component);

Notification.defaultProps = {
    action: 'close',
    autoDismiss: 4000,
    state: 'info'
};
exports.default = Notification;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1864);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".notification{position:fixed;bottom:32px;left:32px;padding:16px 16px 16px 20px;border-radius:8px;background-color:#fff;-webkit-box-shadow:0 16px 30px -6px hsla(220,7%,57%,.25),0 2px 5px hsla(220,7%,57%,.1);box-shadow:0 16px 30px -6px hsla(220,7%,57%,.25),0 2px 5px hsla(220,7%,57%,.1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:400px;-webkit-transform:translateX(calc(-100% - 32px));-ms-transform:translateX(calc(-100% - 32px));transform:translateX(calc(-100% - 32px));-webkit-transition:bottom .35s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .35s cubic-bezier(.47,0,.745,.715);transition:bottom .35s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .35s cubic-bezier(.47,0,.745,.715);-o-transition:bottom .35s cubic-bezier(.175,.885,.32,1.275),transform .35s cubic-bezier(.47,0,.745,.715);transition:bottom .35s cubic-bezier(.175,.885,.32,1.275),transform .35s cubic-bezier(.47,0,.745,.715);transition:bottom .35s cubic-bezier(.175,.885,.32,1.275),transform .35s cubic-bezier(.47,0,.745,.715),-webkit-transform .35s cubic-bezier(.47,0,.745,.715);min-height:72px}[data-player-visibility=true] .notification{bottom:80px}[data-player-term-list-visibility=true] .notification{bottom:152px}.notification__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.notification__message{max-width:224px;margin-right:32px}.thumbnail+.notification__message{margin-left:16px}.notification__context-icon{margin-right:8px}.notification__action{margin-left:auto}.notification--open{-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0);-webkit-transition-timing-function:cubic-bezier(.175,.885,.32,1.275),cubic-bezier(.39,.575,.565,1);-o-transition-timing-function:cubic-bezier(.175,.885,.32,1.275),cubic-bezier(.39,.575,.565,1);transition-timing-function:cubic-bezier(.175,.885,.32,1.275),cubic-bezier(.39,.575,.565,1)}.notification--custom-action{padding-right:20px}.notification--custom-action .notification__action .button{text-transform:uppercase;border:1px solid hsla(0,0%,100%,.3);border-radius:16px;padding:8px 16px;-webkit-transition:.15s ease-in-out;-o-transition:.15s ease-in-out;transition:.15s ease-in-out}.notification--custom-action .notification__action .button:hover{background-color:hsla(0,0%,100%,.2);border-color:hsla(0,0%,100%,0)}.notification--info .notification__action{background-color:#4487ff;border:1px solid;border-color:#4487ff;color:#fff}.notification--info .notification__action:hover{background-color:#377fff}.notification--info .notification__action:active{background-color:#518fff}.notification--success .notification__action{background-color:#75dbbe;border:1px solid;border-color:#75dbbe;color:#fff;border-radius:50%}.notification--success .notification__action .icon{height:24px;width:24px}.notification--success .notification__action .icon svg{width:inherit;height:inherit}.notification--error{background-color:#fff5f5;color:#f75b5b;border-color:#f75b5b}.notification--xsmall .notification__message{font-size:.75em}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/messaging/Notification/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_color-scheme.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss"],"names":[],"mappings":"AA4GA,cClEE,eDmEuB,YC/DnB,UCX2C,4BAAA,kBCtB3B,sBH6GpB,uFAAA,+EAAiG,oBACjG,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,gBAGvB,iDAAA,6CAAA,yCAAmD,sHACnD,8GAAA,yGAAA,sGAAA,2JAEA,eEhG+C,CFiLhD,4CAjGG,WEhF6C,CFiF9C,sDAGC,YEpF6C,CFqF9C,uBAcC,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CACpB,uBAGC,gBACA,iBEzG6C,CF2G7C,kCACE,gBE5G2C,CF6G5C,4BAID,gBEjH6C,CFkH9C,sBAGC,gBAAiB,CAClB,oBAGC,gCAAA,4BAAA,wBAAwB,mGACxB,8FAAA,0FIxIyD,CJyI1D,6BAGC,kBE9H6C,CF6H9C,2DAKK,yBAAyB,oCACkB,mBAE3C,iBAEA,oCAAA,+BAAA,2BAA4B,CAVjC,iEAaO,oCAA2C,8BACL,CACvC,0CK1CD,yBCvHmB,iBDkDN,qBClDM,UAoBb,CNkJX,gDKjDK,wBAR2D,CLyDhE,iDKjDK,wBAV4D,CLiEjE,6CKrDK,yBClHgB,iBDwFH,qBCxFG,WHclB,iBAdgB,CHuKnB,mDO/IC,YLR6C,UAAA,CFuJ9C,uDAQO,cAAc,cACC,CAChB,qBM3HL,yBAvDoB,cN0LpB,oBM3LsB,CN4LvB,6CAIG,eACF,CAAC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Notification Component\n */\n\n.notification{\n  @include position(fixed, null null baseline(4) baseline(4));\n  @include padding(baseline(2) baseline(2) baseline(2) baseline(2.5));\n  @include bgsize(large);\n  @include bgcolor(white);\n\n  [data-player-visibility=\"true\"] & {\n    bottom: baseline(10);\n  }\n\n  [data-player-term-list-visibility=\"true\"] & {\n    bottom: baseline(19);\n  }\n\n  box-shadow: 0 16px 30px -6px $default-shadow-color, 0 2px 5px transparentize(uicolor(shadow), .9);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  min-width: baseline(50);\n  transform: translateX(calc(-100% - #{baseline(4)}));\n  transition: bottom .35s $ease-out-back, transform .35s $ease-in-sine;\n\n  min-height: baseline(9);\n\n  &__content{\n    display: flex;\n    align-items: center;\n  }\n\n  &__message{\n    max-width: baseline(28);\n    margin-right: baseline(4);\n\n    .thumbnail + & {\n      margin-left: baseline(2);\n    }\n  }\n\n  &__context-icon{\n    margin-right: baseline(1);\n  }\n\n  &__action{\n    margin-left: auto;\n  }\n\n  &--open{\n    transform: translateX(0);\n    transition-timing-function: $ease-out-back, $ease-out-sine;\n  }\n\n  &--custom-action{\n    padding-right: baseline(2.5);\n\n    .notification__action{\n      .button{\n        text-transform: uppercase;\n        border: 1px solid transparentize(white, .7);\n        border-radius: baseline(2);\n        padding: baseline(1) baseline(2);\n\n        transition: .15s ease-in-out;\n\n        &:hover{\n          background-color: transparentize(white, .8);\n          border-color: transparentize(white, 1);\n        }\n      }\n    }\n  }\n\n  &--info{\n    .notification__action{\n      @include color-scheme(accent);\n    }\n  }\n\n  &--success{\n    .notification__action{\n      @include color-scheme(positive);\n      @include bgsize(circle);\n\n      .icon{\n        @include size(baseline(3));\n        svg{\n          width: inherit;\n          height: inherit;\n        }\n      }\n    }\n  }\n\n  &--error{\n    @include bgcolor(dangerous-subtle);\n    @include textcolor(dangerous);\n    border-color: color(dangerous)\n  }\n\n  &--xsmall{\n    .notification__message{\n      font-size: .75em\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n * Color Scheme\n */\n\n$color-schemes: (\n  transparent: (\n    background: none,\n    border: 1px solid,\n    border-color: transparent,\n    color: black,\n  ),\n  white: (\n    background-color: white,\n    border: 1px solid,\n    border-color: white,\n    color: black,\n    hover: (\n      background-color: black,\n      color: white,\n    ),\n    active: (\n      background-color: lighten black 15%,\n      color: white,\n    ),\n    is-active: (\n      background-color: black,\n      color: white,\n    ),\n  ),\n  black-outline: (\n    background-color: transparent,\n    border: 1px solid,\n    border-color: black,\n    color: black,\n    hover: (\n      background-color: black,\n      color: white,\n    ),\n    active: (\n      background-color: lighten black 15%,\n      color: white,\n    ),\n    is-active: (\n      background-color: black,\n      color: white,\n    ),\n  ),\n  light: (\n    background-color: bw3,\n    border: 1px solid,\n    border-color: bw3,\n    color: black,\n    hover: (\n      background-color: bw4,\n    ),\n    active: (\n      background-color: bw4,\n    ),\n    is-active: (\n      background-color: bw4,\n    ),\n  ),\n  accent: (\n    background-color: accent,\n    border: 1px solid,\n    border-color: accent,\n    color: white,\n    hover: (\n      background-color: darken accent 2.5%,\n    ),\n    active: (\n      background-color: lighten accent 2.5%,\n    ),\n  ),\n  accent2: (\n    background-color: accent2,\n    border: 1px solid,\n    border-color: accent2,\n    color: white,\n    hover: (\n      background-color: darken accent2 2.5%,\n    ),\n    active: (\n      background-color: lighten accent2 2.5%,\n    ),\n  ),\n  dark: (\n    background-color: black,\n    border: 1px solid,\n    border-color: black,\n    color: white,\n    hover: (\n      background-color: lighten black 15%,\n    ),\n    active: (\n      background-color: accent,\n      border-color: accent,\n    ),\n  ),\n  dangerous: (\n    // background-color: transparent,\n    // border: 1px solid,\n    // border-color: transparent,\n    color: dangerous,\n  ),\n  positive: (\n    background-color: positive,\n    border: 1px solid,\n    border-color: positive,\n    color: white,\n  ),\n  disabled: (\n    background-color: bw2,\n    border: 1px solid,\n    border-color: bw4,\n    color: bw6,\n  ),\n);\n\n@function color-transform($attributes) {\n  @if nth($attributes, 1) == lighten {\n    @return lighten(color(nth($attributes, 2)), nth($attributes, 3));\n  } @else if nth($attributes, 1) == darken {\n    @return darken(color(nth($attributes, 2)), nth($attributes, 3));\n  }\n}\n\n@mixin render-attributes($attributes) {\n  @each $key,$value in $attributes {\n    @if index((color, background-color, border-color), $key) {\n      @if type-of($value) == list {\n        #{$key}: color-transform($value);\n      } @else {\n        #{$key}: color($value);\n      }\n    } @else if (index((hover, active), $key)) {\n      &:#{$key} {\n        @include render-attributes($value);\n      }\n    } @else if (index((is-active), $key)) {\n      &.#{$key} {\n        @include render-attributes($value);\n      }\n    } @else {\n      #{$key}: $value;\n    }\n  }\n}\n\n@mixin color-scheme($color-scheme) {\n  @if map-has-key($color-schemes, $color-scheme) {\n    $attributes: map-get($color-schemes, $color-scheme);\n    @include render-attributes($attributes);\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AddToProjectDrawer Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = __webpack_require__(53);
var postAuthenticationRequests_1 = __webpack_require__(81);
var projects_1 = __webpack_require__(130);
var ui_1 = __webpack_require__(29);
var router_1 = __webpack_require__(27);
__webpack_require__(1866);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
var nextTick = __webpack_require__(82);
var queryString_1 = __webpack_require__(30);
var Button_1 = __webpack_require__(10);
var Badge_1 = __webpack_require__(427);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Drawer_1 = __webpack_require__(215);
var classes = new BEM('add-to-project-drawer');

var AddToProjectDrawer = function (_React$Component) {
    _inherits(AddToProjectDrawer, _React$Component);

    function AddToProjectDrawer(props) {
        _classCallCheck(this, AddToProjectDrawer);

        var _this = _possibleConstructorReturn(this, (AddToProjectDrawer.__proto__ || Object.getPrototypeOf(AddToProjectDrawer)).call(this, props));

        _this.onAddToNewProject = function (name) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.props.isUserLoggedIn) {
                                    _context.next = 3;
                                    break;
                                }

                                this.setState({ isOpen: false }, function () {
                                    _this2.props.signUpAndCreateProject(name);
                                });
                                return _context.abrupt("return");

                            case 3:
                                this.props.dispatch(projects_1.requestCreateProject({
                                    input: { name: name },
                                    promise: {
                                        resolve: function resolve(response, errors) {
                                            if (errors) {
                                                _this2.props.dispatch(notifications_1.pushNotification({
                                                    autoDismiss: false,
                                                    message: 'An error occurred while saving this track to a new playlist. Please try again.',
                                                    state: 'error'
                                                }));
                                            } else {
                                                _this2.onAddToProject(response.createProject.new_project_edge.node.id, true);
                                            }
                                        },
                                        reject: function reject() {
                                            _this2.props.dispatch(notifications_1.pushNotification({
                                                autoDismiss: false,
                                                message: 'An error occurred while saving this track to a new playlist. Please try again.',
                                                state: 'error'
                                            }));
                                        }
                                    }
                                }));

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        };
        _this.onAddToProject = function (id) {
            var isNewProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var licenseParams;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                licenseParams = this.props.searchState.license_params;

                                this.props.dispatch(projects_1.requestAddTrackToProject({
                                    licenseParams: isNewProject && licenseParams ? licenseParams : undefined,
                                    projectId: id,
                                    trackId: this.props.trackId,
                                    trackVersion: this.props.trackVersion,
                                    promise: {
                                        resolve: function resolve(result) {
                                            if (result) {
                                                var trackTitle = lodash_1.last(result.updateProject.project.tracks.edges).node.title;
                                                _this3.setState({ isOpen: false });
                                                _this3.props.dispatch(notifications_1.pushNotification({
                                                    message: "Track <em>" + trackTitle + "</em> was saved to your playlist!",
                                                    state: 'success'
                                                }));
                                            } else {
                                                _this3.props.dispatch(notifications_1.pushNotification({
                                                    autoDismiss: false,
                                                    message: 'An error occurred while saving this track to your playlist. Please try again.',
                                                    state: 'error'
                                                }));
                                            }
                                        },
                                        reject: function reject() {
                                            _this3.props.dispatch(notifications_1.pushNotification({
                                                autoDismiss: false,
                                                message: 'An error occurred while saving this track to your playlist. Please try again.',
                                                state: 'error'
                                            }));
                                        }
                                    }
                                }));

                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        };
        _this.renderProjectButton = function (project) {
            var hasTrack = _this.projectHasTrack(project);
            var tracks = project.tracks;
            return React.createElement(velocity_react_1.VelocityTransitionGroup, { enter: { animation: 'callout.flash' }, component: Button_1.default, key: project.id, className: "drawer__button-list__button", icon: hasTrack ? React.createElement(Icon_1.IconProjectSelected, null) : React.createElement(Icon_1.IconProject, null), label: React.createElement(Label_1.Span, { text: project.name, maxTextLength: 25 }), onClick: function onClick() {
                    return _this.onAddToProject(project.id);
                } }, tracks && React.createElement(Badge_1.default, { key: "project-track-count-" + tracks.edges.length, label: "" + tracks.edges.length, colorScheme: "light" }));
        };
        _this.state = {
            isOpen: true
        };
        return _this;
    }

    _createClass(AddToProjectDrawer, [{
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                isUserLoggedIn = _props.isUserLoggedIn,
                projects = _props.projects;

            return React.createElement(Drawer_1.default, Object.assign({ closeButtonLabel: "Cancel", onClose: function onClose() {
                    return _this4.props.close();
                }, open: this.state.isOpen, headerIcon: null, position: "right", floatingHeader: true }, classes()), React.createElement("div", Object.assign({}, classes('create-project', '', 'drawer__content-group')), React.createElement(Heading_1.default, { is: "h4" }, "Save to", React.createElement("br", null), "New Playlist:"), React.createElement(TextField_1.default, Object.assign({ name: "create-project", placeholder: "Playlist Name", inlineButton: React.createElement(Button_1.default, { label: "Create", colorScheme: "dark", onClick: this.onAddToNewProject }), colorScheme: "light", submitOnEnter: true, withoutBorder: true }, classes('create-project__input')))), isUserLoggedIn && !!projects.length && React.createElement("div", Object.assign({}, classes('project-list', '', 'drawer__button-list'), { "data-title": "Save to an existing playlist:" }), projects.map(this.renderProjectButton)));
        }
    }, {
        key: "projectHasTrack",
        value: function projectHasTrack(project) {
            var _this5 = this;

            return !!project.tracks && !!project.tracks.edges.find(function (_ref) {
                var node = _ref.node;
                return node.id === _this5.props.trackId;
            });
        }
    }]);

    return AddToProjectDrawer;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedAddToProjectDrawer = react_redux_1.connect(function (_ref2) {
    var found = _ref2.found,
        addToProject = _ref2.ui.addToProject,
        _ref2$user = _ref2.user,
        isLoggedIn = _ref2$user.isLoggedIn,
        viewerId = _ref2$user.viewerId;
    return {
        isUserLoggedIn: isLoggedIn,
        location: found.match.location,
        trackId: addToProject ? addToProject.trackId : '',
        trackVersion: addToProject ? addToProject.trackVersion : '',
        viewerId: viewerId
    };
}, function (dispatch) {
    return {
        dispatch: dispatch,
        close: function close() {
            dispatch(ui_1.toggleAddToProjectVisibility(false));
        },
        signUpAndCreateProject: function signUpAndCreateProject(projectName, trackId, trackVersion, searchState, location) {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestCreateProject({
                page: router_1.createHref(location),
                projectName: projectName,
                trackId: trackId,
                trackVersion: trackVersion,
                searchState: searchState
            }));
            nextTick(function () {
                return dispatch(ui_1.showSignUpForm({ reason: 'project' }));
            });
        }
    };
}, function (stateProps, _a, ownProps) {
    var _signUpAndCreateProject = _a.signUpAndCreateProject,
        dispatchProps = __rest(_a, ["signUpAndCreateProject"]);
    return Object.assign({}, stateProps, dispatchProps, ownProps, { signUpAndCreateProject: function signUpAndCreateProject(projectName) {
            return _signUpAndCreateProject(projectName, stateProps.trackId, stateProps.trackVersion, ownProps.searchState, stateProps.location);
        } });
})(AddToProjectDrawer);
var AddToProjectDrawerWithQueryStringContext = function AddToProjectDrawerWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref3) {
        var filters = _ref3.filters,
            license_params = _ref3.license_params,
            query = _ref3.query;
        return React.createElement(ConnectedAddToProjectDrawer, Object.assign({ searchState: { filters: filters, license_params: license_params, query: query } }, props));
    });
};
exports.default = AddToProjectDrawerWithQueryStringContext;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1867);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".add-to-project-drawer__create-project{padding:24px 16px 32px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.add-to-project-drawer__project-list .drawer__button-list__button .button__wrapper>.label{margin-left:12px}.add-to-project-drawer__project-list .drawer__button-list__button:hover{color:#4487ff}.add-to-project-drawer__project-list .badge{margin-left:auto}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/AddToProjectDrawer/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA8GE,uCACE,uBACA,4BAAA,6BAAA,0BAAA,qBAAsB,CACvB,0FAKK,gBCnFyC,CDgF9C,wEElCC,aAnEuB,CFqGxB,4CAYG,gBAAiB,CAClB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * AddToProjectDrawer Component\n */\n\n.add-to-project-drawer{\n\n  &__create-project{\n    padding: baseline(3) baseline(2) baseline(4);\n    flex-direction: column;\n  }\n\n  &__project-list{\n    .drawer__button-list__button{\n      .button__wrapper > .label{\n        margin-left: baseline(1.5);\n      }\n\n      &:hover{\n        @include textcolor(accent);\n      }\n    }\n\n    .badge{\n      margin-left: auto;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  CookieConsentModal Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1869);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var cookie_1 = __webpack_require__(730);
var Button_1 = __webpack_require__(10);
var Heading_1 = __webpack_require__(9);
var Modal = __webpack_require__(452);
var ModalAction;
(function (ModalAction) {
    ModalAction["OK"] = "ok";
    ModalAction["PrivacyPolicy"] = "privacy_policy";
})(ModalAction || (ModalAction = {}));
var classes = new BEM('cookie-consent-modal');

var CookieConsentModalBase = function (_React$Component) {
    _inherits(CookieConsentModalBase, _React$Component);

    function CookieConsentModalBase(props) {
        _classCallCheck(this, CookieConsentModalBase);

        var _this = _possibleConstructorReturn(this, (CookieConsentModalBase.__proto__ || Object.getPrototypeOf(CookieConsentModalBase)).call(this, props));

        _this.onModalClose = function (id) {
            _this.props.cookieConsentContext.clear();
        };
        _this.state = {};
        return _this;
    }

    _createClass(CookieConsentModalBase, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement(Modal.Component, Object.assign({ actions: React.createElement(React.Fragment, null, React.createElement(Modal.Action, { id: ModalAction.PrivacyPolicy, style: "cancel", Element: React.createElement(Button_1.default, { onClick: function onClick(e) {
                            return e.stopPropagation();
                        }, hyperLinkProps: {
                            href: '/privacy-policy',
                            target: '_blank'
                        }, wrapperComponent: "a", label: "Privacy Policy" }) }), React.createElement(Modal.DefaultAction, { id: ModalAction.OK, onClick: function onClick() {
                        return _this2.props.cookieConsentContext.handleConsent();
                    }, label: "OK" })), position: Modal.Position.Center, onClose: this.onModalClose }, classes()), React.createElement(Modal.Content, null, React.createElement("img", { width: "50%", src: "https://assets.boppermusic.com/images/cookies-256x220.png", alt: "cookies" }), React.createElement(Heading_1.default, { is: "h2" }, "Cookies!"), React.createElement(Heading_1.default, { is: "h4" }, "We use cookies to make your experience\xA0better.")));
        }
    }]);

    return CookieConsentModalBase;
}(React.Component);

var CookieConsentModalWithCookieContext = function CookieConsentModalWithCookieContext(props) {
    return React.createElement(cookie_1.CookieContext.Consumer, null, function (ctx) {
        return !ctx.consentReceived ? React.createElement(CookieConsentModalBase, Object.assign({ cookieConsentContext: ctx }, props)) : null;
    });
};
exports.default = found_1.withRouter(CookieConsentModalWithCookieContext);

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1870);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".download-agreement-modal .modal__title{margin-bottom:24px}.download-agreement-modal .modal__actions{border-top:1px solid #e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/CookieConsentModal/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,wCAGM,kBC5E2C,CDyEjD,0CAMM,4BEvGqB,CFwGtB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * CookieConsentModal Component\n */\n\n.download-agreement-modal{\n  .modal{\n    &__title{\n      margin-bottom: baseline(3);\n    }\n    &__actions{\n      border-top: 1px solid uicolor(border);\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".modal{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;pointer-events:all}.modal--center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.modal--top{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.modal__background,.modal__wrapper{display:none}.modal__background{position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgba(16,16,21,.3)}.modal__wrapper{background-color:#fff;border-radius:16px;width:90%;max-width:600px}.modal__content{padding:24px 80px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.modal--top .modal__wrapper{border-radius:0 0 16px 16px}.modal__title{text-align:center;font-size:1.5em}.modal__actions{display:-webkit-box;display:-ms-flexbox;display:flex;z-index:1}.modal__action{-webkit-box-flex:1;-ms-flex:1;flex:1;border:0;border-radius:0}.modal__action:not(:first-child){border-left:1px solid #e4e8ed}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/ModalBase/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,OClEE,kBDmE0B,MAAG,QAAA,SAAA,OAAA,oBAC7B,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,kBACJ,CAEnB,eAAW,yBAAA,sBAAA,kBAAoB,CAAE,YACzB,wBAAA,qBAAA,sBAAwB,CAAE,mCAGhC,YAAa,CACd,mBC7ED,kBDgF4B,MAAG,QAAA,SAAA,OAAA,kCACoB,CAClD,gBEnDC,sBAxCQ,mBFgGR,UAAU,eG9FmC,CHgG9C,gBI5BC,kBJgCA,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,yBACtB,sBAAA,mBAAmB,iBACD,CACnB,4BAGC,2BK9HmB,CL+HpB,cAGC,kBAAkB,eACF,CACjB,gBAGC,oBAAA,oBAAA,aAAa,SACH,CACX,eAGC,mBAAA,WAAA,OAAO,SACE,eACO,CAHjB,iCAMG,6BEtJqB,CFuJtB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ModalBase Component\n */\n\n.modal{\n  @include position(absolute, 0);\n  display: flex;\n  justify-content: center;\n  pointer-events: all;\n\n  &--center{ align-items: center }\n  &--top{ align-items: flex-start }\n\n  &__background, &__wrapper{\n    display: none;  // default state\n  }\n\n  &__background{\n    @include position(absolute, 0);\n    background-color: transparentize(color(dark), .7);\n  }\n\n  &__wrapper{\n    @include bgcolor(bw1);\n    @include bgsize(xlarge);\n    width: 90%;\n    max-width: baseline(75);\n  }\n\n  &__content{\n    @include padding(baseline(3) baseline(10) baseline(3));\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  &--top &__wrapper{\n    border-radius: 0 0 radius(xlarge) radius(xlarge);\n  }\n\n  &__title{\n    text-align: center;\n    font-size: 1.5em;\n  }\n\n  &__actions{\n    display: flex;\n    z-index: 1;\n  }\n\n  &__action{\n    flex: 1;\n    border: 0;\n    border-radius: 0;\n\n    &:not(:first-child) {\n      border-left: 1px solid uicolor(border);\n    }\n  }\n}\n\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  DownloadAgreementModal Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1874);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var download_1 = __webpack_require__(424);
var download_2 = __webpack_require__(402);
var Button_1 = __webpack_require__(10);
var CheckboxWithLabel_1 = __webpack_require__(213);
var Modal = __webpack_require__(452);
var ModalAction;
(function (ModalAction) {
    ModalAction["Download"] = "download";
})(ModalAction || (ModalAction = {}));
var classes = new BEM('download-agreement-modal');

var DownloadAgreementModalBase = function (_React$Component) {
    _inherits(DownloadAgreementModalBase, _React$Component);

    function DownloadAgreementModalBase(props) {
        _classCallCheck(this, DownloadAgreementModalBase);

        var _this = _possibleConstructorReturn(this, (DownloadAgreementModalBase.__proto__ || Object.getPrototypeOf(DownloadAgreementModalBase)).call(this, props));

        _this.onModalClose = function (id) {
            _this.props.downloadContext.clear();
            if (id === ModalAction.Download) {
                if (_this.state.dontShowAgain) {
                    _this.props.downloadContext.setAgreementVisibility(false);
                }
            }
        };
        _this.onChangeCheckbox = function (dontShowAgain) {
            _this.setState({ dontShowAgain: dontShowAgain });
        };
        _this.state = {
            dontShowAgain: !_this.props.downloadContext.agreementVisibility
        };
        return _this;
    }

    _createClass(DownloadAgreementModalBase, [{
        key: "render",
        value: function render() {
            var _props$downloadContex = this.props.downloadContext,
                path = _props$downloadContex.filePath,
                dispatch = _props$downloadContex.dispatch,
                track = _props$downloadContex.track;

            return React.createElement(Modal.Component, Object.assign({ actions: React.createElement(React.Fragment, null, React.createElement(Modal.CancelAction, { label: "Cancel" }), React.createElement(Modal.Action, { id: ModalAction.Download, Element: React.createElement(Button_1.default, { onClick: function onClick() {
                            return dispatch(download_2.downloadTrack({ track: track }));
                        }, hyperLinkProps: {
                            href: path
                        }, wrapperComponent: "a", label: "Agree and Download" }) })), position: Modal.Position.Top, onClose: this.onModalClose }, classes()), React.createElement(Modal.Content, null, React.createElement(Modal.Title, null, "This download is for preview purposes only. You must purchase a license before using it in a production."), React.createElement("div", Object.assign({}, classes('checkbox')), React.createElement(CheckboxWithLabel_1.default, { label: "Don't show this again", name: "always-agree-download", checked: this.state.dontShowAgain, onChange: this.onChangeCheckbox }))));
        }
    }]);

    return DownloadAgreementModalBase;
}(React.Component);

var DownloadAgreementModalWithDownloadContext = function DownloadAgreementModalWithDownloadContext(props) {
    return React.createElement(download_1.DownloadContext.Consumer, null, function (ctx) {
        return !!ctx.filePath ? React.createElement(DownloadAgreementModalBase, Object.assign({ downloadContext: ctx }, props)) : null;
    });
};
exports.default = found_1.withRouter(DownloadAgreementModalWithDownloadContext);

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1875);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".download-agreement-modal .modal__title{margin-bottom:24px}.download-agreement-modal .modal__actions{border-top:1px solid #e4e8ed}.download-agreement-modal__checkbox{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:8px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/DownloadAgreementModal/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss"],"names":[],"mappings":"AA4GA,wCAGM,kBC5E2C,CDyEjD,0CAMM,4BEvGqB,CFwGtB,oCAID,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,iBCrFsB,CDuF9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * DownloadAgreementModal Component\n */\n\n.download-agreement-modal{\n  .modal{\n    &__title{\n      margin-bottom: baseline(3);\n    }\n    &__actions{\n      border-top: 1px solid uicolor(border);\n    }\n  }\n\n  &__checkbox{\n    display: flex;\n    justify-content: center;\n    margin-bottom: baseline(1);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  LicenseThisTrackModal Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var staticData_1 = __webpack_require__(103);
var relay_1 = __webpack_require__(93);
var licensePrice_1 = __webpack_require__(1877);
var track_1 = __webpack_require__(44);
__webpack_require__(1880);
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var trackLicensing_1 = __webpack_require__(432);
var AddToCartButton_1 = __webpack_require__(289);
var PriceTag_1 = __webpack_require__(126);
var TrackCard_1 = __webpack_require__(1882);
var Modal = __webpack_require__(452);
var classes = new BEM('license-track-modal');

var LicenseThisTrackModalBase = function (_React$Component) {
    _inherits(LicenseThisTrackModalBase, _React$Component);

    function LicenseThisTrackModalBase() {
        _classCallCheck(this, LicenseThisTrackModalBase);

        var _this = _possibleConstructorReturn(this, (LicenseThisTrackModalBase.__proto__ || Object.getPrototypeOf(LicenseThisTrackModalBase)).apply(this, arguments));

        _this.onModalClose = function () {
            _this.props.licensingContext.clearAll();
        };
        return _this;
    }

    _createClass(LicenseThisTrackModalBase, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                licenseString = _props.licenseString,
                track = _props.track;

            var price = track.price;
            var isTrackLicenseValid = track_1.canLicenseTrack(track);
            return React.createElement(Modal.Component, Object.assign({ actions: React.createElement(React.Fragment, null, React.createElement(Modal.CancelAction, { label: "Continue Browsing" }), isTrackLicenseValid && React.createElement(Modal.Action, { Element: React.createElement(AddToCartButton_1.default, { item: track }), id: "add-to-cart" })), position: Modal.Position.Top, onClose: this.onModalClose }, classes('', { invalid: !isTrackLicenseValid })), React.createElement(Modal.Content, null, isTrackLicenseValid ? React.createElement(Modal.Title, null, "Based on your selections, your license for the following track is\xA0", React.createElement(PriceTag_1.default, { amount: price, textColor: "accent" }), ".") : React.createElement(Modal.Title, { textColor: "dangerous" }, "We\u2019re sorry, this track cannot be licensed in your chosen territory.")), React.createElement(TrackCard_1.TrackCard, Object.assign({ licenseString: licenseString, track: track }, classes('card'))));
        }
    }]);

    return LicenseThisTrackModalBase;
}(React.Component);

var ConnectedLicenseThisTrackModal = react_redux_1.connect(function (state, _ref) {
    var licensingContext = _ref.licensingContext;

    var components = staticData_1.getLicenseComponents(state);
    var usages = license_1.setLicenseFromParams(components, licensingContext.usages);
    return {
        licenseString: license_1.getLicenseString(usages)
    };
})(LicenseThisTrackModalBase);
var LicenseThisTrackModalRelay = react_relay_1.createFragmentContainer(ConnectedLicenseThisTrackModal, licensePrice_1.LicensePriceFragment);

var LicenseThisTrackModalQueryRenderer = function (_React$Component2) {
    _inherits(LicenseThisTrackModalQueryRenderer, _React$Component2);

    function LicenseThisTrackModalQueryRenderer() {
        _classCallCheck(this, LicenseThisTrackModalQueryRenderer);

        return _possibleConstructorReturn(this, (LicenseThisTrackModalQueryRenderer.__proto__ || Object.getPrototypeOf(LicenseThisTrackModalQueryRenderer)).apply(this, arguments));
    }

    _createClass(LicenseThisTrackModalQueryRenderer, [{
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props$licensingConte = this.props.licensingContext,
                usages = _props$licensingConte.usages,
                trackSlug = _props$licensingConte.trackSlug;

            return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: licensePrice_1.LicensePriceQuery, variables: { trackSlug: trackSlug, usages: usages }, render: function render(_ref2) {
                    var error = _ref2.error,
                        props = _ref2.props;

                    if (error) {
                        return React.createElement("div", null, error.message);
                    } else if (props) {
                        return React.createElement(LicenseThisTrackModalRelay, Object.assign({}, props, _this3.props));
                    }
                    return null;
                } });
        }
    }]);

    return LicenseThisTrackModalQueryRenderer;
}(React.Component);

var LicenseThisTrackModalWithTrackLicensingContext = function LicenseThisTrackModalWithTrackLicensingContext(props) {
    return React.createElement(trackLicensing_1.TrackLicensingContext.Consumer, null, function (ctx) {
        return !!ctx.trackSlug && !!ctx.usages ? React.createElement(LicenseThisTrackModalQueryRenderer, Object.assign({ licensingContext: ctx }, props)) : null;
    });
};
exports.default = found_1.withRouter(LicenseThisTrackModalWithTrackLicensingContext);

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * License Price Relay Query
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.LicensePriceFragment = {
  track: function track() {
    return __webpack_require__(1878);
  }
};
exports.LicensePriceQuery = function () {
  return __webpack_require__(1879);
};

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type licensePrice_track$ref: FragmentReference;
export type licensePrice_track = {|
  +id: string,
  +internal_id: ?number,
  +price: ?number,
  +base_price: ?number,
  +title: ?string,
  +added_to_cart: ?boolean,
  +slug: ?string,
  +duration: ?number,
  +score: ?number,
  +boosted_score: ?number,
  +stems_available: ?boolean,
  +customizable: ?boolean,
  +matched_exclusions: ?$ReadOnlyArray<?number>,
  +tempos: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +value: ?number,
  |}>,
  +assets: ?$ReadOnlyArray<?{|
    +id: string,
    +version: ?string,
    +type: ?string,
    +file_format: ?string,
    +path: ?string,
    +metadata: ?any,
  |}>,
  +artist: ?{|
    +id: string,
    +name: ?string,
    +slug: ?string,
    +bio: ?string,
    +bandcamp: ?string,
    +facebook: ?string,
    +instagram: ?string,
    +itunes: ?string,
    +soundcloud: ?string,
    +spotify: ?string,
    +twitter: ?string,
    +wiki: ?string,
    +youtube: ?string,
    +homebase: ?string,
    +assets: ?$ReadOnlyArray<?{|
      +id: string,
      +version: ?string,
      +type: ?string,
      +file_format: ?string,
      +path: ?string,
      +metadata: ?any,
    |}>,
  |},
  +terms: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_highlighted: ?boolean,
        +name: ?string,
        +parent_id: ?string,
        +taxonomy: ?{|
          +id: string,
          +internal_id: ?number,
          +name: ?string,
        |},
      |},
    |}>,
  |},
  +collections: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +name: string,
        +slug: ?string,
        +category: ?{|
          +id: string,
          +name: ?string,
        |},
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
    |}>,
  |},
  +association_id: ?string,
  +selected_version: ?string,
  +$refType: licensePrice_track$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "licensePrice_track",
    "type": "TrackSearchResult",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "stems_available",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "base_price",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "added_to_cart",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "duration",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "score",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "boosted_score",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "customizable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "matched_exclusions",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "tempos",
      "storageKey": null,
      "args": null,
      "concreteType": "Tempo",
      "plural": true,
      "selections": [v0, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
      }]
    }, v4, {
      "kind": "LinkedField",
      "alias": null,
      "name": "artist",
      "storageKey": null,
      "args": null,
      "concreteType": "Artist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "itunes",
        "args": null,
        "storageKey": null
      }, v0, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bio",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "bandcamp",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "facebook",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "instagram",
        "args": null,
        "storageKey": null
      }, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "soundcloud",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "spotify",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "twitter",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "wiki",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "youtube",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "homebase",
        "args": null,
        "storageKey": null
      }, v4]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "terms",
      "storageKey": "terms(first:100)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 100,
        "type": "Int"
      }],
      "concreteType": "TaxonomyTermConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxonomyTermEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_highlighted",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "parent_id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "taxonomy",
            "storageKey": null,
            "args": null,
            "concreteType": "Taxonomy",
            "plural": false,
            "selections": [v0, v2, v3]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "collections",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionTrackConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CollectionTrackEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Collection",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, v3, v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionCategory",
            "plural": false,
            "selections": [v0, v3]
          }, v4]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "association_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_version",
      "args": null,
      "storageKey": null
    }]
  };
}();
node /*: any*/.hash = '4f48756ccceba2fcd53278c4e1e9494e';
module.exports = node;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 6f39d84e89820336434a6868879ee3d6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type licensePrice_track$ref = any;
export type licensePrice_QueryVariables = {|
  trackSlug?: ?string,
  usages?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
|};
export type licensePrice_QueryResponse = {|
  +track: ?{|
    +$fragmentRefs: licensePrice_track$ref,
  |},
|};
*/

/*
query licensePrice_Query(
  $trackSlug: String
  $usages: [LicenseUsageParamsInput]
) {
  track(slug: $trackSlug, license_params: $usages) {
    ...licensePrice_track
    id
  }
}

fragment licensePrice_track on TrackSearchResult {
  id
  internal_id
  price
  base_price
  title
  added_to_cart
  slug
  duration
  score
  boosted_score
  stems_available
  customizable
  matched_exclusions
  tempos {
    id
    name
    value
  }
  assets {
    id
    version
    type
    file_format
    path
    metadata
  }
  artist {
    id
    name
    slug
    bio
    bandcamp
    facebook
    instagram
    itunes
    soundcloud
    spotify
    twitter
    wiki
    youtube
    homebase
    assets {
      id
      version
      type
      file_format
      path
      metadata
    }
  }
  terms(first: 100) {
    edges {
      node {
        id
        is_highlighted
        name
        parent_id
        taxonomy {
          id
          internal_id
          name
        }
      }
    }
  }
  collections {
    edges {
      node {
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
      }
      id
    }
  }
  association_id
  selected_version
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "trackSlug",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "usages",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "license_params",
    "variableName": "usages",
    "type": "[LicenseUsageParamsInput]"
  }, {
    "kind": "Variable",
    "name": "slug",
    "variableName": "trackSlug",
    "type": "String"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "slug",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "internal_id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "assets",
    "storageKey": null,
    "args": null,
    "concreteType": "Asset",
    "plural": true,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "licensePrice_Query",
    "id": null,
    "text": "query licensePrice_Query(\n  $trackSlug: String\n  $usages: [LicenseUsageParamsInput]\n) {\n  track(slug: $trackSlug, license_params: $usages) {\n    ...licensePrice_track\n    id\n  }\n}\n\nfragment licensePrice_track on TrackSearchResult {\n  id\n  internal_id\n  price\n  base_price\n  title\n  added_to_cart\n  slug\n  duration\n  score\n  boosted_score\n  stems_available\n  customizable\n  matched_exclusions\n  tempos {\n    id\n    name\n    value\n  }\n  assets {\n    id\n    version\n    type\n    file_format\n    path\n    metadata\n  }\n  artist {\n    id\n    name\n    slug\n    bio\n    bandcamp\n    facebook\n    instagram\n    itunes\n    soundcloud\n    spotify\n    twitter\n    wiki\n    youtube\n    homebase\n    assets {\n      id\n      version\n      type\n      file_format\n      path\n      metadata\n    }\n  }\n  terms(first: 100) {\n    edges {\n      node {\n        id\n        is_highlighted\n        name\n        parent_id\n        taxonomy {\n          id\n          internal_id\n          name\n        }\n      }\n    }\n  }\n  collections {\n    edges {\n      node {\n        id\n        description\n        name\n        slug\n        category {\n          id\n          name\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n      }\n      id\n    }\n  }\n  association_id\n  selected_version\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "licensePrice_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "licensePrice_track",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "licensePrice_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "stems_available",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "base_price",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "added_to_cart",
          "args": null,
          "storageKey": null
        }, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "duration",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "score",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "boosted_score",
          "args": null,
          "storageKey": null
        }, v4, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customizable",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "matched_exclusions",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "tempos",
          "storageKey": null,
          "args": null,
          "concreteType": "Tempo",
          "plural": true,
          "selections": [v2, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          }]
        }, v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "artist",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "itunes",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bio",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "bandcamp",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "soundcloud",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "spotify",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "wiki",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtube",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "homebase",
            "args": null,
            "storageKey": null
          }, v6]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": "terms(first:100)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
          }],
          "concreteType": "TaxonomyTermConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TaxonomyTermEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_highlighted",
                "args": null,
                "storageKey": null
              }, v5, {
                "kind": "ScalarField",
                "alias": null,
                "name": "parent_id",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomy",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": false,
                "selections": [v2, v4, v5]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "collections",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionTrackConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, v5, v3, {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionCategory",
                "plural": false,
                "selections": [v2, v5]
              }, v6]
            }, v2]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "association_id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "selected_version",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
node /*: any*/.hash = '2846b1994a37171622748e7523f61278';
module.exports = node;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1881);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".license-track-modal__card{background-color:#f5faff;padding:16px 32px 16px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.license-track-modal__card__thumbnail{-webkit-box-flex:1;-ms-flex:1;flex:1}.license-track-modal__card__content{-webkit-box-flex:3;-ms-flex:3;flex:3;margin-left:16px}.license-track-modal__card__title{margin:0;font-size:1.5em}.license-track-modal__card__artist{margin:8px 0}.license-track-modal--invalid .license-track-modal__card{background-color:#fff5f5}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/LicenseThisTrackModal/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA6GE,2BCpCE,yBDsCA,4BACA,oBAAA,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAEnB,sCACE,mBAAA,WAAA,MAAO,CACR,oCAGC,mBAAA,WAAA,OAAO,gBErFoC,CFuF5C,kCAGC,SAAS,eACO,CACjB,mCAGC,YAAqB,CACtB,yDC1DD,wBAvDoB,CDsHrB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n *  LicenseThisTrackModal Component\n */\n\n.license-track-modal{\n  &__card{\n    @include bgcolor(accent-subtle);\n    padding: baseline(2) baseline(4) baseline(2) baseline(2);\n    display: flex;\n    align-items: center;\n\n    &__thumbnail{\n      flex: 1;\n    }\n\n    &__content{\n      flex: 3;\n      margin-left: baseline(2);\n    }\n\n    &__title{\n      margin: 0;\n      font-size: 1.5em;\n    }\n\n    &__artist{\n      margin: baseline(1) 0;\n    }\n  }\n\n  &--invalid &__card{\n    @include bgcolor(dangerous-subtle);\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackCard Component for LicenseThisTrackModal
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var track_1 = __webpack_require__(44);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);

var TrackCard = function (_React$Component) {
    _inherits(TrackCard, _React$Component);

    function TrackCard() {
        _classCallCheck(this, TrackCard);

        return _possibleConstructorReturn(this, (TrackCard.__proto__ || Object.getPrototypeOf(TrackCard)).apply(this, arguments));
    }

    _createClass(TrackCard, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                licenseString = _props.licenseString,
                track = _props.track;

            var classes = new BEM(className);
            var thumbnail = track_1.getResponsiveTrackThumbnail(track);
            return React.createElement("div", Object.assign({}, classes()), React.createElement(Thumbnail_1.default, Object.assign({ responsiveAssets: thumbnail, size: "large", withShadow: true, responsive: true }, classes('thumbnail'))), React.createElement("div", Object.assign({}, classes('content')), React.createElement(Heading_1.default, Object.assign({ is: "h4" }, classes('title')), track.title), React.createElement(Heading_1.default, Object.assign({ is: "h6" }, classes('artist')), track.artist.name), React.createElement(Label_1.Span, { variant: "description", textColor: "bw6", block: true }, licenseString)));
        }
    }]);

    return TrackCard;
}(React.Component);

exports.TrackCard = TrackCard;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackDetails Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var playerActions = __webpack_require__(42);
var ui_1 = __webpack_require__(29);
var license_1 = __webpack_require__(34);
var router_1 = __webpack_require__(1884);
var user_1 = __webpack_require__(317);
var date_1 = __webpack_require__(119);
var string_1 = __webpack_require__(47);
var track_1 = __webpack_require__(44);
__webpack_require__(1885);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_hot_keys_1 = __webpack_require__(401);
var react_redux_1 = __webpack_require__(5);
var player_1 = __webpack_require__(63);
var money_1 = __webpack_require__(285);
var AddToCartButton_1 = __webpack_require__(289);
var AddToProjectButton_1 = __webpack_require__(423);
var Button_1 = __webpack_require__(10);
var DownloadButton_1 = __webpack_require__(296);
var TrackLicenseBuilderButton_1 = __webpack_require__(661);
var LinkButton_1 = __webpack_require__(51);
var LinkButtonWithLicense_1 = __webpack_require__(651);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var PriceTag_1 = __webpack_require__(126);
var DropdownMenu_1 = __webpack_require__(297);
var ThumbnailWithPlayButton_1 = __webpack_require__(298);
var MakeAnOfferTooltip_1 = __webpack_require__(1887);
var Drawer_1 = __webpack_require__(215);
var Tag_1 = __webpack_require__(127);
var Cart_1 = __webpack_require__(224);
var Selector = __webpack_require__(1890);
var SimilarTracks_1 = __webpack_require__(1891);
var drawerClasses = new BEM('drawer');
var classes = new BEM('track-details');
var defaultList = [];

var TrackDetails = function (_React$Component) {
    _inherits(TrackDetails, _React$Component);

    function TrackDetails(props) {
        _classCallCheck(this, TrackDetails);

        var _this = _possibleConstructorReturn(this, (TrackDetails.__proto__ || Object.getPrototypeOf(TrackDetails)).call(this, props));

        _this.onKeyDown = function (_, _ref) {
            var preventDefault = _ref.preventDefault;

            preventDefault();
        };
        _this.onToggleDropdownMenu = function (downloadMenuOpen) {
            _this.setState({ downloadMenuOpen: downloadMenuOpen });
        };
        _this.onDownloadRequest = function () {
            _this.setState({ isOpen: false });
        };
        _this.state = {
            downloadMenuOpen: false,
            isOpen: true,
            hasSimilarTracks: true
        };
        return _this;
    }

    _createClass(TrackDetails, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.trackInfo.id !== this.props.trackInfo.id) {
                this.setState({
                    hasSimilarTracks: true
                });
            }
        }
    }, {
        key: "renderHeader",
        value: function renderHeader() {
            var _props = this.props,
                currency = _props.currency,
                currentVersionPlaying = _props.currentVersionPlaying,
                hasTrackExclusions = _props.hasTrackExclusions,
                trackCanBeLicensed = _props.trackCanBeLicensed,
                trackInfo = _props.trackInfo,
                trackIsInCart = _props.trackIsInCart;

            var title = trackInfo.title;
            var artist = trackInfo.artist.name;
            var defaultVersion = track_1.getDefaultTrackAsset(trackInfo.assets);
            var thumbnail = track_1.getResponsiveTrackThumbnail(trackInfo);
            var duration = track_1.getTrackDuration({ track: trackInfo, version: defaultVersion });
            var commerceButtonProps = Object.assign({ colorScheme: 'accent', variant: 'pill', size: 'medium', withShadow: true }, classes('button-add-to-cart'));
            return React.createElement("div", Object.assign({}, classes('header')), thumbnail.blur && React.createElement(Thumbnail_1.default, Object.assign({}, classes('header__background'), { src: thumbnail.blur[0].path, responsive: true })), React.createElement(ThumbnailWithPlayButton_1.default, Object.assign({ trackId: currentVersionPlaying || defaultVersion.id, responsiveAssets: thumbnail, size: "large", withShadow: true }, classes('thumbnail'))), React.createElement(Heading_1.default, Object.assign({ hyperLinkProps: {
                    href: track_1.getTrackPagePath(trackInfo)
                }, is: "h4", text: title }, classes('title'))), React.createElement(Label_1.Span, Object.assign({ hyperLinkProps: {
                    href: track_1.getArtistPagePath(trackInfo)
                }, text: artist, size: "medium", textColor: "bw7" }, classes('artist'))), !!duration && React.createElement(Label_1.Span, Object.assign({ text: date_1.getFormattedTime(duration), size: "small", textColor: "bw6" }, classes('duration'))), trackIsInCart ? React.createElement(LinkButton_1.default, Object.assign({ to: Cart_1.CartPagePath, label: "Track is in your cart", icon: React.createElement(Icon_1.IconInCart, null) }, commerceButtonProps, { withShadow: false })) : trackCanBeLicensed ? React.createElement(React.Fragment, null, React.createElement(AddToCartButton_1.default, Object.assign({ label: React.createElement(PriceTag_1.default, { amount: trackInfo.price, label: "License for" }), item: trackInfo }, commerceButtonProps)), React.createElement(MakeAnOfferTooltip_1.MakeAnOfferTooltip, { buttonClassName: "make-an-offer", artist: artist, trackTitle: title, trackPrice: money_1.getFormattedMoney(trackInfo.price, currency), withButton: true })) : hasTrackExclusions ? React.createElement(Button_1.default, Object.assign({ label: "This track cannot be licensed for the selected\xA0region.", icon: React.createElement(Icon_1.IconWarning, null), style: { mixBlendMode: 'multiply' }, disabled: true }, commerceButtonProps)) : React.createElement(TrackLicenseBuilderButton_1.default, Object.assign({ track: trackInfo.slug, label: "License This Track", icon: React.createElement(Icon_1.IconAddToCart, null), onSaveLicense: this.props.close }, commerceButtonProps)));
        }
    }, {
        key: "renderActions",
        value: function renderActions() {
            var _this2 = this;

            var _props2 = this.props,
                currentPage = _props2.currentPage,
                trackInfo = _props2.trackInfo;

            var downloadableAsset = track_1.getDefaultTrackAsset(trackInfo.assets);
            var artistPagePath = track_1.getArtistPagePath(trackInfo);
            var trackPagePath = track_1.getTrackPagePath(trackInfo);
            var versions = track_1.getTrackAssets({ assets: trackInfo.assets || defaultList, format: 'mp3', type: 'track-preview' });
            return React.createElement("div", Object.assign({}, classes('actions', '', 'drawer__button-list')), versions.length > 1 ? React.createElement(React.Fragment, null, React.createElement(DropdownMenu_1.default, { align: "justify", Button: React.createElement(Button_1.default, Object.assign({ icon: this.props.trackIsInProjects ? React.createElement(Icon_1.IconProjectSelected, null) : React.createElement(Icon_1.IconProject, null), label: "Save" }, drawerClasses('button-list__button'))), options: versions.map(function (asset) {
                    return React.createElement(AddToProjectButton_1.default, Object.assign({ key: "save-" + asset.version, showIcon: false, trackId: trackInfo.id, trackVersion: asset.version, label: string_1.capitalizeString(asset.version) }, drawerClasses('button-list__button')));
                }), requestClose: this.state.downloadMenuOpen === false, disableOnClickOutside: this.state.downloadMenuOpen === false, onToggle: this.onToggleDropdownMenu }), React.createElement(DropdownMenu_1.default, { align: "justify", Button: React.createElement(Button_1.default, Object.assign({ icon: React.createElement(Icon_1.IconDownload, null), label: "Download Preview MP3" }, drawerClasses('button-list__button'))), options: versions.map(function (asset) {
                    return React.createElement(DownloadButton_1.default, { key: "download-" + asset.version, icon: React.createElement(Icon_1.IconMusicNote, null), label: string_1.capitalizeString(asset.version), assetPath: asset.path, onDownloadRequest: _this2.onDownloadRequest, track: trackInfo });
                }), requestClose: this.state.downloadMenuOpen === false, disableOnClickOutside: this.state.downloadMenuOpen === false, onToggle: this.onToggleDropdownMenu })) : React.createElement(React.Fragment, null, React.createElement(AddToProjectButton_1.default, Object.assign({ trackId: trackInfo.id }, drawerClasses('button-list__button'))), React.createElement(DownloadButton_1.default, Object.assign({ assetPath: downloadableAsset.path, onDownloadRequest: this.onDownloadRequest, track: trackInfo }, drawerClasses('button-list__button')))), trackPagePath !== currentPage && React.createElement(LinkButtonWithLicense_1.default, Object.assign({ to: trackPagePath, external: true, label: "Go to Track", icon: React.createElement(Icon_1.IconMusicNote, null), lineItemLicense: Selector.getCartLineItem(this.props) }, drawerClasses('button-list__button'))), artistPagePath !== currentPage && React.createElement(LinkButtonWithLicense_1.default, Object.assign({ to: artistPagePath, external: true, label: "Go to Artist", icon: React.createElement(Icon_1.IconUser, null), lineItemLicense: Selector.getCartLineItem(this.props) }, drawerClasses('button-list__button'))));
        }
    }, {
        key: "renderVersions",
        value: function renderVersions() {
            var _props3 = this.props,
                currentVersionPlaying = _props3.currentVersionPlaying,
                pausePlayer = _props3.pausePlayer,
                playTrackVersion = _props3.playTrackVersion,
                trackInfo = _props3.trackInfo;

            var versions = track_1.getTrackAssets({ assets: trackInfo.assets || defaultList, format: 'mp3', type: 'track-preview' });
            var buttons = [];
            versions.forEach(function (_ref2, i) {
                var id = _ref2.id,
                    version = _ref2.version;

                var PlayButton = currentVersionPlaying === id ? Icon_1.IconPlayerPause : Icon_1.IconPlayerPlay;
                buttons.push(React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                        return currentVersionPlaying === id ? pausePlayer() : playTrackVersion(id, trackInfo);
                    }, key: id, label: string_1.capitalizeString(version) + " Version", icon: React.createElement(PlayButton, null) }, drawerClasses('button-list__button'))));
            });
            return versions.length > 1 && React.createElement("div", Object.assign({}, classes('versions', '', 'drawer__button-list'), { "data-title": "Versions" }), buttons);
        }
    }, {
        key: "renderMatchedTags",
        value: function renderMatchedTags() {
            var trackInfo = this.props.trackInfo;

            var terms = lodash_1.chain(trackInfo.terms.edges).map(function (_ref3) {
                var node = _ref3.node;
                return node;
            }).filter(function (_ref4) {
                var is_highlighted = _ref4.is_highlighted;
                return !!is_highlighted;
            }).value();
            return !!terms.length && React.createElement("div", Object.assign({}, classes('matched-tags', '', 'drawer__content-group'), { "data-title": "Matched Tags" }), terms.map(function (_ref5) {
                var id = _ref5.id,
                    name = _ref5.name;
                return React.createElement(Tag_1.default, { key: id, id: id, label: name, colorScheme: "light" });
            }));
        }
    }, {
        key: "render",
        value: function render() {
            var _props4 = this.props,
                className = _props4.className,
                displayInline = _props4.displayInline,
                license = _props4.license,
                trackInfo = _props4.trackInfo;

            var hasAttributes = !!trackInfo.stems_available || !!trackInfo.customizable;
            var content = React.createElement(React.Fragment, null, this.renderHeader(), this.renderActions(), this.renderVersions(), this.renderMatchedTags(), hasAttributes && React.createElement("div", Object.assign({}, classes('attributes', '', 'drawer__content-group'), { "data-title": "Attributes" }), trackInfo.stems_available && React.createElement(Tag_1.default, { id: "stems-available", label: "Stems available" }), trackInfo.customizable && React.createElement(Tag_1.default, { id: "customizable", label: "Customizable" })), React.createElement(SimilarTracks_1.SimilarTracks, { artistSlug: trackInfo.artist.slug, licenseParams: license_1.licenseUsagesToSearchParams(license), trackId: trackInfo.id, className: "drawer__content-group" }));
            return React.createElement(react_hot_keys_1.default, { keyName: "space", onKeyDown: this.onKeyDown }, displayInline ? React.createElement("div", Object.assign({}, classes('', 'inline', className)), content) : React.createElement(Drawer_1.default, Object.assign({ closeButtonLabel: "Close", floatingHeader: true, headerIcon: null, onClose: this.props.close, open: this.state.isOpen, position: "right" }, classes('', '', className)), content));
        }
    }]);

    return TrackDetails;
}(React.Component);

var ConnectedTrackDetails = react_redux_1.connect(function (state, ownProps) {
    return {
        currentPage: router_1.getLocationPathname(state),
        currentVersionPlaying: Selector.currentVersionPlaying(state, ownProps),
        hasTrackExclusions: Selector.getTrackHasExclusions(state, ownProps),
        license: Selector.getLicense(state, ownProps),
        trackCanBeLicensed: Selector.getTrackCanBeLicensed(state, ownProps),
        trackInfo: Selector.getTrackInfo(state, ownProps),
        trackIsInCart: Selector.getTrackIsInCart(state, ownProps),
        trackIsInProjects: Selector.isTrackInProjects(state, ownProps),
        userIsLoggedIn: user_1.isUserLoggedIn(state)
    };
}, function (dispatch, stateProps) {
    return {
        close: function close() {
            dispatch(ui_1.toggleTrackDetailsVisibility(false));
        },
        pausePlayer: function pausePlayer() {
            dispatch(playerActions.pause());
        },
        playTrackVersion: function playTrackVersion(trackId, trackInfo) {
            if (trackInfo) {
                dispatch(playerActions.addTracksToQueue({ tracks: player_1.getPlayerTracksFromResults([trackInfo]) }));
            }
            dispatch(playerActions.playTrackFromQueue({ trackId: trackId }));
        }
    };
})(TrackDetails);
exports.default = ConnectedTrackDetails;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Router Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(49);
exports.getRouterState = function (_ref) {
  var found = _ref.found;
  return found;
};
exports.getLocationPathname = reselect_1.createSelector(exports.getRouterState, function (_ref2) {
  var match = _ref2.match;
  return match.location.pathname;
});

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1886);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.track-details--inline{background-color:#fff;width:320px}html.touchevents .track-details--inline{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .track-details--inline{overflow-x:hidden;overflow-y:auto}.track-details>*{-webkit-box-flex:0;-ms-flex:none;flex:none}.track-details__header{background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:304px;padding:64px 24px 40px;z-index:0}.track-details__header__background{position:absolute;top:-25%;right:-25%;bottom:-25%;left:-25%}.track-details__header__background.thumbnail,.track-details__header__background.thumbnail .thumbnail__inner{border-radius:0}.track-details__header__background.thumbnail .thumbnail__inner{-webkit-filter:brightness(1.25);filter:brightness(1.25);opacity:.2}.track-details__header__background.thumbnail:after{content:\"\";position:absolute;right:0;bottom:0;left:0;height:216px;background-image:-webkit-gradient(linear,left bottom,left top,from(#fff),to(hsla(0,0%,100%,0)));background-image:-webkit-linear-gradient(bottom,#fff,hsla(0,0%,100%,0));background-image:-o-linear-gradient(bottom,#fff 0,hsla(0,0%,100%,0) 100%);background-image:linear-gradient(0deg,#fff 0,hsla(0,0%,100%,0))}.track-details__button-add-to-cart{margin-top:16px}.track-details__title{margin-top:20px;margin-bottom:4px;text-align:center}.track-details__duration{line-height:1.4545}.track-details__thumbnail.thumbnail--loading{mix-blend-mode:multiply}.track-details__button-close{position:absolute;top:0;right:0}.track-details__versions .button .icon{width:20px;min-height:0}.track-details__versions .button .icon svg{width:100%}.track-details__versions .button .label{font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.9375em;line-height:1.0667}.track-details .similar-tracks__list{padding-right:8px;padding-left:8px;width:100%}.track-details .similar-tracks__list .card__background{display:none}.track-details .similar-tracks__list .card__content__right{right:0}.track-details .make-an-offer{margin-top:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:1}.track-details .make-an-offer__info{margin-left:8px}.track-details .button.button--is-active .button__active-background{display:none}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/modals/TrackDetails/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,uBCuBpE,sBCuCA,WC7E6C,CD8E9C,wCCpGC,kBAAgD,kBACT,gCACN,CAClC,2CAEC,kBAAgD,eACX,CDyFzC,iBAOQ,mBAAA,cAAA,SAAW,CAAE,uBD1CjB,sBC8CA,oBAAA,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,iBAEnB,uBACA,SAAU,CAEV,mCErFF,kBFsF8B,SAAM,WAAA,YAAA,SAAA,CADjC,4GAKK,eAAgB,CALrB,+DASK,gCAAA,wBAAwB,UACb,CAVhB,mDAcK,WAAW,kBACe,QAAQ,SAAE,OAAE,aAGtC,gGAAA,wEAAA,0EAAA,+DAAgG,CACjG,mCAML,eCrH6C,CDsH9C,sBGrEqB,gBFjDyB,kBD0H7C,iBAAkB,CACnB,yBAGC,kBAAmB,CACpB,6CAIG,uBAAwB,CACzB,6BE7HH,kBFiI4B,MAAG,OAAE,CAChC,uCAKK,WACA,YAAa,CAJlB,2CAOO,UAAW,CAPlB,wCAYK,mEACA,kBAAkB,kBACC,CAhF3B,qCGnB0B,kBFtDuB,iBDiK3C,UAAW,CAxFjB,uDA0FQ,YAAa,CA1FrB,2DA6FQ,OAAQ,CA7FhB,8BAmGI,eACA,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,SACT,CAtGd,oCAyGM,eClL2C,CDyEjD,oEA8GI,YAAa,CACd","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * TrackDetails Drawer Component\n */\n\n.track-details{\n  &--inline{\n    @include bgcolor(white);\n    @include scroll;\n    width: baseline(40);\n  }\n\n  > * { flex: none }\n\n  &__header{\n    @include bgcolor(white);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: baseline(38);\n    padding: baseline(8) baseline(3) baseline(5);\n    z-index: 0;\n\n    &__background{\n      @include position(absolute, -25%);\n\n      &.thumbnail{\n        &, .thumbnail__inner{\n          border-radius: 0;\n        }\n\n        .thumbnail__inner{\n          filter: brightness(1.25);\n          opacity: .2;\n        }\n\n        &::after{\n          content: \"\";\n          @include position(absolute, null 0 0 0);\n          height: baseline(27);\n          // z-index: 1;\n          background-image: linear-gradient(to top, color(white) 0%, transparentize(color(white), 1) 100%);\n        }\n      }\n    }\n  }\n\n  &__button-add-to-cart{\n    margin-top: baseline(2);\n  }\n\n  &__title{\n    @include margin(baseline(2.5) null baseline(.5));\n    text-align: center;\n  }\n\n  &__duration{\n    line-height: 1.4545;\n  }\n\n  &__thumbnail{\n    &.thumbnail--loading{\n      mix-blend-mode: multiply;\n    }\n  }\n\n  &__button-close{\n    @include position(absolute, 0 0 null null);\n  }\n\n  &__versions{\n    .button{\n      .icon{\n        width: baseline(2.5);\n        min-height: 0;\n\n        svg{\n          width: 100%;\n        }\n      }\n\n      .label{\n        font-family: $font--articulat;\n        font-size: .9375em;\n        line-height: 1.0667;\n      }\n    }\n  }\n\n  .similar-tracks{\n    &__list{\n      @include padding(null baseline(1));\n      width: 100%;\n      .card__background{\n        display: none;\n      }\n      .card__content__right{\n        right: 0;\n      }\n    }\n  }\n\n  .make-an-offer{\n    margin-top: baseline(1);\n    display: flex;\n    align-items: center;\n    z-index: 1;\n\n    &__info {\n      margin-left: baseline(1);\n    }\n  }\n\n  .button.button--is-active .button__active-background {\n    display: none;\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * MakeAnOfferTooltip Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(34);
var staticData_1 = __webpack_require__(103);
var dom_1 = __webpack_require__(304);
__webpack_require__(1888);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var currency_1 = __webpack_require__(115);
var queryString_1 = __webpack_require__(30);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var Tooltip_1 = __webpack_require__(172);
// tslint:disable:max-line-length no-invalid-template-strings
var emailSubject = 'Bopper - Make An Offer';
var emailBody = "\nHello Bopper!\n%0D%0A\n%0D%0AI\u2019m interested in licensing the track '<%= trackTitle %>' by <%= artist %> and I would like to make you an offer.\n%0D%0A\n%0D%0AThe license fee quoted on Bopper for '<%= terms %>' is <%= trackPrice %> (<%= currency %>).\n%0D%0A\n%0D%0AHere is my proposed fee: (please enter your proposed fee)\n%0D%0AHere is my phone number: (please enter your phone number)\n%0D%0AAdditional info: (please enter any additional info)\n%0D%0A\n%0D%0APlease let me know if this is acceptable to you and your artist.\n%0D%0A\n%0D%0AThanks!\n%0D%0A (Your name)\n";
var mailto = lodash_1.template("mailto:<%= email %>?subject=" + emailSubject + "&body=" + emailBody);
var message = lodash_1.template('If this price is outside of your budget, please get in touch. We would be happy to try and accommodate you. Call ${phone} or email ${email}.');
// tslint:enable:max-line-length no-invalid-template-strings
exports.getMailtoLink = function (data) {
    return mailto(data);
};
var classes = new BEM('make-an-offer-tooltip');

var MakeAnOfferTooltipBase = function (_React$PureComponent) {
    _inherits(MakeAnOfferTooltipBase, _React$PureComponent);

    function MakeAnOfferTooltipBase() {
        _classCallCheck(this, MakeAnOfferTooltipBase);

        return _possibleConstructorReturn(this, (MakeAnOfferTooltipBase.__proto__ || Object.getPrototypeOf(MakeAnOfferTooltipBase)).apply(this, arguments));
    }

    _createClass(MakeAnOfferTooltipBase, [{
        key: "renderWithButton",
        value: function renderWithButton() {
            return React.createElement(Button_1.default, Object.assign({ label: "Make an offer", wrapperComponent: "a", hyperLinkProps: {
                    href: this.mailtoHref
                }, colorScheme: "light", size: "xsmall", variant: "pill", icon: this.renderTooltip(), iconPosition: "right", withShadow: true }, classes('cta')));
        }
    }, {
        key: "renderTooltip",
        value: function renderTooltip() {
            var _props = this.props,
                className = _props.className,
                email = _props.email,
                phone = _props.phone.phone_number,
                euPhone = _props.euPhone.phone_number,
                style = _props.style,
                withButton = _props.withButton;

            var phoneStr = phone + " (US) / " + euPhone + " (EU)";
            var extraClasses = classNames(className, withButton && 'button__icon');
            var tooltipContent = React.createElement("div", { onClick: dom_1.stopPropagation }, React.createElement(Label_1.Span, { size: "medium", block: true, text: message({
                    email: "<a class=\"button button--hyperlink\" href=\"" + this.mailtoHref + "\">" + email + "</a>",
                    phone: phoneStr
                }) }));
            return React.createElement(Tooltip_1.Tooltip, Object.assign({ content: tooltipContent, placement: "bottom", theme: "black", interactive: true }, classes('tooltip')), React.createElement(Icon_1.IconHelpFilled, Object.assign({}, classes('', '', extraClasses), { style: style })));
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.withButton ? this.renderWithButton() : this.renderTooltip();
        }
    }, {
        key: "mailtoHref",
        get: function get() {
            var _props2 = this.props,
                _props2$artist = _props2.artist,
                artist = _props2$artist === undefined ? '' : _props2$artist,
                currency = _props2.currency,
                email = _props2.email,
                phone = _props2.phone.phone_number,
                _props2$terms = _props2.terms,
                terms = _props2$terms === undefined ? '' : _props2$terms,
                _props2$trackPrice = _props2.trackPrice,
                trackPrice = _props2$trackPrice === undefined ? '' : _props2$trackPrice,
                _props2$trackTitle = _props2.trackTitle,
                trackTitle = _props2$trackTitle === undefined ? '' : _props2$trackTitle;

            return exports.getMailtoLink({ artist: artist, currency: currency, email: email, phone: phone, terms: terms, trackPrice: trackPrice, trackTitle: trackTitle });
        }
    }]);

    return MakeAnOfferTooltipBase;
}(React.PureComponent);

var MakeAnOfferTooltipWithCurrency = function MakeAnOfferTooltipWithCurrency(props) {
    return React.createElement(currency_1.CurrencyContext.Consumer, null, function (_ref) {
        var currency = _ref.currency;
        return React.createElement(MakeAnOfferTooltipBase, Object.assign({ currency: currency }, props));
    });
};
var MakeAnOfferTooltipWithTerms = function MakeAnOfferTooltipWithTerms(props) {
    return props.usages ? React.createElement(MakeAnOfferTooltipWithCurrency, Object.assign({ terms: license_1.getLicenseString(props.usages) }, props)) : React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref2) {
        var license_params = _ref2.license_params;

        var terms = license_1.getLicenseString(license_1.getLicenseUsagesFromQueryString({
            components: props.components,
            params: license_params || []
        }));
        return React.createElement(MakeAnOfferTooltipWithCurrency, Object.assign({ terms: terms }, props));
    });
};
exports.MakeAnOfferTooltip = react_redux_1.connect(function (state) {
    return {
        email: 'MakeAnOffer@boppermusic.com',
        phone: staticData_1.getBusinessMainPhoneNumber(state),
        euPhone: staticData_1.getBusinessEuropeanPhoneNumber(state),
        components: staticData_1.getLicenseComponents(state)
    };
})(MakeAnOfferTooltipWithTerms);

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".make-an-offer-tooltip{margin-left:8px}.make-an-offer-tooltip__cta{margin-top:8px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/molecules/messaging/MakeAnOfferTooltip/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,uBACE,eC1E+C,CD4E/C,4BACE,cC7E6C,CD8E9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * MakeAnOfferTooltip Component\n */\n\n.make-an-offer-tooltip{\n  margin-left: baseline(1);\n\n  &__cta{\n    margin-top: baseline(1);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TrackDetails Selectors
 */

Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(154);
var ProjectSelectors = __webpack_require__(295);
var track_1 = __webpack_require__(44);
var reselect_1 = __webpack_require__(49);
var getUIState = function getUIState(state) {
    return state.ui.trackDetails;
};
var getTrackInfoFromProps = function getTrackInfoFromProps(_, _ref) {
    var trackInfo = _ref.trackInfo;
    return trackInfo;
};
exports.getTrackInfo = reselect_1.createSelector([getUIState, getTrackInfoFromProps], function (_ref2, trackInfoProp) {
    var trackInfo = _ref2.trackInfo;
    return trackInfoProp || trackInfo;
});
exports.getLicense = reselect_1.createSelector(getUIState, function (_ref3) {
    var license = _ref3.license;
    return license || [];
});
exports.getCartInfo = function (_, props) {
    return props.cartInfo;
};
exports.isTrackInProjects = reselect_1.createSelector([ProjectSelectors.getProjects, exports.getTrackInfo], function (projects, trackInfo) {
    return ProjectSelectors.isTrackInProjects(projects, trackInfo.id);
});
exports.getCartLineItem = function (_ref4) {
    var cartInfo = _ref4.cartInfo,
        trackInfo = _ref4.trackInfo,
        trackIsInCart = _ref4.trackIsInCart;

    return trackIsInCart && !!cartInfo ? cartInfo.license_line_items.find(function (_ref5) {
        var track = _ref5.track;
        return track.id === trackInfo.id;
    }).license : undefined;
};
exports.currentVersionPlaying = reselect_1.createSelector([player_1.getPlayerState, exports.getTrackInfo], function (_ref6, trackInfo) {
    var currentTrack = _ref6.currentTrack,
        isTrackPlaying = _ref6.isTrackPlaying;

    return isTrackPlaying && currentTrack && currentTrack.trackId === trackInfo.id ? currentTrack.versionId : '';
});
exports.getTrackHasExclusions = reselect_1.createSelector(exports.getTrackInfo, track_1.trackHasExclusions);
exports.getTrackCanBeLicensed = reselect_1.createSelector(exports.getTrackInfo, track_1.canLicenseTrack);
exports.getTrackIsInCart = reselect_1.createSelector([exports.getCartInfo, exports.getTrackInfo], function (cartInfo, trackInfo) {
    return !!cartInfo && cartInfo.license_line_items.some(function (_ref7) {
        var track = _ref7.track;
        return track.id === trackInfo.id;
    });
});

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SimilarTracks Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var queryString_1 = __webpack_require__(30);
var Artist_1 = __webpack_require__(186);
var TrackList_1 = __webpack_require__(229);
var classes = new BEM('similar-tracks');

var SimilarTracksBase = function (_React$Component) {
    _inherits(SimilarTracksBase, _React$Component);

    function SimilarTracksBase(props) {
        _classCallCheck(this, SimilarTracksBase);

        var _this = _possibleConstructorReturn(this, (SimilarTracksBase.__proto__ || Object.getPrototypeOf(SimilarTracksBase)).call(this, props));

        _this.onTrackListResult = function (results) {
            if (!results || results.length === 0) {
                _this.setState({ hasSimilarTracks: false });
            } else if (_this.state.hasSimilarTracks === false) {
                _this.setState({ hasSimilarTracks: true });
            }
        };
        _this.artistPagePath = Artist_1.ArtistPagePath(props.artistSlug);
        _this.state = {
            hasSimilarTracks: true
        };
        return _this;
    }

    _createClass(SimilarTracksBase, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.artistSlug !== prevProps.artistSlug) {
                this.setState({ hasSimilarTracks: true });
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.state.hasSimilarTracks && location.pathname !== this.artistPagePath ? React.createElement("div", Object.assign({}, classes('', '', this.props.className), { "data-title": "More like this" }), React.createElement(TrackList_1.TrackListQuery, Object.assign({ actionSource: "track_details_list", cardProps: {
                    backgroundColor: 'white',
                    size: 'xsmall',
                    options: ['PriceElement', 'AddToProject', 'ShowDetails']
                }, excludeSearchResults: [], searchQuery: {
                    count: 5,
                    filters: {
                        similarity: {
                            track_id: this.props.trackId,
                            feature: "Default" /* Default */
                        }
                    },
                    license_params: this.props.licenseParams
                },
                // IMPORTANT: We don't want tracks from the details panel to keep getting added to the queue
                // any time it's opened. Each track will be added when its play button is clicked instead.
                shouldAddTracksToQueue: false, onResult: this.onTrackListResult }, classes('list')))) : null;
        }
    }]);

    return SimilarTracksBase;
}(React.Component);

exports.SimilarTracks = function (props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref) {
        var license_params = _ref.license_params;
        return React.createElement(SimilarTracksBase, Object.assign({ licenseParams: license_params }, props));
    });
};

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ErrorBoundary Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
// import { linkWithCurrentQueryString } from '../../../../utils/router';
__webpack_require__(1893);
var React = __webpack_require__(0);
// import * as BEM from 'react-bem-helper';
var react_redux_1 = __webpack_require__(5);
var notifications_1 = __webpack_require__(53);
// const classes = new BEM('error-boundary');

var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({ hasError: true });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(_, prevState) {
            if (this.state.hasError && !prevState.hasError) {
                this.props.dispatch(notifications_1.pushNotification({
                    // tslint:disable-next-line:max-line-length
                    message: 'Oops! Something went wrong. If the error persists, please reload the page.',
                    state: 'error',
                    autoDismiss: false
                }));
            }
        }
    }, {
        key: "render",
        value: function render() {
            // if (this.state.hasError) {
            //   return (
            //     <div {...classes()}>
            //       <IconWarningLarge {...classes('icon-error')} />
            //       <h1 {...classes('title')}>
            //         <span>Keep</span>
            //         <span>Calm</span>
            //         <small>And</small>
            //         <span>Refresh</span>
            //         <span>This Page</span>
            //       </h1>
            //       <Button
            //         hyperLinkProps={{
            //           href: linkWithCurrentQueryString(DiscoverPagePath),
            //         }}
            //         wrapperComponent="a"
            //         label="Refresh"
            //         size="large"
            //         colorScheme="white"
            //         variant="pill"
            //         icon={<IconClear style={{ transform: 'scaleX(-1) translateY(-50%)' }} />}
            //         withShadow
            //       />
            //     </div>
            //   );
            // }
            return this.props.children;
        }
    }]);

    return ErrorBoundary;
}(React.Component);

var ConnectedErrorBoundary = react_redux_1.connect()(ErrorBoundary);
exports.default = ConnectedErrorBoundary;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1894);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".error-boundary{background-color:#f0f6fa;color:#f75b5b;height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.error-boundary__icon-error{height:104px;width:104px}.error-boundary__icon-error svg{height:100%;width:100%}.error-boundary__title{text-transform:uppercase;text-align:center;font-weight:400;margin-bottom:64px}.error-boundary__title>*{display:block}.error-boundary__title small{font-size:40%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/ErrorBoundary/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss"],"names":[],"mappings":"AA4GA,gBCnCI,yBAzDuB,cDgGzB,aAAa,oBACb,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,wBACtB,qBAAA,uBAAuB,yBACvB,sBAAA,kBAAmB,CAEnB,4BE3EE,aAMA,WCd6C,CHmF9C,gCE3EC,YF+EoB,UAAA,CACnB,uBAID,yBAAyB,kBACP,gBACF,kBG9F6B,CH2F9C,yBAOG,aAAc,CAPjB,6BAWG,aAAc,CACf","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ErrorBoundary Component\n */\n\n.error-boundary{\n  @include bgcolor(bw3);\n  @include textcolor(dangerous);\n\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &__icon-error{\n    @include size(baseline(13));\n\n    svg{\n      @include size(100%);\n    }\n  }\n\n  &__title{\n    text-transform: uppercase;\n    text-align: center;\n    font-weight: 400;\n    margin-bottom: baseline(8);\n\n    > * {\n      display: block;\n    }\n\n    small{\n      font-size: 40%;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Header Component
 */

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1896);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var header_1 = __webpack_require__(1898);
var HeaderPosts_1 = __webpack_require__(664);
var AppNavigation_1 = __webpack_require__(1900);
var BrandNavigation_1 = __webpack_require__(732);
var classes = new BEM('app-header');
function Header(props) {
    var cartInfo = props.cartInfo,
        type = props.type,
        userProfile = props.userProfile,
        viewer = props.viewer;

    return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, classes('fixed-guard', _defineProperty({}, type, !!type)))), React.createElement("div", Object.assign({}, classes('', _defineProperty({}, type, !!type))), React.createElement("div", Object.assign({}, classes('upper-header')), React.createElement(BrandNavigation_1.BrandNavigation, null), React.createElement(HeaderPosts_1.default, { data: viewer && viewer.home_page && viewer.home_page.header_posts })), React.createElement(AppNavigation_1.AppNavigation, { cartInfo: cartInfo, userProfile: userProfile, type: type })));
}
var ConnectedHeader = react_redux_1.connect(function (_ref) {
    var cart = _ref.cart,
        user = _ref.user;
    return {
        itemsInCart: !!cart && cart.lineItems.length,
        isUserLoggedIn: user.isLoggedIn
    };
}, function (dispatch) {
    return { dispatch: dispatch };
})(Header);
var RelayHeader = react_relay_1.createFragmentContainer(ConnectedHeader, header_1.HeaderFragment);
exports.default = RelayHeader;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1897);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".app-header{background-color:#fff;padding:0 24px}.app-header__fixed-guard{height:64px;display:block}@media print{.app-header__fixed-guard{display:none}}.app-header__fixed-guard--extended{display:none}.app-header__fixed-guard--hybrid{height:399px}.app-header--extended .app-header__upper-header{margin-top:0;height:318px;opacity:1;overflow-y:visible;-webkit-transition:height .3s ease-out,margin-top .6s ease-out,opacity .6s ease-in-out;-o-transition:height .3s ease-out,margin-top .6s ease-out,opacity .6s ease-in-out;transition:height .3s ease-out,margin-top .6s ease-out,opacity .6s ease-in-out}.app-header--hybrid .app-header__upper-header{margin-top:0;height:0;display:none}.app-header--simple{position:fixed;top:0;right:0;left:0;-webkit-box-shadow:0 10px 40px rgba(0,13,36,.1);box-shadow:0 10px 40px rgba(0,13,36,.1);z-index:1000}.app-header--simple .app-header__upper-header{margin-top:-106px;height:106px;overflow-y:hidden;opacity:0;-webkit-transition:height .15s ease-out,margin-top .5s ease-in,opacity .3s ease-in;-o-transition:height .15s ease-out,margin-top .5s ease-in,opacity .3s ease-in;transition:height .15s ease-out,margin-top .5s ease-in,opacity .3s ease-in}.app-header--hybrid .app-nav{-webkit-box-shadow:0 10px 40px rgba(0,13,36,.1);box-shadow:0 10px 40px rgba(0,13,36,.1);position:fixed;top:0;right:0;left:0;background-color:#fff;padding:0 24px;-webkit-animation:app-nav-slide-down .2s ease-in-out;animation:app-nav-slide-down .2s ease-in-out;-webkit-transform-origin:top;-ms-transform-origin:top;transform-origin:top}@-webkit-keyframes app-nav-slide-down{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@keyframes app-nav-slide-down{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}.app-header__navbar{-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:64px;-webkit-box-shadow:0 -30px 60 #e4e8ed;box-shadow:0 -30px 60 #e4e8ed;padding:0 8px;z-index:1}.app-header__navbar .user-profile,.app-header__navbar__actions{display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:auto}.app-header__navbar__actions{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.app-header__navbar .user-profile{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.app-header__navbar__action__cart,.app-header__navbar__action__cart .button__wrapper{-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.app-header__navbar--floating{position:fixed;top:0;right:0;left:0;background-color:transparent}.app-header__navbar--floating .app-header__navbar__actions{position:absolute;top:16px;right:16px}.app-header__navbar--floating .app-header__navbar__actions .user-profile .thumbnail{width:39px}.app-header__navbar__action__cart{margin-right:12px}.app-header__navbar__action__cart .button__active-background{background-color:#fff;border-radius:50%;-webkit-box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);box-shadow:0 20px 40px 0 hsla(220,7%,57%,.25);top:0;bottom:0;-webkit-transition:.15s cubic-bezier(.175,.885,.32,1.275);-o-transition:.15s cubic-bezier(.175,.885,.32,1.275);transition:.15s cubic-bezier(.175,.885,.32,1.275)}.app-header__navbar__action__cart .button__wrapper{padding:6px}.app-header__navbar__action__cart .badge{position:absolute;top:-10%;right:-10%}.app-header__navbar__action__cart:hover .button__active-background{-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.app-header__navbar__dropdown-menu-container{position:absolute;top:64px;right:0;left:0}.app-header__navbar__logo svg{width:auto}@media print{.app-header,.app-header__fixed-guard,.app-header__navbar,.app-header__navbar__fixed-guard{display:none}}.app-header .scrollable-section{padding:0}.app-header .scrollable-section--header-posts{margin-top:0;height:260px}.app-header .scrollable-section__list-wrapper{padding:0;height:260px;overflow-y:visible}.app-header .scrollable-section__list{top:6px}.app-header .scrollable-section__list__item{width:400px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/Header/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss"],"names":[],"mappings":"AA4GA,YCnCI,sBDsCF,cE5E+C,CF8E/C,yBACE,YACA,aAAc,CAEd,aAJF,yBAKI,YAAa,CAUhB,CAPC,mCACE,YAAa,CACd,iCAGC,YAjF2B,CAkF5B,gDAKC,aAAa,aAC4C,UAC/C,mBACS,uFACnB,kFAAA,8EAAiF,CAClF,8CAKC,aAAa,SACJ,YACI,CACd,oBGvGH,eH2GyB,MAAG,QAAE,OAAO,gDACnC,wCAA8C,YACjC,CAHd,8CAMG,kBAAoE,aACL,kBAC7C,UACR,mFACV,8EAAA,0EAA6E,CAC9E,6BAKC,gDAAA,wCAA8C,eACvB,MAAG,QAAE,OAAO,sBACZ,eAGvB,qDAAA,6CAA6C,6BAChD,yBAAA,oBAAqB,CAErB,sCACC,GAAK,oCAAA,4BAA4B,SAAY,CAAA,GACtC,gCAAA,wBAAyB,SAAY,CAAA,CAF7C,8BACC,GAAK,oCAAA,4BAA4B,SAAY,CAAA,GACtC,gCAAA,wBAAyB,SAAY,CAAA,CAAA,oBAM5C,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,8BAA8B,yBAC9B,sBAAA,mBAAmB,YAEnB,sCAAA,8BACA,cACA,SAAU,CAEV,+DAEE,oBAAA,oBAAA,aAAa,gBACI,CAClB,6BAGC,0BAAA,uBAAA,mBAAoB,CAjBvB,kCAqBG,yBAAA,sBAAA,kBAAmB,CACpB,qFAIC,0DAAA,qDAAA,iDIrLuD,CJsLxD,8BGpKH,eHuK2B,MAAG,QAAE,OAAO,4BCpKtB,CDsKd,2DGzKH,kBH4K8B,SEnLiB,UAAA,CFkL5C,oFAKK,UEvLuC,CFwLxC,kCAKH,iBE7L2C,CF4L5C,6DCtJD,sBAvCU,kBIfQ,sDCdqC,8CNiOnD,MAAM,SAAW,0DACjB,qDAAA,iDI/MqD,CJuMxD,mDAYG,WExMyC,CF4L5C,yCGrLH,kBHqMgC,SAAM,UAAK,CAhBxC,mEAqBK,6BAAA,yBAAA,oBAAqB,CACtB,6CG3MP,kBHgN8B,SEvNiB,QFuNK,MAAO,CACxD,8BAIG,UAAW,CACZ,aApJP,0FAgKM,YAAa,CACd,CAjKL,gCAqKI,SAAU,CArKd,8CAyKI,aAAa,YA5OmB,CAmEpC,8CA8KI,UAAU,aAjPsB,kBAmPb,CAhLvB,sCAoLI,OE7P6C,CFyEjD,4CAuLM,WAAY,CACb","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * AppHeader Component\n */\n\n.app-header {\n  @include bgcolor(bw1);\n\n  padding: 0 baseline(3);\n\n  &__fixed-guard{\n    height: $app-nav-height-fixed;\n    display: block;\n\n    @media print {\n      display: none;\n    }\n\n    &--extended {\n      display: none;\n    }\n\n    &--hybrid {\n      height: $extended-header-height;\n    }\n  }\n\n  &--extended {\n    .app-header__upper-header {\n      margin-top: 0;\n      height: $brand-nav-height + $header-posts-carousel-height;\n      opacity: 1;\n      overflow-y: visible;\n      transition: height .3s ease-out, margin-top .6s ease-out, opacity .6s ease-in-out;\n    }\n  }\n\n  &--hybrid {\n    .app-header__upper-header {\n      margin-top: 0;\n      height: 0;\n      display: none;\n    }\n  }\n\n  &--simple {\n    @include position(fixed, 0 0 null 0);\n    box-shadow: 0px 10px 40px rgba(0, 13, 36, 0.1);\n    z-index: 1000;\n\n    .app-header__upper-header {\n      margin-top: -($brand-nav-height + $header-posts-carousel-height) / 3;\n      height: ($brand-nav-height + $header-posts-carousel-height) / 3;\n      overflow-y: hidden;\n      opacity: 0;\n      transition: height .15s ease-out, margin-top .5s ease-in, opacity .3s ease-in;\n    }\n  }\n\n  &--hybrid {\n    .app-nav {\n      box-shadow: 0px 10px 40px rgba(0, 13, 36, 0.1);\n      @include position(fixed, 0 0 null 0);\n      background-color: white;\n      padding: 0 baseline(3);\n\n      animation: app-nav-slide-down .2s ease-in-out;\n\t\t\ttransform-origin: top;\n\n\t\t\t@keyframes app-nav-slide-down {\n\t\t\t\t0% { transform: translateY(-100%); opacity: 0; }\n\t\t\t\t100% { transform: translateY(0%); opacity: 1; }\n      }\n    }\n  }\n\n  &__navbar {\n    flex: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: $app-header-height;\n    box-shadow: 0 -30px 60 uicolor(border);\n    padding: 0 baseline(1);\n    z-index: 1;\n\n    &__actions,\n    .user-profile{\n      display: flex;\n      margin-left: auto;\n    }\n\n    &__actions {\n      align-items: stretch;\n    }\n\n    .user-profile{\n      align-items: center;\n    }\n\n    &__action__cart,\n    &__action__cart .button__wrapper{\n      transition: .25s $ease-out-back;\n    }\n\n    &--floating{\n      @include position(fixed, 0 0 null 0);\n      @include bgcolor(none);\n    }\n\n    &--floating &__actions{\n      @include position(absolute, baseline(2) baseline(2) null null);\n\n      .user-profile{\n        .thumbnail{\n          width: baseline(4.875);\n        }\n      }\n    }\n\n    &__action__cart {\n      margin-right: baseline(1.5);\n\n      .button__active-background{\n        @include bgcolor(white);\n        @include bgsize(circle);\n        @include shadow(medium);\n        top: 0; bottom: 0;\n        transition: .15s $ease-out-back;\n      }\n\n      .button__wrapper{\n        padding: baseline(.75);\n      }\n\n      .badge{\n        @include position(absolute, -10% -10% null null);\n      }\n\n      &:hover{\n        .button__active-background{\n          transform: scale(1.1);\n        }\n      }\n    }\n\n    &__dropdown-menu-container{\n      @include position(absolute, $app-header-height 0 null 0);\n    }\n\n    &__logo{\n      svg{\n        width: auto;\n      }\n    }\n\n    @media print{\n      &, &__fixed-guard{\n        display: none;\n      }\n    }\n  }\n\n  @media print{\n    &, &__fixed-guard{\n      display: none;\n    }\n  }\n\n  .scrollable-section {\n    padding: 0;\n  }\n\n  .scrollable-section--header-posts {\n    margin-top: 0;\n    height: $header-posts-carousel-height;\n  }\n\n  .scrollable-section__list-wrapper {\n    padding: 0;\n    height: $header-posts-carousel-height;\n    overflow-y: visible;\n  }\n\n  .scrollable-section__list {\n    top: baseline(0.75);\n\n    &__item {\n      width: 400px;\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Relay for Header
 */

Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.HeaderFragment = {
  viewer: function viewer() {
    return __webpack_require__(1899);
  }
};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type header_viewer$ref: FragmentReference;
export type header_viewer = {|
  +home_page: ?{|
    +header_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +subtitle: string,
      +post_url: string,
      +image_url: string,
    |}>,
  |},
  +$refType: header_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "header_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "home_page",
    "storageKey": null,
    "args": null,
    "concreteType": "HomePageContent",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "header_posts",
      "storageKey": null,
      "args": null,
      "concreteType": "HomePagePost",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "subtitle",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "post_url",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "image_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }]
};
node /*: any*/.hash = '2c5683cdc0b501df488ff5ea63e6384c';
module.exports = node;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1901);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var postAuthenticationRequests_1 = __webpack_require__(81);
var ui_1 = __webpack_require__(29);
var router_1 = __webpack_require__(27);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var Badge_1 = __webpack_require__(427);
var Icon_1 = __webpack_require__(12);
var DropdownMenu_1 = __webpack_require__(297);
var Browse_1 = __webpack_require__(61);
var Cart_1 = __webpack_require__(224);
var Projects_1 = __webpack_require__(319);
var DropdownMenus_1 = __webpack_require__(1903);
var Login_1 = __webpack_require__(152);
var SearchBox_1 = __webpack_require__(1909);
var UserProfile_1 = __webpack_require__(639);
var CartButton = function CartButton(_ref) {
    var className = _ref.className,
        label = _ref.label,
        activeClassName = _ref.activeClassName;
    return React.createElement(LinkButton_1.default, { to: Cart_1.CartPagePath, className: className, activeClassName: activeClassName }, React.createElement(Icon_1.IconCart, null), React.createElement(Badge_1.default, { label: "" + label, variant: "notification" }));
};
var classes = new BEM('app-nav');
var buttonProps = {
    size: 'large'
};
var linkButtonProps = Object.assign({ activeClassName: 'button--is-active' }, buttonProps);

var AppNavComponent = function (_React$Component) {
    _inherits(AppNavComponent, _React$Component);

    function AppNavComponent(props) {
        _classCallCheck(this, AppNavComponent);

        var _this = _possibleConstructorReturn(this, (AppNavComponent.__proto__ || Object.getPrototypeOf(AppNavComponent)).call(this, props));

        _this.onToggleDropdownMenu = function (id) {
            return function (open) {
                _this.setState({ activeDropdownMenu: open ? id : undefined });
            };
        };
        _this.state = {
            activeDropdownMenu: ''
        };
        return _this;
    }

    _createClass(AppNavComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                cartInfo = _props.cartInfo,
                isUserLoggedIn = _props.isUserLoggedIn,
                userProfile = _props.userProfile,
                type = _props.type;

            var hasItemsInCart = cartInfo && cartInfo.license_line_items && cartInfo.license_line_items.length;
            return React.createElement("div", Object.assign({}, classes('', _defineProperty({}, type, !!type))), React.createElement(LinkButton_1.default, Object.assign({ variant: "icon", icon: React.createElement(Icon_1.LogoBopper, null) }, classes('logo'), { size: "small", includeQsParams: true, to: Browse_1.BrowsePagePath })), React.createElement(SearchBox_1.SearchBox, { size: type === 'extended' ? 'medium' : 'small' }), React.createElement("nav", Object.assign({}, classes('nav')), React.createElement(LinkButton_1.default, Object.assign({ to: Browse_1.BrowsePagePath, label: "Browse\xA0Music" }, linkButtonProps)), isUserLoggedIn ?
            // tslint:disable-next-line:max-line-length
            React.createElement(LinkButton_1.default, Object.assign({ to: Projects_1.ProjectsPagePath, iconPosition: "right", icon: React.createElement(Icon_1.IconProject, null), label: "Saved" }, linkButtonProps)) : React.createElement(DropdownMenu_1.default, { Button: React.createElement(Button_1.default, Object.assign({ iconPosition: "right", icon: React.createElement(Icon_1.IconProject, null), label: "Saved" }, buttonProps)), options: this.getLogInDropDownMenuOptions(), requestClose: this.state.activeDropdownMenu !== 'playlists', disableOnClickOutside: this.state.activeDropdownMenu !== 'playlists', onToggle: this.onToggleDropdownMenu('playlists') }), React.createElement(DropdownMenu_1.default, { menu: "help", Button: React.createElement(Button_1.default, Object.assign({ label: "Help" }, buttonProps)), options: DropdownMenus_1.HelpDropDownMenuOptions, requestClose: this.state.activeDropdownMenu !== 'help', disableOnClickOutside: this.state.activeDropdownMenu !== 'help', onToggle: this.onToggleDropdownMenu('help') }), React.createElement(CartButton, Object.assign({ label: hasItemsInCart ? cartInfo.license_line_items.length : '0' }, classes('nav__cart'))), React.createElement(DropdownMenu_1.default, Object.assign({ menu: "account",
                // tslint:disable-next-line:max-line-length
                Button: isUserLoggedIn && React.createElement(Button_1.default, Object.assign({ label: React.createElement(UserProfile_1.default, { profile: userProfile }) }, buttonProps)) || React.createElement(React.Fragment, null), options: isUserLoggedIn ? DropdownMenus_1.AccountDropDownMenuOptions : this.getLogInDropDownMenuOptions(), requestClose: this.state.activeDropdownMenu !== 'account', disableOnClickOutside: this.state.activeDropdownMenu !== 'account', onToggle: this.onToggleDropdownMenu('account'), align: "right" }, classes('account'))), !isUserLoggedIn ? React.createElement(React.Fragment, null, React.createElement(LinkButton_1.default, Object.assign({ to: Login_1.LoginPagePath, label: "Log In" }, linkButtonProps)), React.createElement(LinkButton_1.default, Object.assign({ to: Login_1.SignupPagePath, colorScheme: "dark", label: "Create Account" }, linkButtonProps, classes('signup'), { size: "small" }))) : React.createElement(React.Fragment, null)));
        }
    }, {
        key: "getLogInDropDownMenuOptions",
        value: function getLogInDropDownMenuOptions() {
            return [React.createElement(Button_1.default, Object.assign({ key: "login", label: "Log In", onClick: this.props.showLogInForm }, buttonProps)), React.createElement(Button_1.default, Object.assign({ key: "signup", label: "Sign Up", onClick: this.props.showSignUpForm }, buttonProps))];
        }
    }]);

    return AppNavComponent;
}(React.Component);
// tslint:disable-next-line:max-line-length


var ConnectedAppNav = react_redux_1.connect(function (_ref2, props) {
    var cart = _ref2.cart,
        found = _ref2.found,
        user = _ref2.user;
    return Object.assign({ itemsInCart: !!cart && cart.lineItems.length, currentLocation: found.match.location, isUserLoggedIn: user.isLoggedIn }, props);
}, function (dispatch) {
    return { dispatch: dispatch };
}, function (stateProps, _ref3) {
    var dispatch = _ref3.dispatch;
    return Object.assign({}, stateProps, { showLogInForm: function showLogInForm() {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: router_1.createHref(stateProps.currentLocation) }));
            dispatch(ui_1.toggleLogInFormVisibility(true));
        }, showSignUpForm: function showSignUpForm() {
            dispatch(postAuthenticationRequests_1.pushPostAuthenticationRequestPage({ page: router_1.createHref(stateProps.currentLocation) }));
            dispatch(ui_1.toggleSignUpFormVisibility(true));
        } });
})(AppNavComponent);
exports.AppNavigation = ConnectedAppNav;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1902);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".app-nav{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:81px;padding-bottom:15px;width:100%}.app-nav--hybrid,.app-nav--simple{height:64px;padding-bottom:0}.app-nav__logo{margin-right:12px}.app-nav__logo svg{height:40px!important;width:40px!important}.app-nav--extended .app-nav__logo{display:none}.app-nav .search-box{margin-right:12px}.app-nav__nav{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-flex:3;-ms-flex:3;flex:3;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.app-nav__nav .button--large.with--icon.icon-position--right:not(.button--text) .button__wrapper{padding-right:34px}.app-nav__nav .button--large.with--icon.icon-position--right:not(.button--text) .button__active-background{right:2px}.app-nav__nav .button--large.with--icon.icon-position--right:not(.button--text) .button__icon{right:10px;top:55%}.app-nav__nav .button--large.with--icon.icon-position--right:not(.button--text) .button__icon svg{width:22px;height:22px}.app-nav__nav .button--large.with--icon.icon-position--right:not(.button--text) .button__icon svg path{stroke-width:1px;stroke:#8a8f99}.app-nav .button--large .button__wrapper{padding-right:12px;padding-left:12px}.app-nav .button--large .button__wrapper .button__label,.app-nav .button--large .button__wrapper .label{font-weight:700;font-size:13px}.app-nav__signup.button .button__wrapper{font-weight:700}.app-nav__account.button{background:-webkit-gradient(linear,left top,left bottom,from(#75dbbe),to(#4384f9));background:-webkit-linear-gradient(top,#75dbbe,#4384f9);background:-o-linear-gradient(top,#75dbbe,#4384f9);background:linear-gradient(180deg,#75dbbe,#4384f9);border-radius:32px;padding:1px;border-width:0;margin-left:16px}.app-nav__account.button .button__wrapper{padding:3px;border-radius:32px;background-color:#fff}.app-nav__account.button .button__wrapper .thumbnail{width:32px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/AppNavigation/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GA,SACE,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,YAvEsD,oBADlC,UAqF5B,CAPX,kCACE,YACA,gBAAiB,CAClB,eAWC,iBC/F6C,CD0F9C,mBAEG,sBAAuB,oBACD,CACvB,kCAKD,YAAa,CA1BjB,qBA8BI,iBCvG6C,CDwG9C,cAGC,oBAAA,oBAAA,aAAa,qBACb,kBAAA,yBAAyB,mBACzB,WAAA,OAAO,yBAEP,sBAAA,kBAAmB,CALpB,iGASK,kBAAmB,CATxB,2GAaK,SAAU,CAbf,8FAgBK,WACA,OAAQ,CAjBb,kGAmBO,WAAW,WACC,CApBnB,uGAsBS,iBAAiB,cE7JL,CFsGxB,yCGnB0B,mBFtDuB,iBAAA,CDyEjD,wGAkEQ,gBAAiB,cACF,CAChB,yCAOD,eAAiB,CAClB,yBAGC,mFAAA,wDAAA,mDAAA,mDAAwD,mBAExD,YAAY,eACG,gBC3J4B,CDuJ9C,0CAOK,YAAY,mBAEZ,qBAAuB,CAT5B,qDAWO,UClKuC,CDmKxC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * AppNavigation Component\n */\n\n.app-nav {\n  display: flex;\n  align-items: center;\n  // @include bgcolor(bw1);\n\n  height: $app-nav-height-initial;\n  padding-bottom: $header-post-carousel-bottom-offset;\n\n  &--simple, &--hybrid {\n    height: $app-nav-height-fixed;\n    padding-bottom: 0;\n  }\n\n\n\n  width: 100%;\n\n  &__logo {\n    svg {\n      height: 40px !important;\n      width: 40px !important;\n    }\n    margin-right: baseline(1.5);\n  }\n\n  &--extended &__logo {\n    display: none;\n  }\n\n  .search-box {\n    margin-right: baseline(1.5);\n  }\n\n  &__nav {\n    display: flex;\n    justify-content: flex-end;\n    flex: 3;\n\n    align-items: center;\n\n    .button--large.with--icon.icon-position--right:not(.button--text) {\n      .button__wrapper {\n        padding-right: 34px;\n      }\n      .button__active-background {\n        // Need to offset the bg due to the offset icon\n        right: 2px;\n      }\n      .button__icon {\n        right: baseline(1.25);\n        top: 55%;\n        svg {\n          width: 22px;\n          height: 22px;\n          path {\n            stroke-width: 1px;\n            stroke: color(bw7);\n          }\n        }\n      }\n    }\n  }\n\n  .button--large {\n    .button__wrapper {\n      .button__label, .label {\n        font-weight: bold;\n        font-size: 13px;\n      }\n      @include padding(null baseline(1.5));\n    }\n  }\n\n  &__signup.button {\n    .button__wrapper {\n      font-weight: bold;\n    }\n  }\n  &__account.button {\n      background: linear-gradient(to bottom, #75DBBE, #4384F9);\n      border-radius: baseline(4);\n      padding: 1px;\n      border-width: 0;\n      margin-left: baseline(2);\n      .button__wrapper {\n        padding: 3px;\n        border-radius: baseline(4);\n        background-color: white;\n        .thumbnail {\n          width: baseline(4);\n        }\n      }\n    }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * DropdownMenus for Header
 */

Object.defineProperty(exports, "__esModule", { value: true });
var olark_1 = __webpack_require__(451);
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(10);
var LinkButton_1 = __webpack_require__(51);
var LogoutButton_1 = __webpack_require__(1904);
var Orders_1 = __webpack_require__(302);
var Profile_1 = __webpack_require__(725);
var FAQ_1 = __webpack_require__(277);
var BrandNavigation_1 = __webpack_require__(732);
exports.AccountDropDownMenuOptions = [React.createElement(LinkButton_1.default, { key: "my-orders", label: "My Orders", size: "medium", to: Orders_1.OrdersPagePath }), React.createElement(LinkButton_1.default, { key: "my-profile", label: "My Profile", size: "medium", to: Profile_1.ProfilePagePath }), '-', React.createElement(LogoutButton_1.default, { key: "logout", size: "medium", withIcon: true })];
exports.HelpDropDownMenuOptions = [React.createElement(LinkButton_1.default, { key: "faq", label: "FAQ", size: "medium", to: FAQ_1.FAQPagePath }), React.createElement(Button_1.default, { key: "pricing", label: "Pricing", size: "medium", wrapperComponent: "a", hyperLinkProps: {
        href: BrandNavigation_1.PricingPagePath,
        target: '_blank'
    } }), React.createElement(Button_1.default, { key: "chat", label: "Chat with our experts ", size: "medium", onClick: olark_1.default.expand }), '-', React.createElement(Button_1.default, { key: "about", label: "About Us", size: "medium", wrapperComponent: "a", hyperLinkProps: {
        href: BrandNavigation_1.AboutUsPagePath,
        target: '_blank'
    } }), React.createElement(Button_1.default, { key: "contact", label: "Contact Page", size: "medium", wrapperComponent: "a", hyperLinkProps: {
        href: '/contact',
        target: '_blank'
    } }), '-', React.createElement(Button_1.default, { key: "terms-conditions", label: "Terms and Conditions", size: "medium", wrapperComponent: "a", hyperLinkProps: {
        href: '/terms-and-conditions',
        target: '_blank'
    } }), React.createElement(Button_1.default, { key: "privacy", label: "Privacy Policy", size: "medium", wrapperComponent: "a", hyperLinkProps: {
        href: '/privacy-policy',
        target: '_blank'
    } })];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * LogoutButton Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1905);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var Icon_1 = __webpack_require__(12);
var Button_1 = __webpack_require__(10);

var LogoutButton = function (_React$Component) {
    _inherits(LogoutButton, _React$Component);

    function LogoutButton() {
        _classCallCheck(this, LogoutButton);

        return _possibleConstructorReturn(this, (LogoutButton.__proto__ || Object.getPrototypeOf(LogoutButton)).apply(this, arguments));
    }

    _createClass(LogoutButton, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                logoutUrl = _a.logoutUrl,
                withIcon = _a.withIcon,
                buttonProps = __rest(_a, ["logoutUrl", "withIcon"]);
            var logOutButtonProps = Object.assign({ hyperLinkProps: {
                    href: logoutUrl
                }, wrapperComponent: 'a' }, buttonProps);
            if (withIcon) {
                logOutButtonProps.icon = React.createElement(Icon_1.IconSignOut, null);
                logOutButtonProps.iconPosition = 'right';
            }
            return React.createElement(Button_1.default, Object.assign({}, logOutButtonProps));
        }
    }]);

    return LogoutButton;
}(React.Component);

LogoutButton.defaultProps = {
    label: 'Log Out'
};
var ConnectedLogoutButton = react_redux_1.connect(function (_ref, ownProps) {
    var authentication = _ref.authentication;
    return {
        logoutUrl: authentication.logoutUrl
    };
}, function () {
    return {};
})(LogoutButton);
exports.default = ConnectedLogoutButton;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1906);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"styles.scss","sourceRoot":""}]);

// exports


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1908);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".brand-navigation{height:58px;padding-top:6px;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.brand-navigation,.brand-navigation__logo-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.brand-navigation__logo-wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.brand-navigation__logo-wrapper .button--medium.button--icon,.brand-navigation__logo-wrapper .button--medium.button--icon .button__wrapper{width:125px}.brand-navigation__logo svg{height:40px!important;width:125px!important}.brand-navigation__tagline{font-style:normal;font-weight:500;font-size:10px;padding-top:2px;letter-spacing:.2em;text-transform:uppercase;color:#b1b8c4}.brand-navigation__links{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-flex:1;-ms-flex:1;flex:1}.brand-navigation__links a{text-decoration:none;margin-left:24px;font-style:normal;font-size:12px;letter-spacing:.3em;text-transform:uppercase;color:#101015!important}.brand-navigation__links a .button__wrapper{padding:0}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/BrandNavigation/styles.scss"],"names":[],"mappings":"AAyGA,kBACE,YArE+D,gBAD5B,WAwExB,yBAGX,sBAAA,8BAA8B,8BAC9B,6BAAA,uBAAA,kBAAmB,CAEnB,kDAJA,oBAAA,oBAAA,YAAa,CAIb,gCAEE,yBAAA,sBAAA,kBAAmB,CAFpB,2IAIG,WAAY,CACb,4BAKC,sBAAuB,qBACA,CACxB,2BAID,kBAAkB,gBACF,eACD,gBACC,oBACK,yBACI,aACX,CACf,yBAGC,oBAAA,oBAAA,aAAa,qBACb,kBAAA,yBAAyB,mBACzB,WAAA,MAAO,CAHR,2BAMG,qBAAqB,iBAErB,kBAAkB,eAEH,oBACM,yBACI,uBAGO,CAfnC,4CAkBK,SAAU,CACX","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n\n.brand-navigation {\n  height: $brand-nav-height;\n  padding-top: $header-post-carousel-top-offset;\n  width: 100%;\n\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n\n  &__logo-wrapper {\n    display: flex;\n    align-items: center;\n    .button--medium.button--icon, .button--medium.button--icon .button__wrapper {\n      width: 125px;\n    }\n  }\n\n  &__logo {\n    svg {\n      height: 40px !important;\n      width: 125px !important;\n    }\n  }\n\n  &__tagline {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    padding-top: 2px;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    color: #B1B8C4;\n  }\n\n  &__links {\n    display: flex;\n    justify-content: flex-end;\n    flex: 1;\n\n    a {\n      text-decoration: none;\n      margin-left: baseline(3);\n      font-style: normal;\n      // font-weight: 500;\n      font-size: 12px;\n      letter-spacing: 0.3em;\n      text-transform: uppercase;\n\n      /* Neutral / Darkest */\n      color: color(\"black\") !important;\n\n      .button__wrapper {\n        padding: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1910);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var locales_1 = __webpack_require__(52);
var portal_1 = __webpack_require__(666);
var classes = new BEM('search-box');

var SearchBox = function (_React$Component) {
    _inherits(SearchBox, _React$Component);

    function SearchBox(props) {
        _classCallCheck(this, SearchBox);

        var _this = _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call(this, props));

        _this.onSearchInput = function (_ref) {
            var target = _ref.target;

            _this.setState({ searchInput: target.value });
        };
        _this.onCloseInstantSearch = function () {
            _this.setState({ searchInput: '' });
        };
        _this.state = {
            searchInput: ''
        };
        return _this;
    }

    _createClass(SearchBox, [{
        key: "render",
        value: function render() {
            // const hasFilters = false;
            var size = this.props.size;

            return React.createElement("div", Object.assign({}, classes('')), React.createElement(TextField_1.default, Object.assign({ name: "search-box", placeholder: size === 'small' ? 'Search' : locales_1.default.search.placeholder, size: size, icon: React.createElement(Icon_1.IconSearch, null), onChange: this.onSearchInput, value: this.state.searchInput, isControlled: true }, classes('search', _defineProperty({}, size, !!size)))), this.state.searchInput !== '' && React.createElement(portal_1.InstantSearchPortal, { initialInput: this.state.searchInput, onSearchInput: this.onSearchInput, onClose: this.onCloseInstantSearch }));
        }
    }]);

    return SearchBox;
}(React.Component);

exports.SearchBox = SearchBox;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.search-box svg{stroke-width:2px}.search-box__search{-webkit-transition:ease-in-outs .3s;-o-transition:.3s ease-in-outs;transition:ease-in-outs .3s;min-width:200px}.search-box__search .textfield__background{-webkit-box-shadow:0 1px #fff;box-shadow:0 1px #fff;border-radius:80px;border-width:0;height:40px;background-color:#f0f6fa}.search-box__search .textfield__input{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;font-weight:400;line-height:1.230769231;height:38px}.search-box__search .textfield__input .label{display:inline-block}@media screen and (min-width:600px){.search-box__search .textfield__input{font-size:.9375em;line-height:1.3333333333}}.search-box__search.textfield:after{content:\"\";border-top-right-radius:80px;border-bottom-right-radius:80px;position:absolute;top:0;right:0;bottom:0;width:40px;background-image:-webkit-gradient(linear,right top,left top,color-stop(40%,#f0f6fa),to(rgba(240,246,250,0)));background-image:-webkit-linear-gradient(right,#f0f6fa 40%,rgba(240,246,250,0));background-image:-o-linear-gradient(right,#f0f6fa 40%,rgba(240,246,250,0) 100%);background-image:linear-gradient(270deg,#f0f6fa 40%,rgba(240,246,250,0))}.search-box__search.textfield .textfield__icon{left:15px}.search-box__search.textfield input{padding-left:48px}.search-box--normal .search-box__search{width:256px}.search-box__search--small{width:272px}.search-box__search--large,.search-box__search--medium{width:512px;max-width:1440px}.search-box__search--large .textfield__background,.search-box__search--medium .textfield__background{height:48px}.search-box__search--large .textfield__input,.search-box__search--medium .textfield__input{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.8125em;font-weight:400;line-height:1.230769231;height:46px}.search-box__search--large .textfield__input .label,.search-box__search--medium .textfield__input .label{display:inline-block}@media screen and (min-width:600px){.search-box__search--large .textfield__input,.search-box__search--medium .textfield__input{font-size:.9375em;line-height:1.3333333333}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/SearchBox/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,gBC4DpE,gBAAiB,CAClB,oBAGC,oCAAA,+BAAA,4BAA8B,eC/Ee,CD8E9C,2CAKG,8BAAA,sBACA,mBACA,eAAe,YACH,wBEzGS,CFiGxB,sCCrCC,mCAJqC,kCAKH,mEEhEpC,8CAAA,yCAAA,sCAAsC,kBAuGpB,gBACF,wBHWZ,WAAY,CAff,6CGjGC,oBAAqB,CACtB,oCHgGA,sCGYC,kBAXqB,wBAYI,CHGxB,CAhBF,oCAoBK,WAAW,6BAEX,gCACA,kBAAkB,MACZ,QACE,SACC,WAET,6GAAA,gFAAA,gFAAA,wEAIC,CAhCN,+CAoCK,SAAuB,CApC5B,oCAwCK,iBCtHyC,CDuH1C,wCAKH,WC5H6C,CD6H9C,2BAGC,WChI6C,CDiI9C,uDAEC,YACA,gBCpI6C,CDkI9C,qGAKG,WAAY,CALf,2FCzFC,mCAJqC,kCAKH,mEEhEpC,8CAAA,yCAAA,sCAAsC,kBAuGpB,gBACF,wBH2DZ,WAAY,CAXf,yGGrJC,oBAAqB,CACtB,oCHoJA,2FGxCC,kBAXqB,wBAYI,CHmDxB,CAAA","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n\n@import '../../../atoms/text/Heading/mixins';\n\n.search-box {\n\n  svg {\n    stroke-width: 2px;\n  }\n\n  &__search {\n    transition: 0.30s ease-in-outs;\n    min-width: baseline(25);\n\n    .textfield__background {\n      box-shadow: 0 1px color(bw1);\n      border-radius: baseline(10);\n      border-width: 0;\n      height: 40px;\n      background-color: uicolor(search-background);\n    }\n\n    .textfield__input {\n      @include base-heading;\n      @include h5(true);\n      height: 38px;\n    }\n\n    &.textfield {\n      &::after {\n        content: '';\n        border-top-right-radius: baseline(10);\n        border-bottom-right-radius: baseline(10);\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        width: baseline(5);\n        background-image: linear-gradient(\n          to left,\n          uicolor(search-background) 40%,\n          transparentize(uicolor(search-background), 1) 100%\n        );\n      }\n\n      .textfield__icon {\n        left: baseline(2) - 1px;\n      }\n\n      input {\n        padding-left: baseline(6);\n      }\n    }\n  }\n\n  &--normal &__search {\n    width: baseline(32);\n  }\n\n  &__search--small {\n    width: baseline(34);\n  }\n  &__search--medium, &__search--large {\n    width: baseline(64);\n    max-width: baseline(180);\n\n    .textfield__background {\n      height: 48px;\n    }\n\n    .textfield__input {\n      @include base-heading;\n      @include h5(true);\n      height: 46px;\n    }\n    // .textfield__inline-button {\n    //   @include bgcolor(bw1);\n    //   top: 1px;\n    //   right: 1px;\n    //   bottom: 1px;\n    //   width: baseline(7);\n    //   height: auto;\n\n    //   &::before {\n    //     content: '';\n    //     position: absolute;\n    //     top: 0;\n    //     right: 100%;\n    //     bottom: 0;\n    //     width: baseline(3);\n    //     background-image: linear-gradient(\n    //       to left,\n    //       color(bw1) 0%,\n    //       transparentize(color(bw1), 1) 100%\n    //     );\n    //   }\n    // }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Player Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(42);
var uiActions = __webpack_require__(29);
var player_1 = __webpack_require__(154);
var projects_1 = __webpack_require__(295);
var colors_1 = __webpack_require__(57);
var grid_1 = __webpack_require__(58);
__webpack_require__(733);
var React = __webpack_require__(0);
var react_audio_player_1 = __webpack_require__(1914);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var velocity_react_1 = __webpack_require__(19);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Thumbnail_1 = __webpack_require__(66);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var Track_1 = __webpack_require__(231);
var PlayerProgressBar_1 = __webpack_require__(1923);
var PlayerTrackTerms_1 = __webpack_require__(1924);
var classes = new BEM('player');

var Player = function (_React$Component) {
    _inherits(Player, _React$Component);

    function Player(props) {
        _classCallCheck(this, Player);

        var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

        _this.onKeyDown = function (_ref) {
            var key = _ref.key,
                srcElement = _ref.srcElement,
                target = _ref.target;

            var currentTarget = target || srcElement;
            var targetTagName = currentTarget.tagName.toLowerCase();
            if (['input', 'textarea'].indexOf(targetTagName) > -1) {
                return;
            }
            switch (key) {
                case ' ':
                    _this.props.togglePlay();
                    break;
                case 'ArrowRight':
                    _this.props.playNext();
                    break;
                case 'ArrowLeft':
                    _this.props.playPrevious();
                    break;
                case 'Enter':
                    _this.audioPlayer.currentTime += _this.state.duration * .2;
                    break;
                case 'Backspace':
                    _this.audioPlayer.currentTime -= _this.state.duration * .2;
                    break;
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                case '0':
                    _this.audioPlayer.currentTime = _this.state.duration * (parseInt(key, 10) / 10);
                    break;
                case 'i':
                    _this.onClickDetailsButton();
                    break;
            }
        };
        _this.onListenTick = function (e) {
            if (_this.audioPlayer) {
                _this.props.updateCurrentTrackElapsedTime(_this.audioPlayer.currentTime);
            }
        };
        _this.onLoadedMetadata = function (e) {
            var duration = _this.audioPlayer.duration;

            _this.setState({
                duration: duration,
                metadataLoaded: true,
                remainingTime: duration
            });
        };
        _this.willSeek = function (percentage) {
            _this.audioPlayer.currentTime = _this.state.duration * percentage;
        };
        _this.onSeeked = function () {
            _this.props.play();
        };
        _this.onTrackEnded = function () {
            _this.props.playNext();
        };
        _this.onClickDetailsButton = function () {
            if (_this.props.trackDetailsIsOpen) {
                _this.props.toggleTrackDetailsVisibility(false);
            } else {
                _this.props.showTrackDetails();
            }
        };
        _this.onClickProjectButton = function () {
            if (_this.props.addToProjectIsOpen) {
                _this.props.toggleAddToProjectVisibility(false);
            } else {
                _this.props.addToProject();
            }
        };
        _this.onClickTermsButton = function () {
            _this.setState(function (prevState) {
                return { termListIsOpen: !prevState.termListIsOpen };
            }, function () {
                setTimeout(function () {
                    _this.props.toggleTermListVisibility(_this.state.termListIsOpen);
                }, _this.state.termListIsOpen ? 400 : 0);
            });
        };
        _this.state = {
            duration: 0,
            elapsedTime: 0,
            isInProject: false,
            termListIsOpen: false,
            isTrackPlaying: true,
            metadataLoaded: false,
            remainingTime: 0
        };
        return _this;
    }

    _createClass(Player, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if (this.audioPlayer) {
                this.audioPlayer.volume = 1;
            }
            document.addEventListener('keydown', this.onKeyDown);
            this.showTermListTimer = window.setTimeout(function () {
                _this2.setState({ termListIsOpen: true }, function () {
                    setTimeout(function () {
                        _this2.props.toggleTermListVisibility(_this2.state.termListIsOpen);
                    }, 400);
                });
            }, 2000);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            clearTimeout(this.showTermListTimer);
            document.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _this3 = this;

            if (this.props.isTrackPlaying && !prevProps.isTrackPlaying) {
                this.audioPlayer.play();
            } else if (!this.props.isTrackPlaying && prevProps.isTrackPlaying) {
                this.audioPlayer.pause();
            }
            if (this.props.currentTrack && prevProps.currentTrack) {
                if (this.props.currentTrack.audioFile !== prevProps.currentTrack.audioFile) {
                    this.setState({
                        duration: this.props.currentTrack.duration,
                        elapsedTime: 0,
                        metadataLoaded: false,
                        remainingTime: this.props.currentTrack.duration
                    });
                } else {
                    if (this.props.currentTrack.elapsedTime !== prevProps.currentTrack.elapsedTime) {
                        this.setState({
                            elapsedTime: this.props.currentTrack.elapsedTime,
                            // tslint:disable-next-line:max-line-length
                            remainingTime: this.state.remainingTime - (this.props.currentTrack.elapsedTime - prevProps.currentTrack.elapsedTime)
                        });
                    }
                }
            }
            if (prevProps.isTrackPlaying !== this.props.isTrackPlaying) {
                setTimeout(function () {
                    if (_this3.state.isTrackPlaying !== _this3.props.isTrackPlaying) {
                        _this3.setState({ isTrackPlaying: _this3.props.isTrackPlaying });
                    }
                }, 100);
            }
            if (prevProps.termListIsOpen !== this.props.termListIsOpen && this.props.termListIsOpen !== this.state.termListIsOpen) {
                this.onClickTermsButton();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                addToProjectIsOpen = _props.addToProjectIsOpen,
                trackDetailsIsOpen = _props.trackDetailsIsOpen,
                trackIsInProjects = _props.trackIsInProjects,
                trackTerms = _props.trackTerms;
            var _state = this.state,
                duration = _state.duration,
                elapsedTime = _state.elapsedTime,
                termListIsOpen = _state.termListIsOpen,
                isTrackPlaying = _state.isTrackPlaying,
                metadataLoaded = _state.metadataLoaded,
                remainingTime = _state.remainingTime;

            var currentTrack = this.props.currentTrack;
            var imageInnerProps = {};
            if (currentTrack.image) {
                imageInnerProps.style = { backgroundImage: "url(" + currentTrack.imageBlurred + ")" };
            }
            var ProjectIcon = trackIsInProjects ? Icon_1.IconProjectSelected : Icon_1.IconProject;
            var optionButtonProps = {
                variant: 'icon',
                className: 'track__option'
            };
            var classModifiers = {
                'is-playing': isTrackPlaying,
                'is-buffering': !metadataLoaded
            };
            return React.createElement("div", Object.assign({}, classes('', classModifiers)), React.createElement(react_audio_player_1.default, { ref: function ref(node) {
                    if (node && node.audioEl) {
                        _this4.audioPlayer = node.audioEl;
                    }
                }, src: "/" + currentTrack.audioFile, listenInterval: 250, onEnded: this.onTrackEnded, onListen: this.onListenTick, onLoadedMetadata: this.onLoadedMetadata, onSeeked: this.onSeeked, autoPlay: true }), React.createElement(velocity_react_1.VelocityComponent, { animation: { translateY: termListIsOpen ? [0, '100%'] : ['100%', 0] }, duration: 250, display: termListIsOpen ? 'block' : 'none' }, React.createElement(PlayerTrackTerms_1.default, { track: currentTrack.trackInfo, onClose: this.onClickTermsButton, open: termListIsOpen, slug: currentTrack.trackInfo.slug, terms: trackTerms })), React.createElement("div", Object.assign({}, classes('background')), React.createElement("div", Object.assign({}, classes('background__inner'), imageInnerProps))), React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement("div", Object.assign({}, classes('controls')), React.createElement(Button_1.default, { onClick: this.props.playPrevious, icon: React.createElement(Icon_1.IconPlayerPrevious, null), variant: "icon", disabled: currentTrack.isFirstInQueue, backgroundColor: colors_1.transparent }), React.createElement(Button_1.default, { onClick: isTrackPlaying ? this.props.pause : this.props.play, icon: isTrackPlaying ? React.createElement(Icon_1.IconPlayerPause, null) : React.createElement(Icon_1.IconPlayerPlay, null), variant: "icon", backgroundColor: colors_1.transparent }), React.createElement(Button_1.default, { onClick: this.props.playNext, icon: React.createElement(Icon_1.IconPlayerNext, null), variant: "icon", disabled: currentTrack.isLastInQueue, backgroundColor: colors_1.transparent })), React.createElement("div", Object.assign({}, classes('track-details')), React.createElement(Thumbnail_1.default, Object.assign({ src: currentTrack.image, size: grid_1.baseline * 7 }, classes('track-image'))), React.createElement("div", Object.assign({}, classes('track-info')), React.createElement(Heading_1.default, Object.assign({ is: "h5", text: currentTrack.title, maxTextLength: 15, hyperLinkProps: {
                    href: Track_1.TrackPagePath(currentTrack.trackInfo.slug)
                } }, classes('track-info__title'))), React.createElement(Label_1.Span, Object.assign({ text: currentTrack.artist, size: "small", textColor: "bw7" }, classes('track-info__subtitle')))), React.createElement(Button_1.default, Object.assign({ onClick: this.onClickProjectButton, icon: React.createElement(ProjectIcon, null) }, optionButtonProps, { className: addToProjectIsOpen ? 'track__option track__option--active' : 'track__option' })), React.createElement(Button_1.default, Object.assign({ onClick: this.onClickTermsButton, icon: React.createElement(Icon_1.IconFilter, null) }, optionButtonProps, { className: termListIsOpen ? 'track__option track__option--filters track__option--active' : 'track__option track__option--filters' })), React.createElement(Button_1.default, Object.assign({ onClick: this.onClickDetailsButton, icon: React.createElement(Icon_1.IconMore, null) }, optionButtonProps, { className: trackDetailsIsOpen ? 'track__option track__option--active' : 'track__option' }))), React.createElement(PlayerProgressBar_1.default, { duration: duration, elapsedTime: elapsedTime, metadataLoaded: metadataLoaded, onSeek: this.willSeek, onDragStart: this.props.pause, remainingTime: remainingTime ? -remainingTime : currentTrack.duration })));
        }
    }]);

    return Player;
}(React.Component);

var ConnectedPlayer = react_redux_1.connect(function (state) {
    return {
        addToProjectIsOpen: projects_1.isAddToProjectOpen(state),
        currentTrack: player_1.getCurrentTrack(state),
        isTrackPlaying: player_1.getIsTrackPlaying(state),
        termListIsOpen: player_1.isTermListOpen(state),
        trackDetailsIsOpen: player_1.isTrackDetailsOpen(state),
        trackIsInProjects: projects_1.isCurrentPlayingTrackInProject(state),
        trackTerms: player_1.getTermsForCurrentlyPlayingTrack(state)
    };
}, function (dispatch) {
    return {
        dispatch: dispatch,
        pause: function pause() {
            return dispatch(actions.pause());
        },
        play: function play() {
            return dispatch(actions.play());
        },
        playNext: function playNext() {
            return dispatch(actions.playNext());
        },
        playPrevious: function playPrevious() {
            return dispatch(actions.playPrevious());
        },
        togglePlay: function togglePlay() {
            return dispatch(actions.togglePlay());
        },
        toggleAddToProjectVisibility: function toggleAddToProjectVisibility(visible) {
            return dispatch(uiActions.toggleAddToProjectVisibility(visible));
        },
        toggleTermListVisibility: function toggleTermListVisibility(visible) {
            return dispatch(uiActions.togglePlayerTermListVisibility(visible));
        },
        toggleTrackDetailsVisibility: function toggleTrackDetailsVisibility(visible) {
            return dispatch(uiActions.toggleTrackDetailsVisibility(visible));
        },
        updateCurrentTrackElapsedTime: function updateCurrentTrackElapsedTime(elapsedTime) {
            return dispatch(actions.updateCurrentTrackElapsedTime({ elapsedTime: elapsedTime }));
        }
    };
}, function (stateProps, _a) {
    var dispatch = _a.dispatch,
        dispatchProps = __rest(_a, ["dispatch"]);
    return Object.assign({}, stateProps, dispatchProps, { addToProject: function addToProject() {
            var _stateProps$currentTr = stateProps.currentTrack,
                trackId = _stateProps$currentTr.trackId,
                version = _stateProps$currentTr.version;

            return dispatch(uiActions.showAddTrackToProjectForm({ trackId: trackId, trackVersion: version }));
        }, showTrackDetails: function showTrackDetails() {
            return dispatch(uiActions.showTrackDetails({ trackInfo: stateProps.currentTrack.trackInfo }));
        } });
})(Player);
exports.default = ConnectedPlayer;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".player{position:fixed;right:0;bottom:0;left:0;-webkit-transition:background-color .5s ease-in-out;-o-transition:background-color .5s ease-in-out;transition:background-color .5s ease-in-out;-webkit-animation:show-player .25s cubic-bezier(.445,.05,.55,.95) both;animation:show-player .25s cubic-bezier(.445,.05,.55,.95) both}@-webkit-keyframes show-player{0%{-webkit-transform:translateY(100%);transform:translateY(100%)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes show-player{0%{-webkit-transform:translateY(100%);transform:translateY(100%)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.player--is-playing .player__background{background-color:#fff}.player__background{position:absolute;right:0;bottom:0;left:0;background-color:#f9fafb;-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom;height:56px;overflow:hidden;pointer-events:none}.player__background__inner{height:100%;width:100%;-webkit-filter:blur(20px) contrast(3);filter:blur(20px) contrast(3);-webkit-transform:translateY(-80%);-ms-transform:translateY(-80%);transform:translateY(-80%);-webkit-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s;opacity:0;background-size:cover;background-position:50%}.player--is-playing .player__background__inner{opacity:.15}.player__track-terms__wrapper,.player__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.player__wrapper{padding-right:72px;padding-left:16px;height:56px;-webkit-box-shadow:0 -1px #e4e8ed;box-shadow:0 -1px #e4e8ed;-webkit-animation:show-player-wrapper .25s cubic-bezier(.445,.05,.55,.95) .25s both;animation:show-player-wrapper .25s cubic-bezier(.445,.05,.55,.95) .25s both}@-webkit-keyframes show-player-wrapper{0%{opacity:0}to{opacity:1}}@keyframes show-player-wrapper{0%{opacity:0}to{opacity:1}}.player__track-details{-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.player__track-details .track__option{height:56px;width:56px;border:0;border-left:1px solid #e4e8ed;border-radius:0}.player__track-details .track__option--active,.player__track-details .track__option:hover{background-color:#fff}.player__track-details .track__option--filters.track__option--active{top:-1px}.player__track-image.thumbnail,.player__track-image.thumbnail .thumbnail__inner{border-radius:0}.player__track-info{margin-top:-1px;margin-right:24px;margin-left:16px}.player__track-info__title{margin:0}.player__track-info__subtitle{display:block}.player__track-progress{padding-right:16px;padding-left:16px;border-left:1px solid #e4e8ed;border-right:1px solid #e4e8ed;-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.player__track-progress__duration{-webkit-box-flex:0;-ms-flex:none;flex:none}.player__track-progress__duration--elapsed{display:none}.player__progress-bar{margin-right:8px;margin-left:8px;-webkit-box-flex:1;-ms-flex:auto;flex:auto;height:2px}.player__progress-bar:hover .player__progress-bar__tracker{background-color:#e4e8ed;-webkit-transition-duration:.1s;-o-transition-duration:.1s;transition-duration:.1s;width:calc(100% + 8px);height:8px;-webkit-transform:translateX(-4px) translateY(-3px);-ms-transform:translateX(-4px) translateY(-3px);transform:translateX(-4px) translateY(-3px);border-radius:4px}.player__progress-bar__hitzone{position:absolute;top:-16px;right:0;bottom:-16px;left:0;cursor:pointer;z-index:2}.player__progress-bar__tracker{height:100%;width:100%;background-color:#d2d9e1;-webkit-transition:.25s ease-in-out;-o-transition:.25s ease-in-out;transition:.25s ease-in-out;-webkit-transform-origin:left;-ms-transform-origin:left;transform-origin:left}.player--is-buffering .player__progress-bar__tracker{background-color:#e4e8ed}.player__progress-bar__progress{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#8a8f99;clip:rect(0 0 2px 0);-webkit-transition:clip 0s linear;-o-transition:clip 0s linear;transition:clip 0s linear}.player--is-buffering .player__progress-bar__progress{-webkit-transition-duration:.25s;-o-transition-duration:.25s;transition-duration:.25s;-webkit-transition-timing-function:ease-in-out;-o-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out}.player__controls{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:16px}.player__controls .button{height:56px}.player__controls .button:not([disabled]):hover{color:#4487ff}.player__track-terms{background-color:#fff;border-bottom:1px solid #e4e8ed;height:80px;padding:20px 0}html.touchevents .player__track-terms{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .player__track-terms{overflow-x:hidden;overflow-y:auto}.player__track-terms__wrapper{width:100%;padding-right:24px;padding-left:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.player__track-terms__title{margin:9px 0;min-width:80px}.player__track-terms__list{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 0 0 16px;padding:0}.player__track-terms__term{-webkit-transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);transition:-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275);-o-transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275);transition:transform .25s cubic-bezier(.175,.885,.32,1.275),-webkit-transform .25s cubic-bezier(.175,.885,.32,1.275)}.player__track-terms__term:hover{-webkit-transform:translateY(-5%)!important;-ms-transform:translateY(-5%)!important;transform:translateY(-5%)!important}.player__track-terms__button-find-similar,.player__track-terms__button-view-all{margin-left:8px;top:4px}.player__track-terms__button-close{border-radius:50%;margin-left:auto;top:8px}.player__track-terms__button-close,.player__track-terms__button-view-all,.player__track-terms__title{-webkit-box-flex:0;-ms-flex:none;flex:none}@media screen and (min-width:768px){.player__track-progress__duration--elapsed{display:block}}@media print{.player{display:none}}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/global/Player/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_size.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,QClEE,eDmEuB,QAAQ,SAAE,OAAE,oDACnC,+CAAA,4CAA4C,uEAE5C,8DAAkD,CAQlD,+BACE,GACE,mCAAA,0BAA2B,CAAA,GAG3B,gCAAA,uBAAwB,CAAA,CAL5B,uBACE,GACE,mCAAA,0BAA2B,CAAA,GAG3B,gCAAA,uBAAwB,CAAA,CAAA,wCEpD1B,qBAvCU,CFiGX,oBCzFD,kBD4F4B,QAAQ,SAAE,OAAE,yBAEtC,gCAAA,4BAAA,wBAAwB,YAExB,gBAAgB,mBACI,CAEpB,2BGlGA,YHmGoB,WAAA,sCAClB,8BAA8B,mCAC9B,+BAAA,2BAA2B,+BAC3B,0BAAA,uBAAuB,UACb,sBACY,uBACK,CAE3B,+CACE,WAAY,CACb,+CAKH,oBAAA,oBAAA,YAAa,CACd,iBIrEuB,mBCtDuB,kBL+H7C,YACA,kCAAA,0BAEA,oFAAA,2EAA+D,CAE/D,uCACE,GACE,SAAU,CAAA,GAGV,SAAU,CAAA,CALd,+BACE,GACE,SAAU,CAAA,GAGV,SAAU,CAAA,CAAA,uBAMd,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAHpB,sCGtIC,YER6C,WLqJ3C,SAAS,8BAET,eAAgB,CATnB,0FExGC,qBAvCU,CF+IX,qEAgBK,QAAS,CACV,gFAMD,eAAgB,CACjB,oBIrHmB,gBJoIA,kBKrLyB,gBAAA,CLuL7C,2BACE,QAAS,CACV,8BAGC,aAAc,CACf,wBIvIqB,mBCtDuB,kBLkM7C,8BACA,+BAEA,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,yBACb,sBAAA,kBAAmB,CAEnB,kCACE,mBAAA,cAAA,SAAU,CAEV,2CACE,YAAa,CACd,sBIxJmB,iBCtDuB,gBLoN7C,mBAAA,cAAA,UAAU,UACC,CAHZ,2DE5KC,yBFoLI,gCAAA,2BAAA,wBAAwB,uBACU,WAElC,oDAAA,gDAAA,4CAAgE,iBK7NvB,CL+N1C,+BCxNL,kBD2N8B,UCvN1B,QDuN0C,aCvN1C,ODuN0C,eAC3B,SACL,CACX,+BG7ND,YH+NoB,WAAA,yBAElB,oCAAA,+BAAA,4BAA4B,8BAC5B,0BAAA,qBAAsB,CAEtB,qDEtMF,wBA9DuB,CFsQpB,gCCvOL,kBD0O8B,MAAG,QAAA,SAAA,OAAA,yBAE7B,qBAAqB,kCACrB,6BAAA,yBAA0B,CAE1B,sDACE,iCAAA,4BAAA,yBAAyB,+CACzB,0CAAA,sCAAuC,CACxC,kBA2BH,oBAAA,oBAAA,aAAa,iBKpRgC,CLmR9C,0BAKG,WKxR2C,CLmR9C,gDErOC,aAnEuB,CFgTpB,qBErPH,sBF8PA,gCACA,YAAsD,cAC9B,CA0CzB,sCKtWC,kBAAgD,kBACT,gCACN,CAClC,yCAEC,kBAAgD,eACX,CLwTrC,8BACE,WAAW,mBAEX,kBACA,wBAAA,qBAAA,sBAAuB,CACxB,4BAGC,aAAyB,cKhTkB,CLkT5C,2BAGC,oBAAA,oBAAA,aAAa,mBACb,eAAe,kBAEf,SAAU,CACX,2BAGC,4EAAA,oEAAA,+DAAA,4DAAA,oHMvUuD,CNsUxD,iCAGG,4CAAA,wCAAA,mCAAqC,CACtC,gFAID,gBACA,OKpU2C,CLqU5C,mCOvUC,kBP2UA,iBAAiB,OKzU0B,CL2U5C,qGAGC,mBAAA,cAAA,SAAU,CACX,oCAID,2CACE,aAAc,CACf,CAAA,aA5QL,QAgRI,YAAa,CAEhB,CAAA","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Player Component\n */\n\n.player{\n  @include position(fixed, null 0 0 0);\n  transition: background-color .5s ease-in-out;\n\n  animation: show-player .25s $ease-in-out-sine both;\n\n  // &::before{\n  //   content: \"\";\n  //   @include position(absolute, 0);\n  //   box-shadow: 0 -10px 30px -24px color(dark);\n  // }\n\n  @keyframes show-player {\n    0% {\n      transform: translateY(100%);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  &--is-playing &__background{\n    @include bgcolor(white);\n  }\n\n  &__background{\n    @include position(absolute, null 0 0 0);\n    @include bgcolor(bw2);\n    transform-origin: bottom;\n    height: $player-height;\n    overflow: hidden;\n    pointer-events: none;\n\n    &__inner{\n      @include size(100%);\n      filter: blur(20px) contrast(3);\n      transform: translateY(-80%);\n      transition: opacity .5s;\n      opacity: 0;\n      background-size: cover;\n      background-position: center;\n\n      .player--is-playing & {\n        opacity: .15;\n      }\n    }\n  }\n\n  &__wrapper, &__track-terms__wrapper{\n    display: flex;\n  }\n\n  &__wrapper{\n    @include padding(null baseline(9) null baseline(2));\n    height: $player-height;\n    box-shadow: 0 -1px uicolor(border);\n\n    animation: show-player-wrapper .25s $ease-in-out-sine .25s both;\n\n    @keyframes show-player-wrapper {\n      0% {\n        opacity: 0;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  }\n\n  &__track-details{\n    flex: none;\n    display: flex;\n    align-items: center;\n\n    .track__option{\n      @include size($player-height);\n      border: 0;\n      border-left: 1px solid uicolor(border);\n      border-radius: 0;\n\n      &:hover, &--active{\n        @include bgcolor(white);\n      }\n\n      &--filters.track__option--active{\n        top: -1px;\n      }\n    }\n  }\n\n  &__track-image.thumbnail{\n    &, .thumbnail__inner{\n      border-radius: 0;\n    }\n  }\n  // &__track-image{\n  //   transform: scale(.9);\n  //   transition: transform .25s $ease-out-back;\n\n  //   .player--is-playing &{\n  //     transform: scale(1);\n  //     .thumbnail__inner{\n  //       box-shadow: 0 3px 7px transparentize(color(black), .85);\n  //     }\n  //   }\n  // }\n\n  &__track-info{\n    @include margin(-1px baseline(3) null baseline(2));\n\n    &__title{\n      margin: 0;\n    }\n\n    &__subtitle{\n      display: block;\n    }\n  }\n\n  &__track-progress{\n    @include padding(null baseline(2));\n    border-left: 1px solid uicolor(border);\n    border-right: 1px solid uicolor(border);\n\n    flex: auto;\n    display: flex;\n    align-items: center;\n\n    &__duration{\n      flex: none;\n\n      &--elapsed{\n        display: none;\n      }\n    }\n  }\n\n  &__progress-bar{\n    @include margin(null baseline(1));\n    flex: auto;\n    height: 2px;\n\n    &:hover{\n      .player__progress-bar__tracker{\n        @include bgcolor(bw4);\n        transition-duration: .1s;\n        width: calc(100% + #{baseline(1)});\n        height: baseline(1);\n        transform: translateX(baseline(-.5)) translateY(baseline(-.375));\n        border-radius: baseline(.5);\n      }\n    }\n    &__hitzone{\n      @include position(absolute, baseline(-2) 0);\n      cursor: pointer;\n      z-index: 2;\n    }\n    &__tracker{\n      @include size(100%);\n      @include bgcolor(bw5);\n      transition: .25s ease-in-out;\n      transform-origin: left;\n\n      .player--is-buffering & {\n        @include bgcolor(bw4);\n      }\n    }\n    &__progress{\n      @include position(absolute, 0);\n      @include bgcolor(bw7);\n      clip: rect(0 0 2px 0);\n      transition: clip 0s linear;\n\n      .player--is-buffering & {\n        transition-duration: .25s;\n        transition-timing-function: ease-in-out;\n      }\n    }\n\n    // FIXME: this animation blocks react updates in Safari\n    // &__buffer {\n    //   @include position(absolute, 0);\n    //   @include bgcolor(accent);\n    //   animation: buffer 2s ease-in-out infinite;\n    //   @keyframes buffer {\n    //     0% {\n    //       transform-origin: left;\n    //       animation-fill-mode: forwards;\n    //       transform: scaleX(0);\n    //     } 50% {\n    //       transform-origin: left;\n    //       transform: scaleX(1);\n    //     } 50.001% {\n    //       transform-origin: right;\n    //     } 100% {\n    //       transform-origin: right;\n    //       transform: scaleX(0);\n    //     }\n    //   }\n    // }\n  }\n\n  &__controls{\n    display: flex;\n    margin-right: baseline(2);\n\n    .button{\n      height: $player-height;\n      &:not([disabled]):hover{\n        @include textcolor(accent);\n      }\n    }\n  }\n\n  &__track-terms{\n    @include scroll;\n    @include bgcolor(white);\n\n    // @include textcolor(white);\n    border-bottom: 1px solid uicolor(border);\n    height: $player-with-term-list-height - $player-height;\n    padding: baseline(2.5) 0;\n\n    &__wrapper{\n      width: 100%;\n      padding-right: baseline(3);\n      padding-left: baseline(2);\n      align-items: flex-start;\n    }\n\n    &__title{\n      margin: baseline(1.125) 0;\n      min-width: baseline(10);\n    }\n\n    &__list{\n      display: flex;\n      flex-wrap: wrap;\n      margin: 0 0 0 baseline(2);\n      padding: 0;\n    }\n\n    &__term{\n      transition: transform .25s $ease-out-back;\n      &:hover{\n        transform: translateY(-5%) !important;\n      }\n    }\n\n    &__button-view-all, &__button-find-similar {\n      margin-left: baseline(1);\n      top: baseline(.5);\n    }\n\n    &__button-close{\n      @include bgsize(circle);\n      margin-left: auto;\n      top: baseline(1);\n    }\n\n    &__title, &__button-view-all, &__button-close{\n      flex: none;\n    }\n  }\n\n  @include media(breakpoint(tablet-l)) {\n    &__track-progress__duration--elapsed{\n      display: block;\n    }\n  }\n\n  @media print{\n    display: none;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","@charset \"UTF-8\";\n\n/// Sets the `width` and `height` of the element.\n///\n/// @param {List} $size\n///   A list of at most 2 size values.\n///\n///   If there is only a single value in `$size` it is used for both width and height. All units are supported.\n///\n/// @example scss - Usage\n///   .first-element {\n///     @include size(2em);\n///   }\n///\n///   .second-element {\n///     @include size(auto 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .first-element {\n///     width: 2em;\n///     height: 2em;\n///   }\n///\n///   .second-element {\n///     width: auto;\n///     height: 10em;\n///   }\n///\n/// @todo Refactor in 5.0.0 to use a comma-separated argument\n\n@mixin size($value) {\n  $width: nth($value, 1);\n  $height: $width;\n\n  @if length($value) > 1 {\n    $height: nth($value, 2);\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  @if is-size($height) {\n    height: $height;\n  } @else {\n    @warn \"`#{$height}` is not a valid length for the `$height` parameter in the `size` mixin.\";\n  }\n\n  @if is-size($width) {\n    width: $width;\n  } @else {\n    @warn \"`#{$width}` is not a valid length for the `$width` parameter in the `size` mixin.\";\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PlayerProgressBar Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var date_1 = __webpack_require__(119);
var dom_1 = __webpack_require__(304);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var WindowSizeListener = __webpack_require__(124);
var Label_1 = __webpack_require__(8);
var classes = new BEM('player');

var PlayerProgressBar = function (_React$Component) {
    _inherits(PlayerProgressBar, _React$Component);

    function PlayerProgressBar(props) {
        _classCallCheck(this, PlayerProgressBar);

        var _this = _possibleConstructorReturn(this, (PlayerProgressBar.__proto__ || Object.getPrototypeOf(PlayerProgressBar)).call(this, props));

        _this.onClickSeek = function (e) {
            var positionX = _this.getCurrentPositionX(e);
            _this.props.onSeek(positionX / _this.hitzone.clientWidth);
        };
        _this.onDragStart = function (e) {
            _this.setState({
                isDragging: true,
                dragPosition: _this.getCurrentPositionX(e)
            }, function () {
                if (_this.props.onDragStart) {
                    _this.props.onDragStart();
                }
            });
        };
        _this.onDrag = function (e) {
            var positionX = _this.getCurrentPositionX(e);
            var glitchThreshold = 100;
            // Make sure the new cursor position is not a glitch before setting the drag position
            if (Math.abs(positionX - _this.state.dragPosition) < glitchThreshold) {
                _this.setState({ dragPosition: positionX });
            }
        };
        _this.onDragEnd = function (e) {
            _this.props.onSeek(_this.state.dragPosition / _this.hitzone.clientWidth);
            setTimeout(function () {
                _this.setState({ isDragging: false }, function () {
                    if (_this.props.onDragEnd) {
                        _this.props.onDragEnd();
                    }
                });
            }, 250);
        };
        _this.onResize = function () {
            _this.setState({
                progressBarClip: _this.props.elapsedTime / _this.props.duration * _this.progressBarRef.clientWidth
            });
        };
        _this.onDragThrottled = lodash_1.throttle(_this.onDrag, 20);
        _this.state = {
            dragPosition: 0,
            isDragging: false,
            progressBarClip: 0
        };
        return _this;
    }

    _createClass(PlayerProgressBar, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.elapsedTime !== this.props.elapsedTime) {
                this.setState({
                    progressBarClip: nextProps.elapsedTime / nextProps.duration * this.progressBarRef.clientWidth
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                elapsedTime = _props.elapsedTime,
                remainingTime = _props.remainingTime;

            return React.createElement("div", Object.assign({}, classes('track-progress')), React.createElement(WindowSizeListener, { onResize: this.onResize }), React.createElement(Label_1.Span, Object.assign({ text: date_1.getFormattedTime(elapsedTime), size: "xsmall" }, classes('track-progress__duration', 'elapsed'))), React.createElement("div", Object.assign({}, classes('progress-bar')), React.createElement("div", Object.assign({}, classes('progress-bar__hitzone'), { ref: function ref(node) {
                    return _this2.hitzone = node;
                }, draggable: true, onClick: this.onClickSeek, onDragStart: this.onDragStart, onDragEnd: this.onDragEnd, onDrag: function onDrag(e) {
                    e.persist();
                    _this2.onDragThrottled(e);
                } })), React.createElement("div", Object.assign({}, classes('progress-bar__tracker'))), React.createElement("div", Object.assign({ ref: function ref(node) {
                    return _this2.progressBarRef = node;
                } }, classes('progress-bar__progress'), { style: this.getProgressBarClip() }))), React.createElement(Label_1.Span, Object.assign({ text: "-" + date_1.getFormattedTime(Math.abs(remainingTime)), size: "xsmall" }, classes('track-progress__duration', 'remaining'))));
        }
    }, {
        key: "getCurrentPositionX",
        value: function getCurrentPositionX(e) {
            return dom_1.getRelativeCoordinates(this.hitzone, e).x;
        }
    }, {
        key: "getProgressBarClip",
        value: function getProgressBarClip() {
            var _state = this.state,
                dragPosition = _state.dragPosition,
                isDragging = _state.isDragging,
                progressBarClip = _state.progressBarClip;

            var progressBarStyle = {
                clip: 'rect(0 0 2px 0)'
            };
            if (this.progressBarRef) {
                var progressBarWidth = isDragging ? dragPosition : progressBarClip;
                var progressBarHeight = this.progressBarRef.clientHeight;
                progressBarStyle.clip = "rect(0 " + progressBarWidth + "px " + progressBarHeight + "px 0)";
            }
            return progressBarStyle;
        }
    }]);

    return PlayerProgressBar;
}(React.Component);

exports.default = PlayerProgressBar;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PlayerTrackTerms Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var taxonomy_1 = __webpack_require__(106);
__webpack_require__(733);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Button_1 = __webpack_require__(10);
var FindSimilarButton_1 = __webpack_require__(642);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var PlayerTrackTag_1 = __webpack_require__(1925);
var classes = new BEM('player__track-terms');

var PlayerTrackTerms = function (_React$Component) {
    _inherits(PlayerTrackTerms, _React$Component);

    function PlayerTrackTerms(props) {
        _classCallCheck(this, PlayerTrackTerms);

        var _this = _possibleConstructorReturn(this, (PlayerTrackTerms.__proto__ || Object.getPrototypeOf(PlayerTrackTerms)).call(this, props));

        _this.selectTrackTerms();
        return _this;
    }

    _createClass(PlayerTrackTerms, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (!lodash_1.isEqual(nextProps.terms, this.props.terms)) {
                this.selectTrackTerms(nextProps.terms);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement("div", Object.assign({}, classes()), React.createElement("div", Object.assign({}, classes('wrapper')), React.createElement(Heading_1.default, Object.assign({ is: "h5" }, classes('title')), "This track is:"), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ul", enter: {
                    animation: 'transition.slideUpIn',
                    stagger: 25,
                    duration: 150,
                    display: 'flex',
                    delay: 250
                } }, classes('list')), this.props.open && this.selectedTerms.map(function (_ref) {
                var id = _ref.id,
                    name = _ref.name;
                return React.createElement(PlayerTrackTag_1.PlayerTrackTag, Object.assign({ key: _this2.props.slug + "-" + id, id: id, name: name }, classes('term')));
            })), React.createElement(FindSimilarButton_1.FindSimilarButton, Object.assign({ actionSource: "player_terms_panel", track: this.props.track, colorScheme: "transparent", size: "small", variant: "normal", label: "Find similar tracks", icon: React.createElement(Icon_1.IconArrowRight2, null), iconPosition: "right" }, classes('button-find-similar'))), React.createElement(Button_1.default, Object.assign({ variant: "icon", icon: React.createElement(Icon_1.IconX, null), size: "xsmall", onClick: function onClick() {
                    return _this2.props.onClose && _this2.props.onClose();
                } }, classes('button-close')))));
        }
    }, {
        key: "selectTrackTerms",
        value: function selectTrackTerms() {
            var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.terms;

            var moods = this.getTermsForType(taxonomy_1.TaxonomyType.Moods, terms);
            var genres = this.getTermsForType(taxonomy_1.TaxonomyType.Genres, terms);
            this.selectedTerms = moods.terms.length > 5 ? moods.terms.slice(0, 5) : moods.terms;
            this.selectedTerms = this.selectedTerms.concat(genres.terms.length > 3 ? genres.terms.slice(0, 3) : genres.terms);
            this.selectedTerms = moods.searchedTerms.concat(genres.searchedTerms, lodash_1.shuffle(this.selectedTerms));
        }
    }, {
        key: "getTermsForType",
        value: function getTermsForType(type, terms) {
            var termsForType = taxonomy_1.getTermsByTaxonomy(type, terms);
            var termsStrings = termsForType.map(function (_ref2) {
                var name = _ref2.name;
                return name;
            });
            var searchedTermsForType = lodash_1.flatMap(lodash_1.intersection(termsStrings, this.props.searchFilters.map(function (_ref3) {
                var name = _ref3.name;
                return name;
            })).map(function (termName) {
                return termsForType.filter(function (_ref4) {
                    var name = _ref4.name;
                    return name === termName;
                });
            }));
            lodash_1.pullAllBy(termsForType, searchedTermsForType, 'name');
            return { terms: termsForType, searchedTerms: searchedTermsForType };
        }
    }]);

    return PlayerTrackTerms;
}(React.Component);

var PlayerTrackTermsWithQueryStringContext = function PlayerTrackTermsWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(PlayerTrackTerms, Object.assign({ searchFilters: selectors_1.getSearchFilters(ctx) }, props));
    });
};
exports.default = PlayerTrackTermsWithQueryStringContext;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PlayerTrackTag Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var queryString_1 = __webpack_require__(30);
var Tag_1 = __webpack_require__(127);

var InternalPlayerTrackTag = function (_React$Component) {
    _inherits(InternalPlayerTrackTag, _React$Component);

    function InternalPlayerTrackTag() {
        _classCallCheck(this, InternalPlayerTrackTag);

        var _this = _possibleConstructorReturn(this, (InternalPlayerTrackTag.__proto__ || Object.getPrototypeOf(InternalPlayerTrackTag)).apply(this, arguments));

        _this.onClick = function () {
            _this.props.addSearchFilter({ name: _this.props.name });
        };
        _this.onClickExclude = function () {
            _this.props.addSearchFilter({ name: _this.props.name }, true);
        };
        return _this;
    }

    _createClass(InternalPlayerTrackTag, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                id = _props.id,
                name = _props.name;

            return React.createElement(Tag_1.default, { onClick: this.onClick, onClickExclude: this.onClickExclude, id: id, label: name, wrappedComponent: "li", size: "small", variant: "button", colorScheme: "light", className: className, alwaysDisplayExclude: true });
        }
    }]);

    return InternalPlayerTrackTag;
}(React.Component);

exports.PlayerTrackTag = function (props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref) {
        var addSearchFilter = _ref.addSearchFilter;
        return React.createElement(InternalPlayerTrackTag, Object.assign({ addSearchFilter: addSearchFilter }, props));
    });
};

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Global Helmet Settings
 */
var locales_1 = __webpack_require__(52);
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var react_redux_1 = __webpack_require__(5);
function AppHelmet(props) {
  var _props$businessInform = props.businessInformation,
      name = _props$businessInform.name,
      legal_name = _props$businessInform.legal_name,
      address = _props$businessInform.address,
      logo = _props$businessInform.logo,
      phone_numbers = _props$businessInform.phone_numbers,
      website = _props$businessInform.website,
      social_media = _props$businessInform.social_media;

  var facebook = social_media.facebook;
  var twitter = social_media.twitter;
  var image = social_media.image;
  var facebookUrl = "https://www.facebook.com/" + facebook;
  var twitterUrl = "https://www.twitter.com/" + twitter;
  return React.createElement(react_helmet_1.Helmet, { defaultTitle: locales_1.default.pageTitles.default, titleTemplate: locales_1.default.pageTitles.template }, React.createElement("html", { lang: locales_1.currentLang, "data-app-state": "running" }), React.createElement("meta", { name: "description", property: "og:description", content: locales_1.default.metaDescriptions.default }), React.createElement("meta", { property: "og:locale", content: "en_US" }), React.createElement("meta", { property: "og:type", content: "website" }), React.createElement("meta", { property: "og:title", content: locales_1.default.pageTitles.default }), React.createElement("meta", { property: "og:site_name", content: name }), React.createElement("meta", { property: "og:image", content: image }), React.createElement("meta", { name: "twitter:card", content: "summary" }), React.createElement("meta", { name: "twitter:site", content: "@" + twitter }), React.createElement("script", { type: "application/ld+json" }, "{\n        \"@context\": \"http://schema.org\",\n        \"@type\": \"WebSite\",\n        \"url\": \"" + website + "\",\n        \"name\": \"" + name + "\",\n        \"potentialAction\": {\n          \"@type\": \"SearchAction\",\n          \"target\": \"" + website + "/browse?search=keywords:{search_term_string}\",\n          \"query-input\": \"required name=search_term_string\"\n        }\n      }"), React.createElement("script", { type: "application/ld+json" }, "{\n        \"@context\": \"http://schema.org\",\n        \"@type\": \"Corporation\",\n        \"@id\": \"https://corporation.boppermusic.com\",\n        \"legalName\": \"" + legal_name + "\",\n        \"url\": \"" + website + "\",\n        \"description\": \"" + locales_1.default.metaDescriptions.default + "\",\n        \"address\": {\n          \"@type\": \"PostalAddress\",\n          \"addressLocality\": \"" + address.city + "\",\n          \"addressCountry\": \"" + address.country_code + "\",\n          \"postalCode\": \"" + address.postal_code + "\",\n          \"streetAddress\": \"" + address.line_1 + (address.line_2 ? ", " + address.line_2 : '') + "\"\n        },\n        \"sameAs\": [\n          \"" + facebookUrl + "\",\n          \"" + twitterUrl + "\"\n        ],\n        \"name\": \"" + legal_name + "\",\n        \"logo\": \"" + logo + "\",\n        \"image\": \"" + image + "\",\n        \"telephone\": \"" + phone_numbers.find(function (_ref) {
    var type = _ref.type;
    return type === 'main';
  }).phone_number + "\"\n      }"));
}
var ConnectedAppHelmet = react_redux_1.connect(function (_ref2) {
  var staticData = _ref2.staticData;
  return {
    businessInformation: staticData.businessInformation
  };
})(AppHelmet);
exports.default = ConnectedAppHelmet;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * CurrencyContextProvider Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = __webpack_require__(53);
var currency_1 = __webpack_require__(1928);
var selectedCurrency_1 = __webpack_require__(1930);
var relay_1 = __webpack_require__(226);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var LoadingSpinner_1 = __webpack_require__(163);
var _1 = __webpack_require__(115);
// tslint:disable-next-line:max-line-length

var CurrencyContextProviderBase = function (_React$Component) {
    _inherits(CurrencyContextProviderBase, _React$Component);

    function CurrencyContextProviderBase(props) {
        _classCallCheck(this, CurrencyContextProviderBase);

        var _this = _possibleConstructorReturn(this, (CurrencyContextProviderBase.__proto__ || Object.getPrototypeOf(CurrencyContextProviderBase)).call(this, props));

        _this.setCurrency = function (currency) {
            _this.setState({ submitting: true }, function () {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var _ref, errors;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return relay_1.processMutation(currency_1.ChangeCurrencyMutation, { currency: currency });

                                case 3:
                                    _ref = _context.sent;
                                    errors = _ref.errors;

                                    if (!errors) {
                                        _context.next = 7;
                                        break;
                                    }

                                    throw errors;

                                case 7:
                                    _context.next = 14;
                                    break;

                                case 9:
                                    _context.prev = 9;
                                    _context.t0 = _context["catch"](0);

                                    console.log(_context.t0);
                                    this.props.pushErrorNotification();
                                    this.setState({ submitting: false });

                                case 14:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 9]]);
                }));
            });
        };
        _this.state = {
            currency: _this.props.viewer.selected_currency || 'CAD',
            setCurrency: _this.setCurrency,
            submitting: false
        };
        return _this;
    }

    _createClass(CurrencyContextProviderBase, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.viewer.selected_currency !== this.props.viewer.selected_currency) {
                window.location.reload();
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(_1.CurrencyContext.Provider, { value: this.state }, this.props.children, this.state.submitting && ReactDOM.createPortal(React.createElement(CurrencyLoadingScreen, null), document.getElementsByClassName('drawer-wrapper')[0]));
        }
    }]);

    return CurrencyContextProviderBase;
}(React.Component);

var CurrencyLoadingScreen = function CurrencyLoadingScreen() {
    return React.createElement("div", { style: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,.5)'
        } }, React.createElement(LoadingSpinner_1.default, { center: true }));
};
var ConnectedCurrencyContextProvider = react_redux_1.connect(null, function (dispatch) {
    return {
        pushErrorNotification: function pushErrorNotification() {
            dispatch(notifications_1.pushNotification({
                state: 'error',
                message: 'Something went wrong while changing currency. Please try again later or contact us.'
            }));
        }
    };
})(CurrencyContextProviderBase);
exports.CurrencyContextProvider = react_relay_1.createFragmentContainer(ConnectedCurrencyContextProvider, selectedCurrency_1.selectedCurrency);

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.ChangeCurrencyMutation = function () {
  return __webpack_require__(1929);
};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 * @relayHash 94d138923518f301b94c2d588e2be779
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type currency_MutationVariables = {|
  input: {
    currency: Currency,
    clientMutationId?: ?string,
  },
|};
export type currency_MutationResponse = {|
  +changeCurrency: ?{|
    +viewer: ?{|
      +id: string,
      +selected_currency: ?Currency,
    |},
  |},
|};
*/

/*
mutation currency_Mutation(
  $input: ChangeCurrencyInput!
) {
  changeCurrency(input: $input) {
    viewer {
      id
      selected_currency
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "ChangeCurrencyInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "changeCurrency",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "ChangeCurrencyInput!"
    }],
    "concreteType": "ChangeCurrencyPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "Viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "selected_currency",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "currency_Mutation",
    "id": null,
    "text": "mutation currency_Mutation(\n  $input: ChangeCurrencyInput!\n) {\n  changeCurrency(input: $input) {\n    viewer {\n      id\n      selected_currency\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "currency_Mutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "currency_Mutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
node /*: any*/.hash = '5635c0b9d43dedabdd1c9ed994faff58';
module.exports = node;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_relay_1 = __webpack_require__(13);
var graphql = react_relay_1.graphql;
exports.selectedCurrency = {
  viewer: function viewer() {
    return __webpack_require__(1931);
  }
};

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @flow
 */

/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type selectedCurrency_viewer$ref: FragmentReference;
export type selectedCurrency_viewer = {|
  +selected_currency: ?Currency,
  +$refType: selectedCurrency_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "selectedCurrency_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "selected_currency",
    "args": null,
    "storageKey": null
  }]
};
node /*: any*/.hash = '2eb1d08aad8d940b7824563e0caa8ecb';
module.exports = node;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Download Context Provider Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var ui_1 = __webpack_require__(29);
var localStorage_1 = __webpack_require__(238);
var dom_1 = __webpack_require__(304);
var router_1 = __webpack_require__(27);
var nextTick = __webpack_require__(82);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var _1 = __webpack_require__(424);
exports.downloadAgreementLocalStorageKey = "" + localStorage_1.localStoragePrefix + localStorage_1.localStorageKeySeparator + "download-modal-visibility";

var DownloadContextProviderBase = function (_React$Component) {
    _inherits(DownloadContextProviderBase, _React$Component);

    function DownloadContextProviderBase(props) {
        _classCallCheck(this, DownloadContextProviderBase);

        var _this = _possibleConstructorReturn(this, (DownloadContextProviderBase.__proto__ || Object.getPrototypeOf(DownloadContextProviderBase)).call(this, props));

        _this.clear = function () {
            _this.setState({
                filePath: undefined,
                track: undefined
            });
        };
        _this.setFilePath = function (filePath, track) {
            _this.setState({ filePath: filePath, track: track });
        };
        _this.setAgreementVisibility = function (agreementVisibility) {
            _this.setState({ agreementVisibility: agreementVisibility }, function () {
                window.localStorage.setItem(exports.downloadAgreementLocalStorageKey, "" + agreementVisibility);
            });
        };
        _this.state = {
            dispatch: _this.props.dispatch,
            clear: _this.clear,
            setFilePath: _this.setFilePath,
            setAgreementVisibility: _this.setAgreementVisibility,
            agreementVisibility: !!!window.localStorage.getItem(exports.downloadAgreementLocalStorageKey)
        };
        return _this;
    }

    _createClass(DownloadContextProviderBase, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (!!this.props.filePathFromStore) {
                this.setFilePathFromStore();
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (!!this.props.filePathFromStore && !!!prevProps.filePathFromStore) {
                this.setFilePathFromStore();
            }
        }
    }, {
        key: "setFilePathFromStore",
        value: function setFilePathFromStore() {
            var _this2 = this;

            setTimeout(function () {
                if (_this2.state.agreementVisibility === false) {
                    _this2.autoDownloadTrack(_this2.props.filePathFromStore);
                } else {
                    _this2.setFilePath(_this2.props.filePathFromStore, _this2.props.trackFromStore);
                }
                _this2.props.dispatch(ui_1.clearUIState('downloadAgreementModal'));
            }, 2000);
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(_1.DownloadContext.Provider, { value: this.state }, this.props.children);
        }
    }, {
        key: "autoDownloadTrack",
        value: function autoDownloadTrack(path) {
            var downloadLink = document.createElement('a');
            downloadLink.setAttribute('class', 'download-link');
            downloadLink.setAttribute('href', "" + router_1.getOriginLocation() + path);
            document.body.appendChild(downloadLink);
            nextTick(function () {
                dom_1.simulateClick(downloadLink);
                nextTick(function () {
                    downloadLink.remove();
                });
            });
        }
    }]);

    return DownloadContextProviderBase;
}(React.Component);

exports.DownloadContextProvider = react_redux_1.connect(function (_ref) {
    var ui = _ref.ui;
    return {
        filePathFromStore: ui.downloadAgreementModal && ui.downloadAgreementModal.filePath,
        trackFromStore: ui.downloadAgreementModal && ui.downloadAgreementModal.track
    };
}, function (dispatch) {
    return { dispatch: dispatch };
})(DownloadContextProviderBase);

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Onboarding Context Provider Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __webpack_require__(183);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var _1 = __webpack_require__(400);
exports.onboardingLocalStorageKey = 'ams:onboarding';

var OnboardingContextProvider = function (_React$Component) {
    _inherits(OnboardingContextProvider, _React$Component);

    function OnboardingContextProvider(props) {
        _classCallCheck(this, OnboardingContextProvider);

        var _this = _possibleConstructorReturn(this, (OnboardingContextProvider.__proto__ || Object.getPrototypeOf(OnboardingContextProvider)).call(this, props));

        _this.acknowledgeAchievement = function (id) {
            var achievements = [].concat(_toConsumableArray(_this.state.achievements));
            achievements.splice(lodash_1.findIndex(achievements, { id: id }), 1, {
                id: id,
                acknowledged: true
            });
            _this.setState({ achievements: achievements });
        };
        _this.hasNewAchievement = function () {
            return lodash_1.some(_this.state.achievements, { acknowledged: false });
        };
        _this.isNewAchievement = function (id) {
            var unlockedAchievement = lodash_1.find(_this.state.achievements, { id: id });
            return !!unlockedAchievement && unlockedAchievement.acknowledged === false;
        };
        _this.unlockAchievement = function (id) {
            if (!lodash_1.find(_this.state.achievements, { id: id })) {
                setTimeout(function () {
                    _this.setState(function (_ref) {
                        var achievements = _ref.achievements;
                        return {
                            achievements: [].concat(_toConsumableArray(achievements), [{
                                id: id,
                                acknowledged: false
                            }])
                        };
                    });
                }, 2000);
            }
        };
        _this.state = {
            achievements: _this.retrieveFromLocalStorage(),
            acknowledgeAchievement: _this.acknowledgeAchievement,
            hasNewAchievement: _this.hasNewAchievement,
            isNewAchievement: _this.isNewAchievement,
            unlockAchievement: _this.unlockAchievement
        };
        return _this;
    }

    _createClass(OnboardingContextProvider, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(_, prevState) {
            if (!lodash_1.isEqual(this.state.achievements, prevState.achievements)) {
                this.saveToLocalStorage();
            }
        }
    }, {
        key: "retrieveFromLocalStorage",
        value: function retrieveFromLocalStorage() {
            return this.unserialize(url_1.decodeFromUrl(window.localStorage.getItem(exports.onboardingLocalStorageKey)) || []);
        }
    }, {
        key: "saveToLocalStorage",
        value: function saveToLocalStorage() {
            window.localStorage.setItem(exports.onboardingLocalStorageKey, url_1.encodeForUrl(this.serialize()));
        }
    }, {
        key: "serialize",
        value: function serialize() {
            return this.state.achievements.map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });
        }
    }, {
        key: "unserialize",
        value: function unserialize(serializedAchievements) {
            return serializedAchievements.map(function (id) {
                return {
                    id: id,
                    acknowledged: true
                };
            });
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(_1.OnboardingContext.Provider, { value: this.state }, this.props.children);
        }
    }]);

    return OnboardingContextProvider;
}(React.Component);

exports.OnboardingContextProvider = OnboardingContextProvider;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Licensing Context Provider Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _1 = __webpack_require__(432);

var TrackLicensingContextProvider = function (_React$Component) {
    _inherits(TrackLicensingContextProvider, _React$Component);

    function TrackLicensingContextProvider(props) {
        _classCallCheck(this, TrackLicensingContextProvider);

        var _this = _possibleConstructorReturn(this, (TrackLicensingContextProvider.__proto__ || Object.getPrototypeOf(TrackLicensingContextProvider)).call(this, props));

        _this.clearAll = function () {
            _this.setState({
                trackSlug: undefined,
                usages: undefined
            });
        };
        _this.clearTrack = function () {
            _this.setState({ trackSlug: undefined });
        };
        _this.clearUsages = function () {
            _this.setState({ usages: undefined });
        };
        _this.setUsages = function (usages) {
            // Can only set usages when a track was already selected
            if (!!_this.state.trackSlug) {
                setTimeout(function () {
                    _this.setState({ usages: usages });
                }, 2000);
            }
        };
        _this.setTrack = function (trackSlug) {
            _this.setState({ trackSlug: trackSlug });
        };
        _this.state = {
            clearAll: _this.clearAll,
            setUsages: _this.setUsages,
            setTrack: _this.setTrack
        };
        return _this;
    }

    _createClass(TrackLicensingContextProvider, [{
        key: "render",
        value: function render() {
            return React.createElement(_1.TrackLicensingContext.Provider, { value: this.state }, this.props.children);
        }
    }]);

    return TrackLicensingContextProvider;
}(React.Component);

exports.TrackLicensingContextProvider = TrackLicensingContextProvider;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable:no-string-literal

Object.defineProperty(exports, "__esModule", { value: true });
function activateOptimize() {
    if (window['dataLayer']) {
        window['dataLayer'].push({ event: 'optimize.activate' });
    }
}
exports.activateOptimize = activateOptimize;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Artist Page Routing
 */

Object.defineProperty(exports, "__esModule", { value: true });
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var Heading_1 = __webpack_require__(9);
var Artist_1 = __webpack_require__(186);
var Page_1 = __webpack_require__(391);
var artist_1 = __webpack_require__(644);
var router_1 = __webpack_require__(27);
var render = function render(_ref) {
    var Component = _ref.Component,
        props = _ref.props;

    if (!Component || !props) {
        return React.createElement(router_1.LoadingPage, null);
    }
    return props.artist ? React.createElement(Component, Object.assign({}, props)) : React.createElement(Page_1.default, { id: "artist", className: "not-found" }, React.createElement(Heading_1.default, { is: "h2" }, "Artist Not Found"));
};
exports.ArtistPageRoute = React.createElement(found_1.Route, { path: "artist/:slug", Component: Artist_1.default, query: artist_1.ArtistPageQuery, render: render });

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Browse/Results Page Routing
 */

Object.defineProperty(exports, "__esModule", { value: true });
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var Results_1 = __webpack_require__(734);
var helpers_1 = __webpack_require__(151);
var trackSearch_1 = __webpack_require__(301);
var router_1 = __webpack_require__(27);
var prepareVariables = function prepareVariables(_, match) {
    return Object.assign({}, helpers_1.getQueryStringStateForRoute(match), { count: Results_1.ResultsPerPage, offset: 0 });
};
var render = function render(_ref) {
    var Component = _ref.Component,
        props = _ref.props;

    return !!!Component ? React.createElement(router_1.LoadingPage, null) : !!!props ? React.createElement(Component, { viewer: null, searching: true }) : React.createElement(Component, Object.assign({}, props));
};
exports.ResultsPageRoute = React.createElement(found_1.Route, { Component: Results_1.default, query: trackSearch_1.trackSearchQuery, prepareVariables: prepareVariables, render: render });

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1939);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".page.page--results .filter-bar{position:fixed;top:120px;right:0;z-index:1}.page.page--results .nprogress-wrapper{position:fixed;top:120px}.app-wrapper[data-header-type=simple] .page.page--results .filter-bar{position:fixed;top:129px;right:0}.app-wrapper[data-header-type=simple] .page.page--results .nprogress-wrapper{position:fixed;top:64px}.page.page--results .filter-bar,.page.page--results .results__content-wrapper{margin-left:auto;max-width:calc(100% - 184px);width:88.888889%;-webkit-transition:-webkit-transform .5s cubic-bezier(.445,.05,.55,.95) .25s;transition:-webkit-transform .5s cubic-bezier(.445,.05,.55,.95) .25s;-o-transition:transform .5s cubic-bezier(.445,.05,.55,.95) .25s;transition:transform .5s cubic-bezier(.445,.05,.55,.95) .25s;transition:transform .5s cubic-bezier(.445,.05,.55,.95) .25s,-webkit-transform .5s cubic-bezier(.445,.05,.55,.95) .25s;-webkit-transform:none;-ms-transform:none;transform:none}.page.page--results .results__content-wrapper .results__content{min-height:500px}.page.page--results.has-facet-menu-open .filter-bar,.page.page--results.has-facet-menu-open .results__content-wrapper{-webkit-transform:translate3d(312px,0,0);transform:translate3d(312px,0,0);-webkit-transition-delay:0s;-o-transition-delay:0s;transition-delay:0s}.page.page--results .scrollable-section.scrollable-section--collections{padding:0}.page.page--results .scrollable-section.scrollable-section--collections .scrollable-section__list-wrapper{left:0;right:0;width:100%}.page.page--results .scrollable-section.scrollable-section--collections .scrollable-section__list-wrapper .scrollable-section__list{padding:0}.results__content--no-result{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;min-height:calc(100vh - 120px)}.results__content--no-result,.results__content--no-result .contact-options{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.results__content--no-result .contact-options{background-color:#fff;-webkit-box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);box-shadow:0 10px 20px -3px hsla(220,7%,57%,.25);padding-right:14px;padding-left:14px;margin-top:16px;border-radius:28px}.results__content--no-result .contact-options .icon.icon--phone{background-color:#75dbbe;color:#fff;border-radius:50%;height:32px;width:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:8px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/pages/browse/Results/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AA4GA,gCClEE,eDoEyB,UA7D8C,QA6Dd,SAC7C,CAHd,uCAOI,eAAe,SAlEsD,CAoEtE,sEC3ED,eD+E2B,UAA6C,OAAE,CAF1E,6EAMI,eAAe,QE1F4B,CFyEjD,8EAwBI,iBAAiB,6BACuC,iBACjB,6EACvC,qEAAA,gEAAA,6DAAA,uHAAgD,uBAChD,mBAAA,cAAe,CA5BnB,gEAiCM,gBAAiB,CAjCvB,sHAwCM,yCAAA,iCAA0C,4BAC1C,uBAAA,mBAAoB,CAzC1B,wEA8CI,SAAY,CA9ChB,0GAgDM,OAAO,QACC,UACG,CAlDjB,oIAqDQ,SAAY,CACb,6BASD,4BAAA,6BAAA,0BAAA,sBAAsB,kBAtG1B,8BAAyE,CAoGtE,2EACC,oBAAA,oBAAA,aAAa,wBAEb,qBAAA,uBAAuB,yBACvB,sBAAA,kBAAmB,CAJpB,8CGhGD,sBAxCQ,yDC5B+C,iDAAA,mBF8BV,kBFkJzC,gBAEA,kBEpJyC,CFsI5C,gEGhGD,yBAtDoB,WAcZ,kBEdU,YHgB2B,WF8JvC,oBAAA,oBAAA,aAAa,wBACb,qBAAA,uBAAuB,yBACvB,sBAAA,mBAAmB,gBEhKoB,CFkKxC","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * Results Page Component\n */\n\n.page.page--results {\n  .filter-bar{\n    @include position(fixed, $page-with-header-margin-top 0 null null);\n    z-index: 1;\n  }\n\n  .nprogress-wrapper{\n    position: fixed;\n    top: $page-with-header-margin-top;\n  }\n\n  .app-wrapper[data-header-type=\"simple\"] & {\n    .filter-bar{\n      @include position(fixed, $app-nav-height-fixed + $license-bar-height 0 null null);\n    }\n\n    .nprogress-wrapper{\n      position: fixed;\n      top: $app-nav-height-fixed;\n    }\n  }\n\n  .filter-bar,\n  .results__content-wrapper{\n    margin-left: auto;\n    max-width: calc(100% - #{$faceted-search-nav-min-width});\n    width: 100% - $faceted-search-nav-width;\n    transition: transform .5s $ease-in-out-sine .25s;\n    transform: none;\n  }\n\n  .results__content-wrapper {\n    .results__content {\n      min-height: 500px;\n    }\n  }\n\n  &.has-facet-menu-open{\n    .filter-bar,\n    .results__content-wrapper{\n      transform: translate3d(baseline(39), 0, 0);\n      transition-delay: 0s;\n    }\n  }\n\n  .scrollable-section.scrollable-section--collections {\n    padding: 0 0;\n    .scrollable-section__list-wrapper {\n      left: 0;\n      right: 0;\n      width: 100%;\n\n      .scrollable-section__list {\n        padding: 0 0;\n      }\n    }\n  }\n}\n\n.results {\n  &__content{\n    &--no-result{\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n      @include page-is-at-least-full-height;\n\n      .contact-options{\n        @include bgcolor(bw1);\n        @include shadow(small);\n        @include padding(null baseline(1.75));\n        margin-top: baseline(2);\n\n        border-radius: baseline(3.5);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .icon.icon--phone{\n          @include bgcolor(positive);\n          @include textcolor(bw1);\n          @include bgsize(circle);\n          @include size(baseline(4));\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin-right: baseline(1);\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FacetedSearchNav Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var taxonomy_1 = __webpack_require__(106);
var trackSearch_1 = __webpack_require__(301);
__webpack_require__(1941);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_onclickoutside_1 = __webpack_require__(643);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var velocity_react_1 = __webpack_require__(19);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var FacetMenuBudget_1 = __webpack_require__(1943);
var FacetMenuTempo_1 = __webpack_require__(1944);
var FacetMenuTerms_1 = __webpack_require__(1983);
var customTaxonomies = [{
    id: taxonomy_1.TaxonomyType.Budget,
    name: taxonomy_1.TaxonomyType.Budget,
    isCustom: true
}, {
    id: taxonomy_1.TaxonomyType.Tempos,
    name: 'Tempo',
    isCustom: true
}];
var facetedSearchExcludedTaxonomies = [taxonomy_1.TaxonomyType.ProductType, taxonomy_1.TaxonomyType.FeMood, taxonomy_1.TaxonomyType.Tags, taxonomy_1.TaxonomyType.Languages, taxonomy_1.TaxonomyType.Lyrics, taxonomy_1.TaxonomyType.References, taxonomy_1.TaxonomyType.Catalogs, taxonomy_1.TaxonomyType.RecordingCountry];
var facetedSearchTaxonomiesSortOrder = [taxonomy_1.TaxonomyType.Budget, taxonomy_1.TaxonomyType.Moods, taxonomy_1.TaxonomyType.Genres, taxonomy_1.TaxonomyType.Instruments, taxonomy_1.TaxonomyType.Industries, taxonomy_1.TaxonomyType.Tags, taxonomy_1.TaxonomyType.Vocals, taxonomy_1.TaxonomyType.Tempos];
var defaultObject = {};
var classes = new BEM('faceted-search-nav');

var FacetedSearchNav = function (_React$Component) {
    _inherits(FacetedSearchNav, _React$Component);

    function FacetedSearchNav(props) {
        _classCallCheck(this, FacetedSearchNav);

        var _this = _possibleConstructorReturn(this, (FacetedSearchNav.__proto__ || Object.getPrototypeOf(FacetedSearchNav)).call(this, props));

        _this.onRequestCloseFacetMenu = function () {
            _this.onToggleFacetMenu(_this.state.selectedTaxonomy);
        };
        _this.onShouldCloseFacetMenu = function () {
            return new Promise(function (resolve) {
                _this.onRequestCloseFacetMenu();
                setTimeout(function () {
                    resolve();
                }, 1000);
            });
        };
        _this.taxonomies = _this.getValidTaxonomies();
        _this.state = {
            selectedTaxonomy: ''
        };
        return _this;
    }

    _createClass(FacetedSearchNav, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.viewer) {
                if (prevProps.viewer && !lodash_1.isEqual(prevProps.viewer.trackSearch.taxonomy_cardinalities, this.props.viewer.trackSearch.taxonomy_cardinalities) || !!!prevProps) {
                    this.taxonomies = this.getValidTaxonomies();
                }
            }
            if (prevState.selectedTaxonomy !== this.state.selectedTaxonomy) {
                var shouldOpenFacetMenu = this.state.selectedTaxonomy !== '';
                if (this.props.onToggleFacetMenu) {
                    this.props.onToggleFacetMenu(shouldOpenFacetMenu);
                }
                if (shouldOpenFacetMenu) {
                    this.props.enableOnClickOutside();
                } else {
                    this.props.disableOnClickOutside();
                }
            } else if (this.props.searchFilters.length > prevProps.searchFilters.length || this.props.excludedSearchFilters.length > prevProps.excludedSearchFilters.length || !lodash_1.isEqual(this.props.budgetFilter, prevProps.budgetFilter) || !lodash_1.isEqual(this.props.tempoFilter, prevProps.tempoFilter)) {
                this.onToggleFacetMenu('');
            }
        }
    }, {
        key: "handleClickOutside",
        value: function handleClickOutside() {
            this.onRequestCloseFacetMenu();
        }
    }, {
        key: "onToggleFacetMenu",
        value: function onToggleFacetMenu(taxonomyId) {
            if (this.state.selectedTaxonomy === '') {
                this.setState({ selectedTaxonomy: taxonomyId });
            } else if (taxonomyId === this.state.selectedTaxonomy) {
                if (this.props.onToggleFacetMenu) {
                    this.props.onToggleFacetMenu(false);
                }
                this.setState({ selectedTaxonomy: '' });
            } else {
                this.setState({ selectedTaxonomy: taxonomyId });
            }
        }
    }, {
        key: "renderNavigation",
        value: function renderNavigation() {
            var _this2 = this;

            var taxonomyCardinalities = this.props.viewer ? this.props.viewer.trackSearch.taxonomy_cardinalities : defaultObject;
            var title = this.props.hasFilters ? 'Filter' : 'Search by';
            return React.createElement("ul", Object.assign({}, classes('taxonomy-list'), { "data-title": title }), this.taxonomies.map(function (_ref) {
                var id = _ref.id,
                    internal_id = _ref.internal_id,
                    isCustom = _ref.isCustom,
                    name = _ref.name;
                return React.createElement("li", { key: id }, React.createElement(Button_1.default, Object.assign({ onClick: function onClick() {
                        return _this2.onToggleFacetMenu(id);
                    }, size: "large", variant: "text", label: taxonomy_1.getTaxonomyTitle(name), icon: id === _this2.state.selectedTaxonomy && React.createElement(Icon_1.IconX, null), iconPosition: "right", disabled: _this2.props.hasFilters && !isCustom && !lodash_1.has(taxonomyCardinalities, internal_id) }, classes('button', { 'is-active': id === _this2.state.selectedTaxonomy }))));
            }));
        }
    }, {
        key: "renderFacetMenu",
        value: function renderFacetMenu(termCardinalities) {
            var _this3 = this;

            var taxonomy = lodash_1.find(this.taxonomies, function (_ref2) {
                var id = _ref2.id;
                return id === _this3.state.selectedTaxonomy;
            });
            switch (taxonomy.id) {
                case 'Budget':
                    return this.renderFacetMenuForBudget();
                case 'Tempo':
                    return this.renderFacetMenuForTempo();
                default:
                    return this.renderFacetMenuForTerms(termCardinalities);
            }
        }
    }, {
        key: "renderFacetMenuForBudget",
        value: function renderFacetMenuForBudget() {
            var _this4 = this;

            return React.createElement(FacetMenuBudget_1.default, Object.assign({ key: "facet-menu-budget", currency: this.props.currency }, classes('facet-menu'), { onOpenLicenseBuilder: function onOpenLicenseBuilder() {
                    return _this4.props.disableOnClickOutside();
                }, onCloseLicenseBuilder: function onCloseLicenseBuilder() {
                    return _this4.props.enableOnClickOutside();
                } }));
        }
    }, {
        key: "renderFacetMenuForTempo",
        value: function renderFacetMenuForTempo() {
            return React.createElement(FacetMenuTempo_1.default, Object.assign({ key: "facet-menu-tempo" }, classes('facet-menu')));
        }
    }, {
        key: "renderFacetMenuForTerms",
        value: function renderFacetMenuForTerms(termCardinalities) {
            var taxonomy = this.getSelectedTaxonomy();
            var allTerms = this.getTermsForSelectedTaxonomy(taxonomy, termCardinalities);
            return React.createElement(FacetMenuTerms_1.default, Object.assign({ key: "facet-menu-" + taxonomy.id, shouldCloseFacetMenu: this.onShouldCloseFacetMenu, taxonomyName: taxonomy.name, terms: allTerms, termCardinalities: termCardinalities }, classes('facet-menu')));
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                viewer = _props.viewer,
                topOffsetPx = _props.topOffsetPx,
                headerType = _props.headerType;
            var selectedTaxonomy = this.state.selectedTaxonomy;

            var termCardinalities = viewer ? viewer.trackSearch.term_cardinalities : defaultObject;
            var staticTopOffset = 64;
            // topOffsetPx changes based on license bar height
            var offset = {
                simple: staticTopOffset + topOffsetPx,
                extended: 0,
                hybrid: staticTopOffset
            };
            var topOffset = offset[headerType];
            return React.createElement("aside", Object.assign({}, classes(), { style: { top: topOffset + 'px' } }), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "div", enter: {
                    animation: {
                        // translateX: [0, '-20%'],
                        translateZ: [0, -50],
                        // rotateY: ['0deg', '-30deg'],
                        opacity: 1
                    },
                    duration: 500,
                    delay: 400,
                    easing: [50, 10],
                    display: 'flex'
                }, leave: {
                    animation: {
                        translateZ: 50,
                        opacity: 0
                    },
                    duration: 150
                } }, classes('facet-menu-wrapper')), selectedTaxonomy !== '' && this.renderFacetMenu(termCardinalities)), this.renderNavigation());
        }
    }, {
        key: "getValidTaxonomies",
        value: function getValidTaxonomies() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            var taxonomyIsExcluded = function taxonomyIsExcluded(_ref3) {
                var name = _ref3.name;
                return lodash_1.indexOf(facetedSearchExcludedTaxonomies, name) > -1;
            };
            var convertToInternalTaxonomy = function convertToInternalTaxonomy(_ref4) {
                var id = _ref4.id,
                    internal_id = _ref4.internal_id,
                    name = _ref4.name;
                return {
                    id: id,
                    internal_id: internal_id,
                    name: name
                };
            };
            var sortTaxonomiesByName = function sortTaxonomiesByName(a, b) {
                return facetedSearchTaxonomiesSortOrder.indexOf(a.name) > facetedSearchTaxonomiesSortOrder.indexOf(b.name) ? 1 : -1;
            };
            return props.taxonomies.filter(lodash_1.negate(taxonomyIsExcluded)).map(convertToInternalTaxonomy).concat(customTaxonomies).sort(sortTaxonomiesByName);
        }
    }, {
        key: "getSelectedTaxonomy",
        value: function getSelectedTaxonomy() {
            return lodash_1.find(this.props.taxonomies, { id: this.state.selectedTaxonomy });
        }
    }, {
        key: "getTermsForSelectedTaxonomy",
        value: function getTermsForSelectedTaxonomy(_ref5, termCardinalities) {
            var _this5 = this;

            var terms = _ref5.terms;

            var validTerms = terms.filter(function (_ref6) {
                var internal_id = _ref6.internal_id;
                return _this5.props.hasFilters ? lodash_1.has(termCardinalities, internal_id) : true;
            });
            return lodash_1.sortBy(validTerms, 'name');
        }
    }]);

    return FacetedSearchNav;
}(React.Component);

var FacetedSearchNavWithOnClickOutside = react_onclickoutside_1.default(FacetedSearchNav);
var ConnectedFacetedSearchNav = react_redux_1.connect(function (state) {
    return {
        taxonomies: state.staticData.taxonomies,
        topOffsetPx: state.ui.licenseBar.heightPx,
        headerType: state.ui.header.type
    };
})(FacetedSearchNavWithOnClickOutside);
var RelayFacetedSearchNav = react_relay_1.createFragmentContainer(ConnectedFacetedSearchNav, trackSearch_1.taxonomiesFragment);
var FacetedSearchNavWithQueryStringContext = function FacetedSearchNavWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(RelayFacetedSearchNav, Object.assign({ budgetFilter: selectors_1.getBudgetFilter(ctx), excludedSearchFilters: selectors_1.getExcludedSearchFilters(ctx), hasFilters: selectors_1.hasSearchFilters(ctx), searchFilters: selectors_1.getSearchFilters(ctx), tempoFilter: selectors_1.getTempoFilter(ctx) }, props));
    });
};
exports.default = FacetedSearchNavWithQueryStringContext;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1942);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Articulat CF;font-style:normal;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Light.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:300;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-LightOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Regular.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:italic;font-weight:400;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-RegularOblique.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:500;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-Medium.woff) format(\"woff\")}@font-face{font-family:Articulat CF;font-style:normal;font-weight:600;src:url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff2) format(\"woff2\"),url(https://orpheus-assets.s3.amazonaws.com/fonts/ArticulatCF-DemiBold.woff) format(\"woff\")}.faceted-search-nav{position:fixed;top:128px;bottom:0;left:0;-webkit-transition:top .2s ease-in;-o-transition:top .2s ease-in;transition:top .2s ease-in;background-color:#e2ebf3;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:0;-webkit-animation:faceted-search-nav-appear .5s ease-in-out;animation:faceted-search-nav-appear .5s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.app-wrapper[data-header-type=extended] .faceted-search-nav{position:absolute;top:0;bottom:0;left:0}.app-wrapper[data-header-type=simple] .faceted-search-nav{position:fixed;top:129px;bottom:0;left:0}@-webkit-keyframes faceted-search-nav-appear{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:none;transform:none}}@keyframes faceted-search-nav-appear{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:none;transform:none}}.faceted-search-nav,.faceted-search-nav__fixed-guard{min-width:184px;width:11.111111%}.faceted-search-nav__fixed-guard{-webkit-box-flex:0;-ms-flex:none;flex:none}.faceted-search-nav__taxonomy-list{position:absolute;top:48px;right:0;bottom:0;left:0;list-style:none;margin:0;padding:0;z-index:1}.faceted-search-nav__taxonomy-list li{padding-left:15%}.faceted-search-nav__taxonomy-list .button__label{font-weight:700}.faceted-search-nav__taxonomy-list:before{content:attr(data-title);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Articulat CF,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-transition:font-size .15s ease-in-out;-o-transition:font-size .15s ease-in-out;transition:font-size .15s ease-in-out;font-size:.75em;font-weight:500;line-height:1.3333333333;text-transform:uppercase;letter-spacing:.3em;color:#b1b8c4;display:block;margin-left:44px;margin-bottom:16px}.faceted-search-nav__taxonomy-list:before .label{display:inline-block}.faceted-search-nav__button{height:48px}.faceted-search-nav__button .button__wrapper{padding:15px 20px}.faceted-search-nav__button.with--icon .button__wrapper{padding-right:44px!important}.faceted-search-nav__button.with--icon .button__wrapper .icon{right:12px!important}.faceted-search-nav__button .button__active-background{border-radius:24px}.faceted-search-nav__button--is-active .button__active-background,.faceted-search-nav__button:not([disabled]):hover .button__active-background{background-color:#fff;-webkit-box-shadow:0 3px 30px -10px hsla(220,7%,57%,.25);box-shadow:0 3px 30px -10px hsla(220,7%,57%,.25);-webkit-animation:button-background-appear .15s ease-in-out;animation:button-background-appear .15s ease-in-out;-webkit-transform-origin:right;-ms-transform-origin:right;transform-origin:right}.faceted-search-nav__button-close.button{background-color:#101015;color:#fff;border-radius:50%;height:40px;width:40px;position:absolute;top:-20px;right:-20px}.faceted-search-nav__facet-menu-wrapper{-webkit-perspective:3000px;perspective:3000px;-webkit-box-flex:1;-ms-flex:auto;flex:auto}.app-wrapper[data-header-type=extended] .faceted-search-nav__facet-menu-wrapper{max-height:100vh}.faceted-search-nav__facet-menu{position:absolute;top:0;bottom:0;left:100%}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/config/_font-face.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/FacetedSearchNav/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/atoms/text/Heading/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss"],"names":[],"mappings":"AAKA,WACC,yBAA2B,kBACT,gBACF,uLAEoD,CAAA,WAIpE,yBAA2B,kBACT,gBACF,qMAE2D,CAAA,WAI3E,yBAA2B,kBACT,gBACF,2LAEsD,CAAA,WAItE,yBAA2B,kBACT,gBACF,yMAE6D,CAAA,WAI7E,yBAA2B,kBACT,gBACF,yLAEqD,CAAA,WAIrE,yBAA2B,kBACT,gBACF,6LAEuD,CAAA,oBCRtE,eCqEuB,UAA2B,SAAO,OAAE,mCAE3D,8BAAA,2BAA4B,yBAUH,oBAEzB,oBAAA,aAAa,UACH,4DAEV,oDAAqD,iCACrD,wBAAyB,CAdzB,4DDzEA,kBC0E4B,MAAG,SAAO,MAAE,CACvC,0DD3ED,eC8EyB,UAA6C,SAAO,MAAE,CAC9E,6CAWC,GACE,oCAAA,2BAA4B,CAAA,GAG5B,uBAAA,cAAe,CAAA,CALnB,qCACE,GACE,oCAAA,2BAA4B,CAAA,GAG5B,uBAAA,cAAe,CAAA,CA1BrB,qDAgCI,gBACA,gBAzFiC,CA0FlC,iCAGC,mBAAA,cAAA,SAAU,CACX,mCD1GD,kBC6G4B,SDzGxB,QCyGuC,SAAE,OAAE,gBAE7B,SACP,UACe,SAEd,CAPX,sCAUG,gBAAiB,CAVpB,kDAcG,eAAiB,CAdpB,0CAkBG,yBAAyB,mCChGU,kCAKH,mEChEpC,8CAAA,yCAAA,sCAAsC,gBAyHjB,gBAGL,yBACS,yBAMA,oBACL,cF2BhB,cAAc,iBAEd,kBC3I2C,CDmH9C,iDEtIC,oBAAqB,CFkKvB,4BACE,WChJ6C,CD+I9C,6CAMG,iBCrJ2C,CD+I9C,wDAUG,4BAAuC,CAV1C,8DAaK,oBAA+B,CAbpC,uDAkBG,kBCjK2C,CD+I9C,+IGzGC,sBAvCU,yDC7B6C,iDJuMnD,4DAAA,oDAAqD,+BACrD,2BAAA,sBAAuB,CACxB,yCGrIH,yBArEsB,WA8BZ,kBEfQ,YJgB2B,WFO/C,kBC6K4B,UDzKxB,WEX2C,CDqL9C,wCAGC,2BAAA,mBAAmB,mBAEnB,cAAA,SAAU,CACV,gFACE,gBAAiB,CAClB,gCDtLH,kBC0L4B,MAAG,SAAO,SAAK,CAC1C","file":"styles.scss","sourcesContent":["/**\n * Project-Specific Font-faces\n */\n\n$font-base-path: \"https://orpheus-assets.s3.amazonaws.com/fonts/\";\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-Light.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url($font-base-path + \"ArticulatCF-LightOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-LightOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-Regular.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: italic;\n\tfont-weight: 400;\n\tsrc: url($font-base-path + \"ArticulatCF-RegularOblique.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-RegularOblique.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tsrc: url($font-base-path + \"ArticulatCF-Medium.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Articulat CF\";\n\tfont-style: normal;\n\tfont-weight: 600;\n\tsrc: url($font-base-path + \"ArticulatCF-DemiBold.woff2\") format(\"woff2\"),\n       url($font-base-path + \"ArticulatCF-DemiBold.woff\") format(\"woff\");\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FacetedSearchNav Component\n */\n\n@import '../../../atoms/text/Heading/mixins.scss';\n\n.faceted-search-nav {\n  @include position(fixed, $app-nav-height-fixed * 2 null 0 0);\n\n  transition: top 0.2s ease-in;\n\n  .app-wrapper[data-header-type=\"extended\"] & {\n    @include position(absolute, 0 null 0 0);\n  }\n\n  .app-wrapper[data-header-type=\"simple\"] & {\n    @include position(fixed, $app-nav-height-fixed + $license-bar-height null 0 0);\n  }\n\n  background-color: #E2EBF3;\n\n  display: flex;\n  z-index: 0;\n\n  animation: faceted-search-nav-appear 0.5s ease-in-out;\n  animation-fill-mode: both;\n\n  @keyframes faceted-search-nav-appear {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: none;\n    }\n  }\n\n  &,\n  &__fixed-guard {\n    min-width: $faceted-search-nav-min-width;\n    width: $faceted-search-nav-width;\n  }\n\n  &__fixed-guard {\n    flex: none;\n  }\n\n  &__taxonomy-list {\n    @include position(absolute, baseline(6) 0 0 0);\n\n    list-style: none;\n    margin: 0;\n    padding: baseline(0) 0 0;\n\n    z-index: 1;\n\n    li {\n      padding-left: 15%;\n    }\n\n    .button__label {\n      font-weight: bold;\n    }\n\n    &::before {\n      content: attr(data-title);\n      @include base-heading;\n      @include h6(true);\n      @include textcolor(bw6);\n      display: block;\n      margin-left: baseline(5.5);\n      margin-bottom: baseline(2);\n    }\n  }\n\n  &__button {\n    height: baseline(6);\n\n    .button__wrapper {\n      // justify-content: flex-start;\n      // width: 50%;\n      padding: baseline(1.875) baseline(2.5);\n    }\n\n    &.with--icon .button__wrapper {\n      padding-right: baseline(5.5) !important;\n\n      .icon {\n        right: baseline(1.5) !important;\n      }\n    }\n\n    .button__active-background {\n      border-radius: baseline(3);\n    }\n\n    &:not([disabled]):hover,\n    &--is-active {\n      .button__active-background {\n        @include bgcolor(white);\n        @include shadow(xsmall);\n        animation: button-background-appear 0.15s ease-in-out;\n        transform-origin: right;\n      }\n    }\n  }\n\n  &__button-close.button {\n    @include bgcolor(black);\n    @include textcolor(white);\n    @include bgsize(circle);\n    @include size(baseline(5));\n    @include position(absolute, baseline(-2.5) baseline(-2.5) null null);\n  }\n\n  &__facet-menu-wrapper {\n    perspective: 3000px;\n    // perspective-origin: right;\n    flex: auto;\n    .app-wrapper[data-header-type=\"extended\"] & {\n      max-height: 100vh;\n    }\n  }\n\n  &__facet-menu {\n    @include position(absolute, 0 null 0 100%);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * Headings\n */\n\n/* Breakpoints */\n$break-headings-small:\t\tbreakpoint(tablet);\n$break-headings-medium:\t\tbreakpoint(desktop-xs);\n$break-headings-large:\t\tbreakpoint(desktop-l);\n\n/* Mixins */\n@mixin base-heading(){\n  @include font-smoothing;\n  font-family: $font--articulat;\n  transition: font-size .15s ease-in-out;\n\n  .label{\n    display: inline-block;\n  }\n}\n@mixin h1($no-margin: false){\n  $max-font-size: 4em;\n\n  font-size: $max-font-size * .5;\n  font-weight: 300;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .625;\n  }\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .75;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .75;\n  }\n}\n@mixin h2($no-margin: false){\n  $max-font-size: 3em;\n\n  font-size: $max-font-size * .666667;\n  font-weight: 400;\n  line-height: 1;\n\n  @if $no-margin == false {\n    margin: baseline(2) 0;\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size * .833333;\n  }\n  @include media($break-headings-large){\n    font-size: $max-font-size;\n  }\n}\n@mixin h3($no-margin: false){\n  $max-font-size: 2em;\n\n  font-size: $max-font-size * .625;\n  font-weight: 400;\n  line-height: 1.125;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .75;\n    font-weight: 300;\n  }\n  @include media($break-headings-medium){\n    // font-size: $max-font-size * .875;\n    font-size: $max-font-size;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h4($no-margin: false){\n  $max-font-size: 1.3125em;\n\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.142857143;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size * .857142857;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n\n  @include media($break-headings-medium){\n    font-size: $max-font-size;\n  }\n\n  @media print {\n    font-size: $max-font-size * .857142857;\n  }\n}\n@mixin h5($no-margin: false){\n  $max-font-size: .9375em;\n\n  font-size: .8125em;\n  font-weight: 400;\n  line-height: 1.230769231;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  @include media($break-headings-small){\n    font-size: $max-font-size;\n    line-height: 1.3333333333;\n\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n@mixin h6($no-margin: false){\n  $max-font-size: .75em;\n\n  font-size: $max-font-size;\n  font-weight: 500;\n  line-height: 1.3333333333;\n\n  @if $no-margin == false {\n    margin: baseline(1) 0;\n  }\n\n  text-transform: uppercase;\n  letter-spacing: .3em;\n\n  @include media($break-headings-small){\n    @if $no-margin == false {\n      margin: baseline(2) 0;\n    }\n  }\n}\n\n@mixin heading-proxy($heading, $simulator: false) {\n  @if str-index($heading, 'h1') { @include h1($simulator) }\n  @if str-index($heading, 'h2') { @include h2($simulator) }\n  @if str-index($heading, 'h3') { @include h3($simulator) }\n  @if str-index($heading, 'h4') { @include h4($simulator) }\n  @if str-index($heading, 'h5') { @include h5($simulator) }\n  @if str-index($heading, 'h6') { @include h6($simulator) }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FacetMenuBudget Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(15);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var redux_form_1 = __webpack_require__(37);
var queryString_1 = __webpack_require__(30);
var budgetFilter_1 = __webpack_require__(211);
var selectors_1 = __webpack_require__(65);
var analytics_1 = __webpack_require__(161);
var utils_1 = __webpack_require__(125);
var Button_1 = __webpack_require__(10);
var SessionLicenseBuilderButton_1 = __webpack_require__(300);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var Label_1 = __webpack_require__(8);
var classes = new BEM('facet-menu');

var FacetMenuBudget = function (_React$Component) {
    _inherits(FacetMenuBudget, _React$Component);

    function FacetMenuBudget() {
        _classCallCheck(this, FacetMenuBudget);

        var _this = _possibleConstructorReturn(this, (FacetMenuBudget.__proto__ || Object.getPrototypeOf(FacetMenuBudget)).apply(this, arguments));

        _this.onSubmit = function (_ref) {
            var budget = _ref.budget;

            var validBudget = budget;
            if (budget) {
                if (!budget.minimum) {
                    if (!budget.maximum) {
                        validBudget = undefined;
                    } else {
                        validBudget = {
                            minimum: 0,
                            maximum: budget.maximum
                        };
                    }
                } else {
                    if (!budget.maximum) {
                        validBudget = {
                            minimum: budget.minimum,
                            maximum: budgetFilter_1.budgetFilterMaximum
                        };
                    } else {
                        validBudget = budget.minimum > budget.maximum ? {
                            minimum: budget.maximum,
                            maximum: budget.minimum
                        } : budget;
                    }
                }
            }
            if (validBudget) {
                _this.props.addBudgetFilter(validBudget);
                _this.props.trackSetBudget(validBudget);
            } else {
                _this.props.removeBudgetFilter();
            }
        };
        return _this;
    }

    _createClass(FacetMenuBudget, [{
        key: "renderForm",
        value: function renderForm() {
            var _props = this.props,
                className = _props.className,
                handleSubmit = _props.handleSubmit;

            var textfieldProps = {
                colorScheme: 'light',
                component: TextField_1.default,
                optional: true,
                size: 'small'
            };
            var extraClasses = classNames(className);
            return React.createElement("form", Object.assign({}, classes('', 'budget', extraClasses), { onSubmit: handleSubmit(this.onSubmit) }), React.createElement(Label_1.Paragraph, { className: "message--label", variant: "description", size: "xlarge" }, "Please specify your maximum budget:"), React.createElement(utils_1.FieldMoney, Object.assign({ name: "budget[maximum]", placeholder: "To", withoutBorder: true, autoFocus: true, currency: this.props.currency }, textfieldProps)), React.createElement(Button_1.default, { label: "Set", variant: "pill", size: "small-medium", colorScheme: "dark", isSubmit: true }));
        }
    }, {
        key: "renderSetTerms",
        value: function renderSetTerms() {
            var extraClasses = classNames(this.props.className, 'without--license');
            return React.createElement("div", Object.assign({}, classes('', 'budget', extraClasses)), React.createElement(Label_1.Paragraph, { className: "message--no-terms-set", variant: "description", size: "xlarge" }, "In order to filter by budget, you must first set your license terms."), React.createElement(SessionLicenseBuilderButton_1.default, { label: "Build Your License", colorScheme: "accent", variant: "pill", icon: React.createElement(Icon_1.IconTerms, null), onOpenLicenseBuilder: this.props.onOpenLicenseBuilder, onCloseLicenseBuilder: this.props.onCloseLicenseBuilder }));
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.hasValidLicense ? this.renderForm() : this.renderSetTerms();
        }
    }]);

    return FacetMenuBudget;
}(React.Component);

var ConnectedForm = redux_form_1.reduxForm({
    form: 'budget-filter'
})(FacetMenuBudget);
var ConnectedFacetMenuBudget = react_redux_1.connect(function (_, _ref2) {
    var defaultValue = _ref2.defaultValue;
    return {
        initialValues: {
            budget: defaultValue
        }
    };
}, function (dispatch) {
    return {
        trackSetBudget: function trackSetBudget(budget) {
            return dispatch(analytics_1.trackSetBudget(budget));
        }
    };
})(ConnectedForm);
var FacetMenuBudgetWithQueryStringContext = function FacetMenuBudgetWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedFacetMenuBudget, Object.assign({ addBudgetFilter: ctx.addBudgetFilter, defaultValue: selectors_1.getDefaultBudgetFilter(ctx), hasValidLicense: selectors_1.hasLicenseParams(ctx), removeBudgetFilter: ctx.removeBudgetFilter }, props));
    });
};
exports.default = FacetMenuBudgetWithQueryStringContext;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FacetMenuTempo Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var staticData_1 = __webpack_require__(103);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var rc_slider_1 = __webpack_require__(1945);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Button_1 = __webpack_require__(10);
var classes = new BEM('facet-menu');

var FacetMenuTempo = function (_React$Component) {
    _inherits(FacetMenuTempo, _React$Component);

    function FacetMenuTempo(props) {
        _classCallCheck(this, FacetMenuTempo);

        var _this = _possibleConstructorReturn(this, (FacetMenuTempo.__proto__ || Object.getPrototypeOf(FacetMenuTempo)).call(this, props));

        _this.onRangeAfterChange = function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                minimum = _ref2[0],
                maximum = _ref2[1];

            _this.setState({ values: { minimum: minimum, maximum: maximum } });
        };
        _this.onReset = function () {
            _this.setState({ values: _this.props.initialValues }, function () {
                _this.props.removeTempoFilter();
            });
        };
        _this.onSubmit = function () {
            _this.props.addTempoFilter({
                minimum: _this.state.values.minimum + 1,
                maximum: _this.state.values.maximum + 1
            });
        };
        _this.state = {
            values: props.initialValues
        };
        return _this;
    }

    _createClass(FacetMenuTempo, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                defaultValues = _props.defaultValues,
                initialValues = _props.initialValues,
                tempoNames = _props.tempoNames;

            var extraClasses = classNames(className);
            return React.createElement("div", Object.assign({}, classes('', 'tempo', extraClasses)), React.createElement(rc_slider_1.Range, { min: defaultValues.minimum, max: defaultValues.maximum, defaultValue: [this.state.values.minimum, this.state.values.maximum], allowCross: false, marks: tempoNames, onAfterChange: this.onRangeAfterChange, dots: true, vertical: true }), React.createElement("div", null, React.createElement(Button_1.default, { label: "Set", variant: "pill", size: "small-medium", colorScheme: "dark", onClick: this.onSubmit, disabled: lodash_1.isEqual(initialValues, this.state.values) }), React.createElement(Button_1.default, { label: "Reset", variant: "hyperlink", size: "medium", onClick: this.onReset, disabled: lodash_1.isEqual(initialValues, defaultValues) })));
        }
    }]);

    return FacetMenuTempo;
}(React.Component);

var ConnectedFacetMenuTempo = react_redux_1.connect(function (state, ownProps) {
    return {
        defaultValues: staticData_1.getDefaultTempoValues(state),
        initialValues: staticData_1.getDefaultTempoFilter(state, ownProps),
        tempoNames: lodash_1.mapValues(state.staticData.tempos, 'name')
    };
})(FacetMenuTempo);
var FacetMenuTempoWithQueryStringContext = function FacetMenuTempoWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(ConnectedFacetMenuTempo, Object.assign({ addTempoFilter: ctx.addTempoFilter, removeTempoFilter: ctx.removeTempoFilter, tempoFilter: selectors_1.getTempoFilter(ctx) }, props));
    });
};
exports.default = FacetMenuTempoWithQueryStringContext;

/***/ }),
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FacetMenuTerms Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = __webpack_require__(47);
__webpack_require__(1984);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var velocity_react_1 = __webpack_require__(19);
var queryString_1 = __webpack_require__(30);
var selectors_1 = __webpack_require__(65);
var Button_1 = __webpack_require__(10);
var TextField_1 = __webpack_require__(83);
var Icon_1 = __webpack_require__(12);
var FacetMenuTag_1 = __webpack_require__(1986);
var animationDown = {
    enter: 'transition.slideRightIn',
    leave: 'transition.slideLeftOut'
};
var animationUp = {
    enter: 'transition.slideLeftIn',
    leave: 'transition.slideRightOut'
};
var classes = new BEM('facet-menu');

var FacetMenuTerms = function (_React$Component) {
    _inherits(FacetMenuTerms, _React$Component);

    function FacetMenuTerms(props) {
        _classCallCheck(this, FacetMenuTerms);

        var _this = _possibleConstructorReturn(this, (FacetMenuTerms.__proto__ || Object.getPrototypeOf(FacetMenuTerms)).call(this, props));

        _this.tags = [];
        _this.levelTerms = [];
        _this.subTerms = {};
        _this.onFilterTerms = function (terms, value) {
            var filteredTerms = terms.filter(function (_ref) {
                var name = _ref.name;
                return string_1.fuzzyFilter(string_1.sanitizeString(value), string_1.sanitizeString(name));
            });
            _this.setState({ filteredTerms: filteredTerms });
        };
        _this.onClickSubTags = function (termId) {
            _this.levelTerms = _this.subTerms[termId].filter(function (childTerm) {
                return _this.props.termCardinalities ? !!_this.props.termCardinalities[childTerm.internal_id] : true;
            });
            var nextLevel = {
                depth: _this.state.level.depth + 1,
                termId: termId
            };
            // this.tags = this.levelTerms.map(this.getTag);
            _this.setState({
                animation: animationDown,
                filteredTerms: _this.levelTerms,
                level: nextLevel
            });
        };
        _this.onClickBackButton = function () {
            var previousLevel = {
                depth: _this.state.level.depth - 1,
                termId: undefined
            };
            _this.levelTerms = _this.props.terms;
            _this.captureTags(true, _this.props, _this.state);
            _this.setState({
                animation: animationUp,
                filteredTerms: _this.props.terms,
                level: previousLevel
            });
        };
        _this.getTag = function (term, termCardinalities, level) {
            return React.createElement(FacetMenuTag_1.default, { cardinality: termCardinalities ? termCardinalities[term.internal_id] : undefined, hasSubtags: _this.showSubtagsButton(term.id, level.termId || ''), key: term.id + "-" + level.depth, onClickSubTags: _this.onClickSubTags, term: term, onClose: _this.props.shouldCloseFacetMenu });
        };
        _this.levelTerms = props.terms;
        _this.state = {
            animation: animationDown,
            filteredTerms: props.terms,
            level: {
                depth: 0
            }
        };
        _this.setSubTerms();
        _this.captureTags();
        return _this;
    }

    _createClass(FacetMenuTerms, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (this.shouldRefreshTagsList(nextProps)) {
                this.setState({ filteredTerms: nextProps.terms });
            }
        }
    }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState) {
            if (!lodash_1.isEqual(nextState.filteredTerms, this.state.filteredTerms) || !nextProps.termCardinalities) {
                this.setSubTerms(nextProps.terms);
                this.captureTags(true, nextProps, nextState);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.tags = [];
        }
    }, {
        key: "renderTags",
        value: function renderTags() {
            if (this.tags.length) {
                return this.tags;
            }
            this.captureTags();
            return this.tags.length ? this.tags : null;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var className = this.props.className;

            var hasFilterInput = this.levelTerms.length > 15;
            var extraClasses = classNames(className);
            return React.createElement("div", Object.assign({}, classes('', 'terms', extraClasses)), (this.state.level.depth > 0 || hasFilterInput) && React.createElement("div", Object.assign({}, classes('header')), this.state.level.depth > 0 && React.createElement(Button_1.default, Object.assign({ onClick: this.onClickBackButton, variant: "icon", icon: React.createElement(Icon_1.IconArrowLeft, null), size: "small-medium", colorScheme: "light" }, classes('back-button'))), hasFilterInput && React.createElement(TextField_1.default, Object.assign({ colorScheme: "white", name: "filter-facet-terms", inlineButton: React.createElement(Button_1.default, { variant: "icon", icon: React.createElement(Icon_1.IconFilter, null), disabled: true }), placeholder: "Find a term", size: "small", onChange: function onChange(e, value) {
                    return _this2.onFilterTerms(_this2.levelTerms, value);
                } }, classes('input-filter')))), React.createElement("div", Object.assign({}, classes('term-list__wrapper')), React.createElement(velocity_react_1.VelocityTransitionGroup, Object.assign({ component: "ul", enter: { animation: this.state.animation.enter, delay: 350, display: 'flex', duration: 250 }, leave: { animation: this.state.animation.leave, duration: 250 } }, classes('term-list')), this.renderTags())));
        }
    }, {
        key: "setSubTerms",
        value: function setSubTerms() {
            var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.terms;

            this.subTerms = terms.reduce(function (acc, term) {
                if (term.children.edges.length) {
                    acc[term.id] = term.children.edges.map(function (_ref2) {
                        var node = _ref2.node;
                        return node;
                    });
                }
                return acc;
            }, {});
        }
    }, {
        key: "captureTags",
        value: function captureTags() {
            var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var _this3 = this;

            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
            var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state;
            var excludedSearchFilters = props.excludedSearchFilters,
                searchFilters = props.searchFilters,
                taxonomyName = props.taxonomyName,
                termCardinalities = props.termCardinalities;

            if (reset) {
                this.tags = [];
            }
            var filteredTerms = void 0;
            var notSearchedTerms = state.filteredTerms.filter(function (term) {
                return !searchFilters.some(function (filter) {
                    return filter.name === term.name;
                }) && !excludedSearchFilters.some(function (filter) {
                    return filter.name === term.name;
                });
            });
            switch (taxonomyName) {
                case 'Genre':
                    var firstLevelTerms = notSearchedTerms.filter(function (term) {
                        return state.level.depth > 0 || state.level.depth === 0 && term.children && term.children.edges.length;
                    });
                    filteredTerms = firstLevelTerms.length ? firstLevelTerms : notSearchedTerms;
                    break;
                case 'Mood':
                    filteredTerms = termCardinalities ? notSearchedTerms.filter(function (term) {
                        return termCardinalities[term.internal_id] > 1;
                    }) : notSearchedTerms;
                    break;
                default:
                    filteredTerms = notSearchedTerms;
                    break;
            }
            var relevantTerms = termCardinalities ? filteredTerms.sort(function (a, b) {
                return termCardinalities[a.internal_id] > termCardinalities[b.internal_id] ? -1 : 1;
            }) : filteredTerms;
            this.tags = relevantTerms.map(function (term) {
                return _this3.getTag(term, termCardinalities, state.level);
            });
        }
    }, {
        key: "shouldRefreshTagsList",
        value: function shouldRefreshTagsList(nextProps) {
            var termCardinalities = nextProps.termCardinalities,
                terms = nextProps.terms;
            // if (!isEqual(excludedSearchFilters, this.props.excludedSearchFilters)) {
            //   return true;
            // }
            // if (!isEqual(searchFilters, this.props.searchFilters)) {
            //   return true;
            // }

            if (!lodash_1.isEqual(terms, this.props.terms)) {
                return true;
            }
            if (!lodash_1.isEqual(termCardinalities, this.props.termCardinalities)) {
                return true;
            }
            return false;
        }
    }, {
        key: "showSubtagsButton",
        value: function showSubtagsButton(termId, levelTermId) {
            return this.props.taxonomyName === 'Genre' && this.subTerms.hasOwnProperty(termId) && levelTermId !== termId;
        }
    }]);

    return FacetMenuTerms;
}(React.Component);

var FacetMenuTermsWithQueryStringContext = function FacetMenuTermsWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (ctx) {
        return React.createElement(FacetMenuTerms, Object.assign({ excludedSearchFilters: selectors_1.getExcludedSearchFilters(ctx), searchFilters: selectors_1.getSearchFilters(ctx) }, props));
    });
};
exports.default = FacetMenuTermsWithQueryStringContext;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1985);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".facet-menu{background-color:#fff;border-radius:8px;-webkit-box-shadow:0 3px 30px -10px hsla(220,7%,57%,.25);box-shadow:0 3px 30px -10px hsla(220,7%,57%,.25);width:288px;z-index:1;margin:8px 0 8px 8px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.facet-menu__title{display:block;margin-bottom:24px}.facet-menu__header{margin:24px 24px 0;-webkit-box-shadow:0 13px 20px #fff;box-shadow:0 13px 20px #fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:0;-ms-flex:none;flex:none;z-index:1}.facet-menu__header .textfield__inline-button{color:#d2d9e1}.facet-menu__back-button{margin-right:8px}.facet-menu__input-filter{-webkit-box-flex:1;-ms-flex:auto;flex:auto}.facet-menu--terms .tag .tag__wrapper{padding-right:8px;padding-left:0;margin-left:12px}.facet-menu--terms .tag,.facet-menu--terms .tag .tag__button--exclude{border-radius:16px;margin-right:-8px}.facet-menu--terms .tag .tag__button--exclude,.facet-menu--terms .tag:hover{background-color:#f0f6fa!important;-webkit-box-shadow:none!important;box-shadow:none!important}.facet-menu--terms .tag .tag__button--exclude{border-bottom-right-radius:0;border-top-right-radius:0}.facet-menu--terms .tag:hover .tag__badge{background-color:#fff!important}.facet-menu--terms .tag:hover .tag__button--subtags{background-color:#f0f6fa!important}.facet-menu--terms .tag:hover .tag__button--subtags:hover{background-color:#fff!important}.facet-menu__term-list{margin:24px;padding:0}.facet-menu__term-list__wrapper{-webkit-box-flex:1;-ms-flex:auto;flex:auto}html.touchevents .facet-menu__term-list__wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch}html.no-touchevents .facet-menu__term-list__wrapper{overflow-x:hidden;overflow-y:auto}.facet-menu--budget{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:32px}.facet-menu--budget .button,.facet-menu--budget .textfield{margin-bottom:16px}.facet-menu--budget .button{margin-top:16px}.facet-menu--budget .textfield{width:100%}.facet-menu--budget .textfield:first-of-type{display:inline-block}.facet-menu--budget .range-separator{padding-right:8px;padding-left:8px;display:none}.facet-menu--budget .message--no-terms-set{color:#8a8f99;margin:0}.facet-menu--budget .message--label{color:#8a8f99;margin:0 0 28px}.facet-menu--budget .without--license{padding-right:40px;padding-left:40px}.facet-menu--tempo{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:50% 64px 40% 32px}.facet-menu--tempo .rc-slider{position:relative;height:14px;padding:5px 0;width:100%;border-radius:6px;-ms-touch-action:none;touch-action:none}.facet-menu--tempo .rc-slider,.facet-menu--tempo .rc-slider *{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.facet-menu--tempo .rc-slider-rail{position:absolute;width:100%;background-color:#e4e8ed;height:4px;border-radius:6px}.facet-menu--tempo .rc-slider-track{position:absolute;left:0;height:4px;border-radius:6px;background-color:#4487ff}.facet-menu--tempo .rc-slider-handle{position:absolute;margin-left:-7px;margin-top:-5px;width:14px;height:14px;cursor:pointer;cursor:-webkit-grab;cursor:grab;border-radius:50%;border:2px solid #4487ff;background-color:#fff;-ms-touch-action:pan-x;touch-action:pan-x}.facet-menu--tempo .rc-slider-handle:hover{border-color:#4487ff}.facet-menu--tempo .rc-slider-handle:active{border-color:#4487ff;-webkit-box-shadow:0 0 5px #4487ff;box-shadow:0 0 5px #4487ff;cursor:-webkit-grabbing;cursor:grabbing}.facet-menu--tempo .rc-slider-handle:focus{border-color:#4487ff;-webkit-box-shadow:0 0 0 5px #77a8ff;box-shadow:0 0 0 5px #77a8ff;outline:none}.facet-menu--tempo .rc-slider-mark{position:absolute;top:18px;left:0;width:100%;font-size:11px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;white-space:nowrap}.facet-menu--tempo .rc-slider-mark-text{position:absolute;display:inline-block;vertical-align:middle;text-align:center;cursor:pointer;color:#d2d9e1}.facet-menu--tempo .rc-slider-mark-text-active{color:#4487ff}.facet-menu--tempo .rc-slider-step{position:absolute;width:100%;height:4px;background:transparent}.facet-menu--tempo .rc-slider-dot{position:absolute;bottom:-2px;margin-left:-4px;width:8px;height:8px;border:2px solid #e4e8ed;background-color:#fff;cursor:pointer;border-radius:50%;vertical-align:middle}.facet-menu--tempo .rc-slider-dot-active{border-color:#4487ff}.facet-menu--tempo .rc-slider-disabled{background-color:#f0f6fa}.facet-menu--tempo .rc-slider-disabled .rc-slider-track{background-color:#d2d9e1}.facet-menu--tempo .rc-slider-disabled .rc-slider-dot,.facet-menu--tempo .rc-slider-disabled .rc-slider-handle{border-color:#d2d9e1;-webkit-box-shadow:none;box-shadow:none;background-color:#fff;cursor:not-allowed}.facet-menu--tempo .rc-slider-disabled .rc-slider-dot,.facet-menu--tempo .rc-slider-disabled .rc-slider-mark-text{cursor:not-allowed!important}.facet-menu--tempo .rc-slider-vertical{width:14px;height:100%;padding:0 5px}.facet-menu--tempo .rc-slider-vertical .rc-slider-rail{height:100%;width:4px}.facet-menu--tempo .rc-slider-vertical .rc-slider-track{left:5px;bottom:0;width:4px}.facet-menu--tempo .rc-slider-vertical .rc-slider-handle{margin-left:-5px;margin-bottom:-7px;-ms-touch-action:pan-y;touch-action:pan-y}.facet-menu--tempo .rc-slider-vertical .rc-slider-mark{top:0;left:18px;height:100%}.facet-menu--tempo .rc-slider-vertical .rc-slider-step{height:100%;width:4px}.facet-menu--tempo .rc-slider-vertical .rc-slider-dot{left:2px;margin-bottom:-4px}.facet-menu--tempo .rc-slider-vertical .rc-slider-dot:first-child,.facet-menu--tempo .rc-slider-vertical .rc-slider-dot:last-child{margin-bottom:-4px}.facet-menu--tempo .rc-slider-tooltip-zoom-down-appear,.facet-menu--tempo .rc-slider-tooltip-zoom-down-enter,.facet-menu--tempo .rc-slider-tooltip-zoom-down-leave{-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:both;animation-fill-mode:both;display:block!important;-webkit-animation-play-state:paused;animation-play-state:paused}.facet-menu--tempo .rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active,.facet-menu--tempo .rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active{-webkit-animation-name:rcSliderTooltipZoomDownIn;animation-name:rcSliderTooltipZoomDownIn;-webkit-animation-play-state:running;animation-play-state:running}.facet-menu--tempo .rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active{-webkit-animation-name:rcSliderTooltipZoomDownOut;animation-name:rcSliderTooltipZoomDownOut;-webkit-animation-play-state:running;animation-play-state:running}.facet-menu--tempo .rc-slider-tooltip-zoom-down-appear,.facet-menu--tempo .rc-slider-tooltip-zoom-down-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-animation-timing-function:cubic-bezier(.23,1,.32,1);animation-timing-function:cubic-bezier(.23,1,.32,1)}.facet-menu--tempo .rc-slider-tooltip-zoom-down-leave{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@-webkit-keyframes rcSliderTooltipZoomDownIn{0%{opacity:0;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(1);transform:scale(1)}}@keyframes rcSliderTooltipZoomDownIn{0%{opacity:0;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes rcSliderTooltipZoomDownOut{0%{-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(0);transform:scale(0)}}@keyframes rcSliderTooltipZoomDownOut{0%{-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-transform:scale(0);transform:scale(0)}}.facet-menu--tempo .rc-slider-tooltip{position:absolute;left:-9999px;top:-9999px;visibility:visible}.facet-menu--tempo .rc-slider-tooltip,.facet-menu--tempo .rc-slider-tooltip *{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.facet-menu--tempo .rc-slider-tooltip-hidden{display:none}.facet-menu--tempo .rc-slider-tooltip-placement-top{padding:4px 0 8px}.facet-menu--tempo .rc-slider-tooltip-inner{padding:6px 2px;min-width:24px;height:24px;font-size:12px;line-height:1;color:#fff;text-align:center;text-decoration:none;background-color:#6c6c6c;border-radius:6px;-webkit-box-shadow:0 0 4px #d9d9d9;box-shadow:0 0 4px #d9d9d9}.facet-menu--tempo .rc-slider-tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.facet-menu--tempo .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow{bottom:4px;left:50%;margin-left:-4px;border-width:4px 4px 0;border-top-color:#6c6c6c}.facet-menu--tempo .rc-slider{height:85%;margin-bottom:16px}.facet-menu--tempo .button{-webkit-box-flex:0;-ms-flex:none;flex:none;margin-left:16px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/FacetMenu/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_colors.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_background-shape.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/mixins/_shadow.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/FacetMenu/slider.scss"],"names":[],"mappings":"AA4GA,YCnCI,sBAvCU,kBCrBQ,yDCRqC,iDH4GzD,YACA,UAAU,qBAGV,gBAAgB,oBAEhB,oBAAA,aAAa,4BACb,6BAAA,0BAAA,qBAAsB,CAEtB,mBACE,cAAc,kBIxF+B,CJ0F9C,oBAGC,mBAAiC,oCACjC,4BAA4B,oBAC5B,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,mBACnB,cAAA,UAAU,SACA,CANX,8CC9CC,aAvEmB,CD+HlB,yBAID,gBI1G6C,CJ2G9C,0BAGC,mBAAA,cAAA,SAAU,CACX,sCAKK,kBACA,eAAe,gBIrH0B,CJiH9C,sEASK,mBACA,iBI3HyC,CJiH9C,4EAcK,mCAAuC,kCACvC,yBAA2B,CAfhC,8CAmBK,6BAA6B,yBACH,CApB/B,0CAwBK,+BAAuC,CAxB5C,oDA4BK,kCAAuC,CA5B5C,0DA8BO,+BAAuC,CACxC,uBAML,YACA,SAAU,CAEV,gCAEE,mBAAA,cAAA,SAAU,CACX,iDIlLD,kBAAgD,kBACT,gCACN,CAClC,oDAEC,kBAAgD,eACX,CJgLvC,oBACE,wBAAA,qBAAA,uBAAuB,YIjKsB,CJgK9C,2DAKG,kBIrK2C,CJgK9C,4BASG,eIzK2C,CJgK9C,+BAaG,UAAW,CAbd,6CAeK,oBAAqB,CAf1B,qCK1GuB,kBDtDuB,iBJsL3C,YAAa,CAtBhB,2CClHC,cD6IE,QAAS,CA3BZ,oCClHC,cDkJE,eAA2B,CAhC9B,sCK1GuB,mBDtDuB,iBAAA,CJqM5C,mBAKD,yBAAA,sBAAA,mBAAmB,yBACnB,sBAAA,8BAA8B,yBI3Me,CJwM9C,8BM1OD,kBAAkB,YACN,cACE,WACH,kBACO,sBACI,iBACA,CNoOrB,8DMnOD,8BAAA,sBAAsB,yCACuB,CNkO5C,mCM3ND,kBAAkB,WACP,yBLNc,WKQd,iBACO,CNuNjB,oCMpND,kBAAkB,OACX,WACI,kBACO,wBLZO,CD6NxB,qCM7MD,kBAAkB,iBACD,gBACD,WACL,YACC,eACG,oBACK,YACR,kBACM,yBLxBO,sBAoBb,uBKOW,kBACA,CNiMtB,2CM9LD,oBL/ByB,CD6NxB,4CM3LD,qBLlCyB,mCAAA,2BAAA,wBKoCD,eACR,CNwLf,2CMrLD,qBLxCyB,qCKyCzB,6BAAiD,YACpC,CNmLZ,mCMhLD,kBAAkB,SACT,OACF,WACI,eFcT,mCAJqC,kCAKH,kBEZjB,CN0KlB,wCMvKD,kBAAkB,qBACG,sBACC,kBACJ,eLUhB,aAvEmB,CDiOpB,+CC1JC,aAnEuB,CD6NxB,mCM5JD,kBAAkB,WACP,WACA,sBACY,CNyJtB,kCMtJD,kBAAkB,YACN,iBACK,UACP,WACC,yBL9Ec,sBAuBb,eK0DG,kBACG,qBACI,CN6IrB,yCM1ID,oBLnFyB,CD6NxB,uCMvID,wBLpFyB,CD2NxB,wDMpID,wBL7FqB,CDiOpB,+GMhID,qBLjGqB,wBKkGrB,gBAAgB,sBL1EJ,kBK4EO,CN6HlB,kHMzHD,4BAA8B,CNyH7B,uCMtHD,WAAW,YACC,aACE,CNoHb,uDMjHD,YAAY,SACF,CNgHT,wDM7GD,SAAS,SACA,SACC,CN2GT,yDMxGD,iBAAiB,mBACE,uBACI,kBACA,CNqGtB,uDMlGD,MAAM,UACI,WACE,CNgGX,uDM7FD,YAAY,SACF,CN4FT,sDMzFD,SAAS,kBACU,CNwFlB,mIMlFD,kBAAmB,CNkFlB,mKMrED,+BAA+B,uBACA,iCACE,yBACA,wBACR,oCACW,2BACA,CN+DnC,gMM3DD,iDAAiD,yCACA,qCACZ,4BACA,CNwDpC,+FMrDD,kDAAkD,0CACA,qCACb,4BACA,CNkDpC,6GM9CD,2BAA8B,uBACtB,mBAAsB,4DACmC,mDACA,CN2ChE,sDMxCD,kEAAyE,yDACA,CAC1E,6CAEC,GACE,UAAU,kCACwB,0BACA,2BACJ,kBACA,CAAA,GAG9B,kCAAkC,0BACA,2BACJ,kBACA,CAAA,CAAA,qCAIhC,GACE,UAAU,kCACwB,0BACA,2BACJ,kBACA,CAAA,GAG9B,kCAAkC,0BACA,2BACJ,kBACA,CAAA,CAAA,8CAIhC,GACE,kCAAkC,0BACA,2BACJ,kBACA,CAAA,GAG9B,UAAU,kCACwB,0BACA,2BACJ,kBACA,CAAA,CAAA,sCAIhC,GACE,kCAAkC,0BACA,2BACJ,kBACA,CAAA,GAG9B,UAAU,kCACwB,0BACA,2BACJ,kBACA,CAAA,CNpB/B,sCMwBD,kBAAkB,aACL,YACD,kBACO,CN3BlB,8EM4BD,8BAAA,sBAAsB,yCACuB,CN7B5C,6CMoCD,YAAa,CNpCZ,oDMuCD,iBAAoB,CNvCnB,4CM0CD,gBAAgB,eACD,YACH,eACG,cACD,WLvPF,kBKyPM,qBACG,yBACI,kBACP,mCAClB,0BAA2B,CNpD1B,4CMuDD,kBAAkB,QACV,SACC,yBACgB,kBACN,CN3DlB,6EM8DD,WAAW,SACF,iBACQ,uBACM,wBACE,CNlExB,8BAOG,WAAW,kBI/MgC,CJwM9C,2BAYG,mBAAA,cAAA,UAAU,gBIpNiC,CJsN5C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * FacetMenu Component\n */\n\n.facet-menu{\n  @include bgcolor(white);\n  @include bgsize(large);\n  @include shadow(xsmall);\n  // border-right: 1px solid uicolor(border);\n  width: baseline(36);\n  z-index: 1;\n\n  margin: baseline(1) 0 baseline(1) baseline(1);\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n\n  &__title{\n    display: block;\n    margin-bottom: baseline(3);\n  }\n\n  &__header{\n    margin: baseline(3) baseline(3) 0;\n    box-shadow: 0 13px 20px #fff;\n    display: flex;\n    align-items: center;\n    flex: none;\n    z-index: 1;\n\n    .textfield__inline-button{\n      @include textcolor(bw5);\n    }\n  }\n\n  &__back-button{\n    margin-right: baseline(1);\n  }\n\n  &__input-filter{\n    flex: auto;\n  }\n\n  &--terms{\n    .tag{\n      .tag__wrapper{\n        padding-right: baseline(1);\n        padding-left: 0;\n        margin-left: baseline(1.5);\n      }\n\n      &, .tag__button--exclude{\n        border-radius: baseline(2);\n        margin-right: baseline(-1);\n      }\n\n      &:hover, .tag__button--exclude{\n        background-color: color(bw3) !important;\n        box-shadow: none !important;\n      }\n\n      .tag__button--exclude{\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n      }\n\n      &:hover .tag__badge{\n        background-color: color(bw1) !important;\n      }\n\n      &:hover .tag__button--subtags{\n        background-color: color(bw3) !important;\n        &:hover{\n          background-color: color(bw1) !important;\n        }\n      }\n    }\n  }\n\n  &__term-list{\n    margin: baseline(3);\n    padding: 0;\n\n    &__wrapper{\n      @include scroll;\n      flex: auto;\n    }\n  }\n\n\n  &--budget{\n    align-items: flex-start;\n    padding: baseline(4);\n\n    .textfield, .button{\n      margin-bottom: baseline(2);\n    }\n\n    .button{\n      margin-top: baseline(2);\n    }\n\n    .textfield{\n      width: 100%;\n      &:first-of-type{\n        display: inline-block;\n        // margin-bottom: 0;\n      }\n    }\n\n    .range-separator{\n      @include padding(null baseline(1));\n      display: none;\n    }\n\n    .message--no-terms-set{\n      @include textcolor(bw7);\n      margin: 0;\n    }\n\n    .message--label{\n      @include textcolor(bw7);\n      margin: 0 0 baseline(3.5) 0;\n    }\n\n    .without--license{\n      @include padding(null baseline(5));\n    }\n  }\n\n  &--tempo{\n    @import 'slider';\n    align-items: center;\n    justify-content: space-between;\n    padding: 50% baseline(8) 40% baseline(4);\n\n    .rc-slider{\n      height: 85%;\n      margin-bottom: baseline(2);\n    }\n\n    .button{\n      flex: none;\n      margin-left: baseline(2);\n    }\n  }\n}\n","/**\n * Colors\n */\n\n$color--woodsmoke: #101015;\n$color--oslogray: #85888F; // previous bw7\n$color--manatee: #8A8F99;\n$color--bombay: #AFB3BA; // previous bw6\n// $color--cadet-blue: #B2B8C2;\n$color--cadet-blue: #B1B8C4;\n$color--geyser: #D2D9E1;\n$color--athensgray: #E4E8ED;\n$color--aquahaze: #F0F4F7;\n$color--popesmoke: #F9FAFB;\n$color--dodgerblue: #4487FF;\n$color--aliceblue: #F5FAFF;\n$color--aliceblue2: #F0F6FA;\n$color--carnation: #F75B5B;\n$color--chablis: #FFF5F5;\n$color--bermuda: #75DBBE;\n$color--polar: #E8FAF5;\n$color--cornflower-blue: #735AFF;\n\n$colors: (\n  black: $color--woodsmoke,\n  dark: $color--woodsmoke,\n  bw8: $color--woodsmoke,\n  bw7: $color--manatee,\n  bw6: $color--cadet-blue,\n  bw5: $color--geyser,\n  bw4: $color--athensgray,\n  bw3: $color--aliceblue2,\n  bw2: $color--popesmoke,\n  bw1: white,\n  white: white,\n  accent: $color--dodgerblue,\n  accent-subtle: $color--aliceblue,\n  accent-subtle2: $color--aliceblue2,\n  accent2: $color--cornflower-blue,\n  dangerous: $color--carnation,\n  dangerous-subtle: $color--chablis,\n  positive: $color--bermuda,\n  positive-subtle: $color--polar,\n  default: $color--woodsmoke,\n  transparent: transparent,\n  none: transparent,\n);\n\n$ui-colors: (\n  border: bw4,\n  shadow: bw7,\n  search-background: accent-subtle2,\n);\n\n@function color($name) {\n  @if map_has_key($colors, $name) {\n    @return map-get($colors, $name);\n  } @else {\n    @return color(default);\n  }\n}\n\n@function uicolor($name) {\n  @if map_has_key($ui-colors, $name) {\n    @return color(map-get($ui-colors, $name));\n  } @else {\n    @return color(default);\n  }\n}\n\n\n@mixin bgcolor($name) {\n  @if map_has_key($colors, $name) {\n    background-color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    background-color: uicolor($name);\n  }\n}\n\n@mixin textcolor($name) {\n  @if map_has_key($colors, $name) {\n    color: color($name);\n  } @else if map_has_key($ui-colors, $name) {\n    color: uicolor($name);\n  }\n}\n","/**\n * Background Shape Sizes\n */\n\n/* Definitions */\n$background-sizes: (\n  small: (\n    border-radius: 2px,\n  ),\n  medium: (\n    border-radius: 4px,\n  ),\n  large: (\n    border-radius: 8px,\n  ),\n  xlarge: (\n    border-radius: 16px,\n  ),\n  circle: (\n    border-radius: 50%,\n  ),\n);\n\n/* Mixins */\n@function radius($name) {\n  @if map_has_key($background-sizes, $name) {\n    @return map-get(map-get($background-sizes, $name), border-radius);\n  }\n}\n\n@mixin bgsize($size) {\n  @if map-has-key($background-sizes, $size) {\n    @each $key,$val in map-get($background-sizes, $size){\n      #{$key}: $val;\n    }\n  }\n}\n","/**\n * Shadows\n */\n\n/* Definitions */\n$default-shadow-color: transparentize(uicolor(shadow), .75);\n$shadow-sizes: (\n  xsmall: (\n    box-shadow: 0 3px 30px -10px,\n  ),\n  small: (\n    box-shadow: 0 10px 20px -3px,\n  ),\n  medium: (\n    box-shadow: 0 20px 40px 0,\n  ),\n  large: (\n    box-shadow: 0 30px 60px 0,\n  ),\n);\n\n/* Mixins */\n@mixin shadow($size, $color: $default-shadow-color) {\n  @if map-has-key($shadow-sizes, $size) {\n    @each $key,$val in map-get($shadow-sizes, $size){\n      #{$key}: $val $color;\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n",".rc-slider {\n  position: relative;\n  height: 14px;\n  padding: 5px 0;\n  width: 100%;\n  border-radius: 6px;\n  -ms-touch-action: none;\n      touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: color(bw4);\n  height: 4px;\n  border-radius: 6px;\n}\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  border-radius: 6px;\n  background-color: color(accent);\n}\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -7px;\n  margin-top: -5px;\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px color(accent);\n  background-color: color(white);\n  -ms-touch-action: pan-x;\n      touch-action: pan-x;\n}\n.rc-slider-handle:hover {\n  border-color: color(accent);\n}\n.rc-slider-handle:active {\n  border-color: color(accent);\n  box-shadow: 0 0 5px color(accent);\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.rc-slider-handle:focus {\n  border-color: color(accent);\n  box-shadow: 0 0 0 5px lighten(color(accent), 10%);\n  outline: none;\n}\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 11px;\n  @include font-smoothing;\n  white-space: nowrap;\n}\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  @include textcolor(bw5);\n}\n.rc-slider-mark-text-active {\n  @include textcolor(accent);\n}\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid color(bw4);\n  background-color: color(white);\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n.rc-slider-dot-active {\n  border-color: color(accent);\n}\n.rc-slider-disabled {\n  background-color: color(bw3);\n}\n.rc-slider-disabled .rc-slider-track {\n  background-color: color(bw5);\n}\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: color(bw5);\n  box-shadow: none;\n  background-color: color(white);\n  cursor: not-allowed;\n}\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -5px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n      touch-action: pan-y;\n}\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  -webkit-animation-duration: .3s;\n          animation-duration: .3s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: block !important;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-leave {\n  -webkit-animation-duration: .3s;\n          animation-duration: .3s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: block !important;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  -webkit-animation-name: rcSliderTooltipZoomDownIn;\n          animation-name: rcSliderTooltipZoomDownIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  -webkit-animation-name: rcSliderTooltipZoomDownOut;\n          animation-name: rcSliderTooltipZoomDownOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  -webkit-transform: scale(0, 0);\n          transform: scale(0, 0);\n  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n          animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.rc-slider-tooltip-zoom-down-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n          animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@-webkit-keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n  100% {\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n}\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n  100% {\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n}\n@-webkit-keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n.rc-slider-tooltip-inner {\n  padding: 6px 2px;\n  min-width: 24px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 1;\n  color: color(white);\n  text-align: center;\n  text-decoration: none;\n  background-color: #6c6c6c;\n  border-radius: 6px;\n  box-shadow: 0 0 4px #d9d9d9;\n}\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #6c6c6c;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * FacetMenuTag Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var queryString_1 = __webpack_require__(30);
var Tag_1 = __webpack_require__(127);

var FacetMenuTag = function (_React$PureComponent) {
    _inherits(FacetMenuTag, _React$PureComponent);

    function FacetMenuTag() {
        _classCallCheck(this, FacetMenuTag);

        var _this = _possibleConstructorReturn(this, (FacetMenuTag.__proto__ || Object.getPrototypeOf(FacetMenuTag)).apply(this, arguments));

        _this.onClickSubTags = function () {
            _this.props.onClickSubTags(_this.props.term.id);
        };
        _this.onClickAdd = function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.props.onClose();

                            case 2:
                                this.props.addSearchFilter({ name: this.props.term.name });

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        };
        _this.onClickExclude = function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.props.onClose();

                            case 2:
                                this.props.addSearchFilter({ name: this.props.term.name }, true);

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        };
        return _this;
    }

    _createClass(FacetMenuTag, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                cardinality = _props.cardinality,
                hasSubtags = _props.hasSubtags,
                term = _props.term;

            return React.createElement(Tag_1.default, { id: term.id, label: term.name, variant: "button", size: "small", colorScheme: "transparent", wrappedComponent: "li", cardinality: cardinality, onClick: this.onClickAdd, onClickExclude: this.onClickExclude, onClickSubTags: this.onClickSubTags, hasSubtags: hasSubtags });
        }
    }]);

    return FacetMenuTag;
}(React.PureComponent);

var FacetMenuTagWithQueryStringContext = function FacetMenuTagWithQueryStringContext(props) {
    return React.createElement(queryString_1.QueryStringContext.Consumer, null, function (_ref) {
        var addSearchFilter = _ref.addSearchFilter;
        return React.createElement(FacetMenuTag, Object.assign({ addSearchFilter: addSearchFilter }, props));
    });
};
exports.default = FacetMenuTagWithQueryStringContext;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultList Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __webpack_require__(64);
var sizes_1 = __webpack_require__(649);
__webpack_require__(1988);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_dom_1 = __webpack_require__(28);
var react_redux_1 = __webpack_require__(5);
var Velocity = __webpack_require__(91);
var LoadingButton_1 = __webpack_require__(286);
var Results_1 = __webpack_require__(734);
var grid_1 = __webpack_require__(58);
var ResultListPage_1 = __webpack_require__(1990);
var classes = new BEM('result-list');

var ResultList = function (_React$Component) {
    _inherits(ResultList, _React$Component);

    function ResultList(props) {
        _classCallCheck(this, ResultList);

        var _this = _possibleConstructorReturn(this, (ResultList.__proto__ || Object.getPrototypeOf(ResultList)).call(this, props));

        _this.onClickLoadMore = function () {
            _this.setState({ isLoadingMoreResults: true });
        };
        _this.state = {
            isLoadingMoreResults: false
        };
        return _this;
    }

    _createClass(ResultList, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.element = react_dom_1.findDOMNode(this);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            // if (!prevProps.licenseBuilderIsVisible && this.props.licenseBuilderIsVisible) {
            //   this.updateDisplayTimer = window.setTimeout(() => {
            //     this.setState({ shouldDisplayResults: false });
            //   }, 1000);
            // } else if (prevProps.licenseBuilderIsVisible && !this.props.licenseBuilderIsVisible) {
            //   this.updateDisplayTimer = window.setTimeout(() => {
            //     this.setState({ shouldDisplayResults: true });
            //   }, 100);
            // }
            if (this.element) {
                var pages = this.element.getElementsByClassName('result-list-page');
                if (prevState.isLoadingMoreResults && this.state.isLoadingMoreResults) {
                    this.setState({ isLoadingMoreResults: false }, function () {
                        Velocity(lodash_1.last(pages), 'scroll', {
                            offset: -(sizes_1.Size.pageWithHeaderMarginTop + sizes_1.Size.licenseBarHeight + grid_1.baseline * 2),
                            delay: 500,
                            duration: 500
                        });
                    });
                } else if (prevProps.results.length !== this.props.results.length) {
                    window.scrollTo(0, 0);
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.clearTimeout(this.updateDisplayTimer);
        }
    }, {
        key: "renderPage",
        value: function renderPage(page, cardSize) {
            var results = this.props.results;

            var resultListPageProps = {
                gridSize: cardSize,
                pageNumber: page,
                results: results.slice(page * Results_1.ResultsPerPage, (page + 1) * Results_1.ResultsPerPage)
            };
            var collections = lodash_1.chain(resultListPageProps.results).filter(function (_ref) {
                var node = _ref.node;
                return !!node.collections && !!node.collections.edges.length;
            }).map(function (_ref2) {
                var node = _ref2.node;
                return node.collections.edges.map(function (edge) {
                    return edge.node;
                });
            }).flatten().uniqBy('id').value();
            if (collections.length && resultListPageProps.results.length === Results_1.ResultsPerPage) {
                var pickCollection = function pickCollection(c) {
                    if (!c.length) {
                        return undefined;
                    }
                    var index = lodash_1.random(0, c.length - 1);
                    var collection = c[index];
                    var assets = image_1.getResponsiveAssets('cover', collection.assets);
                    return !assets.blur ? pickCollection([].concat(_toConsumableArray(c)).splice(index, 1)) : collection;
                };
                resultListPageProps.collection = pickCollection(collections);
            }
            return React.createElement(ResultListPage_1.default, Object.assign({ key: "result-page-" + page + "-" + resultListPageProps.results[0].node.id }, resultListPageProps));
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                hasValidLicense = _props.hasValidLicense,
                results = _props.results,
                totalResults = _props.totalResults;
            var isLoadingMoreResults = this.state.isLoadingMoreResults;

            var cardSize = this.getGridSize();
            var nbOfPages = results.length / Results_1.ResultsPerPage;
            var pages = [];
            for (var index = 0; index < nbOfPages; index++) {
                pages.push(index);
            }
            var classModifiers = {
                'with-license': hasValidLicense
            };
            var extraClasses = classNames(className);
            return React.createElement("div", Object.assign({}, classes('', classModifiers, extraClasses)), React.createElement(React.Fragment, null, pages.map(function (page) {
                return _this2.renderPage(page, cardSize);
            }), totalResults > results.length && React.createElement(LoadingButton_1.default, Object.assign({ label: "Load More", onClick: this.onClickLoadMore, onLoad: this.props.onLoadMore, isLoading: isLoadingMoreResults, colorScheme: "dark", size: "large", variant: "pill" }, classes('button-more')))));
        }
    }, {
        key: "getGridSize",
        value: function getGridSize() {
            var totalResults = this.props.totalResults;

            return totalResults < 10 ? 'xlarge' : 'small';
        }
    }]);

    return ResultList;
}(React.Component);

var ConnectedResultList = react_redux_1.connect(function (_ref3) {
    var license = _ref3.license;
    return {
        hasValidLicense: license.isValid
    };
})(ResultList);
exports.default = ConnectedResultList;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1989);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".result-list{padding:16px 16px 16px 0}.result-list__scroller{-webkit-box-flex:1;-ms-flex:auto;flex:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:100%;padding:8px 0}.result-list__button-more{padding:48px;display:block}.result-list__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-line-pack:start;align-content:flex-start;-webkit-box-flex:1;-ms-flex:auto;flex:auto}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/ResultList/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA4GA,aAEE,wBAA8C,CAE9C,uBACE,mBAAA,cAAA,UAAU,oBACV,oBAAA,aAAa,4BACb,6BAAA,0BAAA,sBAAsB,gBACN,aACM,CACvB,0BCfC,aDmBA,aAAc,CACf,sBAGC,oBAAA,oBAAA,aAAa,8BACb,6BAAA,uBAAA,mBAAmB,yBACnB,yBAAyB,mBACzB,cAAA,SAAU,CACX","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ResultList Component\n */\n\n.result-list{\n  $card-margin: 1;\n  padding: baseline(2) baseline(2) baseline(2) 0;\n\n  &__scroller{\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    padding: baseline(1) 0;\n  }\n\n  &__button-more{\n    @include padding(baseline(6));\n    display: block;\n  }\n\n  &__wrapper{\n    display: flex;\n    flex-flow: row wrap;\n    align-content: flex-start;\n    flex: auto;\n  }\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * ResultListPage Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1991);
var classNames = __webpack_require__(15);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var image_1 = __webpack_require__(64);
var CollectionCard_1 = __webpack_require__(645);
var TrackListItem_1 = __webpack_require__(428);
var collectionCardPositionLayouts = 4;

var ResultListPage = function (_React$Component) {
    _inherits(ResultListPage, _React$Component);

    function ResultListPage(props) {
        _classCallCheck(this, ResultListPage);

        var _this = _possibleConstructorReturn(this, (ResultListPage.__proto__ || Object.getPrototypeOf(ResultListPage)).call(this, props));

        _this.collectionCardPositionLayout = lodash_1.random(1, collectionCardPositionLayouts);
        return _this;
    }

    _createClass(ResultListPage, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
            return false; // why?
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                collection = _props.collection,
                gridSize = _props.gridSize,
                results = _props.results;

            var classes = new BEM('result-list-page');
            var extraClasses = classNames("grid--" + gridSize, !collection && 'without--collection', collection && "collection-card-position--" + this.collectionCardPositionLayout);
            return React.createElement("section", Object.assign({}, classes('', '', extraClasses)), React.createElement("ul", Object.assign({}, classes('list')), results.map(function (_ref, i) {
                var node = _ref.node;
                return React.createElement(TrackListItem_1.default, { actionSource: "search_results_list", key: node.id, className: "result-list-item", track: node, cardProps: {
                        backgroundColor: gridSize !== 'xlarge' ? 'white' : 'bw3',
                        size: gridSize
                    } });
            })), collection && React.createElement("div", Object.assign({}, classes('collection-card')), React.createElement(CollectionCard_1.default, { image: image_1.getResponsiveAssets('cover', collection.assets), subtitle: collection.category ? collection.category.name : 'Collection', title: collection.name, slug: collection.slug, topic: "Collection related to your search" })));
        }
    }]);

    return ResultListPage;
}(React.Component);

exports.default = ResultListPage;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1992);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".result-list-page{padding:0 8px}.result-list-page__list{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-line-pack:start;align-content:flex-start;margin:0;padding:0;list-style:none}.result-list-page:last-of-type .result-list-item{-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom;-webkit-animation:show-card .5s cubic-bezier(.075,.82,.165,1);animation:show-card .5s cubic-bezier(.075,.82,.165,1);-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards}.result-list-page:last-of-type .result-list-item:first-child{-webkit-animation-delay:1.08s;animation-delay:1.08s}.result-list-page:last-of-type .result-list-item:nth-child(2){-webkit-animation-delay:1.16s;animation-delay:1.16s}.result-list-page:last-of-type .result-list-item:nth-child(3){-webkit-animation-delay:1.24s;animation-delay:1.24s}.result-list-page:last-of-type .result-list-item:nth-child(4){-webkit-animation-delay:1.32s;animation-delay:1.32s}.result-list-page:last-of-type .result-list-item:nth-child(5){-webkit-animation-delay:1.4s;animation-delay:1.4s}.result-list-page:last-of-type .result-list-item:nth-child(6){-webkit-animation-delay:1.48s;animation-delay:1.48s}.result-list-page:last-of-type .result-list-item:nth-child(7){-webkit-animation-delay:1.56s;animation-delay:1.56s}.result-list-page:last-of-type .result-list-item:nth-child(8){-webkit-animation-delay:1.64s;animation-delay:1.64s}.result-list-page:last-of-type .result-list-item:nth-child(9){-webkit-animation-delay:1.72s;animation-delay:1.72s}.result-list-page:last-of-type .result-list-item:nth-child(10){-webkit-animation-delay:1.8s;animation-delay:1.8s}.result-list-page:last-of-type .result-list-item:nth-child(11){-webkit-animation-delay:1.88s;animation-delay:1.88s}.result-list-page:last-of-type .result-list-item:nth-child(12){-webkit-animation-delay:1.96s;animation-delay:1.96s}.result-list-page:last-of-type .result-list-item:nth-child(13){-webkit-animation-delay:2.04s;animation-delay:2.04s}.result-list-page:last-of-type .result-list-item:nth-child(14){-webkit-animation-delay:2.12s;animation-delay:2.12s}.result-list-page:last-of-type .result-list-item:nth-child(15){-webkit-animation-delay:2.2s;animation-delay:2.2s}@-webkit-keyframes show-card{0%{opacity:0;-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0);-webkit-animation-fill-mode:none;animation-fill-mode:none}to{opacity:1;-webkit-transform:none;transform:none;-webkit-animation-fill-mode:none;animation-fill-mode:none}}@keyframes show-card{0%{opacity:0;-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0);-webkit-animation-fill-mode:none;animation-fill-mode:none}to{opacity:1;-webkit-transform:none;transform:none;-webkit-animation-fill-mode:none;animation-fill-mode:none}}.controlled-grid--small .result-list-page.grid--small .result-list-item,.controlled-grid--small .result-list-page.grid--small .result-list-page__collection-card,.result-list-page.grid--small .result-list-item,.result-list-page.grid--small .result-list-page__collection-card{width:100%}@media screen and (min-width:960px){.result-list-page.grid--small .result-list-item,.result-list-page.grid--small .result-list-page__collection-card{width:50%}}.controlled-grid--medium .result-list-page.grid--small .result-list-item,.controlled-grid--medium .result-list-page.grid--small .result-list-page__collection-card{width:50%}@media screen and (min-width:1440px){.result-list-page.grid--small .result-list-item,.result-list-page.grid--small .result-list-page__collection-card{width:33.3333333333%}}.controlled-grid--large .result-list-page.grid--small .result-list-item,.controlled-grid--large .result-list-page.grid--small .result-list-page__collection-card{width:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11){margin:336px 0 0}.result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:1120px;left:0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11){margin:336px 0 0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:1120px;left:0}@media screen and (min-width:960px){.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(12),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(13){margin-left:50%}.result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:560px;left:0}}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(12),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(13){margin-left:50%}.controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:560px;left:0}@media screen and (min-width:1440px){.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(13),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(15){margin-left:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:336px;left:33.3333333333%}}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(11),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(13),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-item:nth-child(15){margin-left:33.3333333333%}.controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--1 .result-list-page__collection-card{top:336px;left:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(6){margin:336px 0 0}.result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:560px;left:0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(6){margin:336px 0 0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:560px;left:0}@media screen and (min-width:960px){.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(5),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(6),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(7){margin-right:50%}.result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:224px;left:50%}}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(5),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(6),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(7){margin-right:50%}.controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:224px;left:50%}@media screen and (min-width:1440px){.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(5),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(7),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(9){margin-right:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:112px;left:66.6666666667%}}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(5),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(7),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-item:nth-child(9){margin-right:33.3333333333%}.controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--2 .result-list-page__collection-card{top:112px;left:66.6666666667%}.result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child{margin:336px 0 0}.result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child{margin:336px 0 0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}@media screen and (min-width:960px){.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child,.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(3){margin-left:50%}.result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child,.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(3){margin-left:50%}.controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}@media screen and (min-width:1440px){.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child,.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(3),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(5){margin-left:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:first-child,.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(3),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-item:nth-child(5){margin-left:33.3333333333%}.controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--3 .result-list-page__collection-card{top:0;left:0}.result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2){margin:336px 0 0}.result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:112px;left:0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2){margin:336px 0 0}.controlled-grid--small .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:112px;left:0}@media screen and (min-width:960px){.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:first-child,.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--small]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(3){margin-right:50%}.result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:0;left:50%}}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:first-child,.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--small]) .controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(3){margin-right:50%}.controlled-grid--medium .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:0;left:50%}@media screen and (min-width:1440px){.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(4),.result-list:not([class*=controlled-grid--medium]) .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(6){margin-left:33.3333333333%}.result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:0;left:33.3333333333%}}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(n){margin:0}.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(2),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(4),.result-list:not([class*=controlled-grid--medium]) .controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-item:nth-child(6){margin-left:33.3333333333%}.controlled-grid--large .result-list-page.grid--small:not(.without--collection).collection-card-position--4 .result-list-page__collection-card{top:0;left:33.3333333333%}.result-list-page.grid--small .result-list-item{padding:4px 8px}@media screen and (min-width:1024px){.result-list-page.grid--medium .result-list-item{-ms-flex-preferred-size:50%;flex-basis:50%}}.result-list-page.grid--xlarge{padding:16px}.result-list-page.grid--xlarge .result-list-item{padding:48px;-ms-flex-preferred-size:100%;flex-basis:100%}@media screen and (min-width:600px){.result-list-page.grid--xlarge .result-list-item{padding:16px;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:288px}}@media screen and (min-width:960px){.result-list-page.grid--xlarge .result-list-item{-ms-flex-preferred-size:33.3333%;flex-basis:33.3333%}}@media screen and (min-width:1152px){.result-list-page.grid--xlarge .result-list-item{-ms-flex-preferred-size:25%;flex-basis:25%}}@media screen and (min-width:1280px){.result-list-page.grid--xlarge .result-list-item{padding:32px 32px 24px;max-width:320px}}.controlled-grid--small .result-list-page.grid--xlarge .result-list-item,.controlled-grid--small .result-list-page.grid--xlarge .result-list-page__collection-card{width:100%}.controlled-grid--medium .result-list-page.grid--xlarge .result-list-item,.controlled-grid--medium .result-list-page.grid--xlarge .result-list-page__collection-card{width:50%}.controlled-grid--large .result-list-page.grid--xlarge .result-list-item,.controlled-grid--large .result-list-page.grid--xlarge .result-list-page__collection-card{width:33.3333333333%}.result-list-page .result-list-item,.result-list-page .result-list-item:hover{z-index:auto}.result-list-page__collection-card{position:absolute;padding:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:336px;z-index:auto}.result-list-page__collection-card .collection-card{width:90%;max-width:336px;-webkit-transition:.25s cubic-bezier(.175,.885,.32,1.275);-o-transition:.25s cubic-bezier(.175,.885,.32,1.275);transition:.25s cubic-bezier(.175,.885,.32,1.275)}.result-list-page__collection-card .collection-card:hover{-webkit-transform:scale(1.03);-ms-transform:scale(1.03);transform:scale(1.03)}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/ResultListPage/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/search/ResultListPage/mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_position.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/addons/_timing-functions.scss"],"names":[],"mappings":"AA+GA,kBACE,aC7E+C,CD+E/C,wBACE,oBAAA,oBAAA,aAAa,8BACb,6BAAA,uBAAA,mBAAmB,yBACnB,yBAAyB,SAChB,UACC,eACM,CATpB,iDAcM,gCAAA,4BAAA,wBAAwB,8DACxB,sDACA,sCAAA,6BAA8B,CAhBpC,6DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,6BAAA,oBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,8DAoBU,8BAAA,qBAAoC,CApB9C,+DAoBU,6BAAA,oBAAoC,CApB9C,+DAoBU,8BAAA,qBAAoC,CApB9C,+DAoBU,8BAAA,qBAAoC,CApB9C,+DAoBU,8BAAA,qBAAoC,CApB9C,+DAoBU,8BAAA,qBAAoC,CApB9C,+DAoBU,6BAAA,oBAAoC,CACrC,6BAID,GACE,UAAU,uCACV,+BAAiC,iCACjC,wBAAyB,CAAA,GAMzB,UAAU,uBACV,eAAe,iCACf,wBAAyB,CAAA,CAZ7B,qBACE,GACE,UAAU,uCACV,+BAAiC,iCACjC,wBAAyB,CAAA,GAMzB,UAAU,uBACV,eAAe,iCACf,wBAAyB,CAAA,CAAA,kRErE/B,UAL2B,CAM5B,oCFgCH,iHEjCI,SAL2B,CAM5B,CAFD,mKACE,SAL2B,CAM5B,qCFgCH,iHEjCI,oBAL2B,CAM5B,CAFD,iKACE,oBAL2B,CFsC/B,oHEvEQ,gBAAkE,CFuE1E,uHE5CI,WDhC6C,MCiCW,CA7BtD,4IACE,gBAAkE,CACnE,+IA0BH,WDhC6C,MCiCW,CACzD,oCA1BG,qKAAqE,QAAU,CAAE,kfAM7E,eAA+C,CF8DzD,uHE5CI,UDhC6C,MCiCW,CACzD,CA1BG,8LAAqE,QAAU,CAAE,6jBAM7E,eAA+C,CAChD,gJAiBL,UDhC6C,MCiCW,CACzD,qCAhBG,sKAAsE,QAAU,CAAE,qfAM9E,0BAA+C,CFoDzD,uHE5CI,UDhC6C,mBCiCW,CACzD,CAhBG,8LAAsE,QAAU,CAAE,6jBAM9E,0BAA+C,CAChD,+IAOL,UDhC6C,mBCiCW,CF2C5D,mHEvEQ,gBAAkE,CFuE1E,uHE5CI,UDhC6C,MCiCW,CA7BtD,2IACE,gBAAkE,CACnE,+IA0BH,UDhC6C,MCiCW,CACzD,oCA1BG,qKAAqE,QAAU,CAAE,+eAM7E,gBAA+C,CF8DzD,uHE5CI,UDhC6C,QCiCW,CACzD,CA1BG,8LAAqE,QAAU,CAAE,0jBAM7E,gBAA+C,CAChD,gJAiBL,UDhC6C,QCiCW,CACzD,qCAhBG,sKAAsE,QAAU,CAAE,kfAM9E,2BAA+C,CFoDzD,uHE5CI,UDhC6C,mBCiCW,CACzD,CAhBG,8LAAsE,QAAU,CAAE,0jBAM9E,2BAA+C,CAChD,+IAOL,UDhC6C,mBCiCW,CF2C5D,kHEvEQ,gBAAkE,CFuE1E,uHE5CI,MDhC6C,MCiCW,CA7BtD,0IACE,gBAAkE,CACnE,+IA0BH,MDhC6C,MCiCW,CACzD,oCA1BG,qKAAqE,QAAU,CAAE,8eAM7E,eAA+C,CF8DzD,uHE5CI,MDhC6C,MCiCW,CACzD,CA1BG,8LAAqE,QAAU,CAAE,yjBAM7E,eAA+C,CAChD,gJAiBL,MDhC6C,MCiCW,CACzD,qCAhBG,sKAAsE,QAAU,CAAE,ifAM9E,0BAA+C,CFoDzD,uHE5CI,MDhC6C,MCiCW,CACzD,CAhBG,8LAAsE,QAAU,CAAE,yjBAM9E,0BAA+C,CAChD,+IAOL,MDhC6C,MCiCW,CF2C5D,mHEvEQ,gBAAkE,CFuE1E,uHE5CI,UDhC6C,MCiCW,CA7BtD,2IACE,gBAAkE,CACnE,+IA0BH,UDhC6C,MCiCW,CACzD,oCA1BG,qKAAqE,QAAU,CAAE,8eAM7E,gBAA+C,CF8DzD,uHE5CI,MDhC6C,QCiCW,CACzD,CA1BG,8LAAqE,QAAU,CAAE,yjBAM7E,gBAA+C,CAChD,gJAiBL,MDhC6C,QCiCW,CACzD,qCAhBG,sKAAsE,QAAU,CAAE,kfAM9E,0BAA+C,CFoDzD,uHE5CI,MDhC6C,mBCiCW,CACzD,CAhBG,8LAAsE,QAAU,CAAE,0jBAM9E,0BAA+C,CAChD,+IAOL,MDhC6C,mBCiCW,CF2C5D,gDA8CM,eC1H2C,CD2H5C,qCA/CL,iDAqDQ,4BAAA,cAAe,CAElB,CAvDL,+BA4DI,YCxI6C,CD4EjD,iDA+DM,aACA,6BAAA,eAAgB,CAoBjB,oCApFL,iDAmEQ,aACA,4BAAA,eAAe,eChJ0B,CDgK5C,CAAA,oCApFL,iDAyEQ,iCAAA,mBAAoB,CAWvB,CAAA,qCApFL,iDA6EQ,4BAAA,cAAe,CAOlB,CAAA,qCApFL,iDAiFQ,uBACA,eC9JyC,CDgK5C,CAAA,mKErHD,UAL2B,CFiIzB,qKE5HF,SAL2B,CFiIzB,mKE5HF,oBAL2B,CFsC/B,8EAyGM,YAAa,CACd,mCG/KH,kBHmL4B,aAE1B,oBAAA,oBAAA,aAAa,yBACb,sBAAA,mBAAmB,wBACnB,qBAAA,uBAAuB,aAIvB,YAAa,CATd,oDAYG,UAAU,gBAEV,0DAAA,qDAAA,iDIlNuD,CJoM1D,0DAgBK,8BAAA,0BAAA,qBAAsB,CACvB","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * ResultListPage Component\n */\n\n@import './mixins';\n@import '../../../molecules/media/Card/mixins';\n\n.result-list-page{\n  padding: 0 baseline(1);\n\n  &__list{\n    display: flex;\n    flex-flow: row wrap;\n    align-content: flex-start;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &:last-of-type{\n    .result-list-item{\n      transform-origin: bottom;\n      animation: show-card .5s $ease-out-circ;\n      animation-fill-mode: backwards;\n\n      @for $i from 1 through $results-per-page {\n        &:nth-child(#{$i}) {\n          animation-delay: 1 + (.08 * $i * 1s);\n        }\n      }\n\n      @keyframes show-card {\n        0% {\n          opacity: 0;\n          transform: translate3d(0, 50%, 0);\n          animation-fill-mode: none;\n        }\n        1% {\n          // transform: rotateX(-45deg) translate3d(0, 100%, 0);\n        }\n        100% {\n          opacity: 1;\n          transform: none;\n          animation-fill-mode: none;\n        }\n      }\n    }\n  }\n\n  &.grid--small{\n    @include setup-grid();\n\n    .result-list-item{\n      padding: baseline(.5) baseline(1);\n    }\n  }\n\n  &.grid--medium{\n    .result-list-item {\n      @include media(breakpoint(desktop)) {\n        flex-basis: 50%;\n      }\n    }\n  }\n\n  &.grid--xlarge{\n    $image-height: map-get(map-get($card-sizes, xlarge), image-height);\n    padding: baseline(2);\n\n    .result-list-item {\n      padding: baseline(6);\n      flex-basis: 100%;\n\n      @include media(breakpoint(tablet)) {\n        padding: baseline(2);\n        flex-basis: 50%;\n        max-width: baseline($image-height + 4);\n      }\n\n      @include media(breakpoint(desktop-s)) {\n        flex-basis: 33.3333%;\n      }\n\n      @include media(breakpoint(desktop-m)) {\n        flex-basis: 25%;\n      }\n\n      @include media(breakpoint(desktop-l)) {\n        padding: baseline(4) baseline(4) baseline(3);\n        max-width: baseline($image-height + 8);\n      }\n    }\n\n    @each $breakpoint in $result-list-page-breakpoints {\n      // @include optional-media(breakpoint(map-get($breakpoint, media))) {\n      //   @include set-grid-item-width(map-get($breakpoint, items-per-row));\n      // }\n\n      .controlled-grid--#{map-get($breakpoint, id)} & {\n        @include set-grid-item-width(map-get($breakpoint, items-per-row));\n      }\n    }\n  }\n\n  .result-list-item{\n    // perspective: 3000px;\n    // perspective-origin: center;\n    // transform-style: preserve-3d;\n    // transform: translateZ(0);\n    // -webkit-backface-visibility: hidden;\n    z-index: auto;\n    &:hover{\n      z-index: auto;\n    }\n  }\n\n  &__collection-card{\n    @include position(absolute);\n    padding: baseline(2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: baseline(get-collection-card-height(large));\n    // border-right: 1px solid uicolor(border);\n    // border-bottom: 1px solid uicolor(border);\n    z-index: auto;\n\n    .collection-card{\n      width: 90%;\n      max-width: baseline(42);\n      transition: .25s $ease-out-back;\n      &:hover{\n        transform: scale(1.03);\n      }\n    }\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","/**\n * ResultListPage Component\n */\n\n@import '../../../molecules/media/Card/mixins';\n@import '../../../molecules/media/CollectionCard/mixins';\n\n$results-per-page: 15;\n$collection-card-position-in-page: 11 6 1 2;\n$result-list-page-breakpoints: (\n  (\n    id: small,\n    items-per-row: 1\n  ),\n  (\n    id: medium,\n    media: desktop-s,\n    items-per-row: 2\n  ),\n  (\n    id: large,\n    media: desktop-xl,\n    items-per-row: 3\n  ),\n);\n\n$total-layouts: length($collection-card-position-in-page);\n$card-height: get-card-height(small) + 1;\n$collection-card-stack-height: get-collection-card-height(large) / $card-height;\n\n@mixin setup-page-with-collection-card($breakpoint-index, $collection-card-position) {\n  $items-per-row: map-get(nth($result-list-page-breakpoints, $breakpoint-index), items-per-row);\n  $collection-column: $collection-card-position % $items-per-row;\n  @if $collection-column == 0 {\n    $collection-column: $items-per-row;\n  }\n  $is-collection-in-last-column: $collection-card-position % $items-per-row == 0;\n  .result-list-item {\n    @if $breakpoint-index == 1 {\n      &:nth-child(#{$collection-card-position}) {\n        margin: baseline($card-height * $collection-card-stack-height) 0 0;\n      }\n    } @else if $breakpoint-index == 2 {\n      .result-list:not([class*=\"controlled-grid--small\"]) &:nth-child(n) { margin: 0 }\n      @for $i from 1 through $collection-card-stack-height {\n        $nth-child-padding: if($is-collection-in-last-column, $items-per-row, $items-per-row - 1);\n        $nth-child: ($collection-card-position - $nth-child-padding) + ($i * ($items-per-row - 1));\n        .result-list:not([class*=\"controlled-grid--small\"]) &:nth-child(#{$nth-child}) {\n          $margin: if($is-collection-in-last-column, right, left);\n          margin-#{$margin}: 100% / $items-per-row;\n        }\n      }\n    } @else if $breakpoint-index == 3 {\n      .result-list:not([class*=\"controlled-grid--medium\"]) &:nth-child(n) { margin: 0 }\n      @for $i from 1 through $collection-card-stack-height {\n        $nth-child-padding: if($is-collection-in-last-column, $items-per-row, $items-per-row - 1);\n        $nth-child: ($collection-card-position - $nth-child-padding) + ($i * ($items-per-row - 1));\n        .result-list:not([class*=\"controlled-grid--medium\"]) &:nth-child(#{$nth-child}) {\n          $margin: if($is-collection-in-last-column, right, left);\n          margin-#{$margin}: 100% / $items-per-row;\n        }\n      }\n    }\n  }\n\n  .result-list-page__collection-card {\n    $position-top: ceil($collection-card-position / $items-per-row) - 1;\n    top: baseline($card-height * if($position-top < 0, 0, $position-top));\n    left: (100% / $items-per-row) * ($collection-column - 1);\n  }\n}\n\n@mixin set-grid-item-width($items-per-row) {\n  $width: 100% / $items-per-row;\n  .result-list-item {\n    width: $width;\n  }\n  .result-list-page__collection-card{\n    width: $width;\n  }\n}\n\n@mixin setup-grid() {\n\n  @each $breakpoint in $result-list-page-breakpoints {\n    @include optional-media(breakpoint(map-get($breakpoint, media))) {\n      @include set-grid-item-width(map-get($breakpoint, items-per-row));\n    }\n\n    .controlled-grid--#{map-get($breakpoint, id)} & {\n      @include set-grid-item-width(map-get($breakpoint, items-per-row));\n    }\n  }\n\n  &:not(.without--collection) {\n    @for $index from 1 through $total-layouts {\n      &.collection-card-position--#{$index}{\n        $collection-card-position: nth($collection-card-position-in-page, $index);\n\n        @if $collection-card-position >= $results-per-page {\n          $collection-card-position: $results-per-page - $collection-card-stack-height;\n        }\n\n        @each $breakpoint in $result-list-page-breakpoints {\n          $i: index($result-list-page-breakpoints, $breakpoint);\n          $id: map-get($breakpoint, id);\n          $media: map-get($breakpoint, media);\n          @include optional-media(breakpoint($media)) {\n            @include setup-page-with-collection-card($i, $collection-card-position);\n          }\n\n          .controlled-grid--#{$id} & {\n            @include setup-page-with-collection-card($i, $collection-card-position);\n          }\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n/// Provides a quick method for setting an element’s position. Use a `null` value to “skip” a side.\n///\n/// @param {Position} $position [relative]\n///   A CSS position value\n///\n/// @param {Arglist} $coordinates [null null null null]\n///   List of values that correspond to the 4-value syntax for the edges of a box\n///\n/// @example scss - Usage\n///   .element {\n///     @include position(absolute, 0 null null 10em);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     left: 10em;\n///     position: absolute;\n///     top: 0;\n///   }\n///\n/// @require {function} is-length\n/// @require {function} unpack\n\n@mixin position($position: relative, $coordinates: null null null null) {\n  @if type-of($position) == list {\n    $coordinates: $position;\n    $position: relative;\n  }\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n  $coordinates: unpack($coordinates);\n\n  $offsets: (\n    top:    nth($coordinates, 1),\n    right:  nth($coordinates, 2),\n    bottom: nth($coordinates, 3),\n    left:   nth($coordinates, 4)\n  );\n\n  position: $position;\n\n  @each $offset, $value in $offsets {\n    @if is-length($value) {\n      #{$offset}: $value;\n    }\n  }\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n","@charset \"UTF-8\";\n\n/// CSS cubic-bezier timing functions. Timing functions courtesy of jquery.easie (github.com/jaukia/easie)\n///\n/// Timing functions are the same as demoed here: http://jqueryui.com/resources/demos/effect/easing.html\n///\n/// @type cubic-bezier\n\n$ease-in-quad:      cubic-bezier(0.550,  0.085, 0.680, 0.530);\n$ease-in-cubic:     cubic-bezier(0.550,  0.055, 0.675, 0.190);\n$ease-in-quart:     cubic-bezier(0.895,  0.030, 0.685, 0.220);\n$ease-in-quint:     cubic-bezier(0.755,  0.050, 0.855, 0.060);\n$ease-in-sine:      cubic-bezier(0.470,  0.000, 0.745, 0.715);\n$ease-in-expo:      cubic-bezier(0.950,  0.050, 0.795, 0.035);\n$ease-in-circ:      cubic-bezier(0.600,  0.040, 0.980, 0.335);\n$ease-in-back:      cubic-bezier(0.600, -0.280, 0.735, 0.045);\n\n$ease-out-quad:     cubic-bezier(0.250,  0.460, 0.450, 0.940);\n$ease-out-cubic:    cubic-bezier(0.215,  0.610, 0.355, 1.000);\n$ease-out-quart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);\n$ease-out-quint:    cubic-bezier(0.230,  1.000, 0.320, 1.000);\n$ease-out-sine:     cubic-bezier(0.390,  0.575, 0.565, 1.000);\n$ease-out-expo:     cubic-bezier(0.190,  1.000, 0.220, 1.000);\n$ease-out-circ:     cubic-bezier(0.075,  0.820, 0.165, 1.000);\n$ease-out-back:     cubic-bezier(0.175,  0.885, 0.320, 1.275);\n\n$ease-in-out-quad:  cubic-bezier(0.455,  0.030, 0.515, 0.955);\n$ease-in-out-cubic: cubic-bezier(0.645,  0.045, 0.355, 1.000);\n$ease-in-out-quart: cubic-bezier(0.770,  0.000, 0.175, 1.000);\n$ease-in-out-quint: cubic-bezier(0.860,  0.000, 0.070, 1.000);\n$ease-in-out-sine:  cubic-bezier(0.445,  0.050, 0.550, 0.950);\n$ease-in-out-expo:  cubic-bezier(1.000,  0.000, 0.000, 1.000);\n$ease-in-out-circ:  cubic-bezier(0.785,  0.135, 0.150, 0.860);\n$ease-in-out-back:  cubic-bezier(0.680, -0.550, 0.265, 1.550);\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * EmptyState Component
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = __webpack_require__(42);
var player_2 = __webpack_require__(63);
var relay_1 = __webpack_require__(93);
var emptyState_1 = __webpack_require__(305);
var router_1 = __webpack_require__(27);
__webpack_require__(1994);
var found_1 = __webpack_require__(32);
var lodash_1 = __webpack_require__(6);
var React = __webpack_require__(0);
var BEM = __webpack_require__(1);
var react_redux_1 = __webpack_require__(5);
var react_relay_1 = __webpack_require__(13);
var LoadingSpinner_1 = __webpack_require__(163);
// import Charts from '../../content/Charts';
var Collections_1 = __webpack_require__(227);
var FeaturedArtists_1 = __webpack_require__(433);
// import FrontfundrBanner from '../../content/FrontfundrBanner';
var NewsletterPromo_1 = __webpack_require__(665);
var SearchTermsBox_1 = __webpack_require__(668);
var StaffPicks_1 = __webpack_require__(435);
var classes = new BEM('empty-state');
var defaultList = [];

var EmptyState = function (_React$Component) {
    _inherits(EmptyState, _React$Component);

    function EmptyState() {
        _classCallCheck(this, EmptyState);

        return _possibleConstructorReturn(this, (EmptyState.__proto__ || Object.getPrototypeOf(EmptyState)).apply(this, arguments));
    }

    _createClass(EmptyState, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var data = this.props.viewer.home_page;
            var allTracks = lodash_1.concat.apply(lodash_1, [data.featured_artist_tracks || defaultList, data.featured_tracks || defaultList].concat(_toConsumableArray((data.track_charts || defaultList).map(function (_ref) {
                var items = _ref.items;
                return items || defaultList;
            }))));
            this.props.setPlayerQueue(player_2.getPlayerTracksFromResults(allTracks));
        }
    }, {
        key: "render",
        value: function render() {
            var data = this.props.viewer.home_page;
            var featuredTerms = data.featured_terms || defaultList;
            var staffPicks = data.featured_tracks || defaultList;
            var featuredCollections = data.featured_collections || defaultList;
            var featuredArtists = data.featured_artist_tracks || defaultList;
            // const charts = data.track_charts || defaultList;
            return React.createElement("div", Object.assign({}, classes('', '', this.props.className)), React.createElement("div", Object.assign({}, classes('content-wrapper')), React.createElement(StaffPicks_1.default, { tracks: staffPicks }), React.createElement(SearchTermsBox_1.default, Object.assign({ data: featuredTerms }, classes('search-terms'))), React.createElement(FeaturedArtists_1.default, { data: featuredArtists }), React.createElement(Collections_1.default, { data: featuredCollections }), React.createElement(NewsletterPromo_1.default, { isUserLoggedIn: this.props.isUserLoggedIn })));
        }
    }]);

    return EmptyState;
}(React.Component);

var EmptyStateRelay = react_relay_1.createFragmentContainer(EmptyState, emptyState_1.EmptyStateFragment);
var EmptyStateRenderer = function EmptyStateRenderer(_a) {
    var className = _a.className,
        match = _a.match,
        ownProps = __rest(_a, ["className", "match"]);

    return React.createElement(react_relay_1.QueryRenderer, { environment: relay_1.environment, query: emptyState_1.EmptyStateQuery, variables: {
            license_params: router_1.getLicenseParamsForRouteQuery(match)
        }, render: function render(_ref2) {
            var error = _ref2.error,
                props = _ref2.props;

            if (error) {
                return React.createElement("div", null, error.message);
            } else if (props) {
                return React.createElement(EmptyStateRelay, Object.assign({}, props, ownProps, { className: className }));
            }
            return React.createElement(LoadingSpinner_1.default, { center: true });
        } });
};
var ConnectedEmptyState = react_redux_1.connect(function (_ref3) {
    var user = _ref3.user;
    return {
        isUserLoggedIn: user.isLoggedIn
    };
}, function (dispatch) {
    return {
        setPlayerQueue: function setPlayerQueue(tracks) {
            dispatch(player_1.replaceQueue({ tracks: tracks }));
        }
    };
})(EmptyStateRenderer);
exports.default = found_1.withRouter(ConnectedEmptyState);

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1995);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--3-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".empty-state__content-wrapper{padding:48px 32px}.empty-state .featured-artist-list,.empty-state div+.featured-artist-list,.empty-state div+.staff-picks{margin-top:64px}.empty-state .featured-artist-list{margin-top:16px}.empty-state .collection-list,.empty-state .frontfundr,.empty-state .search-terms{margin-top:64px}@media screen and (min-width:1600px){.empty-state .featured-artist-list__list{margin:0 -32px}.empty-state .featured-artist-list__list__item{margin:0 32px}}@media screen and (min-width:1920px){.empty-state .featured-artist-list__list{margin:0 -56px}.empty-state .featured-artist-list__list__item{margin:0 56px}}@media screen and (min-width:2560px){.empty-state .featured-artist-list__list{margin:0 -80px}.empty-state .featured-artist-list__list__item{margin:0 80px}}.empty-state .newsletter-promo{margin-top:64px;-webkit-box-shadow:0 5px 7px -2px rgba(16,16,21,.1),0 1px 2px rgba(16,16,21,.1);box-shadow:0 5px 7px -2px rgba(16,16,21,.1),0 1px 2px rgba(16,16,21,.1)}.empty-state .newsletter-promo .container{margin-right:7.777777778%;margin-left:7.777777778%}.empty-state .charts{margin-top:64px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/components/organisms/sections/EmptyState/styles.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/src/public/assets/css/utils/_mixins.scss","/var/lib/jenkins/workspace/Apollo Music Store Service Build/node_modules/bourbon/app/assets/stylesheets/helpers/_directional-values.scss"],"names":[],"mappings":"AA6GE,8BACE,iBC3E6C,CDyEjD,wGAUI,eCnF6C,CDyEjD,mCAcI,eCvF6C,CDyEjD,kFA0BI,eCnG6C,CDoG9C,qCA3BH,yCAgCQ,cCzGyC,CDyEjD,+CAiCiB,aC1GgC,CD0GR,CAAA,qCAjCzC,yCAqCQ,cC9GyC,CDyEjD,+CAsCiB,aC/GgC,CD+GR,CAAA,qCAtCzC,yCA0CQ,cCnHyC,CDyEjD,+CA2CiB,aCpHgC,CDoHP,CA3C1C,+BAiDI,gBACA,gFAAA,uEAAuG,CAlD3G,0CEnB0B,0BFuEa,wBAAA,CApDvC,qBAyDI,eClI6C,CDmI9C","file":"styles.scss","sourcesContent":["/**\n *   main.scss\n **/\n\n// Vendors\n$output-bourbon-deprecation-warnings: false;\n@import \"~bourbon/app/assets/stylesheets/bourbon\";\n\n// Utils\n  @import \"../../../../assets/css/utils/mixins\",\n  \"utils/local-mixins\";\n\n// Neat Specifics\n  @import \"~bourbon-neat/app/assets/stylesheets/neat-helpers\",\n  \"config/grid-settings\",\n  \"~bourbon-neat/app/assets/stylesheets/neat\";\n\n// Config\n  @import \"../../../../assets/css/config/system-fonts\",\n  \"config/font-face\",\n  \"config/fonts\",\n  \"config/sizes\";\n\n// Mixins\n  @import \"../../../../assets/css/mixins/background-shape\",\n  \"mixins/color-scheme\",\n  \"mixins/colors\",\n  \"mixins/shadow\",\n  \"mixins/input\";\n\n/**\n * Global Variables\n */\n\n// Sizes\n$app-header-height: baseline(8);\n$header-post-carousel-top-offset: 6px;\n$brand-nav-height: baseline(8) - $header-post-carousel-top-offset;\n$header-post-carousel-bottom-offset: 15px;\n$app-nav-height-initial: baseline(12) - $header-post-carousel-bottom-offset;\n$app-nav-height-fixed: $app-header-height;\n$header-posts-carousel-height: 260px;\n$page-header-height: baseline(7);\n\n$extended-header-height: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height;\n$page-with-extended-header-margin-top: $brand-nav-height + $app-nav-height-initial\n  + $header-posts-carousel-height + $page-header-height;\n\n$page-with-header-margin-top: $app-nav-height-fixed + $page-header-height;\n\n$player-height: baseline(7);\n$player-with-term-list-height: baseline(17);\n$license-bar-height: baseline(8) + 1px;\n$faceted-search-nav-width: 11.111111%;\n$faceted-search-nav-min-width: baseline(23);\n\n// Mixins\n@mixin react-to-player-visibility($prop: \"bottom\", $extra-height: 0) {\n  .app-wrapper[data-player-visibility=\"true\"] &{\n    #{$prop}: $player-height + $extra-height;\n  }\n\n  .app-wrapper[data-player-term-list-visibility=\"true\"] &{\n    #{$prop}: $player-with-term-list-height + $extra-height;\n  }\n}\n\n@mixin page-is-at-least-full-height($extra-height: 0) {\n  min-height: calc(100vh - #{$page-with-header-margin-top + $extra-height});\n}\n\n@mixin page-aside($width, $min-width) {\n  @include position(fixed, $page-with-header-margin-top null 0 0);\n  @include react-to-player-visibility;\n  width: $width;\n  min-width: $min-width;\n}\n\n@mixin page-with-aside-content($aside-width, $aside-min-width) {\n  width: 100% - $aside-width;\n  max-width: calc(100% - #{$aside-min-width});\n  margin-left: auto;\n}\n\n@mixin translucent($color: color(bw3), $transparent-color: transparentize($color, .1)) {\n  background-color: $color;\n  @supports(backdrop-filter: blur(20px)) {\n    background-color: $transparent-color;\n    backdrop-filter: blur(20px) saturate(200%);\n  }\n}\n\n@mixin loading-placeholder($animation-duration: 2s) {\n  background-image: linear-gradient(to right, color(bw4) 25%, lighten(color(bw4), 4%), color(bw4) 75%);\n  background-size: 500% auto;\n  animation: gradient-cycle #{$animation-duration} linear infinite;\n}\n\n@keyframes gradient-cycle {\n  0%{ background-position: 100% 50% }\n  100%{ background-position: 0% 50% }\n}\n\n/**\n * EmptyState Component\n */\n\n.empty-state{\n  &__content-wrapper{\n    padding: baseline(6) baseline(4) baseline(6);\n  }\n\n  div + .staff-picks, div + .featured-artist-list{\n    margin-top: baseline(8);\n  }\n\n  .featured-artist-list{\n    margin-top: baseline(8);\n  }\n\n  .featured-artist-list{\n    margin-top: baseline(2);\n  }\n\n  .collection-list{\n    margin-top: baseline(8);\n  }\n\n  .frontfundr {\n    margin-top: baseline(8);\n  }\n\n  .search-terms {\n    margin-top: baseline(8);\n  }\n\n  .featured-artist-list{\n    &__list{\n      @include media(breakpoint(desktop-xxl)) {\n        margin: 0 baseline(-4);\n        &__item{ margin: 0 baseline(4) }\n      }\n\n      @include media(breakpoint(desktop-hd)) {\n        margin: 0 baseline(-7);\n        &__item{ margin: 0 baseline(7) }\n      }\n\n      @include media(breakpoint(desktop-qhd)) {\n        margin: 0 baseline(-10);\n        &__item{ margin: 0 baseline(10) }\n      }\n    }\n  }\n\n  .newsletter-promo{\n    margin-top: baseline(8);\n    box-shadow: 0 5px 7px -2px transparentize(color(black), .9), 0 1px 2px transparentize(color(black), .9);\n    .container{\n      @include margin(null 7.777777778%);\n    }\n  }\n\n  .charts{\n    margin-top: baseline(8);\n  }\n}\n","/**\n *   Mixins\n **/\n\n/* Requires Modernizr.touchevents */\n@mixin scroll($direction: y) {\n  $opposite-direction: x;\n\n  @if $direction == x {\n    $opposite-direction: y;\n  }\n\n  html.touchevents &{\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  html.no-touchevents & {\n    overflow-#{$opposite-direction}: hidden;\n    overflow-#{$direction}: auto;\n  }\n}\n\n@mixin hover() {\n  html.touchevents &:active,\n  html.no-touchevents &:hover{\n    @content;\n  }\n}\n\n// --------------------------------------------------------------------------------\n// note:  Those mixins/functions require bourbon-neat.\n// --------------------------------------------------------------------------------\n@function baseline($numberOfLines: 1, $base: $em-base) {\n    // @return em($baseline-grid * $numberOfLines, $base);\n    @return $baseline-grid * $numberOfLines * 1px;\n}\n\n@function column($numberOfColumns: 1, $totalColumns: $grid-columns, $getFloat: false) {\n    $float: $numberOfColumns / $totalColumns;\n    @if $getFloat==true {\n        @return $float;\n    }\n    @else {\n        @return $float * 100%;\n    }\n}\n\n@function map-deep-get($map, $keys...) {\n    @each $key in $keys {\n        $map: map-get($map, $key);\n    }\n    @return $map;\n}\n\n@mixin when-inside($selector) {\n    #{$selector} & {\n        @content;\n    }\n}\n\n@mixin input-autofill($fill-color, $background-color, $input-height: 55) {\n    input[type=\"text\"]:-webkit-autofill,\n    input[type=\"tel\"]:-webkit-autofill,\n    input[type=\"email\"]:-webkit-autofill,\n    input[type=\"password\"]:-webkit-autofill,\n    select:-webkit-autofill {\n        -webkit-text-fill-color: $fill-color;\n        box-shadow: 0 0 0 px($input-height) $background-color inset;\n    }\n}\n\n@mixin font-smoothing($value: antialiased) {\n    @if $value==sub {\n        $value: subpixel-antialiased;\n    }\n    -webkit-font-smoothing: $value;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@function strip-unit($number) {\n  @if type-of($number) == 'number' and not unitless($number) {\n    @return $number / ($number * 0 + 1);\n  }\n\n  @return $number;\n}\n","@charset \"UTF-8\";\n\n/// Directional-property mixins are shorthands for writing properties like the following\n///\n/// @ignore You can also use `false` instead of `null`.\n///\n/// @param {List} $vals\n///   List of directional values\n///\n/// @example scss - Usage\n///   .element {\n///     @include border-style(dotted null);\n///     @include margin(null 0 10px);\n///   }\n///\n/// @example css - CSS Output\n///   .element {\n///     border-bottom-style: dotted;\n///     border-top-style: dotted;\n///     margin-bottom: 10px;\n///     margin-left: 0;\n///     margin-right: 0;\n///   }\n///\n/// @require {function} contains-falsy\n///\n/// @return {List}\n\n@function collapse-directionals($vals) {\n  @if $output-bourbon-deprecation-warnings == true {\n    @warn \"[Bourbon] [Deprecation] `collapse-directionals` is deprecated and \" +\n    \"will be removed in 5.0.0.\";\n  }\n\n  $output: null;\n\n  $a: nth($vals, 1);\n  $b: if(length($vals) < 2, $a, nth($vals, 2));\n  $c: if(length($vals) < 3, $a, nth($vals, 3));\n  $d: if(length($vals) < 2, $a, nth($vals, if(length($vals) < 4, 2, 4)));\n\n  @if $a == 0 { $a: 0; }\n  @if $b == 0 { $b: 0; }\n  @if $c == 0 { $c: 0; }\n  @if $d == 0 { $d: 0; }\n\n  @if $a == $b and $a == $c and $a == $d { $output: $a;          }\n  @else if $a == $c and $b == $d         { $output: $a $b;       }\n  @else if $b == $d                      { $output: $a $b $c;    }\n  @else                                  { $output: $a $b $c $d; }\n\n  @return $output;\n}\n\n/// Output directional properties, for instance `margin`.\n///\n/// @access private\n///\n/// @param {String} $pre\n///   Prefix to use\n/// @param {String} $suf\n///   Suffix to use\n/// @param {List} $vals\n///   List of values\n///\n/// @require {function} collapse-directionals\n/// @require {function} contains-falsy\n\n@mixin directional-property($pre, $suf, $vals) {\n  @include _bourbon-deprecate(\"directional-property\");\n\n  $user-deprecation-warnings-setting: $output-bourbon-deprecation-warnings;\n  $output-bourbon-deprecation-warnings: false !global;\n\n  // Property Names\n  $top:    $pre + \"-top\"    + if($suf, \"-#{$suf}\", \"\");\n  $bottom: $pre + \"-bottom\" + if($suf, \"-#{$suf}\", \"\");\n  $left:   $pre + \"-left\"   + if($suf, \"-#{$suf}\", \"\");\n  $right:  $pre + \"-right\"  + if($suf, \"-#{$suf}\", \"\");\n  $all:    $pre +             if($suf, \"-#{$suf}\", \"\");\n\n  $vals: collapse-directionals($vals);\n\n  @if contains-falsy($vals) {\n    @if nth($vals, 1) { #{$top}: nth($vals, 1); }\n\n    @if length($vals) == 1 {\n      @if nth($vals, 1) { #{$right}: nth($vals, 1); }\n    } @else {\n      @if nth($vals, 2) { #{$right}: nth($vals, 2); }\n    }\n\n    @if length($vals) == 2 {\n      @if nth($vals, 1) { #{$bottom}: nth($vals, 1); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 3 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 2) { #{$left}:   nth($vals, 2); }\n    } @else if length($vals) == 4 {\n      @if nth($vals, 3) { #{$bottom}: nth($vals, 3); }\n      @if nth($vals, 4) { #{$left}:   nth($vals, 4); }\n    }\n  } @else {\n    #{$all}: $vals;\n  }\n\n  $output-bourbon-deprecation-warnings: $user-deprecation-warnings-setting !global;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * NoMatchFound Component
 */

Object.defineProperty(exports, "__esModule", { value: true });
var staticData_1 = __webpack_require__(103);
var olark_1 = __webpack_require__(451);
var grid_1 = __webpack_require__(58);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(5);
var BEM = __webpack_require__(1);
var Button_1 = __webpack_require__(10);
var Icon_1 = __webpack_require__(12);
var Heading_1 = __webpack_require__(9);
var Label_1 = __webpack_require__(8);
var contactOptionsClasses = new BEM('contact-options');
var NoMatchFoundBase = function NoMatchFoundBase(_ref) {
    var openingHours = _ref.openingHours,
        phoneNumber = _ref.phoneNumber,
        euPhoneNumber = _ref.euPhoneNumber;
    return React.createElement(React.Fragment, null, React.createElement(Heading_1.default, { is: "h1", textColor: "bw6" }, "No Match Found."), React.createElement(Heading_1.default, { is: "h4", textColor: "bw7" }, "Can't find what you're looking for? We can definitely help!"), React.createElement("div", Object.assign({}, contactOptionsClasses()), React.createElement(Icon_1.IconPhone, null), React.createElement(Heading_1.default, { is: "h4" }, phoneNumber.phone_number, " (NA) /\xA0"), React.createElement(Heading_1.default, { is: "h4" }, euPhoneNumber.phone_number, " (EU)"), React.createElement(Label_1.Span, { size: "small", textColor: "bw7", style: { margin: "0 " + grid_1.baseline * 2 + "px" } }, "or"), React.createElement(Button_1.default, { label: "Chat with our experts ", size: "small", onClick: olark_1.default.expand, colorScheme: "dark", variant: "pill" })), React.createElement(Label_1.Span, { size: "small", textColor: "bw7", style: { marginTop: grid_1.baseline * 2 }, block: true }, "We're available from Monday to Friday between ", openingHours, "."));
};
exports.NoMatchFound = react_redux_1.connect(function (state) {
    return {
        openingHours: staticData_1.getBusinessOpeningHours(state),
        phoneNumber: staticData_1.getBusinessMainPhoneNumber(state),
        euPhoneNumber: staticData_1.getBusinessEuropeanPhoneNumber(state)
    };
})(NoMatchFoundBase);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Track Page Routing
 */

Object.defineProperty(exports, "__esModule", { value: true });
var found_1 = __webpack_require__(32);
var React = __webpack_require__(0);
var Heading_1 = __webpack_require__(9);
var Track_1 = __webpack_require__(231);
var Page_1 = __webpack_require__(391);
var track_1 = __webpack_require__(650);
var router_1 = __webpack_require__(27);
var prepareVariables = function prepareVariables(_ref, match) {
    var slug = _ref.slug;
    return {
        slug: slug,
        license_params: router_1.getLicenseParamsForRouteQuery(match)
    };
};
var render = function render(_ref2) {
    var Component = _ref2.Component,
        props = _ref2.props;

    if (!Component || !props) {
        return React.createElement(router_1.LoadingPage, null);
    }
    return props.track ? React.createElement(Component, Object.assign({}, props)) : React.createElement(Page_1.default, { id: "track", className: "not-found" }, React.createElement(Heading_1.default, { is: "h2" }, "Track Not Found"));
};
exports.TrackPageRoute = React.createElement(found_1.Route, { path: "track/:slug", Component: Track_1.default, query: track_1.TrackPageQuery, prepareVariables: prepareVariables, render: render });

/***/ })
],[748]);


// WEBPACK FOOTER //
// static/js/app.480a260e478833110e75.js